// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/bg_normal.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/icon_setting_on.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/icon_renew_small.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/icon_file@3x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/icon_memo@3x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../img/bg_nodata.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../img/icon_x_b@3x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../img/icon_nav_d_s.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../img/icon_arrow_left.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../img/icon_arrow_w.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../img/bg_readyinfo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../img/icon_safety.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../img/icon_caution.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../img/icon_danger.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../img/icon_pen_w.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../img/icon_legend_gray.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../img/icon_legend_purple.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../img/icon_legend_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../img/icon_disabled.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../img/icon_share.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../img/icon_reload.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../img/icon_treeopen.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../img/icon_treeclose.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../img/icon_arrowright.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../img/icon_arrowleft.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../img/icon_calendar.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../img/icon_select_l.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../img/Icon_search_white.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../img/icon_filter.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../img/icon_x_g@3x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../img/icon_searchsamll.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../img/bg_qroutline.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../img/icon_close_w.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../img/icon_filedown_m.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../img/icon_set.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../img/icon_pen_b.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../img/icon_add.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../img/icon_plus.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../img/icon_navi.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../img/icon_export.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("../img/icon_add_g.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("../img/icon_search_g.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("../img/bg_device.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("../img/icon_filedown_m@3x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("../img/icon_upload@3x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("../img/icon_success@3x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("../img/icon_file.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("../img/icon_gopop@3x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("../img/icon_folder_b.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("../img/icon_check_gr.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("../img/icon_prev_top.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("../img/icon_downbtn_s.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("../img/icon_eq.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("../img/icon_btnon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("../img/icon_btnoff.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("../img/icon_chk_s.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("../img/icon_arrow_g.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("../img/icon_go2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("../img/icon_downbtn.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("../img/icon_filedown.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("../img/bg_nodata@3x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("../img/icon_arrow@3x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("../img/icon_deletecircle@3x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("../img/icon_file_w.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("../img/icon_tree.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_65___ = new URL("../img/icon_menuarrow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_66___ = new URL("../img/icon_pin_big.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_67___ = new URL("../img/icon_pin_big_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_68___ = new URL("../img/icon_pen_g.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_69___ = new URL("../img/icon_pin.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_70___ = new URL("../img/icon_pin_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_71___ = new URL("../img/icon_go_g.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_72___ = new URL("../img/icon_go3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_73___ = new URL("../img/icon_arrow_half.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_74___ = new URL("../img/icon_arrow_half_on.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_75___ = new URL("../img/icon_filedown_b.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_76___ = new URL("../img/randing_topbg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_77___ = new URL("../img/icon_go_circle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_78___ = new URL("../img/intro_topbg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_79___ = new URL("../img/icon_sulbi_w.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_80___ = new URL("../img/icon_close_w@3x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_81___ = new URL("../img/icon_arrow_bottom_b.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_82___ = new URL("../img/icon_arrow_left@3x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_83___ = new URL("../img/icon_calendar_b.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_84___ = new URL("../img/icon_etc.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_85___ = new URL("../img/icon_pen_blue.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_86___ = new URL("../img/icon_delete_blue.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_87___ = new URL("../img/icon_sortable_asc.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_88___ = new URL("../img/icon_arrow_right_s.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_89___ = new URL("../img/icon_gas.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_90___ = new URL("../img/icon_gas_b.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_91___ = new URL("../img/icon_info_black.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_92___ = new URL("../img/icon_check_big_g.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_93___ = new URL("../img/icon_check_big_b.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_94___ = new URL("../img/icon_delete_x_lg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_95___ = new URL("../img/icon_delete_gr.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_96___ = new URL("../img/icon_more_g_thin.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_97___ = new URL("../img/icon_prev_w.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_98___ = new URL("../img/icon_not.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_99___ = new URL("../img/icon_not_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_100___ = new URL("../img/bg_cate_step1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_101___ = new URL("../img/icon_plus_w.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_102___ = new URL("../img/bg_top_result.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_103___ = new URL("../img/icon_plus_g.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_104___ = new URL("../img/icon_info_gr.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_105___ = new URL("../img/icon_info_o.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_106___ = new URL("../img/icon_info_r.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_107___ = new URL("../img/icon_down_g.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_108___ = new URL("../img/icon_pen_on.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_109___ = new URL("../img/icon_pen.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_110___ = new URL("../img/icon_goback.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_111___ = new URL("../img/icon_guide_blue.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_112___ = new URL("../img/icon_guide.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_113___ = new URL("../img/icon_arrow_right_g@3x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_114___ = new URL("../img/icon_refresh_gr.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_115___ = new URL("../img/icon_legend.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_116___ = new URL("../img/icon_legend_mint.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_117___ = new URL("../img/icon_filedown_w@3x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_118___ = new URL("../img/icon_renew.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_119___ = new URL("../img/icon_filter_white.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_120___ = new URL("../img/icon_depth_down.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_121___ = new URL("../img/icon_ask.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_122___ = new URL("../img/icon_ask_hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_123___ = new URL("../img/icon_ask_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_124___ = new URL("../img/icon_plus_g_s.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_125___ = new URL("../img/icon_add_all_g.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_126___ = new URL("../img/icon_add_file.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_127___ = new URL("../img/icon_add_file_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_128___ = new URL("../img/icon_add_file_hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_129___ = new URL("../img/icon_gopop.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_130___ = new URL("../img/bg_data.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_131___ = new URL("../img/icon_go_gr.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_132___ = new URL("../img/icon_arrow_right_s_g.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_133___ = new URL("../img/icon_bolt.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_134___ = new URL("../img/icon_home.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_135___ = new URL("../img/icon_result_2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_136___ = new URL("../img/icon_result_1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_137___ = new URL("../img/icon_result_3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_138___ = new URL("../img/icon_point.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_139___ = new URL("../img/icon_page_go.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_140___ = new URL("../img/icon_more_wh.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_141___ = new URL("../img/icon_next_bgno.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_142___ = new URL("../img/bg_picture.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_143___ = new URL("../img/bg_picture_on.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_144___ = new URL("../img/icon_top_w.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_145___ = new URL("../img/icon_treeon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_146___ = new URL("../img/icon_treeoff.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_147___ = new URL("../img/icon_treesub3_g.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_148___ = new URL("../img/bg_servicenfo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_149___ = new URL("../img/bg_service.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_150___ = new URL("../img/icon_logo_ls_sky.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_151___ = new URL("../img/icon_arrow_white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_152___ = new URL("../img/bg_service_mobile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_153___ = new URL("../img/icon_add_file_dis.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_154___ = new URL("../img/icon_profile_navy.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_155___ = new URL("../img/bg_market.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_156___ = new URL("../img/icon_arrow_down_20.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_157___ = new URL("../img/icon_search_large.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_158___ = new URL("../img/icon_arrow_gray.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_159___ = new URL("../img/icon_renew.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_160___ = new URL("../img/icon_select_line.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_161___ = new URL("../img/icon_best.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_162___ = new URL("../img/icon_like_gray.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_163___ = new URL("../img/icon_like.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_164___ = new URL("../img/icon_more_gr.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_165___ = new URL("../img/icon_page_go_gr.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_166___ = new URL("../img/icon_menu_navy.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_167___ = new URL("../img/icon_menu_close.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_168___ = new URL("../img/bg_market_what.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_169___ = new URL("../img/icon_arrow_round.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_170___ = new URL("../img/icon_arrow_round_blue.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_171___ = new URL("../img/icon_arrow_right.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_172___ = new URL("../img/bg_market_service1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_173___ = new URL("../img/icon_scrolldown.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_174___ = new URL("../img/icon_scrolldown_color.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_175___ = new URL("../img/icon_check_blue.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_176___ = new URL("../img/bg_joinok.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_177___ = new URL("../img/icon_logo_login_m.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_178___ = new URL("../img/icon_reload.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_179___ = new URL("../img/icon_reload_primary.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_180___ = new URL("../img/icon_info_disabled.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_181___ = new URL("../img/icon_chk_white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_182___ = new URL("../img/icon_setting.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_183___ = new URL("../img/icon_delete_gray20.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_184___ = new URL("../img/icon_close.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_185___ = new URL("../img/icon_arrow_bg_primary.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_186___ = new URL("../img/icon_arrow_bg_red.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_187___ = new URL("../img/icon_close_white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_188___ = new URL("../img/icon_arrow_blue.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_189___ = new URL("../img/icon-folder-primary.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_190___ = new URL("../img/icon_doteline.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_191___ = new URL("../img/icon_doteline_mg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_192___ = new URL("../img/icon_doteline_db.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_193___ = new URL("../img/icon_doteline_mnb.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_194___ = new URL("../img/icon_doteline_mint.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_195___ = new URL("../img/icon_doteline_la.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_196___ = new URL("../img/icon_change_arrow_lg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_197___ = new URL("../img/icon_page_go_large.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_198___ = new URL("../img/icon_arrow_line2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_199___ = new URL("../img/icon_page_go_gr_large.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_200___ = new URL("../img/icon_move.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_201___ = new URL("../img/icon_premium_badge.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_202___ = new URL("../img/icon_premium.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_203___ = new URL("../img/icon_arrow_right_blue.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_204___ = new URL("../img/icon_move_white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_205___ = new URL("../img/BeyondXEnable_linear_gradient_arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_206___ = new URL("../img/BeyondXEnable_bg_box.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_207___ = new URL("../img/icon_price_blue.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_208___ = new URL("../img/icon_info_check_r.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_209___ = new URL("../img/icon_price_red.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_210___ = new URL("../img/icon_arrow_down_red.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_211___ = new URL("../img/icon_price_gray_blue.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_212___ = new URL("../img/icon_arrow_down_gr_blue.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_213___ = new URL("../img/icon_arrow_down_blue.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_214___ = new URL("../img/BeyondXEnable_monitoring_bg_banner.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_215___ = new URL("../img/BeyondXEnable_monitoring_bg_banner_top.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_216___ = new URL("../img/icon_eye_on.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_217___ = new URL("../img/icon_eye_off.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_218___ = new URL("../img/icon_check_circle_blue.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_219___ = new URL("../img/beyondx_logo_white.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_65___);
var ___CSS_LOADER_URL_REPLACEMENT_66___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_66___);
var ___CSS_LOADER_URL_REPLACEMENT_67___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_67___);
var ___CSS_LOADER_URL_REPLACEMENT_68___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_68___);
var ___CSS_LOADER_URL_REPLACEMENT_69___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_69___);
var ___CSS_LOADER_URL_REPLACEMENT_70___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_70___);
var ___CSS_LOADER_URL_REPLACEMENT_71___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_71___);
var ___CSS_LOADER_URL_REPLACEMENT_72___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_72___);
var ___CSS_LOADER_URL_REPLACEMENT_73___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_73___);
var ___CSS_LOADER_URL_REPLACEMENT_74___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_74___);
var ___CSS_LOADER_URL_REPLACEMENT_75___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_75___);
var ___CSS_LOADER_URL_REPLACEMENT_76___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_76___);
var ___CSS_LOADER_URL_REPLACEMENT_77___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_77___);
var ___CSS_LOADER_URL_REPLACEMENT_78___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_78___);
var ___CSS_LOADER_URL_REPLACEMENT_79___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_79___);
var ___CSS_LOADER_URL_REPLACEMENT_80___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_80___);
var ___CSS_LOADER_URL_REPLACEMENT_81___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_81___);
var ___CSS_LOADER_URL_REPLACEMENT_82___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_82___);
var ___CSS_LOADER_URL_REPLACEMENT_83___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_83___);
var ___CSS_LOADER_URL_REPLACEMENT_84___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_84___);
var ___CSS_LOADER_URL_REPLACEMENT_85___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_85___);
var ___CSS_LOADER_URL_REPLACEMENT_86___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_86___);
var ___CSS_LOADER_URL_REPLACEMENT_87___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_87___);
var ___CSS_LOADER_URL_REPLACEMENT_88___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_88___);
var ___CSS_LOADER_URL_REPLACEMENT_89___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_89___);
var ___CSS_LOADER_URL_REPLACEMENT_90___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_90___);
var ___CSS_LOADER_URL_REPLACEMENT_91___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_91___);
var ___CSS_LOADER_URL_REPLACEMENT_92___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_92___);
var ___CSS_LOADER_URL_REPLACEMENT_93___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_93___);
var ___CSS_LOADER_URL_REPLACEMENT_94___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_94___);
var ___CSS_LOADER_URL_REPLACEMENT_95___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_95___);
var ___CSS_LOADER_URL_REPLACEMENT_96___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_96___);
var ___CSS_LOADER_URL_REPLACEMENT_97___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_97___);
var ___CSS_LOADER_URL_REPLACEMENT_98___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_98___);
var ___CSS_LOADER_URL_REPLACEMENT_99___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_99___);
var ___CSS_LOADER_URL_REPLACEMENT_100___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_100___);
var ___CSS_LOADER_URL_REPLACEMENT_101___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_101___);
var ___CSS_LOADER_URL_REPLACEMENT_102___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_102___);
var ___CSS_LOADER_URL_REPLACEMENT_103___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_103___);
var ___CSS_LOADER_URL_REPLACEMENT_104___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_104___);
var ___CSS_LOADER_URL_REPLACEMENT_105___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_105___);
var ___CSS_LOADER_URL_REPLACEMENT_106___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_106___);
var ___CSS_LOADER_URL_REPLACEMENT_107___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_107___);
var ___CSS_LOADER_URL_REPLACEMENT_108___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_108___);
var ___CSS_LOADER_URL_REPLACEMENT_109___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_109___);
var ___CSS_LOADER_URL_REPLACEMENT_110___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_110___);
var ___CSS_LOADER_URL_REPLACEMENT_111___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_111___);
var ___CSS_LOADER_URL_REPLACEMENT_112___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_112___);
var ___CSS_LOADER_URL_REPLACEMENT_113___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_113___);
var ___CSS_LOADER_URL_REPLACEMENT_114___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_114___);
var ___CSS_LOADER_URL_REPLACEMENT_115___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_115___);
var ___CSS_LOADER_URL_REPLACEMENT_116___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_116___);
var ___CSS_LOADER_URL_REPLACEMENT_117___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_117___);
var ___CSS_LOADER_URL_REPLACEMENT_118___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_118___);
var ___CSS_LOADER_URL_REPLACEMENT_119___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_119___);
var ___CSS_LOADER_URL_REPLACEMENT_120___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_120___);
var ___CSS_LOADER_URL_REPLACEMENT_121___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_121___);
var ___CSS_LOADER_URL_REPLACEMENT_122___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_122___);
var ___CSS_LOADER_URL_REPLACEMENT_123___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_123___);
var ___CSS_LOADER_URL_REPLACEMENT_124___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_124___);
var ___CSS_LOADER_URL_REPLACEMENT_125___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_125___);
var ___CSS_LOADER_URL_REPLACEMENT_126___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_126___);
var ___CSS_LOADER_URL_REPLACEMENT_127___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_127___);
var ___CSS_LOADER_URL_REPLACEMENT_128___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_128___);
var ___CSS_LOADER_URL_REPLACEMENT_129___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_129___);
var ___CSS_LOADER_URL_REPLACEMENT_130___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_130___);
var ___CSS_LOADER_URL_REPLACEMENT_131___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_131___);
var ___CSS_LOADER_URL_REPLACEMENT_132___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_132___);
var ___CSS_LOADER_URL_REPLACEMENT_133___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_133___);
var ___CSS_LOADER_URL_REPLACEMENT_134___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_134___);
var ___CSS_LOADER_URL_REPLACEMENT_135___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_135___);
var ___CSS_LOADER_URL_REPLACEMENT_136___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_136___);
var ___CSS_LOADER_URL_REPLACEMENT_137___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_137___);
var ___CSS_LOADER_URL_REPLACEMENT_138___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_138___);
var ___CSS_LOADER_URL_REPLACEMENT_139___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_139___);
var ___CSS_LOADER_URL_REPLACEMENT_140___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_140___);
var ___CSS_LOADER_URL_REPLACEMENT_141___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_141___);
var ___CSS_LOADER_URL_REPLACEMENT_142___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_142___);
var ___CSS_LOADER_URL_REPLACEMENT_143___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_143___);
var ___CSS_LOADER_URL_REPLACEMENT_144___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_144___);
var ___CSS_LOADER_URL_REPLACEMENT_145___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_145___);
var ___CSS_LOADER_URL_REPLACEMENT_146___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_146___);
var ___CSS_LOADER_URL_REPLACEMENT_147___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_147___);
var ___CSS_LOADER_URL_REPLACEMENT_148___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_148___);
var ___CSS_LOADER_URL_REPLACEMENT_149___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_149___);
var ___CSS_LOADER_URL_REPLACEMENT_150___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_150___);
var ___CSS_LOADER_URL_REPLACEMENT_151___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_151___);
var ___CSS_LOADER_URL_REPLACEMENT_152___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_152___);
var ___CSS_LOADER_URL_REPLACEMENT_153___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_153___);
var ___CSS_LOADER_URL_REPLACEMENT_154___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_154___);
var ___CSS_LOADER_URL_REPLACEMENT_155___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_155___);
var ___CSS_LOADER_URL_REPLACEMENT_156___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_156___);
var ___CSS_LOADER_URL_REPLACEMENT_157___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_157___);
var ___CSS_LOADER_URL_REPLACEMENT_158___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_158___);
var ___CSS_LOADER_URL_REPLACEMENT_159___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_159___);
var ___CSS_LOADER_URL_REPLACEMENT_160___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_160___);
var ___CSS_LOADER_URL_REPLACEMENT_161___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_161___);
var ___CSS_LOADER_URL_REPLACEMENT_162___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_162___);
var ___CSS_LOADER_URL_REPLACEMENT_163___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_163___);
var ___CSS_LOADER_URL_REPLACEMENT_164___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_164___);
var ___CSS_LOADER_URL_REPLACEMENT_165___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_165___);
var ___CSS_LOADER_URL_REPLACEMENT_166___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_166___);
var ___CSS_LOADER_URL_REPLACEMENT_167___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_167___);
var ___CSS_LOADER_URL_REPLACEMENT_168___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_168___);
var ___CSS_LOADER_URL_REPLACEMENT_169___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_169___);
var ___CSS_LOADER_URL_REPLACEMENT_170___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_170___);
var ___CSS_LOADER_URL_REPLACEMENT_171___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_171___);
var ___CSS_LOADER_URL_REPLACEMENT_172___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_172___);
var ___CSS_LOADER_URL_REPLACEMENT_173___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_173___);
var ___CSS_LOADER_URL_REPLACEMENT_174___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_174___);
var ___CSS_LOADER_URL_REPLACEMENT_175___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_175___);
var ___CSS_LOADER_URL_REPLACEMENT_176___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_176___);
var ___CSS_LOADER_URL_REPLACEMENT_177___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_177___);
var ___CSS_LOADER_URL_REPLACEMENT_178___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_178___);
var ___CSS_LOADER_URL_REPLACEMENT_179___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_179___);
var ___CSS_LOADER_URL_REPLACEMENT_180___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_180___);
var ___CSS_LOADER_URL_REPLACEMENT_181___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_181___);
var ___CSS_LOADER_URL_REPLACEMENT_182___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_182___);
var ___CSS_LOADER_URL_REPLACEMENT_183___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_183___);
var ___CSS_LOADER_URL_REPLACEMENT_184___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_184___);
var ___CSS_LOADER_URL_REPLACEMENT_185___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_185___);
var ___CSS_LOADER_URL_REPLACEMENT_186___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_186___);
var ___CSS_LOADER_URL_REPLACEMENT_187___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_187___);
var ___CSS_LOADER_URL_REPLACEMENT_188___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_188___);
var ___CSS_LOADER_URL_REPLACEMENT_189___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_189___);
var ___CSS_LOADER_URL_REPLACEMENT_190___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_190___);
var ___CSS_LOADER_URL_REPLACEMENT_191___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_191___);
var ___CSS_LOADER_URL_REPLACEMENT_192___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_192___);
var ___CSS_LOADER_URL_REPLACEMENT_193___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_193___);
var ___CSS_LOADER_URL_REPLACEMENT_194___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_194___);
var ___CSS_LOADER_URL_REPLACEMENT_195___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_195___);
var ___CSS_LOADER_URL_REPLACEMENT_196___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_196___);
var ___CSS_LOADER_URL_REPLACEMENT_197___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_197___);
var ___CSS_LOADER_URL_REPLACEMENT_198___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_198___);
var ___CSS_LOADER_URL_REPLACEMENT_199___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_199___);
var ___CSS_LOADER_URL_REPLACEMENT_200___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_200___);
var ___CSS_LOADER_URL_REPLACEMENT_201___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_201___);
var ___CSS_LOADER_URL_REPLACEMENT_202___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_202___);
var ___CSS_LOADER_URL_REPLACEMENT_203___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_203___);
var ___CSS_LOADER_URL_REPLACEMENT_204___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_204___);
var ___CSS_LOADER_URL_REPLACEMENT_205___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_205___);
var ___CSS_LOADER_URL_REPLACEMENT_206___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_206___);
var ___CSS_LOADER_URL_REPLACEMENT_207___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_207___);
var ___CSS_LOADER_URL_REPLACEMENT_208___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_208___);
var ___CSS_LOADER_URL_REPLACEMENT_209___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_209___);
var ___CSS_LOADER_URL_REPLACEMENT_210___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_210___);
var ___CSS_LOADER_URL_REPLACEMENT_211___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_211___);
var ___CSS_LOADER_URL_REPLACEMENT_212___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_212___);
var ___CSS_LOADER_URL_REPLACEMENT_213___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_213___);
var ___CSS_LOADER_URL_REPLACEMENT_214___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_214___);
var ___CSS_LOADER_URL_REPLACEMENT_215___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_215___);
var ___CSS_LOADER_URL_REPLACEMENT_216___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_216___);
var ___CSS_LOADER_URL_REPLACEMENT_217___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_217___);
var ___CSS_LOADER_URL_REPLACEMENT_218___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_218___);
var ___CSS_LOADER_URL_REPLACEMENT_219___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_219___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

/********************************************* 컨텐츠 *********************************************/
/* e-HC Status */
.box__status {
  display: flex;
  flex-direction: column;
}
.status__info {
  display: flex;
  flex-direction: column;
}
.status__info li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2px;
  padding: 0 24px 0 16px;
  width: calc(100% - 40px);
  height: 48px;
  background: #f8f8fb;
}
.status__info li:first-child {
  margin-top: 0;
}
.status__info li p {
  color: #2a2c2f;
}
.status__info li p:first-child {
  width: 75%;
  font-weight: 500;
}
.status__info li p:last-child {
  width: 25%;
  text-align: right;
}
.status__info li p strong {
  font-weight: 500;
}
.status__info li p span {
  color: #909fb7;
  margin-left: 0.5rem;
}
.status__data {
  display: flex;
  justify-content: center;
  margin-top: 22px;
}
.status__data li {
  display: flex;
  align-items: center;
  justify-content: center;
}
.status__data li:last-child {
  padding-right: 14px;
}
.status__data li:before {
  content: "";
  height: 40px;
  border-left: 1px solid #dde2e9;
  padding-left: 2px;
  margin-left: 2px;
}
.status__data li:first-child::before {
  content: none;
}
.status__data li:last-child::before {
  padding-left: 35px;
}
.status__data li a {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 104px;
  height: 128px;
  border-radius: 4px;
  border: 1px solid #fff;
}
.status__data li a::before {
  content: "B";
  color: #fff;
  font-size: 1.188rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-bottom: 9px;
  background-color: #5b71ef;
}
.status__data li:nth-child(2) a::before {
  content: "P";
  background-color: #13a79e;
}
.status__data li:nth-child(3) a::before {
  content: "A";
  background-color: #ff9900;
}
.status__data li:nth-child(4) a::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center 12px #1fc95c;
  background-size: 0.604rem 1.167rem;
}
.status__data li a:focus,
.status__data li a.on {
  cursor: pointer;
  width: 102px;
  /* width: 100%; */
  height: 126px;
  box-shadow: 0px 4px 4px rgba(144, 159, 183, 0.5);
}
.status__data li:nth-child(1) a:focus,
.status__data li:nth-child(1) a.on {
  border: 2px solid #5b71ef;
  background: #eff1fe;
}
.status__data li:nth-child(2) a:focus,
.status__data li:nth-child(2) a.on {
  background: #e6fcfa;
  border: 2px solid #13a79e;
}
.status__data li:nth-child(3) a:focus,
.status__data li:nth-child(3) a.on {
  background: #fff5e6;
  border: 2px solid #ff9900;
}
.status__data li:nth-child(4) a:focus,
.status__data li:nth-child(4) a.on {
  background: #e9faef;
  border: 2px solid #1fc95c;
}
.status__data li p.name {
  font-weight: 400;
  font-size: 14px;
  line-height: 10px;
  color: #2a2c2f;
  letter-spacing: -0.075rem;
}
.status__data li p.txt {
  font-weight: 500;
  font-size: 30px;
  line-height: 28px;
  color: #2a2c2f;
  margin-top: 12px;
}
.status__data li a:focus p.name,
.status__data li a.on p.name {
  font-weight: 500;
}
.status__data li a:focus p.txt,
.status__data li a.on p.txt {
  font-weight: 700;
}
.box__setting {
  display: none;
}
.box.on .box__setting {
  position: absolute;
  top: -48px;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding-top: 48px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
}
.box.on .btn-setting.toggle {
  position: relative;
  z-index: 2;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center;
}
.box__setting .form__input {
  height: calc(100% - 72px);
  width: 80%;
  margin: 0 auto;
}
.box__setting .form__input li {
  justify-content: center;
}
.box__setting .form__input li .select ul li {
  justify-content: unset;
}
.box__setting .form__input .input__area {
  width: 70%;
}
.box__setting .popup__footer {
  border-top: 0;
  padding-bottom: 0;
}

/* e-HC Work Order */
.box__status .txt-info {
  line-height: 1.7;
}
.content > .box .box__body .step-order {
  display: flex;
  justify-content: space-between;
}
.content > .box .box__body .step-order li {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  background: #fff;
  height: 60px;
  padding: 16px 14px 12px;
}
.content > .box .box__body .step-order li + li {
  margin-left: 12px;
}
.content > .box .box__body .step-order li:last-child {
  background: none;
}
.content > .box .box__body .step-order li .tit {
  font-weight: 500;
  font-size: 15px;
  line-height: 14px;
  letter-spacing: -0.4px;
  color: #646c74;
}
.content > .box .box__body .step-order li .total-num {
  font-weight: 500;
  font-size: 13px;
  text-align: right;
  color: #646c74;
}
.content > .box .box__body .step-order li .total-num strong {
  font-size: 26px;
  color: #003876;
}
@media screen and (max-width: 499px) {
  .content > .box .box__body .step-order li {
    padding: 14px 9px 10px;
    height: 56px;
  }
  .content > .box .box__body .step-order li .tit {
    font-size: 14px;
  }
  .content > .box .box__body .step-order li .total-num {
    font-size: 12px;
  }
  .content > .box .box__body .step-order li .total-num strong {
    font-size: 22px;
  }
  .content > .box .box__body .step-order li + li {
    margin-left: 7px;
  }
}
@media screen and (max-width: 380px) {
  .content > .box .box__body .step-order li {
    padding: 14px 4px 10px;
  }
  .content > .box .box__body .step-order li + li {
    margin-left: 3px;
  }
}

/* e-HC List */
.box.list .box__header {
  border-bottom: 0;
}
.box.list .box__body {
  padding-top: 0;
  height: calc(100% - 63px);
}
.box.list .box__body .tbl-list {
  height: calc(100% - 93px);
  border-bottom: 1px solid #dde2e9;
}
.box.list .box__body .tbl-list table {
  border-bottom: 0;
}
.tbl-list .btn-renew {
  margin: 0 auto;
  color: #909fb7;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat 7px center transparent;
  background-size: 20px 20px;
}
.tbl-list .btn-renew span {
  padding-left: 17px;
  font-size: 13px;
  color: #909fb7;
}
.tbl-list table.pd-13 th,
.tbl-list table.pd-13 td {
  padding-top: 13px;
  padding-bottom: 13px;
}
.searchinput {
  display: flex;
  align-items: center;
}
.searchinput .select + .input__direct {
  margin-left: 8px;
}
.icon-step {
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-step li {
  width: 8px !important;
  height: 8px !important;
  background: #dde2e9;
  margin-left: 2px;
}
.icon-step li:first-child {
  margin-left: 0;
}
.icon-step.one li:nth-child(1) {
  background: #5b71ef;
}
.icon-step.two li:nth-child(1) {
  background: #5b71ef;
}
.icon-step.two li:nth-child(2) {
  background: #13a79e;
}
.icon-step.all li:nth-child(1) {
  background: #5b71ef;
}
.icon-step.all li:nth-child(2) {
  background: #13a79e;
}
.icon-step.all li:nth-child(3) {
  background: #ff9900;
}
/* 상세정보 페이지 팝업 */
.page-detail .popup__head {
  border-bottom: 0;
}
/* 20220629 =======================   layout_안내팝업.html : 498 ~ 517 참고  ===================================== */
.page-detail .popup__head-opinion {
  border-bottom: 0;
}
/* ============================================================================================================== */

/* 20220628 =======================   layout_안내팝업.html : 926 ~ 940 참고  ===================================== */
.page-detail .popup__head-restart {
  border-bottom: 0;
}
/* ============================================================================================================== */

.page-detail .popup__footer {
  border-top: 0;
  padding-top: 0;
}

/* 20220629 =======================   layout_안내팝업.html : 498 ~ 517 참고  ===================================== */
.page-detail .popup__footer-opinion {
  border-top: 0;
  padding-top: 0;
}
/* ============================================================================================================== */
/* 20220628 =======================   layout_안내팝업.html : 926 ~ 940 참고  ===================================== */
.page-detail .popup__footer-restart {
  border-top: 0;
  padding-top: 0;
}
/* ============================================================================================================== */
.page-detail .popup__body {
  margin-top: -1rem;
}
/* 20220629 =======================   layout_안내팝업.html : 498 ~ 517 참고  ===================================== */
.page-detail .popup__body-opinion {
  margin-top: -1rem;
}
/* ============================================================================================================== */
.page-detail .datadetail-info {
  margin-top: -8px;
}
.page-detail .datadetail-info li {
  display: flex;
  margin-top: 1rem;
}
.page-detail .datadetail-info li:first-child {
  margin-top: 0;
}
.page-detail .datadetail-info feSpotLight {
  display: flex;
  flex-direction: column;
}
.page-detail .datadetail-info li p:first-child {
  width: 90px;
  color: #909fb7;
}
.page-detail .datadetail-info li .icon-step {
  margin: 0 auto;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 4px;
  margin-left: 1rem;
}
.page-detail .datadetail-info li .icon-step li {
  margin-top: 0;
  width: 12px !important;
  height: 10px !important;
  margin-left: 4px;
  border: 0;
}
.page-detail .datadetail-info li .icon-step li:first-child {
  margin-left: 0;
}
.page-detail .datadetail-info li.btnarea {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 40px 0 18px;
}
.page-detail .datadetail-info li.btnarea div {
  width: 33%;
}
.page-detail .datadetail-info li.btnarea div p {
  font-size: 14px;
  color: #2a2c2f;
}
.page-detail .datadetail-info li.btnarea div button {
  margin: 0 auto;
  height: 40px;
  width: 100%;
}
.page-detail .datadetail-info li div .btn-file {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center center;
  background-size: 0.75rem 1.449rem;
}
.page-detail .datadetail-info li div .btn-memo {
  border-radius: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center center;
  background-size: 1.167rem 1.167rem;
}
.page-detail .datadetail-info li.btnarea div button.btn-file.btn:disabled:hover {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center center;
  background-size: 0.75rem 1.449rem;
}
.d-sm-block-toggle {
  display: none;
}
/* 데이터 검색결과 없음 */
.nodata {
  display: flex;
  flex-direction: column;
  /* height: calc(100% - 63px); */
}
/* .nodata .tbl__top {
  display: none;
} */
.nodata .tbl-list {
  display: none;
}
.nodata .paging {
  display: none;
}
.nodata .result__num {
  display: none;
}
.nodata .nodata__txt {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60vh;
  font-size: 14px;
  line-height: 1.4;
  text-align: center;
  letter-spacing: -0.4px;
  color: #909fb7;
}
.nodata .nodata__txt::before {
  content: "";
  width: 164px;
  height: 92px;
  margin-bottom: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat center center;
  background-size: 100%;
}
.nodata__txt {
  display: none;
}
.nodata .nodata__txt.w800 {
  width: 800px;
  border-top: 1px solid #dde2e9;
  border-bottom: 1px solid #dde2e9;
  padding: 168px 0 186px;
}
.nodata .nodata__txt.w800::before {
  width: 120px;
  height: 100px;
  margin-bottom: 0;
}
.nodata .nodata__txt.w800 span {
  font-size: 0.875rem;
  margin-top: 9px;
  text-align: center;
}
.nodata-intable {
  display: flex;
  align-items: center;
  justify-content: center;
}
.nodata-intable::before {
  content: "";
  width: 24px;
  height: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat center center;
  background-size: 100%;
}

/* Basic e-HC */
.box.ehc__score .box__body {
  height: calc(100% - 80px);
}
.ehc-b .box__title .cate {
  font-weight: 700;
}
.ehc-b .box__title .cate {
  color: #5b71ef;
}
.ehc-p .box__title .cate {
  color: #13a79e;
}
.ehc-a .box__title .cate {
  color: #ff9900;
}
.ehc-n .box__title .cate {
  color: #1fc95c;
}
.ehc-b .box__title .cate span,
.ehc-p .box__title .cate span,
.ehc-a .box__title .cate span,
.ehc-n .box__title .cate span {
  color: #2a2c2f;
}
.box__etc .date {
  font-size: 15px;
  color: #2a2c2f;
}
.ehc__info {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: absolute;
  top: 1rem;
  width: calc(100% - 4rem);
  background: #f8f8fb;
  color: #2a2c2f;
  padding: 0.75rem 1rem;
  z-index: 2;
}
.ehc__info.on {
  box-shadow: 0px 2px 8px rgba(144, 159, 183, 0.5);
}
.ehc__name {
  font-weight: 500;
  display: flex;
  align-items: center;
}
.ehc__name::before {
  content: "";
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-radius: 50%;
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.5rem;
}
.ehc-b .ehc__name::before {
  content: "B";
  background-color: #5b71ef;
}
.ehc-p .ehc__name::before {
  content: "P";
  background-color: #13a79e;
}
.ehc-a .ehc__name::before {
  content: "A";
  background-color: #ff9900;
}
.ehc-n .ehc__name::before {
  content: "N";
  background-color: #1fc95c;
}
.ehc__info ul {
  position: relative;
  cursor: pointer;
  padding-right: 1.75rem;
  height: 25px;
  overflow: hidden;
}
.ehc__info ul::after {
  content: "";
  position: absolute;
  right: 0;
  top: 1px;
  width: 1.25rem;
  height: 1.25rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat 0 0;
}
.ehc__info ul.on {
  height: 100%;
  overflow: unset;
}
.ehc__info ul.on::after {
  transform: rotate(180deg);
}
.ehc__info ul li {
  margin-top: 1rem;
  display: flex;
}
.ehc__info ul li:first-child {
  margin-top: 0.25rem;
}
.ehc__info ul li span {
  text-align: left;
}
.ehc__info ul li span:first-child {
  width: 5rem;
  margin-right: 1.375rem;
  color: #909fb7;
}
.ehc__detail {
  margin: 4.5rem 0 2.5rem;
}
.ehc__detail p.tit {
  color: #2a2c2f;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.813rem;
}
.ehc__detail p.txt {
  margin-top: 2px;
  margin-left: 1.375rem;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.438rem;
  color: #2a2c2f;
}
.ehc__selectbtn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 3.5rem 2rem 4.5rem;
}
.ehc__selectbtn li {
  position: relative;
  margin-left: 1rem;
  max-width: 4.5rem;
  width: calc(100% / 5);
  height: 4.5rem;
  /* background: #f8f8fb; */
  /* border: 1px solid #dde2e9; */
  border-radius: 8px;
}
.ehc__selectbtn li:first-child {
  margin-left: 0;
}
.ehc__selectbtn button {
  width: 100%;
  height: 100%;
  background: #f8f8fb;
  border: 1px solid #dde2e9;
  border-radius: 8px;
}
.ehc__selectbtn button:first-child {
  margin-left: 0;
}
.ehc__selectbtn button span {
  font-family: "Urbanist", sans-serif;
  font-weight: 500;
  font-size: 28px;
  color: #2a2c2f;
}
.ehc__selectbtn button:hover {
  background-color: #b4d2ff;
}
.ehc__selectbtn button:active,
.ehc__selectbtn button.on {
  background-color: #0a78ff;
  border-color: #0a78ff;
}
.ehc__selectbtn button:active span,
.ehc__selectbtn button.on span {
  color: #fff;
  font-weight: 600;
}
.ehc__selectbtn button:disabled span {
  color: #dde2e9;
}
.ehc__selectbtn.disabled {
  background: none;
  border: 0;
}
.ehc__selectbtn button:disabled {
  background: #f8f8fb;
  border: 1px solid #f0f2f4;
}
.ehc__selectbtn button:disabled span {
  color: #dde2e9;
}
.ehc__selectbtn.error {
  position: relative;
}
.ehc__selectbtn.error .input-errortxt {
  display: block;
  position: absolute;
  top: 80px;
  width: calc(100% + 50px);
}
.ehc__selectbtn.error button.errorpoint {
  background: #f8f8fb;
  border: 1px solid #f55547;
}
.ehc__selectbtn.error button.errorpoint span {
  color: #2a2c2f;
}
.ehc__score .btn-comment,
.ehc__score .btn-comment-check {
  margin-left: 0.875rem;
}
.ehc__score .btn-comment span,
.ehc__score .btn-comment-check span {
  font-size: 0.875rem;
  font-weight: 400;
  color: #2a2c2f;
  line-height: 1.4;
}
.ehc__score .tbl__top {
  margin-bottom: 1.625rem;
}
.ehc__score .tbl-list {
  max-height: 393px;
  overflow-y: auto;
  margin-bottom: 9rem;
}
.ehc__score .tbl-list table th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
}
.ehc__score .tbl-list tr td {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.ehc__score .tbl-list tr td:first-child {
  vertical-align: top;
}
.ehc__score .tbl__bottom {
  position: absolute;
  bottom: 0;
  height: auto;
  /* height: 5.875rem; */
  width: calc(100% - 2rem);
  background: #fff;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 2rem;
}
.ehc__step {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 2.75rem;
}
.progressbar {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.progressbar .step {
  font-weight: 500;
  font-size: 0.938rem;
  color: #2a2c2f;
}
.progressbar .progress-value {
  display: flex;
  flex-direction: column;
  width: calc(100% - 76px);
  margin-top: 3px;
  position: relative;
}
.progressbar .progress-value .value {
  position: relative;
  margin-left: -15px;
  width: calc(100% - 18px);
}
.progressbar .progress-value .value span {
  position: absolute;
  top: 5px;
  width: 40px;
  font-weight: 500;
  font-size: 0.938rem;
  color: #0a78ff;
  text-align: center;
}
.progressbar .progress-value progress {
  appearance: none;
  height: 0.5rem;
  width: 100%;
}
.progressbar .progress-value progress::-webkit-progress-bar {
  background: #dde2e9;
  font-size: 1rem;
  color: #222;
}
.progressbar .progress-value progress::-webkit-progress-value {
  background: #0a78ff;
  font-size: 1rem;
  color: #222;
}
.ehc__score .tbl__bottom .btn__wrap button {
  padding: 0 1.25rem;
  width: 8.5rem;
  height: 2.5rem;
  background-color: #0a78ff;
  border: 0;
}
.ehc__score .tbl__bottom .btn__wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.ehc__score .tbl__bottom .btn__wrap button:hover {
  background: #0050b8;
}
.ehc__score .tbl__bottom .btn__wrap button:active {
  background: #003876;
}
.ehc__score .tbl__bottom .btn__wrap button span {
  color: #fff;
  font-weight: 700;
}
.ehc__score .tbl__bottom .btn__wrap .bg-transparent {
  background: transparent;
}
.ehc__score .tbl__bottom .btn__wrap .bg-transparent:hover {
  background: #e6f0ff;
}
.ehc__score .tbl__bottom .btn__wrap .bg-transparent:active {
  background: #b4d2ff;
}
.ehc__score .tbl__bottom .btn__wrap .bg-transparent:disabled span {
  color: #dde2e9;
}
.ehc__score .tbl__bottom .btn__wrap .bg-transparent:disabled {
  opacity: 0.3;
  filter: contrast(10%);
}
.ehc__score .tbl__bottom .btn__wrap .bg-transparent:disabled:hover {
  background: transparent;
}
.ehc__score .tbl__bottom .btn__wrap .bg-transparent span {
  color: #0a78ff;
  padding-left: 2.25rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat 0 center;
}
.ehc__score .tbl__bottom ul.btn__wrap li {
  display: flex;
}
.ehc__score .tbl__bottom ul.btn__wrap li button + button {
  margin-left: 8px;
}
.txtnum,
.popup__body p.txtnum {
  /* font-family: 'Urbanist', sans-serif; */
  font-size: 0.875rem;
  font-size: 13px;
  line-height: 19px;
  color: #909fb7;
  text-align: right;
  margin-top: 4px;
}
.popup-boxin .page-detail .popup__body p.txtnum {
  line-height: 17px;
}
.ehc__memo {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.ehc__memo textarea {
  height: 234px;
}
.ehc__memo textarea::placeholder {
  color: #909fb7 !important;
}
.memo__txt {
  padding: 6px 8px;
  font-size: 0.938rem;
  line-height: 1.5rem;
  color: #2a2c2f;
  word-break: break-all;
  text-align: justify;
}
.ehc__memo button {
  margin-top: 0.5rem;
  background: #909fb7;
  padding: 6px 27px 4px;
}
.ehc__memo button span {
  font-size: 0.875rem;
  color: #fff;
}
.ehc__addfile {
  margin-bottom: 1rem;
}
.ehc__addfile p.tit {
  color: #2a2c2f;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.813rem;
}
.ehc__addfile p.txt {
  margin: 0.75rem 0;
  font-size: 0.875rem;
  line-height: 1.5rem;
  color: #909fb7;
}
/*사진첨부 롤링이미지*/
.ehc__rolling {
  width: 100%;
  height: 176px;
  margin: 0 auto 9rem;
  padding-top: 0;
  overflow: hidden;
  position: relative;
}
.rolling__left {
  position: absolute;
  top: 40%;
  left: 0;
  width: 2rem;
  z-index: 2;
}
.rolling__left a {
  display: block;
  width: 2rem;
  height: 2rem;
  transform: rotate(180deg);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat center center;
}
.rolling__right {
  position: absolute;
  top: 40%;
  right: 0;
  width: 2rem;
  z-index: 2;
}
.rolling__right a {
  display: block;
  width: 2rem;
  height: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat center center;
}
.ehc__picture {
  float: left;
  position: relative;
  width: 100%;
  height: 176px;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
.ehc__picture ul {
  position: absolute;
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
}
.ehc__picture ul li {
  position: relative;
  float: left;
  width: 176px;
  height: 176px;
  margin-right: 8px;
}
.ehc__picture li .btn-delete-w {
  position: absolute;
  right: 4px;
  top: 5px;
  z-index: 2;
  border-radius: 0;
}
.ehc__picture li:first-child a {
  /* margin-left: 0; */
}
.ehc__picture li a {
  display: block;
  width: 176px;
  height: 176px;
  /* margin-left: 8px; */
  border-radius: 2px;
  background: #f0f2f4;
}
.picimg__view img {
  display: block;
  width: 100%;
  max-width: 424px;
  height: 424px;
  margin: 0 auto;
}
/*점검전 안내 문구, 빈화면*/
.txt-ready {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 26px;
  color: #909fb7;
}
.txt-ready::before {
  content: "";
  display: block;
  width: 145px;
  height: 136px;
  margin-bottom: 1rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat center center;
  background-size: 100%;
}
.txt-ready strong {
  font-weight: 700;
}

/*점검결과*/
.result__txt {
  display: flex;
  width: calc(100% - 16px);
  margin-left: -1rem;
  padding: 5px 32px 30px;
  box-shadow: 0px 4px 5px rgb(144 159 183 / 15%);
}
.ehc__detail .result__txt .tit {
  font-size: 13px;
  line-height: 14px;
  color: #2a2c2f;
  font-weight: 400;
  padding-top: 35px;
  margin-top: 5px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat top center;
  background-size: 26px 26px;
}
.ehc__detail .result__txt .tit.caution {
  padding-top: 35px;
  margin-top: 5px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat top center;
}
.ehc__detail .result__txt .tit.danger {
  padding-top: 35px;
  margin-top: 5px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat top center;
  background-size: 26px 26px;
}
/* .ehc__detail .result__txt .tit.safety {
  padding-top: 35px;
  margin-top: 5px;
  background: url("../img/icon_safety.png") no-repeat top center;
  background-size: 26px 26px;
} */
.result__txt .btn-edit {
  width: 32px;
  height: 32px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat center center #909fb7;
  background-size: 1.125rem 1.124rem;
}
.ehc__detail .result__txt .score {
  font-weight: 600;
  font-size: 66px;
  line-height: 0.8;
  color: #2a2c2f;
  margin: 0 26px 0 8px;
}
.ehc__detail .result__txt .txt {
  width: calc(100% - 200px);
  font-size: 16px;
  line-height: 26px;
  color: #2a2c2f;
  font-weight: 400;
  margin: 0;
}
.ehc__chart {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 3px 8px 0 6px;
  padding: 23px;
  width: calc(100% - 57px);
  height: 362px;
  text-align: center;
  border-radius: 20px;
  background: #fff;
  filter: drop-shadow(0px 2px 10px rgba(144, 159, 183, 0.3));
}
.ehc__chart__img {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}
.ma__score {
  margin: 24px 4px;
}
.ehc__detail .ma__score p.tit {
  font-size: 1rem;
  font-weight: 500;
}
.score__info {
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
}
.score__info li {
  background: #fff;
  padding: 17px 42px 23px;
}
.score__info li:nth-child(odd) {
  background: #f8f9fa;
}
.score__info li.disabled .tit::after {
  content: "";
  width: 1rem;
  height: 1rem;
  margin-left: 4px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) no-repeat center center;
}
.score__info li.disabled .icon-score li:nth-child(1),
.score__info li.disabled .icon-score li:nth-child(7) {
  color: #646c74;
}
.ehc__detail .ma__score .score__info li .tit {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 15px;
  color: #2a2c2f;
  margin-bottom: 13px;
}
.score__info li .tit span + span {
  font-weight: 400;
  margin-left: 5px;
}
.icon-score {
  display: flex;
  align-items: center;
}
.icon-score li {
  padding: 0;
}
.icon-score li:nth-child(1) {
  margin-right: 30px;
}
.icon-score li:nth-child(7) {
  margin-left: 30px;
}
.icon-score li:nth-child(1),
.icon-score li:nth-child(7) {
  font-size: 14px;
  color: #2a2c2f;
}
.icon-score li:nth-child(2),
.icon-score li:nth-child(3),
.icon-score li:nth-child(4),
.icon-score li:nth-child(5),
.icon-score li:nth-child(6) {
  width: 40px;
  height: 10px;
  background: #dde2e9;
  margin: 0 2px;
}
.icon-score.score1 li:nth-child(2) {
  background-color: #646c74;
}
.icon-score.score2 li:nth-child(3) {
  background-color: #646c74;
}
.icon-score.score3 li:nth-child(4) {
  background-color: #646c74;
}
.icon-score.score4 li:nth-child(5) {
  background-color: #646c74;
}
.icon-score.score5 li:nth-child(6) {
  background-color: #646c74;
}

.ehc__score .ehc__result + .tbl__bottom {
  margin-bottom: 18px;
  border-top: 1px solid #dde2e9;
  padding-top: 20px;
}
.ehc__score .ehc__result + .tbl__bottom .btn__wrap button {
  background-color: #5b71ef;
  width: auto;
}
/* .ehc-p.ehc__score .ehc__result + .tbl__bottom .btn__wrap button {
  background-color: #13a79e;
}
.ehc-a.ehc__score .ehc__result + .tbl__bottom .btn__wrap button {
  background-color: #ff9900;
}
.ehc-n.ehc__score .ehc__result + .tbl__bottom .btn__wrap button {
  background-color: #1fc95c;
} */
.ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-share,
.ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-reload {
  background-color: #fff;
}
.ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-share span,
.ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-reload span {
  color: #909fb7;
  font-weight: 500;
  font-size: 14px;
}
.ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-share:hover {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) no-repeat 0 center;
}
.ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-reload:hover {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) no-repeat 0 center;
}
.ehc__result .scrollH {
  max-height: 680px;
  margin-top: 18px;
  margin-right: -12px;
  overflow-x: hidden;
}

/*박스안 팝업*/
.popup-boxin {
  display: none;
  width: 100%;
}
.popup-boxin.on {
  display: block;
  position: absolute;
  top: -48px;
  left: 0;
  height: calc(100% + 48px);
}
.popup-boxin::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  min-width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  z-index: 2;
}
.popup-boxin .page-detail {
  position: absolute;
  left: 6%;
  width: 88%;
  height: auto;
  top: 25%;
  background: #fff;
  z-index: 3;
  border-radius: 4px;
  filter: drop-shadow(0px 10px 30px rgba(42, 44, 47, 0.5));
}
.popup-boxin .page-detail.w400 {
  width: 25rem;
  left: 12%;
}
.popup-boxin .page-detail.w400 .popup__body {
  padding: 1rem 2rem 1.5rem 1rem;
  width: calc(100% - 3.5rem);
}
.popup-boxin .page-detail.w400 h1 {
  font-weight: 700;
}
.popup-boxin .page-detail.w400 .popup__body p {
  font-size: 0.875rem;
  line-height: 22px;
}
.popup-boxin .page-detail.w400 .popup__body p.fontMedium {
  line-height: 20px;
}
.popup-boxin .popup__head h1 {
  font-weight: 500;
}
.popup-boxin .popup__body .form__input {
  margin: 1rem auto;
}
.popup-boxin .page-detail .popup__body p.tit {
  font-weight: 700;
  font-size: 15px;
  line-height: 14px;
  letter-spacing: -0.004em;
  color: #2a2c2f;
}
.popup-boxin .popup__body .form__input input[type="text"].input-error {
  background: none;
}
.popup-boxin .popup__body .form__input .input-errortxt {
  top: 32px;
}

/* 20220629 =======================   layout_안내팝업.html : 498 ~ 517 참고  ===================================== */
.popup-boxin .popup__head-opinion h1 {
  font-weight: 500;
}
/* ============================================================================================================== */

/* 20220628 =======================   layout_안내팝업.html : 926 ~ 940 참고  ===================================== */
.popup-boxin .popup__head-restart h1 {
  font-weight: 500;
}
/* ============================================================================================================== */

.popup-boxin .page-detail .popup__body {
  min-height: 80px;
}
/* 20220629 =======================   layout_안내팝업.html : 498 ~ 517 참고  ===================================== */
.popup-boxin .page-detail .popup__body-opinion {
  min-height: 80px;
}
/* ============================================================================================================== */
/* 20220628 =======================   layout_안내팝업.html : 926 ~ 940 참고  ===================================== */
.popup-boxin .page-detail .popup__body-restart {
  min-height: 80px;
}
/* ============================================================================================================== */
.popup-boxin .page-detail .popup__body p {
  line-height: 22px;
}

/* 파일 reports */
.container.filereports:not(.testrecord) .content {
  padding-left: 0;
  width: 100%;
}
.container.filereports .content {
  width: calc(100% - 40px);
  grid-template-columns: 1fr auto;
  grid-template-rows: repeat(1, minmax(1006px, auto));
}
.container.filereports .box.list .box__body {
  height: calc(100% - 16px);
}

/* 파일 reports-오른쪽 영역 */
.container.filereports .box.ehc__score {
  width: 520px;
}
.container.filereports .box.ehc__score .box__title {
  display: flex;
  align-items: center;
}
.container.filereports .box.ehc__score .btn-box {
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 8px;
  margin-left: -0.5rem;
  border: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) no-repeat center center;
  background-size: 100%;
}
.container.filereports .box.ehc__score.close {
  width: 38px;
}
.container.filereports .box.ehc__score.close .cate,
.container.filereports .box.ehc__score.close .box__etc,
.container.filereports .box.ehc__score.close .box__body {
  display: none;
}
.container.filereports .box.ehc__score.close .box__header {
  padding: 0 0.75rem;
  justify-content: center;
  border-bottom: 0;
}
.container.filereports .box.ehc__score.close .btn-box {
  display: flex;
  width: auto;
  height: auto;
  margin: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) no-repeat center center;
}
.container.filereports .box.ehc__score.close .btn-box::after {
  content: "e-HC Report";
  writing-mode: vertical-rl;
  -ms-writing-mode: tb-rl;
  transform: rotate(180deg);
  margin-top: 9.5rem;
  font-weight: 700;
}

/* 탭 */
/*탭 슬라이드 관련*/
.swiper-section {
  margin: 0 -1rem;
}
.swiper-section .swiper-navigation {
  background: #fff;
  width: 52px;
  height: 45px;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
  box-shadow: -12px -14px 38px rgba(144, 159, 183, 0.5);
}
.swiper-section .swiper-button-prev,
.swiper-section .swiper-button-next {
  top: 23px;
}
.swiper-section .swiper-button-next,
.swiper-section .swiper-container-rtl .swiper-button-prev {
  right: 0;
  left: auto;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) no-repeat center center;
}
.swiper-section .swiper-button-prev,
.swiper-section .swiper-container-rtl .swiper-button-next {
  right: 26px;
  left: auto;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) no-repeat center center;
}
.swiper-section .swiper-button-next::before {
  content: "";
  display: block;
  width: 1px;
  height: 30px;
  margin-top: 9px;
  background: #dde2e9;
}

/*기본 언더라인 탭*/
.tab__line {
  display: flex;
  align-items: center;
  gap: 20px;
  border-bottom: 1px solid #dde2e9;
  background: #fff;
  width: 100%;
}
.tab__line li {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 14px 13px;
  cursor: pointer;
}
.tab__line li a {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  color: #646c74;
}
.tab__line li.on {
  border-bottom: 3px solid #0a78ff;
  background: #fff;
  font-weight: 500;
  color: #2a2c2f;
}
.tab__line li.on a {
  font-weight: 700 !important;
  color: #2a2c2f !important;
}
.box__header .tab__line {
  margin-left: -24px;
  padding-left: 24px;
  padding-right: 24px;
}
.tab__line.medium:not(.column) li,
.content.w100p .tab__line.medium:not(.column) li {
  padding: 12px 24px;
  min-width: 80px;
}
.tab__line.medium li a,
.content.w100p .tab__line.medium li a {
  font-size: 15px;
  font-weight: 500 !important;
  color: #7d8282;
  letter-spacing: -0.04em;
}
.tab__line.medium:not(.column) li.on a,
.content.w100p .tab__line.medium:not(.column) li.on a {
  color: #2a2c2f;
}
.tab__line.medium li a,
.content.w100p .tab__line.medium li a {
  font-size: 15px;
  font-weight: 500;
  color: #7d8282;
  letter-spacing: -0.04em;
}
.tab__line.small li a,
.content.w100p .tab__line.small li a {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.04em;
}
.tab__line.column {
  flex-direction: column;
  gap: 0;
  height: 100%;
  background: #f7f8fa;
  border-right: 1px solid #dde2e9;
  border-bottom: 0;
}
.tab__line.column li,
.content.w100p .tab__line.column li {
  padding: 14px 32px;
  width: calc(100% - 64px);
  height: auto;
  min-height: 39px;
  border-bottom: 1px solid #dde2e9;
}
.tab__line.column li a,
.content.w100p .tab__line.column li a {
  justify-content: flex-start;
  line-height: 1.4;
  word-break: keep-all;
}
.tab__line.column li.on,
.content.w100p .tab__line.column li.on {
  position: relative;
}
.tab__line.column li.on:after,
.content.w100p .tab__line.column li.on:after {
  content: "";
  position: absolute;
  right: -1px;
  top: 0;
  width: 1px;
  height: 100%;
  background: #fff;
}
.tab__line.column li.on a,
.content.w100p .tab__line.column li.on a {
  color: #0a78ff;
  font-weight: 700;
}

@media screen and (max-width: 940px) {
  #wrap:not(.no-responsive) .box__header .tab__line {
    margin: 0 !important;
    padding: 0 !important;
    gap: 0;
  }
  #wrap:not(.no-responsive) .tab__line li {
    flex: 1;
    padding: 14px;
  }
  #wrap:not(.no-responsive) .tab__line li a {
    font-size: 16px;
    line-height: 1.2;
  }
}

/* 탭 - 라운드 */
.tab__line.round {
  flex-wrap: wrap;
  gap: 9px;
  width: auto;
  border: 0;
  margin-bottom: 16px;
}
.tab__line.round li {
  padding: 0 24px;
  height: 30px;
  font-size: 0.938rem;
  font-weight: 400;
  color: #2a2c2f;
  line-height: 0;
  border: 1px solid #dde2e9;
  border-radius: 25px;
}
.tab__line.round li.on {
  color: #fff;
  font-weight: 700;
  background: #0a78ff;
  border-color: #0a78ff;
}

.swiper-container {
  border-bottom: 1px solid #dde2e9;
  background: #fff;
}
.swiper-slide.tab {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  width: auto !important;
  min-width: 72px;
  padding: 0 24px;
}
.swiper-slide.tab p {
  font-weight: 500;
  color: #646c74;
}
.swiper-slide.tab.on {
  font-weight: 700;
  color: #2a2c2f;
  border-bottom: 3px solid #0a78ff;
  background: #fff;
}
.swiper-slide.tab.on p {
  font-weight: 700;
  color: #2a2c2f;
}

/*탭 내용*/
.tabcontent {
  display: none;
  height: calc(100% - 49px);
  flex-direction: column;
}
.current {
  display: flex;
}
.tabcontent__top {
  margin-bottom: 8px;
}
.tabcontent__title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  font-size: 20px;
  color: #2a2c2f;
  margin: 37px 8px 8px;
}
.tabcontent .title {
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 15px;
  color: #2a2c2f;
}

/*검색영역*/
.tabcontent .search {
  /* padding: 32px 0 32px 8px; */
  padding: 24px 0 24px 8px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #dde2e9;
}
.tabcontent .search .form__input {
  display: inline-block;
  float: left;
  width: calc(100% - 120px);
  /* grid-template-columns: repeat(auto-fill, minmax(23%, auto));
  row-gap: 7px; */
}
.tabcontent .search .form__input li {
  display: inline-block;
  float: left;
  width: auto;
  margin-top: 0;
}
.tabcontent .search .form__input li label {
  display: inline-block;
  float: left;
  margin-top: 8px;
}
.tabcontent .search .form__input li + li label {
  margin-left: 38px;
  max-width: 50%;
}
.tabcontent .search .form__input .input__area {
  margin-left: 1rem;
  width: 186px;
  display: inline-block;
  float: left;
}
.tabcontent .search .form__input .input__area .select .selected {
  min-width: 80px;
}

/*기간 조회*/
.searchterm {
  display: flex;
  align-items: center;
}
.searchterm .term__month {
  width: auto;
}
.searchterm .term__month .selected {
  width: 111px;
}
.searchterm .term__date,
.term__date {
  display: flex;
  align-items: center;
  height: 32px;
}
.searchterm .term__date > div {
  flex: 1;
}
.searchterm .term__date input[type="text"] {
  width: 91px;
  padding: 0 0.75rem 0 35px;
  font-size: 15px;
  font-weight: 400;
  color: #2a2c2f;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) no-repeat 8px center;
  background-size: 20px;
  border: 0;
}
/* 250514 퍼블,개발 화면 다름 */
.searchterm:has(.w100) .term__date input[type="text"] {
  width: 83px !important;
}
.searchterm:has(.w100) .term__date.line input[type="text"] {
  border: 1px solid #909fb7;
}
@media screen and (max-width: 1042px) {
  .searchterm:has(.w100) .term__date input[type="text"] {
    width: 100% !important;
  }
}
.react-datepicker-wrapper {
  height: 100%;
}
.react-datepicker__input-container {
  border: 1px solid #909fb7;
  border-radius: 4px;
  /* height: 1.875rem; */
  height: calc(100% - 2px);
  max-height: 30px;
  font-size: 0.875rem;
  color: #2a2c2f;
  font-weight: 400;
  cursor: pointer;
}
.react-datepicker__input-container input[type="text"] {
  border: 0;
  /* width: calc(100% - 0.6rem) !important; */
  width: calc(100% - 0.6rem);
  height: 100%;
  padding: 0 0.2rem 0 0.4rem;
  cursor: pointer;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_26___}) no-repeat 98% center;
  background-size: 1.25rem 1.25rem;
}
.searchterm .term__date.w100p input[type="text"] {
  width: calc(100% - 46px);
  padding: 0 2rem 0 0.75rem;
}
.searchterm .term__date input[type="text"].calendar.end {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) no-repeat 98% center;
}
.searchterm .term__month + .term__date {
  margin-left: 8px;
}
.centerline {
  font-size: 14px;
  color: #2a2c2f;
  margin: 0 8px;
}

.tabcontent .search .btn__wrap .btn-search {
  border: 0;
  height: 32px;
  width: 104px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) no-repeat 24px center #909fb7;
  background-size: 16px;
}
.tabcontent .search .btn__wrap .btn-search span {
  font-weight: 500;
  font-size: 15px;
  color: #fff;
  margin: 0 0 0 23px;
}
.tabcontent .search .btn__wrap .btn-search:hover {
  background-color: #7a8596;
}
.tabcontent .search .btn__wrap .btn-search:active {
  background-color: #646c74;
}

/*filter*/
.filter {
  padding: 20px 10px;
  border-bottom: 1px solid #dde2e9;
  background: #fff;
}
.filter .title:hover {
  cursor: pointer;
}
.filter .title::before {
  content: "";
  width: 1rem;
  height: 1rem;
  margin-right: 10px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_28___}) no-repeat 0 center;
  background-size: 100%;
}
.filter .title .btn-close {
  display: none;
  width: 0.75rem;
  height: 0.75rem;
  margin-left: 1rem;
}
.filter .title .info {
  display: none;
  margin-left: 24px;
  font-size: 12px;
  font-weight: 400;
  color: #646c74;
}
.filter__select {
  display: none;
  margin: 24px 25px 5px;
}
.filter__type {
  display: flex;
  align-items: center;
  width: 100%;
}
.filter__type + .filter__type {
  margin-top: 13px;
}
.filter__type .tit {
  font-weight: 500;
  font-size: 15px;
  color: #2a2c2f;
}
.type__cont {
  display: flex;
  align-items: center;
  margin-left: 36px;
  flex-wrap: wrap;
  row-gap: 8px;
}
.type__cont li {
  margin-right: 5px;
  height: 30px;
  width: auto;
  min-width: 68px;
  padding: 0 10px;
  border: 1px solid #dde2e9;
  border-radius: 18px;
  background-color: transparent;
}
.type__cont li a {
  font-size: 14px;
  font-weight: 400;
  color: #2a2c2f;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100% - 1px);
}
.type__cont li:hover {
  background: rgba(0, 117, 255, 0.1);
}
.type__cont li.on {
  background: #0a78ff;
  border-color: #0a78ff;
}
.type__cont li.on a {
  font-weight: 500;
  color: #fff;
}
.type__cont li.disabled {
  background-color: #f0f2f4;
  border-color: #f0f2f4;
}
.type__cont li.disabled a {
  color: #fff;
}
.filter__type:nth-child(2) .type__cont li:not(:first-child) {
  border: 1px solid #5b71ef;
  background-color: #fff;
  border-radius: 4px;
  height: 30px;
  padding: 0 18px 0 16px;
}
.filter__type:nth-child(2) .type__cont li:nth-child(3) {
  border-color: #13a79e;
}
.filter__type:nth-child(2) .type__cont li:nth-child(4) {
  border-color: #ff9900;
}
.filter__type:nth-child(2) .type__cont li:not(:first-child) a:before {
  content: "B";
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  width: 24px;
  height: 24px;
  border-radius: 50px;
  background: #5b71ef;
}
.filter__type:nth-child(2) .type__cont li:nth-child(3) a:before {
  content: "P";
  background: #13a79e;
}
.filter__type:nth-child(2) .type__cont li:nth-child(4) a:before {
  content: "A";
  background: #ff9900;
}
.filter__type:nth-child(2) .type__cont li:not(:first-child).on a {
  font-weight: 500;
  color: #2a2c2f;
}
.filter__type:nth-child(2) .type__cont li:nth-child(2).on {
  background: #eff1fe;
}
.filter__type:nth-child(2) .type__cont li:nth-child(3).on {
  background: #e6fcfa;
}
.filter__type:nth-child(2) .type__cont li:nth-child(4).on {
  background: #fff5e6;
}
.filter.open {
  background: linear-gradient(180deg, rgba(250, 250, 250, 0) 0%, #fafafa 100%);
}
.filter.open .title {
  color: #0a78ff;
}
.filter.open .filter__select {
  display: block;
}
.filter.open .title .btn-close {
  display: block;
}
.filter.open .title .info {
  display: block;
}

/*검사성적서 filter&search-small*/
.filereports.testrecord .box.list {
  overflow-y: hidden;
}
.container.filereports.testrecord .content {
  padding-left: 0;
  width: 100%;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(1, minmax(1006px, auto));
}
.tabcontent__title .btn-qr {
  display: none;
}
.search__inline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 28px 0 8px;
}
.search__inline .filter {
  display: flex;
  align-items: center;
  border: 0;
  background: none;
  padding: 0 10px;
  width: 100%;
  /* width: calc(100% - 560px); */
}
.search__inline .filter .filter__select {
  margin: 0;
}
.search__inline .filter .type__cont {
  margin-left: 1rem;
}
.search__inline .search-small {
  display: flex;
  align-items: center;
  padding: 0;
}
.search__inline .search-small .search__cont {
  display: block;
  margin: 0 0 0 1rem;
}
.search__inline .search-small.open .title {
  color: #2a2c2f;
}
.search__inline .btn.btn-filedown {
  margin-left: 10px;
}
.search__inline button + button {
  margin-left: 10px;
}
.testrecord .tbl-list.type2 {
  overflow-y: auto;
  max-height: 810px;
}
.testrecord .tbl-list.type2 table {
  border-bottom: 0;
  background: linear-gradient(180deg, rgba(144, 159, 183, 0.0001) 10%, rgba(144, 159, 183, 0.2) 100%);
}
.testrecord .tbl-list.type2 table thead th.d-sm-block {
  display: none !important;
}
.tbl-list.type2 table th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
}
.tbl-list.type2 table tr.tr__detail .tbl-list.type2 table {
  background: none;
}
.tbl-list.type2 table tr.tr__detail .tbl-list.type2 table th {
  /* position: unset;
  top: unset; */
  z-index: 1;
}
.tbl-list.type2 table th:first-child span,
.tbl-list.type2 table td:first-child span {
  display: flex;
  align-items: center;
}
.tbl-list.type2 table th:first-child span::before,
.tbl-list.type2 table td:first-child span::before {
  content: "";
  margin-right: 12px;
  margin-left: 10px;
  width: 0;
  height: 0;
  border-bottom: 5px solid transparent;
  border-top: 5px solid transparent;
  border-left: 8px solid #909fb7;
  border-right: 8px solid transparent;
}
.tbl-list.type2 table tr.open th:first-child span::before,
.tbl-list.type2 table tr.open td:first-child span::before {
  content: "";
  margin-right: 20px;
  margin-left: 10px;
  margin-bottom: -10px;
  width: 0;
  height: 0;
  border-bottom: 8px solid transparent;
  border-top: 8px solid #2a2c2f;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}
.tbl-list.type2 table tr.bg-darkwhite td {
  background: #fafafa;
}
.tbl-list.type2 tbody tr td.w20,
.tbl-list.type2 thead tr th.w20 {
  width: 20px !important;
  padding: 13px 0px 13px 30px !important;
  text-align: right;
}
.icon-no {
  margin: 0 auto;
  width: auto;
  height: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat center center;
  background-size: 24px 24px;
}
.icon-no.gray {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) no-repeat center center;
  background-size: 24px 24px;
}

.tbl-list.type5 table th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
}
.tbl-list.type5 tbody tr td.w20,
.tbl-list.type5 thead tr th.w20 {
  width: 20px !important;
  padding: 13px 0px 13px 30px !important;
  text-align: right;
}

/*search-small*/
.search-small {
  padding: 20px 10px;
  background: #fff;
}
.search-small .title:before {
  content: "";
  width: 1rem;
  height: 1rem;
  margin-right: 10px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_30___}) no-repeat 0 center;
  background-size: 100%;
}
.search-small .title:hover {
  cursor: pointer;
}
.search-small .search__cont {
  display: none;
  margin: 24px 25px 5px;
}
.search-small .title .btn-close {
  display: none;
  width: 0.75rem;
  height: 0.75rem;
  margin-left: 1rem;
}
.search-small.open {
  background: linear-gradient(180deg, #fafafa 0%, rgba(250, 250, 250, 0) 100%);
}
.inline.right.search-small.open {
  background: transparent;
}
.search-small.open .title {
  color: #0a78ff;
}
.search-small.open .search__cont {
  display: block;
}
.search-small.open .title .btn-close {
  display: block;
}
.search-small input[type="text"] {
  background: #ffffff;
  border: 1px solid #909fb7;
  border-radius: 4px;
  height: 30px;
  padding: 0 0.75rem;
  vertical-align: bottom;
}
.search-small .select + input[type="text"] {
  margin-left: 3px;
}
.tabcontent .btn-renew {
  display: none;
}
/*파일 reports 목록*/
.checkstep-b {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50px;
  font-weight: 600;
  color: #fff;
  background: #5b71ef;
  margin: 0 auto;
}
.checkstep {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50px;
  font-weight: 600;
  color: #fff;
  margin: 0 auto;
}
.checkstep.ehc-b {
  background: #5b71ef;
}
.checkstep.ehc-a {
  background: #ff9900;
}
.checkstep.ehc-p {
  background: #13a79e;
}
.tbl-list table th input[type="checkbox"]:checked + label:after,
.tbl-list table th input[type="checkbox"] + label:before {
  top: -0.75rem;
  left: 0;
}
.tbl-list table td:first-child input[type="checkbox"]:checked + label:after,
.tbl-list table td:first-child input[type="checkbox"] + label:before {
  top: -0.75rem;
  left: 0;
}
.txt .score {
  display: flex;
  align-items: center;
}
.txt .score::before {
  content: "";
  width: 12px;
  height: 12px;
  margin-right: 10px;
}
.txt .score.high::before {
  background: #1fc95c;
}
.txt .score.middle::before {
  background: #ffbc0a;
}
.txt .score.low::before {
  background: #f55547;
}
td .score {
  display: flex;
  align-items: center;
}
td .score::before {
  content: "";
  width: 12px;
  height: 12px;
  margin-right: 10px;
}
td .score.high::before {
  background: #1fc95c;
}
td .score.middle::before {
  background: #ffbc0a;
}
td .score.low::before {
  background: #f55547;
}

/*파일 reports 팝업*/
.popup-layer.page-report {
  width: 390px;
}
.popup-layer.page-report + .dimm {
  background: rgba(0, 0, 0, 0.6);
}
.popup-layer.page-report .filter__select {
  display: flex;
  flex-direction: column;
  margin: 20px 0 0;
}
.popup-layer.page-report .filter__type {
  flex-direction: column;
  align-items: flex-start;
}
.popup-layer.page-report .type__cont {
  margin-left: 0;
  margin-top: 0.75rem;
  display: block;
}
.popup-layer.page-report .type__cont:after {
  content: "";
  display: block;
  clear: both;
}
.popup-layer.page-report .filter__type:first-child .type__cont li {
  width: auto;
  min-width: 76px;
  border: 1px solid #909fb7;
  font-size: 15px;
}
.popup-layer.page-report .filter__type:first-child .type__cont li:hover {
  background: inherit;
}
.popup-layer.page-report .filter__type:first-child .type__cont li.on {
  border-color: #0a78ff;
}
.popup-layer.page-report .filter__type:first-child .type__cont li.on:hover {
  background: #0a78ff;
}
.popup-layer.page-report .type__cont li {
  float: left;
  margin-bottom: 0.5rem;
  padding: 0;
  width: 86px;
  min-width: unset;
}
.popup-layer.page-report .filter__type .tit {
  font-size: 14px;
}
.popup-layer.page-report .filter__type:nth-child(2) .type__cont li:first-child {
  border-radius: 4px;
  width: 58px;
}
.popup-layer.page-report .filter__type:nth-child(2) .type__cont li:not(:first-child) {
  padding: 0;
}
.popup-layer.page-report .filter__type:nth-child(2) .type__cont li:not(:first-child) a:before {
  content: none;
}
.popup-layer.page-report.page-detail .popup__footer {
  padding: 40px 1rem 33px;
}
.popup-layer.page-report .popup__head h1.icon-filter,
.popup-layer.page-report .popup__head h1.icon-search {
  display: flex;
  align-items: center;
}
.popup-layer.page-report .popup__head h1.icon-filter::before {
  content: "";
  width: 20px;
  height: 20px;
  margin-right: 10px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_28___}) no-repeat 0 center;
  background-size: 100%;
}
.popup-layer.page-report .popup__head h1.icon-search::before {
  content: "";
  width: 20px;
  height: 20px;
  margin-right: 10px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_30___}) no-repeat 0 center;
  background-size: 100%;
}
.popup-layer.page-report .form__input {
  margin-bottom: 26px;
  margin-top: 20px;
}
.popup-layer.page-report .form__input input[type="text"],
.popup-layer.page-report .form__input .select {
  height: 40px;
}
.popup-layer.page-report .form__input .select + input[type="text"] {
  margin-top: 8px;
}
.popup-layer.page-report .form__input li {
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 1.025rem;
}
.popup-layer.page-report .form__input .input__area {
  margin-left: 0;
  margin-top: 8px;
}
.popup-layer.page-report .form__input label {
  font-weight: 500;
  font-size: 14px;
}
.d-sm-tab {
  display: none;
  margin: 0 -1rem;
  height: 3rem;
  border-bottom: 1px solid #dde2e9;
  background: #ffffff;
  box-shadow: 0 8px 8px -8px rgba(144, 159, 183, 0.5);
}
.d-sm-tab .select {
  border: 0;
  height: 3rem;
  font-size: 1rem;
  color: #000;
  font-weight: 500;
}
.d-sm-tab .select .selected {
  padding: 0 1rem;
}
.d-sm-tab .select.active ul {
  background: #ffffff;
  box-shadow: 0 8px 8px -8px rgba(144, 159, 183, 0.5);
  font-variant: JIS04;
  margin: -1px 0 0 0;
  border: 0;
  border-radius: 0;
  border-top: 1px solid #dde2e9;
  z-index: 3;
}
.d-sm-tab .select ul li {
  width: calc(100% - 1.8rem);
  padding: 1.035rem 1rem;
  font-weight: 400;
  font-size: 15px;
  color: #000;
}
.popup-layer.page-report .form__input.d-sm-block {
  display: none;
}
.popup-layer .searchterm {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.popup-layer .searchterm .term__month {
  display: block;
  width: 100%;
  margin-bottom: 6px;
}
.popup-layer .searchterm .term__month .selected {
  width: calc(100% - 1.5rem);
}
.popup-layer.page-report .form__input li .select ul li {
  margin-top: 0;
}
.popup-layer.page-report p.info {
  margin: 20px auto 40px;
  font-size: 1rem;
  line-height: 1.4;
  font-weight: 400;
  text-align: center;
}
.popup-layer.page-report p.txt {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
}

/* qr 팝업*/
.popup-layer.page-qr {
  width: 100%;
  height: 100%;
  border-radius: 0;
}
.qr__body {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
}
.qr__top {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 48px);
  margin-top: 60px;
}
.qr__center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 220px);
}
.popup-layer.page-qr img {
  width: 100%;
  height: 100%;
}
.qr__box {
  position: relative;
  width: 320px;
  height: 320px;
  margin-bottom: 22px;
}
.qr__boxin {
  position: absolute;
  top: 1px;
  left: 1px;
  width: calc(100% - 4px);
  height: calc(100% - 4px);
  border: 1px solid #0a78ff;
  z-index: 1;
}
.qr__boxout {
  position: relative;
  width: 100%;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_31___}) no-repeat 0 0;
  background-size: 100%;
  z-index: 2;
}
.qr__center p {
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.875rem;
  color: #fff;
}
.qr__center p.info {
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  margin-top: 4px;
}
.qr__body .btn-close {
  width: 2.625rem;
  height: 2.625rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_32___}) no-repeat center center;
}
.qr__body .qr__bottom {
  position: absolute;
  bottom: 68px;
}
.qr__body .qr__bottom button {
  width: 180px;
  height: 50px;
  background: #0a78ff;
  border: 1px solid #0a78ff;
  box-shadow: 1px 4px 6px #2a2c2f;
  border-radius: 4px;
}
.qr__body .qr__bottom button span {
  font-weight: 500;
  font-size: 1.125rem;
  color: #fff;
}
/* qr 팝업 수정 */
.page-qropen {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100%;
  z-index: 10000;
  height: 100vh;
  box-shadow: none;
  background: #fff;
  border-radius: 0;
}
.page-qropen .popup__body {
  padding: 0;
  width: 100%;
  overflow-y: hidden;
  max-height: none;
  height: calc(100% - 224px);
}
.page-qropen .qr__center {
  display: block;
}
.page-qropen .qr__center img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}
.page-qropen .qr__bottom p {
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: -0.32px;
  color: #2a2c2f;
  text-align: center;
}
.page-qropen .qr__bottom .info {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}
.page-qropen .popup__footer {
  height: 224px;
  width: 100%;
  padding: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  bottom: unset;
}
.page-qropen .popup__footer button {
  width: 140px;
  height: 40px;
  background: #909fb7;
  border: 0;
  box-shadow: none;
  margin-top: 32px;
}
.page-qropen .popup__footer button span {
  font-size: 1rem;
  font-weight: 700;
}
/* qr 조회 팝업 */
.select-qr:after {
  content: "";
  display: block;
  clear: both;
}
.select-qr li {
  display: inline-block;
  float: left;
  margin-top: 8px;
  margin-right: 8px;
}
.select-qr li a {
  display: block;
  padding: 10px 8px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  height: 100%;
  background: #fafafa;
  border-radius: 4px;
  word-break: break-all;
  word-wrap: break-word;
}
.select-qr li a:hover {
  background: #e6f0ff;
}
.select-qr li a.on {
  background: #b4d2ff;
}
.popup__body .tbl-list.type2.qr-result thead {
  display: none;
}
.popup__body .tbl-list.type2.qr-result table th:first-child span::before,
.popup__body .tbl-list.type2.qr-result table td:first-child span::before {
  content: none;
}
.popup__body .tbl-list.type2.qr-result table td span:first-child {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}
.popup__body .tbl-list.type2.qr-result table td span:last-child {
  font-weight: 400;
  font-size: 13px;
  margin-top: 12px;
}
.popup__body .tbl-list.type2.qr-result table td .btn-file {
  width: 24px;
  height: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_33___}) no-repeat center center;
  background-size: 100%;
}

/* 운영관리 */
.admin-site .box.list {
  overflow-y: hidden;
}
.admin-site .box.list .box__body {
  /* height: calc(100% - 49px); */
  /* height: calc(100vh - 82px); */
  padding-top: 0;
  height: calc(100% - 16px);
}
/* .admin-site .box.list .box__body.nodata {
  height: auto;
} */
.admin-site .box.list .box__body.nodata .area__right .area__right_content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.admin-site .content {
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  width: 100%;
  padding-left: 0;
  grid-gap: 0;
}
.admin-site .tabcontent {
  position: relative;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 -1rem;
  /* height: 100%; */
  height: calc(100% - 32px);
}
.pushy-menutype .area__left {
  margin-right: 4px;
  width: 388px;
  /* height: 100%; */
  height: calc(100% - 16px);
  background: #fff;
  border-right: 4px solid #dde2e9;
  padding-top: 1rem;
}
.pushy-menutype .area__left .lnb.nodata {
  height: calc(100% - 56px);
}
.pushy-menutype .area__left .lnb.nodata .nodata_txt {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 14px;
  letter-spacing: -0.4px;
  color: #909fb7;
  line-height: 26px;
}
.admin-site .area__right {
  width: calc(100% - 440px);
  padding: 16px 24px 10px;
  position: relative;
  height: calc(100% - 26px);
  /* max-height: 920px; */
  /* height: calc(100% - 34px); */
}
.admin-site .area__right .area__right_content {
  /* overflow-y: auto; */
  overflow-y: hidden;
  overflow-x: hidden;
  height: calc(100% - 120px);
  /* max-height: 630px; */
}
.admin-site .area__right .area__right_content.hcal-176 {
  height: calc(100% - 176px);
}
.area__right_content.workplace__info {
  /* margin: 0 -27px; */
  margin: 0 -22px 0-27px;
}
.area__right_content.workplace__info .content__list {
  position: absolute;
  bottom: 0;
  padding: 22px 24px 40px;
  width: calc(100% - 48px);
  height: calc(100% - 560px);
}
.admin-site .box.list .box__body .area__right_content.workplace__info .content__list .tbl-list {
  height: calc(100% - 32px);
  max-height: unset;
}
.area__right_content.workplace__info .content__info {
  padding: 0 24px;
  width: calc(100% - 48px);
  overflow-y: auto;
  height: 320px;
}
.area__right_content.workplace__info.info__input .content__info.h-auto {
  height: auto;
}

.lnb__top {
  display: flex;
  align-items: center;
  padding: 0 8px 8px;
}
.lnb__top .tit {
  margin: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  line-height: 12px;
  letter-spacing: -0.4px;
  color: #0a78ff;
}
.lnb__top .box__search {
  width: 100%;
}
.lnb__top .box__search .btn-search {
  position: unset;
  width: 32px;
  height: 32px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) no-repeat center center #909fb7;
  background-size: 16px 16px;
}
.lnb__top .box__search input[type="text"] {
  width: calc(100% - 72px);
  padding: 3px 16px;
  border: 1px solid #909fb7;
  border-radius: 4px;
}

.lnb__top .btn-setting {
  width: 32px;
  height: 32px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_34___}) no-repeat center center #909fb7;
  background-size: 96%;
}
.lnb__top .add__item {
  margin-right: 8px;
  /* width: calc(100% - 40px); */
  width: 100%;
}

/* 운영관리 컨텐츠 영역 */
.admin-site .area__right h2 {
  font-weight: 700;
  font-size: 25px;
  line-height: 20px;
  color: #2a2c2f;
  letter-spacing: -0.045em;
  margin-bottom: 29px;
  margin-top: 18px;
}
.tab__small {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.tab__small li a {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 15px;
  color: #2a2c2f;
}
.tab__small li.on a {
  font-weight: 700;
  color: #0a78ff;
}
.tab__small li + li {
  border-left: 1px solid #dde2e9;
  margin-left: 24px;
  padding-left: 24px;
}
.tab__small li a::before {
  content: "";
  width: 20px;
  height: 20px;
  margin-right: 8px;
}
.tab__small li a.icon-search::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_30___}) no-repeat center center;
  background-size: 100%;
}
.tab__small li a.icon-pen::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_35___}) no-repeat center center;
  background-size: 100%;
}
.tab__small li a.icon-add::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_36___}) no-repeat center center;
  background-size: 100%;
}
.admin-site .area__right .searcharea {
  margin-bottom: 20px;
}
.admin-site .area__right .searcharea input[type="text"] {
  font-weight: 500;
  font-size: 14px;
}

/* 운영관리 컨텐츠 영역_사업장추가테이블 */
.tbl-list.type3 {
  border-bottom: 1px solid #dde2e9;
  border-top: 1px solid #dde2e9;
  max-height: 756px;
  overflow-y: auto;
}
.tbl-list.type3 table {
  border-bottom: 0;
}
.tbl-list.type3 tbody tr:nth-child(even) td {
  background: #fafafa;
}
.tbl-list.type3 td {
  text-align: left;
}
.tbl-list.type3 td ul {
  display: flex;
  justify-content: space-between;
}
.tbl-list.type3 td ul li {
  display: flex;
  align-items: center;
  width: 47%;
}
.tbl-list.type3 td .btn-add {
  width: 32px;
  min-width: auto;
  height: 32px;
  border: 1px solid #e7f2ff;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_37___}) no-repeat center center #e7f2ff;
  background-size: 12px 12px;
}
.tbl-list.type3 td .highlight {
  font-weight: 700;
}
.tbl-list.type3 td ul li p.placename {
  font-size: 15px;
  font-weight: 400;
  color: #2a2c2f;
  line-height: 20px;
  width: 50%;
}
.tbl-list.type3 td ul li p.location {
  font-size: 15px;
  font-weight: 400;
  color: #2a2c2f;
  line-height: 20px;
  padding-left: 28px;
  width: 50%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_38___}) no-repeat 0 -1px;
  background-size: 20px;
}
.tbl-list.type3 td ul li.address {
  font-weight: 400;
  font-size: 12px;
  color: #2a2c2f;
  line-height: 12px;
  width: 53%;
}
.tbl-list.type3::-webkit-scrollbar-thumb {
  background-color: #dde2e9;
}

/* 운영관리 컨텐츠 영역_사업장정보 */
.page-loca {
  display: flex;
  align-items: center;
  background: #f4f6f7;
  padding: 10px 16px;
  margin: 0 -16px 28px;
}
.page-loca li {
  font-weight: 500;
  font-size: 14px;
  line-height: 12px;
  letter-spacing: -0.4px;
  color: #646c74;
}
.page-loca li:after {
  content: ">";
  font-size: 14px;
  color: #646c74;
  margin: 0 6px;
}
.page-loca li:last-child:after {
  content: none;
}
.page-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 40px;
}
.admin-site .area__right .page-top {
  margin-top: 18px;
}
.admin-site .area__right .page-top h2 {
  margin-bottom: 0;
  margin-top: 0;
}
.page-top h2 .txt-info {
  font-weight: 400;
  font-size: 13px;
  margin-left: 8px;
}

.content__list {
  border-top: 2px solid #e9edef;
  /* margin: 0 0 0 -22px;
  padding: 34px 26px 89px;
  width: calc(100% - 10px); */
  /* height: 235px; */
  height: 250px;
}

/*사이트정보*/
.content__info ul li .btn-add {
  margin-top: 10px;
  width: 86px;
  height: 28px;
  border-radius: 4px;
  border: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_39___}) 8px center no-repeat #e6f0ff;
  background-size: 20px;
}
.content__info ul li .btn-add span {
  color: #0a78ff;
  font-weight: 500;
  font-size: 12px;
  padding-left: 15px;
}
.box.list .box__body .content__list .tbl-list {
  height: auto;
  max-height: 275px;
  overflow-y: auto;
  border-bottom: 1px solid #dde2e9;
}
.content__list .tbl-list::-webkit-scrollbar-thumb {
  background-color: #dde2e9;
}
.box.list .box__body .content__list .tbl-list table {
  border-bottom: 0;
}
.content__list .tbl-list th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  padding: 8px 16px 8px;
}
.content__list .tbl-list td {
  padding: 13px 16px;
}
.content__list .tbl-list th,
.content__list .tbl-list td {
  text-align: left;
}
.box.list .box__body .content__list .tbl-list td.d-sm-none {
  display: table-cell !important;
}
.box.list .box__body .content__list .tbl-list td.d-lm-none {
  display: none !important;
}
.content__list .tbl-list td .siteadmin {
  display: flex;
  align-items: center;
}
.content__list .tbl-list td .siteadmin::before {
  content: "S";
  margin-right: 6px;
  text-align: center;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  width: 1rem;
  height: 1rem;
  background: #909fb7;
  border-radius: 2px;
}

/* 운영관리 컨텐츠 영역_사업장정보_메인 사업장 정보(그리드 스타일) */
.area__right_content.workplace__info.workplace__main .content__info {
  display: grid;
  grid-template-columns: 304px 1fr 1fr;
  grid-gap: 24px;
}
.img_workplace {
  position: relative;
  width: 304px;
  height: 304px;
  border-radius: 4px;
}
.image_preview {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.image_preview img {
  display: flex;
  width: 100%;
  height: 100%;
}
.img_workplace .btn-imgadd {
  position: absolute;
  right: 5px;
  top: 267px;
  width: 32px;
  height: 32px;
  z-index: 2;
}
.img_workplace .btn-imgadd label {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  cursor: pointer;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_40___}) center center no-repeat;
  background-size: 100%;
  border: 0;
}
.img_workplace .btn-imgadd input[type="file"] {
  position: absolute;
  width: 0;
  height: 0;
  padding: 0;
  overflow: hidden;
  border: 0;
}

/* 운영관리 컨텐츠 영역_사업장 신규입력 */
.content__info ul.form__input li {
  justify-content: flex-start;
}
.content__info ul.form__input li p.tit {
  margin-top: 5px;
}
.content__info ul.form__input li p.tit.star:after {
  vertical-align: top;
  margin-left: 6px;
}
.content__info ul.form__input .input__area {
  width: calc(100% - 160px);
  min-width: 280px;
  max-width: 454px;
  margin-left: 0;
  min-height: 32px;
}
.content__info ul li p.input-errortxt {
  font-size: 0.813rem;
  line-height: 1.2;
  color: #f55547;
}
.content__info ul.form__input li textarea {
  height: 76px;
}
.content__info ul.form__input li textarea::placeholder {
  color: #909fb7 !important;
}
.content__info ul.form__input li .box__search input[type="text"] {
  padding: 0 34px 0 0.75rem;
  width: calc(100% - 46px);
  border-color: #909fb7;
}
.content__info ul.form__input li .box__search .btn-search {
  right: 0.5rem;
  width: 1.25rem;
  height: 1.25rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_41___}) no-repeat center center;
}
.area__right_content .btn__wrap {
  display: flex;
  align-items: center;
  /* justify-content: center; */
  margin-top: 6px;
  /* margin-left: 10px; */
  margin-left: 24px;
  justify-content: flex-end;
  max-width: 614px;
}
.area__right_content .btn__wrap.center {
  max-width: 100%;
  justify-content: center;
  margin-left: 10px;
}
.area__right_content .btn__wrap button {
  padding: 0 1.25rem;
  width: 8.75rem;
  height: 2.5rem;
  background-color: #0a78ff;
  border: 0;
}
.area__right_content .btn__wrap button span {
  color: #fff;
  font-weight: 700;
}
.area__right_content .btn__wrap button + button {
  margin-left: 0.75rem;
}
/* .area__right_content.workplace__info.info__input .btn__wrap {
  max-width: 965px;
}
.area__right_content.workplace__info.workplace__main.info__input .btn__wrap {
  max-width: unset;
} */

/* 운영관리 컨텐츠 영역_사업장 신규입력 : 디자인 변경 */
.area__right_content.workplace__info.workplace__main.newtype .content__info {
  display: flex;
}
.area__right_content.workplace__info.workplace__main.newtype .content__info + .content__info {
  border-top: 2px solid #e9edef;
  padding-top: 40px;
  margin-top: 40px;
}
.area__right_content.workplace__info.workplace__main.newtype .content__info h3 {
  margin-bottom: 24px;
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.25rem;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.newtype .content__info ul li:last-child {
  margin-bottom: 0;
}
.newtype .content__info ul.form__input .input__area {
  width: 320px;
  min-width: unset;
  max-width: unset;
}
.newtype.area__right_content.workplace__info .column .btn__wrap {
  margin-right: 0;
  max-width: unset;
}
.newtype.area__right_content.workplace__info .column .btn__wrap.center {
  justify-content: center;
  margin: 1.5rem 0 1rem;
  padding: 1rem 0;
  border-top: 2px solid #e9edef;
  border-bottom: 2px solid #e9edef;
}
.newtype.area__right_content .column .btn__wrap button.add__item {
  background: #e6f0ff;
  border-radius: 4px;
  height: 34px;
  border: 0;
  padding: 0 16px;
  justify-content: center;
}
.newtype.area__right_content .column .btn__wrap button.add__item span {
  display: flex;
  align-items: center;
  color: #0a78ff;
  font-weight: 500;
  font-size: 14px;
  line-height: 12px;
}
.newtype .content__info ul.form__info li p.tit {
  margin-top: 0;
  line-height: 20px;
  width: 180px;
}
/* 요청반려 사유확인 팝업 */
.popup-basic.reason {
  width: 600px;
  height: 360px;
}
.popup-basic.reason .popup__body {
  height: 214px;
  overflow-y: auto;
}
.popup-basic.reason .popup__body p {
  font-size: 14px;
  line-height: 22px;
}
.popup-basic.reason .font-16 {
  font-size: 14px !important;
}
.popup-basic.reason dl {
  display: flex;
  margin: 40px 10px 0;
  width: calc(100% - 20px);
}
.popup-basic.reason dl dt {
  width: 80px;
  font-size: 14px;
  line-height: 22px;
}
.popup-basic.reason dl dd {
  width: calc(100% - 80px);
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
}
.popup-basic.reason .page-detail .popup__footer {
  padding: 1rem;
  border-top: 1px solid #dde2e9;
}

/*기기등록관리_리스트*/
.move-list {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 112px;
  height: 30px;
  background: #e6f0ff;
  border-radius: 25px;
  font-weight: 500;
  font-size: 14px;
  color: #0a78ff;
}
.move-list.active {
  background: #0a78ff;
  color: #fff;
}
.move-list + .move-list {
  margin-left: 8px;
}
.inline .tab__small {
  margin-bottom: 0;
  margin-left: 32px;
}
.inline .title + .searcharea {
  margin-bottom: 0;
  margin-left: 1rem;
}
.page-list-view.page-workplace .content__info ul.filelist.down li {
  flex-direction: row;
  align-items: center;
}
.popup-layer.page-list-view.page-workplace {
  z-index: 1000;
}
.popup-layer.page-list-in {
  z-index: 1001;
}
.inline.search-small .title {
  cursor: default;
}

/*기기등록관리_등록*/
.devicetype.mySwiper2 {
  display: none;
  width: 100%;
}
.devicetype.mySwiper2 .swiper-slide {
  width: 64px;
  height: 64px;
}
.devicetype.mySwiper2 .swiper-slide button {
  font-size: 13px;
}
.devicetype.mySwiper2 .swiper-slide button:focus {
  font-size: 14px;
}
.devicetype .swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 72px;
  height: 72px;
  margin-right: 8px;
  cursor: pointer;
}
.devicetype .swiper-slide button::before {
  content: "";
  width: 2.05rem;
  height: 1.6rem;
  margin-bottom: 6px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_42___}) no-repeat center center;
  background-size: 100%;
}
.devicetype .swiper-slide button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #ffffff;
  border: 1px solid #dde2e9;
  box-shadow: 1px 1px 4px rgba(144, 159, 183, 0.3);
  border-radius: 8px;
  font-weight: 400;
  font-size: 14px;
  color: #2a2c2f;
}
.devicetype .swiper-slide button:hover {
  border: 2px solid #b6d7ff;
}
.devicetype .swiper-slide button.active {
  border: 2px solid #0a78ff;
  font-weight: 500;
  color: #0a78ff;
  font-size: 16px;
}
.devicetype .swiper-wrapper.errorpoint button {
  border: 1px solid #f55547;
}
.devicetype .swiper-wrapper.errorpoint .input-errortxt {
  display: block;
  top: 4.7rem;
}

/*기기등록관리_일괄등록*/
.drag__area {
  display: flex;
  justify-content: space-between;
  position: relative;
}
.drag__area .drag__left {
  text-align: center;
  width: 400px;
}
.filebox-drag {
  position: relative;
}
.filebox-drag .tit {
  font-size: 18px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #909fb7;
  padding: 120px 0 64px;
}
.filebox-drag .txt {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.filebox-drag .filelist {
  position: absolute;
  top: 108px;
  z-index: 5;
  left: 0;
  right: 0;
  background: #ffffff;
  box-shadow: 0px 2px 8px rgba(144, 159, 183, 0.8);
  border-radius: 4px;
  margin: 0 auto;
  padding: 8px 14px;
  max-width: 248px;
}
.filebox-drag .filelist li span {
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  text-align: left;
  color: #2a2c2f;
  background-position: 0 2px;
}
.drag__area .drag__left .btn.btn-filedown {
  position: absolute;
  right: 0;
  top: 0;
  width: auto;
  height: 24px;
  padding-right: 28px;
  /* margin-right: 62px; */
  background: url(${___CSS_LOADER_URL_REPLACEMENT_43___}) no-repeat right center;
  background-size: 24px;
}
.drag__area .drag__left .btn-filedown span {
  font-weight: 700;
}
.filebox-drag .txt button {
  border: 0;
  margin-left: 5px;
  font-size: 15px;
  font-weight: 700;
  color: #0a78ff;
  line-height: initial;
}
.area__right_content .filebox-drag .btn__wrap {
  margin: 64px auto 0;
  max-width: unset;
  justify-content: center;
}
.area__right_content .filebox-drag .btn__wrap button:disabled {
  background: #e9edef !important;
}
.drag__area .drag__right {
  width: calc(100% - 424px);
  margin-top: 58px;
}
/* .drag__right .btn-filedown {
  width: auto;
  height: 24px;
  padding-right: 28px;
  margin-right: 62px;
  background: url(../img/icon_filedown_m@3x.png) no-repeat right center;
  background-size: 24px;
} */
/* .drag__right .btn-filedown span {
  font-weight: 700;
} */
.content__info .drag__right__list li {
  flex-direction: column;
  margin-bottom: 34px;
  padding-bottom: 34px;
  border-bottom: 2px solid #e9edef;
}
/* .content__info .drag__right__list li:first-child {
  justify-content: flex-end;
  flex-direction: row;
  border-bottom: 0;
  padding-bottom: 0;
} */
.content__info .drag__right__list li:last-child {
  border-bottom: 0;
}
.content__info .drag__right__list li p.tit {
  margin-top: 0;
  margin-bottom: 18px;
  width: auto;
}
.content__info .drag__right__list .drag-filelist,
.content__info .drag__right__list .filelist-case {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.content__info .drag__right__list .drag-filelist li,
.content__info .drag__right__list .drag-filelist li:first-child,
.content__info .drag__right__list .filelist-case li,
.content__info .drag__right__list .filelist-case li:first-child {
  width: 100%;
  justify-content: flex-start;
  flex-direction: row;
  padding-bottom: 0;
  margin-bottom: 10px;
  border-bottom: 0;
}
.content__info .drag__right__list .drag-filelist li:last-child,
.content__info .drag__right__list .filelist-case li:last-child {
  margin-bottom: 0;
}
.drag-filelist .name {
  font-size: 15px;
  line-height: 14px;
  color: #2a2c2f;
  padding-left: 26px;
  padding-top: 2px;
  width: 356px;
  height: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_44___}) no-repeat left top;
  background-size: 20px;
}
.drag-filelist .progressbar .progress-value {
  margin-top: 0;
  width: auto;
  height: auto;
  flex-direction: row;
  align-items: center;
}
.drag-filelist .progressbar {
  width: auto;
}
.drag-filelist .progressbar .progress-value progress {
  height: 4px;
  width: 100px;
}
.drag-filelist .progressbar .progress-value .value {
  margin-left: 15px;
  width: auto;
}
.drag-filelist .progressbar .progress-value .value span {
  position: initial;
  top: unset;
  width: auto;
  font-weight: 400;
  font-size: 13px;
  line-height: 14px;
  color: #909fb7;
}
.drag-filelist .name.success {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_45___}) no-repeat left top;
  background-size: 20px;
}
.filelist-case .name {
  font-size: 15px;
  line-height: 14px;
  color: #2a2c2f;
  padding-left: 26px;
  padding-top: 2px;
  width: 356px;
  height: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_46___}) no-repeat 7px top;
  background-size: 0.563rem 1.087rem;
}
.filelist-case div {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.filelist-case div p {
  font-size: 14px;
  line-height: 20px;
  color: #2a2c2f;
}
.filelist-case div p strong {
  margin-right: 20px;
}
.filelist-case div p.case-ok strong {
  font-weight: 500;
  color: #1fc95c;
}
.filelist-case div p.case-no {
  margin-left: 16px;
}
.filelist-case div p.case-no strong {
  font-weight: 500;
  color: #f55547;
}
.btn-go {
  width: 19px;
  height: 19px;
  margin-left: 15px;
  border: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_47___}) no-repeat center center;
  background-size: 100%;
}
.drag__area .filebox-upload {
  display: none;
}
.drag__area .filebox-upload .tit {
  margin-top: 8px;
  margin-right: 38px;
  font-weight: 700;
  font-size: 14px;
  line-height: 14px;
  color: #2a2c2f;
}
.drag__area .filebox-upload .filebox label {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 290px;
  height: 32px;
  background: #e6f0ff;
  border-radius: 4px;
  font-size: 13px;
  color: #0a78ff;
}
.drag__area .filebox-upload .filebox label span {
  padding-left: 27px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_48___}) no-repeat left center;
  background-size: 20px 20px;
}
.drag__area .drag__left .filebox-upload .btn-upload {
  display: none;
}
.popup-layer.js-layer.h80vh .popup__body {
  height: calc(100% - 153px);
  max-height: calc(100% - 153px);
  overflow-y: hidden;
}
.tbl__top .tab__button {
  margin-bottom: 0;
}
.tab__button {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.tab__button li {
  width: 90px;
  height: 32px;
  margin-right: 8px;
}
.tab__button li a {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 25px;
  font-weight: 500;
  font-size: 15px;
  line-height: 1.2;
  letter-spacing: -0.4px;
}
.tab__button li a.green {
  color: #3bd071;
}
.tab__button li a.red {
  color: #f55547;
}
.tab__button li.on a {
  color: #fff;
}
.tab__button li.on a.green {
  background: #3bd071;
}
.tab__button li.on a.red {
  background: #f55547;
}
.tbl-list.hcal-77 {
  overflow-y: auto;
  border-bottom: 1px solid #dde2e9;
}
.tbl-list.hcal-77 table {
  border-bottom: 0;
}
.tbl-list.hcal-77 table th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
}

/* 기기등록관리_진행완료성공실패 모바일 테이블 */
.tbl-list.type4 {
  max-height: calc(100vh - 295px);
  overflow-y: auto;
  border-bottom: 1px solid #dde2e9;
}
.tbl-list.type4 table {
  border-bottom: 0;
}
.tbl-list.type4 tbody tr:nth-child(even) td {
  background: #fff;
}
.tbl-list.type4 td {
  text-align: left;
  padding: 1rem;
  background: #fafafa;
}
.tbl-list.type4 td ul li {
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 14px;
}
.tbl-list.type4 td ul li:last-child {
  margin-bottom: 0;
}
.tbl-list.type4 td ul li strong {
  width: 60px;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.tbl-list.type4 td ul li span {
  margin-left: 8px;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  width: calc(100% - 60px);
}
.tbl-list.type4::-webkit-scrollbar-thumb {
  background-color: #dde2e9;
}

/* 관리자_신규가입요청_사업장승인요청 */
td.icon-new span {
  /* display: flex;
  align-items: center; */
}
td.icon-new.pl-50 {
  padding-left: 16px !important;
}
/* td.icon-new + td button.bg-blue {
  background: #003876 !important;
} */
.admin-site.layout-w3 .area__left {
  /* width: 371px; */
  width: 20%;
  height: calc(100% - 32px);
  padding: 16px;
  margin-right: 0;
  border-right: 4px solid #dde2e9;
}
.admin-site.layout-w3 .area__right {
  /* width: calc(100% - 788px); */
  width: 52%;
  height: calc(100% - 32px);
  padding: 16px;
}
.admin-site.layout-w3 .area__right-end {
  /* width: 361px; */
  width: 28%;
  height: calc(100% - 32px);
  padding: 16px;
  border-left: 4px solid #dde2e9;
}
.admin-site.layout-w3 .page-top {
  margin-bottom: 24px;
  margin-top: 20px;
}
.admin-site.layout-w3 h2 {
  font-weight: 700;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.admin-site .box.list .box__body .tbl-list {
  /* height: 650px; */
  /* height: auto; */
  border-bottom: 1px solid #dde2e9;
  /* overflow: hidden; */
}
.admin-site .box.list .box__body .tbl-list.hcal-130 {
  height: calc(100% - 130px);
}
.admin-site .box.list .box__body .tbl-list.hcal-180 {
  height: calc(100% - 180px);
}
/* .admin-site .box.list .box__body .tbl-list.hcal-vh-315 {
  height: calc(100vh - 315px) !important;
}
.admin-site .box.list .box__body .tbl-list.hcal-vh-415 {
  height: calc(100vh - 415px) !important;
}
.admin-site .box.list .box__body .tbl-list.hcal-vh-430 {
  height: calc(100vh - 430px) !important;
}
.admin-site .box.list .box__body .tbl-list.hcal-vh-560 {
  height: calc(100vh - 560px) !important;
} */
.admin-site .tbl-list table {
  border-bottom: 0;
}
.admin-site .tbl-list table th {
  min-height: 32px;
  padding: 8px 15px;
  font-size: 14px;
}
.admin-site .tbl-list table td {
  padding: 8px 15px;
  font-size: 14px;
  max-width: 120px;
  height: 32px;
}
.admin-site .tbl-list.td-h26 table td {
  height: 26px;
}
.admin-site .tbl-list.td-h32 table td {
  height: 32px;
}
.admin-site.layout-w3 .tbl__bottom {
  position: relative;
}
.admin-site.layout-w3 .area__left .tbl__bottom,
.admin-site.layout-w3 .area__right .tbl__bottom,
.admin-site.layout-w3 .area__right-end .tbl__bottom {
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.admin-site.layout-w3 .area__left .tbl__bottom .result__num,
.admin-site.layout-w3 .area__right .tbl__bottom .result__num,
.admin-site.layout-w3 .area__right-end .tbl__bottom .result__num {
  text-align: left;
  width: 100%;
}
.admin-site.layout-w3 .area__left .tbl__bottom .paging,
.admin-site.layout-w3 .area__right .tbl__bottom .paging,
.admin-site.layout-w3 .area__right-end .tbl__bottom .paging {
  width: 100%;
  justify-content: center;
}
.admin-site.layout-w3 .area__left .tbl__bottom .paging ul,
.admin-site.layout-w3 .area__right .tbl__bottom .paging ul,
.admin-site.layout-w3 .area__right-end .tbl__bottom .paging ul {
  margin-left: 0;
  margin-top: 14px;
}
.admin-site.layout-w3 .tbl__bottom .paging__select {
  display: none;
}
.workplace-ok.page-detail {
  width: 910px;
  height: 744px;
}
.workplace-ok.page-detail .popup__head {
  border-bottom: 1px solid #dde2e9;
}
.workplace-ok.page-detail .popup__body {
  padding: 1rem 40px;
  width: calc(100% - 80px);
  height: calc(100% - 170px);
  max-height: none;
  margin-top: 0;
}
.workplace-ok.page-detail .popup__body .tbl-list.type2 table th {
  position: relative;
}
.workplace-ok.page-detail .workplace__info {
  margin: 32px 0 6px;
  display: flex;
}
.workplace-ok.page-detail .workplace__info .img_workplace {
  width: 240px;
  height: 240px;
}
.workplace-ok.page-detail .workplace__info .txt_workplace {
  margin-left: 40px;
  width: calc(100% - 240px);
}
.workplace-ok.page-detail .workplace__info .page-top {
  margin-bottom: 28px;
}
.workplace-ok.page-detail .workplace__info .page-top h2 {
  font-weight: 700;
  font-size: 20px;
  line-height: 29px;
  color: #2a2c2f;
}
.workplace-ok.page-detail .workplace__info .top-button button {
  width: 28px;
  height: 28px;
}
.workplace__info .top-button button.btn-edit.active {
  background-color: #0a78ff;
  border-color: #0a78ff;
}
.top-button button.btn-edit.active {
  background-color: #0a78ff;
  border-color: #0a78ff;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul {
  width: calc(100% - 80px);
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul li {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1rem;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul li p.tit {
  width: 120px;
  margin-right: 30px;
  font-weight: 700;
  font-size: 15px;
  line-height: 14px;
  letter-spacing: -0.004em;
  color: #2a2c2f;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul li p.txt {
  width: calc(100% - 150px);
  font-size: 15px;
  line-height: 14px;
  letter-spacing: -0.004em;
  color: #2a2c2f;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul li .btn__wrap,
.workplace-ok.page-detail .workplace__info .txt_workplace ul li .input__area {
  width: calc(100% - 150px);
  display: flex;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul li .input__area {
  margin-left: 0;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul li .input__area textarea {
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul.form__input li {
  margin-bottom: 16px;
  margin-top: 0;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul.form__input li p.tit {
  margin-top: 8px;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul li .btn__wrap button {
  width: 146px;
  height: 40px;
  border: 1px solid #909fb7;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul li .btn__wrap button + button {
  margin-left: 8px;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul li .btn__wrap button span {
  font-weight: 700;
  color: #909fb7;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul li .btn__wrap button.bg-navy {
  border-color: #003876;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul li .btn__wrap button.bg-navy span {
  color: #fff;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul li .btn__wrap.right.w100p {
  margin-top: 15px;
  justify-content: flex-end;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul li .btn__wrap.right.w100p button {
  width: 120px;
  background: #0a78ff;
  border: 0;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul li .btn__wrap.right.w100p button span {
  color: #fff;
}
.workplace-ok.page-detail .popup__footer button:disabled {
  background: #e9edef;
}
.workplace-ok.page-detail .popup__footer {
  padding: 24px;
  width: calc(100% - 48px);
  border-top: 1px solid #dde2e9;
}
.workplace-ok.page-detail .popup__footer button {
  width: 120px;
}
.workplace-ok.page-detail .popup__footer button + button {
  margin-left: 8px;
}
.userjoin-ok.page-detail {
  width: 1200px;
  /* height: 596px; */
  height: 663px;
}
.userjoin-ok.page-detail .popup__head {
  border-bottom: 1px solid #dde2e9;
}
.userjoin-ok.page-detail .popup__body {
  display: flex;
  justify-content: space-between;
  padding: 0 40px;
  width: calc(100% - 80px);
  margin-top: 0;
}
.userjoin-ok.page-detail .popup__body .left,
.userjoin-ok.page-detail .popup__body .right {
  width: calc(50% - 42px);
  padding: 32px 0 28px;
}
.userjoin-ok.page-detail .popup__body h2 {
  font-weight: 700;
  font-size: 15px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  margin-bottom: 32px;
}
.userjoin-ok.page-detail .popup__body .form__input .tit {
  font-weight: 700;
  font-size: 15px;
  color: #2a2c2f;
  width: 180px;
}
.userjoin-ok.page-detail .popup__body .form__input .input__area,
.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap {
  width: calc(100% - 180px);
  margin-left: 0;
}
.userjoin-ok.page-detail .popup__body .form__input .input__area textarea {
  height: 146px;
}
.userjoin-ok.page-detail .popup__body .form__input li {
  margin-bottom: 24px;
}
.userjoin-ok.page-detail .popup__body .form__input li:last-child {
  margin-bottom: 0;
}
.userjoin-ok.page-detail .popup__body .form__input input[type="text"],
.userjoin-ok.page-detail .popup__body .form__input input[type="password"],
.userjoin-ok.page-detail .popup__body .form__input input[type="tel"],
.userjoin-ok.page-detail .popup__body .form__input input[type="file"] {
  background: #f0f2f4;
  border: 0;
  height: 32px;
  font-weight: 400;
}
.userjoin-ok.page-detail .radioBox {
  width: 100%;
  justify-content: space-between;
  display: inline-flex;
}
.userjoin-ok.page-detail .popup__body .form__input .radioBox label {
  width: auto !important;
  margin-left: 0;
  font-weight: 500;
  color: #2a2c2f;
}
.userjoin-ok.page-detail .popup__body .form__input button.btn-basic {
  border: 0;
  padding: 0 28px;
  height: 26px;
}
.userjoin-ok.page-detail .popup__body .form__input.inline button.btn-basic {
  height: 32px;
}
.userjoin-ok.page-detail .popup__body .form__input button.btn-basic span {
  font-weight: 700;
  font-size: 14px;
}
.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap {
  display: flex;
}
.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap button {
  width: 146px;
  height: 40px;
  border: 1px solid #909fb7;
}
.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap button + button {
  margin-left: 8px;
}
.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap button span {
  font-weight: 700;
  color: #909fb7;
}
.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap button.bg-navy {
  border-color: #003876;
}
.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap button.bg-navy span {
  color: #fff;
}
.userjoin-ok.page-detail .popup__body .form__input .tbl-list.type2 {
  width: 100%;
  /* height: 313px; */
  height: 360px;
  overflow-y: auto;
  border-bottom: 1px solid #dde2e9;
}
.userjoin-ok.page-detail .popup__body .form__input .tbl-list.type2 table {
  border-bottom: 0;
}
.userjoin-ok.page-detail .popup__body .form__input .tbl-list.type2 table th {
  padding: 12px 16px;
}
.userjoin-ok.page-detail .popup__body .form__input .tbl-list.type2 table td {
  padding: 18px 16px;
}
.userjoin-ok.page-detail .popup__body .form__input .tbl-list.type2 table th,
.userjoin-ok.page-detail .popup__body .form__input .tbl-list.type2 table td {
  font-size: 14px;
}
.userjoin-ok .tbl-list table td button.btn-delete-g {
  width: 24px;
  height: 24px;
  min-width: auto;
}
.userjoin-ok .popup__footer button:disabled {
  background: #e9edef;
}
.icon-navi {
  padding-left: 25px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_38___}) no-repeat 0 center;
  background-size: 20px 20px;
}
.userjoin-ok.page-detail .popup__footer {
  padding: 24px 42px;
  width: calc(100% - 84px);
  border-top: 1px solid #dde2e9;
}
.userjoin-ok.page-detail .popup__footer button {
  width: 120px;
}
.userjoin-ok.page-detail .popup__footer button + button {
  margin-left: 8px;
}
.userjoin-ok.page-detail .popup__body.layout-vertical {
  flex-direction: column;
  padding-top: 32px;
  padding-bottom: 0;
}
.userjoin-ok.page-detail .popup__body.layout-vertical .form__input li {
  justify-content: flex-start;
  width: auto;
  margin: 0 0 0 42px;
}
.userjoin-ok.page-detail .popup__body.layout-vertical .form__input li:first-child {
  margin-left: 0;
}

.userjoin-ok.page-detail .popup__body.layout-vertical .form__input label {
  width: auto;
}
.userjoin-ok.page-detail .popup__body.layout-vertical .form__input .input__area {
  display: flex;
  align-items: center;
  width: 300px;
  margin-left: 1rem;
}
.userjoin-ok.page-detail .popup__body.layout-vertical .tbl-list.type2 {
  height: 370px;
  border-bottom: 1px solid #dde2e9;
  overflow-y: auto;
}
.userjoin-ok.page-detail .popup__body.layout-vertical .tbl-list.type2 table {
  border-bottom: 0;
}
.userjoin-ok.page-detail .popup__body .form__input button.btn-basic.d-sm-block {
  display: none;
}
.userjoin-ok.page-detail .popup__body.layout-vertical + .popup__footer {
  padding: 24px 42px;
  border-top: 0;
}
.popup-layer.pop-smallsearch {
  width: 390px;
}
.popup-layer.pop-smallsearch .popup__head h1.icon-search {
  display: flex;
  align-items: center;
}
.popup-layer.pop-smallsearch .popup__head h1.icon-search::before {
  content: "";
  width: 20px;
  height: 20px;
  margin-right: 10px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_30___}) no-repeat 0 center;
  background-size: 100%;
}
.popup-layer.pop-smallsearch .popup__body {
  margin-top: -8px;
}
.popup-layer.pop-smallsearch .popup__body .form__input li {
  margin-top: 1rem;
}
.popup-layer.pop-smallsearch .popup__body .form__input li:first-child {
  margin-top: 0;
}
.popup-layer.pop-smallsearch .popup__body .form__input label {
  font-size: 14px;
}
.popup-layer.pop-smallsearch .popup__body .form__input .input__area {
  height: 40px;
}
.popup-layer.pop-smallsearch .popup__body .form__input .input__area .select {
  height: 100%;
}
.popup-layer.pop-smallsearch .popup__footer {
  padding: 1rem 1rem 1.563rem;
}
/*사용자 타입팝업*/
.popup-layer.pop-usertype {
  width: 766px;
}
.popup-layer.pop-usertype .popup__body {
  padding: 35px 24px 24px;
  width: calc(100% - 48px);
}
.popup-layer.pop-usertype .user-info {
  margin-bottom: 1rem;
}
.popup-layer.pop-usertype .user-info li {
  display: flex;
  margin-bottom: 26px;
}
.popup-layer.pop-usertype .user-info li:last-child {
  margin-bottom: 0;
}
.popup-layer.pop-usertype .user-info li p {
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.popup-layer.pop-usertype .user-info li p strong {
  font-weight: 700;
}
.popup-layer.pop-usertype .user-info li p span {
  color: #909fb7;
}
.popup-layer.pop-usertype .user-info li p:first-child {
  width: 93px;
  display: flex;
  flex-direction: column;
}
.popup-layer.pop-usertype .user-info li p:last-child {
  width: calc(100% - 93px);
  font-weight: 400;
  line-height: 22px;
}
.popup-layer.pop-usertype .tbl__top {
  margin-bottom: 8px;
}
.popup-layer.pop-usertype .tbl__top .info {
  width: 100%;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  text-align: right;
  letter-spacing: -0.4px;
  color: #909fb7;
}
.popup-layer.pop-usertype .tbl-list.type2 table th,
.popup-layer.pop-usertype .tbl-list.type2 table td {
  text-align: center;
}
.popup-layer.pop-usertype .tbl-list.type2 table tbody th {
  padding: 13px 16px;
  font-weight: 400;
  background: #fff;
  border-right: 1px solid #dde2e9;
}
.popup-layer.pop-usertype .tbl-list.type2 table tbody tr:nth-child(even) th {
  background: #f8f9fa;
}
.use-ok {
  margin: 0 auto;
  width: 15px;
  height: 10px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_49___}) no-repeat center center;
  background-size: 100%;
}

/*진단점검요청 팝업*/
.userjoin-ok.page-detail.casecheck-ok {
  height: 636px;
}
.userjoin-ok.page-detail.casecheck-ok .popup__body.layout-vertical {
  height: 466px;
  justify-content: flex-start;
}
.userjoin-ok.page-detail.casecheck-ok .popup__body.layout-vertical h2 {
  display: flex;
  align-items: center;
}
.userjoin-ok.page-detail.casecheck-ok .popup__body.layout-vertical h2 span {
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  color: #2a2c2f;
}
.userjoin-ok.page-detail.casecheck-ok .popup__body.layout-vertical h2 span.checkstep {
  color: #fff;
  margin: 0 8px 0 0;
  font-size: 16px;
}
.userjoin-ok.page-detail.casecheck-ok .popup__body.layout-vertical h2 img {
  margin-right: 8px;
  width: 24px;
  height: 24px;
}
.userjoin-ok.page-detail.casecheck-ok .popup__body.layout-vertical .tit,
.userjoin-ok.page-detail.casecheck-ok .popup__body.layout-vertical .form__input label {
  font-size: 15px;
  font-weight: 700;
  color: #2a2c2f;
  width: 150px;
}
.userjoin-ok.page-detail.casecheck-ok .popup__body.layout-vertical + .popup__footer {
  border-top: 1px solid #dde2e9;
}
.userjoin-ok.page-detail.casecheck-ok .popup__body.layout-vertical .tbl-list.type2 {
  height: auto;
  max-height: 178px;
  overflow-y: auto;
}
.userjoin-ok.page-detail.casecheck-ok .popup__body .form__input .box__search input[type="text"] {
  height: 18px;
  width: 280px;
  padding: 6px 30px 6px 8px;
  background: #fff;
  border: 1px solid #a4b0c4;
}
.userjoin-ok.page-detail.casecheck-ok .popup__body .form__input .box__search .btn-search {
  right: 8px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_41___}) no-repeat center center;
  background-size: auto;
}
.admin-site.layout-w3 .area__right-end .tbl-list table th,
.admin-site.layout-w3 .area__right-end .tbl-list table td {
  padding: 8px;
}
.admin-site.layout-w3 .area__right-end .tbl-list table td {
  max-width: 120px;
}

/*헤더-My Account 팝업*/
.popup-basic.myaccount,
.community .popup-layer.popup-basic.myaccount {
  width: 560px;
  height: auto;
}
.popup-basic.myaccount .popup__body {
  padding: 40px 40px 37px;
  width: calc(100% - 80px);
  min-height: calc(75vh - 11.7rem);
}
.community .popup-layer.popup-basic.myaccount .input__area .select {
  width: calc(100% - 2px);
  height: 38px;
}
.popup-basic.myaccount .popup__body .form__input li {
  margin-top: 26px;
}
.popup-basic.myaccount .popup__body .form__input li:first-child {
  margin-top: 0;
}
.popup-basic.myaccount .popup__body .form__input label {
  width: 49%;
}
.popup-basic.myaccount .popup__body .form__input .radioBox {
  margin: 0;
}
.popup-basic.myaccount .popup__body .form__input .radioBox label {
  margin-left: 10px;
  width: auto;
}
.popup-basic.myaccount .popup__body .form__input .radioBox label:first-child {
  margin-left: 0;
}
.popup-basic.myaccount .popup__body .form__input .radioBox input[type="radio"] {
  margin-right: 5px;
  margin-top: 2px;
}
.popup-basic.myaccount .popup__body .form__input .radioBox input[type="radio"]:disabled {
  border-color: #e9edef;
  background-color: #e9edef;
}
.popup-basic.myaccount .popup__body .form__input .radioBox input[type="radio"]:checked:disabled {
  background-color: #e9edef;
  border-color: #e9edef;
}
.popup-basic.myaccount .popup__body .form__input .radioBox input[type="radio"]:checked:disabled:before {
  color: #909fb7;
}
.popup-basic.myaccount .popup__body .form__input .radioBox input[type="radio"]:checked::before {
  font-size: 0.65rem;
}
.popup-basic.myaccount .popup__body .form__input .btn-txt {
  margin: 11px 0;
}
.popup-basic.myaccount .popup__body .form__input .btn-txt span {
  font-weight: 400;
  font-size: 14px;
}
.popup-basic.myaccount .form__input .select.active ul {
  bottom: 30px;
  border-radius: 4px 4px 0 0;
}
.popup-basic.myaccount .popup__footer {
  padding: 24px 40px;
  width: calc(100% - 80px);
}
.popup-basic.myaccount .popup__footer button.btn-txt {
  width: auto;
  padding: 0;
  margin-right: 111px;
}
.popup-basic.myaccount .popup__footer button.btn-txt span {
  font-weight: 500;
}
/*헤더-My Account 팝업 내 비밀번호 변경 팝업*/
.popup-basic.myaccount.passchange .popup__head {
  justify-content: flex-start;
}
.popup-basic.myaccount.passchange .popup__head h1 {
  margin-left: 8px;
}
.popup-basic.myaccount.passchange .popup__head .btn-close {
  width: 24px;
  height: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_50___}) no-repeat center center;
  background-size: 100%;
}
.popup-basic.myaccount.passchange .popup__body {
  min-height: calc(75vh - 6.1rem);
}
.popup-basic.myaccount.passchange .popup__footer {
  border-top: 0;
  margin-top: 55px;
}

/*사업장추가-이미지크롭 팝업*/
.popup-basic.imgcrop {
  width: 560px;
  height: 730px;
}
.popup-basic.imgcrop .popup__body {
  height: calc(100% - 140px);
  max-height: unset;
  padding: 0;
  width: 100%;
}
.popup-basic.imgcrop .popup__body .image-crop {
  width: 560px;
  height: 500px;
  background: #d9d9d9;
}
.popup-basic.imgcrop .popup__body .scroller {
  width: 100%;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.popup-basic.imgcrop .popup__body .scroller .scroller-wrap {
  position: relative;
}
.popup-basic.imgcrop .popup__body .scroller .scroller-bar {
  width: 320px;
  height: 3px;
  background: #909fb7;
}
.popup-basic.imgcrop .popup__body .scroller .scroller-dot {
  position: absolute;
  top: -10px;
  width: 16px;
  height: 16px;
  background: #0a78ff;
  border-radius: 50px;
  border: 3px solid #fff;
}
.popup-basic.imgcrop .popup__footer {
  padding: 25px 1rem;
}

/* 관리자_사업장관리_회사추가 */
.admin-site .tabcontent.layout-w2 .area__left {
  padding: 16px 0;
  width: 310px;
  height: calc(100% - 29px);
}
.admin-site .tabcontent.layout-w2 .area__left .lnb-depth1 > li > p {
  min-height: 60px;
}
.admin-site .tabcontent.layout-w2 .area__left .lnb-depth1 > li.on p::before,
.admin-site .tabcontent.layout-w2 .area__left .lnb-depth1 > li.active p::before {
  min-height: 60px;
}
.admin-site .tabcontent.layout-w2 .area__left .lnb-depth1 > li > p span {
  width: 100% !important;
}
.admin-site .tabcontent.layout-w2 .area__left .lnb-depth1 > li > p span:last-child {
  background: none;
  padding-left: 0;
  font-weight: 500;
}
.admin-site .tabcontent.layout-w2 .area__left .lnb-depth1 > li.on p span,
.admin-site .tabcontent.layout-w2 .area__left .lnb-depth1 > li.active p span {
  font-weight: 700;
}
.admin-site .tabcontent.layout-w2 .area__left .lnb-depth2 {
  margin: 8px 8px 8px 32px;
  border-bottom: 0;
}
.admin-site .tabcontent.layout-w2 h2 {
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 20px;
  line-height: 20px;
  color: #2a2c2f;
  letter-spacing: -0.4px;
}
.admin-site .tabcontent.layout-w2 h2 .btn-more {
  width: 32px;
  height: 32px;
  border: 0;
  margin-left: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_51___}) no-repeat center center;
  background-size: 100%;
  transform: scaleY(-1);
}
.admin-site .tabcontent.layout-w2 h2 .btn-more.on {
  transform: scaleY(1);
}
.admin-site .tabcontent.layout-w2 .area__right_content.workplace__info {
  position: relative;
  width: calc(100% - 340px);
  padding: 16px 24px 18px;
  margin: 0;
}

.admin-site.rightcont-half .tabcontent .lnb {
  max-height: unset;
  height: calc(100vh - 215px);
}
.admin-site.rightcont-half
  .tabcontent.layout-w2
  .area__right_content.workplace__info
  .content__info
  + .content__info.boxlist {
  max-height: unset;
  height: calc(100vh - 650px);
}
.admin-site .tabcontent.layout-w2 .area__right_content.workplace__info .content__info {
  padding: 0;
}
.admin-site .tabcontent.layout-w2 .area__right_content.workplace__info .content__info + .content__info {
  padding-top: 40px;
  padding-left: 24px;
  padding-right: 24px;
  margin-left: -24px;
  width: 100%;
  max-height: unset;
  height: calc(100vh - 650px);
}
.admin-site .tabcontent.layout-w2 .area__right_content.workplace__info .content__info + .content__info.boxlist {
  max-height: 280px;
  overflow-y: auto;
  overflow-x: hidden;
}
.admin-site .tabcontent.layout-w2 .area__right_content.workplace__info .content__info.hidden {
  display: none;
}
.admin-site .tabcontent.layout-w2 .area__right_content.workplace__info .content__info.hidden + .content__info.boxlist {
  overflow-y: auto;
  max-height: unset;
}
.admin-site .tabcontent.layout-w2 .area__right_content.workplace__info .content__info + .content__info .column {
  width: 100%;
}
.admin-site .tabcontent.layout-w2 .area__right_content .page-top {
  margin-bottom: 30px;
  margin-top: 18px;
  padding: 0;
}
.admin-site .tabcontent.layout-w2 .area__right_content .btn__wrap button + button {
  margin-left: 8px;
}
.admin-site .tabcontent.layout-w2 .area__right_content .content__info ul li .result__score p.tit.caution {
  display: flex;
  align-items: center;
  font-size: 15px;
  color: #2a2c2f;
  font-weight: 400;
  margin-top: 0;
  width: calc(100% - 88px);
}
.admin-site .tabcontent.layout-w2 .area__right_content .content__info ul li .result__score p.tit.caution::before {
  content: "";
  width: 16px;
  height: 16px;
  margin-right: 4px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat top center;
  background-size: 100%;
}
.admin-site .tabcontent.layout-w2 .area__right_content .content__info ul li .result__score p.tit.caution::after {
  content: "";
  width: 14px;
  height: 14px;
  margin-left: 135px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_52___}) no-repeat center center;
  background-size: 100%;
}
.admin-site .tabcontent.layout-w2 .area__right_content .content__info ul li .result__score {
  display: flex;
  align-items: center;
}
.admin-site .tabcontent.layout-w2 .area__right_content .content__info ul li .result__score::after {
  content: "점";
  margin-left: 7px;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #909fb7;
}
.admin-site .tabcontent.layout-w2 .area__right_content .content__info ul li .result__score .select.active ul {
  max-height: 162px;
  overflow-y: auto;
}
.admin-site .tabcontent.layout-w2 .area__right_content.workplace__info .content__info .listbox__top {
  margin-bottom: 22px;
  margin-top: -16px;
}
.admin-site .tabcontent.layout-w2 .area__right_content.workplace__info.workplace__main.newtype .content__info ul li {
  margin-bottom: 20px;
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content.workplace__info.workplace__main.newtype
  .content__info
  .listbox__top
  h3 {
  margin-bottom: 0;
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content.workplace__info.workplace__main.newtype
  .content__info
  .listbox__top
  button.add__item {
  width: 128px;
  height: 32px;
  background: #e7f2ff;
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content.workplace__info.workplace__main.newtype
  .content__info
  .listbox__area {
  grid-auto-rows: 240px;
  grid-template-columns: repeat(auto-fill, minmax(358px, 1fr));
  padding-bottom: 10px;
}
.admin-site .tabcontent.layout-w2 .area__right_content.workplace__info.workplace__main.newtype .content__info .listbox {
  height: 240px;
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content.workplace__info.workplace__main.newtype
  .content__info
  .listbox
  .box__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 32px);
  padding: 12px 16px;
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content.workplace__info.workplace__main.newtype
  .content__info
  .listbox
  .box__top
  p {
  font-size: 15px;
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content.workplace__info.workplace__main.newtype
  .content__info
  .listbox
  .box__bottom {
  padding: 16px 16px 28px;
  display: flex;
  justify-content: space-between;
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content.workplace__info.workplace__main.newtype
  .content__info
  .listbox
  .box__bottom
  .left.img_workplace {
  width: 152px;
  height: 152px;
  margin-right: 16px;
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content.workplace__info.workplace__main.newtype
  .content__info
  .listbox
  .box__bottom
  .right {
  width: calc(100% - 168px);
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content.workplace__info.workplace__main.newtype
  .content__info
  .listbox
  .box__bottom
  .right
  ul
  li {
  font-size: 15px;
  line-height: 16px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content.workplace__info.workplace__main.newtype
  .content__info
  .listbox
  .box__bottom
  .right
  ul
  + ul {
  border-top: 1px solid #dde2e9;
  margin-top: 12px;
  padding-top: 16px;
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content.workplace__info.workplace__main.newtype
  .content__info
  .listbox
  .box__bottom
  .right
  ul
  li
  strong {
  font-weight: 500;
  margin-right: 7px;
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content.workplace__info.workplace__main.newtype
  .content__info
  .listbox
  .box__bottom
  .right
  ul
  li
  .tit {
  font-weight: 700;
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content.workplace__info.workplace__main.newtype
  .content__info
  .listbox
  .box__bottom
  .right
  ul
  li {
  margin-bottom: 12px;
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content.workplace__info.workplace__main.newtype
  .content__info
  .listbox
  .box__bottom
  .right
  ul
  li:first-child {
  margin-bottom: 12px;
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content.workplace__info.workplace__main.newtype
  .content__info
  .listbox
  .box__bottom
  .right
  ul
  li
  .score__info {
  margin-top: -2px;
  margin-bottom: 0;
  font-size: 12px;
  line-height: 20px;
  text-align: justify;
  letter-spacing: -0.4px;
  color: #909fb7;
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content.workplace__info.workplace__main.newtype
  .content__info
  .listbox
  .box__bottom
  .right
  ul
  li
  .result__score {
  justify-content: space-between;
  width: 100%;
  margin-top: 2px;
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content
  .content__info
  .listbox
  .box__bottom
  .right
  ul
  li
  .result__score::after {
  content: none;
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content
  .content__info
  .listbox
  .box__bottom
  .right
  ul
  li
  .result__score
  .score::after {
  content: "점";
  margin-left: 7px;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #909fb7;
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content.workplace__info.workplace__main.newtype
  .content__info
  .listbox
  .box__bottom
  .right
  ul
  li
  .result__score
  .tit {
  font-weight: 400;
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content.workplace__info.workplace__main.newtype
  .content__info
  .listbox
  .box__bottom
  .right
  ul
  li
  .result__score
  p.tit.caution {
  width: auto;
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content.workplace__info.workplace__main.newtype
  .content__info
  .listbox
  .box__bottom
  .right
  ul
  li
  .result__score
  p.tit.caution::before {
  width: 12px;
  height: 11px;
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content.workplace__info.workplace__main.newtype
  .content__info
  .listbox
  .box__bottom
  .right
  ul
  li
  .result__score
  p.tit.caution::after {
  content: none;
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content.workplace__info.workplace__main.newtype
  .content__info
  .listbox
  .box__bottom
  .right
  ul
  li
  .result__score
  .score {
  display: flex;
  align-items: center;
  font-weight: 500;
}
.admin-site
  .tabcontent.layout-w2
  .area__right_content.workplace__info.workplace__main.newtype
  .content__info
  .listbox
  .box__bottom
  .right
  ul
  li
  .result__score
  .score::before {
  content: "";
  margin-right: 7px;
  width: 10px;
  height: 10px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_52___}) no-repeat center center;
  background-size: 100%;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column {
  width: calc(100% - 150px);
  font-size: 15px;
  line-height: 14px;
  letter-spacing: -0.004em;
  color: #2a2c2f;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column .result__score {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column .result__score .tit.caution {
  display: flex;
  align-items: center;
  width: calc(100% - 150px);
  font-weight: 400;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column .result__score .tit.caution::before {
  content: "";
  width: 14px;
  height: 14px;
  margin-right: 6px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat center center;
  background-size: 100%;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column .result__score .score {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 15px;
  line-height: 12px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  width: 120px;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column .result__score .score::before {
  content: "";
  margin-right: 12px;
  width: 14px;
  height: 14px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_52___}) no-repeat center center;
  background-size: 100%;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column .result__score .score::after {
  content: "점";
  margin-left: 12px;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #909fb7;
}
.workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column .score__info {
  margin-top: 0;
  font-size: 15px;
  line-height: 24px;
  text-align: justify;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
/* 관리자_사용자관리_사용자목록 */
.admin-site .tabcontent.layout-w2 .tbl__bottom .paging__select {
  display: flex;
}
td.icon-dot span {
  display: flex;
  align-items: center;
}
td.icon-dot span::before {
  content: "";
  display: flex;
  align-items: center;
  justify-content: center;
  width: 8px;
  height: 8px;
  margin-right: 14px;
  background: #f55547;
  border-radius: 50px;
}
td.icon-dot.pl-16 span::before {
  margin-right: 8px;
}
td.icon-dot.pl-22,
td.icon-dot.pl-16 {
  padding-left: 0 !important;
}
.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.user-list {
  height: calc(100% - 200px);
}
.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.user-list table th {
  padding: 7px;
}
.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.user-list table td {
  height: 34px;
  padding: 7px;
}
.btn-on {
  width: 115px;
  height: 32px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_53___}) no-repeat 0 0;
  background-size: 100%;
}
.btn-off {
  width: 115px;
  height: 32px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_54___}) no-repeat 0 0;
  background-size: 100%;
}
.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap button.btn-on,
.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap button.btn-off {
  width: 114px;
  height: 32px;
  border: 0;
}
.btn-on.disabled,
.btn-off.disabled {
  background: #f0f2f4;
  border-color: #f0f2f4;
}
.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap button.txtline {
  width: auto;
  height: auto;
  border: 0;
}
.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap button.txtline span {
  font-weight: 500;
  font-size: 15px;
  line-height: 0px;
  color: #909fb7;
  text-decoration: underline;
}
.userjoin-ok.page-detail .popup__body.alldisabled .form__input input[type="text"] {
  color: #c8d0dc;
}
.userjoin-ok.page-detail .popup__body.alldisabled .form__input .tit {
  color: #91a1b9;
}
.userjoin-ok.page-detail .popup__body.alldisabled .form__input .radioBox label {
  color: #c8d0dc;
  cursor: default;
}
.userjoin-ok.page-detail .popup__body.alldisabled .form__input .radioBox input[type="radio"] {
  border-color: #c8d0dc !important;
  cursor: default;
}
.userjoin-ok.page-detail .popup__body.alldisabled .form__input .tbl-list.type2 table td {
  color: #c8d0dc;
}
.userjoin-ok.page-detail .popup__body.alldisabled .form__input .tbl-list.type2 table td .icon-navi {
  filter: opacity(0.5);
}
.userjoin-ok.page-detail .popup__body.alldisabled .form__input .tbl-list.type2 table td button.btn-delete-g {
  filter: opacity(0.25);
}
.userjoin-ok.page-detail .popup__body.alldisabled .txt-info {
  color: #dde2e9;
}

/* 관리자_승인 관리 */
.admin-site .area__left .area__left_content.detail__view,
.admin-site .area__right .area__right_content.detail__view,
.admin-site .area__right-end .area__right_content.detail__view {
  height: calc(100% - 73px);
}

/* 관리자_메뉴 관리_메뉴별 권한 설정 */
.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.menuset-list {
  height: calc(100vh - 290px);
  overflow-y: auto;
}
.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.menuset-list table thead {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
}
.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.menuset-list table td {
  height: 34px;
  padding: 7px 15px;
}
.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.menuset-list table td .ellipsis {
  width: 100%;
}
.tbl-list.menuset-list input[type="checkbox"] + label:before {
  width: 12px;
  height: 12px;
  border-radius: 0;
}
.tbl-list.menuset-list input[type="checkbox"]:checked + label:after {
  width: 12px;
  height: 12px;
  border-radius: 0;
  background-size: 10px;
  background-position-y: 2px;
}
.tbl-list.menuset-list input[type="checkbox"]:disabled + label:before {
  background-color: #e9edef;
  border-color: #e9edef;
}
.tbl-list.menuset-list input[type="checkbox"].readonly:disabled + label:before {
  border-color: #909fb7;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_55___}) no-repeat center center #909fb7;
  background-size: 10px;
}
.tbl-list.menuset-list input[type="checkbox"].error + label:before {
  border-color: #f55547;
  background-color: #fff;
}
.tbl-list.menuset-list input[type="checkbox"].error:checked + label:after {
  border-color: #f55547;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_55___}) no-repeat center center #f55547;
  background-size: 10px;
}
.tbl-list.menuset-list input[type="checkbox"] {
  position: unset;
  width: auto;
}
.tbl-list.lang-list input[type="text"] {
  width: calc(100% - 1.625rem);
  height: 1.875rem;
  padding: 0 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #2a2c2f;
  border: 1px solid #909fb7;
  border-radius: 4px;
}
.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.lang-list {
  height: calc(100% - 180px);
}
.tbl-list.lang-list table td:nth-child(3),
.tbl-list.lang-list table td:nth-child(4) {
  border-left: 4px solid #dde2e9;
}
.admin-site.layout-w3 .tbl-list.lang-list table th {
  padding: 8px;
}
.admin-site.layout-w3 .tbl-list.lang-list table td {
  padding: 8px;
  vertical-align: top;
}
.admin-site.layout-w3 .tbl-list.lang-list table tr.on td {
  background: #e7f2ff;
}
.tbl-list.lang-list input[type="text"] {
  background-color: #fff;
}
.tbl-list.lang-list table td .input-errortxt {
  display: block;
  position: relative;
  top: unset;
  text-align: left;
  margin-top: 3px;
}
.tbl-list.lang-list table td .ellipsis {
  margin-top: 8px;
  width: 100%;
}

/* 관리자_메세지 관리_e-Health Checker 메세지 */
.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.message-list {
  height: calc(100% - 180px);
}
.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.message-list.hcal-140 {
  height: calc(100% - 140px);
}
.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.message-list.hcal-vh-180 {
  height: calc(100vh - 180px);
  overflow-y: auto;
}
.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.message-list.hcal-vh-180 table thead {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
}
.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.message-list table th {
  padding: 7px 15px;
}
.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.message-list table td {
  height: 34px;
  padding: 7px 15px;
}
.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.message-list table td strong {
  font-weight: 500;
  color: #000;
}
.messagelang {
  display: flex;
  align-items: center;
}
.messagelang::after {
  content: "";
  width: 9px;
  height: 12px;
  margin-left: 21px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_56___}) no-repeat center center;
  background-size: 100%;
  cursor: pointer;
}
.messagelang li {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.2px;
  color: #dde2e9;
}
.messagelang li + li {
  margin-left: 16px;
}
.messagelang li.on {
  color: #0a78ff;
}
.checker-message.page-detail {
  width: 560px;
  /* height: 776px; */
  height: auto;
}
.checker-message.page-detail .popup__head {
  border-bottom: 1px solid #dde2e9;
}
.checker-message.page-detail .popup__body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 40px;
  width: calc(100% - 80px);
  margin: 32px 0 24px;
}
.checker-message.page-detail .popup__body .form__input {
  width: 100%;
  margin-bottom: 24px;
}
.checker-message.page-detail .popup__body .form__input + .form__input {
  padding-top: 24px;
  border-top: 1px solid #dde2e9;
}
.checker-message.page-detail .popup__body h2 {
  font-weight: 700;
  font-size: 15px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  margin-bottom: 32px;
}
.checker-message.page-detail .popup__body .form__input .tit {
  font-weight: 700;
  font-size: 15px;
  color: #2a2c2f;
  width: 222px;
}
.checker-message.page-detail .popup__body .form__input .sub-input {
  margin-top: 1rem;
  align-items: flex-start;
}
.checker-message.page-detail .popup__body .form__input .sub-input + .sub-input {
  margin-top: 8px;
}
.checker-message.page-detail .popup__body .form__input .sub-input .tit {
  font-weight: 500;
  font-size: 13px;
  color: #2a2c2f;
  width: 222px;
  vertical-align: top;
  margin-top: 8px;
}
.checker-message.page-detail .popup__body .form__input .input__area,
.checker-message.page-detail .popup__body .form__input li .btn__wrap {
  width: 100%;
}
.checker-message.page-detail .popup__body .form__input li {
  /* margin-bottom: 24px; */
}
.checker-message.page-detail .popup__body .form__input li:last-child {
  margin-bottom: 0;
}
.checker-message.page-detail .popup__body .form__input input[type="text"] {
  height: 32px;
  font-weight: 400;
}
.checker-message.page-detail .popup__body .form__input .input__area textarea {
  height: 48px;
  padding: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}
.checker-message.page-detail .popup__body .form__input input[type="text"]:disabled {
  background: #f0f2f4;
  border: 0;
}
.checker-message.page-detail .popup__body .form__input .input__area textarea:read-only {
  background: #f0f2f4;
  border: 0;
}
.checker-message.page-detail .popup__body .form__input button.btn-basic {
  border: 0;
  padding: 0 28px;
  height: 26px;
}
.checker-message.page-detail .popup__body .form__input.inline button.btn-basic {
  height: 32px;
}
.checker-message.page-detail .popup__body .form__input button.btn-basic span {
  font-weight: 700;
  font-size: 14px;
}
.checker-message.page-detail .popup__body .form__input li .btn__wrap {
  display: flex;
}
.checker-message.page-detail .popup__body .form__input li .btn__wrap button {
  width: 146px;
  height: 40px;
  border: 1px solid #909fb7;
}
.checker-message.page-detail .popup__body .form__input li .btn__wrap button + button {
  margin-left: 8px;
}
.checker-message.page-detail .popup__body .form__input li .btn__wrap button span {
  font-weight: 700;
  color: #909fb7;
}
.checker-message.page-detail .popup__body .form__input li .btn__wrap button.bg-navy {
  border-color: #003876;
}
.checker-message.page-detail .popup__body .form__input li .btn__wrap button.bg-navy span {
  color: #fff;
}
.checker-message .tbl-list table td button.btn-delete-g {
  width: 24px;
  height: 24px;
  min-width: auto;
}
.checker-message .popup__footer button:disabled {
  background: #e9edef;
}
.icon-navi {
  padding-left: 25px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_38___}) no-repeat 0 center;
  background-size: 20px 20px;
}
.checker-message.page-detail .popup__footer {
  padding: 24px 42px;
  width: calc(100% - 84px);
  border-top: 1px solid #dde2e9;
}
.checker-message.page-detail .popup__footer button {
  width: 120px;
}
.checker-message.page-detail .popup__footer button + button {
  margin-left: 8px;
}

/*체크시트관리*/
.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.checksheet-list {
  height: calc(100% - 180px);
}
.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.checksheet-list table th {
  padding: 7px 15px;
}
.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.checksheet-list table td {
  height: 34px;
  padding: 7px 15px;
}
.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.checksheet-list table td strong {
  font-weight: 500;
}
.admin-site .box.list .box__body .tbl-list.checksheet-list.hcal-270 {
  height: calc(100% - 270px);
}
.admin-site.layout-w3 .box.list .box__body .area__right .tbl-list.checksheet-list.hcal-300 + .tbl__bottom {
  flex-direction: row;
}
.admin-site.layout-w3 .box.list .box__body .area__right .tbl-list.checksheet-list.hcal-300 + .tbl__bottom .result__num {
  width: auto;
}
.checksheet-list .btn-more {
  width: 9px;
  height: 12px;
  min-width: auto;
  padding: 0;
  margin: 0 auto;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_56___}) no-repeat center center;
}
.checker-sheet.page-detail {
  width: 560px;
  height: auto;
  /* height: 778px; */
}
.checker-sheet.page-detail .popup__head {
  border-bottom: 1px solid #dde2e9;
}
.checker-sheet.page-detail .popup__body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 40px;
  width: calc(100% - 80px);
  max-height: calc(75vh - 7.42rem);
  margin: 32px 0 24px;
}
.checker-sheet.page-detail .popup__body .form__input {
  width: 100%;
  margin-bottom: 32px;
}
.checker-sheet.page-detail .popup__body .form__input + .tbl-list {
  margin-top: -8px;
}
.checker-sheet.page-detail .popup__body h2 {
  font-weight: 700;
  font-size: 15px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  margin-bottom: 32px;
}
.checker-sheet.page-detail .popup__body .form__input .tit {
  font-weight: 700;
  font-size: 15px;
  color: #2a2c2f;
  width: 222px;
}
.checker-sheet.page-detail .popup__body .form__input .sub-input {
  margin-top: 1rem;
  align-items: flex-start;
}
.checker-sheet.page-detail .popup__body .form__input .sub-input + .sub-input {
  margin-top: 8px;
}
.checker-sheet.page-detail .popup__body .form__input .sub-input .tit {
  font-weight: 500;
  font-size: 13px;
  color: #2a2c2f;
  width: 222px;
  vertical-align: top;
  margin-top: 8px;
}
.checker-sheet.page-detail .popup__body .form__input .input__area,
.checker-sheet.page-detail .popup__body .form__input li .btn__wrap {
  width: 100%;
}
.checker-sheet.page-detail .popup__body .form__input li {
  margin-top: 8px;
}
.checker-sheet.page-detail .popup__body .form__input li:first-child {
  margin-top: 0;
}
.checker-sheet.page-detail .popup__body .form__input li:last-child {
  margin-bottom: 0;
}
.checker-sheet.page-detail .popup__body .form__input input[type="text"] {
  height: 32px;
  font-weight: 400;
}
.checker-sheet.page-detail .popup__body .form__input .input__area textarea {
  height: 48px;
  padding: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}
.checker-sheet.page-detail .popup__body .form__input input[type="text"]:disabled {
  background: #f0f2f4;
  border: 0;
}
.checker-sheet.page-detail .popup__body .form__input .input__area textarea:read-only {
  background: #f0f2f4;
  border: 0;
}
.checker-sheet.page-detail .popup__body .tbl-list td {
  padding: 8px 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  vertical-align: top;
}
.checker-sheet.page-detail .popup__body .tbl-list td p {
  margin: 8px 0;
}
.checker-sheet.page-detail .popup__body .tbl-list .input__area textarea {
  height: 41px;
  padding: 5px 12px 2px 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}
.checker-sheet.page-detail .popup__body .form__input button.btn-basic {
  border: 0;
  padding: 0 28px;
  height: 26px;
}
.checker-sheet.page-detail .popup__body .form__input.inline button.btn-basic {
  height: 32px;
}
.checker-sheet.page-detail .popup__body .form__input button.btn-basic span {
  font-weight: 700;
  font-size: 14px;
}
.checker-sheet.page-detail .popup__body .form__input li .btn__wrap {
  display: flex;
}
.checker-sheet.page-detail .popup__body .form__input li .btn__wrap button {
  width: 146px;
  height: 40px;
  border: 1px solid #909fb7;
}
.checker-sheet.page-detail .popup__body .form__input li .btn__wrap button + button {
  margin-left: 8px;
}
.checker-sheet.page-detail .popup__body .form__input li .btn__wrap button span {
  font-weight: 700;
  color: #909fb7;
}
.checker-sheet.page-detail .popup__body .form__input li .btn__wrap button.bg-navy {
  border-color: #003876;
}
.checker-sheet.page-detail .popup__body .form__input li .btn__wrap button.bg-navy span {
  color: #fff;
}
.checker-sheet .tbl-list table td button.btn-delete-g {
  width: 24px;
  height: 24px;
  min-width: auto;
}
.checker-sheet .popup__footer button:disabled {
  background: #e9edef;
}
.checker-sheet.page-detail .popup__footer {
  padding: 24px 42px;
  width: calc(100% - 84px);
  border-top: 1px solid #dde2e9;
}
.checker-sheet.page-detail .popup__footer button {
  width: 120px;
}
.checker-sheet.page-detail .popup__footer button + button {
  margin-left: 8px;
}
.checker-sheet.page-detail .popup__body .tab__small {
  border-bottom: 1px solid #909fb7;
  margin-left: -40px;
  margin-right: -40px;
}
.checker-sheet.page-detail .popup__body .tab__small li:first-child {
  margin-left: 40px;
}
.checker-sheet.page-detail .popup__body .tab__small li + li {
  border: 0;
  margin: 0;
  padding: 0;
}
.checker-sheet.page-detail .popup__body .tab__small li a {
  width: 100px;
  height: 40px;
}
.checker-sheet.page-detail .popup__body .tab__small li.on a {
  border-bottom: 4px solid #0a78ff;
}
.versioninfo {
  margin-top: 34px;
  margin-bottom: 22px;
  text-align: center;
}
.versioninfo li {
  margin-bottom: 18px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.versioninfo li strong {
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
  margin-left: 37px;
}

/*관리자-이메일상담*/
.form__input li.column {
  align-items: flex-start;
}
.form__input li.column .input__area {
  margin-left: 0;
  margin-top: 16px;
}
.checker-message.page-detail .filelist li {
  display: inline-flex;
  width: auto;
  margin: 0 15px 0 0;
}

/*점검출동요청*/
.layout-w1 .content {
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  width: 100%;
  padding-left: 0;
  grid-gap: 0;
}

/*workorder_점검출동*/
.area__top {
  padding: 25px 26px;
  border-bottom: 1px solid #dde2e9;
  margin: -16px -24px;
  margin-bottom: 30px;
}
.area__top h2 {
  margin-bottom: 28px;
}
.area__top + .nodata__txt {
  margin-top: -60px !important;
}
.admin-site .area__right .area__top .search {
  padding: 0;
  border-bottom: 0;
  justify-content: flex-start;
}
.tabcontent .area__top .search .form__input {
  width: auto;
  margin-bottom: 0;
}
.tabcontent .area__top .search .form__input .input__area {
  width: auto;
}
.tabcontent .area__top .search .form__input + .btn__wrap {
  margin-left: 8px;
}
.admin-site .area__right .tbl__top .searcharea {
  margin-bottom: 0;
}
.searcharea .select + input[type="text"] {
  margin-left: 8px;
}

.admin-site.workorder .area__left.only-depth2 + .area__right {
  height: calc(100% - 59px);
}
.admin-site.workorder .area__right .area__right_content {
  /* height: calc(100% - 230px); */
  height: calc(100% - 190px);
}
.admin-site.workorder .box.list .box__body .area__right .area__right_content .tbl-list {
  height: calc(100% - 165px);
  overflow-y: hidden;
}
.workorder .tabcontent .area__top .search .form__input li:last-child label {
  width: 98px;
  margin-left: 0 !important;
}
.admin-site.workorder .nodata .nodata__txt {
  color: #909fb7;
  font-weight: 400;
  font-size: 14px;
  line-height: 26px;
  border-bottom: 1px solid #dde2e9;
  /* margin-top: -80px; */
}
.admin-site.workorder .nodata .nodata__txt::before {
  content: "";
  width: 162px;
  height: 100px;
  margin-bottom: 16px;
}
.checkstatus-box {
  display: flex;
  /* margin-bottom: 48px; */
  margin-bottom: 34px;
}
.checkstatus-box li {
  display: flex;
  margin: 2px 0 0 2px;
}
.checkstatus-box li + li {
  margin-left: 40px;
  padding-left: 40px;
  border-left: 1px solid #dde2e9;
}
.checkstatus-box li + li div {
  position: relative;
}
/* .checkstatus-box li + li div::after {
  content: "";
  display: block;
  padding-right: 8px;
  margin-left: -8px;
  width: 100%;
  margin-top: 9px;
  border-bottom: 2px solid #dde2e9;
} */
/* .checkstatus-box li + li div::before {
  content: "";
  position: absolute;
  bottom: -2px;
  left: -10px;
  width: 6px;
  height: 6px;
  border-radius: 50px;
  background: #dce1e9;
} */
.checkstatus-box li + li div:first-child:before {
  content: "";
  left: 0;
}
.checkstatus-box li + li div:first-child:after {
  content: "";
  margin-left: 0;
}
/* .checkstatus-box li + li div:last-child a::after {
  content: "";
  position: absolute;
  right: -1px;
  bottom: -2px;
  width: 6px;
  height: 6px;
  border-radius: 50px;
  background: #dce1e9;
} */
.checkstatus-box li div a {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 188px;
  height: 48px;
  padding: 16px;
  background: #ffffff;
  box-shadow: 2px 2px 8px rgba(144, 159, 183, 0.5);
  border-radius: 4px;
}
.checkstatus-box li div.on a {
  background: #0a78ff;
}
.checkstatus-box li div.on a p,
.checkstatus-box li div.on a p strong {
  color: #fff;
}
.checkstatus-box li div a:hover {
  background: #e6f0ff;
}
.checkstatus-box li div.on a:hover {
  background: #0a78ff;
}
/* .checkstatus-box li + li div.on::before,
.checkstatus-box li + li div.end::before {
  content: "";
  background: #006aff;
}
.checkstatus-box li + li div.on::after,
.checkstatus-box li + li div.end::after {
  content: "";
  border-color: #006aff;
}
.checkstatus-box li + li div.on + div::before {
  content: "";
  background: #006aff;
}
.checkstatus-box li + li div.on:last-child a::after {
  content: "";
  background: #006aff;
} */
.checkstatus-box li div + div {
  margin-left: 8px;
}
.checkstatus-box li div p:first-child {
  font-weight: 700;
  font-size: 16px;
  line-height: 14px;
  letter-spacing: -0.4px;
  color: #646c74;
}
.checkstatus-box li div p:last-child {
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  text-align: right;
  letter-spacing: -0.4px;
  color: #646c74;
}
.checkstatus-box li div p strong {
  font-weight: 700;
  font-size: 32px;
  letter-spacing: -0.6px;
  color: #003876;
  margin-right: 8px;
}

/* workorder lnb */
.admin-site .area__left.only-depth2 {
  width: 320px;
  margin-right: 0;
  margin-top: 0;
}
.admin-site .area__left.only-depth2 .lnb {
  max-height: 850px;
}
.area__left.only-depth2.close {
  width: 38px !important;
}
.area__left.only-depth2.close .lnb {
  display: none;
}
.area__left.only-depth2 + .area__right {
  width: calc(100% - 320px);
}
.area__left.only-depth2 .lnb-depth2 {
  margin-bottom: 8px;
}
.only-depth2 .lnb-depth2 > li > a::after {
  content: none;
}
.only-depth2 .lnb-depth2 > li.active > a,
.only-depth2 .lnb-depth2 > li.on > a {
  border-bottom: 0;
}
.area__left .box__etc {
  display: none;
  padding: 16px 12px;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
}
.btn-left {
  width: 1.5rem;
  height: 1.5rem;
  border: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) no-repeat center center;
  background-size: 100%;
}
.area__left.only-depth2.close .btn-left {
  width: auto;
  height: auto;
  padding-top: 42px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) no-repeat center 0;
}
.area__left.only-depth2.close .btn-left::after {
  content: "Tree Menu";
  writing-mode: vertical-rl;
  -ms-writing-mode: tb-rl;
  margin-top: 0;
  font-weight: 700;
}
.area__left.only-depth2 + .area__right .page-loca {
  margin: -16px -24px 16px;
  display: none;
}

/*노후교체요청*/
.devicenum {
  display: flex;
}
.devicenum + .devicenum {
  margin-left: 48px;
}
.devicenum p {
  font-weight: 700;
  font-size: 15px;
  line-height: 32px;
  letter-spacing: -0.6px;
  color: #2a2c2f;
}
.devicenum .num {
  padding-right: 20px;
  margin-left: 8px;
  font-size: 20px;
  line-height: 30px;
  color: #0a78ff;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_57___}) no-repeat right center;
  background-size: 20px 20px;
}
.devicenum-detail {
  display: flex;
}
.devicenum-detail li {
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #909fb7;
  margin-left: 16px;
}
.tbl__top .devicenum-detail li span {
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #2a2c2f;
  margin-left: 4px;
  margin-right: 0;
}
.changeold .filter {
  display: none;
}
.admin-site .area__right.changeold h2 {
  font-size: 20px;
  margin-top: 20px;
}
.admin-site .changeold .tbl-list table td {
  height: 26px;
}
.admin-site .changeold .tbl__bottom {
  margin-top: 18px;
}

/********************************************** For small screen, 반응형 **********************************************/
@media screen and (max-width: 1856px) {
  .container.filereports .content {
    width: calc(100% - 40px);
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, minmax(1006px, auto));
  }
  .container.filereports .box.ehc__score {
    grid-column: 2 / 1;
    width: 100% !important;
  }
  .container.filereports .box.ehc__score .btn-box,
  .container.filereports .box.ehc__score.close .btn-bo {
    display: none !important;
  }
  .container.filereports .treebar.box {
    height: 2019px;
  }
  .container.filereports .treebar.box .treearea {
    height: 1930px;
  }
  .container.filereports .box.ehc__score.close .box__header {
    justify-content: space-between;
    padding: 0 0.75rem 0 1rem;
    border-bottom: 1px solid #dde2e9;
  }
  .container.filereports .box.ehc__score.close .cate,
  .container.filereports .box.ehc__score.close .box__etc,
  .container.filereports .box.ehc__score.close .box__body {
    display: block;
  }
  .popup-boxin .page-detail {
    left: 25%;
    width: 50%;
  }
}
@media screen and (max-width: 1689px) {
  .area__right_content.workplace__info.workplace__main.info__input .content__info {
    grid-template-columns: 304px 1fr;
    grid-auto-rows: auto;
    grid-gap: 38px 24px;
  }
  .area__right_content.workplace__info.workplace__main.info__input .content__info ul.info__admin {
    grid-column: 2;
    grid-row: 2;
  }
  .area__right_content.workplace__info .btn__wrap {
    justify-content: flex-end;
    margin-left: 0;
    margin-right: 24px;
    max-width: 640px;
  }
  .page-list-view.page-workplace .popup__head {
    align-items: flex-start;
  }
  .page-list-view.page-workplace .popup__head h1 {
    font-size: 20px;
    margin-top: 16px;
    margin-bottom: 16px;
  }
  .page-list-view.page-workplace .area__right_content.workplace__info .btn__wrap {
    justify-content: center;
    margin-right: 0;
    margin-top: 30px;
    margin-bottom: 6px;
  }
  .page-list-view.page-workplace .area__right_content.workplace__info {
    margin: 0;
  }
  .page-list-view.page-workplace .area__right_content.workplace__info .content__info {
    padding: 0;
    width: 100%;
  }
  .page-list-view.page-workplace .content__info ul.filelist li {
    flex-direction: row;
    align-items: center;
  }
  .page-list-view.page-workplace .content__info ul li {
    flex-direction: column;
  }
  .page-list-view.page-workplace .content__info ul li,
  .page-list-view.page-workplace .content__info ul li p.tit,
  .page-list-view.page-workplace .content__info ul li p.txt {
    width: 100%;
    font-size: 14px;
  }
  .page-list-view.page-workplace .content__info ul li p.txt {
    margin-top: 8px;
  }
  .page-list-view.page-workplace .content__info ul li p.tit .fontRegular {
    display: inline-block;
  }

  .admin-site .tabcontent.layout-w2 .area__right_content.workplace__info .btn__wrap {
    margin-right: 0;
  }
}
@media screen and (max-width: 1685px) {
  .tbl-list.hcal-96 table td .ellipsis,
  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {
    max-width: 80px !important;
    width: 100%;
  }
}
@media screen and (max-width: 1660px) {
  .area__left.only-depth2 {
    padding-top: 0;
  }
  .area__left .box__etc {
    display: flex;
  }
  .area__left.only-depth2 + .area__right .page-loca {
    display: flex;
  }
}
@media screen and (max-width: 1600px) {
  .area__left.only-depth2 + .area__right .checkstatus-box li div a {
    width: 100px;
  }
}
@media screen and (max-width: 1565px) {
  .tbl-list.hcal-96 table td .ellipsis,
  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {
    max-width: 70px !important;
  }
}
@media screen and (max-width: 1549px) {
  .search__inline .filter {
    /* width: calc(100% - 500px); */
    /* width: calc(100% - 520px); */
  }
  .search__inline .search-small .searcharea input[type="text"] {
    width: 145px;
  }
  .search__inline .searcharea .btn-search {
    width: 80px;
  }
  .area__right_content.workplace__info .content__list {
    position: relative;
    margin-top: 40px;
    height: auto;
  }
  .listbox__area {
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: minmax(200px, auto);
  }
  .area__right_content.workplace__info.workplace__main .content__info {
    grid-template-columns: 304px 1fr;
    grid-auto-rows: auto;
    grid-gap: 0 24px;
  }
  .area__right_content.workplace__info.workplace__main .content__info .img_workplace {
    grid-row: 1 / 3;
  }
  .area__right_content.workplace__info.workplace__main .content__info ul.info__admin {
    grid-column: 2;
    grid-row: 2;
  }
  .admin-site .area__right .page-top h2 {
    font-size: 20px;
    line-height: 29px;
  }
  .admin-site .area__right .top-button button {
    width: 28px;
    height: 28px;
  }
  .content__info ul li {
    margin-bottom: 1rem;
  }
  .content__info ul li p {
    font-size: 14px;
  }
  .content__info ul li p.tit {
    width: 120px;
  }
  .content__info ul li p.tit span {
    font-size: 12px;
    display: block;
    margin: 1px 0 0 0;
  }
  .content__info ul li p.txt {
    width: calc(100% - 120px);
  }
  .content__info ul.form__input .input__area {
    width: calc(100% - 120px);
  }
  .area__right_content .btn__wrap {
    max-width: 575px;
  }
  .area__right_content.workplace__info .btn__wrap {
    max-width: 600px;
  }
}
@media screen and (max-width: 1545px) {
  .tbl-list.hcal-96 table td .ellipsis,
  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {
    max-width: 60px !important;
  }
}
@media screen and (max-width: 1529px) {
  .tbl-list.hcal-96 table td .ellipsis,
  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {
    max-width: 45px !important;
  }
}
@media screen and (min-width: 1522px) {
  .tabcontent .tbl__top.d-lm-block {
    display: flex !important;
  }
}
@media screen and (max-width: 1522px) {
  .d-mm-none {
    display: none !important;
  }
  .result__num.d-mm-none {
    display: block !important;
  }
  .no-responsive .tabcontent .search {
    border-bottom: 1px solid #dde2e9;
    padding: 32px 0 32px 8px;
  }
  .tabcontent .search {
    border-bottom: 0;
    padding-bottom: 6rem;
  }
  .search-small {
    width: 74px;
    padding: 2px 0 2px 22px;
    float: left;
  }
  .filter {
    width: 74px;
    padding: 2px 0;
    border-bottom: 0;
    float: left;
    padding-right: 16px;
    border-right: 1px solid #dde2e9;
  }
  .tabcontent__top::after {
    content: "";
    display: block;
    clear: both;
  }
  .tabcontent .btn-renew {
    display: inline-block;
    float: right;
    margin-top: -3px;
    background: #0a78ff;
    border-color: #0a78ff;
    width: 88px;
    height: 28px;
  }
  .btn-renew span {
    font-weight: 500;
    font-size: 0.875rem;
    color: #fff;
  }
  .btn-renew:disabled {
    background: #f0f2f4;
    border-color: #f0f2f4;
  }
  .btn-renew:disabled:hover {
    background: #f0f2f4 !important;
  }
  .tabcontent .tbl__top {
    display: none;
  }
  .no-responsive .tabcontent .tbl__top {
    display: flex;
  }
  .tabcontent .tbl__top.d-lm-block {
    display: flex !important;
  }
  .tabcontent__top {
    margin-bottom: 22px;
  }
  .tabcontent .tbl-list table th {
    font-size: 0.812rem;
    line-height: 16px;
    padding: 10px 8px;
  }
  .tabcontent .tbl-list table td {
    font-size: 0.875rem;
    line-height: 16px;
    padding: 11px 8px;
  }
  .tabcontent .detail__view .tbl-list table td button {
    min-width: 80px;
  }
  .tabcontent .tbl-list table td button {
    min-width: 64px;
  }
  .tabcontent .tbl-list table td button.btn {
    min-width: auto;
  }
  .filter.open .title .btn-close,
  .filter.open .title .info,
  .filter.open .filter__select,
  .search-small.open .title .btn-close,
  .search-small.open .search__cont {
    display: none;
  }
  .tabcontent__top .btn__wrap {
    display: flex;
    align-items: flex-end;
  }
  .form__input .searchterm .term__date input[type="text"] {
    width: 102px;
  }
  .no-responsive .tabcontent .search .form__input {
    width: 100%;
  }
  .no-responsive .tabcontent .search .form__input li {
    display: inline-block;
    float: left;
    width: auto;
    margin-top: 0;
  }
  .no-responsive .tabcontent .search .form__input li:last-child {
    margin-top: 0;
  }
  .no-responsive .tabcontent .search .form__input li label,
  .no-responsive .tabcontent .search .form__input li:last-child label {
    display: inline-block;
    float: left;
    margin-top: 5px;
    width: auto;
  }
  .no-responsive .tabcontent .search .form__input .input__area {
    margin-left: 1rem;
    width: 186px;
    display: inline-block;
    float: left;
  }
  .tabcontent .search .form__input {
    width: 58%;
  }
  .tabcontent .search .form__input li:last-child {
    margin-top: 12px;
  }
  .tabcontent .search .form__input li:last-child label {
    margin-left: 0 !important;
    width: 75px;
  }
  .filter.open .title,
  .search-small.open .title {
    color: #2a2c2f;
  }
  .search__inline {
    justify-content: flex-start;
    margin-bottom: 0;
  }
  .search__inline .search-small {
    justify-content: space-between;
    width: 74px;
    margin-right: calc(100% - 320px);
    padding: 2px 0 2px 22px;
  }
  .search__inline .search-small .search__cont {
    display: none;
  }
  .search__inline .filter {
    width: 84px;
    padding: 2px 0;
    border-bottom: 0;
    float: left;
    padding-right: 16px;
    border-right: 1px solid #dde2e9;
  }
  .testrecord .tabcontent__top {
    margin-bottom: 1rem;
  }
  .tabcontent__title {
    margin: 37px 0 8px;
  }
  .tbl-list.hcal-96 table th.d-lm-none,
  .tbl-list.hcal-96 table td.d-lm-none {
    display: none;
  }
  .tbl-list.hcal-96 table td .ellipsis,
  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {
    max-width: 100% !important;
    width: 100%;
  }
  .tbl-list.hcal-96 table tr.focused td {
    background: #e6f0ff;
  }
  .inline.right.search-small .title {
    display: none;
  }
  .inline.right.search-small.open .searcharea .select,
  .inline.right.search-small.open .input__direct {
    display: none;
  }
  .inline.right.search-small.open .searcharea .btn-search {
    width: 32px;
    height: 32px;
    min-width: auto;
    background-position: center;
  }
  .inline.right.search-small.open .searcharea .btn-search span {
    display: none;
  }
  .tbl-list.type2 tbody tr.open td:first-child:before {
    content: "";
    display: inline-block;
    margin: -11px -8px;
    width: 4px;
    min-height: 100%;
    background: #0a78ff;
    position: absolute;
  }
  .tabcontent .checkstatus-box + .tbl__top {
    display: flex;
  }
  .tabcontent .area__top .search .form__input li:last-child {
    margin-top: 0;
  }
  .tabcontent .area__top .search .form__input li:last-child label {
    width: auto;
    margin-left: 38px !important;
  }
  .workorder .tabcontent .area__top .search .form__input li:last-child label {
    width: 98px;
    margin-left: 0 !important;
  }

  /*노후교체요청*/
  .tabcontent .changeold .search {
    border-bottom: 1px solid #dde2e9;
    padding: 32px 0 32px 8px;
  }
  .tabcontent .changeold .search .form__input {
    flex-direction: row;
    width: calc(100% - 120px);
  }
  .tabcontent .changeold .search .form__input li:last-child {
    margin-top: 0;
  }
  .tabcontent .changeold .search .form__input li:last-child label {
    margin-left: 38px !important;
    width: auto;
  }

  /* .admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.message-list {
    height: calc(100vh - 280px);
  }
  .admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.lang-list {
    height: calc(100vh - 280px);
  }
  .admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.menuset-list {
    height: calc(100vh - 240px);
  }
  .admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.checksheet-list {
    height: calc(100vh - 280px);
  } */
}
@media screen and (max-width: 1470px) {
  .drag__area {
    flex-direction: column;
  }
  .drag__area .filebox-drag {
    display: none;
  }
  .drag__area .filebox-upload {
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
  }
  .drag__area .drag__right {
    width: 100%;
    margin-top: 0;
  }
  .drag__area .drag__left {
    width: 100%;
    margin-bottom: 34px;
    padding-bottom: 34px;
    border-bottom: 2px solid #e9edef;
  }
  .drag__area .drag__left .filebox-upload .filelist {
    margin-top: 10px;
    width: calc(100% - 190px);
  }
  .drag__area .drag__left .filebox-upload .btn-upload {
    display: flex;
    width: 72px;
    height: 24px;
    background: #0a78ff;
    border-radius: 4px;
    border: 0;
    margin-top: 5px;
  }
  .drag__area .drag__left .filebox-upload .btn-upload span {
    font-weight: 700;
    font-size: 12px;
    color: #fff;
  }
  .drag__area .drag__left .btn-filedown span {
    font-size: 13px;
  }
  .drag__area .drag__left .btn.btn-filedown {
    background-size: 20px;
    padding-right: 26px;
    margin-right: 0;
  }
  .drag__area .content__info ul li p {
    font-size: 12px;
  }
  .filelist-case .inline.right.search-small.open {
    font-size: 14px;
    background-size: 16px;
  }
  .drag-filelist .name.success,
  .drag-filelist .name {
    background-size: 16px;
  }
  .filelist-case .name {
    font-size: 14px;
    padding-top: 0px;
    background-size: 8px 15px;
    width: auto;
  }
  .drag-filelist .progressbar .progress-value progress {
    width: 64px;
  }
  .drag-filelist .progressbar .progress-value .value {
    margin-left: 8px;
    width: 35px;
    text-align: right;
  }
  .content__info .drag__right__list .drag-filelist li,
  .content__info .drag__right__list .drag-filelist li:first-child,
  .content__info .drag__right__list .filelist-case li,
  .content__info .drag__right__list .filelist-case li:first-child {
    justify-content: space-between;
  }
  .drag__area .drag__right .drag__right__list p.tit {
    font-size: 14px;
  }
  .flielist__upload {
    display: flex;
    justify-content: space-between;
    width: calc(100% - 114px);
  }
}
@media screen and (max-width: 1406px) {
  .admin-site.layout-w3 .tabcontent {
    flex-direction: column;
    justify-content: flex-start;
  }
  .admin-site.layout-w3 .area__left,
  .admin-site.layout-w3:not(.no-responsive) .area__right,
  .admin-site.layout-w3 .area__right-end {
    position: relative;
    width: calc(100% - 32px);
    height: auto;
    border-bottom: 1px solid #dde2e9;
    border-right: 0;
    border-left: 0;
    padding: 0;
    margin: 0 16px;
  }
  .admin-site.layout-w3 .area__left_content.detail__view,
  .admin-site.layout-w3 .area__right_content.detail__view {
    display: none;
  }
  .admin-site.layout-w3 .area__left_content.detail__view.on,
  .admin-site.layout-w3 .area__right_content.detail__view.on {
    display: block;
    margin-top: -14px;
  }
  .admin-site.layout-w3 .page-top {
    margin: 0;
    padding: 33px 0;
    cursor: pointer;
  }
  .more__detail {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_58___}) no-repeat right center;
    background-size: 20px 20px;
  }
  .admin-site:not(.no-responsive) .box.list .box__body .tbl-list {
    height: auto !important;
  }
  .admin-site.layout-w3 .tbl-list table th {
    font-size: 13px;
  }
  .admin-site.layout-w3 .area__left .tbl__bottom,
  .admin-site.layout-w3 .area__right-end .tbl__bottom,
  .admin-site.layout-w3 .area__right .tbl__bottom.mt-48 {
    flex-direction: row;
    margin: 32px 0 40px !important;
  }
  .admin-site.layout-w3 .area__left .tbl__bottom .result__num,
  .admin-site.layout-w3 .area__right-end .tbl__bottom .result__num {
    width: auto;
  }
  .admin-site.layout-w3 .area__left .tbl__bottom .paging,
  .admin-site.layout-w3 .area__right-end .tbl__bottom .paging {
    width: calc(100% - 100px);
    justify-content: space-around;
  }
  .admin-site.layout-w3 .area__left .tbl__bottom .paging ul,
  .admin-site.layout-w3 .area__right-end .tbl__bottom .paging ul {
    margin-top: 0;
  }
  .admin-site.layout-w3 .tbl__bottom .paging__select {
    display: flex;
    right: 11px;
  }
  .workplace-ok.page-detail {
    width: 566px;
    height: auto;
  }
  .workplace-ok.page-detail .popup__body {
    max-height: calc(80vh - 11rem);
    padding: 33px 40px 40px;
    margin-bottom: 20px;
  }
  .workplace-ok.page-detail .popup__body .tbl-list.mt-16 {
    margin-top: 0 !important;
  }
  .workplace-ok.page-detail .popup__body .tbl-list.type2 table th,
  .workplace-ok.page-detail .popup__body .tbl-list.type2 table td {
    font-size: 14px;
  }
  .workplace-ok.page-detail .popup__body .tbl-list.type2 table th {
    font-size: 14px;
    padding: 8px 16px;
  }
  .workplace-ok.page-detail .popup__body .tbl-list .d-sm-none {
    display: none !important;
  }
  .workplace-ok.page-detail .popup__body .tbl-list tbody.d-sm-block {
    display: table !important;
    width: 100%;
  }
  .workplace-ok.page-detail .workplace__info {
    flex-direction: column-reverse;
    margin-top: 40px;
  }
  .workplace-ok.page-detail .img_workplace {
    width: 238px;
    height: 238px;
    margin-top: -400px;
  }
  .workplace-ok.page-detail .workplace__info .txt_workplace {
    width: 100%;
    margin-left: 0;
  }
  .workplace-ok.page-detail .workplace__info .txt_workplace ul {
    margin-top: 290px;
  }
  .workplace-ok.page-detail .workplace__info .txt_workplace ul li p.tit {
    width: 100px;
    margin-right: 20px;
  }
  .workplace-ok.page-detail .workplace__info .txt_workplace ul li p.txt {
    width: calc(100% - 120px);
  }
  .workplace-ok.page-detail .workplace__info .txt_workplace ul li p.tit,
  .workplace-ok.page-detail .workplace__info .txt_workplace ul li p.txt {
    font-size: 14px;
  }
  .userjoin-ok.page-detail.casecheck-ok {
    width: calc(100% - 60px);
    height: auto;
  }
  .userjoin-ok.page-detail {
    width: 566px;
    height: auto;
  }
  .userjoin-ok.page-detail .popup__body {
    flex-direction: column;
    justify-content: flex-start;
    max-height: calc(80vh - 11rem);
    padding: 33px 40px 40px;
  }
  .userjoin-ok.page-detail .popup__body .left,
  .userjoin-ok.page-detail .popup__body .right {
    width: 100%;
  }
  .userjoin-ok.page-detail .popup__body .right {
    margin-top: 40px;
  }
  .userjoin-ok.page-detail .popup__body h2 {
    display: none;
  }
  .userjoin-ok.page-detail .popup__body .form__input li {
    margin-bottom: 24px;
  }
  .userjoin-ok.page-detail .popup__body .form__input .tbl-list.type2 table th {
    padding: 8px 12px;
  }
  .userjoin-ok.page-detail .popup__body .form__input .tbl-list.type2 table td {
    padding: 14px 12px;
  }
  .userjoin-ok.page-detail .popup__footer.right {
    padding: 24px;
    width: calc(100% - 48px);
    justify-content: center;
  }
  .userjoin-ok.page-detail .popup__body.layout-vertical {
    padding-bottom: 40px;
  }
  .userjoin-ok.page-detail .popup__body.layout-vertical .form__input.inline {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 32px !important;
  }
  .userjoin-ok.page-detail .popup__body.layout-vertical .form__input li {
    margin: 0 0 24px;
    width: 100%;
  }
  .userjoin-ok.page-detail .popup__body.layout-vertical .form__input li:last-child {
    margin-bottom: 0;
  }
  .userjoin-ok.page-detail .popup__body.layout-vertical .form__input label {
    width: 88px;
  }
  .userjoin-ok.page-detail .popup__body.layout-vertical .form__input .input__area {
    margin-left: 0;
    width: calc(100% - 180px);
  }
  .userjoin-ok.page-detail .popup__body.layout-vertical .tbl-list.type2 {
    height: 440px;
  }
  .userjoin-ok.page-detail .popup__body.layout-vertical .tbl-list.type2 th {
    padding: 8px 12px;
  }
  .userjoin-ok.page-detail .popup__body.layout-vertical .tbl-list.type2 td {
    padding: 14px 12px;
  }
  .userjoin-ok.page-detail .popup__body.layout-vertical .tbl-list.type2 td .ellipsis {
    max-width: 120px;
    width: 100%;
  }
  .userjoin-ok.page-detail .popup__body.layout-vertical + .popup__footer {
    padding: 24px 42px;
    width: calc(100% - 84px);
    border-top: 1px solid #dde2e9;
  }
  .popup-layer.pop-usertype {
    width: 560px;
  }
  .popup-layer.pop-usertype .popup__body {
    max-height: calc(80vh - 3.25rem);
  }
  .popup-layer.pop-usertype .user-info {
    margin-bottom: 24px;
  }
  .popup-layer.pop-usertype .user-info li {
    margin-bottom: 24px;
  }
  .popup-layer.pop-usertype .user-info li p:first-child {
    width: 180px;
  }
  .popup-layer.pop-usertype .user-info li p:last-child {
    width: calc(100% - 180px);
    font-size: 13px;
    line-height: 19px;
    letter-spacing: -0.28px;
  }
  .popup-layer.pop-usertype .tbl__top .info {
    font-size: 13px;
  }
  .popup-layer.pop-usertype .tbl-list.type2 table th,
  .popup-layer.pop-usertype .tbl-list.type2 table td {
    font-size: 13px;
  }

  .admin-site .tabcontent.layout-w2 {
    justify-content: space-between;
    flex-direction: row;
  }
  .admin-site .tabcontent.layout-w2 .area__left,
  .admin-site .tabcontent.layout-w2 .area__right,
  .admin-site .tabcontent.layout-w2 .area__right-end {
    padding: 16px 0;
    width: 310px;
    height: calc(100% - 29px);
    border-right: 4px solid #dde2e9;
    border-bottom: 0;
    margin: 0;
  }
}
@media screen and (max-width: 1339px) {
  .tbl-list.hcal-96 table td .ellipsis,
  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {
    max-width: 150px !important;
    width: 100%;
  }
}
@media screen and (max-width: 1304px) {
  .container.filereports .content {
    grid-auto-rows: auto;
  }
  .container.filereports .box.list .box__body {
    padding-top: 0;
  }
  .container.filereports .treebar.box {
    width: 294px;
  }
  .container.filereports .treebar.box .treearea {
    height: 1930px;
  }
  .container.filereports .box.ehc__score {
    grid-column: 1;
    grid-row: 2;
  }
  .tabcontent .search {
    flex-direction: column;
    justify-content: flex-start;
    padding-bottom: 34px;
  }
  .tabcontent .search .form__input {
    display: flex;
    float: none;
    width: 100%;
    flex-direction: column;
    margin-bottom: 12px;
  }
  .tabcontent .search .form__input li {
    display: flex;
    float: none;
    width: 100%;
    margin-top: 0.75rem;
    justify-content: space-between;
    align-items: flex-start;
  }
  .tabcontent .search .form__input li label {
    float: none;
    font-size: 0.938rem;
    line-height: 1.375rem;
    margin-top: 5px;
  }
  .tabcontent .search .form__input li + li label {
    margin-left: 0;
    max-width: none;
  }
  .tabcontent .search .form__input .input__area {
    margin-left: 1rem;
    width: 66%;
    display: flex;
    float: none;
  }
  .tabcontent .search .btn__wrap {
    display: flex;
    justify-content: flex-end;
  }
  .tabcontent .search .form__input .input__area .searchterm .term__month .selected {
    width: auto;
  }

  .admin-site .area__right .area__top .search {
    flex-direction: row;
  }
  .area__top .searchterm {
    flex-direction: row;
  }
  .area__top .searchterm .term__month + .term__date {
    margin-top: 0;
    margin-left: 8px;
  }

  /*노후교체요청*/
  .tabcontent .changeold .search {
    justify-content: space-between;
    flex-direction: row;
    padding: 32px 0 32px 8px;
  }
  .tabcontent .changeold .search .form__input {
    flex-direction: row;
    float: left;
    width: calc(100% - 120px);
    margin-bottom: 0;
  }
  .tabcontent .changeold .search .form__input li {
    margin-top: 0;
    float: left;
    width: auto;
  }
  .tabcontent .changeold .search .form__input .input__area {
    margin-left: 1rem;
    width: 186px;
  }
  .tabcontent .changeold .search .form__input li + li label {
    margin-left: 38px;
  }
}
@media screen and (max-width: 1290px) {
  .checkstatus-box li div a {
    width: 100px;
  }
}
@media screen and (max-width: 1250px) {
  .area__top {
    margin: -16px -14px 48px;
  }
  .area__left.only-depth2 + .area__right .page-loca {
    margin: -16px -14px 16px;
  }
}
@media screen and (max-width: 1249px) {
  .area__right_content.workplace__info {
    /* margin: 0 -18px; */
    margin: 0 -12px 0 -18px;
  }
}
@media screen and (max-width: 1030px) {
  .tabcontent .tbl-list.hcal-96 table th.d-sm-none,
  .tabcontent .tbl-list.hcal-96 table td.d-sm-none {
    display: none !important;
  }
  .tbl-list.hcal-96 table td .ellipsis,
  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {
    width: 100%;
    max-width: 100px !important;
  }
}
@media screen and (max-width: 1024px) {
  .status__data {
    justify-content: flex-start;
  }
  .status__data li {
    width: calc(100% / 5);
    height: auto;
  }
  .status__data li a {
    width: 100%;
  }
  .status__data li a:focus {
    height: calc(100% - 4px);
  }
  .status__data li:first-child {
    width: calc(100% / 5 - 17px);
  }
  .status__data li:last-child {
    width: calc(100% / 2.5);
    padding-right: 0;
    text-align: center;
    justify-content: flex-start;
  }
  .status__data li:last-child a {
    margin: 0 auto;
    width: 50%;
  }
  .status__data li:last-child a:focus {
    width: calc(50% - 10px);
  }
  .status__data li a:focus {
    width: 100%;
    height: auto;
    padding: 13px 0;
  }
  .status__data li:before {
    padding-left: 8px;
    margin-left: 8px;
  }
  .status__data li p.txt {
    font-size: 30px;
  }

  /*노후교체요청*/
  .tabcontent .changeold .search {
    flex-direction: column;
  }
  .tabcontent .changeold .search .form__input {
    flex-direction: column;
    float: none;
    width: 100%;
  }
  .tabcontent .changeold .search .form__input li {
    margin-bottom: 12px;
  }
  .tabcontent .changeold .search .form__input li + li label,
  .tabcontent .changeold .search .form__input li:last-child label {
    margin-left: 0 !important;
  }
  .tabcontent .changeold .search .form__input li label {
    flex: 1;
  }
  .tabcontent .changeold .search .form__input .input__area {
    flex: 2;
  }
  .tabcontent .changeold .search .select.w186 {
    width: 100% !important;
  }
}
@media screen and (max-width: 1759px) {
  .ehc__addfile {
    margin-top: -3rem;
  }
  .ehc__addfile p.txt {
    margin: 0.75rem 0 0.4rem;
  }
  .popup-boxin .page-detail.w400 {
    left: 32%;
  }
}
@media screen and (max-width: 1415px) {
  /* 운영관리 컨텐츠 영역_사업장 신규입력 : 디자인 변경 */
  .newtype .content__info ul li p.txt-info {
    width: 100%;
    /* width: 280px; */
  }
}
@media screen and (min-width: 1377px) {
  .d-lm-block {
    display: none !important;
  }
}
@media screen and (max-width: 1376px) {
  .d-lm-none {
    display: none !important;
  }
  .d-lm-block {
    display: block;
  }
  .popup-boxin .page-detail.w400 {
    left: 28%;
  }
  /*노후교체요청*/
  .devicenum.d-lm-block {
    display: flex;
  }
  .devicenum-detail {
    display: none;
  }
  .btn-basic.down {
    width: 32px;
    height: 32px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_59___}) no-repeat center center #0a78ff;
    background-size: 100%;
  }
  .btn-basic.down span {
    display: none;
  }
}
@media screen and (max-width: 1250px) {
  .admin-site .area__left {
    width: 302px;
  }
  .admin-site .area__right {
    padding: 16px 14px 18px;
    width: calc(100% - 334px);
  }
  .admin-site .area__right .searcharea {
    margin-bottom: 1rem;
  }
  .admin-site:not(.no-responsive) .area__right .searcharea .searchinput {
    width: 100%;
  }
  .admin-site .area__right .searcharea .input__direct {
    width: calc(100% - 104px) !important;
  }
  .admin-site .area__right .searcharea .input__direct input[type="text"] {
    width: calc(100% - 1.5rem) !important;
  }
  .tbl-list.type3.w800 {
    width: 100% !important;
  }
  .tabcontent .tbl-list.type3 table td {
    padding: 1rem;
  }
  .tbl-list.type3 td ul {
    flex-direction: column;
  }
  .tbl-list.type3 td ul li {
    width: 100%;
  }
  .tbl-list.type3 td ul li.address {
    width: 100%;
    margin-top: 1rem;
    line-height: normal;
  }
  .tbl-list.type3 td ul li p.placename {
    width: 45%;
    font-size: 14px;
  }
  .tbl-list.type3 td ul li p.location {
    width: 55%;
    font-size: 14px;
  }
  .nodata .nodata__txt.w800 {
    width: 100% !important;
  }
  .admin-site .area__right .checkstatus-box + .tbl__top .searcharea .searchinput {
    width: auto;
  }
  .admin-site .area__right.changeold .tbl__top .searcharea .searchinput {
    width: auto;
  }
}
@media screen and (max-width: 1200px) {
  .nodata {
    height: auto;
  }
  .nodata .nodata__txt {
    margin: 30px 0;
  }
  .nodata .nodata__txt::before {
    content: "";
    width: 10.156rem;
    height: 6.25rem;
    margin-bottom: 1rem;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_60___}) no-repeat center center;
    background-size: 100%;
  }
  .nodata .result__num {
    display: none;
  }
  .ehc__rolling,
  .ehc__picture {
    height: 152px;
  }
  .ehc__picture ul li,
  .ehc__picture li a {
    width: 152px;
    height: 152px;
  }
  .ehc__addfile p.txt {
    margin: 0.4rem 0;
  }
  .popup-boxin .popup__body .form__input {
    width: 100% !important;
  }
  .popup-boxin .popup__body .form__input .input__area.w260 {
    width: auto !important;
  }
}
@media screen and (max-width: 1170px) {
  .tbl-list.type2 table th:first-child span::before,
  .tbl-list.type2 table td:first-child span::before {
    margin-left: 10px;
  }
  .tbl-list.type2 table tr.open th:first-child span::before,
  .tbl-list.type2 table tr.open td:first-child span::before {
    margin-left: 9px;
  }
}
@media screen and (max-width: 1160px) {
  /* 운영관리 컨텐츠 영역_사업장 신규입력 : 디자인 변경 */
  .admin-site .area__right h2 {
    font-size: 20px;
  }
  .area__right_content.workplace__info.workplace__main.newtype .content__info + .content__info {
    margin-top: 32px;
    padding-top: 32px;
  }
  .newtype .content__info .flex-row {
    flex-direction: column;
  }
  .area__right_content.workplace__info.workplace__main.newtype .content__info h3 {
    font-size: 1rem;
  }
  .newtype .content__info .flex-row .form__input.ml-40 {
    margin-left: 0 !important;
    margin-top: 32px;
  }
  /* .newtype .content__info ul li p.txt-info {
    display: none;
  } */
  .area__right_content.workplace__info.workplace__main.newtype .content__info .img_workplace {
    grid-row: auto;
    margin-bottom: 0;
    width: 238px;
    height: 238px;
  }
  .area__right_content.workplace__info.workplace__main.newtype .content__info .img_workplace .btn-imgadd {
    top: 201px;
  }
  .newtype.area__right_content.workplace__info .column .btn__wrap.center {
    margin: 2rem 0;
  }
  /*노후교체요청*/
  .devicenum.ml-48 {
    margin-left: 15px !important;
  }
}
@media screen and (max-width: 1165px) {
  .tbl-list.hcal-77 table th.d-sm-none,
  .tbl-list.hcal-77 table td.d-sm-none {
    display: none !important;
  }
}
@media screen and (min-width: 1101px) {
  .tbl-list .d-sm-block {
    display: none !important;
  }
}
@media screen and (max-width: 1100px) {
  .box.list .box__header {
    border-bottom: 1px solid #dde2e9;
  }
  .box.list .box__body {
    padding-top: 16px;
    height: auto;
  }
  .box.list .box__body .tbl-list {
    height: auto;
  }
  .box.list .box__body .tbl__top .left span {
    display: none;
  }
  .tbl-list .d-sm-none {
    display: none !important;
  }
  .tbl-list .d-sm-block {
    display: block;
  }
  .tbl-list table td.checkdate {
    text-align: left;
    cursor: pointer;
  }
  .tbl-list table td.checkdate:after {
    content: "";
    display: inline-block;
    width: 8px;
    height: 15px;
    margin-left: 10px;
    vertical-align: top;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_61___}) no-repeat 0 3px;
    background-size: 80%;
  }
  .tbl-list table td.checkdate.disabled:after {
    content: none;
  }
  .tabcontent .tbl-list table th.d-sm-none,
  .tabcontent .tbl-list table td.d-sm-none {
    display: table-cell !important;
  }
  .tabcontent .tbl-list table th.d-lm-none,
  .tabcontent .tbl-list table td.d-lm-none {
    display: none !important;
  }
  .popup-boxin .page-detail.w400 {
    left: 21%;
  }
  .testrecord .tbl-list.type2 table td.d-sm-block {
    display: none !important;
  }
}
@media screen and (max-width: 1089px) {
  .listbox__area {
    grid-template-columns: 1fr;
  }
  .area__right_content.workplace__info.workplace__main .content__info {
    grid-template-columns: 1fr;
    grid-gap: 0;
  }
  .area__right_content.workplace__info.workplace__main .content__info .img_workplace {
    grid-row: auto;
    margin-bottom: 24px;
    width: 238px;
    height: 238px;
  }
  .area__right_content.workplace__info.workplace__main .content__info .img_workplace .btn-imgadd {
    top: 201px;
  }
  .content__info ul.form__input .input__area {
    max-width: unset;
  }
  .area__right_content.workplace__info.workplace__main .content__info ul.info__admin {
    grid-column: auto;
    grid-row: auto;
  }
  .page-top {
    margin-bottom: 34px;
  }
  .area__right_content.workplace__info.workplace__main.info__input .content__info {
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
    grid-gap: 0;
  }
  .area__right_content.workplace__info.workplace__main.info__input .content__info ul.info__admin {
    grid-column: auto;
    grid-row: auto;
  }
  .box.list .box__body .content__list .tbl-list {
    border-top: 1px solid #dde2e9;
    border-bottom: 0;
    margin-top: 20px;
    max-height: 430px;
  }
  .popup-layer .content__list .tbl-list {
    border-top: 1px solid #dde2e9;
    border-bottom: 1px solid #dde2e9;
    margin-top: 20px;
  }
  .box.list .box__body .content__list .tbl-list thead,
  .popup-layer .content__list .tbl-list thead {
    display: none;
  }
  .tabcontent .content__list .tbl-list td,
  .popup-layer .content__list .tbl-list td {
    font-size: 13px;
    vertical-align: top;
    padding: 15px 8px;
  }
  .box.list .box__body .content__list .tbl-list td.d-sm-none,
  .popup-layer .content__list .tbl-list td.d-sm-none {
    display: none !important;
  }
  .box.list .box__body .content__list .tbl-list td.d-lm-none,
  .popup-layer .content__list .tbl-list td.d-lm-none {
    display: table-cell !important;
  }
  .box.list .box__body .content__list .tbl-list td.d-lm-none p,
  .popup-layer .content__list .tbl-list td.d-lm-none p {
    margin-top: 10px;
  }
  .box.list .box__body .content__list .tbl-list td.d-lm-none p:first-child,
  .popup-layer .content__list .tbl-list td.d-lm-none p:first-child {
    margin-top: 0;
  }
  .area__right_content .btn__wrap.ml-0 {
    max-width: 100%;
  }
  .area__right_content.workplace__info .btn__wrap {
    max-width: 100%;
  }
}
@media screen and (max-width: 1023px) {
  /* .content {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(auto-fill, minmax(20.625rem, auto));
    grid-auto-rows: 20.625rem;
  }
  .content > *:nth-child(4) {
    grid-row: auto;
    grid-column: auto;
  } */
}
@media screen and (min-width: 1201px) and (max-width: 1379px) {
  .status__data li a {
    width: 82px;
  }
  .status__data li a:focus,
  .status__data li a.on {
    width: 80px;
  }
}

@media screen and (max-width: 980px) {
  .tabcontent .tbl-list table th.d-sm-none,
  .tabcontent .tbl-list table td.d-sm-none {
    display: none !important;
  }
  .tabcontent .tbl-list table .tr__detail .tbl-list.type2 thead tr th,
  .tabcontent .tbl-list table .tr__detail .tbl-list.type2 tbody tr td {
    display: table-cell !important;
  }
  .tabcontent .tbl-list table .tr__detail .tbl-list.type2 tbody tr td {
    padding: 13px 16px;
  }
  .testrecord .tbl-list.type2 .tr__detail .tbl-list.type2 table tbody tr td.d-sm-block {
    display: none !important;
  }
  .tabcontent .tbl-list.type2 table .tr__detail td {
    padding: 0 0 16px;
  }
  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block.firstline::before {
    content: none;
  }
  .testrecord .tbl-list.type2 table tr.tr__click td.d-sm-block.firstline {
    display: flex !important;
    align-items: flex-start;
    padding-top: 15px;
  }
  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block.firstline {
    display: flex !important;
    padding-top: 15px;
    color: #0a78ff;
  }
  .testrecord .tbl-list.type2 table tr.tr__click td.d-sm-block.firstline span.w25p {
    position: relative;
    display: flex;
    align-items: center;
    font-size: 0.875rem;
    line-height: 20px;
  }
  .testrecord .tbl-list.type2 table tr.tr__click td.d-sm-block.firstline span.w25p::before {
    content: "";
    width: 0;
    height: 0;
    border-bottom: 5px solid transparent;
    border-top: 5px solid transparent;
    border-left: 8px solid #909fb7;
    border-right: 8px solid transparent;
  }
  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block.firstline span.w25p {
    margin-left: 0;
  }
  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block.firstline span.w25p::before {
    content: "";
    margin-left: -1px;
    margin-right: 8px;
    margin-bottom: -10px;
    width: 0;
    height: 0;
    border-bottom: 8px solid transparent;
    border-top: 8px solid #2a2c2f;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
  }
  .testrecord .tbl-list.type2 table tr.tr__click td.d-sm-block.firstline p.w85p {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    line-height: 20px;
    font-size: 0.875rem;
  }
  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block.firstline p.w85p {
    display: block;
  }
  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block {
    display: block !important;
    font-size: 0.875rem;
    color: #003876;
    font-weight: 500;
    padding-top: 0;
  }
  .testrecord .tbl-list.type2 table tr.tr__click.open {
    position: relative;
  }
  .testrecord .tbl-list.type2 table tr.tr__click.open::before {
    content: "";
    position: absolute;
    width: 4px;
    height: 100%;
    background: #0a78ff;
  }
  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block span {
    margin-left: 22.5%;
    display: flex;
  }
  .testrecord .tbl-list tbody tr.tr__click {
    display: flex;
    flex-direction: column;
  }
  .testrecord .tbl-list.type2 table thead th.d-sm-block {
    display: flex !important;
    align-items: center;
    padding: 0 16px;
    height: 36px;
  }
  .tbl-list.type2 table td,
  .tabcontent .tbl-list.type2 table td {
    padding: 15px 16px;
    min-height: auto;
    font-size: 0.812rem;
  }
  .testrecord .tbl-list.type2 table th.d-sm-block span:first-child {
    display: flex;
    align-items: center;
  }
  .testrecord .tbl-list.type2 table th.d-sm-block span:first-child:before {
    content: "";
    width: 0;
    height: 0;
    border-bottom: 5px solid transparent;
    border-top: 5px solid transparent;
    border-left: 8px solid #909fb7;
    border-right: 8px solid transparent;
  }
  .testrecord .tbl-list.type2 table tbody tr.tr__click td:first-child span {
    float: left;
    margin-right: 20px;
  }
  .testrecord .tbl-list.type2 table td:first-child span::before {
    margin-left: 0;
    margin-right: 15px;
  }
  .testrecord .tbl-list.type2 table td:first-child span.d-sm-block::before {
    content: none !important;
  }
  .tbl-list.type2 tbody tr.open td:first-child:before {
    margin: -15px -16px;
    height: 46px;
  }
  .tbl-list.type2 table tr.open td:first-child span::before {
    margin-left: 0;
    margin-right: 15px;
  }
  .tabcontent .tbl-list.type2 table th {
    padding: 10px 16px;
  }
  /*노후교체요청*/
  .tabcontent .changeold .tbl-list table th.d-lm-none.d-sm-none,
  .tabcontent .changeold .tbl-list table td.d-lm-none.d-sm-none {
    display: none !important;
  }
  .tabcontent .changeold .tbl-list table th.d-sm-none,
  .tabcontent .changeold .tbl-list table td.d-sm-none {
    display: table-cell !important;
  }
}

@media screen and (max-width: 975px) {
  .devicetype {
    display: none;
  }
  .devicetype.mySwiper2 {
    display: block;
    overflow: hidden;
  }
  .devicetype .swiper-wrapper.errorpoint {
    height: 85px;
  }
  .devicetype .swiper-wrapper.errorpoint .input-errortxt {
    top: 4.3rem;
  }
  .popup-boxin .page-detail {
    left: 15%;
    width: 70%;
  }
}

@media screen and (max-width: 900px) {
  .d-sm-block-toggle.on {
    display: block;
  }
  .tbl__top .btn-search.on {
    background-color: #0a78ff;
  }
  .tbl__top .btn-search.on.active,
  .tbl__top .btn-search.on:hover {
    background-color: #003876 !important;
  }
  .tbl__top input[type="text"].d-sm-block-toggle.on + .btn-delete {
    display: none;
  }
  .tbl__top input[type="text"].d-sm-block-toggle.on + .btn-delete.active {
    display: block;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_62___}) no-repeat center center;
    background-size: 14px 14px;
    width: 40px;
    height: 32px;
    z-index: 2;
    position: absolute;
    right: 57px;
  }
  .tbl__top .right {
    width: 100%;
  }
  .tbl__top .left + .right {
    width: auto;
  }
  .tbl__top .left + .right .searcharea {
    width: auto;
  }
  .tbl__top .left + .right .searcharea input[type="text"] {
    width: 174px;
  }
  .popup-boxin .page-detail.w400 {
    left: 17%;
  }
  .checkstatus-box + .tbl__top .right .searcharea {
    justify-content: flex-end;
  }
  .checkstatus-box + .tbl__top .right .searcharea input[type="text"] {
    width: auto;
  }
  .box.list .box__body .checkstatus-box + .tbl__top .right .searchinput {
    display: flex;
  }

  /* workorder-점검출동 */
  .box.list .box__body .checkstatus-box + .tbl__top .right .btn-search {
    width: 96px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) no-repeat 20px center #909fb7;
    background-size: 16px;
  }
  .box.list .box__body .checkstatus-box + .tbl__top .right .btn-search span {
    display: block;
  }
}
@media screen and (max-width: 884px) {
  .admin-site.layout-w3 .tbl-list table th.d-sm-none,
  .admin-site.layout-w3 .tbl-list table td.d-sm-none {
    display: none !important;
  }
}
@media screen and (max-width: 870px) {
  .tbl-list.type3 td ul li.address {
    display: block;
    max-width: 260px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .admin-site .tabcontent.layout-w2 .area__right_content.workplace__info {
    overflow-x: auto;
  }
  .admin-site .tabcontent.layout-w2 .area__right_content.workplace__info::-webkit-scrollbar {
    height: 10px;
  }
  .admin-site .tabcontent.layout-w2 .area__left {
    height: auto;
  }
  .area__left.only-depth2 + .area__right .checkstatus-box li div a {
    width: 80px;
  }
}
@media screen and (max-width: 850px) {
  .tbl-list.hcal-96 table td .ellipsis,
  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {
    width: 100%;
    max-width: 70px !important;
  }
}
@media screen and (max-width: 830px) {
  .popup-boxin .page-detail.w400 {
    left: 14%;
  }
  /* .ehc__selectbtn button:hover {
    background-color: transparent;
  } */
  .content__info .drag__right__list .filelist-case li,
  .content__info .drag__right__list .filelist-case li:first-child {
    flex-direction: column;
    margin-bottom: 29px;
  }
  .filelist-case div {
    margin-left: 26px;
    margin-top: 10px;
  }

  /* 운영관리 컨텐츠 영역_사업장 신규입력 : 디자인 변경 */
  .newtype .content__info ul.form__input .input__area {
    width: 280px;
  }

  .admin-site .tabcontent.layout-w2 .area__right_content .content__info ul li .result__score p.tit.caution::after {
    margin-left: 95px;
  }

  /* workorder-점검출동 팝업 */
  .checkstatus-box li div a {
    width: 68px;
    padding: 9px 10px 12px 8px;
  }
  .checkstatus-box li div p:first-child {
    font-size: 14px;
  }
  .checkstatus-box li div p:last-child {
    font-size: 12px;
  }
  .checkstatus-box li div p strong {
    font-size: 24px;
  }
}
@media screen and (max-width: 790px) {
  .popup-boxin .page-detail.w400 {
    left: 11%;
  }
}
@media screen and (min-width: 500px) and (max-width: 768px) {
  header {
    height: 3.75rem;
  }
  .popup-boxin .page-detail.w400 {
    left: 9%;
  }
}
@media screen and (max-width: 767px) {
  .navbar {
    top: 6.25rem;
  }
  .navbar__menu {
    left: -100%;
    width: 100%;
    top: 6.25rem;
    height: calc(100% - 6rem);
  }
  .navbar__toggleBtn {
    width: 2.5rem;
    height: 2.5rem;
  }
  .container.filereports .content {
    grid-template-rows: repeat(2, minmax(auto, auto));
  }
  .box.on .box__setting {
    border: 2px solid #0a78ff;
    width: calc(100% - 4px);
    height: calc(100% - 4px);
  }
  .ehc__score .tbl__bottom .btn__wrap button {
    min-width: 120px;
    width: auto;
    padding: 0 17px;
  }
  .ehc__score .tbl__bottom .btn__wrap button:nth-child(2) {
    margin-right: 41%;
  }
  .ehc__score .tbl__bottom ul.btn__wrap li:nth-child(2) {
    margin-right: 37%;
  }
  .ehc__score .tbl__bottom ul.btn__wrap li:nth-child(2) button {
    min-width: 160px;
    padding: 0;
  }

  .swiper-section {
    display: none;
  }
  .d-sm-tab {
    display: block;
  }
  .no-responsive .tabcontent .search {
    display: flex;
  }
  .tabcontent .search {
    display: none;
  }
  .tabcontent__top {
    margin-top: 2.5rem;
    margin-bottom: 1.75rem;
  }
  /* .tabcontent .tbl-list table th.d-sm-none,
  .tabcontent .tbl-list table td.d-sm-none {
    display: none !important;
  } */
  .box.list .box__body .tbl-list {
    height: auto;
    max-height: unset;
    overflow-y: hidden;
  }
  .admin-site .tbl-list.td-h32 table td {
    height: 22px;
  }
  .popup-layer.page-report .form__input.d-sm-block {
    display: block !important;
  }

  #wrap:not(.no-responsive) .container:not(.no-responsive) .tbl__bottom,
  .popup-layer .tbl__bottom {
    justify-content: flex-start;
    margin: 24px 0;
    flex-wrap: wrap;
  }
  #wrap:not(.no-responsive) .container:not(.no-responsive) .paging,
  .popup-layer .paging {
    width: 100%;
    justify-content: center;
    margin-top: 24px;
  }
  #wrap:not(.no-responsive) .container:not(.no-responsive) .paging__select,
  .popup-layer .paging__select {
    display: none;
  }
  #wrap:not(.no-responsive) .container:not(.no-responsive) .paging ul,
  .popup-layer .paging ul {
    margin-left: 0;
  }
  /* #wrap:not(.no-responsive) .container:not(.no-responsive) .paging li,
  .popup-layer .paging li {
    min-width: auto;
    width: 27px;
    height: 27px;
  } */
  /* #wrap:not(.no-responsive) .container:not(.no-responsive) .paging .btn-prev.disabled,
  #wrap:not(.no-responsive) .container:not(.no-responsive) .paging .btn-next.disabled,
  .popup-layer .paging .btn-prev.disabled,
  .popup-layer .paging .btn-next.disabled {
    background: url('../img/icon_next_m_dis.png') no-repeat center center #fff;
  }
  #wrap:not(.no-responsive) .container:not(.no-responsive) .paging .btn-prev,
  #wrap:not(.no-responsive) .container:not(.no-responsive) .paging .btn-next,
  .popup-layer .paging .btn-prev,
  .popup-layer .paging .btn-next {
    width: 28px;
    background: url('../img/icon_next_m.png') no-repeat center center #fff;
    border: 0;
    margin: 0;
  } */
  #wrap:not(.no-responsive) .container:not(.no-responsive) .paging .btn-first,
  #wrap:not(.no-responsive) .container:not(.no-responsive) .paging .btn-last,
  .popup-layer .paging .btn-first,
  .popup-layer .paging .btn-last {
    display: none;
  }
  #wrap:not(.no-responsive) .container:not(.no-responsive) .paging li > a,
  .popup-layer .paging li > a {
    font-size: 0.875rem;
  }
  #wrap:not(.no-responsive) .container:not(.no-responsive) .paging li > a.active,
  .popup-layer .paging li > a.active {
    height: 100%;
    border-top: 1px solid #909fb7;
    border-bottom: 1px solid #909fb7;
  }
  /* #wrap:not(.no-responsive) .container:not(.no-responsive) .paging li.btn-prev + li,
  .popup-layer .paging li.btn-prev + li {
    border: none;
  } */
  .paging .btn-prev {
    margin-right: 16px;
  }
  .paging .btn-next {
    margin-left: 16px;
  }
  .result__num.d-mm-none {
    display: none !important;
  }
  .result__num.d-mm-block {
    display: block !important;
  }
  .popup-boxin .page-detail.w400 {
    left: 22%;
  }
  .tabcontent__title {
    margin-top: 0;
  }
  .search__inline .search-small {
    margin-right: calc(100% - 174px);
  }
  .search__inline .btn.btn-filedown,
  .search__inline .btn-qr.btn-basic {
    display: none;
  }
  /* .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block.firstline::before {
    content: none;
  }
  .testrecord .tbl-list.type2 table tr.tr__click td.d-sm-block.firstline {
    display: flex !important;
    align-items: flex-start;
    padding-top: 15px;
  }
  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block.firstline {
    display: flex !important;
    padding-top: 15px;
    color: #0a78ff;
  }
  .testrecord .tbl-list.type2 table tr.tr__click td.d-sm-block.firstline span.w25p {
    position: relative;
    display: flex;
    align-items: center;
  }
  .testrecord .tbl-list.type2 table tr.tr__click td.d-sm-block.firstline span.w25p::before {
    content: "";
    width: 0;
    height: 0;
    border-bottom: 5px solid transparent;
    border-top: 5px solid transparent;
    border-left: 8px solid #909fb7;
    border-right: 8px solid transparent;
  }
  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block.firstline span.w25p {
    margin-left: 0;
  }
  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block.firstline span.w25p::before {
    content: "";
    margin-left: -1px;
    margin-right: 8px;
    margin-bottom: -10px;
    width: 0;
    height: 0;
    border-bottom: 8px solid transparent;
    border-top: 8px solid #2a2c2f;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
  }
  .testrecord .tbl-list.type2 table tr.tr__click td.d-sm-block.firstline p.w85p {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 20px;
  }
  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block.firstline p.w85p {
    display: block;
  }
  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block {
    display: block !important;
    font-size: 0.812rem;
    color: #003876;
    font-weight: 500;
    padding-top: 0;
  }
  .testrecord .tbl-list.type2 table tr.tr__click.open {
    position: relative;
  }
  .testrecord .tbl-list.type2 table tr.tr__click.open::before {
    content: "";
    position: absolute;
    width: 4px;
    height: 100%;
    background: #0a78ff;
  }
  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block span {
    margin-left: 25%;
    display: flex;
  }
  .testrecord .tbl-list tbody tr.tr__click {
    display: flex;
    flex-direction: column;
  }
  .testrecord .tbl-list.type2 table thead th.d-sm-block {
    display: flex !important;
    align-items: center;
    padding: 0 16px;
    height: 36px;
  }
  .tbl-list.type2 table td,
  .tabcontent .tbl-list.type2 table td {
    padding: 15px 16px;
    min-height: auto;
    font-size: 0.812rem;
  }
  .testrecord .tbl-list.type2 table th.d-sm-block span:first-child {
    display: flex;
    align-items: center;
  }
  .testrecord .tbl-list.type2 table th.d-sm-block span:first-child:before {
    content: "";
    width: 0;
    height: 0;
    border-bottom: 5px solid transparent;
    border-top: 5px solid transparent;
    border-left: 8px solid #909fb7;
    border-right: 8px solid transparent;
  }
  .testrecord .tbl-list.type2 table tbody tr.tr__click td:first-child span {
    float: left;
    margin-right: 20px;
  }
  .testrecord .tbl-list.type2 table td:first-child span::before {
    margin-left: 0;
    margin-right: 15px;
  }
  .testrecord .tbl-list.type2 table td:first-child span.d-sm-block::before {
    content: none !important;
  }
  .tbl-list.type2 tbody tr.open td:first-child:before {
    margin: -15px -16px;
    height: 46px;
  }
  .tbl-list.type2 table tr.open td:first-child span::before {
    margin-left: 0;
    margin-right: 15px;
  }
  .tabcontent .tbl-list.type2 table th {
    padding: 10px 16px;
  } */
  .testrecord .tbl-list.type2 table tr.tr__click td.d-sm-block.firstline span.w25p,
  .testrecord .tbl-list.type2 table thead th.d-sm-block span.w25p {
    width: 30% !important;
  }
  .testrecord .tbl-list.type2 table tr.tr__click td.d-sm-block.firstline p.w85p,
  .testrecord .tbl-list.type2 table thead th.d-sm-block span.w85p {
    width: 70% !important;
    -webkit-line-clamp: 2;
  }
  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block span {
    margin-left: 29.5%;
  }
  .tr__detail .tbl-list.type2 {
    margin-left: 0;
  }
  .tr__detail .tbl-list.type2 th {
    display: none;
  }
  .tbl-list.type2 table tbody .tr__detail td {
    padding: 0 0 0 8px;
  }
  .tbl-list.type2 table tbody .tr__detail td .tbl-list.type2 table tbody td {
    padding: 14px 20px;
  }
  .tabcontent .tbl-list table .tr__detail .tbl-list.type2 thead,
  .tabcontent .tbl-list table .tr__detail .tbl-list.type2 tbody tr td.d-sm-none {
    display: none !important;
  }
  .testrecord .tbl-list.type2 table tbody .tr__detail td .tbl-list.type2 table tbody td.d-sm-block {
    display: block !important;
    padding: 14px 34px 14px 28px;
  }
  .tbl-list.type2 table tbody .tr__detail td .tbl-list.type2 table tbody td .btn-file {
    width: 24px;
    height: 24px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_33___}) no-repeat center center;
    background-size: 100%;
  }
  .tr__detail .tbl-list.type2 tbody tr td.btn__tdarea:hover,
  .tr__detail .tbl-list.type2 tbody tr td.btn__tdarea:active {
    background: #f0f2f4;
    cursor: pointer;
  }
  .tr__detail .tbl-list.type2 tbody tr td.btn__tdarea .btn-file:hover,
  .tr__detail .tbl-list.type2 tbody tr td.btn__tdarea .btn-file:active {
    filter: none;
  }
  .tr__detail .tbl-list.type2 tbody tr:nth-child(even) td.btn__tdarea:hover,
  .tr__detail .tbl-list.type2 tbody tr:nth-child(even) td.btn__tdarea:active {
    background: #dde2e9;
  }
  .tbl-list.type2 table .tr__detail td:first-child span::before {
    content: none;
  }
  .tbl-list.type2 table .tr__detail td.d-sm-block span:first-child {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
  }
  .tbl-list.type2 table .tr__detail td.d-sm-block span:last-child {
    font-weight: 400;
    font-size: 13px;
    margin-top: 12px;
  }
  .container.admin-site {
    min-height: calc(100vh - 7.3rem);
  }
  .admin-site .box.list .box__body {
    height: auto;
    padding-top: 0;
  }
  .admin-site .area__left {
    width: 100%;
    border-right: 0;
  }
  .admin-site .area__right {
    display: none;
  }
  .admin-site.no-responsive .area__right {
    display: block;
  }
  .admin-site .tbl-list table td {
    height: 22px;
  }
  .admin-site .tabcontent .lnb {
    margin: 0 8px;
    max-height: unset;
    height: calc(100vh - 237px);
  }
  .admin-site .tabcontent .lnb ul.lnb-depth1 {
    border-bottom: 1px solid #dde2e9;
  }
  .popup-layer.page-workplace {
    margin-top: 49px;
    width: calc(100% - 24px);
    height: calc(100vh - 136px);
  }
  .popup-layer.page-workplace.page-detail .popup__head {
    flex-direction: column-reverse;
    padding-top: 13px;
    padding-bottom: 32px;
    padding-right: 13px;
    width: calc(100% - 29px);
  }
  .popup-layer.page-workplace.page-detail .popup__head h1 {
    text-align: left;
    width: 100%;
    font-size: 15px;
  }
  .popup-layer.page-workplace.page-detail .popup__head .btn-close {
    width: 100%;
    background-position: right center;
  }
  .popup-layer.page-workplace.page-detail .popup__body {
    max-height: calc(100% - 95px);
    overflow-y: hidden;
  }
  .popup-layer.page-workplace.page-detail .popup__body .area__right_content .searcharea {
    margin-bottom: 32px;
  }
  .tbl-list.type3.w800 {
    max-height: calc(100vh - 340px);
  }
  .popup-layer.page-workplace.page-detail .popup__body .area__right_content .searcharea .searchinput {
    width: 100%;
  }
  .popup-layer.page-workplace.page-detail .popup__body .area__right_content .searcharea .btn-search {
    width: 32px;
    background-position: center;
  }
  .popup-layer.page-workplace.page-detail .popup__body .area__right_content .searcharea .btn-search span {
    display: none;
  }
  .popup-layer.page-workplace.page-detail .popup__body .area__right_content .searcharea .input__direct {
    width: calc(100% - 40px);
  }
  .popup-layer.page-workplace.page-detail
    .popup__body
    .area__right_content
    .searcharea
    .input__direct
    input[type="text"] {
    width: calc(100% - 54px) !important;
    padding-right: 40px;
  }
  .popup-layer.page-workplace.page-info {
    margin-top: 49px;
    width: calc(100% - 18px);
  }
  .popup-layer.page-workplace.page-detail.page-info .popup__body {
    overflow-x: hidden;
  }
  .popup-layer.page-workplace.page-info .area__right_content.workplace__info {
    height: calc(100vh - 265px);
    overflow-y: auto;
  }
  .popup-layer.page-workplace.page-detail.page-info .popup__head {
    padding: 0;
    border-bottom: 0;
  }
  .popup-layer.page-workplace.page-detail.page-info .popup__head .btn-close {
    z-index: 3;
    position: absolute;
    right: 12px;
    top: 10px;
    width: 1rem;
  }
  .popup-layer.page-workplace.page-detail.page-info .popup__body {
    max-height: 100%;
  }
  .popup-layer.page-workplace.page-detail.page-info .page-loca {
    position: relative;
    z-index: 2;
    padding: 13px 16px;
    margin-bottom: 20px;
  }
  .popup-layer.page-workplace.page-detail.page-info .page-loca li {
    font-size: 13px;
  }
  .popup-layer.page-workplace.page-detail.page-info .page-top {
    margin-bottom: 42px;
  }
  .popup-layer.page-workplace.page-detail.page-info .page-top h2 {
    font-weight: 700;
    font-size: 20px;
    line-height: 29px;
    color: #2a2c2f;
  }
  .popup-layer.page-workplace.page-detail.page-info .page-top .top-button button {
    width: 28px;
    height: 28px;
  }
  .popup-layer.page-workplace.page-detail.page-info .page-top .top-button button + button {
    margin-left: 8px;
  }
  .popup-layer.page-workplace.page-detail.page-info .area__right_content.workplace__info .content__info {
    padding: 0 16px;
    width: calc(100% - 32px);
    height: auto;
  }
  .popup-layer.page-workplace.page-detail.page-list-view .popup__head {
    padding-bottom: 1rem;
    padding-top: 13px;
    padding-left: 1rem;
  }
  .popup-layer.page-workplace.page-detail.page-list-view .popup__head h1 {
    font-size: 20px;
    margin-top: 16px;
    margin-bottom: 16px;
  }
  .popup-layer.page-workplace.page-detail.page-info.page-list-view .area__right_content.workplace__info .content__info {
    padding: 0;
  }
  .popup-layer.page-workplace.page-detail.page-info .content__info ul li {
    flex-direction: column;
    margin-bottom: 1rem;
  }
  .popup-layer.page-workplace.page-detail.page-info .content__info ul li p {
    font-size: 14px;
    width: 100%;
  }
  .popup-layer.page-workplace.page-detail.page-info .content__info ul li:first-child p.txt.treeon,
  .popup-layer.page-workplace.page-detail.page-info .content__info ul li:first-child p.txt.treeoff {
    width: 64px;
  }
  .popup-layer.page-workplace.page-detail.page-info .content__info ul li p.tit {
    margin-top: 0;
    margin-bottom: 8px;
  }
  .popup-layer.page-workplace.page-detail.page-info .content__info ul.filelist.down li,
  .popup-layer.page-workplace.page-detail.page-info .content__info ul.filelist li {
    flex-direction: row;
  }
  .popup-layer.page-workplace.page-detail.page-info .content__info ul.filelist::not(.down) li span {
    line-height: 21px;
  }
  .popup-layer.page-workplace.page-detail.page-info .area__right_content.workplace__info .content__list {
    padding: 34px 16px;
    width: calc(100% - 32px);
  }
  .popup-layer.page-workplace .area__right_content.workplace__info .content__info ul li p.tit span {
    display: inline-block;
    margin: 0 0 0 1px;
  }
  .popup-layer.page-workplace .info__input {
    height: calc(100vh - 265px);
    overflow-y: auto;
  }
  .popup-layer.page-workplace
    .area__right_content.workplace__info
    .content__info
    .area__right_content.workplace__info
    .content__info {
    padding: 0 24px;
    width: calc(100% - 48px);
  }
  .popup-layer.page-workplace.page-detail .popup__body {
    max-height: 100%;
    overflow-x: hidden;
  }
  .popup-layer.page-workplace.info__input .area__right_content.workplace__info {
    height: calc(100vh - 265px);
    overflow-y: auto;
  }
  .popup-layer.page-workplace .area__right_content.workplace__info .content__info ul.form__input .input__area {
    width: 100%;
  }
  .popup-layer.page-workplace .area__right_content.workplace__info .content__info ul.form__input li {
    flex-direction: column;
    margin-top: 0;
  }
  .popup-layer.page-workplace .area__right_content.workplace__info .content__info ul.form__input li p.tit {
    width: 100%;
    margin: 0 0 8px;
  }
  .popup-layer.page-workplace .area__right_content.workplace__info .content__info ul.form__input li textarea {
    height: 106px;
  }
  .popup-layer.page-workplace .area__right_content.workplace__info .content__info ul.form__input li input[type="text"],
  .popup-layer.page-workplace
    .area__right_content.workplace__info
    .content__info
    ul.form__input
    li
    input[type="password"],
  .popup-layer.page-workplace .area__right_content.workplace__info .content__info ul.form__input li input[type="tel"],
  .popup-layer.page-workplace .area__right_content.workplace__info .content__info ul.form__input li input[type="file"] {
    height: 40px;
    font-size: 1rem;
  }
  .popup-layer.page-workplace .area__right_content.workplace__info .btn__wrap {
    justify-content: center;
    margin-right: 0;
    margin-bottom: 80px;
  }
  .popup-layer.page-workplace.page-list-in .area__right_content.workplace__info .btn__wrap,
  .popup-layer.page-workplace.page-list-view .area__right_content.workplace__info .btn__wrap {
    margin-bottom: 0;
  }
  .popup-layer .popup__body .form__input .filebox label {
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    color: #fff;
    vertical-align: middle;
    cursor: pointer;
    height: 100%;
    width: 32px !important;
    border-radius: 4px 0 0 4px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_63___}) no-repeat center center #a4b0c4;
    background-size: 0.563rem 1.087rem;
  }
  .popup-layer.page-workplace .area__right_content.workplace__info .content__info ul.form__input li .filelist li {
    flex-direction: row;
  }
  .popup-layer.page-list .area__right_content.workplace__info .tab__small {
    margin-bottom: 8px;
  }
  .popup-layer.page-workplace.page-detail.page-info.page-list .page-top {
    margin-bottom: 24px;
  }
  .popup-layer.page-workplace .mySwiper2 {
    margin-top: 8px;
  }
  .popup-layer.page-workplace .btn-scan {
    height: 42px;
  }
  .popup-layer.page-workplace .btn-scan span {
    font-size: 14px;
  }
  .popup-layer.page-workplace.page-info.page-list .area__right_content.workplace__info {
    padding: 0 1rem;
  }
  .popup-layer.page-workplace.page-info.page-list .search-small.mb-16 {
    margin-bottom: 12px !important;
  }
  .popup-layer.page-workplace.page-detail.page-list .popup__body .area__right_content .searcharea {
    margin-bottom: 0;
  }
  .popup-layer.page-list .tbl-list table {
    border-bottom: 1px solid #dde2e9;
  }
  .popup-layer.page-list .tbl-list table td,
  .popup-layer.page-list .tabcontent .tbl-list table td {
    padding: 22px 17px;
  }
  .popup-layer.page-list .tbl-list table th {
    padding: 10px 15px;
  }
  .popup-layer.page-list .tbl-list.hcal-96 {
    height: auto !important;
  }
  .popup-layer.page-workplace .drag__area .filebox-upload {
    flex-direction: column;
    align-items: flex-start;
  }
  .popup-layer.page-workplace .drag__area .filebox-upload .filebox {
    margin-top: 10px;
    width: 100%;
  }
  .popup-layer.page-workplace .drag__area .filebox-upload .filebox label {
    width: 100%;
  }
  .popup-layer.page-workplace .drag__area .filebox-upload .flielist__upload {
    margin-top: 12px;
    width: 100%;
  }
  .popup-layer.page-workplace .drag__area .drag__left .filebox-upload .filelist {
    width: calc(100% - 100px);
  }
  .popup-layer.page-workplace .content__info .drag__right__list li:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
  }
  .tbl-list.type5 {
    margin-top: 2px;
    max-height: calc(100vh - 415px);
    border-bottom: 0;
  }
  .tbl-list.type5 table tbody td {
    padding: 14px 34px 14px 28px;
    background: #fafafa;
  }
  .tbl-list.type5 table tbody td:first-child {
    display: flex;
    flex-direction: column;
  }
  .tbl-list.type5 table td span:first-child {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
  }
  .tbl-list.type5 table td span:last-child {
    font-weight: 400;
    font-size: 13px;
    margin-top: 12px;
  }
  .tbl-list.type5 table tbody td .btn-file {
    width: 24px;
    height: 24px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_33___}) no-repeat center center;
    background-size: 100%;
  }
  .tbl-list.type5 tbody tr td.btn__tdarea:hover,
  .tbl-list.type5 tbody tr td.btn__tdarea:active {
    background: #f0f2f4;
    cursor: pointer;
  }
  .tbl-list.type5 tbody tr td.btn__tdarea .btn-file:hover,
  .tbl-list.type5 tbody tr td.btn__tdarea .btn-file:active {
    filter: none;
  }
  .tbl-list.type5 tbody tr:nth-child(even) td.btn__tdarea:hover,
  .tbl-list.type5 tbody tr:nth-child(even) td.btn__tdarea:active {
    background: #dde2e9;
  }
  .admin-site.layout-w3 .page-top {
    padding: 20px 0;
  }
  .admin-site.layout-w3 .area__left {
    margin-top: 20px;
  }
  .admin-site.layout-w3 .area__right {
    display: block;
  }
  .admin-site.layout-w3 .area__left_content.detail__view.on,
  .admin-site.layout-w3 .area__right_content.detail__view.on {
    margin-top: 4px;
  }
  .admin-site.layout-w3 .area__left .tbl__bottom,
  .admin-site.layout-w3 .area__right-end .tbl__bottom,
  .admin-site.layout-w3 .area__right .tbl__bottom.mt-48 {
    margin: 16px 0 40px !important;
  }
  .admin-site.layout-w3 .area__left .tbl__bottom .paging,
  .admin-site.layout-w3 .area__right-end .tbl__bottom .paging {
    justify-content: flex-start;
    width: auto;
  }
  .admin-site.layout-w3 .area__left .tbl__bottom .paging ul,
  .admin-site.layout-w3 .area__right-end .tbl__bottom .paging ul {
    margin-left: 1.25rem;
  }
  .admin-site.layout-w3 .tbl__bottom .paging__select {
    display: none;
  }
  .workplace-ok.page-detail {
    width: calc(100% - 24px);
    margin-top: 49px;
    height: calc(100vh - 136px);
  }
  .workplace-ok.page-detail .popup__head {
    flex-direction: column-reverse;
    align-items: flex-start;
    justify-content: space-between;
    border-bottom: 0;
  }
  .workplace-ok.page-detail .popup__head h1 {
    margin-top: 4px;
  }
  .workplace-ok.page-detail .popup__head .btn-close {
    width: 100%;
    background-position: right center;
  }
  .workplace-ok.page-detail .popup__body {
    padding: 16px;
    margin: 0 0 8px;
    width: calc(100% - 2rem);
    max-height: calc(100% - 172px);
    height: auto;
  }
  .workplace-ok.page-detail .img_workplace {
    margin-top: -495px;
  }
  .workplace-ok.page-detail .workplace__info .txt_workplace ul {
    margin-top: 280px;
  }
  .workplace-ok.page-detail .workplace__info .txt_workplace ul li {
    flex-direction: column;
  }
  .workplace-ok.page-detail .workplace__info .txt_workplace ul li p.txt {
    margin-top: 10px;
  }
  .workplace-ok.page-detail .popup__footer {
    border-top: 0;
    padding-top: 0;
  }

  .userjoin-ok.page-detail {
    width: calc(100% - 24px);
    margin-top: 49px;
    height: calc(100vh - 136px);
  }
  .userjoin-ok.page-detail .popup__head {
    flex-direction: column-reverse;
    align-items: flex-start;
    justify-content: space-between;
    border-bottom: 0;
  }
  .userjoin-ok.page-detail .popup__head h1 {
    margin-top: 4px;
  }
  .userjoin-ok.page-detail .popup__head .btn-close {
    width: 100%;
    background-position: right center;
  }
  .userjoin-ok.page-detail .popup__body {
    padding: 16px;
    margin: 0 0 8px;
    width: calc(100% - 2rem);
    max-height: calc(100% - 172px);
    height: auto;
  }
  .userjoin-ok.page-detail .popup__body .form__input li {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 16px;
    margin-top: 0;
  }
  .userjoin-ok.page-detail .popup__body .form__input .tit {
    font-size: 14px;
    margin-bottom: 8px;
    width: 100%;
  }
  .userjoin-ok.page-detail .popup__body .form__input li.inline {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 24px;
  }
  .userjoin-ok.page-detail .popup__body .form__input li.inline .tit {
    width: auto;
  }
  .userjoin-ok.page-detail .popup__body .form__input input[type="text"],
  .userjoin-ok.page-detail .popup__body .form__input input[type="password"],
  .userjoin-ok.page-detail .popup__body .form__input input[type="tel"],
  .userjoin-ok.page-detail .popup__body .form__input input[type="file"] {
    height: 42px;
  }
  .userjoin-ok.page-detail .popup__body .form__input .input__area {
    width: 100%;
  }
  .userjoin-ok.page-detail .popup__body .form__input .tbl-list.type2.mt-m10 {
    margin-top: 0 !important;
  }
  .userjoin-ok.page-detail .popup__body .right {
    margin-top: 30px;
  }
  .userjoin-ok.page-detail .popup__footer {
    border-top: 0;
    padding-top: 0;
  }
  .userjoin-ok.page-detail .popup__body .form__input button.btn-basic.d-sm-none {
    display: none;
  }
  .userjoin-ok.page-detail .popup__body .form__input button.btn-basic.d-sm-block {
    display: flex;
  }

  .popup-layer.pop-usertype {
    width: calc(100% - 24px);
    margin-top: 49px;
    height: calc(100vh - 136px);
  }
  .popup-layer.pop-usertype .popup__head {
    flex-direction: column-reverse;
    align-items: flex-start;
    justify-content: space-between;
    border-bottom: 0;
  }
  .popup-layer.pop-usertype .popup__head h1 {
    margin-top: 4px;
  }
  .popup-layer.pop-usertype .popup__head .btn-close {
    width: 100%;
    background-position: right center;
  }
  .popup-layer.pop-usertype .popup__body {
    padding: 16px;
    margin: 0 0 8px;
    width: calc(100% - 2rem);
    max-height: calc(100% - 108px);
    height: auto;
  }
  .popup-layer.pop-usertype .user-info {
    margin-bottom: 40px;
  }
  .popup-layer.pop-usertype .user-info li {
    margin-bottom: 20px;
  }
  .popup-layer.pop-usertype .user-info li p:first-child {
    width: 86px;
    font-size: 14px;
  }
  .popup-layer.pop-usertype .user-info li p:last-child {
    width: calc(100% - 86px);
  }
  .popup-layer.pop-usertype .tbl-list table {
    border-bottom: 1px solid #dde2e9;
  }

  /* 운영관리 컨텐츠 영역_사업장 신규입력 : 디자인 변경 */
  .area__right_content.workplace__info.workplace__main.newtype .content__info {
    display: grid;
  }
  .area__right_content.workplace__info.workplace__main.newtype .content__info h3 {
    font-size: 0.938rem;
    margin-bottom: 1rem;
  }
  .area__right_content.workplace__info.workplace__main.newtype .content__info + .content__info {
    margin-top: 40px;
    padding-top: 40px;
  }
  .newtype .content__info .flex-row .form__input.ml-40 {
    margin-top: 1rem;
  }
  .newtype .column .btn__wrap {
    display: none;
  }
  .admin-site .tabcontent.layout-w2 .newtype .column .btn__wrap {
    display: flex;
  }
  .area__right_content.workplace__info.newtype .btn__wrap {
    margin-top: 40px;
  }
  .newtype .content__info ul.form__info li {
    flex-direction: column;
    margin-bottom: 1rem;
  }
  .newtype .content__info ul.form__info li:last-child {
    margin-bottom: 0;
  }
  .newtype .content__info ul.form__info li p {
    font-size: 14px;
    width: 100%;
  }
  .newtype .content__info ul.form__info li p.tit {
    margin-top: 0;
    margin-bottom: 8px;
  }

  /* 요청반려 사유확인 팝업 */
  .popup-basic.reason {
    width: calc(100% - 4rem);
    height: 450px;
  }
  .popup-basic.reason .popup__body {
    height: 305px;
  }
  .popup-basic.reason .font-16 {
    font-size: 16px !important;
  }
  .popup-basic.reason dl {
    margin: 24px 16px 0;
    width: calc(100% - 32px);
  }
  .popup-basic.reason .page-detail .popup__footer {
    border-top: 0;
  }
  /* workorder-점검출동 */
  .admin-site .area__right.d-sm-block {
    display: block;
  }
  .tabcontent .area__top .search {
    display: flex;
  }
  .area__top + .nodata__txt {
    margin-top: 0px !important;
  }
  .area__top .searchterm .term__month {
    height: 40px;
  }
  .area__top .searchterm .term__month + .term__date {
    display: none;
  }
  .tabcontent .area__top .search .form__input {
    width: 100%;
  }
  .tabcontent .area__top .search .form__input + .btn__wrap {
    display: none;
  }
  .tabcontent .area__top .search .form__input li {
    flex-direction: column;
  }
  .tabcontent .area__top .search .form__input .input__area {
    margin-left: 0 !important;
    margin-top: 8px;
    width: 100%;
  }
  .box.list .box__body .checkstatus-box + .tbl__top .right .searchinput {
    display: none;
  }
  .box.list .box__body .checkstatus-box + .tbl__top .right .btn-search {
    width: 32px;
    background-position: center center;
  }
  .box.list .box__body .checkstatus-box + .tbl__top .right .btn-search span {
    display: none;
  }

  .area__left.only-depth2,
  .area__left.only-depth2.close {
    display: none;
  }
  .admin-site .area__left.only-depth2 + .area__right {
    display: block;
    width: calc(100% - 28px) !important;
    margin-top: -16px;
  }
  .admin-site .area__left.only-depth2 + .area__right .page-loca {
    margin-bottom: 0;
    margin-top: 0;
  }
  .area__left__toggleBtn {
    display: block;
    position: fixed;
    bottom: 1.25rem;
    right: 1.5rem;
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    box-shadow: 2px 4px 8px rgb(2 136 255 / 40%);
    z-index: 20;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_64___}) no-repeat center center #0a78ff;
    background-size: 2rem 2rem;
  }
  .area__left.only-depth2.active {
    display: block;
    position: fixed;
    top: 6.75rem;
    width: 100% !important;
    height: calc(100% - 5.75rem);
    border: 0;
    padding: 0;
    margin: -0.5rem;
    z-index: 100;
  }
  .area__left.only-depth2.active .btn-left {
    display: flex !important;
    width: 1.5rem;
    height: 1.5rem;
    padding: 0;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) no-repeat center center;
  }
  .area__left.only-depth2.active .btn-left::after {
    content: none;
  }
  .area__left.only-depth2.active .lnb {
    display: block;
    max-height: unset;
    height: calc(100% - 63px);
  }
  .area__left.only-depth2.active .lnb .lnb-depth1 {
    border-bottom: 1px solid #dde2e9;
    margin-bottom: 10px;
  }
  .admin-site.workorder .nodata .nodata__txt {
    margin-top: 0;
  }

  /*노후교체요청*/
  .tabcontent .changeold .search {
    display: flex;
  }

  .tabcontent__title .btn-qr {
    display: flex;
  }
  .admin-site .box.list .box__body .tbl-list.hcal-77 {
    height: auto;
  }
  .admin-site .box.list .box__body .tbl-list.hcal-vh-315 {
    height: auto !important;
  }
  .admin-site .box.list .box__body .tbl-list.hcal-vh-415 {
    height: auto !important;
  }
  .admin-site .box.list .box__body .tbl-list.hcal-vh-430 {
    height: auto !important;
  }
  .admin-site .box.list .box__body .tbl-list.hcal-vh-560 {
    height: auto !important;
  }
}
@media screen and (max-width: 700px) {
  .popup-boxin .page-detail.w400 {
    left: 20%;
  }
  /* workorder-점검출동 팝업 */
  .area__left.only-depth2 + .area__right .checkstatus-box li {
    width: calc(100% - 10px);
  }
  .area__left.only-depth2 + .area__right .checkstatus-box li:first-child {
    display: none;
  }
  .area__left.only-depth2 + .area__right .checkstatus-box li + li {
    margin-left: 2px;
    padding-left: 0;
    border-left: 0;
  }
  .area__left.only-depth2 + .area__right .checkstatus-box li + li div {
    width: 25%;
  }
  .area__left.only-depth2 + .area__right .checkstatus-box li div a {
    width: auto;
  }
}
@media screen and (max-width: 650px) {
  /*노후교체요청*/
  .tabcontent .changeold .tbl-list table th.d-sm-none,
  .tabcontent .changeold .tbl-list table td.d-sm-none {
    display: none !important;
  }
}
@media screen and (max-width: 648px) {
  .popup-boxin .page-detail.w400 {
    left: 17%;
  }
}
@media screen and (max-width: 600px) {
  .popup-boxin .page-detail.w400 {
    left: 15%;
  }
  /*사업장추가-이미지크롭 팝업*/
  .popup-basic.imgcrop {
    width: calc(100% - 4rem);
    height: 75vh;
  }

  /* workorder-점검출동 팝업 */
  .checkstatus-box li {
    width: calc(100% - 10px);
  }
  .checkstatus-box li:first-child {
    display: none;
  }
  .checkstatus-box li + li {
    margin-left: 2px;
    padding-left: 0;
    border-left: 0;
  }
  .checkstatus-box li + li div {
    width: 25%;
  }
  .checkstatus-box li div a {
    width: auto;
  }
  /* .checkstatus-box li + li div::before,
  .checkstatus-box li + li div.on::before,
  .checkstatus-box li + li div.end::before,
  .checkstatus-box li + li div.on + div::before {
    content: none;
  }
  .checkstatus-box li + li div:last-child a::after,
  .checkstatus-box li + li div.on::after,
  .checkstatus-box li + li div.end::after,
  .checkstatus-box li + li div::after {
    content: none;
  } */
}

@media screen and (max-width: 560px) {
  .popup-boxin .page-detail.w400 {
    left: 12%;
  }
  /*노후교체요청*/
  .devicenum,
  .devicenum.d-lm-block {
    display: none;
  }
  .btn-basic.down {
    display: none;
  }
}
@media screen and (max-width: 570px) {
  .ehc__score .tbl__bottom .btn__wrap button {
    padding: 0 0.75rem;
  }
  .ehc__score .tbl__bottom ul.btn__wrap li button + button {
    margin-left: 7px;
  }
  .ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-share,
  .ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-reload {
    width: 2.5rem;
    min-width: 2.5rem;
    height: 2.5rem;
    background-position: center;
  }
  .ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-share:hover,
  .ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-reload:hover {
    background-position: center;
  }
  .ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-share span,
  .ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-reload span {
    position: absolute;
    left: -99999px;
    width: 0;
    height: 0;
    font-size: 0;
    line-height: 0;
    text-indent: -9999em;
    overflow: hidden;
    z-index: -1;
  }
  .ehc__score .tbl__bottom ul.btn__wrap li:nth-child(2) {
    margin-right: 32%;
  }
  .ehc__score .tbl__bottom .btn__wrap button:nth-child(2) {
    margin-right: 36.5%;
  }

  /*헤더-My Account 팝업*/
  .popup-basic.myaccount,
  .community .popup-layer.popup-basic.myaccount {
    width: calc(100% - 24px);
    margin-top: 49px;
    height: auto;
  }
  .popup-basic.myaccount .popup__head {
    flex-direction: column-reverse;
    align-items: flex-start;
    justify-content: space-between;
    border-bottom: 0;
  }
  .popup-basic.myaccount .popup__head h1 {
    margin-top: 4px;
  }
  .popup-basic.myaccount .popup__head .btn-close {
    width: 100%;
    background-position: right center;
  }
  .popup-basic.myaccount .popup__body {
    padding: 20px 16px 20px;
    width: calc(100% - 32px);
    min-height: calc(75vh - 11.7rem);
    max-height: calc(75vh - 10rem);
  }
  .popup-basic.myaccount .popup__body .form__input li {
    margin-top: 16px;
  }
  .popup-basic.myaccount .popup__body .form__input label {
    width: 100%;
    font-size: 14px;
  }
  .popup-basic.myaccount .popup__body .form__input input[type="text"],
  .popup-basic.myaccount .popup__body .form__input input[type="password"],
  .popup-basic.myaccount .popup__body .form__input input[type="tel"],
  .popup-basic.myaccount .popup__body .form__input input[type="file"] {
    font-size: 14px;
  }
  .popup-basic.myaccount .input-errortxt {
    font-size: 12px;
  }
  .popup-basic.myaccount .popup__body .form__input .btn-txt {
    margin: 14px 0;
  }
  .popup-basic.myaccount .popup__body .form__input .btn-txt span {
    font-weight: 500;
    font-size: 15px;
  }
  .popup-basic.myaccount .popup__body .form__input .radioBox {
    margin: 12px 0;
  }
  .popup-basic.myaccount .popup__body .form__input .checkBox {
    margin: 26px 17px;
  }
  .popup-basic.myaccount .popup__footer {
    padding: 16px 20px;
    width: calc(100% - 40px);
  }
  .popup-basic.myaccount .popup__footer button.btn-txt {
    width: auto;
    margin-right: 80px;
  }
  .popup-basic.myaccount .popup__footer button.btn-txt span {
    font-weight: 700;
  }
  /*헤더-My Account 팝업 내 비밀번호 변경 팝업*/
  .popup-basic.myaccount.passchange .popup__head {
    flex-direction: row;
    padding-top: 28px;
  }
  .popup-basic.myaccount.passchange .popup__body {
    min-height: calc(75vh - 5.8rem);
  }
}
@media screen and (max-width: 530px) {
  .popup-boxin .page-detail.w400 {
    left: 10%;
  }
}
@media screen and (max-width: 500px) {
  .d-sm-none {
    display: none !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .tbl-list table td.d-sm-block {
    display: table-cell !important;
  }
  .status__data li {
    margin-left: 5px;
    width: calc(100% / 5);
  }
  .status__data li:first-child {
    margin-left: 0;
    width: calc(100% / 5);
  }
  .status__data li:last-child {
    width: calc(100% / 3);
  }
  .status__data li:last-child a {
    width: calc(100% - 4px);
  }
  .status__data li:last-child a:focus {
    width: calc(100% - 4px);
  }
  .status__data li a:focus,
  .status__data li a.on,
  .status__data li a {
    width: calc(100% - 4px);
  }
  .status__data li a {
    height: 128px;
  }
  .status__data li a:focus {
    height: calc(100% - 30px);
  }
  .status__data li a.on {
    height: 126px;
  }
  .status__data li:before {
    content: none;
  }
  .box__setting .form__input .input__area {
    width: 100%;
    margin-top: 8px;
  }
  .box__setting .form__input {
    width: 94%;
  }
  .box__setting .form__input .input__area .select.active ul {
    max-height: 150px;
    overflow-y: auto;
  }
  .ehc__info {
    margin: -1rem;
    width: calc(100% - 2rem);
  }
  .ehc__detail {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
  .ehc__selectbtn {
    margin: 0 0.188rem 50px;
  }
  .ehc__selectbtn button {
    margin-left: 0.5rem;
    max-width: 4rem;
    height: 4rem;
  }
  .ehc__addfile {
    margin-top: -2rem;
  }
  .ehc__rolling {
    margin-bottom: 7rem;
  }
  .ehc__detail .ma__score .ehc__detail .ma__score .score__info li .tit {
    font-size: 0.938rem;
  }
  .ehc__detail .ma__score .score__info li .tit {
    flex-direction: column;
    align-items: flex-start;
  }
  .ehc__detail .ma__score .score__info li .tit span {
    line-height: 1.4;
  }
  .score__info li .tit span + span {
    margin-left: 0;
  }
  .score__info li.disabled .tit::after {
    content: none;
  }
  .score__info li.disabled .tit span:first-child {
    display: flex;
    align-items: center;
  }
  .score__info li.disabled .tit span:first-child::after {
    content: "";
    width: 1rem;
    height: 1rem;
    margin-left: 4px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) no-repeat right center;
  }
  .ehc__detail .result__txt .tit {
    width: 1.667rem;
    height: auto;
  }
  .ehc__detail .result__txt .tit span {
    position: absolute;
    left: -99999px;
    width: 0;
    height: 0;
    font-size: 0;
    line-height: 0;
    text-indent: -9999em;
    overflow: hidden;
    z-index: -1;
  }
  .ehc__detail .result__txt .txt {
    line-height: 22px;
    width: calc(100% - 148px);
    word-break: break-all;
    word-wrap: break-word;
  }
  .ehc__detail .result__txt .score {
    font-size: 50px;
    line-height: 60px;
    margin: 0 20px 0 10px;
  }
  .result__txt {
    align-items: center;
    padding: 5px 22px 22px;
    width: calc(100% - 12px);
  }
  .ma__score {
    margin: 24px 0;
  }
  .ehc__chart {
    margin: 3px 0px 0 2px;
    width: calc(100% - 50px);
    filter: drop-shadow(0px 2px 4px rgba(144, 159, 183, 0.3));
  }
  .score__info li {
    padding: 14px 24px 20px;
  }
  .icon-score li {
    padding: 0;
  }
  .icon-score li:nth-child(1) {
    margin-right: 16px;
    width: 33px;
  }
  .icon-score li:nth-child(7) {
    margin-left: 16px;
    width: 46px;
  }
  .tabcontent .tbl-list table {
    border-bottom: 1px solid #dde2e9 !important;
  }
  .box__setting .popup__footer {
    padding-bottom: 0;
  }
  .popup-boxin .page-detail.w400 {
    left: 12%;
    width: 358px;
  }
  .qr__top {
    width: calc(100% - 40px);
  }
  .qr__box {
    width: 304px;
    height: 304px;
    margin-bottom: 35px;
  }
  .tbl-list.hcal-96 table td .ellipsis,
  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {
    max-width: 290px !important;
  }
  .popup-boxin .page-detail {
    left: 6%;
    width: 88%;
  }
  .popup-boxin .page-detail .popup__body p.tit {
    width: 100%;
    margin-bottom: 8px;
  }
  .popup-boxin .page-detail .popup__body .form__input .input__area {
    width: 100% !important;
  }
  .popup-boxin .popup__body .form__input .input-errortxt {
    top: 42px;
  }
  .popup-layer.pop-smallsearch {
    width: calc(100% - 24px);
  }

  .popup-basic.myaccount .form__input .select.active ul {
    bottom: 40px;
  }
  .search__inline .filter {
    width: 90px;
  }

  /* 요청반려 사유확인 팝업 */
  .popup-basic.reason {
    width: calc(100% - 2rem);
    height: 400px;
  }
  .popup-basic.reason .popup__body {
    height: 255px;
  }
  .nodata .nodata__txt.w800 {
    padding: 40px 0 60px;
  }

  .content__info ul.form__input li .filelist li {
    flex-direction: row;
  }

  /*진단점검 filter, search 팝업*/
  .popup-layer.page-report {
    width: 90%;
  }

  /* workorder-점검출동 팝업 */
  .admin-site .area__left.only-depth2 + .area__right .page-loca {
    margin-bottom: 12px;
  }
  .area__top {
    padding: 0;
    margin: 0 0 24px;
    border: 0;
  }
  .area__top + h2 {
    display: none;
  }
  .checkstatus-box + .tbl__top .right .searcharea input[type="text"] {
    width: calc(100% - 146px);
  }
  .checkstatus-box {
    margin-bottom: 24px;
  }

  /*노후교체요청*/
  .tabcontent .changeold .search {
    display: none;
  }
  .changeold .filter {
    display: block;
    float: none;
    border-right: 0;
  }
  .box.list .box__body .changeold .tbl__top .left .filter span {
    display: block;
    margin: 0;
    font-weight: 700;
    font-size: 16px;
  }
}
@media screen and (max-width: 480px) {
  .tbl-list.hcal-96 table td .ellipsis,
  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {
    max-width: 200px !important;
  }
}
@media screen and (max-width: 499px) {
  .navbar__toggleBtn {
    margin-left: 0.625rem;
  }
}
@media screen and (max-width: 414px) {
  .navbar {
    top: 100px;
  }
  .navbar__menu {
    top: 100px;
    height: calc(100% - 100px);
  }
  .ehc__info ul li span:first-child {
    display: none;
  }
  .tbl__top {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  .tbl__top .left {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
  }
  .tbl__top .right {
    width: 100%;
    align-items: flex-end;
  }
  .tbl__top .left + .right {
    width: 100%;
  }
  .tbl__top .left + .right .searcharea {
    justify-content: flex-end;
  }
  .tbl__top .select,
  .tbl__top input[type="text"] {
    width: 100% !important;
    height: 38px;
  }
  .tbl__top .searcharea .input__direct input[type="text"] {
    width: calc(100% - 54px) !important;
  }
  .tbl__top input[type="checkbox"]:checked + label:after,
  .tbl__top input[type="checkbox"] + label:before {
    width: 1.125rem;
    height: 1.125rem;
  }
  .popup-boxin .page-detail.w400 {
    left: 5%;
    width: 358px;
  }
  .admin-site.layout-w3 .tbl-list table th,
  .admin-site.layout-w3 .tbl-list table td {
    padding: 8px;
  }
  .tbl-list table th.question span:after {
    margin-left: 2px;
  }
  /*노후교체요청*/
  .box.list .box__body .changeold .tbl__top {
    flex-direction: row;
    align-items: center;
  }
  .changeold .tbl__top .left + .right {
    margin-top: 0;
  }
  .changeold .tbl__top .left {
    width: auto;
  }
}
@media screen and (max-width: 390px) {
  .popup-boxin .page-detail.w400 {
    left: 2%;
  }
  .status__data li p.name {
    font-size: 13px;
  }
  .tbl-list.hcal-96 table td .ellipsis,
  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {
    max-width: 170px !important;
  }
}

@media screen and (max-width: 360px) {
  .tbl-list table td.checkdate:after {
    margin-left: 5px;
  }
  .tbl__top input[type="text"].d-sm-block-toggle.on + .btn-delete.active {
    right: 58px;
  }
  .admin-site.layout-w3 .tbl-list table th,
  .admin-site.layout-w3 .tbl-list table td {
    padding: 8px 6px;
  }
  .tabcontent .detail__view .tbl-list table td button {
    min-width: 66px;
  }
  /* .tabcontent .detail__view .tbl-list table td button span {
    font-size: 13px;
  } */

  .nodata .nodata__txt.w800 {
    padding: 20px 0 30px;
  }

  .tbl-list.hcal-96 table td .ellipsis,
  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {
    max-width: 140px !important;
  }
  /* workorder-점검출동 팝업 */
  .checkstatus-box li div a {
    padding: 9px 6px;
  }
  .checkstatus-box li div p strong {
    margin-right: 1px;
    font-size: 20px;
  }
}
@media screen and (max-width: 320px) {
  .status__data li:last-child {
    width: calc(100% / 4);
  }
  .status__data li:last-child a:focus {
    width: 100%;
  }
  .status__data li p.name {
    font-size: 12px;
  }
  .score__info li {
    padding: 14px 15px 20px;
  }
  .icon-score li {
    padding: 0;
  }
  .icon-score li:nth-child(1) {
    margin-right: 10px;
    width: 34px;
  }
  .icon-score li:nth-child(7) {
    margin-left: 10px;
    width: 47px;
  }
  input[type="checkbox"] + label:before,
  .tbl__top input[type="checkbox"]:checked + label:after,
  .tbl__top input[type="checkbox"] + label:before {
    top: 0.125rem;
  }
  .paging {
    justify-content: center;
    width: 100%;
  }
  .paging ul {
    margin: 0;
  }
}

/********************************************************* main 레이아웃 ******************************************************/
.main .container {
  margin: 116px 8px 5px 8px;
  min-height: calc(100% - 224px);
}
.main .content-top {
  position: fixed;
  top: 50px;
  left: 0;
  width: 100%;
  height: 56px;
  background: #ffffff;
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.2);
  z-index: 3;
}
.main .content-top .top-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 16px 0 22px;
}
.main .content-top .top-wrap .left {
  display: flex;
  align-items: center;
  width: 80%;
}
.main .content-top .top-wrap .right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.main .content-top .top-wrap h2 {
  display: flex;
  font-weight: 700;
  font-size: 22px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.main .content-top .top-wrap h2 span + span {
  margin-left: 16px;
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.main .btn-menuopen {
  margin-left: 90px;
  width: 30px;
  height: 30px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_65___}) no-repeat center center;
}
.main .btn-menuopen.active {
  transform: rotate(180deg);
}
.main .content-top .top-wrap .right .btn-pin {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_66___}) no-repeat center center;
}
.main .content-top .top-wrap .right .btn-pin.active {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_67___}) no-repeat center center;
}
.main .content-top .top-wrap .right .btn-pin:hover::before {
  top: 3px;
  right: 26px;
}
.main .content-top .top-wrap .right .btn-edit {
  position: relative;
  width: 24px;
  height: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_68___}) no-repeat center center;
}
.main .content-top .top-wrap .right .btn-edit span {
  display: none;
}
.main .content-top .top-wrap .right .btn-edit:hover::before {
  content: "카드 위치 편집";
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 2px;
  right: 26px;
  width: 88px;
  height: 18px;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #fff;
  background: #646c74;
  border-radius: 10px;
}
.main .content-top .top-wrap .right .btn-edit.active:hover::before {
  right: 55px;
  top: 5px;
}
.main .content-top .top-wrap .right .btn-edit.active {
  width: 48px;
  height: 28px;
  background: #0a78ff;
  border-radius: 4px;
}
.main .content-top .top-wrap .right .btn-edit.active span {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 12px;
  color: #fff;
}
.main .content-top .top-wrap .right button + button {
  margin-left: 8px;
}
.content__dragwrap {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.main .content + .content {
  margin-top: 0.5rem;
}
.main .content {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0;
  grid-gap: unset;
}
.main .content > .box {
  width: 100%;
  height: 475px;
}
.main .content > .box + .box {
  margin-left: 0.5rem;
}
.main .content > .box .box__header {
  height: 45px;
}
.main .content > .box .box__header .box__etc {
  display: flex;
  align-items: center;
}
.main .content > .box .box__body {
  padding: 33px 38px;
  height: calc(100% - 112px);
}
.menu-slide {
  opacity: 0;
  visibility: hidden;
  position: fixed;
  top: 106px;
  left: 0;
  width: 414px;
  height: calc(100vh - 122px);
  padding: 16px 0 0 0;
  z-index: 2;
  background: #fff;
  box-shadow: 0px 2px 10px #909fb7;
}
.menu-slide.open {
  opacity: 1;
  visibility: visible;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}
.menu-slide .lnb {
  max-height: calc(100% - 40px);
  overflow-y: auto;
}
.menu-slide .lnb__top {
  border-bottom: 1px solid #dde2e9;
}
.menu-slide .lnb.nodata {
  height: calc(100% - 56px);
}
.menu-slide .lnb.nodata .nodata_txt {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 14px;
  letter-spacing: -0.4px;
  color: #909fb7;
  line-height: 26px;
}
.menu-slide .lnb-depth1 > li:first-child {
  border-top: 0;
}
.menu-slide .lnb-depth1 > li > p {
  min-height: 58px;
  padding: 0 16px 0 24px;
  width: calc(100% - 40px);
}
.menu-slide .lnb-depth1 > li > p a {
  width: calc(100% - 24px);
}
.menu-slide .lnb-depth1 > li.active p a {
  font-weight: 700;
}
.menu-slide .lnb-depth1 > li.on p::before,
.menu-slide .lnb-depth1 > li.active p::before {
  min-height: 58px;
}
.btn-pin {
  position: relative;
  width: 24px;
  height: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_69___}) no-repeat center center;
}
.btn-pin.blue {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_70___}) no-repeat center center;
}
/* .btn-pin:hover::before {
  content: "메인 대시보드 고정";
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 1px;
  right: 22px;
  width: 109px;
  height: 18px;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #fff;
  background: #646c74;
  border-radius: 10px;
} */

/* 설비수명 */
.tbl-list table td input[type="text"] {
  width: calc(100% - 1.625rem);
  height: 1.875rem;
  padding: 0 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #2a2c2f;
  border: 1px solid #909fb7;
  border-radius: 4px;
}

/* ehc work order */
.content > .box .box__etc .btn-go {
  width: 24px;
  height: 24px;
  margin: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_71___}) no-repeat center center;
  background-size: 100%;
}

/********************************************************* main 컨텐츠 ******************************************************/
/* main 운영 현황 */
.datalist li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #dde2e9;
  padding: 10px 0;
}
.datalist li:first-child {
  padding-top: 0;
}
.datalist li:last-child {
  border-bottom: 0;
}
.datalist li p {
  font-size: 15px;
  letter-spacing: -0.4px;
  color: #909fb7;
}
.datalist li p.tit {
  display: flex;
  align-items: center;
  color: #2a2c2f;
}
.datalist li p strong {
  font-weight: 500;
  font-size: 24px;
  color: #003876;
}
.datalist-small {
  padding: 6px 2px 10px;
}
.datalist-small li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 0;
  padding: 0 0 10px;
}
.datalist-small li p {
  font-size: 13px;
  letter-spacing: -0.4px;
  color: #909fb7;
}
.datalist-small li p.tit {
  color: #2a2c2f;
  font-size: 14px;
}
.datalist-small li p strong {
  font-size: 14px;
  color: #2a2c2f;
  font-weight: 500;
}
.main .box__body button.add__item {
  border-radius: 4px;
  width: 100%;
  padding: 0 10px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_72___}) no-repeat 98% center #e7f2ff;
  background-size: 20px 20px;
}
.main .box__body button.add__item span {
  font-weight: 500;
  font-size: 13px;
  letter-spacing: -0.4px;
  color: #0a78ff;
}
.main .box__body button.add__item span::before {
  content: "";
  margin-right: 10px;
}

/* main e-HC 진행률 */
.main .box__body .top {
  display: flex;
  justify-content: space-between;
}
.main .box__body .top .right.inline {
  width: auto;
}
.main .box__body .top.right {
  justify-content: flex-end;
}
.main .box__body .top .txt {
  font-size: 15px;
  line-height: 14px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.main .box__body .small-tit {
  font-size: 15px;
  color: #2a2c2f;
  letter-spacing: -0.05em;
}
.main .box__body .small-tit.icon-dot {
  display: flex;
}
.main .box__body .small-tit.icon-dot::before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 50px;
  background: #1492c6;
  margin-right: 8px;
  margin-top: 3px;
}
.main .box__body .total-num {
  font-weight: 400;
  font-size: 15px;
  text-align: right;
  color: #909fb7;
  letter-spacing: -1px;
}
.main .box__body .total-num strong {
  font-weight: 500;
  font-size: 20px;
  color: #2a2c2f;
}
.main .box__body .total-num strong.largetxt {
  font-size: 36px;
}
.main .box__body .total-num span {
  font-size: 18px;
  margin-right: 2px;
}
.main .box__body .progress-wrap li {
  display: flex;
  align-items: center;
  margin-bottom: 23px;
}
.main .box__body .progress-wrap li:last-child {
  margin-bottom: 0;
}
.main .box__body .progress-wrap li p {
  font-size: 14px;
  color: #2a2c2f;
}
.main .box__body .progress-wrap li p strong {
  font-weight: 500;
  color: #2a2c2f;
}
.main .box__body .progress-wrap li .tit {
  flex: 1.5;
}
.main .box__body .progress-wrap li .num {
  flex: 1;
  text-align: right;
  color: #909fb7;
}
.main .box__body .progress-wrap li .progress-bar {
  position: relative;
  flex: 4;
}
.progress-bar::before {
  content: "0";
  position: absolute;
  left: 0;
  top: -12px;
  font-size: 10px;
  color: #909fb7;
}
.progress-bar::after {
  content: "100";
  position: absolute;
  right: 0;
  top: -12px;
  font-size: 10px;
  color: #909fb7;
}
.progress-bar {
  width: 100%;
  height: 10px;
  background-color: #e6e9f0;
  font-weight: 600;
  font-size: 0.8rem;
}
.progress-bar .progress {
  height: 10px;
  padding: 0;
  text-align: center;
  background: linear-gradient(270deg, #116aac -7.8%, #1694c7 100%);
  color: #111;
}
.progress-bar:hover .progress {
  background: #1bc7e9;
}
.progress-wrap li .progress-bar .progress .num-detail {
  display: none;
}
.progress-wrap li .progress-bar:hover .progress .num-detail {
  display: block;
  position: absolute;
  top: -30px;
  left: 30%;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  color: #fff;
  background: rgba(42, 44, 47, 0.9);
  background-blend-mode: darken;
  padding: 2px 3px;
}
.progress-bar:hover .progress .num-detail:after {
  content: "";
  position: absolute;
  top: 20px;
  left: 45%;
  border-top: 5px solid rgba(42, 44, 47, 0.9);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 0px solid transparent;
}
.progress-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.progress-circle .percent {
  position: relative;
}
.progress-circle svg {
  position: relative;
  width: 120px;
  height: 120px;
  /*transform: rotate(-90deg);*/
  transform: rotate(-0deg);
}
.progress-circle svg circle {
  width: 100%;
  height: 100%;
  fill: none;
  stroke: #f0f0f0;
  stroke-width: 10;
}
.progress-circle svg circle:last-of-type {
  /*   stroke-dasharray: 350px;
  stroke-dashoffset: calc(350px - (350px * var(--percent)) / 100); */
  stroke: #3498db;
}
.progress-circle .number {
  position: absolute;
  top: 54%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.progress-circle .number p {
  font-weight: 500;
  font-size: 32px;
  color: #2a2c2f;
  text-align: center;
  line-height: 18px;
}
.progress-circle .number p span {
  font-weight: 400;
  font-size: 15px;
  color: #909fb7;
}
.progress-circle .title h2 {
  margin: 25px 0 0;
}
.progress-circle:nth-child(1) svg circle:last-of-type {
  stroke: #0f5fa5;
}
.progresscircle-wrap .progress-circle:hover {
  cursor: pointer;
}
.progresscircle-wrap .progress-circle:hover .number p {
  font-weight: 700;
}
.progresscircle-wrap .progress-circle:hover .title h3 {
  font-weight: 500;
}

/* main e-HC Status */
.main .content > .box .box__header .select {
  width: 158px;
}
.main .content > .box .box__body h2 {
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  margin-bottom: 12px;
}
.main .content > .box .box__body .txt-info {
  font-size: 15px;
  line-height: 14px;
  letter-spacing: -1px;
  color: #2a2c2f;
  padding-left: 21px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat 0 0;
  background-size: 14px 14px;
}
.progresscircle-wrap {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.progresscircle-wrap .progress-circle svg {
  width: 80px;
  height: 80px;
}
.progresscircle-wrap .progress-circle svg circle {
  stroke-width: 6;
}
/* .progresscircle-wrap .progress-circle svg circle:last-of-type {
  stroke-dasharray: 220px;
  stroke-dashoffset: calc(220px - (220px * var(--percent)) / 100);
} */
.progresscircle-wrap .progress-circle .number {
  top: 50%;
}
.progresscircle-wrap .progress-circle .number p {
  font-size: 22px;
}
.progresscircle-wrap .progress-circle .title h3 {
  margin-top: 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.progresscircle-wrap .progress-circle .title h3 img {
  vertical-align: top;
  margin-right: 4px;
  margin-top: 2px;
}
.progresscircle-wrap .progress-circle:last-child {
  padding-left: 22px;
  margin-left: 13px;
  border-left: 1px solid #e6e9f0;
}
.main .content > .box .box__body .bottom.line {
  border-top: 1px solid #dde2e9;
  margin-top: 24px;
  margin-left: -38px;
  margin-right: -38px;
  padding: 24px 38px 0;
}
.main .content > .box .box__body .step-order {
  display: flex;
  justify-content: space-between;
}
.main .content > .box .box__body .step-order li {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  background: #fff;
  height: 60px;
  padding: 16px 30px 12px 14px;
}
.main .content > .box .box__body .step-order li:last-child {
  background: none;
}
.main .content > .box .box__body .step-order li .tit {
  font-weight: 500;
  font-size: 15px;
  line-height: 14px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.main .content > .box .box__body .step-order li .total-num {
  font-weight: 500;
  font-size: 13px;
}
.main .content > .box .box__body .step-order li .total-num strong {
  font-size: 26px;
  color: #003876;
}
/* .main .content > .box .box__body .step-order li:hover {
  background-color: #f0f2f4;
  cursor: pointer;
}
.main .content > .box .box__body .step-order li:hover .tit {
  font-weight: 700;
} */

/* main e-HC 평균 점수 */
.main .box__body .ehc__info {
  top: 0;
  left: 0;
  width: calc(100% - 32px);
  height: 38px;
  padding: 0 1rem;
  align-items: center;
}
.main .box__body .ehc__info .ehc__name {
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.main .box__body .ehc__info .ehc__name::before {
  content: "";
  width: 16px;
  height: 16px;
  font-size: 13px;
}
.main .box__body .ehc-b .ehc__name::before {
  content: "B";
  background-color: #5b71ef;
}
.main .box__body .ehc-p .ehc__name::before {
  content: "P";
  background-color: #13a79e;
}
.main .box__body .ehc-a .ehc__name::before {
  content: "A";
  background-color: #ff9900;
}
.main .box__body .ehc-n .ehc__name::before {
  content: "N";
  background-color: #1fc95c;
}
.main .box__body .ehc__detail {
  position: absolute;
  left: 0;
  top: 39px;
  margin: 0;
  width: 100%;
  height: 76px;
}
.main .box__body .result__txt {
  box-shadow: none;
  width: calc(100% - 70px);
  height: 76px;
  padding: 0 32px 0;
  margin: 0 0 0 6px;
  display: flex;
  align-items: center;
}
.main .box__body .ehc__detail .result__txt .tit {
  font-size: 10px;
  line-height: 10px;
  color: #2a2c2f;
  font-weight: 400;
  padding-top: 24px;
  margin-top: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat top center;
  background-size: 21px 21px;
}
.main .box__body .ehc__detail .result__txt .tit.caution {
  padding-top: 24px;
  margin-top: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat top center;
  background-size: 21px 21px;
}
.main .box__body .ehc__detail .result__txt .tit.danger {
  padding-top: 24px;
  margin-top: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat top center;
  background-size: 22px 22px;
}
.main .box__body .result__txt .btn-edit {
  width: 32px;
  height: 32px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat center center #909fb7;
  background-size: 1.125rem 1.124rem;
}
.main .box__body .ehc__detail .result__txt .score {
  font-weight: 500;
  font-size: 44px;
  /* line-height: 30px; */
  letter-spacing: -2px;
  color: #2a2c2f;
  margin: 0 24px 0 4px;
}
.main .box__body .ehc__detail .result__txt .txt {
  width: calc(100% - 144px);
  font-size: 15px;
  line-height: 22px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  font-weight: 400;
  margin: 0;
}
.main .box__body .bottom .ehc__chart {
  filter: none;
  padding: 0;
  width: 100% !important;
  height: 350px !important;
  margin: 0;
}
.main .box__body .bottom .ehc__chart.h300 {
  height: 300px !important;
}
.main .box__body .bottom.ehc__chart {
  width: 100%;
  height: calc(100% - 80px);
  filter: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.main .box__body .bottom.ehc__chart .chart > div {
  width: 100%;
  height: 375px;
}

/* main 노후 교체 현황 */
.main .content > .box .btn-go {
  width: 24px;
  height: 24px;
  margin: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_71___}) no-repeat center center;
  background-size: 100%;
}

/* main e-HC 점수 현황 */
.main .content > .box .box__body .tab__small {
  position: absolute;
  top: 33px;
  left: 0;
  width: 100%;
  height: 32px;
  border-bottom: 1px solid #dde2e9;
  margin-bottom: 0;
}
.main .content > .box .box__body .tab__small li {
  margin-left: 38px;
}
.main .content > .box .box__body .tab__small li + li {
  border: 0;
  padding: 0;
  margin-left: 30px !important;
}
.main .content > .box .box__body .tab__small li a {
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  text-align: center;
  letter-spacing: -0.4px;
  color: #6b7891;
  padding-bottom: 12px;
  position: relative;
}
.main .content > .box .box__body .tab__small li a::before {
  content: none;
}
.main .content > .box .box__body .tab__small li.on a,
.main .content > .box .box__body .tab__small li:hover a {
  font-weight: 700;
  color: #2a2c2f;
}
.main .content > .box .box__body .tab__small li.on a:after,
.main .content > .box .box__body .tab__small li:hover a:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  border-bottom: 4px solid #5b71ef;
}
.main .content > .box .box__body .tab__small li:nth-child(2).on a:after,
.main .content > .box .box__body .tab__small li:nth-child(2):hover a:after {
  border-color: #13a79e;
}
.main .content > .box .box__body .tab__small li:nth-child(3).on a:after,
.main .content > .box .box__body .tab__small li:nth-child(3):hover a:after {
  border-color: #ff9900;
}

/* main 진단 점검 서비스 */
.main .e-checkbox .buttonbox {
  background: #fafafc;
  height: 128px;
  flex: 1;
}
.main .e-checkbox .buttonbox + .buttonbox {
  margin-left: 4px;
}
.main .e-checkbox .top .buttonbox {
  background: #fff;
  height: 64px;
  padding: 18px 18px 18px 12px;
}
.main .e-checkbox .top .buttonbox a {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.main .e-checkbox .top .buttonbox p {
  display: flex;
  flex-direction: column;
  flex: 2.3;
}
.main .e-checkbox .top .buttonbox p span {
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.main .e-checkbox .top .buttonbox .tit {
  font-weight: 700;
  font-size: 20px;
  line-height: 14px;
  letter-spacing: -1px;
  color: #0a78ff;
  margin-bottom: 12px;
}
.main .e-checkbox .top .buttonbox button {
  flex: 1.2;
  justify-content: flex-end;
  border: 0;
  width: 80px;
  height: 30px;
  padding: 0 13px 12px 0;
  margin-bottom: 6px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_73___}) no-repeat right bottom;
  background-size: 80px 6px;
}
.main .e-checkbox .top .buttonbox:hover button,
.main .e-checkbox .top .buttonbox:active button {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_74___}) no-repeat right bottom;
  background-size: 80px 6px;
}
.main .e-checkbox .top .buttonbox button span {
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: -1px;
  color: #0f5fa5;
}
.main .e-checkbox .bottom {
  display: flex;
  flex-direction: column;
  margin-top: 4px;
}
.main .e-checkbox .bottom li {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.main .e-checkbox .bottom li + li {
  margin-top: 4px;
}
.main .e-checkbox .bottom .buttonbox a {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 12px 6px 20px 12px;
  height: calc(100% - 32px);
}
.main .e-checkbox .bottom .buttonbox a div {
  display: flex;
  justify-content: space-between;
}
.main .e-checkbox .bottom .buttonbox a p {
  display: flex;
  flex-direction: column;
}
.main .e-checkbox .bottom .buttonbox a p span {
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: -0.08em;
  color: #2a2c2f;
}
.main .e-checkbox .bottom .buttonbox a p .tit {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}
.main .e-checkbox .buttonbox:hover,
.main .e-checkbox .buttonbox:active {
  background: #e7f2ff;
}
.main .e-checkbox .buttonbox .img-default {
  display: block;
}
.main .e-checkbox .buttonbox .img-active {
  display: none;
}
.main .e-checkbox .buttonbox:hover .img-default,
.main .e-checkbox .buttonbox:active .img-default {
  display: none;
}
.main .e-checkbox .buttonbox:hover .img-active,
.main .e-checkbox .buttonbox:active .img-active {
  display: block;
}
.main .e-checkbox .top .buttonbox:hover button span,
.main .e-checkbox .top .buttonbox:active button span {
  color: #0a78ff;
}
.main .e-checkbox .bottom .buttonbox:hover a p .tit,
.main .e-checkbox .bottom .buttonbox:active a p .tit {
  color: #003876;
}

/********************************************** main For small screen, main 레이아웃 반응형 **********************************************/
@media screen and (max-width: 1810px) and (min-width: 1610px) {
  .main .content > .box .box__body {
    padding: 33px 16px;
  }
}
@media screen and (max-width: 1609px) {
  /*1609에서 탭화면으로 변경, 박스 2개*/
  .main .content > .box .box__body {
    padding: 33px 72px;
  }
  .main .box__body .progress-wrap li .progress-bar {
    flex: 6;
  }
  .progress-circle {
    flex: 1.7;
  }
  .progresscircle-wrap .progress-circle:last-child {
    flex: 2;
    margin-left: 30px;
  }
  .main .content > .box .box__body .tab__small li {
    margin-left: 72px;
  }
  .main .box__body .result__txt {
    padding: 0 72px;
    width: calc(100% - 144px);
  }
  .main .content > .box .box__body .bottom.line {
    margin-left: 0;
    margin-right: 0;
    padding: 24px 0 0;
  }
}
@media screen and (max-width: 1140px) and (min-width: 965px) {
  .main .content > .box .box__body {
    padding: 33px 16px;
  }
  .main .content > .box .box__body .tab__small li {
    margin-left: 16px;
  }
  .main .box__body .result__txt {
    padding: 0 16px;
    width: calc(100% - 32px);
  }
}
@media screen and (max-width: 964px) {
  /*964에서 모바일화면으로 변경, 박스 1개*/
  .main .content > .box .box__body {
    padding: 26px 56px;
    height: calc(100% - 98px);
  }
  .main .content-top .top-wrap h2 {
    font-size: 16px;
  }
  .main .box__body .result__txt {
    padding: 0 56px;
    width: calc(100% - 112px);
  }
  .main .content > .box .box__body .tab__small {
    top: 20px;
  }
  .main .content > .box .box__body .tab__small li {
    margin-left: 56px;
  }
  .datalist-small li p.tit {
    font-size: 13px;
  }
  .main .content > .box .box__body .mt-32 {
    margin-top: 0 !important;
  }
}
@media screen and (max-width: 767px) {
  .main .container {
    margin-top: 166px;
  }
  .main .content-top {
    top: 100px;
  }
  .main .content > .box {
    height: auto;
    min-height: 390px;
  }
  .datalist li {
    padding: 5px 0;
  }
  .datalist-small {
    padding: 6px 2px 12px;
  }
  .datalist-small li {
    padding: 0 0 4px;
  }
  .menu-slide {
    top: 156px;
    width: 100%;
    height: calc(100vh - 174px);
  }
  .menu-slide .lnb-depth1 > li.on p::before,
  .menu-slide .lnb-depth1 > li.active p::before {
    margin-left: -24px;
  }
  .menu-slide .lnb-depth1 > li > p span:first-child {
    width: 130px;
  }
  .progress-wrap.mt-40 {
    margin-top: 20px !important;
  }
  .main .box__body .progress-wrap li {
    margin-bottom: 18px;
  }
  .progresscircle-wrap.mt-40 {
    margin-top: 20px !important;
  }
  .main .content > .box .box__body .bottom.line.mt-50 {
    margin-top: 20px !important;
  }
  .main .content > .box .box__body h2 {
    margin-bottom: 0;
  }
  .main .content > .box .box__body .bottom.progress-wrap.mt-40 {
    margin-top: 20px !important;
  }
  .main .content > .box .box__body .bottom.mt-40 {
    margin-top: 40px !important;
  }
}
@media screen and (max-width: 550px) {
  .main .content > .box .box__body {
    padding: 26px 16px;
  }
  .main .content > .box .box__body .bottom.line {
    margin-left: -16px;
    margin-right: -16px;
    padding: 24px 16px 0;
  }
  .main .content > .box .box__body .tab__small li {
    margin-left: 16px;
  }
  .main .box__body .result__txt {
    padding: 0 16px;
    width: calc(100% - 32px);
  }
}
@media screen and (max-width: 500px) {
  .main .content-top .top-wrap .left {
    width: 70%;
  }
  .main .content-top .top-wrap .right .btn-edit:hover::before {
    content: none;
  }
  .btn-pin:hover::before {
    content: none;
  }
  .menu-slide .lnb-depth1 > li > p span:first-child {
    width: 110px;
  }
  .menu-slide .lnb-depth1 > li p span:last-child,
  .menu-slide .lnb-depth1 > li p span:last-child {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 40%;
  }
  .main .box__body .ehc__info {
    display: none;
  }
  .main .box__body .ehc__detail {
    top: 0;
    height: 85px;
  }
  .main .box__body .result__txt {
    height: 85px;
  }
  .progresscircle-wrap .progress-circle:last-child {
    display: none;
  }
  .main .box__body .bottom .ehc__chart {
    filter: none;
    padding: 0;
    width: 100%;
    height: 370px;
    margin: 0;
  }
}
@media screen and (max-width: 499px) {
  .main .content-top {
    top: 91px;
  }
  .main .box__body .progress-wrap li .progress-bar {
    flex: 4;
  }
  .main .content > .box .box__body .step-order li {
    padding: 10px 20px 10px 14px;
    background-position: right 53px;
  }
}
@media screen and (max-width: 400px) {
  .main .box__body .ehc__detail .result__txt .txt {
    width: calc(100% - 140px);
  }
  .main .box__body .ehc__detail .result__txt .score {
    margin-right: 20px;
  }
  .main .e-checkbox {
    margin: 0 -10px 0;
  }
  .main .e-checkbox .top .buttonbox {
    padding: 20px 5px 13px;
  }
  .main .e-checkbox .top .buttonbox button {
    padding: 0 20px 20px 0;
  }
  .main .e-checkbox .top .buttonbox .tit {
    font-size: 18px;
  }
  .main .e-checkbox .top .buttonbox p span {
    font-size: 12px;
    line-height: 16px;
  }
  .main .e-checkbox .top .buttonbox button span {
    font-size: 18px;
  }
  .main .e-checkbox .bottom .buttonbox a p .tit {
    font-size: 13px;
  }
  .main .e-checkbox .bottom .buttonbox a p span {
    font-size: 10px;
    line-height: 14px;
  }
}
@media screen and (max-width: 320px) {
  .main .box__body .total-num strong.largetxt {
    font-size: 32px;
  }
  .main .box__body .progress-wrap li .progress-bar {
    flex: 3;
  }
  .main .content > .box .box__header .select {
    width: 130px;
  }
  .main .content > .box .box__body .step-order li {
    padding: 10px 20px 10px 14px;
    background-position: right 43px;
    height: 50px;
  }
  .main .content > .box .box__body .step-order li .tit {
    font-size: 14px;
  }
  .main .content > .box .box__body .step-order li .total-num strong {
    font-size: 20px;
  }
  .main .box__body .total-num span {
    font-size: 14px;
  }
  .main .box__body .ehc__detail .result__txt .txt {
    font-size: 13px;
    line-height: 1.2;
  }
}

/********************************************************* 도움말 help-page ******************************************************/
.help.content .box {
  overflow-y: hidden;
  position: relative;
}
.help.content .box .box-wrap .content-wrap {
  overflow-y: auto;
  height: calc(100vh - 115px);
}
.help .btn-filedown {
  width: 156px;
  height: 32px;
  border: 0;
  border-radius: 4px;
  background: #fff;
  position: absolute;
  top: 7px;
  right: 20px;
}
.btn-filedown.help span:before {
  content: "";
  width: 20px;
  height: 20px;
  margin-right: 8px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_75___}) no-repeat left center;
  background-size: 100%;
}
.btn-filedown.help span {
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 15px;
  letter-spacing: -0.8px;
  color: #0a78ff;
}
.btn-filedown.help:hover,
.btn-filedown.help:active {
  background: #e7f2ff;
}
.help .lnb__top {
  padding: 16px 8px 8px;
}
.help h2 {
  font-weight: 700;
  font-size: 25px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.help h3 {
  margin-top: 24px;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.help h4 {
  font-weight: 700;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  border-bottom: 1px solid #a4b0c4;
  padding-bottom: 16px;
}
.help dl + dl {
  margin-top: 16px;
}
.help dt {
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.004em;
  color: #2a2c2f;
  margin-bottom: 16px;
}
.help dd {
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.help dd + dd {
  margin-top: 10px;
}
.img-wrap {
  width: 100%;
  height: auto;
  background: #f7f7f7;
  min-height: 440px;
}
.img-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.help .box__header {
  padding: 32px 80px 24px;
}
.help .box__body {
  padding: 56px 80px;
}
.help .box__body .cont {
  margin-top: 16px;
}
.help .box__body .cont + h4 {
  margin-top: 56px;
}
.help .box-wrap > .treebar.box {
  border-right: 4px solid #dde2e9;
  box-shadow: none;
  border-radius: 0;
  height: calc(100vh - 115px);
  min-height: auto;
}
#wrap:not(.float-page, .no-responsive) .help .box-wrap .treebar.box {
  width: 340px;
}
#wrap:not(.no-responsive) .help .treebar.box + .content-wrap {
  width: calc(100% - 340px);
}
.help .lnb-depth1 > li:first-child {
  border-top: 0;
}
.help .lnb-depth1 > li > p {
  background: #fff;
  padding: 0 24px;
  width: calc(100% - 48px);
}
.help .lnb-depth1 > li.on p::before,
.help .lnb-depth1 > li.active p::before {
  content: none;
}
.help .lnb-depth1 > li > p > a {
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.help .box.treebar.pushy-menutype .lnb .lnb-depth1 > li > p > a:after {
  content: none;
}
.help .box.treebar.pushy-menutype .lnb .lnb-depth1 > li > p a span {
  max-width: unset;
}
.help .lnb-depth2 {
  margin: 20px 0 21px 32px !important;
}
.help .box.treebar.pushy-menutype .lnb .lnb-depth2 > li:last-child {
  border-bottom: 1px solid #dde2e9;
}
.help .box.treebar.pushy-menutype .lnb .lnb-depth2 > li > a {
  background: #fff;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  padding: 0 20px;
  min-height: 50px;
  width: calc(100% - 40px);
}
.help .box.treebar.pushy-menutype .lnb .lnb-depth2 > li > a:after {
  content: none;
}
.help .lnb-depth2 > li.active > a::before,
.help .lnb-depth2 > li.on > a::before {
  content: none;
}
.help .lnb-depth2 > li.active > a,
.help .lnb-depth2 > li.on > a {
  background: #0a78ff;
  color: #fff;
}
@media screen and (max-width: 940px) {
  #wrap:not(.no-responsive) .help .treebar.box + .content-wrap {
    width: 100%;
    height: auto;
  }
  #wrap:not(.no-responsive) .help .content-wrap .box__header {
    padding: 20px;
  }
  .help .tab__line {
    display: none;
  }
  #wrap:not(.float-page, .no-responsive) .help .box-wrap .treebar.box {
    height: calc(100vh - 102px);
    overflow-y: auto;
  }
  .help .btn-filedown {
    position: relative;
    top: unset;
    right: unset;
    margin-top: 10px;
  }
  .help .box.treebar.pushy-menutype .lnb {
    overflow-y: unset;
  }
  .help .box__body {
    padding: 40px 20px;
  }
  .help .img-wrap {
    min-height: 244px;
  }
  .help h2 {
    font-size: 20px;
  }
  .help h3 {
    margin-top: 16px;
    font-size: 15px;
  }
  .help h4 {
    font-size: 15px;
  }
  .help dt {
    font-size: 14px;
  }
  .help .lnb-depth2 > li > a,
  .help .lnb-depth1 > li > p {
    padding: 0 16px;
    width: calc(100% - 32px);
  }
  .help .lnb-depth1 > li > p > a,
  .help .lnb-depth2 > li > a {
    font-size: 14px;
  }
}
@media screen and (max-width: 499px) {
  #wrap:not(.float-page, .no-responsive) .help .box-wrap .treebar.box {
    top: 142px;
    height: calc(100vh - 142px);
  }
  .help .lnb-depth1 {
    padding: 16px 8px;
  }
  .help .lnb-depth1 > li > p > a,
  .help .lnb-depth2 > li > a {
    font-size: 15px;
  }
  .help .lnb-depth1 > li > p > a {
    font-weight: 500;
  }
  .help .lnb-depth2 > li > a {
    font-weight: 700;
  }
  .help .box__body {
    padding: 20px;
  }
  .help .img-wrap {
    min-height: 156px;
  }
  #wrap:not(.no-responsive, .float-page) .content.help {
    padding-top: 50px;
  }
  #wrap:not(.no-responsive) .help .content-wrap .box__header {
    padding: 60px 20px 20px 20px;
  }
  #wrap:not(.no-responsive) .help .content-wrap > div:first-child .box__header:first-child {
    padding-top: 45px;
  }
}

/********************************************************* 랜딩 randing ******************************************************/
#wrap.randing .container {
  min-height: calc(100vh - 50px);
  margin: 50px 0 0;
}
#wrap.randing .content {
  display: block;
  width: 100%;
  padding: 0;
}
#wrap.randing .content .content__title {
  width: 100%;
  height: 700px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_76___}) no-repeat center center;
  background-size: cover;
}
#wrap.randing .content .content__title .title-wrap {
  max-width: 1200px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin: 0 auto;
}
#wrap.randing .content .content__title h1 {
  margin-bottom: 34px;
  margin-top: 3%;
  font-weight: 500;
  font-size: 16px;
  line-height: 0;
  letter-spacing: -1px;
  color: #dde2e9;
}
#wrap.randing .content .content__title h1 img {
  width: auto;
  vertical-align: baseline;
}
#wrap.randing .content .content__title p.page-title {
  width: 399px;
  height: 42px;
  margin-top: 0;
  margin-bottom: 12px;
}
#wrap.randing .content .content__title p.page-title img {
  width: 100%;
  vertical-align: baseline;
}
#wrap.randing .content .content__title p {
  font-weight: 300;
  font-size: 16px;
  line-height: 26px;
  letter-spacing: -0.4px;
  color: #dde2e9;
  margin-top: 24px;
}
#wrap.randing .content .content__title p + p {
  margin-top: 4px;
}
#wrap.randing .content article section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 0 18%;
  max-width: 1200px;
  min-height: 580px;
}
#wrap.randing .content article section:nth-child(even) {
  background: #f8fafc;
}
#wrap.randing .content article section .txt-wrap {
  width: 50%;
  padding-left: 95px;
  padding-right: 120px;
}
#wrap.randing .content article section .txt-wrap h2 {
  font-weight: 700;
  font-size: 35px;
  line-height: 44px;
  letter-spacing: -0.02em;
  color: #2a2c2f;
  margin-bottom: 24px;
}
#wrap.randing .content article section .txt-wrap p {
  font-weight: 400;
  font-size: 20px;
  line-height: 35px;
  letter-spacing: -0.8px;
  color: #2a2c2f;
}
#wrap.randing .content article section.center {
  flex-direction: column;
  justify-content: flex-end;
  height: 728px;
  padding-bottom: 0 !important;
}
#wrap.randing .content article section.center .txt-wrap {
  width: 100%;
  text-align: center;
  margin-bottom: 16px;
}
#wrap.randing .content article section.center .txt-wrap h2 {
  margin-bottom: 16px;
}
#wrap.randing .content section.center .img-wrap {
  width: 100%;
}
#wrap.randing .content section.center .img-wrap img {
  width: 100%;
}
#wrap.randing .content .img-wrap {
  background: transparent;
  width: 50%;
  min-height: auto;
  text-align: right;
}
#wrap.randing .content .img-wrap.left {
  text-align: left;
}
#wrap.randing .content .img-wrap img {
  width: auto;
  height: auto;
  object-fit: contain;
}
#wrap.randing .content section.example {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-height: auto;
  padding: 116px 18% 122px;
}
#wrap.randing .content article section.example .txt-wrap {
  width: 100%;
  padding: 0;
}
#wrap.randing .content article section.example .txt-wrap h2 {
  margin-bottom: 8px;
}
#wrap.randing .content section.example ul {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 50px;
}
#wrap.randing .content section.example ul li {
  width: 31%;
  height: 530px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_77___}) no-repeat 93% 93% #fff;
  border: 1px solid #dde2e9;
}
#wrap.randing .content section.example ul li .img-wrap {
  width: 100%;
}
#wrap.randing .content section.example ul li .img-wrap img {
  object-fit: cover;
  width: 100%;
}
#wrap.randing .content section.example ul li .txt-wrap {
  width: calc(100% - 48px);
  padding: 32px 24px 40px;
}
#wrap.randing .content section.example ul li .txt-wrap h3 {
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
#wrap.randing .content section.example ul li .txt-wrap p {
  font-weight: 400;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  margin-top: 12px;
}
#wrap.randing .bottom-area {
  padding: 80px;
  font-weight: 700;
  font-size: 35px;
  line-height: 40px;
  letter-spacing: -0.01em;
  color: #ffffff;
  text-align: center;
  background: #2788fe;
}

@media screen and (max-width: 1600px) {
  #wrap.randing .content .img-wrap img {
    width: 100%;
    object-fit: cover;
  }
  #wrap.randing .content article section,
  #wrap.randing .content article section.center {
    min-height: auto;
    height: auto;
    padding: 7% 15%;
  }
  #wrap.randing .content article section .txt-wrap {
    padding: 0 5%;
  }
}
@media screen and (max-width: 1400px) {
  #wrap.randing .content .content__title .title-wrap {
    margin: 0 10%;
  }
}
@media screen and (max-width: 1200px) {
  #wrap.randing .content article section,
  #wrap.randing .content article section.center,
  #wrap.randing .content section.example {
    padding: 7% 10%;
  }
}
@media screen and (max-width: 768px) {
  #wrap.randing .content .content__title {
    height: 460px;
  }
  #wrap.randing .content .content__title p {
    font-size: 14px;
    line-height: 20px;
    margin-top: 32px;
  }
  #wrap.randing .content .content__title p + p {
    margin-top: 8px;
  }
  #wrap.randing .content .content__title p.page-title {
    height: 26px;
    width: auto;
  }
  #wrap.randing .content .content__title p.page-title img {
    height: 100%;
  }
  #wrap.randing .content .content__title img {
    height: 26px;
  }
  #wrap.randing .content .content__title h1 {
    font-size: 14px;
    margin-top: 19%;
    margin-bottom: 32px;
  }
  #wrap.randing .content .content__title h1 img {
    height: 24px;
  }
  #wrap.randing .content article section {
    flex-direction: column;
  }
  #wrap.randing .content article section .txt-wrap {
    width: 90%;
    padding: 0;
  }
  #wrap.randing .content article section .txt-wrap h2 {
    font-size: 24px;
    line-height: 40px;
    margin-bottom: 16px;
  }
  #wrap.randing .content article section .txt-wrap p {
    font-size: 18px;
    line-height: 24px;
  }
  #wrap.randing .content .img-wrap {
    width: 400px;
  }
  #wrap.randing .content article section,
  #wrap.randing .content article section.center {
    padding: 80px 10%;
  }
  #wrap.randing .content article section:not(.center) .txt-wrap + .img-wrap,
  #wrap.randing .content article section:not(.center) .img-wrap + .txt-wrap {
    margin-top: 40px;
  }
  #wrap.randing .content section.example {
    display: none;
  }
  #wrap.randing .bottom-area {
    font-size: 24px;
    line-height: 32px;
    padding: 64px 50px;
  }
}
@media screen and (max-width: 767px) {
  #wrap.randing .container {
    min-height: calc(100vh - 100px);
    margin: 100px 0 0;
  }
  #wrap.randing .content .content__title {
    height: 420px;
  }
  #wrap.randing .content .content__title h1 {
    margin-top: 17%;
  }
}
@media screen and (max-width: 499px) {
  #wrap.randing .container {
    min-height: calc(100vh - 90px);
    margin: 90px 0 0;
  }
}
@media screen and (max-width: 414px) {
  #wrap.randing .content article section .txt-wrap {
    width: 100%;
  }
  #wrap.randing .content .img-wrap {
    width: 100%;
  }
  #wrap.randing .content article section {
    padding: 64px 10%;
  }
  #wrap.randing .content article section.center {
    padding: 80px 7%;
  }
  #wrap.randing .content article section:nth-child(6),
  #wrap.randing .content article section:nth-child(7) {
    flex-direction: column-reverse;
  }
  #wrap.randing .content article section:nth-child(7) {
    padding-bottom: 116px;
  }
  #wrap.randing .content article section:nth-child(6) .txt-wrap + .img-wrap,
  #wrap.randing .content article section:nth-child(7) .txt-wrap + .img-wrap {
    margin-top: 0;
    margin-bottom: 40px;
  }
  #wrap.randing .content .content__title .title-wrap {
    margin: 0 7%;
  }
}
@media screen and (max-width: 360px) {
  #wrap.randing .content .content__title img {
    height: 22px;
  }
  #wrap.randing .content .content__title h1 img {
    height: 18px;
  }
}

/********************************************************* 소개 intro ******************************************************/
#wrap.intro .container {
  min-height: calc(100vh - 50px);
  margin: 50px 0 0;
}
#wrap.intro .content {
  display: block;
  width: 100%;
  padding: 0;
}
#wrap.intro .content .content__title {
  width: 100%;
  height: 296px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_78___}) no-repeat center center;
  background-size: cover;
}
#wrap.intro .content .content__title .title-wrap {
  max-width: 1280px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin: 0 auto;
}

#wrap.intro .content .content__title img {
  width: auto;
  vertical-align: baseline;
}
#wrap.intro .content .content__title h1 {
  margin-bottom: 24px;
  margin-top: 5%;
  font-weight: 500;
  font-size: 16px;
  line-height: 0;
  letter-spacing: -1px;
  color: #dde2e9;
}
#wrap.intro .content .content__title h1 img {
  height: 24px;
}
#wrap.intro .content .content__title h2 {
  font-weight: 700;
  font-size: 25px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #fff;
}
#wrap.intro .content .content__title h2 img {
  margin-right: 16px;
  height: 26px;
}
#wrap.intro .content .content__title p {
  font-size: 14px;
  line-height: 24px;
  font-weight: 300;
  letter-spacing: -0.4px;
  color: #dde2e9;
  margin-top: 16px;
}
#wrap.intro .content .content__title p + p {
  margin-top: 4px;
}
#wrap.intro .content article section {
  margin: 80px auto;
  background: #fff;
  max-width: 1280px;
}
#wrap.intro .content article section + section {
  margin-top: 0;
}
#wrap.intro .content article section h3 {
  padding-bottom: 24px;
  margin-bottom: 16px;
  font-weight: 700;
  font-size: 25px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  border-bottom: 1px solid #a4b0c4;
}
#wrap.intro .content article section .addmean {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.004em;
  color: #2a2c2f;
}
#wrap.intro .content article section .cont {
  margin-top: 56px;
}
#wrap.intro .content article section .cont dl + dl {
  margin-top: 24px;
}
#wrap.intro .content article section .cont dl dt {
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.004em;
  color: #2a2c2f;
}
#wrap.intro .content article section .cont dl dt::before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #2a2c2f;
}
#wrap.intro .content article section .cont dl dd {
  margin-top: 8px;
  margin-left: 7px;
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
#wrap.intro .content article section .cont .img-wrap {
  margin-top: 56px;
  min-height: auto;
}

@media screen and (max-width: 1600px) {
  #wrap.intro .content article section {
    margin: 80px 17%;
    width: calc(100% - 34%);
    max-width: calc(100% - 34%);
  }
  #wrap.intro .content .content__title .title-wrap {
    margin: 0 17%;
    width: calc(100% - 34%);
    max-width: calc(100% - 34%);
  }
}
@media screen and (max-width: 1400px) {
  #wrap.intro .content article section {
    margin: 80px 10%;
    width: calc(100% - 20%);
    max-width: calc(100% - 20%);
  }
  #wrap.intro .content .content__title .title-wrap {
    margin: 0 10%;
    width: calc(100% - 20%);
    max-width: calc(100% - 20%);
  }
}
@media screen and (max-width: 768px) {
  #wrap.intro .content article section {
    margin: 64px 10%;
  }
  #wrap.intro .content article section .cont .img-wrap {
    margin-top: 40px;
  }
  #wrap.intro .content article section .cont {
    margin-top: 40px;
  }
}
@media screen and (max-width: 767px) {
  #wrap.intro .container {
    min-height: calc(100vh - 100px);
    margin: 100px 0 0;
  }
}
@media screen and (max-width: 560px) {
  #wrap.intro .content article section {
    margin: 60px 10%;
  }
  #wrap.intro .content .content__title h2 img {
    height: 22px;
  }
}
@media screen and (max-width: 499px) {
  #wrap.intro .container {
    min-height: calc(100vh - 90px);
    margin: 90px 0 0;
  }
  #wrap.intro .content .content__title {
    display: none;
  }
}

/*-------------------------------------------------------------LS MVP 3.0 e-HP-----------------------------------------------------------------*/

/*오늘의 점검*/
.content.wcal-296 {
  width: calc(100% - 296px);
}
.content.wcal-296 > *:nth-child(1) {
  flex: 1.8;
}
.content.wcal-296 > *:nth-child(2) {
  flex: 1;
}
/* @media screen and (min-width: 1876px) {
  .content.wcal-296 {
    width: calc(100% - 296px);
  }
  .content.wcal-296 > *:nth-child(1) {
    flex: 1.8;
  }
  .content.wcal-296 > *:nth-child(2) {
    flex: 1;
  }
  .box.box-detailinfo {
    margin-top: -16px;
    margin-right: -16px;
    margin-bottom: -8px;
    border-radius: 0;
    background: #f7f8fa;
  }
} */
@media screen and (min-width: 941px) and (max-width: 1650px) {
  .content.wcal-296 {
    width: calc(100% - 280px);
  }
  .content.wcal-296 > *:nth-child(1) {
    flex: 1;
  }
}
@media screen and (max-width: 1650px) {
  .lm-none {
    display: none !important;
  }
  .lm-block {
    display: block !important;
  }
  td.lm-block,
  th.lm-block {
    display: table-cell !important;
  }
}
@media screen and (min-width: 1651px) {
  .lm-block {
    display: none !important;
  }
}
@media screen and (max-width: 1500px) {
  .sm-none {
    display: none !important;
  }
  .sm-block {
    display: block !important;
  }
  td.sm-block,
  th.sm-block {
    display: table-cell !important;
  }
}
@media screen and (min-width: 1501px) {
  .sm-block {
    display: none !important;
  }
}
@media screen and (min-width: 1201px) {
  .xsm-none {
    display: block !important;
  }
  button.xsm-none {
    display: flex !important;
  }
}
@media screen and (max-width: 1200px) {
  .xsm-none {
    display: none !important;
  }
  .xsm-block {
    display: block !important;
  }
  button.xsm-block {
    display: flex !important;
  }
}
@media screen and (max-width: 940px) {
  .content.wcal-296 {
    width: 100%;
  }
  .m-none {
    display: none !important;
  }
  .m-block {
    display: block !important;
  }
  .m-flex {
    display: flex !important;
  }
  td.m-block,
  th.m-block {
    display: table-cell !important;
  }
}
@media screen and (min-width: 941px) {
  .m-block,
  .m-flex {
    display: none !important;
  }
}

/* 설비별 목록 */
.tbl-select tr.selected td {
  border-top: 2px solid #0a78ff;
  border-bottom: 2px solid #0a78ff;
  height: 36px;
}
.tbl-select tr.selected td:first-child {
  border-left: 2px solid #0a78ff;
}
.tbl-select tr.selected td:last-child {
  border-right: 2px solid #0a78ff;
}
.tbl-select.line-1 tr.selected td {
  border-width: 1px;
}
.tbl-select.line-1 tr.selected td:first-child {
  border-width: 1px;
}
.tbl-select.line-1 tr.selected td:last-child {
  border-width: 1px;
}
.tbl-select tr.selected td button.bg-no.btn-basic {
  background: #0978ff !important;
}
.tbl-select tr.selected td button.bg-no.btn-basic span,
.tbl-select tr.selected td button.bg-no.btn-basic span.txt-gray {
  color: #fff !important;
}
.tbl-select tr td:hover button.bg-no.btn-basic:not(:disabled):hover {
  background: #0978ff !important;
}
.tbl-select tr td:hover button.bg-no.btn-basic:not(:disabled):hover span,
.tbl-select tr.selected td button.bg-no.btn-basic:not(:disabled):hover span.txt-gray {
  color: #fff !important;
}
.tbl__top .right .btn-add.tooltip-link:before {
  left: auto;
  right: 0;
  width: 70px;
}

@media screen and (max-width: 940px) {
  .tbl-select tr.selected td {
    height: 52px;
  }
  .tbl-select:not(.tbl-border) tr.selected td {
    border: 0 !important;
  }
  .tbl-select tr.selected td button.bg-no.btn-basic.wmax-90 {
    max-width: 101px !important;
  }
}

/* 설비상세정보 박스 */
.box.box-detailinfo {
  margin-top: -16px;
  margin-right: -16px;
  margin-bottom: -8px;
  border-radius: 0;
  background: #f7f8fa;
}
.box.box-detailinfo .box__header {
  position: absolute;
  width: calc(100% - 64px);
  padding: 58px 32px 16px;
  background: #2c364e;
  border-bottom: 2px solid #dde2e9;
  z-index: 1;
}
.box.box-detailinfo .box__header .box__title {
  color: #fff;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_79___}) no-repeat 0 center;
  background-size: 24px 24px;
  padding-left: 32px;
}
.box.box-detailinfo .box__header .box__title.bg-no {
  background: none;
  padding-left: 0;
}
.box.box-detailinfo .box__header .btn-close {
  display: none;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_80___}) no-repeat center center;
  background-size: 100%;
}
.box.box-detailinfo .box__body {
  position: absolute;
  top: 96px;
  padding: 16px 30px;
  width: calc(100% - 60px);
  max-height: calc(100% - 129px);
  overflow-y: auto;
}
.box.box-detailinfo .box__body section {
  background: #f7f8fa;
  padding: 16px;
}
.box.box-detailinfo .box__body section + section {
  margin-top: 16px;
}
.box.box-detailinfo .box__body section .section-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}
.box.box-detailinfo .box__body section .section-top .right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.box.box-detailinfo .box__body section .section-top .tit {
  font-weight: 500;
  font-size: 16px;
  line-height: 1.2;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.box.box-detailinfo .box__body section .section-top .tit .txt-info {
  font-weight: 400;
  font-size: 14px;
  color: #7a8596;
  margin-left: 8px;
  letter-spacing: -0.7px;
}
.box.box-detailinfo .box__body section .section-top .btn {
  width: 32px;
  height: 32px;
}
.box.box-detailinfo .box__body section .section-bottom {
  padding: 16px;
  border-top: 2px solid #dde2e9;
  border-bottom: 2px solid #dde2e9;
  background: #fff;
}
.box.box-detailinfo .box__body section .section-bottom .tbl-list {
  margin: -16px;
}
.box.box-detailinfo .box__body section .section-bottom .tbl-list table {
  border-bottom: 0;
}
.box.box-detailinfo .box__body section .section-bottom .tbl-list th,
.box.box-detailinfo .box__body section .section-bottom .tbl-list td {
  padding: 10px 16px;
  height: 28px;
}
.box.box-detailinfo .box__body section .section-bottom textarea:read-only {
  width: 100%;
  height: auto;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.7;
  letter-spacing: -0.4px;
  color: #000;
  border: 0;
  padding: 0;
  background: #fff;
}
/* @media screen and (min-width: 1876px) {
  .box.box-detailinfo .box__header {
    position: absolute;
    width: calc(100% - 64px);
    padding: 58px 32px 16px;
    background: #2c364e;
    border-bottom: 2px solid #dde2e9;
    z-index: 1;
  }
  .box.box-detailinfo .box__body {
    position: absolute;
    top: 96px;
    padding: 16px 30px;
    width: calc(100% - 60px);
    max-height: calc(100% - 129px);
    overflow-y: auto;
  }
} */
@media screen and (max-width: 1650px) {
  .box.box-detailinfo .box__header {
    margin-top: -18px;
  }
  .box.box-detailinfo .box__header .btn-close {
    display: block;
    width: 32px;
    height: 32px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_80___}) no-repeat center center;
    background-size: 100%;
  }
  .box.box-detailinfo.m-hidden {
    display: none;
  }
  .box.box-detailinfo {
    height: 100vh;
    margin: 0;
  }
}
@media screen and (min-width: 500px) and (max-width: 1650px) {
  /* .box.box-detailinfo .box__header,
  .box.box-detailinfo .box__body {
    position: relative;
    top: unset;
  } */
  .box.box-detailinfo {
    box-shadow: 0px 10px 30px rgba(42, 44, 47, 0.5);
  }
}
@media screen and (min-width: 640px) and (max-width: 1650px) {
  .box.box-detailinfo {
    width: 640px;
  }
}
@media screen and (max-width: 639px) {
  .box.box-detailinfo {
    width: 100%;
    margin: 0;
  }
}
@media screen and (max-width: 499px) {
  .box.box-detailinfo {
    width: 100% !important;
  }
  .box.box-detailinfo .box__body {
    padding: 16px 4px;
    width: calc(100% - 8px);
    overflow-x: hidden;
  }
}

/* 설비상세정보 박스 - 설비정보*/
.box.box-detailinfo .box__body section .section-bottom .btn-open {
  height: 40px;
  width: calc(100% + 32px);
  margin-top: 16px;
  margin-bottom: -16px;
  margin-left: -16px;
  background: #f7f8fa;
}
.box.box-detailinfo .box__body section .section-bottom .btn-open:before {
  content: "";
  width: 12px;
  height: 12px;
  margin-right: 8px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_81___}) no-repeat center center;
  background-size: 100%;
}
.box.box-detailinfo .box__body section .section-bottom .btn-open span {
  font-weight: 400;
  font-size: 14px;
  color: #0a78ff;
}
.box.box-detailinfo .box__body section .section-bottom .btn-open.close:before {
  transform: scaleY(-1);
}
.box.box-detailinfo .box__body section .section-bottom .tbl-list.fold-list {
  height: 245px;
  overflow-y: hidden;
}
.box.box-detailinfo .box__body section .section-bottom .tbl-list.fold-list.open {
  height: auto;
  overflow-y: auto;
}

/* 설비상세정보 박스 - reports*/
.box.box-detailinfo .box__body section .section-top .btn.btn-more {
  width: auto;
  height: auto;
}
.box.box-detailinfo .box__body section .section-top .btn-more:after {
  content: "";
  width: 20px;
  height: 20px;
  margin-left: 4px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_82___}) no-repeat center center;
  background-size: 100%;
  transform: scaleX(-1);
}
.box.box-detailinfo .box__body section .section-top .btn-more span {
  font-weight: 400;
  font-size: 14px;
  color: #0a78ff;
}
.box.box-detailinfo .box__body section .section-bottom .tbl-list .filelist {
  margin: 0;
}
.box.box-detailinfo .box__body section .section-bottom .tbl-list .filelist li span {
  color: #2a2c2f;
  font-size: 14px;
  padding-left: 20px;
  line-height: 1.2;
  background-size: 9px 17px;
}
.box.box-detailinfo .box__body section .section-bottom .tbl-list .filelist li.no-file span {
  background: none;
}

/* 설비상세정보 박스 -  진단점검 평균점수 */
.box.box-detailinfo .box__body section .section-top .date {
  color: #7a8596;
  font-weight: 400;
  font-size: 14px;
}

/* 설비상세정보 박스 -  진단점검 Trend */
.box.box-detailinfo .box__body section .section-top .select {
  width: auto;
  height: auto;
  color: #0a78ff;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.7px;
  border: 0;
  border-radius: 0;
}
.box.box-detailinfo .box__body section .section-top .select .selected .arrow {
  width: 20px;
  height: 20px;
  margin-left: 4px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_82___}) no-repeat center center;
  background-size: 100%;
  transform: rotate(-90deg);
}
.box.box-detailinfo .box__body section .section-top .select.active .selected .arrow {
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_82___}) no-repeat center center;
  background-size: 100%;
  transform: rotate(90deg);
}

/* 설비상세정보 박스 - 진단점검 */
.color-info {
  display: flex;
  align-items: center;
  gap: 14px;
}
.color-info p {
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 1;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.color-info p:before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #0f5fa5;
  margin-right: 8px;
}
.color-info .ehc::before {
  background: #0f5fa5;
}
.color-info .jig::before {
  background: #00dacd;
}
.color-info .etc::before {
  background: #ff9900;
}
.color-info .memo::before {
  background: #d3b59a;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow {
  position: relative;
  padding: 0;
  border: 0;
  box-shadow: 1px 1px 12px rgba(144, 159, 183, 0.5);
  border-radius: 6px;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow::before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background: #0f5fa5;
  border-radius: 4px 0 0 4px;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow.ehc::before {
  content: "";
  background: #0f5fa5;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow.jig::before {
  content: "";
  background: #00dacd;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow.etc::before {
  content: "";
  background: #ff9900;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow + .box-shadow {
  margin-top: 8px;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow .title {
  display: flex;
  align-items: center;
  width: calc(100% - 34px);
  padding: 0 14px 0 20px;
  height: 60px;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow .title a {
  flex: 3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  width: 100%;
  height: 100%;
  margin-right: 10px;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow .title a p {
  font-weight: 500;
  font-size: 16px;
  line-height: 1.3;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow .title a p:first-child {
  width: calc(100% - 109px);
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow .title a p.date {
  font-weight: 400;
  padding-left: 23px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_83___}) no-repeat 0 center;
  background-size: 16px 16px;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow .title .btn {
  height: 32px;
  padding: 0 20px;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow .title .btn span {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  letter-spacing: -0.4px;
  color: #0a78ff;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow .title .btn:hover {
  background: #0978ff;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow .title .btn:hover span {
  color: #fff;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow .title .btn.btn-etc {
  position: relative;
  padding: 0;
}
.btn.btn-etc {
  width: 32px;
  height: 32px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_84___}) no-repeat center center transparent !important;
  background-size: 100% !important;
}

/*데이터없는경우*/
.box.box-detailinfo .nodata .nodata__txt {
  height: 100%;
  margin: 20px auto;
}
.float-page .nodata .nodata__txt {
  height: 100%;
  margin: 20px auto;
}
.nodata .nodata__txt {
  margin: 20px auto;
}
.nodata .tbl-list {
  border: 0;
  display: block;
}
.nodata .tbl-list table {
  display: none;
}
.nodata .tbl-list .nodata__txt {
  margin: 0 auto;
}
.popup__body .nodata .tbl-list .nodata__txt {
  height: 100%;
}

/*btn-etc 클릭시 수정삭제팝업*/
.popup-etc {
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 88px;
  height: auto;
  position: absolute;
  top: 45px;
  right: -15px;
  background: #fff;
  border-radius: 4px;
  filter: drop-shadow(0px 8px 12px rgba(122, 133, 150, 0.5));
  z-index: 2;
}
.popup-etc.open {
  display: flex;
}
.popup-etc li {
  width: 100%;
  flex: 1;
}
.popup-etc li button {
  width: 100% !important;
  height: 100% !important;
  border: 0 !important;
  background-size: 28%;
  background-position: 12px center;
  padding: 4px 0 3px 20px;
}
.popup-etc li button span {
  font-weight: 400;
  font-size: 15px;
  line-height: 1.8;
  letter-spacing: -0.004em;
  color: #19181a;
}
.popup-etc li button:focus {
  background-color: #b4d2ff;
  border-radius: 0;
}
.popup-etc li button.btn-edit-g:focus {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_85___}) no-repeat 12px center #b4d2ff;
  background-size: 24px;
}
.popup-etc li button.btn-delete-gr:focus {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_86___}) no-repeat 12px center #b4d2ff;
  background-size: 24px;
}
.popup-etc li button:focus span {
  font-weight: 700;
  color: #0a78ff;
}
.popup-etc li button:focus:hover {
  background-color: #b4d2ff;
}
.popup-etc li button:hover {
  background-color: #e6f0ff;
  border-radius: 0;
}
.popup-etc li:first-child button:hover,
.popup-etc li:first-child button:focus {
  border-radius: 4px 4px 0 0;
}
.popup-etc li:last-child button:hover,
.popup-etc li:last-child button:focus {
  border-radius: 0 0 4px 4px;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow .cont {
  display: none;
  border-top: 2px solid #dde2e9;
  padding: 32px 48px;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow .cont.open {
  display: block;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow .cont li + li {
  border-top: 1px solid #dde2e9;
  padding-top: 24px;
  margin-top: 24px;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow .cont li {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow .cont li p {
  display: flex;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow .cont li p span {
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: -0.004em;
  font-weight: 400;
  color: #2a2c2f;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow .cont li p span:nth-child(1) {
  flex: 1;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow .cont li p span:nth-child(2) {
  font-weight: 500;
  color: #000;
  flex: 2;
}

@media screen and (max-width: 940px) {
  .box.box-detailinfo .box__body section .section-bottom.box-shadow .title a p.date {
    margin-left: 0;
  }
}

/* 설비상세정보 박스 - 진단점검 : 데이터 없는 경우*/
.box.box-detailinfo .box__body section .section-bottom.box-shadow.no-data {
  box-shadow: none;
  border-radius: 4px;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow.no-data::before {
  content: none;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow.no-data::before {
  content: none;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow.no-data .title {
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 14px 10px 14px 24px;
  height: auto;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow.no-data .title a {
  width: auto;
  flex: unset;
  margin: 0;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow.no-data .title a p {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.4;
  color: #7a8596;
  width: 100%;
}
.box.box-detailinfo .box__body section .section-bottom.box-shadow.no-data .title .flex-inline.right {
  width: auto !important;
}
@media screen and (max-width: 940px) {
  .box.box-detailinfo .box__body section .section-bottom.box-shadow.no-data .title {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 14px;
    height: auto;
    padding: 23px 14px 17px 20px;
  }
  .box.box-detailinfo .box__body section .section-bottom.box-shadow.no-data .title a {
    height: auto;
    width: 100%;
  }
  .box.box-detailinfo .box__body section .section-bottom.box-shadow.no-data .title .flex-inline.right {
    width: 100% !important;
  }
}

/* 일정별 - 왼쪽 */
.body-left {
  background: #f7f8fa;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 340px;
}
@media screen and (min-width: 1651px) and (max-width: 1820px) {
  .content.wcal-296 .box__body .flex-row.m-m24 {
    flex-direction: column !important;
  }
  .body-left {
    flex: 1;
    width: calc(100% - 32px);
    flex-direction: row;
  }
}
@media screen and (max-width: 1280px) {
  .content.wcal-296 .box__body .flex-row.m-m24 {
    flex-direction: column !important;
  }
}
@media screen and (min-width: 941px) and (max-width: 1280px) {
  .body-left {
    flex: 1;
    width: calc(100% - 32px);
    flex-direction: row;
    gap: 16px;
  }
}
@media screen and (max-width: 940px) {
  .body-left {
    flex-direction: column;
    width: 100%;
    padding: 0 0 18px 0;
    gap: 18px;
  }
}

/* 일정별 - 캘린더 */
.left-top {
  height: 370px;
  background: #fff;
  padding: 24px 16px;
  width: calc(100% - 32px);
}
.left-top .calendar-area {
  display: flex;
  justify-content: center;
  /* height: calc(100% - 36px); */
}
.left-top .color-info {
  justify-content: flex-end;
  /* margin-top: 24px; */
  margin-right: 9px;
}
.calendar-area .css-1cafy48-MuiPickersSlideTransition-root-MuiDayCalendar-slideTransition > * {
  display: grid !important;
  grid-gap: 9px 0 !important;
}
.css-12p2adl-MuiDayCalendar-monthContainer {
  overflow: unset !important;
}
.MuiPickersLayout-actionBar {
  width: fit-content !important;
  height: fit-content !important;
  left: 65% !important;
  padding: 0 !important;
  grid-column: none !important;
  grid-row: none !important;
  top: -5px !important;
  color: #0978ff !important;
}
.left-top .MuiPickersLayout-actionBar {
  left: 60% !important;
  top: 0px !important;
}
.css-16ac5r2-MuiButtonBase-root-MuiListItemButton-root:hover,
.css-1uwabd6:hover {
  background-color: transparent !important;
}
.calendar-area .css-flbe84-MuiDayCalendar-weekContainer,
.calendar-area .MuiDayCalendar-weekContainer {
  align-items: center !important;
}
.calendar-area .MuiButtonBase-root-MuiPickersDay-root,
.calendar-area .css-ga06f9-MuiButtonBase-root-MuiPickersDay-root {
  width: 28px !important;
  height: 28px !important;
  color: #2a2c2f !important;
  font-size: 0.875rem !important;
}
.calendar-area .MuiButtonBase-root.MuiPickersDay-root.Mui-selected {
  width: 28px !important;
  height: 28px !important;
  font-size: 0.875rem !important;
  letter-spacing: -0.3px !important;
  background: #0a78ff !important;
  color: #fff !important;
  font-weight: 700 !important;
}
.calendar-area .css-10dddir-MuiPickersLayout-root .MuiPickersLayout-actionBar {
  grid-column: none !important;
  grid-row: none !important;
}
.calendar-area .MuiButtonBase-root-MuiPickersDay-root:not(.Mui-selected),
.calendar-area .css-byu9xf-MuiButtonBase-root-MuiPickersDay-root:not(.Mui-selected) {
  width: 28px !important;
  height: 28px !important;
  font-size: 0.875rem !important;
  font-weight: 700 !important;
  color: #0978ff !important;
  border: 0 !important;
  background: none !important;
}
.calendar-area .css-7oawqu-MuiButtonBase-root-MuiPickersDay-root:not(.Mui-selected) {
  border: 0 !important;
}
.calendar-area .css-rhmlg1-MuiTypography-root-MuiDayCalendar-weekDayLabel {
  height: 25px !important;
  font-size: 0.875rem !important;
  color: #909fb7 !important;
}
.calendar-area .css-vrdxij-MuiPickersLayout-root {
  width: 100% !important;
  min-width: 100% !important;
}
.left-top .calendar-area .css-cwhad8-MuiDateCalendar-root {
  width: 100% !important;
}
.calendar-area .css-rhmlg1-MuiTypography-root-MuiDayCalendar-weekDayLabel {
  width: calc(100% / 7) !important;
}
.calendar-area .css-jz75aw-MuiBadge-root {
  width: calc(100% / 7) !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
}
.calendar-area .css-1qs309j-MuiButtonBase-root-MuiPickersDay-root {
  width: 100% !important;
}
.calendar-area .css-yav00v-MuiPickersLayout-root {
  min-width: 100% !important;
}
.calendar-area .css-dplwbx-MuiPickersCalendarHeader-label {
  font-family: "NotoSansKR", sans-serif !important;
  font-weight: 500 !important;
  font-size: 16px !important;
  line-height: 1.4 !important;
  letter-spacing: -0.32px !important;
  color: #2a2c2f !important;
}
.calendar-area .css-16snd-MuiPickersLayout-root .MuiPickersLayout-actionBar {
  padding: 0 !important;
}
.calendar-area .css-16ac5r2-MuiButtonBase-root-MuiListItemButton-root,
.calendar-area .css-1uwabd6 {
  padding: 0 !important;
  text-align: center !important;
}
.calendar-area .css-10hburv-MuiTypography-root,
.calendar-area .css-yb0lig {
  font-family: "NotoSansKR", sans-serif !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 1.4 !important;
  letter-spacing: -0.4px !important;
  color: #0978ff !important;
}
.left-top .calendar-area .css-nk89i7-MuiPickersCalendarHeader-root {
  margin-top: 5px !important;
  margin-bottom: 20px !important;
  padding-left: 16px !important;
  padding-right: 8px !important;
}
.calendar-area .css-6kkttg-MuiPickersLayout-root .MuiPickersLayout-actionBar {
  padding: 0 !important;
  display: flex !important;
}
.calendar-area button:hover {
  background: none !important;
}
.calendar-area button.css-1beqopj-MuiPickersYear-yearButton.Mui-selected:hover {
  background: #0978ff !important;
}
.calendar-area .css-1beqopj-MuiPickersYear-yearButton.Mui-selected {
  background: #0978ff !important;
}
.calendar-area .css-1cafy48-MuiPickersSlideTransition-root-MuiDayCalendar-slideTransition {
  display: block !important;
  position: relative !important;
  overflow-x: hidden !important;
  min-height: 280px !important;
}

@media screen and (min-width: 1651px) and (max-width: 1820px) {
  .left-top {
    flex: 1;
  }
  .left-bottom {
    flex: 1;
  }
}
@media screen and (min-width: 941px) and (max-width: 1280px) {
  .left-top {
    flex: 1;
  }
  .left-bottom {
    flex: 1;
  }
}
@media screen and (max-width: 940px) {
  .left-top {
    flex: auto;
    padding: 24px 20px;
  }
  .left-bottom {
    flex: auto;
    height: auto;
  }
  .left-bottom.m-h200 {
    height: 200px;
  }
}

/* 일정별 - 탭영역 */
.left-bottom {
  height: 418px;
  background: #fff;
}
.tab__box {
  display: flex;
}
.tab__box li {
  flex: 1;
  height: 40px;
  display: flex;
  align-items: center;
}
.tab__box li a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.2;
  letter-spacing: -0.4px;
  color: #646c74;
  background: #f7f8fa;
  border-bottom: 1px solid #dde2e9;
}
.tab__box li.on a {
  font-weight: 700;
  color: #0978ff;
  background: #fff;
  border-bottom: 1px solid #fff;
  border-left: 1px solid #dde2e9;
  border-right: 1px solid #dde2e9;
}
.tab__box li:first-child.on a {
  border-left: 0;
}
.tab__box li:last-child.on a {
  border-right: 0;
}
.tabbox-cont {
  height: 378px;
}
@media screen and (max-width: 940px) {
  #wrap:not(.no-responsive) .tab__box li a {
    font-size: 16px;
  }
  #wrap:not(.no-responsive) .tabbox-cont {
    height: 211px;
  }
}

/* 일정별 - 탭영역 - 메모 */
.tabbox-cont .cont-memo {
  padding: 8px 16px 16px;
  height: calc(100% - 24px);
}
.tabbox-cont .cont-memo .memo-top {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 8px;
}
.tabbox-cont .cont-memo .memo-top .btn {
  width: 32px;
  height: 32px;
}
.tabbox-cont .cont-memo .memo-top .btn + .btn {
  margin-left: 4px;
}
.tabbox-cont .cont-memo .memo-box {
  display: flex;
  justify-content: flex-end;
  height: calc(100% - 40px);
  overflow-y: auto;
}
.tabbox-cont .cont-memo .memo-box textarea:read-only {
  width: 100%;
  height: 100%;
  font-weight: 400;
  font-size: 15px;
  line-height: 2.1;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  border: 0;
  padding: 0;
  background: #fff;
}
.tabbox-cont .cont-memo .memo-box p {
  width: 100%;
  font-weight: 400;
  font-size: 15px;
  line-height: 2.1;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.tabbox-cont .cont-memo.nodata .memo-box {
  display: none;
}
.tabbox-cont .cont-memo.nodata .nodata__txt {
  margin: 0 auto;
  height: auto;
}
/* 일정별 - 탭영역 - 월별일정,미이행항목 */
.tabbox-cont .cont-tbl {
  height: 100%;
  overflow-y: auto;
}
.tbl-list:not(.row) tr:hover td,
.tbl-list:not(.row) tbody tr:nth-child(even):hover td {
  background: #e6f0ff;
}
.tbl-list:not(.row) tr:active td,
.tbl-list:not(.row) tbody tr:nth-child(even):active td {
  background: #b4d2ff;
}

.tabbox-cont .cont-tbl .tbl-list td {
  padding: 0 4px;
  height: 54px;
  text-align: center;
  margin: 0 auto;
  border-bottom: 1px solid #dde2e9;
  cursor: pointer;
}
.tabbox-cont .cont-tbl .tbl-list table td .ellipsis {
  width: 90px;
  margin: 0 auto;
}
.tabbox-cont .cont-tbl .tbl-list tbody tr:nth-child(even) td {
  background: #fff;
}
.tabbox-cont .cont-tbl .tbl-list td img {
  width: 16px;
  height: 16px;
  margin-left: 4px;
}

/* 일정별 - 목록영역 */
.body-right {
  width: calc(100% - 340px);
}
.body-right .right-top {
  padding: 24px;
  height: 33px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #dde2e9;
}
.body-right .right-top .tit {
  font-weight: 500;
  font-size: 20px;
  line-height: 1.2;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.body-right .right-top .tab__toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f8fa;
  border-radius: 16px;
  padding: 4px;
}
.body-right .right-top .tab__toggle li a {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  height: 26px;
  font-weight: 400;
  font-size: 14px;
  line-height: 1;
  text-align: center;
  color: #2c364e;
  border-radius: 45px;
  background: #f7f8fa;
}
.body-right .right-top .tab__toggle li.on a {
  font-weight: 500;
  color: #fff;
  background: #2c364e;
}
.body-right .right-bottom {
  padding: 38px 24px 24px;
}
.body-right .right-bottom .tbl-list table tr:hover td {
  background: #e6f0ff;
}
.body-right .right-bottom .tbl-list table tr:active td {
  background: #e6f0ff;
}
/* 일정별 - 목록영역 - 테이블 유형컬러 */
.body-right .right-bottom .tbl-list table td span.ehc,
.body-right .right-bottom .tbl-list table td span.jig,
.body-right .right-bottom .tbl-list table td span.etc {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}
.body-right .right-bottom .tbl-list table td span.ehc:before {
  content: "";
  display: block;
  position: absolute;
  left: -8px;
  width: 4px;
  height: 32px;
  background: #0f5fa5;
}
.body-right .right-bottom .tbl-list table td span.jig:before {
  content: "";
  display: block;
  position: absolute;
  left: -8px;
  width: 4px;
  height: 32px;
  background: #00dacd;
}
.body-right .right-bottom .tbl-list table td span.etc:before {
  content: "";
  display: block;
  position: absolute;
  left: -8px;
  width: 4px;
  height: 32px;
  background: #ff9900;
}
/* 일정별 - 목록영역 - 유형선택레이어 */
.tbl-list table th.select-cate {
  position: relative;
}
.tbl-list table th.select-cate span {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.tbl-list table th.select-cate span:after {
  content: "";
  width: 7px;
  height: 6px;
  margin-left: 10px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_87___}) no-repeat right center;
  background-size: 100%;
}
.popup-cate {
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 128px;
  height: auto;
  position: absolute;
  top: 28px;
  left: 0;
  background: #fff;
  border-radius: 4px;
  filter: drop-shadow(0px 8px 12px rgba(122, 133, 150, 0.5));
  z-index: 2;
}
.popup-cate.open {
  display: flex;
}
.popup-cate li {
  display: flex;
  align-items: center;
  width: calc(100% - 28px);
  flex: 1;
  padding: 5px 14px;
}
.popup-cate input[type="checkbox"] + label {
  font-size: 15px;
  letter-spacing: -0.004em;
  color: #19181a;
}
.popup-cate li:first-child {
  padding-top: 8px;
}
.popup-cate li:last-child {
  padding-bottom: 9px;
}
.popup-cate li:hover {
  background: #e6f0ff;
  border-radius: 0;
}
.popup-cate li:first-child:hover,
.popup-cate li:first-child {
  border-radius: 4px 4px 0 0;
}
.popup-cate li:last-child:hover,
.popup-cate li:last-child {
  border-radius: 0 0 4px 4px;
}
.popup-cate li:active,
.popup-cate li.checked {
  background: #b4d2ff;
  border-radius: 0;
}
.popup-cate li:active:hover,
.popup-cate li.checked:hover {
  background: #b4d2ff;
}
.popup-cate li.checked label span {
  color: #0a78ff;
  font-weight: 700;
  letter-spacing: -0.01em;
}
.tbl-list table th.select-cate .popup-cate span:after {
  content: none;
}
.tbl-list table th.select-cate .popup-cate input[type="checkbox"]:checked + label:after,
.tbl-list table th.select-cate .popup-cate input[type="checkbox"] + label:before {
  top: 4px;
  left: 0;
}

@media screen and (min-width: 1651px) and (max-width: 1820px) {
  .body-right {
    flex: 1;
    width: 100%;
  }
}
@media screen and (min-width: 500px) and (max-width: 1280px) {
  .body-right {
    flex: 1;
    width: 100%;
  }
}
@media screen and (max-width: 940px) {
  .body-right {
    border-top: 1px solid #dde2e9;
    padding-top: 16px;
    width: 100%;
  }
  .body-right .right-top {
    padding: 16px 20px;
  }
  .body-right .right-bottom {
    padding: 16px 20px;
  }
  .tabbox-cont .cont-memo {
    padding: 10px 20px 18px;
    height: calc(100% - 28px);
  }
  .tabbox-cont .cont-memo .memo-top {
    justify-content: flex-start;
  }
  .tabbox-cont .cont-memo .memo-top .m-block.title {
    width: auto;
    flex: 1;
    font-size: 16px;
    font-weight: 700;
    color: #0978ff;
    line-height: 1.2;
    letter-spacing: -0.4px;
  }
  .tabbox-cont .cont-memo .memo-box {
    height: calc(100% - 48px);
  }
  .tabbox-cont .cont-memo .memo-box p {
    font-size: 16px;
    line-height: 2;
  }
  #wrap:not(.no-responsive) .left-bottom .tabbox-cont {
    height: 100%;
  }
}
@media screen and (max-width: 499px) {
  .body-right .right-top .tit {
    font-size: 19px;
    letter-spacing: -1px;
  }
  .body-right .right-top .tab__toggle li a {
    padding: 0 10px;
    letter-spacing: -1px;
  }
}

/* 설비별 - 설비추가 팝업 */
.locate {
  background: #f4f6f8;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  margin: -16px -16px 0;
}
.locate li {
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.locate li:before {
  content: "";
  width: 16px;
  height: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_88___}) no-repeat center center;
  background-size: 100%;
}
.locate li:first-child:before {
  content: none;
}

/* 점검진행 */
.float-page header {
  background-color: #2c364e;
}
.float-page header .header__title {
  width: auto;
  height: auto;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_79___}) no-repeat 0 center;
  background-size: 24px 24px;
  padding-left: 32px;
  margin-left: 12px;
}
.float-page header .header__title.bg-no {
  background: none;
  padding-left: 0;
  margin-left: 0;
}
.float-page header .header__title span {
  font-weight: 400;
  font-size: 18px;
  line-height: 1;
  padding-left: 16px;
}
.float-page header .header__title strong {
  font-weight: 700;
}
.float-page .header__etc {
  margin-right: 16px;
}
.float-page .header__etc li {
  width: auto !important;
  height: auto;
  font-weight: 400;
  font-size: 18px;
  line-height: 1;
  letter-spacing: -0.6px;
  color: #ffffff;
}
.float-page .header__etc li button {
  width: 117px;
  height: 34px;
  font-weight: 700;
  font-size: 16px;
  line-height: 1;
  letter-spacing: -0.4px;
  color: #ffffff;
  background: rgba(144, 159, 183, 0.2);
  border-radius: 4px;
  border: 0;
  margin-left: 16px;
}
@media screen and (max-width: 940px) {
  .float-page .header__etc li.date {
    display: none;
  }
  .float-page .container .treebar__toggleBtn.active {
    border-bottom: 0;
  }
  .float-page .container .treebar__toggleBtn p span:last-child {
    margin-left: 5px;
  }
  .float-page .container .treebar__toggleBtn p span {
    font-weight: 400;
    margin-left: 11px;
  }
}
@media screen and (max-width: 768px) {
  .float-page header {
    background-color: #2c364e;
  }
  .float-page.onepage header {
    padding-top: 47px;
    padding-bottom: 5px;
  }
  .float-page .header__etc {
    margin-right: 0;
  }
  .float-page .header__etc li.date {
    display: none;
  }
  .float-page .header__etc li button.btn-close {
    width: 36px;
    height: 36px;
    font-size: 0;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_80___}) no-repeat center center;
    background-size: 100%;
  }
}
@media screen and (max-width: 679px) {
  .float-page .container {
    margin: 102px 0 0 0;
  }
  .float-page .container .treebar__toggleBtn {
    top: 102px;
  }
  .float-page header {
    justify-content: space-between;
    padding: 47px 10px 5px 20px;
    width: calc(100% - 30px);
  }
  .float-page header .header__left {
    width: calc(100% - 50px);
  }
  .float-page header .header__title {
    background: none;
    padding-left: 0;
    margin-left: 0;
    width: 100%;
  }
  .float-page header .header__title strong {
    display: none;
  }
  .float-page header .header__title span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    width: 100%;
    display: inline-block;
    padding-left: 0;
    text-align: left;
  }
  .float-page header .header__right {
    margin-right: 0;
  }
}

/* 점검진행 - 왼쪽 메뉴 */
.float-page .treebar.box.menutype {
  width: 304px;
  overflow-y: hidden;
}
.float-page .treebar.box.menutype .box__header {
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  height: 89px;
  padding: 18px 12px 12px 20px;
  border-bottom: 1px solid #dde2e9;
}
.float-page .treebar.box.menutype .box__header .title-info {
  display: flex;
  gap: 20px;
  width: 100%;
  margin-right: 8px;
  font-weight: 400;
  margin-top: 4px;
  margin-bottom: 0;
}
.float-page .treebar.box.menutype .box__header .title-info span:first-child {
  max-width: calc(100% - 83px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
.float-page .treebar.box.menutype .box__header .title-info span + span {
  flex: 1;
  max-width: 63px;
}
.float-page .treebar.box.menutype .box__header .list-info {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  width: 100%;
  margin-top: 30px;
}
.float-page .treebar.box.menutype .box__header .list-info span {
  display: flex;
  align-items: center;
}
.float-page .treebar.box.menutype .box__header .list-info span:before {
  content: "";
  width: 10px;
  height: 10px;
  margin-right: 8px;
  background: #0a78ff;
  border-radius: 50%;
}
.float-page .treebar.box.menutype .box__header .list-info span.not::before {
  background: #f55547;
}
.float-page .treebar.box.menutype .manuarea {
  overflow-y: auto;
  height: calc(100% - 120px);
}
.float-page .treebar.box.menutype .manuarea .manulist li {
  height: 45px;
  border-bottom: 1px solid #dde2e9;
}
.float-page .treebar.box.menutype .manuarea .manulist li a {
  padding: 0 24px 0 20px;
  margin-right: 11px;
  height: 100%;
  display: flex;
  align-items: center;
}
.float-page .treebar.box.menutype .manuarea .manulist li a.ok::before {
  content: "";
  width: 10px;
  height: 10px;
  background: #0a78ff;
  border-radius: 50%;
}
.float-page .treebar.box.menutype .manuarea .manulist li a.not::before {
  content: "";
  width: 10px;
  height: 10px;
  background: #f55547;
  border-radius: 50%;
}
.float-page .treebar.box.menutype .manuarea .manulist li:hover {
  background: #e8f1fe;
}
.float-page .treebar.box.menutype .manuarea .manulist li.on {
  background: #b4d2ff;
}
.float-page .treebar.box.menutype .manuarea .manulist li.on a p {
  color: #0a78ff;
  font-weight: 700;
}
.float-page .treebar.box.menutype .manuarea .manulist li a.not p,
.float-page .treebar.box.menutype .manuarea .manulist li a.ok p {
  margin-left: 16px;
}
.float-page .treebar.box.menutype .manuarea .manulist li a p {
  display: block;
  width: calc(100% - 20px);
  margin-left: 26px;
  font-weight: 400;
  font-size: 14px;
  line-height: 1;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.float-page .treebar.box.menutype .manuarea .manulist li.gas a {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_89___}) no-repeat center right;
  background-size: 24px;
}
.float-page .treebar.box.menutype .manuarea .manulist li.on.gas a {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_90___}) no-repeat center right;
  background-size: 24px;
}

/* 점검진행 - 점검하기 */
.float-page .content {
  width: calc(100% - 304px);
}
.float-page .box__header {
  padding: 24px;
}
.float-page .box__header h2 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 20px;
  line-height: 1.2;
  letter-spacing: -1px;
}
.float-page .box__header h2 strong {
  font-weight: 700;
}
.float-page .box__body {
  height: calc(100% - 153px);
}
.float-page .box__body .flex-row.m-m24 {
  height: calc(100% + 48px);
}
.float-page .body-left + .body-right {
  border-left: 1px solid #dde2e9;
}
.float-page .body-left + .body-right.m-popup.m-hidden .box__header {
  display: none;
}
.float-page .body-left {
  position: relative;
  width: auto;
  flex: 1.65;
  flex-direction: column;
  gap: 16px;
  padding: 16px 14px 24px;
  width: calc(100% - 28px);
  height: calc(100% - 40px);
}
.float-page .body-right {
  width: auto;
  flex: 1;
  height: 100%;
  overflow: hidden;
}
.float-page .txt-info {
  font-size: 16px;
  line-height: 1.25;
  letter-spacing: -0.4px;
  color: #7a8596;
}
.float-page .txt-info.icon {
  padding-left: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_91___}) no-repeat 0 1px;
  background-size: 16px;
}
.float-page .body-left .left-top {
  width: calc(100% - 10px);
  height: calc(100% - 150px);
  padding: 5px;
  background: none;
  flex: none;
}
.scorebox-list {
  width: calc(100% - 20px);
  height: calc(100% - 10px);
  padding: 5px 15px 5px 5px;
  overflow-y: auto;
  overflow-x: hidden;
}
.scorebox-list .scorebox {
  display: flex;
  align-items: center;
  padding: 16px 24px;
  width: calc(100% - 48px);
  background: #ffffff;
  border: 2px solid #ffffff;
  border-radius: 10px;
  filter: drop-shadow(0px 0px 2px #909fb7);
}
.scorebox-list .scorebox + .scorebox {
  margin-top: 12px;
}
.scorebox-list .scorebox .score {
  display: flex;
  align-items: center;
  flex: 1;
  font-weight: 400;
  font-size: 20px;
  line-height: 1.3;
  letter-spacing: -0.4px;
  color: #909fb7;
}
.scorebox-list .scorebox .score::before {
  content: "";
  width: 20px;
  height: 20px;
  margin-right: 10px;
  margin-left: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_92___}) no-repeat center center;
  background-size: 100%;
}
.scorebox-list .scorebox:hover {
  background: #e8f1fe;
}
.scorebox-list .scorebox:active {
  background: #b4d2ff;
}
.scorebox-list .scorebox.selected {
  border-color: #0a78ff;
}
.scorebox-list .scorebox:hover .score,
.scorebox-list .scorebox:active .score,
.scorebox-list .scorebox.selected .score {
  color: #0a78ff;
  font-weight: 500;
}
.scorebox-list .scorebox:hover .score::before,
.scorebox-list .scorebox:active .score::before,
.scorebox-list .scorebox.selected .score::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_93___}) no-repeat center center;
  background-size: 100%;
}
.scorebox-list .scorebox .score-list {
  flex: 4;
}
.scorebox-list .scorebox .score-list li {
  font-weight: 350;
  font-size: 16px;
  line-height: 1.7;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  display: flex;
}
.scorebox-list .scorebox .score-list li:before {
  content: "";
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #2a2c2f;
  margin: 12px 10px 0 0;
}
.scorebox-list .scorebox .score-list li span {
  width: calc(100% - 14px);
}
.float-page .body-left .left-bottom {
  position: absolute;
  bottom: 24px;
  left: 0;
  height: auto;
  width: 100%;
  gap: 16px;
  display: flex;
  flex-direction: column;
  background: none;
}
.float-page .progress-area {
  position: relative;
  height: 6px;
  width: 100%;
  border-bottom: 1px solid #dde2e9;
}
.float-page .progress-area progress {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
  -webkit-appearance: none;
  appearance: none;
  color: #0a78ff;
  background-color: #f7f8fa;
}
progress::-webkit-progress-bar {
  background-color: #f7f8fa;
}
progress::-webkit-progress-value {
  background-color: #0a78ff;
}
.float-page .body-right .tab__line {
  padding: 0 10px;
  width: calc(100% - 20px);
}
.float-page .body-right .tab__line li {
  padding: 12px 14px 11px;
}
.float-page .body-right .tab__line li a {
  font-size: 16px;
}
.float-page .body-right .tab__line li.on a,
.float-page .body-right .tab__line li.on {
  font-weight: 700;
}
.float-page .body-right .right-bottom {
  padding: 24px;
  height: calc(100% - 91px);
}
.float-page .body-right .tab-content {
  height: 100%;
  overflow-y: auto;
  margin-right: -10px;
  padding-right: 10px;
  overflow-x: hidden;
}
.float-page .body-right .tab-content .tit,
.imgbox-area .tit {
  font-weight: 500;
  font-size: 16px;
  line-height: 1.3;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  margin-bottom: 14px;
}
.float-page .body-right .imgbox-area {
  height: calc(100vh - 272px);
}
.float-page .body-right .imgbox-area li + li,
.imgbox-area li + li {
  margin-top: 24px;
}
.float-page .body-right .imgbox-area .txt,
.imgbox-area .txt {
  font-weight: 400;
  font-size: 15px;
  line-height: 1.6;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  margin-top: 8px;
}
.float-page .body-right .img-area,
.img-area {
  display: flex;
  gap: 8px;
  /* height: 368px; */
  height: 300px;
  overflow-x: auto;
}
.float-page .body-right .img-area video,
.img-area video {
  width: 100%;
}
ul.img-area li {
  height: 100%;
  /* width: 367px; */
  width: 372px;
  background: #f7f8fa;
  text-align: center;
}
ul.img-area li + li {
  margin-top: 0;
}
ul.img-area li img {
  object-fit: contain;
  height: 100%;
  width: 372px;
  /* width: auto; */
}
ul.img-area.video,
.float-page .body-right ul.img-area.video {
  width: 100%;
  height: auto;
  flex-direction: column;
  gap: 20px;
}
ul.img-area.video li {
  width: 100%;
  height: auto;
}
ul.img-area.video li video {
  width: 100%;
  object-fit: cover;
}
.float-page .body-right .img-area img,
.img-area img {
  object-fit: cover;
}
.float-page .body-right .img-area.more-img img,
.img-area.more-img img {
  width: 272px;
  object-fit: cover;
}

.float-page .body-right .tab-content textarea {
  height: 50vh;
  overflow-y: scroll;
  font-weight: 400;
  font-size: 16px;
  line-height: 2;
  letter-spacing: -0.4px;
  border-color: #dde2e9;
}
.float-page .body-right .tab-content .btn-basic {
  width: 120px;
  height: 40px;
}
.float-page .body-right .tab-content .btn-basic span {
  font-size: 16px;
  font-weight: 700;
}
.float-page .body-right .tab-content .form__input li .tit {
  flex: 1;
  min-width: 100px;
}
.float-page .body-right .tab-content .form__input .input__area {
  flex: 3;
  max-width: 400px;
}
.float-page .body-right .tab-content .form__input .filebox .upload-name {
  height: 38px;
}
.float-page .body-right .tab-content .form__input input[type="text"],
.float-page .body-right .tab-content .form__input input[type="password"],
.float-page .body-right .tab-content .form__input input[type="tel"],
.float-page .body-right .tab-content .form__input input[type="file"],
.float-page .body-right .tab-content .form__input .box__search input[type="text"],
.float-page .body-right .tab-content .form__input .select {
  height: 38px;
}
.float-page .body-right .tab-content .form__input .select {
  font-size: 16px;
}
.float-page .body-right .tab-content .form__input .input__area .txt-info,
.form__input .input__area .txt-info {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: -0.48px;
  color: #909fb7;
  margin-top: 5px;
  margin-left: 0;
}
.float-page .body-right .tab-content .form__input .filelist,
.form__input .filelist {
  display: inline-table;
}
.float-page .body-right .tab-content .form__input .filelist li,
.form__input .filelist li {
  display: inline-flex;
  flex-direction: row !important;
  align-items: center !important;
  gap: 4px;
  margin-bottom: 4px;
}
.float-page .body-right .tab-content .form__input .filelist li .btn-delete,
.form__input .filelist li .btn-delete,
.form__input .labellist li .btn-delete {
  margin-left: 0;
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_94___}) no-repeat center center;
  background-size: 100%;
}
.float-page .body-right .tab-content .form__input .filelist li span,
.form__input .filelist li span {
  font-size: 14px;
  line-height: 20px;
}
.form__input .filelist li span {
  background-position: left 4px;
}
.float-page .body-right .tab-content .form__input .filelist li:not(:first-child) span,
.form__input .filelist li:not(:first-child) span {
  background: none;
}
.float-page .body-right .tab-content .imglist {
  margin-top: 40px;
  padding-top: 24px;
  border-top: 1px solid #dde2e9;
}
.float-page .body-right .tab-content .imglist .tit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.float-page .body-right .tab-content .imglist .imgbox-area {
  height: calc(100vh - 800px);
}
.float-page .body-right .tab-content .imglist .imgbox-area .tit {
  margin-bottom: 8px;
}
.float-page .body-right .tab-content .imglist .imgbox-area .img-area {
  height: 552px;
  width: 100%;
  overflow-x: hidden;
}
.float-page .body-right .tab-content .imglist .imgbox-area .img-area.js-open {
  cursor: pointer;
}
.float-page .body-right .tab-content .imglist .imgbox-area .img-area img {
  width: auto;
  height: 100%;
  object-fit: contain;
}
.float-page .body-right .tab-content .imglist .imgbox-area .tit .btn-area {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  width: 75px !important;
}
.float-page .body-right .tab-content .imglist .imgbox-area .tit .btn-area button {
  width: 32px;
  height: 32px;
}
.float-page .body-right .tab-content .imglist .imgbox-area .tit .btn-area button.btn-edit-g {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_68___}) no-repeat center center;
  background-size: 100%;
}
.float-page .body-right .tab-content .imglist .imgbox-area .tit .btn-area button.btn-delete-gr {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_95___}) no-repeat center center;
  background-size: 100%;
}
@media screen and (min-width: 941px) and (max-width: 1650px) {
  .float-page .body-right .box__header {
    padding: 3px 20px 5px 10px;
  }
  .float-page .body-right .tab__line {
    margin-top: 50px;
  }
  .float-page .body-left + .body-right.m-popup.popup-layer .right-bottom {
    height: calc(100% - 158px);
  }
}
@media screen and (max-width: 1650px) {
  .float-page .treebar.box.menutype {
    height: auto;
  }
  .float-page .content .box__header.flex-column {
    flex-direction: row !important;
  }
  .float-page .body-left .left-top .clicktab-list {
    display: flex;
    flex-direction: column;
    margin-top: 32px;
  }
  .float-page .body-left .left-top .clicktab-list li {
    display: flex;
    align-items: center;
    padding: 0 20px;
    height: 48px;
    font-weight: 500;
    font-size: 16px;
    line-height: 1;
    letter-spacing: -0.4px;
    color: #2a2c2f;
    border-top: 1px solid #dde2e9;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_96___}) no-repeat 98% center #fff;
    background-size: 32px;
    cursor: pointer;
  }
  .scorebox-list .scorebox {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    padding: 16px;
    width: calc(100% - 32px);
  }
  .scorebox-list .scorebox .score::before {
    margin-right: 8px;
    margin-left: 0;
  }
  .float-page .body-right.m-hidden {
    display: none;
  }
  .float-page .body-right .box__header {
    position: absolute;
    top: 0;
    width: calc(100% - 30px);
    background: #2c364e;
    border-bottom: 2px solid #dde2e9;
    z-index: 1;
  }
  .float-page .body-right .box__header .box__title {
    color: #fff;
    text-align: center;
    font-weight: 500;
    width: calc(100% - 40px);
  }
  .float-page .body-right .box__header .btn-prev {
    display: block;
    width: 40px;
    height: 40px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_97___}) no-repeat center center;
    background-size: 100%;
  }
  .float-page .body-left + .body-right.m-popup.popup-layer {
    width: 100% !important;
    border-radius: 0;
  }
  .float-page .body-right.m-popup.popup-layer .tab-content .form__input .input__area {
    max-width: unset;
  }
  .float-page .body-right.m-popup.popup-layer .tab-content .form__input li .tit {
    min-width: unset;
  }
}
@media screen and (max-width: 940px) {
  .float-page .body-right .box__header {
    padding: 47px 20px 5px 10px;
  }
  .float-page .body-right .tab__line {
    margin-top: 90px;
  }
  .float-page .body-left + .body-right.m-popup.popup-layer .right-bottom {
    height: calc(100% - 198px);
  }
  .float-page .content {
    width: 100%;
    padding-left: 0;
  }
  .float-page .treebar.box.active {
    top: 101px;
    z-index: 10;
  }
  .float-page .treebar.box.menutype .box__header {
    display: flex;
    height: auto;
    padding: 18px 20px 12px;
  }
  .float-page .treebar.box.menutype .box__header .box__title,
  .float-page .treebar.box.menutype .box__header .title-info {
    display: none;
  }
  .float-page .treebar.box.menutype .box__header .list-info {
    margin-top: 0;
  }
  .float-page .treebar.box.menutype .manuarea {
    height: calc(100vh - 202px);
  }
  .float-page .treebar.box.menutype .manuarea .manulist li {
    height: 58px;
  }
  .float-page .treebar.box.menutype .manuarea .manulist li a p {
    font-size: 16px;
  }
  .float-page .body-left .left-top {
    margin-bottom: 150px;
  }
  .float-page .body-left .left-bottom {
    position: fixed;
    bottom: 0;
    padding-bottom: 24px;
    background: #fff;
    z-index: 1;
  }
  .float-page .body-right .tab__line {
    gap: 1px;
  }
  .float-page .body-right .tab__line li {
    padding: 12px 0 11px;
  }
  .float-page .treebar.box.menutype + .content {
    margin-top: 52px;
  }
}
@media screen and (max-width: 679px) {
  .float-page .treebar.box.active {
    top: 153px;
  }
}

/* 점검진행 - 측정값 */
.float-page .body-left .tbl-list table th,
.float-page .body-left .tbl-list table td {
  font-size: 16px;
  padding-left: 40px;
  padding-right: 40px;
}
.float-page .body-left .tbl-list table tr.selected td {
  border-top: 2px solid #0a78ff;
  border-bottom: 2px solid #0a78ff;
  height: 36px;
}
.float-page .body-left .tbl-list table tr.selected td:first-child {
  border-left: 2px solid #0a78ff;
}
.float-page .body-left .tbl-list table tr.selected td:last-child {
  border-right: 2px solid #0a78ff;
  font-weight: 500;
  color: #0a78ff;
}
.float-page .body-left .tbl__top {
  justify-content: flex-start;
  gap: 16px;
}
.float-page .body-left .tbl__top span {
  font-weight: 500;
  font-size: 20px;
  line-height: 1.2;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.float-page .body-left .tbl__top span.disabled {
  color: #f0f2f4;
  font-weight: 400;
  background: none;
  border: none;
}
.float-page .body-left .tbl__top span.input-value {
  color: #0a78ff;
}
.float-page .body-left .value-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -5%;
  height: 35%;
}
.float-page .body-left .value-box .form__input {
  width: 100%;
}
.float-page .body-left .value-box .form__input button {
  width: 170px;
}
.float-page .body-left .value-box .form__input button.btn-not {
  background: #ffffff;
  border: 2px solid #ffffff;
  filter: drop-shadow(0px 0px 2px #909fb7);
}
.float-page .body-left .value-box .form__input button.btn-not span {
  color: #909fb7;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
}
.float-page .body-left .value-box .form__input button.btn-not span::before {
  content: "";
  width: 20px;
  height: 20px;
  margin-right: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_98___}) no-repeat center center;
  background-size: 100%;
}
.float-page .body-left .value-box .form__input button.btn-not:hover {
  background: #feeeed;
}
.float-page .body-left .value-box .form__input button.btn-not:hover span {
  color: #e53f31;
  font-weight: 500;
}
.float-page .body-left .value-box .form__input button.btn-not:hover span::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_99___}) no-repeat center center;
  background-size: 100%;
}
.float-page .body-left .value-box .form__input button.btn-not.selected {
  background: #f5c6c1;
}
.float-page .body-left .value-box .form__input button.btn-not.selected span {
  color: #e53f31;
  font-weight: 500;
}
.float-page .body-left .value-box .form__input button.btn-not.selected span::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_99___}) no-repeat center center;
  background-size: 100%;
}
.float-page .body-left .value-box .form__input button,
.float-page .body-left .value-box .form__input input[type="text"] {
  height: 56px;
}
.float-page .body-left .value-box .form__input input[type="text"],
.float-page .body-left .value-box .form__input input[type="text"]::placeholder {
  font-size: 20px !important;
}
.float-page .body-left .value-box .form__input li {
  align-items: center;
}
.float-page .body-left .value-box .form__input li .tit {
  font-weight: 500;
  font-size: 20px;
  line-height: 1;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  flex: 1;
  margin-left: 16px;
  margin-top: 0;
}
.float-page .body-left .value-box .form__input .input__area {
  flex: 2.5;
  display: flex;
  gap: 12px;
}
.float-page .body-left .value-box .form__input .input__area .input-errortxt {
  top: 63px;
  font-size: 1rem;
}
.float-page .body-left .value-box.more {
  flex-direction: column;
  gap: 20px;
  height: auto;
  margin: 5% 0 40px;
}
.float-page .body-left .value-box.more .form__input {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 2%;
}
.float-page .body-left .value-box.more .form__input li {
  margin-top: 0;
  width: 49%;
}
.float-page .body-left .value-box.more .btn-area {
  width: 100%;
  justify-content: flex-end;
}
.float-page .body-left .value-box.more button {
  width: 170px;
  height: 56px;
}
.float-page .body-left .left-top textarea {
  border-color: #dde2e9;
  font-size: 16px;
  line-height: 2;
  height: 40vh;
}
.input-list {
  margin: 16px 0;
  padding: 20px 40px;
  background: #fff;
  border: 2px solid #0a78ff;
}
.input-list li {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 10%;
}
.input-list li:last-child {
  margin-bottom: 0;
}
.input-list li p {
  width: 45%;
  display: flex;
  align-items: center;
}
.input-list li p span {
  font-weight: 400;
  font-size: 16px;
  line-height: 1;
  letter-spacing: -0.7px;
  color: #2a2c2f;
  flex: 1;
}
.input-list li p span strong {
  font-weight: 500;
  font-size: 20px;
  color: #0a78ff;
}

@media screen and (max-width: 1650px) {
  .float-page .body-left .value-box {
    height: auto;
    margin: 2% 0 7%;
  }
  .float-page .body-left .value-box .form__input li {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  .float-page .body-left .value-box .form__input li .tit {
    margin-left: 0;
  }
}
@media screen and (max-width: 940px) {
  .float-page .body-left .value-box .form__input .input__area {
    flex-direction: column;
    flex: 1;
  }
  .float-page .body-left .value-box .form__input .input__area .btn-area {
    flex-direction: row-reverse;
    margin: 0;
    width: 100%;
  }
  .float-page .body-left .value-box .form__input .input__area .btn-area button {
    width: auto;
    flex: 1;
  }
  .float-page .body-left .value-box .form__input .input__area .btn-area button span {
    font-size: 20px;
  }
  .float-page .body-left .value-box .form__input .input__area .input-errortxt + .btn-area {
    margin-top: 20px;
  }
  .float-page .body-left .tbl__top {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .float-page .body-left .tbl__top span.tit {
    font-size: 16px;
    line-height: 1;
  }
  .float-page .body-left .tbl-list table th,
  .float-page .body-left .tbl-list table td {
    padding-left: 20px;
    padding-right: 20px;
  }
  .float-page .body-left .tbl-list table td {
    height: 40px !important;
  }
  .float-page .body-left .value-box.more .form__input {
    gap: 16px;
  }
  .float-page .body-left .value-box.more .form__input li {
    width: 100%;
  }
}

/* 점검진행 - 점검유형선택 */
#wrap.float-page.onepage {
  background: #fff !important;
}
.float-page.onepage .content {
  width: 100%;
  padding-left: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
}
.float-page.onepage .content .top {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.float-page.onepage .content .top:before {
  content: "";
  width: 350px;
  height: 136px;
  margin-bottom: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_100___}) no-repeat 0 center;
  background-size: 100%;
}
.float-page.onepage .content .top p {
  font-weight: 500;
  font-size: 18px;
  line-height: 1.4;
  text-align: center;
  letter-spacing: -0.4px;
  color: #646c74;
}
.float-page.onepage .content .top p.tit {
  font-weight: 400;
  font-size: 24px;
  line-height: 1.3;
  text-align: center;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  margin-top: 4px;
}
.float-page.onepage .content .bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
}
.float-page.onepage .content .bottom .form-area {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 350px;
}
.float-page.onepage .content .bottom a {
  font-weight: 500;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: -0.4px;
  color: #0a78ff;
}
.float-page.onepage .content .bottom a:hover {
  text-decoration: underline;
}
.float-page.onepage .content .bottom button,
.float-page .content .btn-area button {
  width: 100%;
  height: 48px;
  background: #0a78ff;
  border: 0;
  position: relative;
}
.float-page.onepage .content .bottom button:hover,
.float-page .content .btn-area button:hover {
  border-color: #0050b8;
  background-color: #0050b8;
}
.float-page.onepage .content .bottom button:active,
.float-page .content .btn-area button:active {
  border-color: #003876;
  background-color: #003876;
}
.float-page.onepage .content .bottom button span,
.float-page .content .btn-area button span {
  font-size: 20px;
  line-height: 1;
  color: #fff;
  font-weight: 700;
}
.float-page.onepage .content .bottom button.btn-back:before {
  content: "";
  position: absolute;
  left: 10px;
  width: 32px;
  height: 32px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_82___}) no-repeat center center;
  background-size: 100%;
}
.float-page.onepage .content .bottom button.btn {
  width: 40px;
  height: 40px;
}
.float-page.onepage .content .bottom button.btn.btn-add {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_101___}) no-repeat center center #0a78ff;
  background-size: 16px;
}
.float-page.onepage .content .bottom button.btn.btn-edit {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat center center #0a78ff;
  background-size: 45%;
}
.float-page.onepage .content .bottom button.btn-back.bg-white:disabled span {
  color: #e6f0ff !important;
}
.float-page.onepage .content .bottom button.btn-back.bg-white:disabled:before {
  opacity: 0.1;
}
.float-page .content .btn-area {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}
.float-page .content .btn-area button,
.float-page.onepage .content .bottom .btn-area button {
  width: 169px;
}
.float-page.onepage .content .bottom .select {
  height: 46px;
  font-size: 18px;
}
.float-page.onepage .content .bottom .select .selected {
  padding: 0 12px;
}
.float-page.onepage .content.step3 .bottom .form-area {
  gap: 24px;
}
.float-page.onepage .content .bottom .form-area .info-add {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.float-page.onepage .content .bottom .form-area .info-add .name {
  font-weight: 500;
  font-size: 20px;
  line-height: 1;
  letter-spacing: -0.8px;
  color: #2a2c2f;
}
.float-page.onepage .content .bottom .form-area .info-add.edit .name {
  flex: 1;
}
.float-page.onepage .content .bottom .form-area .info-add.edit .right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  flex: 1;
}
.float-page.onepage .content .bottom .form-area .info-add.edit .number {
  font-weight: 400;
  font-size: 20px;
  line-height: 1;
  text-align: right;
  letter-spacing: -0.4px;
  color: #0a78ff;
}
.float-page.onepage .content .bottom .form-area .info-add.edit .number strong {
  font-weight: 500;
  color: #2a2c2f;
}
.float-page.onepage .content .bottom .form-area .info-add-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  max-height: 212px;
}
.float-page.onepage .content .bottom .form-area .info-add-list li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
  border-bottom: 1px solid #dde2e9;
}
.float-page.onepage .content .bottom .form-area .info-add-list li .name {
  font-weight: 500;
  font-size: 18px;
  line-height: 1.3;
  color: #2a2c2f;
}
.float-page.onepage .content .bottom .form-area .info-add-list .btn-more {
  width: 32px;
  height: 32px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_96___}) no-repeat center center;
  background-size: 100%;
}
.float-page.onepage.onepage .content.step2-1 .top:before {
  content: none;
}
.float-page.onepage.onepage .content.step2-1 .bottom .tbl-list {
  width: 100%;
  max-width: 616px;
  max-height: 53vh;
  overflow-y: auto;
  overflow-x: hidden;
  border-bottom: 1px solid #dde2e9;
}
.float-page.onepage.onepage .content.step2-1 .bottom .tbl-list table {
  border-bottom: 0;
}
.float-page.onepage.onepage .content.step2-1 .bottom .tbl-list table th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
}
.float-page.onepage .content.step2-1 .bottom .tbl-list table td span.ehc,
.float-page.onepage .content.step2-1 .bottom .tbl-list table td span.jig,
.float-page.onepage .content.step2-1 .bottom .tbl-list table td span.etc {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}
.float-page.onepage .content.step2-1 .bottom .tbl-list table td span.ehc:before {
  content: "";
  display: block;
  position: absolute;
  left: -8px;
  width: 4px;
  height: 32px;
  background: #0f5fa5;
}
.float-page.onepage .content.step2-1 .bottom .tbl-list table td span.jig:before {
  content: "";
  display: block;
  position: absolute;
  left: -8px;
  width: 4px;
  height: 32px;
  background: #00dacd;
}
.float-page.onepage .content.step2-1 .bottom .tbl-list table td span.etc:before {
  content: "";
  display: block;
  position: absolute;
  left: -8px;
  width: 4px;
  height: 32px;
  background: #ff9900;
}
.float-page.onepage .content.step2-1 .bottom .tbl-list table td .btn-file {
  width: 0.563rem !important;
  height: 1.087rem !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_46___}) no-repeat center center !important;
  background-size: 100% !important;
  padding: 0;
}
.float-page.onepage .content.step2-1 .bottom .tbl-list table .tooltip-link::before {
  left: -5%;
}
.float-page .content .btn-area.sm-column .left {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}
@media screen and (max-width: 940px) {
  .float-page.onepage .content {
    margin: 84px 0;
  }
  .float-page .content .btn-area.sm-column {
    flex-direction: column;
    gap: 8px;
  }
  .float-page .content .body-left .left-bottom .btn-area.sm-column .right {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: relative;
  }
}
@media screen and (max-width: 499px) {
  .float-page.onepage .container {
    margin-top: 102px;
    min-height: calc(100vh - 102px);
  }
  .float-page.onepage .content {
    margin: 20px;
    min-height: calc(100vh - 145px);
    width: calc(100% - 40px);
  }
  .float-page.onepage .content .top p.tit {
    font-size: 20px;
  }
  .float-page.onepage .content .top p {
    font-size: 16px;
  }
  .float-page.onepage .content .bottom,
  .float-page.onepage .content .top,
  .float-page.onepage .content .bottom .form-area,
  .float-page .content .btn-area {
    width: 100%;
  }
  .float-page .content .btn-area button,
  .float-page.onepage .content .bottom .btn-area button {
    height: 40px;
  }
  .float-page:not(.onepage) .content .btn-area {
    width: calc(100% - 60px);
    margin: 0 30px;
  }
  .float-page.onepage .content .bottom button span,
  .float-page .content .btn-area button span {
    font-size: 16px;
  }
}

/* 점검결과 - 설비선택결과보기 */
.box.box-detailinfo .box-result {
  background: #fff;
  width: 100%;
  height: 100%;
}
.box.box-detailinfo .box-result .box__header {
  position: relative;
  height: 33px;
  width: 100%;
  padding: 0;
  margin-bottom: 15px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_102___}) no-repeat 0 0 #fff;
  background-size: 183px 32px;
  border-top: 1px solid #003875;
  border-bottom: 0;
}
.box.box-detailinfo .box-result .box__header .box__title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: none;
  padding-left: 20px;
}
.box.box-detailinfo .box-result .box__header .box__title span {
  font-weight: 500;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: -1px;
  color: #ffffff;
}
.box.box-detailinfo .box-result .box__header .box__title span.tit {
  display: flex;
  align-items: center;
  gap: 8px;
}
.box.box-detailinfo .box-result .box__header .box__title span.date {
  font-weight: 400;
  color: #2a2c2f;
}
.box.box-detailinfo .box__body .box-result section {
  padding: 16px 16px 0;
  background: #fff;
}
.box.box-detailinfo .box__body .box-result section::after {
  content: "";
  width: calc(100% + 92px);
  height: 1px;
  background: #dde2e9;
  margin: 48px -46px 16px;
  display: block;
}
.box.box-detailinfo .box__body .box-result section .section-top {
  margin-bottom: 30px;
  border-bottom: 2px solid #0f5fa5;
  padding-bottom: 8px;
}
.box.box-detailinfo .box__body .box-result section .section-top .tit {
  font-size: 20px;
  font-weight: 500;
}
.box.box-detailinfo .box__body .box-result section .section-bottom {
  border: 0;
  border-radius: 0;
  padding: 0;
}
.box.box-detailinfo .box__body .box-result section .section-bottom + .section-bottom {
  border-top: 2px solid #dde2e9;
  padding-top: 32px;
  margin-top: 32px;
}
.box.box-detailinfo .box__body .box-result section .section-bottom .part:not(.line) + .part:not(.line) {
  margin-top: 32px;
}
.box.box-detailinfo .box__body .box-result section .section-bottom .part.line {
  border-bottom: 2px solid #dde2e9;
  padding-bottom: 32px;
  margin-bottom: 32px;
}
.box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list {
  margin: 0;
  border-bottom: 2px solid #dde2e9;
}
.box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list th {
  height: 24px;
  padding: 4px 16px;
}
.box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list.row {
  border-top: 2px solid #dde2e9;
}
.box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list.row th {
  height: auto;
  padding: 12px 16px;
}
.box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list.td-40 td {
  height: auto;
  padding: 12px 16px;
  vertical-align: top;
}
.box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list td .btn {
  width: 24px;
  height: 24px;
  padding: 0;
}
.box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list.tbl-border {
  border-top: 1px solid #909fb7;
  border-bottom: 1px solid #909fb7;
  border-right: 1px solid #909fb7;
}
.box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list.tbl-border th {
  border-left: 1px solid #909fb7;
  padding: 4px 8px;
}
.box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list.tbl-border td {
  padding: 4px 8px;
  height: 39px;
  border-left: 1px solid #909fb7;
  border-top: 1px solid #909fb7;
  background: #fff !important;
}
.box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list.tbl-border td .ellipsis {
  width: 100%;
}
.box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list.tbl-border td .flex-inline .ellipsis {
  width: calc(100% - 26px);
}
.box.box-detailinfo .box__body .box-result section .section-bottom .tbl__top {
  margin-bottom: 12px;
}
.box.box-detailinfo .box__body .box-result section .section-bottom .tbl__top p.tit {
  font-weight: 500;
  color: #2a2c2f;
}
.box.box-detailinfo .box__body .box-result section .section-bottom .tbl__top p {
  font-weight: 350;
  color: #7a8596;
}
.box.box-detailinfo .box__body .box-result section .section-bottom .tbl__top .btn-area {
  margin-top: 0;
}
.score-info {
  display: flex;
  align-items: center;
}
.score-info:before {
  content: "";
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
}
.score-info.green:before {
  background: #1fc95c;
}
.score-info.orange:before {
  background: #ff7836;
}
.score-info.yellow:before {
  background: #ffbc0a;
}
.score-info.gray:before {
  background: #909fb7;
}
.box.box-detailinfo .box__body .box-result .tit-bar {
  margin-bottom: 16px;
  padding: 8px 16px;
  background: rgba(227, 231, 238, 0.5);
  font-weight: 400;
  font-size: 15px;
  line-height: 1.6;
  letter-spacing: -0.7px;
  color: #2a2c2f;
}
.box.box-detailinfo .box__body .box-result .detail-area {
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 0 16px 0;
}
.box.box-detailinfo .box__body .box-result .detail-area li {
  display: flex;
}
.box.box-detailinfo .box__body .box-result .detail-area li .tit {
  flex: 1;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.7;
  letter-spacing: -0.7px;
  color: #2a2c2f;
}
.box.box-detailinfo .box__body .box-result .detail-area li .txt-area {
  flex: 3.5;
}
.box.box-detailinfo .box__body .box-result .detail-area li .txt-area p {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.7;
  letter-spacing: -0.7px;
  color: #2a2c2f;
  word-wrap: break-word;
  text-align: justify;
}
.box.box-detailinfo .box__body .box-result .detail-area li .txt-area p .txt-gray {
  color: #7a8596 !important;
}
.box.box-detailinfo .box__body .box-result .detail-area li .img-area {
  margin-top: 8px;
  display: flex;
  gap: 8px;
  height: 300px;
  overflow-x: auto;
}
.box.box-detailinfo .box__body .box-result .detail-area li .img-area img {
  object-fit: cover;
}
.box.box-detailinfo .box__body .box-result .detail-area.line {
  border-top: 2px solid #dde2e9;
  border-bottom: 2px solid #dde2e9;
  padding: 16px;
}
.box.box-detailinfo .box__body .box-result section .section-bottom .tbl__top .btn.btn-more {
  position: relative;
  padding: 0;
  width: 32px;
  height: 32px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_103___}) no-repeat center center;
  background-size: 100%;
}
.box.box-detailinfo .box__body .box-result section .section-bottom .tbl__top .flex-right {
  width: auto !important;
  align-items: center;
}
.box.box-detailinfo .box__body .box-result section .section-bottom .tbl__top p strong {
  color: #2a2c2f;
  font-weight: 500;
}
.box.box-detailinfo .box__body .box-result .btn-area {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
}
.box.box-detailinfo .box__body .box-result .btn-area.m-block {
  display: flex !important;
}
.box.box-detailinfo .box__body .box-result .btn-area button.btn-basic {
  height: 40px;
  min-width: 140px;
}
.box.box-detailinfo .box__body .box-result .btn-area button.btn-basic span {
  font-size: 16px;
}
.box.box-detailinfo .box__body .box-result .total-score .score-top {
  border-bottom: 1px solid #e5e6ee;
  padding-bottom: 32px;
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
}
.box.box-detailinfo .box__body .box-result .total-score .score-top .tit {
  font-weight: 500;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: -0.4px;
  color: #ff7836;
}
.box.box-detailinfo .box__body .box-result .total-score .score-top .score {
  font-weight: 500;
  font-size: 40px;
  line-height: 1.2;
  letter-spacing: -0.4px;
  color: #2c364e;
  margin: 2px 0 14px;
}
.box.box-detailinfo .box__body .box-result .total-score .score-top .score span {
  color: #909fb7;
  font-weight: 400;
  font-size: 20px;
  margin-left: 3px;
}
.box.box-detailinfo .box__body .box-result .total-score .score-top .info {
  font-weight: 400;
  font-size: 18px;
  line-height: 1.4;
  letter-spacing: -1px;
  color: #2a2c2f;
  padding-left: 23px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_104___}) no-repeat -3px -1px;
  background-size: 26px;
}
.box.box-detailinfo .box__body .box-result .total-score .score-top.caution .info {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_105___}) no-repeat 0 3px;
  background-size: 18px;
}
.box.box-detailinfo .box__body .box-result .total-score .score-top .info .tit {
  font-size: 18px;
  line-height: 1.4;
  letter-spacing: -1px;
  color: #1fc95c;
  margin-right: 4px;
}
.box.box-detailinfo .box__body .box-result .total-score .score-top.caution .info .tit {
  color: #f55547;
}
.box.box-detailinfo .box__body .box-result .total-score .graph-area {
  padding: 16px;
}
.box.box-detailinfo .box__body .box-result .total-score .graph-area + .graph-area {
  margin-top: 30px;
}
.box.box-detailinfo .box__body .box-result .total-score .graph-area > div {
  height: 100% !important;
}

@media screen and (max-width: 499px) {
  .box.box-detailinfo .box-result .box__header {
    margin-top: -16px;
  }
  .box.box-detailinfo .box__body section + section {
    margin-top: 24px;
  }
  .box.box-detailinfo .box__body .box-result section .section-top .tit {
    font-size: 24px;
  }
  .box.box-detailinfo .box__body .box-result .total-score .score-top .score span {
    font-size: 44px;
  }
  .box.box-detailinfo .box__body .box-result .total-score .score-top .score span {
    font-size: 24px;
  }
  .box.box-detailinfo .box__body .box-result .total-score .score-top .info {
    font-size: 20px;
  }
  .box.box-detailinfo .box__body .box-result section .section-bottom .tbl__top {
    flex-direction: row;
    align-items: center;
  }
  .box.box-detailinfo .box__body .box-result section .section-bottom .tbl__top p {
    font-size: 20px;
  }
  .box.box-detailinfo .box__body .box-result section .section-bottom .tbl__top .btn-area .btn {
    width: 32px;
    height: 32px;
  }
  .box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list th {
    padding: 4px;
  }
  .box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list.td-40 td {
    padding: 12px 5px;
  }
  .box.box-detailinfo .box__body .box-result .tit-bar {
    font-size: 18px;
    padding: 10px 16px;
    margin-bottom: 24px;
  }
  .box.box-detailinfo .box__body .box-result .detail-area {
    gap: 40px;
  }
  .box.box-detailinfo .box__body .box-result .detail-area li .tit,
  .box.box-detailinfo .box__body .box-result .detail-area li .txt-area p {
    font-size: 16px;
  }
  .box.box-detailinfo .box__body .box-result .detail-area li {
    flex-direction: column;
    gap: 10px;
  }
  .box.box-detailinfo .box__body .box-result .detail-area li .img-area {
    height: 240px;
  }
  .box.box-detailinfo .box__body .box-result .btn-area button.btn-basic {
    min-width: auto;
    padding: 0 10px;
  }
}

/* 점검결과 - 설비선택결과보기 - 전체화면 */
.float-page .content.w100p {
  width: 100%;
  padding-left: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.float-page .content .box-result-top {
  width: 100%;
  margin-top: 4px;
}
.box-result-top .txt {
  color: #757d88;
  font-size: 20px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: -0.4px;
  margin-left: 32px;
  max-width: 50%;
}
.float-page .content .box-result-top .btn-area {
  gap: unset;
  justify-content: flex-end;
}
.float-page .content .box-result-top button {
  height: 32px;
  padding: 0 20px;
  min-width: 94px;
  width: auto;
}
.float-page .content .box-result-top button span {
  font-size: 15px;
  font-weight: 500;
}
.float-page .content .box-result-top button.bg-transparent {
  background: transparent;
}
.float-page .content .box-result-top button.bg-transparent span {
  color: #0a78ff;
}
.float-page .content .box-result {
  width: 55%;
  padding: 40px 20px 24px;
  background: #fff;
}
.float-page .content .box-result .box__header {
  position: relative;
  height: 33px;
  width: 100%;
  padding: 0;
  margin-bottom: 30px;
  /* background: url('../img/bg_top_result.png') no-repeat 0 0 #fff;
  background-size: 312px 32px; */
  border-top: 1px solid #003875;
  border-bottom: 0;
}
.float-page .content .box-result .box__header .box__title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: none;
  height: 34px;
}
.float-page .content .box-result .box__header .box__title span {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.4;
  color: #ffffff;
}
.float-page .content .box-result .box__header .box__title span.tit {
  display: flex;
  align-items: center;
  gap: 8px;
  width: auto;
  height: 100%;
  padding-left: 20px;
  padding-right: 45px;
  cursor: pointer;
  background: #003875;
  position: relative;
}
.float-page .content .box-result .box__header .box__title span.tit:after {
  content: "";
  position: absolute;
  right: -34px;
  top: 0;
  width: 0;
  height: 0;
  border-bottom: 17px solid transparent;
  border-top: 17px solid #003875;
  border-left: 17px solid #003875;
  border-right: 17px solid transparent;
}
.float-page .content .box-result .box__header .box__title span.tit span {
  max-width: calc(100% - 28px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.float-page .content .box-result .box__header .box__title span.tit .btn-edit {
  width: 24px;
  height: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_68___}) no-repeat center center;
  background-size: 100%;
  filter: brightness(0) invert(1);
}
.float-page .content .box-result .box__header .box__title span.date {
  font-weight: 400;
  color: #2a2c2f;
}
.float-page .content .box-result section {
  padding: 30px 20px 0;
  background: #fff;
}
.float-page .content .box-result section::after {
  content: "";
  width: calc(100% + 80px);
  height: 1px;
  background: #dde2e9;
  margin: 48px -40px 16px;
  display: block;
}
.float-page .content .box-result section .section-top {
  margin-bottom: 36px;
  border-bottom: 2px solid #0f5fa5;
  padding-bottom: 10px;
}
.float-page .content .box-result section .section-top .tit {
  font-size: 20px;
  font-weight: 500;
}
.float-page .content .box-result section .section-bottom {
  border: 0;
  border-radius: 0;
  padding: 0;
}
.float-page .content .box-result section .section-bottom + .section-bottom {
  border-top: 2px solid #dde2e9;
  padding-top: 32px;
  margin-top: 32px;
}
.float-page .content .box-result section .section-bottom .part:not(.line) + .part:not(.line) {
  margin-top: 32px;
}
.float-page .content .box-result section .section-bottom .part.line {
  border-bottom: 2px solid #dde2e9;
  padding-bottom: 40px;
  margin-bottom: 40px;
}
.float-page .content .box-result section .section-bottom .tbl-list {
  margin: 0;
  border-bottom: 2px solid #dde2e9;
}
.float-page .content .box-result section .section-bottom .tbl-list th {
  height: 24px;
  padding: 4px 16px;
}
.float-page .content .box-result section .section-bottom .tbl-list.row {
  border-top: 2px solid #dde2e9;
}
.float-page .content .box-result section .section-bottom .tbl-list.row th {
  height: auto;
  padding: 12px 16px;
  vertical-align: top;
}
.float-page .content .box-result section .section-bottom .tbl-list.row td {
  height: auto;
  padding: 12px 16px;
  vertical-align: top;
}
.float-page .content .box-result section .section-bottom .tbl-list.row td button.add__item {
  margin: -4px -16px;
  width: calc(100% + 32px);
  height: 40px;
  background: #e6f0ff;
  border-radius: 4px;
  border: 0;
  justify-content: flex-start;
}
.float-page .content .box-result section .section-bottom .tbl-list.row td button.add__item span {
  display: flex;
  align-items: center;
  color: #0a78ff;
}
.float-page .content .box-result section .section-bottom .tbl-list.row td button.add__item span:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_37___}) no-repeat center center;
  width: 12px;
  height: 12px;
  margin-right: 12px;
  background-size: 100%;
}
.float-page .content .box-result section .section-bottom .tbl-list.td-40 td {
  height: auto;
  padding: 12px 16px;
  vertical-align: top;
}
.float-page .content .box-result section .section-bottom .tbl-list td {
  height: auto;
  padding: 16px;
  vertical-align: top;
}
.float-page .content .box-result section .section-bottom .tbl-list td .btn {
  width: 24px;
  height: 24px;
  padding: 0;
}
.float-page .content .box-result section .section-bottom .tbl-list.tbl-border {
  border-top: 1px solid #909fb7;
  border-bottom: 1px solid #909fb7;
  border-right: 1px solid #909fb7;
}
.float-page .content .box-result section .section-bottom .tbl-list.tbl-border th {
  border-left: 1px solid #909fb7;
  padding: 4px 8px;
}
.float-page .content .box-result section .section-bottom .tbl-list.tbl-border td {
  padding: 6px 8px 5px;
  height: auto;
  border-left: 1px solid #909fb7;
  border-top: 1px solid #909fb7;
  background: #fff !important;
  line-height: 1.5;
}
.float-page .content .box-result section .section-bottom .tbl-list.tbl-border td .ellipsis {
  width: 100%;
}
.float-page .content .box-result section .section-bottom .tbl-list.tbl-border td .flex-inline .ellipsis {
  width: calc(100% - 26px);
}
.float-page .content .box-result section .section-bottom textarea {
  height: 170px;
}
.tbl-list table td.score-line {
  padding: 0 0 0 12px !important;
}
.tbl-list table td .score-line {
  padding: 0 !important;
}
.tbl-list table td .score-line ul + ul {
  margin-top: 16px;
}
.tbl-list table .score-line ul li {
  display: flex;
  min-height: 36px;
  vertical-align: middle;
}
.tbl-list table .score-line ul li span {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 0 12px;
}
.tbl-list table .score-line ul li + li {
  border-top: 2px solid #dde2e9;
}
.float-page .content .box-result section .section-bottom .tbl__top p.tit {
  font-weight: 500;
  color: #2a2c2f;
}
.float-page .content .box-result section .section-bottom .tbl__top p {
  font-weight: 350;
  color: #7a8596;
}
.float-page .content .box-result section .section-bottom .tbl__top .btn-area {
  margin-top: 0;
}
.float-page .content .box-result section .section-bottom .tbl__top .btn-area .btn {
  width: 32px;
  height: 32px;
}
.float-page .content .box-result section .section-bottom .tbl__top .btn-area .btn.btn-edit-g {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_68___}) no-repeat center center;
  background-size: 100%;
}
.float-page .content .box-result .tit-bar {
  margin-bottom: 20px;
  padding: 8px 20px;
  background: rgba(227, 231, 238, 0.5);
  font-weight: 400;
  font-size: 15px;
  line-height: 1.6;
  letter-spacing: -0.7px;
  color: #2a2c2f;
}
.float-page .content .box-result .detail-area {
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 0 20px 0;
}
.float-page .content .box-result .detail-area li {
  display: flex;
}
.float-page .content .box-result .detail-area li .tit {
  flex: 1;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.7;
  letter-spacing: -0.7px;
  color: #2a2c2f;
}
.float-page .content .box-result .detail-area li .txt-area {
  flex: 6;
  overflow: hidden;
}
.float-page .content .box-result .detail-area li .txt-area p {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.7;
  letter-spacing: -0.7px;
  color: #2a2c2f;
  word-wrap: break-word;
  text-align: justify;
}
.float-page .content .box-result .detail-area li .txt-area p .txt-gray {
  color: #7a8596 !important;
}
.float-page .content .box-result .detail-area li .img-area {
  margin-top: 8px;
  display: flex;
  gap: 8px;
  height: 300px;
  overflow-x: auto;
}
.float-page .content .box-result .detail-area li .img-area img {
  object-fit: cover;
  width: 300px;
}
.float-page .content .box-result .detail-area.line {
  border-top: 2px solid #dde2e9;
  border-bottom: 2px solid #dde2e9;
  padding: 20px;
}
.float-page .content .box-result section .section-bottom .tbl__top .btn.btn-more {
  position: relative;
  padding: 0;
  width: 32px;
  height: 32px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_103___}) no-repeat center center;
  background-size: 100%;
}
.float-page .content .box-result section .section-bottom .tbl__top .flex-right {
  width: auto !important;
  align-items: center;
}
.float-page .content .box-result section .section-bottom .tbl__top p strong {
  color: #2a2c2f;
  font-weight: 500;
}
.float-page .content .box-result .btn-area {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 16px 0 0;
}
.float-page .content .box-result .btn-area.m-block {
  display: flex !important;
}
.float-page .content .box-result .btn-area button.btn-basic {
  height: 48px;
  min-width: 219px;
  width: auto;
}
.float-page .content .box-result .btn-area button.btn-basic span {
  font-size: 20px;
}
.float-page .content .box-result .total-score .score-top {
  border-bottom: 1px solid #e5e6ee;
  padding-bottom: 40px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
}
/* .float-page .content .box-result .total-score .score-top .tit {
  font-weight: 500;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: -0.4px;
  color: #ff7836;
} */
.float-page .content .box-result .total-score .score-top .score {
  font-weight: 500;
  font-size: 44px;
  line-height: 1.2;
  letter-spacing: -0.4px;
  color: #2c364e;
  margin: 2px 0 14px;
}
.float-page .content .box-result .total-score .score-top .score span {
  color: #909fb7;
  font-weight: 400;
  font-size: 24px;
  margin-left: 3px;
}
.float-page .content .box-result .total-score .score-top .info {
  display: inline-flex;
  flex-wrap: wrap;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.4;
  letter-spacing: -1px;
  color: #2a2c2f;
  padding-left: 28px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_104___}) no-repeat 0 -2px;
  background-size: 28px;
}
.float-page .content .box-result .total-score .score-top.caution .info {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_106___}) no-repeat 0 -2px;
  background-size: 28px;
}
.float-page .content .box-result .total-score .score-top .info .tit {
  color: #1fc95c;
  margin-right: 8px;
}
.float-page .content .box-result .total-score .score-top.caution .info .tit {
  color: #f55547;
}
.float-page .content .box-result .total-score .score-top .info .txt {
  flex: 1;
}
.float-page .content .box-result .total-score .score-top .info-line {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 5px;
  gap: 20px;
}
.float-page .content .box-result .total-score .score-top .info-line p {
  color: #7a8596;
  font-size: 16px;
  line-height: 1.3;
}
.float-page .content .box-result .total-score .graph-box {
  /* height: 342px; */
  height: auto;
  display: flex;
  gap: 15px;
}
.float-page .content .box-result .total-score .graph-area {
  flex: 1.4;
}
.float-page .content .box-result .total-score .graph-area + .graph-area {
  flex: 1;
}

.float-page .content .box-result .detail-area.form__input {
  gap: 24px;
  padding: 0;
}
.float-page .content .box-result .detail-area.form__input li {
  margin: 0;
}
.float-page .content .box-result .form__input li .tit {
  flex: 1;
  min-width: 100px;
}
.float-page .content .box-result .form__input .input__area {
  flex: 7;
}
.float-page .content .box-result .form__input .filebox .upload-name {
  height: 30px;
}
.float-page .content .box-result .form__input input[type="text"],
.float-page .content .box-result .form__input input[type="password"],
.float-page .content .box-result .form__input input[type="tel"],
.float-page .content .box-result .form__input input[type="file"],
.float-page .content .box-result .form__input .box__search input[type="text"],
.float-page .content .box-result .form__input .select {
  height: 30px;
}
.float-page .content .box-result .form__input .select {
  font-size: 16px;
}
.float-page .content .box-result .form__input .input__area .txt-info {
  font-weight: 400;
  font-size: 14px;
  line-height: 15px;
  letter-spacing: -0.4px;
  color: #909fb7;
  margin-top: 5px;
  margin-left: 0;
}
.float-page .content .box-result .form__input .filelist {
  display: inline-table;
}
.float-page .content .box-result .form__input .filelist li {
  display: inline-flex;
  flex-direction: row !important;
  align-items: center !important;
  gap: 4px;
  margin-bottom: 4px;
}
.float-page .content .box-result .form__input .filelist li .btn-delete {
  margin-left: 0;
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_94___}) no-repeat center center;
  background-size: 100%;
}
.float-page .content .box-result .form__input .filelist li span {
  font-size: 14px;
  line-height: 1.7;
}
.float-page .content .box-result .form__input .filelist li:not(:first-child) span {
  background: none;
}
.float-page .content .box-result .imglist {
  margin-top: 40px;
  padding-top: 24px;
  border-top: 1px solid #dde2e9;
}
.float-page .content .box-result .imglist .tit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.float-page .content .box-result .imglist .imgbox-area {
  display: flex;
  gap: 14px;
  overflow-x: auto;
}
.float-page .content .box-result .imglist .imgbox-area li + li {
  margin: 0;
}
.float-page .content .box-result .imglist .imgbox-area .tit {
  margin-bottom: 8px;
}
.float-page .content .box-result .imglist .imgbox-area .img-area {
  height: 468px;
  width: 100%;
  overflow-x: hidden;
}
.float-page .content .box-result .imglist .imgbox-area .img-area.js-open {
  cursor: pointer;
}
.float-page .content .box-result .imglist .imgbox-area .img-area img {
  width: auto;
  height: 100%;
  object-fit: contain;
}
.float-page .content .box-result .imglist .imgbox-area .tit .btn-area {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  width: 75px !important;
  margin: 0;
}
.float-page .content .box-result .imglist .imgbox-area .tit .btn-area button {
  width: 32px;
  height: 32px;
}
.float-page .content .box-result .imglist .imgbox-area .tit .btn-area button.btn-edit-g {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_68___}) no-repeat center center;
  background-size: 100%;
}
.float-page .content .box-result .imglist .imgbox-area .tit .btn-area button.btn-delete-gr {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_95___}) no-repeat center center;
  background-size: 100%;
}

@media screen and (max-width: 1399px) {
  .float-page .content .box-result {
    width: 80%;
  }
}
@media screen and (max-width: 990px) {
  .float-page .content .box-result {
    width: 100%;
  }
}
@media screen and (max-width: 940px) {
  .float-page .content.w100p {
    margin-top: 0;
  }
  .float-page .content .box-result .m-none,
  .float-page .content .box-result-top .m-none {
    display: none !important;
  }
  .float-page .content .box-result .m-block:not(td),
  .float-page .content .box-result-top .m-block:not(td) {
    display: none !important;
  }
  #wrap:not(.no-responsive) .float-page .content .box-result section .section-bottom .tbl-list:not(.row) table td {
    height: auto;
    padding: 16px;
    vertical-align: top;
  }
  .float-page .content .box-result section .section-bottom .tbl-list td,
  .float-page .content .box-result section .section-bottom .tbl-list.row td,
  .float-page .content .box-result section .section-bottom .tbl-list.row th,
  .float-page .content .box-result section .section-bottom .tbl-list.td-40 td {
    height: auto !important;
    padding: 15px 16px 14px;
    vertical-align: top;
  }
  .float-page .content .box-result section .section-bottom .tbl-list.td-40 th {
    height: auto !important;
    padding: 11px 16px 10px;
    vertical-align: top;
  }
  .float-page .content .box-result section .section-bottom .tbl-list.tbl-border td {
    height: auto !important;
    padding: 12px 8px 11px;
    vertical-align: top;
  }
}
@media screen and (max-width: 840px) {
  .float-page .content.w100p {
    position: relative;
    margin-top: 0;
    background: #fff;
    gap: 0;
  }
  .float-page .content .box-result {
    width: calc(100% - 20px);
    padding: 0 10px 24px;
  }
  .float-page .content .box-result .m-none {
    display: none !important;
  }

  .float-page .content .box-result .m-block:not(td),
  .float-page .content .box-result-top .m-block:not(td) {
    display: block !important;
  }
  .float-page .content .box-result .m-block-w60p {
    width: 60%;
  }
  .float-page .content .box-result .m-block-w10p {
    width: 10%;
  }
  .float-page .content .box-result-top .txt {
    display: none;
  }
  .float-page .content .box-result-top .btn-area {
    display: none;
  }
  .float-page .content .box-result-top .btn-area.open {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 16px;
    position: absolute;
    background: #fff;
    top: 56px;
    left: 0;
    width: 100%;
    height: calc(100vh - 154px);
    margin: 0;
    z-index: 1;
  }
  .float-page .content .box-result-top .btn-area.open button {
    width: calc(100% - 40px);
    min-width: calc(100% - 40px);
    height: 48px;
  }
  .float-page .content .box-result-top .btn-area.open button:first-child {
    margin-top: 16px;
  }
  .float-page .content .box-result-top .btn-area.open button span {
    font-size: 20px;
  }
  .float-page .content .box-result-top .btn-area.open button + button {
    margin-left: 0;
  }
  .float-page .content .box-result-top .m-block button {
    justify-content: space-between;
    height: 52px;
    min-width: 100%;
    width: 100%;
    border-radius: 0;
    border: 0;
    border-bottom: 1px solid #dde2e9;
    background: #fff;
  }
  .float-page .content .box-result-top .m-block button:after {
    content: "";
    width: 24px;
    height: 24px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_107___}) no-repeat right center;
    background-size: 100%;
  }
  .float-page .content .box-result-top .m-block button.action:after {
    transform: scaleY(-1);
  }
  .float-page .content .box-result-top .m-block button span {
    color: #909fb7;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: -1px;
    text-align: left;
    width: calc(100% - 30px);
  }
  .float-page .content .box-result .box__header {
    margin-bottom: 10px;
  }
  .float-page .content section + section {
    margin-top: 24px;
  }
  .float-page .content .box-result section {
    padding: 30px 10px 0;
  }
  .float-page .content .box-result section .section-top .tit {
    font-size: 24px;
  }
  .float-page .content .box-result .total-score .score-top .score span {
    font-size: 44px;
  }
  .float-page .content .box-result .total-score .score-top .score span {
    font-size: 24px;
  }
  .float-page .content .box-result .total-score .score-top .info {
    font-size: 20px;
  }
  .float-page .content .box-result .total-score .score-top .info-line {
    margin-top: 20px;
    flex-direction: column;
  }
  .float-page .content .box-result .total-score .score-top .info-line button {
    width: 100%;
  }
  .float-page .content .box-result section .section-bottom .tbl__top {
    flex-direction: row;
    align-items: center;
  }
  .float-page .content .box-result section .section-bottom .tbl__top p {
    font-size: 20px;
  }
  .float-page .content .box-result section .section-bottom .tbl__top .btn-area {
    width: auto;
    margin: 0;
  }
  .float-page .content .box-result section .section-bottom .tbl__top .btn-area .btn {
    width: 32px;
    height: 32px;
  }
  .float-page .content .box-result section .section-bottom .tbl-list th {
    padding: 4px;
  }
  .float-page .content .box-result .tit-bar {
    font-size: 18px;
    padding: 10px 16px;
    margin-bottom: 24px;
  }
  .float-page .content .box-result .detail-area {
    gap: 40px;
  }
  .float-page .content .box-result .detail-area li .tit,
  .float-page .content .box-result .detail-area li .txt-area p {
    font-size: 16px;
  }
  .float-page .content .box-result .detail-area li {
    flex-direction: column;
    gap: 10px;
  }
  .float-page .content .box-result .detail-area li .img-area {
    height: 240px;
  }
  .float-page .content .box-result .total-score .graph-box {
    flex-direction: column;
    gap: 40px;
  }
  .float-page .content .box-result .total-score .graph-area {
    flex: auto;
  }
  .float-page .content .box-result .part.flex-row {
    flex-direction: column !important;
  }
  .float-page .content .box-result .part.flex-row.gap-20 {
    gap: 32px !important;
  }
  .float-page .content .box-result .detail-area.form__input {
    gap: 16px;
  }
}
@media screen and (max-width: 610px) {
  .float-page .content .box-result .m-block-w60p {
    width: 52%;
  }
}
@media screen and (max-width: 499px) {
  .float-page .content .box-result .btn-area {
    width: 100%;
    margin: 0;
  }
  /* .float-page .content .box-result .box__header {
    background: url('../img/bg_top_result_m.png') no-repeat 0 0 #fff;
    background-size: 77% 32px;
  } */
  .float-page .content .box-result .box__header .box__title span.tit {
    width: auto;
    max-width: 60%;
    padding-left: 11px;
    padding-right: 15px;
  }
  .float-page .content .box-result section .section-bottom textarea {
    height: 234px;
  }
  .float-page .content .box-result .form__input .filebox .upload-name,
  .float-page .content .box-result .form__input input[type="text"],
  .float-page .content .box-result .form__input input[type="password"],
  .float-page .content .box-result .form__input input[type="tel"],
  .float-page .content .box-result .form__input input[type="file"],
  .float-page .content .box-result .form__input .box__search input[type="text"],
  .float-page .content .box-result .form__input .select {
    height: 38px;
  }
  .float-page .content .box-result .detail-area.form__input .input__area .btn-basic {
    width: 100%;
  }
  .float-page .content .box-result .imglist .imgbox-area {
    flex-direction: column;
    gap: 20px;
  }
  .float-page .content .box-result .imglist .imgbox-area .img-area {
    height: auto;
  }
  .float-page .content .box-result .imglist .imgbox-area .img-area img {
    width: 100%;
  }
  .float-page .content .box-result .imglist .tit span {
    font-weight: 500;
  }
  .float-page .content .box-result .m-block-w60p {
    width: 37%;
  }
}

/* management - 체크시트 관리 - 상세유형  리스트  */
.content.w100p {
  width: 100%;
  padding-left: 0;
}
.content.w100p .tab__line li {
  padding: 15px 14px 14px;
}
.content.w100p .tab__line li a {
  font-size: 16px;
  font-weight: 500;
  color: #646c74;
}
.content.w100p .box {
  width: 100%;
}
.content.w100p .box .box-wrap,
.content.w100p .box .content-wrap {
  width: 100%;
}
.no-responsive .box-wrap {
  display: flex;
  height: calc(100% - 49px);
}
.no-responsive .treebar.box {
  width: 304px;
}
.no-responsive .treebar.box + .content-wrap {
  width: calc(100% - 304px);
  position: relative;
}
.tbl-list table td button.btn {
  width: 32px;
  height: 32px;
  background-size: 100%;
}
.tbl-list table td button.btn.btn-delete-gr {
  filter: none;
}
.tbl-list table td button.btn.btn-edit-g {
  background-size: contain;
}
.tbl-list table td button.btn.btn-comment {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_108___}) no-repeat center center;
  background-size: 100%;
}
.tbl-list table td button.btn.btn-comment:hover {
  opacity: 1 !important;
  filter: none !important;
}
.tbl-list table td button.btn.btn-comment.icon-gray {
  opacity: 1 !important;
  filter: none !important;
  background-color: unset !important;
  border-color: unset !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_109___}) no-repeat center center;
  background-size: 100%;
}

/* management - 체크시트 관리 - 왼쪽 메뉴 */
#wrap.no-responsive {
  min-width: 1580px;
  overflow-x: auto;
}
.no-responsive .treebar.box.menutype {
  display: block;
  width: 301px;
  overflow-y: hidden;
  box-shadow: none;
  border-right: 4px solid #dde2e9;
  border-radius: 0;
  height: calc(100vh - 115px);
  min-height: 964px;
}
.no-responsive .treebar.box.menutype .box__header {
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  height: auto;
  padding: 12px 15px 11px;
  border-bottom: 1px solid #dde2e9;
}
.no-responsive .treebar.box.menutype .box__header .title-info {
  font-weight: 400;
  margin-top: 4px;
  margin-bottom: 30px;
}
.no-responsive .treebar.box.menutype .box__header .title-info span + span {
  margin-left: 16px;
}
.no-responsive .treebar.box.menutype .box__header .list-info {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  width: 100%;
}
.no-responsive .treebar.box.menutype .box__header .list-info span {
  display: flex;
  align-items: center;
}
.no-responsive .treebar.box.menutype .box__header .list-info span:before {
  content: "";
  width: 10px;
  height: 10px;
  margin-right: 8px;
  background: #0a78ff;
  border-radius: 50%;
}
.no-responsive .treebar.box.menutype .box__header .list-info span.not::before {
  background: #f55547;
}
.no-responsive .treebar.box.menutype .manuarea {
  overflow-y: auto;
  height: calc(100% - 41px);
}
.no-responsive .treebar.box.menutype .manuarea .manulist li {
  height: 45px;
  border-bottom: 1px solid #dde2e9;
}
.no-responsive .treebar.box.menutype .manuarea .manulist li a {
  padding: 0 16px 0 20px;
  margin-right: 0;
  height: 100%;
  display: flex;
  align-items: center;
}
.no-responsive .treebar.box.menutype .manuarea .manulist li a.ok::before {
  content: "";
  width: 10px;
  height: 10px;
  background: #0a78ff;
  border-radius: 50%;
}
.no-responsive .treebar.box.menutype .manuarea .manulist li a.not::before {
  content: "";
  width: 10px;
  height: 10px;
  background: #f55547;
  border-radius: 50%;
}
.no-responsive .treebar.box.menutype .manuarea .manulist li:hover {
  background: #e8f1fe;
}
.no-responsive .treebar.box.menutype .manuarea .manulist li.on {
  background: #b4d2ff;
}
.no-responsive .treebar.box.menutype .manuarea .manulist li.on a p {
  color: #0a78ff;
  font-weight: 700;
}
.no-responsive .treebar.box.menutype .manuarea .manulist li a.not p,
.no-responsive .treebar.box.menutype .manuarea .manulist li a.ok p {
  margin-left: 16px;
}
.no-responsive .treebar.box.menutype .manuarea .manulist li a p {
  display: block;
  flex: 4;
  width: auto;
  margin-left: 26px;
  font-weight: 400;
  font-size: 14px;
  line-height: 1;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.no-responsive .treebar.box.menutype .manuarea .manulist li a .txt {
  flex: 1;
  color: #0a78ff;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.2;
  text-align: right;
}
.no-responsive .treebar.box.menutype .manuarea .manulist li.title-line:first-child {
  margin-top: 0;
}
.no-responsive .treebar.box.menutype .manuarea .manulist li.title-line {
  position: relative;
  margin-top: 24px;
  padding: 0 0 0 12px;
  margin-right: 0;
  display: flex;
  align-items: center;
  background: #f0f2f4;
}
.no-responsive .treebar.box.menutype .manuarea .manulist li.title-line p {
  width: calc(100% - 32px);
  font-weight: 700;
  font-size: 14px;
  line-height: 1;
  color: #2a2c2f;
}
.no-responsive .treebar.box.menutype .manuarea .manulist li.title-line .popup-etc {
  right: 2px;
  top: 37px;
}
.no-responsive .treebar.box.menutype .manuarea .manulist li.title-line .popup-etc li {
  height: auto;
  border-bottom: 0;
}
.no-responsive .treebar.box.menutype .manuarea .manulist li.title-line .popup-etc li button.btn-add-g {
  padding-left: 13px !important;
  background-position: 0 5px !important;
}
.no-responsive .treebar.box.menutype .manuarea .manulist li.title-line .popup-etc li button.btn-add-g:hover {
  border-radius: 4px;
}
.no-responsive .treebar.box.menutype .manuarea .manulist li.title-line .popup-etc li button.btn-add-g:active {
  border-radius: 4px;
}

/* management - 체크시트 관리 - 점검항목 리스트 */
.go-back {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 0;
  margin-right: 8px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_110___}) no-repeat center center;
  background-size: 100%;
}
.tbl-list table td .list-icon {
  width: 24px;
  height: 24px;
  vertical-align: middle;
}
.btn-guide {
  width: 32px;
  height: 32px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_111___}) no-repeat center center;
  background-size: 100%;
}
.tbl-list table td button.btn.btn-guide:hover {
  opacity: 1 !important;
  filter: none !important;
}
.tbl-list table td button.btn.btn-guide.icon-gray {
  opacity: 1 !important;
  filter: none !important;
  background-color: unset !important;
  border-color: unset !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_112___}) no-repeat center center;
  background-size: 100%;
}
.tbl-list table td ul.input__area {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.tbl-list table td ul.input__area li {
  display: flex;
  align-items: center;
}
.tbl-list table td .btn-add-wide {
  width: 100%;
  height: 40px;
  background: #e7f2ff;
  border-radius: 4px;
  border: 0;
  justify-content: flex-start;
}
.tbl-list table td .btn-add-wide span {
  color: #0978ff;
  display: flex;
  align-items: center;
}
.tbl-list table td .btn-add-wide span::before {
  content: "";
  width: 12px;
  height: 12px;
  margin-right: 12px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_37___}) no-repeat center center;
  background-size: 100%;
}
.go-back.tooltip-link::before {
  background: #fff;
  top: 90%;
  width: 140%;
  font-weight: 700;
  color: #646c74;
}
.float-page .body-left .left-bottom .btn-txt.next {
  position: absolute;
  right: 24px;
}
.float-page .body-left .left-bottom .btn-area.sm-column .right {
  position: absolute;
  right: 24px;
}
.float-page .body-left .left-bottom .btn-area.sm-column .right .btn-txt.next {
  position: relative;
}
.btn-txt.next span,
.float-page .content .btn-area button.btn-txt.next span {
  font-weight: 400;
  font-size: 16px;
  display: flex;
  align-items: center;
}
.btn-txt.next span:after {
  content: "";
  width: 16px;
  height: 16px;
  margin-left: 4px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat center center;
  background-size: 100%;
  transform: scaleX(-1);
}

/* Report - 점검결과 - 단일 유형별리스트*/
/* Report - 점검결과 - 단일 유형별리스트 - 왼쪽 메뉴(반응형) */
#wrap:not(.float-page, .no-responsive) .treebar.box {
  width: 282px;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype {
  display: block;
  width: 301px;
  overflow-y: hidden;
  box-shadow: none;
  border-right: 4px solid #dde2e9;
  border-radius: 0;
  height: calc(100vh - 115px);
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .box__header {
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  height: auto;
  padding: 12px 15px 11px;
  border-bottom: 1px solid #dde2e9;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .box__header .title-info {
  font-weight: 400;
  margin-top: 4px;
  margin-bottom: 30px;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .box__header .title-info span + span {
  margin-left: 16px;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .box__header .list-info {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  width: 100%;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .box__header .list-info span {
  display: flex;
  align-items: center;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .box__header .list-info span:before {
  content: "";
  width: 10px;
  height: 10px;
  margin-right: 8px;
  background: #0a78ff;
  border-radius: 50%;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .box__header .list-info span.not::before {
  background: #f55547;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea {
  overflow-y: auto;
  height: calc(100% - 41px);
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li {
  height: 45px;
  border-bottom: 1px solid #dde2e9;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li a {
  padding: 0 16px 0 20px;
  margin-right: 0;
  height: 100%;
  display: flex;
  align-items: center;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li a.ok::before {
  content: "";
  width: 10px;
  height: 10px;
  background: #0a78ff;
  border-radius: 50%;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li a.not::before {
  content: "";
  width: 10px;
  height: 10px;
  background: #f55547;
  border-radius: 50%;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist > li a:hover,
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea li.arrow:hover {
  background: #e8f1fe !important;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li.on,
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li.on a:hover,
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li.title-line.on,
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea li.arrow.on,
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li:active a {
  background: #b4d2ff !important;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li.on a p,
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li.title-line.on p {
  color: #0a78ff;
  font-weight: 700;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li a.not p,
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li a.ok p {
  margin-left: 16px;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li a p {
  display: block;
  flex: 4;
  width: auto;
  margin-left: 26px;
  font-weight: 400;
  font-size: 14px;
  line-height: normal;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li a .txt {
  flex: 1;
  color: #0a78ff;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.2;
  text-align: right;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li.title-line:first-child {
  margin-top: 0;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li.title-line {
  position: relative;
  margin-top: 24px;
  padding: 0 0 0 12px;
  margin-right: 0;
  display: flex;
  align-items: center;
  background: #f0f2f4;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li.title-line p {
  width: calc(100% - 32px);
  font-weight: 700;
  font-size: 14px;
  line-height: 1;
  color: #2a2c2f;
  margin-left: 8px;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li.arrow p {
  margin-left: 20px;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li.title-line .popup-etc {
  right: 2px;
  top: 37px;
}
#wrap:not(.float-page, .no-responsive) .selectbar.box.menutype {
  display: none;
}

@media screen and (max-width: 1650px) {
  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype {
    height: auto;
  }
}
@media screen and (max-width: 940px) {
  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype {
    display: none;
  }
  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype.active {
    display: block;
    top: 102px;
    z-index: 22;
  }
  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype.active {
    position: fixed;
    display: block;
    top: 154px;
    left: 0;
    width: 100%;
    border: 0;
    padding: 0;
    margin: 0;
    z-index: 21;
  }
  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype .box__header,
  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype .box__header {
    display: flex;
    height: auto;
    padding: 18px 20px 12px;
  }
  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype .box__header .box__title,
  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype .box__header .title-info {
    display: none;
  }
  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype .box__header .list-info {
    margin-top: 0;
  }
  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea {
    height: calc(100vh - 202px);
  }
  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li {
    height: 58px;
  }
  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li a p,
  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li.title-line p {
    font-size: 16px;
  }
  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype .manuarea {
    height: calc(100vh - 154px);
  }
  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype .manuarea .manulist li {
    height: 58px;
    border-bottom: 1px solid #dde2e9;
  }
  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype .manuarea .manulist li a {
    padding: 0 16px 0 20px;
    margin-right: 0;
    height: 100%;
    display: flex;
    align-items: center;
  }
  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype .manuarea .manulist li:hover {
    background: #e8f1fe;
  }
  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype .manuarea .manulist li.on {
    background: #b4d2ff;
  }
  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype .manuarea .manulist li.on a p {
    color: #0a78ff;
    font-weight: 700;
  }
  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype .manuarea .manulist li a p {
    display: block;
    flex: 4;
    width: auto;
    font-weight: 400;
    font-size: 16px;
    line-height: normal;
    letter-spacing: -0.4px;
    color: #2a2c2f;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
@media screen and (max-width: 679px) {
  /* .float-page .treebar.box.active {
    top: 153px;
  } */
}

/* Report - 점검결과 - 단일 유형별리스트 - 레이아웃 영역*/
#wrap:not(.no-responsive) .box-wrap {
  display: flex;
}
#wrap:not(.no-responsive) .treebar.box + .content-wrap {
  width: calc(100% - 304px);
}
#wrap:not(.no-responsive) .content-wrap .box__header {
  padding-bottom: 21px;
}
@media screen and (max-width: 940px) {
  #wrap:not(.no-responsive) .treebar.box + .content-wrap {
    width: 100%;
  }
}

/* Report - 점검결과 - 단일 유형별리스트 - 컨텐츠 영역*/
.score-info {
  display: flex;
  align-items: center;
}
.score-info:before {
  content: "";
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
}
.score-info.green:before {
  background: #1fc95c;
}
.score-info.orange:before {
  background: #ff7836;
}
.score-info.yellow:before {
  background: #ffbc0a;
}
.score-info.gray:before {
  background: #909fb7;
}
.score-level {
  padding-left: 18px;
}
.score-level.danger {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat 0 2px;
  background-size: 12px;
}
.score-level.safety {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat 0 2px;
  background-size: 12px;
}

/* 페이지 검색 영역 */
.tbl__top > .search {
  width: 100%;
}
.tbl__top > .search ul.form__input {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 3%;
  width: 100%;
}
.tbl__top > .search ul.form__input:has(.wmin-64) {
  justify-content: space-between;
}
.tbl__top > .search ul.form__input li {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin: 0;
}
.tbl__top > .search ul.form__input .input__area {
  width: auto;
}
.tbl__top > .search ul.form__input .input__area:has(.btn-basic.bg-sky) {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}
@media screen and (max-width: 940px) {
  .tbl__top > .search ul.form__input .input__area:has(.btn-basic.bg-sky) {
    align-items: normal;
    flex-direction: column;
  }
}
.tbl__top > .search ul.form__input li > span:not(.centerline) {
  min-width: 72px;
  margin-top: 8px;
  font-weight: 700;
  font-size: 15px;
  line-height: 1.1;
  color: #2a2c2f;
}
.tbl__top > .search ul.form__input li button.btn-basic {
  margin-left: 0;
}
.tbl__top > .search ul.form__input .input__area + button,
.tbl__top > .search ul.form__input .input__area + button.btn-basic {
  margin-left: -8px;
}
button.btn-basic.btn-more:after {
  content: "";
  width: 20px;
  height: 20px;
  margin-left: 4px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_113___}) no-repeat center center;
  background-size: 100%;
}

.tbl__top .right .inline-flex {
  width: 100%;
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px 12px;
}

@media screen and (max-width: 1599px) {
  .tbl__top > .search ul.form__input {
    gap: 10px 1%;
  }
}
@media screen and (max-width: 940px) {
  .tbl__top:not(.m-none) + .tbl__top {
    margin-top: 40px;
  }
  .tbl__top > .search ul.form__input li {
    width: 100%;
  }
  .tbl__top > .search ul.form__input .input__area {
    width: 100%;
  }
  .tbl__top > .search ul.form__input .input__area .select,
  .tbl__top > .search ul.form__input .input__area input[type="text"] {
    width: 100% !important;
    height: 38px;
  }
  .tbl__top > .search ul.form__input .input__area .searchterm .term__month {
    width: calc(100% - 2px) !important;
    height: 38px;
  }
  .tbl__top > .search ul.form__input {
    gap: 20px;
  }
  .tbl__top > .search ul.form__input li {
    gap: 10px;
  }
  .tbl__top > .search ul.form__input li > span:not(.centerline) {
    margin-top: 0;
  }
  .tbl__top > .search ul.form__input .input__area + button,
  .tbl__top > .search ul.form__input .input__area + button.btn-basic {
    margin-left: 0;
  }
  .tbl__top > .search ul.form__input li button.btn-basic {
    width: 100%;
  }
  .searchterm .term__month .selected {
    width: calc(100% - 0.6rem) !important;
  }
  .searchterm .term__month {
    width: calc(100% - 2px);
  }
  .searchterm {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }
  .searchterm .term__month + .term__date {
    width: 100%;
    margin-top: 8px;
    margin-left: 0;
  }
  .form__input .searchterm .term__date input[type="text"] {
    width: calc(100% - 51px);
    font-size: 14px;
    padding-left: 39px;
    background-position: 10px center;
  }
}

/* Report - 점검결과 - 단일 유형별리스트 - 오른쪽 팝업 영역 */
.popup-type3 .popup__body .check-area .check-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 16px;
  margin-bottom: 46px;
  border-bottom: 2px solid #dde2e9;
  border-radius: 0;
}
.popup-type3 .popup__body .check-area input[type="checkbox"] + label {
  padding-left: 26px;
}
.popup-type3 .popup__body .check-area input[type="checkbox"] + label:before {
  border-radius: 0;
  width: 12px;
  height: 12px;
  top: 4px;
}
.popup-type3 .popup__body .check-area input[type="checkbox"] + label:after {
  top: 4px;
}
input[type="checkbox"]:checked + label:after {
  width: 12px;
  height: 12px;
}
.popup-type3 .popup__body .check-area .check-top input[type="checkbox"] + label {
  font-size: 16px;
  font-weight: 500;
}
.popup-type3 .popup__body .check-area .check-list section > input[type="checkbox"] + label {
  font-size: 16px;
  font-weight: 500;
}
.popup-type3 .popup__body .check-area .check-list {
  display: flex;
  flex-direction: column;
  gap: 46px;
}
.popup-type3 .popup__body .check-area .check-list section ul {
  margin: 12px 0 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.popup-type3 .popup__body .check-area .check-list section ul li {
  background: #fff;
  height: 60px;
  padding: 0 14px 0 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.popup-type3 .popup__body .check-area .check-list section ul li input[type="checkbox"] + label {
  width: 85%;
  font-size: 16px;
}
.popup-type3 .popup__body .check-area .check-list section ul li .tooltip-link p {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.popup-type3 .popup__body .check-area .check-list section ul li .tooltip-link::before {
  max-width: 100%;
  width: auto;
  left: 0;
  top: 20px;
}
.popup-type3 .popup__body .check-area .check-list section ul li .btn {
  width: 32px;
  height: 32px;
}

/* Report - 점검결과 - 에너지레포트 리스트 */
.tbl__top > .search ul.form__input .input__area > .type__cont {
  margin-left: 0;
}
.tbl__top > .search ul.form__input li .type__cont li {
  margin-right: 4px;
}
.tbl__top > .search ul.form__input li .type__cont li a {
  height: 100%;
}

@media screen and (max-width: 940px) {
  .tbl-list table th.sm-w45p {
    width: 45% !important;
  }
  .tbl__top > .search ul.form__input li .type__cont li {
    margin-right: 4px;
    width: auto;
  }
}
@media screen and (max-width: 499px) {
  .tbl-list table th.sm-w45p {
    width: auto !important;
  }
  .tbl-list table th.w3p,
  .tbl-list table th.w4p {
    width: 10% !important;
  }
}

/* 모니터링 */
.monitor .treebar.box {
  /* min-height: 900px; */
  min-height: unset;
}
.monitor .box {
  width: 100%;
}
.time {
  display: flex;
  align-items: center;
  gap: 8px;
}
.time .btn-refresh {
  margin: 0 auto;
  width: 24px;
  height: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_114___}) no-repeat 0 0 transparent;
  background-size: 100%;
}
.time p {
  font-size: 15px;
  color: #7a8596;
  line-height: 1.3;
}
.monitor .box__body {
  padding: 16px 12px 16px 15px;
  min-height: calc(100% - 116px);
  max-height: calc(100vh - 182px);
  overflow-y: auto;
  background: #f7f8fa;
}
.monitor .box__body .box-column {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
}
.monitor .box__body .box-column > li {
  display: flex;
  gap: 14px;
  flex-wrap: nowrap;
  flex: 1;
  min-width: 673px;
}
.monitor .box__body .box-column > li.w100p {
  min-width: 100%;
}
.monitor .box__body .box-column > li > article {
  background: #fff;
  padding: 16px;
  border-radius: 4px;
  height: 368px;
  box-shadow: 0px 3px 8px rgba(144, 159, 183, 0.5);
  flex: 1;
}
.monitor .box__body .box-column > li:nth-child(2) > article,
.monitor .box__body .box-column > li:nth-child(3) > article,
.monitor .box__body .box-column > li:nth-child(4) > article {
  width: 45%;
}
.monitor .box__body .box-column > li > article.h-auto {
  height: 368px !important;
}
.monitor .box__body .box-column > li.w100p > article.h-auto {
  height: auto !important;
}
.monitor .box__body .box-column > li > article .top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.monitor .box__body .box-column > li > article h2 {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.3;
  color: #2a2c2f;
}
.monitor .box__body .box-column > li > article .top > .right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
}
.monitor .box__body .box-column > li > article:not(.boxtype-tab) > .top .txt-info {
  font-size: 12px;
  margin-top: 2px;
  flex: 1;
}
.monitor .box__body .box-column > li > article.boxtype-tab > .top .txt-info {
  letter-spacing: -1.2px;
}
.monitor .box__body .box-column > li > article .cont .txt-info {
  line-height: 1.4;
}
/* 250207 추가 */
.monitor .box__body .box-column > li > article .cont .txt-info.mt-16.mb-18 {
  font-size: 12px;
  line-height: 18px;
}
.monitor .box__body .box-column > li > article .cont {
  width: 100%;
}
.monitor .box__body .box-column > li > article .cont .tbl-list table th,
.monitor .box__body .box-column > li > article .cont .tbl-list table td {
  padding: 16px 16px 15px;
  height: auto;
}
.monitor .box__body .box-column > li > article .cont .tbl-list {
  border-top: 2px solid #dde2e9;
  border-bottom: 2px solid #dde2e9;
}
.monitor .box__body .box-column > li > article .cont .graph-box {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.monitor .box__body .box-column > li > article .cont .graph-box .graph-area {
  width: 100%;
  height: 300px;
}
.monitor .box__body .box-column > li > article .cont .graph-box .graph-area .echarts-for-react > div:first-child {
  width: 100% !important;
}
.monitor
  .box__body
  .box-column
  > li
  > article
  .cont
  .graph-box
  .graph-area
  .echarts-for-react
  > div:first-child
  canvas {
  width: 100% !important;
}
.graph-legend {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
}
.graph-legend p {
  font-size: 12px;
  line-height: 1.7;
  letter-spacing: -0.7px;
  color: #2a2c2f !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.graph-legend p:before {
  content: "";
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_115___}) no-repeat 0 0 transparent;
  background-size: 100%;
}
.graph-legend p.mint:before {
  content: "";
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_116___}) no-repeat 0 0 transparent;
  background-size: 100%;
}
.graph-legend p.red:before {
  content: "";
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) no-repeat 0 0 transparent;
  background-size: 100%;
}
.graph-legend p.line-type:before {
  content: "";
  width: 16px;
  height: 4px;
  background-color: #5470c6;
}
.monitor .box__body .box-column > li > article.part-len {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.monitor .box__body .box-column > li > article.part-len > div {
  flex: 1;
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap {
  display: flex;
  gap: 8px;
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  flex: 1;
  padding: 16px;
  min-height: 102px;
  background: #fff;
  border: 1px solid #dde2e9;
  border-radius: 4px;
  box-shadow: 0px 2px 8px rgba(144, 159, 183, 0.4);
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.opacity-5 li {
  border: 1px solid rgba(221, 226, 233, 0.5);
  box-shadow: none;
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li .tit {
  font-size: 16px;
  line-height: 1.3;
  color: #051c3f;
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li .score-info {
  justify-content: space-between;
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li .score-info::before {
  content: none;
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li .count-info {
  text-align: right;
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li span {
  font-size: 16px;
  line-height: 1.3;
  color: #646c74;
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li span.info {
  font-size: 24px;
  display: flex;
  align-items: center;
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li span.info:before {
  content: "";
  width: 32px;
  height: 32px;
  margin-right: 4px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_104___}) no-repeat 0 0 transparent;
  background-size: 100%;
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li span.info.caution:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_106___}) no-repeat 0 0 transparent;
  background-size: 100%;
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li span strong {
  font-size: 30px;
  color: #003876;
  font-weight: 700;
  line-height: 1.1;
  margin-right: 8px;
  vertical-align: sub;
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li .count-info span strong {
  color: #2a2c2f;
  font-weight: 400;
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.link li:hover {
  background: #e8f1fe;
  border: 2px solid #fff;
  padding: 15px;
  cursor: pointer;
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.link li:hover .tit {
  font-weight: 500;
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.link li:hover .count-info span strong {
  color: #003876;
  font-weight: 500;
}
/* 250207 box-list 관련 추가 [s] */
.monitor .box__body .box-column > li > article.part-len:has(.cont ul.box-small-wrap.box-list) {
  height: auto;
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li {
  border: none;
  background: #f7f8fa;
  border-radius: 0;
  box-shadow: none;
  padding: 24px;
  min-height: 120px;
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li:hover {
  cursor: pointer;
  background: #e6f0ff;
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li .tit {
  font-size: 15px;
  line-height: 24px;
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li .tit:before {
  content: "";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin: 6px 8px 0 0;
  background: #0a78ff;
  border-radius: 50%;
  vertical-align: text-top;
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li span {
  font-size: 12px;
  line-height: 24px;
  color: #909fb7;
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li span strong {
  font-size: 40px;
  line-height: 40px;
  font-family: "Pretendard";
  margin-right: 4px;
}
/* 주의 클래스 caution */
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li.caution:hover {
  background: rgba(245, 85, 71, 0.1);
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li.caution .tit:before {
  background: #f55547;
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li.caution span > strong {
  color: #f55547;
}
.monitor .box__body .box-column > li > article.part-len:has(ul.box-small-wrap.box-list li.caution) .cont .banner-wrap {
  height: 160px;
  display: block;
}
.monitor
  .box__body
  .box-column
  > li
  > article.part-len:has(ul.box-small-wrap.box-list li.caution)
  .cont
  .banner-wrap
  > a {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.monitor
  .box__body
  .box-column
  > li
  > article.part-len:has(ul.box-small-wrap.box-list li.caution)
  .cont
  .banner-wrap
  > a
  > .img {
  height: 100%;
  min-width: 350px;
  width: 100%;
}
.monitor
  .box__body
  .box-column
  > li
  > article.part-len:has(ul.box-small-wrap.box-list li.caution)
  .cont
  .banner-wrap
  > a
  > .img
  > img {
  height: 100%;
  object-fit: cover;
}
@media screen and (max-width: 1091px) {
  .monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list {
    flex-direction: column;
  }
  .monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li {
    min-height: 0;
    flex-direction: row;
  }
}
@media screen and (max-width: 940px) {
  .monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list {
    gap: 8px;
  }
}
/* 250207 box-list 관련 추가 [e] */
.monitor .box__body .box-column > li > article.boxtype-tab {
  height: auto;
  width: 100%;
  min-height: 368px;
  padding: 0;
}
.monitor .box__body .box-column > li > article.boxtype-tab > .top {
  padding: 16px 16px 8px;
  margin-bottom: 0;
}
.monitor .box__body .box-column > li > article.boxtype-tab > .top h2 img {
  width: 132px;
  height: 40px;
}
.monitor .box__body .box-column > li > article.boxtype-tab > .cont {
  display: flex;
  border-top: 1px solid #dde2e9;
}
.monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line__toggleBtn {
  display: none;
}
.monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line {
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  background: #f7f8fa;
  width: 239px;
  border-right: 1px solid #dde2e9;
}
.monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li {
  justify-content: flex-start;
  font-size: 14px;
  line-height: 1;
  font-weight: 400;
  color: #2a2c2f;
  padding: 0 32px;
  width: calc(100% - 64px);
  height: 45px;
  border-bottom: 1px solid #dde2e9;
}
.monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li.on {
  font-weight: 700;
  color: #0a78ff;
  border-right: 1px solid #fff;
  background: #fff;
}
.icon-down:before {
  content: "";
  width: 20px;
  height: 20px;
  margin-right: 8px;
  margin-left: -8px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_117___}) no-repeat center center;
  background-size: 100%;
}
.monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.show {
  padding: 16px;
  width: calc(100% - 272px);
}
.monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab-content .top h3 {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.3;
  color: #2a2c2f;
}
.monitor .box__body .box-column > li > article .cont .tab-cont-wrap {
  display: flex;
  flex-direction: column;
  gap: 42px;
}
.monitor .box__body .box-column > li > article .cont .tab-cont-wrap.part-len > div {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .top {
  margin-bottom: 0;
}
.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont + .cont {
  margin-top: 42px;
}
.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap {
  gap: 32px;
  height: auto;
  flex-wrap: wrap;
}
.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap.border-0 li {
  box-shadow: none;
  border: 0;
}
.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap li {
  min-height: 60px;
  flex: none;
}
.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap li .tit {
  font-size: 15px;
  color: #646c74;
  display: flex;
  align-items: center;
}
.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap li .tit:before {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #0f5fa5;
  margin-right: 8px;
}
.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap li span {
  font-size: 12px;
  color: #909fb7;
}
.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap li .count-info span strong {
  font-size: 28px;
  font-weight: 500;
}
.monitor .box__body .cont-border-box {
  padding: 16px;
  border: 1px solid rgba(221, 226, 233, 0.5);
}
.monitor .box__body .cont-border-box .scrollX {
  margin-bottom: -20px;
  padding-bottom: 17px;
}
/* .monitor .box__body .cont-border-box .scrollX .graph-box {
  min-width: calc(100vw - 646px);
} */
.monitor .box__body .cont-border-box .scrollX .graph-box .graph-area {
  width: 100%;
  min-width: 1185px;
  height: 300px;
}
.monitor .box__body .box-column > li > article .cont .cont-border-box .scrollX .tbl-list table {
  table-layout: auto;
}
.monitor .box__body .box-column > li > article .cont .cont-border-box .tbl-list table th {
  min-width: 80px;
  word-break: keep-all;
  text-align: center;
  padding: 9px 5px 8px;
}
.monitor .box__body .box-column > li > article .cont .cont-border-box .tbl-list table td {
  min-width: 80px;
  word-break: keep-all;
  background: #fff;
  text-align: center;
  padding: 12px 5px 11px;
}
.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list.w-min-auto table th,
.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list.w-min-auto table td {
  min-width: auto;
}
.monitor .box__body .box-column > li > article .cont > .count-info {
  margin-top: 16px;
}
.monitor .box__body .box-column > li > article .cont > .count-info span {
  font-size: 20px;
  line-height: 1;
  color: #909fb7;
  margin-left: 16px;
}
.monitor .box__body .box-column > li > article .cont > .count-info span strong {
  font-size: 24px;
  line-height: 1.2;
  color: #003876;
  margin-right: 8px;
}
.monitor .box__body .box-column > li > article .cont > .tab__round {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  width: fit-content;
  background: #f7f8fa;
  border-radius: 25px;
}
.monitor .box__body .box-column > li > article .cont > .tab__round li a {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 14px 5px;
  min-width: 68px;
  font-size: 14px;
  line-height: 1.1;
  color: #2c364e;
}
.monitor .box__body .box-column > li > article .cont > .tab__round li.on {
  background: #2c364e;
  border-radius: 25px;
}
.monitor .box__body .box-column > li > article .cont > .tab__round li.on a {
  color: #fff;
  font-weight: 500;
}
.monitor .box__body .txtnum {
  font-size: 12px;
}
.popup__body .img-box {
  margin: 24px 0;
}

@media screen and (max-width: 940px) {
  .monitor .box__body .box-column > li > article {
    height: auto;
  }
}

/* 모니터링 - 배너영역 */
.monitor .box__body .box-column > li > article .cont .banner-wrap {
  display: flex;
  flex-direction: column;
  gap: 6px;
  height: 348px;
  overflow: hidden;
}
.monitor .box__body .box-column > li > article .cont .banner-wrap > li {
  position: relative;
  height: 112px;
  min-height: 112px;
  width: 100%;
}
.monitor .box__body .box-column > li > article .cont .banner-wrap > li > a {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.monitor .box__body .box-column > li > article .cont .banner-wrap > li > a > .img {
  position: absolute;
  left: auto;
  right: auto;
  height: 100%;
  min-width: 612px;
  width: 100%;
}
.monitor .box__body .box-column > li > article .cont .banner-wrap > li > a > .img > img {
  height: 100%;
  object-fit: cover;
}
.monitor .box__body .box-column > li > article .cont .banner-wrap + .slide-pagenation {
  gap: 9px;
}

/* 모니터링 - 데이터 프리미엄 전 안내 */
.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont.no-view {
  position: relative;
}
.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont.no-view:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.57);
  z-index: 1;
}
.no-view-txt {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
}
.no-view-txt span {
  padding: 6px 48px;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #fff;
  background: #2c364e;
}

/* 모니터링 - 캘린더 박스 */
.monitor .box__body .box-column > li > article .cont .calendar-wrap {
  display: flex;
  flex-direction: column;
  gap: 30px;
  height: 100%;
}
.monitor .box__body .box-column > li > article .cont .calendar-wrap .calendar-area {
  height: 324px;
}
.monitor .box__body .box-column > li > article .cont .calendar-wrap .color-info {
  justify-content: center;
}

/* 모니터링 - 탭 박스 */
.monitor .box__body .box-column > li > article .cont .tabbox-wrap {
  margin: 0 -16px !important;
}
.monitor .box__body .box-column > li > article .cont .tabbox-wrap .tab__box li a {
  border-top: 1px solid #dde2e9;
  line-height: 16px;
}
.monitor .box__body .box-column > li > article .cont .tabbox-cont {
  height: 280px;
}
.monitor .box__body .box-column > li > article .cont .tabbox-cont .cont-tbl .tbl-list {
  border: 0;
}
.monitor .box__body .box-column > li > article .cont .tabbox-cont .cont-tbl .tbl-list table td {
  height: 24px;
}
@media screen and (max-width: 940px) {
  .monitor .box__body .box-column > li > article .cont .tabbox-wrap .tab__box li {
    height: 46px;
  }
  #wrap:not(.no-responsive) .monitor .box__body .box-column > li > article .cont .tabbox-wrap .tab__box li a {
    font-size: 14px;
  }
  .monitor .box__body .box-column > li > article .cont .tabbox-cont .cont-tbl .tbl-list table td {
    height: 27px;
    font-size: 14px !important;
  }
  .monitor .box__body .box-column > li > article .cont .tabbox-cont {
    height: 285px !important;
  }
}

/* 모니터링 - 알람박스리스트 */
.list-box {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.monitor .box__body .box-column > li > article .cont .list-box {
  height: 334px;
  overflow-y: auto;
  margin-right: -15px;
  padding-right: 5px;
  margin-left: -15px;
  padding-left: 15px;
  padding-top: 5px;
  margin-top: -5px;
  padding-bottom: 5px;
}
.list-box li {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0px 0px 4px 0px rgba(144, 159, 183, 0.5);
}
.list-box li p {
  font-size: 14px;
  color: #2a2c2f;
}
.list-box li .title {
  display: flex;
  justify-content: space-between;
}
.list-box li .title p {
  font-weight: 500;
  line-height: 14px;
}
.list-box li .title p.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  /* background: #909FB7; */
  background: #0978ff;
  margin-right: 5px;
}
/* .list-box li .title p.dot.new{
  background: #0978FF;
} */
.list-box li .detail {
  display: flex;
  justify-content: space-between;
}
.list-box li .detail p:not(.date) {
  font-size: 13px;
  width: calc(100% - 100px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.list-box li .detail p.date {
  font-size: 14px;
  color: #6b7891;
}
@media screen and (max-width: 940px) {
  .list-box li {
    padding: 24px 16px;
    gap: 10px;
  }
  .list-box li .title p {
    font-size: 16px;
  }
  .monitor .box__body .box-column > li > article .cont .list-box {
    height: 453px;
    padding-bottom: 5px;
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 5px;
  }
}

/* 모니터링 - 운영설비 */
.monitor .box__body .box-column > li > article.seolbi {
  height: auto;
}
.monitor .box__body .box-column > li > article.seolbi .tab__line {
  margin: 0 -16px 0 -16px;
  width: calc(100% + 32px);
}
.monitor .box__body .box-column > li > article.seolbi .tbl__top {
  margin-top: 24px;
}
.monitor .box__body .box-column > li > article.seolbi .tbl__top .searcharea {
  position: relative;
}
.monitor .box__body .box-column > li > article.seolbi .cont .tbl-list table th {
  padding: 4px 8px;
  height: 24px;
}
.monitor .box__body .box-column > li > article.seolbi .cont .tbl-list table td {
  padding: 4px 8px;
  height: 40px;
}
.monitor .box__body .box-column > li > article.seolbi .btn-ask.etc + .popup-etc {
  top: 33px;
  right: 0;
}
.filter-txt {
  margin-bottom: 12px;
  height: 28px;
  padding: 0 12px;
  background: #e7f2ff;
  border-radius: 25px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.filter-txt p {
  font-size: 14px;
  line-height: 20px;
  color: #0a78ff;
}
.filter-txt p span {
  font-size: 14px;
  line-height: 20px;
  color: #0a78ff;
}
.filter-txt .btn-delete {
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_94___}) no-repeat center center;
  background-size: 100%;
}
.filter-txt button.btn-renew {
  width: 24px;
  height: 24px;
  border: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_118___}) no-repeat center center;
  background-size: 100%;
}

@media screen and (max-width: 1625px) {
  .filter-txt-wrap {
    text-align: right;
  }
}

@media screen and (max-width: 500px) {
  #wrap:not(.no-responsive) .monitor .box__body .box-column > li > article.seolbi .tab__line li {
    padding: 14px 5px;
    letter-spacing: -1px;
  }
}

/* 모니터링 - 스마트에너지인사이트 */
.monitor .box__body .box-column > li > article.smartEI {
  width: calc(100% - 32px);
  height: auto;
}
.monitor .box__body .box-column > li > article.smartEI h2 {
  font-weight: 700;
}
.monitor .box__body .box-column > li > article.smartEI h2 img {
  width: 150px;
  height: 8px;
  display: block;
  margin-bottom: 11px;
}
.monitor .box__body .box-column > li > article.smartEI > .cont .tab__line {
  align-items: flex-start;
  gap: 0;
  margin: 0 -16px 32px;
  width: calc(100% + 32px);
  height: 46px;
  background: #f7f8fa;
  border-top: 1px solid #dde2e9;
}
.monitor .box__body .box-column > li > article.smartEI > .cont .tab__line li {
  justify-content: center;
  font-size: 14px;
  line-height: 1;
  font-weight: 400;
  color: #2a2c2f;
  padding: 0 32px;
  min-width: 115px;
  height: 100%;
  border-right: 1px solid #dde2e9;
}
.monitor .box__body .box-column > li > article.smartEI > .cont .tab__line li.on {
  font-weight: 700;
  color: #0a78ff;
  border-bottom: 1px solid #fff;
  background: #fff;
}
.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap {
  gap: 0;
}
.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div {
  border-top: 1px solid #dde2e9;
  padding-top: 32px;
}
.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div:first-child {
  border-top: 0;
  padding-top: 0;
  /* margin-bottom: 16px; */
}
.monitor .box__body .box-column > li > article.smartEI > .cont .tab-content .top h3 {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.3;
  color: #2a2c2f;
}
.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row {
  display: flex;
}
.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 16px;
}
.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.verage {
  width: 352px;
  margin-right: 16px;
  border-right: 16px solid #f7f8fa;
  padding-right: 16px;
  gap: 0;
}
.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.verage .top {
  margin-bottom: 24px;
}
.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.verage .cont {
  flex-direction: column;
  gap: 0;
}
.monitor
  .box__body
  .box-column
  > li
  > article.smartEI
  .cont
  .tab-cont-wrap
  > div
  > .row
  > .part.verage
  .cont
  .score-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  margin-bottom: 8px;
  height: 46px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #dde2e9;
}
.monitor
  .box__body
  .box-column
  > li
  > article.smartEI
  .cont
  .tab-cont-wrap
  > div
  > .row
  > .part.verage
  .cont
  .score-top
  .tit {
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.6px;
  display: flex;
  align-items: center;
}
.monitor
  .box__body
  .box-column
  > li
  > article.smartEI
  .cont
  .tab-cont-wrap
  > div
  > .row
  > .part.verage
  .cont
  .score-top
  .tit:before {
  content: "";
  width: 42px;
  height: 42px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_104___}) no-repeat 0 0 transparent;
  background-size: 100%;
}
.monitor
  .box__body
  .box-column
  > li
  > article.smartEI
  .cont
  .tab-cont-wrap
  > div
  > .row
  > .part.verage
  .cont
  .score-top
  .score {
  font-size: 30px;
  line-height: 32px;
  color: #003876;
  font-weight: 700;
}
.monitor
  .box__body
  .box-column
  > li
  > article.smartEI
  .cont
  .tab-cont-wrap
  > div
  > .row
  > .part.verage
  .cont
  .score-top
  .score
  span {
  color: #646c74;
  font-size: 16px;
  line-height: 20px;
  margin-left: 8px;
  font-weight: 400;
  vertical-align: middle;
}
.monitor
  .box__body
  .box-column
  > li
  > article.smartEI
  .cont
  .tab-cont-wrap
  > div
  > .row
  > .part.verage
  .cont
  .score-top.caution {
  background: #f55547;
  border-color: #f55547;
}
.monitor
  .box__body
  .box-column
  > li
  > article.smartEI
  .cont
  .tab-cont-wrap
  > div
  > .row
  > .part.verage
  .cont
  .score-top.caution
  .tit:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_106___}) no-repeat 0 0 transparent;
  background-size: 100%;
}
.monitor
  .box__body
  .box-column
  > li
  > article.smartEI
  .cont
  .tab-cont-wrap
  > div
  > .row
  > .part.verage
  .cont
  .score-top.caution
  p,
.monitor
  .box__body
  .box-column
  > li
  > article.smartEI
  .cont
  .tab-cont-wrap
  > div
  > .row
  > .part.verage
  .cont
  .score-top.caution
  span {
  color: #fff;
}
.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.trend {
  width: 100%;
}
.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.verage + .part.trend {
  width: calc(100% - 400px);
}
.monitor
  .box__body
  .box-column
  > li
  > article.smartEI
  .cont
  .tab-cont-wrap
  > div
  > .row
  > .part.verage
  + .part.trend
  .cont {
  gap: 32px;
}
.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part .cont {
  flex-direction: row;
}
.monitor
  .box__body
  .box-column
  > li
  > article.smartEI
  .cont
  .tab-cont-wrap
  > div
  > .row
  > .part
  .cont
  > div
  .tbl__top
  span {
  font-size: 15px;
}
.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.trend .cont {
  gap: 48px;
  justify-content: space-between;
}
.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.trend .cont > div {
  width: 100%;
}
.monitor
  .box__body
  .box-column
  > li
  > article.smartEI
  .cont
  .tab-cont-wrap
  > div
  > .row
  > .part.trend
  .cont
  > div
  .cont-border-box {
  width: calc(100% - 34px);
}
/* .monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.trend .cont > div .cont-border-box.w1118 {
  width: 1118px;
} */
.monitor
  .box__body
  .box-column
  > li
  > article.smartEI
  .cont
  .tab-cont-wrap
  > div
  > .row
  > .part.trend
  .cont
  > .result__num {
  font-size: 13px;
}
.monitor .box__body .box-column > li > article.smartEI .cont .tbl-list table th {
  padding: 8px 10px;
}
.monitor .box__body .box-column > li > article.smartEI .cont .tbl-list table td {
  padding: 16px 10px 15px;
  letter-spacing: -1px;
}
.monitor
  .box__body
  .box-column
  > li
  > article.smartEI
  .cont
  .tab-cont-wrap
  > div
  > .row
  > .part.trend
  .cont
  > div:last-child {
  width: fit-content;
}
.monitor
  .box__body
  .box-column
  > li
  > article.smartEI
  .cont
  .tab-cont-wrap
  > div
  > .row
  > .part.trend
  .cont
  > div
  .tbl-list {
  max-width: 352px;
  min-width: 352px;
}
.monitor
  .box__body
  .box-column
  > li
  > article.smartEI
  .cont
  .tab-cont-wrap
  > div
  > .row
  > .part.trend
  .cont
  > div
  .tbl-list.scrollH {
  padding: 0;
  margin: 0;
}
.monitor
  .box__body
  .box-column
  > li
  > article.smartEI
  .cont
  .tab-cont-wrap
  > div
  > .row
  > .part.trend
  .cont
  > div
  .cont-border-box
  .scrollX {
  margin-bottom: 0;
  padding-bottom: 0;
}
.monitor
  .box__body
  .box-column
  > li
  > article.smartEI
  .cont
  .tab-cont-wrap
  > div
  > .row
  > .part.trend
  .cont
  > div
  .cont-border-box
  .scrollX
  .graph-box
  .graph-area {
  min-width: 1118px;
}
.btn-basic.btn-filter {
  padding: 0 24px 0 16px;
}
.btn-filter::before {
  content: "";
  width: 20px;
  height: 20px;
  margin-right: 8px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_119___}) no-repeat 0 center;
  background-size: 100%;
}
@media screen and (max-width: 1892px) {
  .monitor .box__body .box-column > li > article.smartEI .lm-none {
    display: none !important;
  }
  .monitor .box__body .box-column > li > article.smartEI .lm-block {
    display: block !important;
  }
  .monitor
    .box__body
    .box-column
    > li
    > article.smartEI
    .cont
    .tab-cont-wrap
    > div
    > .row
    > .part.trend
    .cont
    > div
    .cont-border-box {
    width: calc(100% - 32px);
  }
  /* .monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.trend .cont > div .cont-border-box.w1118 {
    width: calc(100% - 32px);
  } */
  .monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.trend .cont,
  .monitor
    .box__body
    .box-column
    > li
    > article.smartEI
    .cont
    .tab-cont-wrap
    > div
    > .row
    > .part.verage
    + .part.trend
    .cont {
    gap: 24px;
  }
  .monitor
    .box__body
    .box-column
    > li
    > article.smartEI
    .cont
    .tab-cont-wrap
    > div
    > .row
    > .part.trend
    .cont
    > div:first-child {
    max-width: calc(100% - 376px);
  }
  .monitor
    .box__body
    .box-column
    > li
    > article.smartEI
    .cont
    .tab-cont-wrap
    > div
    > .row
    > .part.verage
    + .part.trend
    .cont
    > div:first-child {
    max-width: 100%;
  }
}
@media screen and (max-width: 1625px) {
  .monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part .cont {
    flex-direction: column;
  }
  .monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.trend .cont > div {
    max-width: 100% !important;
    width: 100% !important;
  }
  .monitor
    .box__body
    .box-column
    > li
    > article.smartEI
    .cont
    .tab-cont-wrap
    > div
    > .row
    > .part.trend
    .cont
    > div
    .tbl-list {
    max-width: 100% !important;
    width: 100% !important;
  }
  .monitor
    .box__body
    .box-column
    > li
    > article.smartEI
    .cont
    .tab-cont-wrap
    > div
    > .row
    > .part.trend
    .cont
    > div
    .tbl-list.mt-52 {
    margin-top: 0 !important;
  }
  .monitor
    .box__body
    .box-column
    > li
    > article.smartEI
    .cont
    .tab-cont-wrap
    > div
    > .row
    > .part.trend
    .cont
    > div
    .tbl-list.h288 {
    height: 324px !important;
  }
  .monitor
    .box__body
    .box-column
    > li
    > article.smartEI
    .cont
    .tab-cont-wrap
    > div
    > .row
    > .part.trend
    .cont
    > div
    .cont-border-box.h258 {
    height: 294px !important;
  }
  .monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row {
    flex-direction: column;
  }
  .monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.verage {
    width: 100%;
    margin-right: 0;
    border-right: 0;
    padding-right: 0;
  }
  .monitor
    .box__body
    .box-column
    > li
    > article.smartEI
    .cont
    .tab-cont-wrap
    > div
    > .row
    > .part.verage
    .cont
    .score-top {
    margin-bottom: 0;
  }
  .monitor
    .box__body
    .box-column
    > li
    > article.smartEI
    .cont
    .tab-cont-wrap
    > div
    > .row
    > .part.verage
    + .part.trend {
    width: 100%;
  }
  .monitor .box__body .box-column > li > article.smartEI .lm-none {
    display: block !important;
  }
  .monitor .box__body .box-column > li > article.smartEI .lm-block {
    display: none !important;
  }
}

@media screen and (max-width: 940px) {
  #wrap:not(.no-responsive) .monitor .box__body .box-column > li > article.smartEI > .cont .tab__line li {
    padding: 0 5px;
    flex: unset;
  }
  .monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.verage .top {
    margin-bottom: 16px;
  }
  .monitor .box__body .box-column > li > article.smartEI .cont .tbl-list table td {
    height: auto !important;
    padding: 16px 8px 15px;
  }
  .monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part {
    gap: 20px;
  }
  .monitor .box__body .box-column > li > article.smartEI > .cont .tab-content .top h3 {
    font-size: 20px;
  }
  .monitor .box__body .box-column > li > article.smartEI .select {
    height: 40px;
  }
  .monitor .box__body .box-column > li > article.smartEI .react-datepicker__input-container {
    height: 40px;
    max-height: 40px;
  }
  .react-datepicker__input-container {
    max-height: 38px;
  }
}
@media screen and (max-width: 620px) {
  .monitor
    .box__body
    .box-column
    > li
    > article.smartEI
    .cont
    .tab-cont-wrap
    > div
    > .row
    > .part
    .cont
    > div
    .tbl__top {
    gap: 20px;
  }
  .monitor
    .box__body
    .box-column
    > li
    > article.smartEI
    .cont
    .tab-cont-wrap
    > div
    > .row
    > .part
    .cont
    > div
    .tbl__top
    .left {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }
  .monitor
    .box__body
    .box-column
    > li
    > article.smartEI
    .cont
    .tab-cont-wrap
    > div
    > .row
    > .part
    .cont
    > div
    .tbl__top
    span.ml-48 {
    margin-left: 0 !important;
  }
  .monitor
    .box__body
    .box-column
    > li
    > article.smartEI
    .cont
    .tab-cont-wrap
    > div
    > .row
    > .part
    .cont
    > div
    .tbl__top
    span {
    margin-bottom: 10px;
  }
  .monitor
    .box__body
    .box-column
    > li
    > article.smartEI
    .cont
    .tab-cont-wrap
    > div
    > .row
    > .part
    .cont
    > div
    .tbl__top
    button
    span {
    margin-bottom: 0;
  }
  .monitor .box__body .box-column > li > article.smartEI .select,
  .monitor .box__body .box-column > li > article.smartEI .term__date.w158 {
    width: 100% !important;
    margin-bottom: 20px;
  }
  .monitor .box__body .box-column > li > article.smartEI .select:last-child {
    margin-bottom: 0;
  }
}
@media screen and (max-width: 400px) {
  #wrap:not(.no-responsive) .monitor .box__body .box-column > li > article.smartEI > .cont .tab__line li {
    min-width: auto;
    flex: 1;
  }
}

/* 모니터링 - 기본 정보 */
.monitor .box__body .box-column > li > article.boxtype-tab > .cont .row {
  display: flex;
}
.monitor .box__body .box-column > li > article.boxtype-tab > .cont .part.verage {
  flex: 1;
  margin: 0 32px 32px 0;
}
.monitor .box__body .box-column > li > article.boxtype-tab > .cont .part.trend {
  flex: 1;
}
.monitor .box__body .box-column > li > article.boxtype-tab > .cont .part + .part {
  margin-right: 16px;
  padding-left: 32px;
  border-left: 16px solid #f7f8fa;
}
.monitor .box__body .box-column > li > article.boxtype-tab > .cont .small-tit {
  color: #646c74;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.4px;
  margin-top: 32px;
}
.monitor .box__body .box-column > li > article.boxtype-tab .part.verage .cont .score-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  height: 46px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #dde2e9;
}
.monitor .box__body .box-column > li > article.boxtype-tab .part.verage .cont .score-top .tit {
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.6px;
  display: flex;
  align-items: center;
}
.monitor .box__body .box-column > li > article.boxtype-tab .part.verage .cont .score-top .tit:before {
  content: "";
  width: 42px;
  height: 42px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_104___}) no-repeat 0 0 transparent;
  background-size: 100%;
}
.monitor .box__body .box-column > li > article.boxtype-tab .part.verage .cont .score-top .score {
  font-size: 30px;
  line-height: 32px;
  color: #003876;
  font-weight: 700;
}
.monitor .box__body .box-column > li > article.boxtype-tab .part.verage .cont .score-top .score span {
  color: #646c74;
  font-size: 16px;
  line-height: 20px;
  margin-left: 8px;
  font-weight: 400;
  vertical-align: middle;
}
.monitor .box__body .box-column > li > article.boxtype-tab .part.verage .cont .score-top.caution {
  background: #f55547;
  border-color: #f55547;
}
.monitor .box__body .box-column > li > article.boxtype-tab .part.verage .cont .score-top.caution .tit:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_106___}) no-repeat 0 0 transparent;
  background-size: 100%;
}
.monitor .box__body .box-column > li > article.boxtype-tab .part.verage .cont .score-top.caution p,
.monitor .box__body .box-column > li > article.boxtype-tab .part.verage .cont .score-top.caution span {
  color: #fff;
}
.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li .etc-info {
  color: #7a8596;
  font-size: 14px;
  margin-top: 8px;
}
.monitor .box__body .box-column > li > article.boxtype-tab > .cont .part.verage .graph-box .graph-area,
.monitor .box__body .box-column > li > article.boxtype-tab > .cont .part.trend .graph-box .graph-area {
  /* min-width: 576px; */
  min-width: 525px;
}

@media screen and (max-width: 1770px) {
  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .row {
    flex-direction: column;
  }
  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .part.verage {
    margin-right: 0;
    margin-bottom: 48px;
  }
  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .part + .part {
    margin-right: 0;
    padding-left: 0;
    border-left: 0;
  }
  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .part.trend {
    margin-bottom: 16px;
  }
}

@media screen and (min-width: 2390px) {
  .monitor .box__body .box-column {
    display: grid;
    gap: 14px;
    grid-template-columns: 1fr 1fr;
  }
  .monitor .box__body .box-column > li:nth-child(1) {
    grid-column: 1 / 2;
    grid-row: 1;
  }
  .monitor .box__body .box-column > li:nth-child(2) {
    grid-column: 2 / 3;
    grid-row: 1;
  }
  .monitor .box__body .box-column > li:nth-child(3) {
    grid-column: 1 / 2;
    grid-row: 2;
  }
  .monitor .box__body .box-column > li:nth-child(4) {
    grid-column: 2 / 3;
    grid-row: 2;
  }
  .monitor .box__body .box-column > li:nth-child(5) {
    grid-column: 1 / 3;
    grid-row: 3;
  }
  .monitor .box__body .box-column > li:nth-child(6) {
    grid-column: 1 / 3;
    grid-row: 4;
  }
  .monitor .box__body .box-column > li:nth-child(7) {
    grid-column: 1 / 3;
    grid-row: 5;
  }
}
@media screen and (min-width: 2390px) {
  .monitor.type2 .box__body .box-column > li:nth-child(1) {
    grid-column: 1 / 3;
    grid-row: 1;
  }
  .monitor.type2 .box__body .box-column > li:nth-child(2) {
    grid-column: 1 / 3;
    grid-row: 2;
  }
  .monitor.type2 .box__body .box-column > li:nth-child(3) {
    grid-column: 1;
    grid-row: 3;
  }
  .monitor.type2 .box__body .box-column > li:nth-child(4) {
    grid-column: 2;
    grid-row: 3;
  }
  .monitor.type2 .box__body .box-column > li:nth-child(5) {
    grid-column: 1 / 3;
    grid-row: 4;
  }
  .monitor.type2 .box__body .box-column > li:nth-child(6) {
    grid-column: 1 / 3;
    grid-row: 5;
  }
}
@media screen and (max-width: 1200px) {
  .monitor .box__body .box-column > li > article .top {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  .monitor .box__body .box-column > li > article .top > .right {
    width: 100%;
  }

  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line {
    width: 191px;
  }
  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.show {
    width: calc(100% - 224px);
  }
}
@media screen and (max-width: 1091px) {
  .monitor .box__body .box-column > li {
    flex-direction: column;
    min-width: 100%;
  }
  .monitor .box__body .box-column > li:nth-child(2) > article,
  .monitor .box__body .box-column > li:nth-child(3) > article,
  .monitor .box__body .box-column > li:nth-child(4) > article {
    width: auto;
  }
}
@media screen and (max-width: 940px) {
  .monitor .box__body {
    padding: 7px 0 0;
    min-height: auto;
    max-height: none;
    overflow-y: unset;
  }
  .monitor .box__body .box-column {
    gap: 0;
  }
  .monitor .box__body .box-column > li {
    gap: 0;
  }
  .monitor .box__body .box-column > li > article {
    padding: 20px;
    box-shadow: none;
  }
  .monitor .box__body .box-column > li > article.h-auto {
    height: auto !important;
  }
  .monitor .box__body .box-column > li > article.part-len {
    gap: 40px;
  }
  .monitor .box__body .box-column > li > article .txt-info {
    font-size: 14px;
    margin-left: 0;
    line-height: 1.4;
    text-align: right;
  }
  .monitor .box__body .box-column > li > article:not(.boxtype-tab) > .top .txt-info {
    margin-top: 0;
  }
  .monitor .box__body .box-column > li > article h2 {
    font-size: 20px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .monitor .box__body .box-column > li > article h2.flex-row {
    flex-direction: column !important;
  }
  .monitor .box__body .box-column > li > article .top {
    margin-bottom: 16px;
  }
  .monitor .box__body .box-column > li > article .top > .right {
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
  }
  .monitor .box__body .box-column > li > article.boxtype-tab > .top {
    gap: 18px;
    padding: 20px 20px 12px;
  }
  .monitor .box__body .box-column > li > article.boxtype-tab > .cont {
    flex-direction: column;
    position: relative;
  }
  .monitor .box__body .box-column > li > article .cont ul.box-small-wrap {
    gap: 10px;
  }
  .monitor .box__body .box-column > li > article .cont .graph-box {
    gap: 20px;
  }
  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line__toggleBtn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    width: calc(100% - 40px);
    height: 47px;
    background: #fff;
    border-bottom: 1px solid #dde2e9;
    cursor: pointer;
  }
  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line__toggleBtn::after {
    content: "";
    width: 24px;
    height: 24px;
    margin-left: 40px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_26___}) no-repeat center center;
    background-size: 100%;
  }
  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line__toggleBtn.active:after {
    content: "";
    transform: rotate(180deg);
  }
  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line__toggleBtn p {
    color: #2a2c2f;
    font-size: 16px;
    font-weight: 700;
  }
  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line {
    display: none;
  }
  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line.active {
    display: block;
    position: absolute;
    top: 49px;
    width: 100% !important;
    border: 0;
    padding: 0;
    margin: 0;
    z-index: 2;
    box-shadow: none;
  }
  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li {
    padding: 0px 20px !important;
    width: calc(100% - 40px);
    border-right: 0;
  }
  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.show {
    width: calc(100% - 40px) !important;
    padding: 20px;
  }
  .monitor .box__body .box-column > li > article .cont .cont-border-box .tbl-list table th,
  .monitor .box__body .box-column > li > article .cont .cont-border-box .tbl-list table td {
    font-size: 14px !important;
    height: auto !important;
  }
  .monitor .box__body .box-column > li > article .cont .tab-cont-wrap {
    gap: 40px;
  }
  .monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont {
    gap: 20px;
  }
  .monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap {
    gap: 16px 24px;
  }
  .monitor .box__body .box-column > li > article .cont .tbl-list table th,
  .monitor .box__body .box-column > li > article .cont .tbl-list table td {
    padding: 15px 16px 14px;
  }
  .monitor .box__body .box-column > li > article .cont ul.box-small-wrap li span.info {
    font-size: 0;
  }
  .monitor .box__body .box-column > li > article .cont ul.box-small-wrap li span.info:before {
    width: 28px;
    height: 28px;
  }
  .monitor .box__body .box-column > li > article .cont ul.box-small-wrap li span strong {
    margin-right: 4px;
    font-size: 22px;
    vertical-align: bottom;
  }
  .popup__body .img-box {
    margin: 16px 0;
  }
}
@media screen and (max-width: 620px) {
  .popup-layer.w658,
  .popup-layer.w524 {
    width: calc(100% - 40px) !important;
  }
}
@media screen and (max-width: 499px) {
  .monitor .box__body .box-column > li > article .cont ul.box-small-wrap li {
    padding: 16px 8px;
  }
  table.m-w400 {
    width: 400px;
  }
  table.m-w578 {
    width: 578px;
  }
  .popup__body .img-box {
    margin: 24px 0;
  }
  .popup__body p.txt.word {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.22px;
    text-align: justify;
  }
}

/* 운영관리 - 왼쪽 메뉴(반응형) */
.box.treebar.pushy-menutype {
  min-height: auto;
}
.box.treebar.pushy-menutype .lnb {
  width: 100%;
  overflow-y: auto;
  height: 100%;
}
.box.treebar.pushy-menutype .lnb a {
  width: 100%;
}
.box.treebar.pushy-menutype .lnb .add__item {
  height: auto;
  width: 100%;
  padding: 13px 12px;
  background: #e6f0ff;
  border-radius: 4px;
  border: 0;
  justify-content: flex-start;
}
.box.treebar.pushy-menutype .lnb .add__item:hover {
  background: #dee9f6;
}
.box.treebar.pushy-menutype .lnb .add__item:active {
  background: #b4d2ff;
}
.box.treebar.pushy-menutype .lnb .add__item span {
  display: flex;
  align-items: center;
  color: #0978ff;
  font-weight: 500;
  font-size: 14px;
  line-height: 1;
}
.box.treebar.pushy-menutype .lnb .add__item span::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_37___}) no-repeat center center;
  width: 12px;
  height: 12px;
  margin-right: 12px;
  background-size: 100%;
}
/* .add__item.active {
  background: #0978FF;
}
.add__item.active span {
  color: #fff;
}
.add__item.active span::before {
  background: url('../img/icon_plus_w.png') no-repeat center center;
  background-size: 100%;
} */

.box.treebar.pushy-menutype .lnb > .add__item {
  margin: 8px;
  width: calc(100% - 16px);
}
.box.treebar.pushy-menutype .lnb .lnb-depth1 > li {
  border-top: 1px solid #fff;
  border-bottom: 1px solid #dde2e9;
  padding: 0;
  width: 100%;
}
.box.treebar.pushy-menutype .lnb .lnb-depth1 > li:first-child {
  border-top: 0;
}
.box.treebar.pushy-menutype .lnb .lnb-depth1 > li > p {
  display: flex;
  align-items: center;
  padding: 16px;
  width: calc(100% - 32px);
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: #2a2c2f;
  cursor: pointer;
  background: #f0f2f4;
}
.box.treebar.pushy-menutype .lnb .lnb-depth1 > li > p a {
  position: relative;
  display: flex;
  gap: 16px;
  width: calc(100% - 16px);
}
.box.treebar.pushy-menutype .lnb .lnb-depth1 > li > p a::after {
  content: "";
  position: absolute;
  right: -16px;
  width: 16px;
  height: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_120___}) 0 center no-repeat;
  background-size: 100%;
}
.box.treebar.pushy-menutype .lnb .lnb-depth1 > li > p a span + span {
  margin-right: 16px;
}
.box.treebar.pushy-menutype .lnb .lnb-depth1 > li > p a span {
  max-width: 50%;
}
.box.treebar.pushy-menutype:not(.type2, .type3) .lnb .lnb-depth1 > li.active > p {
  background: #0a78ff;
}
.box.treebar.pushy-menutype:not(.type2, .type3) .lnb .lnb-depth1 > li.active > p span {
  color: #fff;
}
.box.treebar.pushy-menutype .lnb .lnb-depth1 > li.active p span {
  font-weight: 700;
}
.box.treebar.pushy-menutype .lnb .lnb-depth1 > li.active > p a::after {
  transform: scaleY(-1);
  filter: brightness(0) invert(1);
}
.box.treebar.pushy-menutype:not(.type2, .type3) .lnb .lnb-depth1 > li.active.nobg p {
  background: #f0f2f4;
}
.box.treebar.pushy-menutype:not(.type2, .type3) .lnb .lnb-depth1 > li.active.nobg p span {
  color: #2a2c2f;
}
.box.treebar.pushy-menutype .lnb .lnb-depth1 > li.active.nobg > p a::after {
  filter: none;
}
.box.treebar.pushy-menutype .lnb .lnb-depth1 > li.active > .lnb-depth2,
.box.treebar.pushy-menutype .lnb .lnb-depth2 > li.active > .lnb-depth3,
.box.treebar.pushy-menutype .lnb .lnb-depth3 > li.active > .lnb-depth4 {
  display: block;
}
.box.treebar.pushy-menutype .lnb .lnb-depth2 {
  display: none;
}
.box.treebar.pushy-menutype .lnb .lnb-depth2 > li > .add__item {
  margin: 8px;
  width: calc(100% - 16px);
}
.box.treebar.pushy-menutype .lnb .lnb-depth2 > li > a {
  position: relative;
  display: flex;
  align-items: center;
  padding: 16px 35px 15px 44px;
  width: calc(100% - 79px);
  font-size: 14px;
  font-weight: 400;
  color: #2a2c2f;
  border-top: 1px solid #dde2e9;
  background: #fff;
}
.box.treebar.pushy-menutype .lnb .lnb-depth2 > li > a::after {
  content: "";
  position: absolute;
  right: 15px;
  width: 16px;
  height: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_120___}) 0 center no-repeat;
  background-size: 100%;
}
.box.treebar.pushy-menutype .lnb .lnb-depth2 > li.active > a {
  font-weight: 700;
  background: #0a78ff;
  color: #fff;
}
.box.treebar.pushy-menutype .lnb .lnb-depth2 > li.active > a::after {
  transform: scaleY(-1);
  filter: brightness(0) invert(1);
}
.box.treebar.pushy-menutype .lnb .lnb-depth2 > li.active.nobg > a,
.box.treebar.pushy-menutype.navy .lnb .lnb-depth2 > li.active.nobg > a {
  font-weight: 400;
  color: #2a2c2f;
  background: #fff;
}
.box.treebar.pushy-menutype .lnb .lnb-depth2 > li.active.nobg > a::after {
  filter: none;
}
.box.treebar.pushy-menutype .lnb .lnb-depth2 > li > .lnb-depth3 {
  display: none;
  background: #fff;
  padding-bottom: 24px;
  height: auto;
}
.box.treebar.pushy-menutype .lnb .lnb-depth2 > li.active > .lnb-depth3 {
  height: auto !important;
}
.box.treebar.pushy-menutype .lnb .lnb-depth3 > li > .add__item {
  margin: 8px 8px 8px 36px;
  width: calc(100% - 44px);
}
.box.treebar.pushy-menutype .lnb .lnb-depth3 > li a {
  position: relative;
  display: flex;
  align-items: center;
  padding: 16px 48px 16px 72px;
  width: calc(100% - 120px);
  font-size: 14px;
  color: #2a2c2f;
  font-weight: 700;
  background: #fff;
}
.box.treebar.pushy-menutype .lnb .lnb-depth3 > li.active a {
  background: #0a78ff;
  color: #fff;
}
.box.treebar.pushy-menutype .lnb .lnb-depth4 {
  display: none;
  background: #fff;
}
.box.treebar.pushy-menutype .lnb .lnb-depth4 > li > .add__item {
  margin: 8px 8px 8px 64px;
  width: calc(100% - 74px);
}
.box.treebar.pushy-menutype .lnb .lnb-depth4 > li:has(.btn-etc) {
  position: relative;
}
.box.treebar.pushy-menutype .lnb .lnb-depth4 > li .popup-etc {
  width: auto;
  top: 29px;
  right: 53px;
}
.box.treebar.pushy-menutype .lnb .lnb-depth4 > li .popup-etc li button {
  background-size: 24px !important;
  padding: 4px 18px 3px 39px !important;
  background-position-x: 9px !important;
}
.box.treebar.pushy-menutype .lnb .lnb-depth4 > li:has(.popup-etc.open) .add__item {
  background: #e6f0ff;
}
@media screen and (max-width: 940px) {
  .box.treebar.pushy-menutype.active {
    top: 102px;
  }
  .box.treebar.pushy-menutype .lnb .lnb-depth1 > li > p {
    min-height: 28px;
  }
  .box.treebar.pushy-menutype .lnb .lnb-depth2 > li a {
    min-height: 28px;
  }
  .box.treebar.pushy-menutype .lnb .lnb-depth3 > li a {
    min-height: 28px;
  }
}
/* 운영관리 - 왼쪽 메뉴(반응형) - 포인트컬러 네이비 */
.box.treebar.pushy-menutype.navy .lnb .add__item {
  background: #fff;
}
.box.treebar.pushy-menutype.navy .lnb .add__item:hover {
  background: rgba(10, 120, 255, 0.1);
}
.box.treebar.pushy-menutype.navy .lnb .add__item:active {
  background: #b4d2ff;
}
.box.treebar.pushy-menutype.navy .lnb .lnb-depth3 > li.active a,
.box.treebar.pushy-menutype.navy .lnb .lnb-depth2 > li.active > a,
.box.treebar.pushy-menutype.navy .lnb .lnb-depth1 > li.active > p {
  background: #062b55;
}
.box.treebar.pushy-menutype .lnb .lnb-depth1 > li.requesting > p a::after {
  right: -13px;
  width: 8px;
  height: 8px;
  background: #0a78ff;
  border-radius: 50%;
  top: 5px;
  filter: none;
  transform: none;
}
.box.treebar.pushy-menutype .lnb .lnb-depth1 > li.requesting.delete > p a::after {
  background: #f55547;
}
.box.treebar.pushy-menutype .lnb .lnb-depth1 > li.requesting.delete > .lnb-depth2,
.box.treebar.pushy-menutype .lnb .lnb-depth2 > li.requesting.delete > .lnb-depth3,
.box.treebar.pushy-menutype .lnb .lnb-depth3 > li.requesting.delete > .lnb-depth4 {
  display: none !important;
}
.box.treebar.pushy-menutype .lnb .lnb-depth1 > li.disabled > p a span {
  color: rgba(144, 159, 183, 0.5);
  font-weight: 500;
}

@media screen and (max-width: 940px) {
  .box.treebar.pushy-menutype .lnb {
    height: calc(100vh - 102px);
  }
}
/* lnb-depth3 type4 */
.box.treebar.pushy-menutype.type4 .lnb .lnb-depth3 > li a {
  padding: 15px 40px;
  width: calc(100% - 80px);
  font-weight: 400;
  line-height: 14px;
}
.box.treebar.pushy-menutype.type4 .lnb .lnb-depth3 > li.active a {
  background: #b4d2ff;
  color: #0a78ff;
  font-weight: 500;
}

/* 운영관리 - 컨텐츠 */
.btn-add.etc + .popup-etc {
  top: 56px;
  right: 140px;
  width: 112px;
}
.btn-add.etc + .popup-etc li button,
.btn-add.etc + .popup-etc li button:focus {
  background-position: 10px center;
  background-size: 24px !important;
}
.btn-ask.etc + .popup-etc {
  top: 56px;
  right: 23px;
  width: 106px;
}
.btn-ask.etc + .popup-etc li button {
  background: #fff;
  padding-left: 0;
}
.btn-ask.etc + .popup-etc li button:focus-within {
  background: #b4d2ff;
}
.btn-ask.etc + .popup-etc li button:hover {
  background: #e6f0ff;
}
.btn-ask {
  width: 32px;
  height: 32px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_121___}) no-repeat 7px 7px #0a78ff;
  background-size: 21px;
}
.btn-ask:hover {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_122___}) no-repeat 7px 7px #0050b8;
  background-size: 21px;
}
.btn-ask:active {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_123___}) no-repeat 7px 7px #003876;
  background-size: 21px;
}
.btn-add-g-s {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_124___}) no-repeat center center;
  background-size: 24px;
}
.btn-add-all {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_125___}) no-repeat center center;
  background-size: 24px;
}
@media screen and (max-width: 1160px) {
  .left.m-block-mt-8 {
    margin-top: 8px;
  }
  .right.m-block-mt-34 {
    margin-top: 34px;
    width: 100% !important;
  }
  .btn-ask.etc + .popup-etc,
  .btn-add.etc + .popup-etc {
    top: 130px;
  }
}
@media screen and (max-width: 940px) {
  #wrap:not(.no-responsive) .tbl__top .searcharea button.btn.btn-filedown {
    background-size: 100%;
  }
  #wrap:not(.no-responsive) .tbl__top .searcharea button.btn.btn-ask {
    background-size: 25px;
    background-position: 10px 9px;
  }
  .btn-add.etc + .popup-etc {
    top: 140px;
    right: 95px;
  }
  .btn-ask.etc + .popup-etc {
    top: 140px;
  }
}
@media screen and (max-width: 499px) {
  .right.m-block-mt-34 {
    margin-top: 0;
  }
  .btn-ask.etc + .popup-etc,
  .btn-add.etc + .popup-etc {
    top: 155px;
  }
}

/* 운영관리 - 사용자 */
.btn-small-round,
.tbl-list table td button.btn-small-round {
  border: 0;
  padding: 0 12px;
  gap: 4px;
  justify-content: flex-end;
}
.btn-small-round span:first-child {
  font-size: 12px;
  font-weight: 500;
  /* line-height: 3px; */
  letter-spacing: -0.7px;
  color: #909fb7;
}
.btn-small-round span:last-child {
  background: #0a78ff;
  border-radius: 25px;
  padding: 4px 7px;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: -0.4px;
  color: #fff;
}
.btn-small-round.red span:last-child {
  background: #f55547;
}

/* 운영관리 - 사업장,전기실 관리 - 사용자관리 */
.request-cond {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-left: 2px;
}
.request-cond p {
  font-size: 12px;
  line-height: 16px;
  color: #909fb7;
  font-weight: 500;
  letter-spacing: -0.7px;
}
.request-cond .tit {
  font-size: 10px;
  color: #fff;
  font-weight: 500;
  letter-spacing: -0.4px;
  padding: 4px 8px 4px 7px;
  background: #0a78ff;
  border-radius: 25px;
  line-height: 1;
}
.request-cond.ok .tit {
  background: #f55547;
}

.content__info ul li p.txt .request-cond {
  display: none;
}

@media screen and (max-width: 940px) {
  .content__info ul li p.txt .request-cond {
    display: inline-block;
    margin-left: 15px;
  }
  .content__info ul li p.txt .request-cond span {
    font-size: 12px;
    line-height: 16px;
    color: #909fb7;
    font-weight: 500;
    letter-spacing: -0.7px;
  }
  .content__info ul li p.txt .request-cond span.tit {
    margin-left: 5px;
    font-size: 10px;
    color: #fff;
    font-weight: 500;
    letter-spacing: -0.4px;
    padding: 2px 8px 2px 7px;
    background: #0a78ff;
    border-radius: 25px;
    line-height: 1;
  }
  .content__info ul li p.txt .request-cond.ok span.tit {
    background: #f55547;
  }
}

@media screen and (max-width: 320px) {
  .content__info ul li p.txt .request-cond {
    display: block;
    margin-left: 0;
    margin-top: 4px;
  }
}

.form__info .txt > .filelist span span {
  padding-left: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_126___}) no-repeat 0 center;
  background-size: 20px;
  cursor: pointer;
  color: #0a78ff;
}
.form__info .txt > .filelist span:active span {
  padding-left: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_127___}) no-repeat 0 center;
  background-size: 20px;
}
.form__info .txt > .filelist span:hover span {
  padding-left: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_128___}) no-repeat 0 center;
  background-size: 20px;
}
#wrap:not(.no-responsive) .container:not(.service) .content__info + .content__info.line:before {
  content: "";
  position: relative;
  display: block;
  left: 0;
  width: 100%;
  height: 1px;
  background: #e9edef;
  margin-bottom: 40px;
}
#wrap:not(.no-responsive) .container:not(.service) .content__info ul > li {
  margin-bottom: 16px;
}
#wrap:not(.no-responsive) .container:not(.service) .content__info ul > li:last-child {
  margin-bottom: 40px;
}
.content__info > .top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.content__info > .top .tit {
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
  color: #2a2c2f;
}
.content__info ul.box-small-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.content__info ul.box-small-wrap li {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  flex: 1;
  padding: 16px;
  margin: 0 !important;
  max-width: calc(100% / 6 - 41px);
  min-width: calc(100% / 6 - 41px);
  min-height: 102px;
  background: #fff;
  border: 1px solid #dde2e9;
  border-radius: 4px;
}
.content__info ul.box-small-wrap li .tit {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.3;
  color: #051c3f;
  width: 100%;
}
.content__info ul.box-small-wrap li .score-info {
  justify-content: space-between;
}
.content__info ul.box-small-wrap li .score-info::before {
  content: none;
}
.content__info ul.box-small-wrap li .count-info {
  text-align: right;
  width: 100%;
}
.content__info ul.box-small-wrap li span {
  font-size: 16px;
  line-height: 1.3;
  color: #646c74;
}
.content__info ul.box-small-wrap li span.info {
  font-size: 24px;
  display: flex;
  align-items: center;
}
.content__info ul.box-small-wrap li span.info:before {
  content: "";
  width: 32px;
  height: 32px;
  margin-right: 4px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_104___}) no-repeat 0 0 transparent;
  background-size: 100%;
}
.content__info ul.box-small-wrap li span.info.caution:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_106___}) no-repeat 0 0 transparent;
  background-size: 100%;
}
.content__info ul.box-small-wrap li span strong {
  font-size: 30px;
  color: #003876;
  font-weight: 700;
  line-height: 1.1;
  margin-right: 8px;
  vertical-align: sub;
}
.content__info ul.box-small-wrap li .count-info span strong {
  color: #2a2c2f;
  font-weight: 400;
}
.content__info ul.box-small-wrap li > button {
  position: relative;
  margin: -17px;
  width: calc(100% + 34px);
  height: calc(100% + 34px);
  border: 0;
  background: #e8f1fe;
  padding: 16px 20px 16px 16px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  text-align: left;
}
.content__info ul.box-small-wrap li > button::before {
  content: "";
  position: absolute;
  right: 24px;
  bottom: 20px;
  display: block;
  width: 12px;
  height: 12px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_37___}) no-repeat center center;
  background-size: 100%;
}
.content__info ul.box-small-wrap li > button .tit {
  color: #0a78ff;
}
@media screen and (max-width: 1260px) {
  .content__info ul.box-small-wrap li {
    max-width: calc(100% / 3 - 41px);
    min-width: calc(100% / 3 - 41px);
  }
}
@media screen and (max-width: 940px) {
  .tab__line.m-fix {
    position: fixed;
    top: 102px;
    left: 0;
    background: #fff;
    z-index: 2;
  }
}
@media screen and (max-width: 499px) {
  .tab__line.m-fix {
    top: 142px;
  }
  .content__info ul.box-small-wrap {
    gap: 10px;
  }
  .content__info ul.box-small-wrap li {
    padding: 16px 8px;
    max-width: calc(100% / 3 - 25px);
    min-width: calc(100% / 3 - 25px);
  }
  .content__info ul.box-small-wrap li .count-info span strong {
    font-size: 22px;
    margin-right: 2px;
    vertical-align: text-bottom;
  }
  .content__info ul.box-small-wrap li > button {
    padding: 16px 8px;
    margin: -17px -9px;
    width: calc(100% + 18px);
    height: calc(100% + 34px);
  }
  .content__info ul.box-small-wrap li > button::before {
    right: 16px;
  }
}

/* 운영관리 - 설비추가 - 일괄 등록 */
.tbl-list.scrollX-basic {
  overflow-x: auto;
  width: 100%;
}
.tbl-list.scrollX-basic table {
  white-space: nowrap;
  width: max-content;
}
.tbl-list.scrollX-basic table th,
.tbl-list.scrollX-basic table td {
  padding: 4px 20px;
}
.tbl-list.scrollX-basic td .ellipsis {
  max-width: 152px;
  width: auto;
}
.content__info > .top .upload-area {
  display: flex;
  flex-direction: column;
  gap: 22px;
}
.content__info > .top .upload-area li {
  align-items: center;
  margin-bottom: 0;
}
.content__info > .top .upload-area li.flex-top {
  align-items: flex-start;
}
.content__info > .top .upload-area .tit {
  width: 104px;
  margin-right: 16px;
}
.content__info > .top .upload-area button.btn-basic {
  min-width: 96px;
}
.content__info > .top .upload-area button + button {
  margin-left: 8px;
}
.content__info .upload-area li .filelist {
  margin-right: 70px;
}
.content__info .upload-area li .filelist li {
  margin-bottom: 0 !important;
}
.content__info .upload-area li .filelist li + li {
  margin-top: 8px;
}
.content__info .upload-area li .filelist li span {
  font-size: 14px;
  line-height: 20px;
  color: #2a2c2f;
  padding-left: 21px;
}
.content__info .upload-area li .filelist li span.uploading {
  background: none;
  padding-left: 21px;
  position: relative;
}
.content__info .upload-area li .filelist li span.uploading:before {
  content: "";
  display: inline-block;
  position: absolute;
  left: -8px;
  top: 0;
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_44___}) no-repeat center center;
  background-size: 100%;
}
.content__info .upload-area li .filelist li span.uploading.end:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_45___}) no-repeat center center;
  background-size: 100%;
}
.content__info .upload-area li .filelist.h80.scrollH {
  padding-right: 0;
}
.content__info .upload-area li .filelist.h80.scrollH::-webkit-scrollbar-thumb {
  height: 64px;
}
.content__info .upload-area .progressbar .progress-value {
  margin-top: 0;
  width: auto;
  height: auto;
  flex-direction: row;
  align-items: center;
}
.content__info .upload-area .progressbar {
  width: auto;
  display: flex;
  justify-content: space-between;
}
.content__info .upload-area .progressbar .progress-value progress {
  height: 4px;
  width: 95px;
}
.content__info .upload-area .progressbar .progress-value .value {
  margin-left: 15px;
  width: auto;
}
.content__info .upload-area .progressbar .progress-value .value span {
  position: initial;
  top: unset;
  width: auto;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #2a2c2f;
}
.content__info .upload-area li .filelist li .case-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 70px;
}
.content__info .upload-area li .filelist li .case-info p {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 88px;
  font-size: 14px;
  line-height: 20px;
  color: #2a2c2f;
}
.content__info .upload-area li .filelist li .case-info span {
  background: none;
  padding-left: 0;
}
.content__info .upload-area li .filelist li .case-info .case-ok strong {
  font-weight: 500;
  color: #1fc95c;
}
.content__info .upload-area li .filelist li .case-info .case-no {
  margin-left: 24px;
}
.content__info .upload-area li .filelist li .case-info .case-no strong {
  font-weight: 500;
  color: #f55547;
}
.content__info .upload-area li .filelist li .case-info .btn-go {
  width: 20px;
  height: 20px;
  margin-left: 15px;
  border: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_129___}) no-repeat center center;
  background-size: 100%;
}
.tbl-list table.mb-110 .select.active ul {
  max-height: 110px;
}
.tbl-list table.mb-110 .select.active ul::-webkit-scrollbar-thumb {
  height: 70px;
}

@media screen and (max-width: 1580px) {
  .no-responsive .header__menu {
    margin-left: 70px;
  }
  .no-responsive .header__menu li a {
    padding: 0 12px;
    width: auto;
  }
}

/* 운영관리 - 데이터 관리 */
.box__body.data-manage {
  padding: 0 0 88px !important;
  overflow-y: auto;
  height: calc(100vh - 275px);
}
.box__body.data-manage .top-img {
  position: relative;
  padding: 48px 72px 24px;
  margin-bottom: 54px;
  height: 130px;
  background: linear-gradient(96.19deg, #114886 -1.88%, #003876 35.48%);
}
.box__body.data-manage .top-img::after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 136px;
  display: block;
  width: 240px;
  height: 162px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_130___}) no-repeat 0 0;
  background-size: 100%;
}
.box__body.data-manage .top-img .text-wrap {
  position: relative;
  width: 845px;
  z-index: 1;
}
.box__body.data-manage .top-img p {
  color: #fff;
  line-height: 20px;
  letter-spacing: -0.7px;
}
.box__body.data-manage .top-img p.tit {
  margin-bottom: 16px;
  font-size: 20px;
  font-weight: 500;
}
.box__body.data-manage .top-img p.txt {
  font-size: 13px;
}
.box__body.data-manage .top-img .btn-basic {
  background: rgba(10, 120, 255, 0.5);
  border-color: transparent;
  margin-top: 16px;
}
.box__body.data-manage .info__input + .info__input {
  margin-top: 80px;
}
.box__body.data-manage .info__input + .info__input + .info__input {
  margin-top: 120px;
}
.box__body.data-manage .info__input {
  width: 828px;
  margin-left: 72px;
}
.box__body.data-manage .info__input li {
  margin-bottom: 16px;
  margin-top: 0;
  gap: 0;
}
.box__body.data-manage .info__input li:last-child {
  margin-bottom: 0;
}
.box__body.data-manage .info__input li .flex-column {
  width: 100%;
  margin-bottom: 16px;
}
.box__body.data-manage .info__input li .flex-column .tit {
  margin-bottom: 16px;
}
.box__body.data-manage .info__input .page-top {
  margin-bottom: 16px;
}
.box__body.data-manage .info__input .page-top h3 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 16px;
  font-weight: 700;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  border-bottom: 1px solid #dde2e9;
}
.box__body.data-manage .info__input .page-top h3 .txt-info {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.box__body.data-manage .info__input .input__area .txt-info {
  display: inline-flex;
  font-size: 14px;
  line-height: 16px;
  color: #7a8596;
  margin-top: 4px;
}
.box__body.data-manage .info__input .input__area .txt-info + .txt-info {
  margin-top: 0;
}
.box__body.data-manage .info__input .input__area .txt-info::before {
  content: "*";
  margin-right: 2px;
}
.box__body.data-manage .info__input .input__area .txt-info.txt-red {
  color: #f55547 !important;
}
.box__body.data-manage .info__input .content__info .form__input {
  margin-left: 220px;
}
.box__body.data-manage .info__input .content__info ul.form__input li p.tit {
  width: 248px;
  margin-top: 7px;
  line-height: 20px;
  font-size: 15px;
}
.box__body.data-manage .info__input .content__info ul.form__input .input__area,
.box__body.data-manage .info__input .content__info ul li .txt {
  width: 360px;
  max-width: 360px;
}
.box__body.data-manage .info__input .content__info ul li .txt {
  margin-top: 7px;
  margin-bottom: 6px;
}
.box__body.data-manage .info__input .content__info ul.form__input .input__area .checkBox {
  margin-bottom: 15px;
}
.box__body.data-manage .info__input .content__info ul.form__input .input__area p.txtnum {
  position: absolute;
  top: -15px;
  right: 0;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #909fb7;
}
.box__body.data-manage .info__input .content__info ul li .btn__wrap {
  margin-top: 56px;
}
.box__body.data-manage .upload-area {
  margin-top: 40px;
}
.box__body.data-manage .content__info .upload-area li p.tit {
  width: 220px;
  margin-top: 6px;
  font-size: 15px;
}
.box__body.data-manage .content__info .upload-area li .filelist {
  margin-top: 6px;
  margin-right: 10px;
}
.box__body.data-manage .content__info .upload-area li .filelist li span:not(.uploading) {
  background-position: 5px center;
}
.box__body.data-manage .content__info .upload-area li .filelist li span {
  width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.box__body.data-manage .content__info .upload-area li .filelist li span.uploading {
  width: 300px;
  padding-left: 25px;
}
.box__body.data-manage .content__info .upload-area li .filelist li span.uploading.end {
  width: 200px;
}
.box__body.data-manage .content__info .upload-area li .filelist li span.uploading:before {
  left: 0;
}
.box__body.data-manage .content__info .upload-area li .filelist.end {
  width: 608px;
  margin-right: 0;
}
.box__body.data-manage .content__info .upload-area li .filelist.end li {
  justify-content: space-between;
}
.box__body.data-manage .content__info .upload-area li .filelist.end li span {
  width: auto;
  max-width: 300px;
}
.box__body.data-manage .content__info .upload-area li .filelist.end li .case-info {
  margin-left: 0;
}
.box__body.data-manage .content__info .upload-area li .btn-area {
  justify-content: flex-end;
  display: flex;
  flex: 1;
}
.box__body.data-manage .content__info .upload-area li .btn-area button {
  min-width: 96px;
}
.box__body.data-manage .content__info .upload-area li .btn-area button + button {
  margin-left: 8px;
}
.box__body.data-manage .content__info .upload-area .progressbar {
  margin-top: 6px;
  justify-content: flex-end;
  flex: 1;
}
.box__body.data-manage .content__info .upload-area .progressbar .progress-value {
  width: 200px;
}
.box__body.data-manage .content__info .upload-area .progressbar .progress-value progress {
  width: 160px;
}
.box__body.data-manage .content__info .upload-area .progressbar .progress-value .value {
  width: 35px;
  margin-left: 5px;
  text-align: right;
}
.box__body.data-manage .content__info .upload-area .endtxt {
  flex: 1;
  margin-top: 6px;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #0a78ff;
  text-align: right;
}
.box__body.data-manage .btn-basic span.icon-go:after {
  content: "";
  width: 20px;
  height: 20px;
  margin-left: 8px;
  margin-right: -8px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_131___}) no-repeat center center;
  background-size: 100%;
}
.box__body.data-manage .img-wrap {
  border: 1px solid #dde2e9;
}
.box__body.data-manage .paging {
  width: 100%;
  display: block;
}
.box__body.data-manage .paging ul {
  margin-left: 0;
}
.box__body.data-manage .info__input .content__info .paging ul > li {
  margin-bottom: 0 !important;
  border: 0;
}
.box__body.data-manage .info__input .content__info .paging ul > li > a {
  color: #909fb7;
}
.box__body.data-manage .info__input .content__info .paging ul > li > a.active {
  color: #fff;
}

/* 컨설팅 */
#wrap.bg-white .box {
  box-shadow: none;
}
.container.wide {
  margin: 50px 0 0 0;
  min-height: calc(100vh - 50px);
}
.container.wide .content {
  width: 100%;
  padding-left: 0;
}
.container.wide .box {
  display: flex;
  flex-direction: column;
  /* gap: 20px; */
  width: 100%;
  border-radius: 0;
}
.container.wide .box .box__header {
  padding: 0;
  border: 0;
  border-radius: 0;
  background: #0f2b4b;
  position: fixed;
  width: 100%;
  z-index: 3;
}
.container.wide .box .box__header .box-wrap {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;

  margin: 0 auto;
}
.container.wide .box .box__header .select {
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.4px;
  height: 32px;
  background: #0f2b4b;
}
.container.wide .box .box__header .select ul {
  margin-top: 0;
}
.container.wide .box .box__header .select .selected .arrow {
  filter: brightness(0) invert(1);
  background-size: 16px;
  margin-left: 8px;
}
.container.wide .box .box__body {
  padding: 0;
}
.container.wide .box .box__body .box-wrap {
  display: flex;
  flex-direction: column;
  width: calc(100% - 150px);
  max-width: 1050px;
  margin: 0 auto;
  padding: 0 75px 0;
  /* gap: 20px; */
}
.container.wide .box .box__body .box-wrap .locate {
  justify-content: flex-end;
  gap: 4px;
  background: none;
  position: relative;
  top: unset;
  width: 100%;
  max-width: 1050px;
  margin: 0 auto;
  padding: 0 0 20px;
  /* z-index: 3; */
}
.container.wide .box .box__body .box-wrap .locate li {
  gap: 4px;
  line-height: 1;
}
.container.wide .box .box__body .box-wrap .locate li:before {
  content: "";
  width: 16px;
  height: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_132___}) no-repeat center center;
  background-size: 100%;
}
.container.wide .box .box__body .box-wrap .locate li:first-child:before {
  content: none;
}
.container.wide .box .box__body .box-wrap .locate li a {
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 13px;
  letter-spacing: -0.4px;
  color: #909fb7;
}
.container.wide .box .box__body .box-wrap .locate li.on a {
  font-weight: 500;
  color: #2a2c2f;
}
.container.wide .box .box__body .box-wrap > section {
  display: flex;
  flex-direction: column;
  /* gap: 160px; */
}
.container.wide .box .box__body .box-wrap > section > article {
  display: flex;
  flex-direction: column;
  padding-top: 160px;
  /* gap: 120px; */
}
.container.wide .box .box__body .box-wrap > section > article:first-child {
  padding-top: 112px;
}
.container.wide .box .box__body .box-wrap h2 {
  font-size: 35px;
  font-weight: 500;
  line-height: 1.3;
  color: #2a2c2f;
  letter-spacing: -0.4px;
  padding-bottom: 80px;
}
.container.wide .box .box__body .box-wrap h3 {
  font-size: 26px;
  font-weight: 700;
  line-height: 1.6;
  color: #2a2c2f;
  letter-spacing: -1px;
  margin-bottom: 40px;
}
.container.wide .box .box__body .box-wrap h3 .txt-info {
  margin: 0;
}
.container.wide .box .box__body .box-wrap .txt-info {
  color: #646c74;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.4px;
  margin: 0 0 10px 0;
}
.helper-info {
  display: flex;
  gap: 16px;
}
.helper-info::before {
  content: "";
  width: 92px;
  height: 92px;
  flex: none;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_133___}) no-repeat center center;
  background-size: 100%;
}
.helper-info p {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: calc(100% - 92px);
}
.helper-info p span {
  font-size: 16px;
  line-height: 1.5;
  color: #2a2c2f;
  padding: 20px;
  background: #f7f8fa;
  border-radius: 20px;
}
.consult-result-box {
  margin-top: 80px;
}
.consult-result-box .title {
  font-size: 22px;
  font-weight: 500;
  line-height: 1.8;
  color: #2a2c2f;
  padding-left: 46px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_134___}) no-repeat 0 center;
  background-size: 38px 40px;
  margin-bottom: 20px;
}
.consult-result-box ul.result-box {
  display: flex;
  gap: 15px;
}
.consult-result-box ul.result-box li {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  flex: 1;
  padding: 32px 24px 24px;
  min-height: 166px;
  background-image: linear-gradient(145deg, #eef1f4, #f7f8fa);
  border: 1px solid #f7f8fa;
  border-radius: 24px;
  box-shadow: none;
}
.consult-result-box ul.result-box li .tit {
  font-size: 22px;
  font-weight: 500;
  line-height: 1.3;
  color: #051c3f;
}
.consult-result-box ul.result-box li .tit span {
  font-size: 18px;
  font-weight: 400;
  line-height: 1.3;
  color: #051c3f;
}
.consult-result-box ul.result-box li .score-info {
  justify-content: space-between;
}
.consult-result-box ul.result-box li .score-info::before {
  content: "";
  width: 72px;
  height: 72px;
  border-radius: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_135___}) no-repeat 0 0;
  background-size: 100%;
}
.consult-result-box ul.result-box li:first-child .score-info::before {
  width: 72px;
  height: 72px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_136___}) no-repeat 0 0;
  background-size: 100%;
}
.consult-result-box ul.result-box li:last-child .score-info::before {
  width: 72px;
  height: 72px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_137___}) no-repeat 0 0;
  background-size: 100%;
}
.consult-result-box ul.result-box li span {
  margin-top: 10px;
  font-size: 20px;
  line-height: 1;
  color: #646c74;
}
.consult-result-box ul.result-box li span strong {
  font-size: 38px;
  color: #051c3f;
  font-weight: 500;
  line-height: 1.1;
  margin-right: 8px;
  vertical-align: sub;
}
.consult-result-box ul.result-box + ul.result-box.small {
  margin-top: 16px;
}
.consult-result-box ul.result-box.small {
  gap: 11px;
}
.consult-result-box ul.result-box.small li {
  padding: 24px;
  min-height: 98px;
  background: #fff;
  border: 1px solid #dde2e9;
  border-radius: 20px;
}
.consult-result-box ul.result-box.small li .tit {
  font-size: 18px;
}
.consult-result-box ul.result-box.small li .score-info {
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}
.consult-result-box ul.result-box.small li .score-info::after {
  content: "";
  width: 100%;
  height: 2px;
  background: #c7d6ea;
}
.consult-result-box ul.result-box.small li .score-info::before {
  content: none;
}
.consult-result-box ul.result-box.small li .tit span {
  font-size: 18px;
}
.consult-result-box ul.result-box.small li span {
  font-size: 16px;
  margin-top: 0;
}
.consult-result-box ul.result-box.small li span strong {
  font-size: 30px;
  margin-right: 4px;
}
.consult-result-txt {
  margin-top: 80px;
}
.consult-result-txt .title {
  font-size: 16px;
  color: #2a2c2f;
  line-height: 1.5;
  margin-bottom: 20px;
}
.consult-result-txt .method {
  font-size: 26px;
  font-weight: 500;
  line-height: 1.6;
  letter-spacing: -1px;
  margin-bottom: 40px;
}
.consult-result-txt .method strong {
  font-weight: 700;
}
.consult-result-txt .point-wrap {
  padding: 40px 40px 60px;
  border-radius: 20px;
  background: #f7f8fa;
  margin-bottom: 40px;
}
.consult-result-txt .point-wrap .tit {
  display: flex;
  gap: 10px;
  margin-bottom: 40px;
}
.consult-result-txt .point-wrap .tit:before {
  content: "";
  width: 40px;
  height: 40px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_138___}) no-repeat 0 0;
  background-size: 100%;
}
.consult-result-txt .point-wrap .tit span {
  font-size: 22px;
  line-height: 1.5;
  color: #2a2c2f;
}
.consult-result-txt .point-wrap .tit strong {
  font-weight: 700;
}
.consult-result-txt .point-wrap .point {
  display: flex;
  flex-direction: column;
  gap: 35px;
  margin-left: 20px;
}
.consult-result-txt .point-wrap .point li {
  list-style: decimal;
  font-size: 16px;
  line-height: 1.5;
  color: #2a2c2f;
}
.solution + .solution {
  margin-top: 120px;
}
.solution .sol-txt li {
  font-size: 20px;
  line-height: 1.8;
  color: #2a2c2f;
}
.solution .sol-txt li strong {
  font-weight: 500;
}
.solution-area {
  display: flex;
  flex-direction: column;
  margin-top: 60px;
}
.solution-area .top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.solution-area .top .btn-basic {
  background: #fff !important;
  border-color: #fff !important;
}
.solution-area .top .btn-basic span {
  color: #909fb7;
}
.solution-area .top .btn-basic span.icon-go:after {
  content: "";
  width: 20px;
  height: 20px;
  margin-left: 8px;
  margin-right: -8px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_131___}) no-repeat center center;
  background-size: 100%;
}
.solution-area .tab__line {
  display: flex;
  align-items: center;
  background: #f7f8fa;
  border-radius: 25px;
  border: 0;
  gap: 0;
  width: auto;
  height: 32px;
}
.solution-area .tab__line li {
  padding: 0 24px;
}
.solution-area .tab__line li a {
  color: #2a2c2f;
}
.solution-area .tab__line li.on,
.solution-area .tab__line li:hover {
  background: #003875;
  border-radius: 25px;
  border: 0;
}
.solution-area .top .tab__line li.on a,
.solution-area .top .tab__line li:hover a {
  color: #fff !important;
  font-weight: 500 !important;
}
.solution-area .tab__line li.on a,
.solution-area .tab__line li:hover a {
  color: #fff !important;
  font-weight: 500 !important;
}
.item-list {
  display: flex;
  gap: 20px;
  height: 528px;
}
.item-list > li {
  flex: 1;
  max-width: 515px;
  height: 100%;
  border-radius: 4px;
  background: #fff;
  border: 1px solid #dde2e9;
}
.item-list li .img-wrap {
  position: relative;
  height: 200px;
  min-height: unset;
  background-size: cover;
  border-radius: 4px 4px 0 0;
}
.item-list li .img-wrap img {
  object-fit: cover;
  border-radius: 4px 4px 0 0;
}
.item-list li .img-wrap .tit {
  position: absolute;
  left: 40px;
  top: 88px;
  width: 80%;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.item-list li .img-wrap .tit strong {
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
}
.item-list li .img-wrap .tit span {
  color: #fff;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.3;
}
.slide-pagenation {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-top: 13px;
}
.slide-pagenation li {
  margin: 0 !important;
}
.slide-pagenation li a {
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #909fb7;
}
.slide-pagenation li.on a {
  background: #0978ff;
}
.item-info {
  height: calc(100% - 200px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.item-info-top {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
}
.item-info-top .keyword {
  display: flex;
  flex-wrap: wrap;
  gap: 0px 16px;
}
.item-info-top .keyword span {
  font-size: 13px;
  color: #0a78ff;
  line-height: 1.5;
}
.item-info-top .keyword span:before {
  content: "#";
}
.item-info-top .tit {
  color: #2a2c2f;
  font-size: 18px;
  font-weight: 700;
}
.item-info-top .company {
  color: #7783a1;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.3;
}
.item-info-top .cont {
  color: #2a2c2f;
  font-size: 13px;
  line-height: 1.5;
}
.item-info-top .etc {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.item-info-top .etc li {
  color: #003875;
  font-size: 13px;
  line-height: 1.5;
  font-weight: 500;
}
.item-info-btnarea {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #41444a;
  height: 48px;
  border-radius: 0 0 4px 4px;
}
.item-info-btnarea button {
  flex: 1;
  border: 0;
  height: 100%;
  justify-content: flex-start;
  padding: 0 16px 0 20px;
}
.item-info-btnarea button + button {
  border-left: 1px solid #26282e;
  height: 38px;
  border-radius: 0;
}
.item-info-btnarea button span.icon-go {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_139___}) no-repeat center right;
  background-size: 24px;
}
.item-info-btnarea button span.icon-more {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_140___}) no-repeat center right;
  background-size: 24px;
}
.item-info-btnarea button span {
  width: 100%;
  font-size: 14px;
  color: #fff;
  text-align: left;
}
.solution-area .paging {
  margin-top: 20px;
  width: 100%;
  justify-content: center;
}
.solution-area .paging ul {
  margin: 0;
  gap: 40px;
}
.solution-area .paging .btn-prev {
  width: 32px;
  height: 32px;
  margin: 0;
  border: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_141___}) no-repeat center center;
  background-size: 100%;
  transform: rotate(180deg);
}
.solution-area .paging .btn-next {
  width: 32px;
  height: 32px;
  margin: 0;
  border: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_141___}) no-repeat center center;
  background-size: 100%;
}
.solution-area .paging .btn-prev.disabled,
.solution-area .paging .btn-next.disabled {
  opacity: 0.2;
}
.solution-area .paging li.btn-prev + li {
  border: 0;
  height: auto;
  min-width: unset;
  letter-spacing: 3px;
  font-size: 14px;
  font-weight: 500;
}
.product {
  margin-top: -30px;
  margin-bottom: 30px;
}
.container.wide .box .box__body .box-wrap .product h3 {
  margin-bottom: 10px;
  margin-top: 30px;
}
.product .scrollX {
  margin-bottom: -20px;
  padding-bottom: 17px;
}
.product .scrollX::-webkit-scrollbar-thumb {
  border: 2px solid transparent;
}
.product .scrollX .tab__line {
  gap: 10px;
  width: 100%;
  min-width: 1050px;
  border: 0;
  background: none;
}
.product .scrollX .tab__line > li {
  height: 132px;
  padding: 0;
  min-width: 120px;
  max-width: 120px;
  border-radius: 4px;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
}
.product .scrollX .tab__line > li a {
  flex-direction: column;
}
.product .scrollX .tab__line > li a .img-wrap {
  width: 100%;
  height: 64px;
  min-height: unset;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_142___}) no-repeat center 35px;
  background-size: 24px;
}
.product .scrollX .tab__line > li.on a .img-wrap {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_143___}) no-repeat center 35px;
  background-size: 24px;
}
.product .scrollX .tab__line > li a .img-wrap img {
  object-fit: cover;
  border-radius: 4px 4px 0 0;
}
.product .scrollX .tab__line > li a p {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #2a2c2f;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  letter-spacing: -1px;
  font-weight: 500;
  height: calc(100% - 64px);
  padding: 0 8px;
}
.product .scrollX .tab__line li.on {
  border: 0;
  background: #0a78ff;
}
.product .scrollX .tab__line li.on a p {
  color: #fff;
  font-weight: 700;
}
.product .tab-content {
  padding: 40px;
  height: 448px;
  overflow-y: scroll;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 4px 4px;
}
.product .tab-content .scrollH {
  height: 448px;
}
.product .tab-content p {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  text-align: justify;
}
.product .tab-content p.tit {
  font-size: 20px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: -0.4px;
  color: #051c3f;
  margin-bottom: 20px;
}
.btn-top {
  position: fixed;
  right: 80px;
  bottom: 40px;
  width: 50px;
  height: 50px;
  border-radius: 0;
  border: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_144___}) no-repeat center center #26282e;
  background-size: 30px;
  z-index: 10;
}
.bg-logo {
  width: 100%;
  height: 30px;
  text-align: left;
}
.bg-logo img {
  width: 152px;
}

@media screen and (max-width: 940px) {
  .container.wide .box .box-wrap .select__toggleBtn {
    top: 50px;
  }
  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype.active {
    top: 102px;
    height: calc(100vh - 102px);
  }
  .container.wide .box .box__body .box-wrap {
    width: calc(100% - 80px);
    padding: 0 40px 0;
  }
  .container.wide .box .box__body .box-wrap > section > article {
    padding-top: 140px;
  }
  .container.wide .box .box__body .box-wrap > section > article:first-child {
    padding-top: 20px;
  }
  #wrap:not(.no-responsive) .solution-area .tab__line li {
    width: auto;
    padding: 0 24px;
    flex: unset;
  }
  #wrap:not(.no-responsive) .product > .tab__line li {
    flex: unset;
    padding: 12px 14px 13px;
  }
  #wrap:not(.no-responsive) .product .scrollX .tab__line li {
    flex: unset;
    padding: 0;
  }
}
@media screen and (max-width: 779px) {
  .container.wide .box .box__body .box-wrap .locate li a {
    font-size: 14px;
  }
  .container.wide .box .box__body .box-wrap h2 {
    font-size: 32px;
    padding-bottom: 72px;
  }
  .helper-info {
    gap: 8px;
  }
  .helper-info p {
    width: calc(100% - 100px);
  }
  .consult-result-box {
    margin-top: 72px;
  }
  .consult-result-box .title {
    margin-bottom: 16px;
  }
  .consult-result-box ul.result-box {
    flex-direction: column;
    gap: 12px;
  }
  .consult-result-box ul.result-box li {
    padding: 28px 20px 20px;
    min-height: 102px;
  }
  .consult-result-box ul.result-box li .score-info::before,
  .consult-result-box ul.result-box li:first-child .score-info::before,
  .consult-result-box ul.result-box li:last-child .score-info::before {
    width: 64px;
    height: 64px;
  }
  .consult-result-box ul.result-box + ul.result-box.small {
    flex-wrap: wrap;
    flex-direction: row;
    gap: 10px;
  }
  .consult-result-box ul.result-box.small li {
    width: 33%;
    padding: 24px 20px;
    flex: auto;
  }
  .consult-result-box ul.result-box.small li .tit {
    display: flex;
    flex-direction: column;
  }
  .consult-result-txt {
    margin-top: 68px;
  }
  .consult-result-txt .method {
    font-size: 22px;
    line-height: 1.8;
  }
  .consult-result-txt .point-wrap {
    padding: 40px 20px 60px;
  }
  .consult-result-txt .point-wrap .tit {
    gap: 8px;
    margin-bottom: 20px;
  }
  .consult-result-txt .point-wrap .point {
    gap: 30px;
    margin-left: 25px;
  }
  .consult-result-txt .point-wrap .point li {
    line-height: 1.8;
  }
  #wrap:not(.no-responsive) .solution-area .tab__line li {
    padding: 0 20px;
  }
  #wrap:not(.no-responsive) .solution-area .tab__line li a {
    font-size: 14px;
    line-height: 1;
  }
  .solution-area .top {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
  .solution-area .top .right {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
  #wrap:not(.no-responsive) .solution-area .top .btn-basic {
    height: 32px;
  }
  #wrap:not(.no-responsive) .solution-area .top .btn-basic span {
    font-size: 14px;
  }
  .item-list {
    width: 100%;
    overflow: hidden;
  }
  .item-list > li {
    width: calc(100% - 2px);
    flex: none;
  }
  .product > .tab__line {
    gap: 0;
  }
  #wrap:not(.no-responsive) .product > .tab__line li {
    min-width: 89px;
  }
  .product .tab-content {
    padding: 20px 0;
    width: calc(100% + 15px);
    overflow: hidden;
    box-shadow: none;
    height: auto;
  }
  .product .tab-content .scrollH {
    height: 540px;
    padding-right: 25px;
    margin-right: 0;
  }
  .bg-logo {
    text-align: center;
  }
  .btn-top {
    right: 20px;
  }
}
@media screen and (max-width: 767px) {
  #wrap:not(.no-responsive) .container:not(.no-responsive) .solution-area .paging {
    margin-top: 20px;
    width: 100%;
    justify-content: center;
  }
  #wrap:not(.no-responsive) .container:not(.no-responsive) .solution-area .paging ul {
    margin: 0;
    gap: 40px;
  }
  #wrap:not(.no-responsive) .container:not(.no-responsive) .solution-area .paging .btn-prev {
    width: 32px;
    height: 32px;
    margin: 0;
    border: 0;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_141___}) no-repeat center center;
    background-size: 100%;
    transform: rotate(180deg);
  }
  #wrap:not(.no-responsive) .container:not(.no-responsive) .solution-area .paging .btn-next {
    width: 32px;
    height: 32px;
    margin: 0;
    border: 0;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_141___}) no-repeat center center;
    background-size: 100%;
  }
  #wrap:not(.no-responsive) .container:not(.no-responsive) .solution-area .paging .btn-prev.disabled,
  #wrap:not(.no-responsive) .container:not(.no-responsive) .solution-area .paging .btn-next.disabled {
    opacity: 0.2;
  }
  #wrap:not(.no-responsive) .container:not(.no-responsive) .solution-area .paging li.btn-prev + li {
    border: 0;
    height: auto;
    min-width: unset;
    width: auto;
    letter-spacing: 3px;
  }
}
@media screen and (max-width: 499px) {
  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype.active {
    top: 194px;
    height: calc(100vh - 192px);
  }
  .container.wide .box .box__body .box-wrap {
    width: calc(100% - 40px);
    padding: 0 20px 0;
  }
  #wrap:not(.no-responsive) .solution-area .tab__line li {
    padding: 0 12px;
  }
  .container.wide .box .box-wrap .select__toggleBtn {
    top: 90px;
  }
  #wrap:not(.float-page, .no-responsive) .container.wide .selectbar.box.menutype.active {
    top: 142px;
  }
}

/* management - 승인관리 */
.content-wrap > .l-divide {
  display: flex;
  height: 100%;
}
.content-wrap > .l-divide > article + article {
  border-left: 4px solid #dde2e9;
}
.user-num {
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #2a2c2f;
  text-align: right;
}
.user-num span {
  font-weight: 700;
  color: #0a78ff;
  margin-right: 4px;
}
td.icon-new {
  position: relative;
}
td.icon-new:after {
  content: "";
  display: block;
  clear: both;
}
td.icon-new span::before {
  content: "New";
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: -20px;
  float: left;
  margin-top: 2px;
  width: 24px;
  height: 12px;
  margin-right: 8px;
  font-weight: 500;
  font-size: 8px;
  line-height: 14px;
  color: #fff;
  background: #0a78ff;
  border-radius: 16px;
}
td.icon-delete {
  position: relative;
}
td.icon-delete:after {
  content: "";
  display: block;
  clear: both;
}
td.icon-delete span::before {
  content: "삭제";
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: -20px;
  float: left;
  margin-top: 2px;
  width: 24px;
  height: 12px;
  margin-right: 8px;
  font-weight: 500;
  font-size: 8px;
  line-height: 14px;
  color: #fff;
  background: #f55547;
  border-radius: 16px;
}
.tbl-list table td button.btn.btn-delete-g {
  background-size: 20px 20px;
}
.form__input .input__area .btn-new {
  position: absolute;
  right: 10px;
  top: 10px;
  background: #0978ff;
  height: 12px;
  min-width: 24px;
  padding: 0 3px;
  border-radius: 25px;
  border-color: #0978ff;
}
.form__input .input__area .btn-new span {
  color: #fff;
  font-size: 8px;
}
.form__input .input__area .btn-new + input[type="text"] {
  padding-right: 38px;
  width: calc(100% - 54px);
}

/* management - 설비유형 관리 */
.no-responsive .box-wrap > .treebar.box {
  border-right: 4px solid #dde2e9;
  box-shadow: none;
  border-radius: 0;
  height: calc(100vh - 115px);
  min-height: 964px;
}
.treebar.box.pushy-menutype.type2 .box__header {
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  height: auto;
  padding: 12px 15px 11px;
}
.treebar.box.pushy-menutype.type2 .box__header .add__item {
  height: auto;
  width: calc(100% + 16px);
  padding: 12px;
  margin: 0 -8px;
  background: #e6f0ff;
  border-radius: 4px;
  border: 0;
  justify-content: flex-start;
}
.treebar.box.pushy-menutype.type2 .box__header .add__item:hover {
  background: #dee9f6;
}
.treebar.box.pushy-menutype.type2 .box__header .add__item:active {
  background: #b4d2ff;
}
.treebar.box.pushy-menutype.type2 .box__header .add__item span {
  display: flex;
  align-items: center;
  color: #0978ff;
  font-weight: 500;
  font-size: 14px;
  line-height: 1;
}
.treebar.box.pushy-menutype.type2 .box__header .add__item span::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_37___}) no-repeat center center;
  width: 12px;
  height: 12px;
  margin-right: 12px;
  background-size: 100%;
}
.box.treebar.pushy-menutype.type2 .lnb {
  /* height: calc(100vh - 103px); */
  height: calc(100% - 74px);
}
.box.treebar.pushy-menutype.type2 .lnb .lnb-depth2 > li > .add__item {
  margin: 8px 8px 24px;
  width: calc(100% - 16px);
}
.box.treebar.pushy-menutype.type2 .lnb .lnb-depth1 > li.active {
  border-bottom: 0;
}
.box.treebar.pushy-menutype.type2 .lnb .lnb-depth1 > li.active > p {
  background: #f0f2f4;
  color: #2a2c2f;
}
.box.treebar.pushy-menutype.type2 .lnb .lnb-depth1 > li > p a {
  font-weight: 700;
}
.box.treebar.pushy-menutype.type2 .lnb .lnb-depth1 > li > p a::after {
  content: none;
}
.box.treebar.pushy-menutype.type2 .lnb .lnb-depth2 > li {
  border-bottom: 1px solid #dde2e9;
}
.box.treebar.pushy-menutype.type2 .lnb .lnb-depth2 > li:first-child {
  border-top: 1px solid #dde2e9;
}
.box.treebar.pushy-menutype.type2 .lnb .lnb-depth2 > li > a {
  padding: 16px 24px 15px 20px;
  width: calc(100% - 44px);
  border: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.box.treebar.pushy-menutype.type2 .lnb .lnb-depth2 > li > a::after {
  content: none;
}
.box.treebar.pushy-menutype.type2 .lnb .lnb-depth2 > li > a p {
  display: flex;
  align-items: center;
  flex: 2.5;
}
.box.treebar.pushy-menutype.type2 .lnb .lnb-depth2 > li > a p:before {
  content: "";
  width: 8px;
  height: 8px;
  margin-right: 16px;
  background: #0a78ff;
  border-radius: 50%;
}
.box.treebar.pushy-menutype.type2 .lnb .lnb-depth2 > li > a.dis p:before {
  background: #dde2e9;
}
.box.treebar.pushy-menutype.type2 .lnb .lnb-depth2.basic > li > a p:before {
  content: none;
}
.box.treebar.pushy-menutype.type2 .lnb .lnb-depth2 > li > a span.txt {
  flex: 1;
  color: #0a78ff;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.2;
  text-align: right;
}
.box.treebar.pushy-menutype.type2 .lnb .lnb-depth2 > li.active > a {
  background: #b4d2ff;
  font-weight: 700;
  color: #0a78ff;
}
.box.treebar.pushy-menutype.type2 .box__search.type-line + .box__header + .lnb {
  height: calc(100% - 107px);
}
.treebar.box.pushy-menutype .box__header .list-info {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  width: 100%;
}
.treebar.box.pushy-menutype .box__header .list-info.tit {
  color: #0a78ff;
  justify-content: flex-start;
  font-weight: 500;
}
.treebar.box.pushy-menutype .box__header .list-info span {
  display: flex;
  align-items: center;
}
.treebar.box.pushy-menutype .box__header .list-info span:before {
  content: "";
  width: 10px;
  height: 10px;
  margin-right: 8px;
  background: #0a78ff;
  border-radius: 50%;
}
.treebar.box.pushy-menutype .box__header .list-info span.dis:before {
  background: #dde2e9;
}
.top-button {
  display: flex;
}
.top-button button {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background-color: #909fb7;
}
.top-button button:hover {
  background-color: #7a8596;
}
.top-button button:active {
  background-color: #646c74;
}
.top-button button.blue {
  border-color: #0a78ff;
  background-color: #0a78ff;
}
.top-button button.blue:hover {
  border-color: #0050b8;
  background-color: #0050b8;
}
.top-button button.blue:active {
  border-color: #003876;
  background-color: #003876;
}
.top-button button + button {
  margin-left: 10px;
}
.content__info ul:not(.paging__button) li {
  display: flex;
  align-items: flex-start;
  margin-bottom: 40px;
}
.content__info ul li p {
  font-size: 14px;
  line-height: 14px;
  color: #2a2c2f;
}
.content__info ul li p.txt-info {
  font-size: 14px;
  color: #7a8596;
  line-height: 24px;
  margin: 5px 0 0 0;
}
.content__info ul li p.tit {
  width: 120px;
  font-weight: 700;
  line-height: 20px;
  font-size: 15px;
}
/* .content__info ul li:first-child p.tit {
  margin-top: 5px;
} */
.content__info ul li p.tit span {
  font-size: 13px;
  font-weight: 400;
  margin-left: 3px;
}
.content__info ul li p.tit span.inline {
  display: inline !important;
}
.content__info ul li .txt {
  width: calc(100% - 120px);
  line-height: 20px;
  position: relative;
}
.content__info ul li .treeon {
  width: 100px;
  height: 32px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_145___}) no-repeat 0 0;
  background-size: 100%;
}
.content__info ul li .treeoff {
  width: 100px;
  height: 32px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_146___}) no-repeat 0 0;
  background-size: 100%;
}
.content__info ul li p.txt a {
  color: #0a78ff;
}
.content__info ul li .tbl-list table th {
  background: rgba(227, 231, 238, 0.5);
  padding: 4px 24px;
}
.content__info ul li .tbl-list table td {
  padding: 4px 24px;
}
.content__info ul li .tbl-list.p-4 table th,
.content__info ul li .tbl-list.p-4 table td {
  padding: 4px;
}
.content__info ul li .tbl-list.p-4 table td .btn-delete-gr {
  background-size: 32px;
}
.content__info ul li .txt.radioBox {
  gap: 20px;
  flex-wrap: wrap;
  margin-top: 4px;
}
.content__info ul li .txt.radioBox input[type="checkbox"] + label {
  width: 63px;
  margin-left: 0;
}
.content__info ul li .txt.radioBox input[type="checkbox"] + label:before {
  top: 0;
  border-radius: 0;
}
.content__info ul li .txt.radioBox input[type="checkbox"] + label:after {
  width: 12px;
  height: 12px;
  top: 0;
  border-radius: 0;
  background-size: inherit;
}
.content__info ul li .btn__wrap {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 6px;
}
.content__info ul li .btn__wrap .btn-basic {
  height: 40px;
  min-width: 140px;
}
.content__info ul li .btn__wrap .btn-basic span {
  font-size: 16px;
  font-weight: 700;
}

@media screen and (max-width: 940px) {
  .no-responsive .treebar.box {
    display: block;
  }
  .no-responsive .box.treebar.pushy-menutype.active {
    top: unset;
  }
  .no-responsive .box.treebar.pushy-menutype .lnb .lnb-depth1 > li > p {
    min-height: unset;
  }
  .no-responsive .box.treebar.pushy-menutype .lnb .lnb-depth2 > li a {
    min-height: unset;
  }
  .no-responsive .box.treebar.pushy-menutype .lnb .lnb-depth3 > li a {
    min-height: unset;
  }
}

/* management - 메세지 관리 */
.box.treebar.pushy-menutype.type3 .lnb .lnb-depth1 > li.active {
  position: relative;
}
.box.treebar.pushy-menutype.type3 .lnb .lnb-depth1 > li.active:before {
  content: none;
}
.box.treebar.pushy-menutype .lnb .lnb-depth1 > li.active > p {
  background: #b4d2ff;
  color: #0a78ff;
}
.box.treebar.pushy-menutype.type3 .lnb .lnb-depth1 > li > p {
  font-weight: 700;
}
.box.treebar.pushy-menutype.type3 .lnb .lnb-depth1 > li > p a::after {
  content: none;
}
.box.treebar.pushy-menutype.type3 .lnb .lnb-depth1 > li > p a span {
  max-width: 100%;
}
.popup__body .message .form__input {
  width: 100%;
  margin-bottom: 24px;
}
.popup__body .message .form__input + .form__input {
  padding-top: 24px;
  border-top: 1px solid #dde2e9;
}
.popup__body .message .form__input:last-child {
  margin-bottom: 0;
}
.popup__body .message .form__input .tit {
  font-weight: 700;
  font-size: 15px;
  color: #2a2c2f;
  width: 222px;
}
.popup__body .message .form__input .sub-input {
  margin-top: 1rem;
  align-items: flex-start;
}
.popup__body .message .form__input .sub-input + .sub-input {
  margin-top: 8px;
}
.popup__body .message .form__input .sub-input .tit {
  font-weight: 500;
  font-size: 13px;
  color: #2a2c2f;
  width: 222px;
  vertical-align: top;
  margin-top: 8px;
}
.popup__body .message .form__input input[type="text"]:read-only,
.popup__body .message .form__input input[type="text"]:read-only:focus,
.popup__body .message .form__input input[type="text"]:disabled {
  background: #f7f8fa !important;
  border-color: #f7f8fa !important;
  color: #2a2c2f !important;
}

/* management - 메뉴 관리 */
.tbl-list.menulist input[type="checkbox"] + label:before {
  width: 12px;
  height: 12px;
  border-radius: 0;
}
.tbl-list.menulist input[type="checkbox"]:checked + label:after {
  width: 12px;
  height: 12px;
  border-radius: 0;
  background-size: 10px;
  background-position-y: 2px;
}
.tbl-list.menulist input[type="checkbox"]:disabled + label:before {
  background-color: #e9edef;
  border-color: #e9edef;
}
.tbl-list.menulist input[type="checkbox"]:disabled + label:after {
  content: none;
}
.tbl-list.menulist input[type="checkbox"].readonly:disabled + label:before {
  border-color: #909fb7;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_55___}) no-repeat center center #909fb7;
  background-size: 10px;
}
.tbl-list.menulist input[type="checkbox"].error + label:before {
  border-color: #f55547;
  background-color: #fff;
}
.tbl-list.menulist input[type="checkbox"].error:checked + label:after {
  border-color: #f55547;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_55___}) no-repeat center center #f55547;
  background-size: 10px;
}
.tbl-list.menulist input[type="checkbox"] {
  position: unset;
  width: auto;
}
.tbl-list.menulist input[type="checkbox"] + label {
  display: inline;
}

/* management - 사용자 관리 */
.box.treebar.pushy-menutype.type3 .box__header + .lnb {
  height: calc(100% - 47px);
}
.tbl-list.userlist table td button.btn-basic {
  padding: 0 8px;
  height: 30px;
}
/* .tbl-list.userlist table td button.btn-basic.bg-no:hover, .tbl-list.userlist.tbl-select tr td:hover button.bg-no.btn-basic:not(:disabled):hover, .tbl-list.userlist.tbl-select tr.selected td button.bg-no.btn-basic{
  background: transparent !important;
} */
.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap button.txtline {
  width: auto;
  height: auto;
  border: 0;
}
.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap button.txtline span {
  font-weight: 500;
  font-size: 15px;
  line-height: 0px;
  color: #909fb7;
  text-decoration: underline;
}

/* management - 사업장 관리 */
.content__info + .content__info.line:before {
  content: "";
  position: absolute;
  left: 0;
  width: 100%;
  height: 2px;
  background: #e9edef;
}
.content__info + .content__info.line > .form__input {
  padding-top: 35px;
}
.content__info + .content__info.scrollH {
  max-height: calc(100vh - 560px);
  min-height: 520px;
  margin-right: -20px;
}
.content__info.hidden + .content__info.scrollH {
  height: calc(100vh - 240px);
}
.content__info + .content__info > h3 {
  margin-top: 30px;
  font-weight: 700;
  font-size: 17px;
  line-height: 22px;
  color: #2a2c2f;
}
.content__info + .content__info.scrollH ul.form__input li:last-child {
  margin: 40px 0 0;
}
.result__score p.tit.caution {
  display: flex;
  align-items: center;
  font-size: 15px;
  color: #2a2c2f;
  font-weight: 400;
  margin-top: 0;
  width: auto;
}
.result__score p.tit.caution::before {
  content: "";
  width: 16px;
  height: 16px;
  margin-right: 4px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat top center;
  background-size: 100%;
}
.result__score p.tit.caution::after {
  content: "";
  width: 14px;
  height: 14px;
  margin-left: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_52___}) no-repeat center center;
  background-size: 100%;
}
.txt .result__score .score::before {
  content: "";
  width: 12px;
  height: 12px;
  margin-right: 0;
}
.result__score {
  display: flex;
  align-items: center;
}
.result__score::after {
  content: "점";
  margin-left: 7px;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #909fb7;
}
.result__score .select.active ul {
  max-height: 162px;
  overflow-y: auto;
}
.content-wrap .box__header .box__title > .btn-more {
  width: 32px;
  height: 32px;
  border: 0;
  margin-left: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_51___}) no-repeat center center;
  background-size: 100%;
  transform: scaleY(-1);
}
.content-wrap .box__header .box__title > .btn-more.on {
  transform: scaleY(1);
}
.content-wrap .content__info .listbox__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  margin-top: 30px;
}
.content-wrap .content__info .listbox__top h3 {
  font-weight: 700;
  font-size: 17px;
  line-height: 22px;
  color: #2a2c2f;
}
.content-wrap .content__info .listbox__top button.add__item {
  width: 128px;
  height: 32px;
  background: #e7f2ff;
  border: 0;
}
.content-wrap .content__info .listbox__top button.add__item span {
  font-weight: 500;
  font-size: 14px;
  color: #0a78ff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.content-wrap .content__info .listbox__top button.add__item span::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_37___}) no-repeat center center;
  width: 12px;
  height: 12px;
  margin-right: 7px;
  background-size: 100%;
}
.content-wrap .content__info .listbox__top button.add__item:hover {
  background: #dee9f6;
}
.content-wrap .content__info .listbox__top button.add__item:active {
  background: #b4d2ff;
}
.content-wrap .content__info .listbox__area {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding-left: 4px;
}
.content-wrap .content__info .listbox {
  width: calc(25% - 8px);
  min-width: 320px;
  height: 270px;
  background: #ffffff;
  box-shadow: 0px 3px 8px rgba(144, 159, 183, 0.5);
  border-radius: 4px;
}
.content-wrap .content__info .listbox:last-child {
  margin-right: 0;
}
.content-wrap .content__info .listbox .box__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 15px;
  border-bottom: 1px solid #dde2e9;
}
.content-wrap .content__info .listbox .box__top p {
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.content-wrap .content__info .listbox .box__top p.site {
  padding-left: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_147___}) 0 center no-repeat;
  background-size: 10px 14px;
}
.content-wrap .content__info .listbox .box__top p.factory {
  padding-left: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_147___}) 0 center no-repeat;
  background-size: 10px 14px;
}
.content-wrap .content__info .listbox .box__bottom {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.content-wrap .content__info .listbox .box__bottom p span {
  font-weight: 400;
  font-size: 14px;
  line-height: 12px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.content-wrap .content__info .listbox .box__bottom ul {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.content-wrap .content__info .listbox .box__bottom ul li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  line-height: 16px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  margin-bottom: 0;
}
.content-wrap .content__info .listbox .box__bottom ul li.column {
  flex-direction: column;
}
.content-wrap .content__info .listbox .box__bottom ul + ul {
  border-top: 1px solid #dde2e9;
  margin-top: 12px;
  padding-top: 5px;
}
.content-wrap .content__info .listbox .box__bottom ul li strong {
  font-weight: 500;
  margin-right: 7px;
}
.content-wrap .content__info .listbox .box__bottom ul li .tit {
  width: auto;
}
.content-wrap .content__info .listbox .box__bottom ul li .score__info {
  margin-top: 8px;
  margin-bottom: 0;
  font-size: 12px;
  line-height: 1.3;
  text-align: justify;
  letter-spacing: -0.4px;
  color: #909fb7;
}
.content-wrap .content__info .listbox .box__bottom ul li .result__score {
  justify-content: space-between;
  width: 100%;
  margin-top: 5px;
}
.content-wrap .content__info .listbox .box__bottom ul li .result__score::after {
  content: none;
}
.content-wrap .content__info .listbox .box__bottom ul li .result__score div::after {
  content: "점";
  margin-left: 7px;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #909fb7;
}
.content-wrap .content__info .listbox .box__bottom ul li .result__score p.tit.caution::after {
  margin-right: 7px;
  margin-left: 15px;
}
.content-wrap .content__info .listbox .box__bottom li div {
  display: flex;
  align-items: center;
}
.content-wrap .content__info .listbox .box__bottom p strong {
  font-weight: 700;
  margin-left: 10px;
}
.popup-type1.workplace-ok.page-detail .workplace__info .txt_workplace {
  margin-left: 0;
  width: 100%;
}
.popup-type1.workplace-ok.page-detail .workplace__info .txt_workplace ul {
  width: 100%;
}
.popup-type1.workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column .result__score {
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 0;
}
.popup-type1.workplace-ok.page-detail .workplace__info .txt_workplace .result__score::after {
  content: none;
}
.popup-type1.workplace-ok.page-detail .workplace__info .txt_workplace .result__score > div::after {
  content: "점";
  margin-left: 7px;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #909fb7;
}
.popup-type1.workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column .result__score .tit.caution {
  width: auto;
  margin-right: 0;
}
.popup-type1.workplace-ok.page-detail .workplace__info .txt_workplace .result__score p.tit.caution::after {
  margin-right: 7px;
  margin-left: 15px;
}
.popup-type1.workplace-ok.page-detail
  .workplace__info
  .txt_workplace
  ul
  li
  div.txt.column
  .result__score
  .score::before {
  content: none;
}
.popup-type1.workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column .score__info {
  margin-top: 20px;
  margin-bottom: 0;
  font-size: 13px;
  line-height: 1.3;
  text-align: justify;
  letter-spacing: -0.4px;
  color: #909fb7;
}
.popup-type1.workplace-ok.page-detail .workplace__info .txt_workplace ul li p.tit {
  width: 160px;
}

/* management - 솔루션관리 */
.keywordlist {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
td .keywordlist {
  margin: 12px 0;
}
.labellist {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.labellist li {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 28px;
  padding: 0 12px;
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: #0a78ff;
  background: #e7f2ff;
  border-radius: 45px;
}
td .labellist {
  margin: 12px 0;
}

/* 서비스요청 - 상담신청 */
.service .box__header {
  flex-direction: column;
  align-items: flex-start;
  padding: 32px 72px 32px;
  max-width: 828px;
  height: auto;
  border: 0;
}
.service .box__header h2 {
  margin-bottom: 24px;
  font-weight: 700;
  font-size: 25px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.service .box__header .box__title {
  margin-bottom: 32px;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.service .box__info {
  padding-left: 225px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_148___}) no-repeat left center;
  background-size: auto 88px;
}
.service .box__info.nobg {
  background: none;
  padding: 0;
}
.service .box__info li {
  position: relative;
  display: flex;
  font-weight: 400;
  font-size: 13px;
  line-height: 22px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  padding-left: 10px;
}
.service .box__info li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  margin-right: 7px;
  border-radius: 50%;
  background: #2a2c2f;
}
.service hr {
  border-top: 1px solid #dde2e9;
}
.service .box__body .d-sm-block {
  display: none;
}
.service .box__body {
  padding: 40px 72px 64px;
  max-width: 828px;
}
.service .box__body .info__input + .info__input {
  margin-top: 70px;
}
.service .box__body .info__input {
  width: 828px;
}
.service .box__body .info__input li {
  margin-bottom: 24px;
  margin-top: 0;
  gap: 0;
}
.service .box__body .info__input li:last-child {
  margin-bottom: 0;
}
.service .box__body .info__input li .flex-column {
  width: 100%;
  margin-bottom: 16px;
}
.service .box__body .info__input li .flex-column .tit {
  margin-bottom: 16px;
}
.service .box__body .page-top h3 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 16px;
  font-weight: 700;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  border-bottom: 1px solid #a4b0c4;
}
.service .box__body .page-top h3 .txt-info {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.service .box__body .info__input .content__info {
  margin-left: 220px;
}
.service .box__body .content__info ul.form__input li p.tit {
  width: 248px;
  margin-top: 7px;
  line-height: 20px;
  font-size: 15px;
}
.service .box__body .content__info ul.form__input .input__area {
  width: 360px;
  max-width: 360px;
}
.service .box__body .content__info ul.form__input .input__area .checkBox {
  margin-bottom: 15px;
}
.service .box__body .content__info ul.form__input .input__area p.txtnum {
  position: absolute;
  top: -15px;
  right: 0;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #909fb7;
}
.service .box__body .input__area .select + .select {
  margin-top: 8px;
}
.service .box__body .input__area .txt-info {
  display: inline-flex;
  font-size: 12px;
  line-height: 16px;
  color: #646c74;
  margin-bottom: 8px;
  margin-top: 4px;
}
.service .box__body .input__area .txt-info + .txt-info {
  margin-top: 0;
}
.service .box__body .input__area .txt-info::before {
  content: "*";
  margin-right: 2px;
  font-size: 12px;
}
.service .box__body .input__area .txt-info.txt-red {
  color: #f55547 !important;
}
.service ul.form__input li .filelist li {
  gap: 4px;
}
.service .box__body .content__info ul.form__input li.flex-column p.tit,
.service .box__body .content__info ul.form__input li.flex-column .input__area {
  width: 100% !important;
  max-width: 100% !important;
}
.service .box__body .content__info ul.form__input li.flex-column p.tit {
  font-size: 14px;
}
.service .box__body .content__info ul.form__input li.flex-column .input__area {
  margin-top: 16px;
}
.service .box__body .terms {
  display: flex;
  flex-direction: column;
}
.service .box__body .terms li {
  display: flex;
  flex-direction: column;
  margin-top: 24px;
}
.service .box__body .terms li:first-child {
  margin-top: 0;
}
.service .box__body .terms .box-scroll {
  border: 1px solid #909fb7;
  border-radius: 4px;
  padding: 9px 19px 9px 9px;
  font-size: 13px;
  height: 140px;
  overflow-y: scroll;
  background: #fff;
}
.service .box__body .terms p {
  width: 100%;
  font-size: 13px;
  line-height: 16px;
  color: #2a2c2f;
  word-wrap: break-word;
  word-break: break-all;
  text-align: justify;
}
/* .service .box__body .radioBox input[type='radio']:checked::before {
  height: 100%;
} */
.service .box__body .form__input li .btn__wrap {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 0;
}
.service .box__body .form__input li .btn__wrap.center {
  max-width: 100%;
  justify-content: center;
  margin-left: 10px;
}
.service .box__body .form__input li .btn__wrap button {
  padding: 0 1.25rem;
  width: 8.75rem;
  height: 2.5rem;
  background-color: #0a78ff;
  border: 0;
}
.service .box__body .form__input li .btn__wrap button span {
  color: #fff;
  font-weight: 700;
}
.service .box__body .form__input li .btn__wrap button + button {
  margin-left: 8px;
}
.service .form__input input[type="text"].input-error,
.service .form__input input[type="password"].input-error,
.service .form__input input[type="tel"].input-error,
.service .form__input input[type="file"].input-error,
.service .form__input textarea.input-error {
  background: none;
}
.service .service-info {
  margin-top: 96px;
}
.service .service-info .banner-box {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 22px 15px 19px 30px;
  height: 55px;
  width: calc(100% - 45px);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_149___}) no-repeat 0 0;
  background-size: cover;
}
.service .service-info .banner-box::after {
  content: "";
  position: absolute;
  top: 12px;
  right: 12px;
  width: 40px;
  height: 19.2px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_150___}) no-repeat center center;
  background-size: 100%;
  opacity: 0.6;
}
.service .service-info .banner-box .left p {
  color: #fff;
  font-weight: 600;
}
.service .service-info .banner-box .right {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.service .service-info .banner-box .right .btn-txt {
  gap: 0 !important;
}
.service .service-info .banner-box .right .btn-txt span {
  font-size: 14px;
  letter-spacing: -0.07em;
  color: #fff !important;
}
.service .service-info .banner-box button::after {
  content: "";
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_151___}) no-repeat center center;
  background-size: 100%;
  transform: scaleX(-1);
}

@media screen and (max-width: 1124px) {
  .service .box__body {
    padding: 40px 24px 64px;
    max-width: 720px;
  }
  .service .box__header {
    padding: 32px 24px 32px;
    max-width: 720px;
  }
  .service .box__header h2 {
    font-size: 20px;
    line-height: 1;
    margin-bottom: 38px;
  }
  .service .box__header .box__title {
    margin-bottom: 34px;
  }
  .service .box__info {
    padding-left: 144px;
    background-size: auto 72px;
  }
  .service .box__info li {
    font-size: 12px;
    line-height: 18px;
  }
  .service .box__body .page-top {
    margin-bottom: 32px;
  }
  .service .box__body .page-top h3 {
    font-size: 15px;
  }
  .service .box__body .info__input {
    width: 100%;
  }
  .service .box__body .info__input .content__info {
    margin-left: 132px;
  }
  .service .box__body .content__info ul.form__input li p.tit {
    width: 228px;
    font-size: 14px;
  }
  .service .box__body .content__info ul.form__input .input__area {
    width: calc(100% - 228px);
    max-width: calc(100% - 228px);
  }
  .service .box__body .terms li:last-child {
    margin-top: 16px !important;
  }
}
@media screen and (max-width: 940px) {
  .service .service-info .m-block {
    display: none !important;
  }
  .service .service-info .m-none {
    display: block !important;
  }
  #wrap:not(.no-responsive, .float-page) .container.service {
    margin: 3.625rem 0.5rem 0.5rem 0.5rem;
  }
  #wrap:not(.no-responsive, .float-page) .container.service .content {
    margin-top: 0;
  }
  .container.service .form__input {
    display: block;
  }
  .container.service .form__input li {
    flex-direction: row;
  }
  .container.service .form__input li .tit {
    margin-top: 7px !important;
  }
  .service .box__body .content__info ul.form__input li.flex-column p.tit {
    margin-top: 0 !important;
  }
  .service .box__body .info__input li .flex-column .tit {
    margin-bottom: 16px !important;
  }
  #wrap:not(.no-responsive) .service .tbl-list table th {
    font-size: 14px;
  }
  #wrap:not(.no-responsive) .service .tbl-list:not(.row) table td {
    height: 40px;
    font-size: 14px;
  }
}
@media screen and (max-width: 699px) {
  .service .service-info .m-block {
    display: block !important;
  }
  .service .service-info .m-none {
    display: none !important;
  }
  .service .box__header {
    padding: 24px 20px 0;
  }
  .service .box__header h2 {
    margin-bottom: 16px;
  }
  .service hr {
    display: none;
  }
  .service .box__body {
    padding: 58px 20px 64px;
  }
  .service .box__body .page-top {
    margin-bottom: 24px;
  }
  .service .box__body .page-top h3 {
    font-size: 20px;
  }
  .service .box__body .page-top h3 .txt-info {
    font-size: 12px;
  }
  .container.service .form__input {
    display: flex;
    flex-direction: column;
    gap: 17px;
  }
  .container.service .form__input li {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin: 0;
    gap: 10px;
  }
  .service .box__body .content__info ul.form__input li p.tit {
    font-size: 15px;
    width: 100%;
    margin-top: 0 !important;
    margin-bottom: 8px;
  }
  .service .box__body .info__input li .flex-column .tit {
    margin-bottom: 10px !important;
  }
  .service .box__header .box__title {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 0;
  }
  .service .box__header .box__info {
    display: none;
  }
  .service .box__body .info__input .content__info {
    margin-left: 4px;
  }
  .service .box__body .input__area .txt-info {
    font-size: 14px;
    line-height: 21px;
    color: #909fb7;
  }
  .service .box__body .content__info ul.form__input .input__area {
    width: 100%;
    max-width: 100%;
    min-width: 100%;
  }
  .service .box__body .content__info ul.form__input .input__area .checkBox {
    margin-bottom: 8px;
  }
  .service .box__body .content__info ul.form__input .input__area p.txtnum {
    top: -22px;
  }
  .service .box__body .terms li {
    margin-top: 16px;
  }
  .service .box__body .content__info ul.form__input li.flex-column .terms li:last-child .input__area {
    margin-top: 0;
  }
  .service .box__body .content__info ul.form__input li.flex-column p.tit {
    margin-bottom: 0;
    font-size: 16px;
    line-height: 20px;
  }
  .service .box__body .content__info ul.form__input li.flex-column .input__area {
    margin-top: 14px;
  }
  .service .box__body .content__info ul.form__input li.flex-column .input__area.mt-8 {
    margin-top: 0 !important;
  }
  .service .box__body .select {
    height: 40px;
  }
  .service .box__body .form__input input[type="text"],
  .service .box__body .form__input input[type="password"],
  .service .box__body .form__input input[type="tel"],
  .service .box__body .form__input input[type="file"] {
    height: 40px;
  }
  .service .box__body .filebox .upload-name {
    height: 40px;
    padding: 0 0.75rem 0 3.2rem;
  }
  .service .box__body .filebox label {
    width: 40px;
  }
  .service .box__body .form__input li .btn__wrap {
    max-width: 100%;
    margin-left: 0;
    justify-content: center;
  }
  .service .box__body .info__input li.mt-80 {
    margin-top: 72px !important;
  }
  .container.service .box__body .form__input li.mt-70 {
    margin-top: 35px !important;
  }
  #wrap:not(.no-responsive) .service .tbl-list table th {
    font-size: 16px;
  }
  #wrap:not(.no-responsive) .service .tbl-list:not(.row) table td {
    font-size: 16px;
    height: 52px;
  }
  .service .content__info ul.form__input li textarea {
    height: 234px !important;
  }
  .service .box__body .input__area .txt-info {
    margin-bottom: 4px;
  }
  .service .box__body .info__input + .info__input {
    margin-bottom: 30px;
  }
  .service .box__body .terms p {
    font-size: 14px;
    line-height: 19px;
  }
  .service .box__body .service-info {
    margin-top: 80px;
  }
  .service .service-info .banner-box {
    margin-bottom: 16px;
    padding: 16px 12px 16px 24px;
    width: calc(100% - 36px);
    height: 104px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_152___}) no-repeat 0 0;
    background-size: cover;
  }
  .service .service-info .banner-box .left p {
    line-height: 20px;
    width: 295px;
  }
  .service .service-info .banner-box button::after {
    width: 16px;
    height: 16px;
  }
  .service .service-info .banner-box .right .btn-txt span {
    font-size: 12px;
    letter-spacing: -0.04em;
  }
  .service .service-info ul {
    padding: 10px 8px 8px 16px;
    background: #e9edef;
  }
  .service .service-info ul li {
    display: flex;
    gap: 8px;
  }
  .service .service-info ul li p {
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: #2a2c2f;
    width: calc(100% - 8px);
  }
  .service .service-info ul li::before {
    content: "";
    width: 3px;
    height: 3px;
    background: #2a2c2f;
    margin-top: 9px;
    border-radius: 50%;
  }
}
@media screen and (max-width: 499px) {
  #wrap:not(.no-responsive, .float-page) .container.service {
    margin: 90px 0 0;
  }
  .service .service-info .banner-box .left p {
    line-height: 20px;
    width: 224px;
    letter-spacing: 0;
  }
}

/* management - 요청 관리 - 고객 문의 */
.btn-add-file,
.tbl-list table td button.btn.btn-add-file {
  padding-left: 24px;
  margin: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_126___}) no-repeat 0 center;
  background-size: 20px;
  width: auto;
  height: 20px;
  filter: none;
}
.tbl-list table td button.btn.btn-add-file span {
  font-weight: 400;
}
.btn-add-file:active {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_127___}) no-repeat 0 center !important;
  background-size: 20px !important;
}
.btn-add-file:hover {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_128___}) no-repeat 0 center !important;
  background-size: 20px !important;
}
.btn-add-file:disabled {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_153___}) no-repeat 0 center !important;
  background-size: 20px !important;
  border-color: transparent !important;
  background-color: transparent !important;
  opacity: 1 !important;
}
.btn-add-file:disabled span {
  color: #2a2c2f !important;
}
.btn-add-file:disabled:active {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_153___}) no-repeat 0 center !important;
  background-size: 20px !important;
}
.sub-input .filelist li span {
  padding-left: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_126___}) no-repeat 0 center;
  background-size: 20px;
}
.sub-input .filelist li:active span {
  padding-left: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_127___}) no-repeat 0 center;
  background-size: 20px;
}
.sub-input .filelist li:hover span {
  padding-left: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_128___}) no-repeat 0 center;
  background-size: 20px;
}
.sub-input .filelist li:not(:first-child) span {
  background: none !important;
}
.popup-type2 .popup__body .form__input .sub-input {
  margin-top: 16px;
}
.popup-type2 .popup__body .form__input .sub-input + .sub-input {
  margin-top: 8px;
}
.popup-type2 .popup__body .form__input .sub-input .tit {
  font-weight: 500;
  font-size: 14px;
  color: #2a2c2f;
  line-height: 20px;
  min-width: 72px;
  margin-right: 16px;
  margin-top: 0;
}
.btn-basic.dis-click {
  background: #f0f2f4;
  border-color: #f0f2f4;
}
.popup-layer.h90vh {
  height: auto !important;
}
.popup-layer.popup-type2.h90vh .popup__body {
  max-height: calc(90vh - 6.5rem) !important;
}
.popup-layer.h90vh .popup__body {
  max-height: calc(90vh - 7.5rem) !important;
}

.popup-type2.h674 .popup__body .flex-row .pop-right {
  height: calc(75vh - 73px);
}

/* management - 에너지솔루션 관리 */
.content-wrap > .l-divide:has(.flex-7, .flex-3) .box__body h3 {
  font-weight: 700;
  font-size: 15px;
  line-height: 1;
  color: #2a2c2f;
}
.content-wrap > .l-divide:has(.flex-7, .flex-3) .box__body .form__input .tit {
  font-weight: 700;
  font-size: 14px;
  line-height: 1.3;
  color: #2a2c2f;
  letter-spacing: -0.06em;
  min-width: 108px;
  max-width: 108px;
  word-break: keep-all;
}
.content-wrap > .l-divide:has(.flex-7, .flex-3) ul > li:has(+ h3) {
  border-bottom: 1px solid #dde2e9;
  padding-bottom: 40px;
  margin-bottom: 40px;
}
*/

/* sei - 마켓플레이스 */
#wrap.page-market > header {
  background-color: #fff;
  height: 62px;
  border-bottom: 1px solid #dde2e9;
}
#wrap.page-market > header .header__left {
  flex: 2;
  justify-content: space-between;
}
#wrap.page-market > header h1 {
  width: 216px;
  height: 20px;
  padding-left: 32px;
}
#wrap.page-market > header h1 img {
  /* width: 216px; */
  width: auto;
  height: 20px;
  object-fit: contain;
}
#wrap.page-market > header h1:has(img.h26) {
  width: 193px;
  height: 26px;
}
#wrap.page-market .header__menu {
  margin: 0 !important;
  flex: none;
  gap: 8px;
}
#wrap.page-market .header__menu li a {
  font-size: 14px;
  font-weight: 400;
  color: #2c364e;
  line-height: 1.5;
  padding: 0 20px;
  width: auto;
  min-width: auto;
}
#wrap.page-market .header__menu li.active a {
  color: #0a78ff;
  font-weight: 500;
}
#wrap.page-market .header__menu li.disabled {
  background: none;
  border: none;
}
#wrap.page-market .header__menu li.disabled a {
  color: #dde2e9;
}
#wrap.page-market > header .navbar__toggleBtn {
  display: none;
}
#wrap.page-market > header .header__right {
  margin-right: 1rem;
  justify-content: flex-end;
  flex: 1;
}
#wrap.page-market > header .header__etc {
  margin: 0;
  gap: 16px;
  flex: none;
}
#wrap.page-market .header__etc li {
  width: auto !important;
}
#wrap.page-market .header__etc li a {
  color: #2a2c2f;
  font-weight: 400;
}
#wrap.page-market .header__etc li a.btn-admin {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_154___}) no-repeat 0 center;
  background-size: 40px 40px;
}
#wrap.page-market .header__etc li a.btn-admin span {
  font-size: 14px;
  font-weight: 400;
  margin-left: 40px;
}
#wrap.page-market .header__etc li .btn-basic span {
  font-weight: 400;
}
#wrap.page-market .header__etc li span.icon-go:after,
.header__etc li span.icon-go:after {
  content: "";
  width: 24px;
  height: 24px;
  margin-left: 8px;
  margin-right: -8px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_139___}) no-repeat center center;
  background-size: 100%;
}
#wrap.page-market > header .header__userinfo {
  top: 62px;
  border-radius: 0 0 4px 4px;
  right: 85px;
}
#wrap.page-market > .container {
  margin: 62px 0 0 0;
  width: 100%;
  min-height: calc(100vh - 62px);
}
#wrap.page-market > .container .content {
  flex-direction: column;
  align-items: center;
  gap: 0;
  width: 100%;
  padding: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_155___}) no-repeat 0 0;
  background-size: 100% 528px;
}
#wrap.page-market > .container .content .area-search {
  margin-top: 120px;
  margin-bottom: 46px;
}
#wrap.page-market > .container .content .area-search .name {
  display: none;
}
#wrap.page-market > .container .content .area-search h2 {
  font-size: 40px;
  font-weight: 500;
  line-height: 1.25;
  color: #fff;
  text-align: center;
}
#wrap.page-market > .container .content .area-search .searcharea {
  margin-top: 30px;
  height: 60px;
  width: 744px;
  padding: 0 24px 0 32px;
  justify-content: space-between;
  background: #fff;
  border-radius: 45px;
}
#wrap.page-market > .container .content .area-search .searcharea .searchinput {
  height: 100%;
  width: calc(100% - 80px);
  gap: 32px;
}
#wrap.page-market > .container .content .area-search .searcharea .input__direct {
  margin: 0 !important;
  height: 100%;
  width: calc(100% - 100px);
}
#wrap.page-market > .container .content .area-search .searcharea .input__direct input[type="text"] {
  height: 100%;
  border: 0;
  font-size: 16px;
  padding: 0;
}
#wrap.page-market > .container .content .area-search .searcharea .input__direct input[type="text"]::placeholder {
  font-size: 16px !important;
}
#wrap.page-market > .container .content .area-search .searcharea .select {
  height: 100%;
  width: 117px;
  border: 0;
  font-size: 16px;
  letter-spacing: -0.4px;
  font-weight: 500;
}
/* #wrap.page-market > .container .content .area-search .searcharea .select.active ul {
  margin: 4px 0 0 -32px;
  width: calc(100% + 32px) !important;
  padding: 8px 0;
  border-radius: 4px;
  border: 0;
  box-shadow: 0px 8px 20px 0px rgba(122, 133, 150, 0.5);
} */
#wrap.page-market > .container .content .area-search .searcharea .select.active ul {
  margin: 0;
  padding: 2px 0;
  position: absolute;
  top: 64px;
  left: -32px;
  width: max-content !important;
  border-radius: 4px;
  border: 0;
  box-shadow: 0px 8px 20px 0px rgba(122, 133, 150, 0.5);
}
#wrap.page-market > .container .content .area-search .searcharea .select ul li {
  font-size: 15px;
  line-height: 21px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  font-weight: 350;
  padding: 7px 24px 8px;
  width: calc(100% - 48px) !important;
  min-width: 140px;
}
#wrap.page-market > .container .content .area-search .searcharea .select .selected {
  padding: 0;
}
#wrap.page-market > .container .content .area-search .searcharea .select .selected .arrow {
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_156___}) no-repeat center center;
  background-size: 100%;
}
#wrap.page-market > .container .content .area-search .searcharea .select ul li {
  font-size: 15px;
  line-height: 16px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  font-weight: 350;
  padding: 10px 24px;
  width: calc(100% - 48px) !important;
}
#wrap.page-market > .container .content .area-search .searcharea button.btn-search {
  height: 100%;
  width: 40px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_157___}) no-repeat center center;
  background-size: 40px;
  border: 0;
}
.area-select {
  margin: 0 auto;
  width: 1230px;
  background: #fff;
  box-shadow: 0px 2px 10px 0px rgba(67, 85, 131, 0.25);
  border-radius: 8px;
}
.area-select .select-cont {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 40px 40px 24px;
  min-height: 98px;
}
.area-select .select-cont > li {
  display: flex;
  justify-content: space-between;
}
.area-select .select-cont > li:first-child .right {
  height: auto;
  max-height: 66px;
  overflow-y: auto;
}
.area-select.open .select-cont > li:first-child .right {
  max-height: 242px;
  overflow-y: auto;
}
.area-select .select-cont .left {
  width: 120px;
}
.area-select .select-cont .right {
  flex: 1;
  max-width: 1030px;
}
.area-select .select-cont .tit {
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  color: #2a2c2f;
  letter-spacing: -0.4px;
}
.labellist li.on {
  background: #0a78ff;
  color: #fff;
}
.area-select .select-cont .labellist {
  gap: 10px;
}
.area-select .select-cont .labellist li {
  height: auto;
  padding: 0;
}
.labellist li > a {
  display: flex;
  align-items: center;
  height: 28px;
  padding: 0 12px;
}
.filterlist {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.filterlist li {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 24px;
  margin: 0;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  background: #fff;
  border: 1px solid #dde2e9;
  border-radius: 45px;
}
.filterlist li.on {
  border: 1.5px solid #0a78ff;
  color: #2a2c2f;
  font-weight: 500;
}
.area-select .select-cont .filterlist li {
  height: auto;
  padding: 0;
}
.filterlist li > a {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 16px;
}
.filterlist li img {
  width: 24px;
  height: 24px;
  object-fit: cover;
  margin-right: -4px;
}
.area-select .select-btn {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #dde2e9;
  padding: 12px 16px;
}
.area-select .select-btn button {
  height: 48px;
}
.area-select .select-btn button.btn-basic {
  background-color: #fff;
  border-color: #fff;
  gap: 8px;
}
.area-select .select-btn button.btn-basic span {
  font-size: 16px;
  font-weight: 400;
  color: #646c74;
  gap: 8px;
}
.area-select .select-btn button.btn-open-select span:after {
  content: "";
  width: 24px;
  height: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_158___}) no-repeat center center;
  background-size: 100%;
}
.area-select .select-btn button.btn-open-select.active span:after {
  transform: scaleY(-1);
}
.area-select .select-btn button.btn-basic.btn-renew span {
  color: #646c74;
}
.area-select .select-btn button.btn-renew span:before {
  content: "";
  width: 24px;
  height: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_159___}) no-repeat center center;
  background-size: 100%;
}
.area-result {
  max-width: 1230px;
  width: 100%;
}
.area-result .solution-area .top {
  margin-bottom: 16px;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  gap: 40px;
}
.area-result .solution-area .top .result-num {
  font-size: 22px;
  line-height: 1.8;
  letter-spacing: -1px;
  font-weight: 350;
  color: #2a2c2f;
}
.area-result .solution-area .top .result-num strong {
  font-weight: 500;
  color: #0a78ff;
}
.area-result .solution-area .tab__line {
  border-bottom: 1px solid #dde2e9;
  width: 100%;
  background: none;
  border-radius: 0;
  height: 64px;
}
.area-result .solution-area .tab__line li {
  padding: 0 !important;
}
.area-result .solution-area .tab__line li a {
  padding: 0 24px;
  color: #646c74 !important;
  font-size: 20px !important;
  letter-spacing: -0.4px;
}
.area-result .solution-area .tab__line li a span {
  margin-left: 25px;
  font-weight: 350;
  color: #909fb7 !important;
}
.area-result .solution-area .tab__line li.on a span,
.area-result .solution-area .tab__line li:hover a span {
  color: #0a78ff !important;
}
.area-result .solution-area .tab__line li.on,
.area-result .solution-area .tab__line li:hover {
  border-radius: 0;
  background: none;
  position: relative;
}
.area-result .solution-area .tab__line li.on:after,
.area-result .solution-area .tab__line li:hover:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 4px;
  background: #0978ff;
}
.area-result .solution-area .tab__line li.on a,
.area-result .solution-area .tab__line li:hover a {
  color: #2a2c2f !important;
}
.area-result .solution-area .top .select {
  height: auto;
  width: auto;
  border: 0;
  letter-spacing: -0.4px;
}
.area-result .solution-area .top .select .selected {
  padding: 0;
  gap: 10px;
}
.area-result .solution-area .top .select .selected .selected-value {
  width: auto;
}
.area-result .solution-area .top .select .selected .arrow {
  width: 16px;
  height: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_160___}) no-repeat center center;
  background-size: 100%;
}
.area-result .solution-area .top .select.active ul {
  margin-top: 4px;
  border-radius: 4px;
  width: 214px !important;
  max-height: 192px;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.2);
}
.area-result .solution-area .top .select ul li {
  padding: 16px 24px;
  width: calc(100% - 48px) !important;
  font-size: 15px;
  line-height: 16px;
  letter-spacing: -0.4px;
  font-weight: 400;
}
.area-result .solution-area .top .select ul li:active {
  font-weight: 700;
  color: #0a78ff;
}

.area-result .item-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(394px, auto));
  gap: 24px;
  height: auto;
  overflow: hidden;
}
.area-result .item-list > li {
  max-width: unset;
  border-radius: 8px;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
  height: 528px;
}
.area-result .item-info-top .tit {
  position: relative;
  padding-top: 3px;
}
.area-result .item-info-top .tit {
  font-size: 16px;
}
.area-result .item-info-top.best .tit:after {
  content: "";
  position: absolute;
  right: 0;
  top: -1px;
  width: 24px;
  height: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_161___}) no-repeat center 0;
  /* background: url('../img/icon_best.svg') no-repeat center 0; */
  background-size: 100%;
}
.area-result .item-info-top .keyword {
  width: calc(100% - 30px);
}
.area-result .item-info-top .btn-like {
  width: 24px;
  height: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_162___}) no-repeat center -2px;
  background-size: 100%;
}
.area-result .item-info-top .btn-like.on {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_163___}) no-repeat center -2px;
  background-size: 100%;
}
.area-result .solution-area .paging {
  margin: 40px 0 160px;
}
.area-result .item-info-btnarea {
  background: #f0f2f4;
}
.area-result .item-info-btnarea button span {
  color: #909fb7;
}
.area-result .item-info-btnarea button + button {
  border-color: #dde2e9;
}
.area-result .item-info-btnarea button span.icon-more {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_164___}) no-repeat center right;
  background-size: 24px;
}
.area-result .item-info-btnarea button span.icon-go {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_165___}) no-repeat center right;
  background-size: 24px;
}
.area-result .item-list > li:hover .item-info-btnarea {
  background: #41444a;
}
.area-result .item-list > li:hover .item-info-btnarea button span {
  color: #fff;
}
.area-result .item-list > li:hover .item-info-btnarea button + button {
  border-color: #26282e;
}
.area-result .item-list > li:hover .item-info-btnarea button span.icon-more {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_140___}) no-repeat center right;
  background-size: 24px;
}
.area-result .item-list > li:hover .item-info-btnarea button span.icon-go {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_139___}) no-repeat center right;
  background-size: 24px;
}
.area-result .nodata .nodata__txt {
  margin: 0 auto 10%;
  height: 40vh;
}
#wrap.page-market .navbar {
  display: none;
}
.area-select .select-top button.btn-basic:disabled {
  background: none !important;
  border: none !important;
}
.area-select .select-top button.btn-basic:disabled span {
  color: #f0f2f4 !important;
}
.area-select .s0elect-top button.btn-open-select:disabled span:after {
  opacity: 0.1;
}
/* 241125 추가 */
@media screen and (max-width: 1480px) {
  #wrap.page-market > header .header__right {
    flex: unset;
  }
}
@media screen and (max-width: 1300px) {
  #wrap.page-market > .container .content {
    width: calc(100% - 60px);
    padding: 0 30px;
  }
  #wrap.page-market > .container .content .area-search {
    width: 100%;
  }
  #wrap.page-market > .container .content .area-search .searcharea {
    width: 70%;
    margin: 30px auto;
  }
  #wrap.page-market > .container .content .area-search .searcharea .searchinput {
    width: calc(100% - 50px);
  }
  .area-select {
    max-width: 1230px;
    width: 100%;
  }
}
@media screen and (max-width: 1299px) {
  .area-result .item-list {
    grid-template-columns: repeat(auto-fill, minmax(48%, auto));
  }
}
@media screen and (max-width: 1278px) {
  #wrap:not(.no-responsive).page-market .header__etc li a.btn-admin span {
    display: none;
  }
  #wrap.page-market > header {
    height: 90px;
    padding-bottom: 10px;
    align-items: flex-end;
    justify-content: space-between;
    z-index: 19;
  }
  #wrap.page-market > header h1 {
    padding-left: 0;
  }
  #wrap.page-market > header .header__menu,
  #wrap.page-market .header__etc li > .bi-beyoundx {
    /* 241125 선택자 추가 */
    display: none;
  }
  .header-etc-pop,
  #wrap.page-market > header .header-etc-pop {
    left: 0; /* 241126 추가 */
  }
  #wrap.page-market > header .header__userinfo {
    top: 100px;
  }
  #wrap.page-market .header__etc > li:last-child {
    display: none;
  }
  #wrap.page-market .header__etc li a.btn-admin {
    width: 36px;
    height: 36px;
    background-position: center center;
  }
  #wrap.page-market > header .navbar__toggleBtn {
    display: block;
    margin-left: 12px;
    width: 36px;
    height: 36px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_166___}) no-repeat center center;
    background-size: 100%;
    cursor: pointer;
  }
  #wrap.page-market > header .navbar__toggleBtn.active {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_167___}) no-repeat center center;
    background-size: 100%;
  }
  #wrap.page-market > header .header__left {
    flex: 1;
    justify-content: center;
    height: 36px;
  }
  #wrap.page-market > header .header__right {
    flex: none;
    margin-right: 0;
    height: 36px;
  }
  #wrap.page-market .header-etc-pop.header__userinfo {
    left: auto !important;
    right: 0;
  }
  #wrap.page-market .navbar {
    display: block;
  }
  #wrap.page-market .navbar .navbar__menu {
    top: 100px;
    width: 100%;
    height: calc(100% - 100px);
    box-shadow: unset;
  }
  #wrap.page-market .navbar__menu li {
    padding: 0 21px;
  }
  #wrap.page-market .navbar__menu li > a {
    padding: 22px 0;
    color: #2a2c2f;
    background: none;
    border-bottom: 1px solid #dde2e9;
    border-top: 0;
  }
  #wrap.page-market .navbar__menu li.disabled {
    background: unset;
    border-color: unset;
  }
  #wrap.page-market .navbar__menu li.disabled > a {
    color: #dde2e9;
  }
  #wrap.page-market .navbar__menu li:first-child > a {
    border-top: 1px solid #dde2e9;
  }
  #wrap.page-market .navbar__menu li button.btn-basic {
    margin-top: 60px;
    width: 100%;
    height: 48px !important;
  }
  #wrap.page-market .navbar__menu li button.btn-basic span {
    font-size: 14px !important;
    letter-spacing: -0.4px;
  }
  #wrap.page-market .navbar__menu li button.btn-basic span.icon-go:after {
    content: "";
    width: 24px;
    height: 24px;
    margin-left: 15px;
    margin-right: -8px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_139___}) no-repeat center center;
    background-size: 100%;
  }
  #wrap.page-market > .container {
    margin: 101px 0 0 0;
  }
}
@media screen and (max-width: 1130px) {
  #wrap.page-market .header__etc li a.btn-admin {
    width: 40px;
    height: 40px;
  }
  #wrap.page-market > header .header__userinfo {
    right: 5px;
  }
  #wrap.page-market .header__etc li .btn-basic {
    padding: 0 12px;
  }
  #wrap.page-market > header .header__etc {
    gap: 10px;
  }
  #wrap.page-market > header .header__menu {
    gap: 0;
  }
}
@media screen and (max-width: 940px) {
  .area-select.m-block {
    display: none !important;
  }
  .area-select.m-none {
    display: block !important;
  }
  #wrap.page-market > .container {
    margin: 100px 0 0 0 !important;
    min-height: calc(100vh - 100px);
  }
  #wrap.page-market > .container .content {
    margin-top: 0;
  }
  /* #wrap.page-market .navbar {
    display: block;
  } */
}
@media screen and (max-width: 733px) {
  #wrap.page-market > .container .content {
    padding: 0 20px;
    margin: 0;
    width: calc(100% - 40px);
    background-size: 100% 244px;
  }
  #wrap.page-market > .container .content .area-search {
    width: 100%;
    margin-top: 20px;
    margin-bottom: 0;
  }
  #wrap.page-market > .container .content .area-search .name {
    display: block;
    font-size: 14px;
    color: #909fb7;
    line-height: 20px;
    letter-spacing: -0.4px;
    text-align: right;
    margin-bottom: 40px;
  }
  #wrap.page-market > .container .content .area-search h2 {
    text-align: left;
    width: 220px;
    font-size: 32px;
  }
  #wrap.page-market > .container .content .area-search .searcharea {
    margin-top: 46px;
    margin-bottom: 10px;
    width: calc(100% - 56px);
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
  }
  #wrap.page-market > .container .content .area-search .searcharea .select {
    display: none;
  }
  #wrap.page-market > .container .content .area-search .searcharea .searchinput {
    width: calc(100% - 40px);
  }
  #wrap.page-market > .container .content .area-search .searcharea .input__direct {
    width: 100%;
  }
  .area-result .solution-area {
    margin-top: 56px;
  }
  .area-result .solution-area .tab__line {
    margin: 0 -20px;
    width: calc(100% + 40px);
  }
  .area-result .solution-area .tab__line li {
    flex: 1 !important;
  }
  .area-result .solution-area .top .result-num {
    font-size: 16px;
    line-height: 24px;
  }
  .area-result .item-list {
    gap: 20px;
    grid-template-columns: repeat(auto-fit, minmax(100%, auto));
  }
  .area-result .solution-area .paging {
    margin: 20px 0 64px;
  }
  .area-select {
    box-shadow: unset;
    width: 100%;
    border-bottom: 1px solid #dde2e9;
    margin: 0;
    padding: 0 20px 0 20px;
    border-radius: 0;
  }
  .area-select.m-block {
    display: block !important;
  }
  .area-select.m-none {
    display: none !important;
  }
  .area-select .select-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(100% + 20px);
    margin-right: -20px;
  }
  .area-select .select-top .left {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .area-select .select-top .tit {
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
    color: #2a2c2f;
    letter-spacing: -0.4px;
  }
  .area-select .select-top button {
    height: 48px !important;
  }
  .area-select .select-top button.btn-basic {
    background-color: #fff;
    border-color: #fff;
    gap: 8px;
  }
  .area-select .select-top button.btn-basic span {
    font-size: 14px !important;
    font-weight: 400;
    color: #646c74;
    gap: 8px;
  }
  .area-select .select-top button.btn-open-select span:after {
    content: "";
    width: 24px;
    height: 24px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_158___}) no-repeat center center;
    background-size: 100%;
  }
  .area-select .select-top button.btn-open-select.active span:after {
    transform: scaleY(-1);
  }
  .area-select .select-bottom {
    display: none;
  }
  .area-select.open .select-bottom {
    display: block;
  }
  .area-select .select-cont {
    padding: 0;
    min-height: unset;
    gap: 20px;
  }
  .area-select .select-btn {
    justify-content: flex-end;
    padding: 0;
    margin: 20px 0 10px;
    border-top: 0;
  }
  .area-select .select-btn button {
    height: 48px !important;
  }
  .area-select .select-btn button.btn-basic span {
    font-size: 14px !important;
  }
  .area-select .select-btn button.btn-basic.btn-renew {
    margin-right: -20px;
  }
}
@media screen and (max-width: 499px) {
  #wrap.page-market > header {
    padding-top: 0;
  }
  .area-result .item-list {
    grid-template-columns: repeat(auto-fit, minmax(300px, auto));
  }
  .area-result .solution-area .tab__line li a {
    padding: 0;
  }
  .header__etc .btn-lang {
    display: none;
  }
  #wrap.page-market > header .header__etc {
    margin-right: 9px;
  }
  #wrap.page-market .header__etc li a.btn-admin {
    width: 36px;
    height: 36px;
  }
  .header-etc-pop,
  #wrap.page-market > header .header-etc-pop {
    top: 49px !important;
  }
  #wrap.page-market .header__etc li .header__userinfo li {
    padding: 0;
  }
}

/* sei - 마켓플레이스 - 상세페이지 */
#wrap.page-market.detail header .btn-prev {
  display: none;
}
#wrap.page-market.detail > .container .content {
  border-top: 1px solid #dde2e9;
  padding-top: 120px;
  background: none;
}
#wrap.page-market.detail > .container .content > div:not(.cont-imgslide) {
  max-width: 1230px;
  width: 100%;
}
#wrap.page-market.detail > .container .content .cont-top {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 30px;
}
#wrap.page-market.detail > .container .content .cont-top .left {
  display: flex;
  align-items: flex-end;
  flex: 1;
}
#wrap.page-market.detail > .container .content .cont-top .left .left-txt {
  display: flex;
  gap: 4px;
}
#wrap.page-market.detail > .container .content .cont-top .left h1 {
  font-size: 40px;
  line-height: 56px;
  letter-spacing: -1px;
  font-weight: 500;
  color: #2a2c2f;
}
#wrap.page-market.detail > .container .content .cont-top .left h2 {
  display: flex;
  align-items: flex-end;
  color: #2a2c2f;
  font-size: 24px;
  line-height: 40px;
  letter-spacing: -0.4px;
  font-weight: 350;
}
#wrap.page-market.detail > .container .content .cont-top .left img {
  width: 44px;
  height: 44px;
  margin-bottom: 5px;
  margin-left: 6px;
}
#wrap.page-market.detail > .container .content .cont-top .right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
}
#wrap.page-market.detail > .container .content .cont-top .btn-like {
  height: 46px;
  padding: 0 18px 0 29px;
  border-radius: 25px;
  border: 1px solid #dde2e9;
}
#wrap.page-market.detail > .container .content .cont-top button.btn-like span {
  font-weight: 400;
  font-size: 15px;
  letter-spacing: -0.4px;
  color: #646c74;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
#wrap.page-market.detail > .container .content .cont-top .btn-like span:after {
  content: "";
  width: 24px;
  height: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_162___}) no-repeat center center;
  background-size: 100%;
}
#wrap.page-market.detail > .container .content .cont-top .btn-like.on span:after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_163___}) no-repeat center center;
  background-size: 100%;
}
#wrap.page-market.detail > .container .content .cont-imgslide .img-wrap {
  height: 400px;
  min-height: unset;
  overflow: hidden;
}
#wrap.page-market.detail > .container .content .cont-bottom {
  margin-top: 50px;
}
#wrap.page-market.detail > .container .content .cont-bottom .top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid #dde2e9;
  margin-bottom: 24px;
}
#wrap.page-market.detail > .container .content .cont-bottom .top p {
  font-size: 15px;
  line-height: 24px;
  letter-spacing: -0.4px;
  color: #646c74;
  font-weight: 400;
}
#wrap.page-market.detail > .container .content .cont-bottom .top p span {
  margin-left: 8px;
}
#wrap.page-market.detail > .container .content .cont-bottom .top p.tit {
  color: #7783a1;
  font-weight: 500;
}
#wrap.page-market.detail > .container .content .cont-bottom .key-area .tit {
  display: inline;
  margin-right: 15px;
  padding: 6px 24px 7px 25px;
  font-size: 14px;
  letter-spacing: -0.4px;
  color: #fff;
  font-weight: 400;
  border-radius: 25px;
  background: #003875;
  vertical-align: initial;
}
#wrap.page-market.detail > .container .content .cont-bottom .key-area .keyword {
  display: inline;
}
#wrap.page-market.detail > .container .content .cont-bottom .key-area .keyword span {
  font-size: 16px;
  line-height: 32px;
  font-weight: 500;
  color: #003875;
}
#wrap.page-market.detail > .container .content .cont-bottom .cont-text {
  margin: 80px 0 160px;
  display: flex;
  flex-direction: column;
}
#wrap.page-market.detail > .container .content .cont-bottom .cont-text article + article {
  margin-top: 80px;
}
#wrap.page-market.detail > .container .content .cont-bottom .cont-text article .tit {
  font-size: 26px;
  line-height: 40px;
  font-weight: 700;
  letter-spacing: -1px;
}
#wrap.page-market.detail > .container .content .cont-bottom .cont-text article .tit-sub {
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
}
#wrap.page-market.detail > .container .content .cont-bottom .cont-text article p {
  font-size: 14px;
  line-height: 24px;
  color: #2a2c2f;
  font-weight: 400;
  margin-bottom: 16px;
}
#wrap.page-market.detail > .container .content .cont-bottom .cont-text article p:last-child {
  margin-bottom: 0;
}
#wrap.page-market.detail > .container .content .cont-bottom .btn-area {
  display: flex;
  align-items: center;
  justify-content: center;
}
#wrap.page-market.detail > .container .content .cont-bottom .btn-area .btn-basic {
  height: 48px;
  min-width: 350px;
}
#wrap.page-market.detail > .container .content .cont-bottom .btn-area .btn-basic span {
  font-size: 20px;
  letter-spacing: -0.4px;
}
#wrap.page-market.detail > .container .content .cont-bottom .select-cont {
  margin-top: 160px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
#wrap.page-market.detail > .container .content .cont-bottom .select-cont .tit {
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.4px;
  font-weight: 500;
  color: #2a2c2f;
}
#wrap.page-market.detail > .container .content .cont-bottom .select-cont .labellist li {
  height: auto;
  padding: 0;
}
#wrap.page-market.detail > .container .content .cont-bottom .page-bottom {
  margin-top: 40px;
  margin-bottom: 160px;
  padding-top: 40px;
  border-top: 1px solid #dde2e9;
}
#wrap.page-market.detail > .container .content .cont-bottom .page-bottom .btn-basic {
  height: 48px;
  background: #2c364e;
  border-color: #2c364e;
}
#wrap.page-market.detail > .container .content .cont-bottom .page-bottom .btn-basic span {
  font-size: 16px;
  letter-spacing: -0.4px;
  font-weight: 400;
}
@media screen and (max-width: 940px) {
  #wrap.page-market.detail > header .navbar__toggleBtn {
    display: none !important;
  }
  #wrap.page-market.detail > header .header__left {
    display: none !important;
  }
  #wrap.page-market.detail header .btn-prev {
    display: flex;
    align-items: center;
    gap: 2px;
    margin-left: 12px;
  }
  #wrap.page-market.detail header .btn-prev:before {
    content: "";
    width: 36px;
    height: 36px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_167___}) no-repeat 0 center;
    background-size: 100%;
  }
  #wrap.page-market.detail header .btn-prev span {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: #2c364e;
  }
  #wrap.page-market.detail > .container .content {
    border: 0;
    padding: 20px 0 0;
    width: 100%;
  }
  #wrap.page-market.detail > .container .content > div:not(.cont-imgslide) {
    padding: 0 20px;
    width: calc(100% - 40px);
  }
  #wrap.page-market.detail > .container .content .cont-top {
    flex-direction: column;
    align-items: unset;
    gap: 10px;
    margin-bottom: 20px;
  }
  #wrap.page-market.detail > .container .content .cont-top .left {
    gap: 0;
    align-items: flex-start;
  }
  #wrap.page-market.detail > .container .content .cont-top .left .left-txt {
    flex-direction: column;
    gap: 0;
  }
  #wrap.page-market.detail > .container .content .cont-top .left h1 {
    font-size: 32px;
    line-height: 40px;
  }
  #wrap.page-market.detail > .container .content .cont-top .left h2 {
    font-size: 20px;
    line-height: 40px;
  }
  #wrap.page-market.detail > .container .content .cont-top .left img {
    width: 31px;
    height: 31px;
    margin-bottom: 0;
    margin-top: 3px;
    margin-left: 4px;
  }
  #wrap.page-market.detail > .container .content .cont-imgslide .img-wrap {
    height: 200px;
  }
  #wrap.page-market.detail > .container .content .cont-bottom {
    margin-top: 39px;
  }
  #wrap.page-market.detail > .container .content .cont-bottom .key-area .tit {
    display: inline-block;
    margin-bottom: 10px;
    padding: 9px 24px 9px 25px;
  }
  #wrap.page-market.detail > .container .content .cont-bottom .key-area .keyword {
    display: block;
  }
  #wrap.page-market.detail > .container .content .cont-bottom .cont-text {
    margin: 40px 0 80px;
  }
  #wrap.page-market.detail > .container .content .cont-bottom .cont-text article + article {
    margin-top: 40px;
  }
  #wrap.page-market.detail > .container .content .cont-bottom .select-cont {
    margin-top: 80px;
  }
  #wrap.page-market.detail > .container .content .cont-bottom .page-bottom {
    margin-bottom: 74px;
  }
  #wrap.page-market.detail > .container .content .cont-bottom .btn-area .btn-basic {
    height: 46px;
    min-width: unset;
    flex: 1;
    border-radius: 25px;
  }
  #wrap.page-market.detail > .container .content .cont-bottom .btn-area .btn-basic span {
    font-size: 16px;
  }
  #wrap.page-market.detail > .container .content .cont-bottom .page-bottom .btn-basic {
    height: 32px;
  }
  #wrap.page-market.detail > .container .content .cont-bottom .page-bottom .btn-basic span {
    font-size: 14px;
  }
}

/* sei - 마켓플레이스 - 상담신청 */
#wrap.page-market.consulting > .container .content {
  padding: 120px 0 160px;
  background: linear-gradient(180deg, #f7f8fa 0%, rgba(247, 248, 250, 0) 100%);
}
#wrap.page-market.consulting .service h1 {
  font-size: 40px;
  font-weight: 500;
  line-height: 40px;
  letter-spacing: -1px;
  color: #2a2c2f;
  margin-bottom: 32px;
}
#wrap.page-market.consulting .service .box {
  border-radius: 8px;
  box-shadow: 0px 2px 10px 0px rgba(67, 85, 131, 0.25);
}
#wrap.page-market.consulting .service .box__header {
  padding: 64px 72px 30px;
}
#wrap.page-market.consulting .service .box__body {
  padding: 40px 72px 72px;
}
#wrap.page-market.consulting .service .box__body .page-top h3 {
  border-bottom: 1px solid #dde2e9;
}
#wrap.page-market.consulting .service .box__body .input__area .txt-info {
  width: 100%;
}

@media screen and (max-width: 1300px) {
  #wrap.page-market.consulting > .container .content {
    width: 100%;
  }
}
@media screen and (max-width: 940px) {
  #wrap.page-market.consulting > .container .content {
    padding: 112px 0;
  }
  #wrap.page-market.consulting .service .box {
    width: 98%;
  }
  #wrap.page-market.consulting .service .box__header {
    max-width: calc(100% - 48px);
    padding: 32px 24px;
  }
  #wrap.page-market.consulting .service .box__body {
    max-width: calc(100% - 48px);
    padding: 40px 24px 64px;
  }
  #wrap.page-market.consulting .service .box__body .page-top h3 .txt-info {
    font-size: 13px;
  }
  #wrap.page-market.consulting .terms .box-scroll {
    height: 140px;
    line-height: 16px;
    padding: 9px;
  }
}
@media screen and (max-width: 699px) {
  #wrap.page-market.consulting .service .box {
    box-shadow: none;
    width: 100%;
  }
  #wrap.page-market.consulting > .container .content {
    padding: 0 0 64px;
    background: #fff;
  }
  #wrap.page-market.consulting > .container .content .cont-top {
    padding: 80px 20px 40px;
    width: calc(100% - 40px);
    background: linear-gradient(180deg, #f7f8fa 0%, rgba(247, 248, 250, 0) 100%);
  }
  #wrap.page-market.consulting .service h1 {
    margin-bottom: 0;
    font-size: 32px;
  }
  #wrap.page-market.consulting .service .box__header {
    max-width: calc(100% - 40px);
    padding: 0 20px;
  }
  #wrap.page-market.consulting .service .box__header .box__title {
    margin-bottom: 0;
    font-weight: 400;
    font-size: 16px;
  }
  #wrap.page-market.consulting .service .box__info {
    display: none;
  }
  #wrap.page-market.consulting .service hr {
    display: none;
  }
  #wrap.page-market.consulting .service .box__body {
    max-width: calc(100% - 40px);
    padding: 64px 20px 0;
  }
  #wrap.page-market.consulting .service .box__body .page-top h3 {
    border-color: #a4b0c4;
    font-size: 20px;
  }
  #wrap.page-market.consulting .service .box__body .page-top h3 .txt-info {
    font-size: 12px;
  }
  #wrap.page-market.consulting .service .box__body .info__input + .info__input {
    margin-top: 40px;
  }
  #wrap.page-market.consulting .terms .box-scroll {
    height: 164px;
    line-height: 19px;
    padding: 12px 12px 4px 12px;
    font-size: 14px;
  }
  #wrap.page-market.consulting .service .box__body .form__input li .btn__wrap button {
    height: 46px;
    flex: 1;
  }
  #wrap.page-market.consulting .service .box__body .service-info {
    margin-top: 76px;
  }
}

/* sei - 마켓플레이스 - what we do */
#wrap.page-market.whatwedo > .container .content {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_168___}) no-repeat 0 0;
  background-size: 100% 528px;
}
#wrap.page-market.whatwedo > .container .content .cont-top {
  margin-top: 120px;
  margin-bottom: 46px;
  width: 100%;
  max-width: 1230px;
}
#wrap.page-market.whatwedo > .container .content .cont-top h1 {
  font-size: 40px;
  font-weight: 500;
  line-height: 1.25;
  color: #2a2c2f;
  text-align: center;
}
#wrap.page-market.whatwedo > .container .content .cont-top .txt {
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  color: #2a2c2f;
  text-align: center;
  margin-top: 30px;
}
#wrap.page-market.whatwedo > .container .content .cont-bottom {
  max-width: 1230px;
  width: 100%;
}
#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(49%, auto));
  gap: 18px;
  height: 640px;
  overflow: hidden;
  padding-bottom: 162px;
}
#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list > li {
  width: 100%;
  max-width: 100%;
  height: 100%;
  border-radius: 8px;
  box-shadow: 0px 2px 10px 0px rgba(67, 85, 131, 0.25);
  border: 0;
}
#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list > li > a {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  border-radius: 8px;
}
#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .img-wrap {
  width: 100%;
  height: 374px;
  border-radius: 0 0 8px 8px;
  overflow: hidden;
}
#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .img-wrap img {
  object-fit: cover;
  border-radius: 0 0 8px 8px;
  transition-duration: 0.3s;
}
#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .item-info {
  height: calc(100% - 450px);
  padding: 40px 36px 36px 40px;
  justify-content: flex-start;
  position: relative;
}
#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .item-info:after {
  content: "";
  position: absolute;
  right: 36px;
  bottom: 36px;
  width: 32px;
  height: 32px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_169___}) no-repeat center center;
  background-size: 100%;
}
#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .item-info .tit {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 82%;
}
#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .item-info .tit strong {
  font-size: 26px;
  line-height: 40px;
  font-weight: 500;
  color: #2a2c2f;
  letter-spacing: -1px;
}
#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .item-info .tit span {
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  color: #2a2c2f;
}
#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list > li:hover .item-info:after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_170___}) no-repeat center center;
  background-size: 100%;
}
#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li:hover .item-info .tit strong {
  color: #0a78ff;
  font-weight: 700;
}
#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li:hover .img-wrap img {
  transform: scale(1.2, 1.2);
  transition-duration: 0.6s;
}
#wrap.page-market.whatwedo .m-block {
  display: none !important;
}
@media screen and (max-width: 1299px) {
  #wrap.page-market.whatwedo > .container .content .cont-bottom .item-list {
    grid-template-columns: repeat(auto-fill, minmax(48%, auto));
  }
}
@media screen and (max-width: 940px) {
  #wrap.page-market.whatwedo > .container .content {
    background-size: 100% 400px;
  }
  #wrap.page-market.whatwedo > .container .content .cont-top {
    margin-bottom: 62px;
  }
  #wrap.page-market.whatwedo > .container .content .cont-bottom .item-list {
    height: 458px;
    padding-bottom: 230px;
  }
  #wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .img-wrap {
    height: 244px;
  }
  #wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .item-info {
    height: calc(100% - 312px);
    padding: 40px 28px 28px 40px;
  }
  #wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .item-info:after {
    right: 28px;
    bottom: 28px;
  }
  #wrap.page-market.whatwedo .m-block {
    display: none !important;
  }
  #wrap.page-market.whatwedo .m-none {
    display: block !important;
  }
}
@media screen and (max-width: 733px) {
  #wrap.page-market.whatwedo > .container .content {
    background-size: 100% 244px;
  }
  #wrap.page-market.whatwedo > .container .content .cont-top {
    margin-bottom: 20px;
    margin-top: 80px;
  }
  #wrap.page-market.whatwedo > .container .content .cont-top h1 {
    font-size: 32px;
    text-align: left;
  }
  #wrap.page-market.whatwedo > .container .content .cont-top .txt {
    margin-top: 20px;
    text-align: left;
  }
  #wrap.page-market.whatwedo > .container .content .cont-bottom .item-list {
    grid-template-columns: repeat(auto-fit, minmax(100%, auto));
    height: auto;
    gap: 20px;
  }
  #wrap.page-market.whatwedo > .container .content .cont-bottom .item-list > li {
    width: 98%;
    max-width: 98%;
    height: 412px;
    margin: 0 auto;
  }
  #wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .item-info {
    height: calc(100% - 264px);
    padding: 20px 28px 28px 16px;
  }
  #wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .img-wrap {
    height: 216px;
  }
  #wrap.page-market.whatwedo .m-block {
    display: block !important;
  }
  #wrap.page-market.whatwedo .m-none {
    display: none !important;
  }
}

/* sei - 마켓플레이스 - what we do - 상세 */
#wrap.page-market.whatwedo > .container .content.detail {
  background-size: 100% 360px;
}
#wrap.page-market.whatwedo > .container .content.detail .cont-top {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 30px;
}
#wrap.page-market.whatwedo > .container .content.detail .cont-top h1 {
  line-height: 1;
  letter-spacing: -1px;
}
#wrap.page-market.whatwedo > .container .content.detail .cont-top .btn-prev {
  width: 56px;
  height: 56px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_171___}) no-repeat center center;
  background-size: 100%;
}
#wrap.page-market.whatwedo > .container .content.detail .cont-bottom .item-list {
  grid-template-columns: repeat(auto-fill, minmax(394px, auto));
  gap: 12px;
  height: auto;
  padding-bottom: 74px;
}
#wrap.page-market.whatwedo > .container .content.detail .cont-bottom .item-list > li {
  height: 184px;
}
#wrap.page-market.whatwedo > .container .content.detail .cont-bottom .item-list li .item-info {
  height: calc(100% - 44px);
  padding: 16px 28px 28px 32px;
}
#wrap.page-market.whatwedo > .container .content.detail .cont-bottom .item-list li .item-info .tit {
  height: 70%;
  justify-content: center;
}
#wrap.page-market.whatwedo > .container .content.detail .cont-bottom .item-list li .item-info .tit strong {
  font-size: 20px;
  line-height: 28px;
}
#wrap.page-market.whatwedo > .container .content.detail .cont-bottom .item-list li:hover {
  border: 1px solid #2a2c2f;
  background: #2c364e;
  background: radial-gradient(#2c364e, #2a2c2f);
  box-shadow: 0px 8px 10px 0px rgba(67, 85, 131, 0.5);
}
#wrap.page-market.whatwedo > .container .content.detail .cont-bottom .item-list li:hover .item-info .tit strong {
  color: #fff;
}

@media screen and (max-width: 1299px) {
  #wrap.page-market.whatwedo > .container .content.detail .cont-bottom .item-list {
    grid-template-columns: repeat(auto-fill, minmax(32%, auto));
  }
}
@media screen and (max-width: 940px) {
}
@media screen and (max-width: 733px) {
  #wrap.page-market.whatwedo > .container .content.detail .cont-top {
    margin-bottom: 20px;
  }
  #wrap.page-market.whatwedo > .container .content.detail .cont-bottom .item-list {
    grid-template-columns: repeat(auto-fit, minmax(100%, auto));
    gap: 20px;
    padding-bottom: 64px;
  }
  #wrap.page-market.whatwedo > .container .content.detail .cont-bottom .item-list > li {
    height: 176px;
  }
  #wrap.page-market.whatwedo > .container .content.detail .cont-bottom .item-list li .item-info {
    padding: 16px 28px 28px 24px;
  }
}

/* sei - 마켓플레이스 - what we do - 팝업 */
.popup-type1 .popup__body.scroll-no {
  max-height: calc(85vh - 6.5rem);
}
.popup__body .product {
  margin-top: 0;
  margin-bottom: 0;
}
.popup__body .product .tab__line {
  margin-bottom: 30px;
  margin-top: -12px;
}
.popup__body .product .tab__line li.on {
  font-weight: 700;
}
.popup__body .product .tab-content {
  height: 466px;
  overflow-y: hidden;
}
.popup__body .product .tab-content.itmelist {
  height: 546px;
}
.popup__body .product .tab-content p {
  font-size: 15px;
  line-height: 32px;
}
.popup__body .product .tab-content p.tit {
  font-size: 20px;
  font-weight: 700;
  line-height: 36px;
  text-align: left;
  letter-spacing: -0.4px;
  color: #051c3f;
  margin-bottom: 20px;
}
.popup__body .product .tab-content .item-info-top .tit {
  position: relative;
  padding-top: 3px;
  font-size: 16px;
  line-height: 28px;
  color: #2a2c2f;
  margin: 0;
}
.popup__body .product .tab-content .item-info-top.best .tit:after {
  content: "";
  position: absolute;
  right: 0;
  top: -1px;
  width: 24px;
  height: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_161___}) no-repeat center 0;
  /* background: url('../img/icon_best.svg') no-repeat center 0; */
  background-size: 100%;
}
.popup__body .product .tab-content .item-info-top .keyword {
  width: calc(100% - 30px);
}
.popup__body .product .tab-content .item-info-top .btn-like {
  width: 24px;
  height: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_162___}) no-repeat center -2px;
  background-size: 100%;
}
.popup__body .product .tab-content .item-info-top .btn-like.on {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_163___}) no-repeat center -2px;
  background-size: 100%;
}
.popup__body .product .tab-content .item-info-top .company {
  color: #7783a1;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.3;
  margin-top: -4px;
}
.popup__body .product .tab-content .item-info-top .cont {
  color: #2a2c2f;
  font-size: 13px;
  line-height: 1.5;
}
.popup__body .product .tab-content .item-info-top .etc {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.popup__body .product .tab-content.itmelist {
  padding: 0;
  overflow-y: hidden;
  overflow-x: auto;
  box-shadow: none;
}
.popup__body .product .tab-content.itmelist::-webkit-scrollbar-thumb,
.popup__body .product .tab-content .scrollH::-webkit-scrollbar-thumb {
  border: 1px solid transparent;
}
.popup__body .product .tab-content.itmelist .item-list {
  display: inline-flex;
  gap: 12px;
}
.popup__body .product .tab-content.itmelist .item-list > li {
  flex: none;
  width: 392px;
  max-width: 392px;
  height: calc(100% - 2px);
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
}
.popup__body .product .tab-content.itmelist .item-info-btnarea {
  background: #f0f2f4;
}
.popup__body .product .tab-content.itmelist .item-info-btnarea button span {
  color: #909fb7;
}
.popup__body .product .tab-content.itmelist .item-info-btnarea button + button {
  border-color: #dde2e9;
}
.popup__body .product .tab-content.itmelist .item-info-btnarea button span.icon-more {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_164___}) no-repeat center right;
  background-size: 24px;
}
.popup__body .product .tab-content.itmelist .item-info-btnarea button span.icon-go {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_165___}) no-repeat center right;
  background-size: 24px;
}
.popup__body .product .tab-content.itmelist .item-list > li:hover .item-info-btnarea {
  background: #41444a;
}
.popup__body .product .tab-content.itmelist .item-list > li:hover .item-info-btnarea button span {
  color: #fff;
}
.popup__body .product .tab-content.itmelist .item-list > li:hover .item-info-btnarea button + button {
  border-color: #26282e;
}
.popup__body .product .tab-content.itmelist .item-list > li:hover .item-info-btnarea button span.icon-more {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_140___}) no-repeat center right;
  background-size: 24px;
}
.popup__body .product .tab-content.itmelist .item-list > li:hover .item-info-btnarea button span.icon-go {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_139___}) no-repeat center right;
  background-size: 24px;
}
@media screen and (max-width: 1180px) {
  .popup-layer.w1130 {
    width: calc(100% - 40px) !important;
  }
}
@media screen and (max-width: 779px) {
  .popup-type1 .popup__head h1.ellipsis {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: normal;
  }
  .popup-type1 .popup__body.scroll-no {
    overflow-y: hidden;
  }
  .popup__body .product .tab-content {
    padding-bottom: 0;
    height: 546px;
  }
  .popup__body .product .tab-content .scrollH {
    height: calc(85vh - 160px);
    padding-right: 15px;
  }
  .popup__body .product .tab__line {
    margin: -4px -20px 0;
    width: calc(100% + 40px);
  }
  #wrap:not(.no-responsive) .popup__body .product > .tab__line li {
    flex: 1;
  }
  .popup__body .product .tab-content p.tit {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 24px;
  }
  .popup__body .product .tab-content.itmelist {
    padding-top: 20px;
    padding-bottom: 10px;
    height: calc(85vh - 160px);
    overflow-y: auto;
  }
  .popup__body .product .tab-content.itmelist .item-list {
    overflow: unset;
    width: auto;
  }
  .popup__body .product .tab-content.itmelist .item-list > li {
    width: 348px;
    max-width: 348px;
  }
  .popup__body .product .tab-content.itmelist::-webkit-scrollbar-thumb,
  .popup__body .product .tab-content .scrollH::-webkit-scrollbar-thumb {
    border: 2px solid transparent;
  }
}

/* sei - 마켓플레이스 - 서비스소개 */
#wrap.page-market.serviceintro {
  overflow-x: unset;
}
#wrap.page-market.serviceintro > .container .content {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_172___}) no-repeat 0 0;
  background-size: 100% 1018px;
}
#wrap.page-market.serviceintro > .container .content .cont-top {
  width: 100%;
  max-width: 1230px;
  height: 1018px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}
#wrap.page-market.serviceintro > .container .content .cont-top .subtit {
  margin-top: -24px;
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 30px;
  color: #fff;
  opacity: 0.8;
}
#wrap.page-market.serviceintro > .container .content .cont-top .tit {
  font-size: 56px;
  font-weight: 500;
  line-height: 70px;
  letter-spacing: -0.04em;
  color: #fff;
}
#wrap.page-market.serviceintro > .container .content .cont-top .txt {
  margin-top: 180px;
  font-size: 24px;
  font-weight: 350;
  line-height: 40px;
  letter-spacing: -0.01em;
  color: #fff;
}
#wrap.page-market.serviceintro > .container .content .btn-scroll {
  position: absolute;
  bottom: 80px;
  left: 50%;
  transform: translate(-50%, 0%);
  width: 160px;
  height: 80px;
  border: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_173___}) no-repeat center center;
  background-size: 100%;
  z-index: 2;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom {
  width: 100%;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom .btn-scroll {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_174___}) no-repeat center center;
  background-size: 100%;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article {
  position: relative;
  min-height: 1080px;
  width: 100%;
  height: 1080px;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article:last-child {
  height: auto;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 1230px;
  margin: 0 auto;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article:first-child > section {
  padding-top: 120px;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article:nth-child(2) > section {
  padding-top: 200px;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section > p {
  text-align: center;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section > p.cate {
  font-size: 20px;
  font-weight: 500;
  line-height: 40px;
  letter-spacing: -0.4px;
  color: #909fb7;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section > p.tit {
  font-size: 40px;
  font-weight: 350;
  line-height: 56px;
  letter-spacing: -1px;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section > p.txt {
  font-size: 20px;
  font-weight: 350;
  line-height: 40px;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section > p strong {
  font-weight: 700;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section > .img-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  padding: 40px 84px 40px 106px;
  width: calc(100% - 190px);
  box-shadow: 0px 2px 10px 0px rgba(67, 85, 131, 0.25);
  background: #fff;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  margin-top: 80px;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li {
  flex: 1;
  min-width: calc(48% - 80px);
  height: 256px;
  padding: 40px;
  background: #fff;
  box-shadow: 0px 2px 10px 0px rgba(67, 85, 131, 0.25);
  border-radius: 8px;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li > .tit {
  font-size: 26px;
  font-weight: 700;
  line-height: 40px;
  color: #002f68;
  position: relative;
  display: inline-block;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li > .tit span {
  font-size: 26px;
  font-weight: 700;
  line-height: 40px;
  color: #002f68;
  position: relative;
  z-index: 1;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li > .tit:after {
  content: "";
  position: absolute;
  bottom: 2px;
  left: 0;
  width: 100%;
  height: 12px;
  background: #8bc3ff;
  opacity: 0.4;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li > .txt {
  margin-top: 40px;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li > .txt span {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  font-size: 20px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.01em;
  color: #2a2c2f;
}
#wrap.page-market.serviceintro
  > .container
  .content
  .cont-bottom
  > article
  > section
  .txt-box
  > li
  > .txt
  span:last-child {
  margin-bottom: 0;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li > .txt span:before {
  content: "";
  width: 24px;
  height: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_175___}) no-repeat center center;
  background-size: 100%;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel {
  position: unset;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel > section {
  max-width: unset;
  position: relative;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel > section > .top {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 232px;
  width: 100%;
  background-size: cover !important;
  background-position: center center !important;
  backrground-repeat: no-repeat !important;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel > section > .top p {
  font-size: 20px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: -0.4px;
  text-align: center;
  color: #fff;
  opacity: 0.8;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel > section > .bottom {
  max-width: 1230px;
  width: 100%;
  margin: 80px auto 112px;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel > section > .bottom .cate {
  font-size: 16px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: -1px;
  color: #7783a1;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel > section > .bottom > .tit {
  font-size: 40px;
  font-weight: 500;
  line-height: 56px;
  letter-spacing: -0.02em;
  color: #2a2c2f;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel > section > .bottom .detail {
  margin-top: 40px;
}
#wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel > section > .bottom .detail > li {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  padding: 20px 0;
  border-top: 1px solid #dde2e9;
}
#wrap.page-market.serviceintro
  > .container
  .content
  .cont-bottom
  > article.intro-sel
  > section
  > .bottom
  .detail
  > li
  .img-wrap {
  width: 349px;
  height: 234px;
  min-height: auto;
}
#wrap.page-market.serviceintro
  > .container
  .content
  .cont-bottom
  > article.intro-sel
  > section
  > .bottom
  .detail
  > li
  .txt-wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
#wrap.page-market.serviceintro
  > .container
  .content
  .cont-bottom
  > article.intro-sel
  > section
  > .bottom
  .detail
  > li
  .txt-wrap
  button {
  margin-bottom: 20px;
  width: 132px;
  height: 46px;
  background: #fff;
  border-radius: 45px;
  border: 1px solid #dde2e9;
}
#wrap.page-market.serviceintro
  > .container
  .content
  .cont-bottom
  > article.intro-sel
  > section
  > .bottom
  .detail
  > li
  .txt-wrap
  button
  span {
  color: #646c74;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: -0.4px;
}
#wrap.page-market.serviceintro
  > .container
  .content
  .cont-bottom
  > article.intro-sel
  > section
  > .bottom
  .detail
  > li
  .txt-wrap
  button:hover {
  border: 2px solid #0a78ff;
}
#wrap.page-market.serviceintro
  > .container
  .content
  .cont-bottom
  > article.intro-sel
  > section
  > .bottom
  .detail
  > li
  .txt-wrap
  button:hover
  span {
  font-weight: 500;
  color: #2a2c2f;
}
#wrap.page-market.serviceintro
  > .container
  .content
  .cont-bottom
  > article.intro-sel
  > section
  > .bottom
  .detail
  > li
  .txt-wrap
  button.not-ex:hover {
  background: #f0f2f4;
  width: 222px;
  border: 0;
}
#wrap.page-market.serviceintro
  > .container
  .content
  .cont-bottom
  > article.intro-sel
  > section
  > .bottom
  .detail
  > li
  .txt-wrap
  button.not-ex:hover
  span {
  font-size: 0;
}
#wrap.page-market.serviceintro
  > .container
  .content
  .cont-bottom
  > article.intro-sel
  > section
  > .bottom
  .detail
  > li
  .txt-wrap
  button.not-ex:hover
  span:before {
  content: "DEMO가 현재 준비중입니다.";
  font-size: 15px;
  font-weight: 400;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
#wrap.page-market.serviceintro
  > .container
  .content
  .cont-bottom
  > article.intro-sel
  > section
  > .bottom
  .detail
  > li
  .txt-wrap
  .tit {
  font-size: 26px;
  font-weight: 500;
  line-height: 40px;
  letter-spacing: -0.01em;
}
#wrap.page-market.serviceintro
  > .container
  .content
  .cont-bottom
  > article.intro-sel
  > section
  > .bottom
  .detail
  > li
  .txt-wrap
  .txt {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}
#wrap.page-market.serviceintro
  > .container
  .content
  .cont-bottom
  > article.intro-sel
  > section
  > .bottom
  .detail
  > li
  .txt-wrap
  .txt
  span {
  font-size: 16px;
  font-weight: 350;
  line-height: 28px;
  letter-spacing: -0.01em;
}

@media screen and (max-width: 940px) {
  #wrap.page-market.serviceintro > .container .content {
    background-size: 100% 528px;
    padding: 0;
    width: 100%;
  }
  #wrap.page-market.serviceintro > .container .content .cont-top {
    height: 528px;
    padding: 0 20px;
    width: calc(100% - 40px);
  }
  #wrap.page-market.serviceintro > .container .content .cont-top .subtit {
    margin-bottom: 8px;
  }
  #wrap.page-market.serviceintro > .container .content .cont-top .tit {
    font-size: 32px;
    font-weight: 500;
    line-height: 40px;
    letter-spacing: -0.8px;
  }
  #wrap.page-market.serviceintro > .container .content .cont-top .txt {
    margin-top: 90px;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.4px;
  }
  #wrap.page-market.serviceintro > .container .content .cont-bottom > article {
    height: auto;
    min-height: auto;
    padding: 80px 20px 60px;
    width: calc(100% - 40px);
  }
  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section {
    padding-top: 0 !important;
  }
  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section > p.cate {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 20px;
  }
  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section > p.tit {
    font-size: 32px;
    font-weight: 500;
    line-height: 40px;
    letter-spacing: -2.6px;
  }
  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section > p.txt {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -1px;
  }
  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section > .img-wrap {
    margin-top: 60px;
    padding: 0;
    width: 100%;
    box-shadow: none;
  }
  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box {
    gap: 20px;
    margin-top: 60px;
  }
  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li {
    width: calc(100% - 40px);
    min-height: 184px;
    height: auto;
    padding: 20px;
    flex: none;
  }
  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li > .tit,
  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li > .tit span {
    font-size: 20px;
  }
  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li > .tit:after {
    height: 10px;
    bottom: 6px;
  }
  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li > .txt {
    margin-top: 20px;
  }
  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li > .txt span {
    margin-bottom: 16px;
    font-size: 16px;
    line-height: 20px;
  }
  #wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel {
    padding: 0;
    width: 100%;
  }
  #wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel > section > .top {
    height: 200px;
  }
  #wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel > section > .bottom {
    margin: 48px auto 140px;
    padding: 0 20px;
    width: calc(100% - 40px);
  }
  #wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel > section > .bottom > .tit {
    font-size: 32px;
    line-height: 40px;
    letter-spacing: -1.4px;
  }
  #wrap.page-market.serviceintro
    > .container
    .content
    .cont-bottom
    > article.intro-sel
    > section
    > .bottom
    .detail
    > li {
    flex-direction: column;
  }
  #wrap.page-market.serviceintro
    > .container
    .content
    .cont-bottom
    > article.intro-sel
    > section
    > .bottom
    .detail
    > li
    .txt-wrap
    .tit {
    font-size: 24px;
    line-height: 32px;
  }
  #wrap.page-market.serviceintro
    > .container
    .content
    .cont-bottom
    > article.intro-sel
    > section
    > .bottom
    .detail
    > li
    .txt-wrap
    button {
    display: none;
  }
  #wrap.page-market.serviceintro
    > .container
    .content
    .cont-bottom
    > article.intro-sel
    > section
    > .bottom
    .detail
    > li
    .img-wrap {
    width: 100%;
  }
  #wrap.page-market.serviceintro
    > .container
    .content
    .cont-bottom
    > article.intro-sel
    > section
    > .bottom
    .detail
    > li
    .img-wrap
    img {
    object-fit: fill;
  }
  #wrap.page-market.serviceintro > .container .content .btn-scroll {
    display: none;
  }
}
/* sei - 마켓플레이스 - 로그인 */
#wrap.page-market .login-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100vh - 63px);
  border-top: 1px solid #dde2e9;
}
#wrap.page-market .login-wrap h2 p {
  font-size: 1.375rem;
  font-weight: 500;
  color: #2a2c2f;
}
#wrap.page-market .login-wrap h2 p:first-child {
  display: none;
}
#wrap.page-market .login__form .form__input {
  margin: 2.25rem 0 1.938rem;
}
#wrap.page-market .login__form .form__input li {
  margin-top: 1rem;
}
#wrap.page-market .login__form .form__input li:first-child {
  margin-top: 0 !important;
}
#wrap.page-market .login__form .form__input .input__area {
  margin-left: 0;
}
#wrap.page-market .login__form .form__input input[type="text"],
#wrap.page-market .login__form .form__input input[type="password"] {
  width: 19.125rem;
  height: 2.75rem;
  padding: 0 1rem;
}
#wrap.page-market .login__form .input-errortxt {
  top: 3rem;
  font-size: 0.875rem;
  line-height: 1;
}
#wrap.page-market .login__form .form__etc {
  display: flex;
  align-items: center;
  justify-content: center;
}
#wrap.page-market .login__form .form__etc li:last-child {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
#wrap.page-market .login__form .form__etc button:first-child:before {
  content: none;
}
#wrap.page-market .login__form .form__etc button::before {
  content: "";
  width: 1px;
  height: 0.658rem;
  margin-left: 0.499rem;
  padding-left: 0.499rem;
  border-left: 1px solid #909fb7;
}
#wrap.page-market .login__form .form__etc button span {
  font-size: 0.875rem;
}
#wrap.page-market .btn-login {
  margin: 1.813rem 0 1rem;
  background: #0a78ff;
  border: 0;
  width: 21.25rem;
  height: 2.875rem;
}
#wrap.page-market .btn-login:hover,
#wrap.page-market .btn-login:active {
  background: #0050b8;
}
#wrap.page-market .btn-login:disabled {
  background: #e9edef;
}
#wrap.page-market .btn-login span {
  color: #fff;
}
#wrap.page-market .join {
  display: flex;
  flex-direction: column;
  align-items: center;
}
#wrap.page-market .join li {
  display: flex;
  align-items: center;
  justify-content: center;
}
#wrap.page-market .join li p {
  color: #909fb7;
  margin-right: 0.5rem;
}
#wrap.page-market .terms {
  display: flex;
  flex-direction: column;
  height: auto;
  /* height: calc(75vh - 6.5rem); */
}
/* #wrap.page-market.login .terms {
  height: calc(75vh - 6.5rem);
} */
/* #wrap.page-market.community .terms {
  height: calc(68vh - 10.3rem);
} */
#wrap.page-market .terms li {
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  min-height: 30%;
  flex: 1;
}
#wrap.page-market .terms li:first-child {
  margin-top: 0;
}
#wrap.page-market .terms .terms__tit {
  font-size: 15px;
  font-weight: 700;
  color: #2a2c2f;
  margin-bottom: 12px;
}
#wrap.page-market .terms .box-scroll {
  border: 1px solid #909fb7;
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 13px;
  height: 100%;
  overflow-y: scroll;
  /* background: #fff; */
}
#wrap.page-market .terms p {
  font-size: 13px;
  line-height: 19.24px;
  word-wrap: break-word;
  word-break: break-all;
  margin-bottom: 1rem;
}
#wrap.page-market .terms p strong {
  font-weight: 700;
}
#wrap.page-market .terms p.tit {
  font-size: 14px;
  font-weight: 700;
  line-height: 20.72px;
}
#wrap.page-market .terms p.txt + p.tit {
  padding-top: 2.25rem;
}
#wrap.page-market .terms .tit-middle {
  font-weight: 700;
  padding-top: 1rem;
}
#wrap.page-market .terms p.tit + p.tit-small {
  padding-top: 0;
}
#wrap.page-market .terms p.tit-small {
  font-weight: 400;
  padding-top: 0.6rem;
  margin-bottom: 0;
}
#wrap.page-market .terms .btn-txt span {
  font-size: 14px;
}
#wrap.page-market .terms .renewday {
  color: #7783a1;
}
#wrap.page-market .terms .dot {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 0;
}
#wrap.page-market .terms .dot::before {
  content: "";
  width: 4px;
  height: 4px;
  background-color: #222;
  border-radius: 50%;
  margin: 8px 8px 0 5px;
}
#wrap.page-market .joinok:before {
  content: "";
  width: 200px;
  height: 108px;
  display: block;
  margin: 0 auto 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_176___}) no-repeat center center;
  /* background-size: 1.25rem; */
}
#wrap.page-market .popup__body.joinok-h {
  padding: 2rem 2.5rem 8.7rem;
}
#wrap.page-market .popup__body.joinok-h .complete-txt {
  height: calc(75vh - 8.9rem);
}
#wrap.page-market .popup__body.joinok-h .complete-txt button {
  margin-top: 33px;
  padding: 0 1.25rem;
  width: 8.75rem;
  height: 2.5rem;
  background-color: #0a78ff;
  border: 0;
}
#wrap.page-market .popup__body.joinok-h .complete-txt button span {
  color: #fff;
  font-weight: 700;
}
#wrap.page-market .popup__body.joinok-h .complete-txt button:hover {
  background-color: #0050b8;
}
#wrap.page-market .popup__body.joinok-h .complete-txt button:active {
  background-color: #003876;
}

@media screen and (max-width: 940px) {
  #wrap.page-market.login > header {
    display: none;
  }
  #wrap.page-market.login > .container {
    margin: 0 !important;
    min-height: 100vh;
  }
  #wrap.page-market:not(.community) .login-wrap {
    width: calc(100% - 40px);
    height: auto;
    min-height: calc(100vh - 40%);
    padding: 20% 20px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_177___}) no-repeat 20px 54px;
    background-size: 72px 34px;
  }
  #wrap.page-market .login-wrap h2 {
    width: 100%;
  }
  #wrap.page-market .login-wrap h2 p:first-child {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  #wrap.page-market .login-wrap h2 p:first-child span {
    font-size: 1.375rem;
    font-weight: 300;
    color: #2a2c2f;
  }
  #wrap.page-market .login-wrap h2 p:first-child span:last-child {
    font-size: 2.188rem;
    font-weight: 700;
    color: #003876;
    width: 100%;
    height: 30px;
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #wrap.page-market:not(.community) .login-wrap h2 p:first-child span:last-child img {
    height: 30px;
    width: 100%;
  }
  #wrap.page-market:not(.community) .login-wrap h2 p:last-child {
    display: none;
  }
  #wrap.page-market:not(.community) .login-wrap .join__sns button {
    margin-left: 1.5rem;
  }
  #wrap.page-market:not(.community) .login-wrap .btn-login {
    margin: 64px 0 20px;
    width: 100%;
  }
  #wrap.page-market:not(.community) .login-wrap .login__form .form__input {
    margin: 64px 0 24px;
    gap: 8px;
  }
  #wrap.page-market:not(.community) .login-wrap .form__input li {
    margin-top: 0;
  }
  #wrap.page-market:not(.community) .login__form {
    width: 100%;
  }
  #wrap.page-market:not(.community) .login__form .form__input input[type="text"],
  #wrap.page-market:not(.community) .login__form .form__input input[type="password"] {
    height: 38px;
    width: calc(100% - 24px);
    padding: 0 12px;
  }
  #wrap.page-market:not(.community) .login__form .input-errortxt {
    top: 2.7rem;
  }
  #wrap.page-market:not(.community) .popup-type1 .popup__body .form__input {
    gap: 16px;
  }
  #wrap.page-market:not(.community) .popup-layer .popup__body .form__input li {
    gap: 0;
  }
  #wrap.page-market:not(.community) .popup__body.joinok-h {
    padding: 0;
    width: 100%;
    min-height: 75vh;
  }
  #wrap.page-market .popup__body .form__input .checkBox.column label {
    width: auto !important;
  }
  #wrap.page-market .popup__body .form__input .checkBox.column li.ml-50 {
    margin-left: 20px !important;
    margin-top: 0;
  }
  #wrap.page-market .popup__body .form__input .checkBox.column li.ml-50 label {
    width: 100% !important;
  }
  #wrap.page-market:not(.community) .popup__body .input-errortxt {
    font-size: 13px;
    top: 44px;
  }
  #wrap.page-market:not(.community) .popup__body .form__input input[type="text"],
  #wrap.page-market:not(.community) .popup__body .form__input input[type="password"],
  #wrap.page-market:not(.community) .popup__body .form__input input[type="tel"],
  #wrap.page-market:not(.community) .popup__body .select {
    height: 40px;
    font-size: 1rem;
  }

  #wrap.page-market .popup__body .form__input input[type="text"].input-error,
  #wrap.page-market .popup__body .form__input input[type="password"].input-error,
  #wrap.page-market .popup__body .form__input input[type="tel"].input-error {
    background: none;
  }
  #wrap.page-market .joinok {
    margin: 0 !important;
  }
  #wrap.page-market .terms .terms__tit {
    font-size: 1rem;
  }
  .popup-layer.w570 {
    width: calc(100% - 40px) !important;
  }
}

/************************************************** 컨텐츠팝업 ****************************************************/
/* 컨텐츠팝업 - 팝업 height 고정일경우 : h값에 따라 popup__body 값이 정해짐 */
.popup-layer.h740 .popup__body {
  height: 602px;
  max-height: 100vh;
  min-height: 602px;
  /* min-height: 521px; */
}
.popup-layer.h740 .popup__body .flex-row {
  min-height: 585px;
  max-height: 100vh;
}
.popup-layer.scrollH-no .popup__body {
  overflow-y: hidden !important;
}

/* 컨텐츠팝업 - 기본형 - popup-type1 */
.popup-type1 .popup__body {
  position: relative;
  padding: 32px 40px;
  width: calc(100% - 80px);
  height: auto;
  max-height: calc(75vh - 6.5rem);
  overflow-y: auto;
}
.popup-type1 .popup__body h2 {
  font-weight: 700;
  font-size: 15px;
  line-height: 1;
  color: #2a2c2f;
}
.popup-type1 .popup__body .form__input {
  margin-top: 0;
}
.popup-type1 .popup__body .form__input .tit {
  font-weight: 700;
  font-size: 14px;
  line-height: 1.3;
  color: #2a2c2f;
  min-width: 120px;
  max-width: 150px;
}
.popup-type1 .popup__body h2 + .form__input {
  margin-top: 26px;
}
.popup-type1 .locate {
  margin: -32px -40px 0;
}
.popup__body p {
  font-size: 14px;
  color: #2a2c2f;
  line-height: 1.5;
}
.popup__body p.txt.word {
  word-break: break-word;
}
.popup__body p.txt-info {
  font-weight: 400;
  font-size: 14px;
  color: #7a8596;
  margin-left: 8px;
  letter-spacing: -0.7px;
}
.popup__body textarea {
  width: calc(100% - 20px);
  padding: 6px 10px;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.6px;
}
.popup-layer.h97vh .popup__body,
.popup-layer.h97vh.popup-type1 .popup__body,
.popup-layer.h97vh.popup-type2 .popup__body {
  max-height: calc(97vh - 6.5rem);
}
.popup-layer.h76vh .popup__body,
.popup-layer.h76vh.popup-type1 .popup__body {
  max-height: calc(76vh - 6.5rem);
}
.popup-layer.h82vh .popup__body,
.popup-layer.h82vh.popup-type1 .popup__body,
.popup-layer.h82vh.popup-type2 .popup__body {
  max-height: calc(82vh - 6.5rem);
}

/**/
.popup-layer.popup-type2.h674 .popup__body {
  max-height: calc(75vh - 1.6rem);
}
.popup-layer.popup-type2.h674 .popup__body .flex-row .pop-left,
.popup-layer.popup-type2.h674 .popup__body .flex-row .pop-right {
  height: 100%;
  min-height: 610px;
}
.popup-layer.popup-type2.h674 .popup__body .flex-row > div .form__input > li {
  margin-top: 16px;
}
.popup-layer.popup-type2.h674 .popup__body .input__area textarea {
  padding: 12px;
}
@media screen and (max-width: 940px) {
  .popup-layer.popup-type2.h674 .popup__body .flex-row .pop-right {
    min-height: 982px;
  }
}

@media screen and (max-width: 940px) {
  .popup-type1 .popup__body {
    padding: 20px;
    width: calc(100% - 40px);
  }
  .popup-type1 .popup__body .form__input {
    margin-top: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .popup-type1 .locate {
    margin: -20px -20px 0;
    width: calc(100% - 3px);
  }
  .popup-type1 .popup__footer button {
    width: 120px;
  }
  .popup-layer.w630 {
    width: calc(100% - 40px) !important;
  }
}
@media screen and (max-width: 1150px) {
  .popup-type2.popup-layer {
    width: calc(100% - 40px) !important;
  }
}
@media screen and (max-width: 1500px) {
  .popup-layer.w1496 {
    width: calc(100% - 40px) !important;
  }
}

/* 컨텐츠팝업 - 좌우형 - popup-type2 */
.popup-type2 .popup__body {
  position: relative;
  padding: 1rem 1rem 0;
  width: calc(100% - 2rem);
  height: auto;
  max-height: calc(75vh - 6.5rem);
  overflow-y: auto;
}
.popup-type2 .popup__body .flex-row {
  margin: 0 -16px;
}
.popup-type2 .popup__body .flex-row .pop-left {
  padding: 32px 40px;
  height: calc(75vh - 290px);
  /* height: calc(100vh - 186px); */
}
.popup-type2 .popup__body .flex-row .pop-right {
  border-left: 4px solid #e3e7ee;
  padding: 32px 40px;
  height: calc(75vh - 290px);
  /* height: calc(100vh - 186px); */
}
.popup-type2 .popup__body:has(.locate) .flex-row .pop-left,
.popup-type2 .popup__body:has(.locate) .flex-row .pop-right {
  height: calc(75vh - 160px);
}
.popup-type2 .popup__body h2 {
  font-weight: 700;
  font-size: 15px;
  line-height: 1;
  color: #2a2c2f;
}
.popup-type2 .popup__body .tbl-list table td {
  height: 34px;
}
.popup-type2 .popup__body .form__input {
  margin-top: 26px;
}
.popup-type2 .popup__body .form__input .tit {
  font-weight: 700;
  font-size: 14px;
  line-height: 1.3;
  color: #2a2c2f;
  letter-spacing: -0.06em;
  min-width: 120px;
  max-width: 150px;
}
.popup-type2 .popup__body .form__input .tit.w185 {
  max-width: 185px;
}
.popup-type2 .popup__body .form__input .tit.disabled {
  background: none;
  border: 0;
  color: #dde2e9;
}
.popup-type2 .popup__body .form__input .input__area {
  margin-left: 0;
}
.popup-type2 .popup__body .input__area textarea {
  height: 58px;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.4;
}
.popup-type2 .popup__body .form__input ul:not(.filelist, .labellist, .checkBox) li {
  margin-bottom: 24px;
}
.popup-type2 .popup__body .form__input li:last-child {
  margin-bottom: 0;
}
.popup-type2 .popup__body .form__input .radioBox {
  width: 100%;
  /* justify-content: space-between; */
  display: inline-flex;
  gap: 20px;
}
.popup-type2 .popup__body .form__input .radioBox label {
  width: auto !important;
  margin-left: 0;
  /* font-weight: 500; */
  color: #2a2c2f;
}
.popup-type2 .popup__body .form__input .radioBox.left {
  justify-content: flex-start;
  gap: 22px;
}
.popup-type2 .popup__body .tbl-list.scrollH {
  height: 410px;
}
.popup-type2 .popup__body .tbl-select tr.selected td {
  height: 30px;
}

@media screen and (max-width: 1150px) {
  .popup-type2.popup-layer {
    width: calc(100% - 40px) !important;
  }
}
@media screen and (max-width: 940px) {
  .popup-type2 .popup__body .tbl-list table td {
    height: 52px;
  }
  .popup-type2 .popup__body h2 {
    font-size: 1rem;
  }
  .popup-type2 .popup__body .flex-row .pop-left {
    padding: 32px 20px;
  }
  .popup-type2 .popup__body .flex-row .pop-right {
    padding: 32px 20px;
  }
}

/* 컨텐츠팝업 - 화면 오른쪽 노출 - popup-type3 */
.popup-type3 {
  width: 640px;
  right: 0;
  top: 0;
  left: auto !important;
  height: 100vh;
  margin: 0;
  border-radius: 0;
  box-shadow: 0px 10px 30px rgba(42, 44, 47, 0.5);
  transform: unset;
}
.popup-type3 .popup__head {
  width: calc(100% - 64px);
  padding: 30px 32px 16px;
  background: #2c364e;
  border-bottom: 2px solid #dde2e9;
  z-index: 1;
}
.popup-type3 .popup__head .btn-close {
  display: block;
  width: 32px;
  height: 32px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_80___}) no-repeat center center;
  background-size: 100%;
}
.popup-type3 .popup__head h1 {
  color: #fff;
  font-size: 20px;
}
.popup-type3 .popup__body {
  position: relative;
  padding: 30px 40px;
  width: calc(100% - 80px);
  height: calc(100vh - 254px);
  max-height: calc(100vh - 254px);
  overflow-y: auto;
  background: #f7f8fa;
}
.popup-type3 .popup__body h2 {
  font-weight: 700;
  font-size: 15px;
  line-height: 1;
  color: #2a2c2f;
}
.popup-type3 .popup__body .form__input {
  margin-top: 0;
}
.popup-type3 .popup__body .form__input .tit {
  font-weight: 700;
  font-size: 14px;
  line-height: 1.3;
  color: #2a2c2f;
  min-width: 120px;
  max-width: 150px;
}
.popup-type3 .popup__body h2 + .form__input {
  margin-top: 26px;
}
.popup-type3 .popup__footer {
  position: absolute;
  bottom: 0;
  height: 73px;
  width: calc(100% - 92px);
  padding: 16px 46px 24px;
}
.popup-type3 .popup__footer .flex-column {
  width: 100%;
  gap: 16px;
}
.popup-type3 .popup__footer button {
  margin: 0 auto;
  width: auto;
}
.popup-type3 .popup__footer .result__num {
  font-size: 16px;
}

@media screen and (max-width: 940px) {
  .popup-type3 {
    width: 100%;
    position: fixed !important;
    box-shadow: none;
  }
}
@media screen and (max-width: 499px) {
  .popup-type3 {
    width: 100% !important;
    top: 0 !important;
    position: fixed !important;
  }
  .popup-type3 .popup__body {
    padding: 30px 20px;
    width: calc(100% - 40px);
  }
}

/* 알럿 타입 팝업 - popup-basic */
.popup-basic .popup__head {
  border-bottom: 0;
}
.popup-basic .popup__body {
  padding-top: 6px;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.45;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  min-height: 38px;
}
.popup-basic .popup__footer {
  border-top: 0;
}

/* 컨텐츠팝업 - 기본형 - popup-type1 - 와이드형 -  wide */
.popup-type1.wide {
  height: 90vh;
}
.popup-type1.wide .popup__body {
  height: calc(90vh - 186px);
  max-height: calc(90vh - 186px);
}
/*와이드형-사진확대팝업*/
.popup-type1.wide .popup__body .img-area {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  text-align: center;
}
.popup-type1.wide .popup__body .img-area img {
  width: auto;
  height: 100%;
}

/* 컨텐츠팝업 - 사진파일업로드 */
.popup__body .form__input .input__area.add-file .txt-info {
  font-weight: 400;
  font-size: 14px;
  line-height: 15px;
  letter-spacing: -0.4px;
  color: #909fb7;
  margin-top: 5px;
  margin-left: 0;
}
.popup__body .form__input .input__area.add-file .filelist {
  display: inline-table;
}
.popup__body .form__input .input__area.add-file .filelist li {
  display: inline-flex;
  flex-direction: row !important;
  align-items: center !important;
  gap: 4px;
  margin-bottom: 4px;
}
.popup__body .form__input .input__area.add-file .filelist li span {
  font-size: 14px;
  line-height: 1.7;
}
.popup__body .form__input .input__area.add-file .filelist li:not(:first-child) span {
  background: none;
}
.popup__body .form__input .input__area.add-file .filelist li .btn-delete {
  margin-left: 0;
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_94___}) no-repeat center center;
  background-size: 100%;
}
.popup__body .form__input .input__area.add-file .btn-basic {
  width: 120px;
  height: 40px;
}
.popup__body .form__input .input__area.add-file .btn-basic span {
  font-size: 16px;
  font-weight: 700;
}
.popup__body .imglist {
  margin-top: 40px;
  padding-top: 24px;
  border-top: 1px solid #dde2e9;
}
.popup__body .imglist .tit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.3;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.popup__body .imglist .tit span:last-child {
  font-weight: 400;
}
.popup__body .imglist .imgbox-area .tit {
  margin-bottom: 8px;
}
.popup__body .imglist .imgbox-area .tit .btn-area {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  width: 75px !important;
}
.popup__body .imglist .imgbox-area .tit .btn-area button {
  width: 32px;
  height: 32px;
}
.popup__body .imglist .imgbox-area li + li {
  margin-top: 24px;
}

/* 지정 컬러 */
.set-color {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 32px;
}
.set-color > li {
  margin-top: 0;
  gap: 16px;
}
.set-color input[type="radio"] {
  width: 16px;
  height: 16px;
  margin-top: 8px;
}
.popup__body .form__input .set-color label {
  width: auto;
}
.set-color .sample {
  width: 78px;
  height: 78px;
  border: 1px solid #dde2e9;
  background: #fafbfc;
}
.set-color .sample .title {
  width: 100%;
  height: 24px;
  font-size: 12px;
  font-weight: 500;
  line-height: 2;
  color: #eff6ed;
  text-align: center;
  background: #909fb7;
  border: 1px solid #dde2e9;
  margin-left: -1px;
  margin-top: -1px;
}
.set-color .set-blue {
  background: #f2f5fb;
}
.set-color .set-yellow {
  background: #fffff7;
}
.set-color .set-teal {
  background: #ebf9f6;
}
.set-color .set-magenta {
  background: #fff6f7;
}
.set-color .set-navy {
  background: #f8f9fb;
}
.set-color .set-green {
  background: #f8fff6;
}
.set-color .set-blue .title {
  background: #577eff;
  border-color: #577eff;
}
.set-color .set-yellow .title {
  background: #d6a834;
  border-color: #d6a834;
}
.set-color .set-teal .title {
  background: #00a985;
  border-color: #00a985;
}
.set-color .set-magenta .title {
  background: #d00365;
  border-color: #d00365;
}
.set-color .set-navy .title {
  background: #2c364e;
  border-color: #2c364e;
}
.set-color .set-green .title {
  background: #005b09;
  border-color: #005b09;
}

/* 텍스트와 필드간격 16px 지정  */
.popup-type1 .popup__body .form__input.gap16 li {
  gap: 16px;
}
.popup-type1 .popup__body .form__input.gap16 .tit {
  min-width: 104px;
  max-width: 104px;
}

/********************************************** language - ENGLISH **********************************************/
#wrap.lang-eng > *,
#wrap.lang-eng h1,
#wrap.lang-eng h2,
#wrap.lang-eng h3,
#wrap.lang-eng h4,
#wrap.lang-eng h5,
#wrap.lang-eng button,
#wrap.lang-eng button span,
#wrap.lang-eng .tab__line li a {
  word-break: keep-all;
}
#wrap.lang-eng .monitor .box__body .box-column > li > article .cont ul.box-small-wrap li span.info {
  font-size: 20px;
}
#wrap.lang-eng .monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li {
  height: 68px;
  line-height: 1.4;
}
#wrap.lang-eng .monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap {
  gap: 0;
}
#wrap.lang-eng .graph-legend {
  gap: 8px 16px;
}
#wrap.lang-eng .area-result .solution-area .top .result-num {
  line-height: 1.6;
}
#wrap.lang-eng .container.wide .box .box__body .box-wrap h2 {
  line-height: 1.4;
}
#wrap.lang-eng .helper-info p span {
  line-height: 1.4;
}
#wrap.lang-eng.float-page .body-left .tbl-list table th,
#wrap.lang-eng .float-page .body-left .tbl-list table td {
  padding-left: 30px;
  padding-right: 30px;
}
#wrap.lang-eng.float-page .body-left .value-box .form__input button.btn-not.selected span {
  letter-spacing: -0.08em;
}
#wrap.lang-eng.float-page .body-left .value-box .form__input button.btn-not.selected span::before {
  width: 18px;
  height: 18px;
  margin-right: 3px;
}
#wrap.lang-eng .content__info ul li p.tit.w120 {
  width: 225px !important;
}
#wrap.lang-eng .btn-add.etc + .popup-etc {
  width: 186px;
}
#wrap.lang-eng .monitor .box__body .box-column > li > article .cont .tbl-list table th,
#wrap.lang-eng .monitor .box__body .box-column > li > article .cont .tbl-list table td {
  word-break: keep-all;
  padding: 13px 12px;
}
#wrap.lang-eng .monitor .box__body .box-column > li > article .cont .tbl-list.small-size table th,
#wrap.lang-eng .monitor .box__body .box-column > li > article .cont .tbl-list.small-size table td {
  padding: 9px 5px 8px;
}
#wrap.lang-eng .tab__box li a {
  letter-spacing: -0.9px;
}
#wrap.lang-eng .color-info {
  gap: 10px;
}
#wrap.lang-eng .color-info p {
  letter-spacing: -0.8px;
}
#wrap.lang-eng .color-info p:before {
  margin-right: 4px;
}
#wrap.lang-eng .tbl-list table th,
#wrap.lang-eng .tbl-list table td {
  word-break: keep-all;
}
#wrap.lang-eng .list-area > li > .list-top .btn-alarm:hover::before {
  content: "Mark as Read";
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 22px;
  width: 85px;
  height: 18px;
  font-weight: 400;
  font-size: 12px;
  color: #2a2c2f;
  background: #dde2e9;
  border-radius: 10px;
  z-index: 1000;
}
#wrap.lang-eng .list-area > li > .list-top .btn-alarm.readend:hover:before {
  content: "Mark as Unread";
  width: 108px;
  right: 24px;
}
#wrap.lang-eng .header__alarm .alarm__list li a .list__name button:hover::before {
  content: "Mark as Read";
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 22px;
  width: 85px;
  height: 18px;
  font-weight: 400;
  font-size: 12px;
  color: #2a2c2f;
  background: #dde2e9;
  border-radius: 10px;
  z-index: 1000;
}
#wrap.lang-eng .header__alarm .alarm__list li a .list__name button.readend:hover:before {
  content: "Mark as Unread" !important;
  width: 108px;
  right: 24px;
}
#wrap.lang-eng.page-market.serviceintro > .container .content .cont-bottom > article > section > p.tit {
  font-size: 32px;
}
#wrap.lang-eng.page-market.serviceintro
  > .container
  .content
  .cont-bottom
  > article.intro-sel
  > section
  > .bottom
  > .tit {
  font-size: 32px;
}
#wrap.lang-eng.page-market.serviceintro > .container .content .cont-bottom > article > section > p.txt {
  font-size: 18px;
  line-height: 1.6;
}
#wrap.lang-eng.page-market > .container .content .area-search .searcharea .select {
  flex: none;
  min-width: 180px;
  width: auto;
}
#wrap.lang-eng.page-market > .container .content .area-search .searcharea .select.active ul {
  min-width: 214px;
}
.float-page.lang-eng .body-left .value-box .form__input input[type="text"],
.float-page.lang-eng .body-left .value-box .form__input input[type="text"]::placeholder {
  font-size: 17px !important;
}
.float-page.lang-eng .body-left .value-box .form__input button.btn-not span {
  letter-spacing: -0.06em;
}
.float-page.lang-eng .body-left .value-box .form__input button.btn-not span::before {
  margin-right: 4px;
}
.lang-eng .tbl-list table th.sort span {
  flex-wrap: nowrap;
}
.lang-eng .tbl-list table th.sort span:after {
  flex: none;
}
.lang-eng .workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column .result__score .score::after {
  content: "points";
}
.lang-eng.main .content-top .top-wrap .right .btn-edit:hover::before {
  content: "Edit card position";
  width: 98px;
}
.lang-eng td.icon-delete span::before {
  content: "delete";
  left: -24px;
  width: 28px;
  letter-spacing: -0.02em;
}
.lang-eng td.icon-new span::before {
  left: -24px;
  width: 28px;
  letter-spacing: -0.02em;
}
.lang-eng .result__score::after {
  content: "points";
}
.lang-eng .content-wrap .content__info .listbox .box__bottom ul li .result__score div::after {
  content: "points";
}
.lang-eng .popup-type1.workplace-ok.page-detail .workplace__info .txt_workplace .result__score > div::after {
  content: "points";
}
#wrap.lang-eng.page-market.serviceintro
  > .container
  .content
  .cont-bottom
  > article.intro-sel
  > section
  > .bottom
  .detail
  > li
  .txt-wrap
  button.not-ex:hover
  span:before {
  content: "DEMO is currently being prepared.";
}
.lang-eng .loading-box::before {
  content: "Loading";
}
.lang-eng .header__alarm .alarm__list li a .list__name button:hover::before {
  content: "Mark as read";
}
.lang-eng .header__alarm .alarm__list li a .list__name button.readend:hover:before {
  content: "Mark as unread";
}
.lang-eng .list-area > li > .list-top .btn-alarm:hover::before {
  content: "Mark as read";
}
.lang-eng .list-area > li > .list-top .btn-alarm.readend:hover:before {
  content: "Mark as unread";
}
.lang-eng .btn-basic.pw-12.bg-no {
  flex: none;
}
.lang-eng .popup-type2 .popup__body .flex-row .pop-right .tbl-list table td ul.input__area > li:nth-of-type(2) > label {
  letter-spacing: -0.09em;
}
.lang-eng
  .popup-type2
  .popup__body
  .flex-row
  .pop-right
  .tbl-list
  table
  td
  ul.input__area
  > li
  > input[type="text"].w84.ml-16.mr-14 {
  flex: 1;
}
.lang-eng textarea::placeholder {
  word-break: keep-all;
}
.lang-eng .rank-info-list > li strong {
  min-width: 84px;
}
.lang-eng .pop-login.popup-type1 .popup__body .tab__line li {
  min-height: 32px;
  letter-spacing: -0.04em;
}

/********************************************** SEI2.0 에너지레포트 고도화 **********************************************/
.container.energy-solution .content .box .box__header .select ul,
.container.report .content .box .box__header .select ul {
  max-height: 436px;
  border-radius: 4px;
  box-shadow: 0px 8px 20px 0px #7a859680;
}
/* report 신규 발행 버튼 */
.container .content .box .box__header .select.report ul {
  margin-top: 0;
  width: calc(147px - 24px) !important;
  border: none;
}
.container .content .box .box__header .select.report:has(p.txt-round) ul {
  width: calc(177px - 24px) !important;
}
.box__header .select.report ul {
  padding: 12px;
}
.box__header .select.report ul li {
  border-bottom: 0;
  padding: 0;
  font-size: 14px;
  line-height: 24px;
  width: 100% !important;
}
.select.report ul li:hover {
  background: inherit;
}
.box__header .select.report ul li:active,
.select.report ul li:active,
.select.report ul li.active {
  background: inherit;
  color: inherit !important;
  font-weight: 500;
}
.box__header .select.report ul li + li {
  padding-top: 8px;
}

@media screen and (max-width: 940px) {
  .select.report {
    height: 100%;
    border: none;
  }
  .select.report ul {
    padding: 12px;
    border-radius: 4px;
    box-shadow: 0px 8px 20px 0px #7a859680;
    width: calc(100% - 24px) !important;
    border: none;
  }
  .select.report ul li {
    border-bottom: 0;
    padding: 0;
    font-size: 14px;
    line-height: 24px;
    width: 100% !important;
  }
  .box__header .select.report ul li:active,
  .select.report ul li:active,
  .select.report ul li.active {
    font-weight: 700;
  }
  .select.report ul li + li {
    padding-top: 24px;
  }
}
/********* 에너지 솔루션 - ESS설치분석 *********/
.container.energy-solution .box__body:has(.area__left) {
  padding: 0;
  display: flex;
  gap: 16px;
}
.container.energy-solution .box__body > .area__left {
  width: 240px;
}
.container.energy-solution .box__body > .area__right {
  display: flex;
  width: calc(100% - 252px);
  padding: 16px 0;
}
.container.energy-solution .box__body > .area__left .tab__line__toggleBtn {
  display: none;
}
.container.energy-solution .box .box__header:has(.tab__line.medium) + .box__body {
  min-height: calc(100% - 119px);
}
@media screen and (max-width: 940px) {
  .container.energy-solution .box__body > .area__left .tab__line__toggleBtn {
    display: block;
  }
  .container.energy-solution .box__body:has(.area__left) {
    flex-direction: column;
    gap: 0;
  }
  .container.energy-solution .box__body:has(.area__left) > .area__left {
    width: 100%;
    position: relative;
  }
  .container.energy-solution .box__body:has(.area__left) > .area__right {
    width: calc(100% - 40px);
    padding: 20px;
  }
}

.container.energy-solution .box__body .box-search-card-wrap {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 296px;
}
.container.energy-solution .box__body .box-search-card {
  padding-top: 16px;
  border-radius: 4px;
  background: #f2f5fb;
  border: 1px solid #0a78ff;
}
.container.energy-solution .box__body .box-search-card > .top {
  padding: 0 16px 16px;
}
.container.energy-solution .box__body .box-search-card > .top .tit {
  font-size: 1rem;
  font-weight: 500;
  line-height: 2;
  letter-spacing: -0.02em;
  color: #051c3f;
}
.container.energy-solution .box__body .box-search-card > .top .txt {
  margin-top: 4px;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.6;
  letter-spacing: -0.02em;
  color: #7a8596;
  word-break: break-word;
}
.container.energy-solution .box__body .box-search-card > .top .txt > button {
  display: inline-block;
}
.container.energy-solution .box__body .box-search-card > .top:has(.icon-renew.btn-pop-hover) {
  position: relative;
}
.container.energy-solution .box__body .box-search-card > .top .icon-renew.btn-pop-hover + .pop-layer-box.info {
  top: 24px;
  right: 16px;
  left: auto;
  width: auto;
  border: 0;
}
.container.energy-solution
  .box__body
  .box-search-card
  > .top
  .icon-renew.btn-pop-hover
  + .pop-layer-box.info
  .pop-body {
  padding: 9px 8px 8px;
}
.container.energy-solution
  .box__body
  .box-search-card
  > .top
  .icon-renew.btn-pop-hover
  + .pop-layer-box.info
  .pop-body
  p {
  font-size: 0.75rem;
  line-height: 1.3;
  letter-spacing: -0.02em;
}
.icon-renew {
  width: 24px;
  height: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_178___}) no-repeat center center;
  background-size: 100%;
}
.icon-renew:hover,
.btn-pop-hover.icon-renew.click {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_179___}) no-repeat center center;
}
.btn-pop-hover.icon-renew {
  width: 24px;
  height: 24px;
}
.container.energy-solution .box__body .box-search-card > .bottom {
  padding: 0 16px 24px;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul + ul {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #dde2e9;
  gap: 0;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > li > * {
  flex: 1;
}
/* .container.energy-solution .box__body .box-search-card > .bottom > ul > li > *:not(.tit) {
  text-align: right;
} */
.container.energy-solution .box__body .box-search-card > .bottom > ul > li .tit {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  letter-spacing: -0.05em;
  color: #051c3f;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > li .tit:has(.btn-pop) {
  display: flex;
  position: relative;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > li .tit .btn-pop {
  margin-top: 1px;
  margin-left: 2px;
}
/* .container.energy-solution .box__body .box-search-card > .bottom > ul > li > .btn-pop-area {
  position: relative;
  display: flex;
} */
/* .container.energy-solution .box__body .box-search-card > .bottom > ul > li > .btn-pop-area .btn-pop {
  margin-left: 2px;
  margin-top: 1px;
} */
/* .container.energy-solution .box__body .box-search-card .btn-pop-area .pop-layer-box.info {
  left: 0;
  top: 22px;
} */
.container.energy-solution .box__body .box-search-card > .bottom > ul > li .txt {
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.6;
  letter-spacing: -0.04em;
  color: #051c3f;
  text-align: right;
  font-family: "Pretendard", sans-serif; /* 추가 */
}
.container.energy-solution .box__body .unit {
  display: inline-block;
  min-width: 24px;
  margin-left: 4px;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.66;
  letter-spacing: -0.02em;
  color: #909fb7;
  text-align: left;
  vertical-align: middle;
  font-family: "NotoSansKR", sans-serif; /* 추가 */
}
.container.energy-solution .input__area {
  max-width: 120px;
}
.container.energy-solution .box__body .btn-area:has(.btn-round) {
  display: flex;
  gap: 3px;
}
.container.energy-solution .box__body .btn-area:has(.btn-round) .btn-round {
  flex: 1;
  height: 40px;
  background: #fff;
  border-color: #dde2e9;
  border-radius: 25px;
}
.container.energy-solution .box__body .btn-area:has(.btn-round) .btn-round:hover {
  border-color: #e6f0ff;
  background-color: #e6f0ff;
}
.container.energy-solution .box__body .btn-area:has(.btn-round) .btn-round span {
  font-size: 1rem;
  color: #2a2c2f;
  font-weight: 400;
  letter-spacing: -0.04em;
}
.container.energy-solution .box__body .btn-area:has(.btn-round) .btn-select.active {
  background: #0a78ff;
  border-color: #0a78ff;
}
.container.energy-solution .box__body .btn-area:has(.btn-round) .btn-select.active span {
  color: #fff;
  font-weight: 700;
}
.container.energy-solution .box__body .box-search-card .select,
.container.energy-solution .box__body .box-search-card input[type="text"] {
  height: 38px;
  font-size: 1rem;
  letter-spacing: -0.04em;
  background-color: #fff;
}
.container.energy-solution .box__body .box-search-card input[type="text"] {
  padding-right: 40px;
  width: calc(100% - 52px);
}
.container.energy-solution .box__body .box-search-card .select .selected {
  padding: 0 10px 0 12px;
}
.container.energy-solution .box__body .box-search-card .select.active ul {
  top: 42px;
  border-radius: 4px;
  box-shadow: 0px 8px 20px 0px rgba(122, 133, 150, 0.5);
}
.container.energy-solution .box__body .box-search-card .select ul li {
  width: calc(100% - 48px) !important;
  padding: 16px 24px;
  border-bottom: 1px solid #dde2e9;
}
.container.energy-solution .box__body .box-search-card .select.disabled {
  border-color: #f0f2f4;
  background-color: #f0f2f4;
  color: #bdc6d3;
}
.container.energy-solution .box__body .box-search-card .select.disabled .selected .arrow {
  opacity: 0.2;
}
.container.energy-solution .box__body .box-search-card .select.disabled + .txt-info {
  color: #bdc6d3;
}
input[type="text"]:has(.num-inputin) {
  padding-right: 40px;
  width: calc(100% - 54px);
}
.num-inputin {
  position: absolute;
  right: 12px;
  top: 8px;
  font-size: 1rem;
  letter-spacing: -0.04em;
  line-height: 1.5;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > li.column {
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > li.column > * {
  width: 100%;
  max-width: 100%;
  text-align: left;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > li.column .input__area {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > li.column .input__area .radioBox {
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
}
.container.energy-solution .box__body .box-search-card .radioBox label {
  margin-left: 8px;
  font-size: 1rem;
  letter-spacing: -0.04em;
}
.container.energy-solution .box__body .box-search-card .radioBox label:has(input[type="radio"]:disabled) {
  color: #f0f2f4;
}
.container.energy-solution .box__body .box-search-card .radioBox input[type="radio"]:disabled {
  background: #fff;
}
.container.energy-solution .box__body .box-search-card .radioBox label:has(input[type="radio"]:disabled) + .icon-info {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_180___}) no-repeat center center;
}
.container.energy-solution .box__body .box-search-card input[type="checkbox"] + label {
  font-size: 1rem;
  padding-left: 24px;
}
.container.energy-solution .box__body .box-search-card input[type="checkbox"] + label:before {
  top: 1px;
  width: 16px;
  height: 16px;
}
.container.energy-solution .box__body .box-search-card input[type="checkbox"]:checked + label:after {
  top: 1px;
  width: 16px;
  height: 16px;
  border-radius: 0;
  background-position-x: 1px;
}
.container.energy-solution .box__body .pop-layer-box.info {
  border-radius: 4px;
}
.container.energy-solution .box__body .pop-layer-box.info .pop-body {
  padding: 10px 24px;
  max-height: 300px;
  overflow-y: auto;
}
.container.energy-solution .box__body .box-search-card .radioBox .pop-layer-box.info {
  left: 56%;
  top: 20px;
}
@media screen and (max-width: 699px) {
  .container.energy-solution .box__body .box-search-card .radioBox .pop-layer-box.info {
    left: -16px;
  }
}
.container.energy-solution .box__body .box-search-card .txt-info {
  margin: 0;
  line-height: 1.5;
  font-size: 0.75rem;
  letter-spacing: -0.03em;
}
.container.energy-solution .box__body .box-search-card > .btn-area {
  width: 100%;
}
.container.energy-solution .box__body .box-search-card > .btn-area .btn-basic {
  width: 100%;
  height: 42px;
}
.container.energy-solution .box__body .box-search-card > .btn-area .btn-basic span {
  font-size: 1rem;
}
.container.energy-solution .box__body .box-search-card-bottom > button {
  padding: 0 16px;
  width: 100%;
  height: 44px;
  background: #f0f2f4;
  border-radius: 4px;
  border: 0;
  justify-content: space-between;
}
.container.energy-solution .box__body .box-search-card-bottom > button:after {
  content: "";
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_151___}) no-repeat center center;
  background-size: 100%;
  transform: scaleX(-1);
}
.container.energy-solution .box__body .box-search-card-bottom > button span {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #fff;
}
.container.energy-solution .box__body .box-search-card-bottom > button.btn-chk span:before {
  content: "";
  width: 24px;
  height: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_181___}) no-repeat center center;
  background-size: 100%;
}
.container.energy-solution .box__body .box-search-card-bottom > button.btn-set span:before {
  content: "";
  width: 24px;
  height: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_182___}) no-repeat center center;
  background-size: 100%;
}
.container.energy-solution .box__body .box-search-card-bottom > button.bg-primary:hover {
  background-color: #0050b8 !important;
}
.container.energy-solution .box__body .box-search-card-bottom > button.bg-primary:active,
.container.energy-solution .box__body .box-search-card-bottom > button.bg-primary:focus {
  background: #003876 !important;
}
/* .container.energy-solution .box__body .box-search-card-bottom .btn-chk:focus:after {
  background: url('../img/icon_arrow_white.svg') no-repeat center center;
}
.container.energy-solution .box__body .box-search-card-bottom .btn-chk:focus span {
  color: #fff;
}
.container.energy-solution .box__body .box-search-card-bottom .btn-chk:focus span:before {
  background: url('../img/icon_chk_white.svg') no-repeat center center;
  background-size: 100%;
} */
.container.energy-solution .box__body .box-search-card-bottom .filelist {
  margin: 8px 0 0;
}
.container.energy-solution .box__body .box-search-card-bottom .filelist li {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px 6px 16px;
  background: #e7f2ff;
  border-radius: 25px;
  margin-bottom: 8px;
  width: auto;
}
.container.energy-solution .box__body .box-search-card-bottom .filelist li span {
  display: inline;
  padding: 0;
  font-size: 0.75rem;
  line-height: 1.43;
  letter-spacing: -0.04em;
  background: none;
}
.container.energy-solution .box__body .box-search-card-bottom .filelist li .btn-delete {
  display: inline;
  margin-left: 0;
  width: 20px;
  height: 20px;
  vertical-align: middle;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_183___}) no-repeat 0 0;
  background-size: 20px;
}
.container.energy-solution .box__body .box-column {
  margin: 0 0 16px 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.container.energy-solution .box__body .scroll-area .box-column {
  width: calc(100% - 21px);
  padding: 5px 16px 5px 5px;
  margin: 0;
}
.container.energy-solution .box__body .box-column > li {
  padding: 16px;
  background: #fff;
  box-shadow: 0px 2px 8px 0px rgba(144, 159, 183, 0.5);
  border-radius: 4px;
  min-height: 160px;
}
.container.energy-solution .box__body .box-column > li.on,
.container.energy-solution .box__body .box-column > li.on {
  border: 1px solid #0a78ff;
}
.container.energy-solution .box__body > .area__right:has(.box-column > li.on) .box-search-card {
  border-color: #f2f5fb;
}
.container.energy-solution .box__body > .area__right:has(.box-column > li.on) .box-search-card > .btn-area .btn-basic {
  border-color: #909fb7;
  background-color: #909fb7;
}
.container.energy-solution .box__body > .area__right:has(.scroll-area) {
  height: calc(100vh - 217px);
}
.container.energy-solution .box__body > .area__right .scroll-area:has(.box-column) {
  flex: 1;
  margin: -4px 0 0 16px;
  width: calc(100% - 328px);
  height: 100%;
  overflow-y: auto;
}
.container.energy-solution .box__body .box-column > li > article > section .top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #dde2e9;
}
.container.energy-solution .box__body .box-column > li > article > section .top input[type="checkbox"] + label {
  padding-left: 24px;
  font-size: 1rem;
  letter-spacing: -0.02em;
  font-weight: 500;
  line-height: 1.5;
}
.container.energy-solution .box__body .box-column > li > article > section .top input[type="checkbox"] + label:before {
  width: 16px;
  height: 16px;
  top: 4px;
}
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .top
  input[type="checkbox"]:checked
  + label:after {
  width: 16px;
  height: 16px;
  top: 4px;
  background-position-x: 1px;
}
.container.energy-solution .box__body .box-column > li > article > section .top .btn-close {
  margin-top: -5px;
  width: 32px;
  height: 32px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_184___}) no-repeat center center;
  background-size: 100%;
}
.container.energy-solution .box__body .box-column > li > article > section .cont {
  display: flex;
  gap: 32px;
}
.container.energy-solution .box__body .box-column > li > article > section .cont > .left {
  flex: 1;
}
.container.energy-solution .box__body .box-column > li > article > section .cont > .right {
  flex: 1.53;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  height: 100%;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li {
  padding: 16px;
  background: #f7f8fa;
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
  /* min-width: 174px; */
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li > .box-list > li {
  padding: 0;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list.column {
  flex-direction: column;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list.column > li {
  flex-direction: row;
  justify-content: space-between;
  min-height: 56px;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .name {
  font-size: 0.938rem;
  line-height: 1.6;
  letter-spacing: -0.04em;
  color: #2a2c2f;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .name:before {
  content: "";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin: 6px 8px 0 0;
  background: #0a78ff;
  border-radius: 50%;
  vertical-align: text-top;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .data {
  text-align: right;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .data .num {
  font-size: 1.625rem;
  font-weight: 500;
  line-height: 1.39;
  letter-spacing: -0.02em;
  color: #2a2c2f;
  font-family: "Pretendard", sans-serif; /* 추가 */
  font-style: normal; /* 추가 */
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .data + .name {
  margin-top: 16px;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info span {
  font-size: 0.813rem;
  font-weight: 400;
  line-height: 1.54;
  letter-spacing: -0.02em;
  color: #646c74;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info span {
  font-size: 0.813rem;
  font-weight: 400;
  line-height: 1.54;
  letter-spacing: -0.02em;
  color: #646c74;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info .percent {
  display: inline-flex;
  justify-content: flex-end;
  align-items: center;
  gap: 2px;
  font-size: 0.875rem;
  line-height: 1.43;
  color: #0a78ff;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info .percent .unit {
  font-size: 0.75rem;
  color: #0a78ff;
  min-width: auto;
  margin-left: 0;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info .percent.down {
  color: #0a78ff;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info .percent.down .unit {
  color: #0a78ff;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info .percent.up {
  color: #f55547;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info .percent.up .unit {
  color: #f55547;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info .percent.down:after {
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_185___}) no-repeat center center;
  background-size: 100%;
  vertical-align: bottom;
}
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .box-list
  > li
  .info
  .percent.down.text:after {
  content: "감소";
  width: auto;
  background: none;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info .percent.up:after {
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_186___}) no-repeat center center;
  background-size: 100%;
  vertical-align: bottom;
  transform: scaleY(-1);
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info .percent.up.text:after {
  content: "증가";
  background: none;
  transform: none;
  width: auto;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info .text {
  font-size: 0.75rem;
  color: #0a78ff;
  line-height: 1.66;
  letter-spacing: -0.04em;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info a {
  cursor: pointer;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info a:hover,
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info a:active {
  font-weight: 500;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list:not(.column) > li {
  position: relative;
  min-height: 248px;
}
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .box-list:not(.column)
  > li:has(.data + .btn-pop-area, .data + .name) {
  min-height: 248px;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list:not(.column) > li:not(:has(.etc)) {
  min-height: 104px;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .etc {
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: absolute;
  bottom: 22px;
  width: calc(100% - 32px);
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .etc p {
  display: flex;
  justify-content: space-between;
  font-size: 0.813rem;
  font-weight: 400;
  line-height: 1.54;
  letter-spacing: -0.02em;
  color: #646c74;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .etc p > span {
  flex: 1;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .etc p > span.txt-right {
  word-break: break-word;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li.warning {
  border: 1px solid #f55547;
  background: rgba(245, 85, 71, 0.1);
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li.warning .name,
.container.energy-solution .box__body .box-column > li > article > section .box-list > li.warning .data .num,
.container.energy-solution .box__body .box-column > li > article > section .box-list > li.warning .data .unit {
  color: #f55547;
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li.warning .name:before {
  background: #f55547;
}
.container.energy-solution .box__body .box-column > li > article > section .bottom {
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.container.energy-solution .box__body .box-column > li > article > section .bottom .btn-area {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  flex: 1;
}
.container.energy-solution .box__body .box-column > li > article > section .bottom .btn-area .checkbox-wrap {
  padding: 6px 16px 6px 8px;
}
@media screen and (max-width: 1006px) {
  .container.energy-solution .box__body .box-column > li > article > section .bottom .btn-area:has(.checkbox-wrap) {
    flex-direction: column;
    align-items: flex-end;
    gap: 16px;
  }
}
@media screen and (max-width: 940px) {
  .container.energy-solution .box__body .box-column > li > article > section .bottom .btn-area:has(.checkbox-wrap) {
    flex-direction: row;
    gap: 8px;
  }
}
@media screen and (max-width: 750px) {
  .container.energy-solution .box__body .box-column > li > article > section .bottom .btn-area:has(.checkbox-wrap) {
    flex-direction: column;
    gap: 16px;
  }
}
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .bottom
  .btn-area
  .checkbox-wrap
  input[type="checkbox"]:disabled
  + label:after {
  top: 0.125rem;
}
@media screen and (max-width: 320px) {
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .bottom
    .btn-area
    .checkbox-wrap
    input[type="checkbox"]
    + label:before {
    width: 12px;
    height: 12px;
    top: 0.125rem;
  }
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .bottom
    .btn-area
    .checkbox-wrap
    input[type="checkbox"]:checked
    + label:after {
    top: 0.125rem;
  }
}
.container.energy-solution .box__body .box-column > li > article > section .bottom .btn-area .btn-basic {
  min-width: 112px;
  padding: 0 16px;
}
.container.energy-solution .box__body .box-column > li > article > section .bottom .btn-area .btn-basic + .btn-basic {
  margin-left: 0;
}
.container.energy-solution .box__body .box-column > li > article > section .bottom .btn-area .btn-basic span {
  letter-spacing: -0.047em;
}
.container.energy-solution .box__body .box-column > li > article > section .bottom .txt-info {
  font-size: 0.75rem;
  letter-spacing: -0.02em;
  margin-left: 0;
  line-height: 1.66;
}

/*데이터없는경우*/
.container.energy-solution .box__body .scroll-area .box-column.nodata {
  height: calc(100% - 10px);
}
.container.energy-solution .box__body .nodata .nodata__txt {
  height: 100%;
  font-size: 0.75rem;
}

@media screen and (max-width: 1740px) {
  .container.energy-solution .box__body .box-column > li > article > section .cont {
    flex-direction: column;
    gap: 16px;
  }
  .container.energy-solution .box__body .box-column > li > article > section .box-list.column {
    flex-direction: row;
  }
  .container.energy-solution .box__body .box-column > li > article > section .box-list.column > li {
    flex-direction: column;
    gap: 24px;
  }
}
@media screen and (max-width: 1294px) {
  .container.energy-solution .box__body .box-column > li > article > section .box-list {
    flex-direction: column;
  }
  .container.energy-solution .box__body .box-column > li > article > section .box-list.column {
    flex-direction: column;
  }
  /* .container.energy-solution .box__body .box-column > li > article > section .box-list > li .etc {
    position: relative;
    bottom: auto;
    margin-top: 0;
    width: 100%;
  } */
  .container.energy-solution .box__body .box-column > li > article > section .bottom {
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    gap: 16px;
  }
  .container.energy-solution .box__body .box-column > li > article > section .bottom > * {
    width: 100%;
  }
}
@media screen and (max-width: 940px) {
  #wrap:not(.no-responsive) .container.energy-solution .box__header .tab__line li {
    padding: 11px 14px 12px;
  }
  .container.energy-solution .box__body > .area__left > .tab__line {
    display: none;
  }
  .container.energy-solution .box__body > .area__left > .tab__line__toggleBtn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    width: calc(100% - 40px);
    height: 47px;
    background: #fff;
    border-bottom: 1px solid #dde2e9;
    cursor: pointer;
  }
  .container.energy-solution .box__body > .area__left > .tab__line__toggleBtn::after {
    content: "";
    width: 24px;
    height: 24px;
    margin-left: 40px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_26___}) no-repeat center center;
    background-size: 100%;
  }
  .container.energy-solution .box__body > .area__left > .tab__line__toggleBtn.active:after {
    content: "";
    transform: rotate(180deg);
  }
  .container.energy-solution .box__body > .area__left > .tab__line.active {
    display: block;
    position: absolute;
    top: 49px;
    width: 100% !important;
    height: auto;
    border: 0;
    padding: 0;
    margin: 0;
    z-index: 2;
    box-shadow: none;
  }
  #wrap:not(.no-responsive) .container.energy-solution .box__body > .area__left > .tab__line li {
    padding: 14px 32px;
    width: calc(100% - 64px);
    height: auto;
    min-height: 39px;
    border-bottom: 1px solid #dde2e9;
  }
  #wrap:not(.no-responsive) .container.energy-solution .box__header.flex-column.brd-bottom-0.pb-0 {
    padding: 32px 0 24px;
  }
  #wrap:not(.no-responsive, .float-page) .container.energy-solution {
    margin: 50px 0 0 0;
  }
  #wrap:not(.no-responsive, .float-page) .container.energy-solution .content {
    margin-top: 0;
  }
  .container.energy-solution .box__header > *:not(.tab__line) {
    margin: 0 20px;
    width: calc(100% - 40px) !important;
  }
  #wrap:not(.no-responsive) .container.energy-solution .box {
    height: auto;
    overflow-y: hidden;
  }
  .container.energy-solution .box__body > .area__right .scroll-area:has(.box-column) {
    margin: -4px -14px 0 16px;
  }
  .container.energy-solution .box__body .scroll-area .box-column {
    padding-right: 5px;
    width: calc(100% - 10px);
  }
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .top
    input[type="checkbox"].m-none
    + label {
    padding-left: 0;
  }
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .top
    input[type="checkbox"].m-none
    + label:before {
    content: none;
  }
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .top
    input[type="checkbox"].m-none:checked
    + label:after {
    content: none;
  }
  .container.energy-solution .box__body .box-column > li > article > section .bottom .btn-area .btn-basic,
  #wrap:not(.no-responsive)
    .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .bottom
    .btn-area
    .btn-basic {
    height: 32px;
  }
  .container.energy-solution .box__body .box-column > li > article > section .bottom .btn-area .btn-basic span,
  #wrap:not(.no-responsive)
    .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .bottom
    .btn-area
    .btn-basic
    span {
    font-size: 14px;
  }
}
@media screen and (max-width: 699px) {
  .container.energy-solution .box__body:has(.area__left) > .area__right {
    flex-direction: column;
    gap: 20px;
    height: auto;
  }
  .container.energy-solution .box__body .box-search-card-wrap {
    width: 100%;
    flex: 1;
  }
  .container.energy-solution .box__body .box-column {
    width: 100%;
    margin: 0;
  }
  .container.energy-solution .box__body > .area__right .scroll-area:has(.box-column) {
    margin: 0;
    width: 100%;
  }
}
@media screen and (max-width: 499px) {
  #wrap:not(.no-responsive) .container.energy-solution .box__header.flex-column.brd-bottom-0.pb-0 {
    padding: 83px 0 24px;
  }
}

/* 운영 효과 상세분석 */
.detail-analysispop {
  display: none;
  margin-top: 32px;
}
.detail-analysispop.view {
  display: block;
}
.container.energy-solution .box__body .box-column > li > article > section.detail-analysispop .top,
.detail-analysispop .top {
  border-radius: 4px 4px 0px 0px;
  background: #003378;
  color: #fff;
  padding: 6px 16px;
}
.detail-analysispop .left > b {
  font-size: 14px;
  font-weight: 500;
}
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section.detail-analysispop
  > .top
  .right
  .btn-close.white,
.detail-analysispop > .top .right .btn-close.white {
  margin-top: 0;
  width: 20px !important;
  height: 20px !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_187___}) no-repeat center center !important;
}
.detail-analysis-wrap {
  margin: 32px 16px 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.detail-analysis-wrap + .detail-analysis-wrap {
  margin-top: 48px;
}
.detail-analysis-wrap > .title {
  font-size: 1.25rem;
  font-weight: 500;
  color: #2a2c2f;
  line-height: 1.6;
}
.detail-analysis-wrap .title-small {
  font-size: 1rem;
  font-weight: 500;
  color: #2a2c2f;
  line-height: 1.5;
}
.detail-analysis-wrap .tbl__top .title-small {
  margin-bottom: 0;
}
.detail-analysis-wrap .tbl-list.tbl-border-large .btn-txt span {
  font-weight: 400;
}
.detail-analysis-wrap .tbl-list.tbl-border-large .btn-txt:hover span,
.detail-analysis-wrap .tbl-list.tbl-border-large .btn-txt:active span {
  font-weight: 500;
}
.container.energy-solution .box__body .detail-analysispop .unit {
  min-width: auto;
}
.container.energy-solution .box__body .box-column > li > article > section .detail-analysis-wrap > .bottom {
  margin-top: 0;
}
.analysis-box {
  padding: 32px;
  width: calc(100% - 64px);
  border: 1px solid #dde2e9;
}
.analysis-box > ul {
  display: flex;
  gap: 16px 64px;
  flex-wrap: wrap;
}
/* .analysis-box li {
  padding: 32px;
} */
.analysis-box > ul > li > p {
  font-size: 0.813rem;
  font-weight: 400;
  line-height: 1.53;
  color: #2a2c2f;
}
.analysis-box li > p.tit {
  margin-bottom: 4px;
  color: #646c74;
}
@media screen and (max-width: 1469px) {
  .analysis-box > ul {
    gap: 16px 32px;
  }
  .analysis-box > ul > li {
    width: calc(50% - 32px);
  }
}
@media screen and (max-width: 1294px) {
  .analysis-box > ul {
    flex-direction: column;
    gap: 32px;
  }
  .analysis-box > ul > li {
    width: 100%;
  }
}
@media screen and (max-width: 940px) {
  .detail-analysis-wrap {
    margin: 32px 0 0;
  }
  .container.energy-solution .box__body .box-column > li > article > section.detail-analysispop .top,
  .detail-analysispop .top {
    margin: 0 -8px 0;
  }
  .analysis-box {
    padding: 16px;
    width: calc(100% - 32px);
  }
}

.line-box {
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 32px;
  width: calc(100% - 64px);
  border: 1px solid #dde2e9;
}
.line-box .txt-info {
  font-size: 0.75rem;
  line-height: 1.5;
  margin: 16px 0 0 0;
}
.line-box .txt-info-large {
  margin-top: 16px;
  font-size: 1.125rem;
  line-height: 1.6;
  color: #2a2c2f;
  letter-spacing: -0.05em;
}
.line-box .txt-info-large + .txt-info-large {
  margin-top: 8px;
}
.line-box.row {
  flex-direction: row;
  justify-content: space-between;
}
.line-box.row > * {
  flex: 1;
}
.box-info-area {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.box-info-area:has(.left) {
  flex-direction: row !important;
  justify-content: space-between;
}
.box-info-area.hover:hover {
  background: #e6f0ff !important;
  border: 1px solid #0a78ff !important;
}
.box-info-area > .left {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.box-info-area .select-wrap {
  display: flex;
  gap: 38px;
  flex-direction: row;
}
.box-info-area .select-wrap .date-area {
  position: relative;
}
/* 선택 스케줄 일 react-datepicker */
.box-info-area .select-wrap .date-area .react-datepicker {
  position: absolute;
  left: 0;
  top: 72px;
  font-family: "NotoSansKR", sans-serif !important;
  border-color: #0d78ff;
  box-shadow: 0px 8px 12px 0px rgba(122, 133, 150, 0.5);
  z-index: 2;
}
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__navigation {
  top: 20px;
  height: 20px;
  width: 20px;
}
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__navigation--previous {
  left: 80px;
}
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__navigation--next {
  right: 80px;
}
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__year-read-view--down-arrow,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__month-read-view--down-arrow,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__month-year-read-view--down-arrow,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__navigation-icon::before {
  border-color: #0a78ff;
  border-width: 2px 2px 0 0;
  height: 10px;
  width: 10px;
}
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__header {
  padding-top: 23px;
  background-color: #fff;
  border-bottom: 0;
}
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__day-names {
  margin-top: 16px;
}
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__day-name {
  margin: 3px;
  width: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #909fb7;
}
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__month {
  margin: 0px 6px 13px;
}
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__current-month {
  font-size: 15px;
  font-weight: 500;
}
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__day {
  margin: 2px 3px;
  width: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #2a2c2f;
}
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__day:hover,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__month-text:hover,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__quarter-text:hover,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__year-text:hover {
  color: #fff;
  font-weight: 700;
  border-radius: 100%;
  background-color: #0a78ff;
}
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__day--selected,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__day--in-selecting-range,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__day--in-range,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__month-text--selected,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__month-text--in-selecting-range,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__month-text--in-range,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__quarter-text--selected,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__quarter-text--in-selecting-range,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__quarter-text--in-range,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__year-text--selected,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__year-text--in-selecting-range,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__year-text--in-range {
  color: #fff;
  font-weight: 700;
  border-radius: 100%;
  background-color: #0a78ff;
}
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__day--selected:hover,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__day--in-selecting-range:hover,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__day--in-range:hover,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__month-text--selected:hover,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__month-text--in-selecting-range:hover,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__month-text--in-range:hover,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__quarter-text--selected:hover,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__quarter-text--in-selecting-range:hover,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__quarter-text--in-range:hover,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__year-text--selected:hover,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__year-text--in-selecting-range:hover,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__year-text--in-range:hover {
  color: #fff;
  font-weight: 700;
  background-color: #0a78ff;
}
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__day--keyboard-selected,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__month-text--keyboard-selected,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__quarter-text--keyboard-selected,
.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__year-text--keyboard-selected {
  color: #fff;
  font-weight: 700;
  border-radius: 100%;
  background-color: #0a78ff;
}
.box-info-area .term__date {
  display: flex;
  gap: 12px;
  border-radius: 0;
  border: 0;
  background-color: transparent;
  height: auto;
}
.box-info-area .term__date:after {
  content: "";
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_188___}) no-repeat center center;
  background-size: 100%;
  flex: none;
}
.box-info-area .term__date.open:after {
  transform: scaleY(-1);
}
.box-info-area .term__date span {
  font-size: 26px;
  line-height: 40px;
  font-weight: 500;
  letter-spacing: -0.02em;
  text-align: left;
  font-family: "Pretendard", sans-serif; /* 추가 */
}
.box-info-area .txt-info {
  margin: 0;
  font-size: 0.75rem;
  line-height: 1.5;
}
.box-info-area .tit {
  font-size: 0.938rem;
  line-height: 1.6;
  font-weight: 400;
  color: #051c3f;
}
.box-info-area .select-wrap .tit {
  margin-bottom: 8px;
  white-space: nowrap;
}
.box-info-area .select-wrap .txt {
  font-size: 26px;
  line-height: 40px;
  font-weight: 500;
  letter-spacing: -0.02em;
  font-family: "Pretendard", sans-serif;
}
.box-info-area .num {
  font-size: 1.625rem;
  font-weight: 500;
  line-height: 1.08;
  letter-spacing: -0.02em;
  color: #2a2c2f;
  font-family: "Pretendard", sans-serif; /* 추가 */
}
.box-info-area .unit,
.container.energy-solution .box__body .box-info-area .unit {
  margin-left: 8px;
  line-height: 1.66;
  min-width: auto;
}
.line-box .box-info-area.large .unit,
.container.energy-solution .box__body .line-box .box-info-area.large .unit {
  min-width: 24px;
  font-size: 1rem;
  line-height: 2;
}
.line-box .box-info-area {
  gap: 16px;
  margin: -32px -32px 0;
  padding: 32px;
  background: #f7f8fa;
}
.line-box .box-info-area .tit {
  font-size: 1rem;
  line-height: 1.5;
}
.line-box .box-info-area.large .tit {
  font-size: 1.125rem;
  line-height: 1.334;
}
.line-box .box-info-area .num {
  line-height: 1.39;
}
.line-box .box-info-area.large .num {
  font-family: "Pretendard", sans-serif;
  font-style: normal;
  font-size: 1.875rem;
  line-height: 1.61;
}
.line-box .box-info-area .unit,
.container.energy-solution .box__body .line-box .box-info-area .unit {
  line-height: 2.67;
}
.box-info-area > .right:has(.btn-txt) {
  display: flex;
  align-items: flex-end;
  flex: 1;
  gap: 79px;
  margin-left: 140px;
}
.box-info-area > .right:has(.btn-txt + .btn-txt) {
  margin-left: 80px;
}
.box-info-area > .right .btn-txt {
  margin-bottom: 10px;
  gap: 33px;
}
.box-info-area > .right .btn-txt i {
  width: 20px;
  height: 20px;
}
.box-info-area > .right .btn-txt span {
  color: var(--navy) !important;
}
.box-info-area > .right .btn-txt:has(.icon-setting-primary) {
  gap: 22px;
}
.icon-folder-primary {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_189___}) no-repeat center center;
  background-size: 100%;
}
@media screen and (max-width: 1540px) {
  .box-info-area:has(.left) {
    flex-direction: column;
  }
}
@media screen and (max-width: 1140px) {
  .box-info-area > div,
  .box-info-area .select-wrap {
    flex-direction: column;
  }
  .box-info-area .select-wrap {
    gap: 16px;
  }
  .box-info-area .right:has(button) {
    display: flex;
    align-items: flex-end;
  }
  .line-box .box-info-area > .data,
  .line-box .box-info-area > .data + .txt-info {
    text-align: right;
  }
}
@media screen and (max-width: 940px) {
  .line-box {
    padding: 16px;
    width: calc(100% - 32px);
  }
  .line-box .box-info-area,
  .box-info-area {
    padding: 16px;
    margin: -16px -16px 0;
  }
  .box-info-area .right:has(button.m-none) {
    display: none;
  }
}

.box-info-area .select-wrap .select,
.box-info-area .select-wrap .select input[type="date"] {
  display: flex;
  gap: 38px;
  height: 40px;
  color: #2a2c2f;
  font-weight: 500;
  font-size: 26px;
  line-height: 40px;
  letter-spacing: -0.7px;
  border: 0;
  border-radius: 0;
  background: transparent;
}
.box-info-area .select-wrap .select .selected .selected-value {
  font-family: "Pretendard", sans-serif; /* 추가 */
}
.box-info-area .select-wrap .select.wmin-120 .selected .selected-value {
  min-width: 120px;
}
.box-info-area .select-wrap .select.wmin-120.active > ul {
  min-width: 96%;
  white-space: nowrap;
}
/* input="date" 캘린더 아이콘 제거 */
.selected-value input[type="date"] {
  width: 137px;
}
.selected-value input[type="date"]::-webkit-calendar-picker-indicator,
.selected-value input[type="time"]::-webkit-calendar-picker-indicator,
.selected-value input[type="month"]::-webkit-calendar-picker-indicator,
.selected-value input[type="week"]::-webkit-calendar-picker-indicator,
.selected-value input[type="datetime-local"]::-webkit-calendar-picker-indicator {
  display: none;
}
.box-info-area .select-wrap .select.active > ul {
  border-radius: 4px;
  top: 40px;
  width: auto !important;
  max-height: 398px;
  box-shadow: 0px 8px 20px 0px rgba(122, 133, 150, 0.5);
}
.box-info-area .select-wrap .select ul li:hover {
  color: #0a78ff;
}
.box-info-area .select-wrap .select > ul li {
  font-size: 1rem;
  padding: 12px 32px 11px 24px;
  width: auto !important;
  line-height: 1;
  border-bottom: 1px solid #dde2e9;
}
.box-info-area .select-wrap .select .selected {
  padding: 0;
  gap: 12px;
}
.box-info-area .select-wrap .select .selected .arrow {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_188___}) no-repeat center center;
}
.box-info-area > div > .btn-basic {
  height: 28px;
  min-width: 80px;
}
.box-info-area > div > .btn-basic.viewall {
  width: 100px;
}
@media screen and (max-width: 940px) {
  .box-info-area > div > .btn-basic,
  #wrap:not(.no-responsive) .box-info-area > div > button.btn-basic {
    height: 28px;
  }
  .box-info-area > div > .btn-basic span,
  #wrap:not(.no-responsive) .box-info-area > div > button.btn-basic span {
    font-size: 14px;
  }
}
.analysis-graph .analysis-graph-wrap .tit {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.3;
  color: #2a2c2f;
}
.analysis-graph-wrap .graph-cont {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.analysis-graph-wrap .graph-cont .graph-box {
  overflow: auto;
}
.analysis-graph-wrap .graph-cont .graph-box .graph-area {
  width: 100%;
  min-width: 525px;
}
.graph-cont .graph-legend {
  justify-content: center;
  gap: 8px;
}
.graph-cont .graph-legend p {
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.43;
}
.graph-cont .graph-legend p:before {
  content: "";
  width: 16px;
  height: 16px;
  background: #ddd;
  border-radius: 0;
  min-width: 16px;
}
.graph-cont .graph-legend p sub {
  padding-right: 3px;
  transform: translatey(30%);
}
.graph-cont .graph-legend p.line-square:before {
  border: 3px solid #ff6781;
  background: #fff;
}
.graph-cont .graph-legend p.line-bg-square:before {
  border: 1px solid #ff4f6e;
  background-color: rgba(255, 79, 110, 0.1);
}
.graph-cont .graph-legend p.dote-type:before {
  height: 4px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_190___}) no-repeat center center;
  background-size: 100%;
}
.graph-cont .graph-legend p.dote-type.magenta:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_191___}) no-repeat center center !important;
}
.graph-cont .graph-legend p.dote-type.deep-blue:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_192___}) no-repeat center center !important;
}
.graph-cont .graph-legend p.dote-type.midnight-blue:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_193___}) no-repeat center center !important;
}
.graph-cont .graph-legend p.dote-type.mint:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_194___}) no-repeat center center !important;
}
.graph-cont .graph-legend p.dote-type.light-aqua:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_195___}) no-repeat center center !important;
}
.graph-cont .graph-legend p.line-type:before {
  height: 6px;
}
.graph-cont .graph-legend .navy::before {
  background: #0f5fa5 !important;
}
.graph-cont .graph-legend .dark-navy::before {
  background: #003876 !important;
}
.graph-cont .graph-legend .blue::before {
  background: #4253ba !important;
}
.graph-cont .graph-legend .blue-navy::before {
  background: #1b67aa !important;
}
.graph-cont .graph-legend .light-blue::before {
  background: #5b71ef !important;
}
.graph-cont .graph-legend .cyan::before {
  background: #00d5cc !important;
}
.graph-cont .graph-legend .red::before {
  background: #ff6781 !important;
}
.graph-cont .graph-legend .purple::before {
  background: #930aff !important;
}
.graph-cont .graph-legend .light-purple::before {
  background: #e3e6ff !important;
}
.graph-cont .graph-legend .vivid-purple::before {
  background: rgba(147, 10, 255, 0.89) !important;
}
.graph-cont .graph-legend .light-cyan::before {
  background: #ccece5 !important;
}
.graph-cont .graph-legend .light-green::before {
  background: #eefbdd !important;
}
.graph-cont .graph-legend .sky-blue::before {
  background: #cddbff !important;
}
.graph-cont .graph-legend .dark-blue::before {
  background: #162db9 !important;
}
.graph-cont .graph-legend .deep-blue::before {
  background: #0028b6 !important;
}
.graph-cont .graph-legend .medium-blue::before {
  background: #5c73f8 !important;
}
.graph-cont .graph-legend .light-gray::before {
  background: #dde2e9 !important;
}
.graph-cont .graph-legend .white-gray::before {
  background: #d5d8e5 !important;
}
.graph-cont .graph-legend .dark-gray::before {
  background: #646c74 !important;
}
.graph-cont .graph-legend .hot-pink::before {
  background: #ff4f6e !important;
}
.graph-cont .graph-legend .coral::before {
  background: #f55547 !important;
}
.graph-cont .graph-legend .mint::before {
  background: #00dacd !important;
}
.graph-cont .graph-legend .deep-cyan::before {
  background: #13a79e !important;
}
.graph-cont .graph-legend .bright-blue::before {
  background: #0a78ff !important;
}
.graph-cont .graph-legend .lavender::before {
  background: #7d5cbe !important;
}
.graph-cont .graph-legend .orange::before {
  background: #ff9900 !important;
}
.graph-cont .graph-legend .turquoise::before {
  background: #00a07c !important;
}
.graph-cont .graph-legend .bright-cyan::before {
  background: #1bc8e9 !important;
}
.graph-cont .graph-legend .lime::before {
  background: #819b17 !important;
}
.graph-cont .graph-legend .beige::before {
  background: #8d5b2d !important;
}
.graph-cont .graph-legend .light-pink::before {
  background: #ffc0cd !important;
}
.graph-cont .graph-legend .grayish::before {
  background: #b2c0db !important;
}
.graph-cont .graph-legend .dark-cerulean::before {
  background: #084a84 !important;
}
.graph-cont .graph-legend .deep-pink::before {
  background: #cc4b78 !important;
}
.graph-cont .graph-legend .dark-purple::before {
  background: #663c90 !important;
}
.graph-cont .graph-legend .dark-orange::before {
  background: #e76700 !important;
}
.graph-cont .graph-legend .bright-yellow::before {
  background: #ffe501 !important;
}
.graph-cont .graph-legend .golden::before {
  background: #eaa925 !important;
}
.graph-cont .graph-legend .terracotta::before {
  background: #d67047 !important;
}
.graph-cont .graph-legend .raspberry::before {
  background: #c43c68 !important;
}
.graph-cont .graph-legend .vivid-pink::before {
  background: #b40b85 !important;
}
.graph-cont .graph-legend .cool-gray::before {
  background: #909fb7 !important;
}
@media screen and (max-width: 1450px) {
  .graph-cont .graph-legend {
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 940px) {
  .analysis-graph-wrap .graph-cont {
    gap: 16px;
  }
}
/* bar-type */
.graph-legend p.bar-type {
  gap: 0;
  position: relative;
  padding-bottom: 1.5em;
}
.graph-legend p.bar-type::before {
  width: 300px;
}
.graph-legend p.bar-type > span {
  position: absolute;
  bottom: 0;
}
.graph-legend p.bar-type > span.left {
  left: 0;
}
.graph-legend p.bar-type > span.right {
  right: 0;
  text-align: right;
}
.graph-cont .graph-legend .green-pink::before {
  background: linear-gradient(to right, #0d5d82, #82a5bb, #f6edf4, #fbacb9, #ff6c7f);
}

.graph-info {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
  margin-top: 64px;
}
.graph-info .name {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  font-size: 1.125rem;
  line-height: 1.33;
  font-weight: 400;
  color: #051c3f;
  letter-spacing: -0.07em;
}
.graph-info .name:before {
  content: "";
  width: 16px;
  height: 16px;
  flex: none;
  background: #ddd;
}
.graph-info .name.line-type:before {
  height: 6px;
}
.graph-info .name.navy::before {
  background: #0f5fa5 !important;
}
.graph-info .name.blue::before {
  background: #4253ba !important;
}
.graph-info .name.light-blue::before {
  background: #5b71ef !important;
}
.graph-info .name.cyan::before {
  background: #00d5cc !important;
}
.graph-info .name.red::before {
  background: #ff6781 !important;
}
.graph-info .name.purple::before {
  background: #930aff !important;
}
.graph-info .name.light-purple::before {
  background: #e3e6ff !important;
}
.graph-info .name.light-cyan::before {
  background: #ccece5 !important;
}
.graph-info .name.light-green::before {
  background: #eefbdd !important;
}
.graph-info .name.bright-blue::before {
  background: #0a78ff !important;
}
.graph-info .name.mint::before {
  background: #00dacd !important;
}
.graph-info .name.dote-type:before {
  height: 4px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_190___}) no-repeat center center;
  background-size: 100%;
}
.graph-info .data {
  text-align: right;
}
.graph-info .num {
  font-family: "Pretendard", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 1.625rem;
  font-weight: 400;
  line-height: 1.33;
  letter-spacing: -0.02em;
  color: #2a2c2f;
}
.graph-info .num.primary {
  font-weight: 600;
}
.container.energy-solution .box__body .graph-info .unit {
  display: inline-block;
  min-width: unset;
  margin-left: 4px;
  font-size: 1rem;
  font-weight: 400;
  line-height: 2;
  letter-spacing: -0.02em;
  color: #909fb7;
  text-align: right;
  vertical-align: middle;
}
.graph-info .arrow {
  width: 32px;
  height: 32px;
  /* background: url('../img/icon_change_arrow.svg') no-repeat center center; */
  background: url(${___CSS_LOADER_URL_REPLACEMENT_196___}) no-repeat center center;
  background-size: 100%;
}
@media screen and (max-width: 1450px) {
  .graph-info {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 32px;
  }
  .graph-info > * {
    width: 100%;
  }
  .graph-info .arrow {
    margin: 0 auto;
    transform: rotate(90deg);
  }
}
.graph-info.gap-64 {
  margin-top: 0;
}
@media screen and (max-width: 1450px) {
  .graph-info.gap-64 {
    gap: 32px !important;
  }
}
.table-wrap:has(.left) {
  display: flex;
  gap: 64px;
}
@media screen and (max-width: 1540px) {
  .table-wrap:has(.left) {
    flex-direction: column;
    gap: 32px;
  }
}
.detail-box .tit {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}
.detail-box .tit {
  margin-bottom: 8px;
}
.container.energy-solution .box__body .box-column > li > article > section .detail-box .box-list {
  height: auto;
}
.container.energy-solution .box__body .box-column > li > article > section .detail-box .box-list + .box-list {
  margin-top: 8px;
}
.container.energy-solution .box__body .box-column > li > article > section .detail-box .box-list:not(.column) > li {
  min-height: auto;
}
.container.energy-solution .box__body .box-column > li > article > section .detail-box .box-list > li.row {
  flex-direction: row;
  justify-content: space-between;
  max-width: calc(50% - 36px);
}
/* .detail-box .box-list {
  display: flex;
  gap: 8px;
}
.detail-box .box-list.column > li {
  flex-direction: column;
}
.detail-box .box-list > li {
  padding: 16px;
  background: #f7f8fa;
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
}
.detail-box .box-list > li .name {
  font-size: 0.938rem;
  line-height: 1.6;
  letter-spacing: -0.04em;
  color: #2a2c2f;
}
.detail-box .box-list > li .name:before {
  content: '';
  display: inline-block;
  width: 8px;
  height: 8px;
  margin: 6px 8px 0 0;
  background: #0a78ff;
  border-radius: 50%;
  vertical-align: text-top;
} */
.btn-pop-area {
  position: relative;
  display: inline-flex;
  gap: 2px;
}
.btn-pop-area .btn-pop {
  margin-top: 1px;
  min-width: 20px;
}
.btn-pop-area .pop-layer-box.info {
  left: 0;
  top: 22px;
}
.detail-box .box-list > li .data {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.detail-box .box-list > li .data .num {
  font-size: 1.625rem;
  font-weight: 500;
  line-height: 1.39;
  letter-spacing: -0.02em;
  color: #2a2c2f;
}
.detail-box .box-list > li .info .percent {
  font-size: 0.875rem;
  line-height: 1.43;
  color: #0a78ff;
  font-weight: 400;
  letter-spacing: -0.02em;
}
.detail-box .box-list > li .info .percent .unit {
  font-size: 0.75rem;
  color: #0a78ff;
  margin-left: 2px;
  min-width: auto;
  font-weight: 400;
  line-height: 1.54;
  letter-spacing: -0.02em;
}
.detail-box .box-list > li .info .percent.down:after {
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_185___}) no-repeat center center;
  background-size: 100%;
  vertical-align: bottom;
}
@media screen and (max-width: 1420px) {
  /* .detail-box .box-list,
  .detail-box .box-list > li {
    flex-direction: column;
  }
  .detail-box,
  .detail-box.margin {
    padding: 16px;
    margin-bottom: 0;
  } */
  .container.energy-solution .box__body .box-column > li > article > section .detail-box .box-list > li.row {
    flex-direction: column;
    max-width: 100%;
    gap: 24px;
  }
}
@media screen and (max-width: 1294px) {
  .container.energy-solution .box__body .box-column > li > article > section .detail-box .box-list:not(.column) > li {
    gap: 24px;
  }
}

/********* 에너지 솔루션 - ESS설치분석 - 팝업 *********/
.btn-basic .icon-go-large {
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_197___}) no-repeat center center;
  background-size: 100%;
}
.dot-list > li:before {
  content: "";
  width: 4px;
  height: 4px;
  background: #2a2c2f;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
}

/********* 에너지 솔루션 - PV 설치 분석 *********/
@media screen and (max-width: 1740px) {
  .container.energy-solution .box__body .box-column > li > article > section .cont > .box-list > li {
    min-width: 233px;
  }
}
@media screen and (max-width: 1400px) {
  .popup-layer.w1360 {
    width: calc(100% - 40px) !important;
  }
}
@media screen and (max-width: 940px) {
  .popup-layer.w880 {
    width: calc(100% - 40px) !important;
  }
}
@media screen and (max-width: 600px) {
  .popup-layer.w560 {
    width: calc(100% - 40px) !important;
  }
}

/********* 에너지 솔루션 - 고효율 설비 교체 분석 *********/
.container.energy-solution .box__body .box-search-card.no-focus {
  border-color: #f2f5fb;
}
.container.energy-solution .box__body .box-search-card > .bottom .menu-list {
  gap: 24px;
}
.container.energy-solution .box__body .box-search-card > .bottom .menu-list > li > a {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  width: 100%;
  font-size: 1rem;
  line-height: 1.5;
  color: #051c3f;
}
.container.energy-solution .box__body .box-search-card > .bottom .menu-list > li > a > span {
  min-width: 47px;
}
.container.energy-solution .box__body .box-search-card > .bottom .menu-list.only-view > li > a {
  cursor: default;
}
.container.energy-solution .box__body .box-search-card > .bottom .menu-list:not(.only-view) > li.on > a {
  color: var(--primary);
  font-weight: 700;
}
.container.energy-solution .box__body .box-search-card > .bottom .menu-list:not(.only-view) > li.on:after,
.container.energy-solution .box__body .box-search-card > .bottom .menu-list:not(.only-view) > li:hover:after {
  content: "";
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_198___}) no-repeat center center;
  background-size: 100%;
}
.container.energy-solution .box__body .box-search-card > .bottom .menu-list:not(.only-view) > li:hover > a {
  color: var(--primary);
}
.container.energy-solution .box__body .box-column:has(.box-guide) {
  gap: 8px;
}
.container.energy-solution .box__body .box-column > li > article > section .top:has(.tit) {
  padding-bottom: 10px;
}
.container.energy-solution .box__body .box-column > li > article > section .top.brd-0 {
  padding-bottom: 0;
}
.container.energy-solution .box__body .box-column > li > article > section .top .tit {
  font-size: 1rem;
  letter-spacing: -0.02em;
  font-weight: 500;
  line-height: 1.5;
  color: #2a2c2f;
}
.container.energy-solution .box__body .box-column > li > article > section .top .tit .txt-info {
  margin-left: 16px;
  color: #646c74;
}
.container.energy-solution .box__body .box-column > li > article > section .cont .box-info-area {
  padding: 24px;
  width: calc(100% - 48px);
  background: #f7f8fa;
}
.container.energy-solution .box__body .box-column > li > article > section .cont .box-info-area.hover:hover {
  width: calc(100% - 50px);
}

.container.energy-solution .box__body .box-column > li > article > section .cont .box-info-area.active-color.show {
  background: #e6f0ff;
}
.container.energy-solution .box__body .box-column > li > article > section .cont .box-info-area.active-color.show .tit {
  font-weight: 500;
}
.container.energy-solution .box__body .box-column > li > article > section .cont .box-info-area .select-wrap {
  gap: 64px;
}
.container.energy-solution .box__body .box-column > li > article > section .cont:has(.box-guide, .box-data-detail) {
  flex-direction: column;
  gap: 0;
}
.container.energy-solution .box__body .box-column > li > article > section .cont:has(> .right .box-info-area) {
  flex-direction: row;
  align-items: flex-end;
  gap: 24px;
  flex: 1;
}
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .cont:has(.box-guide, .box-data-detail)
  > .left,
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .cont:has(.box-guide, .box-data-detail)
  > .right,
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .cont:has(.box-guide, .box-data-detail)
  > .row
  > .left,
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .cont:has(.box-guide, .box-data-detail)
  > .row
  > .right {
  flex: 1;
  width: 100%;
}
.container.energy-solution .box__body .box-column > li > article > section .cont:has(> .row .btn-area-line) {
  flex-direction: column;
  gap: 40px;
}
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .cont:has(.box-guide, .box-data-detail)
  > .row {
  display: flex;
  gap: 24px;
  align-items: flex-end;
}
.container.energy-solution .box__body .box-column > li > article > section .cont .box-guide {
  display: none;
}
.container.energy-solution .box__body .box-column > li.on > article > section .cont .box-guide {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  background: #0a78ff;
  font-size: 0.875rem;
  line-height: 1.4;
  font-weight: 500;
  color: #fff;
  border-radius: 4px 4px 0 0;
}
.box-guide .tag {
  padding: 0 5px 0 4px;
  width: auto;
  height: 16px;
  color: #0a78ff;
  font-size: 0.688rem;
  font-weight: 600;
  letter-spacing: -0.07em;
  background: #fff;
  border-radius: 25px;
  flex: none;
}
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .cont:has(.box-guide, .box-data-detail)
  .box-info-area
  .tit,
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .cont
  .box-info-area
  .select-wrap:has(.txt)
  .tit {
  font-size: 1rem;
  line-height: 1.4;
}
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .cont:has(.box-guide, .box-data-detail)
  .box-info-area
  .num {
  line-height: 1.61;
}

.box-data-detail {
  display: none;
  gap: 24px;
}
.box-data-detail.show {
  display: flex;
  margin-top: 16px;
}
.box-data-detail > *,
.box-data-detail > .row > * {
  flex: 1;
}
.box-data-detail:has(> .row) {
  flex-direction: column;
  gap: 40px;
}
.box-data-detail > .row {
  display: flex;
  gap: 24px;
}
.box-data-detail .tbl-list.scrollH {
  height: 320px;
  margin: 0;
  padding: 0;
}
.box-data-detail .keywordlist {
  gap: 8px;
}
.box-data-detail .keywordlist.scrollH {
  height: 310px;
  margin: 0;
  padding: 0 0 10px 0;
  border-bottom: 1px solid #ddd;
}
.box-data-detail .keywordlist > li {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: none;
  padding: 5px 12px 4px;
  width: fit-content;
  min-height: 24px;
  background: var(--sky);
  border-radius: 25px;
}
.box-data-detail .keywordlist span {
  font-size: 12px;
  line-height: 1.63;
  color: var(--primary);
}
.box-data-detail .keywordlist li .btn-delete {
  display: inline;
  width: 20px;
  height: 20px;
  flex: none;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_183___}) no-repeat center center;
  background-size: 100%;
}
.box-data-detail .tbl__top .data .num {
  font-size: 1.25rem;
  line-height: 1.6;
  font-weight: 500;
  letter-spacing: -0.07em;
  color: #051c3f;
}
.container.energy-solution .cont .btn-area-line {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
  flex: 1;
  padding-top: 16px;
  border-top: 1px solid #dde2e9;
}
.container.energy-solution .cont .btn-area-line button.btn-basic {
  height: 42px;
  min-width: 376px;
}
.container.energy-solution .cont .btn-area-line button.btn-basic span {
  font-size: 1rem;
  font-weight: 700;
}
.container.energy-solution .cont .btn-area-line button.btn-basic:disabled {
  border-color: #dde2e9 !important;
  background-color: #dde2e9 !important;
}
@media screen and (max-width: 500px) {
  .container.energy-solution .cont .btn-area-line button.btn-basic {
    min-width: 100%;
  }
}
@media screen and (max-width: 1130px) {
  #wrap:not(.no-responsive) .tbl__top:has(.left, .right > .btn-basic.gray) {
    gap: 16px;
    flex-direction: column;
    align-items: normal;
  }
}
button.gray:disabled {
  background: #f0f2f4 !important;
}
.popup-type2 .popup__body:has(.locate) .flex-row .pop-right > ul li.error-txt .txt-info-small {
  color: #f55547;
}
/********* 에너지 솔루션 - 고효율 설비 교체 분석 상세 분석 *********/
.box-data-detail.show .detail-analysispop {
  display: block;
  margin-top: 0;
}
.box-data-detail .detail-analysis-wrap + .detail-analysis-wrap {
  margin-top: 40px;
}
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .cont
  .box-data-detail
  .detail-analysispop
  .box-info-area {
  gap: 16px;
  width: 100%;
  margin: -32px -32px 0;
  padding: 32px;
  background: #f7f8fa;
}
.box-data-detail .detail-analysispop {
  width: 100%;
}
.box-data-detail .detail-analysispop .line-box {
  border-color: #fff;
}
.box-data-detail .detail-analysispop .box-info-area .tit {
  font-size: 1.125rem;
  line-height: 1.33;
  color: #2a2c2f;
}
.box-data-detail .detail-analysispop .box-info-area .num {
  font-family: "Pretendard", sans-serif;
  font-style: normal;
  font-size: 1.875rem;
  line-height: 1.33;
}
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .cont:has(.box-guide, .box-data-detail)
  .box-info-area
  .num
  .unit {
  min-width: 24px;
  font-size: 1rem;
  line-height: 2;
}
.container.energy-solution .cont .box-data-detail .detail-analysispop .btn-area-line {
  margin: 0 16px;
}
.container.energy-solution .searcharea:has(.btn-add.etc + .popup-etc) {
  position: relative;
}
.tbl__top .data > .num {
  font-size: 1.625rem;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: -0.02em;
  color: #2a2c2f;
}
.tbl__top .data > .num .unit {
  display: inline-block;
  margin-left: 8px;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 2.66;
  letter-spacing: -0.02em;
  color: #909fb7;
  text-align: left;
  vertical-align: middle;
}
.tbl__top .data.error > .num,
.tbl__top .data.error + .txt-info-small {
  color: #f55547;
}
.box-data-detail .tbl__top .data button.num {
  display: block;
  border: 0;
  border-radius: 0;
}
.tbl__top button.num span {
  font-size: 1.25rem;
  line-height: 1.6;
  font-weight: 500;
  letter-spacing: -0.07em;
  color: #051c3f;
}
.tbl__top button span.unit {
  margin-left: 8px;
}
.box-data-detail .tbl__top:has(.data button.num.btn-pop) {
  position: relative;
}
.box-data-detail .tbl__top .data button.num.btn-pop + .pop-layer-box.show {
  top: 25px;
  left: calc(100% - 330px);
}
.tbl-list.right table td button {
  margin-right: 8px;
}
.m-block-1540 {
  display: none !important;
}
.m-block-1250 {
  display: none !important;
}
.m-block-1090 {
  display: none !important;
}
@media screen and (max-width: 1670px) {
  .box-data-detail .detail-analysis-wrap .line-box.row .graph-cont .graph-legend {
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 1740px) {
  .container.energy-solution .box__body .box-column > li > article > section .cont {
    flex-direction: column;
    gap: 16px;
  }
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .box-data-detail
    .detail-analysis-wrap
    .detail-box
    .box-list.column {
    flex-direction: column;
  }
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .box-data-detail
    .detail-analysis-wrap
    .detail-box
    .box-list.column
    > li {
    flex-direction: row;
  }
}
@media screen and (max-width: 1710px) {
  .box-info-area:has(.right .btn-txt + .btn-txt) {
    flex-direction: column;
  }
  .box-info-area > .right:has(.btn-txt + .btn-txt) {
    margin: 16px 0 0 0;
  }
}
@media screen and (max-width: 1710px) {
  .box-info-area:has(.right .btn-txt + .btn-txt) {
    flex-direction: column;
  }
  .box-info-area > .right:has(.btn-txt + .btn-txt) {
    margin: 16px 0 0 0;
  }
  .box-data-detail
    .detail-analysispop:has(.analysis-graph-wrap + .detail-box)
    .analysis-graph-wrap
    .graph-cont
    .graph-box
    .graph-area {
    min-width: auto;
  }
}
@media screen and (max-width: 1540px) {
  .box-info-area > .right:has(.btn-txt) {
    margin: 16px 0 0 0;
  }
  .box-info-area:has(.left + .right.flex-row.end) {
    flex-direction: row;
  }
  /* .box-info-area:has(.left + .right.flex-row.end){
    flex-direction: row-reverse;
  } */
  .box-data-detail > .row {
    flex-direction: column;
  }
  .box-data-detail > .row:has(.keywordlist.scrollH) {
    flex-direction: column-reverse;
    gap: 0;
  }
  .box-data-detail .keywordlist.scrollH {
    display: none;
  }
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .cont:has(.box-guide, .box-data-detail)
    > .row {
    flex-direction: column;
    gap: 32px;
  }
  .container.energy-solution .box__body .box-column > li > article > section .detail-box .box-list {
    flex-direction: column;
    flex-wrap: nowrap;
  }
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .box-data-detail
    .detail-box
    .box-list.column
    > li {
    flex-direction: row;
  }
  .container.energy-solution .box__body .box-column > li > article > section .detail-box .box-list > li > .box-list {
    flex-direction: row;
  }
  .box-data-detail .detail-analysis-wrap .line-box.row {
    flex-direction: column;
    gap: 24px;
  }
  .m-none-1540 {
    display: none !important;
  }
  .m-block-1540 {
    display: block !important;
  }
}
@media screen and (max-width: 1500px) {
  .m-none-1500 {
    display: none !important;
  }
}
@media screen and (max-width: 1250px) {
  .line-box .txt-info-large + .txt-info-large {
    margin-top: 16px;
  }
  .box-data-detail .detail-analysispop .line-box {
    padding: 0;
    width: 100%;
  }
  .detail-analysis-wrap.section .analysis-graph-wrap.scroll.m-mt-16 {
    margin-top: 0 !important;
  }
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .cont
    .box-data-detail
    .detail-analysispop
    .box-info-area {
    margin: 0;
    width: calc(100% - 64px);
  }
  .m-none-1250 {
    display: none !important;
  }
  .m-block-1250 {
    display: block !important;
  }
}
@media screen and (max-width: 1190px) {
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .box-data-detail
    .detail-analysis-wrap
    .detail-box
    .box-list
    > li
    > .box-list {
    flex-direction: column;
    gap: 40px;
  }
}
@media screen and (max-width: 1140px) {
  .container.energy-solution .box__body .box-column > li > article > section .cont .box-info-area .select-wrap {
    gap: 32px;
  }
  .box-info-area > .right:has(.btn-txt + .btn-txt) {
    margin: 56px 0 0 0;
  }
  .box-info-area > .right:has(.btn-txt) {
    /* 240626 flex-start삭제 */
    gap: 16px;
  }

  #wrap:not(.no-responsive) .container:not(.no-responsive) .box-data-detail .tbl__bottom {
    justify-content: flex-start;
    margin: 24px 0 0;
    flex-wrap: wrap;
  }
  #wrap:not(.no-responsive) .container:not(.no-responsive) .box-data-detail .paging {
    width: 100%;
    justify-content: center;
    margin-top: 24px;
  }
  #wrap:not(.no-responsive) .container:not(.no-responsive) .box-data-detail .paging__select {
    display: none;
  }
  #wrap:not(.no-responsive) .container:not(.no-responsive) .box-data-detail .paging ul {
    margin-left: 0;
  }
  #wrap:not(.no-responsive) .container:not(.no-responsive) .box-data-detail .paging .btn-first,
  #wrap:not(.no-responsive) .container:not(.no-responsive) .box-data-detail .paging .btn-last {
    display: none;
  }
  #wrap:not(.no-responsive) .container:not(.no-responsive) .box-data-detail .paging li > a {
    font-size: 0.875rem;
  }
  #wrap:not(.no-responsive) .container:not(.no-responsive) .box-data-detail .paging li > a.active {
    height: 100%;
    border-top: 1px solid #909fb7;
    border-bottom: 1px solid #909fb7;
  }
  .box-data-detail .paging .btn-prev {
    margin-right: 16px;
  }
  .box-data-detail .paging .btn-next {
    margin-left: 16px;
  }
}
@media screen and (max-width: 1090px) {
  .m-none-1090 {
    display: none !important;
  }
  .m-block-1090 {
    display: block !important;
  }
  .container.energy-solution .cont .btn-area-line button.btn-basic {
    min-width: 100%;
  }
}
@media screen and (max-width: 940px) {
  .container.energy-solution .box__body .box-column > li > article > section .cont .box-info-area {
    margin: 0;
  }
}
@media screen and (max-width: 699px) {
  .m-none-699 {
    display: none !important;
  }
}
@media screen and (max-width: 500px) {
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .box-data-detail
    .detail-analysis-wrap
    .detail-box
    .box-list.column
    > li {
    flex-direction: column;
  }
  .box-info-area .right.flex-row.end {
    justify-content: flex-end;
  }
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .cont
    .box-data-detail
    .detail-analysispop
    .box-info-area {
    margin: 0;
    padding: 16px;
    width: calc(100% - 32px);
  }
  .box-data-detail .detail-analysis-wrap .line-box .detail-box {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .box-data-detail .detail-analysis-wrap .line-box .txt-info-large {
    margin-top: 0;
  }
}

/********* 에너지 솔루션 - 고효율 설비 교체 분석 USER 화면 *********/
.box-column.only-view .box-data-detail {
  display: flex;
  margin-top: 16px;
}
.container.energy-solution .box__body .box-column.only-view > li > article > section .cont .box-info-area.active-color {
  background: #e6f0ff;
}
.container.energy-solution
  .box__body
  .box-column.only-view
  > li
  > article
  > section
  .cont
  .box-info-area.active-color
  .tit {
  font-weight: 500;
}

/********* 에너지 솔루션 - 전기차충전기설치분석 *********/
.radioBox .checked-box.on {
  display: block;
}
.radioBox .checked-box {
  display: none;
  margin-left: 8px;
}
.radioBox .checked-box .wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.radioBox .checked-box .wrap > li .text {
  color: #7a8596;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  word-break: break-word;
  letter-spacing: -0.02em;
}
.radioBox .checked-box .wrap .input-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.radioBox .checked-box .wrap .input-box .tit {
  flex: 1;
}
.radioBox .checked-box .wrap .input-box .input__area {
  max-width: 88px !important;
}
.box-data-detail .detail-analysis-wrap.pt96 + .detail-analysis-wrap.pt96 {
  margin-top: 96px;
}
.box-data-detail .detail-analysispop .detail-analysis-wrap.pt96 .line-box.no .box-info-area .left .tit {
  font-size: 1.125rem;
  line-height: 1.334;
}
.line-box.no {
  padding: 32px 32px 0 32px;
}
.line-box.no .box-info-area .num {
  line-height: 1.33 !important;
}
.line-box.pt48 {
  gap: 16px;
  padding: 48px 32px 0;
}
@media screen and (max-width: 1250px) {
  .box-data-detail .detail-analysispop .line-box.pt48 {
    padding: 48px 0 0;
  }
}
.line-box.pt48 .column-box {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.full-box {
  background: #f7f8fa;
}
.full-box:hover,
.ful-box:active {
  background-color: #e6f0ff;
}
.full-box .wrap {
  padding: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
@media screen and (max-width: 1100px) {
  .full-box .wrap {
    padding: 16px;
  }
}
.full-box .wrap .text {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.4;
}
.full-box .wrap .move::after {
  content: "";
  display: block;
  width: 24px;
  height: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_199___}) no-repeat center;
}
.full-box:active .wrap .move::after,
.full-box:hover .wrap .move::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_200___}) no-repeat center center;
  background-size: 24px;
}
@media screen and (max-width: 1140px) {
  .line-box.no .box-info-area > .data,
  .line-box.no .box-info-area > .data + .txt-info {
    text-align: left;
  }
}
.detail-box.info .title-small {
  font-weight: 400;
  margin-bottom: 16px;
}
.detail-box.info .box-list > li {
  gap: 8px !important;
  padding: 32px !important;
}
@media screen and (max-width: 1540px) {
  .detail-box.info .box-list > li {
    padding: 16px !important;
  }
}
.detail-box.info .box-list > li .tit {
  font-weight: 400;
  margin-bottom: 0;
}
.detail-box.info .box-list > li .data {
  align-items: flex-start;
}
.detail-box.info .box-list > li .data .num {
  line-height: 1.539 !important;
}
.detail-box.info .box-list > li .txt-info {
  font-size: 0.75rem;
  margin-left: 0;
  line-height: 1.5;
}
.detail-box.info .box-list > li .data .num .unit {
  margin-left: 8px;
  font-size: 0.75rem;
  line-height: 2.667;
}
.detail-box.info .box-list:not(.column) > li {
  min-height: 98px !important;
}
.line-box.right-circular {
  padding: 0;
  gap: 8px;
  width: auto;
}
.line-box.right-circular .analysis-graph-wrap .graph-cont .graph-box {
  margin: 0 auto;
}
.line-box.right-circular .analysis-graph-wrap .graph-cont .graph-box .graph-area {
  width: 220px;
  min-width: 220px;
}
.line-box.right-circular .analysis-graph-wrap .graph-cont {
  gap: 18px;
}
.detail-analysis-wrap .line-box.right-circular .title-small {
  margin-bottom: 8px;
}
.line-box.right-circular .txt-info-large {
  margin-top: 0;
  margin-bottom: 16px;
}
@media screen and (max-width: 1540px) {
  .box-data-detail .detail-analysis-wrap .line-box.right-circular {
    gap: 32px;
  }
}
@media screen and (max-width: 500px) {
  .box-data-detail .detail-analysis-wrap .line-box.right-circular .detail-box {
    gap: 0;
  }
}
.txt-info.pt {
  font-size: 0.75rem;
  margin-left: 0;
  margin-top: -8px;
  line-height: 1.5;
  letter-spacing: -0.2px;
}
.full-box-wrap {
  display: flex;
  flex-direction: column;
  gap: 40px;
}
@media screen and (max-width: 1250px) {
  .full-box-wrap {
    gap: 8px;
  }
}
.full-box-wrap .box-info-area {
  flex-direction: row;
  align-items: center;
  gap: 8px !important;
}
@media screen and (max-width: 1636px) {
  .full-box-wrap.btn .box-info-area {
    align-items: flex-start;
  }
}
@media screen and (max-width: 1645px) {
  .full-box-wrap.btn .box-info-area .wrap.txt {
    gap: 8px;
  }
}
@media screen and (max-width: 1585px) {
  .full-box-wrap .box-info-area {
    align-items: unset;
    flex-direction: column;
  }
  .full-box-wrap.btn .box-info-area {
    align-items: flex-start;
    flex-direction: unset;
  }
}
@media screen and (max-width: 1058px) {
  .full-box-wrap .box-info-area {
    margin: 0 !important;
    padding: 16px !important;
    width: calc(100% - 32px) !important;
  }
}
.full-box-wrap .box-info-area:hover,
.full-box-wrap .box-info-area:active {
  background-color: #e6f0ff !important;
}
.full-box-wrap .box-info-area .wrap {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
}
.full-box-wrap .box-info-area .wrap > img {
  width: 100px;
  height: 20px;
}
.full-box-wrap .box-info-area .wrap .text {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.4;
}
@media screen and (max-width: 1585px) {
  .full-box-wrap .box-info-area .wrap {
    align-items: flex-start !important;
    flex-direction: column;
  }
  .full-box-wrap .box-info-area .btn-area {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
}
.flex-right .txt-info {
  text-align: right;
  letter-spacing: -0.2px;
}
.guide-wrap .txt-info-large {
  margin-top: 8px;
}
@media screen and (max-width: 500px) {
  .box-data-detail .detail-analysis-wrap .line-box .guide-wrap .txt-info-large {
    margin-top: 8px;
  }
}

/********* 에너지 솔루션 - 전기요금변동 시뮬레이션 *********/
.container.energy-solution .box__body .box-search-card > .bottom.right > ul > li .txt,
.container.energy-solution .box__body .box-search-card > .bottom.right > ul > li .txt-info {
  text-align: right;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > li .etc {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > li .etc li {
  display: flex;
  justify-content: space-between;
  font-size: 0.813rem;
  font-weight: 400;
  line-height: 1.54;
  letter-spacing: -0.02em;
  color: #646c74;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > li .etc li span {
  flex: 1;
}
.pop-layer-box .pop-bottom:has(a) {
  padding: 10px 24px;
}
.pop-layer-box .pop-bottom > a {
  font-size: 0.813rem;
  line-height: 1.4;
  letter-spacing: -0.02em;
  text-decoration: underline;
  color: #0a78ff;
}

.container.energy-solution .box__body .btn-area:has(.btn-round) .btn-round.h32 span {
  font-size: 0.938rem;
  line-height: 21.72px;
}
.container.energy-solution .box__body .btn-area:has(.btn-round) .btn-select.h32.active span {
  font-weight: 500;
}
.container.energy-solution .box__body .box-column > li > article > section .cont .box-guide.check {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  background: #0a78ff;
  font-size: 0.875rem;
  line-height: 1.4;
  font-weight: 500;
  color: #fff;
  border-radius: 4px 4px 0 0;
}
.full-box-wrap .box-info-area.bg:hover,
.full-box-wrap .box-info-area.bg:active {
  background-color: #f7f8fa !important;
}
.full-box-wrap .box-info-area .wrap.txt {
  gap: 16px;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;
}
.full-box-wrap .box-info-area .wrap.txt.gap-8 {
  flex-direction: column;
}
.full-box-wrap .box-info-area .wrap.txt > p {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.full-box-wrap .box-info-area .wrap.txt > p > span .txt-red {
  padding-left: 4px;
}
@media screen and (max-width: 1585px) {
  .full-box-wrap .box-info-area .wrap.txt {
    flex-direction: row;
  }
}
@media screen and (max-width: 1512px) {
  .full-box-wrap .box-info-area .wrap.txt {
    gap: 8px;
  }
}
@media screen and (max-width: 1098px) {
  .full-box-wrap .box-info-area .wrap.txt,
  .full-box-wrap .box-info-area .wrap.txt > p {
    flex-direction: column;
  }
}
.graph-info.no-graph {
  margin-top: 0;
}
.graph-info.no-graph .name.line-type:before {
  display: none;
}
.graph-info.no-graph .arrow {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_196___}) no-repeat center center;
}
.graph-info .arrow.gr {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_196___}) no-repeat center center;
}
@media screen and (max-width: 1450px) {
  .graph-info.no-graph > * {
    width: auto;
  }
  .graph-info.no-graph {
    flex-direction: row;
    gap: 32px;
    align-items: center;
  }
  .graph-info.no-graph .arrow {
    margin: 0;
    width: 32px;
    transform: rotate(0deg);
  }
}
@media screen and (max-width: 1177px) {
  .graph-info.no-graph {
    flex-direction: column;
    gap: 0px;
  }
  .graph-info.no-graph .arrow {
    transform: rotate(90deg);
  }
}
@media screen and (max-width: 699px) {
  .graph-info.no-graph .name {
    justify-content: center;
  }
  .graph-info.no-graph .num {
    text-align: center;
  }
}
@media screen and (max-width: 1710px) {
  .box-data-detail
    .detail-analysispop:has(.analysis-graph-wrap + .detail-box)
    .analysis-graph-wrap.scroll
    .graph-cont
    .graph-box
    .graph-area {
    min-width: 525px;
  }
}
.box-data-detail .detail-analysispop .line-box.no .line-box.row {
  padding: 0;
  width: 100%;
}
.box-data-detail .detail-analysispop .line-box.no .line-box.row .top {
  background: none;
  border-radius: 0;
  padding: 0;
}
.box-data-detail .detail-analysispop .line-box.no .line-box.row .top .tit .txt-info {
  margin-left: 4px;
}
.box-data-detail .detail-analysispop .line-box.no .line-box.row .box-list.column {
  flex-direction: column !important;
}
.box-data-detail .detail-analysispop .line-box.no .line-box.row .left .box-list.column > li {
  min-height: 36px;
}
.box-data-detail .detail-analysispop .line-box.no .line-box.row .left .box-list.column > li.change {
  background: #e6f0ff;
}
.box-data-detail .detail-analysispop .line-box.no .line-box.row .left .box-list.column > li.change .data .num {
  color: #0a78ff;
}
.box-data-detail .detail-analysispop .line-box.no .line-box.row:has(.box-list.column) {
  gap: 8px;
}
@media screen and (max-width: 1719px) {
  .box-data-detail .detail-analysispop .line-box.no .line-box.row:has(.box-list.column) {
    flex-direction: column;
    gap: 32px;
  }
}
@media screen and (max-width: 1740px) {
  .container.energy-solution .box__body .box-column > li > article > section .line-box.row .left .box-list.column > li {
    flex-direction: row;
    gap: 0;
  }
}
@media screen and (max-width: 699px) {
  .container.energy-solution .box__body .box-column > li > article > section .line-box.row .left .box-list.column > li {
    flex-direction: column;
    gap: 24px;
  }
}
.container.energy-solution .box__body .box-column > li > article > section .box-list > li .data .num {
  line-height: 1.3;
}
.box-data-detail .tbl-list.scrollH.h296 {
  height: 296px !important;
}
@media screen and (max-width: 1160px) {
  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(1) {
    width: 43% !important;
  }
  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(2) {
    width: 58% !important;
  }
  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(3),
  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(4),
  .line-box.row.list-gp .right .tbl-list.scrollH table th:nth-child(3),
  .line-box.row.list-gp .right .tbl-list.scrollH table th:nth-child(4),
  .line-box.row.list-gp .right .tbl-list.scrollH table td:nth-child(3),
  .line-box.row.list-gp .right .tbl-list.scrollH table td:nth-child(4) {
    display: none;
  }
}
@media screen and (max-width: 940px) {
  #wrap:not(.no-responsive) .line-box.row.list-gp .right .tbl-list.scrollH table td {
    height: 40px;
  }
  #wrap:not(.no-responsive) .line-box.row.list-gp .right .tbl-list.scrollH table td,
  #wrap:not(.no-responsive) .line-box.row.list-gp .right .tbl-list.scrollH table th {
    font-size: 14px;
  }
  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(1) {
    width: 20% !important;
  }
  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(2) {
    width: 51% !important;
  }
  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(3),
  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(4),
  .line-box.row.list-gp .right .tbl-list.scrollH table th:nth-child(3),
  .line-box.row.list-gp .right .tbl-list.scrollH table th:nth-child(4),
  .line-box.row.list-gp .right .tbl-list.scrollH table td:nth-child(3),
  .line-box.row.list-gp .right .tbl-list.scrollH table td:nth-child(4) {
    display: table-cell;
  }
}
@media screen and (max-width: 900px) {
  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(1) {
    width: 43% !important;
  }
  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(2) {
    width: 57% !important;
  }
  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(3),
  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(4),
  .line-box.row.list-gp .right .tbl-list.scrollH table th:nth-child(3),
  .line-box.row.list-gp .right .tbl-list.scrollH table th:nth-child(4),
  .line-box.row.list-gp .right .tbl-list.scrollH table td:nth-child(3),
  .line-box.row.list-gp .right .tbl-list.scrollH table td:nth-child(4) {
    display: none;
  }
}
.box-info-area .select-wrap:has(.wmin-100) .tit {
  white-space: normal;
}
.box-info-area .select-wrap .select.wmin-100 .selected .selected-value {
  min-width: 100px;
}
.box-data-detail .detail-analysispop .detail-analysis-wrap.pt96 .line-box.no .box-info-area.hover .left {
  flex-direction: row;
  gap: 64px;
}
.box-data-detail .detail-analysispop .detail-analysis-wrap.pt96 .full-box-wrap.btn .box-info-area.brd-0,
.box-data-detail
  .detail-analysispop
  .detail-analysis-wrap.pt96
  .full-box-wrap.btn:has(.box-info-area.brd-0.active)
  .box-info-area.bg {
  display: none;
}
.box-data-detail .detail-analysispop .detail-analysis-wrap.pt96 .full-box-wrap.btn .box-info-area.brd-0.active,
.box-data-detail .detail-analysispop .detail-analysis-wrap.pt96 .full-box-wrap.btn:not(.active) .box-info-area.bg {
  display: flex;
}
@media screen and (max-width: 1645px) {
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .cont
    .box-data-detail
    .detail-analysispop
    .detail-analysis-wrap.pt96
    .full-box-wrap.btn
    .box-info-area {
    gap: 58px !important;
    align-items: flex-start;
  }
  .box-data-detail .detail-analysispop .detail-analysis-wrap.pt96 .line-box.no .box-info-area.hover .left {
    gap: 24px;
  }
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .cont
    .box-info-area
    .select-wrap:has(.wmin-100) {
    gap: 24px;
  }
}
@media screen and (max-width: 1566px) {
  .box-data-detail .detail-analysispop .detail-analysis-wrap.pt96 .line-box.no .box-info-area.hover .left {
    flex-direction: column;
  }
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .cont
    .box-info-area
    .select-wrap:has(.wmin-100) {
    gap: 78px;
  }
}
@media screen and (max-width: 1540px) {
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .cont
    .box-data-detail
    .detail-analysispop
    .detail-analysis-wrap.pt96
    .box-info-area:has(.left) {
    flex-direction: unset;
  }
}
@media screen and (max-width: 1327px) {
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .cont
    .box-data-detail
    .detail-analysispop
    .detail-analysis-wrap.pt96
    .full-box-wrap.btn
    .box-info-area {
    gap: 16px !important;
    align-items: unset;
  }
  .full-box-wrap.btn .box-info-area,
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .cont
    .box-data-detail
    .detail-analysispop
    .detail-analysis-wrap.pt96
    .box-info-area:has(.left) {
    flex-direction: column !important;
    gap: 16px;
    align-items: unset;
  }
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .cont
    .box-info-area
    .select-wrap:has(.wmin-100) {
    gap: 40px;
  }
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .cont
    .box-data-detail
    .detail-analysispop
    .detail-analysis-wrap.pt96
    .box-info-area:has(.right)
    .btn-area {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
}
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .cont
  .box-data-detail
  .detail-analysispop
  .detail-analysis-wrap.pt96
  .box-info-area:has(.right)
  .btn-area
  .btn-basic {
  height: 28px !important;
  min-width: 80px;
}
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .cont
  .box-data-detail
  .detail-analysispop
  .detail-analysis-wrap.pt96
  .box-info-area:has(.right)
  .btn-area
  .btn-basic
  span {
  font-size: 14px !important;
}
.box-data-detail .detail-analysispop .detail-analysis-wrap.pt96 .line-box.no .box-info-area.hover .left .tit {
  font-size: 1rem;
  line-height: 1.6;
}
@media screen and (max-width: 1140px) {
  .box-data-detail .detail-analysispop .detail-analysis-wrap.pt96 .line-box.no .box-info-area.hover .left,
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .cont
    .box-info-area
    .select-wrap:has(.wmin-100) {
    gap: 16px;
  }
}
.box-info-area.hover.brd-0:hover {
  border: 0 !important;
}
.white.tooltip-link::before {
  top: 80%;
  width: 75%;
  background: #fff;
  font-weight: 400;
  color: #2a2c2f;
}
.white.tooltip-link.w140p::before {
  width: 140%;
  left: -20%;
}
.line-box.row.list-gp .right .tbl-list tr.order td {
  background: #e6f0ff !important;
}
.line-box.row.list-gp .right .tbl-list tr.order td > p {
  color: #0a78ff;
}
.line-box.row.list-gp .right .tbl-list:not(.row) tr:hover td,
.line-box.row.list-gp .right .tbl-list:not(.row) tr:active td {
  background: #fff;
}
.line-box.row.list-gp .right .tbl-list:not(.row) tbody tr:nth-child(even):hover td,
.line-box.row.list-gp .right .tbl-list:not(.row) tbody tr:nth-child(even):active td {
  background: #f7f8fa;
}
.analysis-graph-wrap .graph-cont .graph-box.load {
  position: relative;
}
.analysis-graph-wrap .graph-cont .graph-box.load .loading {
  position: absolute;
  height: 100%;
  z-index: 10;
}
/********* 에너지 솔루션 - 설비운전패턴 최적화 분석 *********/
.detail-analysis-wrap.section {
  scroll-margin-top: 16px;
}
@media screen and (max-width: 699px) {
  .detail-analysis-wrap.section {
    scroll-margin-top: 64px;
  }
}
.container.energy-solution .box__body .box-column > li > article > section .top .btn-refresh {
  width: 24px;
  height: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_114___}) no-repeat 0 0 transparent;
  background-size: 100%;
}
.box-data-detail .detail-analysispop .detail-analysis-wrap.pt96 .line-box.no .box-info-area.hover.column .left {
  flex-direction: column;
  gap: 8px;
}
.tbl-list.blod table td {
  position: relative;
}
.tbl-select.blod tr.selected td {
  font-weight: 500;
}
.analysis-graph-wrap .graph-cont .graph-box.line {
  /* border: 1px solid #DDE2E9; */
  padding: 40px 32px;
}
.line-box.gap-8 {
  padding: 0;
  width: auto;
}
.container.energy-solution .box__body .box-column > li > article > section .top.brd-0.bg {
  background: 0;
  padding: 0;
}
.container.energy-solution .box__body .box-column > li > article > section .cont.start > .row {
  align-items: flex-start;
}
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .cont.start
  > .row
  .left
  .analysis-graph-wrap
  .graph-cont {
  gap: 16px;
}
.box-data-detail .tbl-list.scrollH.tb-h80 {
  height: 400px;
}
.tbl-list.tb-h80 table td {
  height: 72px;
  padding: 4px 16px;
}
.tbl-list.tb-h68 table td {
  height: 52px;
  padding: 8px;
}
.tbl-list.tb-h68 table th {
  height: 40px;
}
@media screen and (max-width: 940px) {
  .container.energy-solution .box__body .box-column > li > article > section.detail-analysispop .top,
  .detail-analysispop:has(.pt96) .top {
    margin: 0;
  }
}
.tbl-list table td .ellipsis.clamp2 {
  width: 90%;
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .cont
  .box-data-detail
  .detail-analysispop
  .box-info-area.no-box {
  gap: 8px;
  background: #fff;
  margin: 0;
  padding: 0;
}
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .cont:has(.box-guide, .box-data-detail)
  .box-info-area.no-box
  .tit {
  font-size: 0.938rem;
  line-height: 1.599;
}
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .cont:has(.box-guide, .box-data-detail)
  .box-info-area.no-box
  .num {
  font-size: 1.625rem;
  line-height: 1.077;
}
.container.energy-solution .box__body .box-data-detail .detail-analysispop .box-info-area.no-box .unit {
  font-size: 0.75rem;
  line-height: 1.667;
  letter-spacing: -0.4px;
}
/* .analysis-graph-wrap .graph-cont.small .graph-box {
  padding: 16px 0;
} */
.analysis-graph-wrap .graph-cont.small .graph-box .graph-area.w288 {
  min-width: auto;
  max-width: 358.66px;
  margin: 0 auto;
}

.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .cont
  .box-data-detail
  .detail-analysispop
  .box-info-area:has(.btn-area.flex) {
  align-items: flex-start;
}
.btn-area.flex {
  display: flex;
}
@media screen and (max-width: 1585px) {
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .cont
    .box-data-detail
    .detail-analysispop
    .box-info-area:has(.btn-area.flex) {
    align-items: unset;
  }
}
@media screen and (max-width: 1140px) {
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .cont
    .box-data-detail
    .detail-analysispop
    .box-info-area:has(.btn-area.flex)
    > div {
    gap: 8px;
  }
}
@media screen and (max-width: 1939px) {
  .two-box .row {
    flex-direction: column;
  }
}
@media screen and (max-width: 1140px) {
  .line-box .box-info-area.long > .data {
    text-align: left;
  }
}
@media screen and (max-width: 500px) {
  .line-box .box-info-area.long > .data {
    text-align: right;
  }
}
@media screen and (max-width: 1452px) {
  .container.energy-solution .box__body .box-column > li > article > section .detail-box.long .box-list > li.row {
    flex-direction: column;
    max-width: 100%;
    gap: 24px;
  }
}
.full-box-wrap .box-info-area.gap-16 {
  gap: 16px !important;
}
@media screen and (max-width: 1089px) {
  .full-box-wrap .box-info-area.gap-16 {
    margin: 0 !important;
    padding: 16px !important;
    width: calc(100% - 32px) !important;
  }
}
@media screen and (max-width: 1250px) {
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .cont
    .box-data-detail
    .detail-analysispop
    .box-info-area.gap-16:has(.wrap.txt) {
    margin-bottom: 32px !important;
  }
}
@media screen and (max-width: 1352px) {
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .cont
    .box-data-detail
    .detail-analysispop
    .detail-analysis-wrap.pt96
    .box-info-area.column:has(.left) {
    flex-direction: column;
  }
  .box-info-area.column .right:has(button) {
    display: flex;
    justify-content: flex-end;
  }
}
.analysis-graph-wrap .graph-cont .graph-box:has(.m-w-402) {
  width: 100%;
}
.analysis-graph-wrap .graph-cont .graph-area.m-w-402 {
  min-width: 402px;
  max-width: 544px;
  margin: 0 auto;
}
.analysis-graph-wrap .graph-cont .graph-area.m-w-402.h246 {
  padding: 17px 0;
}
@media screen and (max-width: 1555px) {
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .cont:has(.box-guide, .box-data-detail)
    > .row:has(.m-w-402) {
    flex-direction: column;
  }
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .cont:has(.box-guide, .box-data-detail)
    > .row.gap-8 {
    gap: 32px !important;
  }
  .analysis-graph-wrap .graph-cont .graph-area.m-w-402 {
    min-width: 525px;
    max-width: 544px;
  }
}
@media screen and (max-width: 940px) {
  #wrap:not(.no-responsive) .tbl-list.blod:not(.row) table td {
    height: 40px;
  }
  #wrap:not(.no-responsive) .tbl-list.blod table td {
    font-size: 14px;
  }
  #wrap:not(.no-responsive) .tbl-list.blod table th {
    font-size: 14px;
  }
  .tbl-select.blod tr.selected td:first-child {
    border-left: 2px solid #0a78ff !important;
  }
  .tbl-select.blod tr.selected td:last-child {
    border-right: 2px solid #0a78ff !important;
  }
  .tbl-select.blod:not(.tbl-border) tr.selected td {
    border-top: 2px solid #0a78ff !important;
    border-bottom: 2px solid #0a78ff !important;
  }
  #wrap:not(.no-responsive) .tbl-list.tb-h80:not(.row) table td {
    height: 70px;
  }
  #wrap:not(.no-responsive) .tbl-list.tb-h80 table td,
  #wrap:not(.no-responsive) .tbl-list.tb-h68 table td,
  #wrap:not(.no-responsive) .tbl-list.tb-h68 table th {
    font-size: 14px;
  }
}
.row.gap-8:has(.top.brd-0.bg) {
  display: flex;
  width: 100%;
}
.row.gap-8:has(.top.brd-0.bg) .flex-1 .analysis-graph-wrap .graph-cont .graph-box .graph-area {
  min-width: auto;
}
.row.gap-8:has(.top.brd-0.bg) .flex-1 .analysis-graph-wrap .graph-cont .graph-box .graph-area.m-w-391 {
  min-width: 391px;
  max-width: 552px;
  margin: 0 auto;
}
@media screen and (max-width: 1030px) {
  .row.gap-8:has(.top.brd-0.bg) .flex-1 .analysis-graph-wrap .graph-cont .graph-box .graph-area.m-w-391 {
    min-width: 252px;
  }
}
@media screen and (max-width: 1529px) {
  .row.gap-8:has(.top.brd-0.bg) {
    flex-direction: column;
    gap: 32px !important;
  }
  .row.gap-8:has(.left.flex-1.m-w-376) {
    gap: 8px !important;
  }
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .column-box.legend
    .cont
    .graph-cont
    .graph-legend {
    justify-content: center !important;
  }
}
@media screen and (max-width: 1276px) {
  .m-none-1276 {
    display: none !important;
  }
}
.popup-layer.d-sm-on {
  display: none;
}
@media screen and (max-width: 940px) {
  .popup-layer:not(.hidden).d-sm-on {
    display: block;
  }
  #wrap:not(.no-responsive) .tbl-list.tbl80:not(.row) table th {
    font-size: 16px !important;
    background: #dde2e9;
  }
  #wrap:not(.no-responsive) .tbl-list.tbl80:not(.row) table td {
    word-break: keep-all;
    height: 71.5px !important;
    font-size: 16px !important;
    padding: 4px 8px;
  }
}
.container.energy-solution .box__body .box-column > li > article > section .column-box.legend .cont {
  flex-direction: column;
}
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .column-box.legend:not(.line)
  .cont
  .graph-cont
  .graph-legend {
  gap: 15px;
  row-gap: 6px;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.container.energy-solution .box__body .box-column > li > article > section .top:has(.tit.center) {
  justify-content: center;
}
.container.energy-solution .box__body .box-column > li > article > section .column-box.line {
  border: 1px solid #dde2e9;
  padding: 16px 16px 32px;
}
.container.energy-solution .box__body .box-column > li > article > section .column-box.line .cont .row .flex-1.m-w-376 {
  min-width: 376px;
}
@media screen and (max-width: 1529px) {
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .column-box.line
    .cont
    .row
    .flex-1.m-w-376 {
    min-width: auto;
  }
}
.row.gap-8:has(.top.brd-0.bg) .flex-1 .analysis-graph-wrap .graph-cont .graph-box .graph-area.m-h-443 {
  height: 100%;
  max-height: 443px;
  min-height: 128px;
  padding: 12px 0;
  min-width: 525px;
}
@media screen and (max-width: 940px) {
  .container.energy-solution .box__body .box-column > li > article > section .cont.gap-32 {
    gap: 16px !important;
  }
}
.selected-process {
  display: none;
}
.selected-process.active {
  display: block;
}
@media screen and (max-width: 500px) {
  .box-data-detail .detail-analysis-wrap .line-box .detail-box.long {
    gap: 0px;
  }
}
@media screen and (max-width: 940px) {
  .btn-pop-area .pop-layer-box.info.lf-32 {
    left: -32px;
  }
}

/********* 에너지 솔루션 - 피크 최적화 분석 *********/
.box-data-detail .detail-analysispop .box-info-area.long > ul {
  display: flex;
  gap: 64px;
  flex-wrap: wrap;
  row-gap: 40px;
}
.box-data-detail .detail-analysispop .box-info-area.long > ul > li {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.box-data-detail .detail-analysispop .box-info-area.long > ul > li .tit,
.box-data-detail .detail-analysispop .box-info-area.long .tit {
  font-size: 1.125rem !important;
  color: #2a2c2f;
  line-height: 1.334 !important;
}
.box-data-detail .detail-analysispop .box-info-area.long > ul > li .data .num {
  line-height: 1.334 !important;
}
@media screen and (max-width: 940px) {
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .cont
    .box-data-detail
    .detail-analysispop
    .box-info-area {
    padding: 16px;
    width: calc(100% - 32px);
  }
}
.analysis-graph-wrap .graph-cont:has(.h360, .m-w-391) {
  align-items: center;
}
.graph-info.no-graph.gap {
  gap: 64px;
}
@media screen and (max-width: 1177px) {
  .graph-info.no-graph.gap {
    flex-direction: row;
    gap: 32px;
  }
  .graph-info.no-graph.gap .arrow {
    margin: 0;
    width: 32px;
    transform: rotate(0deg);
  }
}
@media screen and (max-width: 1234px) {
  .graph-info.no-graph.gap {
    flex-direction: column;
    gap: 16px;
  }
  .graph-info.no-graph.gap .arrow {
    transform: rotate(90deg) !important;
  }
}
.row.gap-8:has(.top.brd-0.bg) .flex-1 .analysis-graph-wrap .graph-cont .graph-box .graph-area.m-w-402 {
  min-width: 402px;
  max-width: 100%;
  margin: auto;
}
.tbl-list.tb-h80 table:has(p.legend) th,
.tbl-list.tb-h68 table:has(p.legend) th {
  text-align: right;
  padding: 4px 16px;
  word-break: break-word;
  overflow-wrap: break-word;
}
.tbl-list.tb-h68 table:has(p.legend) th {
  padding: 8px 8px;
}
.tbl-list.tb-h68 table:has(p.legend) th:first-child,
.tbl-list.tb-h68 table td:first-child {
  padding: 8px 8px 8px 16px;
}
.tbl-list.tb-h68 table:has(p.legend) th:last-child,
.tbl-list.tb-h68 table td:last-child {
  padding: 8px 16px 8px 8px;
}
.tbl-list.tb-h80.p-space-8 table:has(p.legend) th:first-child {
  padding: 4px 8px 4px 16px;
}
.tbl-list.tb-h80.p-space-8 table:has(p.legend) th {
  padding: 4px 8px;
}
.tbl-list.tb-h80 table:has(p.legend) th:first-child,
.tbl-list.tb-h68 table:has(p.legend) th:first-child {
  text-align: left;
}
.tbl-list.tb-h80 table:has(p.legend) th.left {
  text-align: left;
}
.tbl-list.tb-h80 table:has(p.legend) td p,
.tbl-list.tb-h68 table:has(p.legend) td p {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  color: #2a2c2f !important;
}
.tbl-list.tb-h80 table:has(p.legend) td.left p,
.tbl-list.tb-h68 table:has(p.legend) td.left p {
  justify-content: flex-start;
}
.tbl-list.tb-h80 table:has(p.legend) td:first-child p,
.tbl-list.tb-h68 table:has(p.legend) td:first-child p {
  justify-content: flex-start;
  word-break: keep-all;
  white-space: normal;
}
.tbl-list.tb-h80.p-space-8 table td {
  padding: 4px 8px;
}
.tbl-list.tb-h80.p-space-8 table td:first-child {
  padding: 4px 8px 4px 16px;
}
.tbl-list.tb-h80 table td p.legend:before,
.tbl-list.tb-h68 table td p.legend:before {
  display: block;
  content: "";
  min-width: 16px;
  width: 16px;
  height: 16px;
  background: #ddd;
  border-radius: 0;
}
.tbl-list.tb-h80 table td p.legend.red,
.tbl-list.tb-h68 table td p.legend.red:before {
  color: #2a2c2f !important;
}
.tbl-list.tb-h80 table td p.legend.navy::before,
.tbl-list.tb-h68 table td p.legend.navy:before {
  background: #0f5fa5 !important;
}
.tbl-list.tb-h80 table td p.legend.mint::before,
.tbl-list.tb-h68 table td p.legend.mint:before {
  background: #00dacd !important;
}
.tbl-list.tb-h80 table td p.legend.red::before,
.tbl-list.tb-h68 table td p.legend.red:before {
  background: #ff6781 !important;
}
.tbl-list.tb-h80 table td p.legend.lavender::before,
.tbl-list.tb-h68 table td p.legendlavender:before {
  background: #7d5cbe !important;
}
.tbl-list.tb-h80 table.wmin-1016:has(p.legend) colgroup col:first-child {
  min-width: 176px;
  max-width: 256px;
}
.tbl-list.tb-h80 table.wmin-1016:has(p.legend) colgroup col {
  min-width: 140px;
  max-width: 156px;
}
.table-wrap:has(.wmin-1016) {
  display: block;
}
.table-wrap:has(.wmin-1016) .tbl__top .right .btn-basic {
  height: 28px;
  min-width: 80px;
}
@media screen and (max-width: 940px) {
  .table-wrap:has(.wmin-1016) .tbl__top .right .btn-basic {
    height: 28px !important;
  }
  .table-wrap:has(.wmin-1016) .tbl__top .right .btn-basic span {
    font-size: 14px !important;
  }
}
@media screen and (max-width: 1100px) {
  .table-wrap:has(.wmin-1016) .tbl__top {
    align-items: normal;
    flex-wrap: nowrap;
    flex-direction: column;
    gap: 16px;
  }
}
@media screen and (max-width: 1760px) {
  .row.gap-8:has(.left, .right, .graph-legend) {
    flex-direction: column;
    gap: 64px !important;
  }
  .container.energy-solution .box__body .box-column > li > article > section .top.brd-0.bg:has(.filter-txt-wrap) {
    flex-direction: row;
  }
}
.container.energy-solution .box__body .box-column > li > article > section .top.brd-0.bg:has(.filter-txt-wrap) .left {
  display: flex;
  align-items: center;
  gap: 4px;
}
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .top.brd-0.bg
  .left
  .box-search-card-bottom
  .filter-txt-wrap
  .filter-txt {
  height: 32px;
  margin: 0;
}
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .top.brd-0.bg
  .left
  .box-search-card-bottom
  .filter-txt-wrap
  .filter-txt
  > p {
  font-size: 12px;
}
@media screen and (max-width: 1185px) {
  .container.energy-solution .box__body .box-column > li > article > section .top.brd-0.bg:has(.filter-txt-wrap) {
    flex-direction: column;
    gap: 16px;
  }
  .container.energy-solution .box__body .box-column > li > article > section .top.brd-0.bg:has(.filter-txt-wrap) .left {
    flex-direction: column;
    align-items: flex-start;
  }
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .top.brd-0.bg:has(.filter-txt-wrap)
    .right {
    display: flex;
    justify-content: flex-end;
  }
}
@media screen and (max-width: 1032px) {
  .container.energy-solution .box__body .box-column > li > article > section .top.brd-0.bg:has(.filter-txt-wrap) {
    flex-direction: column;
    gap: 16px;
  }
}
@media screen and (max-width: 1625px) {
  .container.energy-solution
    .box__body
    .box-column
    > li
    > article
    > section
    .top.brd-0.bg
    .left
    .box-search-card-bottom
    .filter-txt-wrap {
    text-align: left;
  }
}
.table-wrap:has(.right > button) {
  flex-direction: column;
  gap: 0;
}
#wrap:not(.no-responsive) .tbl__top:has(.left, .right) .right > button.btn-basic {
  height: 28px;
}
@media screen and (max-width: 940px) {
  #wrap:not(.no-responsive) .top.brd-0.bg:has(.box-search-card-bottom) .right > button.btn-basic,
  #wrap:not(.no-responsive) section:has(.target-content) .target-content .right button.btn-basic {
    height: 32px;
  }
  #wrap:not(.no-responsive) .top.brd-0.bg:has(.box-search-card-bottom) .right > button.btn-basic span,
  #wrap:not(.no-responsive) .tbl__top:has(.left, .right) .right > button.btn-basic span,
  #wrap:not(.no-responsive) section:has(.target-content) .target-content .right button.btn-basic span {
    font-size: 14px;
  }
}
@media screen and (max-width: 1100px) {
  #wrap:not(.no-responsive) .tbl__top:has(.left, .right > .btn-basic) {
    gap: 16px;
    flex-direction: column;
    align-items: normal;
  }
}
.tbl-list.tbl-border-large:has(.wmin-532) tr > .focus {
  font-weight: 500;
  font-size: 14px;
}
.tbl-list.tbl-border-large:has(.wmin-532) tbody th.focus {
  background: #e6f0ff !important;
  border-top: 2px solid #0a78ff !important;
  border-left: 2px solid #0a78ff !important;
  border-bottom: 2px solid #0a78ff !important;
}
.tbl-list.tbl-border-large:has(.wmin-532) tbody td.focus {
  background: #f8fbff !important;
  border-top: 2px solid #0a78ff !important;
  border-right: 2px solid #0a78ff !important;
  border-bottom: 2px solid #0a78ff !important;
}
.container.energy-solution .box__body .pop-layer-box.info .pop-body .list-item p:before {
  display: none;
}
.tbl-list.tbl-border-large:has(.bg-light-blue) thead tr:first-child > th:first-child,
.tbl-list.tbl-border-large:has(.bg-light-blue) tbody tr:first-child > th:first-child {
  background: #dde2e9;
}
.tbl-list.tbl-border-large:has(.bg-light-blue) tr:nth-child(n + 3):nth-child(-n + 11) th {
  background: #f7f8fa;
}
.tbl-list.tbl-border-large thead th.bg-light-blue {
  background: #e6f0ff !important;
  border-top: 2px solid #0a78ff !important;
  border-right: 2px solid #0a78ff !important;
  border-left: 2px solid #0a78ff !important;
}
.tbl-list.tbl-border-large thead th.bg-light-blue-left,
.tbl-list.tbl-border-large thead th.bg-light-blue-right {
  background: #e6f0ff !important;
}
.tbl-list.tbl-border-large thead th.bg-light-blue-left,
.tbl-list.tbl-border-large td.bg-light-blue-left {
  border-left: 2px solid #0a78ff !important;
}
.tbl-list.tbl-border-large thead th.bg-light-blue-right,
.tbl-list.tbl-border-large td.bg-light-blue-right {
  border-right: 2px solid #0a78ff !important;
}
.tbl-list.tbl-border-large tbody tr:last-child td[class^="bg-light-blue-"] {
  border-bottom: 2px solid #0a78ff !important;
}
.container.energy-solution .box__body .nodata .nodata__txt.noicon {
  width: calc(100% - 24px);
  background: #f7f8fa;
  margin: 0;
  height: 80px;
  font-size: 0.85rem;
  color: #2a2c2f;
  padding: 10px 12px;
}
.nodata .nodata__txt.noicon::before {
  display: none;
}
/* progress 관련 [s] */
.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area {
  flex-direction: column;
  align-items: normal;
  gap: 8px;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area .btn-pop-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.container.energy-solution
  .box__body
  .area__right:has(.box-column > li.on)
  .box-search-card:hover
  > .bottom
  > ul
  .progress-area
  .btn-pop-area
  .btn-txt {
  display: block;
}
.container.energy-solution
  .box__body
  > .area__right:has(.box-column > li.on)
  .box-search-card-wrap
  .bottom
  > ul
  .progress-area
  .btn-pop-area
  .btn-txt {
  display: none;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area .btn-pop-area .btn-txt.disabled {
  background: inherit !important;
}
.container.energy-solution
  .box__body
  .box-search-card
  > .bottom
  > ul
  > .progress-area
  .btn-pop-area
  .btn-txt.disabled
  > span {
  color: #dde2e9 !important;
}
.btn-txt.btn-pop.disabled:hover + .pop-layer-box.info.w296.error {
  display: flex;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area .btn-pop-area .btn-txt > span {
  font-size: 0.75rem;
  line-height: 1.667;
}
.container.energy-solution
  .box__body
  .box-search-card
  > .bottom
  > ul
  > .progress-area
  .btn-pop-area
  .btn-txt:hover
  span {
  font-weight: normal;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area > label {
  display: flex;
  gap: 16px;
  flex-direction: column;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area > label .right {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area .progressbar-wrap {
  width: 100%;
  position: relative;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area .num-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area .num-wrap > span {
  color: #909fb7;
  font-size: 10px;
  line-height: 15px;
}
.container.energy-solution
  .box__body
  > .area__right:has(.box-column > li.on)
  .box-search-card-wrap
  .bottom
  > ul
  .progress-area
  .num-wrap {
  display: none;
}
.container.energy-solution
  .box__body
  > .area__right:has(.box-column > li.on)
  .box-search-card-wrap:hover
  .bottom
  > ul
  .progress-area
  .num-wrap {
  display: flex;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area .progressbar-wrap .progressbar {
  width: 100%;
  background: linear-gradient(90deg, #f55547 0%, #ffbc0a 50.38%, #1fc95c 100%);
  box-shadow: 1px 1px 4px 0px rgba(122, 133, 150, 0.5) inset;
  height: 8px;
  border-radius: 2px;
  position: relative;
  display: flex;
  justify-content: space-between;
  gap: 13px;
}
.container.energy-solution
  .box__body
  .box-search-card
  > .bottom
  > ul
  > .progress-area
  .progressbar-wrap
  .progressbar
  .tick-marks {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.container.energy-solution
  .box__body
  .box-search-card
  > .bottom
  > ul
  > .progress-area
  .progressbar-wrap
  .progressbar
  .tick-marks
  .tick {
  width: 1px;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  position: absolute;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area .progressbar-wrap .range {
  width: inherit;
  position: absolute;
  bottom: -4px;
  left: 0px;
  border: none;
  background: none;
  appearance: none;
  z-index: 1;
  transition: 0.2s all;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area:has(input:disabled) .num-wrap {
  display: none;
}
.container.energy-solution
  .box__body
  .box-search-card
  > .bottom
  > ul
  > .progress-area
  .progressbar-wrap
  .range::-webkit-slider-thumb {
  -webkit-appearance: none;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  cursor: pointer;
  margin-top: -4px;
  z-index: 1;
  position: relative;
  background: rgba(255, 255, 255, 1);
  border: 0.5px solid rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.4);
  transition: 0.2s all;
}
.container.energy-solution
  .box__body
  .box-search-card
  > .bottom
  > ul
  > .progress-area
  .progressbar-wrap
  .range::-webkit-slider-thumb:hover {
  background: #0050b8;
}
.container.energy-solution
  .box__body
  .box-search-card
  > .bottom
  > ul
  > .progress-area
  .progressbar-wrap
  .range::-webkit-slider-thumb:active {
  background: #003876;
}
.container.energy-solution
  .box__body
  .box-search-card
  > .bottom
  > ul
  > .progress-area
  .progressbar-wrap:has(:disabled)
  .range::-webkit-slider-thumb {
  background: #909fb7;
}
.container.energy-solution
  .box__body
  .box-search-card
  > .bottom
  > ul
  > .progress-area
  .progressbar-wrap:has(.gray)
  .range::-webkit-slider-thumb {
  background: #909fb7;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area:has(.gray) .num-wrap {
  display: none;
}
.container.energy-solution
  .box__body
  .box-search-card:hover
  > .bottom
  > ul
  > .progress-area
  .progressbar-wrap
  .range::-webkit-slider-thumb {
  background: #0a78ff !important;
}
.container.energy-solution
  .box__body
  > .area__right:has(.box-column > li.on)
  .box-search-card
  > .bottom
  > ul
  > .progress-area
  .progressbar-wrap
  .range::-webkit-slider-thumb {
  background: #909fb7;
}
/* progress 관련 [e] */
.btn-pop-area .pop-layer-box.info.input {
  top: 74px;
  border: 1px solid #0a78ff;
}
.btn-pop-area .pop-layer-box.input.error {
  border: 1px solid #f55547;
}
.btn-pop-area .pop-layer-box.info.input input[type="text"],
.btn-pop-area .pop-layer-box.info.input input[type="text"]:focus {
  border: 0;
}
.btn-pop-area .pop-layer-box.info.input input[type="text"] {
  padding-right: 0;
  width: calc(100% - 24px);
}
.container.energy-solution .box__body .pop-layer-box.info.input .pop-body {
  padding: 16px 16px 24px;
}
.btn-pop-area .pop-layer-box.info.input .pop-body:has(.dot-list) li {
  padding-left: 7.25px;
  font-size: 0.625rem;
  line-height: 1.6;
  color: #2a2c2f;
  position: relative;
}
.btn-pop-area .pop-layer-box.input.error .pop-body:has(.dot-list) li.error-txt {
  color: #f55547;
}
.btn-pop-area .pop-layer-box.info.input .pop-body .dot-list li::before {
  content: "";
  position: absolute;
  top: 7.25px;
  left: 0;
  display: block;
  width: 2.5px;
  height: 2.5px;
  border-radius: 100%;
  background: #2a2c2f;
}
.btn-pop-area .pop-layer-box.input.error .pop-body:has(.dot-list) li.error-txt::before {
  background: #f55547;
}
.btn-pop-area .pop-layer-box.info.input .pop-bottom {
  padding: 0 16px 16px;
  border-top: 0;
}
.btn-pop-area .pop-layer-box.info.input .pop-bottom .btn-basic {
  height: 28px;
}
.btn-pop-area .pop-layer-box.info.input .pop-bottom .btn-basic + .btn-basic {
  margin-left: 0.5rem;
}
.btn-pop-area .pop-layer-box.info.input .pop-bottom .btn-wrap {
  display: flex;
  justify-content: flex-end;
}
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section:has(.target-content)
  .target-content
  .top
  .tit {
  font-size: 1.125rem;
  font-weight: 400;
  line-height: 1.6;
}
.tbl-list table td button.btn.move {
  width: 24px !important;
  height: 24px !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_199___}) no-repeat center;
}
.tbl-select tr.selected td button.btn.move,
.tbl-list table tr td button.btn.move:hover {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_200___}) no-repeat center center !important;
  background-size: 24px !important;
  filter: none;
}
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section:has(.target-content)
  .target-content
  > .right {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}
.box-data-detail.show
  .detail-analysispop:not(.detail-analysis-wrap.pt96.mt-16 > .box-guide.check.m-mb-16)
  .detail-analysis-wrap.pt96:first-child {
  margin-top: 16px !important;
}
@media screen and (max-width: 940px) {
  .box-data-detail .tbl-list.scrollH.h230:has(.wmin-636) {
    height: 282px !important;
  }
}

/************************************************** RE100 컨설팅 ****************************************************/
.btn-pop-area .pop-layer-box.info.w296 {
  left: calc(100% - 0px);
  top: calc(100% - 138px);
}
@media screen and (max-width: 699px) {
  .btn-pop-area .pop-layer-box.info.w296 {
    left: calc(100% - 327px);
  }
}
.container.energy-solution .box__body .pop-layer-box.info.input.w296.error .pop-body {
  padding: 8px;
}
.container.energy-solution .box__body .pop-layer-box.info.input.w296.error .txt {
  letter-spacing: -0.01em;
  color: #f55547;
  font-size: 12px;
  text-align: left;
  font-weight: 400;
  line-height: 1.334;
}
.btn-pop-area .pop-layer-box.info.w296.error {
  top: calc(100% - 38px);
}
.container.energy-solution .box__body .pop-layer-box.info.input .pop-body .type__cont {
  flex-wrap: nowrap;
  align-items: center;
}
.container.energy-solution .box__body .pop-layer-box.info.input .pop-body .type__cont li {
  height: 38px;
  min-width: 64px;
  border-radius: 30px;
  margin-bottom: 0;
}
.container.energy-solution .box__body .pop-layer-box.info.input .pop-body > ul > li:has(.input__area.wmax-120) {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.container.energy-solution .box__body .pop-layer-box.info.input .pop-body > ul > li .input__area.wmax-120 > input {
  border: 1px solid #909fb7;
  border-radius: 4px;
  padding-right: 40px;
  width: calc(100% - 52px);
}
.container.energy-solution .box__body .pop-layer-box.info.input .pop-body .tit {
  line-height: 1.5;
}
.type__cont li.active {
  background: #0a78ff;
  border-color: #0a78ff;
  color: #fff;
}
.type__cont li.active a {
  font-weight: 500;
  color: #fff;
}
.container.energy-solution .box__body .box-search-card > .bottom > ul > li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.container.energy-solution
  .box__body
  .box-search-card
  > .bottom
  > .filelist:has(.filter-txt-wrap)
  li
  .filter-txt-wrap
  .filter-no {
  font-size: 12px;
  color: #909fb7;
  line-height: 32px;
}
.container.energy-solution .box__body .box-search-card > .bottom > .filelist:has(.filter-txt-wrap) {
  margin-left: 0;
}
.container.energy-solution .box__body .box-search-card > .bottom > .filelist:has(.filter-txt-wrap) .progress-area {
  margin-bottom: 0;
  display: block;
}
.container.energy-solution
  .box__body
  .box-search-card
  > .bottom
  > .filelist:has(.filter-txt-wrap)
  li
  .filter-txt-wrap
  .filter-txt {
  height: 32px;
  background: #fff;
  margin-bottom: 8px;
}
.container.energy-solution
  .box__body
  .box-search-card
  > .bottom
  > .filelist:has(.filter-txt-wrap)
  li
  .filter-txt-wrap
  .filter-txt
  > p {
  font-size: 12px;
}
.container.energy-solution
  .box__body
  .box-search-card
  > .bottom
  > .filelist:has(.filter-txt-wrap)
  li
  .filter-txt-wrap
  .filter-txt
  .btn-delete {
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_94___}) no-repeat center center;
  background-size: 100%;
  margin-left: 0;
}
.container.energy-solution
  .box__body
  > .area__right:has(.box-column > li.on)
  .box-search-card-wrap
  .bottom
  .filelist
  .progress-area
  .btn-pop-area
  .btn-txt {
  display: block;
}
@media screen and (max-width: 1625px) {
  .container.energy-solution
    .box__body
    .box-search-card
    > .bottom
    > .filelist:has(.filter-txt-wrap)
    li
    .filter-txt-wrap {
    text-align: left;
  }
}
.left-fixed-area {
  display: flex;
  gap: 32px;
}
.left-fixed-area .body-left.line-box {
  background: inherit;
  padding: 0;
  max-width: 400px;
  min-width: 354px;
  width: auto;
  margin-top: 136px;
}
.left-fixed-area .body-left.line-box .analysis-graph-wrap .graph-cont {
  align-items: center;
  width: 290px;
  margin: 0 auto;
}
.left-fixed-area .body-right {
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: calc(100% - 432px);
}
.left-fixed-area .body-right .detail-box.info .box-list > li {
  padding: 32px 32px 30px !important;
  min-height: auto !important;
}
.left-fixed-area .body-right .detail-box.info .box-list > li:last-child .data {
  align-items: end;
}
.left-fixed-area .body-right .right-top {
  padding: 0;
  border-bottom: 0;
  height: 28px;
  margin-bottom: 16px;
}
.left-fixed-area .body-right .line-box.no.w100p .table-wrap .flex-right .txt-info.mo {
  display: none;
}
.left-fixed-area .body-right .right-top .tab__toggle {
  gap: 4px;
}
.left-fixed-area .body-right .right-top .tab__toggle li a {
  padding: 0 16px;
}
@media screen and (max-width: 1692px) {
  .container.energy-solution .box__body .box-column > li > article > section .detail-box .box-list {
    flex-direction: column;
  }
  .left-fixed-area .body-right .detail-box.info .box-list > li:last-child .data {
    align-items: start;
  }
}
@media screen and (max-width: 1384px) {
  .left-fixed-area {
    flex-direction: column;
  }
  .left-fixed-area .body-right {
    width: 100%;
  }
  .left-fixed-area .line-box .body-left.line-box {
    width: 100%;
  }
  .left-fixed-area .body-left.line-box .analysis-graph-wrap .graph-cont {
    flex-direction: row;
    gap: 42px;
    width: 100%;
    justify-content: center;
  }
  .box-data-detail .detail-analysispop:has(.left-fixed-area) .line-box {
    padding: 48px 0 32px;
    max-width: 100%;
    min-width: auto;
    margin-top: 0;
  }
}
@media screen and (max-width: 1254px) {
  .left-fixed-area .body-left.line-box .analysis-graph-wrap .graph-cont {
    flex-direction: column;
    gap: 32px;
  }
  .left-fixed-area .body-left.line-box .analysis-graph-wrap .graph-cont .graph-legend {
    flex-direction: column;
    align-items: start;
  }
}
@media screen and (max-width: 940px) {
  .left-fixed-area .body-right {
    border-top: 0;
    padding-top: 0;
  }
  .left-fixed-area .body-right .detail-box.info .box-list > li {
    padding: 16px 32px !important;
  }
  .left-fixed-area .body-left.line-box .analysis-graph-wrap .graph-cont {
    flex-direction: row;
    gap: 42px;
  }
}
@media screen and (max-width: 938px) {
  .left-fixed-area .body-left.line-box .analysis-graph-wrap .graph-cont {
    flex-direction: column;
    gap: 32px;
  }
}
@media screen and (max-width: 699px) {
  .left-fixed-area .body-right .line-box.no.w100p .table-wrap .flex-right .txt-info.pc {
    display: none;
  }
  .left-fixed-area .body-right .line-box.no.w100p .table-wrap .flex-right .txt-info.mo {
    display: block;
  }
  .left-fixed-area .body-right:has(.box-info-area.no-box .tit.line-h28-8 + .tit.line-h28-8) .detail-box.info {
    margin-top: 32px;
  }
}
.container.energy-solution
  .box__body
  .box-column
  > li
  > article
  > section
  .cont:has(.box-guide, .box-data-detail)
  .box-info-area.no-box
  .tit.line-h28-8 {
  font-size: 1.125rem;
}
.switch-wrap {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.form-toggle > input.coral-pink[type="checkbox"]:checked + label:before {
  background: #ff6781;
}
.form-toggle > input.coral-pink[type="checkbox"]:checked + label:after {
  background: #ffe7ea;
}
.form-toggle > input.purple[type="checkbox"]:checked + label:before {
  background: #7d5cbe;
}
.form-toggle > input.purple[type="checkbox"]:checked + label:after {
  background: #e9deff;
}
.graph-cont .graph-legend:has(.form-toggle) {
  justify-content: flex-start;
  gap: 40px;
}
.graph-cont .graph-legend:has(.form-toggle) p {
  align-items: flex-start;
}
.graph-cont .graph-legend:has(.form-toggle) p:before {
  margin-top: 4px;
}
.analysis-graph-wrap .graph-cont .graph-box:has(.w240.wmin-240.h240) {
  overflow: unset;
}
.form__input.wmin-86 li {
  align-items: center;
  gap: 34px;
}
.popup-type1 .popup__body .form__input.wmin-86 .tit {
  min-width: 86px;
  max-width: 86px;
  line-height: 1.141;
  color: #2a2c2f;
}
.form__input.wmin-54 {
  display: flex;
  align-items: center;
}
.form__input.wmin-54 li {
  align-items: center;
  gap: 16px;
  margin-top: 0;
}
.popup-type1 .popup__body .form__input.wmin-54 .tit {
  min-width: 54px;
  max-width: 82px;
  line-height: 1.429;
  color: #2a2c2f;
  margin-top: 0;
}
.popup-type1 .popup__body .form__input.wmin-54 > li .input__area {
  width: auto;
}
.popup__body:has(.wmin-54, .wmin-86) p.txt-info {
  font-size: 12px;
  margin-left: 0;
  margin-top: 4px;
  letter-spacing: -0.2px;
}
@media screen and (max-width: 940px) {
  .popup-type1 .popup__body .form__input.wmin-54 {
    flex-direction: row;
  }
}
@media screen and (max-width: 500px) {
  .form__input.wmin-54 li:not(.form__input .filelist li) {
    margin-top: 0;
  }
}
@media screen and (max-width: 940px) {
  .form__input.wmin-54 li {
    align-items: flex-start;
    gap: 8px;
  }
}
@media screen and (max-width: 940px) {
  .form__input.wmin-86 li {
    flex-direction: row;
  }
}
@media screen and (max-width: 500px) {
  .form__input.wmin-86 li:not(.form__input .filelist li) {
    flex-direction: row;
    align-items: center;
  }
}
@media screen and (max-width: 940px) {
  .tbl-select:not(.tbl-border) tr:has(.btn.move).selected td:first-child {
    border-left: 2px solid #0a78ff !important;
  }
  .tbl-select:not(.tbl-border) tr:has(.btn.move).selected td {
    border-top: 2px solid #0a78ff !important;
    border-bottom: 2px solid #0a78ff !important;
  }
  .tbl-select:not(.tbl-border) tr:has(.btn.move).selected td:last-child {
    border-right: 2px solid #0a78ff !important;
  }
}
.graph-info > div .graph-cont .graph-help {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
}
.graph-info > div .graph-cont .graph-help .txt,
.graph-info > div .graph-cont .graph-help > p {
  font-weight: 300;
  font-size: 14px;
  line-height: 20px;
  color: #2a2c2f;
}
.graph-info > div .graph-cont .graph-help > p {
  color: #909fb7;
}
.graph-info > div .graph-cont .graph-help .num .unit {
  font-weight: 400 !important;
  font-size: 12px !important;
  line-height: 20px !important;
}
.graph-cont:not(.analysis-graph-wrap) .graph-box:has(.w200.h200) {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.graph-info:has(.graph-help) {
  align-items: flex-start;
  gap: 64px;
}
@media screen and (max-width: 1277px) {
  .graph-info.no-graph.gap:has(.graph-help) {
    flex-direction: column;
    align-items: center;
  }
  .graph-info > div .graph-cont .graph-help {
    gap: 4px;
    flex-direction: column;
  }
  .graph-info.no-graph.gap:has(.graph-help) .arrow {
    transform: rotate(90deg) !important;
    margin-top: 0 !important;
    width: 100%;
  }
}
@media screen and (max-width: 940px) {
  .graph-info.no-graph.gap:has(.graph-help) {
    gap: 24px;
  }
}
@media screen and (max-width: 699px) {
  .graph-info.no-graph.gap:has(.graph-help) {
    gap: 16px;
  }
}
@media screen and (max-width: 1100px) {
  .graph-info.no-graph.gap:has(.graph-help) > * {
    width: auto;
  }
}
@media screen and (max-width: 699px) {
  .graph-info.no-graph.gap:has(.graph-help) .name {
    justify-content: flex-start;
  }
}
.detail-analysis-wrap.pt96.load {
  position: relative;
}
.detail-analysis-wrap.pt96.load .loading {
  height: 100%;
  position: absolute;
}
.graph-info .name:has(.txt-midlightgray) {
  flex-direction: column;
  align-items: flex-end;
  gap: 0;
}
/************************************************** 05.management_에너지솔루션 관리_전기차 충전기설치분석 ****************************************************/
.tbl-list.menulist.tbl-select.scrollX.dark table.wmin-2922 tbody tr td input[type="checkbox"] + label {
  padding-left: 0;
}
.tbl-list.menulist.tbl-select.scrollX.dark table.wmin-2922 tbody tr td input[type="checkbox"] + label:before,
.tbl-list.menulist.tbl-select.scrollX.dark table.wmin-2922 tbody tr td input[type="checkbox"]:checked + label:after {
  right: 0;
  left: auto;
}
.tbl-list.menulist.tbl-select.scrollX.dark table.wmin-2922 tbody tr.selected td {
  font-weight: 500;
}

/************************************************** 02.점검결과_report_에너지레포트_리스트 ****************************************************/
.tbl__top > .search ul.form__input li > span.wmin-64.d-sm-block {
  display: none;
}
@media screen and (max-width: 1843px) {
  .tbl__top > .search ul.form__input:has(.wmin-64) {
    gap: 16px;
  }
  .tbl__top > .search ul.form__input li > span.wmin-64.d-sm-block {
    display: block;
  }
}
@media screen and (max-width: 1343px) {
  .tbl__top:has(.wmin-64.d-sm-block) {
    margin-bottom: 34px;
  }
}
@media screen and (max-width: 940px) {
  .tbl__top > .search ul.form__input:has(.wmin-64) {
    gap: 32px;
  }
  .tbl__top:has(.wmin-64.d-sm-block) + .tbl__top {
    margin-top: 0;
  }
  .tbl__top:has(.wmin-64.d-sm-block) {
    margin-bottom: 0;
  }
  .searchterm .term__month .selected.w87 {
    width: calc(100% - 0.6rem) !important;
  }
}
@media screen and (max-width: 539px) {
  .tbl__top > .search ul.form__input .input__area:has(.btn-basic.bg-sky) > a {
    width: 100%;
  }
}
@media screen and (max-width: 500px) {
  .form__input:has(.btn-basic.bg-sky) li:not(.form__input .filelist li) {
    margin-top: 0;
  }
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist .title-line.bg-white.brd-bottom-0 {
  border-top: 2px solid #dde2e9;
  margin-top: 32px !important;
}
#wrap:not(.float-page, .no-responsive)
  .treebar.box.menutype
  .manuarea
  .manulist
  .title-line.bg-white.brd-bottom-0:first-child {
  border-top: none;
  margin-top: 0 !important;
}
#wrap:not(.float-page, .no-responsive)
  .treebar.box.menutype
  .manuarea
  .manulist
  .title-line.bg-white.brd-bottom-0.arrow {
  padding: 0;
}
#wrap:not(.float-page, .no-responsive)
  .treebar.box.menutype
  .manuarea
  .manulist:has(.title-line.bg-white.brd-bottom-0)
  li.on
  a
  p {
  font-weight: 500;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li:has(.premium) {
  position: relative;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li:has(.premium) a::before {
  content: "";
  width: 34px;
  height: 34px;
  top: 0;
  left: 0;
  position: absolute;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_201___}) no-repeat center;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li:has(.premium.disabled) {
  pointer-events: none;
}
#wrap:not(.float-page, .no-responsive)
  .treebar.box.menutype
  .manuarea
  .manulist
  li.brd-bottom-0
  > a
  > p.premium.disabled {
  background: inherit;
  border-color: inherit;
  color: #dde2e9;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
#wrap:not(.float-page, .no-responsive)
  .treebar.box.menutype
  .manuarea
  .manulist
  li.brd-bottom-0
  > a
  > p.premium.disabled
  > span {
  color: #dc7700;
  font-size: 11px;
  font-weight: 400;
  line-height: 1.5;
}
@media screen and (max-width: 940px) {
  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li:has(.premium) a::before {
    background: none;
  }
  #wrap:not(.float-page, .no-responsive)
    .treebar.box.menutype
    .manuarea
    .manulist
    li.brd-bottom-0
    > a
    > p.premium::after {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_202___}) no-repeat center;
    content: "";
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: top;
    margin-left: 8px;
  }
}
.popup-type3 .popup__body .check-area .check-list section > input[type="checkbox"] + label > span.premium::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_202___}) no-repeat center;
  content: "";
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: top;
  margin-left: 4px;
}
.badge {
  width: max-content;
  padding: 3px 12px;
  border-radius: 5px;
  background-color: #f4aa0c1a;
  color: #f4aa0c;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: -0.12px;
  white-space: nowrap;
  line-height: 16px;
  display: inline-block;
  margin-right: 8px;
}
.badge.type2 {
  width: 25px;
  padding: 3px 5px;
  border-radius: 100px;
  background-color: #dde2e9;
  color: #7a8596;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: -0.4px;
  white-space: nowrap;
  line-height: 12px;
  margin-right: 16px;
  text-align: center;
}
.badge.type2.gray {
  background-color: #909fb7;
  color: #fff;
}
@media screen and (max-width: 499px) {
  .tbl-list table th.w3p,
  .tbl-list table th.w4p.txt-center {
    width: 4% !important;
  }
  .tbl-list table th.w6p {
    width: 6% !important;
  }
  .tbl-list table th.d-sm-w60 {
    width: 60px !important;
  }
  .tbl-list table th.d-sm-w76 {
    width: 76px !important;
  }
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea li:not(.title-line.bg-white.brd-bottom-0) a {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea li.arrow a {
  flex: 1;
  padding-left: 0;
}
#wrap:not(.float-page, .no-responsive)
  .treebar.box.menutype
  .manuarea
  li:not(.title-line.bg-white.brd-bottom-0)
  a::after,
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea li.arrow a::after {
  content: "";
  display: block;
  width: 16px;
  height: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_113___}) no-repeat center center;
  background-size: 100%;
}
#wrap:not(.float-page, .no-responsive)
  .treebar.box.menutype
  .manuarea
  li:not(.title-line.bg-white.brd-bottom-0).on
  a::after,
#wrap:not(.float-page, .no-responsive)
  .treebar.box.menutype
  .manuarea
  li:hover:not(.title-line.bg-white.brd-bottom-0)
  a::after,
#wrap:not(.float-page, .no-responsive)
  .treebar.box.menutype
  .manuarea
  li:active:not(.title-line.bg-white.brd-bottom-0)
  a::after,
#wrap:not(.float-page, .no-responsive)
  .treebar.box.menutype
  .manuarea
  li:not(.title-line.bg-white.brd-bottom-0).on
  a::after,
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea li.arrow:hover a::after,
#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea li.arrow.on a::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_203___}) no-repeat center center;
}
/* 클래스 report 추가 */
#wrap:has(.report) .box__header.brd-bottom-0.gap-16 {
  justify-content: normal;
}
#wrap:has(.report) .tbl__top .left .search {
  width: 100%;
}
#wrap:has(.report) .tbl__top .btn__wrap {
  gap: 12px;
}
@media screen and (max-width: 1086px) {
  #wrap:has(.report) .tbl__top .btn__wrap .searcharea.m-none.end {
    justify-content: flex-end;
    width: 100%;
  }
}
@media screen and (max-width: 940px) {
  #wrap:has(.report) .tbl__top.gap-20 {
    gap: 32px !important;
  }
  #wrap:has(.report) .tbl__top.gap-20 .btn__wrap {
    gap: 8px !important;
  }
}
#wrap:has(.report) .centerline {
  margin: 0 4px;
}
#wrap:has(.report) .box.treebar {
  width: 304px;
  overflow-x: hidden;
  box-shadow: none;
  border-right: 4px solid #dde2e9;
  border-radius: 0;
  min-height: calc(100vh - 66px);
  height: auto;
}
#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1:has(li.active > .lnb-depth2) {
  background: #f7f8fa;
}
#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1 > li {
  position: relative;
}
#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1 > li.active {
  margin: 4px;
  width: calc(100% - 8px);
  border-bottom: 0;
  border-top: 0;
}
#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1 > li.active::after {
  content: "";
  width: calc(100% + 16px);
  height: 1px;
  background: #dde2e9;
  position: absolute;
  left: -8px;
  bottom: -8px;
}
#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1 > li.active::before:first-child {
  border-top: 0;
}
#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1 > li > p {
  font-size: 15px;
  line-height: 24px;
  font-weight: 400;
  background: #fff;
  padding: 24px 24px 24px 32px;
  width: calc(100% - 56px);
}
#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1 > li:not(.active):hover > p {
  font-weight: 500;
  color: #0978ff;
  background: #e6f0ff;
}
#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1 > li:hover > p a::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_188___}) 0 center no-repeat;
}
#wrap:has(.report) .box.treebar.pushy-menutype.navy .lnb .lnb-depth1 > li.active > p {
  background: #123069;
  border-radius: 8px;
  padding: 16px 16px 16px 24px;
  width: calc(100% - 40px);
}
#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1 > li > p a::after {
  width: 20px;
  height: 20px;
  top: 50%;
  transform: translateY(-50%) rotate(-90deg);
}
#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1 > li:has(.lnb-depth2):hover > p a::after {
  transform: translateY(-50%);
}
#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1 > li:has(.lnb-depth2).active > p {
  font-size: 15px;
  line-height: 24px;
  font-weight: 400;
  background: #f1f3f7;
  padding: 24px 24px 24px 32px;
  border-radius: 0;
  margin: -8px -8px 0 -8px;
  color: #2a2c2f;
  border-bottom: 1px solid #dde2e9;
}
#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth2 > li > a {
  border-top: 0;
  padding: 16px 16px 16px 32px;
  width: calc(100% - 48px);
  background: #f7f8fa;
  line-height: 24px;
  font-size: 15px;
}
#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth2 > li.active > a {
  background: #003875;
  border-radius: 8px;
}
#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth2 > li:not(.active):hover a {
  background: #e6f0ff;
  color: #0978ff;
}
#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth2 > li > a::after {
  display: none;
}
#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth2 > li.active > a::after,
#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth2 > li:hover > a::after {
  display: block;
  transform: rotate(-90deg);
  width: 20px;
  height: 20px;
}
#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth2 > li:not(.active):hover > a::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_188___}) 0 center no-repeat;
}
#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth2 > li:last-child {
  padding-bottom: 52px;
}
#wrap:has(.report)
  .box.treebar.pushy-menutype.report.m-none
  .lnb
  .lnb-depth1
  > li:has(.lnb-depth2).active
  > p
  a::after {
  filter: grayscale(1) brightness(0.1);
  transform: translateY(-50%);
}
#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1 > li:has(.lnb-depth2).active p span {
  color: #2a2c2f;
  font-weight: 400;
}
#wrap:has(.report) .box.treebar.menutype.m-block {
  display: none !important;
}
#wrap:has(.report) .box.treebar.menutype.m-block.active {
  display: block !important;
}
@media screen and (min-width: 941px) {
  #wrap:has(.report) .box.treebar.menutype.m-block.active {
    display: none !important;
  }
}
#wrap:has(.report) .box.treebar.menutype.m-block .manuarea .manulist li {
  height: 60px;
  border: 0;
}
#wrap:has(.report) .box.treebar.menutype.m-block .manuarea .manulist .title-line.bg-white.brd-bottom-0 {
  margin-top: 0 !important;
  border-top: 1px solid #dde2e9;
}
#wrap:has(.report) .box.treebar.menutype.m-block .manuarea li:not(.title-line.bg-white.brd-bottom-0) a::after,
#wrap:has(.report) .box.treebar.menutype.m-block .manuarea li.arrow a::after {
  width: 24px;
  height: 24px;
  background-size: 24px;
}
#wrap:has(.report.new) .tbl-select tr.selected td {
  border-top: 0;
  border-bottom: 0;
  height: 40px;
}
#wrap:has(.report.new) .tbl-select tr.selected td:first-child {
  border-left: 0;
}
#wrap:has(.report.new) .tbl-select tr.selected td:last-child {
  border-right: 0;
}
#wrap:has(.report.new) .tbl-list table tr:has(input[type="checkbox"]:checked) td {
  background: #b4d2ff;
}
#wrap:has(.report) .searchterm .term__month > span {
  margin-left: 8px;
}
@media screen and (max-width: 940px) {
  #wrap:has(.report) .box__body:has(button.btn-basic.bg-sky.w100p) {
    padding-top: 32px !important;
  }
  #wrap:has(.report) .centerline {
    margin: 0 14px;
  }
  #wrap:not(.report) .tbl__top.gap-12 {
    gap: 32px !important;
  }
  #wrap:has(.report) .form__input li {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 10px !important;
  }
  #wrap:has(.report) .searchterm .term__month {
    height: 40px;
  }
  #wrap:has(.report) .searchterm .term__month + .term__date {
    height: 40px;
  }
  #wrap:has(.report) .form__input .searchterm .term__date input[type="text"] {
    height: 100%;
  }
  #wrap:has(.report) .searchterm button.btn-basic.bg-gray.ml-8 {
    margin-left: 0px !important;
    margin-top: 8px;
    width: 100%;
  }
  #wrap:has(.report) .tbl-list:not(.row) table td {
    height: 52px;
  }
}
/************************************************** beyondX enable 모니터링  ****************************************************/
.monitor.type2 .content *,
.popup-layer.type2 * {
  font-family: "Pretendard";
}
.d-xsm-block {
  display: none !important;
}
.icon-move.white::before {
  content: "";
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_204___}) no-repeat center center;
  background-size: 100%;
}
.icon-move::before {
  content: "";
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_200___}) no-repeat center center;
  background-size: 100%;
}
.btn-basic.bg-none {
  background: transparent;
  border: 0;
}

.container.monitor.type2 .content .box .box__header .select ul {
  max-height: 436px;
  border-radius: 4px;
  box-shadow: 0px 8px 20px 0px #7a859680;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li:has(.btn-pop-area) {
  color: #145973;
  font-weight: 400;
  justify-content: space-between;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li:has(.btn-pop-area):hover {
  font-weight: 600;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab__line
  li:has(.btn-pop-area):hover
  .btn-pop-area
  .icon-arrow {
  display: flex;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li .btn-pop-area .icon-arrow {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_205___}) no-repeat center center;
  width: 25px;
  margin-top: 0;
  display: none;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab__line
  li:has(.btn-pop-area):hover
  .btn-pop-area
  .pop-layer-box {
  display: flex;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li .btn-pop-area .pop-layer-box {
  border-radius: 4px;
  left: -167px;
  width: 292px;
  top: 25px;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab__line
  li
  .btn-pop-area
  .pop-layer-box
  .pop-body
  p {
  font-size: 12px;
  font-weight: 400;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .tab-cont-wrap {
  gap: 64px;
}
.monitor.type2 .box__body .box-column > li > article .cont .tbl-list.row > table {
  border-top: 1px solid #dde2e9;
}
.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li {
  min-height: 112px;
  padding: 16px;
}
.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li span strong {
  font-size: 26px;
  font-weight: 500;
  line-height: 36px;
}
.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li span {
  line-height: 32px;
}
.monitor.type2 .box__body .box-column > li > article .cont .tbl-list.row table th {
  padding: 12px 20px 12px 24px;
  height: 23px;
  font-size: 15px;
}
.monitor.type2 .box__body .box-column > li > article .cont .tbl-list.row table th + td {
  padding: 12px 24px 12px 0;
  height: 23px;
  font-weight: 500;
  font-size: 15px !important;
}

/* sort 있는 table */
.monitor.type2 .box__body .box-column > li > article .cont .tbl-list:has(th.sort) {
  border-bottom: 1px solid #dde2e9;
  border-top: 0;
}
.monitor.type2 .box__body .box-column > li > article .cont .tbl-list table thead th.sort {
  padding: 8px 16px;
  height: 0;
  font-size: 15px;
  background: #f1f3f7;
}
.monitor.type2 .box__body .box-column > li > article .cont .tbl-list table thead th.sort span:after {
  margin-left: 12px;
}
.monitor.type2 .box__body .box-column > li > article .cont .tbl-list table:has(th.sort) td {
  padding: 12px 16px;
  height: auto !important;
}
.monitor.type2 .box__body .box-column > li > article .cont .tbl-list table td > p.ellipsis {
  font-size: 15px;
  line-height: 24px;
  width: 100%;
}
.monitor.type2 .box__body .box-column > li > article .cont .tbl-select tr.selected td {
  border-top: 1px solid #0a78ff !important;
  border-bottom: 1px solid #0a78ff !important;
  font-weight: 400;
}
.monitor.type2 .box__body .box-column > li > article .cont .tbl-select tr.selected td:first-child {
  border-left: 1px solid #0a78ff !important;
}
.monitor.type2 .box__body .box-column > li > article .cont .tbl-select tr.selected td:last-child {
  border-right: 1px solid #0a78ff !important;
}

.monitor.type2 .box__body .box-column > li > article.h-auto {
  height: auto !important;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top {
  padding: 16px 16px 0 16px;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top .tab__line {
  border-bottom: 0;
  width: auto;
  gap: 32px;
  margin-top: auto;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top .tab__line li:has(img) {
  gap: 8px;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top .tab__line > li {
  padding: 0px 8px 15px 8px;
  font-size: 18px;
  font-weight: 400;
  color: #646c74;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top .tab__line li.on {
  font-weight: 600;
  color: #0a1941;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top .tab__line h2 > img {
  width: 147.86px;
  height: 20px;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li {
  font-size: 15px;
  height: 68px;
  padding: 0 32px;
  width: calc(100% - 64px);
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li:last-child {
  border-bottom: 0;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li.on {
  font-weight: 600;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .bg-box:has(.btn-basic.bg-none) {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_206___}) no-repeat center center;
  background-size: cover;
  background-position: right;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .bg-box:has(.btn-basic.bg-none)
  .txt-info {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .bottom.top {
  flex-wrap: wrap;
  gap: 20px;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .bottom.top > .right {
  margin-left: auto;
}

/* bg-box */
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .bg-box {
  background: #f7f8fa;
  padding: 24px 32px;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .top.justify-right {
  margin-bottom: 0;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .top h3 {
  font-size: 20px;
  font-weight: 600;
}
.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap li .tit.d-sm-block {
  display: none;
}
.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap li .tit.font-18 {
  font-size: 18px;
  color: #2a2c2f;
}
.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap li .tit.font-18::before {
  display: none;
}
.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap .count-info.type2 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap .count-info.type2 span {
  font-size: 16px;
}
.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap .count-info.type2 span.icon {
  display: flex;
  align-items: center;
}
.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap .count-info.type2 span.icon::before {
  content: "";
  width: 32px;
  height: 32px;
  margin-right: 8px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_207___}) no-repeat 0 0 transparent;
  background-size: 100%;
}
.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap .count-info.type2 span:has(.btn-pop) {
  display: flex;
  align-items: center;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  ul.box-small-wrap
  .count-info.type2
  .btn-pop-area
  .pop-layer-box.info {
  border-radius: 4px;
  border: 0;
  text-align: left;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  ul.box-small-wrap
  .count-info.type2
  .btn-pop-area
  .pop-layer-box.info
  .pop-body {
  padding: 10px 24px;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  .tab-cont-wrap
  .cont
  ul.box-small-wrap
  li
  .count-info
  span
  strong {
  font-size: 30px;
  margin-right: 8px;
}
.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap .score-info.type2 {
  background: rgba(31, 201, 92, 0.1);
  border-radius: 10px;
  padding: 4px 16px 4px 6px;
  width: fit-content;
}
.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap li .score-info.type2 span.info {
  color: #1fc95c;
  font-weight: 600;
  font-size: 26px;
}
.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap li .score-info.type2 span.info:before {
  width: 40px;
  height: 40px;
  margin-right: 8px;
}
.monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap {
  gap: 48px 32px;
}
.monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap.center {
  margin: 0 auto;
  gap: 64px;
}
.monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap.center li {
  padding: 0;
  justify-content: flex-start;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  .tab-cont-wrap
  .cont
  ul.box-small-wrap.center
  li
  .count-info
  span
  strong {
  font-weight: 400;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  .tab-cont-wrap
  .cont
  ul.box-small-wrap.center
  li
  .count-info {
  gap: 5px;
}
.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap li span.txt {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #f55547;
}
.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap li span.txt.down {
  color: #0a78ff;
}
@media screen and (max-width: 1240px) {
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .bg-box {
    padding: 24px;
  }
}
@media screen and (max-width: 1490px) {
  .monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap.center {
    gap: 32px;
  }
}
@media screen and (max-width: 699px) {
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap
    .item
    .graph-info
    .info
    .percent {
    justify-content: center !important;
  }
}
@media screen and (max-width: 500px) {
  .monitor.type2
    .box__body
    .box-column
    > li
    > article
    .cont
    .tab-cont-wrap
    .cont
    ul.box-small-wrap.center
    li
    .count-info {
    gap: 0;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article
    .cont
    .tab-content.type2
    .tab-cont-wrap
    .cont:has(.graph-legend.mb-32.m-mb-0)
    ul.box-small-wrap {
    margin-top: 20px;
  }
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .bg-box {
    padding: 16px 24px;
  }
}

/* 부적합 */
.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap .score-info.type2:has(.info.caution) {
  background: #ffe7e4;
}
.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap li .score-info.type2 span.info.caution {
  color: #f55547;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  ul.box-small-wrap
  li
  .score-info.type2
  span.info.caution:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_208___}) no-repeat 0 0 transparent;
  background-size: 100%;
}
.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap .count-info.type2 > .score-info.type2 {
  background: #ffe7e4;
  border-radius: 10px;
  padding: 4px 8px;
  width: auto;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  ul.box-small-wrap
  .count-info.type2
  > .score-info.type2
  .info::before {
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_209___}) no-repeat 0 0 transparent;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  ul.box-small-wrap
  .count-info.type2
  > .score-info.type2
  .info {
  color: #f55547;
  line-height: 20px;
  font-weight: 600;
  font-size: 14px;
}
i.icon-arrow-down {
  width: 20px !important;
  height: 20px !important;
}
.icon-arrow-down:before {
  content: "";
  display: block;
  width: 20px;
  height: 20px;
}
.icon-arrow-down.red:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_210___}) no-repeat center center;
}

/* level */
.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap:has(.img-area) li {
  justify-content: flex-start;
}
.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap li .img-area {
  height: auto;
  gap: 40px;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  ul.box-small-wrap
  li:has(.score-info.type2 > .info.level)
  .img-area
  > img {
  height: 98px;
  width: auto;
  object-fit: contain;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  ul.box-small-wrap
  li:has(.score-info.type2 > .info.level)
  .txt {
  text-align: right;
  padding-right: 59px;
  font-weight: 400;
  font-size: 13px;
  line-height: 24px;
  margin-top: -8px;
}
.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap .score-info.type2:has(.info.level) {
  background: #e6f0ff;
  padding: 4px 14px 4px 6px;
  height: fit-content;
}
.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap li .score-info.type2 span.info.level {
  color: #0a78ff;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  ul.box-small-wrap
  li
  .score-info.type2
  span.info.level:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_207___}) no-repeat 0 0 transparent;
  background-size: 100%;
}
.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap li button.btn-basic.h40 {
  width: fit-content;
  padding: 0 16px;
  gap: 23px;
  margin-top: -4px;
}
.monitor
  .box__body
  .box-column
  > li
  > article
  .cont
  .tab-cont-wrap
  .cont
  ul.box-small-wrap
  li
  button.btn-basic.h40
  > span {
  color: #fff;
}
@media screen and (max-width: 500px) {
  .monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap li button.btn-basic.h40 {
    gap: 15px;
    padding: 0 16px !important;
    width: auto;
    max-width: 286px;
  }
  .monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap li .img-area {
    gap: 20px;
  }
}

/* 감액 클래스 notice */
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  ul.box-small-wrap
  .count-info.type2
  > .score-info.notice.type2
  .info::before {
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_211___}) no-repeat 0 0 transparent;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  ul.box-small-wrap
  .count-info.type2
  > .score-info.notice.type2 {
  background: #ebedf4;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  ul.box-small-wrap
  .count-info.type2
  > .score-info.notice.type2
  .info {
  color: #2e4890;
}
.icon-arrow-down.gr-blue:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_212___}) no-repeat center center;
}

/* info-area */
.monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap .cont .box-info-area {
  padding: 32px;
  gap: 16px;
  background: #f7f8fa;
}
.monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap .cont .box-info-area:has(.left) {
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  .tab-cont-wrap
  .cont
  .box-info-area
  + .box-small-wrap.pt-0.pb-0 {
  padding: 16px;
}
.monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap .cont .box-info-area .right:has(button) {
  margin-left: auto;
}
.monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap .cont .box-info-area .left .select-wrap .tit {
  font-size: 16px;
}
.monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap .cont .box-info-area .txt-info {
  line-height: 18px;
  text-align: left;
}
@media screen and (max-width: 940px) {
  .monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap .cont .box-info-area {
    margin: 0;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article
    .cont
    .tab-cont-wrap
    .cont
    .box-info-area
    + .box-small-wrap.pt-0.pb-0 {
    padding: 0;
    gap: 64px;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .box-small-wrap.pt-0.pb-0
    + .cont-border-box.m-mt-16
    .scrollX
    .graph-box {
    padding: 20px 0 0;
  }
}
@media screen and (max-width: 500px) {
  .monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap .cont .box-info-area {
    padding: 16px;
  }
}

/* content */
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .tab-cont-wrap
  .cont
  + .cont {
  margin-top: 48px;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .tbl-tit,
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .sm-tit {
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .item-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .item-wrap > div {
  flex: 1;
  width: 100%;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .cont-border-box
  .scrollX
  .graph-box {
  padding: 32px;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .cont-border-box
  .scrollX
  .graph-box:has(.graph-legend) {
  padding: 32px 32px 0 32px;
  gap: 34px;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .cont-border-box
  .scrollX
  .graph-box
  .graph-area {
  min-width: 421px;
}

.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .item-wrap .box-wrap.long {
  flex-direction: column;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .box-wrap.long
  ul.box-small-wrap {
  flex-direction: column;
  gap: 8px;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .box-wrap.long
  ul.box-small-wrap
  li {
  min-height: 56px;
  min-width: 310px;
  flex-direction: row;
  align-items: flex-start;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .box-wrap.long
  ul.box-small-wrap
  li
  .tit {
  color: #2a2c2f;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .box-wrap.long
  ul.box-small-wrap
  li
  .tit::before {
  margin-top: 0;
  background: #0a78ff;
  vertical-align: text-top;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .box-wrap.long
  ul.box-small-wrap
  li
  span
  strong {
  font-size: 26px;
  margin-right: 4px;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .box-wrap.long
  ul.box-small-wrap
  li
  .count-info:has(span.percent) {
  display: flex;
  flex-direction: column;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .box-wrap.long
  ul.box-small-wrap
  li
  .count-info
  span.percent {
  line-height: 20px;
  font-size: 14px;
  font-weight: 400;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .box-wrap.long
  ul.box-small-wrap
  li
  .count-info
  span.percent.down,
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .box-wrap.long
  ul.box-small-wrap
  li
  .count-info
  span.percent
  > span.unit {
  color: #0a78ff;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .box-wrap.long
  ul.box-small-wrap
  li
  .count-info
  span.percent
  > span.unit {
  line-height: 20px;
  margin-left: 2px;
  font-weight: 400;
  font-size: 12px;
}

/* item-wrap > item */
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .item-wrap:has(.item) {
  align-items: flex-start;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .item-wrap .item {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .item-wrap .item .img-item {
  position: relative;
  padding: 32px 50px;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .item
  .graph-info {
  gap: 24px;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .item
  .graph-info:has(.info > .percent)
  > div {
  margin-bottom: auto;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .item
  .graph-info
  .num {
  line-height: 24px;
  color: #051c3f;
  font-size: 30px;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .item
  .graph-info
  .num
  > .unit {
  color: #909fb7;
  margin-left: 4px;
  font-size: 16px;
  line-height: 32px;
  font-weight: 400;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .item
  .graph-info
  .info
  .percent {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 2px;
  font-size: 14px;
  font-weight: 400;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .item
  .graph-info
  .info
  .percent.down {
  color: #0a78ff;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .item
  .graph-info
  .info
  .percent.down.icon:after {
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_213___}) no-repeat center center;
  background-size: 100%;
  vertical-align: bottom;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .item
  .graph-info
  .info
  .percent
  .unit {
  font-size: 12px;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .item
  ul.box-small-wrap {
  gap: 64px;
  justify-content: center;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .item
  .img-item
  .label {
  position: absolute;
  top: 14.54%;
  right: 50px;
  gap: 8px;
  padding: 8px 16px;
  background: #2a2c2f;
  border-radius: 4px;
  display: flex;
  box-shadow: 0px 4px 12px rgba(122, 133, 150, 0.5);
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .item
  .img-item
  .label.peak {
  top: 23.27%;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .item
  .img-item
  .label
  > span {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.43;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .item-wrap
  .item
  .img-item
  .label
  > span.num {
  min-width: 52px;
  text-align: right;
}
@media screen and (max-width: 1649px) {
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap.gap-40:has(.item) {
    flex-direction: column;
    gap: 32px !important;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap.gap-40
    .cont-border-box
    .scrollX
    .graph-box.pt-0.pb-0 {
    padding: 22px;
  }
}
@media screen and (max-width: 1560px) {
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .item-wrap.d-w-1560 {
    flex-direction: column;
    gap: 64px;
  }
}
@media screen and (max-width: 1177px) {
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap
    .item
    .graph-info {
    gap: 8px;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap
    .item
    ul.box-small-wrap {
    gap: 32px;
    flex-wrap: nowrap;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap
    .item
    .img-item {
    padding: 32px 24px;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap
    .item
    .img-item
    .label {
    right: 24px;
  }
}
@media screen and (max-width: 1110px) {
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap
    .item
    .img-item
    .label {
    display: none;
  }
}
@media screen and (max-width: 940px) {
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .item-wrap.d-w-1560 {
    padding: 0 !important;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap.gap-40:has(.item) {
    gap: 20px !important;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap.gap-40
    .cont-border-box
    .scrollX
    .graph-box.pt-0.pb-0 {
    padding: 0;
  }
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .item-wrap .item {
    gap: 20px;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap
    .item
    ul.box-small-wrap {
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 699px) {
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap
    .item
    .graph-info.no-graph
    .name {
    justify-content: flex-start;
  }
}
@media screen and (max-width: 499px) {
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .item-wrap.d-w-1560 {
    gap: 40px;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap
    .item
    ul.box-small-wrap {
    justify-content: flex-start;
    gap: 40px;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap
    .item
    .img-item {
    padding: 20px;
  }
}
/* 스카다 없을때 반응형 */
@media screen and (max-width: 1770px) {
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .row.gap-40:has(.img-area.h-auto) {
    flex-direction: row;
    gap: 40px !important;
  }
}
@media screen and (max-width: 1649px) {
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap.gap-40:has(.img-area.h-auto) {
    flex-direction: row;
    gap: 40px !important;
  }
}
@media screen and (max-width: 1241px) {
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .cont-border-box
    .graph-cont.p-32.pb-0:has(.img-area) {
    padding: 32px 0 0 32px !important;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .cont-border-box
    .graph-cont.p-32.pb-0:has(.img-area)
    .img-area {
    height: 304px !important;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .cont-border-box
    .graph-cont.p-32.pb-0:has(.img-area)
    .img-area
    > img {
    min-width: fit-content;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap.gap-40:has(.img-area.h-auto) {
    flex-direction: column;
    gap: 32px !important;
  }
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .row.gap-40:has(.img-area.h-auto) {
    flex-direction: column;
    gap: 48px !important;
  }
}
@media screen and (max-width: 940px) {
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .cont-border-box
    .graph-cont.p-32.pb-0:has(.img-area) {
    padding: 20px 0 0 0 !important;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap.gap-40:has(.img-area.h-auto) {
    gap: 20px !important;
  }
}

/* column-box */
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .tab-cont-wrap
  .selected-process {
  display: none;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .tab-cont-wrap
  .selected-process.active {
  display: flex;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .column-box.line {
  border: 1px solid #dde2e9;
  padding: 16px 16px 0;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .column-box .top {
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 16px;
}
.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .column-box .top.center {
  justify-content: center;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .column-box
  .graph-cont
  .graph-legend {
  justify-content: flex-start;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .graph-cont
  .graph-legend
  p {
  font-weight: 400;
}
@media screen and (min-width: 1920px) {
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .column-box
    .flex-1.m-w-600 {
    min-width: 616px;
  }
}
@media screen and (max-width: 1770px) {
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .row.gap-40 {
    gap: 16px !important;
  }
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .column-box .top.center {
    justify-content: flex-start;
  }
}
@media screen and (max-width: 1590px) {
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .column-box
    .graph-cont
    .graph-legend {
    justify-content: center;
  }
}
@media screen and (max-width: 1133px) {
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .column-box.line {
    padding: 16px 0 16px 16px;
  }
}
@media screen and (max-width: 940px) {
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .column-box.line {
    padding: 0;
    padding-top: 12px;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .column-box
    .top.center
    > div {
    width: 100%;
    text-align: center;
  }
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab .column-box .cont.gap-32,
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab .column-box .cont .row.gap-40 {
    gap: 20px !important;
  }
}
@media screen and (max-width: 499px) {
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .graph-cont
    .graph-legend.m-mt-0 {
    margin-top: 0 !important;
  }
  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .row.gap-16 {
    gap: 8px !important;
  }
}

.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .cont-border-box {
  border: none;
  padding: 0;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .cont-border-box
  .graph-cont {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .cont-border-box
  .scrollX
  .graph-box {
  padding: 32px 32px 0 32px;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article.boxtype-tab
  > .cont
  .tab-content.type2
  .cont-border-box
  .graph-cont
  .graph-legend
  p {
  font-weight: 400;
}
.tbl-list.type6.tbl-border table th {
  background: #f1f3f7;
  border: 1px solid #dde2e9 !important;
}
.tbl-list.type6.tbl-border table tbody th {
  background: #f7f8fa;
}
.tbl-list.type6.tbl-border table:has(tbody > tr > th) tr:first-child th:first-child {
  border-bottom: 0 !important;
}
.tbl-list.type6.tbl-border td {
  border: 1px solid #dde2e9 !important;
  border-top: 0 !important;
  font-size: 15px;
}
.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list.type6 table th {
  padding: 10px 12px;
  line-height: 20px;
  font-size: 15px;
}
.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box:not(.scrollX) .tbl-list.type6 table th {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list.type6 table td {
  padding: 8px 16px;
}
.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list.type6.small table tbody th,
.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list.type6.small table td {
  padding: 10px 12px;
}
.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list.type6.w-min-149 table td {
  min-width: 149px;
}
.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list.type6.w-min-600 table {
  min-width: 600px;
}

/* item-box (ul) */
.monitor.type2 .box__body .box-column > li > article .cont .tab-content.type2 ul.item-box {
  display: flex;
  gap: 16px;
  width: 100%;
}
.monitor.type2 .box__body .box-column > li > article .cont .tab-content.type2 ul.item-box > li {
  background: #f7f8fa;
  padding: 32px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  text-align: center;
}
.monitor.type2 .box__body .box-column > li > article .cont .tab-content.type2 ul.item-box > li > p {
  font-size: 15px;
  line-height: 20px;
}
.monitor.type2 .box__body .box-column > li > article .cont .tab-content.type2 ul.item-box > li > .tit {
  font-weight: 700;
}

/* banner-area */
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  .tab-content.type2
  .tab-cont-wrap
  > div
  > .cont
  .banner-area {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  height: 142px;
  overflow: hidden;
  width: auto;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  .tab-content.type2
  .tab-cont-wrap
  > div
  > .cont
  .banner-area::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_214___}) no-repeat center center;
  background-size: cover;
  background-position: 100% 0;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  .tab-content.type2
  .tab-cont-wrap
  > div
  > .cont
  .banner-area
  > .item {
  padding: 43px 32px;
  z-index: 1;
  width: calc(100% - 64px);
  height: 100%;
  display: flex;
  gap: 16px;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  .tab-content.type2
  .tab-cont-wrap
  > div
  > .cont
  .banner-area
  > .item
  .txt-area {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  .tab-content.type2
  .tab-cont-wrap
  > div
  > .cont
  .banner-area
  > .item
  .txt-area
  > p {
  font-size: 20px;
  font-weight: 700;
  line-height: 32px;
  white-space: nowrap;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  .tab-content.type2
  .tab-cont-wrap
  > div
  > .cont
  .banner-area
  > .item
  .txt-area
  .txt-sm {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  .tab-content.type2
  .tab-cont-wrap
  > div
  > .cont
  .banner-area
  > .item
  .txt-area
  > p
  > span {
  color: #5221cb;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  .tab-content.type2
  .tab-cont-wrap
  > div
  > .cont
  .banner-area
  > .item
  .btn-basic.black {
  background: #2a2c2f;
  border-color: #2a2c2f;
  margin-top: auto;
}
@media screen and (max-width: 1320px) {
  .monitor.type2
    .box__body
    .box-column
    > li
    > article
    .cont
    .tab-content.type2
    .tab-cont-wrap
    > div
    > .cont
    .banner-area
    > .item {
    flex-direction: column;
    padding: 24px;
    width: calc(100% - 48px);
    gap: 0;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article
    .cont
    .tab-content.type2
    .tab-cont-wrap
    > div
    > .cont
    .banner-area
    > .item
    .txt-area {
    gap: 4px;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article
    .cont
    .tab-content.type2
    .tab-cont-wrap
    > div
    > .cont
    .banner-area
    > .item
    .txt-area
    > p {
    font-size: 16px;
    line-height: 22px;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article
    .cont
    .tab-content.type2
    .tab-cont-wrap
    > div
    > .cont
    .banner-area
    > .item
    .btn-basic.black {
    width: fit-content;
  }
}
@media screen and (max-width: 965px) {
  .monitor.type2
    .box__body
    .box-column
    > li
    > article
    .cont
    .tab-content.type2
    .tab-cont-wrap
    > div
    > .cont
    .banner-area
    > .item {
    padding: 24px 16px;
    width: calc(100% - 32px);
  }
}

/* linear 버튼 */
.btn-basic.linear {
  border: 1.5px solid transparent;
  border-radius: 4px;
  background:
    linear-gradient(#0a1e5a, #0a1e5a) padding-box,
    linear-gradient(90deg, #61c9e1, #83c8c2, #92c8b4) border-box;
}
.btn-basic.linear:hover,
.btn-basic.linear:active {
  background:
    linear-gradient(#3c899c, #3c899c) padding-box,
    linear-gradient(90deg, #61c9e1, #83c8c2, #92c8b4) border-box;
}

/* banner-area */
.monitor.type2 .box__body .box-column > li > article.h-auto:has(.banner-area) {
  position: relative;
  overflow: hidden;
  padding: 40px 40px 34px 60px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_215___}) no-repeat 0 0;
  width: auto;
  background-size: cover;
}
.monitor.type2 .box__body .box-column > li > article > .banner-area {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 60px;
}
.monitor.type2 .box__body .box-column > li > article > .banner-area > .item {
  display: flex;
  flex-direction: column;
  gap: 38px;
}
.monitor.type2 .box__body .box-column > li > article > .banner-area > .item > button {
  width: fit-content;
}
.monitor.type2 .box__body .box-column > li > article > .banner-area > .item > .txt-area {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 80px;
}
.monitor.type2 .box__body .box-column > li > article > .banner-area > .item > .txt-area > div {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
}
.monitor.type2 .box__body .box-column > li > article > .banner-area > .item > .txt-area > .left {
  font-size: 24px;
  font-weight: 700;
  line-height: 29px;
}
.monitor.type2 .box__body .box-column > li > article > .banner-area > .item > .txt-area > .left > p {
  margin-top: 8px;
}
.monitor.type2 .box__body .box-column > li > article > .banner-area > .item > .txt-area > .left > p > img {
  width: 219px;
  height: 29px;
  object-fit: cover;
  margin-right: 6px;
}
@media screen and (max-width: 940px) {
  .monitor.type2 .box__body .box-column > li > article.h-auto:has(.banner-area) {
    padding: 40px;
  }
}
@media screen and (max-width: 521px) {
  .monitor.type2 .box__body .box-column > li > article.h-auto:has(.banner-area) {
    padding: 20px 20px 32px 20px;
  }
  .monitor.type2 .box__body .box-column > li > article > .banner-area > .item > .txt-area {
    gap: 10px;
  }
  .monitor.type2 .box__body .box-column > li > article > .banner-area > .item {
    gap: 0;
    justify-content: space-between;
    height: 224px;
  }
  .monitor.type2 .box__body .box-column > li > article > .banner-area > .item > .txt-area > .left {
    font-size: 16px;
  }
  .monitor.type2 .box__body .box-column > li > article > .banner-area > .item > .txt-area > .left > p > img {
    width: 146px;
    height: 20px;
  }
}

/* 팝업 */
.popup-layer.type2 .popup__body .tbl-list table {
  border-top: 1px solid #dde2e9;
  border-left: 1px solid #dde2e9;
  border-right: 1px solid #dde2e9;
}
.popup-layer.type2 .popup__body .tbl-list table th {
  padding: 10px 8px;
}
.popup-layer.type2 .popup__body .tbl-list table thead th {
  background: #dfe3ea;
  border-top: 1px solid #dde2e9;
}
.popup-layer.type2 .popup__body .tbl-list table thead th + th {
  border-left: 1px solid #dde2e9;
}
.popup-layer.type2 .popup__body .tbl-list table td {
  height: 27.5px;
  border-top: 1px solid #dde2e9;
}
.popup-layer.type2 .popup__body .tbl-list table td + td {
  border-left: 1px solid #dde2e9;
}
.popup-layer.type2 .popup__body .tbl-list table td > span {
  line-height: 20px;
}
.popup-layer.type2 .popup__body .tbl-list table td .unit {
  margin-left: 6px;
  color: #95a1c6;
}
.popup-layer.type2 .popup__body .tbl-list tbody th {
  border-right: 1px solid #dde2e9;
  border-top: 1px solid #dde2e9;
}
.popup-layer.type2 .popup__body .tbl-list .d-xsm-block {
  display: none !important;
}

/* 팝업 내 양옆 border 없는 테이블 */
.popup-layer.type2 .popup__body .tbl-list.brd-none table {
  border-left: 0;
  border-right: 0;
}
.popup-layer.type2 .popup__body .tbl-list.brd-none table thead th {
  background: #edf0f6;
  border-top: 1px solid #d5d8e5;
}
.popup-layer.type2 .popup__body .tbl-list.brd-none table tbody th {
  background: #f9faff;
  border-right: 1px solid #d5d8e5;
  border-top: 1px solid #d5d8e5;
  border-bottom: 1px solid #d5d8e5 !important;
}
.popup-layer.type2 .popup__body .tbl-list.brd-none table thead th + th {
  border-left: 1px solid #d5d8e5;
}
.popup-layer.type2 .popup__body .tbl-list.brd-none table td {
  border-top: 1px solid #d5d8e5;
  border-bottom: 1px solid #d5d8e5 !important;
  padding: 10px 2px;
  height: 19px;
  word-break: break-all;
}
.popup-layer.type2 .popup__body .tbl-list.brd-none table td + td {
  border-left: 1px solid #d5d8e5;
}

/* d-sm-none */
.popup-layer.type2 .popup__body .tbl-list .d-sm-none {
  display: table-cell !important;
}
.popup-layer.type2 .popup__body .tbl-list colgroup.d-sm-none {
  display: table-column-group !important;
}
.popup-layer.type2 .popup__body .tbl-list .d-sm-block {
  display: none !important;
}
@media screen and (max-width: 499px) {
  .popup-layer.type2 .popup__body .tbl-list .d-sm-block {
    display: table-cell !important;
  }
  .popup-layer.type2 .popup__body .tbl-list colgroup.d-sm-block {
    display: table-column-group !important;
  }
  .popup-layer.type2 .popup__body .tbl-list .d-sm-none,
  .popup-layer.type2 .popup__body .tbl-list colgroup.d-sm-none {
    display: none !important;
  }
}

/* d-w620-none */
.d-w620-none {
  display: flex !important;
}
.d-w620-flex {
  display: none !important;
}
@media screen and (max-width: 620px) {
  .d-w620-none {
    display: none !important;
  }
  .d-w620-flex {
    display: flex !important;
  }
}

/* popup__sticky */
.popup__sticky {
  display: flex;
  align-items: center;
  width: auto;
  padding: 16px 40px;
  background: #fff;
}
@media screen and (max-width: 940px) {
  .popup__sticky {
    padding: 20px;
  }
}

/* 팝업 내 highlight */
.popup-layer.type2 .popup__body .tbl-list table th.highlight-blue,
.popup-layer.type2 .popup__body .tbl-list table td.highlight-blue {
  background: #e2ebfb !important;
  color: #0028b6;
  font-weight: 500;
}
.popup-layer.type2 .popup__body .tbl-list table th.highlight-blue-bottom,
.popup-layer.type2 .popup__body .tbl-list table td.highlight-blue-bottom {
  border-bottom: 1px solid #577eff !important;
}
.popup-layer.type2 .popup__body .tbl-list table tbody th.highlight-blue.highlight-blue-bottom {
  border-left: 1px solid #577eff !important;
}
.popup-layer.type2
  .popup__body
  .tbl-list
  table
  tbody
  th.highlight-blue.highlight-blue-bottom
  + td.highlight-blue.highlight-blue-bottom {
  border-right: 1px solid #577eff !important;
}

/* 팝업 내 수용률 계산식 */
.popup-layer.type2 .popup__body:has(.formula-container) {
  padding: 32px 40px 64px;
  width: calc(100% - 80px);
}
.popup-layer.type2 .popup__body .formula-container {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  color: #2a2c2f;
  padding: 20px 0;
}
.popup-layer.type2 .popup__body .formula-container .side-text {
  line-height: 17px;
}
.popup-layer.type2 .popup__body .formula-container .side-text.left {
  margin-right: 8.38px;
}
.popup-layer.type2 .popup__body .formula-container .side-text.right {
  margin-left: 12px;
}
.popup-layer.type2 .popup__body .formula-container .formula-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.popup-layer.type2 .popup__body .formula-container .formula-wrapper .formula div {
  min-width: 152px;
  line-height: 17px;
}
.popup-layer.type2 .popup__body .formula-container .formula-wrapper .formula .numerator {
  border-bottom: 1px solid rgba(42, 44, 47, 0.8);
  padding-bottom: 8px;
}
.popup-layer.type2 .popup__body .formula-container .formula-wrapper .formula .denominator {
  padding-top: 8px;
}
@media screen and (max-width: 620px) {
  .popup-layer.type2 .popup__body:has(.formula-container) {
    padding: 32px 20px 178px;
    width: calc(100% - 40px);
  }
  .popup-layer.type2 .popup__body .formula-container + .tbl-list {
    margin-top: 20px;
  }
}

/* 팝업 body 높이 444px */
.popup-layer.type2 .popup__body.h380:has(.complete-txt) {
  display: flex;
  align-items: center;
}
.popup-layer.type2 .popup__body .form__input li {
  align-items: center;
}
.popup-layer.type2 .popup__body.h380 .complete-txt .joinok.font-14::before {
  margin: 0 auto 14px;
}
.popup-layer.type2 input[type="text"] {
  font-size: 14px !important;
}
.popup-layer.type2 input[type="text"]:read-only {
  background: #f0f2f4 !important;
  border: 1px solid #f0f2f4 !important;
}
.input__area:has(.btn-eye) input[type="password"] {
  padding: 0 28px 0 12px;
  width: calc(100% - 2.625rem);
  position: relative;
}
.input__area .btn-eye {
  border: 0;
  position: absolute;
  right: 8px;
  top: 6px;
}
i.icon-eye,
i.icon-eye-off {
  width: 20px;
  height: 20px;
}
i.icon-eye::before,
i.icon-eye-off::before {
  content: "";
  display: block;
  background-size: 20px;
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_216___});
}
i.icon-eye-off::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_217___});
}
@media screen and (max-width: 940px) {
  .popup-layer.type2 .popup__body.h380 {
    height: 490px !important;
    padding: 24px 20px;
  }
  .popup-layer.type2 .popup__body .form__input {
    gap: 16px;
  }
  .popup-layer.type2 .popup__body .form__input input[type="checkbox"] + label {
    width: calc(100% - 29px) !important;
    margin-bottom: 0;
    margin-top: 14px;
  }
}
@media screen and (max-width: 500px) {
  .popup-layer.type2 .popup__body .form__input li:not(.form__input .filelist li) {
    margin-top: 0;
  }
}

/* 반응형 */
@media screen and (max-width: 1655px) {
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap:has(.flex-inline.center) {
    gap: 32px;
  }
}
@media screen and (max-width: 1601px) {
  .monitor.type2 .box__body .box-column > li > article .flex-row.center.gap-16 {
    flex-direction: column !important;
  }
}
@media screen and (max-width: 1260px) {
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top .right .txt-info {
    display: none;
  }
}
@media screen and (max-width: 1200px) {
  .monitor.type2 .box__body .box-column > li > article .top:has(.tab__line.group) {
    flex-direction: row;
  }
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top:has(.tab__line.group) .right {
    width: auto;
  }
  .monitor.type2 .box__body .box-column > li > article .cont .tab-content.type2 ul.item-box {
    flex-direction: column;
    width: 100%;
  }
  .monitor.type2 .box__body .box-column > li > article .cont .tab-content.type2 ul.item-box > li {
    width: auto;
  }
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li {
    padding: 0 16px;
    width: calc(100% - 32px);
  }
}
@media screen and (max-width: 1127px) {
  .monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap.item-w1127 li:has(.score-info.type2) {
    width: calc(100% - 32px);
  }
}
@media screen and (max-width: 1091px) {
  .monitor.type2 .box__body .box-column > li {
    width: calc(100% - 32px);
  }
  .monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li {
    min-height: auto;
  }
}
@media screen and (max-width: 1000px) {
  .monitor.type2 .box__body .box-column > li > article .top:has(.tab__line.group) {
    flex-direction: column;
    margin-bottom: 0;
  }
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top .tab__line li.on {
    border-bottom: 0;
    padding: 0 !important;
  }
  .monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li {
    min-height: auto;
  }
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top .right .txt-info {
    display: block;
  }
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top:has(.tab__line.group) .right {
    margin-left: auto;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
  }
}
@media screen and (max-width: 940px) {
  #wrap:not(.no-responsive)
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    button.btn-basic
    span,
  #wrap:not(.no-responsive)
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .tbl__top
    button.btn-basic
    span,
  #wrap:not(.no-responsive) button.btn-basic.font-14 span {
    font-size: 14px !important;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab__line
    li:has(.btn-pop-area)
    .btn-pop-area {
    display: none;
  }
  .monitor.type2 .box__body .box-column > li > article h2 {
    font-size: 16px;
  }
  .monitor.type2 .box__body .box-column > li > article .txt-info.ml-16 {
    margin-left: 0 !important;
    margin-top: 20px !important;
  }
  .monitor.type2 .box__body .box-column > li > article .top {
    margin-bottom: 10px;
  }
  .monitor.type2 .box__body .box-column > li > article .cont .tbl-list.row table th {
    padding: 14px 8px 14px 24px;
    vertical-align: middle !important;
  }
  .monitor.type2 .box__body .box-column > li > article .cont .tbl-list.row table th + td {
    padding: 14px 20px 14px 0px;
    font-weight: 400;
  }
  .monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap > div.p-16 {
    padding: 0 !important;
    gap: 20px;
  }
  .monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap > div > div.p-16.gap-16 {
    gap: 20px !important;
  }
  .monitor.type2 .box__body .box-column > li > article .cont .tab-content.type2 .tab-cont-wrap .cont ul.box-small-wrap {
    gap: 40px;
  }
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .tbl-tit,
  .monitor.type2
    .box__body
    .box-column
    > li
    > article
    .cont
    .tab-cont-wrap
    .cont
    .tab-content.type2
    ul.box-small-wrap.border-0
    li,
  .monitor.type2 .box__body .tab-content.type2 .cont-border-box {
    padding: 0;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap:has(.flex-inline.center) {
    padding: 0 !important;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap:has(.box-wrap.long) {
    flex-direction: column;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap
    .box-wrap.long
    ul.box-small-wrap
    li {
    min-width: auto;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article
    .cont
    .tab-content.type2
    .cont-border-box
    .tbl-list.type6
    table
    th,
  .monitor.type2
    .box__body
    .box-column
    > li
    > article
    .cont
    .tab-content.type2
    .cont-border-box
    .tbl-list.type6
    table
    td {
    font-size: 15px !important;
  }
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .cont-border-box.mt-16 {
    margin-top: 0 !important;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .cont-border-box
    .graph-cont {
    gap: 20px;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .cont-border-box
    .scrollX
    .graph-box {
    padding: 20px 20px 0 20px;
  }
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .bottom.top {
    margin-top: 0 !important;
  }
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .top.justify-right {
    padding: 0;
    padding-top: 20px;
  }
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .tab-cont-wrap {
    gap: 60px;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .tab-cont-wrap
    .cont
    + .cont {
    margin-top: 44px;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article
    .cont
    .tab-content.type2
    .tab-cont-wrap
    .cont
    ul.box-small-wrap:not(.box-list)
    li {
    padding: 0;
  }
}
@media screen and (max-width: 508px) {
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top:has(.tab__line.group) .right .btn-basic.h32 {
    margin-left: auto;
  }
}
@media screen and (max-width: 499px) {
  .monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li {
    min-height: 86px;
  }
  .monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li .count-info {
    margin-top: auto;
  }
  .monitor.type2 .box__body .box-column > li > article .cont .tbl-list.row table th {
    padding: 14px 8px 14px 16px;
  }
  .monitor.type2 .box__body .box-column > li > article .cont .tbl-list.row table th + td {
    padding: 14px 8px 14px 0px;
  }
  .monitor.type2 .box__body .box-column > li > article .txt-info.ml-16,
  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .bottom.top {
    margin-top: 0px !important;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap
    .cont-border-box
    .scrollX
    .graph-box {
    padding: 32px 16px;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .cont-border-box
    .graph-cont
    .graph-legend.m-mb-0 {
    margin-bottom: 0 !important;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap
    .box-wrap.long
    ul.box-small-wrap
    li {
    flex-direction: column;
    min-height: 104px;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap:has(.box-wrap.long) {
    gap: 60px !important;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap
    .box-wrap.long {
    gap: 8px !important;
  }
  .monitor.type2
    .box__body
    .box-column
    > li
    > article.boxtype-tab
    > .cont
    .tab-content.type2
    .item-wrap
    .box-wrap.long
    ul.box-small-wrap
    li
    .count-info {
    margin-left: auto;
  }
  .monitor.type2 .box__body .box-column > li > article .cont .tab-content.type2 .tab-cont-wrap .cont .txt-info.mt-16 {
    margin-top: 0 !important;
  }
}
@media screen and (max-width: 390px) {
  .d-xsm-none {
    display: none !important;
  }
  .d-xsm-block {
    display: block !important;
  }
  .popup-layer.type2 .popup__body .tbl-list .d-xsm-none {
    display: none !important;
  }
  .popup-layer.type2 .popup__body .tbl-list .d-xsm-block {
    display: block !important;
  }
  .popup-layer.type2 .popup__body p.txt,
  .popup-layer.type2 .popup__body p.txt-info,
  .popup-layer.type2 .popup__body .tbl-list table th,
  .popup-layer.type2 .popup__body .tbl-list table td {
    font-size: 16px;
    line-height: 22px;
  }
}
@media screen and (max-width: 360px) {
  .graph-legend p.bar-type::before {
    width: 240px;
  }
}

/* tab-group */
.tab-group {
  display: none !important;
}
.tab-group.show {
  display: flex !important;
}

/* highlight-blue */
.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list table th.highlight-blue,
.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list table td.highlight-blue {
  background: #e6f0ff !important;
  color: #0a78ff;
  font-weight: 500;
  font-size: 16px;
  border: 1px solid #0a78ff !important;
}
.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list table th.brd-right-0 {
  border-right: 0 !important;
}
.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list table th.highlight-blue-bottom,
.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list table td.highlight-blue-bottom {
  border-bottom: 1px solid #0a78ff !important;
}
.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list table .highlight-blue.brd-left-0 {
  border-left: 0 !important;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  .cont-border-box
  .tbl-list
  table
  .highlight-blue.brd-right-0 {
  border-right: 0 !important;
}
.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list table .highlight-blue.brd-left-1 {
  border-left: 1px solid #0a78ff !important;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  .cont-border-box
  .tbl-list
  table
  th.highlight-blue.brd-right-gray,
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  .cont-border-box
  .tbl-list
  table
  td.highlight-blue.brd-right-gray {
  border-right: 1px solid #dde2e9 !important;
}
.monitor.type2
  .box__body
  .box-column
  > li
  > article
  .cont
  .cont-border-box
  .tbl-list
  table
  td.highlight-blue
  span.unit {
  color: #003378;
  font-weight: 500;
  font-size: 16px;
}
/************************************************** beyondX enable 업그레이드 개발 - 제안서 추가  ****************************************************/
#wrap:has(.report) .box.treebar:has(.tooltip-link) {
  overflow-x: unset;
}
.box.treebar.pushy-menutype:has(.tooltip-link) .lnb {
  overflow-y: unset;
}
.box.treebar.pushy-menutype:has(.btn-pop-area) .lnb .lnb-depth1 .btn-pop-area .pop-layer-box.info {
  left: 20px;
  top: 40px;
}
.tooltip-link.wmax-292::before {
  max-width: 292px;
  width: 100%;
  letter-spacing: 0;
  pointer-events: none;
}
.tooltip-link.wmax-282::before {
  right: auto;
  left: -192px;
  text-align: left;
  width: 282px;
  max-width: 282px;
  letter-spacing: 0;
  pointer-events: none;
  top: 36px;
}

i.icon-check-circle.blue {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_218___});
}
.float-page.type2 * {
  font-family: "Pretendard", sans-serif;
}
.float-page.type2 header .header__title {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_219___}) no-repeat 0 center;
  background-size: contain;
  height: 26px;
  padding-left: 184px;
  margin-left: 24px;
}
.float-page.type2 .content {
  width: 100%;
  padding: 0;
}
.float-page.type2 .box__header {
  padding: 16px 25px 16px 32px;
  flex-wrap: wrap;
  gap: 8px;
}
.float-page.type2 header .header__title span {
  font-weight: 700;
  padding-left: 12px;
  line-height: 30px;
}
.float-page.type2 .box__body {
  padding: 0;
  height: calc(100% - 65px);
}
.float-page.type2 .box__body .body-right {
  flex: unset;
  width: 493px;
}
.float-page.type2 .box__body .body-right .right-top {
  padding: 16px 24px;
  height: auto;
}
.float-page.type2 .box__body .body-right .right-top > p {
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
}
.float-page.type2 .box__body .body-right .right-bottom {
  padding: 16px 32px;
  height: calc(100vh - 216px);
  overflow: auto;
}
.float-page.type2 .txt-info {
  font-size: 15px;
  line-height: 1.4;
  margin-left: 0;
}
.float-page.type2 .asterisk {
  position: relative;
  display: block;
  width: 100%;
  padding-left: 14px;
}
.float-page.type2 .asterisk::before {
  content: "※";
  position: absolute;
  left: 0;
  color: #0028b6;
}
.float-page.type2 .box__body .box-search-card-wrap {
  width: auto;
}
.float-page.type2 .box__body .box-search-card {
  background: #fff;
  border: 1px solid #dde2e9;
  border-radius: 6px;
}
.float-page.type2 .box__body .box-search-card.on,
.float-page.type2 .box__body .box-search-card:hover {
  border-color: #0a78ff;
}
.float-page.type2 .box__body .box-search-card > .top .tit {
  line-height: 1.5;
  font-weight: 600;
}
.float-page.type2 .box__body .box-search-card > .bottom {
  padding: 0 16px 16px;
}
.float-page.type2 .box__body .box-search-card .input__area.wmax-180 input[type="text"] {
  text-align: right;
}
.float-page.type2 .box__body .box-search-card .input__area.wmax-180:has(.num-inputin.font-13) input[type="text"] {
  padding-right: 88px;
  width: calc(100% - 102px);
}
.float-page.type2 .box__body .box-search-card .input__area.wmax-180:has(.num-inputin.font-13) .num-inputin.font-13 {
  top: 9px;
  line-height: 24px;
}
.float-page.type2 .box__body .box-search-card > .bottom > ul:has(.input__area > textarea) {
  gap: 16px;
}
.float-page.type2 .box__body .box-search-card > .bottom > ul:has(.input__area > textarea) > li {
  gap: 8px;
  flex-direction: column;
  align-items: flex-start;
}
.float-page.type2 .box__body .box-search-card > .bottom > ul:has(.input__area > textarea) > li .input__area {
  max-width: none;
}
.float-page.type2 .box__body .box-search-card > .bottom > ul:has(.input__area > textarea) > li .input__area > textarea {
  width: calc(100% - 25px);
  padding: 8px 12.5px;
  height: 102px;
}
.float-page.type2 .body-left:has(.left, .right) {
  flex-direction: row;
  gap: 0;
}
.float-page.type2 .body-left {
  padding: 0;
  gap: 0;
  flex-direction: row;
  height: calc(100vh - 132px);
}
.float-page.type2 .body-left .tab__line {
  width: 272px;
  height: calc(100vh - 132px);
  overflow: auto;
  align-items: flex-start;
  flex-direction: column;
  background: inherit;
  gap: 0;
  border-bottom: 0;
}
.float-page.type2 .body-left .tab__line li {
  width: 100%;
  justify-content: flex-start;
  padding: 16px 16px 16px 32px;
  border-bottom: 1px solid #dde2e9;
  max-width: 214px;
}
.float-page.type2 .body-left .tab__line li:last-child {
  border-bottom: 0;
}
.float-page.type2 .body-left .tab__line li.on {
  border-bottom: 1px solid #dde2e9;
  background: inherit;
  font-weight: 700;
  color: #0a78ff;
}
.float-page.type2 .body-left .tab__line li.white.tooltip-link::before {
  width: fit-content;
  pointer-events: none;
}
.float-page.type2 .body-left .tab__line li > span {
  font-size: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 20px;
}
.float-page.type2 .body-left .tab-content-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc((100vh - 4.16665vw) - 132px);
  width: calc((100% - 7.08333vw) - 272px);
  gap: 52px;
  margin: auto;
}
.float-page.type2 .body-left .tab-content,
.float-page.type2 .body-left .tab-content .tab-cont-wrap,
.float-page.type2 .body-left .tab-content .tab-cont-wrap .proposal-wrap {
  width: 100%;
  height: auto;
}
.float-page.type2 .body-left .tab-content .tab-cont-wrap .proposal-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1.458331vw;
}
.float-page.type2 .body-left .tab-content .tab-cont-wrap .proposal-wrap .proposal {
  width: min(100%, calc((100vh - 7.08333vw - 132px) * (4 / 3)));
  height: auto;
  aspect-ratio: 4 / 3.11;
  /* max-width: 1000px;
  max-height: 750px;*/
  overflow: hidden;
  border: 1px solid #909fb7;
  background: #fff;
  box-sizing: border-box;
}
.float-page.type2 .body-left .tab-content .tab-cont-wrap .proposal-wrap .proposal > img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.float-page.type2 .body-left .tab-content-group .paging {
  width: 100%;
  height: 28px;
}
.float-page.type2 .body-left .tab-content-group .paging ul {
  margin-left: 0;
}
.float-page.type2 .body-left .tab-content-group .paging ul > li.count {
  border: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.float-page.type2 .body-left .tab-content-group .paging ul > li.count > span {
  font-size: 14px;
  color: #2a2c2f;
}
.float-page.type2 .body-left .tab-content-group .paging ul li:not(.count) {
  border-radius: 0 4px 4px 0;
  width: 28px;
  height: 28px;
}
@media screen and (max-width: 940px) {
  .float-page.type2 .container.energy-solution .box__header > * {
    margin: 0 !important;
    width: auto !important;
  }
  .float-page.type2 header {
    padding: unset;
    width: 100%;
  }
  .float-page.type2 .container {
    margin-top: 58px;
    height: calc(100vh - 66px);
  }
  .float-page.type2 .box__body .body-right {
    border: none;
    padding-top: 0;
  }
  #wrap:not(.no-responsive) button.btn-basic {
    height: 32px;
  }
  .float-page.type2 .body-left .tab__line li {
    flex: unset;
    padding: 16px 16px 16px 32px !important;
  }
}
/* radio */
.float-page.type2 .container.energy-solution .box__body .box-search-card > .bottom > ul > li:has(.radioBox) {
  gap: 20px;
}
.float-page.type2 .container.energy-solution .box__body .box-search-card > .bottom > ul > li:has(.radioBox) .tit {
  max-width: 128px;
}
.float-page.type2
  .container.energy-solution
  .box__body
  .box-search-card
  > .bottom
  > ul
  > li:has(.radioBox)
  .input__area {
  max-width: none;
}
.float-page.type2
  .container.energy-solution
  .box__body
  .box-search-card
  > .bottom
  > ul
  > li:has(.radioBox)
  .input__area
  .radioBox {
  display: flex;
  align-items: center;
}
.float-page.type2
  .container.energy-solution
  .box__body
  .box-search-card
  > .bottom
  > ul
  > li:has(.radioBox)
  .input__area
  .radioBox
  label {
  margin-left: 0;
  align-items: center;
  letter-spacing: -0.09em;
}
.float-page.type2
  .container.energy-solution
  .box__body
  .box-search-card
  > .bottom
  > ul
  > li:has(.radioBox)
  .input__area
  .radioBox
  label
  + label {
  margin-left: 16px;
}
.float-page.type2
  .container.energy-solution
  .box__body
  .box-search-card
  > .bottom
  > ul
  > li:has(.radioBox)
  .input__area
  .radioBox
  input[type="radio"] {
  margin: 8px;
}
/* state 표시 있을 시 */
.float-page.type2 .body-left .tab-content .tab-cont-wrap .proposal-wrap:has(.state) {
  flex-direction: column;
  margin-top: 0;
}
.float-page.type2 .body-left .tab-content .tab-cont-wrap .proposal-wrap:has(.state) .state {
  color: #7a8596;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 0.625vw;
  width: min(100%, calc((100vh - 7.08333vw - 132px) * (4 / 3)));
  text-align: right;
}
.float-page.type2
  .container.energy-solution
  .box__body
  .box-search-card
  > .bottom
  > ul
  > li:has(.input-error)
  .num-inputin {
  display: none;
}

/********* 에너지 솔루션 - 인버터(고압 MVD) 경제성 분석 *********
 * 좌우 폭과 결과 패널(지표 카드 · 표) 규칙. 입력 폼 쪽은 아래 「피그마 화면 개편」 블록에 있다.
 * 이 화면에만 적용되도록 .inverter-input / .inverter-result 로 스코프를 좁힌다.
 ***************************************************************/
/* 좌측 Step 레일 폭에 맞춘 값 — 고효율 설비 교체 분석과 같은 296px 레일이다 (2026-08-31) */
.container.energy-solution .box__body > .area__right .scroll-area.inverter-result:has(.box-column) {
  width: calc(100% - 328px);
}
@media screen and (max-width: 940px) {
  .container.energy-solution .box__body .box-search-card-wrap.inverter-input,
  .container.energy-solution .box__body > .area__right .scroll-area.inverter-result:has(.box-column) {
    width: 100%;
  }
}
/* 결과 패널 본문 — 기본 .cont 는 좌/우 2단(display:flex)이라 지표 그리드와 표가 가로로 붙는다.
 * 인버터 화면은 지표 → CASE 표 → 대수운전 표 순으로 세로로 쌓는다. */
.container.energy-solution
  .box__body
  .inverter-result
  .box-column
  > li
  > article
  > section
  .cont {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* 결과 지표 6종 — 화면 ver 1.3 의 .grid3 / .metric 을 그대로 옮긴다.
 * 프로젝트 기본 .box-list 는 값이 오른쪽 정렬이고 카드 높이를 균등하게 늘려서 쓰지 않는다. */
.container.energy-solution .box__body .inverter-result .inv-grid3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
  width: 100%;
}
.container.energy-solution .box__body .inverter-result .inv-grid3 + .inv-grid3 {
  margin-top: 6px;
}
@media screen and (max-width: 1200px) {
  .container.energy-solution .box__body .inverter-result .inv-grid3 {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (max-width: 780px) {
  .container.energy-solution .box__body .inverter-result .inv-grid3 {
    grid-template-columns: 1fr;
  }
}
/* 피그마 : 회색 패널 · 라벨 좌상단 · 값과 보조문구는 우측 정렬, 값 색은 모두 먹색 */
/* 보조문구가 없는 카드(총 가동 시간)도 값이 같은 높이에 오도록 block 으로 쌓는다.
 * flex + space-between 이면 보조문구가 없는 카드만 값이 아래로 내려간다. */
.container.energy-solution .box__body .inverter-result .inv-metric {
  display: block;
  min-height: 92px;
  padding: 11px 20px 4px;
  border: 0;
  border-radius: 2px;
  background: #f7f8fa;
}
.container.energy-solution .box__body .inverter-result .inv-metric .k {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 14px;
  font-size: 0.8125rem;
  line-height: 1.4;
  color: #3d4753;
}
.container.energy-solution .box__body .inverter-result .inv-metric .k:before {
  content: "";
  flex: 0 0 auto;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #1763d6;
}
.container.energy-solution .box__body .inverter-result .inv-metric .v {
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: -0.3px;
  line-height: 1.3;
  color: #1a2330;
  text-align: right;
}
.container.energy-solution .box__body .inverter-result .inv-metric .v small {
  margin-left: 3px;
  font-size: 0.6875rem;
  font-weight: 400;
  color: #97a3b4;
}
/* 값 왼쪽의 회색 보조표기 (「2 CASE 합계」) */
.container.energy-solution .box__body .inverter-result .inv-metric .v > em {
  margin-right: 10px;
  font-style: normal;
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0;
  color: #97a3b4;
}
.container.energy-solution .box__body .inverter-result .inv-metric .v.green,
.container.energy-solution .box__body .inverter-result .inv-metric.savings .v,
.container.energy-solution .box__body .inverter-result .inv-metric.benefit .v {
  color: #1a2330;
}
.container.energy-solution .box__body .inverter-result .inv-metric .sub {
  margin-top: 2px;
  font-size: 0.75rem;
  line-height: 1.4;
  color: #1763d6;
  text-align: right;
}

/* ---- 표 (HTML .breakdown) ----
 * 프로젝트 기본 tbl-list 는 파란 bg-sky 헤더 + 전체 격자선이라 HTML 과 인상이 다르다.
 * 마크업은 그대로 두고 인버터 결과 영역에서만 .breakdown 형태로 덮어쓴다.
 * 헤더 옅은 배경 · 가로선만 · 첫 칸 왼쪽 정렬 · 나머지 오른쪽 정렬. */
/* 피그마 : 표를 감싸는 상자도, 회색 제목바도 없다. 제목은 흰 배경 위 글씨 한 줄 */
.container.energy-solution .box__body .inverter-result .table-wrap {
  margin-top: 20px;
  border: 0;
  border-radius: 0;
  overflow: visible;
}
.container.energy-solution .box__body .inverter-result .table-wrap .tbl__top {
  margin: 0 0 8px;
  padding: 0;
  background: none;
  border: 0;
}
.container.energy-solution .box__body .inverter-result .table-wrap .tbl__top .title-small {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: normal;
  color: #1a2330;
}
.container.energy-solution .box__body .inverter-result .tbl-list {
  border: 0;
}
.container.energy-solution .box__body .inverter-result .tbl-list table {
  width: 100%;
  border-collapse: collapse;
  /* 기본 tbl-list 는 table-layout:fixed 라 모든 열이 같은 폭이 된다.
     HTML .breakdown 은 auto 라 라벨 열이 내용만큼만 차지한다. */
  table-layout: auto;
  border-bottom: 0;
  font-size: 0.75rem;
}
/* 기본 tbl-list 는 th 배경 #dde2e9 · td 높이 40px · 자간 -0.9px 가 걸려 있다.
 * HTML .breakdown 과 맞추려면 이 넷을 모두 되돌려야 한다. */
.container.energy-solution .box__body .inverter-result .tbl-list th,
.container.energy-solution .box__body .inverter-result .tbl-list td {
  height: 33px;
  min-height: 0;
  padding: 0 14px;
  border: 0;
  border-bottom: 1px solid #f1f3f6;
  background: #fff;
  text-align: center;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.4;
  letter-spacing: normal;
  color: #1a2330;
}
/* 헤더 — 옅은 배경에 회색 글씨 */
.container.energy-solution .box__body .inverter-result .tbl-list thead th {
  background: #fbfcfe;
  color: #6b7686;
  font-weight: 600;
}
/* 데이터 행 — HTML .caseRow td 는 600. 첫 칸도 같은 굵기이고 배경색을 따로 주지 않는다
 * (마크업에서 bg-sky 를 제거했으므로 여기서 덮어쓸 필요가 없다) */
.container.energy-solution .box__body .inverter-result .tbl-list tbody th,
.container.energy-solution .box__body .inverter-result .tbl-list tbody td {
  background: #fff;
  font-weight: 400;
}
.container.energy-solution .box__body .inverter-result .tbl-list th:first-child,
.container.energy-solution .box__body .inverter-result .tbl-list td:first-child {
  text-align: left;
}
/* 경제성 검토 표만 첫 칸 제외 가운데 정렬 — HTML .ecoTable */
.container.energy-solution .box__body .inverter-result .tbl-list.eco-table th:not(:first-child),
.container.energy-solution .box__body .inverter-result .tbl-list.eco-table td:not(:first-child) {
  text-align: center;
}
.container.energy-solution .box__body .inverter-result .tbl-list tbody tr:last-child th,
.container.energy-solution .box__body .inverter-result .tbl-list tbody tr:last-child td {
  border-bottom: 0;
}
/* 합계행 — HTML .sumRow */
.container.energy-solution .box__body .inverter-result .tbl-list tr.sum-row th,
.container.energy-solution .box__body .inverter-result .tbl-list tr.sum-row td {
  background: #eef5ff;
  font-weight: 800;
  color: #0f4aa8;
}

/* 추천 지정 별표 — 추천이 아닌 건에만 회색 ☆ 로 노출된다(추천 건은 배지로 표시).
 * 제목 바로 옆에 놓기 위해 .top .left 를 가로 정렬로 잡는다. */
.container.energy-solution .box__body .inverter-result .box-column > li > article > section .top .left {
  display: flex;
  align-items: center;
}
.container.energy-solution .box__body .inverter-result .btn-report-star {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  margin-left: 6px;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  line-height: 1;
  vertical-align: middle;
}
.container.energy-solution .box__body .inverter-result .btn-report-star:before {
  content: "☆";
  font-size: 1.25rem;
  color: #c2cad6;
}
.container.energy-solution .box__body .inverter-result .btn-report-star:hover:before {
  color: #f0a92a;
}

/* 적용 회전수 자동 산정값 — 직접 입력이 아니라는 것을 배경으로 구분한다 */
.container.energy-solution .box__body .inverter-input .box-search-card input[type="text"].auto-filled {
  background: #eef5ff;
}

/* ---- 결과 영역 스크롤 해제 ----
 * 기본은 고정 높이(100vh-217px) + overflow-y:auto 라 이력이 여러 건이거나 상세분석을 펼치면
 * 안쪽에 스크롤이 생긴다. 인버터 화면은 높이를 풀어 전체가 한 번에 보이게 하고 페이지 스크롤로 넘긴다. */
.container.energy-solution .box__body > .area__right:has(.scroll-area.inverter-result) {
  height: auto;
}
.container.energy-solution .box__body > .area__right .scroll-area.inverter-result:has(.box-column) {
  height: auto;
  overflow: visible;
}
/* 분석 이력이 없을 때는 안내문이 납작해지지 않도록 최소 높이를 준다 */
.container.energy-solution .box__body .inverter-result .box-column.nodata {
  height: auto;
  min-height: 320px;
}


/* ⓘ 분석 설비 정보 — 3단 요약표 */
.container.energy-solution .box__body .inverter-result .inv-info-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
@media screen and (max-width: 760px) {
  .container.energy-solution .box__body .inverter-result .inv-info-grid {
    grid-template-columns: 1fr;
  }
}
.container.energy-solution .box__body .inverter-result .inv-info-col {
  border: 1px solid #e3e8ef;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}
.container.energy-solution .box__body .inverter-result .inv-info-h {
  padding: 8px 12px;
  background: #f7f9fc;
  border-bottom: 1px solid #e3e8ef;
  font-size: 0.75rem;
  font-weight: 700;
  color: #0f4aa8;
}
.container.energy-solution .box__body .inverter-result .inv-info-tbl {
  width: 100%;
  border-collapse: collapse;
}
.container.energy-solution .box__body .inverter-result .inv-info-tbl td {
  padding: 6px 12px;
  border-bottom: 1px solid #f0f3f7;
  font-size: 0.75rem;
  line-height: 1.4;
  color: #6b7686;
}
.container.energy-solution .box__body .inverter-result .inv-info-tbl td:first-child {
  width: 52%;
}
.container.energy-solution .box__body .inverter-result .inv-info-tbl tr:last-child td {
  border-bottom: 0;
}
.container.energy-solution .box__body .inverter-result .inv-info-tbl td:last-child {
  text-align: right;
  font-weight: 700;
  color: #1a2330;
}
.container.energy-solution .box__body .inverter-result .inv-rpm-card {
  padding: 14px 15px;
  border: 1px solid #e3e8ef;
  border-radius: 10px;
  background: linear-gradient(180deg, #fbfcfe, #fff);
}
.container.energy-solution .box__body .inverter-result .inv-rpm-card .rc-k {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  font-size: 0.75rem;
  font-weight: 700;
  color: #6b7686;
}
.container.energy-solution .box__body .inverter-result .inv-rpm-card .rc-k:before {
  content: "";
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #1763d6;
}
.container.energy-solution .box__body .inverter-result .inv-rpm-card .rc-v {
  font-size: 1.5rem;
  font-weight: 800;
  letter-spacing: -0.5px;
  line-height: 1.25;
  color: #0f4aa8;
}
.container.energy-solution .box__body .inverter-result .inv-rpm-card .rc-v small {
  margin-left: 2px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7686;
}
.container.energy-solution .box__body .inverter-result .inv-rpm-card .rc-eq {
  margin-top: 7px;
  font-family: Consolas, monospace;
  font-size: 0.656rem;
  line-height: 1.6;
  color: #8a94a3;
}
/* 최종 적용 회전속도 — 한 줄 전체를 쓰고 값이 더 크다 */
.container.energy-solution .box__body .inverter-result .inv-rpm-card.final {
  grid-column: 1 / -1;
  border-color: #bcd3f7;
  background: linear-gradient(180deg, #eef5ff, #f7faff);
}
.container.energy-solution .box__body .inverter-result .inv-rpm-card.final .rc-k {
  color: #0f4aa8;
}
.container.energy-solution .box__body .inverter-result .inv-rpm-card.final .rc-v {
  font-size: 1.75rem;
  color: #1763d6;
}

/* 2번 소비전력 산식 */
.container.energy-solution .box__body .inverter-result .inv-formula {
  padding: 12px 14px;
  border: 1px solid #e3e8ef;
  border-radius: 8px;
  background: #f7f9fc;
  text-align: center;
}
.container.energy-solution .box__body .inverter-result .inv-formula p {
  font-family: Consolas, monospace;
  font-size: 0.813rem;
  line-height: 1.9;
  color: #2a3340;
}
.container.energy-solution .box__body .inverter-result .inv-formula b {
  color: #0f4aa8;
}
.container.energy-solution .box__body .inverter-result .inv-formula .sub {
  display: block;
  margin-top: 6px;
  font-size: 0.813rem;
  color: #8a94a3;
}

/* 4번 추천 MVD 기기 — HTML .mvd-hero / .spec2 / .dim-wrap */
.container.energy-solution .box__body .inverter-result .mvd-hero {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border: 1px solid #e8f0fc;
  border-radius: 10px;
  background: linear-gradient(135deg, #eef5ff, #f7fbff);
}
.container.energy-solution .box__body .inverter-result .mvd-hero .badge {
  padding: 4px 10px;
  border-radius: 20px;
  background: #1763d6;
  color: #fff;
  font-size: 0.656rem;
  font-weight: 800;
  white-space: nowrap;
}
.container.energy-solution .box__body .inverter-result .mvd-hero .mname {
  font-size: 1.125rem;
  font-weight: 800;
  letter-spacing: 0.3px;
  color: #0f4aa8;
}
.container.energy-solution .box__body .inverter-result .mvd-hero .msub {
  margin-top: 2px;
  font-size: 0.688rem;
  color: #6b7686;
}
.container.energy-solution .box__body .inverter-result .mvd-warn {
  padding: 11px 14px;
  border: 1px solid #ffd9b0;
  border-radius: 9px;
  background: #fff5ec;
  color: #a85a12;
  font-size: 0.719rem;
  font-weight: 600;
  line-height: 1.55;
}
.container.energy-solution .box__body .inverter-result .mvd-warn.nomargin {
  margin: 0;
}
.container.energy-solution .box__body .inverter-result .spec2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
@media screen and (max-width: 760px) {
  .container.energy-solution .box__body .inverter-result .spec2 {
    grid-template-columns: 1fr;
  }
}
.container.energy-solution .box__body .inverter-result .spec-card {
  border: 1px solid #e3e8ef;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
}
.container.energy-solution .box__body .inverter-result .spec-card .sh {
  padding: 9px 13px;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 800;
}
.container.energy-solution .box__body .inverter-result .spec-card.mot .sh {
  background: #5b6472;
}
.container.energy-solution .box__body .inverter-result .spec-card.mvd .sh {
  background: #1763d6;
}
.container.energy-solution .box__body .inverter-result .spec-card table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.75rem;
}
.container.energy-solution .box__body .inverter-result .spec-card td {
  padding: 7px 13px;
  border-bottom: 1px solid #f0f3f7;
}
.container.energy-solution .box__body .inverter-result .spec-card tr:last-child td {
  border-bottom: none;
}
.container.energy-solution .box__body .inverter-result .spec-card td:first-child {
  width: 56%;
  color: #6b7686;
}
.container.energy-solution .box__body .inverter-result .spec-card td:last-child {
  text-align: right;
  font-weight: 700;
  color: #1a2330;
}
.container.energy-solution .box__body .inverter-result .dim-wrap {
  padding: 16px;
  border: 1px solid #e3e8ef;
  border-radius: 10px;
  background: #fff;
}
.container.energy-solution .box__body .inverter-result .dim-wrap .dt {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 12px;
  font-size: 0.75rem;
  font-weight: 800;
  color: #1a2330;
}
.container.energy-solution .box__body .inverter-result .dim-wrap .dt .pt {
  padding: 2px 8px;
  border-radius: 10px;
  background: #6b7686;
  color: #fff;
  font-size: 0.625rem;
  font-weight: 700;
}
.container.energy-solution .box__body .inverter-result .dim-tbl {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.75rem;
}
.container.energy-solution .box__body .inverter-result .dim-tbl td {
  padding: 6px 10px;
  border-bottom: 1px solid #f0f3f7;
  color: #6b7686;
}
.container.energy-solution .box__body .inverter-result .dim-tbl tr:last-child td {
  border-bottom: none;
}
.container.energy-solution .box__body .inverter-result .dim-tbl td:last-child {
  text-align: right;
  font-weight: 700;
  color: #1a2330;
}

/* 3번 차트 제목 · 절감효과 강조행 */
.container.energy-solution .box__body .inverter-result .inv-chart-tit {
  text-align: center;
  font-size: 0.875rem;
  font-weight: 800;
  color: #1f9d5b;
}

/* =========================================================================
 * 에너지 솔루션 - 인버터 경제성 분석 : 피그마 화면 개편 (2026-08-26, 08-31 개정)
 *
 * 좌측 Step 레일(고정 296px) + 우측 카드 스택 구조로 바꾼다.
 * 기본 카드(box-search-card, 296px·1열)와 폭·열수가 달라 공용 클래스에 손대지 않고
 * .inv-* 를 새로 두되, 다른 화면에 번지지 않도록 .inverter-input / .inverter-result
 * 안으로만 스코프를 좁힌다.
 * ========================================================================= */

/* ---- 좌측 Step 레일 ----
 * 폭·글자 크기는 「고효율 설비 교체 분석」 레일(.box-search-card-wrap 296px,
 * .menu-list 1rem)과 같게 맞춘다. 두 화면이 같은 자리에 번갈아 뜨므로 어긋나면 눈에 띈다. */
.container.energy-solution .box__body .box-search-card-wrap.inverter-input {
  width: 296px;
  min-width: 296px;
  flex: 0 0 296px;
}
.container.energy-solution .box__body .inverter-input .box-search-card.inv-rail {
  padding-bottom: 16px;
}
.container.energy-solution .box__body .inverter-input .inv-rail > .top .flex-inline.left-right {
  align-items: baseline;
}
.container.energy-solution .box__body .inverter-input .inv-rail .inv-rail-link {
  margin-left: auto;
  border: 0;
  background: none;
  font-size: 0.6875rem;
  color: #1763d6;
  text-decoration: underline;
  cursor: pointer;
}
.container.energy-solution .box__body .inverter-input .inv-rail > .bottom {
  padding: 0 12px;
}
.container.energy-solution .box__body .inverter-input .inv-rail .inv-steps {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px 0;
  border-radius: 4px;
  background: #f2f5f9;
}
/* 고효율 .menu-list > li > a 와 같은 글자 크기(1rem)·행 높이(40px)·색(#051c3f) */
.container.energy-solution .box__body .inverter-input .inv-rail .inv-steps > li {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 8px 14px;
  font-size: 1rem;
  line-height: 1.5;
  color: #051c3f;
  cursor: pointer;
}
/* 「Step n」 칸을 고정폭으로 잡아야 아래 이름들의 시작선이 맞는다 (고효율 span min-width 47px) */
.container.energy-solution .box__body .inverter-input .inv-rail .inv-steps > li .no {
  flex: 0 0 auto;
  min-width: 47px;
}
.container.energy-solution .box__body .inverter-input .inv-rail .inv-steps > li.on .no,
.container.energy-solution .box__body .inverter-input .inv-rail .inv-steps > li.on .nm {
  font-weight: 700;
  color: #1763d6;
}
/* 활성 단계 오른쪽 화살표 (→) — 가로선 + 촉 */
.container.energy-solution .box__body .inverter-input .inv-rail .inv-steps > li .arw {
  display: none;
}
.container.energy-solution .box__body .inverter-input .inv-rail .inv-steps > li.on .arw {
  position: relative;
  display: block;
  flex: 0 0 auto;
  width: 18px;
  height: 10px;
  margin-left: auto;
}
.container.energy-solution .box__body .inverter-input .inv-rail .inv-steps > li.on .arw::before {
  content: "";
  position: absolute;
  left: 0;
  top: 4px;
  width: 17px;
  height: 1.5px;
  background: #1763d6;
}
.container.energy-solution .box__body .inverter-input .inv-rail .inv-steps > li.on .arw::after {
  content: "";
  position: absolute;
  right: 0;
  top: 1.5px;
  width: 7px;
  height: 7px;
  border-top: 1.5px solid #1763d6;
  border-right: 1.5px solid #1763d6;
  transform: rotate(45deg);
}
.container.energy-solution .box__body .inverter-input .inv-rail .inv-rail-reset {
  width: 100%;
  height: 32px;
  margin-top: 12px;
  border: 1px solid #dfe3e9;
  border-radius: 4px;
  background: #fff;
  font-size: 0.75rem;
  color: #6b7684;
  cursor: pointer;
}

/* ---- 우측 : 입력 카드 스택 ---- */
/* 기존 폭 규칙은 :has(.box-column) 에만 걸려 있어 입력 단계(.inv-form)에서는 폭이 생기지 않는다 */
.container.energy-solution .box__body > .area__right .scroll-area.inverter-result {
  flex: 1;
  margin: -4px 0 0 16px;
  width: calc(100% - 328px);
  height: 100%;
  overflow-y: auto;
}
@media screen and (max-width: 940px) {
  .container.energy-solution .box__body > .area__right .scroll-area.inverter-result {
    width: 100%;
    margin-left: 0;
  }
}
.container.energy-solution .inverter-result .inv-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 0 0 24px;
}
.container.energy-solution .inverter-result .inv-card {
  border: 1px solid #e4e8ee;
  border-radius: 6px;
  background: #fff;
}
.container.energy-solution .inverter-result .inv-card.on {
  border-color: #1763d6;
  box-shadow: 0 0 0 1px rgba(23, 99, 214, 0.25);
}
.container.energy-solution .inverter-result .inv-card .inv-card-hd {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
}
.container.energy-solution .inverter-result .inv-card .inv-card-hd .tit {
  font-size: 0.875rem;
  font-weight: 700;
  color: #1a2330;
}
.container.energy-solution .inverter-result .inv-card .inv-card-hd .inv-hd-btns {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
}
/* Guide 띠 */
.container.energy-solution .inverter-result .inv-card .inv-guide {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 28px;
  margin: 0 16px;
  padding: 0 12px;
  background: #1763d6;
  font-size: 0.75rem;
  color: #fff;
}
.container.energy-solution .inverter-result .inv-card .inv-guide > span {
  padding: 2px 7px;
  border-radius: 10px;
  background: #fff;
  font-size: 0.625rem;
  font-weight: 700;
  color: #1763d6;
}
.container.energy-solution .inverter-result .inv-card .inv-card-bd {
  padding: 0 16px 16px;
}
.container.energy-solution .inverter-result .inv-card:not(.on) .inv-card-bd {
  padding-top: 16px;
}

/* ---- 카드 안 그리드 : 라벨 위 · 값 아래 ---- */
.container.energy-solution .inverter-result .inv-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 24px 32px;
  padding: 24px;
  border-radius: 4px;
  background: #f7f8fa;
}
.container.energy-solution .inverter-result .inv-grid + .inv-grid {
  margin-top: 8px;
}
/* 피그마는 카드마다 열 수가 달라도 6열 그리드 위에 얹혀 있다.
   3열 카드 = 2칸씩 · 2열 카드 = 3칸씩 차지하고, 4·5열 카드는 6열 중 앞에서부터 채운다.
   그래야 설비(3) · 운용(4) · 모터(6) · 시나리오(5) 의 열 시작선이 서로 맞는다. */
.container.energy-solution .inverter-result .inv-grid-2 > * {
  grid-column: span 3;
}
.container.energy-solution .inverter-result .inv-grid-3 > * {
  grid-column: span 2;
}
.container.energy-solution .inverter-result .inv-grid-4 > *,
.container.energy-solution .inverter-result .inv-grid-5 > *,
.container.energy-solution .inverter-result .inv-grid-6 > * {
  grid-column: span 1;
}
@media all and (max-width: 1600px) {
  .container.energy-solution .inverter-result .inv-grid-5 > *,
  .container.energy-solution .inverter-result .inv-grid-6 > * {
    grid-column: span 2;
  }
}
@media all and (max-width: 1200px) {
  .container.energy-solution .inverter-result .inv-grid-3 > *,
  .container.energy-solution .inverter-result .inv-grid-4 > *,
  .container.energy-solution .inverter-result .inv-grid-5 > *,
  .container.energy-solution .inverter-result .inv-grid-6 > * {
    grid-column: span 3;
  }
}
.container.energy-solution .inverter-result .inv-f {
  min-width: 0;
}
.container.energy-solution .inverter-result .inv-f-lb {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 0.75rem;
  color: #46505f;
  white-space: nowrap;
}
.container.energy-solution .inverter-result .inv-f-lb > i {
  font-style: normal;
  color: #ea3f3f;
}
.container.energy-solution .inverter-result .inv-f-lb > em {
  font-style: normal;
  font-size: 0.6875rem;
  color: #a4adb9;
}
.container.energy-solution .inverter-result .inv-f-in {
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin-top: 4px;
  min-width: 0;
}
.container.energy-solution .inverter-result .inv-f-in > input[type="text"] {
  width: 100%;
  min-width: 0;
  height: 28px;
  padding: 0;
  border: 0;
  border-bottom: 1px solid transparent;
  background: none;
  font-size: 1.0625rem;
  color: #1a2330;
}
.container.energy-solution .inverter-result .inv-f-in > input[type="text"]:focus {
  border-bottom-color: #1763d6;
  outline: none;
}
.container.energy-solution .inverter-result .inv-f-in > input[type="text"]::placeholder {
  color: #b6bfcb;
}
.container.energy-solution .inverter-result .inv-f-in > input.auto-filled {
  color: #1763d6;
}
.container.energy-solution .inverter-result .inv-f-in > .unit {
  flex: 0 0 auto;
  font-size: 0.6875rem;
  color: #97a3b4;
}
/* 드롭다운 — 공용 .select 를 밑줄형으로 낮춰 쓴다 */
.container.energy-solution .inverter-result .inv-f-in > .select.inv-sel {
  width: 100%;
  min-width: 0;
  height: 28px;
  border: 0;
  background: none;
}
.container.energy-solution .inverter-result .inv-f-in > .select.inv-sel .selected {
  height: 28px;
  padding: 0;
  border: 0;
  background: none;
}
.container.energy-solution .inverter-result .inv-f-in > .select.inv-sel .selected-value {
  font-size: 1.0625rem;
  color: #1a2330;
}
.container.energy-solution .inverter-result .inv-f-in > .select.inv-sel > ul {
  top: 30px;
}
.container.energy-solution .inverter-result .inv-f.inv-f-note {
  grid-column: span 3;
  align-self: end;
}
.container.energy-solution .inverter-result .inv-f.inv-f-note > p {
  padding-bottom: 4px;
  font-size: 0.6875rem;
  color: #97a3b4;
}
.container.energy-solution .inverter-result .inv-sub-tit {
  padding: 24px 24px 8px;
  border-bottom: 1px solid #e1e6ed;
  border-radius: 4px 4px 0 0;
  background: #f7f8fa;
  font-size: 0.75rem;
  color: #46505f;
}
/* 소제목이 붙으면 아래 패널과 한 덩어리로 보이게 위쪽 라운드를 없앤다 */
.container.energy-solution .inverter-result .inv-sub-tit + .inv-grid {
  padding-top: 20px;
  border-radius: 0 0 4px 4px;
}
.container.energy-solution .inverter-result .inv-sub-tit.inv {
  color: #1763d6;
}
/* 운전 CASE 카드는 「기본 정보 → 유량 / 개도율 → 압력」이 한 판 위에 이어진다 (피그마 2026-08-31).
   앞 격자는 아래 라운드를, 뒤따르는 소제목은 위 라운드를 버려야 경계가 보이지 않는다. */
.container.energy-solution .inverter-result .inv-grid:has(+ .inv-sub-tit) {
  border-radius: 4px 4px 0 0;
}
.container.energy-solution .inverter-result .inv-grid + .inv-sub-tit {
  margin: 0;
  border-radius: 0;
}
.container.energy-solution .inverter-result .inv-sub-tit + .inv-grid:has(+ .inv-sub-tit) {
  border-radius: 0;
}
/* 6열 격자에서 안내문은 남는 두 칸만 쓴다 (span 3 이면 줄이 넘친다) */
.container.energy-solution .inverter-result .inv-grid-6 > .inv-f.inv-f-note {
  grid-column: span 2;
}
/* 대수 운전 시나리오 카드도 한 판이다 (피그마) — 위 격자와 DOL/INV 묶음이 떨어지면
   회색 배경이 둘로 갈라져 보인다. 사이 여백과 맞닿는 모서리 둥글기를 없앤다. */
.container.energy-solution .inverter-result .inv-grid:has(+ .inv-sc-pair) {
  border-radius: 4px 4px 0 0;
}
.container.energy-solution .inverter-result .inv-grid + .inv-sc-pair {
  margin-top: 0;
  border-radius: 0 0 4px 4px;
}
.container.energy-solution .inverter-result .inv-sc-pair {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 0 32px;
  margin-top: 8px;
  padding: 0 24px;
  border-radius: 4px;
  background: #f7f8fa;
}
.container.energy-solution .inverter-result .inv-sc-pair > * {
  grid-column: span 2;
}
.container.energy-solution .inverter-result .inv-sc-pair .inv-sub-tit {
  padding: 24px 0 8px;
  border-radius: 0;
  background: none;
}
.container.energy-solution .inverter-result .inv-sc-pair .inv-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  padding: 20px 0 24px;
  border-radius: 0;
  background: none;
}
.container.energy-solution .inverter-result .inv-sc-pair .inv-grid > * {
  grid-column: span 1;
}

/* ---- 카드 하단 버튼 3종 ---- */
.container.energy-solution .inverter-result .inv-card-ft {
  display: flex;
  justify-content: center;
  gap: 8px;
  padding: 16px;
}
.container.energy-solution .inverter-result .btn-inv-dark,
.popup-layer.inverter-all-pop .btn-inv-dark {
  height: 40px;
  padding: 0 14px;
  border: 0;
  border-radius: 4px;
  background: #13315c;
  font-size: 0.8125rem;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
}
.container.energy-solution .inverter-result .btn-inv-dark.sm,
.popup-layer.inverter-all-pop .btn-inv-dark.sm {
  height: 30px;
  padding: 0 10px;
  font-size: 0.75rem;
}
.container.energy-solution .inverter-result .btn-inv-dark:disabled,
.popup-layer.inverter-all-pop .btn-inv-dark:disabled {
  background: #e6eaf0;
  color: #a4adb9;
  cursor: default;
}
.container.energy-solution .inverter-result .btn-inv-dark,
.container.energy-solution .inverter-result .btn-inv-go {
  white-space: nowrap;
}
.container.energy-solution .inverter-result .btn-inv-go {
  height: 40px;
  /* 「한번에 입력하기」 팝업 하단 버튼과 같은 규격이다 (담당자 2026-09-02).
     min-width 가 없으면 [수정] 처럼 글자가 짧은 버튼만 좁아져 두 화면의 크기가 어긋난다. */
  min-width: 104px;
  padding: 0 24px;
  border: 0;
  border-radius: 4px;
  background: #1763d6;
  font-size: 0.8125rem;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
}
.container.energy-solution .inverter-result .btn-inv-go:disabled {
  background: #e6eaf0;
  color: #a4adb9;
  cursor: default;
}
/* 수정 모드의 「+ 신규 분석 추가」 — 같은 크기의 보조 동작이라 테두리형으로 구분한다 */
.container.energy-solution .inverter-result .btn-inv-go.outline {
  background: #fff;
  border: 1px solid #1763d6;
  color: #1763d6;
}
.container.energy-solution .inverter-result .btn-inv-go.outline:disabled {
  background: #fff;
  border-color: #e6eaf0;
  color: #a4adb9;
}
.container.energy-solution .inverter-result .btn-inv-del,
.popup-layer.inverter-all-pop .btn-inv-del {
  position: relative;
  width: 22px;
  height: 22px;
  border: 0;
  background: none;
  cursor: pointer;
}
.container.energy-solution .inverter-result .btn-inv-del::before,
.container.energy-solution .inverter-result .btn-inv-del::after,
.popup-layer.inverter-all-pop .btn-inv-del::before,
.popup-layer.inverter-all-pop .btn-inv-del::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 10px;
  width: 14px;
  height: 1px;
  background: #8c96a3;
}
.container.energy-solution .inverter-result .btn-inv-del::before,
.popup-layer.inverter-all-pop .btn-inv-del::before {
  transform: rotate(45deg);
}
.container.energy-solution .inverter-result .btn-inv-del::after,
.popup-layer.inverter-all-pop .btn-inv-del::after {
  transform: rotate(-45deg);
}

/* ---- 소제목 옆 ⓘ 도움말 (피그마 2026-08-31) ----
 * 공용 .tooltip-link 을 그대로 쓰되, 기본 말풍선은 트리거 폭(14px)의 130% 라
 * 글이 한 글자씩 잘린다. 폭·위치·색만 흰 말풍선으로 덮어쓴다.
 * ------------------------------------------------------------------ */
.container.energy-solution .inverter-result .inv-tip,
.popup-layer.inverter-all-pop .inv-tip {
  display: inline-block;
  width: 14px;
  height: 14px;
  margin-left: 6px;
  border-radius: 50%;
  background: #46505f;
  font-style: normal;
  vertical-align: -2px;
  cursor: help;
}
.container.energy-solution .inverter-result .inv-tip::after,
.popup-layer.inverter-all-pop .inv-tip::after {
  content: "i";
  display: block;
  font-size: 0.5625rem;
  font-weight: 700;
  line-height: 14px;
  text-align: center;
  color: #fff;
}
.container.energy-solution .inverter-result .inv-tip::before,
.popup-layer.inverter-all-pop .inv-tip::before {
  top: 22px;
  left: -4px;
  width: 320px;
  max-width: 320px;
  padding: 12px 14px;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(122, 133, 150, 0.4);
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.5;
  color: #46505f;
  white-space: normal;
}

/* ---- 결과 : 하단 안내문 + 버튼 줄 ---- */
.container.energy-solution .inverter-result .bottom.inv-result-ft {
  display: flex;
  align-items: center;
  gap: 12px;
}
.container.energy-solution .inverter-result .bottom.inv-result-ft .btn-area {
  /* 안내문(inv-result-note)이 빠져 flex 로 밀어 주던 것이 없어졌다. 버튼 줄을 직접 오른쪽으로 붙인다 */
  flex: 0 0 auto;
  margin-left: auto;
}

/* ---- 결과 표 : 피그마 실측 ----
 * 헤더는 모든 칸 가운데. 본문은 첫 칸 왼쪽 · 마지막(금액) 칸 오른쪽 · 나머지 가운데.
 * 단위는 헤더가 아니라 셀 안에 붙는다(마크업 참조). 줄무늬는 없다.
 * ------------------------------------------------------------------ */
.container.energy-solution .box__body .inverter-result .tbl-list thead th,
.container.energy-solution .box__body .inverter-result .tbl-list thead th:first-child,
.container.energy-solution .box__body .inverter-result .tbl-list thead th:last-child {
  height: 32px;
  padding: 0 14px;
  background: #f7f8fa;
  vertical-align: middle;
  border-bottom: 0;
  font-weight: 400;
  color: #46505f;
  text-align: center;
}
.container.energy-solution .box__body .inverter-result .tbl-list tbody th,
.container.energy-solution .box__body .inverter-result .tbl-list tbody td {
  height: 33px;
  text-align: center;
}
.container.energy-solution .box__body .inverter-result .tbl-list tbody th:first-child,
.container.energy-solution .box__body .inverter-result .tbl-list tbody td:first-child {
  text-align: left;
}
.container.energy-solution .box__body .inverter-result .tbl-list tbody th:last-child,
.container.energy-solution .box__body .inverter-result .tbl-list tbody td:last-child {
  text-align: right;
}
.container.energy-solution .box__body .inverter-result .tbl-list tr.sum-row th,
.container.energy-solution .box__body .inverter-result .tbl-list tr.sum-row td {
  background: #e6f0ff;
  border-bottom: 0;
  font-weight: 400;
  color: #1763d6;
}
/* 경제성 검토 표는 값 칸이 둘이라 둘 다 오른쪽 정렬이다 (피그마 상세분석) */
.container.energy-solution .box__body .inverter-result .tbl-list.eco-table tbody td {
  text-align: right;
}

/* ---- 결과 카드 제목줄 (피그마 : 글씨 한 줄 + 얇은 구분선) ---- */
.container.energy-solution .box__body .inverter-result .top.inv-item-hd {
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 14px;
  border-bottom-color: #e1e6ec;
}
.container.energy-solution .box__body .inverter-result .inv-item-tit {
  font-size: 0.875rem;
  font-weight: 500;
  color: #1a2330;
}

/* =========================================================================
 * 상세분석 — 피그마(2026-08-26) f06_2~4 구조
 * 섹션 제목은 번호 배지가 아니라 「1. 회전속도 산정」 글씨 한 줄,
 * 본문 블록은 전부 테두리 없는 회색 패널(#f7f8fa)이다.
 * ========================================================================= */
.container.energy-solution .box__body .inverter-result .inv-detail .inv-sec-tit {
  margin: 26px 0 10px;
  font-size: 0.9375rem;
  font-weight: 500;
  color: #1a2330;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-sec-tit > em {
  margin-right: 4px;
  font-style: normal;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-panel {
  padding: 18px 20px;
  border: 0;
  border-radius: 4px;
  background: #f7f8fa;
}

/* ---- 설비 / 모터 / 운용 입력값 요약 : 흰 카드 한 장 안 3열 ---- */
.container.energy-solution .box__body .inverter-result .inv-detail .inv-info-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0 30px;
  padding: 18px 20px;
  border: 1px solid #e7eaef;
  border-radius: 4px;
  background: #fff;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-info-col {
  border: 0;
  border-radius: 0;
  overflow: visible;
  background: none;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-info-h {
  padding: 0 0 8px;
  border-bottom: 1px solid #e7eaef;
  background: none;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #1a2330;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-info-tbl td {
  padding: 6px 0;
  border-bottom: 0;
  font-size: 0.75rem;
  color: #6b7686;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-info-tbl td:last-child {
  font-weight: 400;
  color: #1a2330;
}

/* ---- 1. 회전속도 산정 : 패널 한 장 안 3열 ---- */
.container.energy-solution .box__body .inverter-result .inv-detail .inv-panel.inv-rpm {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0 24px;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card {
  padding: 0;
  border: 0;
  border-radius: 0;
  background: none;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card .rc-k {
  margin-bottom: 10px;
  font-size: 0.8125rem;
  font-weight: 400;
  color: #46505f;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card .rc-k:before {
  display: none;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card .rc-v {
  font-size: 1.625rem;
  font-weight: 700;
  line-height: 1.2;
  color: #1a2330;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card .rc-v small {
  margin-left: 4px;
  font-size: 0.75rem;
  font-weight: 400;
  color: #97a3b4;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card.final .rc-v {
  color: #1763d6;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card .rc-eq {
  margin-top: 8px;
  font-size: 0.75rem;
  line-height: 1.5;
  color: #97a3b4;
}

/* ---- 2. 예상 소비전력 ---- */
.container.energy-solution .box__body .inverter-result .inv-detail .inv-panel.inv-formula {
  border: 0;
  background: #f7f8fa;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-formula .ff-hd {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-formula .ff-k {
  font-size: 0.8125rem;
  color: #46505f;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-formula .ff-law {
  margin-left: auto;
  font-size: 0.75rem;
  color: #97a3b4;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-formula p {
  font-size: 1.375rem;
  font-weight: 500;
  line-height: 1.4;
  color: #1a2330;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-formula b {
  font-weight: 700;
  color: #1763d6;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-formula .sub {
  display: block;
  margin-top: 10px;
  font-size: 0.75rem;
  color: #97a3b4;
}

/* ---- 3. 경제성 검토 : 좌 차트 / 우 절감효과 3종 + 비교표 ---- */
.container.energy-solution .box__body .inverter-result .inv-detail .inv-eco {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 0 24px;
  align-items: start;
}
@media screen and (max-width: 1100px) {
  .container.energy-solution .box__body .inverter-result .inv-detail .inv-eco {
    grid-template-columns: minmax(0, 1fr);
    gap: 20px;
  }
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-eco-l .inv-chart-tit {
  margin-bottom: 8px;
  font-size: 0.9375rem;
  font-weight: 700;
  color: #1763d6;
  text-align: center;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-chart-box {
  height: 300px;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-eco-r {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-eco-r .inv-metric {
  min-height: 0;
  padding: 12px 16px;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-eco-r .inv-metric .k {
  margin-bottom: 6px;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-eco-r .tbl-list {
  margin-top: 10px;
}

/* ---- 4. 추천 MVD 기기 ---- */
.container.energy-solution .box__body .inverter-result .inv-detail .mvd-hero {
  display: block;
  padding: 18px 20px;
}
.container.energy-solution .box__body .inverter-result .inv-detail .mvd-hero .badge {
  display: block;
  margin: 0 0 6px;
  padding: 0;
  border-radius: 0;
  background: none;
  font-size: 0.8125rem;
  font-weight: 400;
  color: #46505f;
}
.container.energy-solution .box__body .inverter-result .inv-detail .mvd-hero .mname {
  font-size: 1.625rem;
  font-weight: 700;
  line-height: 1.2;
  color: #1763d6;
}
.container.energy-solution .box__body .inverter-result .inv-detail .mvd-hero .msub {
  margin-top: 8px;
  font-size: 0.75rem;
  color: #97a3b4;
}
.container.energy-solution .box__body .inverter-result .inv-detail .dim-wrap .dm {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 10px 0 12px;
  font-size: 1.0625rem;
  font-weight: 700;
  color: #1a2330;
}
.container.energy-solution .box__body .inverter-result .inv-detail .dim-wrap .dm .badge {
  padding: 3px 9px;
  border-radius: 10px;
  background: #1763d6;
  font-size: 0.6875rem;
  font-weight: 500;
  color: #fff;
}
.container.energy-solution .box__body .inverter-result .inv-detail .dim-wrap .dm .pt {
  font-size: 0.75rem;
  font-weight: 400;
  color: #97a3b4;
}

/* ---- 상세분석 보정 (2026-08-26) ---- */
/* 옛 규칙은 회전속도가 2열이라 최종 카드가 한 줄을 다 썼다. 피그마는 3열이라 되돌린다 */
.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card.final {
  grid-column: auto;
  border-color: transparent;
  background: none;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card.final .rc-k {
  color: #46505f;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card.final .rc-v {
  font-size: 1.625rem;
}
/* 산식은 왼쪽 정렬 · 본문 글꼴 (옛 규칙이 가운데 정렬 + 고정폭 글꼴이었다) */
.container.energy-solution .box__body .inverter-result .inv-detail .inv-panel.inv-formula {
  text-align: left;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-formula p {
  font-family: inherit;
}

/* CASE 2·3 이 있으면 한 칸에 「49.2 Hz / 86.1 Hz」가 들어가 값이 길어진다 (2026-09-03) */
.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card .rc-v.multi {
  font-size: 1.125rem;
  line-height: 1.35;
  word-break: keep-all;
}
.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card.final .rc-v.multi {
  font-size: 1.25rem;
}
/* CASE 별 산식은 한 줄에 하나씩 (2026-09-03) */
.container.energy-solution .box__body .inverter-result .inv-rpm-card .rc-eq .eq-line {
  display: block;
}
.container.energy-solution .box__body .inverter-result .inv-rpm-card .rc-eq .eq-line + .eq-line {
  margin-top: 4px;
}
/* 예상 소비전력 — 패널 한 장 안에서 CASE 를 구분선으로만 나눈다 (2026-09-03) */
.container.energy-solution .box__body .inverter-result .inv-detail .inv-formula .ff-row + .ff-row {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e5e8ee;
}

/* ---- 4. 추천 MVD : 스펙 표 ---- */
.container.energy-solution .box__body .inverter-result .inv-detail .spec2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 40px;
  align-items: start;
  margin-top: 22px;
}
@media screen and (max-width: 1100px) {
  .container.energy-solution .box__body .inverter-result .inv-detail .spec2 {
    grid-template-columns: minmax(0, 1fr);
    gap: 24px;
  }
}
.container.energy-solution .box__body .inverter-result .inv-detail .spec-card {
  padding: 0;
  border: 0;
  border-radius: 0;
  background: none;
}
.container.energy-solution .box__body .inverter-result .inv-detail .spec-card .sh {
  margin-bottom: 8px;
  padding: 0;
  border: 0;
  background: none;
  font-size: 0.8125rem;
  font-weight: 700;
  color: #1a2330;
}
.container.energy-solution .box__body .inverter-result .inv-detail .spec-card table,
.container.energy-solution .box__body .inverter-result .inv-detail .dim-tbl {
  width: 100%;
  border-collapse: collapse;
  border-bottom: 1px solid #eceff3;
}
.container.energy-solution .box__body .inverter-result .inv-detail .spec-card table td,
.container.energy-solution .box__body .inverter-result .inv-detail .dim-tbl td {
  height: 32px;
  padding: 0 16px;
  border: 0;
  font-size: 0.8125rem;
  font-weight: 400;
  color: #1a2330;
}
.container.energy-solution .box__body .inverter-result .inv-detail .spec-card table tr:nth-child(odd) td,
.container.energy-solution .box__body .inverter-result .inv-detail .dim-tbl tr:nth-child(odd) td {
  background: #f7f8fa;
}
.container.energy-solution .box__body .inverter-result .inv-detail .spec-card table td:last-child,
.container.energy-solution .box__body .inverter-result .inv-detail .dim-tbl td:last-child {
  text-align: right;
  white-space: nowrap;
}
/* 값 오른쪽 끝을 맞추기 위해 단위는 고정폭으로 뽑아 둔다 */
.container.energy-solution .box__body .inverter-result .inv-detail .spec-card table td > i,
.container.energy-solution .box__body .inverter-result .inv-detail .dim-tbl td > i {
  display: inline-block;
  width: 34px;
  margin-left: 6px;
  font-style: normal;
  font-size: 0.75rem;
  color: #1a2330;
  text-align: left;
}
/* MVD 선정 스펙에는 「Level 상당」·「Pulse 상당」이 있어 34px 로는 단위 시작점이 어긋난다.
   가장 긴 단위에 맞춰 칸을 넓히면 V·A·kVA·kW·Hz 까지 한 줄에서 시작한다.
   전동기 입력 스펙도 같은 규칙을 타므로 좌우 두 표의 단위 위치가 맞는다. */
.container.energy-solution .box__body .inverter-result .inv-detail .spec-card table td > i {
  width: 62px;
}

/* ---- 4. 추천 MVD : 외형 치수 ---- */
.container.energy-solution .box__body .inverter-result .inv-detail .dim-wrap {
  margin-top: 26px;
}
.container.energy-solution .box__body .inverter-result .inv-detail .dim-wrap .dt {
  font-size: 0.8125rem;
  font-weight: 700;
  color: #1a2330;
}
.container.energy-solution .box__body .inverter-result .inv-detail .dim-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 40px;
  align-items: start;
}
@media screen and (max-width: 1100px) {
  .container.energy-solution .box__body .inverter-result .inv-detail .dim-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 20px;
  }
}
.container.energy-solution .box__body .inverter-result .inv-detail .dim-fig {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  border: 1px dashed #dfe3e9;
  border-radius: 4px;
  background: #fbfcfd;
  font-size: 0.75rem;
  color: #a4adb9;
}
/* 도면이 들어오면 자리표시자용 점선을 실선으로 바꾸고 여백을 준다 */
.container.energy-solution .box__body .inverter-result .inv-detail .dim-fig.has-fig {
  border-style: solid;
  background: #fff;
  padding: 12px;
}
.container.energy-solution .box__body .inverter-result .inv-detail .dim-fig img {
  max-width: 100%;
  max-height: 260px;
  height: auto;
  object-fit: contain;
}

/* =========================================================================
 * 「한번에 입력하기」 팝업
 * ========================================================================= */
.popup-layer.inverter-all-pop {
  width: 1240px;
  max-width: 96%;
}
.popup-layer.inverter-all-pop .popup__body {
  max-height: calc(100vh - 220px);
  overflow-y: auto;
  /* 스크롤이 생기는 순간 내용이 왼쪽으로 밀리지 않도록 스크롤바 자리를 미리 잡는다 */
  scrollbar-gutter: stable;
  padding: 8px 24px 20px;
}
.popup-layer.inverter-all-pop .inv-pop-row {
  display: grid;
  grid-template-columns: 120px minmax(0, 1fr);
  gap: 0 16px;
  padding: 16px 0;
  border-bottom: 1px solid #eef1f5;
}
.popup-layer.inverter-all-pop .inv-pop-row:last-child {
  border-bottom: 0;
}
.popup-layer.inverter-all-pop .inv-pop-lb {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding-top: 6px;
  font-size: 0.8125rem;
  font-weight: 700;
  color: #1a2330;
}
.popup-layer.inverter-all-pop .inv-grid {
  display: grid;
  gap: 10px 16px;
}
.popup-layer.inverter-all-pop .inv-grid-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.popup-layer.inverter-all-pop .inv-grid-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.popup-layer.inverter-all-pop .inv-grid-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
/* 팝업은 「라벨 왼쪽 · 입력 오른쪽」의 테두리형이다 */
/* 라벨은 남는 폭, 입력칸은 고정폭. 피그마 f03 은 140px 이었으나
   단위가 붙는 칸(「0.4747 tCO₂/MWh」 등)이 빠듯해 200px 로 넓혔다 (2026-08-31 요청) */
.popup-layer.inverter-all-pop .inv-f {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 200px;
  align-items: center;
  gap: 0 10px;
  min-width: 0;
}
.popup-layer.inverter-all-pop .inv-f-lb {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 0.8125rem;
  color: #1a2330;
  white-space: nowrap;
}
.popup-layer.inverter-all-pop .inv-f-lb > i {
  font-style: normal;
  color: #ea3f3f;
}
.popup-layer.inverter-all-pop .inv-f-lb > em {
  font-style: normal;
  font-size: 0.6875rem;
  color: #a4adb9;
}
.popup-layer.inverter-all-pop .inv-f-in {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 0;
  height: 34px;
  padding: 0 10px;
  border: 1px solid #cfd8e3;
  border-radius: 4px;
  background: #fff;
}
.popup-layer.inverter-all-pop .inv-f-in:focus-within {
  border-color: #1763d6;
}
.popup-layer.inverter-all-pop .inv-f-in > input[type="text"] {
  width: 100%;
  min-width: 0;
  height: 32px;
  border: 0;
  background: none;
  font-size: 0.8125rem;
  color: #1a2330;
  text-align: right;
}
.popup-layer.inverter-all-pop .inv-f-in > input[type="text"]::placeholder {
  color: #b6bfcb;
}
/* 피그마 : 값은 오른쪽 정렬, 안내문구(placeholder)는 왼쪽. 단위는 칸 오른쪽 끝 */
.popup-layer.inverter-all-pop .inv-f-in > input[type="text"]:placeholder-shown {
  text-align: left;
}
.popup-layer.inverter-all-pop .inv-f-in > .unit {
  flex: 0 0 auto;
  margin-left: 4px;
  font-size: 0.6875rem;
  color: #97a3b4;
}
.popup-layer.inverter-all-pop .inv-f-in > .select.inv-sel {
  width: 100%;
  min-width: 0;
  height: 32px;
  border: 0;
  background: none;
}
.popup-layer.inverter-all-pop .inv-f-in > .select.inv-sel .selected {
  height: 32px;
  padding: 0;
  border: 0;
  background: none;
}
.popup-layer.inverter-all-pop .inv-f-in > .select.inv-sel .selected-value {
  font-size: 0.8125rem;
  color: #1a2330;
}
.popup-layer.inverter-all-pop .inv-f.inv-f-note {
  grid-column: span 2;
}
.popup-layer.inverter-all-pop .inv-f.inv-f-note > p {
  font-size: 0.6875rem;
  color: #97a3b4;
}
.popup-layer.inverter-all-pop .inv-sub-tit {
  margin: 16px 0 10px;
  font-size: 0.8125rem;
  font-weight: 700;
  color: #1a2330;
}
.popup-layer.inverter-all-pop .inv-sub-tit.dol,
.popup-layer.inverter-all-pop .inv-sub-tit.inv {
  margin-top: 22px;
  color: #1a2330;
}
/* 「일일 대수운전 패턴 비교」는 체크박스와 같은 높이에서 시작한다 */
.popup-layer.inverter-all-pop .inv-pop-fields > .inv-sub-tit:first-child {
  margin-top: 2px;
}
.popup-layer.inverter-all-pop .inv-sc-pair {
  gap: 0 24px;
}
.popup-layer.inverter-all-pop .inv-chk {
  display: inline-flex;
  align-items: center;
}

/* ---- 팝업 보정 (2026-08-26) ---- */
/* 버튼 문구가 두 줄로 접히지 않게 */
.popup-layer.inverter-all-pop .btn-inv-dark,
.popup-layer.inverter-all-pop .popup__footer button {
  white-space: nowrap;
}
.popup-layer.inverter-all-pop .popup__footer button {
  min-width: 104px;
  padding: 0 20px;
}
.popup-layer.inverter-all-pop .inv-chk label {
  white-space: nowrap;
}
.popup-layer.inverter-all-pop .inv-pop-lb {
  white-space: nowrap;
}

/* 앞 필드 개수가 달라져도 항상 새 줄 첫 칸에서 시작한다 */
.container.energy-solution .box__body .inverter-result .inv-grid > .inv-f.inv-f-newrow,
.popup-layer.inverter-all-pop .inv-grid > .inv-f.inv-f-newrow {
  grid-column-start: 1;
}
/* 시나리오처럼 블록이 여러 개인 줄은 이 상자로 감싼다 (격자 칸 하나를 차지) */
.popup-layer.inverter-all-pop .inv-pop-fields {
  min-width: 0;
}
/* 1열 격자 (대수운전 DOL/INV 묶음) */
.popup-layer.inverter-all-pop .inv-grid-1 {
  grid-template-columns: minmax(0, 1fr);
}
/* DOL / INV 는 좌우 두 묶음 — 3중 격자로 쌓으면 라벨이 겹친다 */
.popup-layer.inverter-all-pop .inv-sc-pair {
  display: grid;
  gap: 0 16px;
}
/* 피그마 f05 : 시나리오도 위 3열 줄과 같은 트랙 폭(왼쪽 두 칸)에 놓인다.
 * 2열이라고 폭을 반씩 나누면 라벨과 입력칸 사이가 벌어져 다른 줄과 어긋난다. */
.popup-layer.inverter-all-pop .inv-pop-fields .inv-grid-2,
.popup-layer.inverter-all-pop .inv-pop-fields .inv-sc-pair {
  grid-template-columns: repeat(2, calc((100% - 32px) / 3));
}
.popup-layer.inverter-all-pop .inv-pop-fields .inv-grid-1 {
  grid-template-columns: minmax(0, 1fr);
}
/* 하단 버튼 — 프로젝트 기본 폭이 고정이라 문구가 잘린다 */
/* ---- 「한번에 입력하기」 팝업 하단 버튼 ----
 * 단계별 입력 화면(.btn-inv-go)과 색을 맞춘다. 공통 팝업 기본색(#0a78ff)을 그대로 두면
 * 같은 [수정]·[+ 신규 분석 추가]가 화면과 팝업에서 다른 파랑으로 보인다.
 * 취소(.bg-gray)는 공통 규칙을 그대로 쓴다.
 * ------------------------------------------------------------------ */
.popup-layer.inverter-all-pop .popup__footer button:not(.bg-gray) {
  background-color: #1763d6;
}
/* [+ 신규 분석 추가] — 화면과 같은 테두리형. span 색까지 눌러야 흰 글자가 안 남는다 */
.popup-layer.inverter-all-pop .popup__footer button.outline {
  background-color: #fff;
  border: 1px solid #1763d6;
}
.popup-layer.inverter-all-pop .popup__footer button.outline span {
  color: #1763d6;
}
/* 공통 팝업은 1rem 인데 단계별 화면 버튼은 0.8125rem 이다.
   글자 크기가 다르면 [+ 신규 분석 추가] 처럼 라벨이 긴 버튼의 폭이 두 화면에서 어긋난다. */
.popup-layer.inverter-all-pop .popup__footer button span {
  font-size: 0.8125rem;
}
.popup-layer.inverter-all-pop .popup__footer button {
  width: auto;
  min-width: 104px;
  padding: 0 24px;
  white-space: nowrap;
}

/* =========================================================================
 * 태양광 역률 영향 분석 — 프로토타입 「별도_태양광 내 역률 영향 분석 ver.0.1」 재현
 * 5대분류 세로형 표는 기존 .tbl-list 로는 못 만든다(열 균등분할·첫 열 강제 배경·!important).
 * 이 화면에만 적용되도록 .pvpf-wrap 으로 스코프를 좁혀 표를 따로 만든다.
 * ========================================================================= */
.detail-analysis-wrap.pvpf-wrap .pvpf-legend .pvpf-unit {
  margin-left: 10px;
  font-size: 0.75rem;
  font-weight: 400;
  color: #8b94a1;
}

/* 범례 — 어느 셀을 고칠 수 있는지 */
.detail-analysis-wrap.pvpf-wrap .pvpf-legend {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin: 10px 0 12px;
  font-size: 0.75rem;
  color: #5b6472;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-legend .sw {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 5px;
  border-radius: 3px;
  vertical-align: -1px;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-legend .sw.edit {
  border: 1px solid #b5d4f4;
  background: #e6f1fb;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-legend .sw.auto {
  border: 1px solid #c9d2dd;
  background: #fff;
}

/* 전력 단가 · 연간 발전량 · 할인율 + 기준 전환 */
.detail-analysis-wrap.pvpf-wrap .pvpf-assump {
  display: flex;
  gap: 18px;
  flex-wrap: wrap;
  align-items: center;
  margin: 4px 0 14px;
  font-size: 0.8125rem;
  color: #5b6472;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-assump > label {
  display: inline-flex;
  gap: 6px;
  align-items: center;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-assump input[type="text"] {
  width: 90px;
  height: 30px;
  padding: 0 8px;
  border: 1px solid #b5d4f4;
  border-radius: 6px;
  background: #e6f1fb;
  color: #0c447c;
  font-size: 0.8125rem;
  text-align: right;
}
/* 전력단가·연간발전량·역률개선 할인율 — 고쳐 쓰는 값이 아니라 기 입력·분석 결과라 읽기 전용이다.
   입력칸과 헷갈리지 않도록 테두리를 없애고 값만 굵게 보여 준다 */
.detail-analysis-wrap.pvpf-wrap .pvpf-assump .pvpf-fixed {
  display: inline-flex;
  gap: 6px;
  align-items: baseline;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-assump .pvpf-fixed .vl {
  min-width: 60px;
  padding: 0 2px;
  color: #0c447c;
  font-size: 0.9375rem;
  font-weight: 600;
  text-align: right;
}

/* 표 — 가로 스크롤, 첫 두 열 고정 */
/* 역률 영향 분석을 펼친 동안에는 스크롤을 페이지 하나로 모은다.
   .area__right 는 평소 calc(100vh - 217px) 로 잘려 있고 .scroll-area 가 안쪽에서 스크롤하는데,
   이 패널은 카드·차트·표가 이어져 길어서 안쪽 스크롤이 페이지 스크롤과 겹쳐 보인다. */
.container.energy-solution .box__body > .area__right:has(.pvpf-wrap) {
  height: auto;
}
.container.energy-solution .box__body > .area__right:has(.pvpf-wrap) .scroll-area:has(.box-column) {
  height: auto;
  overflow-y: visible;
}

/* 표 위 — 범례(어느 셀을 고칠 수 있는지)와 역률 안내 버튼 */
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl-top {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  margin: 24px 0 8px;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl-top .pvpf-legend {
  align-items: flex-end;
  margin: 0;
}
/* 단위 안내 — 역률 조정 요금 범례 옆 */
.detail-analysis-wrap.pvpf-wrap .pvpf-legend .pvpf-unit {
  color: #8b94a1;
}
/* ------------------------------------------------------------------ *
 *  월별 표 — Enable 표(.tbl-list) 규격에 5대분류 세로형 구성을 얹었다.
 *  기본 .tbl-list 는 th 배경 #dde2e9 · 높이 40px · 자간 -0.9px · 열 균등분할(table-layout:fixed)이
 *  걸려 있어 여기서 되돌린다. 열 폭은 colgroup 으로 못박아 편집 셀과 계산 셀 크기를 맞춘다.
 * ------------------------------------------------------------------ */
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl-wrap {
  overflow-x: auto;
  overflow-y: hidden;
  border: 0;
  background: #fff;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl {
  width: 100%;
  min-width: 0;
  border-collapse: collapse;
  border-bottom: 0;
  table-layout: fixed;
  white-space: nowrap;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl .col-grp {
  width: 112px;
}
/* 가장 긴 라벨 「태양광 설치/발전 시 (a−c)」가 딱 들어가는 폭.
   글자가 약 158px 이라 이보다 좁히면 잘린다 — 더 줄이려면 라벨을 줄여야 한다. */
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl .col-lbl {
  width: 154px;
}
/* 월 열은 폭을 주지 않는다 — 남은 폭을 균등하게 나눠 가져 가로 스크롤이 생기지 않는다 */
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl .col-yr {
  width: 96px;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl caption {
  overflow: hidden;
  width: 1px;
  height: 1px;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
}
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl th,
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td {
  box-sizing: border-box;
  height: 36px;
  min-height: 0;
  padding: 0 8px;
  border: 0;
  border-bottom: 1px solid #f1f3f6;
  background: #fff;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.4;
  letter-spacing: normal;
  color: #1a2330;
  vertical-align: middle;
}
/* 머리글 — 옅은 회색 바탕에 회색 글씨 (인버터 결과 표와 같은 규격) */
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  height: 40px;
  border-bottom: 1px solid #e9edf2;
  background: #f7f8fa;
  color: #46505f;
  font-weight: 400;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl th.lft,
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td.lft {
  text-align: left;
}
/* 대분류·구분 두 열은 왼쪽 고정. 월 열만 좌우로 스크롤한다 */
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td.grp {
  position: sticky;
  left: 0;
  z-index: 1;
  padding: 0 12px;
  white-space: normal;
  border-right: 1px solid #eaedf2;
  background: #f7f8fa;
  color: #46505f;
  text-align: left;
  line-height: 1.45;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td.grp span {
  display: block;
}
/* 구분 — 이름이 길면 줄을 바꿔 다 보여 준다. 행 높이는 그만큼 늘어난다 (담당자 요청 2026-09-04) */
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td.lbl {
  position: sticky;
  left: 112px;
  padding: 6px 5px;
  z-index: 1;
  border-right: 1px solid #eaedf2;
  background: #f1f3f7;
  color: #46505f;
  text-align: left;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  line-height: 1.35;
  word-break: keep-all;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl thead th.grp-h {
  left: 0;
  z-index: 3;
  border-right: 1px solid #e9edf2;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl thead th.lbl-h {
  left: 112px;
  z-index: 3;
  border-right: 1px solid #e9edf2;
}
/* 셀 안 단위 — 값보다 옅게 */
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl .u {
  color: #8b94a1;
}
/* 대분류가 바뀌는 자리만 진한 선 */
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl tr.grp-end td {
  border-bottom: 1px solid #e3e8ef;
}
/* 표 아래도 행 사이와 같은 선으로 닫는다 (담당자 2026-09-03) */
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl tbody tr:last-child td {
  border-bottom: 1px solid #f1f3f6;
}
/* 파란 바탕은 입력 행(무효 전력)과 연간 열에만 둔다 (담당자 2026-09-03).
   무효 전력이 이 표에서 유일하게 고칠 수 있는 값이라 한눈에 보여야 한다. */
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl tr.hl td:not(.grp) {
  background: #e6f0ff;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl tr.hl td.lbl {
  background: #e6f0ff;
  color: #0c447c;
}
/* 최종 절감 행 — 바탕색 없이 글자만 파랗게 */
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl tr.hi td:not(.grp) {
  color: #1763d6;
  font-weight: 600;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl tr.hi td.lbl {
  color: #1763d6;
}
/* 편집 가능 셀 — 구분 칸까지 같은 색으로 묶는다 */
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td.edit {
  padding: 0;
  background: #e6f0ff;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td.lbl.edit {
  padding: 0 5px;
  background: #e6f0ff;
  color: #0c447c;
  font-weight: 400;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl .pvpf-cell-input {
  box-sizing: border-box;
  display: block;
  width: 100%;
  min-width: 0;
  height: 35px;
  margin: 0;
  padding: 0 8px;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: #0c447c;
  font-family: inherit;
  font-size: 0.8125rem;
  line-height: 35px;
  letter-spacing: normal;
  text-align: center;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl .pvpf-cell-input:focus {
  outline: 2px solid #378add;
  outline-offset: -2px;
}
/* 연간 열 — 맨 오른쪽. 강조 행 위에 와야 하므로 뒤에 둔다 */
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td.yr,
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl tr.hl td.yr,
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl tr.hi td.yr {
  background: #e6f0ff;
  color: #0f4aa8;
  font-weight: 600;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td.yr .u {
  color: #5b87c4;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td.yr .avg {
  margin-left: 3px;
  font-size: 0.625rem;
}


/* 절감 금액 3단계 비교 */
/* 절감 금액 3종 — 피그마 : 회색 패널 한 장 안에 3칸.
   글자 크기는 피그마 실측을 배율 2.5 로 환산해 프로젝트 표준 스케일에 맞췄다
   (기준 = 이미 구현된 PV 결과 카드의 라벨 15px · 값 26px 잉크 높이). */
.detail-analysis-wrap.pvpf-wrap .pvpf-panel {
  padding: 24px;
  border-radius: 10px;
  background: #f7f8fa;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-sum-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0 32px;
  margin: 0 0 16px;
}
@media screen and (max-width: 1100px) {
  .detail-analysis-wrap.pvpf-wrap .pvpf-sum-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 20px;
  }
}
.detail-analysis-wrap.pvpf-wrap .pvpf-sum .ps-k {
  margin-bottom: 10px;
  font-size: 1rem;
  line-height: 1.6;
  letter-spacing: -0.04em;
  color: #2a2c2f;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-sum .ps-v {
  font-family: "Pretendard", sans-serif;
  font-size: 1.75rem;
  font-weight: 500;
  font-style: normal;
  line-height: 1.39;
  letter-spacing: -0.02em;
  color: #2a2c2f;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-sum .ps-v small {
  margin-left: 6px;
  font-size: 0.8125rem;
  font-weight: 400;
  letter-spacing: -0.02em;
  color: #97a3b4;
}
/* 최종 절감액만 파랗다 — 피그마 세 번째 칸 */
.detail-analysis-wrap.pvpf-wrap .pvpf-sum.acc .ps-v {
  color: #1763d6;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-sum .ps-s {
  margin-top: 10px;
  font-size: 0.75rem;
  line-height: 1.5;
  letter-spacing: -0.02em;
  color: #97a3b4;
}
/* 차트 캡션 — 무엇의 합계인지와 단위 */
.detail-analysis-wrap.pvpf-wrap .pvpf-chart-tit {
  margin: 24px 0 0;
  font-size: 0.75rem;
  color: #6b7686;
}
/* 차트 — 높이는 피그마 실측 350px(공용 .h446 은 !important 라 전용 클래스로 뺐다).
   공용 .graph-box 의 overflow:auto 는 이 화면에서 스크롤을 하나 더 만들므로 되돌린다. */
.detail-analysis-wrap.pvpf-wrap .analysis-graph-wrap .graph-cont .graph-box {
  overflow: visible;
}
.detail-analysis-wrap.pvpf-wrap .analysis-graph-wrap .graph-area.pvpf-chart {
  height: 350px;
}

/* CSV 다운로드 · 입력값 초기화 */
.detail-analysis-wrap.pvpf-wrap .pvpf-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 14px;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-footer .btn-basic {
  width: auto;
  min-width: 130px;
}

/* ==========================================================================
   management - MVD 모델 관리 / 전압 등급 관리
   레이아웃은 「고효율 설비 List」와 같다(.l-divide > article.flex-7 + article.flex-3).
   그 화면이 쓰는 규칙을 그대로 타므로 여기서는 고효율에 없는 것만 더한다.
     - 고효율 우측 패널은 읽기 전용이라 버튼줄이 없다 → 저장·삭제 버튼줄을 여기서 정의
     - 참조 중인 전압 등급 안내문
   라벨 폭(.form__input .tit 108px)과 h3 는 위쪽 「management - 에너지솔루션 관리」 블록이
   :has(.flex-7, .flex-3) 로 이 화면에도 걸어 준다. 다시 정의하지 말 것.
   ========================================================================== */
.content-wrap > .l-divide .box__body .btn-area.mvd-btns {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 32px;
}
.content-wrap > .l-divide .box__body .txt-info.mvd-note {
  margin-top: 20px;
  padding: 10px 12px;
  border-radius: 4px;
  background: #f7f8fa;
  font-size: 13px;
  line-height: 1.5;
  color: #6b7684;
  word-break: keep-all;
}

/* ==========================================================================
   역률 안내 버튼 (.pvpf-guide-btn) — 태양광 역률 영향 분석 패널
   안내 내용은 공통 팝업(EnablePowerFactorGuidePop)을 띄운다. 여기엔 버튼 모양만 둔다.
   ========================================================================== */
.detail-analysis-wrap.pvpf-wrap .title {
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl-top .pvpf-guide-btn {
  margin-left: auto;
  padding: 5px 12px;
  border: 1px solid #d6e4f7;
  border-radius: 6px;
  background: #eff6ff;
  font-size: 12.5px;
  line-height: 16px;
  color: #2a78d6;
  white-space: nowrap;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl-top .pvpf-guide-btn::before {
  content: "ⓘ ";
}
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl-top .pvpf-guide-btn:hover {
  background: #d6e4f7;
}

/* 역률 조정 요금 셀 — 할증(+) 붉게 · 감액(−) 푸르게. 템플릿 ver.1.0 의 adjCell 과 같은 규칙 */
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td.pos {
  color: #e5484d;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td.neg {
  color: #2a78d6;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-legend .pvpf-pos {
  color: #e5484d;
}
.detail-analysis-wrap.pvpf-wrap .pvpf-legend .pvpf-neg {
  color: #2a78d6;
}
`, "",{"version":3,"sources":["webpack://./static/css/content.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB,gGAAgG;AAChG,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;EACtB,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,iFAAqE;EACrE,kCAAkC;AACpC;AACA;;EAEE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,gDAAgD;AAClD;AACA;;EAEE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;;EAEE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;;EAEE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,2EAAqE;AACvE;AACA;EACE,yBAAyB;EACzB,UAAU;EACV,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,cAAc;AACd;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,oFAA+E;EAC/E,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA,gBAAgB;AAChB;EACE,gBAAgB;AAClB;AACA,8GAA8G;AAC9G;EACE,gBAAgB;AAClB;AACA,mHAAmH;;AAEnH,8GAA8G;AAC9G;EACE,gBAAgB;AAClB;AACA,mHAAmH;;AAEnH;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,8GAA8G;AAC9G;EACE,aAAa;EACb,cAAc;AAChB;AACA,mHAAmH;AACnH,8GAA8G;AAC9G;EACE,aAAa;EACb,cAAc;AAChB;AACA,mHAAmH;AACnH;EACE,iBAAiB;AACnB;AACA,8GAA8G;AAC9G;EACE,iBAAiB;AACnB;AACA,mHAAmH;AACnH;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,cAAc;EACd,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;AACA;EACE,2EAAkE;EAClE,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,2EAAkE;EAClE,kCAAkC;AACpC;AACA;EACE,2EAAkE;EAClE,iCAAiC;AACnC;AACA;EACE,aAAa;AACf;AACA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;AACA;;GAEG;AACH;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,2EAA+D;EAC/D,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,2EAAiE;EACjE,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,cAAc;EACd,eAAe;EACf,iEAAwD;AAC1D;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,MAAM;AACR;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,sEAAgE;AAClE;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;AACA,aAAa;AACb;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,UAAU;AACZ;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,2EAAkE;AACpE;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,UAAU;AACZ;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,2EAAkE;AACpE;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;AACA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,4EAAkE;EAClE,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;;AAEA,OAAO;AACP;EACE,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,8CAA8C;AAChD;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yEAA8D;EAC9D,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,yEAA+D;AACjE;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,yEAA8D;EAC9D,0BAA0B;AAC5B;AACA;;;;;GAKG;AACH;EACE,WAAW;EACX,YAAY;EACZ,oFAAwE;EACxE,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,0DAA0D;AAC5D;AACA;EACE,oDAA8C;EAC9C,oDAAgD;EAChD,oDAA6C;AAC/C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,4EAAmE;AACrE;AACA;;EAEE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,eAAe;EACf,cAAc;AAChB;AACA;;;;;EAKE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;;;;;;;;GAQG;AACH;;EAEE,sBAAsB;AACxB;AACA;;EAEE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,uEAA2D;AAC7D;AACA;EACE,uEAA4D;AAC9D;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,oCAAoC;EACpC,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,wDAAwD;AAC1D;AACA;EACE,YAAY;EACZ,SAAS;AACX;AACA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;;AAEA,8GAA8G;AAC9G;EACE,gBAAgB;AAClB;AACA,mHAAmH;;AAEnH,8GAA8G;AAC9G;EACE,gBAAgB;AAClB;AACA,mHAAmH;;AAEnH;EACE,gBAAgB;AAClB;AACA,8GAA8G;AAC9G;EACE,gBAAgB;AAClB;AACA,mHAAmH;AACnH,8GAA8G;AAC9G;EACE,gBAAgB;AAClB;AACA,mHAAmH;AACnH;EACE,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,mDAAmD;AACrD;AACA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,SAAS;EACT,4EAAmE;EACnE,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;;;EAGE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,SAAS;EACT,4EAAoE;AACtE;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,MAAM;AACN,YAAY;AACZ;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,UAAU;EACV,qDAAqD;AACvD;AACA;;EAEE,SAAS;AACX;AACA;;EAEE,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,4EAAqE;AACvE;AACA;;EAEE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,4EAAoE;AACtE;AACA;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,eAAe;EACf,2BAA2B;EAC3B,cAAc;EACd,uBAAuB;AACzB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,MAAM;EACN,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;AAClC;AACA;;EAEE,2BAA2B;EAC3B,gBAAgB;EAChB,oBAAoB;AACtB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,oBAAoB;IACpB,qBAAqB;IACrB,MAAM;EACR;EACA;IACE,OAAO;IACP,aAAa;EACf;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,OAAO;AACP;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,OAAO;AACP;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,yBAAyB;EACzB;iBACe;AACjB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,eAAe;AACjB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,OAAO;AACT;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yEAAgE;EAChE,qBAAqB;EACrB,SAAS;AACX;AACA,uBAAuB;AACvB;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,SAAS;EACT,2CAA2C;EAC3C,0BAA0B;EAC1B,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,yEAAgE;EAChE,gCAAgC;AAClC;AACA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,yEAAgE;AAClE;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,kFAA6E;EAC7E,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uEAA4D;EAC5D,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,wBAAwB;AAC1B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,WAAW;EACX,0BAA0B;EAC1B,mDAAmD;AACrD;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,+BAA+B;AACjC;AACA;EACE,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mGAAmG;AACrG;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,MAAM;EACN,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE;eACa;EACb,UAAU;AACZ;AACA;;EAEE,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,iCAAiC;EACjC,8BAA8B;EAC9B,mCAAmC;AACrC;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,6BAA6B;EAC7B,kCAAkC;EAClC,mCAAmC;AACrC;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,sBAAsB;EACtB,sCAAsC;EACtC,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,2EAAiE;EACjE,0BAA0B;AAC5B;AACA;EACE,4EAAiE;EACjE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,MAAM;EACN,UAAU;AACZ;AACA;;EAEE,sBAAsB;EACtB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uEAAiE;EACjE,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,OAAO;AACT;AACA;;EAEE,aAAa;EACb,OAAO;AACT;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,YAAY;AACd;AACA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uEAA4D;EAC5D,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uEAAiE;EACjE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;EACnB,mDAAmD;AACrD;AACA;EACE,SAAS;EACT,YAAY;EACZ,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,mDAAmD;EACnD,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,UAAU;AACZ;AACA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kEAAsD;EACtD,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,4EAAgE;AAClE;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;AACA,aAAa;AACb;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA,aAAa;AACb;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;;EAEE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,4EAAmE;EACnE,qBAAqB;AACvB;;AAEA,SAAS;AACT;EACE,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,cAAc;EACd,yBAAyB;AAC3B;AACA;;GAEG;AACH;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,oFAA+E;EAC/E,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oFAAsE;EACtE,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,4EAAsE;EACtE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,4EAAgE;EAChE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,4EAA8D;EAC9D,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,oFAAuE;EACvE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,qEAAsD;EACtD,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B;;6BAE2B;EAC3B,mBAAmB;EACnB,aAAa;AACf;;AAEA,QAAQ;AACR;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,iFAAoE;EACpE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,MAAM;EACN,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,4EAAgE;EAChE,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,4EAAiE;AACnE;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;;;;;GAKG;;AAEH,kCAAkC;AAClC;EACE,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;AACA,iBAAiB;AACjB;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,4EAA6D;EAC7D,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,WAAW;AACb;;AAEA,cAAc;AACd;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,gDAAgD;EAChD,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,2EAAuE;EACvE,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;;;;;;;GAOG;AACH;;GAEG;AACH;EACE,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;AACA;;;;;GAKG;AACH;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;AACA;;;;EAIE,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,uEAA6D;EAC7D,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,uEAA8D;EAC9D,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,sEAAuD;EACvD,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,4EAAiE;EACjE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,0EAA+D;EAC/D,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,MAAM;AACR;;AAEA,4BAA4B;AAC5B;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE;wBACsB;AACxB;AACA;EACE,6BAA6B;AAC/B;AACA;;GAEG;AACH;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,UAAU;EACV,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;;;;;;;;;;;GAWG;AACH;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;;;EAGE,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;AACA;;;EAGE,gBAAgB;EAChB,WAAW;AACb;AACA;;;EAGE,WAAW;EACX,uBAAuB;AACzB;AACA;;;EAGE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,wBAAwB;EACxB,aAAa;AACf;AACA;;EAEE,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;AACd;AACA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;;;;EAIE,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,SAAS;EACT,eAAe;EACf,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,uEAA0D;EAC1D,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uEAAiE;EACjE,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,2BAA2B;AAC7B;AACA,WAAW;AACX;EACE,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4EAAmE;EACnE,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,4EAAmE;EACnE,qBAAqB;AACvB;AACA;;EAEE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;;EAEE,YAAY;EACZ,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,gCAAgC;AAClC;AACA;EACE,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA,gCAAgC;AAChC;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,4EAAiE;EACjE,qBAAqB;AACvB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,UAAU;EACV,WAAW;AACb;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,4EAAoE;EACpE,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;;;;;EAKE,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yEAA+D;EAC/D,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4EAA6D;EAC7D,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;;;;;;EAME,gBAAgB;AAClB;AACA;;;;;;EAME,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;AACA;;;;;EAKE,qBAAqB;EACrB,4DAA4D;EAC5D,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;;;;;;EAME,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wBAAwB;EACxB,kBAAkB;AACpB;AACA;;;;;;;EAOE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;;;;;EAME,uBAAuB;EACvB,aAAa;EACb,8BAA8B;AAChC;AACA;;;;;;;EAOE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;AACA;;;;;;;EAOE,yBAAyB;AAC3B;AACA;;;;;;;;;EASE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;;;;;;;;;EASE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;;;;;;;;;EAUE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;;;;;;;;;EAUE,gBAAgB;AAClB;AACA;;;;;;;;;EASE,mBAAmB;AACrB;AACA;;;;;;;;;EASE,mBAAmB;AACrB;AACA;;;;;;;;;;EAUE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;AACA;;;;;;;;;;EAUE,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;AACA;;;;;;;;;;EAUE,aAAa;AACf;AACA;;;;;;;;;;;EAWE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;;;;;;;;;;;EAWE,gBAAgB;AAClB;AACA;;;;;;;;;;;EAWE,WAAW;AACb;AACA;;;;;;;;;;;EAWE,WAAW;EACX,YAAY;AACd;AACA;;;;;;;;;;;EAWE,aAAa;AACf;AACA;;;;;;;;;;;EAWE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;;;;;;;;;;EAWE,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,4EAA2D;EAC3D,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,4EAAkE;EAClE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,4EAA6D;EAC7D,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;AACA,oBAAoB;AACpB;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kEAAoD;EACpD,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kEAAqD;EACrD,qBAAqB;AACvB;AACA;;EAEE,YAAY;EACZ,YAAY;EACZ,SAAS;AACX;AACA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;;;EAGE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,MAAM;EACN,UAAU;AACZ;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,oFAAwE;EACxE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,oFAAwE;EACxE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,oCAAoC;AACpC;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,MAAM;EACN,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,4EAAkE;EAClE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;;EAEE,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,SAAS;EACT,eAAe;EACf,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,uEAA0D;EAC1D,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,0BAA0B;AAC5B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,UAAU;EACV,cAAc;EACd,4EAAkE;AACpE;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,wBAAwB;EACxB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;;EAEE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,eAAe;EACf,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,SAAS;EACT,UAAU;AACZ;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,kBAAkB;AACpB;AACA;;;;;;;;GAQG;AACH;;;;;;;;;GASG;AACH;EACE,WAAW;EACX,OAAO;AACT;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;;;;;;;;;GASG;AACH;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gDAAgD;EAChD,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;;;GAiBG;AACH;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,eAAe;EACf,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,cAAc;EACd,SAAS;EACT,4EAAoE;EACpE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uEAA8D;AAChE;AACA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,aAAa;AACf;;AAEA,SAAS;AACT;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,2EAA6D;EAC7D,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;;AAEA,oHAAoH;AACpH;EACE;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,mDAAmD;EACrD;EACA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;;IAEE,wBAAwB;EAC1B;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,8BAA8B;IAC9B,yBAAyB;IACzB,gCAAgC;EAClC;EACA;;;IAGE,cAAc;EAChB;EACA;IACE,SAAS;IACT,UAAU;EACZ;AACF;AACA;EACE;IACE,gCAAgC;IAChC,oBAAoB;IACpB,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;;;IAGE,WAAW;IACX,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;AACF;AACA;EACE;;IAEE,0BAA0B;IAC1B,WAAW;EACb;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;;IAEE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,+BAA+B;IAC/B,+BAA+B;EACjC;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,8BAA8B;IAC9B,mCAAmC;EACrC;EACA;IACE,gCAAgC;IAChC,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;;IAEE,0BAA0B;EAC5B;AACF;AACA;EACE;;IAEE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,uBAAuB;IACvB,WAAW;EACb;EACA;IACE,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,+BAA+B;EACjC;EACA;IACE,WAAW;IACX,cAAc;IACd,WAAW;EACb;EACA;IACE,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;;;;IAKE,aAAa;EACf;EACA;IACE,aAAa;IACb,qBAAqB;EACvB;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,qBAAqB;IACrB,WAAW;IACX,WAAW;IACX,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;;IAEE,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;IACZ,qBAAqB;IACrB,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,WAAW;EACb;EACA;;IAEE,cAAc;EAChB;EACA;IACE,2BAA2B;IAC3B,gBAAgB;EAClB;EACA;IACE,8BAA8B;IAC9B,WAAW;IACX,gCAAgC;IAChC,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,+BAA+B;EACjC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,aAAa;EACf;EACA;;IAEE,0BAA0B;IAC1B,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;;IAEE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,2BAA2B;EAC7B;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,4BAA4B;EAC9B;EACA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA,SAAS;EACT;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,aAAa;EACf;EACA;IACE,4BAA4B;IAC5B,WAAW;EACb;;EAEA;;;;;;;;;;;KAWG;AACL;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;EAClC;EACA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,qBAAqB;EACvB;EACA;;IAEE,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,iBAAiB;EACnB;EACA;;;;IAIE,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;EACA;;;IAGE,kBAAkB;IAClB,wBAAwB;IACxB,YAAY;IACZ,gCAAgC;IAChC,eAAe;IACf,cAAc;IACd,UAAU;IACV,cAAc;EAChB;EACA;;IAEE,aAAa;EACf;EACA;;IAEE,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,eAAe;IACf,eAAe;EACjB;EACA;IACE,2EAAiE;IACjE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;;;IAGE,mBAAmB;IACnB,8BAA8B;EAChC;EACA;;IAEE,WAAW;EACb;EACA;;IAEE,yBAAyB;IACzB,6BAA6B;EAC/B;EACA;;IAEE,aAAa;EACf;EACA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,WAAW;EACb;EACA;IACE,8BAA8B;IAC9B,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,eAAe;EACjB;EACA;IACE,wBAAwB;IACxB,YAAY;EACd;EACA;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,8BAA8B;IAC9B,uBAAuB;EACzB;EACA;;IAEE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,wBAAwB;IACxB,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;EAChC;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;IACd,yBAAyB;EAC3B;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,6BAA6B;EAC/B;EACA;IACE,YAAY;EACd;EACA;IACE,gCAAgC;EAClC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;;;IAGE,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,+BAA+B;IAC/B,gBAAgB;IAChB,SAAS;EACX;AACF;AACA;EACE;;IAEE,2BAA2B;IAC3B,WAAW;EACb;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;EACjB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,UAAU;IACV,aAAa;IACb,WAAW;EACb;EACA;IACE,aAAa;IACb,yBAAyB;EAC3B;EACA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA,SAAS;EACT;IACE,8BAA8B;IAC9B,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,WAAW;IACX,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,qBAAqB;IACrB,uBAAuB;EACzB;AACF;AACA;EACE;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,WAAW;IACX,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;EAC7B;EACA;IACE,cAAc;IACd,UAAU;EACZ;EACA;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;;EAEA,SAAS;EACT;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,WAAW;IACX,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,OAAO;EACT;EACA;IACE,OAAO;EACT;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,SAAS;EACX;AACF;AACA;EACE,kCAAkC;EAClC;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,cAAc;EAChB;EACA;IACE,SAAS;EACX;EACA,SAAS;EACT;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,oFAA2E;IAC3E,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,uBAAuB;IACvB,yBAAyB;EAC3B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,oCAAoC;EACtC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,4EAAkE;IAClE,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;;IAEE,aAAa;EACf;EACA;;IAEE,YAAY;IACZ,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;;IAEE,iBAAiB;EACnB;EACA;;IAEE,gBAAgB;EAClB;AACF;AACA;EACE,kCAAkC;EAClC;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;EACA;;KAEG;EACH;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA,SAAS;EACT;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;;IAEE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,gCAAgC;EAClC;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,oEAAyD;IACzD,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,wBAAwB;EAC1B;EACA;IACE,SAAS;EACX;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,WAAW;EACb;EACA;IACE,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,6BAA6B;IAC7B,gCAAgC;IAChC,gBAAgB;EAClB;EACA;;IAEE,aAAa;EACf;EACA;;IAEE,eAAe;IACf,mBAAmB;IACnB,iBAAiB;EACnB;EACA;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gBAAgB;EAClB;EACA;;IAEE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;;;;;;;;KAQG;AACL;AACA;EACE;IACE,WAAW;EACb;EACA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;IACxB,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,wBAAwB;IACxB,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,iCAAiC;IACjC,8BAA8B;IAC9B,mCAAmC;EACrC;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,6BAA6B;IAC7B,kCAAkC;IAClC,mCAAmC;EACrC;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,eAAe;IACf,YAAY;EACd;EACA;;IAEE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,iCAAiC;IACjC,8BAA8B;IAC9B,mCAAmC;EACrC;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA,SAAS;EACT;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;IACT,UAAU;EACZ;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,oCAAoC;EACtC;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,4EAA0E;IAC1E,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,SAAS;EACX;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;;EAEA,mBAAmB;EACnB;IACE,WAAW;IACX,kFAA6E;IAC7E,qBAAqB;EACvB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;;IAEE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;;IAEE,WAAW;IACX,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,SAAS;EACX;EACA;;KAEG;EACH;;IAEE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA,kCAAkC;EAClC;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA,sBAAsB;EACtB;IACE,WAAW;IACX,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,QAAQ;EACV;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,cAAc;EAChB;EACA;IACE,iDAAiD;EACnD;EACA;IACE,yBAAyB;IACzB,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;;;KAGG;EACH;IACE,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,2BAA2B;IAC3B,cAAc;IACd,eAAe;EACjB;EACA;;IAEE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;EACA;;IAEE,aAAa;EACf;EACA;;IAEE,cAAc;EAChB;EACA;;;;;KAKG;EACH;;;;;;;;;;;;;;KAcG;EACH;;;;IAIE,aAAa;EACf;EACA;;IAEE,mBAAmB;EACrB;EACA;;IAEE,YAAY;IACZ,6BAA6B;IAC7B,gCAAgC;EAClC;EACA;;;KAGG;EACH;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,gCAAgC;EAClC;EACA;;IAEE,aAAa;EACf;EACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA4HG;EACH;;IAEE,qBAAqB;EACvB;EACA;;IAEE,qBAAqB;IACrB,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;EACA;IACE,WAAW;IACX,YAAY;IACZ,4EAAqE;IACrE,qBAAqB;EACvB;EACA;;IAEE,mBAAmB;IACnB,eAAe;EACjB;EACA;;IAEE,YAAY;EACd;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gCAAgC;EAClC;EACA;IACE,YAAY;IACZ,cAAc;EAChB;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;IACb,iBAAiB;IACjB,2BAA2B;EAC7B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,2BAA2B;EAC7B;EACA;IACE,8BAA8B;IAC9B,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,eAAe;EACjB;EACA;IACE,WAAW;IACX,iCAAiC;EACnC;EACA;IACE,6BAA6B;IAC7B,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,+BAA+B;EACjC;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,2BAA2B;EAC7B;EACA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;EAC1B;EACA;;;;;;IAME,mCAAmC;IACnC,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,2BAA2B;IAC3B,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,wBAAwB;IACxB,YAAY;EACd;EACA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,WAAW;EACb;EACA;;IAEE,WAAW;EACb;EACA;IACE,aAAa;IACb,kBAAkB;EACpB;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;EACA;IACE,2BAA2B;IAC3B,gBAAgB;EAClB;EACA;;;;;IAKE,eAAe;IACf,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,2BAA2B;IAC3B,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,aAAa;EACf;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;;;;;;;;;IASE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,eAAe;IACf,mBAAmB;EACrB;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,qBAAqB;IACrB,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,0BAA0B;IAC1B,oFAAuE;IACvE,kCAAkC;EACpC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gCAAgC;EAClC;EACA;;IAEE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;IACZ,4EAAqE;IACrE,qBAAqB;EACvB;EACA;;IAEE,mBAAmB;IACnB,eAAe;EACjB;EACA;;IAEE,YAAY;EACd;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;;IAEE,eAAe;EACjB;EACA;;;IAGE,8BAA8B;EAChC;EACA;;IAEE,2BAA2B;IAC3B,WAAW;EACb;EACA;;IAEE,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,2BAA2B;EAC7B;EACA;IACE,8BAA8B;IAC9B,uBAAuB;IACvB,8BAA8B;IAC9B,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,iCAAiC;EACnC;EACA;IACE,aAAa;IACb,eAAe;IACf,wBAAwB;IACxB,8BAA8B;IAC9B,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,2BAA2B;EAC7B;EACA;IACE,8BAA8B;IAC9B,uBAAuB;IACvB,8BAA8B;IAC9B,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,iCAAiC;EACnC;EACA;IACE,aAAa;IACb,eAAe;IACf,wBAAwB;IACxB,8BAA8B;IAC9B,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;;;;IAIE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,2BAA2B;EAC7B;EACA;IACE,8BAA8B;IAC9B,uBAAuB;IACvB,8BAA8B;IAC9B,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,iCAAiC;EACnC;EACA;IACE,aAAa;IACb,eAAe;IACf,wBAAwB;IACxB,8BAA8B;IAC9B,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gCAAgC;EAClC;;EAEA,kCAAkC;EAClC;IACE,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA,iBAAiB;EACjB;IACE,wBAAwB;IACxB,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA,mBAAmB;EACnB;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,eAAe;IACf,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,kCAAkC;EACpC;EACA;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;EACA;IACE,cAAc;IACd,mCAAmC;IACnC,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4CAA4C;IAC5C,WAAW;IACX,oFAAqE;IACrE,0BAA0B;EAC5B;EACA;IACE,cAAc;IACd,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;IAC5B,SAAS;IACT,UAAU;IACV,eAAe;IACf,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,aAAa;IACb,cAAc;IACd,UAAU;IACV,4EAAoE;EACtE;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,iBAAiB;IACjB,yBAAyB;EAC3B;EACA;IACE,gCAAgC;IAChC,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;;EAEA,SAAS;EACT;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,SAAS;EACX;EACA,sBAAsB;EACtB;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;AACF;AACA;EACE,SAAS;EACT;;IAEE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,SAAS;EACX;EACA,iBAAiB;EACjB;IACE,wBAAwB;IACxB,YAAY;EACd;;EAEA,sBAAsB;EACtB;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;;;;;;;;;;;KAWG;AACL;;AAEA;EACE;IACE,SAAS;EACX;EACA,SAAS;EACT;;IAEE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,2BAA2B;EAC7B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,kBAAkB;IAClB,cAAc;IACd,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;;EAEA,mBAAmB;EACnB;;IAEE,wBAAwB;IACxB,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,8BAA8B;IAC9B,uBAAuB;IACvB,8BAA8B;IAC9B,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,iCAAiC;EACnC;EACA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,gCAAgC;IAChC,8BAA8B;EAChC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;;;;IAIE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA,gCAAgC;EAChC;IACE,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;EACA;IACE,cAAc;IACd,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;;;IAGE,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,2EAAgE;EAClE;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,wBAAwB;EAC1B;EACA;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;IACrB,wBAAwB;IACxB,yDAAyD;EAC3D;EACA;IACE,uBAAuB;EACzB;EACA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;EACA;;IAEE,2BAA2B;EAC7B;EACA;IACE,QAAQ;IACR,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,SAAS;EACX;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;;EAEA,iBAAiB;EACjB;IACE,wBAAwB;IACxB,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,yBAAyB;EACzB;IACE,UAAU;EACZ;;EAEA,sBAAsB;EACtB;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,gBAAgB;IAChB,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;EACrB;;EAEA,SAAS;EACT;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;EACA;IACE,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;EACE;;IAEE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,WAAW;EACb;EACA;IACE,WAAW;IACX,qBAAqB;EACvB;EACA;IACE,WAAW;EACb;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,mCAAmC;EACrC;EACA;;IAEE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,YAAY;EACd;EACA;;IAEE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA,SAAS;EACT;IACE,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,QAAQ;EACV;EACA;IACE,eAAe;EACjB;EACA;;IAEE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;;KAEG;;EAEH;IACE,oBAAoB;EACtB;;EAEA;;IAEE,2BAA2B;EAC7B;EACA,sBAAsB;EACtB;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;;;IAGE,aAAa;EACf;EACA;IACE,uBAAuB;IACvB,WAAW;EACb;EACA;IACE,SAAS;EACX;AACF;;AAEA,2HAA2H;AAC3H;EACE,yBAAyB;EACzB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,4EAAoE;AACtE;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4EAAkE;AACpE;AACA;EACE,4EAAyE;AAC3E;AACA;EACE,QAAQ;EACR,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,4EAAgE;AAClE;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,UAAU;EACV,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,OAAO;EACP,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,wCAAwC;EACxC,qCAAqC;EACrC,gCAAgC;AAClC;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,4EAA8D;AAChE;AACA;EACE,4EAAqE;AACvE;AACA;;;;;;;;;;;;;;;;GAgBG;;AAEH,SAAS;AACT;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,4EAA+D;EAC/D,qBAAqB;AACvB;;AAEA,0HAA0H;AAC1H,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iFAAmE;EACnE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,OAAO;EACP,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,OAAO;AACT;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gEAAgE;EAChE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,iCAAiC;EACjC,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2CAA2C;EAC3C,kCAAkC;EAClC,mCAAmC;EACnC,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;oEACkE;EAClE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,kEAAuD;EACvD,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;;;GAGG;AACH;EACE,QAAQ;AACV;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;;;;;;GAMG;;AAEH,oBAAoB;AACpB;EACE,MAAM;EACN,OAAO;EACP,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,SAAS;EACT,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,yEAA8D;EAC9D,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,yEAA+D;EAC/D,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,yEAA8D;EAC9D,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,oFAAwE;EACxE,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,4EAA+D;EAC/D,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,gCAAgC;AAClC;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,aAAa;EACb,OAAO;AACT;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,yBAAyB;EACzB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,2EAAoE;EACpE,yBAAyB;AAC3B;AACA;;EAEE,2EAAuE;EACvE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;;AAEA,mIAAmI;AACnI;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,yBAAyB;EACzB;IACE,kBAAkB;EACpB;EACA;IACE,OAAO;EACT;EACA;IACE,SAAS;EACX;EACA;IACE,OAAO;IACP,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,yBAAyB;EAC3B;EACA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,wBAAwB;EAC1B;AACF;AACA;EACE,0BAA0B;EAC1B;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,WAAW;IACX,2BAA2B;EAC7B;EACA;;IAEE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;;IAEE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,MAAM;IACN,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,UAAU;IACV,WAAW;IACX,aAAa;IACb,SAAS;EACX;AACF;AACA;EACE;IACE,SAAS;EACX;EACA;IACE,OAAO;EACT;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,OAAO;EACT;EACA;IACE,YAAY;EACd;EACA;IACE,4BAA4B;IAC5B,+BAA+B;IAC/B,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,+HAA+H;AAC/H;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,0EAAmE;EACnE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;AACA;;EAEE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,2BAA2B;IAC3B,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,eAAe;IACf,wBAAwB;EAC1B;EACA;;IAEE,eAAe;EACjB;AACF;AACA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA,4HAA4H;AAC5H;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,aAAa;EACb,4EAAmE;EACnE,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,WAAW;EACX,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,aAAa;EACb,2EAAmE;EACnE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;;IAEE,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;;;IAGE,eAAe;EACjB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;;IAEE,iBAAiB;EACnB;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,+BAA+B;IAC/B,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,8BAA8B;IAC9B,gBAAgB;EAClB;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA,0HAA0H;AAC1H;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,aAAa;EACb,4EAAiE;EACjE,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,uBAAuB;IACvB,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,gBAAgB;IAChB,uBAAuB;IACvB,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,+BAA+B;IAC/B,iBAAiB;EACnB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,8BAA8B;IAC9B,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;AACF;;AAEA,gJAAgJ;;AAEhJ,SAAS;AACT;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,OAAO;AACT;AACA;;;;;;;;;;;;;;;;;GAiBG;AACH;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,OAAO;EACT;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,8BAA8B;EAChC;AACF;AACA;EACE;;IAEE,wBAAwB;EAC1B;AACF;;AAEA,WAAW;AACX;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,YAAY;AACd;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,8BAA8B;AAChC;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,8BAA8B;AAChC;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,QAAQ;EACR,WAAW;AACb;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,oBAAoB;EACtB;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,WAAW;EACX,uEAA6D;EAC7D,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,4EAAqE;EACrE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,wBAAwB;EACxB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;GAiBG;AACH;EACE;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,4EAAqE;IACrE,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,SAAS;EACX;AACF;AACA;EACE;;;;KAIG;EACH;IACE,+CAA+C;EACjD;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;IACX,SAAS;EACX;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;EACpB;AACF;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,4EAAyE;EACzE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,4EAAwE;EACxE,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,4EAAwE;EACxE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,4EAAwE;EACxE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,iDAAiD;EACjD,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uEAAgE;EAChE,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,mGAAqF;EACrF,gCAAgC;AAClC;;AAEA,UAAU;AACV;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0DAA0D;EAC1D,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,OAAO;AACT;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,gCAAgC;EAChC,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,kFAAyE;EACzE,qBAAqB;AACvB;AACA;EACE,kFAA4E;EAC5E,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,OAAO;AACT;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,OAAO;AACT;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,YAAY;AACd;AACA;EACE,WAAW;EACX,WAAW;EACX,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,4BAA4B;EAC9B;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;AACA;EACE;IACE,iCAAiC;EACnC;EACA;IACE,OAAO;IACP,wBAAwB;IACxB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,iCAAiC;EACnC;AACF;AACA;EACE;IACE,OAAO;IACP,wBAAwB;IACxB,mBAAmB;IACnB,SAAS;EACX;AACF;AACA;EACE;IACE,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,SAAS;EACX;AACF;;AAEA,cAAc;AACd;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;AACA;;EAEE,wCAAwC;AAC1C;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,iCAAiC;EACjC,8BAA8B;EAC9B,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;EACzB,oBAAoB;EACpB,2BAA2B;AAC7B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,8BAA8B;EAC9B,kCAAkC;AACpC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gDAAgD;EAChD,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,kCAAkC;EAClC,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;;EAEE,gDAAgD;EAChD,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE;IACE,OAAO;EACT;EACA;IACE,OAAO;EACT;AACF;AACA;EACE;IACE,OAAO;EACT;EACA;IACE,OAAO;EACT;AACF;AACA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,aAAa;EACf;AACF;;AAEA,cAAc;AACd;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA,2BAA2B;AAC3B;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA,0BAA0B;AAC1B;;;EAGE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;AACA,yBAAyB;AACzB;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,2EAAsE;EACtE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,0DAA0D;EAC1D,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,OAAO;EACP,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;;EAEE,QAAQ;EACR,OAAO;AACT;;AAEA;EACE;IACE,OAAO;IACP,WAAW;EACb;AACF;AACA;EACE;IACE,OAAO;IACP,WAAW;EACb;AACF;AACA;EACE;IACE,6BAA6B;IAC7B,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,yBAAyB;EAC3B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,WAAW;IACX,OAAO;IACP,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,eAAe;IACf,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,oBAAoB;EACtB;AACF;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,4EAAwE;EACxE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;;AAEA,SAAS;AACT;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,uEAA6D;EAC7D,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,oCAAoC;EACpC,kBAAkB;EAClB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,4EAAqE;IACrE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,8BAA8B;IAC9B,2BAA2B;IAC3B,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,4BAA4B;EAC5B,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,OAAO;EACP,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,2EAA6D;EAC7D,qBAAqB;AACvB;AACA;EACE,2EAA+D;EAC/D,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,OAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,oEAA6D;EAC7D,qBAAqB;AACvB;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,4EAAsE;EACtE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;;;EAGE,cAAc;EACd,gBAAgB;AAClB;AACA;;;EAGE,4EAAsE;EACtE,qBAAqB;AACvB;AACA;EACE,OAAO;AACT;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,aAAa;AACf;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,YAAY;EACZ,WAAW;EACX,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,SAAS;EACT,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;AACA;;EAEE,WAAW;AACb;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;;;;;;EAME,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,oBAAoB;EACpB,8BAA8B;EAC9B,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;AACA;;;EAGE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4EAAsE;EACtE,qBAAqB;AACvB;AACA;;EAEE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,4EAAgE;EAChE,qBAAqB;AACvB;AACA;EACE,4EAAoE;EACpE,qBAAqB;AACvB;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,cAAc;IACd,6BAA6B;IAC7B,8EAAwE;IACxE,qBAAqB;IACrB,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,wBAAwB;EAC1B;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,wBAAwB;IACxB,mBAAmB;IACnB,gCAAgC;IAChC,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;EAC1B;EACA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,4EAAiE;IACjE,qBAAqB;EACvB;EACA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,aAAa;IACb,YAAY;IACZ,uBAAuB;EACzB;EACA;;IAEE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,SAAS;IACT,oBAAoB;IACpB,gBAAgB;IAChB,UAAU;EACZ;EACA;IACE,QAAQ;EACV;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;;AAEA,eAAe;AACf;;EAEE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,YAAY;AACd;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4EAA8D;EAC9D,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,4EAAkE;EAClE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,4EAAkE;EAClE,qBAAqB;AACvB;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,OAAO;EACP,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,SAAS;EACT,aAAa;EACb,SAAS;AACX;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,OAAO;AACT;AACA;EACE,aAAa;EACb,UAAU;AACZ;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,OAAO;AACT;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,OAAO;EACT;EACA;IACE,2BAA2B;IAC3B,SAAS;IACT,WAAW;EACb;EACA;IACE,WAAW;IACX,OAAO;EACT;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;AACF;;AAEA,kBAAkB;AAClB;EACE,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,wEAA8D;EAC9D,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;AACA;;EAEE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;;EAEE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;;EAEE,eAAe;EACf,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,4EAAwE;EACxE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,qFAAyE;EACzE,qBAAqB;AACvB;AACA;EACE,oFAAwE;EACxE,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;;EAEE,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,OAAO;AACT;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,OAAO;AACT;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,4EAAsE;EACtE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,MAAM;EACN,UAAU;AACZ;AACA;;;EAGE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uFAA0E;EAC1E,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;IACtB,QAAQ;EACV;EACA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,+BAA+B;EACjC;EACA;IACE,YAAY;IACZ,+BAA+B;IAC/B,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;;;IAIE,WAAW;EACb;EACA;;IAEE,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,cAAc;EAChB;EACA;;IAEE,eAAe;EACjB;AACF;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,wEAA8D;EAC9D,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,wBAAwB;EACxB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;AACjC;AACA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,WAAW;AACb;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,6EAAiE;EACjE,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,yEAA8D;EAC9D,qBAAqB;AACvB;AACA;EACE,qEAAyD;EACzD,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,SAAS;EACX;EACA;;IAEE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB;gCAC8B;EAC9B,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,8BAA8B;EAC9B,+BAA+B;EAC/B,oCAAoC;AACtC;AACA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,4EAAgE;EAChE,qBAAqB;EACrB,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,wBAAwB;EACxB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,4EAA+D;EAC/D,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;AACjC;AACA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,8BAA8B;AAChC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,4EAAgE;EAChE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,6EAAiE;EACjE,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;AACA;;;;;;GAMG;AACH;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,sEAA2D;EAC3D,qBAAqB;AACvB;AACA;EACE,sEAA0D;EAC1D,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,OAAO;AACT;AACA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,OAAO;AACT;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,OAAO;AACT;AACA;EACE,YAAY;AACd;AACA;;;;;;EAME,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4EAAsE;EACtE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,4EAAgE;EAChE,qBAAqB;AACvB;AACA;EACE,4EAAoE;EACpE,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,wBAAwB;EAC1B;EACA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;EACA;;;;IAIE,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,MAAM;EACR;EACA;IACE,wBAAwB;IACxB,oBAAoB;EACtB;EACA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,yBAAyB;EAC3B;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,OAAO;IACP,WAAW;IACX,2BAA2B;IAC3B,SAAS;IACT,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,4BAA4B;IAC5B,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,8BAA8B;IAC9B,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,gCAAgC;IAChC,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,4EAAgE;IAChE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,wBAAwB;EAC1B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,SAAS;EACX;EACA;;IAEE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,iCAAiC;EACnC;EACA;IACE,oBAAoB;EACtB;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,WAAW;IACX,SAAS;EACX;EACA;;;KAGG;EACH;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;;;;;;;IAOE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;AACF;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;;EAEE,WAAW;AACb;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,6EAAiE;EACjE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kCAAkC;EAClC,8BAA8B;EAC9B,6EAA8D;EAC9D,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,OAAO;EACP,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,qCAAqC;AACvC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6EAAiE;EACjE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,6EAAqE;EACrE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kCAAkC;EAClC,8BAA8B;EAC9B,6EAAgE;EAChE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4EAA+D;EAC/D,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,2EAAqE;EACrE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B,2CAA2C;AAC3C;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,8BAA8B;AAChC;AACA;;;;;EAKE,8BAA8B;AAChC;AACA;;EAEE,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,OAAO;EACP,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,UAAU;IACV,WAAW;EACb;EACA;IACE,eAAe;IACf,cAAc;IACd,UAAU;IACV,OAAO;IACP,WAAW;IACX,SAAS;IACT,UAAU;IACV,SAAS;IACT,WAAW;EACb;EACA;;IAEE,aAAa;IACb,YAAY;IACZ,uBAAuB;EACzB;EACA;;IAEE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,YAAY;EACd;EACA;;IAEE,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,YAAY;IACZ,gCAAgC;EAClC;EACA;IACE,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,OAAO;IACP,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;AACA;EACE;;KAEG;AACL;;AAEA,uCAAuC;AACvC;EACE,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,WAAW;EACb;AACF;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oEAAyD;EACzD,qBAAqB;AACvB;AACA;EACE,oEAAyD;EACzD,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;AACA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE;IACE,mBAAmB;IACnB,sBAAsB;EACxB;AACF;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,6EAA2E;EAC3E,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;;IAEE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,kCAAkC;IAClC,YAAY;EACd;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;;IAEE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,qCAAqC;EACvC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,eAAe;IACf,cAAc;EAChB;EACA;IACE,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,gCAAgC;EAClC;AACF;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;EACX,OAAO;EACP,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;;IAEE,qBAAqB;EACvB;AACF;;AAEA,SAAS;AACT;EACE,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,+EAAuE;EACvE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gDAAgD;EAChD,OAAO;AACT;AACA;;;EAGE,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,eAAe;EACf,eAAe;EACf,OAAO;AACT;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA,cAAc;AACd;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;;EAEE,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;;;;;;;;;;;EAWE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,+EAAmE;EACnE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,+EAAwE;EACxE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,8EAAuE;EACvE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,OAAO;AACT;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gDAAgD;AAClD;AACA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+EAAoE;EACpE,qBAAqB;AACvB;AACA;EACE,+EAAmE;EACnE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA,8BAA8B;AAC9B;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;AACnB;AACA,mBAAmB;AACnB;EACE,kCAAkC;AACpC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;;;;;;;;EAQE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;AACA;;;;;;;;;EASE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;AACA;;;;;;;;;;EAUE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;AACA;EACE;IACE,QAAQ;EACV;AACF;AACA,8BAA8B;AAC9B;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,6EAAwE;EACxE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,0CAA0C;AAC5C;AACA;EACE,oBAAoB;EACpB,oBAAoB;AACtB;AACA;;GAEG;AACH;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,QAAQ;AACV;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,oDAAoD;AACtD;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;GAEG;AACH;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA,gBAAgB;AAChB;EACE,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,SAAS;EACT,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,4EAAsE;EACtE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,6EAAgE;EAChE,qBAAqB;AACvB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA,sBAAsB;AACtB;EACE,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,MAAM;EACN,oBAAoB;EACpB,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,MAAM;AACR;AACA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,MAAM;AACR;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,MAAM;AACR;AACA;;;;;;;;;;;;EAYE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;;;;;;;;;;;;;EAaE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;AACA;;;;;;;;;;;;;EAaE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,+EAAoE;EACpE,qBAAqB;AACvB;AACA;;;;;;;;;;;;;EAaE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;EAcE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;;;;;;;;;;;;EAYE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;;;;;;;;;;;;;EAaE,+EAAmE;EACnE,qBAAqB;AACvB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;EA0BE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;;;;;;;;;;;;EAYE,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;EAcE,eAAe;AACjB;AACA;EACE,SAAS;EACT,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;AACA;;;;;;;;;;;;;EAaE,wBAAwB;AAC1B;AACA;;GAEG;AACH;;;;;;;;;;;;EAYE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;AACA;;;;;;;;;;;;EAYE,kBAAkB;AACpB;AACA;;;;;;;;;;;;;EAaE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;;;;;;;;;;;;EAaE,UAAU;EACV,SAAS;AACX;AACA;;;;;;;;;;;;;;EAcE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;;;;;;;;;;;;;;;EAgBE,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,wEAAkE;EAClE,qBAAqB;AACvB;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;;;;;;;;;;;;;IAaE,wBAAwB;EAC1B;EACA;;KAEG;EACH;;;;;;;;;;;;;IAaE,SAAS;EACX;EACA;;;;;;;;;;;;IAYE,6BAA6B;EAC/B;EACA;;;;;;;;;;;;;IAaE,eAAe;EACjB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;;;;;;;;;;;;;IAaE,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;;;;;;;;;;;;;IAaE,wBAAwB;EAC1B;EACA;;;;;;;;;;;;;IAaE,wBAAwB;EAC1B;EACA;;;;;;;;;;;;;IAaE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;EACA;;;;;;;;;;;;IAYE,gBAAgB;EAClB;EACA;;;;;;;;;;;IAWE,WAAW;EACb;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;;;;;;;;;;;;;IAaE,SAAS;EACX;EACA;;;;;;;;;;;;;;IAcE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;EACA;;;;;;;;;;;;;;IAcE,yBAAyB;EAC3B;EACA;;;;;;;;;;;;;;IAcE,mBAAmB;EACrB;EACA;;;;;;;;;;;;;;;IAeE,gBAAgB;EAClB;EACA;;IAEE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,eAAe;IACf,OAAO;EACT;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;AACf;AACA;EACE,OAAO;EACP,qBAAqB;AACvB;AACA;EACE,OAAO;AACT;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,+EAAoE;EACpE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,+EAAmE;EACnE,qBAAqB;AACvB;AACA;;EAEE,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;;EAEE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,eAAe;IACf,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,SAAS;IACT,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;AACF;AACA;EACE;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;AACF;AACA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,sBAAsB;IACtB,eAAe;EACjB;EACA;;;IAGE,WAAW;EACb;AACF;AACA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,MAAM;EACR;EACA;IACE,MAAM;EACR;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;EACA;IACE,iCAAiC;EACnC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,qBAAqB;IACrB,SAAS;EACX;EACA;IACE,SAAS;IACT,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;EACjB;EACA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,4EAAmE;IACnE,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,yBAAyB;EAC3B;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,SAAS;IACT,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,wBAAwB;IACxB,eAAe;EACjB;EACA;IACE,mCAAmC;IACnC,aAAa;EACf;EACA;;IAEE,0BAA0B;IAC1B,uBAAuB;EACzB;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;EAChB;EACA;;IAEE,uBAAuB;EACzB;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,sBAAsB;EACxB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;;IAEE,mCAAmC;EACrC;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;EACrB;AACF;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,4EAA+D;EAC/D,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;AACA;;;;;;;;;GASG;;AAEH;EACE,WAAW;EACX,wBAAwB;AAC1B;AACA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,UAAU;EACV,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,wEAAgE;EAChE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,wEAAgE;EAChE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;AACA;;EAEE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,SAAS;EACT,WAAW;AACb;AACA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,qCAAqC;AACvC;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;AACA,kCAAkC;AAClC;EACE,gBAAgB;AAClB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mBAAmB;AACrB;AACA;;;EAGE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;;;EAGE,wBAAwB;AAC1B;AACA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,SAAS;EACT,YAAY;EACZ,YAAY;AACd;AACA;;EAEE,gCAAgC;EAChC,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,+EAAgE;EAChE,qBAAqB;AACvB;AACA;EACE,+EAAsE;EACtE,qBAAqB;AACvB;AACA;EACE,+EAAuE;EACvE,qBAAqB;AACvB;AACA;EACE,6EAAmE;EACnE,qBAAqB;AACvB;AACA;EACE,6EAAoE;EACpE,qBAAqB;AACvB;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;EACA;;IAEE,UAAU;EACZ;AACF;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;IACrB,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;;IAEE,UAAU;EACZ;AACF;;AAEA,eAAe;AACf;;EAEE,SAAS;EACT,eAAe;EACf,QAAQ;EACR,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,qBAAqB;IACrB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,wBAAwB;IACxB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,cAAc;IACd,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,wEAA8D;EAC9D,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,wEAAqE;EACrE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,wEAAoE;EACpE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,OAAO;EACP,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,oBAAoB;EACpB,gCAAgC;EAChC,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;AACA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+EAAoE;EACpE,qBAAqB;AACvB;AACA;EACE,+EAAmE;EACnE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,wBAAwB;EACxB,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4EAA+D;EAC/D,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,gCAAgC;IAChC,gCAAgC;EAClC;AACF;AACA;EACE;IACE,eAAe;IACf,UAAU;IACV,OAAO;IACP,gBAAgB;IAChB,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,gCAAgC;IAChC,gCAAgC;EAClC;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,2BAA2B;EAC7B;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,WAAW;EACb;AACF;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,WAAW;EACX,YAAY;EACZ,4EAAoE;EACpE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,4EAAqE;EACrE,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,6EAAgE;EAChE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,WAAW;EACb;AACF;;AAEA,kBAAkB;AAClB;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,qEAAqE;AACvE;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mEAAmD;EACnD,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,MAAM;AACR;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,OAAO;AACT;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,OAAO;AACT;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,OAAO;AACT;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,OAAO;EACP,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,6EAAgE;EAChE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;;AAEA,QAAQ;AACR;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;;EAEjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,cAAc;AAChB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6EAA0E;EAC1E,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,6EAA+D;EAC/D,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,wEAA0D;EAC1D,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,OAAO;EACP,uBAAuB;EACvB,iBAAiB;EACjB,2DAA2D;EAC3D,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mEAAyD;EACzD,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mEAAyD;EACzD,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mEAAyD;EACzD,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mEAAsD;EACtD,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,6EAAgE;EAChE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,MAAM;EACN,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;AACA;;EAEE,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;;EAEE,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,SAAS;EACT,aAAa;AACf;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,OAAO;EACP,SAAS;EACT,YAAY;EACZ,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,4EAAiE;EACjE,qBAAqB;AACvB;AACA;EACE,4EAAiE;EACjE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,SAAS;EACT,6EAAoE;EACpE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,SAAS;EACT,6EAAoE;EACpE,qBAAqB;AACvB;AACA;;EAEE,YAAY;AACd;AACA;EACE,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;AACjD;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2EAA8D;EAC9D,qBAAqB;AACvB;AACA;EACE,2EAAiE;EACjE,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,+CAA+C;EAC/C,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,qFAAwE;EACxE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,wBAAwB;IACxB,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,eAAe;IACf,WAAW;EACb;EACA;IACE,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,UAAU;EACZ;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,oBAAoB;EACtB;EACA;IACE,QAAQ;EACV;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;EACA;;;IAGE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,UAAU;IACV,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,QAAQ;IACR,mBAAmB;EACrB;EACA;IACE,SAAS;IACT,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,WAAW;IACX,aAAa;IACb,yBAAyB;EAC3B;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,uBAAuB;IACvB,UAAU;EACZ;EACA;IACE,MAAM;EACR;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,gBAAgB;IAChB,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,SAAS;IACT,SAAS;EACX;EACA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;IACT,SAAS;IACT,6EAAoE;IACpE,qBAAqB;IACrB,yBAAyB;EAC3B;EACA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;IACT,SAAS;IACT,6EAAoE;IACpE,qBAAqB;EACvB;EACA;;IAEE,YAAY;EACd;EACA;IACE,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;AACF;AACA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,wBAAwB;IACxB,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;AACF;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,yBAAyB;AACzB;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,wBAAwB;EACxB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,4EAA+D;EAC/D,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,OAAO;EACP,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;;GAEG;AACH;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mEAAuD;EACvD,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mEAAwD;EACxD,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,MAAM;EACN,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,MAAM;EACN,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;;;EAGE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,oFAAwE;EACxE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,oFAAwE;EACxE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;;GAEG;AACH;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yEAA+D;EAC/D,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,4EAA6D;EAC7D,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,4EAAoE;EACpE,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,4EAA+D;EAC/D,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gDAAgD;EAChD,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,wEAAgE;EAChE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,wEAAgE;EAChE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;;;;;;;;EAQE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,2EAAiE;EACjE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,MAAM;AACR;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,QAAQ;AACV;AACA;;EAEE,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;;GAEG;AACH;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;;;;EAKE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,4BAA4B;EAC5B,YAAY;EACZ,wBAAwB;EACxB,mEAAsD;EACtD,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,cAAc;EACd,6EAAsE;EACtE,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6EAAsE;EACtE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE;IACE,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qCAAqC;EACvC;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,SAAS;IACT,SAAS;EACX;EACA;IACE,eAAe;IACf,WAAW;IACX,wBAAwB;IACxB,kBAAkB;EACpB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,YAAY;EACd;EACA;;;;IAIE,YAAY;EACd;EACA;IACE,YAAY;IACZ,2BAA2B;EAC7B;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,cAAc;IACd,uBAAuB;EACzB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,4BAA4B;IAC5B,wBAAwB;IACxB,aAAa;IACb,mEAA6D;IAC7D,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,kBAAkB;EACpB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA,+BAA+B;AAC/B;;EAEE,kBAAkB;EAClB,SAAS;EACT,wEAA8D;EAC9D,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mFAAgF;EAChF,gCAAgC;AAClC;AACA;EACE,mFAA+E;EAC/E,gCAAgC;AAClC;AACA;EACE,mFAA6E;EAC7E,gCAAgC;EAChC,oCAAoC;EACpC,wCAAwC;EACxC,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mFAA6E;EAC7E,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,wEAA8D;EAC9D,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,wEAAqE;EACrE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,wEAAoE;EACpE,qBAAqB;AACvB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;AACA;;;;EAIE,sBAAsB;EACtB,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,OAAO;EACP,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,UAAU;EACV,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,OAAO;AACT;AACA;EACE,SAAS;EACT,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,wEAAkE;EAClE,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,6EAAkE;EAClE,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,MAAM;EACN,WAAW;EACX,UAAU;EACV,mEAAqD;EACrD,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,SAAS;EACT,eAAe;EACf,UAAU;AACZ;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;AACA;;;;;;;GAOG;AACH;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,SAAS;EACT,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,6EAAwE;EACxE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,YAAY;EACZ,WAAW;EACX,6EAAuE;EACvE,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,oDAAoD;EACpD,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,OAAO;EACP,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,QAAQ;AACV;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6EAAqE;EACrE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6EAAgE;EAChE,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,WAAW;EACX,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,6EAAsE;EACtE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,+CAA+C;AACjD;AACA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;EAC/C,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,wEAA0D;EAC1D,gEAAgE;EAChE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,2EAAkE;EAClE,qBAAqB;AACvB;AACA;EACE,2EAA6D;EAC7D,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,4EAAiE;EACjE,qBAAqB;AACvB;AACA;EACE,4EAAoE;EACpE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;AACA;EACE,4EAAiE;EACjE,qBAAqB;AACvB;AACA;EACE,4EAAiE;EACjE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA,cAAc;AACd;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,wBAAwB;IACxB,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;AACF;AACA;EACE;IACE,2DAA2D;EAC7D;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,oBAAoB;IACpB,qBAAqB;IACrB,8BAA8B;IAC9B,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;;IAEE,kBAAkB;IAClB,aAAa;EACf;EACA;;IAEE,OAAO,EAAE,cAAc;EACzB;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,kCAAkC;EACpC;EACA;IACE,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,6EAAoE;IACpE,qBAAqB;IACrB,eAAe;EACjB;EACA;IACE,6EAAqE;IACrE,qBAAqB;EACvB;EACA;IACE,OAAO;IACP,uBAAuB;IACvB,YAAY;EACd;EACA;IACE,UAAU;IACV,eAAe;IACf,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,QAAQ;EACV;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;IACV,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gCAAgC;IAChC,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,6EAAkE;IAClE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;IACE,MAAM;EACR;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,aAAa;EACf;EACA;;KAEG;AACL;AACA;EACE;IACE,eAAe;IACf,SAAS;IACT,wBAAwB;IACxB,2BAA2B;EAC7B;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;IACxB,+CAA+C;EACjD;EACA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,2DAA2D;EAC7D;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,WAAW;IACX,gCAAgC;IAChC,SAAS;IACT,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;EACV;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;IACd,QAAQ;EACV;EACA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,6EAAqE;IACrE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;IACV,iBAAiB;IACjB,SAAS;EACX;EACA;IACE,yBAAyB;IACzB,UAAU;IACV,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,4DAA4D;EAC9D;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;;IAEE,oBAAoB;EACtB;EACA;IACE,UAAU;EACZ;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,OAAO;AACT;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6EAAoE;EACpE,qBAAqB;AACvB;AACA;EACE,6EAA+D;EAC/D,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,wEAAgE;IAChE,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;EAChB;EACA;IACE,SAAS;IACT,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,eAAe;IACf,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,MAAM;IACN,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,MAAM;EACR;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,qBAAqB;IACrB,mBAAmB;IACnB,0BAA0B;EAC5B;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,OAAO;IACP,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;EACtB,4EAA4E;AAC9E;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,oDAAoD;AACtD;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,WAAW;AACb;;AAEA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;IACE,4BAA4B;IAC5B,kBAAkB;EACpB;EACA;IACE,4BAA4B;IAC5B,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,iBAAiB;IACjB,YAAY;EACd;AACF;AACA;EACE;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,4EAA4E;EAC9E;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,4BAA4B;IAC5B,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,4BAA4B;IAC5B,oBAAoB;EACtB;EACA;IACE,qBAAqB;IACrB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,iBAAiB;IACjB,2BAA2B;IAC3B,eAAe;EACjB;EACA;IACE,YAAY;IACZ,OAAO;EACT;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,8BAA8B;AAC9B;EACE,mEAA0D;EAC1D,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oDAAoD;EACpD,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,6EAAsE;EACtE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,6EAA2E;EAC3E,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE;IACE,2DAA2D;EAC7D;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,2DAA2D;IAC3D,YAAY;IACZ,SAAS;EACX;EACA;IACE,UAAU;IACV,cAAc;IACd,aAAa;IACb,cAAc;EAChB;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,aAAa;EACf;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA,mCAAmC;AACnC;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,6EAAsE;EACtE,qBAAqB;AACvB;AACA;EACE,6DAA6D;EAC7D,SAAS;EACT,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,mDAAmD;AACrD;AACA;EACE,WAAW;AACb;;AAEA;EACE;IACE,2DAA2D;EAC7D;AACF;AACA;AACA;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,2DAA2D;IAC3D,SAAS;IACT,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,mCAAmC;AACnC;EACE,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,wEAA0D;EAC1D,gEAAgE;EAChE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,2EAAkE;EAClE,qBAAqB;AACvB;AACA;EACE,2EAA6D;EAC7D,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,oBAAoB;EACpB,SAAS;AACX;AACA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,+CAA+C;AACjD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,4EAAiE;EACjE,qBAAqB;AACvB;AACA;EACE,4EAAoE;EACpE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;AACA;EACE,4EAAiE;EACjE,qBAAqB;AACvB;AACA;EACE,4EAAiE;EACjE,qBAAqB;AACvB;AACA;EACE;IACE,mCAAmC;EACrC;AACF;AACA;EACE;IACE,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,wBAAwB;EAC1B;EACA;IACE,OAAO;EACT;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,YAAY;IACZ,gBAAgB;EAClB;EACA;;IAEE,6BAA6B;EAC/B;AACF;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;AACnB;AACA;EACE,mEAA8D;EAC9D,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,6EAAqE;EACrE,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,6EAA2E;EAC3E,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,oDAAoD;EACpD,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,oDAAoD;EACpD,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;AACA;;;;;;;;;;EAUE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6EAAqE;EACrE,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,iCAAiC;EACjC,6CAA6C;EAC7C,wCAAwC;AAC1C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,6BAA6B;AAC/B;AACA;;;;;;;;;;EAUE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AACA;;;;;;;;;;EAUE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;;;;;;;;;;;EAWE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;;;;;;;;;;;;EAYE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;;;;;;;;;;;EAWE,yBAAyB;AAC3B;AACA;;;;;;;;;;;;EAYE,gBAAgB;EAChB,cAAc;AAChB;AACA;;;;;;;;;;;EAWE,mBAAmB;EACnB,YAAY;EACZ,SAAS;AACX;AACA;;;;;;;;;;;;EAYE,YAAY;AACd;AACA;;;;;;;;;;;;EAYE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA;;;;;;;;;;;EAWE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;;;;;;;;;;;EAWE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;;;;;;;;;;;;EAYE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;IACV,WAAW;EACb;EACA;IACE,aAAa;IACb,eAAe;IACf,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,wBAAwB;IACxB,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,UAAU;EACZ;EACA;;IAEE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;IACvB,eAAe;IACf,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,sBAAsB;EACxB;EACA;;;;;;;;;IASE,sBAAsB;EACxB;EACA;;;;;;;;;;;IAWE,eAAe;IACf,iBAAiB;EACnB;EACA;;;;;;;;;;;IAWE,aAAa;EACf;EACA;;;;;;;;;;IAUE,WAAW;EACb;EACA;;;;;;;;;;;IAWE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;AACF;AACA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,cAAc;AAChB;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iCAAiC;AACnC;AACA;;GAEG;AACH;;GAEG;AACH;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,OAAO;AACT;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,6EAA+D;EAC/D,8BAA8B;AAChC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;EACA;IACE,wBAAwB;IACxB,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,yEAAmE;IACnE,0BAA0B;EAC5B;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;;IAEE,YAAY;IACZ,wBAAwB;IACxB,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,MAAM;EACR;EACA;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,4BAA4B;IAC5B,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,SAAS;EACX;EACA;;;;IAIE,YAAY;IACZ,eAAe;EACjB;;EAEA;;;IAGE,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,mCAAmC;EACrC;AACF;;AAEA,8GAA8G;AAC9G,wDAAwD;AACxD;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;AACA;;;EAGE,+BAA+B;AACjC;AACA;;EAEE,+BAA+B;AACjC;AACA;;;EAGE,+BAA+B;AACjC;;AAEA,GAAG;AACH;EACE,+BAA+B;AACjC;AACA;;EAEE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;IACb,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;EACA;IACE,qBAAqB;IACrB,uBAAuB;EACzB;EACA;IACE,YAAY;EACd;EACA;IACE,mCAAmC;EACrC;AACF;AACA;EACE;IACE,mCAAmC;EACrC;AACF;AACA;EACE;IACE,mCAAmC;EACrC;AACF;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,iCAAiC;AACnC;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,0BAA0B;EAC1B,iCAAiC;AACnC;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,oCAAoC;EACpC,oBAAoB;EACpB,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;;AAEA;EACE;IACE,mCAAmC;EACrC;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA,oCAAoC;AACpC;EACE,YAAY;EACZ,QAAQ;EACR,MAAM;EACN,qBAAqB;EACrB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4EAAqE;EACrE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;EAC3B,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;IACX,0BAA0B;IAC1B,gBAAgB;EAClB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,iBAAiB;IACjB,0BAA0B;EAC5B;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;AACF;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA,6CAA6C;AAC7C;EACE,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;AACA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4EAAsE;EACtE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,iHAAiH;AACjH;;;;;;;;;EASE,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,MAAM;AACR;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;;EAEE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,SAAS;AACX;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;;;;;;;;EAQE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;;;;;;;;;;;;EAYE,4CAA4C;AAC9C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;;;;;;;;;;;EAWE,OAAO;AACT;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,gHAAgH;AAChH;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;AACA,oBAAoB;AACpB;EACE,aAAa;EACb,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,oCAAoC;AACtC;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;;;EAGE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,sCAAsC;IACtC,mCAAmC;IACnC,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,sBAAsB;EACxB;EACA;;;IAGE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;AACF;AACA,sCAAsC;AACtC;EACE,UAAU;EACV,aAAa;EACb,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,8BAA8B;AAChC;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;IACtB,MAAM;EACR;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,wBAAwB;IACxB,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,SAAS;AACX;AACA;;;;;;;EAOE,oBAAoB;AACtB;AACA;;;;;;;;EAQE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,6EAAiE;EACjE,qBAAqB;AACvB;AACA;;EAEE,6EAAyE;AAC3E;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,MAAM;AACR;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,OAAO;AACT;AACA;;GAEG;AACH;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;;;GAGG;AACH;;;GAGG;AACH;;;GAGG;AACH;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,qCAAqC,EAAE,OAAO;AAChD;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC,EAAE,OAAO;AAChD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,qDAAqD;AACvD;AACA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6EAAwE;AAC1E;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,QAAQ;EACR,WAAW;EACX,YAAY;AACd;AACA;EACE,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,SAAS;AACX;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6EAAsE;EACtE,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6EAAoE;EACpE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6EAAkE;EAClE,qBAAqB;AACvB;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,8BAA8B;AAChC;AACA;;;;;;;;;GASG;AACH;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mEAA8D;EAC9D,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,oDAAoD;EACpD,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,OAAO;EACP,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;AACV;AACA;;;;;;;;;EASE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,6EAAgE;EAChE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,OAAO;AACT;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,qCAAqC,EAAE,OAAO;EAC9C,kBAAkB,EAAE,OAAO;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,6EAA2E;EAC3E,qBAAqB;EACrB,sBAAsB;AACxB;AACA;;;;;;;;;;EAUE,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,6EAAuE;EACvE,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;;;;;;;EAQE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,OAAO;AACT;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,kCAAkC;AACpC;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,OAAO;AACT;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,sBAAsB;IACtB,qBAAqB;IACrB,SAAS;EACX;AACF;AACA;EACE;IACE,mBAAmB;IACnB,QAAQ;EACV;AACF;AACA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;AACA;;;;;;;;;;;EAWE,aAAa;AACf;AACA;EACE;;;;;;;;;;;IAWE,WAAW;IACX,YAAY;IACZ,aAAa;EACf;EACA;;;;;;;;;;;IAWE,aAAa;EACf;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;;;;;KAKG;EACH;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;EACjB;EACA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,4EAAmE;IACnE,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,yBAAyB;EAC3B;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,sBAAsB;IACtB,YAAY;IACZ,SAAS;IACT,UAAU;IACV,SAAS;IACT,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;EAClC;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,mCAAmC;EACrC;EACA;IACE,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;;;;;;;;;IASE,eAAe;EACjB;EACA;;;;;;;;;IASE,aAAa;EACf;EACA;;;;;;;;;IASE,aAAa;EACf;EACA;;;;;;;;;;;IAWE,YAAY;EACd;EACA;;;;;;;;;;;;IAYE,eAAe;EACjB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,OAAO;EACT;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,SAAS;IACT,WAAW;EACb;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;;;;;;;;;;EAUE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,wFAAiF;AACnF;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;;GAEG;AACH;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,OAAO;AACT;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,gDAAgD;EAChD,qBAAqB;EACrB,qDAAqD;EACrD,UAAU;AACZ;AACA;EACE,SAAS;EACT,YAAY;EACZ,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;;;;EAIE,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;;;;EAIE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;;;;;;;;;;;;EAYE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;;;;;;;;;;;;EAYE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;;;;EAIE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6EAAqE;EACrE,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,qCAAqC,EAAE,OAAO;AAChD;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,qCAAqC;AACvC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,qCAAqC,EAAE,OAAO;AAChD;AACA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;;EAEE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE,SAAS;EACT,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,OAAO;EACP,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,SAAS;AACX;AACA;EACE,6EAAuE;EACvE,qBAAqB;AACvB;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE;;IAEE,sBAAsB;EACxB;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;IACb,qBAAqB;EACvB;EACA;;IAEE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,aAAa;IACb,wBAAwB;EAC1B;EACA;;IAEE,aAAa;IACb,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,qCAAqC,EAAE,OAAO;AAChD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA,4BAA4B;AAC5B;EACE,YAAY;AACd;AACA;;;;;EAKE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,qDAAqD;AACvD;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,sBAAsB;EACtB,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,6EAAqE;AACvE;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE;;IAEE,YAAY;EACd;EACA;;IAEE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,yCAAyC;AAC3C;AACA;EACE,WAAW;EACX,6EAAmE;EACnE,qBAAqB;AACvB;AACA;EACE,wFAAiF;AACnF;AACA;EACE,wFAAiF;AACnF;AACA;EACE,wFAAkF;AACpF;AACA;EACE,wFAAmF;AACrF;AACA;EACE,wFAAiF;AACnF;AACA;EACE,WAAW;AACb;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+CAA+C;AACjD;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,SAAS;EACX;AACF;AACA,aAAa;AACb;EACE,MAAM;EACN,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,OAAO;AACT;AACA;EACE,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,kFAAkF;AACpF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,6EAAiE;EACjE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,6EAA6E;EAC7E,6EAAwE;EACxE,qBAAqB;AACvB;AACA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;IACd,wBAAwB;EAC1B;AACF;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAgCG;AACH;EACE,kBAAkB;EAClB,oBAAoB;EACpB,QAAQ;AACV;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,OAAO;EACP,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,6EAA2E;EAC3E,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE;;;;;;;;KAQG;EACH;IACE,sBAAsB;IACtB,eAAe;IACf,SAAS;EACX;AACF;AACA;EACE;IACE,SAAS;EACX;AACF;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,YAAY;EACZ,6EAAwE;EACxE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,mCAAmC;EACrC;AACF;AACA;EACE;IACE,mCAAmC;EACrC;AACF;AACA;EACE;IACE,mCAAmC;EACrC;AACF;;AAEA,2CAA2C;AAC3C;EACE,qBAAqB;AACvB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6EAAsE;EACtE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,QAAQ;AACV;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,MAAM;AACR;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;EACT,OAAO;AACT;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAkCE,OAAO;EACP,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,SAAS;AACX;AACA;;;;;;;;EAQE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;AACA;;;;;;;;;;;;;;;;;;;EAmBE,eAAe;EACf,gBAAgB;AAClB;AACA;;;;;;;;;EASE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;;EAEE,OAAO;AACT;AACA;EACE,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,SAAS;EACT,UAAU;AACZ;AACA;EACE,QAAQ;AACV;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,UAAU;EACV,6EAAwE;EACxE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,OAAO;EACP,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,SAAS;IACT,sBAAsB;IACtB,mBAAmB;EACrB;AACF;AACA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;AACA,iDAAiD;AACjD;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;;;EAUE,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;;;;;;;;;EAUE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,wBAAwB;AAC1B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;;;;;;;;;;IAUE,sBAAsB;EACxB;EACA;;;;;;;;;;;IAWE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;;;;;;IAME,eAAe;EACjB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;;KAEG;EACH;IACE,sBAAsB;EACxB;EACA;IACE,8BAA8B;IAC9B,MAAM;EACR;EACA;IACE,aAAa;EACf;EACA;;;;;;;;IAQE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;;;;;;;;;;IAUE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,wBAAwB;EAC1B;EACA;;;;;;;;;;IAUE,SAAS;IACT,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;;;;;;;;;;;;IAYE,sBAAsB;IACtB,SAAS;EACX;AACF;AACA;EACE;IACE,SAAS;EACX;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;IACxB,SAAS;EACX;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;;IAEE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,6BAA6B;IAC7B,gCAAgC;EAClC;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;;;;;;;;;;;IAWE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;;;;;;;;;;IAUE,SAAS;IACT,aAAa;IACb,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,aAAa;EACf;AACF;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;;;;;;;;;EASE,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,OAAO;AACT;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,SAAS;EACT,oBAAoB;AACtB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sEAAkE;AACpE;AACA;;EAEE,6EAA6D;EAC7D,qBAAqB;AACvB;AACA;EACE;;IAEE,gBAAgB;EAClB;AACF;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,QAAQ;EACR,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,MAAM;EACR;AACF;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE;IACE,QAAQ;EACV;AACF;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,QAAQ;EACV;AACF;AACA;EACE;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,qBAAqB;EACvB;AACF;AACA;EACE;IACE,oBAAoB;IACpB,wBAAwB;IACxB,mCAAmC;EACrC;AACF;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE;IACE,kCAAkC;IAClC,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,qBAAqB;IACrB,yBAAyB;EAC3B;AACF;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,2CAA2C;AAC3C;;EAEE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,OAAO;AACT;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,0BAA0B;AAC5B;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,QAAQ;EACV;AACF;AACA;EACE;;IAEE,sBAAsB;EACxB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,6EAAwE;AAC1E;AACA;EACE,6EAAwE;AAC1E;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,SAAS;IACT,WAAW;IACX,uBAAuB;EACzB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,QAAQ;EACV;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;;;;;;IAME,gBAAgB;EAClB;AACF;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,QAAQ;AACV;AACA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;AACA;EACE;IACE,mBAAmB;IACnB,MAAM;EACR;AACF;AACA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;;;;;;IAME,aAAa;EACf;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;;IAEE,eAAe;EACjB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;;;;;;IAME,mBAAmB;EACrB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;;;;;;IAME,aAAa;EACf;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,SAAS;AACX;AACA;;;;;;EAME,aAAa;AACf;AACA;;EAEE,aAAa;AACf;AACA;EACE;;;;;;;;;;;;IAYE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,SAAS;EACX;EACA;;;;;;;;;IASE,SAAS;EACX;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;;;;;;;;;IASE,SAAS;EACX;AACF;AACA;EACE;;;;;;;;;;;IAWE,qBAAqB;EACvB;AACF;AACA;EACE;;;;;;;;;;;;IAYE,oBAAoB;IACpB,kBAAkB;EACpB;EACA;;;;;;;;;;;;IAYE,iCAAiC;IACjC,SAAS;IACT,kBAAkB;EACpB;EACA;;;;;;;;;IASE,SAAS;EACX;EACA;;;;;;;;;;;;IAYE,aAAa;IACb,qBAAqB;IACrB,yBAAyB;EAC3B;AACF;AACA;;;;;;;;;;;;;EAaE,uBAAuB;EACvB,eAAe;AACjB;AACA;;;;;;;;;;;;;;EAcE,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;;;;;;;;;;IAUE,SAAS;EACX;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EACE,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA,4CAA4C;AAC5C;EACE,uBAAuB;AACzB;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE,WAAW;EACX,YAAY;EACZ,+EAAqE;EACrE,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,aAAa;EACb,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;;;;;;;;;;;EAWE,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE;;IAEE,SAAS;EACX;AACF;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;;;;;;;;;;EAUE,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;;;;;;;;;EASE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;;;;;;;;EASE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;;GAEG;AACH;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;;;;;EAUE,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE;;;;;;;;;;IAUE,kBAAkB;EACpB;AACF;AACA;EACE;;;;;;;;;;;IAWE,QAAQ;EACV;AACF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,eAAe;IACf,SAAS;EACX;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,oBAAoB;IACpB,wBAAwB;IACxB,mCAAmC;EACrC;AACF;AACA;EACE;;;;;;;;;;IAUE,8BAA8B;EAChC;AACF;AACA;EACE;;;;;;;;;;;IAWE,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,yBAAyB;EAC3B;AACF;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE;;;;;;;;IAQE,sBAAsB;EACxB;EACA;;;;;;;;IAQE,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,wCAAwC;IACxC,2CAA2C;EAC7C;EACA;IACE,YAAY;EACd;EACA;;;IAGE,eAAe;EACjB;AACF;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;;;;;;;;;;IAUE,kCAAkC;EACpC;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,yBAAyB;IACzB,0BAA0B;IAC1B,gBAAgB;EAClB;AACF;AACA;EACE,sBAAsB;AACxB;AACA;;;;;;;;;;EAUE,SAAS;EACT,YAAY;EACZ,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;;;;;;;;;;IAUE,eAAe;EACjB;AACF;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,QAAQ;EACV;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;;EAEE,8BAA8B;EAC9B,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE;;;;;;;;;;IAUE,aAAa;IACb,wBAAwB;EAC1B;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE;IACE,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,SAAS;IACT,WAAW;IACX,uBAAuB;EACzB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,mCAAmC;EACrC;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;AACA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,yBAAyB;AAC3B;AACA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,cAAc;EACd,WAAW;EACX,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB,SAAS;EACX;AACF;AACA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;;;;;;;;;;;EAWE,YAAY;EACZ,SAAS;AACX;AACA;;;;;;;;;;;;EAYE,eAAe;AACjB;AACA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;;;;;;;;IAQE,aAAa;IACb,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;AACA;EACE;;;;;;;;;;IAUE,gBAAgB;EAClB;AACF;AACA;EACE,sBAAsB;EACtB,MAAM;AACR;AACA;EACE,YAAY;AACd;AACA;EACE;;IAEE,YAAY;EACd;EACA;;;IAGE,eAAe;EACjB;AACF;AACA;EACE;IACE,SAAS;IACT,sBAAsB;IACtB,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,yCAAyC;EACzC,2CAA2C;AAC7C;AACA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,0CAA0C;EAC1C,2CAA2C;AAC7C;AACA;EACE,aAAa;AACf;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,0CAA0C;EAC1C,yCAAyC;AAC3C;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,yCAAyC;AAC3C;AACA;;EAEE,0CAA0C;AAC5C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA,oBAAoB;AACpB;EACE,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;;;;;;;;;EASE,cAAc;AAChB;AACA;;;;;;;;;EASE,aAAa;AACf;AACA;EACE,8BAA8B;AAChC;AACA;;;;;;;;;EASE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;;;;;;;;EASE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;;;;;;;;EAQE,aAAa;AACf;AACA;;;;;;;;EAQE,aAAa;AACf;AACA;EACE,WAAW;EACX,4EAA4E;EAC5E,0DAA0D;EAC1D,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;;;;;;;;;EASE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;AACA;;;;;;;;;;EAUE,UAAU;EACV,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;;;;;;;;EAQE,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,kCAAkC;EAClC,0CAA0C;EAC1C,8CAA8C;EAC9C,oBAAoB;AACtB;AACA;;;;;;;;EAQE,mBAAmB;AACrB;AACA;;;;;;;;EAQE,mBAAmB;AACrB;AACA;;;;;;;;EAQE,mBAAmB;AACrB;AACA;;;;;;;;EAQE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;;;;;;;;EAQE,8BAA8B;AAChC;AACA;;;;;;;;;EASE,mBAAmB;AACrB;AACA,oBAAoB;AACpB;EACE,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;;;;;;;;;EASE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,sEAAkE;AACpE;AACA;;EAEE,wFAAwE;EACxE,gCAAgC;EAChC,YAAY;AACd;AACA;;;;;;;;EAQE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;AACA;;;EAGE,2BAA2B;AAC7B;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,kHAAkH;AAClH;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;;;;;;;;EAQE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;;;;;;;;EAQE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;;;;;;EASE,eAAe;AACjB;AACA;;;;;;;;;EASE,WAAW;EACX,YAAY;EACZ,4EAAoE;EACpE,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;;;;;EASE,cAAc;AAChB;AACA;EACE;;;;;;;IAOE,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,QAAQ;AACV;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,oBAAoB;IACpB,eAAe;IACf,eAAe;IACf,aAAa;EACf;AACF;AACA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,aAAa;IACb,cAAc;EAChB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mBAAmB;IACnB,SAAS;EACX;AACF;AACA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;;;;;;;;;EASE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,SAAS;AACX;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;AACA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,uBAAuB;IACvB,QAAQ;EACV;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,wCAAwC;IACxC,2CAA2C;EAC7C;EACA;IACE,0CAA0C;EAC5C;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,SAAS;AACX;AACA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,QAAQ;IACR,sBAAsB;EACxB;EACA;IACE,mCAAmC;IACnC,wBAAwB;IACxB,WAAW;EACb;AACF;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,MAAM;AACR;AACA,4IAA4I;AAC5I;EACE,eAAe;AACjB;AACA;;EAEE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;;AAEA,kIAAkI;AAClI;EACE,aAAa;AACf;AACA;EACE;IACE,SAAS;EACX;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;;;;;EAKE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;;;;;EAKE,UAAU;AACZ;AACA;;;;;;;EAOE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,sEAAiE;AACnE;AACA;EACE,oBAAoB;AACtB;AACA;;;;;;;EAOE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;;;;;;;;EAQE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;EAClB;EACA;;;;;;;IAOE,sEAA2D;IAC3D,WAAW;IACX,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;EAClB;AACF;AACA;EACE,sEAA2D;EAC3D,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE;;IAEE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,OAAO;EACP,eAAe;AACjB;AACA;;;;;;EAME,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,6EAA2E;EAC3E,qBAAqB;AACvB;AACA;;;;;;;;;;;;;;;;;;;;;;EAsBE,6EAA2E;AAC7E;AACA,kBAAkB;AAClB;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE;IACE,yBAAyB;IACzB,WAAW;EACb;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,WAAW;EACX,wBAAwB;EACxB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,wEAAgE;AAClE;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,0CAA0C;AAC5C;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,4BAA4B;EAC5B,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;;EAEE,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;AACA;EACE,wEAAgE;AAClE;AACA;EACE,oBAAoB;AACtB;AACA;;;;;;;EAOE,oCAAoC;EACpC,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,YAAY;EACZ,SAAS;AACX;AACA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,cAAc;EAChB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iCAAiC;IACjC,kCAAkC;IAClC,oBAAoB;EACtB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,2BAA2B;IAC3B,eAAe;IACf,WAAW;EACb;EACA;IACE,YAAY;EACd;AACF;AACA,6HAA6H;AAC7H;;EAEE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6EAAqE;EACrE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6EAA+D;EAC/D,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;;;EAUE,aAAa;AACf;AACA;EACE,6EAAyF;EACzF,WAAW;EACX,aAAa;EACb,aAAa;AACf;AACA;;;;;;;;;;EAUE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,SAAS;AACX;AACA;;;;;;;;;;;;EAYE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,YAAY;EACZ,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,gCAAgC;EAChC,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,wCAAwC;EACxC,2CAA2C;EAC3C,gBAAgB;AAClB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;EAQE,6EAA0E;EAC1E,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;;;;;;;;;EASE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+EAAuE;EACvE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;;;;;;;;;;EAUE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;AACA;;;;;;;;;;;EAWE,kBAAkB;AACpB;AACA;;;;;;;;;;;;;EAaE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;EACE,UAAU;EACV,2BAA2B;AAC7B;AACA;;;;;;;;;;;;;EAaE,gBAAgB;AAClB;AACA;;;;;;;;;;;EAWE,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE;;;;;;;;;;;;IAYE,kCAAkC;EACpC;AACF;AACA;EACE;;;;;;;;;;;IAWE,MAAM;EACR;EACA;;;;;;;;;;IAUE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA,QAAQ;AACR;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;;;;;;;;;;EAUE,+EAAyE;EACzE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;AACA;;;;;;;;;;EAUE,WAAW;EACX,YAAY;EACZ,+EAAsE;AACxE;AACA;;;;;;;;;;EAUE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,6EAAyE;AAC3E;;AAEA,UAAU;AACV;EACE,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,SAAS;AACX;AACA;;;;;;;;;;EAUE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AACA;;;;;;;;;EASE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;;;;;;;;;;EAUE,+EAAuE;EACvE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;AACA;;;;;;;;;;;;EAYE,WAAW;AACb;AACA;EACE;IACE,SAAS;IACT,0BAA0B;IAC1B,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;AACF;;AAEA,kBAAkB;AAClB;;;;;;;;;;EAUE,WAAW;EACX,YAAY;EACZ,+EAA4E;AAC9E;AACA;;;;;;;;;EASE,mBAAmB;AACrB;AACA;;;;;;;;;;EAUE,cAAc;AAChB;AACA;EACE,6EAA6E;AAC/E;;AAEA,cAAc;AACd;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;AACA;;;;;;;;;;EAUE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE;IACE,SAAS;EACX;EACA;;;;;;;;;;IAUE,UAAU;IACV,SAAS;EACX;EACA;;;;;;;;;;;IAWE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA,YAAY;AACZ;;;;;;;;;;EAUE,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;AACA;EACE,OAAO;EACP,WAAW;AACb;AACA;;;;;;;;;;;EAWE,aAAa;AACf;AACA;;;;;;;;;;;EAWE,yBAAyB;EACzB,SAAS;AACX;AACA;;;;;;;;;;;;EAYE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;AACA;;;;;;;;;;EAUE,sBAAsB;EACtB,QAAQ;AACV;AACA;;;;;;;;;;;EAWE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;;;;;;;;;;EAYE,cAAc;AAChB;AACA;;;;;;;;;;;;EAYE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;;;;;;;;;;;;;EAaE,eAAe;EACf,iBAAiB;AACnB;AACA;;;;;;;;;;;;EAYE,aAAa;EACb,sBAAsB;AACxB;AACA;;;;;;;;;;;;;EAaE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;EA2BE,cAAc;AAChB;AACA;;;;;;;;;;;;;;EAcE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;;;;;;;;;EAUE,SAAS;AACX;AACA;;;;;;;;;;;EAWE,mBAAmB;AACrB;AACA;;;;;;;;;;;EAWE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;;;;;;;;;;;;EAYE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;;;;;;;;;EAYE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;AACA;;;;;;;;;;;;EAYE,cAAc;AAChB;AACA;;;;;;;;;;;;EAYE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,6EAA0E;EAC1E,qBAAqB;EACrB,sBAAsB;AACxB;AACA;;;;;;;;;;;;;EAaE,eAAe;AACjB;AACA;;;;;;;;;;EAUE,SAAS;EACT,uBAAuB;AACzB;AACA;;;;;;;;;;;EAWE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,iDAAiD;AACnD;AACA;;;;;;;;;;;EAWE,WAAW;AACb;AACA;;;;;;;;;;;;EAYE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;;;;;;;;;;;EAYE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;;;;;;;;IAQE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;;;;;;;;;;;IAWE,aAAa;EACf;AACF;AACA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;AACA;EACE;;;;;;;;;;IAUE,QAAQ;EACV;EACA;;;;;;;;;;IAUE,SAAS;IACT,iBAAiB;EACnB;EACA;;;;;;;;;;IAUE,kBAAkB;EACpB;EACA;;;;;;;;;;;IAWE,WAAW;EACb;AACF;AACA;EACE;;;;;;;;;;;IAWE,aAAa;EACf;AACF;AACA;EACE;IACE,qBAAqB;EACvB;EACA;;;;;;;;IAQE,oBAAoB;EACtB;EACA;;;;;;;;;;;IAWE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;;;;;;;;;;IAUE,eAAe;EACjB;AACF;AACA;EACE;;;;;;;;;;;IAWE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,SAAS;EACX;EACA;;;;;;;;;;IAUE,2BAA2B;IAC3B,SAAS;EACX;EACA;;;;;;;;;;IAUE,aAAa;EACf;AACF;AACA,gBAAgB;AAChB;EACE;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;AACA;EACE;;;;;;;;IAQE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;AACA;EACE;;;;;;;;;IASE,iCAAiC;EACnC;EACA;;;;;;;;;;IAUE,wBAAwB;EAC1B;EACA;;;;;;;;;;;IAWE,sBAAsB;EACxB;EACA;;;;;;;;IAQE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF;AACA;EACE;;;;;;;;;IASE,8BAA8B;EAChC;EACA;;;;;;;;IAQE,oBAAoB;EACtB;AACF;;AAEA,eAAe;AACf;;;;;;;;;EASE,aAAa;AACf;AACA;;;;;;;;;EASE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;;;;;;;;;;EAUE,2BAA2B;AAC7B;AACA;;;;;;;;;;EAUE,gBAAgB;AAClB;AACA;EACE;;;;;;;;;IASE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;;;;;;;;;;IAUE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;;;;;;;;;;IAUE,WAAW;IACX,kBAAkB;EACpB;EACA;;IAEE,oBAAoB;EACtB;AACF;AACA;EACE;;;;;;;;;IASE,wBAAwB;EAC1B;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;;;;;;;;;EASE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;;;;;;;;;;EAUE,yBAAyB;AAC3B;AACA;;;;;;;;;;;EAWE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;;;;;;;;;;;EAWE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;AACA;;;;;;;;;;;EAWE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,6EAAwF;EACxF,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;;;;;;;;;;;;EAYE,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,SAAS;AACX;AACA;;;;;;;;;;;;;EAaE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;;;;;;;;;;;;;;EAcE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;EAcE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;;;;;;;;;;;;;;EAeE,cAAc;AAChB;AACA;;;;;;;;;;;;;EAaE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE;;;;;;;;;;;;IAYE,sBAAsB;IACtB,aAAa;IACb,wBAAwB;IACxB,MAAM;EACR;EACA;;;;;;;;;;;;;IAaE,QAAQ;EACV;EACA;;;;;;;;;;;;;;IAcE,eAAe;IACf,iBAAiB;EACnB;EACA;;;;;;;;;;;;;IAaE,kBAAkB;EACpB;AACF;AACA;EACE;;;;;;;;;;;;IAYE,kBAAkB;IAClB,wBAAwB;EAC1B;AACF;;AAEA,cAAc;AACd;EACE,+BAA+B;EAC/B,kBAAkB;EAClB;;gEAE8D;AAChE;AACA;;EAEE;;gEAE8D;AAChE;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,mEAAkF;EAClF,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,SAAS;EACX;EACA;IACE,MAAM;IACN,8BAA8B;IAC9B,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,YAAY;EACd;AACF;;AAEA,OAAO;AACP;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,2CAA2C;AAC7C;AACA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;EAC7B,2CAA2C;EAC3C,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,8BAA8B;AAChC;;AAEA,cAAc;AACd;EACE,8BAA8B;AAChC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,sCAAsC;EACxC;EACA;;IAEE,wBAAwB;EAC1B;AACF;;AAEA,gBAAgB;AAChB;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA,mBAAmB;AACnB;;EAEE,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,2CAA2C;AAC7C;AACA;EACE,yCAAyC;AAC3C;AACA;;;;;;;EAOE,0CAA0C;AAC5C;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,8BAA8B;EAC9B,oCAAoC;AACtC;AACA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,qDAAyC;AAC3C;AACA;EACE,qDAA0C;AAC5C;AACA;EACE;IACE,wBAAwB;IACxB,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,mCAAmC;IACnC,gBAAgB;IAChB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA,QAAQ;AACR;EACE;;;;;;;;IAQE,SAAS;EACX;AACF;AACA;EACE;IACE,iCAAiC;EACnC;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,SAAS;EACX;AACF;AACA;EACE;;;;;;;;;;;;;;;;;;;;IAoBE,0BAA0B;EAC5B;EACA;;;;;;;;;IASE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,2BAA2B;IAC3B,iCAAiC;EACnC;EACA;IACE,2BAA2B;IAC3B,gBAAgB;EAClB;EACA;IACE,qBAAqB;IACrB,SAAS;EACX;EACA;IACE,oBAAoB;EACtB;EACA;IACE,SAAS;EACX;EACA;;;;;;;;;;;;;IAaE,UAAU;EACZ;EACA;;;;;;;;IAQE,qBAAqB;EACvB;EACA;;;;;;;;IAQE,sBAAsB;EACxB;EACA;;;;;;;;;;;IAWE,eAAe;EACjB;EACA;;;;;;;;;;;;;;;;;;;;;;IAsBE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;;;;;;;;;IASE,SAAS;EACX;EACA;;;;;;;;;;IAUE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;;;;;;;;;;IAUE,gBAAgB;EAClB;EACA;;;;;;;;;;;IAWE,UAAU;EACZ;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,0BAA0B;EAC5B;EACA;;;;;;;;;;;IAWE,kBAAkB;EACpB;EACA;;;;;;;;;;IAUE,2BAA2B;EAC7B;EACA;;;;;;;;;;;IAWE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;;;;;;;;IAQE,oBAAoB;EACtB;EACA;;;;;;;;;IASE,mBAAmB;EACrB;EACA;;;;;;;;;;;;IAYE,iBAAiB;EACnB;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;;;;IAIE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;;AAEA,cAAc;AACd;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;;AAEA,mBAAmB;AACnB;;EAEE,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oCAAoC;AACtC;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,2CAA2C;AAC7C;AACA;EACE,yBAAyB;AAC3B;AACA;;;;;;;;;;EAUE,0BAA0B;AAC5B;AACA;EACE,yCAAyC;AAC3C;AACA;;;;;;;;;;;;;;;;;;;;EAoBE,0CAA0C;AAC5C;AACA;;;;;;;;;;;EAWE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA,0IAA0I;AAC1I;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,2DAA0D;AAC5D;AACA;EACE,qCAAqC;AACvC;AACA;EACE,wEAAmE;EACnE,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,QAAQ;EACR,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,MAAM;AACR;AACA;EACE,UAAU;EACV,MAAM;EACN,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,cAAc;EACd,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,MAAM;EACN,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,2BAA2B;EAC3B,4BAA4B;EAC5B,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,uCAAuC;EACvC,SAAS;EACT,YAAY;AACd;AACA;;;EAGE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,6DAA6D;EAC7D,YAAY;EACZ,sBAAsB;EACtB;qBACmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;EACA;IACE,YAAY;IACZ,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,uCAAuC;EACzC;AACF;AACA,UAAU;AACV;EACE,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;EAQE,eAAe;AACjB;AACA;;;;;;;;;EASE,aAAa;EACb,mBAAmB;AACrB;AACA;;;;;;;;;;EAUE,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;;;;;;;;;EAWE,iBAAiB;AACnB;AACA;;;;;;;;;;EAUE,WAAW;AACb;AACA,kBAAkB;AAClB;EACE,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,6DAA6D;EAC7D,iBAAiB;AACnB;AACA;;;;;;;;EAQE,aAAa;AACf;;AAEA;;;gEAGgE;AAChE,kEAAkE;AAClE;EACE,yBAAyB;AAC3B;AACA;EACE;;IAEE,WAAW;EACb;AACF;AACA;8CAC8C;AAC9C;;;;;;;;EAQE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;4DAC4D;AAC5D;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA,sDAAsD;AACtD;sDACsD;AACtD;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;8CAG8C;AAC9C,oDAAoD;AACpD;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;EACX,yBAAyB;EACzB;iDAC+C;EAC/C,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;4CAC4C;AAC5C;;EAEE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;2CAC2C;AAC3C;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA,6CAA6C;AAC7C;;EAEE,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;AAClB;AACA,uBAAuB;AACvB;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;4CAC4C;AAC5C;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,mBAAmB;AACrB;;AAEA;;+DAE+D;AAC/D;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA,0CAA0C;AAC1C;EACE,YAAY;EACZ,iBAAiB;AACnB;;;AAGA,wBAAwB;AACxB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kDAAkD;AACpD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,qDAAqD;AACvD;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;;8EAO8E;;AAE9E;;+DAE+D;AAC/D;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA,mEAAmE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA,qEAAqE;AACrE;EACE,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;AACA,gCAAgC;AAChC;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,+BAA+B;EAC/B,iCAAiC;EACjC,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,4BAA4B;AAC5B,uEAAuE;AACvE;EACE,OAAO;EACP,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE;IACE,WAAW;IACX,cAAc;EAChB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;AACA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;;yDAEyD;AACzD;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;;EAGE,mBAAmB;AACrB;AACA;EACE;;IAEE,mBAAmB;EACrB;AACF;AACA;EACE;;;;IAIE,mBAAmB;EACrB;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,SAAS;EACT,oCAAoC;EACpC,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;AACA,oCAAoC;AACpC;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA,2CAA2C;AAC3C;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;qDACqD;AACrD;EACE,0BAA0B;AAC5B;AACA;EACE,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA,+CAA+C;AAC/C;EACE,mBAAmB;AACrB;AACA;gDACgD;AAChD;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gDAAgD;EAChD,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,aAAa;AACf;AACA;;EAEE,YAAY;EACZ,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;AACA;;EAEE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ;6DAC2D;EAC3D,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA,qDAAqD;AACrD;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;AACA;;;;EAIE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,yBAAyB;AAC3B;;AAEA;;;uEAGuE;AACvE;;EAEE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;AACd;AACA;;EAEE,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;;EAEE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,sEAAsE;EACtE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;uEAGuE;AACvE;;;EAGE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,YAAY;EACZ,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA,+CAA+C;AAC/C;EACE,iBAAiB;AACnB;;AAEA,gDAAgD;AAChD;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;8EAI8E;AAC9E;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;AACA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,oDAAoD;EACpD,WAAW;EACX,kBAAkB;AACpB;AACA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mCAAmC;AACnC,sDAAsD;AACtD;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA,iDAAiD;AACjD;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;;AAEA,sEAAsE;AACtE;EACE,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA,qCAAqC;AACrC;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA,wDAAwD;AACxD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;AACA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,gCAAgC;AAClC;AACA;;EAEE,YAAY;EACZ,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;AACA,oCAAoC;AACpC;;EAEE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;;8CAE8C;AAC9C;EACE,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,kBAAkB;AACpB;AACA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA,wCAAwC;AACxC;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;8EAE8E;AAC9E;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,iDAAiD;EACjD,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,2CAA2C;EAC3C,WAAW;EACX,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA,iCAAiC;AACjC;mEACmE;AACnE;EACE,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA,wDAAwD;AACxD;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;AACA,wCAAwC;AACxC;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC,uBAAuB;AACvB;;EAEE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;;EAEE,oBAAoB;AACtB;AACA,gDAAgD;AAChD;EACE,YAAY;AACd;AACA,4BAA4B;AAC5B;EACE,qCAAqC;AACvC;AACA,6CAA6C;AAC7C;EACE,aAAa;EACb,WAAW;AACb;AACA;gDACgD;AAChD;;EAEE,yDAAyD;AAC3D;AACA;EACE,qCAAqC;AACvC;AACA,oCAAoC;AACpC;;;;uEAIuE;AACvE;EACE,yBAAyB;AAC3B;AACA,yDAAyD;AACzD;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;yDACyD;AACzD;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;8EAI8E;AAC9E;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;AACA;uCACuC;AACvC;EACE,oBAAoB;EACpB,QAAQ;EACR,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;;oDAEoD;AACpD;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,SAAS;AACX;AACA,0BAA0B;AAC1B;EACE,cAAc;AAChB;AACA;;;;uEAIuE;AACvE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;oDACoD;AACpD;EACE,YAAY;AACd;AACA,sDAAsD;AACtD;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;AACA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;AACA,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA,kEAAkE;AAClE;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,OAAO;EACP,UAAU;EACV,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,UAAU;EACV,+BAA+B;AACjC;AACA,oBAAoB;AACpB;EACE,cAAc;AAChB;AACA,sBAAsB;AACtB;EACE,gCAAgC;AAClC;AACA,4CAA4C;AAC5C;EACE,gCAAgC;AAClC;AACA;8CAC8C;AAC9C;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA,6BAA6B;AAC7B;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA,gCAAgC;AAChC;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;AACA,uCAAuC;AACvC;;;EAGE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA,iBAAiB;AACjB;;oDAEoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,gBAAgB;AAClB;AACA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA,6BAA6B;AAC7B;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;gEACgE;AAChE;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;;;;;;+EAQ+E;AAC/E;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;;;+EAG+E;AAC/E;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;;AAEA,qEAAqE;AACrE;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB","sourcesContent":["@charset \"UTF-8\";\n\n/********************************************* 컨텐츠 *********************************************/\n/* e-HC Status */\n.box__status {\n  display: flex;\n  flex-direction: column;\n}\n.status__info {\n  display: flex;\n  flex-direction: column;\n}\n.status__info li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 2px;\n  padding: 0 24px 0 16px;\n  width: calc(100% - 40px);\n  height: 48px;\n  background: #f8f8fb;\n}\n.status__info li:first-child {\n  margin-top: 0;\n}\n.status__info li p {\n  color: #2a2c2f;\n}\n.status__info li p:first-child {\n  width: 75%;\n  font-weight: 500;\n}\n.status__info li p:last-child {\n  width: 25%;\n  text-align: right;\n}\n.status__info li p strong {\n  font-weight: 500;\n}\n.status__info li p span {\n  color: #909fb7;\n  margin-left: 0.5rem;\n}\n.status__data {\n  display: flex;\n  justify-content: center;\n  margin-top: 22px;\n}\n.status__data li {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.status__data li:last-child {\n  padding-right: 14px;\n}\n.status__data li:before {\n  content: \"\";\n  height: 40px;\n  border-left: 1px solid #dde2e9;\n  padding-left: 2px;\n  margin-left: 2px;\n}\n.status__data li:first-child::before {\n  content: none;\n}\n.status__data li:last-child::before {\n  padding-left: 35px;\n}\n.status__data li a {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 104px;\n  height: 128px;\n  border-radius: 4px;\n  border: 1px solid #fff;\n}\n.status__data li a::before {\n  content: \"B\";\n  color: #fff;\n  font-size: 1.188rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  margin-bottom: 9px;\n  background-color: #5b71ef;\n}\n.status__data li:nth-child(2) a::before {\n  content: \"P\";\n  background-color: #13a79e;\n}\n.status__data li:nth-child(3) a::before {\n  content: \"A\";\n  background-color: #ff9900;\n}\n.status__data li:nth-child(4) a::before {\n  content: \"\";\n  background: url(\"../img/bg_normal.png\") no-repeat center 12px #1fc95c;\n  background-size: 0.604rem 1.167rem;\n}\n.status__data li a:focus,\n.status__data li a.on {\n  cursor: pointer;\n  width: 102px;\n  /* width: 100%; */\n  height: 126px;\n  box-shadow: 0px 4px 4px rgba(144, 159, 183, 0.5);\n}\n.status__data li:nth-child(1) a:focus,\n.status__data li:nth-child(1) a.on {\n  border: 2px solid #5b71ef;\n  background: #eff1fe;\n}\n.status__data li:nth-child(2) a:focus,\n.status__data li:nth-child(2) a.on {\n  background: #e6fcfa;\n  border: 2px solid #13a79e;\n}\n.status__data li:nth-child(3) a:focus,\n.status__data li:nth-child(3) a.on {\n  background: #fff5e6;\n  border: 2px solid #ff9900;\n}\n.status__data li:nth-child(4) a:focus,\n.status__data li:nth-child(4) a.on {\n  background: #e9faef;\n  border: 2px solid #1fc95c;\n}\n.status__data li p.name {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 10px;\n  color: #2a2c2f;\n  letter-spacing: -0.075rem;\n}\n.status__data li p.txt {\n  font-weight: 500;\n  font-size: 30px;\n  line-height: 28px;\n  color: #2a2c2f;\n  margin-top: 12px;\n}\n.status__data li a:focus p.name,\n.status__data li a.on p.name {\n  font-weight: 500;\n}\n.status__data li a:focus p.txt,\n.status__data li a.on p.txt {\n  font-weight: 700;\n}\n.box__setting {\n  display: none;\n}\n.box.on .box__setting {\n  position: absolute;\n  top: -48px;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 100%;\n  padding-top: 48px;\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 4px;\n}\n.box.on .btn-setting.toggle {\n  position: relative;\n  z-index: 2;\n  background: url(\"../img/icon_setting_on.png\") no-repeat center center;\n}\n.box__setting .form__input {\n  height: calc(100% - 72px);\n  width: 80%;\n  margin: 0 auto;\n}\n.box__setting .form__input li {\n  justify-content: center;\n}\n.box__setting .form__input li .select ul li {\n  justify-content: unset;\n}\n.box__setting .form__input .input__area {\n  width: 70%;\n}\n.box__setting .popup__footer {\n  border-top: 0;\n  padding-bottom: 0;\n}\n\n/* e-HC Work Order */\n.box__status .txt-info {\n  line-height: 1.7;\n}\n.content > .box .box__body .step-order {\n  display: flex;\n  justify-content: space-between;\n}\n.content > .box .box__body .step-order li {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  flex: 1;\n  background: #fff;\n  height: 60px;\n  padding: 16px 14px 12px;\n}\n.content > .box .box__body .step-order li + li {\n  margin-left: 12px;\n}\n.content > .box .box__body .step-order li:last-child {\n  background: none;\n}\n.content > .box .box__body .step-order li .tit {\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 14px;\n  letter-spacing: -0.4px;\n  color: #646c74;\n}\n.content > .box .box__body .step-order li .total-num {\n  font-weight: 500;\n  font-size: 13px;\n  text-align: right;\n  color: #646c74;\n}\n.content > .box .box__body .step-order li .total-num strong {\n  font-size: 26px;\n  color: #003876;\n}\n@media screen and (max-width: 499px) {\n  .content > .box .box__body .step-order li {\n    padding: 14px 9px 10px;\n    height: 56px;\n  }\n  .content > .box .box__body .step-order li .tit {\n    font-size: 14px;\n  }\n  .content > .box .box__body .step-order li .total-num {\n    font-size: 12px;\n  }\n  .content > .box .box__body .step-order li .total-num strong {\n    font-size: 22px;\n  }\n  .content > .box .box__body .step-order li + li {\n    margin-left: 7px;\n  }\n}\n@media screen and (max-width: 380px) {\n  .content > .box .box__body .step-order li {\n    padding: 14px 4px 10px;\n  }\n  .content > .box .box__body .step-order li + li {\n    margin-left: 3px;\n  }\n}\n\n/* e-HC List */\n.box.list .box__header {\n  border-bottom: 0;\n}\n.box.list .box__body {\n  padding-top: 0;\n  height: calc(100% - 63px);\n}\n.box.list .box__body .tbl-list {\n  height: calc(100% - 93px);\n  border-bottom: 1px solid #dde2e9;\n}\n.box.list .box__body .tbl-list table {\n  border-bottom: 0;\n}\n.tbl-list .btn-renew {\n  margin: 0 auto;\n  color: #909fb7;\n  background: url(\"../img/icon_renew_small.png\") no-repeat 7px center transparent;\n  background-size: 20px 20px;\n}\n.tbl-list .btn-renew span {\n  padding-left: 17px;\n  font-size: 13px;\n  color: #909fb7;\n}\n.tbl-list table.pd-13 th,\n.tbl-list table.pd-13 td {\n  padding-top: 13px;\n  padding-bottom: 13px;\n}\n.searchinput {\n  display: flex;\n  align-items: center;\n}\n.searchinput .select + .input__direct {\n  margin-left: 8px;\n}\n.icon-step {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.icon-step li {\n  width: 8px !important;\n  height: 8px !important;\n  background: #dde2e9;\n  margin-left: 2px;\n}\n.icon-step li:first-child {\n  margin-left: 0;\n}\n.icon-step.one li:nth-child(1) {\n  background: #5b71ef;\n}\n.icon-step.two li:nth-child(1) {\n  background: #5b71ef;\n}\n.icon-step.two li:nth-child(2) {\n  background: #13a79e;\n}\n.icon-step.all li:nth-child(1) {\n  background: #5b71ef;\n}\n.icon-step.all li:nth-child(2) {\n  background: #13a79e;\n}\n.icon-step.all li:nth-child(3) {\n  background: #ff9900;\n}\n/* 상세정보 페이지 팝업 */\n.page-detail .popup__head {\n  border-bottom: 0;\n}\n/* 20220629 =======================   layout_안내팝업.html : 498 ~ 517 참고  ===================================== */\n.page-detail .popup__head-opinion {\n  border-bottom: 0;\n}\n/* ============================================================================================================== */\n\n/* 20220628 =======================   layout_안내팝업.html : 926 ~ 940 참고  ===================================== */\n.page-detail .popup__head-restart {\n  border-bottom: 0;\n}\n/* ============================================================================================================== */\n\n.page-detail .popup__footer {\n  border-top: 0;\n  padding-top: 0;\n}\n\n/* 20220629 =======================   layout_안내팝업.html : 498 ~ 517 참고  ===================================== */\n.page-detail .popup__footer-opinion {\n  border-top: 0;\n  padding-top: 0;\n}\n/* ============================================================================================================== */\n/* 20220628 =======================   layout_안내팝업.html : 926 ~ 940 참고  ===================================== */\n.page-detail .popup__footer-restart {\n  border-top: 0;\n  padding-top: 0;\n}\n/* ============================================================================================================== */\n.page-detail .popup__body {\n  margin-top: -1rem;\n}\n/* 20220629 =======================   layout_안내팝업.html : 498 ~ 517 참고  ===================================== */\n.page-detail .popup__body-opinion {\n  margin-top: -1rem;\n}\n/* ============================================================================================================== */\n.page-detail .datadetail-info {\n  margin-top: -8px;\n}\n.page-detail .datadetail-info li {\n  display: flex;\n  margin-top: 1rem;\n}\n.page-detail .datadetail-info li:first-child {\n  margin-top: 0;\n}\n.page-detail .datadetail-info feSpotLight {\n  display: flex;\n  flex-direction: column;\n}\n.page-detail .datadetail-info li p:first-child {\n  width: 90px;\n  color: #909fb7;\n}\n.page-detail .datadetail-info li .icon-step {\n  margin: 0 auto;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-top: 4px;\n  margin-left: 1rem;\n}\n.page-detail .datadetail-info li .icon-step li {\n  margin-top: 0;\n  width: 12px !important;\n  height: 10px !important;\n  margin-left: 4px;\n  border: 0;\n}\n.page-detail .datadetail-info li .icon-step li:first-child {\n  margin-left: 0;\n}\n.page-detail .datadetail-info li.btnarea {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 40px 0 18px;\n}\n.page-detail .datadetail-info li.btnarea div {\n  width: 33%;\n}\n.page-detail .datadetail-info li.btnarea div p {\n  font-size: 14px;\n  color: #2a2c2f;\n}\n.page-detail .datadetail-info li.btnarea div button {\n  margin: 0 auto;\n  height: 40px;\n  width: 100%;\n}\n.page-detail .datadetail-info li div .btn-file {\n  background: url(\"../img/icon_file@3x.png\") no-repeat center center;\n  background-size: 0.75rem 1.449rem;\n}\n.page-detail .datadetail-info li div .btn-memo {\n  border-radius: 0;\n  background: url(\"../img/icon_memo@3x.png\") no-repeat center center;\n  background-size: 1.167rem 1.167rem;\n}\n.page-detail .datadetail-info li.btnarea div button.btn-file.btn:disabled:hover {\n  background: url(\"../img/icon_file@3x.png\") no-repeat center center;\n  background-size: 0.75rem 1.449rem;\n}\n.d-sm-block-toggle {\n  display: none;\n}\n/* 데이터 검색결과 없음 */\n.nodata {\n  display: flex;\n  flex-direction: column;\n  /* height: calc(100% - 63px); */\n}\n/* .nodata .tbl__top {\n  display: none;\n} */\n.nodata .tbl-list {\n  display: none;\n}\n.nodata .paging {\n  display: none;\n}\n.nodata .result__num {\n  display: none;\n}\n.nodata .nodata__txt {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 60vh;\n  font-size: 14px;\n  line-height: 1.4;\n  text-align: center;\n  letter-spacing: -0.4px;\n  color: #909fb7;\n}\n.nodata .nodata__txt::before {\n  content: \"\";\n  width: 164px;\n  height: 92px;\n  margin-bottom: 16px;\n  background: url(\"../img/bg_nodata.png\") no-repeat center center;\n  background-size: 100%;\n}\n.nodata__txt {\n  display: none;\n}\n.nodata .nodata__txt.w800 {\n  width: 800px;\n  border-top: 1px solid #dde2e9;\n  border-bottom: 1px solid #dde2e9;\n  padding: 168px 0 186px;\n}\n.nodata .nodata__txt.w800::before {\n  width: 120px;\n  height: 100px;\n  margin-bottom: 0;\n}\n.nodata .nodata__txt.w800 span {\n  font-size: 0.875rem;\n  margin-top: 9px;\n  text-align: center;\n}\n.nodata-intable {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.nodata-intable::before {\n  content: \"\";\n  width: 24px;\n  height: 24px;\n  background: url(\"../img/icon_x_b@3x.png\") no-repeat center center;\n  background-size: 100%;\n}\n\n/* Basic e-HC */\n.box.ehc__score .box__body {\n  height: calc(100% - 80px);\n}\n.ehc-b .box__title .cate {\n  font-weight: 700;\n}\n.ehc-b .box__title .cate {\n  color: #5b71ef;\n}\n.ehc-p .box__title .cate {\n  color: #13a79e;\n}\n.ehc-a .box__title .cate {\n  color: #ff9900;\n}\n.ehc-n .box__title .cate {\n  color: #1fc95c;\n}\n.ehc-b .box__title .cate span,\n.ehc-p .box__title .cate span,\n.ehc-a .box__title .cate span,\n.ehc-n .box__title .cate span {\n  color: #2a2c2f;\n}\n.box__etc .date {\n  font-size: 15px;\n  color: #2a2c2f;\n}\n.ehc__info {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  position: absolute;\n  top: 1rem;\n  width: calc(100% - 4rem);\n  background: #f8f8fb;\n  color: #2a2c2f;\n  padding: 0.75rem 1rem;\n  z-index: 2;\n}\n.ehc__info.on {\n  box-shadow: 0px 2px 8px rgba(144, 159, 183, 0.5);\n}\n.ehc__name {\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n}\n.ehc__name::before {\n  content: \"\";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  border-radius: 50%;\n  width: 1.5rem;\n  height: 1.5rem;\n  margin-right: 0.5rem;\n}\n.ehc-b .ehc__name::before {\n  content: \"B\";\n  background-color: #5b71ef;\n}\n.ehc-p .ehc__name::before {\n  content: \"P\";\n  background-color: #13a79e;\n}\n.ehc-a .ehc__name::before {\n  content: \"A\";\n  background-color: #ff9900;\n}\n.ehc-n .ehc__name::before {\n  content: \"N\";\n  background-color: #1fc95c;\n}\n.ehc__info ul {\n  position: relative;\n  cursor: pointer;\n  padding-right: 1.75rem;\n  height: 25px;\n  overflow: hidden;\n}\n.ehc__info ul::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  top: 1px;\n  width: 1.25rem;\n  height: 1.25rem;\n  background: url(\"../img/icon_nav_d_s.png\") no-repeat 0 0;\n}\n.ehc__info ul.on {\n  height: 100%;\n  overflow: unset;\n}\n.ehc__info ul.on::after {\n  transform: rotate(180deg);\n}\n.ehc__info ul li {\n  margin-top: 1rem;\n  display: flex;\n}\n.ehc__info ul li:first-child {\n  margin-top: 0.25rem;\n}\n.ehc__info ul li span {\n  text-align: left;\n}\n.ehc__info ul li span:first-child {\n  width: 5rem;\n  margin-right: 1.375rem;\n  color: #909fb7;\n}\n.ehc__detail {\n  margin: 4.5rem 0 2.5rem;\n}\n.ehc__detail p.tit {\n  color: #2a2c2f;\n  font-weight: 500;\n  font-size: 1.25rem;\n  line-height: 1.813rem;\n}\n.ehc__detail p.txt {\n  margin-top: 2px;\n  margin-left: 1.375rem;\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.438rem;\n  color: #2a2c2f;\n}\n.ehc__selectbtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 3.5rem 2rem 4.5rem;\n}\n.ehc__selectbtn li {\n  position: relative;\n  margin-left: 1rem;\n  max-width: 4.5rem;\n  width: calc(100% / 5);\n  height: 4.5rem;\n  /* background: #f8f8fb; */\n  /* border: 1px solid #dde2e9; */\n  border-radius: 8px;\n}\n.ehc__selectbtn li:first-child {\n  margin-left: 0;\n}\n.ehc__selectbtn button {\n  width: 100%;\n  height: 100%;\n  background: #f8f8fb;\n  border: 1px solid #dde2e9;\n  border-radius: 8px;\n}\n.ehc__selectbtn button:first-child {\n  margin-left: 0;\n}\n.ehc__selectbtn button span {\n  font-family: \"Urbanist\", sans-serif;\n  font-weight: 500;\n  font-size: 28px;\n  color: #2a2c2f;\n}\n.ehc__selectbtn button:hover {\n  background-color: #b4d2ff;\n}\n.ehc__selectbtn button:active,\n.ehc__selectbtn button.on {\n  background-color: #0a78ff;\n  border-color: #0a78ff;\n}\n.ehc__selectbtn button:active span,\n.ehc__selectbtn button.on span {\n  color: #fff;\n  font-weight: 600;\n}\n.ehc__selectbtn button:disabled span {\n  color: #dde2e9;\n}\n.ehc__selectbtn.disabled {\n  background: none;\n  border: 0;\n}\n.ehc__selectbtn button:disabled {\n  background: #f8f8fb;\n  border: 1px solid #f0f2f4;\n}\n.ehc__selectbtn button:disabled span {\n  color: #dde2e9;\n}\n.ehc__selectbtn.error {\n  position: relative;\n}\n.ehc__selectbtn.error .input-errortxt {\n  display: block;\n  position: absolute;\n  top: 80px;\n  width: calc(100% + 50px);\n}\n.ehc__selectbtn.error button.errorpoint {\n  background: #f8f8fb;\n  border: 1px solid #f55547;\n}\n.ehc__selectbtn.error button.errorpoint span {\n  color: #2a2c2f;\n}\n.ehc__score .btn-comment,\n.ehc__score .btn-comment-check {\n  margin-left: 0.875rem;\n}\n.ehc__score .btn-comment span,\n.ehc__score .btn-comment-check span {\n  font-size: 0.875rem;\n  font-weight: 400;\n  color: #2a2c2f;\n  line-height: 1.4;\n}\n.ehc__score .tbl__top {\n  margin-bottom: 1.625rem;\n}\n.ehc__score .tbl-list {\n  max-height: 393px;\n  overflow-y: auto;\n  margin-bottom: 9rem;\n}\n.ehc__score .tbl-list table th {\n  position: sticky;\n  position: -webkit-sticky;\n  top: 0;\n}\n.ehc__score .tbl-list tr td {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n.ehc__score .tbl-list tr td:first-child {\n  vertical-align: top;\n}\n.ehc__score .tbl__bottom {\n  position: absolute;\n  bottom: 0;\n  height: auto;\n  /* height: 5.875rem; */\n  width: calc(100% - 2rem);\n  background: #fff;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-bottom: 2rem;\n}\n.ehc__step {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  margin-bottom: 2.75rem;\n}\n.progressbar {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n.progressbar .step {\n  font-weight: 500;\n  font-size: 0.938rem;\n  color: #2a2c2f;\n}\n.progressbar .progress-value {\n  display: flex;\n  flex-direction: column;\n  width: calc(100% - 76px);\n  margin-top: 3px;\n  position: relative;\n}\n.progressbar .progress-value .value {\n  position: relative;\n  margin-left: -15px;\n  width: calc(100% - 18px);\n}\n.progressbar .progress-value .value span {\n  position: absolute;\n  top: 5px;\n  width: 40px;\n  font-weight: 500;\n  font-size: 0.938rem;\n  color: #0a78ff;\n  text-align: center;\n}\n.progressbar .progress-value progress {\n  appearance: none;\n  height: 0.5rem;\n  width: 100%;\n}\n.progressbar .progress-value progress::-webkit-progress-bar {\n  background: #dde2e9;\n  font-size: 1rem;\n  color: #222;\n}\n.progressbar .progress-value progress::-webkit-progress-value {\n  background: #0a78ff;\n  font-size: 1rem;\n  color: #222;\n}\n.ehc__score .tbl__bottom .btn__wrap button {\n  padding: 0 1.25rem;\n  width: 8.5rem;\n  height: 2.5rem;\n  background-color: #0a78ff;\n  border: 0;\n}\n.ehc__score .tbl__bottom .btn__wrap {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n.ehc__score .tbl__bottom .btn__wrap button:hover {\n  background: #0050b8;\n}\n.ehc__score .tbl__bottom .btn__wrap button:active {\n  background: #003876;\n}\n.ehc__score .tbl__bottom .btn__wrap button span {\n  color: #fff;\n  font-weight: 700;\n}\n.ehc__score .tbl__bottom .btn__wrap .bg-transparent {\n  background: transparent;\n}\n.ehc__score .tbl__bottom .btn__wrap .bg-transparent:hover {\n  background: #e6f0ff;\n}\n.ehc__score .tbl__bottom .btn__wrap .bg-transparent:active {\n  background: #b4d2ff;\n}\n.ehc__score .tbl__bottom .btn__wrap .bg-transparent:disabled span {\n  color: #dde2e9;\n}\n.ehc__score .tbl__bottom .btn__wrap .bg-transparent:disabled {\n  opacity: 0.3;\n  filter: contrast(10%);\n}\n.ehc__score .tbl__bottom .btn__wrap .bg-transparent:disabled:hover {\n  background: transparent;\n}\n.ehc__score .tbl__bottom .btn__wrap .bg-transparent span {\n  color: #0a78ff;\n  padding-left: 2.25rem;\n  background: url(\"../img/icon_arrow_left.png\") no-repeat 0 center;\n}\n.ehc__score .tbl__bottom ul.btn__wrap li {\n  display: flex;\n}\n.ehc__score .tbl__bottom ul.btn__wrap li button + button {\n  margin-left: 8px;\n}\n.txtnum,\n.popup__body p.txtnum {\n  /* font-family: 'Urbanist', sans-serif; */\n  font-size: 0.875rem;\n  font-size: 13px;\n  line-height: 19px;\n  color: #909fb7;\n  text-align: right;\n  margin-top: 4px;\n}\n.popup-boxin .page-detail .popup__body p.txtnum {\n  line-height: 17px;\n}\n.ehc__memo {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n.ehc__memo textarea {\n  height: 234px;\n}\n.ehc__memo textarea::placeholder {\n  color: #909fb7 !important;\n}\n.memo__txt {\n  padding: 6px 8px;\n  font-size: 0.938rem;\n  line-height: 1.5rem;\n  color: #2a2c2f;\n  word-break: break-all;\n  text-align: justify;\n}\n.ehc__memo button {\n  margin-top: 0.5rem;\n  background: #909fb7;\n  padding: 6px 27px 4px;\n}\n.ehc__memo button span {\n  font-size: 0.875rem;\n  color: #fff;\n}\n.ehc__addfile {\n  margin-bottom: 1rem;\n}\n.ehc__addfile p.tit {\n  color: #2a2c2f;\n  font-weight: 500;\n  font-size: 1.25rem;\n  line-height: 1.813rem;\n}\n.ehc__addfile p.txt {\n  margin: 0.75rem 0;\n  font-size: 0.875rem;\n  line-height: 1.5rem;\n  color: #909fb7;\n}\n/*사진첨부 롤링이미지*/\n.ehc__rolling {\n  width: 100%;\n  height: 176px;\n  margin: 0 auto 9rem;\n  padding-top: 0;\n  overflow: hidden;\n  position: relative;\n}\n.rolling__left {\n  position: absolute;\n  top: 40%;\n  left: 0;\n  width: 2rem;\n  z-index: 2;\n}\n.rolling__left a {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n  transform: rotate(180deg);\n  background: url(\"../img/icon_arrow_w.png\") no-repeat center center;\n}\n.rolling__right {\n  position: absolute;\n  top: 40%;\n  right: 0;\n  width: 2rem;\n  z-index: 2;\n}\n.rolling__right a {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n  background: url(\"../img/icon_arrow_w.png\") no-repeat center center;\n}\n.ehc__picture {\n  float: left;\n  position: relative;\n  width: 100%;\n  height: 176px;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n}\n.ehc__picture ul {\n  position: absolute;\n  display: flex;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.ehc__picture ul li {\n  position: relative;\n  float: left;\n  width: 176px;\n  height: 176px;\n  margin-right: 8px;\n}\n.ehc__picture li .btn-delete-w {\n  position: absolute;\n  right: 4px;\n  top: 5px;\n  z-index: 2;\n  border-radius: 0;\n}\n.ehc__picture li:first-child a {\n  /* margin-left: 0; */\n}\n.ehc__picture li a {\n  display: block;\n  width: 176px;\n  height: 176px;\n  /* margin-left: 8px; */\n  border-radius: 2px;\n  background: #f0f2f4;\n}\n.picimg__view img {\n  display: block;\n  width: 100%;\n  max-width: 424px;\n  height: 424px;\n  margin: 0 auto;\n}\n/*점검전 안내 문구, 빈화면*/\n.txt-ready {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 26px;\n  color: #909fb7;\n}\n.txt-ready::before {\n  content: \"\";\n  display: block;\n  width: 145px;\n  height: 136px;\n  margin-bottom: 1rem;\n  background: url(\"../img/bg_readyinfo.png\") no-repeat center center;\n  background-size: 100%;\n}\n.txt-ready strong {\n  font-weight: 700;\n}\n\n/*점검결과*/\n.result__txt {\n  display: flex;\n  width: calc(100% - 16px);\n  margin-left: -1rem;\n  padding: 5px 32px 30px;\n  box-shadow: 0px 4px 5px rgb(144 159 183 / 15%);\n}\n.ehc__detail .result__txt .tit {\n  font-size: 13px;\n  line-height: 14px;\n  color: #2a2c2f;\n  font-weight: 400;\n  padding-top: 35px;\n  margin-top: 5px;\n  background: url(\"../img/icon_safety.png\") no-repeat top center;\n  background-size: 26px 26px;\n}\n.ehc__detail .result__txt .tit.caution {\n  padding-top: 35px;\n  margin-top: 5px;\n  background: url(\"../img/icon_caution.png\") no-repeat top center;\n}\n.ehc__detail .result__txt .tit.danger {\n  padding-top: 35px;\n  margin-top: 5px;\n  background: url(\"../img/icon_danger.png\") no-repeat top center;\n  background-size: 26px 26px;\n}\n/* .ehc__detail .result__txt .tit.safety {\n  padding-top: 35px;\n  margin-top: 5px;\n  background: url(\"../img/icon_safety.png\") no-repeat top center;\n  background-size: 26px 26px;\n} */\n.result__txt .btn-edit {\n  width: 32px;\n  height: 32px;\n  background: url(\"../img/icon_pen_w.png\") no-repeat center center #909fb7;\n  background-size: 1.125rem 1.124rem;\n}\n.ehc__detail .result__txt .score {\n  font-weight: 600;\n  font-size: 66px;\n  line-height: 0.8;\n  color: #2a2c2f;\n  margin: 0 26px 0 8px;\n}\n.ehc__detail .result__txt .txt {\n  width: calc(100% - 200px);\n  font-size: 16px;\n  line-height: 26px;\n  color: #2a2c2f;\n  font-weight: 400;\n  margin: 0;\n}\n.ehc__chart {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 3px 8px 0 6px;\n  padding: 23px;\n  width: calc(100% - 57px);\n  height: 362px;\n  text-align: center;\n  border-radius: 20px;\n  background: #fff;\n  filter: drop-shadow(0px 2px 10px rgba(144, 159, 183, 0.3));\n}\n.ehc__chart__img {\n  background: url(\"../img/icon_legend_gray.png\");\n  background: url(\"../img/icon_legend_purple.png\");\n  background: url(\"../img/icon_legend_red.png\");\n}\n.ma__score {\n  margin: 24px 4px;\n}\n.ehc__detail .ma__score p.tit {\n  font-size: 1rem;\n  font-weight: 500;\n}\n.score__info {\n  display: flex;\n  flex-direction: column;\n  margin-top: 1rem;\n}\n.score__info li {\n  background: #fff;\n  padding: 17px 42px 23px;\n}\n.score__info li:nth-child(odd) {\n  background: #f8f9fa;\n}\n.score__info li.disabled .tit::after {\n  content: \"\";\n  width: 1rem;\n  height: 1rem;\n  margin-left: 4px;\n  background: url(\"../img/icon_disabled.png\") no-repeat center center;\n}\n.score__info li.disabled .icon-score li:nth-child(1),\n.score__info li.disabled .icon-score li:nth-child(7) {\n  color: #646c74;\n}\n.ehc__detail .ma__score .score__info li .tit {\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n  font-size: 15px;\n  color: #2a2c2f;\n  margin-bottom: 13px;\n}\n.score__info li .tit span + span {\n  font-weight: 400;\n  margin-left: 5px;\n}\n.icon-score {\n  display: flex;\n  align-items: center;\n}\n.icon-score li {\n  padding: 0;\n}\n.icon-score li:nth-child(1) {\n  margin-right: 30px;\n}\n.icon-score li:nth-child(7) {\n  margin-left: 30px;\n}\n.icon-score li:nth-child(1),\n.icon-score li:nth-child(7) {\n  font-size: 14px;\n  color: #2a2c2f;\n}\n.icon-score li:nth-child(2),\n.icon-score li:nth-child(3),\n.icon-score li:nth-child(4),\n.icon-score li:nth-child(5),\n.icon-score li:nth-child(6) {\n  width: 40px;\n  height: 10px;\n  background: #dde2e9;\n  margin: 0 2px;\n}\n.icon-score.score1 li:nth-child(2) {\n  background-color: #646c74;\n}\n.icon-score.score2 li:nth-child(3) {\n  background-color: #646c74;\n}\n.icon-score.score3 li:nth-child(4) {\n  background-color: #646c74;\n}\n.icon-score.score4 li:nth-child(5) {\n  background-color: #646c74;\n}\n.icon-score.score5 li:nth-child(6) {\n  background-color: #646c74;\n}\n\n.ehc__score .ehc__result + .tbl__bottom {\n  margin-bottom: 18px;\n  border-top: 1px solid #dde2e9;\n  padding-top: 20px;\n}\n.ehc__score .ehc__result + .tbl__bottom .btn__wrap button {\n  background-color: #5b71ef;\n  width: auto;\n}\n/* .ehc-p.ehc__score .ehc__result + .tbl__bottom .btn__wrap button {\n  background-color: #13a79e;\n}\n.ehc-a.ehc__score .ehc__result + .tbl__bottom .btn__wrap button {\n  background-color: #ff9900;\n}\n.ehc-n.ehc__score .ehc__result + .tbl__bottom .btn__wrap button {\n  background-color: #1fc95c;\n} */\n.ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-share,\n.ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-reload {\n  background-color: #fff;\n}\n.ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-share span,\n.ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-reload span {\n  color: #909fb7;\n  font-weight: 500;\n  font-size: 14px;\n}\n.ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-share:hover {\n  background: url(\"../img/icon_share.png\") no-repeat 0 center;\n}\n.ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-reload:hover {\n  background: url(\"../img/icon_reload.png\") no-repeat 0 center;\n}\n.ehc__result .scrollH {\n  max-height: 680px;\n  margin-top: 18px;\n  margin-right: -12px;\n  overflow-x: hidden;\n}\n\n/*박스안 팝업*/\n.popup-boxin {\n  display: none;\n  width: 100%;\n}\n.popup-boxin.on {\n  display: block;\n  position: absolute;\n  top: -48px;\n  left: 0;\n  height: calc(100% + 48px);\n}\n.popup-boxin::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  min-width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.7);\n  z-index: 2;\n}\n.popup-boxin .page-detail {\n  position: absolute;\n  left: 6%;\n  width: 88%;\n  height: auto;\n  top: 25%;\n  background: #fff;\n  z-index: 3;\n  border-radius: 4px;\n  filter: drop-shadow(0px 10px 30px rgba(42, 44, 47, 0.5));\n}\n.popup-boxin .page-detail.w400 {\n  width: 25rem;\n  left: 12%;\n}\n.popup-boxin .page-detail.w400 .popup__body {\n  padding: 1rem 2rem 1.5rem 1rem;\n  width: calc(100% - 3.5rem);\n}\n.popup-boxin .page-detail.w400 h1 {\n  font-weight: 700;\n}\n.popup-boxin .page-detail.w400 .popup__body p {\n  font-size: 0.875rem;\n  line-height: 22px;\n}\n.popup-boxin .page-detail.w400 .popup__body p.fontMedium {\n  line-height: 20px;\n}\n.popup-boxin .popup__head h1 {\n  font-weight: 500;\n}\n.popup-boxin .popup__body .form__input {\n  margin: 1rem auto;\n}\n.popup-boxin .page-detail .popup__body p.tit {\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 14px;\n  letter-spacing: -0.004em;\n  color: #2a2c2f;\n}\n.popup-boxin .popup__body .form__input input[type=\"text\"].input-error {\n  background: none;\n}\n.popup-boxin .popup__body .form__input .input-errortxt {\n  top: 32px;\n}\n\n/* 20220629 =======================   layout_안내팝업.html : 498 ~ 517 참고  ===================================== */\n.popup-boxin .popup__head-opinion h1 {\n  font-weight: 500;\n}\n/* ============================================================================================================== */\n\n/* 20220628 =======================   layout_안내팝업.html : 926 ~ 940 참고  ===================================== */\n.popup-boxin .popup__head-restart h1 {\n  font-weight: 500;\n}\n/* ============================================================================================================== */\n\n.popup-boxin .page-detail .popup__body {\n  min-height: 80px;\n}\n/* 20220629 =======================   layout_안내팝업.html : 498 ~ 517 참고  ===================================== */\n.popup-boxin .page-detail .popup__body-opinion {\n  min-height: 80px;\n}\n/* ============================================================================================================== */\n/* 20220628 =======================   layout_안내팝업.html : 926 ~ 940 참고  ===================================== */\n.popup-boxin .page-detail .popup__body-restart {\n  min-height: 80px;\n}\n/* ============================================================================================================== */\n.popup-boxin .page-detail .popup__body p {\n  line-height: 22px;\n}\n\n/* 파일 reports */\n.container.filereports:not(.testrecord) .content {\n  padding-left: 0;\n  width: 100%;\n}\n.container.filereports .content {\n  width: calc(100% - 40px);\n  grid-template-columns: 1fr auto;\n  grid-template-rows: repeat(1, minmax(1006px, auto));\n}\n.container.filereports .box.list .box__body {\n  height: calc(100% - 16px);\n}\n\n/* 파일 reports-오른쪽 영역 */\n.container.filereports .box.ehc__score {\n  width: 520px;\n}\n.container.filereports .box.ehc__score .box__title {\n  display: flex;\n  align-items: center;\n}\n.container.filereports .box.ehc__score .btn-box {\n  width: 1.5rem;\n  height: 1.5rem;\n  margin-right: 8px;\n  margin-left: -0.5rem;\n  border: 0;\n  background: url(\"../img/icon_treeopen.png\") no-repeat center center;\n  background-size: 100%;\n}\n.container.filereports .box.ehc__score.close {\n  width: 38px;\n}\n.container.filereports .box.ehc__score.close .cate,\n.container.filereports .box.ehc__score.close .box__etc,\n.container.filereports .box.ehc__score.close .box__body {\n  display: none;\n}\n.container.filereports .box.ehc__score.close .box__header {\n  padding: 0 0.75rem;\n  justify-content: center;\n  border-bottom: 0;\n}\n.container.filereports .box.ehc__score.close .btn-box {\n  display: flex;\n  width: auto;\n  height: auto;\n  margin: 0;\n  background: url(\"../img/icon_treeclose.png\") no-repeat center center;\n}\n.container.filereports .box.ehc__score.close .btn-box::after {\n  content: \"e-HC Report\";\n  writing-mode: vertical-rl;\n  -ms-writing-mode: tb-rl;\n  transform: rotate(180deg);\n  margin-top: 9.5rem;\n  font-weight: 700;\n}\n\n/* 탭 */\n/*탭 슬라이드 관련*/\n.swiper-section {\n  margin: 0 -1rem;\n}\n.swiper-section .swiper-navigation {\n  background: #fff;\n  width: 52px;\n  height: 45px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 2;\n  box-shadow: -12px -14px 38px rgba(144, 159, 183, 0.5);\n}\n.swiper-section .swiper-button-prev,\n.swiper-section .swiper-button-next {\n  top: 23px;\n}\n.swiper-section .swiper-button-next,\n.swiper-section .swiper-container-rtl .swiper-button-prev {\n  right: 0;\n  left: auto;\n  height: 100%;\n  background: url(\"../img/icon_arrowright.png\") no-repeat center center;\n}\n.swiper-section .swiper-button-prev,\n.swiper-section .swiper-container-rtl .swiper-button-next {\n  right: 26px;\n  left: auto;\n  height: 100%;\n  background: url(\"../img/icon_arrowleft.png\") no-repeat center center;\n}\n.swiper-section .swiper-button-next::before {\n  content: \"\";\n  display: block;\n  width: 1px;\n  height: 30px;\n  margin-top: 9px;\n  background: #dde2e9;\n}\n\n/*기본 언더라인 탭*/\n.tab__line {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  border-bottom: 1px solid #dde2e9;\n  background: #fff;\n  width: 100%;\n}\n.tab__line li {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 14px 13px;\n  cursor: pointer;\n}\n.tab__line li a {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 400;\n  color: #646c74;\n}\n.tab__line li.on {\n  border-bottom: 3px solid #0a78ff;\n  background: #fff;\n  font-weight: 500;\n  color: #2a2c2f;\n}\n.tab__line li.on a {\n  font-weight: 700 !important;\n  color: #2a2c2f !important;\n}\n.box__header .tab__line {\n  margin-left: -24px;\n  padding-left: 24px;\n  padding-right: 24px;\n}\n.tab__line.medium:not(.column) li,\n.content.w100p .tab__line.medium:not(.column) li {\n  padding: 12px 24px;\n  min-width: 80px;\n}\n.tab__line.medium li a,\n.content.w100p .tab__line.medium li a {\n  font-size: 15px;\n  font-weight: 500 !important;\n  color: #7d8282;\n  letter-spacing: -0.04em;\n}\n.tab__line.medium:not(.column) li.on a,\n.content.w100p .tab__line.medium:not(.column) li.on a {\n  color: #2a2c2f;\n}\n.tab__line.medium li a,\n.content.w100p .tab__line.medium li a {\n  font-size: 15px;\n  font-weight: 500;\n  color: #7d8282;\n  letter-spacing: -0.04em;\n}\n.tab__line.small li a,\n.content.w100p .tab__line.small li a {\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: -0.04em;\n}\n.tab__line.column {\n  flex-direction: column;\n  gap: 0;\n  height: 100%;\n  background: #f7f8fa;\n  border-right: 1px solid #dde2e9;\n  border-bottom: 0;\n}\n.tab__line.column li,\n.content.w100p .tab__line.column li {\n  padding: 14px 32px;\n  width: calc(100% - 64px);\n  height: auto;\n  min-height: 39px;\n  border-bottom: 1px solid #dde2e9;\n}\n.tab__line.column li a,\n.content.w100p .tab__line.column li a {\n  justify-content: flex-start;\n  line-height: 1.4;\n  word-break: keep-all;\n}\n.tab__line.column li.on,\n.content.w100p .tab__line.column li.on {\n  position: relative;\n}\n.tab__line.column li.on:after,\n.content.w100p .tab__line.column li.on:after {\n  content: \"\";\n  position: absolute;\n  right: -1px;\n  top: 0;\n  width: 1px;\n  height: 100%;\n  background: #fff;\n}\n.tab__line.column li.on a,\n.content.w100p .tab__line.column li.on a {\n  color: #0a78ff;\n  font-weight: 700;\n}\n\n@media screen and (max-width: 940px) {\n  #wrap:not(.no-responsive) .box__header .tab__line {\n    margin: 0 !important;\n    padding: 0 !important;\n    gap: 0;\n  }\n  #wrap:not(.no-responsive) .tab__line li {\n    flex: 1;\n    padding: 14px;\n  }\n  #wrap:not(.no-responsive) .tab__line li a {\n    font-size: 16px;\n    line-height: 1.2;\n  }\n}\n\n/* 탭 - 라운드 */\n.tab__line.round {\n  flex-wrap: wrap;\n  gap: 9px;\n  width: auto;\n  border: 0;\n  margin-bottom: 16px;\n}\n.tab__line.round li {\n  padding: 0 24px;\n  height: 30px;\n  font-size: 0.938rem;\n  font-weight: 400;\n  color: #2a2c2f;\n  line-height: 0;\n  border: 1px solid #dde2e9;\n  border-radius: 25px;\n}\n.tab__line.round li.on {\n  color: #fff;\n  font-weight: 700;\n  background: #0a78ff;\n  border-color: #0a78ff;\n}\n\n.swiper-container {\n  border-bottom: 1px solid #dde2e9;\n  background: #fff;\n}\n.swiper-slide.tab {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 45px;\n  width: auto !important;\n  min-width: 72px;\n  padding: 0 24px;\n}\n.swiper-slide.tab p {\n  font-weight: 500;\n  color: #646c74;\n}\n.swiper-slide.tab.on {\n  font-weight: 700;\n  color: #2a2c2f;\n  border-bottom: 3px solid #0a78ff;\n  background: #fff;\n}\n.swiper-slide.tab.on p {\n  font-weight: 700;\n  color: #2a2c2f;\n}\n\n/*탭 내용*/\n.tabcontent {\n  display: none;\n  height: calc(100% - 49px);\n  flex-direction: column;\n}\n.current {\n  display: flex;\n}\n.tabcontent__top {\n  margin-bottom: 8px;\n}\n.tabcontent__title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-weight: 700;\n  font-size: 20px;\n  color: #2a2c2f;\n  margin: 37px 8px 8px;\n}\n.tabcontent .title {\n  display: flex;\n  align-items: center;\n  font-weight: 700;\n  font-size: 15px;\n  color: #2a2c2f;\n}\n\n/*검색영역*/\n.tabcontent .search {\n  /* padding: 32px 0 32px 8px; */\n  padding: 24px 0 24px 8px;\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid #dde2e9;\n}\n.tabcontent .search .form__input {\n  display: inline-block;\n  float: left;\n  width: calc(100% - 120px);\n  /* grid-template-columns: repeat(auto-fill, minmax(23%, auto));\n  row-gap: 7px; */\n}\n.tabcontent .search .form__input li {\n  display: inline-block;\n  float: left;\n  width: auto;\n  margin-top: 0;\n}\n.tabcontent .search .form__input li label {\n  display: inline-block;\n  float: left;\n  margin-top: 8px;\n}\n.tabcontent .search .form__input li + li label {\n  margin-left: 38px;\n  max-width: 50%;\n}\n.tabcontent .search .form__input .input__area {\n  margin-left: 1rem;\n  width: 186px;\n  display: inline-block;\n  float: left;\n}\n.tabcontent .search .form__input .input__area .select .selected {\n  min-width: 80px;\n}\n\n/*기간 조회*/\n.searchterm {\n  display: flex;\n  align-items: center;\n}\n.searchterm .term__month {\n  width: auto;\n}\n.searchterm .term__month .selected {\n  width: 111px;\n}\n.searchterm .term__date,\n.term__date {\n  display: flex;\n  align-items: center;\n  height: 32px;\n}\n.searchterm .term__date > div {\n  flex: 1;\n}\n.searchterm .term__date input[type=\"text\"] {\n  width: 91px;\n  padding: 0 0.75rem 0 35px;\n  font-size: 15px;\n  font-weight: 400;\n  color: #2a2c2f;\n  background: url(\"../img/icon_calendar.png\") no-repeat 8px center;\n  background-size: 20px;\n  border: 0;\n}\n/* 250514 퍼블,개발 화면 다름 */\n.searchterm:has(.w100) .term__date input[type=\"text\"] {\n  width: 83px !important;\n}\n.searchterm:has(.w100) .term__date.line input[type=\"text\"] {\n  border: 1px solid #909fb7;\n}\n@media screen and (max-width: 1042px) {\n  .searchterm:has(.w100) .term__date input[type=\"text\"] {\n    width: 100% !important;\n  }\n}\n.react-datepicker-wrapper {\n  height: 100%;\n}\n.react-datepicker__input-container {\n  border: 1px solid #909fb7;\n  border-radius: 4px;\n  /* height: 1.875rem; */\n  height: calc(100% - 2px);\n  max-height: 30px;\n  font-size: 0.875rem;\n  color: #2a2c2f;\n  font-weight: 400;\n  cursor: pointer;\n}\n.react-datepicker__input-container input[type=\"text\"] {\n  border: 0;\n  /* width: calc(100% - 0.6rem) !important; */\n  width: calc(100% - 0.6rem);\n  height: 100%;\n  padding: 0 0.2rem 0 0.4rem;\n  cursor: pointer;\n  background: url(\"../img/icon_select_l.png\") no-repeat 98% center;\n  background-size: 1.25rem 1.25rem;\n}\n.searchterm .term__date.w100p input[type=\"text\"] {\n  width: calc(100% - 46px);\n  padding: 0 2rem 0 0.75rem;\n}\n.searchterm .term__date input[type=\"text\"].calendar.end {\n  background: url(\"../img/icon_calendar.png\") no-repeat 98% center;\n}\n.searchterm .term__month + .term__date {\n  margin-left: 8px;\n}\n.centerline {\n  font-size: 14px;\n  color: #2a2c2f;\n  margin: 0 8px;\n}\n\n.tabcontent .search .btn__wrap .btn-search {\n  border: 0;\n  height: 32px;\n  width: 104px;\n  background: url(\"../img/Icon_search_white.png\") no-repeat 24px center #909fb7;\n  background-size: 16px;\n}\n.tabcontent .search .btn__wrap .btn-search span {\n  font-weight: 500;\n  font-size: 15px;\n  color: #fff;\n  margin: 0 0 0 23px;\n}\n.tabcontent .search .btn__wrap .btn-search:hover {\n  background-color: #7a8596;\n}\n.tabcontent .search .btn__wrap .btn-search:active {\n  background-color: #646c74;\n}\n\n/*filter*/\n.filter {\n  padding: 20px 10px;\n  border-bottom: 1px solid #dde2e9;\n  background: #fff;\n}\n.filter .title:hover {\n  cursor: pointer;\n}\n.filter .title::before {\n  content: \"\";\n  width: 1rem;\n  height: 1rem;\n  margin-right: 10px;\n  background: url(\"../img/icon_filter.png\") no-repeat 0 center;\n  background-size: 100%;\n}\n.filter .title .btn-close {\n  display: none;\n  width: 0.75rem;\n  height: 0.75rem;\n  margin-left: 1rem;\n}\n.filter .title .info {\n  display: none;\n  margin-left: 24px;\n  font-size: 12px;\n  font-weight: 400;\n  color: #646c74;\n}\n.filter__select {\n  display: none;\n  margin: 24px 25px 5px;\n}\n.filter__type {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n.filter__type + .filter__type {\n  margin-top: 13px;\n}\n.filter__type .tit {\n  font-weight: 500;\n  font-size: 15px;\n  color: #2a2c2f;\n}\n.type__cont {\n  display: flex;\n  align-items: center;\n  margin-left: 36px;\n  flex-wrap: wrap;\n  row-gap: 8px;\n}\n.type__cont li {\n  margin-right: 5px;\n  height: 30px;\n  width: auto;\n  min-width: 68px;\n  padding: 0 10px;\n  border: 1px solid #dde2e9;\n  border-radius: 18px;\n  background-color: transparent;\n}\n.type__cont li a {\n  font-size: 14px;\n  font-weight: 400;\n  color: #2a2c2f;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: calc(100% - 1px);\n}\n.type__cont li:hover {\n  background: rgba(0, 117, 255, 0.1);\n}\n.type__cont li.on {\n  background: #0a78ff;\n  border-color: #0a78ff;\n}\n.type__cont li.on a {\n  font-weight: 500;\n  color: #fff;\n}\n.type__cont li.disabled {\n  background-color: #f0f2f4;\n  border-color: #f0f2f4;\n}\n.type__cont li.disabled a {\n  color: #fff;\n}\n.filter__type:nth-child(2) .type__cont li:not(:first-child) {\n  border: 1px solid #5b71ef;\n  background-color: #fff;\n  border-radius: 4px;\n  height: 30px;\n  padding: 0 18px 0 16px;\n}\n.filter__type:nth-child(2) .type__cont li:nth-child(3) {\n  border-color: #13a79e;\n}\n.filter__type:nth-child(2) .type__cont li:nth-child(4) {\n  border-color: #ff9900;\n}\n.filter__type:nth-child(2) .type__cont li:not(:first-child) a:before {\n  content: \"B\";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 8px;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  width: 24px;\n  height: 24px;\n  border-radius: 50px;\n  background: #5b71ef;\n}\n.filter__type:nth-child(2) .type__cont li:nth-child(3) a:before {\n  content: \"P\";\n  background: #13a79e;\n}\n.filter__type:nth-child(2) .type__cont li:nth-child(4) a:before {\n  content: \"A\";\n  background: #ff9900;\n}\n.filter__type:nth-child(2) .type__cont li:not(:first-child).on a {\n  font-weight: 500;\n  color: #2a2c2f;\n}\n.filter__type:nth-child(2) .type__cont li:nth-child(2).on {\n  background: #eff1fe;\n}\n.filter__type:nth-child(2) .type__cont li:nth-child(3).on {\n  background: #e6fcfa;\n}\n.filter__type:nth-child(2) .type__cont li:nth-child(4).on {\n  background: #fff5e6;\n}\n.filter.open {\n  background: linear-gradient(180deg, rgba(250, 250, 250, 0) 0%, #fafafa 100%);\n}\n.filter.open .title {\n  color: #0a78ff;\n}\n.filter.open .filter__select {\n  display: block;\n}\n.filter.open .title .btn-close {\n  display: block;\n}\n.filter.open .title .info {\n  display: block;\n}\n\n/*검사성적서 filter&search-small*/\n.filereports.testrecord .box.list {\n  overflow-y: hidden;\n}\n.container.filereports.testrecord .content {\n  padding-left: 0;\n  width: 100%;\n  grid-template-columns: 1fr;\n  grid-template-rows: repeat(1, minmax(1006px, auto));\n}\n.tabcontent__title .btn-qr {\n  display: none;\n}\n.search__inline {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 28px 0 8px;\n}\n.search__inline .filter {\n  display: flex;\n  align-items: center;\n  border: 0;\n  background: none;\n  padding: 0 10px;\n  width: 100%;\n  /* width: calc(100% - 560px); */\n}\n.search__inline .filter .filter__select {\n  margin: 0;\n}\n.search__inline .filter .type__cont {\n  margin-left: 1rem;\n}\n.search__inline .search-small {\n  display: flex;\n  align-items: center;\n  padding: 0;\n}\n.search__inline .search-small .search__cont {\n  display: block;\n  margin: 0 0 0 1rem;\n}\n.search__inline .search-small.open .title {\n  color: #2a2c2f;\n}\n.search__inline .btn.btn-filedown {\n  margin-left: 10px;\n}\n.search__inline button + button {\n  margin-left: 10px;\n}\n.testrecord .tbl-list.type2 {\n  overflow-y: auto;\n  max-height: 810px;\n}\n.testrecord .tbl-list.type2 table {\n  border-bottom: 0;\n  background: linear-gradient(180deg, rgba(144, 159, 183, 0.0001) 10%, rgba(144, 159, 183, 0.2) 100%);\n}\n.testrecord .tbl-list.type2 table thead th.d-sm-block {\n  display: none !important;\n}\n.tbl-list.type2 table th {\n  position: sticky;\n  position: -webkit-sticky;\n  top: 0;\n  z-index: 2;\n}\n.tbl-list.type2 table tr.tr__detail .tbl-list.type2 table {\n  background: none;\n}\n.tbl-list.type2 table tr.tr__detail .tbl-list.type2 table th {\n  /* position: unset;\n  top: unset; */\n  z-index: 1;\n}\n.tbl-list.type2 table th:first-child span,\n.tbl-list.type2 table td:first-child span {\n  display: flex;\n  align-items: center;\n}\n.tbl-list.type2 table th:first-child span::before,\n.tbl-list.type2 table td:first-child span::before {\n  content: \"\";\n  margin-right: 12px;\n  margin-left: 10px;\n  width: 0;\n  height: 0;\n  border-bottom: 5px solid transparent;\n  border-top: 5px solid transparent;\n  border-left: 8px solid #909fb7;\n  border-right: 8px solid transparent;\n}\n.tbl-list.type2 table tr.open th:first-child span::before,\n.tbl-list.type2 table tr.open td:first-child span::before {\n  content: \"\";\n  margin-right: 20px;\n  margin-left: 10px;\n  margin-bottom: -10px;\n  width: 0;\n  height: 0;\n  border-bottom: 8px solid transparent;\n  border-top: 8px solid #2a2c2f;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n}\n.tbl-list.type2 table tr.bg-darkwhite td {\n  background: #fafafa;\n}\n.tbl-list.type2 tbody tr td.w20,\n.tbl-list.type2 thead tr th.w20 {\n  width: 20px !important;\n  padding: 13px 0px 13px 30px !important;\n  text-align: right;\n}\n.icon-no {\n  margin: 0 auto;\n  width: auto;\n  height: 24px;\n  background: url(\"../img/icon_x_b@3x.png\") no-repeat center center;\n  background-size: 24px 24px;\n}\n.icon-no.gray {\n  background: url(\"../img/icon_x_g@3x.png\") no-repeat center center;\n  background-size: 24px 24px;\n}\n\n.tbl-list.type5 table th {\n  position: sticky;\n  position: -webkit-sticky;\n  top: 0;\n  z-index: 2;\n}\n.tbl-list.type5 tbody tr td.w20,\n.tbl-list.type5 thead tr th.w20 {\n  width: 20px !important;\n  padding: 13px 0px 13px 30px !important;\n  text-align: right;\n}\n\n/*search-small*/\n.search-small {\n  padding: 20px 10px;\n  background: #fff;\n}\n.search-small .title:before {\n  content: \"\";\n  width: 1rem;\n  height: 1rem;\n  margin-right: 10px;\n  background: url(\"../img/icon_searchsamll.png\") no-repeat 0 center;\n  background-size: 100%;\n}\n.search-small .title:hover {\n  cursor: pointer;\n}\n.search-small .search__cont {\n  display: none;\n  margin: 24px 25px 5px;\n}\n.search-small .title .btn-close {\n  display: none;\n  width: 0.75rem;\n  height: 0.75rem;\n  margin-left: 1rem;\n}\n.search-small.open {\n  background: linear-gradient(180deg, #fafafa 0%, rgba(250, 250, 250, 0) 100%);\n}\n.inline.right.search-small.open {\n  background: transparent;\n}\n.search-small.open .title {\n  color: #0a78ff;\n}\n.search-small.open .search__cont {\n  display: block;\n}\n.search-small.open .title .btn-close {\n  display: block;\n}\n.search-small input[type=\"text\"] {\n  background: #ffffff;\n  border: 1px solid #909fb7;\n  border-radius: 4px;\n  height: 30px;\n  padding: 0 0.75rem;\n  vertical-align: bottom;\n}\n.search-small .select + input[type=\"text\"] {\n  margin-left: 3px;\n}\n.tabcontent .btn-renew {\n  display: none;\n}\n/*파일 reports 목록*/\n.checkstep-b {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50px;\n  font-weight: 600;\n  color: #fff;\n  background: #5b71ef;\n  margin: 0 auto;\n}\n.checkstep {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50px;\n  font-weight: 600;\n  color: #fff;\n  margin: 0 auto;\n}\n.checkstep.ehc-b {\n  background: #5b71ef;\n}\n.checkstep.ehc-a {\n  background: #ff9900;\n}\n.checkstep.ehc-p {\n  background: #13a79e;\n}\n.tbl-list table th input[type=\"checkbox\"]:checked + label:after,\n.tbl-list table th input[type=\"checkbox\"] + label:before {\n  top: -0.75rem;\n  left: 0;\n}\n.tbl-list table td:first-child input[type=\"checkbox\"]:checked + label:after,\n.tbl-list table td:first-child input[type=\"checkbox\"] + label:before {\n  top: -0.75rem;\n  left: 0;\n}\n.txt .score {\n  display: flex;\n  align-items: center;\n}\n.txt .score::before {\n  content: \"\";\n  width: 12px;\n  height: 12px;\n  margin-right: 10px;\n}\n.txt .score.high::before {\n  background: #1fc95c;\n}\n.txt .score.middle::before {\n  background: #ffbc0a;\n}\n.txt .score.low::before {\n  background: #f55547;\n}\ntd .score {\n  display: flex;\n  align-items: center;\n}\ntd .score::before {\n  content: \"\";\n  width: 12px;\n  height: 12px;\n  margin-right: 10px;\n}\ntd .score.high::before {\n  background: #1fc95c;\n}\ntd .score.middle::before {\n  background: #ffbc0a;\n}\ntd .score.low::before {\n  background: #f55547;\n}\n\n/*파일 reports 팝업*/\n.popup-layer.page-report {\n  width: 390px;\n}\n.popup-layer.page-report + .dimm {\n  background: rgba(0, 0, 0, 0.6);\n}\n.popup-layer.page-report .filter__select {\n  display: flex;\n  flex-direction: column;\n  margin: 20px 0 0;\n}\n.popup-layer.page-report .filter__type {\n  flex-direction: column;\n  align-items: flex-start;\n}\n.popup-layer.page-report .type__cont {\n  margin-left: 0;\n  margin-top: 0.75rem;\n  display: block;\n}\n.popup-layer.page-report .type__cont:after {\n  content: \"\";\n  display: block;\n  clear: both;\n}\n.popup-layer.page-report .filter__type:first-child .type__cont li {\n  width: auto;\n  min-width: 76px;\n  border: 1px solid #909fb7;\n  font-size: 15px;\n}\n.popup-layer.page-report .filter__type:first-child .type__cont li:hover {\n  background: inherit;\n}\n.popup-layer.page-report .filter__type:first-child .type__cont li.on {\n  border-color: #0a78ff;\n}\n.popup-layer.page-report .filter__type:first-child .type__cont li.on:hover {\n  background: #0a78ff;\n}\n.popup-layer.page-report .type__cont li {\n  float: left;\n  margin-bottom: 0.5rem;\n  padding: 0;\n  width: 86px;\n  min-width: unset;\n}\n.popup-layer.page-report .filter__type .tit {\n  font-size: 14px;\n}\n.popup-layer.page-report .filter__type:nth-child(2) .type__cont li:first-child {\n  border-radius: 4px;\n  width: 58px;\n}\n.popup-layer.page-report .filter__type:nth-child(2) .type__cont li:not(:first-child) {\n  padding: 0;\n}\n.popup-layer.page-report .filter__type:nth-child(2) .type__cont li:not(:first-child) a:before {\n  content: none;\n}\n.popup-layer.page-report.page-detail .popup__footer {\n  padding: 40px 1rem 33px;\n}\n.popup-layer.page-report .popup__head h1.icon-filter,\n.popup-layer.page-report .popup__head h1.icon-search {\n  display: flex;\n  align-items: center;\n}\n.popup-layer.page-report .popup__head h1.icon-filter::before {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  margin-right: 10px;\n  background: url(\"../img/icon_filter.png\") no-repeat 0 center;\n  background-size: 100%;\n}\n.popup-layer.page-report .popup__head h1.icon-search::before {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  margin-right: 10px;\n  background: url(\"../img/icon_searchsamll.png\") no-repeat 0 center;\n  background-size: 100%;\n}\n.popup-layer.page-report .form__input {\n  margin-bottom: 26px;\n  margin-top: 20px;\n}\n.popup-layer.page-report .form__input input[type=\"text\"],\n.popup-layer.page-report .form__input .select {\n  height: 40px;\n}\n.popup-layer.page-report .form__input .select + input[type=\"text\"] {\n  margin-top: 8px;\n}\n.popup-layer.page-report .form__input li {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin-top: 1.025rem;\n}\n.popup-layer.page-report .form__input .input__area {\n  margin-left: 0;\n  margin-top: 8px;\n}\n.popup-layer.page-report .form__input label {\n  font-weight: 500;\n  font-size: 14px;\n}\n.d-sm-tab {\n  display: none;\n  margin: 0 -1rem;\n  height: 3rem;\n  border-bottom: 1px solid #dde2e9;\n  background: #ffffff;\n  box-shadow: 0 8px 8px -8px rgba(144, 159, 183, 0.5);\n}\n.d-sm-tab .select {\n  border: 0;\n  height: 3rem;\n  font-size: 1rem;\n  color: #000;\n  font-weight: 500;\n}\n.d-sm-tab .select .selected {\n  padding: 0 1rem;\n}\n.d-sm-tab .select.active ul {\n  background: #ffffff;\n  box-shadow: 0 8px 8px -8px rgba(144, 159, 183, 0.5);\n  font-variant: JIS04;\n  margin: -1px 0 0 0;\n  border: 0;\n  border-radius: 0;\n  border-top: 1px solid #dde2e9;\n  z-index: 3;\n}\n.d-sm-tab .select ul li {\n  width: calc(100% - 1.8rem);\n  padding: 1.035rem 1rem;\n  font-weight: 400;\n  font-size: 15px;\n  color: #000;\n}\n.popup-layer.page-report .form__input.d-sm-block {\n  display: none;\n}\n.popup-layer .searchterm {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.popup-layer .searchterm .term__month {\n  display: block;\n  width: 100%;\n  margin-bottom: 6px;\n}\n.popup-layer .searchterm .term__month .selected {\n  width: calc(100% - 1.5rem);\n}\n.popup-layer.page-report .form__input li .select ul li {\n  margin-top: 0;\n}\n.popup-layer.page-report p.info {\n  margin: 20px auto 40px;\n  font-size: 1rem;\n  line-height: 1.4;\n  font-weight: 400;\n  text-align: center;\n}\n.popup-layer.page-report p.txt {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.4;\n}\n\n/* qr 팝업*/\n.popup-layer.page-qr {\n  width: 100%;\n  height: 100%;\n  border-radius: 0;\n}\n.qr__body {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.4);\n}\n.qr__top {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: calc(100% - 48px);\n  margin-top: 60px;\n}\n.qr__center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: calc(100vh - 220px);\n}\n.popup-layer.page-qr img {\n  width: 100%;\n  height: 100%;\n}\n.qr__box {\n  position: relative;\n  width: 320px;\n  height: 320px;\n  margin-bottom: 22px;\n}\n.qr__boxin {\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  width: calc(100% - 4px);\n  height: calc(100% - 4px);\n  border: 1px solid #0a78ff;\n  z-index: 1;\n}\n.qr__boxout {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background: url(../img/bg_qroutline.png) no-repeat 0 0;\n  background-size: 100%;\n  z-index: 2;\n}\n.qr__center p {\n  font-weight: 500;\n  font-size: 1.25rem;\n  line-height: 1.875rem;\n  color: #fff;\n}\n.qr__center p.info {\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  margin-top: 4px;\n}\n.qr__body .btn-close {\n  width: 2.625rem;\n  height: 2.625rem;\n  background: url(../img/icon_close_w.png) no-repeat center center;\n}\n.qr__body .qr__bottom {\n  position: absolute;\n  bottom: 68px;\n}\n.qr__body .qr__bottom button {\n  width: 180px;\n  height: 50px;\n  background: #0a78ff;\n  border: 1px solid #0a78ff;\n  box-shadow: 1px 4px 6px #2a2c2f;\n  border-radius: 4px;\n}\n.qr__body .qr__bottom button span {\n  font-weight: 500;\n  font-size: 1.125rem;\n  color: #fff;\n}\n/* qr 팝업 수정 */\n.page-qropen {\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100%;\n  z-index: 10000;\n  height: 100vh;\n  box-shadow: none;\n  background: #fff;\n  border-radius: 0;\n}\n.page-qropen .popup__body {\n  padding: 0;\n  width: 100%;\n  overflow-y: hidden;\n  max-height: none;\n  height: calc(100% - 224px);\n}\n.page-qropen .qr__center {\n  display: block;\n}\n.page-qropen .qr__center img {\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n}\n.page-qropen .qr__bottom p {\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 30px;\n  letter-spacing: -0.32px;\n  color: #2a2c2f;\n  text-align: center;\n}\n.page-qropen .qr__bottom .info {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n.page-qropen .popup__footer {\n  height: 224px;\n  width: 100%;\n  padding: 0;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  bottom: unset;\n}\n.page-qropen .popup__footer button {\n  width: 140px;\n  height: 40px;\n  background: #909fb7;\n  border: 0;\n  box-shadow: none;\n  margin-top: 32px;\n}\n.page-qropen .popup__footer button span {\n  font-size: 1rem;\n  font-weight: 700;\n}\n/* qr 조회 팝업 */\n.select-qr:after {\n  content: \"\";\n  display: block;\n  clear: both;\n}\n.select-qr li {\n  display: inline-block;\n  float: left;\n  margin-top: 8px;\n  margin-right: 8px;\n}\n.select-qr li a {\n  display: block;\n  padding: 10px 8px;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  height: 100%;\n  background: #fafafa;\n  border-radius: 4px;\n  word-break: break-all;\n  word-wrap: break-word;\n}\n.select-qr li a:hover {\n  background: #e6f0ff;\n}\n.select-qr li a.on {\n  background: #b4d2ff;\n}\n.popup__body .tbl-list.type2.qr-result thead {\n  display: none;\n}\n.popup__body .tbl-list.type2.qr-result table th:first-child span::before,\n.popup__body .tbl-list.type2.qr-result table td:first-child span::before {\n  content: none;\n}\n.popup__body .tbl-list.type2.qr-result table td span:first-child {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n}\n.popup__body .tbl-list.type2.qr-result table td span:last-child {\n  font-weight: 400;\n  font-size: 13px;\n  margin-top: 12px;\n}\n.popup__body .tbl-list.type2.qr-result table td .btn-file {\n  width: 24px;\n  height: 24px;\n  background: url(../img/icon_filedown_m.png) no-repeat center center;\n  background-size: 100%;\n}\n\n/* 운영관리 */\n.admin-site .box.list {\n  overflow-y: hidden;\n}\n.admin-site .box.list .box__body {\n  /* height: calc(100% - 49px); */\n  /* height: calc(100vh - 82px); */\n  padding-top: 0;\n  height: calc(100% - 16px);\n}\n/* .admin-site .box.list .box__body.nodata {\n  height: auto;\n} */\n.admin-site .box.list .box__body.nodata .area__right .area__right_content {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.admin-site .content {\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr;\n  width: 100%;\n  padding-left: 0;\n  grid-gap: 0;\n}\n.admin-site .tabcontent {\n  position: relative;\n  flex-direction: row;\n  justify-content: space-between;\n  margin: 0 -1rem;\n  /* height: 100%; */\n  height: calc(100% - 32px);\n}\n.pushy-menutype .area__left {\n  margin-right: 4px;\n  width: 388px;\n  /* height: 100%; */\n  height: calc(100% - 16px);\n  background: #fff;\n  border-right: 4px solid #dde2e9;\n  padding-top: 1rem;\n}\n.pushy-menutype .area__left .lnb.nodata {\n  height: calc(100% - 56px);\n}\n.pushy-menutype .area__left .lnb.nodata .nodata_txt {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  font-size: 14px;\n  letter-spacing: -0.4px;\n  color: #909fb7;\n  line-height: 26px;\n}\n.admin-site .area__right {\n  width: calc(100% - 440px);\n  padding: 16px 24px 10px;\n  position: relative;\n  height: calc(100% - 26px);\n  /* max-height: 920px; */\n  /* height: calc(100% - 34px); */\n}\n.admin-site .area__right .area__right_content {\n  /* overflow-y: auto; */\n  overflow-y: hidden;\n  overflow-x: hidden;\n  height: calc(100% - 120px);\n  /* max-height: 630px; */\n}\n.admin-site .area__right .area__right_content.hcal-176 {\n  height: calc(100% - 176px);\n}\n.area__right_content.workplace__info {\n  /* margin: 0 -27px; */\n  margin: 0 -22px 0-27px;\n}\n.area__right_content.workplace__info .content__list {\n  position: absolute;\n  bottom: 0;\n  padding: 22px 24px 40px;\n  width: calc(100% - 48px);\n  height: calc(100% - 560px);\n}\n.admin-site .box.list .box__body .area__right_content.workplace__info .content__list .tbl-list {\n  height: calc(100% - 32px);\n  max-height: unset;\n}\n.area__right_content.workplace__info .content__info {\n  padding: 0 24px;\n  width: calc(100% - 48px);\n  overflow-y: auto;\n  height: 320px;\n}\n.area__right_content.workplace__info.info__input .content__info.h-auto {\n  height: auto;\n}\n\n.lnb__top {\n  display: flex;\n  align-items: center;\n  padding: 0 8px 8px;\n}\n.lnb__top .tit {\n  margin: 10px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 12px;\n  letter-spacing: -0.4px;\n  color: #0a78ff;\n}\n.lnb__top .box__search {\n  width: 100%;\n}\n.lnb__top .box__search .btn-search {\n  position: unset;\n  width: 32px;\n  height: 32px;\n  background: url(\"../img/Icon_search_white.png\") no-repeat center center #909fb7;\n  background-size: 16px 16px;\n}\n.lnb__top .box__search input[type=\"text\"] {\n  width: calc(100% - 72px);\n  padding: 3px 16px;\n  border: 1px solid #909fb7;\n  border-radius: 4px;\n}\n\n.lnb__top .btn-setting {\n  width: 32px;\n  height: 32px;\n  background: url(\"../img/icon_set.png\") no-repeat center center #909fb7;\n  background-size: 96%;\n}\n.lnb__top .add__item {\n  margin-right: 8px;\n  /* width: calc(100% - 40px); */\n  width: 100%;\n}\n\n/* 운영관리 컨텐츠 영역 */\n.admin-site .area__right h2 {\n  font-weight: 700;\n  font-size: 25px;\n  line-height: 20px;\n  color: #2a2c2f;\n  letter-spacing: -0.045em;\n  margin-bottom: 29px;\n  margin-top: 18px;\n}\n.tab__small {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.tab__small li a {\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n  font-size: 15px;\n  color: #2a2c2f;\n}\n.tab__small li.on a {\n  font-weight: 700;\n  color: #0a78ff;\n}\n.tab__small li + li {\n  border-left: 1px solid #dde2e9;\n  margin-left: 24px;\n  padding-left: 24px;\n}\n.tab__small li a::before {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  margin-right: 8px;\n}\n.tab__small li a.icon-search::before {\n  content: \"\";\n  background: url(\"../img/icon_searchsamll.png\") no-repeat center center;\n  background-size: 100%;\n}\n.tab__small li a.icon-pen::before {\n  content: \"\";\n  background: url(\"../img/icon_pen_b.png\") no-repeat center center;\n  background-size: 100%;\n}\n.tab__small li a.icon-add::before {\n  content: \"\";\n  background: url(\"../img/icon_add.png\") no-repeat center center;\n  background-size: 100%;\n}\n.admin-site .area__right .searcharea {\n  margin-bottom: 20px;\n}\n.admin-site .area__right .searcharea input[type=\"text\"] {\n  font-weight: 500;\n  font-size: 14px;\n}\n\n/* 운영관리 컨텐츠 영역_사업장추가테이블 */\n.tbl-list.type3 {\n  border-bottom: 1px solid #dde2e9;\n  border-top: 1px solid #dde2e9;\n  max-height: 756px;\n  overflow-y: auto;\n}\n.tbl-list.type3 table {\n  border-bottom: 0;\n}\n.tbl-list.type3 tbody tr:nth-child(even) td {\n  background: #fafafa;\n}\n.tbl-list.type3 td {\n  text-align: left;\n}\n.tbl-list.type3 td ul {\n  display: flex;\n  justify-content: space-between;\n}\n.tbl-list.type3 td ul li {\n  display: flex;\n  align-items: center;\n  width: 47%;\n}\n.tbl-list.type3 td .btn-add {\n  width: 32px;\n  min-width: auto;\n  height: 32px;\n  border: 1px solid #e7f2ff;\n  background: url(\"../img/icon_plus.png\") no-repeat center center #e7f2ff;\n  background-size: 12px 12px;\n}\n.tbl-list.type3 td .highlight {\n  font-weight: 700;\n}\n.tbl-list.type3 td ul li p.placename {\n  font-size: 15px;\n  font-weight: 400;\n  color: #2a2c2f;\n  line-height: 20px;\n  width: 50%;\n}\n.tbl-list.type3 td ul li p.location {\n  font-size: 15px;\n  font-weight: 400;\n  color: #2a2c2f;\n  line-height: 20px;\n  padding-left: 28px;\n  width: 50%;\n  background: url(../img/icon_navi.png) no-repeat 0 -1px;\n  background-size: 20px;\n}\n.tbl-list.type3 td ul li.address {\n  font-weight: 400;\n  font-size: 12px;\n  color: #2a2c2f;\n  line-height: 12px;\n  width: 53%;\n}\n.tbl-list.type3::-webkit-scrollbar-thumb {\n  background-color: #dde2e9;\n}\n\n/* 운영관리 컨텐츠 영역_사업장정보 */\n.page-loca {\n  display: flex;\n  align-items: center;\n  background: #f4f6f7;\n  padding: 10px 16px;\n  margin: 0 -16px 28px;\n}\n.page-loca li {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 12px;\n  letter-spacing: -0.4px;\n  color: #646c74;\n}\n.page-loca li:after {\n  content: \">\";\n  font-size: 14px;\n  color: #646c74;\n  margin: 0 6px;\n}\n.page-loca li:last-child:after {\n  content: none;\n}\n.page-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 40px;\n}\n.admin-site .area__right .page-top {\n  margin-top: 18px;\n}\n.admin-site .area__right .page-top h2 {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n.page-top h2 .txt-info {\n  font-weight: 400;\n  font-size: 13px;\n  margin-left: 8px;\n}\n\n.content__list {\n  border-top: 2px solid #e9edef;\n  /* margin: 0 0 0 -22px;\n  padding: 34px 26px 89px;\n  width: calc(100% - 10px); */\n  /* height: 235px; */\n  height: 250px;\n}\n\n/*사이트정보*/\n.content__info ul li .btn-add {\n  margin-top: 10px;\n  width: 86px;\n  height: 28px;\n  border-radius: 4px;\n  border: 0;\n  background: url(../img/icon_export.png) 8px center no-repeat #e6f0ff;\n  background-size: 20px;\n}\n.content__info ul li .btn-add span {\n  color: #0a78ff;\n  font-weight: 500;\n  font-size: 12px;\n  padding-left: 15px;\n}\n.box.list .box__body .content__list .tbl-list {\n  height: auto;\n  max-height: 275px;\n  overflow-y: auto;\n  border-bottom: 1px solid #dde2e9;\n}\n.content__list .tbl-list::-webkit-scrollbar-thumb {\n  background-color: #dde2e9;\n}\n.box.list .box__body .content__list .tbl-list table {\n  border-bottom: 0;\n}\n.content__list .tbl-list th {\n  position: sticky;\n  position: -webkit-sticky;\n  top: 0;\n  padding: 8px 16px 8px;\n}\n.content__list .tbl-list td {\n  padding: 13px 16px;\n}\n.content__list .tbl-list th,\n.content__list .tbl-list td {\n  text-align: left;\n}\n.box.list .box__body .content__list .tbl-list td.d-sm-none {\n  display: table-cell !important;\n}\n.box.list .box__body .content__list .tbl-list td.d-lm-none {\n  display: none !important;\n}\n.content__list .tbl-list td .siteadmin {\n  display: flex;\n  align-items: center;\n}\n.content__list .tbl-list td .siteadmin::before {\n  content: \"S\";\n  margin-right: 6px;\n  text-align: center;\n  font-weight: 500;\n  font-size: 12px;\n  color: #fff;\n  width: 1rem;\n  height: 1rem;\n  background: #909fb7;\n  border-radius: 2px;\n}\n\n/* 운영관리 컨텐츠 영역_사업장정보_메인 사업장 정보(그리드 스타일) */\n.area__right_content.workplace__info.workplace__main .content__info {\n  display: grid;\n  grid-template-columns: 304px 1fr 1fr;\n  grid-gap: 24px;\n}\n.img_workplace {\n  position: relative;\n  width: 304px;\n  height: 304px;\n  border-radius: 4px;\n}\n.image_preview {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n}\n.image_preview img {\n  display: flex;\n  width: 100%;\n  height: 100%;\n}\n.img_workplace .btn-imgadd {\n  position: absolute;\n  right: 5px;\n  top: 267px;\n  width: 32px;\n  height: 32px;\n  z-index: 2;\n}\n.img_workplace .btn-imgadd label {\n  display: block;\n  width: 100%;\n  height: 100%;\n  border-radius: 4px;\n  cursor: pointer;\n  background: url(\"../img/icon_add_g.jpg\") center center no-repeat;\n  background-size: 100%;\n  border: 0;\n}\n.img_workplace .btn-imgadd input[type=\"file\"] {\n  position: absolute;\n  width: 0;\n  height: 0;\n  padding: 0;\n  overflow: hidden;\n  border: 0;\n}\n\n/* 운영관리 컨텐츠 영역_사업장 신규입력 */\n.content__info ul.form__input li {\n  justify-content: flex-start;\n}\n.content__info ul.form__input li p.tit {\n  margin-top: 5px;\n}\n.content__info ul.form__input li p.tit.star:after {\n  vertical-align: top;\n  margin-left: 6px;\n}\n.content__info ul.form__input .input__area {\n  width: calc(100% - 160px);\n  min-width: 280px;\n  max-width: 454px;\n  margin-left: 0;\n  min-height: 32px;\n}\n.content__info ul li p.input-errortxt {\n  font-size: 0.813rem;\n  line-height: 1.2;\n  color: #f55547;\n}\n.content__info ul.form__input li textarea {\n  height: 76px;\n}\n.content__info ul.form__input li textarea::placeholder {\n  color: #909fb7 !important;\n}\n.content__info ul.form__input li .box__search input[type=\"text\"] {\n  padding: 0 34px 0 0.75rem;\n  width: calc(100% - 46px);\n  border-color: #909fb7;\n}\n.content__info ul.form__input li .box__search .btn-search {\n  right: 0.5rem;\n  width: 1.25rem;\n  height: 1.25rem;\n  background: url(../img/icon_search_g.png) no-repeat center center;\n}\n.area__right_content .btn__wrap {\n  display: flex;\n  align-items: center;\n  /* justify-content: center; */\n  margin-top: 6px;\n  /* margin-left: 10px; */\n  margin-left: 24px;\n  justify-content: flex-end;\n  max-width: 614px;\n}\n.area__right_content .btn__wrap.center {\n  max-width: 100%;\n  justify-content: center;\n  margin-left: 10px;\n}\n.area__right_content .btn__wrap button {\n  padding: 0 1.25rem;\n  width: 8.75rem;\n  height: 2.5rem;\n  background-color: #0a78ff;\n  border: 0;\n}\n.area__right_content .btn__wrap button span {\n  color: #fff;\n  font-weight: 700;\n}\n.area__right_content .btn__wrap button + button {\n  margin-left: 0.75rem;\n}\n/* .area__right_content.workplace__info.info__input .btn__wrap {\n  max-width: 965px;\n}\n.area__right_content.workplace__info.workplace__main.info__input .btn__wrap {\n  max-width: unset;\n} */\n\n/* 운영관리 컨텐츠 영역_사업장 신규입력 : 디자인 변경 */\n.area__right_content.workplace__info.workplace__main.newtype .content__info {\n  display: flex;\n}\n.area__right_content.workplace__info.workplace__main.newtype .content__info + .content__info {\n  border-top: 2px solid #e9edef;\n  padding-top: 40px;\n  margin-top: 40px;\n}\n.area__right_content.workplace__info.workplace__main.newtype .content__info h3 {\n  margin-bottom: 24px;\n  font-weight: 700;\n  font-size: 1.25rem;\n  line-height: 1.25rem;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.newtype .content__info ul li:last-child {\n  margin-bottom: 0;\n}\n.newtype .content__info ul.form__input .input__area {\n  width: 320px;\n  min-width: unset;\n  max-width: unset;\n}\n.newtype.area__right_content.workplace__info .column .btn__wrap {\n  margin-right: 0;\n  max-width: unset;\n}\n.newtype.area__right_content.workplace__info .column .btn__wrap.center {\n  justify-content: center;\n  margin: 1.5rem 0 1rem;\n  padding: 1rem 0;\n  border-top: 2px solid #e9edef;\n  border-bottom: 2px solid #e9edef;\n}\n.newtype.area__right_content .column .btn__wrap button.add__item {\n  background: #e6f0ff;\n  border-radius: 4px;\n  height: 34px;\n  border: 0;\n  padding: 0 16px;\n  justify-content: center;\n}\n.newtype.area__right_content .column .btn__wrap button.add__item span {\n  display: flex;\n  align-items: center;\n  color: #0a78ff;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 12px;\n}\n.newtype .content__info ul.form__info li p.tit {\n  margin-top: 0;\n  line-height: 20px;\n  width: 180px;\n}\n/* 요청반려 사유확인 팝업 */\n.popup-basic.reason {\n  width: 600px;\n  height: 360px;\n}\n.popup-basic.reason .popup__body {\n  height: 214px;\n  overflow-y: auto;\n}\n.popup-basic.reason .popup__body p {\n  font-size: 14px;\n  line-height: 22px;\n}\n.popup-basic.reason .font-16 {\n  font-size: 14px !important;\n}\n.popup-basic.reason dl {\n  display: flex;\n  margin: 40px 10px 0;\n  width: calc(100% - 20px);\n}\n.popup-basic.reason dl dt {\n  width: 80px;\n  font-size: 14px;\n  line-height: 22px;\n}\n.popup-basic.reason dl dd {\n  width: calc(100% - 80px);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 22px;\n}\n.popup-basic.reason .page-detail .popup__footer {\n  padding: 1rem;\n  border-top: 1px solid #dde2e9;\n}\n\n/*기기등록관리_리스트*/\n.move-list {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 112px;\n  height: 30px;\n  background: #e6f0ff;\n  border-radius: 25px;\n  font-weight: 500;\n  font-size: 14px;\n  color: #0a78ff;\n}\n.move-list.active {\n  background: #0a78ff;\n  color: #fff;\n}\n.move-list + .move-list {\n  margin-left: 8px;\n}\n.inline .tab__small {\n  margin-bottom: 0;\n  margin-left: 32px;\n}\n.inline .title + .searcharea {\n  margin-bottom: 0;\n  margin-left: 1rem;\n}\n.page-list-view.page-workplace .content__info ul.filelist.down li {\n  flex-direction: row;\n  align-items: center;\n}\n.popup-layer.page-list-view.page-workplace {\n  z-index: 1000;\n}\n.popup-layer.page-list-in {\n  z-index: 1001;\n}\n.inline.search-small .title {\n  cursor: default;\n}\n\n/*기기등록관리_등록*/\n.devicetype.mySwiper2 {\n  display: none;\n  width: 100%;\n}\n.devicetype.mySwiper2 .swiper-slide {\n  width: 64px;\n  height: 64px;\n}\n.devicetype.mySwiper2 .swiper-slide button {\n  font-size: 13px;\n}\n.devicetype.mySwiper2 .swiper-slide button:focus {\n  font-size: 14px;\n}\n.devicetype .swiper-slide {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 72px;\n  height: 72px;\n  margin-right: 8px;\n  cursor: pointer;\n}\n.devicetype .swiper-slide button::before {\n  content: \"\";\n  width: 2.05rem;\n  height: 1.6rem;\n  margin-bottom: 6px;\n  background: url(../img/bg_device.png) no-repeat center center;\n  background-size: 100%;\n}\n.devicetype .swiper-slide button {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  background: #ffffff;\n  border: 1px solid #dde2e9;\n  box-shadow: 1px 1px 4px rgba(144, 159, 183, 0.3);\n  border-radius: 8px;\n  font-weight: 400;\n  font-size: 14px;\n  color: #2a2c2f;\n}\n.devicetype .swiper-slide button:hover {\n  border: 2px solid #b6d7ff;\n}\n.devicetype .swiper-slide button.active {\n  border: 2px solid #0a78ff;\n  font-weight: 500;\n  color: #0a78ff;\n  font-size: 16px;\n}\n.devicetype .swiper-wrapper.errorpoint button {\n  border: 1px solid #f55547;\n}\n.devicetype .swiper-wrapper.errorpoint .input-errortxt {\n  display: block;\n  top: 4.7rem;\n}\n\n/*기기등록관리_일괄등록*/\n.drag__area {\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n}\n.drag__area .drag__left {\n  text-align: center;\n  width: 400px;\n}\n.filebox-drag {\n  position: relative;\n}\n.filebox-drag .tit {\n  font-size: 18px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #909fb7;\n  padding: 120px 0 64px;\n}\n.filebox-drag .txt {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.filebox-drag .filelist {\n  position: absolute;\n  top: 108px;\n  z-index: 5;\n  left: 0;\n  right: 0;\n  background: #ffffff;\n  box-shadow: 0px 2px 8px rgba(144, 159, 183, 0.8);\n  border-radius: 4px;\n  margin: 0 auto;\n  padding: 8px 14px;\n  max-width: 248px;\n}\n.filebox-drag .filelist li span {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  text-align: left;\n  color: #2a2c2f;\n  background-position: 0 2px;\n}\n.drag__area .drag__left .btn.btn-filedown {\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: auto;\n  height: 24px;\n  padding-right: 28px;\n  /* margin-right: 62px; */\n  background: url(\"../img/icon_filedown_m@3x.png\") no-repeat right center;\n  background-size: 24px;\n}\n.drag__area .drag__left .btn-filedown span {\n  font-weight: 700;\n}\n.filebox-drag .txt button {\n  border: 0;\n  margin-left: 5px;\n  font-size: 15px;\n  font-weight: 700;\n  color: #0a78ff;\n  line-height: initial;\n}\n.area__right_content .filebox-drag .btn__wrap {\n  margin: 64px auto 0;\n  max-width: unset;\n  justify-content: center;\n}\n.area__right_content .filebox-drag .btn__wrap button:disabled {\n  background: #e9edef !important;\n}\n.drag__area .drag__right {\n  width: calc(100% - 424px);\n  margin-top: 58px;\n}\n/* .drag__right .btn-filedown {\n  width: auto;\n  height: 24px;\n  padding-right: 28px;\n  margin-right: 62px;\n  background: url(../img/icon_filedown_m@3x.png) no-repeat right center;\n  background-size: 24px;\n} */\n/* .drag__right .btn-filedown span {\n  font-weight: 700;\n} */\n.content__info .drag__right__list li {\n  flex-direction: column;\n  margin-bottom: 34px;\n  padding-bottom: 34px;\n  border-bottom: 2px solid #e9edef;\n}\n/* .content__info .drag__right__list li:first-child {\n  justify-content: flex-end;\n  flex-direction: row;\n  border-bottom: 0;\n  padding-bottom: 0;\n} */\n.content__info .drag__right__list li:last-child {\n  border-bottom: 0;\n}\n.content__info .drag__right__list li p.tit {\n  margin-top: 0;\n  margin-bottom: 18px;\n  width: auto;\n}\n.content__info .drag__right__list .drag-filelist,\n.content__info .drag__right__list .filelist-case {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n.content__info .drag__right__list .drag-filelist li,\n.content__info .drag__right__list .drag-filelist li:first-child,\n.content__info .drag__right__list .filelist-case li,\n.content__info .drag__right__list .filelist-case li:first-child {\n  width: 100%;\n  justify-content: flex-start;\n  flex-direction: row;\n  padding-bottom: 0;\n  margin-bottom: 10px;\n  border-bottom: 0;\n}\n.content__info .drag__right__list .drag-filelist li:last-child,\n.content__info .drag__right__list .filelist-case li:last-child {\n  margin-bottom: 0;\n}\n.drag-filelist .name {\n  font-size: 15px;\n  line-height: 14px;\n  color: #2a2c2f;\n  padding-left: 26px;\n  padding-top: 2px;\n  width: 356px;\n  height: 20px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  background: url(../img/icon_upload@3x.png) no-repeat left top;\n  background-size: 20px;\n}\n.drag-filelist .progressbar .progress-value {\n  margin-top: 0;\n  width: auto;\n  height: auto;\n  flex-direction: row;\n  align-items: center;\n}\n.drag-filelist .progressbar {\n  width: auto;\n}\n.drag-filelist .progressbar .progress-value progress {\n  height: 4px;\n  width: 100px;\n}\n.drag-filelist .progressbar .progress-value .value {\n  margin-left: 15px;\n  width: auto;\n}\n.drag-filelist .progressbar .progress-value .value span {\n  position: initial;\n  top: unset;\n  width: auto;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 14px;\n  color: #909fb7;\n}\n.drag-filelist .name.success {\n  background: url(../img/icon_success@3x.png) no-repeat left top;\n  background-size: 20px;\n}\n.filelist-case .name {\n  font-size: 15px;\n  line-height: 14px;\n  color: #2a2c2f;\n  padding-left: 26px;\n  padding-top: 2px;\n  width: 356px;\n  height: 20px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  background: url(../img/icon_file.png) no-repeat 7px top;\n  background-size: 0.563rem 1.087rem;\n}\n.filelist-case div {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.filelist-case div p {\n  font-size: 14px;\n  line-height: 20px;\n  color: #2a2c2f;\n}\n.filelist-case div p strong {\n  margin-right: 20px;\n}\n.filelist-case div p.case-ok strong {\n  font-weight: 500;\n  color: #1fc95c;\n}\n.filelist-case div p.case-no {\n  margin-left: 16px;\n}\n.filelist-case div p.case-no strong {\n  font-weight: 500;\n  color: #f55547;\n}\n.btn-go {\n  width: 19px;\n  height: 19px;\n  margin-left: 15px;\n  border: 0;\n  background: url(../img/icon_gopop@3x.png) no-repeat center center;\n  background-size: 100%;\n}\n.drag__area .filebox-upload {\n  display: none;\n}\n.drag__area .filebox-upload .tit {\n  margin-top: 8px;\n  margin-right: 38px;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 14px;\n  color: #2a2c2f;\n}\n.drag__area .filebox-upload .filebox label {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 290px;\n  height: 32px;\n  background: #e6f0ff;\n  border-radius: 4px;\n  font-size: 13px;\n  color: #0a78ff;\n}\n.drag__area .filebox-upload .filebox label span {\n  padding-left: 27px;\n  background: url(../img/icon_folder_b.png) no-repeat left center;\n  background-size: 20px 20px;\n}\n.drag__area .drag__left .filebox-upload .btn-upload {\n  display: none;\n}\n.popup-layer.js-layer.h80vh .popup__body {\n  height: calc(100% - 153px);\n  max-height: calc(100% - 153px);\n  overflow-y: hidden;\n}\n.tbl__top .tab__button {\n  margin-bottom: 0;\n}\n.tab__button {\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n}\n.tab__button li {\n  width: 90px;\n  height: 32px;\n  margin-right: 8px;\n}\n.tab__button li a {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 25px;\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 1.2;\n  letter-spacing: -0.4px;\n}\n.tab__button li a.green {\n  color: #3bd071;\n}\n.tab__button li a.red {\n  color: #f55547;\n}\n.tab__button li.on a {\n  color: #fff;\n}\n.tab__button li.on a.green {\n  background: #3bd071;\n}\n.tab__button li.on a.red {\n  background: #f55547;\n}\n.tbl-list.hcal-77 {\n  overflow-y: auto;\n  border-bottom: 1px solid #dde2e9;\n}\n.tbl-list.hcal-77 table {\n  border-bottom: 0;\n}\n.tbl-list.hcal-77 table th {\n  position: sticky;\n  position: -webkit-sticky;\n  top: 0;\n}\n\n/* 기기등록관리_진행완료성공실패 모바일 테이블 */\n.tbl-list.type4 {\n  max-height: calc(100vh - 295px);\n  overflow-y: auto;\n  border-bottom: 1px solid #dde2e9;\n}\n.tbl-list.type4 table {\n  border-bottom: 0;\n}\n.tbl-list.type4 tbody tr:nth-child(even) td {\n  background: #fff;\n}\n.tbl-list.type4 td {\n  text-align: left;\n  padding: 1rem;\n  background: #fafafa;\n}\n.tbl-list.type4 td ul li {\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  margin-bottom: 14px;\n}\n.tbl-list.type4 td ul li:last-child {\n  margin-bottom: 0;\n}\n.tbl-list.type4 td ul li strong {\n  width: 60px;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 16px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.tbl-list.type4 td ul li span {\n  margin-left: 8px;\n  font-size: 13px;\n  line-height: 16px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  width: calc(100% - 60px);\n}\n.tbl-list.type4::-webkit-scrollbar-thumb {\n  background-color: #dde2e9;\n}\n\n/* 관리자_신규가입요청_사업장승인요청 */\ntd.icon-new span {\n  /* display: flex;\n  align-items: center; */\n}\ntd.icon-new.pl-50 {\n  padding-left: 16px !important;\n}\n/* td.icon-new + td button.bg-blue {\n  background: #003876 !important;\n} */\n.admin-site.layout-w3 .area__left {\n  /* width: 371px; */\n  width: 20%;\n  height: calc(100% - 32px);\n  padding: 16px;\n  margin-right: 0;\n  border-right: 4px solid #dde2e9;\n}\n.admin-site.layout-w3 .area__right {\n  /* width: calc(100% - 788px); */\n  width: 52%;\n  height: calc(100% - 32px);\n  padding: 16px;\n}\n.admin-site.layout-w3 .area__right-end {\n  /* width: 361px; */\n  width: 28%;\n  height: calc(100% - 32px);\n  padding: 16px;\n  border-left: 4px solid #dde2e9;\n}\n.admin-site.layout-w3 .page-top {\n  margin-bottom: 24px;\n  margin-top: 20px;\n}\n.admin-site.layout-w3 h2 {\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.admin-site .box.list .box__body .tbl-list {\n  /* height: 650px; */\n  /* height: auto; */\n  border-bottom: 1px solid #dde2e9;\n  /* overflow: hidden; */\n}\n.admin-site .box.list .box__body .tbl-list.hcal-130 {\n  height: calc(100% - 130px);\n}\n.admin-site .box.list .box__body .tbl-list.hcal-180 {\n  height: calc(100% - 180px);\n}\n/* .admin-site .box.list .box__body .tbl-list.hcal-vh-315 {\n  height: calc(100vh - 315px) !important;\n}\n.admin-site .box.list .box__body .tbl-list.hcal-vh-415 {\n  height: calc(100vh - 415px) !important;\n}\n.admin-site .box.list .box__body .tbl-list.hcal-vh-430 {\n  height: calc(100vh - 430px) !important;\n}\n.admin-site .box.list .box__body .tbl-list.hcal-vh-560 {\n  height: calc(100vh - 560px) !important;\n} */\n.admin-site .tbl-list table {\n  border-bottom: 0;\n}\n.admin-site .tbl-list table th {\n  min-height: 32px;\n  padding: 8px 15px;\n  font-size: 14px;\n}\n.admin-site .tbl-list table td {\n  padding: 8px 15px;\n  font-size: 14px;\n  max-width: 120px;\n  height: 32px;\n}\n.admin-site .tbl-list.td-h26 table td {\n  height: 26px;\n}\n.admin-site .tbl-list.td-h32 table td {\n  height: 32px;\n}\n.admin-site.layout-w3 .tbl__bottom {\n  position: relative;\n}\n.admin-site.layout-w3 .area__left .tbl__bottom,\n.admin-site.layout-w3 .area__right .tbl__bottom,\n.admin-site.layout-w3 .area__right-end .tbl__bottom {\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n.admin-site.layout-w3 .area__left .tbl__bottom .result__num,\n.admin-site.layout-w3 .area__right .tbl__bottom .result__num,\n.admin-site.layout-w3 .area__right-end .tbl__bottom .result__num {\n  text-align: left;\n  width: 100%;\n}\n.admin-site.layout-w3 .area__left .tbl__bottom .paging,\n.admin-site.layout-w3 .area__right .tbl__bottom .paging,\n.admin-site.layout-w3 .area__right-end .tbl__bottom .paging {\n  width: 100%;\n  justify-content: center;\n}\n.admin-site.layout-w3 .area__left .tbl__bottom .paging ul,\n.admin-site.layout-w3 .area__right .tbl__bottom .paging ul,\n.admin-site.layout-w3 .area__right-end .tbl__bottom .paging ul {\n  margin-left: 0;\n  margin-top: 14px;\n}\n.admin-site.layout-w3 .tbl__bottom .paging__select {\n  display: none;\n}\n.workplace-ok.page-detail {\n  width: 910px;\n  height: 744px;\n}\n.workplace-ok.page-detail .popup__head {\n  border-bottom: 1px solid #dde2e9;\n}\n.workplace-ok.page-detail .popup__body {\n  padding: 1rem 40px;\n  width: calc(100% - 80px);\n  height: calc(100% - 170px);\n  max-height: none;\n  margin-top: 0;\n}\n.workplace-ok.page-detail .popup__body .tbl-list.type2 table th {\n  position: relative;\n}\n.workplace-ok.page-detail .workplace__info {\n  margin: 32px 0 6px;\n  display: flex;\n}\n.workplace-ok.page-detail .workplace__info .img_workplace {\n  width: 240px;\n  height: 240px;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace {\n  margin-left: 40px;\n  width: calc(100% - 240px);\n}\n.workplace-ok.page-detail .workplace__info .page-top {\n  margin-bottom: 28px;\n}\n.workplace-ok.page-detail .workplace__info .page-top h2 {\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 29px;\n  color: #2a2c2f;\n}\n.workplace-ok.page-detail .workplace__info .top-button button {\n  width: 28px;\n  height: 28px;\n}\n.workplace__info .top-button button.btn-edit.active {\n  background-color: #0a78ff;\n  border-color: #0a78ff;\n}\n.top-button button.btn-edit.active {\n  background-color: #0a78ff;\n  border-color: #0a78ff;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul {\n  width: calc(100% - 80px);\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul li {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul li p.tit {\n  width: 120px;\n  margin-right: 30px;\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 14px;\n  letter-spacing: -0.004em;\n  color: #2a2c2f;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul li p.txt {\n  width: calc(100% - 150px);\n  font-size: 15px;\n  line-height: 14px;\n  letter-spacing: -0.004em;\n  color: #2a2c2f;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul li .btn__wrap,\n.workplace-ok.page-detail .workplace__info .txt_workplace ul li .input__area {\n  width: calc(100% - 150px);\n  display: flex;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul li .input__area {\n  margin-left: 0;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul li .input__area textarea {\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 20px;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul.form__input li {\n  margin-bottom: 16px;\n  margin-top: 0;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul.form__input li p.tit {\n  margin-top: 8px;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul li .btn__wrap button {\n  width: 146px;\n  height: 40px;\n  border: 1px solid #909fb7;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul li .btn__wrap button + button {\n  margin-left: 8px;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul li .btn__wrap button span {\n  font-weight: 700;\n  color: #909fb7;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul li .btn__wrap button.bg-navy {\n  border-color: #003876;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul li .btn__wrap button.bg-navy span {\n  color: #fff;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul li .btn__wrap.right.w100p {\n  margin-top: 15px;\n  justify-content: flex-end;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul li .btn__wrap.right.w100p button {\n  width: 120px;\n  background: #0a78ff;\n  border: 0;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul li .btn__wrap.right.w100p button span {\n  color: #fff;\n}\n.workplace-ok.page-detail .popup__footer button:disabled {\n  background: #e9edef;\n}\n.workplace-ok.page-detail .popup__footer {\n  padding: 24px;\n  width: calc(100% - 48px);\n  border-top: 1px solid #dde2e9;\n}\n.workplace-ok.page-detail .popup__footer button {\n  width: 120px;\n}\n.workplace-ok.page-detail .popup__footer button + button {\n  margin-left: 8px;\n}\n.userjoin-ok.page-detail {\n  width: 1200px;\n  /* height: 596px; */\n  height: 663px;\n}\n.userjoin-ok.page-detail .popup__head {\n  border-bottom: 1px solid #dde2e9;\n}\n.userjoin-ok.page-detail .popup__body {\n  display: flex;\n  justify-content: space-between;\n  padding: 0 40px;\n  width: calc(100% - 80px);\n  margin-top: 0;\n}\n.userjoin-ok.page-detail .popup__body .left,\n.userjoin-ok.page-detail .popup__body .right {\n  width: calc(50% - 42px);\n  padding: 32px 0 28px;\n}\n.userjoin-ok.page-detail .popup__body h2 {\n  font-weight: 700;\n  font-size: 15px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  margin-bottom: 32px;\n}\n.userjoin-ok.page-detail .popup__body .form__input .tit {\n  font-weight: 700;\n  font-size: 15px;\n  color: #2a2c2f;\n  width: 180px;\n}\n.userjoin-ok.page-detail .popup__body .form__input .input__area,\n.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap {\n  width: calc(100% - 180px);\n  margin-left: 0;\n}\n.userjoin-ok.page-detail .popup__body .form__input .input__area textarea {\n  height: 146px;\n}\n.userjoin-ok.page-detail .popup__body .form__input li {\n  margin-bottom: 24px;\n}\n.userjoin-ok.page-detail .popup__body .form__input li:last-child {\n  margin-bottom: 0;\n}\n.userjoin-ok.page-detail .popup__body .form__input input[type=\"text\"],\n.userjoin-ok.page-detail .popup__body .form__input input[type=\"password\"],\n.userjoin-ok.page-detail .popup__body .form__input input[type=\"tel\"],\n.userjoin-ok.page-detail .popup__body .form__input input[type=\"file\"] {\n  background: #f0f2f4;\n  border: 0;\n  height: 32px;\n  font-weight: 400;\n}\n.userjoin-ok.page-detail .radioBox {\n  width: 100%;\n  justify-content: space-between;\n  display: inline-flex;\n}\n.userjoin-ok.page-detail .popup__body .form__input .radioBox label {\n  width: auto !important;\n  margin-left: 0;\n  font-weight: 500;\n  color: #2a2c2f;\n}\n.userjoin-ok.page-detail .popup__body .form__input button.btn-basic {\n  border: 0;\n  padding: 0 28px;\n  height: 26px;\n}\n.userjoin-ok.page-detail .popup__body .form__input.inline button.btn-basic {\n  height: 32px;\n}\n.userjoin-ok.page-detail .popup__body .form__input button.btn-basic span {\n  font-weight: 700;\n  font-size: 14px;\n}\n.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap {\n  display: flex;\n}\n.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap button {\n  width: 146px;\n  height: 40px;\n  border: 1px solid #909fb7;\n}\n.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap button + button {\n  margin-left: 8px;\n}\n.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap button span {\n  font-weight: 700;\n  color: #909fb7;\n}\n.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap button.bg-navy {\n  border-color: #003876;\n}\n.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap button.bg-navy span {\n  color: #fff;\n}\n.userjoin-ok.page-detail .popup__body .form__input .tbl-list.type2 {\n  width: 100%;\n  /* height: 313px; */\n  height: 360px;\n  overflow-y: auto;\n  border-bottom: 1px solid #dde2e9;\n}\n.userjoin-ok.page-detail .popup__body .form__input .tbl-list.type2 table {\n  border-bottom: 0;\n}\n.userjoin-ok.page-detail .popup__body .form__input .tbl-list.type2 table th {\n  padding: 12px 16px;\n}\n.userjoin-ok.page-detail .popup__body .form__input .tbl-list.type2 table td {\n  padding: 18px 16px;\n}\n.userjoin-ok.page-detail .popup__body .form__input .tbl-list.type2 table th,\n.userjoin-ok.page-detail .popup__body .form__input .tbl-list.type2 table td {\n  font-size: 14px;\n}\n.userjoin-ok .tbl-list table td button.btn-delete-g {\n  width: 24px;\n  height: 24px;\n  min-width: auto;\n}\n.userjoin-ok .popup__footer button:disabled {\n  background: #e9edef;\n}\n.icon-navi {\n  padding-left: 25px;\n  background: url(\"../img/icon_navi.png\") no-repeat 0 center;\n  background-size: 20px 20px;\n}\n.userjoin-ok.page-detail .popup__footer {\n  padding: 24px 42px;\n  width: calc(100% - 84px);\n  border-top: 1px solid #dde2e9;\n}\n.userjoin-ok.page-detail .popup__footer button {\n  width: 120px;\n}\n.userjoin-ok.page-detail .popup__footer button + button {\n  margin-left: 8px;\n}\n.userjoin-ok.page-detail .popup__body.layout-vertical {\n  flex-direction: column;\n  padding-top: 32px;\n  padding-bottom: 0;\n}\n.userjoin-ok.page-detail .popup__body.layout-vertical .form__input li {\n  justify-content: flex-start;\n  width: auto;\n  margin: 0 0 0 42px;\n}\n.userjoin-ok.page-detail .popup__body.layout-vertical .form__input li:first-child {\n  margin-left: 0;\n}\n\n.userjoin-ok.page-detail .popup__body.layout-vertical .form__input label {\n  width: auto;\n}\n.userjoin-ok.page-detail .popup__body.layout-vertical .form__input .input__area {\n  display: flex;\n  align-items: center;\n  width: 300px;\n  margin-left: 1rem;\n}\n.userjoin-ok.page-detail .popup__body.layout-vertical .tbl-list.type2 {\n  height: 370px;\n  border-bottom: 1px solid #dde2e9;\n  overflow-y: auto;\n}\n.userjoin-ok.page-detail .popup__body.layout-vertical .tbl-list.type2 table {\n  border-bottom: 0;\n}\n.userjoin-ok.page-detail .popup__body .form__input button.btn-basic.d-sm-block {\n  display: none;\n}\n.userjoin-ok.page-detail .popup__body.layout-vertical + .popup__footer {\n  padding: 24px 42px;\n  border-top: 0;\n}\n.popup-layer.pop-smallsearch {\n  width: 390px;\n}\n.popup-layer.pop-smallsearch .popup__head h1.icon-search {\n  display: flex;\n  align-items: center;\n}\n.popup-layer.pop-smallsearch .popup__head h1.icon-search::before {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  margin-right: 10px;\n  background: url(\"../img/icon_searchsamll.png\") no-repeat 0 center;\n  background-size: 100%;\n}\n.popup-layer.pop-smallsearch .popup__body {\n  margin-top: -8px;\n}\n.popup-layer.pop-smallsearch .popup__body .form__input li {\n  margin-top: 1rem;\n}\n.popup-layer.pop-smallsearch .popup__body .form__input li:first-child {\n  margin-top: 0;\n}\n.popup-layer.pop-smallsearch .popup__body .form__input label {\n  font-size: 14px;\n}\n.popup-layer.pop-smallsearch .popup__body .form__input .input__area {\n  height: 40px;\n}\n.popup-layer.pop-smallsearch .popup__body .form__input .input__area .select {\n  height: 100%;\n}\n.popup-layer.pop-smallsearch .popup__footer {\n  padding: 1rem 1rem 1.563rem;\n}\n/*사용자 타입팝업*/\n.popup-layer.pop-usertype {\n  width: 766px;\n}\n.popup-layer.pop-usertype .popup__body {\n  padding: 35px 24px 24px;\n  width: calc(100% - 48px);\n}\n.popup-layer.pop-usertype .user-info {\n  margin-bottom: 1rem;\n}\n.popup-layer.pop-usertype .user-info li {\n  display: flex;\n  margin-bottom: 26px;\n}\n.popup-layer.pop-usertype .user-info li:last-child {\n  margin-bottom: 0;\n}\n.popup-layer.pop-usertype .user-info li p {\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.popup-layer.pop-usertype .user-info li p strong {\n  font-weight: 700;\n}\n.popup-layer.pop-usertype .user-info li p span {\n  color: #909fb7;\n}\n.popup-layer.pop-usertype .user-info li p:first-child {\n  width: 93px;\n  display: flex;\n  flex-direction: column;\n}\n.popup-layer.pop-usertype .user-info li p:last-child {\n  width: calc(100% - 93px);\n  font-weight: 400;\n  line-height: 22px;\n}\n.popup-layer.pop-usertype .tbl__top {\n  margin-bottom: 8px;\n}\n.popup-layer.pop-usertype .tbl__top .info {\n  width: 100%;\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 20px;\n  text-align: right;\n  letter-spacing: -0.4px;\n  color: #909fb7;\n}\n.popup-layer.pop-usertype .tbl-list.type2 table th,\n.popup-layer.pop-usertype .tbl-list.type2 table td {\n  text-align: center;\n}\n.popup-layer.pop-usertype .tbl-list.type2 table tbody th {\n  padding: 13px 16px;\n  font-weight: 400;\n  background: #fff;\n  border-right: 1px solid #dde2e9;\n}\n.popup-layer.pop-usertype .tbl-list.type2 table tbody tr:nth-child(even) th {\n  background: #f8f9fa;\n}\n.use-ok {\n  margin: 0 auto;\n  width: 15px;\n  height: 10px;\n  background: url(\"../img/icon_check_gr.png\") no-repeat center center;\n  background-size: 100%;\n}\n\n/*진단점검요청 팝업*/\n.userjoin-ok.page-detail.casecheck-ok {\n  height: 636px;\n}\n.userjoin-ok.page-detail.casecheck-ok .popup__body.layout-vertical {\n  height: 466px;\n  justify-content: flex-start;\n}\n.userjoin-ok.page-detail.casecheck-ok .popup__body.layout-vertical h2 {\n  display: flex;\n  align-items: center;\n}\n.userjoin-ok.page-detail.casecheck-ok .popup__body.layout-vertical h2 span {\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 30px;\n  color: #2a2c2f;\n}\n.userjoin-ok.page-detail.casecheck-ok .popup__body.layout-vertical h2 span.checkstep {\n  color: #fff;\n  margin: 0 8px 0 0;\n  font-size: 16px;\n}\n.userjoin-ok.page-detail.casecheck-ok .popup__body.layout-vertical h2 img {\n  margin-right: 8px;\n  width: 24px;\n  height: 24px;\n}\n.userjoin-ok.page-detail.casecheck-ok .popup__body.layout-vertical .tit,\n.userjoin-ok.page-detail.casecheck-ok .popup__body.layout-vertical .form__input label {\n  font-size: 15px;\n  font-weight: 700;\n  color: #2a2c2f;\n  width: 150px;\n}\n.userjoin-ok.page-detail.casecheck-ok .popup__body.layout-vertical + .popup__footer {\n  border-top: 1px solid #dde2e9;\n}\n.userjoin-ok.page-detail.casecheck-ok .popup__body.layout-vertical .tbl-list.type2 {\n  height: auto;\n  max-height: 178px;\n  overflow-y: auto;\n}\n.userjoin-ok.page-detail.casecheck-ok .popup__body .form__input .box__search input[type=\"text\"] {\n  height: 18px;\n  width: 280px;\n  padding: 6px 30px 6px 8px;\n  background: #fff;\n  border: 1px solid #a4b0c4;\n}\n.userjoin-ok.page-detail.casecheck-ok .popup__body .form__input .box__search .btn-search {\n  right: 8px;\n  background: url(\"../img/icon_search_g.png\") no-repeat center center;\n  background-size: auto;\n}\n.admin-site.layout-w3 .area__right-end .tbl-list table th,\n.admin-site.layout-w3 .area__right-end .tbl-list table td {\n  padding: 8px;\n}\n.admin-site.layout-w3 .area__right-end .tbl-list table td {\n  max-width: 120px;\n}\n\n/*헤더-My Account 팝업*/\n.popup-basic.myaccount,\n.community .popup-layer.popup-basic.myaccount {\n  width: 560px;\n  height: auto;\n}\n.popup-basic.myaccount .popup__body {\n  padding: 40px 40px 37px;\n  width: calc(100% - 80px);\n  min-height: calc(75vh - 11.7rem);\n}\n.community .popup-layer.popup-basic.myaccount .input__area .select {\n  width: calc(100% - 2px);\n  height: 38px;\n}\n.popup-basic.myaccount .popup__body .form__input li {\n  margin-top: 26px;\n}\n.popup-basic.myaccount .popup__body .form__input li:first-child {\n  margin-top: 0;\n}\n.popup-basic.myaccount .popup__body .form__input label {\n  width: 49%;\n}\n.popup-basic.myaccount .popup__body .form__input .radioBox {\n  margin: 0;\n}\n.popup-basic.myaccount .popup__body .form__input .radioBox label {\n  margin-left: 10px;\n  width: auto;\n}\n.popup-basic.myaccount .popup__body .form__input .radioBox label:first-child {\n  margin-left: 0;\n}\n.popup-basic.myaccount .popup__body .form__input .radioBox input[type=\"radio\"] {\n  margin-right: 5px;\n  margin-top: 2px;\n}\n.popup-basic.myaccount .popup__body .form__input .radioBox input[type=\"radio\"]:disabled {\n  border-color: #e9edef;\n  background-color: #e9edef;\n}\n.popup-basic.myaccount .popup__body .form__input .radioBox input[type=\"radio\"]:checked:disabled {\n  background-color: #e9edef;\n  border-color: #e9edef;\n}\n.popup-basic.myaccount .popup__body .form__input .radioBox input[type=\"radio\"]:checked:disabled:before {\n  color: #909fb7;\n}\n.popup-basic.myaccount .popup__body .form__input .radioBox input[type=\"radio\"]:checked::before {\n  font-size: 0.65rem;\n}\n.popup-basic.myaccount .popup__body .form__input .btn-txt {\n  margin: 11px 0;\n}\n.popup-basic.myaccount .popup__body .form__input .btn-txt span {\n  font-weight: 400;\n  font-size: 14px;\n}\n.popup-basic.myaccount .form__input .select.active ul {\n  bottom: 30px;\n  border-radius: 4px 4px 0 0;\n}\n.popup-basic.myaccount .popup__footer {\n  padding: 24px 40px;\n  width: calc(100% - 80px);\n}\n.popup-basic.myaccount .popup__footer button.btn-txt {\n  width: auto;\n  padding: 0;\n  margin-right: 111px;\n}\n.popup-basic.myaccount .popup__footer button.btn-txt span {\n  font-weight: 500;\n}\n/*헤더-My Account 팝업 내 비밀번호 변경 팝업*/\n.popup-basic.myaccount.passchange .popup__head {\n  justify-content: flex-start;\n}\n.popup-basic.myaccount.passchange .popup__head h1 {\n  margin-left: 8px;\n}\n.popup-basic.myaccount.passchange .popup__head .btn-close {\n  width: 24px;\n  height: 24px;\n  background: url(../img/icon_prev_top.png) no-repeat center center;\n  background-size: 100%;\n}\n.popup-basic.myaccount.passchange .popup__body {\n  min-height: calc(75vh - 6.1rem);\n}\n.popup-basic.myaccount.passchange .popup__footer {\n  border-top: 0;\n  margin-top: 55px;\n}\n\n/*사업장추가-이미지크롭 팝업*/\n.popup-basic.imgcrop {\n  width: 560px;\n  height: 730px;\n}\n.popup-basic.imgcrop .popup__body {\n  height: calc(100% - 140px);\n  max-height: unset;\n  padding: 0;\n  width: 100%;\n}\n.popup-basic.imgcrop .popup__body .image-crop {\n  width: 560px;\n  height: 500px;\n  background: #d9d9d9;\n}\n.popup-basic.imgcrop .popup__body .scroller {\n  width: 100%;\n  height: 88px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.popup-basic.imgcrop .popup__body .scroller .scroller-wrap {\n  position: relative;\n}\n.popup-basic.imgcrop .popup__body .scroller .scroller-bar {\n  width: 320px;\n  height: 3px;\n  background: #909fb7;\n}\n.popup-basic.imgcrop .popup__body .scroller .scroller-dot {\n  position: absolute;\n  top: -10px;\n  width: 16px;\n  height: 16px;\n  background: #0a78ff;\n  border-radius: 50px;\n  border: 3px solid #fff;\n}\n.popup-basic.imgcrop .popup__footer {\n  padding: 25px 1rem;\n}\n\n/* 관리자_사업장관리_회사추가 */\n.admin-site .tabcontent.layout-w2 .area__left {\n  padding: 16px 0;\n  width: 310px;\n  height: calc(100% - 29px);\n}\n.admin-site .tabcontent.layout-w2 .area__left .lnb-depth1 > li > p {\n  min-height: 60px;\n}\n.admin-site .tabcontent.layout-w2 .area__left .lnb-depth1 > li.on p::before,\n.admin-site .tabcontent.layout-w2 .area__left .lnb-depth1 > li.active p::before {\n  min-height: 60px;\n}\n.admin-site .tabcontent.layout-w2 .area__left .lnb-depth1 > li > p span {\n  width: 100% !important;\n}\n.admin-site .tabcontent.layout-w2 .area__left .lnb-depth1 > li > p span:last-child {\n  background: none;\n  padding-left: 0;\n  font-weight: 500;\n}\n.admin-site .tabcontent.layout-w2 .area__left .lnb-depth1 > li.on p span,\n.admin-site .tabcontent.layout-w2 .area__left .lnb-depth1 > li.active p span {\n  font-weight: 700;\n}\n.admin-site .tabcontent.layout-w2 .area__left .lnb-depth2 {\n  margin: 8px 8px 8px 32px;\n  border-bottom: 0;\n}\n.admin-site .tabcontent.layout-w2 h2 {\n  display: flex;\n  align-items: center;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 20px;\n  color: #2a2c2f;\n  letter-spacing: -0.4px;\n}\n.admin-site .tabcontent.layout-w2 h2 .btn-more {\n  width: 32px;\n  height: 32px;\n  border: 0;\n  margin-left: 16px;\n  background: url(\"../img/icon_downbtn_s.png\") no-repeat center center;\n  background-size: 100%;\n  transform: scaleY(-1);\n}\n.admin-site .tabcontent.layout-w2 h2 .btn-more.on {\n  transform: scaleY(1);\n}\n.admin-site .tabcontent.layout-w2 .area__right_content.workplace__info {\n  position: relative;\n  width: calc(100% - 340px);\n  padding: 16px 24px 18px;\n  margin: 0;\n}\n\n.admin-site.rightcont-half .tabcontent .lnb {\n  max-height: unset;\n  height: calc(100vh - 215px);\n}\n.admin-site.rightcont-half\n  .tabcontent.layout-w2\n  .area__right_content.workplace__info\n  .content__info\n  + .content__info.boxlist {\n  max-height: unset;\n  height: calc(100vh - 650px);\n}\n.admin-site .tabcontent.layout-w2 .area__right_content.workplace__info .content__info {\n  padding: 0;\n}\n.admin-site .tabcontent.layout-w2 .area__right_content.workplace__info .content__info + .content__info {\n  padding-top: 40px;\n  padding-left: 24px;\n  padding-right: 24px;\n  margin-left: -24px;\n  width: 100%;\n  max-height: unset;\n  height: calc(100vh - 650px);\n}\n.admin-site .tabcontent.layout-w2 .area__right_content.workplace__info .content__info + .content__info.boxlist {\n  max-height: 280px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.admin-site .tabcontent.layout-w2 .area__right_content.workplace__info .content__info.hidden {\n  display: none;\n}\n.admin-site .tabcontent.layout-w2 .area__right_content.workplace__info .content__info.hidden + .content__info.boxlist {\n  overflow-y: auto;\n  max-height: unset;\n}\n.admin-site .tabcontent.layout-w2 .area__right_content.workplace__info .content__info + .content__info .column {\n  width: 100%;\n}\n.admin-site .tabcontent.layout-w2 .area__right_content .page-top {\n  margin-bottom: 30px;\n  margin-top: 18px;\n  padding: 0;\n}\n.admin-site .tabcontent.layout-w2 .area__right_content .btn__wrap button + button {\n  margin-left: 8px;\n}\n.admin-site .tabcontent.layout-w2 .area__right_content .content__info ul li .result__score p.tit.caution {\n  display: flex;\n  align-items: center;\n  font-size: 15px;\n  color: #2a2c2f;\n  font-weight: 400;\n  margin-top: 0;\n  width: calc(100% - 88px);\n}\n.admin-site .tabcontent.layout-w2 .area__right_content .content__info ul li .result__score p.tit.caution::before {\n  content: \"\";\n  width: 16px;\n  height: 16px;\n  margin-right: 4px;\n  background: url(\"../img/icon_caution.png\") no-repeat top center;\n  background-size: 100%;\n}\n.admin-site .tabcontent.layout-w2 .area__right_content .content__info ul li .result__score p.tit.caution::after {\n  content: \"\";\n  width: 14px;\n  height: 14px;\n  margin-left: 135px;\n  background: url(\"../img/icon_eq.png\") no-repeat center center;\n  background-size: 100%;\n}\n.admin-site .tabcontent.layout-w2 .area__right_content .content__info ul li .result__score {\n  display: flex;\n  align-items: center;\n}\n.admin-site .tabcontent.layout-w2 .area__right_content .content__info ul li .result__score::after {\n  content: \"점\";\n  margin-left: 7px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #909fb7;\n}\n.admin-site .tabcontent.layout-w2 .area__right_content .content__info ul li .result__score .select.active ul {\n  max-height: 162px;\n  overflow-y: auto;\n}\n.admin-site .tabcontent.layout-w2 .area__right_content.workplace__info .content__info .listbox__top {\n  margin-bottom: 22px;\n  margin-top: -16px;\n}\n.admin-site .tabcontent.layout-w2 .area__right_content.workplace__info.workplace__main.newtype .content__info ul li {\n  margin-bottom: 20px;\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content.workplace__info.workplace__main.newtype\n  .content__info\n  .listbox__top\n  h3 {\n  margin-bottom: 0;\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content.workplace__info.workplace__main.newtype\n  .content__info\n  .listbox__top\n  button.add__item {\n  width: 128px;\n  height: 32px;\n  background: #e7f2ff;\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content.workplace__info.workplace__main.newtype\n  .content__info\n  .listbox__area {\n  grid-auto-rows: 240px;\n  grid-template-columns: repeat(auto-fill, minmax(358px, 1fr));\n  padding-bottom: 10px;\n}\n.admin-site .tabcontent.layout-w2 .area__right_content.workplace__info.workplace__main.newtype .content__info .listbox {\n  height: 240px;\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content.workplace__info.workplace__main.newtype\n  .content__info\n  .listbox\n  .box__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: calc(100% - 32px);\n  padding: 12px 16px;\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content.workplace__info.workplace__main.newtype\n  .content__info\n  .listbox\n  .box__top\n  p {\n  font-size: 15px;\n  max-width: 300px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content.workplace__info.workplace__main.newtype\n  .content__info\n  .listbox\n  .box__bottom {\n  padding: 16px 16px 28px;\n  display: flex;\n  justify-content: space-between;\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content.workplace__info.workplace__main.newtype\n  .content__info\n  .listbox\n  .box__bottom\n  .left.img_workplace {\n  width: 152px;\n  height: 152px;\n  margin-right: 16px;\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content.workplace__info.workplace__main.newtype\n  .content__info\n  .listbox\n  .box__bottom\n  .right {\n  width: calc(100% - 168px);\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content.workplace__info.workplace__main.newtype\n  .content__info\n  .listbox\n  .box__bottom\n  .right\n  ul\n  li {\n  font-size: 15px;\n  line-height: 16px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content.workplace__info.workplace__main.newtype\n  .content__info\n  .listbox\n  .box__bottom\n  .right\n  ul\n  + ul {\n  border-top: 1px solid #dde2e9;\n  margin-top: 12px;\n  padding-top: 16px;\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content.workplace__info.workplace__main.newtype\n  .content__info\n  .listbox\n  .box__bottom\n  .right\n  ul\n  li\n  strong {\n  font-weight: 500;\n  margin-right: 7px;\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content.workplace__info.workplace__main.newtype\n  .content__info\n  .listbox\n  .box__bottom\n  .right\n  ul\n  li\n  .tit {\n  font-weight: 700;\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content.workplace__info.workplace__main.newtype\n  .content__info\n  .listbox\n  .box__bottom\n  .right\n  ul\n  li {\n  margin-bottom: 12px;\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content.workplace__info.workplace__main.newtype\n  .content__info\n  .listbox\n  .box__bottom\n  .right\n  ul\n  li:first-child {\n  margin-bottom: 12px;\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content.workplace__info.workplace__main.newtype\n  .content__info\n  .listbox\n  .box__bottom\n  .right\n  ul\n  li\n  .score__info {\n  margin-top: -2px;\n  margin-bottom: 0;\n  font-size: 12px;\n  line-height: 20px;\n  text-align: justify;\n  letter-spacing: -0.4px;\n  color: #909fb7;\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content.workplace__info.workplace__main.newtype\n  .content__info\n  .listbox\n  .box__bottom\n  .right\n  ul\n  li\n  .result__score {\n  justify-content: space-between;\n  width: 100%;\n  margin-top: 2px;\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content\n  .content__info\n  .listbox\n  .box__bottom\n  .right\n  ul\n  li\n  .result__score::after {\n  content: none;\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content\n  .content__info\n  .listbox\n  .box__bottom\n  .right\n  ul\n  li\n  .result__score\n  .score::after {\n  content: \"점\";\n  margin-left: 7px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #909fb7;\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content.workplace__info.workplace__main.newtype\n  .content__info\n  .listbox\n  .box__bottom\n  .right\n  ul\n  li\n  .result__score\n  .tit {\n  font-weight: 400;\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content.workplace__info.workplace__main.newtype\n  .content__info\n  .listbox\n  .box__bottom\n  .right\n  ul\n  li\n  .result__score\n  p.tit.caution {\n  width: auto;\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content.workplace__info.workplace__main.newtype\n  .content__info\n  .listbox\n  .box__bottom\n  .right\n  ul\n  li\n  .result__score\n  p.tit.caution::before {\n  width: 12px;\n  height: 11px;\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content.workplace__info.workplace__main.newtype\n  .content__info\n  .listbox\n  .box__bottom\n  .right\n  ul\n  li\n  .result__score\n  p.tit.caution::after {\n  content: none;\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content.workplace__info.workplace__main.newtype\n  .content__info\n  .listbox\n  .box__bottom\n  .right\n  ul\n  li\n  .result__score\n  .score {\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n}\n.admin-site\n  .tabcontent.layout-w2\n  .area__right_content.workplace__info.workplace__main.newtype\n  .content__info\n  .listbox\n  .box__bottom\n  .right\n  ul\n  li\n  .result__score\n  .score::before {\n  content: \"\";\n  margin-right: 7px;\n  width: 10px;\n  height: 10px;\n  background: url(../img/icon_eq.png) no-repeat center center;\n  background-size: 100%;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column {\n  width: calc(100% - 150px);\n  font-size: 15px;\n  line-height: 14px;\n  letter-spacing: -0.004em;\n  color: #2a2c2f;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column .result__score {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 20px;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column .result__score .tit.caution {\n  display: flex;\n  align-items: center;\n  width: calc(100% - 150px);\n  font-weight: 400;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column .result__score .tit.caution::before {\n  content: \"\";\n  width: 14px;\n  height: 14px;\n  margin-right: 6px;\n  background: url(\"../img/icon_caution.png\") no-repeat center center;\n  background-size: 100%;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column .result__score .score {\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 12px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  width: 120px;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column .result__score .score::before {\n  content: \"\";\n  margin-right: 12px;\n  width: 14px;\n  height: 14px;\n  background: url(\"../img/icon_eq.png\") no-repeat center center;\n  background-size: 100%;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column .result__score .score::after {\n  content: \"점\";\n  margin-left: 12px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #909fb7;\n}\n.workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column .score__info {\n  margin-top: 0;\n  font-size: 15px;\n  line-height: 24px;\n  text-align: justify;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n/* 관리자_사용자관리_사용자목록 */\n.admin-site .tabcontent.layout-w2 .tbl__bottom .paging__select {\n  display: flex;\n}\ntd.icon-dot span {\n  display: flex;\n  align-items: center;\n}\ntd.icon-dot span::before {\n  content: \"\";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 8px;\n  height: 8px;\n  margin-right: 14px;\n  background: #f55547;\n  border-radius: 50px;\n}\ntd.icon-dot.pl-16 span::before {\n  margin-right: 8px;\n}\ntd.icon-dot.pl-22,\ntd.icon-dot.pl-16 {\n  padding-left: 0 !important;\n}\n.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.user-list {\n  height: calc(100% - 200px);\n}\n.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.user-list table th {\n  padding: 7px;\n}\n.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.user-list table td {\n  height: 34px;\n  padding: 7px;\n}\n.btn-on {\n  width: 115px;\n  height: 32px;\n  background: url(../img/icon_btnon.png) no-repeat 0 0;\n  background-size: 100%;\n}\n.btn-off {\n  width: 115px;\n  height: 32px;\n  background: url(../img/icon_btnoff.png) no-repeat 0 0;\n  background-size: 100%;\n}\n.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap button.btn-on,\n.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap button.btn-off {\n  width: 114px;\n  height: 32px;\n  border: 0;\n}\n.btn-on.disabled,\n.btn-off.disabled {\n  background: #f0f2f4;\n  border-color: #f0f2f4;\n}\n.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap button.txtline {\n  width: auto;\n  height: auto;\n  border: 0;\n}\n.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap button.txtline span {\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 0px;\n  color: #909fb7;\n  text-decoration: underline;\n}\n.userjoin-ok.page-detail .popup__body.alldisabled .form__input input[type=\"text\"] {\n  color: #c8d0dc;\n}\n.userjoin-ok.page-detail .popup__body.alldisabled .form__input .tit {\n  color: #91a1b9;\n}\n.userjoin-ok.page-detail .popup__body.alldisabled .form__input .radioBox label {\n  color: #c8d0dc;\n  cursor: default;\n}\n.userjoin-ok.page-detail .popup__body.alldisabled .form__input .radioBox input[type=\"radio\"] {\n  border-color: #c8d0dc !important;\n  cursor: default;\n}\n.userjoin-ok.page-detail .popup__body.alldisabled .form__input .tbl-list.type2 table td {\n  color: #c8d0dc;\n}\n.userjoin-ok.page-detail .popup__body.alldisabled .form__input .tbl-list.type2 table td .icon-navi {\n  filter: opacity(0.5);\n}\n.userjoin-ok.page-detail .popup__body.alldisabled .form__input .tbl-list.type2 table td button.btn-delete-g {\n  filter: opacity(0.25);\n}\n.userjoin-ok.page-detail .popup__body.alldisabled .txt-info {\n  color: #dde2e9;\n}\n\n/* 관리자_승인 관리 */\n.admin-site .area__left .area__left_content.detail__view,\n.admin-site .area__right .area__right_content.detail__view,\n.admin-site .area__right-end .area__right_content.detail__view {\n  height: calc(100% - 73px);\n}\n\n/* 관리자_메뉴 관리_메뉴별 권한 설정 */\n.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.menuset-list {\n  height: calc(100vh - 290px);\n  overflow-y: auto;\n}\n.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.menuset-list table thead {\n  position: sticky;\n  position: -webkit-sticky;\n  top: 0;\n  z-index: 2;\n}\n.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.menuset-list table td {\n  height: 34px;\n  padding: 7px 15px;\n}\n.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.menuset-list table td .ellipsis {\n  width: 100%;\n}\n.tbl-list.menuset-list input[type=\"checkbox\"] + label:before {\n  width: 12px;\n  height: 12px;\n  border-radius: 0;\n}\n.tbl-list.menuset-list input[type=\"checkbox\"]:checked + label:after {\n  width: 12px;\n  height: 12px;\n  border-radius: 0;\n  background-size: 10px;\n  background-position-y: 2px;\n}\n.tbl-list.menuset-list input[type=\"checkbox\"]:disabled + label:before {\n  background-color: #e9edef;\n  border-color: #e9edef;\n}\n.tbl-list.menuset-list input[type=\"checkbox\"].readonly:disabled + label:before {\n  border-color: #909fb7;\n  background: url(\"../img/icon_chk_s.png\") no-repeat center center #909fb7;\n  background-size: 10px;\n}\n.tbl-list.menuset-list input[type=\"checkbox\"].error + label:before {\n  border-color: #f55547;\n  background-color: #fff;\n}\n.tbl-list.menuset-list input[type=\"checkbox\"].error:checked + label:after {\n  border-color: #f55547;\n  background: url(\"../img/icon_chk_s.png\") no-repeat center center #f55547;\n  background-size: 10px;\n}\n.tbl-list.menuset-list input[type=\"checkbox\"] {\n  position: unset;\n  width: auto;\n}\n.tbl-list.lang-list input[type=\"text\"] {\n  width: calc(100% - 1.625rem);\n  height: 1.875rem;\n  padding: 0 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #2a2c2f;\n  border: 1px solid #909fb7;\n  border-radius: 4px;\n}\n.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.lang-list {\n  height: calc(100% - 180px);\n}\n.tbl-list.lang-list table td:nth-child(3),\n.tbl-list.lang-list table td:nth-child(4) {\n  border-left: 4px solid #dde2e9;\n}\n.admin-site.layout-w3 .tbl-list.lang-list table th {\n  padding: 8px;\n}\n.admin-site.layout-w3 .tbl-list.lang-list table td {\n  padding: 8px;\n  vertical-align: top;\n}\n.admin-site.layout-w3 .tbl-list.lang-list table tr.on td {\n  background: #e7f2ff;\n}\n.tbl-list.lang-list input[type=\"text\"] {\n  background-color: #fff;\n}\n.tbl-list.lang-list table td .input-errortxt {\n  display: block;\n  position: relative;\n  top: unset;\n  text-align: left;\n  margin-top: 3px;\n}\n.tbl-list.lang-list table td .ellipsis {\n  margin-top: 8px;\n  width: 100%;\n}\n\n/* 관리자_메세지 관리_e-Health Checker 메세지 */\n.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.message-list {\n  height: calc(100% - 180px);\n}\n.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.message-list.hcal-140 {\n  height: calc(100% - 140px);\n}\n.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.message-list.hcal-vh-180 {\n  height: calc(100vh - 180px);\n  overflow-y: auto;\n}\n.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.message-list.hcal-vh-180 table thead {\n  position: sticky;\n  position: -webkit-sticky;\n  top: 0;\n  z-index: 2;\n}\n.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.message-list table th {\n  padding: 7px 15px;\n}\n.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.message-list table td {\n  height: 34px;\n  padding: 7px 15px;\n}\n.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.message-list table td strong {\n  font-weight: 500;\n  color: #000;\n}\n.messagelang {\n  display: flex;\n  align-items: center;\n}\n.messagelang::after {\n  content: \"\";\n  width: 9px;\n  height: 12px;\n  margin-left: 21px;\n  background: url(\"../img/icon_arrow_g.png\") no-repeat center center;\n  background-size: 100%;\n  cursor: pointer;\n}\n.messagelang li {\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: -0.2px;\n  color: #dde2e9;\n}\n.messagelang li + li {\n  margin-left: 16px;\n}\n.messagelang li.on {\n  color: #0a78ff;\n}\n.checker-message.page-detail {\n  width: 560px;\n  /* height: 776px; */\n  height: auto;\n}\n.checker-message.page-detail .popup__head {\n  border-bottom: 1px solid #dde2e9;\n}\n.checker-message.page-detail .popup__body {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 0 40px;\n  width: calc(100% - 80px);\n  margin: 32px 0 24px;\n}\n.checker-message.page-detail .popup__body .form__input {\n  width: 100%;\n  margin-bottom: 24px;\n}\n.checker-message.page-detail .popup__body .form__input + .form__input {\n  padding-top: 24px;\n  border-top: 1px solid #dde2e9;\n}\n.checker-message.page-detail .popup__body h2 {\n  font-weight: 700;\n  font-size: 15px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  margin-bottom: 32px;\n}\n.checker-message.page-detail .popup__body .form__input .tit {\n  font-weight: 700;\n  font-size: 15px;\n  color: #2a2c2f;\n  width: 222px;\n}\n.checker-message.page-detail .popup__body .form__input .sub-input {\n  margin-top: 1rem;\n  align-items: flex-start;\n}\n.checker-message.page-detail .popup__body .form__input .sub-input + .sub-input {\n  margin-top: 8px;\n}\n.checker-message.page-detail .popup__body .form__input .sub-input .tit {\n  font-weight: 500;\n  font-size: 13px;\n  color: #2a2c2f;\n  width: 222px;\n  vertical-align: top;\n  margin-top: 8px;\n}\n.checker-message.page-detail .popup__body .form__input .input__area,\n.checker-message.page-detail .popup__body .form__input li .btn__wrap {\n  width: 100%;\n}\n.checker-message.page-detail .popup__body .form__input li {\n  /* margin-bottom: 24px; */\n}\n.checker-message.page-detail .popup__body .form__input li:last-child {\n  margin-bottom: 0;\n}\n.checker-message.page-detail .popup__body .form__input input[type=\"text\"] {\n  height: 32px;\n  font-weight: 400;\n}\n.checker-message.page-detail .popup__body .form__input .input__area textarea {\n  height: 48px;\n  padding: 8px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n}\n.checker-message.page-detail .popup__body .form__input input[type=\"text\"]:disabled {\n  background: #f0f2f4;\n  border: 0;\n}\n.checker-message.page-detail .popup__body .form__input .input__area textarea:read-only {\n  background: #f0f2f4;\n  border: 0;\n}\n.checker-message.page-detail .popup__body .form__input button.btn-basic {\n  border: 0;\n  padding: 0 28px;\n  height: 26px;\n}\n.checker-message.page-detail .popup__body .form__input.inline button.btn-basic {\n  height: 32px;\n}\n.checker-message.page-detail .popup__body .form__input button.btn-basic span {\n  font-weight: 700;\n  font-size: 14px;\n}\n.checker-message.page-detail .popup__body .form__input li .btn__wrap {\n  display: flex;\n}\n.checker-message.page-detail .popup__body .form__input li .btn__wrap button {\n  width: 146px;\n  height: 40px;\n  border: 1px solid #909fb7;\n}\n.checker-message.page-detail .popup__body .form__input li .btn__wrap button + button {\n  margin-left: 8px;\n}\n.checker-message.page-detail .popup__body .form__input li .btn__wrap button span {\n  font-weight: 700;\n  color: #909fb7;\n}\n.checker-message.page-detail .popup__body .form__input li .btn__wrap button.bg-navy {\n  border-color: #003876;\n}\n.checker-message.page-detail .popup__body .form__input li .btn__wrap button.bg-navy span {\n  color: #fff;\n}\n.checker-message .tbl-list table td button.btn-delete-g {\n  width: 24px;\n  height: 24px;\n  min-width: auto;\n}\n.checker-message .popup__footer button:disabled {\n  background: #e9edef;\n}\n.icon-navi {\n  padding-left: 25px;\n  background: url(\"../img/icon_navi.png\") no-repeat 0 center;\n  background-size: 20px 20px;\n}\n.checker-message.page-detail .popup__footer {\n  padding: 24px 42px;\n  width: calc(100% - 84px);\n  border-top: 1px solid #dde2e9;\n}\n.checker-message.page-detail .popup__footer button {\n  width: 120px;\n}\n.checker-message.page-detail .popup__footer button + button {\n  margin-left: 8px;\n}\n\n/*체크시트관리*/\n.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.checksheet-list {\n  height: calc(100% - 180px);\n}\n.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.checksheet-list table th {\n  padding: 7px 15px;\n}\n.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.checksheet-list table td {\n  height: 34px;\n  padding: 7px 15px;\n}\n.admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.checksheet-list table td strong {\n  font-weight: 500;\n}\n.admin-site .box.list .box__body .tbl-list.checksheet-list.hcal-270 {\n  height: calc(100% - 270px);\n}\n.admin-site.layout-w3 .box.list .box__body .area__right .tbl-list.checksheet-list.hcal-300 + .tbl__bottom {\n  flex-direction: row;\n}\n.admin-site.layout-w3 .box.list .box__body .area__right .tbl-list.checksheet-list.hcal-300 + .tbl__bottom .result__num {\n  width: auto;\n}\n.checksheet-list .btn-more {\n  width: 9px;\n  height: 12px;\n  min-width: auto;\n  padding: 0;\n  margin: 0 auto;\n  background: url(\"../img/icon_arrow_g.png\") no-repeat center center;\n}\n.checker-sheet.page-detail {\n  width: 560px;\n  height: auto;\n  /* height: 778px; */\n}\n.checker-sheet.page-detail .popup__head {\n  border-bottom: 1px solid #dde2e9;\n}\n.checker-sheet.page-detail .popup__body {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 0 40px;\n  width: calc(100% - 80px);\n  max-height: calc(75vh - 7.42rem);\n  margin: 32px 0 24px;\n}\n.checker-sheet.page-detail .popup__body .form__input {\n  width: 100%;\n  margin-bottom: 32px;\n}\n.checker-sheet.page-detail .popup__body .form__input + .tbl-list {\n  margin-top: -8px;\n}\n.checker-sheet.page-detail .popup__body h2 {\n  font-weight: 700;\n  font-size: 15px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  margin-bottom: 32px;\n}\n.checker-sheet.page-detail .popup__body .form__input .tit {\n  font-weight: 700;\n  font-size: 15px;\n  color: #2a2c2f;\n  width: 222px;\n}\n.checker-sheet.page-detail .popup__body .form__input .sub-input {\n  margin-top: 1rem;\n  align-items: flex-start;\n}\n.checker-sheet.page-detail .popup__body .form__input .sub-input + .sub-input {\n  margin-top: 8px;\n}\n.checker-sheet.page-detail .popup__body .form__input .sub-input .tit {\n  font-weight: 500;\n  font-size: 13px;\n  color: #2a2c2f;\n  width: 222px;\n  vertical-align: top;\n  margin-top: 8px;\n}\n.checker-sheet.page-detail .popup__body .form__input .input__area,\n.checker-sheet.page-detail .popup__body .form__input li .btn__wrap {\n  width: 100%;\n}\n.checker-sheet.page-detail .popup__body .form__input li {\n  margin-top: 8px;\n}\n.checker-sheet.page-detail .popup__body .form__input li:first-child {\n  margin-top: 0;\n}\n.checker-sheet.page-detail .popup__body .form__input li:last-child {\n  margin-bottom: 0;\n}\n.checker-sheet.page-detail .popup__body .form__input input[type=\"text\"] {\n  height: 32px;\n  font-weight: 400;\n}\n.checker-sheet.page-detail .popup__body .form__input .input__area textarea {\n  height: 48px;\n  padding: 8px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n}\n.checker-sheet.page-detail .popup__body .form__input input[type=\"text\"]:disabled {\n  background: #f0f2f4;\n  border: 0;\n}\n.checker-sheet.page-detail .popup__body .form__input .input__area textarea:read-only {\n  background: #f0f2f4;\n  border: 0;\n}\n.checker-sheet.page-detail .popup__body .tbl-list td {\n  padding: 8px 4px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  vertical-align: top;\n}\n.checker-sheet.page-detail .popup__body .tbl-list td p {\n  margin: 8px 0;\n}\n.checker-sheet.page-detail .popup__body .tbl-list .input__area textarea {\n  height: 41px;\n  padding: 5px 12px 2px 4px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n}\n.checker-sheet.page-detail .popup__body .form__input button.btn-basic {\n  border: 0;\n  padding: 0 28px;\n  height: 26px;\n}\n.checker-sheet.page-detail .popup__body .form__input.inline button.btn-basic {\n  height: 32px;\n}\n.checker-sheet.page-detail .popup__body .form__input button.btn-basic span {\n  font-weight: 700;\n  font-size: 14px;\n}\n.checker-sheet.page-detail .popup__body .form__input li .btn__wrap {\n  display: flex;\n}\n.checker-sheet.page-detail .popup__body .form__input li .btn__wrap button {\n  width: 146px;\n  height: 40px;\n  border: 1px solid #909fb7;\n}\n.checker-sheet.page-detail .popup__body .form__input li .btn__wrap button + button {\n  margin-left: 8px;\n}\n.checker-sheet.page-detail .popup__body .form__input li .btn__wrap button span {\n  font-weight: 700;\n  color: #909fb7;\n}\n.checker-sheet.page-detail .popup__body .form__input li .btn__wrap button.bg-navy {\n  border-color: #003876;\n}\n.checker-sheet.page-detail .popup__body .form__input li .btn__wrap button.bg-navy span {\n  color: #fff;\n}\n.checker-sheet .tbl-list table td button.btn-delete-g {\n  width: 24px;\n  height: 24px;\n  min-width: auto;\n}\n.checker-sheet .popup__footer button:disabled {\n  background: #e9edef;\n}\n.checker-sheet.page-detail .popup__footer {\n  padding: 24px 42px;\n  width: calc(100% - 84px);\n  border-top: 1px solid #dde2e9;\n}\n.checker-sheet.page-detail .popup__footer button {\n  width: 120px;\n}\n.checker-sheet.page-detail .popup__footer button + button {\n  margin-left: 8px;\n}\n.checker-sheet.page-detail .popup__body .tab__small {\n  border-bottom: 1px solid #909fb7;\n  margin-left: -40px;\n  margin-right: -40px;\n}\n.checker-sheet.page-detail .popup__body .tab__small li:first-child {\n  margin-left: 40px;\n}\n.checker-sheet.page-detail .popup__body .tab__small li + li {\n  border: 0;\n  margin: 0;\n  padding: 0;\n}\n.checker-sheet.page-detail .popup__body .tab__small li a {\n  width: 100px;\n  height: 40px;\n}\n.checker-sheet.page-detail .popup__body .tab__small li.on a {\n  border-bottom: 4px solid #0a78ff;\n}\n.versioninfo {\n  margin-top: 34px;\n  margin-bottom: 22px;\n  text-align: center;\n}\n.versioninfo li {\n  margin-bottom: 18px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.versioninfo li strong {\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 22px;\n  margin-left: 37px;\n}\n\n/*관리자-이메일상담*/\n.form__input li.column {\n  align-items: flex-start;\n}\n.form__input li.column .input__area {\n  margin-left: 0;\n  margin-top: 16px;\n}\n.checker-message.page-detail .filelist li {\n  display: inline-flex;\n  width: auto;\n  margin: 0 15px 0 0;\n}\n\n/*점검출동요청*/\n.layout-w1 .content {\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr;\n  width: 100%;\n  padding-left: 0;\n  grid-gap: 0;\n}\n\n/*workorder_점검출동*/\n.area__top {\n  padding: 25px 26px;\n  border-bottom: 1px solid #dde2e9;\n  margin: -16px -24px;\n  margin-bottom: 30px;\n}\n.area__top h2 {\n  margin-bottom: 28px;\n}\n.area__top + .nodata__txt {\n  margin-top: -60px !important;\n}\n.admin-site .area__right .area__top .search {\n  padding: 0;\n  border-bottom: 0;\n  justify-content: flex-start;\n}\n.tabcontent .area__top .search .form__input {\n  width: auto;\n  margin-bottom: 0;\n}\n.tabcontent .area__top .search .form__input .input__area {\n  width: auto;\n}\n.tabcontent .area__top .search .form__input + .btn__wrap {\n  margin-left: 8px;\n}\n.admin-site .area__right .tbl__top .searcharea {\n  margin-bottom: 0;\n}\n.searcharea .select + input[type=\"text\"] {\n  margin-left: 8px;\n}\n\n.admin-site.workorder .area__left.only-depth2 + .area__right {\n  height: calc(100% - 59px);\n}\n.admin-site.workorder .area__right .area__right_content {\n  /* height: calc(100% - 230px); */\n  height: calc(100% - 190px);\n}\n.admin-site.workorder .box.list .box__body .area__right .area__right_content .tbl-list {\n  height: calc(100% - 165px);\n  overflow-y: hidden;\n}\n.workorder .tabcontent .area__top .search .form__input li:last-child label {\n  width: 98px;\n  margin-left: 0 !important;\n}\n.admin-site.workorder .nodata .nodata__txt {\n  color: #909fb7;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 26px;\n  border-bottom: 1px solid #dde2e9;\n  /* margin-top: -80px; */\n}\n.admin-site.workorder .nodata .nodata__txt::before {\n  content: \"\";\n  width: 162px;\n  height: 100px;\n  margin-bottom: 16px;\n}\n.checkstatus-box {\n  display: flex;\n  /* margin-bottom: 48px; */\n  margin-bottom: 34px;\n}\n.checkstatus-box li {\n  display: flex;\n  margin: 2px 0 0 2px;\n}\n.checkstatus-box li + li {\n  margin-left: 40px;\n  padding-left: 40px;\n  border-left: 1px solid #dde2e9;\n}\n.checkstatus-box li + li div {\n  position: relative;\n}\n/* .checkstatus-box li + li div::after {\n  content: \"\";\n  display: block;\n  padding-right: 8px;\n  margin-left: -8px;\n  width: 100%;\n  margin-top: 9px;\n  border-bottom: 2px solid #dde2e9;\n} */\n/* .checkstatus-box li + li div::before {\n  content: \"\";\n  position: absolute;\n  bottom: -2px;\n  left: -10px;\n  width: 6px;\n  height: 6px;\n  border-radius: 50px;\n  background: #dce1e9;\n} */\n.checkstatus-box li + li div:first-child:before {\n  content: \"\";\n  left: 0;\n}\n.checkstatus-box li + li div:first-child:after {\n  content: \"\";\n  margin-left: 0;\n}\n/* .checkstatus-box li + li div:last-child a::after {\n  content: \"\";\n  position: absolute;\n  right: -1px;\n  bottom: -2px;\n  width: 6px;\n  height: 6px;\n  border-radius: 50px;\n  background: #dce1e9;\n} */\n.checkstatus-box li div a {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 188px;\n  height: 48px;\n  padding: 16px;\n  background: #ffffff;\n  box-shadow: 2px 2px 8px rgba(144, 159, 183, 0.5);\n  border-radius: 4px;\n}\n.checkstatus-box li div.on a {\n  background: #0a78ff;\n}\n.checkstatus-box li div.on a p,\n.checkstatus-box li div.on a p strong {\n  color: #fff;\n}\n.checkstatus-box li div a:hover {\n  background: #e6f0ff;\n}\n.checkstatus-box li div.on a:hover {\n  background: #0a78ff;\n}\n/* .checkstatus-box li + li div.on::before,\n.checkstatus-box li + li div.end::before {\n  content: \"\";\n  background: #006aff;\n}\n.checkstatus-box li + li div.on::after,\n.checkstatus-box li + li div.end::after {\n  content: \"\";\n  border-color: #006aff;\n}\n.checkstatus-box li + li div.on + div::before {\n  content: \"\";\n  background: #006aff;\n}\n.checkstatus-box li + li div.on:last-child a::after {\n  content: \"\";\n  background: #006aff;\n} */\n.checkstatus-box li div + div {\n  margin-left: 8px;\n}\n.checkstatus-box li div p:first-child {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 14px;\n  letter-spacing: -0.4px;\n  color: #646c74;\n}\n.checkstatus-box li div p:last-child {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 14px;\n  text-align: right;\n  letter-spacing: -0.4px;\n  color: #646c74;\n}\n.checkstatus-box li div p strong {\n  font-weight: 700;\n  font-size: 32px;\n  letter-spacing: -0.6px;\n  color: #003876;\n  margin-right: 8px;\n}\n\n/* workorder lnb */\n.admin-site .area__left.only-depth2 {\n  width: 320px;\n  margin-right: 0;\n  margin-top: 0;\n}\n.admin-site .area__left.only-depth2 .lnb {\n  max-height: 850px;\n}\n.area__left.only-depth2.close {\n  width: 38px !important;\n}\n.area__left.only-depth2.close .lnb {\n  display: none;\n}\n.area__left.only-depth2 + .area__right {\n  width: calc(100% - 320px);\n}\n.area__left.only-depth2 .lnb-depth2 {\n  margin-bottom: 8px;\n}\n.only-depth2 .lnb-depth2 > li > a::after {\n  content: none;\n}\n.only-depth2 .lnb-depth2 > li.active > a,\n.only-depth2 .lnb-depth2 > li.on > a {\n  border-bottom: 0;\n}\n.area__left .box__etc {\n  display: none;\n  padding: 16px 12px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  flex-direction: row;\n  align-items: center;\n}\n.btn-left {\n  width: 1.5rem;\n  height: 1.5rem;\n  border: 0;\n  background: url(\"../img/icon_treeclose.png\") no-repeat center center;\n  background-size: 100%;\n}\n.area__left.only-depth2.close .btn-left {\n  width: auto;\n  height: auto;\n  padding-top: 42px;\n  background: url(\"../img/icon_treeopen.png\") no-repeat center 0;\n}\n.area__left.only-depth2.close .btn-left::after {\n  content: \"Tree Menu\";\n  writing-mode: vertical-rl;\n  -ms-writing-mode: tb-rl;\n  margin-top: 0;\n  font-weight: 700;\n}\n.area__left.only-depth2 + .area__right .page-loca {\n  margin: -16px -24px 16px;\n  display: none;\n}\n\n/*노후교체요청*/\n.devicenum {\n  display: flex;\n}\n.devicenum + .devicenum {\n  margin-left: 48px;\n}\n.devicenum p {\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 32px;\n  letter-spacing: -0.6px;\n  color: #2a2c2f;\n}\n.devicenum .num {\n  padding-right: 20px;\n  margin-left: 8px;\n  font-size: 20px;\n  line-height: 30px;\n  color: #0a78ff;\n  background: url(\"../img/icon_go2.png\") no-repeat right center;\n  background-size: 20px 20px;\n}\n.devicenum-detail {\n  display: flex;\n}\n.devicenum-detail li {\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 16px;\n  color: #909fb7;\n  margin-left: 16px;\n}\n.tbl__top .devicenum-detail li span {\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 16px;\n  color: #2a2c2f;\n  margin-left: 4px;\n  margin-right: 0;\n}\n.changeold .filter {\n  display: none;\n}\n.admin-site .area__right.changeold h2 {\n  font-size: 20px;\n  margin-top: 20px;\n}\n.admin-site .changeold .tbl-list table td {\n  height: 26px;\n}\n.admin-site .changeold .tbl__bottom {\n  margin-top: 18px;\n}\n\n/********************************************** For small screen, 반응형 **********************************************/\n@media screen and (max-width: 1856px) {\n  .container.filereports .content {\n    width: calc(100% - 40px);\n    grid-template-columns: 1fr;\n    grid-template-rows: repeat(2, minmax(1006px, auto));\n  }\n  .container.filereports .box.ehc__score {\n    grid-column: 2 / 1;\n    width: 100% !important;\n  }\n  .container.filereports .box.ehc__score .btn-box,\n  .container.filereports .box.ehc__score.close .btn-bo {\n    display: none !important;\n  }\n  .container.filereports .treebar.box {\n    height: 2019px;\n  }\n  .container.filereports .treebar.box .treearea {\n    height: 1930px;\n  }\n  .container.filereports .box.ehc__score.close .box__header {\n    justify-content: space-between;\n    padding: 0 0.75rem 0 1rem;\n    border-bottom: 1px solid #dde2e9;\n  }\n  .container.filereports .box.ehc__score.close .cate,\n  .container.filereports .box.ehc__score.close .box__etc,\n  .container.filereports .box.ehc__score.close .box__body {\n    display: block;\n  }\n  .popup-boxin .page-detail {\n    left: 25%;\n    width: 50%;\n  }\n}\n@media screen and (max-width: 1689px) {\n  .area__right_content.workplace__info.workplace__main.info__input .content__info {\n    grid-template-columns: 304px 1fr;\n    grid-auto-rows: auto;\n    grid-gap: 38px 24px;\n  }\n  .area__right_content.workplace__info.workplace__main.info__input .content__info ul.info__admin {\n    grid-column: 2;\n    grid-row: 2;\n  }\n  .area__right_content.workplace__info .btn__wrap {\n    justify-content: flex-end;\n    margin-left: 0;\n    margin-right: 24px;\n    max-width: 640px;\n  }\n  .page-list-view.page-workplace .popup__head {\n    align-items: flex-start;\n  }\n  .page-list-view.page-workplace .popup__head h1 {\n    font-size: 20px;\n    margin-top: 16px;\n    margin-bottom: 16px;\n  }\n  .page-list-view.page-workplace .area__right_content.workplace__info .btn__wrap {\n    justify-content: center;\n    margin-right: 0;\n    margin-top: 30px;\n    margin-bottom: 6px;\n  }\n  .page-list-view.page-workplace .area__right_content.workplace__info {\n    margin: 0;\n  }\n  .page-list-view.page-workplace .area__right_content.workplace__info .content__info {\n    padding: 0;\n    width: 100%;\n  }\n  .page-list-view.page-workplace .content__info ul.filelist li {\n    flex-direction: row;\n    align-items: center;\n  }\n  .page-list-view.page-workplace .content__info ul li {\n    flex-direction: column;\n  }\n  .page-list-view.page-workplace .content__info ul li,\n  .page-list-view.page-workplace .content__info ul li p.tit,\n  .page-list-view.page-workplace .content__info ul li p.txt {\n    width: 100%;\n    font-size: 14px;\n  }\n  .page-list-view.page-workplace .content__info ul li p.txt {\n    margin-top: 8px;\n  }\n  .page-list-view.page-workplace .content__info ul li p.tit .fontRegular {\n    display: inline-block;\n  }\n\n  .admin-site .tabcontent.layout-w2 .area__right_content.workplace__info .btn__wrap {\n    margin-right: 0;\n  }\n}\n@media screen and (max-width: 1685px) {\n  .tbl-list.hcal-96 table td .ellipsis,\n  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {\n    max-width: 80px !important;\n    width: 100%;\n  }\n}\n@media screen and (max-width: 1660px) {\n  .area__left.only-depth2 {\n    padding-top: 0;\n  }\n  .area__left .box__etc {\n    display: flex;\n  }\n  .area__left.only-depth2 + .area__right .page-loca {\n    display: flex;\n  }\n}\n@media screen and (max-width: 1600px) {\n  .area__left.only-depth2 + .area__right .checkstatus-box li div a {\n    width: 100px;\n  }\n}\n@media screen and (max-width: 1565px) {\n  .tbl-list.hcal-96 table td .ellipsis,\n  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {\n    max-width: 70px !important;\n  }\n}\n@media screen and (max-width: 1549px) {\n  .search__inline .filter {\n    /* width: calc(100% - 500px); */\n    /* width: calc(100% - 520px); */\n  }\n  .search__inline .search-small .searcharea input[type=\"text\"] {\n    width: 145px;\n  }\n  .search__inline .searcharea .btn-search {\n    width: 80px;\n  }\n  .area__right_content.workplace__info .content__list {\n    position: relative;\n    margin-top: 40px;\n    height: auto;\n  }\n  .listbox__area {\n    grid-template-columns: 1fr 1fr;\n    grid-auto-rows: minmax(200px, auto);\n  }\n  .area__right_content.workplace__info.workplace__main .content__info {\n    grid-template-columns: 304px 1fr;\n    grid-auto-rows: auto;\n    grid-gap: 0 24px;\n  }\n  .area__right_content.workplace__info.workplace__main .content__info .img_workplace {\n    grid-row: 1 / 3;\n  }\n  .area__right_content.workplace__info.workplace__main .content__info ul.info__admin {\n    grid-column: 2;\n    grid-row: 2;\n  }\n  .admin-site .area__right .page-top h2 {\n    font-size: 20px;\n    line-height: 29px;\n  }\n  .admin-site .area__right .top-button button {\n    width: 28px;\n    height: 28px;\n  }\n  .content__info ul li {\n    margin-bottom: 1rem;\n  }\n  .content__info ul li p {\n    font-size: 14px;\n  }\n  .content__info ul li p.tit {\n    width: 120px;\n  }\n  .content__info ul li p.tit span {\n    font-size: 12px;\n    display: block;\n    margin: 1px 0 0 0;\n  }\n  .content__info ul li p.txt {\n    width: calc(100% - 120px);\n  }\n  .content__info ul.form__input .input__area {\n    width: calc(100% - 120px);\n  }\n  .area__right_content .btn__wrap {\n    max-width: 575px;\n  }\n  .area__right_content.workplace__info .btn__wrap {\n    max-width: 600px;\n  }\n}\n@media screen and (max-width: 1545px) {\n  .tbl-list.hcal-96 table td .ellipsis,\n  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {\n    max-width: 60px !important;\n  }\n}\n@media screen and (max-width: 1529px) {\n  .tbl-list.hcal-96 table td .ellipsis,\n  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {\n    max-width: 45px !important;\n  }\n}\n@media screen and (min-width: 1522px) {\n  .tabcontent .tbl__top.d-lm-block {\n    display: flex !important;\n  }\n}\n@media screen and (max-width: 1522px) {\n  .d-mm-none {\n    display: none !important;\n  }\n  .result__num.d-mm-none {\n    display: block !important;\n  }\n  .no-responsive .tabcontent .search {\n    border-bottom: 1px solid #dde2e9;\n    padding: 32px 0 32px 8px;\n  }\n  .tabcontent .search {\n    border-bottom: 0;\n    padding-bottom: 6rem;\n  }\n  .search-small {\n    width: 74px;\n    padding: 2px 0 2px 22px;\n    float: left;\n  }\n  .filter {\n    width: 74px;\n    padding: 2px 0;\n    border-bottom: 0;\n    float: left;\n    padding-right: 16px;\n    border-right: 1px solid #dde2e9;\n  }\n  .tabcontent__top::after {\n    content: \"\";\n    display: block;\n    clear: both;\n  }\n  .tabcontent .btn-renew {\n    display: inline-block;\n    float: right;\n    margin-top: -3px;\n    background: #0a78ff;\n    border-color: #0a78ff;\n    width: 88px;\n    height: 28px;\n  }\n  .btn-renew span {\n    font-weight: 500;\n    font-size: 0.875rem;\n    color: #fff;\n  }\n  .btn-renew:disabled {\n    background: #f0f2f4;\n    border-color: #f0f2f4;\n  }\n  .btn-renew:disabled:hover {\n    background: #f0f2f4 !important;\n  }\n  .tabcontent .tbl__top {\n    display: none;\n  }\n  .no-responsive .tabcontent .tbl__top {\n    display: flex;\n  }\n  .tabcontent .tbl__top.d-lm-block {\n    display: flex !important;\n  }\n  .tabcontent__top {\n    margin-bottom: 22px;\n  }\n  .tabcontent .tbl-list table th {\n    font-size: 0.812rem;\n    line-height: 16px;\n    padding: 10px 8px;\n  }\n  .tabcontent .tbl-list table td {\n    font-size: 0.875rem;\n    line-height: 16px;\n    padding: 11px 8px;\n  }\n  .tabcontent .detail__view .tbl-list table td button {\n    min-width: 80px;\n  }\n  .tabcontent .tbl-list table td button {\n    min-width: 64px;\n  }\n  .tabcontent .tbl-list table td button.btn {\n    min-width: auto;\n  }\n  .filter.open .title .btn-close,\n  .filter.open .title .info,\n  .filter.open .filter__select,\n  .search-small.open .title .btn-close,\n  .search-small.open .search__cont {\n    display: none;\n  }\n  .tabcontent__top .btn__wrap {\n    display: flex;\n    align-items: flex-end;\n  }\n  .form__input .searchterm .term__date input[type=\"text\"] {\n    width: 102px;\n  }\n  .no-responsive .tabcontent .search .form__input {\n    width: 100%;\n  }\n  .no-responsive .tabcontent .search .form__input li {\n    display: inline-block;\n    float: left;\n    width: auto;\n    margin-top: 0;\n  }\n  .no-responsive .tabcontent .search .form__input li:last-child {\n    margin-top: 0;\n  }\n  .no-responsive .tabcontent .search .form__input li label,\n  .no-responsive .tabcontent .search .form__input li:last-child label {\n    display: inline-block;\n    float: left;\n    margin-top: 5px;\n    width: auto;\n  }\n  .no-responsive .tabcontent .search .form__input .input__area {\n    margin-left: 1rem;\n    width: 186px;\n    display: inline-block;\n    float: left;\n  }\n  .tabcontent .search .form__input {\n    width: 58%;\n  }\n  .tabcontent .search .form__input li:last-child {\n    margin-top: 12px;\n  }\n  .tabcontent .search .form__input li:last-child label {\n    margin-left: 0 !important;\n    width: 75px;\n  }\n  .filter.open .title,\n  .search-small.open .title {\n    color: #2a2c2f;\n  }\n  .search__inline {\n    justify-content: flex-start;\n    margin-bottom: 0;\n  }\n  .search__inline .search-small {\n    justify-content: space-between;\n    width: 74px;\n    margin-right: calc(100% - 320px);\n    padding: 2px 0 2px 22px;\n  }\n  .search__inline .search-small .search__cont {\n    display: none;\n  }\n  .search__inline .filter {\n    width: 84px;\n    padding: 2px 0;\n    border-bottom: 0;\n    float: left;\n    padding-right: 16px;\n    border-right: 1px solid #dde2e9;\n  }\n  .testrecord .tabcontent__top {\n    margin-bottom: 1rem;\n  }\n  .tabcontent__title {\n    margin: 37px 0 8px;\n  }\n  .tbl-list.hcal-96 table th.d-lm-none,\n  .tbl-list.hcal-96 table td.d-lm-none {\n    display: none;\n  }\n  .tbl-list.hcal-96 table td .ellipsis,\n  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {\n    max-width: 100% !important;\n    width: 100%;\n  }\n  .tbl-list.hcal-96 table tr.focused td {\n    background: #e6f0ff;\n  }\n  .inline.right.search-small .title {\n    display: none;\n  }\n  .inline.right.search-small.open .searcharea .select,\n  .inline.right.search-small.open .input__direct {\n    display: none;\n  }\n  .inline.right.search-small.open .searcharea .btn-search {\n    width: 32px;\n    height: 32px;\n    min-width: auto;\n    background-position: center;\n  }\n  .inline.right.search-small.open .searcharea .btn-search span {\n    display: none;\n  }\n  .tbl-list.type2 tbody tr.open td:first-child:before {\n    content: \"\";\n    display: inline-block;\n    margin: -11px -8px;\n    width: 4px;\n    min-height: 100%;\n    background: #0a78ff;\n    position: absolute;\n  }\n  .tabcontent .checkstatus-box + .tbl__top {\n    display: flex;\n  }\n  .tabcontent .area__top .search .form__input li:last-child {\n    margin-top: 0;\n  }\n  .tabcontent .area__top .search .form__input li:last-child label {\n    width: auto;\n    margin-left: 38px !important;\n  }\n  .workorder .tabcontent .area__top .search .form__input li:last-child label {\n    width: 98px;\n    margin-left: 0 !important;\n  }\n\n  /*노후교체요청*/\n  .tabcontent .changeold .search {\n    border-bottom: 1px solid #dde2e9;\n    padding: 32px 0 32px 8px;\n  }\n  .tabcontent .changeold .search .form__input {\n    flex-direction: row;\n    width: calc(100% - 120px);\n  }\n  .tabcontent .changeold .search .form__input li:last-child {\n    margin-top: 0;\n  }\n  .tabcontent .changeold .search .form__input li:last-child label {\n    margin-left: 38px !important;\n    width: auto;\n  }\n\n  /* .admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.message-list {\n    height: calc(100vh - 280px);\n  }\n  .admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.lang-list {\n    height: calc(100vh - 280px);\n  }\n  .admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.menuset-list {\n    height: calc(100vh - 240px);\n  }\n  .admin-site .box.list .box__body .tabcontent.layout-w2 .tbl-list.checksheet-list {\n    height: calc(100vh - 280px);\n  } */\n}\n@media screen and (max-width: 1470px) {\n  .drag__area {\n    flex-direction: column;\n  }\n  .drag__area .filebox-drag {\n    display: none;\n  }\n  .drag__area .filebox-upload {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 50px;\n  }\n  .drag__area .drag__right {\n    width: 100%;\n    margin-top: 0;\n  }\n  .drag__area .drag__left {\n    width: 100%;\n    margin-bottom: 34px;\n    padding-bottom: 34px;\n    border-bottom: 2px solid #e9edef;\n  }\n  .drag__area .drag__left .filebox-upload .filelist {\n    margin-top: 10px;\n    width: calc(100% - 190px);\n  }\n  .drag__area .drag__left .filebox-upload .btn-upload {\n    display: flex;\n    width: 72px;\n    height: 24px;\n    background: #0a78ff;\n    border-radius: 4px;\n    border: 0;\n    margin-top: 5px;\n  }\n  .drag__area .drag__left .filebox-upload .btn-upload span {\n    font-weight: 700;\n    font-size: 12px;\n    color: #fff;\n  }\n  .drag__area .drag__left .btn-filedown span {\n    font-size: 13px;\n  }\n  .drag__area .drag__left .btn.btn-filedown {\n    background-size: 20px;\n    padding-right: 26px;\n    margin-right: 0;\n  }\n  .drag__area .content__info ul li p {\n    font-size: 12px;\n  }\n  .filelist-case .inline.right.search-small.open {\n    font-size: 14px;\n    background-size: 16px;\n  }\n  .drag-filelist .name.success,\n  .drag-filelist .name {\n    background-size: 16px;\n  }\n  .filelist-case .name {\n    font-size: 14px;\n    padding-top: 0px;\n    background-size: 8px 15px;\n    width: auto;\n  }\n  .drag-filelist .progressbar .progress-value progress {\n    width: 64px;\n  }\n  .drag-filelist .progressbar .progress-value .value {\n    margin-left: 8px;\n    width: 35px;\n    text-align: right;\n  }\n  .content__info .drag__right__list .drag-filelist li,\n  .content__info .drag__right__list .drag-filelist li:first-child,\n  .content__info .drag__right__list .filelist-case li,\n  .content__info .drag__right__list .filelist-case li:first-child {\n    justify-content: space-between;\n  }\n  .drag__area .drag__right .drag__right__list p.tit {\n    font-size: 14px;\n  }\n  .flielist__upload {\n    display: flex;\n    justify-content: space-between;\n    width: calc(100% - 114px);\n  }\n}\n@media screen and (max-width: 1406px) {\n  .admin-site.layout-w3 .tabcontent {\n    flex-direction: column;\n    justify-content: flex-start;\n  }\n  .admin-site.layout-w3 .area__left,\n  .admin-site.layout-w3:not(.no-responsive) .area__right,\n  .admin-site.layout-w3 .area__right-end {\n    position: relative;\n    width: calc(100% - 32px);\n    height: auto;\n    border-bottom: 1px solid #dde2e9;\n    border-right: 0;\n    border-left: 0;\n    padding: 0;\n    margin: 0 16px;\n  }\n  .admin-site.layout-w3 .area__left_content.detail__view,\n  .admin-site.layout-w3 .area__right_content.detail__view {\n    display: none;\n  }\n  .admin-site.layout-w3 .area__left_content.detail__view.on,\n  .admin-site.layout-w3 .area__right_content.detail__view.on {\n    display: block;\n    margin-top: -14px;\n  }\n  .admin-site.layout-w3 .page-top {\n    margin: 0;\n    padding: 33px 0;\n    cursor: pointer;\n  }\n  .more__detail {\n    background: url(\"../img/icon_downbtn.png\") no-repeat right center;\n    background-size: 20px 20px;\n  }\n  .admin-site:not(.no-responsive) .box.list .box__body .tbl-list {\n    height: auto !important;\n  }\n  .admin-site.layout-w3 .tbl-list table th {\n    font-size: 13px;\n  }\n  .admin-site.layout-w3 .area__left .tbl__bottom,\n  .admin-site.layout-w3 .area__right-end .tbl__bottom,\n  .admin-site.layout-w3 .area__right .tbl__bottom.mt-48 {\n    flex-direction: row;\n    margin: 32px 0 40px !important;\n  }\n  .admin-site.layout-w3 .area__left .tbl__bottom .result__num,\n  .admin-site.layout-w3 .area__right-end .tbl__bottom .result__num {\n    width: auto;\n  }\n  .admin-site.layout-w3 .area__left .tbl__bottom .paging,\n  .admin-site.layout-w3 .area__right-end .tbl__bottom .paging {\n    width: calc(100% - 100px);\n    justify-content: space-around;\n  }\n  .admin-site.layout-w3 .area__left .tbl__bottom .paging ul,\n  .admin-site.layout-w3 .area__right-end .tbl__bottom .paging ul {\n    margin-top: 0;\n  }\n  .admin-site.layout-w3 .tbl__bottom .paging__select {\n    display: flex;\n    right: 11px;\n  }\n  .workplace-ok.page-detail {\n    width: 566px;\n    height: auto;\n  }\n  .workplace-ok.page-detail .popup__body {\n    max-height: calc(80vh - 11rem);\n    padding: 33px 40px 40px;\n    margin-bottom: 20px;\n  }\n  .workplace-ok.page-detail .popup__body .tbl-list.mt-16 {\n    margin-top: 0 !important;\n  }\n  .workplace-ok.page-detail .popup__body .tbl-list.type2 table th,\n  .workplace-ok.page-detail .popup__body .tbl-list.type2 table td {\n    font-size: 14px;\n  }\n  .workplace-ok.page-detail .popup__body .tbl-list.type2 table th {\n    font-size: 14px;\n    padding: 8px 16px;\n  }\n  .workplace-ok.page-detail .popup__body .tbl-list .d-sm-none {\n    display: none !important;\n  }\n  .workplace-ok.page-detail .popup__body .tbl-list tbody.d-sm-block {\n    display: table !important;\n    width: 100%;\n  }\n  .workplace-ok.page-detail .workplace__info {\n    flex-direction: column-reverse;\n    margin-top: 40px;\n  }\n  .workplace-ok.page-detail .img_workplace {\n    width: 238px;\n    height: 238px;\n    margin-top: -400px;\n  }\n  .workplace-ok.page-detail .workplace__info .txt_workplace {\n    width: 100%;\n    margin-left: 0;\n  }\n  .workplace-ok.page-detail .workplace__info .txt_workplace ul {\n    margin-top: 290px;\n  }\n  .workplace-ok.page-detail .workplace__info .txt_workplace ul li p.tit {\n    width: 100px;\n    margin-right: 20px;\n  }\n  .workplace-ok.page-detail .workplace__info .txt_workplace ul li p.txt {\n    width: calc(100% - 120px);\n  }\n  .workplace-ok.page-detail .workplace__info .txt_workplace ul li p.tit,\n  .workplace-ok.page-detail .workplace__info .txt_workplace ul li p.txt {\n    font-size: 14px;\n  }\n  .userjoin-ok.page-detail.casecheck-ok {\n    width: calc(100% - 60px);\n    height: auto;\n  }\n  .userjoin-ok.page-detail {\n    width: 566px;\n    height: auto;\n  }\n  .userjoin-ok.page-detail .popup__body {\n    flex-direction: column;\n    justify-content: flex-start;\n    max-height: calc(80vh - 11rem);\n    padding: 33px 40px 40px;\n  }\n  .userjoin-ok.page-detail .popup__body .left,\n  .userjoin-ok.page-detail .popup__body .right {\n    width: 100%;\n  }\n  .userjoin-ok.page-detail .popup__body .right {\n    margin-top: 40px;\n  }\n  .userjoin-ok.page-detail .popup__body h2 {\n    display: none;\n  }\n  .userjoin-ok.page-detail .popup__body .form__input li {\n    margin-bottom: 24px;\n  }\n  .userjoin-ok.page-detail .popup__body .form__input .tbl-list.type2 table th {\n    padding: 8px 12px;\n  }\n  .userjoin-ok.page-detail .popup__body .form__input .tbl-list.type2 table td {\n    padding: 14px 12px;\n  }\n  .userjoin-ok.page-detail .popup__footer.right {\n    padding: 24px;\n    width: calc(100% - 48px);\n    justify-content: center;\n  }\n  .userjoin-ok.page-detail .popup__body.layout-vertical {\n    padding-bottom: 40px;\n  }\n  .userjoin-ok.page-detail .popup__body.layout-vertical .form__input.inline {\n    flex-direction: column;\n    align-items: flex-start;\n    margin-bottom: 32px !important;\n  }\n  .userjoin-ok.page-detail .popup__body.layout-vertical .form__input li {\n    margin: 0 0 24px;\n    width: 100%;\n  }\n  .userjoin-ok.page-detail .popup__body.layout-vertical .form__input li:last-child {\n    margin-bottom: 0;\n  }\n  .userjoin-ok.page-detail .popup__body.layout-vertical .form__input label {\n    width: 88px;\n  }\n  .userjoin-ok.page-detail .popup__body.layout-vertical .form__input .input__area {\n    margin-left: 0;\n    width: calc(100% - 180px);\n  }\n  .userjoin-ok.page-detail .popup__body.layout-vertical .tbl-list.type2 {\n    height: 440px;\n  }\n  .userjoin-ok.page-detail .popup__body.layout-vertical .tbl-list.type2 th {\n    padding: 8px 12px;\n  }\n  .userjoin-ok.page-detail .popup__body.layout-vertical .tbl-list.type2 td {\n    padding: 14px 12px;\n  }\n  .userjoin-ok.page-detail .popup__body.layout-vertical .tbl-list.type2 td .ellipsis {\n    max-width: 120px;\n    width: 100%;\n  }\n  .userjoin-ok.page-detail .popup__body.layout-vertical + .popup__footer {\n    padding: 24px 42px;\n    width: calc(100% - 84px);\n    border-top: 1px solid #dde2e9;\n  }\n  .popup-layer.pop-usertype {\n    width: 560px;\n  }\n  .popup-layer.pop-usertype .popup__body {\n    max-height: calc(80vh - 3.25rem);\n  }\n  .popup-layer.pop-usertype .user-info {\n    margin-bottom: 24px;\n  }\n  .popup-layer.pop-usertype .user-info li {\n    margin-bottom: 24px;\n  }\n  .popup-layer.pop-usertype .user-info li p:first-child {\n    width: 180px;\n  }\n  .popup-layer.pop-usertype .user-info li p:last-child {\n    width: calc(100% - 180px);\n    font-size: 13px;\n    line-height: 19px;\n    letter-spacing: -0.28px;\n  }\n  .popup-layer.pop-usertype .tbl__top .info {\n    font-size: 13px;\n  }\n  .popup-layer.pop-usertype .tbl-list.type2 table th,\n  .popup-layer.pop-usertype .tbl-list.type2 table td {\n    font-size: 13px;\n  }\n\n  .admin-site .tabcontent.layout-w2 {\n    justify-content: space-between;\n    flex-direction: row;\n  }\n  .admin-site .tabcontent.layout-w2 .area__left,\n  .admin-site .tabcontent.layout-w2 .area__right,\n  .admin-site .tabcontent.layout-w2 .area__right-end {\n    padding: 16px 0;\n    width: 310px;\n    height: calc(100% - 29px);\n    border-right: 4px solid #dde2e9;\n    border-bottom: 0;\n    margin: 0;\n  }\n}\n@media screen and (max-width: 1339px) {\n  .tbl-list.hcal-96 table td .ellipsis,\n  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {\n    max-width: 150px !important;\n    width: 100%;\n  }\n}\n@media screen and (max-width: 1304px) {\n  .container.filereports .content {\n    grid-auto-rows: auto;\n  }\n  .container.filereports .box.list .box__body {\n    padding-top: 0;\n  }\n  .container.filereports .treebar.box {\n    width: 294px;\n  }\n  .container.filereports .treebar.box .treearea {\n    height: 1930px;\n  }\n  .container.filereports .box.ehc__score {\n    grid-column: 1;\n    grid-row: 2;\n  }\n  .tabcontent .search {\n    flex-direction: column;\n    justify-content: flex-start;\n    padding-bottom: 34px;\n  }\n  .tabcontent .search .form__input {\n    display: flex;\n    float: none;\n    width: 100%;\n    flex-direction: column;\n    margin-bottom: 12px;\n  }\n  .tabcontent .search .form__input li {\n    display: flex;\n    float: none;\n    width: 100%;\n    margin-top: 0.75rem;\n    justify-content: space-between;\n    align-items: flex-start;\n  }\n  .tabcontent .search .form__input li label {\n    float: none;\n    font-size: 0.938rem;\n    line-height: 1.375rem;\n    margin-top: 5px;\n  }\n  .tabcontent .search .form__input li + li label {\n    margin-left: 0;\n    max-width: none;\n  }\n  .tabcontent .search .form__input .input__area {\n    margin-left: 1rem;\n    width: 66%;\n    display: flex;\n    float: none;\n  }\n  .tabcontent .search .btn__wrap {\n    display: flex;\n    justify-content: flex-end;\n  }\n  .tabcontent .search .form__input .input__area .searchterm .term__month .selected {\n    width: auto;\n  }\n\n  .admin-site .area__right .area__top .search {\n    flex-direction: row;\n  }\n  .area__top .searchterm {\n    flex-direction: row;\n  }\n  .area__top .searchterm .term__month + .term__date {\n    margin-top: 0;\n    margin-left: 8px;\n  }\n\n  /*노후교체요청*/\n  .tabcontent .changeold .search {\n    justify-content: space-between;\n    flex-direction: row;\n    padding: 32px 0 32px 8px;\n  }\n  .tabcontent .changeold .search .form__input {\n    flex-direction: row;\n    float: left;\n    width: calc(100% - 120px);\n    margin-bottom: 0;\n  }\n  .tabcontent .changeold .search .form__input li {\n    margin-top: 0;\n    float: left;\n    width: auto;\n  }\n  .tabcontent .changeold .search .form__input .input__area {\n    margin-left: 1rem;\n    width: 186px;\n  }\n  .tabcontent .changeold .search .form__input li + li label {\n    margin-left: 38px;\n  }\n}\n@media screen and (max-width: 1290px) {\n  .checkstatus-box li div a {\n    width: 100px;\n  }\n}\n@media screen and (max-width: 1250px) {\n  .area__top {\n    margin: -16px -14px 48px;\n  }\n  .area__left.only-depth2 + .area__right .page-loca {\n    margin: -16px -14px 16px;\n  }\n}\n@media screen and (max-width: 1249px) {\n  .area__right_content.workplace__info {\n    /* margin: 0 -18px; */\n    margin: 0 -12px 0 -18px;\n  }\n}\n@media screen and (max-width: 1030px) {\n  .tabcontent .tbl-list.hcal-96 table th.d-sm-none,\n  .tabcontent .tbl-list.hcal-96 table td.d-sm-none {\n    display: none !important;\n  }\n  .tbl-list.hcal-96 table td .ellipsis,\n  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {\n    width: 100%;\n    max-width: 100px !important;\n  }\n}\n@media screen and (max-width: 1024px) {\n  .status__data {\n    justify-content: flex-start;\n  }\n  .status__data li {\n    width: calc(100% / 5);\n    height: auto;\n  }\n  .status__data li a {\n    width: 100%;\n  }\n  .status__data li a:focus {\n    height: calc(100% - 4px);\n  }\n  .status__data li:first-child {\n    width: calc(100% / 5 - 17px);\n  }\n  .status__data li:last-child {\n    width: calc(100% / 2.5);\n    padding-right: 0;\n    text-align: center;\n    justify-content: flex-start;\n  }\n  .status__data li:last-child a {\n    margin: 0 auto;\n    width: 50%;\n  }\n  .status__data li:last-child a:focus {\n    width: calc(50% - 10px);\n  }\n  .status__data li a:focus {\n    width: 100%;\n    height: auto;\n    padding: 13px 0;\n  }\n  .status__data li:before {\n    padding-left: 8px;\n    margin-left: 8px;\n  }\n  .status__data li p.txt {\n    font-size: 30px;\n  }\n\n  /*노후교체요청*/\n  .tabcontent .changeold .search {\n    flex-direction: column;\n  }\n  .tabcontent .changeold .search .form__input {\n    flex-direction: column;\n    float: none;\n    width: 100%;\n  }\n  .tabcontent .changeold .search .form__input li {\n    margin-bottom: 12px;\n  }\n  .tabcontent .changeold .search .form__input li + li label,\n  .tabcontent .changeold .search .form__input li:last-child label {\n    margin-left: 0 !important;\n  }\n  .tabcontent .changeold .search .form__input li label {\n    flex: 1;\n  }\n  .tabcontent .changeold .search .form__input .input__area {\n    flex: 2;\n  }\n  .tabcontent .changeold .search .select.w186 {\n    width: 100% !important;\n  }\n}\n@media screen and (max-width: 1759px) {\n  .ehc__addfile {\n    margin-top: -3rem;\n  }\n  .ehc__addfile p.txt {\n    margin: 0.75rem 0 0.4rem;\n  }\n  .popup-boxin .page-detail.w400 {\n    left: 32%;\n  }\n}\n@media screen and (max-width: 1415px) {\n  /* 운영관리 컨텐츠 영역_사업장 신규입력 : 디자인 변경 */\n  .newtype .content__info ul li p.txt-info {\n    width: 100%;\n    /* width: 280px; */\n  }\n}\n@media screen and (min-width: 1377px) {\n  .d-lm-block {\n    display: none !important;\n  }\n}\n@media screen and (max-width: 1376px) {\n  .d-lm-none {\n    display: none !important;\n  }\n  .d-lm-block {\n    display: block;\n  }\n  .popup-boxin .page-detail.w400 {\n    left: 28%;\n  }\n  /*노후교체요청*/\n  .devicenum.d-lm-block {\n    display: flex;\n  }\n  .devicenum-detail {\n    display: none;\n  }\n  .btn-basic.down {\n    width: 32px;\n    height: 32px;\n    background: url(\"../img/icon_filedown.png\") no-repeat center center #0a78ff;\n    background-size: 100%;\n  }\n  .btn-basic.down span {\n    display: none;\n  }\n}\n@media screen and (max-width: 1250px) {\n  .admin-site .area__left {\n    width: 302px;\n  }\n  .admin-site .area__right {\n    padding: 16px 14px 18px;\n    width: calc(100% - 334px);\n  }\n  .admin-site .area__right .searcharea {\n    margin-bottom: 1rem;\n  }\n  .admin-site:not(.no-responsive) .area__right .searcharea .searchinput {\n    width: 100%;\n  }\n  .admin-site .area__right .searcharea .input__direct {\n    width: calc(100% - 104px) !important;\n  }\n  .admin-site .area__right .searcharea .input__direct input[type=\"text\"] {\n    width: calc(100% - 1.5rem) !important;\n  }\n  .tbl-list.type3.w800 {\n    width: 100% !important;\n  }\n  .tabcontent .tbl-list.type3 table td {\n    padding: 1rem;\n  }\n  .tbl-list.type3 td ul {\n    flex-direction: column;\n  }\n  .tbl-list.type3 td ul li {\n    width: 100%;\n  }\n  .tbl-list.type3 td ul li.address {\n    width: 100%;\n    margin-top: 1rem;\n    line-height: normal;\n  }\n  .tbl-list.type3 td ul li p.placename {\n    width: 45%;\n    font-size: 14px;\n  }\n  .tbl-list.type3 td ul li p.location {\n    width: 55%;\n    font-size: 14px;\n  }\n  .nodata .nodata__txt.w800 {\n    width: 100% !important;\n  }\n  .admin-site .area__right .checkstatus-box + .tbl__top .searcharea .searchinput {\n    width: auto;\n  }\n  .admin-site .area__right.changeold .tbl__top .searcharea .searchinput {\n    width: auto;\n  }\n}\n@media screen and (max-width: 1200px) {\n  .nodata {\n    height: auto;\n  }\n  .nodata .nodata__txt {\n    margin: 30px 0;\n  }\n  .nodata .nodata__txt::before {\n    content: \"\";\n    width: 10.156rem;\n    height: 6.25rem;\n    margin-bottom: 1rem;\n    background: url(\"../img/bg_nodata@3x.png\") no-repeat center center;\n    background-size: 100%;\n  }\n  .nodata .result__num {\n    display: none;\n  }\n  .ehc__rolling,\n  .ehc__picture {\n    height: 152px;\n  }\n  .ehc__picture ul li,\n  .ehc__picture li a {\n    width: 152px;\n    height: 152px;\n  }\n  .ehc__addfile p.txt {\n    margin: 0.4rem 0;\n  }\n  .popup-boxin .popup__body .form__input {\n    width: 100% !important;\n  }\n  .popup-boxin .popup__body .form__input .input__area.w260 {\n    width: auto !important;\n  }\n}\n@media screen and (max-width: 1170px) {\n  .tbl-list.type2 table th:first-child span::before,\n  .tbl-list.type2 table td:first-child span::before {\n    margin-left: 10px;\n  }\n  .tbl-list.type2 table tr.open th:first-child span::before,\n  .tbl-list.type2 table tr.open td:first-child span::before {\n    margin-left: 9px;\n  }\n}\n@media screen and (max-width: 1160px) {\n  /* 운영관리 컨텐츠 영역_사업장 신규입력 : 디자인 변경 */\n  .admin-site .area__right h2 {\n    font-size: 20px;\n  }\n  .area__right_content.workplace__info.workplace__main.newtype .content__info + .content__info {\n    margin-top: 32px;\n    padding-top: 32px;\n  }\n  .newtype .content__info .flex-row {\n    flex-direction: column;\n  }\n  .area__right_content.workplace__info.workplace__main.newtype .content__info h3 {\n    font-size: 1rem;\n  }\n  .newtype .content__info .flex-row .form__input.ml-40 {\n    margin-left: 0 !important;\n    margin-top: 32px;\n  }\n  /* .newtype .content__info ul li p.txt-info {\n    display: none;\n  } */\n  .area__right_content.workplace__info.workplace__main.newtype .content__info .img_workplace {\n    grid-row: auto;\n    margin-bottom: 0;\n    width: 238px;\n    height: 238px;\n  }\n  .area__right_content.workplace__info.workplace__main.newtype .content__info .img_workplace .btn-imgadd {\n    top: 201px;\n  }\n  .newtype.area__right_content.workplace__info .column .btn__wrap.center {\n    margin: 2rem 0;\n  }\n  /*노후교체요청*/\n  .devicenum.ml-48 {\n    margin-left: 15px !important;\n  }\n}\n@media screen and (max-width: 1165px) {\n  .tbl-list.hcal-77 table th.d-sm-none,\n  .tbl-list.hcal-77 table td.d-sm-none {\n    display: none !important;\n  }\n}\n@media screen and (min-width: 1101px) {\n  .tbl-list .d-sm-block {\n    display: none !important;\n  }\n}\n@media screen and (max-width: 1100px) {\n  .box.list .box__header {\n    border-bottom: 1px solid #dde2e9;\n  }\n  .box.list .box__body {\n    padding-top: 16px;\n    height: auto;\n  }\n  .box.list .box__body .tbl-list {\n    height: auto;\n  }\n  .box.list .box__body .tbl__top .left span {\n    display: none;\n  }\n  .tbl-list .d-sm-none {\n    display: none !important;\n  }\n  .tbl-list .d-sm-block {\n    display: block;\n  }\n  .tbl-list table td.checkdate {\n    text-align: left;\n    cursor: pointer;\n  }\n  .tbl-list table td.checkdate:after {\n    content: \"\";\n    display: inline-block;\n    width: 8px;\n    height: 15px;\n    margin-left: 10px;\n    vertical-align: top;\n    background: url(../img/icon_arrow@3x.png) no-repeat 0 3px;\n    background-size: 80%;\n  }\n  .tbl-list table td.checkdate.disabled:after {\n    content: none;\n  }\n  .tabcontent .tbl-list table th.d-sm-none,\n  .tabcontent .tbl-list table td.d-sm-none {\n    display: table-cell !important;\n  }\n  .tabcontent .tbl-list table th.d-lm-none,\n  .tabcontent .tbl-list table td.d-lm-none {\n    display: none !important;\n  }\n  .popup-boxin .page-detail.w400 {\n    left: 21%;\n  }\n  .testrecord .tbl-list.type2 table td.d-sm-block {\n    display: none !important;\n  }\n}\n@media screen and (max-width: 1089px) {\n  .listbox__area {\n    grid-template-columns: 1fr;\n  }\n  .area__right_content.workplace__info.workplace__main .content__info {\n    grid-template-columns: 1fr;\n    grid-gap: 0;\n  }\n  .area__right_content.workplace__info.workplace__main .content__info .img_workplace {\n    grid-row: auto;\n    margin-bottom: 24px;\n    width: 238px;\n    height: 238px;\n  }\n  .area__right_content.workplace__info.workplace__main .content__info .img_workplace .btn-imgadd {\n    top: 201px;\n  }\n  .content__info ul.form__input .input__area {\n    max-width: unset;\n  }\n  .area__right_content.workplace__info.workplace__main .content__info ul.info__admin {\n    grid-column: auto;\n    grid-row: auto;\n  }\n  .page-top {\n    margin-bottom: 34px;\n  }\n  .area__right_content.workplace__info.workplace__main.info__input .content__info {\n    grid-template-columns: 1fr;\n    grid-auto-rows: auto;\n    grid-gap: 0;\n  }\n  .area__right_content.workplace__info.workplace__main.info__input .content__info ul.info__admin {\n    grid-column: auto;\n    grid-row: auto;\n  }\n  .box.list .box__body .content__list .tbl-list {\n    border-top: 1px solid #dde2e9;\n    border-bottom: 0;\n    margin-top: 20px;\n    max-height: 430px;\n  }\n  .popup-layer .content__list .tbl-list {\n    border-top: 1px solid #dde2e9;\n    border-bottom: 1px solid #dde2e9;\n    margin-top: 20px;\n  }\n  .box.list .box__body .content__list .tbl-list thead,\n  .popup-layer .content__list .tbl-list thead {\n    display: none;\n  }\n  .tabcontent .content__list .tbl-list td,\n  .popup-layer .content__list .tbl-list td {\n    font-size: 13px;\n    vertical-align: top;\n    padding: 15px 8px;\n  }\n  .box.list .box__body .content__list .tbl-list td.d-sm-none,\n  .popup-layer .content__list .tbl-list td.d-sm-none {\n    display: none !important;\n  }\n  .box.list .box__body .content__list .tbl-list td.d-lm-none,\n  .popup-layer .content__list .tbl-list td.d-lm-none {\n    display: table-cell !important;\n  }\n  .box.list .box__body .content__list .tbl-list td.d-lm-none p,\n  .popup-layer .content__list .tbl-list td.d-lm-none p {\n    margin-top: 10px;\n  }\n  .box.list .box__body .content__list .tbl-list td.d-lm-none p:first-child,\n  .popup-layer .content__list .tbl-list td.d-lm-none p:first-child {\n    margin-top: 0;\n  }\n  .area__right_content .btn__wrap.ml-0 {\n    max-width: 100%;\n  }\n  .area__right_content.workplace__info .btn__wrap {\n    max-width: 100%;\n  }\n}\n@media screen and (max-width: 1023px) {\n  /* .content {\n    grid-template-columns: 1fr;\n    grid-template-rows: repeat(auto-fill, minmax(20.625rem, auto));\n    grid-auto-rows: 20.625rem;\n  }\n  .content > *:nth-child(4) {\n    grid-row: auto;\n    grid-column: auto;\n  } */\n}\n@media screen and (min-width: 1201px) and (max-width: 1379px) {\n  .status__data li a {\n    width: 82px;\n  }\n  .status__data li a:focus,\n  .status__data li a.on {\n    width: 80px;\n  }\n}\n\n@media screen and (max-width: 980px) {\n  .tabcontent .tbl-list table th.d-sm-none,\n  .tabcontent .tbl-list table td.d-sm-none {\n    display: none !important;\n  }\n  .tabcontent .tbl-list table .tr__detail .tbl-list.type2 thead tr th,\n  .tabcontent .tbl-list table .tr__detail .tbl-list.type2 tbody tr td {\n    display: table-cell !important;\n  }\n  .tabcontent .tbl-list table .tr__detail .tbl-list.type2 tbody tr td {\n    padding: 13px 16px;\n  }\n  .testrecord .tbl-list.type2 .tr__detail .tbl-list.type2 table tbody tr td.d-sm-block {\n    display: none !important;\n  }\n  .tabcontent .tbl-list.type2 table .tr__detail td {\n    padding: 0 0 16px;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block.firstline::before {\n    content: none;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click td.d-sm-block.firstline {\n    display: flex !important;\n    align-items: flex-start;\n    padding-top: 15px;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block.firstline {\n    display: flex !important;\n    padding-top: 15px;\n    color: #0a78ff;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click td.d-sm-block.firstline span.w25p {\n    position: relative;\n    display: flex;\n    align-items: center;\n    font-size: 0.875rem;\n    line-height: 20px;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click td.d-sm-block.firstline span.w25p::before {\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-bottom: 5px solid transparent;\n    border-top: 5px solid transparent;\n    border-left: 8px solid #909fb7;\n    border-right: 8px solid transparent;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block.firstline span.w25p {\n    margin-left: 0;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block.firstline span.w25p::before {\n    content: \"\";\n    margin-left: -1px;\n    margin-right: 8px;\n    margin-bottom: -10px;\n    width: 0;\n    height: 0;\n    border-bottom: 8px solid transparent;\n    border-top: 8px solid #2a2c2f;\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click td.d-sm-block.firstline p.w85p {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    line-height: 20px;\n    font-size: 0.875rem;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block.firstline p.w85p {\n    display: block;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block {\n    display: block !important;\n    font-size: 0.875rem;\n    color: #003876;\n    font-weight: 500;\n    padding-top: 0;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click.open {\n    position: relative;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click.open::before {\n    content: \"\";\n    position: absolute;\n    width: 4px;\n    height: 100%;\n    background: #0a78ff;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block span {\n    margin-left: 22.5%;\n    display: flex;\n  }\n  .testrecord .tbl-list tbody tr.tr__click {\n    display: flex;\n    flex-direction: column;\n  }\n  .testrecord .tbl-list.type2 table thead th.d-sm-block {\n    display: flex !important;\n    align-items: center;\n    padding: 0 16px;\n    height: 36px;\n  }\n  .tbl-list.type2 table td,\n  .tabcontent .tbl-list.type2 table td {\n    padding: 15px 16px;\n    min-height: auto;\n    font-size: 0.812rem;\n  }\n  .testrecord .tbl-list.type2 table th.d-sm-block span:first-child {\n    display: flex;\n    align-items: center;\n  }\n  .testrecord .tbl-list.type2 table th.d-sm-block span:first-child:before {\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-bottom: 5px solid transparent;\n    border-top: 5px solid transparent;\n    border-left: 8px solid #909fb7;\n    border-right: 8px solid transparent;\n  }\n  .testrecord .tbl-list.type2 table tbody tr.tr__click td:first-child span {\n    float: left;\n    margin-right: 20px;\n  }\n  .testrecord .tbl-list.type2 table td:first-child span::before {\n    margin-left: 0;\n    margin-right: 15px;\n  }\n  .testrecord .tbl-list.type2 table td:first-child span.d-sm-block::before {\n    content: none !important;\n  }\n  .tbl-list.type2 tbody tr.open td:first-child:before {\n    margin: -15px -16px;\n    height: 46px;\n  }\n  .tbl-list.type2 table tr.open td:first-child span::before {\n    margin-left: 0;\n    margin-right: 15px;\n  }\n  .tabcontent .tbl-list.type2 table th {\n    padding: 10px 16px;\n  }\n  /*노후교체요청*/\n  .tabcontent .changeold .tbl-list table th.d-lm-none.d-sm-none,\n  .tabcontent .changeold .tbl-list table td.d-lm-none.d-sm-none {\n    display: none !important;\n  }\n  .tabcontent .changeold .tbl-list table th.d-sm-none,\n  .tabcontent .changeold .tbl-list table td.d-sm-none {\n    display: table-cell !important;\n  }\n}\n\n@media screen and (max-width: 975px) {\n  .devicetype {\n    display: none;\n  }\n  .devicetype.mySwiper2 {\n    display: block;\n    overflow: hidden;\n  }\n  .devicetype .swiper-wrapper.errorpoint {\n    height: 85px;\n  }\n  .devicetype .swiper-wrapper.errorpoint .input-errortxt {\n    top: 4.3rem;\n  }\n  .popup-boxin .page-detail {\n    left: 15%;\n    width: 70%;\n  }\n}\n\n@media screen and (max-width: 900px) {\n  .d-sm-block-toggle.on {\n    display: block;\n  }\n  .tbl__top .btn-search.on {\n    background-color: #0a78ff;\n  }\n  .tbl__top .btn-search.on.active,\n  .tbl__top .btn-search.on:hover {\n    background-color: #003876 !important;\n  }\n  .tbl__top input[type=\"text\"].d-sm-block-toggle.on + .btn-delete {\n    display: none;\n  }\n  .tbl__top input[type=\"text\"].d-sm-block-toggle.on + .btn-delete.active {\n    display: block;\n    background: url(\"../img/icon_deletecircle@3x.png\") no-repeat center center;\n    background-size: 14px 14px;\n    width: 40px;\n    height: 32px;\n    z-index: 2;\n    position: absolute;\n    right: 57px;\n  }\n  .tbl__top .right {\n    width: 100%;\n  }\n  .tbl__top .left + .right {\n    width: auto;\n  }\n  .tbl__top .left + .right .searcharea {\n    width: auto;\n  }\n  .tbl__top .left + .right .searcharea input[type=\"text\"] {\n    width: 174px;\n  }\n  .popup-boxin .page-detail.w400 {\n    left: 17%;\n  }\n  .checkstatus-box + .tbl__top .right .searcharea {\n    justify-content: flex-end;\n  }\n  .checkstatus-box + .tbl__top .right .searcharea input[type=\"text\"] {\n    width: auto;\n  }\n  .box.list .box__body .checkstatus-box + .tbl__top .right .searchinput {\n    display: flex;\n  }\n\n  /* workorder-점검출동 */\n  .box.list .box__body .checkstatus-box + .tbl__top .right .btn-search {\n    width: 96px;\n    background: url(\"../img/Icon_search_white.png\") no-repeat 20px center #909fb7;\n    background-size: 16px;\n  }\n  .box.list .box__body .checkstatus-box + .tbl__top .right .btn-search span {\n    display: block;\n  }\n}\n@media screen and (max-width: 884px) {\n  .admin-site.layout-w3 .tbl-list table th.d-sm-none,\n  .admin-site.layout-w3 .tbl-list table td.d-sm-none {\n    display: none !important;\n  }\n}\n@media screen and (max-width: 870px) {\n  .tbl-list.type3 td ul li.address {\n    display: block;\n    max-width: 260px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n  .admin-site .tabcontent.layout-w2 .area__right_content.workplace__info {\n    overflow-x: auto;\n  }\n  .admin-site .tabcontent.layout-w2 .area__right_content.workplace__info::-webkit-scrollbar {\n    height: 10px;\n  }\n  .admin-site .tabcontent.layout-w2 .area__left {\n    height: auto;\n  }\n  .area__left.only-depth2 + .area__right .checkstatus-box li div a {\n    width: 80px;\n  }\n}\n@media screen and (max-width: 850px) {\n  .tbl-list.hcal-96 table td .ellipsis,\n  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {\n    width: 100%;\n    max-width: 70px !important;\n  }\n}\n@media screen and (max-width: 830px) {\n  .popup-boxin .page-detail.w400 {\n    left: 14%;\n  }\n  /* .ehc__selectbtn button:hover {\n    background-color: transparent;\n  } */\n  .content__info .drag__right__list .filelist-case li,\n  .content__info .drag__right__list .filelist-case li:first-child {\n    flex-direction: column;\n    margin-bottom: 29px;\n  }\n  .filelist-case div {\n    margin-left: 26px;\n    margin-top: 10px;\n  }\n\n  /* 운영관리 컨텐츠 영역_사업장 신규입력 : 디자인 변경 */\n  .newtype .content__info ul.form__input .input__area {\n    width: 280px;\n  }\n\n  .admin-site .tabcontent.layout-w2 .area__right_content .content__info ul li .result__score p.tit.caution::after {\n    margin-left: 95px;\n  }\n\n  /* workorder-점검출동 팝업 */\n  .checkstatus-box li div a {\n    width: 68px;\n    padding: 9px 10px 12px 8px;\n  }\n  .checkstatus-box li div p:first-child {\n    font-size: 14px;\n  }\n  .checkstatus-box li div p:last-child {\n    font-size: 12px;\n  }\n  .checkstatus-box li div p strong {\n    font-size: 24px;\n  }\n}\n@media screen and (max-width: 790px) {\n  .popup-boxin .page-detail.w400 {\n    left: 11%;\n  }\n}\n@media screen and (min-width: 500px) and (max-width: 768px) {\n  header {\n    height: 3.75rem;\n  }\n  .popup-boxin .page-detail.w400 {\n    left: 9%;\n  }\n}\n@media screen and (max-width: 767px) {\n  .navbar {\n    top: 6.25rem;\n  }\n  .navbar__menu {\n    left: -100%;\n    width: 100%;\n    top: 6.25rem;\n    height: calc(100% - 6rem);\n  }\n  .navbar__toggleBtn {\n    width: 2.5rem;\n    height: 2.5rem;\n  }\n  .container.filereports .content {\n    grid-template-rows: repeat(2, minmax(auto, auto));\n  }\n  .box.on .box__setting {\n    border: 2px solid #0a78ff;\n    width: calc(100% - 4px);\n    height: calc(100% - 4px);\n  }\n  .ehc__score .tbl__bottom .btn__wrap button {\n    min-width: 120px;\n    width: auto;\n    padding: 0 17px;\n  }\n  .ehc__score .tbl__bottom .btn__wrap button:nth-child(2) {\n    margin-right: 41%;\n  }\n  .ehc__score .tbl__bottom ul.btn__wrap li:nth-child(2) {\n    margin-right: 37%;\n  }\n  .ehc__score .tbl__bottom ul.btn__wrap li:nth-child(2) button {\n    min-width: 160px;\n    padding: 0;\n  }\n\n  .swiper-section {\n    display: none;\n  }\n  .d-sm-tab {\n    display: block;\n  }\n  .no-responsive .tabcontent .search {\n    display: flex;\n  }\n  .tabcontent .search {\n    display: none;\n  }\n  .tabcontent__top {\n    margin-top: 2.5rem;\n    margin-bottom: 1.75rem;\n  }\n  /* .tabcontent .tbl-list table th.d-sm-none,\n  .tabcontent .tbl-list table td.d-sm-none {\n    display: none !important;\n  } */\n  .box.list .box__body .tbl-list {\n    height: auto;\n    max-height: unset;\n    overflow-y: hidden;\n  }\n  .admin-site .tbl-list.td-h32 table td {\n    height: 22px;\n  }\n  .popup-layer.page-report .form__input.d-sm-block {\n    display: block !important;\n  }\n\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .tbl__bottom,\n  .popup-layer .tbl__bottom {\n    justify-content: flex-start;\n    margin: 24px 0;\n    flex-wrap: wrap;\n  }\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .paging,\n  .popup-layer .paging {\n    width: 100%;\n    justify-content: center;\n    margin-top: 24px;\n  }\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .paging__select,\n  .popup-layer .paging__select {\n    display: none;\n  }\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .paging ul,\n  .popup-layer .paging ul {\n    margin-left: 0;\n  }\n  /* #wrap:not(.no-responsive) .container:not(.no-responsive) .paging li,\n  .popup-layer .paging li {\n    min-width: auto;\n    width: 27px;\n    height: 27px;\n  } */\n  /* #wrap:not(.no-responsive) .container:not(.no-responsive) .paging .btn-prev.disabled,\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .paging .btn-next.disabled,\n  .popup-layer .paging .btn-prev.disabled,\n  .popup-layer .paging .btn-next.disabled {\n    background: url('../img/icon_next_m_dis.png') no-repeat center center #fff;\n  }\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .paging .btn-prev,\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .paging .btn-next,\n  .popup-layer .paging .btn-prev,\n  .popup-layer .paging .btn-next {\n    width: 28px;\n    background: url('../img/icon_next_m.png') no-repeat center center #fff;\n    border: 0;\n    margin: 0;\n  } */\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .paging .btn-first,\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .paging .btn-last,\n  .popup-layer .paging .btn-first,\n  .popup-layer .paging .btn-last {\n    display: none;\n  }\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .paging li > a,\n  .popup-layer .paging li > a {\n    font-size: 0.875rem;\n  }\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .paging li > a.active,\n  .popup-layer .paging li > a.active {\n    height: 100%;\n    border-top: 1px solid #909fb7;\n    border-bottom: 1px solid #909fb7;\n  }\n  /* #wrap:not(.no-responsive) .container:not(.no-responsive) .paging li.btn-prev + li,\n  .popup-layer .paging li.btn-prev + li {\n    border: none;\n  } */\n  .paging .btn-prev {\n    margin-right: 16px;\n  }\n  .paging .btn-next {\n    margin-left: 16px;\n  }\n  .result__num.d-mm-none {\n    display: none !important;\n  }\n  .result__num.d-mm-block {\n    display: block !important;\n  }\n  .popup-boxin .page-detail.w400 {\n    left: 22%;\n  }\n  .tabcontent__title {\n    margin-top: 0;\n  }\n  .search__inline .search-small {\n    margin-right: calc(100% - 174px);\n  }\n  .search__inline .btn.btn-filedown,\n  .search__inline .btn-qr.btn-basic {\n    display: none;\n  }\n  /* .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block.firstline::before {\n    content: none;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click td.d-sm-block.firstline {\n    display: flex !important;\n    align-items: flex-start;\n    padding-top: 15px;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block.firstline {\n    display: flex !important;\n    padding-top: 15px;\n    color: #0a78ff;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click td.d-sm-block.firstline span.w25p {\n    position: relative;\n    display: flex;\n    align-items: center;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click td.d-sm-block.firstline span.w25p::before {\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-bottom: 5px solid transparent;\n    border-top: 5px solid transparent;\n    border-left: 8px solid #909fb7;\n    border-right: 8px solid transparent;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block.firstline span.w25p {\n    margin-left: 0;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block.firstline span.w25p::before {\n    content: \"\";\n    margin-left: -1px;\n    margin-right: 8px;\n    margin-bottom: -10px;\n    width: 0;\n    height: 0;\n    border-bottom: 8px solid transparent;\n    border-top: 8px solid #2a2c2f;\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click td.d-sm-block.firstline p.w85p {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    line-height: 20px;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block.firstline p.w85p {\n    display: block;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block {\n    display: block !important;\n    font-size: 0.812rem;\n    color: #003876;\n    font-weight: 500;\n    padding-top: 0;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click.open {\n    position: relative;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click.open::before {\n    content: \"\";\n    position: absolute;\n    width: 4px;\n    height: 100%;\n    background: #0a78ff;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block span {\n    margin-left: 25%;\n    display: flex;\n  }\n  .testrecord .tbl-list tbody tr.tr__click {\n    display: flex;\n    flex-direction: column;\n  }\n  .testrecord .tbl-list.type2 table thead th.d-sm-block {\n    display: flex !important;\n    align-items: center;\n    padding: 0 16px;\n    height: 36px;\n  }\n  .tbl-list.type2 table td,\n  .tabcontent .tbl-list.type2 table td {\n    padding: 15px 16px;\n    min-height: auto;\n    font-size: 0.812rem;\n  }\n  .testrecord .tbl-list.type2 table th.d-sm-block span:first-child {\n    display: flex;\n    align-items: center;\n  }\n  .testrecord .tbl-list.type2 table th.d-sm-block span:first-child:before {\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-bottom: 5px solid transparent;\n    border-top: 5px solid transparent;\n    border-left: 8px solid #909fb7;\n    border-right: 8px solid transparent;\n  }\n  .testrecord .tbl-list.type2 table tbody tr.tr__click td:first-child span {\n    float: left;\n    margin-right: 20px;\n  }\n  .testrecord .tbl-list.type2 table td:first-child span::before {\n    margin-left: 0;\n    margin-right: 15px;\n  }\n  .testrecord .tbl-list.type2 table td:first-child span.d-sm-block::before {\n    content: none !important;\n  }\n  .tbl-list.type2 tbody tr.open td:first-child:before {\n    margin: -15px -16px;\n    height: 46px;\n  }\n  .tbl-list.type2 table tr.open td:first-child span::before {\n    margin-left: 0;\n    margin-right: 15px;\n  }\n  .tabcontent .tbl-list.type2 table th {\n    padding: 10px 16px;\n  } */\n  .testrecord .tbl-list.type2 table tr.tr__click td.d-sm-block.firstline span.w25p,\n  .testrecord .tbl-list.type2 table thead th.d-sm-block span.w25p {\n    width: 30% !important;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click td.d-sm-block.firstline p.w85p,\n  .testrecord .tbl-list.type2 table thead th.d-sm-block span.w85p {\n    width: 70% !important;\n    -webkit-line-clamp: 2;\n  }\n  .testrecord .tbl-list.type2 table tr.tr__click.open td.d-sm-block span {\n    margin-left: 29.5%;\n  }\n  .tr__detail .tbl-list.type2 {\n    margin-left: 0;\n  }\n  .tr__detail .tbl-list.type2 th {\n    display: none;\n  }\n  .tbl-list.type2 table tbody .tr__detail td {\n    padding: 0 0 0 8px;\n  }\n  .tbl-list.type2 table tbody .tr__detail td .tbl-list.type2 table tbody td {\n    padding: 14px 20px;\n  }\n  .tabcontent .tbl-list table .tr__detail .tbl-list.type2 thead,\n  .tabcontent .tbl-list table .tr__detail .tbl-list.type2 tbody tr td.d-sm-none {\n    display: none !important;\n  }\n  .testrecord .tbl-list.type2 table tbody .tr__detail td .tbl-list.type2 table tbody td.d-sm-block {\n    display: block !important;\n    padding: 14px 34px 14px 28px;\n  }\n  .tbl-list.type2 table tbody .tr__detail td .tbl-list.type2 table tbody td .btn-file {\n    width: 24px;\n    height: 24px;\n    background: url(\"../img/icon_filedown_m.png\") no-repeat center center;\n    background-size: 100%;\n  }\n  .tr__detail .tbl-list.type2 tbody tr td.btn__tdarea:hover,\n  .tr__detail .tbl-list.type2 tbody tr td.btn__tdarea:active {\n    background: #f0f2f4;\n    cursor: pointer;\n  }\n  .tr__detail .tbl-list.type2 tbody tr td.btn__tdarea .btn-file:hover,\n  .tr__detail .tbl-list.type2 tbody tr td.btn__tdarea .btn-file:active {\n    filter: none;\n  }\n  .tr__detail .tbl-list.type2 tbody tr:nth-child(even) td.btn__tdarea:hover,\n  .tr__detail .tbl-list.type2 tbody tr:nth-child(even) td.btn__tdarea:active {\n    background: #dde2e9;\n  }\n  .tbl-list.type2 table .tr__detail td:first-child span::before {\n    content: none;\n  }\n  .tbl-list.type2 table .tr__detail td.d-sm-block span:first-child {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n  }\n  .tbl-list.type2 table .tr__detail td.d-sm-block span:last-child {\n    font-weight: 400;\n    font-size: 13px;\n    margin-top: 12px;\n  }\n  .container.admin-site {\n    min-height: calc(100vh - 7.3rem);\n  }\n  .admin-site .box.list .box__body {\n    height: auto;\n    padding-top: 0;\n  }\n  .admin-site .area__left {\n    width: 100%;\n    border-right: 0;\n  }\n  .admin-site .area__right {\n    display: none;\n  }\n  .admin-site.no-responsive .area__right {\n    display: block;\n  }\n  .admin-site .tbl-list table td {\n    height: 22px;\n  }\n  .admin-site .tabcontent .lnb {\n    margin: 0 8px;\n    max-height: unset;\n    height: calc(100vh - 237px);\n  }\n  .admin-site .tabcontent .lnb ul.lnb-depth1 {\n    border-bottom: 1px solid #dde2e9;\n  }\n  .popup-layer.page-workplace {\n    margin-top: 49px;\n    width: calc(100% - 24px);\n    height: calc(100vh - 136px);\n  }\n  .popup-layer.page-workplace.page-detail .popup__head {\n    flex-direction: column-reverse;\n    padding-top: 13px;\n    padding-bottom: 32px;\n    padding-right: 13px;\n    width: calc(100% - 29px);\n  }\n  .popup-layer.page-workplace.page-detail .popup__head h1 {\n    text-align: left;\n    width: 100%;\n    font-size: 15px;\n  }\n  .popup-layer.page-workplace.page-detail .popup__head .btn-close {\n    width: 100%;\n    background-position: right center;\n  }\n  .popup-layer.page-workplace.page-detail .popup__body {\n    max-height: calc(100% - 95px);\n    overflow-y: hidden;\n  }\n  .popup-layer.page-workplace.page-detail .popup__body .area__right_content .searcharea {\n    margin-bottom: 32px;\n  }\n  .tbl-list.type3.w800 {\n    max-height: calc(100vh - 340px);\n  }\n  .popup-layer.page-workplace.page-detail .popup__body .area__right_content .searcharea .searchinput {\n    width: 100%;\n  }\n  .popup-layer.page-workplace.page-detail .popup__body .area__right_content .searcharea .btn-search {\n    width: 32px;\n    background-position: center;\n  }\n  .popup-layer.page-workplace.page-detail .popup__body .area__right_content .searcharea .btn-search span {\n    display: none;\n  }\n  .popup-layer.page-workplace.page-detail .popup__body .area__right_content .searcharea .input__direct {\n    width: calc(100% - 40px);\n  }\n  .popup-layer.page-workplace.page-detail\n    .popup__body\n    .area__right_content\n    .searcharea\n    .input__direct\n    input[type=\"text\"] {\n    width: calc(100% - 54px) !important;\n    padding-right: 40px;\n  }\n  .popup-layer.page-workplace.page-info {\n    margin-top: 49px;\n    width: calc(100% - 18px);\n  }\n  .popup-layer.page-workplace.page-detail.page-info .popup__body {\n    overflow-x: hidden;\n  }\n  .popup-layer.page-workplace.page-info .area__right_content.workplace__info {\n    height: calc(100vh - 265px);\n    overflow-y: auto;\n  }\n  .popup-layer.page-workplace.page-detail.page-info .popup__head {\n    padding: 0;\n    border-bottom: 0;\n  }\n  .popup-layer.page-workplace.page-detail.page-info .popup__head .btn-close {\n    z-index: 3;\n    position: absolute;\n    right: 12px;\n    top: 10px;\n    width: 1rem;\n  }\n  .popup-layer.page-workplace.page-detail.page-info .popup__body {\n    max-height: 100%;\n  }\n  .popup-layer.page-workplace.page-detail.page-info .page-loca {\n    position: relative;\n    z-index: 2;\n    padding: 13px 16px;\n    margin-bottom: 20px;\n  }\n  .popup-layer.page-workplace.page-detail.page-info .page-loca li {\n    font-size: 13px;\n  }\n  .popup-layer.page-workplace.page-detail.page-info .page-top {\n    margin-bottom: 42px;\n  }\n  .popup-layer.page-workplace.page-detail.page-info .page-top h2 {\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 29px;\n    color: #2a2c2f;\n  }\n  .popup-layer.page-workplace.page-detail.page-info .page-top .top-button button {\n    width: 28px;\n    height: 28px;\n  }\n  .popup-layer.page-workplace.page-detail.page-info .page-top .top-button button + button {\n    margin-left: 8px;\n  }\n  .popup-layer.page-workplace.page-detail.page-info .area__right_content.workplace__info .content__info {\n    padding: 0 16px;\n    width: calc(100% - 32px);\n    height: auto;\n  }\n  .popup-layer.page-workplace.page-detail.page-list-view .popup__head {\n    padding-bottom: 1rem;\n    padding-top: 13px;\n    padding-left: 1rem;\n  }\n  .popup-layer.page-workplace.page-detail.page-list-view .popup__head h1 {\n    font-size: 20px;\n    margin-top: 16px;\n    margin-bottom: 16px;\n  }\n  .popup-layer.page-workplace.page-detail.page-info.page-list-view .area__right_content.workplace__info .content__info {\n    padding: 0;\n  }\n  .popup-layer.page-workplace.page-detail.page-info .content__info ul li {\n    flex-direction: column;\n    margin-bottom: 1rem;\n  }\n  .popup-layer.page-workplace.page-detail.page-info .content__info ul li p {\n    font-size: 14px;\n    width: 100%;\n  }\n  .popup-layer.page-workplace.page-detail.page-info .content__info ul li:first-child p.txt.treeon,\n  .popup-layer.page-workplace.page-detail.page-info .content__info ul li:first-child p.txt.treeoff {\n    width: 64px;\n  }\n  .popup-layer.page-workplace.page-detail.page-info .content__info ul li p.tit {\n    margin-top: 0;\n    margin-bottom: 8px;\n  }\n  .popup-layer.page-workplace.page-detail.page-info .content__info ul.filelist.down li,\n  .popup-layer.page-workplace.page-detail.page-info .content__info ul.filelist li {\n    flex-direction: row;\n  }\n  .popup-layer.page-workplace.page-detail.page-info .content__info ul.filelist::not(.down) li span {\n    line-height: 21px;\n  }\n  .popup-layer.page-workplace.page-detail.page-info .area__right_content.workplace__info .content__list {\n    padding: 34px 16px;\n    width: calc(100% - 32px);\n  }\n  .popup-layer.page-workplace .area__right_content.workplace__info .content__info ul li p.tit span {\n    display: inline-block;\n    margin: 0 0 0 1px;\n  }\n  .popup-layer.page-workplace .info__input {\n    height: calc(100vh - 265px);\n    overflow-y: auto;\n  }\n  .popup-layer.page-workplace\n    .area__right_content.workplace__info\n    .content__info\n    .area__right_content.workplace__info\n    .content__info {\n    padding: 0 24px;\n    width: calc(100% - 48px);\n  }\n  .popup-layer.page-workplace.page-detail .popup__body {\n    max-height: 100%;\n    overflow-x: hidden;\n  }\n  .popup-layer.page-workplace.info__input .area__right_content.workplace__info {\n    height: calc(100vh - 265px);\n    overflow-y: auto;\n  }\n  .popup-layer.page-workplace .area__right_content.workplace__info .content__info ul.form__input .input__area {\n    width: 100%;\n  }\n  .popup-layer.page-workplace .area__right_content.workplace__info .content__info ul.form__input li {\n    flex-direction: column;\n    margin-top: 0;\n  }\n  .popup-layer.page-workplace .area__right_content.workplace__info .content__info ul.form__input li p.tit {\n    width: 100%;\n    margin: 0 0 8px;\n  }\n  .popup-layer.page-workplace .area__right_content.workplace__info .content__info ul.form__input li textarea {\n    height: 106px;\n  }\n  .popup-layer.page-workplace .area__right_content.workplace__info .content__info ul.form__input li input[type=\"text\"],\n  .popup-layer.page-workplace\n    .area__right_content.workplace__info\n    .content__info\n    ul.form__input\n    li\n    input[type=\"password\"],\n  .popup-layer.page-workplace .area__right_content.workplace__info .content__info ul.form__input li input[type=\"tel\"],\n  .popup-layer.page-workplace .area__right_content.workplace__info .content__info ul.form__input li input[type=\"file\"] {\n    height: 40px;\n    font-size: 1rem;\n  }\n  .popup-layer.page-workplace .area__right_content.workplace__info .btn__wrap {\n    justify-content: center;\n    margin-right: 0;\n    margin-bottom: 80px;\n  }\n  .popup-layer.page-workplace.page-list-in .area__right_content.workplace__info .btn__wrap,\n  .popup-layer.page-workplace.page-list-view .area__right_content.workplace__info .btn__wrap {\n    margin-bottom: 0;\n  }\n  .popup-layer .popup__body .form__input .filebox label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: inline-block;\n    color: #fff;\n    vertical-align: middle;\n    cursor: pointer;\n    height: 100%;\n    width: 32px !important;\n    border-radius: 4px 0 0 4px;\n    background: url(../img/icon_file_w.png) no-repeat center center #a4b0c4;\n    background-size: 0.563rem 1.087rem;\n  }\n  .popup-layer.page-workplace .area__right_content.workplace__info .content__info ul.form__input li .filelist li {\n    flex-direction: row;\n  }\n  .popup-layer.page-list .area__right_content.workplace__info .tab__small {\n    margin-bottom: 8px;\n  }\n  .popup-layer.page-workplace.page-detail.page-info.page-list .page-top {\n    margin-bottom: 24px;\n  }\n  .popup-layer.page-workplace .mySwiper2 {\n    margin-top: 8px;\n  }\n  .popup-layer.page-workplace .btn-scan {\n    height: 42px;\n  }\n  .popup-layer.page-workplace .btn-scan span {\n    font-size: 14px;\n  }\n  .popup-layer.page-workplace.page-info.page-list .area__right_content.workplace__info {\n    padding: 0 1rem;\n  }\n  .popup-layer.page-workplace.page-info.page-list .search-small.mb-16 {\n    margin-bottom: 12px !important;\n  }\n  .popup-layer.page-workplace.page-detail.page-list .popup__body .area__right_content .searcharea {\n    margin-bottom: 0;\n  }\n  .popup-layer.page-list .tbl-list table {\n    border-bottom: 1px solid #dde2e9;\n  }\n  .popup-layer.page-list .tbl-list table td,\n  .popup-layer.page-list .tabcontent .tbl-list table td {\n    padding: 22px 17px;\n  }\n  .popup-layer.page-list .tbl-list table th {\n    padding: 10px 15px;\n  }\n  .popup-layer.page-list .tbl-list.hcal-96 {\n    height: auto !important;\n  }\n  .popup-layer.page-workplace .drag__area .filebox-upload {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .popup-layer.page-workplace .drag__area .filebox-upload .filebox {\n    margin-top: 10px;\n    width: 100%;\n  }\n  .popup-layer.page-workplace .drag__area .filebox-upload .filebox label {\n    width: 100%;\n  }\n  .popup-layer.page-workplace .drag__area .filebox-upload .flielist__upload {\n    margin-top: 12px;\n    width: 100%;\n  }\n  .popup-layer.page-workplace .drag__area .drag__left .filebox-upload .filelist {\n    width: calc(100% - 100px);\n  }\n  .popup-layer.page-workplace .content__info .drag__right__list li:last-child {\n    margin-bottom: 0;\n    padding-bottom: 0;\n  }\n  .tbl-list.type5 {\n    margin-top: 2px;\n    max-height: calc(100vh - 415px);\n    border-bottom: 0;\n  }\n  .tbl-list.type5 table tbody td {\n    padding: 14px 34px 14px 28px;\n    background: #fafafa;\n  }\n  .tbl-list.type5 table tbody td:first-child {\n    display: flex;\n    flex-direction: column;\n  }\n  .tbl-list.type5 table td span:first-child {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n  }\n  .tbl-list.type5 table td span:last-child {\n    font-weight: 400;\n    font-size: 13px;\n    margin-top: 12px;\n  }\n  .tbl-list.type5 table tbody td .btn-file {\n    width: 24px;\n    height: 24px;\n    background: url(\"../img/icon_filedown_m.png\") no-repeat center center;\n    background-size: 100%;\n  }\n  .tbl-list.type5 tbody tr td.btn__tdarea:hover,\n  .tbl-list.type5 tbody tr td.btn__tdarea:active {\n    background: #f0f2f4;\n    cursor: pointer;\n  }\n  .tbl-list.type5 tbody tr td.btn__tdarea .btn-file:hover,\n  .tbl-list.type5 tbody tr td.btn__tdarea .btn-file:active {\n    filter: none;\n  }\n  .tbl-list.type5 tbody tr:nth-child(even) td.btn__tdarea:hover,\n  .tbl-list.type5 tbody tr:nth-child(even) td.btn__tdarea:active {\n    background: #dde2e9;\n  }\n  .admin-site.layout-w3 .page-top {\n    padding: 20px 0;\n  }\n  .admin-site.layout-w3 .area__left {\n    margin-top: 20px;\n  }\n  .admin-site.layout-w3 .area__right {\n    display: block;\n  }\n  .admin-site.layout-w3 .area__left_content.detail__view.on,\n  .admin-site.layout-w3 .area__right_content.detail__view.on {\n    margin-top: 4px;\n  }\n  .admin-site.layout-w3 .area__left .tbl__bottom,\n  .admin-site.layout-w3 .area__right-end .tbl__bottom,\n  .admin-site.layout-w3 .area__right .tbl__bottom.mt-48 {\n    margin: 16px 0 40px !important;\n  }\n  .admin-site.layout-w3 .area__left .tbl__bottom .paging,\n  .admin-site.layout-w3 .area__right-end .tbl__bottom .paging {\n    justify-content: flex-start;\n    width: auto;\n  }\n  .admin-site.layout-w3 .area__left .tbl__bottom .paging ul,\n  .admin-site.layout-w3 .area__right-end .tbl__bottom .paging ul {\n    margin-left: 1.25rem;\n  }\n  .admin-site.layout-w3 .tbl__bottom .paging__select {\n    display: none;\n  }\n  .workplace-ok.page-detail {\n    width: calc(100% - 24px);\n    margin-top: 49px;\n    height: calc(100vh - 136px);\n  }\n  .workplace-ok.page-detail .popup__head {\n    flex-direction: column-reverse;\n    align-items: flex-start;\n    justify-content: space-between;\n    border-bottom: 0;\n  }\n  .workplace-ok.page-detail .popup__head h1 {\n    margin-top: 4px;\n  }\n  .workplace-ok.page-detail .popup__head .btn-close {\n    width: 100%;\n    background-position: right center;\n  }\n  .workplace-ok.page-detail .popup__body {\n    padding: 16px;\n    margin: 0 0 8px;\n    width: calc(100% - 2rem);\n    max-height: calc(100% - 172px);\n    height: auto;\n  }\n  .workplace-ok.page-detail .img_workplace {\n    margin-top: -495px;\n  }\n  .workplace-ok.page-detail .workplace__info .txt_workplace ul {\n    margin-top: 280px;\n  }\n  .workplace-ok.page-detail .workplace__info .txt_workplace ul li {\n    flex-direction: column;\n  }\n  .workplace-ok.page-detail .workplace__info .txt_workplace ul li p.txt {\n    margin-top: 10px;\n  }\n  .workplace-ok.page-detail .popup__footer {\n    border-top: 0;\n    padding-top: 0;\n  }\n\n  .userjoin-ok.page-detail {\n    width: calc(100% - 24px);\n    margin-top: 49px;\n    height: calc(100vh - 136px);\n  }\n  .userjoin-ok.page-detail .popup__head {\n    flex-direction: column-reverse;\n    align-items: flex-start;\n    justify-content: space-between;\n    border-bottom: 0;\n  }\n  .userjoin-ok.page-detail .popup__head h1 {\n    margin-top: 4px;\n  }\n  .userjoin-ok.page-detail .popup__head .btn-close {\n    width: 100%;\n    background-position: right center;\n  }\n  .userjoin-ok.page-detail .popup__body {\n    padding: 16px;\n    margin: 0 0 8px;\n    width: calc(100% - 2rem);\n    max-height: calc(100% - 172px);\n    height: auto;\n  }\n  .userjoin-ok.page-detail .popup__body .form__input li {\n    flex-direction: column;\n    align-items: flex-start;\n    margin-bottom: 16px;\n    margin-top: 0;\n  }\n  .userjoin-ok.page-detail .popup__body .form__input .tit {\n    font-size: 14px;\n    margin-bottom: 8px;\n    width: 100%;\n  }\n  .userjoin-ok.page-detail .popup__body .form__input li.inline {\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between;\n    margin-top: 24px;\n  }\n  .userjoin-ok.page-detail .popup__body .form__input li.inline .tit {\n    width: auto;\n  }\n  .userjoin-ok.page-detail .popup__body .form__input input[type=\"text\"],\n  .userjoin-ok.page-detail .popup__body .form__input input[type=\"password\"],\n  .userjoin-ok.page-detail .popup__body .form__input input[type=\"tel\"],\n  .userjoin-ok.page-detail .popup__body .form__input input[type=\"file\"] {\n    height: 42px;\n  }\n  .userjoin-ok.page-detail .popup__body .form__input .input__area {\n    width: 100%;\n  }\n  .userjoin-ok.page-detail .popup__body .form__input .tbl-list.type2.mt-m10 {\n    margin-top: 0 !important;\n  }\n  .userjoin-ok.page-detail .popup__body .right {\n    margin-top: 30px;\n  }\n  .userjoin-ok.page-detail .popup__footer {\n    border-top: 0;\n    padding-top: 0;\n  }\n  .userjoin-ok.page-detail .popup__body .form__input button.btn-basic.d-sm-none {\n    display: none;\n  }\n  .userjoin-ok.page-detail .popup__body .form__input button.btn-basic.d-sm-block {\n    display: flex;\n  }\n\n  .popup-layer.pop-usertype {\n    width: calc(100% - 24px);\n    margin-top: 49px;\n    height: calc(100vh - 136px);\n  }\n  .popup-layer.pop-usertype .popup__head {\n    flex-direction: column-reverse;\n    align-items: flex-start;\n    justify-content: space-between;\n    border-bottom: 0;\n  }\n  .popup-layer.pop-usertype .popup__head h1 {\n    margin-top: 4px;\n  }\n  .popup-layer.pop-usertype .popup__head .btn-close {\n    width: 100%;\n    background-position: right center;\n  }\n  .popup-layer.pop-usertype .popup__body {\n    padding: 16px;\n    margin: 0 0 8px;\n    width: calc(100% - 2rem);\n    max-height: calc(100% - 108px);\n    height: auto;\n  }\n  .popup-layer.pop-usertype .user-info {\n    margin-bottom: 40px;\n  }\n  .popup-layer.pop-usertype .user-info li {\n    margin-bottom: 20px;\n  }\n  .popup-layer.pop-usertype .user-info li p:first-child {\n    width: 86px;\n    font-size: 14px;\n  }\n  .popup-layer.pop-usertype .user-info li p:last-child {\n    width: calc(100% - 86px);\n  }\n  .popup-layer.pop-usertype .tbl-list table {\n    border-bottom: 1px solid #dde2e9;\n  }\n\n  /* 운영관리 컨텐츠 영역_사업장 신규입력 : 디자인 변경 */\n  .area__right_content.workplace__info.workplace__main.newtype .content__info {\n    display: grid;\n  }\n  .area__right_content.workplace__info.workplace__main.newtype .content__info h3 {\n    font-size: 0.938rem;\n    margin-bottom: 1rem;\n  }\n  .area__right_content.workplace__info.workplace__main.newtype .content__info + .content__info {\n    margin-top: 40px;\n    padding-top: 40px;\n  }\n  .newtype .content__info .flex-row .form__input.ml-40 {\n    margin-top: 1rem;\n  }\n  .newtype .column .btn__wrap {\n    display: none;\n  }\n  .admin-site .tabcontent.layout-w2 .newtype .column .btn__wrap {\n    display: flex;\n  }\n  .area__right_content.workplace__info.newtype .btn__wrap {\n    margin-top: 40px;\n  }\n  .newtype .content__info ul.form__info li {\n    flex-direction: column;\n    margin-bottom: 1rem;\n  }\n  .newtype .content__info ul.form__info li:last-child {\n    margin-bottom: 0;\n  }\n  .newtype .content__info ul.form__info li p {\n    font-size: 14px;\n    width: 100%;\n  }\n  .newtype .content__info ul.form__info li p.tit {\n    margin-top: 0;\n    margin-bottom: 8px;\n  }\n\n  /* 요청반려 사유확인 팝업 */\n  .popup-basic.reason {\n    width: calc(100% - 4rem);\n    height: 450px;\n  }\n  .popup-basic.reason .popup__body {\n    height: 305px;\n  }\n  .popup-basic.reason .font-16 {\n    font-size: 16px !important;\n  }\n  .popup-basic.reason dl {\n    margin: 24px 16px 0;\n    width: calc(100% - 32px);\n  }\n  .popup-basic.reason .page-detail .popup__footer {\n    border-top: 0;\n  }\n  /* workorder-점검출동 */\n  .admin-site .area__right.d-sm-block {\n    display: block;\n  }\n  .tabcontent .area__top .search {\n    display: flex;\n  }\n  .area__top + .nodata__txt {\n    margin-top: 0px !important;\n  }\n  .area__top .searchterm .term__month {\n    height: 40px;\n  }\n  .area__top .searchterm .term__month + .term__date {\n    display: none;\n  }\n  .tabcontent .area__top .search .form__input {\n    width: 100%;\n  }\n  .tabcontent .area__top .search .form__input + .btn__wrap {\n    display: none;\n  }\n  .tabcontent .area__top .search .form__input li {\n    flex-direction: column;\n  }\n  .tabcontent .area__top .search .form__input .input__area {\n    margin-left: 0 !important;\n    margin-top: 8px;\n    width: 100%;\n  }\n  .box.list .box__body .checkstatus-box + .tbl__top .right .searchinput {\n    display: none;\n  }\n  .box.list .box__body .checkstatus-box + .tbl__top .right .btn-search {\n    width: 32px;\n    background-position: center center;\n  }\n  .box.list .box__body .checkstatus-box + .tbl__top .right .btn-search span {\n    display: none;\n  }\n\n  .area__left.only-depth2,\n  .area__left.only-depth2.close {\n    display: none;\n  }\n  .admin-site .area__left.only-depth2 + .area__right {\n    display: block;\n    width: calc(100% - 28px) !important;\n    margin-top: -16px;\n  }\n  .admin-site .area__left.only-depth2 + .area__right .page-loca {\n    margin-bottom: 0;\n    margin-top: 0;\n  }\n  .area__left__toggleBtn {\n    display: block;\n    position: fixed;\n    bottom: 1.25rem;\n    right: 1.5rem;\n    width: 4rem;\n    height: 4rem;\n    border-radius: 50%;\n    box-shadow: 2px 4px 8px rgb(2 136 255 / 40%);\n    z-index: 20;\n    background: url(../img/icon_tree.png) no-repeat center center #0a78ff;\n    background-size: 2rem 2rem;\n  }\n  .area__left.only-depth2.active {\n    display: block;\n    position: fixed;\n    top: 6.75rem;\n    width: 100% !important;\n    height: calc(100% - 5.75rem);\n    border: 0;\n    padding: 0;\n    margin: -0.5rem;\n    z-index: 100;\n  }\n  .area__left.only-depth2.active .btn-left {\n    display: flex !important;\n    width: 1.5rem;\n    height: 1.5rem;\n    padding: 0;\n    background: url(\"../img/icon_treeclose.png\") no-repeat center center;\n  }\n  .area__left.only-depth2.active .btn-left::after {\n    content: none;\n  }\n  .area__left.only-depth2.active .lnb {\n    display: block;\n    max-height: unset;\n    height: calc(100% - 63px);\n  }\n  .area__left.only-depth2.active .lnb .lnb-depth1 {\n    border-bottom: 1px solid #dde2e9;\n    margin-bottom: 10px;\n  }\n  .admin-site.workorder .nodata .nodata__txt {\n    margin-top: 0;\n  }\n\n  /*노후교체요청*/\n  .tabcontent .changeold .search {\n    display: flex;\n  }\n\n  .tabcontent__title .btn-qr {\n    display: flex;\n  }\n  .admin-site .box.list .box__body .tbl-list.hcal-77 {\n    height: auto;\n  }\n  .admin-site .box.list .box__body .tbl-list.hcal-vh-315 {\n    height: auto !important;\n  }\n  .admin-site .box.list .box__body .tbl-list.hcal-vh-415 {\n    height: auto !important;\n  }\n  .admin-site .box.list .box__body .tbl-list.hcal-vh-430 {\n    height: auto !important;\n  }\n  .admin-site .box.list .box__body .tbl-list.hcal-vh-560 {\n    height: auto !important;\n  }\n}\n@media screen and (max-width: 700px) {\n  .popup-boxin .page-detail.w400 {\n    left: 20%;\n  }\n  /* workorder-점검출동 팝업 */\n  .area__left.only-depth2 + .area__right .checkstatus-box li {\n    width: calc(100% - 10px);\n  }\n  .area__left.only-depth2 + .area__right .checkstatus-box li:first-child {\n    display: none;\n  }\n  .area__left.only-depth2 + .area__right .checkstatus-box li + li {\n    margin-left: 2px;\n    padding-left: 0;\n    border-left: 0;\n  }\n  .area__left.only-depth2 + .area__right .checkstatus-box li + li div {\n    width: 25%;\n  }\n  .area__left.only-depth2 + .area__right .checkstatus-box li div a {\n    width: auto;\n  }\n}\n@media screen and (max-width: 650px) {\n  /*노후교체요청*/\n  .tabcontent .changeold .tbl-list table th.d-sm-none,\n  .tabcontent .changeold .tbl-list table td.d-sm-none {\n    display: none !important;\n  }\n}\n@media screen and (max-width: 648px) {\n  .popup-boxin .page-detail.w400 {\n    left: 17%;\n  }\n}\n@media screen and (max-width: 600px) {\n  .popup-boxin .page-detail.w400 {\n    left: 15%;\n  }\n  /*사업장추가-이미지크롭 팝업*/\n  .popup-basic.imgcrop {\n    width: calc(100% - 4rem);\n    height: 75vh;\n  }\n\n  /* workorder-점검출동 팝업 */\n  .checkstatus-box li {\n    width: calc(100% - 10px);\n  }\n  .checkstatus-box li:first-child {\n    display: none;\n  }\n  .checkstatus-box li + li {\n    margin-left: 2px;\n    padding-left: 0;\n    border-left: 0;\n  }\n  .checkstatus-box li + li div {\n    width: 25%;\n  }\n  .checkstatus-box li div a {\n    width: auto;\n  }\n  /* .checkstatus-box li + li div::before,\n  .checkstatus-box li + li div.on::before,\n  .checkstatus-box li + li div.end::before,\n  .checkstatus-box li + li div.on + div::before {\n    content: none;\n  }\n  .checkstatus-box li + li div:last-child a::after,\n  .checkstatus-box li + li div.on::after,\n  .checkstatus-box li + li div.end::after,\n  .checkstatus-box li + li div::after {\n    content: none;\n  } */\n}\n\n@media screen and (max-width: 560px) {\n  .popup-boxin .page-detail.w400 {\n    left: 12%;\n  }\n  /*노후교체요청*/\n  .devicenum,\n  .devicenum.d-lm-block {\n    display: none;\n  }\n  .btn-basic.down {\n    display: none;\n  }\n}\n@media screen and (max-width: 570px) {\n  .ehc__score .tbl__bottom .btn__wrap button {\n    padding: 0 0.75rem;\n  }\n  .ehc__score .tbl__bottom ul.btn__wrap li button + button {\n    margin-left: 7px;\n  }\n  .ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-share,\n  .ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-reload {\n    width: 2.5rem;\n    min-width: 2.5rem;\n    height: 2.5rem;\n    background-position: center;\n  }\n  .ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-share:hover,\n  .ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-reload:hover {\n    background-position: center;\n  }\n  .ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-share span,\n  .ehc__score .ehc__result + .tbl__bottom .btn__wrap button.btn-reload span {\n    position: absolute;\n    left: -99999px;\n    width: 0;\n    height: 0;\n    font-size: 0;\n    line-height: 0;\n    text-indent: -9999em;\n    overflow: hidden;\n    z-index: -1;\n  }\n  .ehc__score .tbl__bottom ul.btn__wrap li:nth-child(2) {\n    margin-right: 32%;\n  }\n  .ehc__score .tbl__bottom .btn__wrap button:nth-child(2) {\n    margin-right: 36.5%;\n  }\n\n  /*헤더-My Account 팝업*/\n  .popup-basic.myaccount,\n  .community .popup-layer.popup-basic.myaccount {\n    width: calc(100% - 24px);\n    margin-top: 49px;\n    height: auto;\n  }\n  .popup-basic.myaccount .popup__head {\n    flex-direction: column-reverse;\n    align-items: flex-start;\n    justify-content: space-between;\n    border-bottom: 0;\n  }\n  .popup-basic.myaccount .popup__head h1 {\n    margin-top: 4px;\n  }\n  .popup-basic.myaccount .popup__head .btn-close {\n    width: 100%;\n    background-position: right center;\n  }\n  .popup-basic.myaccount .popup__body {\n    padding: 20px 16px 20px;\n    width: calc(100% - 32px);\n    min-height: calc(75vh - 11.7rem);\n    max-height: calc(75vh - 10rem);\n  }\n  .popup-basic.myaccount .popup__body .form__input li {\n    margin-top: 16px;\n  }\n  .popup-basic.myaccount .popup__body .form__input label {\n    width: 100%;\n    font-size: 14px;\n  }\n  .popup-basic.myaccount .popup__body .form__input input[type=\"text\"],\n  .popup-basic.myaccount .popup__body .form__input input[type=\"password\"],\n  .popup-basic.myaccount .popup__body .form__input input[type=\"tel\"],\n  .popup-basic.myaccount .popup__body .form__input input[type=\"file\"] {\n    font-size: 14px;\n  }\n  .popup-basic.myaccount .input-errortxt {\n    font-size: 12px;\n  }\n  .popup-basic.myaccount .popup__body .form__input .btn-txt {\n    margin: 14px 0;\n  }\n  .popup-basic.myaccount .popup__body .form__input .btn-txt span {\n    font-weight: 500;\n    font-size: 15px;\n  }\n  .popup-basic.myaccount .popup__body .form__input .radioBox {\n    margin: 12px 0;\n  }\n  .popup-basic.myaccount .popup__body .form__input .checkBox {\n    margin: 26px 17px;\n  }\n  .popup-basic.myaccount .popup__footer {\n    padding: 16px 20px;\n    width: calc(100% - 40px);\n  }\n  .popup-basic.myaccount .popup__footer button.btn-txt {\n    width: auto;\n    margin-right: 80px;\n  }\n  .popup-basic.myaccount .popup__footer button.btn-txt span {\n    font-weight: 700;\n  }\n  /*헤더-My Account 팝업 내 비밀번호 변경 팝업*/\n  .popup-basic.myaccount.passchange .popup__head {\n    flex-direction: row;\n    padding-top: 28px;\n  }\n  .popup-basic.myaccount.passchange .popup__body {\n    min-height: calc(75vh - 5.8rem);\n  }\n}\n@media screen and (max-width: 530px) {\n  .popup-boxin .page-detail.w400 {\n    left: 10%;\n  }\n}\n@media screen and (max-width: 500px) {\n  .d-sm-none {\n    display: none !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .tbl-list table td.d-sm-block {\n    display: table-cell !important;\n  }\n  .status__data li {\n    margin-left: 5px;\n    width: calc(100% / 5);\n  }\n  .status__data li:first-child {\n    margin-left: 0;\n    width: calc(100% / 5);\n  }\n  .status__data li:last-child {\n    width: calc(100% / 3);\n  }\n  .status__data li:last-child a {\n    width: calc(100% - 4px);\n  }\n  .status__data li:last-child a:focus {\n    width: calc(100% - 4px);\n  }\n  .status__data li a:focus,\n  .status__data li a.on,\n  .status__data li a {\n    width: calc(100% - 4px);\n  }\n  .status__data li a {\n    height: 128px;\n  }\n  .status__data li a:focus {\n    height: calc(100% - 30px);\n  }\n  .status__data li a.on {\n    height: 126px;\n  }\n  .status__data li:before {\n    content: none;\n  }\n  .box__setting .form__input .input__area {\n    width: 100%;\n    margin-top: 8px;\n  }\n  .box__setting .form__input {\n    width: 94%;\n  }\n  .box__setting .form__input .input__area .select.active ul {\n    max-height: 150px;\n    overflow-y: auto;\n  }\n  .ehc__info {\n    margin: -1rem;\n    width: calc(100% - 2rem);\n  }\n  .ehc__detail {\n    margin-top: 3rem;\n    margin-bottom: 3rem;\n  }\n  .ehc__selectbtn {\n    margin: 0 0.188rem 50px;\n  }\n  .ehc__selectbtn button {\n    margin-left: 0.5rem;\n    max-width: 4rem;\n    height: 4rem;\n  }\n  .ehc__addfile {\n    margin-top: -2rem;\n  }\n  .ehc__rolling {\n    margin-bottom: 7rem;\n  }\n  .ehc__detail .ma__score .ehc__detail .ma__score .score__info li .tit {\n    font-size: 0.938rem;\n  }\n  .ehc__detail .ma__score .score__info li .tit {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .ehc__detail .ma__score .score__info li .tit span {\n    line-height: 1.4;\n  }\n  .score__info li .tit span + span {\n    margin-left: 0;\n  }\n  .score__info li.disabled .tit::after {\n    content: none;\n  }\n  .score__info li.disabled .tit span:first-child {\n    display: flex;\n    align-items: center;\n  }\n  .score__info li.disabled .tit span:first-child::after {\n    content: \"\";\n    width: 1rem;\n    height: 1rem;\n    margin-left: 4px;\n    background: url(../img/icon_disabled.png) no-repeat right center;\n  }\n  .ehc__detail .result__txt .tit {\n    width: 1.667rem;\n    height: auto;\n  }\n  .ehc__detail .result__txt .tit span {\n    position: absolute;\n    left: -99999px;\n    width: 0;\n    height: 0;\n    font-size: 0;\n    line-height: 0;\n    text-indent: -9999em;\n    overflow: hidden;\n    z-index: -1;\n  }\n  .ehc__detail .result__txt .txt {\n    line-height: 22px;\n    width: calc(100% - 148px);\n    word-break: break-all;\n    word-wrap: break-word;\n  }\n  .ehc__detail .result__txt .score {\n    font-size: 50px;\n    line-height: 60px;\n    margin: 0 20px 0 10px;\n  }\n  .result__txt {\n    align-items: center;\n    padding: 5px 22px 22px;\n    width: calc(100% - 12px);\n  }\n  .ma__score {\n    margin: 24px 0;\n  }\n  .ehc__chart {\n    margin: 3px 0px 0 2px;\n    width: calc(100% - 50px);\n    filter: drop-shadow(0px 2px 4px rgba(144, 159, 183, 0.3));\n  }\n  .score__info li {\n    padding: 14px 24px 20px;\n  }\n  .icon-score li {\n    padding: 0;\n  }\n  .icon-score li:nth-child(1) {\n    margin-right: 16px;\n    width: 33px;\n  }\n  .icon-score li:nth-child(7) {\n    margin-left: 16px;\n    width: 46px;\n  }\n  .tabcontent .tbl-list table {\n    border-bottom: 1px solid #dde2e9 !important;\n  }\n  .box__setting .popup__footer {\n    padding-bottom: 0;\n  }\n  .popup-boxin .page-detail.w400 {\n    left: 12%;\n    width: 358px;\n  }\n  .qr__top {\n    width: calc(100% - 40px);\n  }\n  .qr__box {\n    width: 304px;\n    height: 304px;\n    margin-bottom: 35px;\n  }\n  .tbl-list.hcal-96 table td .ellipsis,\n  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {\n    max-width: 290px !important;\n  }\n  .popup-boxin .page-detail {\n    left: 6%;\n    width: 88%;\n  }\n  .popup-boxin .page-detail .popup__body p.tit {\n    width: 100%;\n    margin-bottom: 8px;\n  }\n  .popup-boxin .page-detail .popup__body .form__input .input__area {\n    width: 100% !important;\n  }\n  .popup-boxin .popup__body .form__input .input-errortxt {\n    top: 42px;\n  }\n  .popup-layer.pop-smallsearch {\n    width: calc(100% - 24px);\n  }\n\n  .popup-basic.myaccount .form__input .select.active ul {\n    bottom: 40px;\n  }\n  .search__inline .filter {\n    width: 90px;\n  }\n\n  /* 요청반려 사유확인 팝업 */\n  .popup-basic.reason {\n    width: calc(100% - 2rem);\n    height: 400px;\n  }\n  .popup-basic.reason .popup__body {\n    height: 255px;\n  }\n  .nodata .nodata__txt.w800 {\n    padding: 40px 0 60px;\n  }\n\n  .content__info ul.form__input li .filelist li {\n    flex-direction: row;\n  }\n\n  /*진단점검 filter, search 팝업*/\n  .popup-layer.page-report {\n    width: 90%;\n  }\n\n  /* workorder-점검출동 팝업 */\n  .admin-site .area__left.only-depth2 + .area__right .page-loca {\n    margin-bottom: 12px;\n  }\n  .area__top {\n    padding: 0;\n    margin: 0 0 24px;\n    border: 0;\n  }\n  .area__top + h2 {\n    display: none;\n  }\n  .checkstatus-box + .tbl__top .right .searcharea input[type=\"text\"] {\n    width: calc(100% - 146px);\n  }\n  .checkstatus-box {\n    margin-bottom: 24px;\n  }\n\n  /*노후교체요청*/\n  .tabcontent .changeold .search {\n    display: none;\n  }\n  .changeold .filter {\n    display: block;\n    float: none;\n    border-right: 0;\n  }\n  .box.list .box__body .changeold .tbl__top .left .filter span {\n    display: block;\n    margin: 0;\n    font-weight: 700;\n    font-size: 16px;\n  }\n}\n@media screen and (max-width: 480px) {\n  .tbl-list.hcal-96 table td .ellipsis,\n  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {\n    max-width: 200px !important;\n  }\n}\n@media screen and (max-width: 499px) {\n  .navbar__toggleBtn {\n    margin-left: 0.625rem;\n  }\n}\n@media screen and (max-width: 414px) {\n  .navbar {\n    top: 100px;\n  }\n  .navbar__menu {\n    top: 100px;\n    height: calc(100% - 100px);\n  }\n  .ehc__info ul li span:first-child {\n    display: none;\n  }\n  .tbl__top {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n  .tbl__top .left {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n    width: 100%;\n  }\n  .tbl__top .right {\n    width: 100%;\n    align-items: flex-end;\n  }\n  .tbl__top .left + .right {\n    width: 100%;\n  }\n  .tbl__top .left + .right .searcharea {\n    justify-content: flex-end;\n  }\n  .tbl__top .select,\n  .tbl__top input[type=\"text\"] {\n    width: 100% !important;\n    height: 38px;\n  }\n  .tbl__top .searcharea .input__direct input[type=\"text\"] {\n    width: calc(100% - 54px) !important;\n  }\n  .tbl__top input[type=\"checkbox\"]:checked + label:after,\n  .tbl__top input[type=\"checkbox\"] + label:before {\n    width: 1.125rem;\n    height: 1.125rem;\n  }\n  .popup-boxin .page-detail.w400 {\n    left: 5%;\n    width: 358px;\n  }\n  .admin-site.layout-w3 .tbl-list table th,\n  .admin-site.layout-w3 .tbl-list table td {\n    padding: 8px;\n  }\n  .tbl-list table th.question span:after {\n    margin-left: 2px;\n  }\n  /*노후교체요청*/\n  .box.list .box__body .changeold .tbl__top {\n    flex-direction: row;\n    align-items: center;\n  }\n  .changeold .tbl__top .left + .right {\n    margin-top: 0;\n  }\n  .changeold .tbl__top .left {\n    width: auto;\n  }\n}\n@media screen and (max-width: 390px) {\n  .popup-boxin .page-detail.w400 {\n    left: 2%;\n  }\n  .status__data li p.name {\n    font-size: 13px;\n  }\n  .tbl-list.hcal-96 table td .ellipsis,\n  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {\n    max-width: 170px !important;\n  }\n}\n\n@media screen and (max-width: 360px) {\n  .tbl-list table td.checkdate:after {\n    margin-left: 5px;\n  }\n  .tbl__top input[type=\"text\"].d-sm-block-toggle.on + .btn-delete.active {\n    right: 58px;\n  }\n  .admin-site.layout-w3 .tbl-list table th,\n  .admin-site.layout-w3 .tbl-list table td {\n    padding: 8px 6px;\n  }\n  .tabcontent .detail__view .tbl-list table td button {\n    min-width: 66px;\n  }\n  /* .tabcontent .detail__view .tbl-list table td button span {\n    font-size: 13px;\n  } */\n\n  .nodata .nodata__txt.w800 {\n    padding: 20px 0 30px;\n  }\n\n  .tbl-list.hcal-96 table td .ellipsis,\n  .tbl-list.hcal-96 table td .ellipsis.wmax-140 {\n    max-width: 140px !important;\n  }\n  /* workorder-점검출동 팝업 */\n  .checkstatus-box li div a {\n    padding: 9px 6px;\n  }\n  .checkstatus-box li div p strong {\n    margin-right: 1px;\n    font-size: 20px;\n  }\n}\n@media screen and (max-width: 320px) {\n  .status__data li:last-child {\n    width: calc(100% / 4);\n  }\n  .status__data li:last-child a:focus {\n    width: 100%;\n  }\n  .status__data li p.name {\n    font-size: 12px;\n  }\n  .score__info li {\n    padding: 14px 15px 20px;\n  }\n  .icon-score li {\n    padding: 0;\n  }\n  .icon-score li:nth-child(1) {\n    margin-right: 10px;\n    width: 34px;\n  }\n  .icon-score li:nth-child(7) {\n    margin-left: 10px;\n    width: 47px;\n  }\n  input[type=\"checkbox\"] + label:before,\n  .tbl__top input[type=\"checkbox\"]:checked + label:after,\n  .tbl__top input[type=\"checkbox\"] + label:before {\n    top: 0.125rem;\n  }\n  .paging {\n    justify-content: center;\n    width: 100%;\n  }\n  .paging ul {\n    margin: 0;\n  }\n}\n\n/********************************************************* main 레이아웃 ******************************************************/\n.main .container {\n  margin: 116px 8px 5px 8px;\n  min-height: calc(100% - 224px);\n}\n.main .content-top {\n  position: fixed;\n  top: 50px;\n  left: 0;\n  width: 100%;\n  height: 56px;\n  background: #ffffff;\n  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.2);\n  z-index: 3;\n}\n.main .content-top .top-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 100%;\n  padding: 0 16px 0 22px;\n}\n.main .content-top .top-wrap .left {\n  display: flex;\n  align-items: center;\n  width: 80%;\n}\n.main .content-top .top-wrap .right {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n.main .content-top .top-wrap h2 {\n  display: flex;\n  font-weight: 700;\n  font-size: 22px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.main .content-top .top-wrap h2 span + span {\n  margin-left: 16px;\n  width: 200px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.main .btn-menuopen {\n  margin-left: 90px;\n  width: 30px;\n  height: 30px;\n  background: url(\"../img/icon_menuarrow.png\") no-repeat center center;\n}\n.main .btn-menuopen.active {\n  transform: rotate(180deg);\n}\n.main .content-top .top-wrap .right .btn-pin {\n  background: url(\"../img/icon_pin_big.png\") no-repeat center center;\n}\n.main .content-top .top-wrap .right .btn-pin.active {\n  background: url(\"../img/icon_pin_big_active.png\") no-repeat center center;\n}\n.main .content-top .top-wrap .right .btn-pin:hover::before {\n  top: 3px;\n  right: 26px;\n}\n.main .content-top .top-wrap .right .btn-edit {\n  position: relative;\n  width: 24px;\n  height: 24px;\n  background: url(\"../img/icon_pen_g.png\") no-repeat center center;\n}\n.main .content-top .top-wrap .right .btn-edit span {\n  display: none;\n}\n.main .content-top .top-wrap .right .btn-edit:hover::before {\n  content: \"카드 위치 편집\";\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 2px;\n  right: 26px;\n  width: 88px;\n  height: 18px;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  color: #fff;\n  background: #646c74;\n  border-radius: 10px;\n}\n.main .content-top .top-wrap .right .btn-edit.active:hover::before {\n  right: 55px;\n  top: 5px;\n}\n.main .content-top .top-wrap .right .btn-edit.active {\n  width: 48px;\n  height: 28px;\n  background: #0a78ff;\n  border-radius: 4px;\n}\n.main .content-top .top-wrap .right .btn-edit.active span {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 12px;\n  color: #fff;\n}\n.main .content-top .top-wrap .right button + button {\n  margin-left: 8px;\n}\n.content__dragwrap {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.main .content + .content {\n  margin-top: 0.5rem;\n}\n.main .content {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0;\n  grid-gap: unset;\n}\n.main .content > .box {\n  width: 100%;\n  height: 475px;\n}\n.main .content > .box + .box {\n  margin-left: 0.5rem;\n}\n.main .content > .box .box__header {\n  height: 45px;\n}\n.main .content > .box .box__header .box__etc {\n  display: flex;\n  align-items: center;\n}\n.main .content > .box .box__body {\n  padding: 33px 38px;\n  height: calc(100% - 112px);\n}\n.menu-slide {\n  opacity: 0;\n  visibility: hidden;\n  position: fixed;\n  top: 106px;\n  left: 0;\n  width: 414px;\n  height: calc(100vh - 122px);\n  padding: 16px 0 0 0;\n  z-index: 2;\n  background: #fff;\n  box-shadow: 0px 2px 10px #909fb7;\n}\n.menu-slide.open {\n  opacity: 1;\n  visibility: visible;\n  -webkit-transition: all 0.5s ease-in-out;\n  -moz-transition: all 0.5s ease-in-out;\n  transition: all 0.5s ease-in-out;\n}\n.menu-slide .lnb {\n  max-height: calc(100% - 40px);\n  overflow-y: auto;\n}\n.menu-slide .lnb__top {\n  border-bottom: 1px solid #dde2e9;\n}\n.menu-slide .lnb.nodata {\n  height: calc(100% - 56px);\n}\n.menu-slide .lnb.nodata .nodata_txt {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  font-size: 14px;\n  letter-spacing: -0.4px;\n  color: #909fb7;\n  line-height: 26px;\n}\n.menu-slide .lnb-depth1 > li:first-child {\n  border-top: 0;\n}\n.menu-slide .lnb-depth1 > li > p {\n  min-height: 58px;\n  padding: 0 16px 0 24px;\n  width: calc(100% - 40px);\n}\n.menu-slide .lnb-depth1 > li > p a {\n  width: calc(100% - 24px);\n}\n.menu-slide .lnb-depth1 > li.active p a {\n  font-weight: 700;\n}\n.menu-slide .lnb-depth1 > li.on p::before,\n.menu-slide .lnb-depth1 > li.active p::before {\n  min-height: 58px;\n}\n.btn-pin {\n  position: relative;\n  width: 24px;\n  height: 24px;\n  background: url(\"../img/icon_pin.png\") no-repeat center center;\n}\n.btn-pin.blue {\n  background: url(\"../img/icon_pin_active.png\") no-repeat center center;\n}\n/* .btn-pin:hover::before {\n  content: \"메인 대시보드 고정\";\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 1px;\n  right: 22px;\n  width: 109px;\n  height: 18px;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  color: #fff;\n  background: #646c74;\n  border-radius: 10px;\n} */\n\n/* 설비수명 */\n.tbl-list table td input[type=\"text\"] {\n  width: calc(100% - 1.625rem);\n  height: 1.875rem;\n  padding: 0 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #2a2c2f;\n  border: 1px solid #909fb7;\n  border-radius: 4px;\n}\n\n/* ehc work order */\n.content > .box .box__etc .btn-go {\n  width: 24px;\n  height: 24px;\n  margin: 0;\n  background: url(\"../img/icon_go_g.png\") no-repeat center center;\n  background-size: 100%;\n}\n\n/********************************************************* main 컨텐츠 ******************************************************/\n/* main 운영 현황 */\n.datalist li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #dde2e9;\n  padding: 10px 0;\n}\n.datalist li:first-child {\n  padding-top: 0;\n}\n.datalist li:last-child {\n  border-bottom: 0;\n}\n.datalist li p {\n  font-size: 15px;\n  letter-spacing: -0.4px;\n  color: #909fb7;\n}\n.datalist li p.tit {\n  display: flex;\n  align-items: center;\n  color: #2a2c2f;\n}\n.datalist li p strong {\n  font-weight: 500;\n  font-size: 24px;\n  color: #003876;\n}\n.datalist-small {\n  padding: 6px 2px 10px;\n}\n.datalist-small li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 0;\n  padding: 0 0 10px;\n}\n.datalist-small li p {\n  font-size: 13px;\n  letter-spacing: -0.4px;\n  color: #909fb7;\n}\n.datalist-small li p.tit {\n  color: #2a2c2f;\n  font-size: 14px;\n}\n.datalist-small li p strong {\n  font-size: 14px;\n  color: #2a2c2f;\n  font-weight: 500;\n}\n.main .box__body button.add__item {\n  border-radius: 4px;\n  width: 100%;\n  padding: 0 10px;\n  background: url(\"../img/icon_go3.png\") no-repeat 98% center #e7f2ff;\n  background-size: 20px 20px;\n}\n.main .box__body button.add__item span {\n  font-weight: 500;\n  font-size: 13px;\n  letter-spacing: -0.4px;\n  color: #0a78ff;\n}\n.main .box__body button.add__item span::before {\n  content: \"\";\n  margin-right: 10px;\n}\n\n/* main e-HC 진행률 */\n.main .box__body .top {\n  display: flex;\n  justify-content: space-between;\n}\n.main .box__body .top .right.inline {\n  width: auto;\n}\n.main .box__body .top.right {\n  justify-content: flex-end;\n}\n.main .box__body .top .txt {\n  font-size: 15px;\n  line-height: 14px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.main .box__body .small-tit {\n  font-size: 15px;\n  color: #2a2c2f;\n  letter-spacing: -0.05em;\n}\n.main .box__body .small-tit.icon-dot {\n  display: flex;\n}\n.main .box__body .small-tit.icon-dot::before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  border-radius: 50px;\n  background: #1492c6;\n  margin-right: 8px;\n  margin-top: 3px;\n}\n.main .box__body .total-num {\n  font-weight: 400;\n  font-size: 15px;\n  text-align: right;\n  color: #909fb7;\n  letter-spacing: -1px;\n}\n.main .box__body .total-num strong {\n  font-weight: 500;\n  font-size: 20px;\n  color: #2a2c2f;\n}\n.main .box__body .total-num strong.largetxt {\n  font-size: 36px;\n}\n.main .box__body .total-num span {\n  font-size: 18px;\n  margin-right: 2px;\n}\n.main .box__body .progress-wrap li {\n  display: flex;\n  align-items: center;\n  margin-bottom: 23px;\n}\n.main .box__body .progress-wrap li:last-child {\n  margin-bottom: 0;\n}\n.main .box__body .progress-wrap li p {\n  font-size: 14px;\n  color: #2a2c2f;\n}\n.main .box__body .progress-wrap li p strong {\n  font-weight: 500;\n  color: #2a2c2f;\n}\n.main .box__body .progress-wrap li .tit {\n  flex: 1.5;\n}\n.main .box__body .progress-wrap li .num {\n  flex: 1;\n  text-align: right;\n  color: #909fb7;\n}\n.main .box__body .progress-wrap li .progress-bar {\n  position: relative;\n  flex: 4;\n}\n.progress-bar::before {\n  content: \"0\";\n  position: absolute;\n  left: 0;\n  top: -12px;\n  font-size: 10px;\n  color: #909fb7;\n}\n.progress-bar::after {\n  content: \"100\";\n  position: absolute;\n  right: 0;\n  top: -12px;\n  font-size: 10px;\n  color: #909fb7;\n}\n.progress-bar {\n  width: 100%;\n  height: 10px;\n  background-color: #e6e9f0;\n  font-weight: 600;\n  font-size: 0.8rem;\n}\n.progress-bar .progress {\n  height: 10px;\n  padding: 0;\n  text-align: center;\n  background: linear-gradient(270deg, #116aac -7.8%, #1694c7 100%);\n  color: #111;\n}\n.progress-bar:hover .progress {\n  background: #1bc7e9;\n}\n.progress-wrap li .progress-bar .progress .num-detail {\n  display: none;\n}\n.progress-wrap li .progress-bar:hover .progress .num-detail {\n  display: block;\n  position: absolute;\n  top: -30px;\n  left: 30%;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 16px;\n  text-align: center;\n  color: #fff;\n  background: rgba(42, 44, 47, 0.9);\n  background-blend-mode: darken;\n  padding: 2px 3px;\n}\n.progress-bar:hover .progress .num-detail:after {\n  content: \"\";\n  position: absolute;\n  top: 20px;\n  left: 45%;\n  border-top: 5px solid rgba(42, 44, 47, 0.9);\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-bottom: 0px solid transparent;\n}\n.progress-circle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n.progress-circle .percent {\n  position: relative;\n}\n.progress-circle svg {\n  position: relative;\n  width: 120px;\n  height: 120px;\n  /*transform: rotate(-90deg);*/\n  transform: rotate(-0deg);\n}\n.progress-circle svg circle {\n  width: 100%;\n  height: 100%;\n  fill: none;\n  stroke: #f0f0f0;\n  stroke-width: 10;\n}\n.progress-circle svg circle:last-of-type {\n  /*   stroke-dasharray: 350px;\n  stroke-dashoffset: calc(350px - (350px * var(--percent)) / 100); */\n  stroke: #3498db;\n}\n.progress-circle .number {\n  position: absolute;\n  top: 54%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.progress-circle .number p {\n  font-weight: 500;\n  font-size: 32px;\n  color: #2a2c2f;\n  text-align: center;\n  line-height: 18px;\n}\n.progress-circle .number p span {\n  font-weight: 400;\n  font-size: 15px;\n  color: #909fb7;\n}\n.progress-circle .title h2 {\n  margin: 25px 0 0;\n}\n.progress-circle:nth-child(1) svg circle:last-of-type {\n  stroke: #0f5fa5;\n}\n.progresscircle-wrap .progress-circle:hover {\n  cursor: pointer;\n}\n.progresscircle-wrap .progress-circle:hover .number p {\n  font-weight: 700;\n}\n.progresscircle-wrap .progress-circle:hover .title h3 {\n  font-weight: 500;\n}\n\n/* main e-HC Status */\n.main .content > .box .box__header .select {\n  width: 158px;\n}\n.main .content > .box .box__body h2 {\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  margin-bottom: 12px;\n}\n.main .content > .box .box__body .txt-info {\n  font-size: 15px;\n  line-height: 14px;\n  letter-spacing: -1px;\n  color: #2a2c2f;\n  padding-left: 21px;\n  background: url(\"../img/icon_danger.png\") no-repeat 0 0;\n  background-size: 14px 14px;\n}\n.progresscircle-wrap {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n}\n.progresscircle-wrap .progress-circle svg {\n  width: 80px;\n  height: 80px;\n}\n.progresscircle-wrap .progress-circle svg circle {\n  stroke-width: 6;\n}\n/* .progresscircle-wrap .progress-circle svg circle:last-of-type {\n  stroke-dasharray: 220px;\n  stroke-dashoffset: calc(220px - (220px * var(--percent)) / 100);\n} */\n.progresscircle-wrap .progress-circle .number {\n  top: 50%;\n}\n.progresscircle-wrap .progress-circle .number p {\n  font-size: 22px;\n}\n.progresscircle-wrap .progress-circle .title h3 {\n  margin-top: 4px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.progresscircle-wrap .progress-circle .title h3 img {\n  vertical-align: top;\n  margin-right: 4px;\n  margin-top: 2px;\n}\n.progresscircle-wrap .progress-circle:last-child {\n  padding-left: 22px;\n  margin-left: 13px;\n  border-left: 1px solid #e6e9f0;\n}\n.main .content > .box .box__body .bottom.line {\n  border-top: 1px solid #dde2e9;\n  margin-top: 24px;\n  margin-left: -38px;\n  margin-right: -38px;\n  padding: 24px 38px 0;\n}\n.main .content > .box .box__body .step-order {\n  display: flex;\n  justify-content: space-between;\n}\n.main .content > .box .box__body .step-order li {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  flex: 1;\n  background: #fff;\n  height: 60px;\n  padding: 16px 30px 12px 14px;\n}\n.main .content > .box .box__body .step-order li:last-child {\n  background: none;\n}\n.main .content > .box .box__body .step-order li .tit {\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 14px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.main .content > .box .box__body .step-order li .total-num {\n  font-weight: 500;\n  font-size: 13px;\n}\n.main .content > .box .box__body .step-order li .total-num strong {\n  font-size: 26px;\n  color: #003876;\n}\n/* .main .content > .box .box__body .step-order li:hover {\n  background-color: #f0f2f4;\n  cursor: pointer;\n}\n.main .content > .box .box__body .step-order li:hover .tit {\n  font-weight: 700;\n} */\n\n/* main e-HC 평균 점수 */\n.main .box__body .ehc__info {\n  top: 0;\n  left: 0;\n  width: calc(100% - 32px);\n  height: 38px;\n  padding: 0 1rem;\n  align-items: center;\n}\n.main .box__body .ehc__info .ehc__name {\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.main .box__body .ehc__info .ehc__name::before {\n  content: \"\";\n  width: 16px;\n  height: 16px;\n  font-size: 13px;\n}\n.main .box__body .ehc-b .ehc__name::before {\n  content: \"B\";\n  background-color: #5b71ef;\n}\n.main .box__body .ehc-p .ehc__name::before {\n  content: \"P\";\n  background-color: #13a79e;\n}\n.main .box__body .ehc-a .ehc__name::before {\n  content: \"A\";\n  background-color: #ff9900;\n}\n.main .box__body .ehc-n .ehc__name::before {\n  content: \"N\";\n  background-color: #1fc95c;\n}\n.main .box__body .ehc__detail {\n  position: absolute;\n  left: 0;\n  top: 39px;\n  margin: 0;\n  width: 100%;\n  height: 76px;\n}\n.main .box__body .result__txt {\n  box-shadow: none;\n  width: calc(100% - 70px);\n  height: 76px;\n  padding: 0 32px 0;\n  margin: 0 0 0 6px;\n  display: flex;\n  align-items: center;\n}\n.main .box__body .ehc__detail .result__txt .tit {\n  font-size: 10px;\n  line-height: 10px;\n  color: #2a2c2f;\n  font-weight: 400;\n  padding-top: 24px;\n  margin-top: 0;\n  background: url(\"../img/icon_safety.png\") no-repeat top center;\n  background-size: 21px 21px;\n}\n.main .box__body .ehc__detail .result__txt .tit.caution {\n  padding-top: 24px;\n  margin-top: 0;\n  background: url(\"../img/icon_caution.png\") no-repeat top center;\n  background-size: 21px 21px;\n}\n.main .box__body .ehc__detail .result__txt .tit.danger {\n  padding-top: 24px;\n  margin-top: 0;\n  background: url(\"../img/icon_danger.png\") no-repeat top center;\n  background-size: 22px 22px;\n}\n.main .box__body .result__txt .btn-edit {\n  width: 32px;\n  height: 32px;\n  background: url(\"../img/icon_pen_w.png\") no-repeat center center #909fb7;\n  background-size: 1.125rem 1.124rem;\n}\n.main .box__body .ehc__detail .result__txt .score {\n  font-weight: 500;\n  font-size: 44px;\n  /* line-height: 30px; */\n  letter-spacing: -2px;\n  color: #2a2c2f;\n  margin: 0 24px 0 4px;\n}\n.main .box__body .ehc__detail .result__txt .txt {\n  width: calc(100% - 144px);\n  font-size: 15px;\n  line-height: 22px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  font-weight: 400;\n  margin: 0;\n}\n.main .box__body .bottom .ehc__chart {\n  filter: none;\n  padding: 0;\n  width: 100% !important;\n  height: 350px !important;\n  margin: 0;\n}\n.main .box__body .bottom .ehc__chart.h300 {\n  height: 300px !important;\n}\n.main .box__body .bottom.ehc__chart {\n  width: 100%;\n  height: calc(100% - 80px);\n  filter: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.main .box__body .bottom.ehc__chart .chart > div {\n  width: 100%;\n  height: 375px;\n}\n\n/* main 노후 교체 현황 */\n.main .content > .box .btn-go {\n  width: 24px;\n  height: 24px;\n  margin: 0;\n  background: url(\"../img/icon_go_g.png\") no-repeat center center;\n  background-size: 100%;\n}\n\n/* main e-HC 점수 현황 */\n.main .content > .box .box__body .tab__small {\n  position: absolute;\n  top: 33px;\n  left: 0;\n  width: 100%;\n  height: 32px;\n  border-bottom: 1px solid #dde2e9;\n  margin-bottom: 0;\n}\n.main .content > .box .box__body .tab__small li {\n  margin-left: 38px;\n}\n.main .content > .box .box__body .tab__small li + li {\n  border: 0;\n  padding: 0;\n  margin-left: 30px !important;\n}\n.main .content > .box .box__body .tab__small li a {\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 20px;\n  text-align: center;\n  letter-spacing: -0.4px;\n  color: #6b7891;\n  padding-bottom: 12px;\n  position: relative;\n}\n.main .content > .box .box__body .tab__small li a::before {\n  content: none;\n}\n.main .content > .box .box__body .tab__small li.on a,\n.main .content > .box .box__body .tab__small li:hover a {\n  font-weight: 700;\n  color: #2a2c2f;\n}\n.main .content > .box .box__body .tab__small li.on a:after,\n.main .content > .box .box__body .tab__small li:hover a:after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  border-bottom: 4px solid #5b71ef;\n}\n.main .content > .box .box__body .tab__small li:nth-child(2).on a:after,\n.main .content > .box .box__body .tab__small li:nth-child(2):hover a:after {\n  border-color: #13a79e;\n}\n.main .content > .box .box__body .tab__small li:nth-child(3).on a:after,\n.main .content > .box .box__body .tab__small li:nth-child(3):hover a:after {\n  border-color: #ff9900;\n}\n\n/* main 진단 점검 서비스 */\n.main .e-checkbox .buttonbox {\n  background: #fafafc;\n  height: 128px;\n  flex: 1;\n}\n.main .e-checkbox .buttonbox + .buttonbox {\n  margin-left: 4px;\n}\n.main .e-checkbox .top .buttonbox {\n  background: #fff;\n  height: 64px;\n  padding: 18px 18px 18px 12px;\n}\n.main .e-checkbox .top .buttonbox a {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n}\n.main .e-checkbox .top .buttonbox p {\n  display: flex;\n  flex-direction: column;\n  flex: 2.3;\n}\n.main .e-checkbox .top .buttonbox p span {\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.main .e-checkbox .top .buttonbox .tit {\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 14px;\n  letter-spacing: -1px;\n  color: #0a78ff;\n  margin-bottom: 12px;\n}\n.main .e-checkbox .top .buttonbox button {\n  flex: 1.2;\n  justify-content: flex-end;\n  border: 0;\n  width: 80px;\n  height: 30px;\n  padding: 0 13px 12px 0;\n  margin-bottom: 6px;\n  background: url(\"../img/icon_arrow_half.png\") no-repeat right bottom;\n  background-size: 80px 6px;\n}\n.main .e-checkbox .top .buttonbox:hover button,\n.main .e-checkbox .top .buttonbox:active button {\n  background: url(\"../img/icon_arrow_half_on.png\") no-repeat right bottom;\n  background-size: 80px 6px;\n}\n.main .e-checkbox .top .buttonbox button span {\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 20px;\n  letter-spacing: -1px;\n  color: #0f5fa5;\n}\n.main .e-checkbox .bottom {\n  display: flex;\n  flex-direction: column;\n  margin-top: 4px;\n}\n.main .e-checkbox .bottom li {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.main .e-checkbox .bottom li + li {\n  margin-top: 4px;\n}\n.main .e-checkbox .bottom .buttonbox a {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 12px 6px 20px 12px;\n  height: calc(100% - 32px);\n}\n.main .e-checkbox .bottom .buttonbox a div {\n  display: flex;\n  justify-content: space-between;\n}\n.main .e-checkbox .bottom .buttonbox a p {\n  display: flex;\n  flex-direction: column;\n}\n.main .e-checkbox .bottom .buttonbox a p span {\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 16px;\n  letter-spacing: -0.08em;\n  color: #2a2c2f;\n}\n.main .e-checkbox .bottom .buttonbox a p .tit {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n}\n.main .e-checkbox .buttonbox:hover,\n.main .e-checkbox .buttonbox:active {\n  background: #e7f2ff;\n}\n.main .e-checkbox .buttonbox .img-default {\n  display: block;\n}\n.main .e-checkbox .buttonbox .img-active {\n  display: none;\n}\n.main .e-checkbox .buttonbox:hover .img-default,\n.main .e-checkbox .buttonbox:active .img-default {\n  display: none;\n}\n.main .e-checkbox .buttonbox:hover .img-active,\n.main .e-checkbox .buttonbox:active .img-active {\n  display: block;\n}\n.main .e-checkbox .top .buttonbox:hover button span,\n.main .e-checkbox .top .buttonbox:active button span {\n  color: #0a78ff;\n}\n.main .e-checkbox .bottom .buttonbox:hover a p .tit,\n.main .e-checkbox .bottom .buttonbox:active a p .tit {\n  color: #003876;\n}\n\n/********************************************** main For small screen, main 레이아웃 반응형 **********************************************/\n@media screen and (max-width: 1810px) and (min-width: 1610px) {\n  .main .content > .box .box__body {\n    padding: 33px 16px;\n  }\n}\n@media screen and (max-width: 1609px) {\n  /*1609에서 탭화면으로 변경, 박스 2개*/\n  .main .content > .box .box__body {\n    padding: 33px 72px;\n  }\n  .main .box__body .progress-wrap li .progress-bar {\n    flex: 6;\n  }\n  .progress-circle {\n    flex: 1.7;\n  }\n  .progresscircle-wrap .progress-circle:last-child {\n    flex: 2;\n    margin-left: 30px;\n  }\n  .main .content > .box .box__body .tab__small li {\n    margin-left: 72px;\n  }\n  .main .box__body .result__txt {\n    padding: 0 72px;\n    width: calc(100% - 144px);\n  }\n  .main .content > .box .box__body .bottom.line {\n    margin-left: 0;\n    margin-right: 0;\n    padding: 24px 0 0;\n  }\n}\n@media screen and (max-width: 1140px) and (min-width: 965px) {\n  .main .content > .box .box__body {\n    padding: 33px 16px;\n  }\n  .main .content > .box .box__body .tab__small li {\n    margin-left: 16px;\n  }\n  .main .box__body .result__txt {\n    padding: 0 16px;\n    width: calc(100% - 32px);\n  }\n}\n@media screen and (max-width: 964px) {\n  /*964에서 모바일화면으로 변경, 박스 1개*/\n  .main .content > .box .box__body {\n    padding: 26px 56px;\n    height: calc(100% - 98px);\n  }\n  .main .content-top .top-wrap h2 {\n    font-size: 16px;\n  }\n  .main .box__body .result__txt {\n    padding: 0 56px;\n    width: calc(100% - 112px);\n  }\n  .main .content > .box .box__body .tab__small {\n    top: 20px;\n  }\n  .main .content > .box .box__body .tab__small li {\n    margin-left: 56px;\n  }\n  .datalist-small li p.tit {\n    font-size: 13px;\n  }\n  .main .content > .box .box__body .mt-32 {\n    margin-top: 0 !important;\n  }\n}\n@media screen and (max-width: 767px) {\n  .main .container {\n    margin-top: 166px;\n  }\n  .main .content-top {\n    top: 100px;\n  }\n  .main .content > .box {\n    height: auto;\n    min-height: 390px;\n  }\n  .datalist li {\n    padding: 5px 0;\n  }\n  .datalist-small {\n    padding: 6px 2px 12px;\n  }\n  .datalist-small li {\n    padding: 0 0 4px;\n  }\n  .menu-slide {\n    top: 156px;\n    width: 100%;\n    height: calc(100vh - 174px);\n  }\n  .menu-slide .lnb-depth1 > li.on p::before,\n  .menu-slide .lnb-depth1 > li.active p::before {\n    margin-left: -24px;\n  }\n  .menu-slide .lnb-depth1 > li > p span:first-child {\n    width: 130px;\n  }\n  .progress-wrap.mt-40 {\n    margin-top: 20px !important;\n  }\n  .main .box__body .progress-wrap li {\n    margin-bottom: 18px;\n  }\n  .progresscircle-wrap.mt-40 {\n    margin-top: 20px !important;\n  }\n  .main .content > .box .box__body .bottom.line.mt-50 {\n    margin-top: 20px !important;\n  }\n  .main .content > .box .box__body h2 {\n    margin-bottom: 0;\n  }\n  .main .content > .box .box__body .bottom.progress-wrap.mt-40 {\n    margin-top: 20px !important;\n  }\n  .main .content > .box .box__body .bottom.mt-40 {\n    margin-top: 40px !important;\n  }\n}\n@media screen and (max-width: 550px) {\n  .main .content > .box .box__body {\n    padding: 26px 16px;\n  }\n  .main .content > .box .box__body .bottom.line {\n    margin-left: -16px;\n    margin-right: -16px;\n    padding: 24px 16px 0;\n  }\n  .main .content > .box .box__body .tab__small li {\n    margin-left: 16px;\n  }\n  .main .box__body .result__txt {\n    padding: 0 16px;\n    width: calc(100% - 32px);\n  }\n}\n@media screen and (max-width: 500px) {\n  .main .content-top .top-wrap .left {\n    width: 70%;\n  }\n  .main .content-top .top-wrap .right .btn-edit:hover::before {\n    content: none;\n  }\n  .btn-pin:hover::before {\n    content: none;\n  }\n  .menu-slide .lnb-depth1 > li > p span:first-child {\n    width: 110px;\n  }\n  .menu-slide .lnb-depth1 > li p span:last-child,\n  .menu-slide .lnb-depth1 > li p span:last-child {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 40%;\n  }\n  .main .box__body .ehc__info {\n    display: none;\n  }\n  .main .box__body .ehc__detail {\n    top: 0;\n    height: 85px;\n  }\n  .main .box__body .result__txt {\n    height: 85px;\n  }\n  .progresscircle-wrap .progress-circle:last-child {\n    display: none;\n  }\n  .main .box__body .bottom .ehc__chart {\n    filter: none;\n    padding: 0;\n    width: 100%;\n    height: 370px;\n    margin: 0;\n  }\n}\n@media screen and (max-width: 499px) {\n  .main .content-top {\n    top: 91px;\n  }\n  .main .box__body .progress-wrap li .progress-bar {\n    flex: 4;\n  }\n  .main .content > .box .box__body .step-order li {\n    padding: 10px 20px 10px 14px;\n    background-position: right 53px;\n  }\n}\n@media screen and (max-width: 400px) {\n  .main .box__body .ehc__detail .result__txt .txt {\n    width: calc(100% - 140px);\n  }\n  .main .box__body .ehc__detail .result__txt .score {\n    margin-right: 20px;\n  }\n  .main .e-checkbox {\n    margin: 0 -10px 0;\n  }\n  .main .e-checkbox .top .buttonbox {\n    padding: 20px 5px 13px;\n  }\n  .main .e-checkbox .top .buttonbox button {\n    padding: 0 20px 20px 0;\n  }\n  .main .e-checkbox .top .buttonbox .tit {\n    font-size: 18px;\n  }\n  .main .e-checkbox .top .buttonbox p span {\n    font-size: 12px;\n    line-height: 16px;\n  }\n  .main .e-checkbox .top .buttonbox button span {\n    font-size: 18px;\n  }\n  .main .e-checkbox .bottom .buttonbox a p .tit {\n    font-size: 13px;\n  }\n  .main .e-checkbox .bottom .buttonbox a p span {\n    font-size: 10px;\n    line-height: 14px;\n  }\n}\n@media screen and (max-width: 320px) {\n  .main .box__body .total-num strong.largetxt {\n    font-size: 32px;\n  }\n  .main .box__body .progress-wrap li .progress-bar {\n    flex: 3;\n  }\n  .main .content > .box .box__header .select {\n    width: 130px;\n  }\n  .main .content > .box .box__body .step-order li {\n    padding: 10px 20px 10px 14px;\n    background-position: right 43px;\n    height: 50px;\n  }\n  .main .content > .box .box__body .step-order li .tit {\n    font-size: 14px;\n  }\n  .main .content > .box .box__body .step-order li .total-num strong {\n    font-size: 20px;\n  }\n  .main .box__body .total-num span {\n    font-size: 14px;\n  }\n  .main .box__body .ehc__detail .result__txt .txt {\n    font-size: 13px;\n    line-height: 1.2;\n  }\n}\n\n/********************************************************* 도움말 help-page ******************************************************/\n.help.content .box {\n  overflow-y: hidden;\n  position: relative;\n}\n.help.content .box .box-wrap .content-wrap {\n  overflow-y: auto;\n  height: calc(100vh - 115px);\n}\n.help .btn-filedown {\n  width: 156px;\n  height: 32px;\n  border: 0;\n  border-radius: 4px;\n  background: #fff;\n  position: absolute;\n  top: 7px;\n  right: 20px;\n}\n.btn-filedown.help span:before {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  margin-right: 8px;\n  background: url(\"../img/icon_filedown_b.png\") no-repeat left center;\n  background-size: 100%;\n}\n.btn-filedown.help span {\n  display: flex;\n  align-items: center;\n  font-weight: 700;\n  font-size: 15px;\n  letter-spacing: -0.8px;\n  color: #0a78ff;\n}\n.btn-filedown.help:hover,\n.btn-filedown.help:active {\n  background: #e7f2ff;\n}\n.help .lnb__top {\n  padding: 16px 8px 8px;\n}\n.help h2 {\n  font-weight: 700;\n  font-size: 25px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.help h3 {\n  margin-top: 24px;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.help h4 {\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  border-bottom: 1px solid #a4b0c4;\n  padding-bottom: 16px;\n}\n.help dl + dl {\n  margin-top: 16px;\n}\n.help dt {\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 20px;\n  letter-spacing: -0.004em;\n  color: #2a2c2f;\n  margin-bottom: 16px;\n}\n.help dd {\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 22px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.help dd + dd {\n  margin-top: 10px;\n}\n.img-wrap {\n  width: 100%;\n  height: auto;\n  background: #f7f7f7;\n  min-height: 440px;\n}\n.img-wrap img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.help .box__header {\n  padding: 32px 80px 24px;\n}\n.help .box__body {\n  padding: 56px 80px;\n}\n.help .box__body .cont {\n  margin-top: 16px;\n}\n.help .box__body .cont + h4 {\n  margin-top: 56px;\n}\n.help .box-wrap > .treebar.box {\n  border-right: 4px solid #dde2e9;\n  box-shadow: none;\n  border-radius: 0;\n  height: calc(100vh - 115px);\n  min-height: auto;\n}\n#wrap:not(.float-page, .no-responsive) .help .box-wrap .treebar.box {\n  width: 340px;\n}\n#wrap:not(.no-responsive) .help .treebar.box + .content-wrap {\n  width: calc(100% - 340px);\n}\n.help .lnb-depth1 > li:first-child {\n  border-top: 0;\n}\n.help .lnb-depth1 > li > p {\n  background: #fff;\n  padding: 0 24px;\n  width: calc(100% - 48px);\n}\n.help .lnb-depth1 > li.on p::before,\n.help .lnb-depth1 > li.active p::before {\n  content: none;\n}\n.help .lnb-depth1 > li > p > a {\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.help .box.treebar.pushy-menutype .lnb .lnb-depth1 > li > p > a:after {\n  content: none;\n}\n.help .box.treebar.pushy-menutype .lnb .lnb-depth1 > li > p a span {\n  max-width: unset;\n}\n.help .lnb-depth2 {\n  margin: 20px 0 21px 32px !important;\n}\n.help .box.treebar.pushy-menutype .lnb .lnb-depth2 > li:last-child {\n  border-bottom: 1px solid #dde2e9;\n}\n.help .box.treebar.pushy-menutype .lnb .lnb-depth2 > li > a {\n  background: #fff;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  padding: 0 20px;\n  min-height: 50px;\n  width: calc(100% - 40px);\n}\n.help .box.treebar.pushy-menutype .lnb .lnb-depth2 > li > a:after {\n  content: none;\n}\n.help .lnb-depth2 > li.active > a::before,\n.help .lnb-depth2 > li.on > a::before {\n  content: none;\n}\n.help .lnb-depth2 > li.active > a,\n.help .lnb-depth2 > li.on > a {\n  background: #0a78ff;\n  color: #fff;\n}\n@media screen and (max-width: 940px) {\n  #wrap:not(.no-responsive) .help .treebar.box + .content-wrap {\n    width: 100%;\n    height: auto;\n  }\n  #wrap:not(.no-responsive) .help .content-wrap .box__header {\n    padding: 20px;\n  }\n  .help .tab__line {\n    display: none;\n  }\n  #wrap:not(.float-page, .no-responsive) .help .box-wrap .treebar.box {\n    height: calc(100vh - 102px);\n    overflow-y: auto;\n  }\n  .help .btn-filedown {\n    position: relative;\n    top: unset;\n    right: unset;\n    margin-top: 10px;\n  }\n  .help .box.treebar.pushy-menutype .lnb {\n    overflow-y: unset;\n  }\n  .help .box__body {\n    padding: 40px 20px;\n  }\n  .help .img-wrap {\n    min-height: 244px;\n  }\n  .help h2 {\n    font-size: 20px;\n  }\n  .help h3 {\n    margin-top: 16px;\n    font-size: 15px;\n  }\n  .help h4 {\n    font-size: 15px;\n  }\n  .help dt {\n    font-size: 14px;\n  }\n  .help .lnb-depth2 > li > a,\n  .help .lnb-depth1 > li > p {\n    padding: 0 16px;\n    width: calc(100% - 32px);\n  }\n  .help .lnb-depth1 > li > p > a,\n  .help .lnb-depth2 > li > a {\n    font-size: 14px;\n  }\n}\n@media screen and (max-width: 499px) {\n  #wrap:not(.float-page, .no-responsive) .help .box-wrap .treebar.box {\n    top: 142px;\n    height: calc(100vh - 142px);\n  }\n  .help .lnb-depth1 {\n    padding: 16px 8px;\n  }\n  .help .lnb-depth1 > li > p > a,\n  .help .lnb-depth2 > li > a {\n    font-size: 15px;\n  }\n  .help .lnb-depth1 > li > p > a {\n    font-weight: 500;\n  }\n  .help .lnb-depth2 > li > a {\n    font-weight: 700;\n  }\n  .help .box__body {\n    padding: 20px;\n  }\n  .help .img-wrap {\n    min-height: 156px;\n  }\n  #wrap:not(.no-responsive, .float-page) .content.help {\n    padding-top: 50px;\n  }\n  #wrap:not(.no-responsive) .help .content-wrap .box__header {\n    padding: 60px 20px 20px 20px;\n  }\n  #wrap:not(.no-responsive) .help .content-wrap > div:first-child .box__header:first-child {\n    padding-top: 45px;\n  }\n}\n\n/********************************************************* 랜딩 randing ******************************************************/\n#wrap.randing .container {\n  min-height: calc(100vh - 50px);\n  margin: 50px 0 0;\n}\n#wrap.randing .content {\n  display: block;\n  width: 100%;\n  padding: 0;\n}\n#wrap.randing .content .content__title {\n  width: 100%;\n  height: 700px;\n  background: url(\"../img/randing_topbg.jpg\") no-repeat center center;\n  background-size: cover;\n}\n#wrap.randing .content .content__title .title-wrap {\n  max-width: 1200px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  margin: 0 auto;\n}\n#wrap.randing .content .content__title h1 {\n  margin-bottom: 34px;\n  margin-top: 3%;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 0;\n  letter-spacing: -1px;\n  color: #dde2e9;\n}\n#wrap.randing .content .content__title h1 img {\n  width: auto;\n  vertical-align: baseline;\n}\n#wrap.randing .content .content__title p.page-title {\n  width: 399px;\n  height: 42px;\n  margin-top: 0;\n  margin-bottom: 12px;\n}\n#wrap.randing .content .content__title p.page-title img {\n  width: 100%;\n  vertical-align: baseline;\n}\n#wrap.randing .content .content__title p {\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 26px;\n  letter-spacing: -0.4px;\n  color: #dde2e9;\n  margin-top: 24px;\n}\n#wrap.randing .content .content__title p + p {\n  margin-top: 4px;\n}\n#wrap.randing .content article section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #fff;\n  padding: 0 18%;\n  max-width: 1200px;\n  min-height: 580px;\n}\n#wrap.randing .content article section:nth-child(even) {\n  background: #f8fafc;\n}\n#wrap.randing .content article section .txt-wrap {\n  width: 50%;\n  padding-left: 95px;\n  padding-right: 120px;\n}\n#wrap.randing .content article section .txt-wrap h2 {\n  font-weight: 700;\n  font-size: 35px;\n  line-height: 44px;\n  letter-spacing: -0.02em;\n  color: #2a2c2f;\n  margin-bottom: 24px;\n}\n#wrap.randing .content article section .txt-wrap p {\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 35px;\n  letter-spacing: -0.8px;\n  color: #2a2c2f;\n}\n#wrap.randing .content article section.center {\n  flex-direction: column;\n  justify-content: flex-end;\n  height: 728px;\n  padding-bottom: 0 !important;\n}\n#wrap.randing .content article section.center .txt-wrap {\n  width: 100%;\n  text-align: center;\n  margin-bottom: 16px;\n}\n#wrap.randing .content article section.center .txt-wrap h2 {\n  margin-bottom: 16px;\n}\n#wrap.randing .content section.center .img-wrap {\n  width: 100%;\n}\n#wrap.randing .content section.center .img-wrap img {\n  width: 100%;\n}\n#wrap.randing .content .img-wrap {\n  background: transparent;\n  width: 50%;\n  min-height: auto;\n  text-align: right;\n}\n#wrap.randing .content .img-wrap.left {\n  text-align: left;\n}\n#wrap.randing .content .img-wrap img {\n  width: auto;\n  height: auto;\n  object-fit: contain;\n}\n#wrap.randing .content section.example {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  min-height: auto;\n  padding: 116px 18% 122px;\n}\n#wrap.randing .content article section.example .txt-wrap {\n  width: 100%;\n  padding: 0;\n}\n#wrap.randing .content article section.example .txt-wrap h2 {\n  margin-bottom: 8px;\n}\n#wrap.randing .content section.example ul {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  margin-top: 50px;\n}\n#wrap.randing .content section.example ul li {\n  width: 31%;\n  height: 530px;\n  background: url(\"../img/icon_go_circle.png\") no-repeat 93% 93% #fff;\n  border: 1px solid #dde2e9;\n}\n#wrap.randing .content section.example ul li .img-wrap {\n  width: 100%;\n}\n#wrap.randing .content section.example ul li .img-wrap img {\n  object-fit: cover;\n  width: 100%;\n}\n#wrap.randing .content section.example ul li .txt-wrap {\n  width: calc(100% - 48px);\n  padding: 32px 24px 40px;\n}\n#wrap.randing .content section.example ul li .txt-wrap h3 {\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 30px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n#wrap.randing .content section.example ul li .txt-wrap p {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 30px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  margin-top: 12px;\n}\n#wrap.randing .bottom-area {\n  padding: 80px;\n  font-weight: 700;\n  font-size: 35px;\n  line-height: 40px;\n  letter-spacing: -0.01em;\n  color: #ffffff;\n  text-align: center;\n  background: #2788fe;\n}\n\n@media screen and (max-width: 1600px) {\n  #wrap.randing .content .img-wrap img {\n    width: 100%;\n    object-fit: cover;\n  }\n  #wrap.randing .content article section,\n  #wrap.randing .content article section.center {\n    min-height: auto;\n    height: auto;\n    padding: 7% 15%;\n  }\n  #wrap.randing .content article section .txt-wrap {\n    padding: 0 5%;\n  }\n}\n@media screen and (max-width: 1400px) {\n  #wrap.randing .content .content__title .title-wrap {\n    margin: 0 10%;\n  }\n}\n@media screen and (max-width: 1200px) {\n  #wrap.randing .content article section,\n  #wrap.randing .content article section.center,\n  #wrap.randing .content section.example {\n    padding: 7% 10%;\n  }\n}\n@media screen and (max-width: 768px) {\n  #wrap.randing .content .content__title {\n    height: 460px;\n  }\n  #wrap.randing .content .content__title p {\n    font-size: 14px;\n    line-height: 20px;\n    margin-top: 32px;\n  }\n  #wrap.randing .content .content__title p + p {\n    margin-top: 8px;\n  }\n  #wrap.randing .content .content__title p.page-title {\n    height: 26px;\n    width: auto;\n  }\n  #wrap.randing .content .content__title p.page-title img {\n    height: 100%;\n  }\n  #wrap.randing .content .content__title img {\n    height: 26px;\n  }\n  #wrap.randing .content .content__title h1 {\n    font-size: 14px;\n    margin-top: 19%;\n    margin-bottom: 32px;\n  }\n  #wrap.randing .content .content__title h1 img {\n    height: 24px;\n  }\n  #wrap.randing .content article section {\n    flex-direction: column;\n  }\n  #wrap.randing .content article section .txt-wrap {\n    width: 90%;\n    padding: 0;\n  }\n  #wrap.randing .content article section .txt-wrap h2 {\n    font-size: 24px;\n    line-height: 40px;\n    margin-bottom: 16px;\n  }\n  #wrap.randing .content article section .txt-wrap p {\n    font-size: 18px;\n    line-height: 24px;\n  }\n  #wrap.randing .content .img-wrap {\n    width: 400px;\n  }\n  #wrap.randing .content article section,\n  #wrap.randing .content article section.center {\n    padding: 80px 10%;\n  }\n  #wrap.randing .content article section:not(.center) .txt-wrap + .img-wrap,\n  #wrap.randing .content article section:not(.center) .img-wrap + .txt-wrap {\n    margin-top: 40px;\n  }\n  #wrap.randing .content section.example {\n    display: none;\n  }\n  #wrap.randing .bottom-area {\n    font-size: 24px;\n    line-height: 32px;\n    padding: 64px 50px;\n  }\n}\n@media screen and (max-width: 767px) {\n  #wrap.randing .container {\n    min-height: calc(100vh - 100px);\n    margin: 100px 0 0;\n  }\n  #wrap.randing .content .content__title {\n    height: 420px;\n  }\n  #wrap.randing .content .content__title h1 {\n    margin-top: 17%;\n  }\n}\n@media screen and (max-width: 499px) {\n  #wrap.randing .container {\n    min-height: calc(100vh - 90px);\n    margin: 90px 0 0;\n  }\n}\n@media screen and (max-width: 414px) {\n  #wrap.randing .content article section .txt-wrap {\n    width: 100%;\n  }\n  #wrap.randing .content .img-wrap {\n    width: 100%;\n  }\n  #wrap.randing .content article section {\n    padding: 64px 10%;\n  }\n  #wrap.randing .content article section.center {\n    padding: 80px 7%;\n  }\n  #wrap.randing .content article section:nth-child(6),\n  #wrap.randing .content article section:nth-child(7) {\n    flex-direction: column-reverse;\n  }\n  #wrap.randing .content article section:nth-child(7) {\n    padding-bottom: 116px;\n  }\n  #wrap.randing .content article section:nth-child(6) .txt-wrap + .img-wrap,\n  #wrap.randing .content article section:nth-child(7) .txt-wrap + .img-wrap {\n    margin-top: 0;\n    margin-bottom: 40px;\n  }\n  #wrap.randing .content .content__title .title-wrap {\n    margin: 0 7%;\n  }\n}\n@media screen and (max-width: 360px) {\n  #wrap.randing .content .content__title img {\n    height: 22px;\n  }\n  #wrap.randing .content .content__title h1 img {\n    height: 18px;\n  }\n}\n\n/********************************************************* 소개 intro ******************************************************/\n#wrap.intro .container {\n  min-height: calc(100vh - 50px);\n  margin: 50px 0 0;\n}\n#wrap.intro .content {\n  display: block;\n  width: 100%;\n  padding: 0;\n}\n#wrap.intro .content .content__title {\n  width: 100%;\n  height: 296px;\n  background: url(\"../img/intro_topbg.jpg\") no-repeat center center;\n  background-size: cover;\n}\n#wrap.intro .content .content__title .title-wrap {\n  max-width: 1280px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  margin: 0 auto;\n}\n\n#wrap.intro .content .content__title img {\n  width: auto;\n  vertical-align: baseline;\n}\n#wrap.intro .content .content__title h1 {\n  margin-bottom: 24px;\n  margin-top: 5%;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 0;\n  letter-spacing: -1px;\n  color: #dde2e9;\n}\n#wrap.intro .content .content__title h1 img {\n  height: 24px;\n}\n#wrap.intro .content .content__title h2 {\n  font-weight: 700;\n  font-size: 25px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #fff;\n}\n#wrap.intro .content .content__title h2 img {\n  margin-right: 16px;\n  height: 26px;\n}\n#wrap.intro .content .content__title p {\n  font-size: 14px;\n  line-height: 24px;\n  font-weight: 300;\n  letter-spacing: -0.4px;\n  color: #dde2e9;\n  margin-top: 16px;\n}\n#wrap.intro .content .content__title p + p {\n  margin-top: 4px;\n}\n#wrap.intro .content article section {\n  margin: 80px auto;\n  background: #fff;\n  max-width: 1280px;\n}\n#wrap.intro .content article section + section {\n  margin-top: 0;\n}\n#wrap.intro .content article section h3 {\n  padding-bottom: 24px;\n  margin-bottom: 16px;\n  font-weight: 700;\n  font-size: 25px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  border-bottom: 1px solid #a4b0c4;\n}\n#wrap.intro .content article section .addmean {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: -0.004em;\n  color: #2a2c2f;\n}\n#wrap.intro .content article section .cont {\n  margin-top: 56px;\n}\n#wrap.intro .content article section .cont dl + dl {\n  margin-top: 24px;\n}\n#wrap.intro .content article section .cont dl dt {\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 20px;\n  letter-spacing: -0.004em;\n  color: #2a2c2f;\n}\n#wrap.intro .content article section .cont dl dt::before {\n  content: \"\";\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: #2a2c2f;\n}\n#wrap.intro .content article section .cont dl dd {\n  margin-top: 8px;\n  margin-left: 7px;\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 22px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n#wrap.intro .content article section .cont .img-wrap {\n  margin-top: 56px;\n  min-height: auto;\n}\n\n@media screen and (max-width: 1600px) {\n  #wrap.intro .content article section {\n    margin: 80px 17%;\n    width: calc(100% - 34%);\n    max-width: calc(100% - 34%);\n  }\n  #wrap.intro .content .content__title .title-wrap {\n    margin: 0 17%;\n    width: calc(100% - 34%);\n    max-width: calc(100% - 34%);\n  }\n}\n@media screen and (max-width: 1400px) {\n  #wrap.intro .content article section {\n    margin: 80px 10%;\n    width: calc(100% - 20%);\n    max-width: calc(100% - 20%);\n  }\n  #wrap.intro .content .content__title .title-wrap {\n    margin: 0 10%;\n    width: calc(100% - 20%);\n    max-width: calc(100% - 20%);\n  }\n}\n@media screen and (max-width: 768px) {\n  #wrap.intro .content article section {\n    margin: 64px 10%;\n  }\n  #wrap.intro .content article section .cont .img-wrap {\n    margin-top: 40px;\n  }\n  #wrap.intro .content article section .cont {\n    margin-top: 40px;\n  }\n}\n@media screen and (max-width: 767px) {\n  #wrap.intro .container {\n    min-height: calc(100vh - 100px);\n    margin: 100px 0 0;\n  }\n}\n@media screen and (max-width: 560px) {\n  #wrap.intro .content article section {\n    margin: 60px 10%;\n  }\n  #wrap.intro .content .content__title h2 img {\n    height: 22px;\n  }\n}\n@media screen and (max-width: 499px) {\n  #wrap.intro .container {\n    min-height: calc(100vh - 90px);\n    margin: 90px 0 0;\n  }\n  #wrap.intro .content .content__title {\n    display: none;\n  }\n}\n\n/*-------------------------------------------------------------LS MVP 3.0 e-HP-----------------------------------------------------------------*/\n\n/*오늘의 점검*/\n.content.wcal-296 {\n  width: calc(100% - 296px);\n}\n.content.wcal-296 > *:nth-child(1) {\n  flex: 1.8;\n}\n.content.wcal-296 > *:nth-child(2) {\n  flex: 1;\n}\n/* @media screen and (min-width: 1876px) {\n  .content.wcal-296 {\n    width: calc(100% - 296px);\n  }\n  .content.wcal-296 > *:nth-child(1) {\n    flex: 1.8;\n  }\n  .content.wcal-296 > *:nth-child(2) {\n    flex: 1;\n  }\n  .box.box-detailinfo {\n    margin-top: -16px;\n    margin-right: -16px;\n    margin-bottom: -8px;\n    border-radius: 0;\n    background: #f7f8fa;\n  }\n} */\n@media screen and (min-width: 941px) and (max-width: 1650px) {\n  .content.wcal-296 {\n    width: calc(100% - 280px);\n  }\n  .content.wcal-296 > *:nth-child(1) {\n    flex: 1;\n  }\n}\n@media screen and (max-width: 1650px) {\n  .lm-none {\n    display: none !important;\n  }\n  .lm-block {\n    display: block !important;\n  }\n  td.lm-block,\n  th.lm-block {\n    display: table-cell !important;\n  }\n}\n@media screen and (min-width: 1651px) {\n  .lm-block {\n    display: none !important;\n  }\n}\n@media screen and (max-width: 1500px) {\n  .sm-none {\n    display: none !important;\n  }\n  .sm-block {\n    display: block !important;\n  }\n  td.sm-block,\n  th.sm-block {\n    display: table-cell !important;\n  }\n}\n@media screen and (min-width: 1501px) {\n  .sm-block {\n    display: none !important;\n  }\n}\n@media screen and (min-width: 1201px) {\n  .xsm-none {\n    display: block !important;\n  }\n  button.xsm-none {\n    display: flex !important;\n  }\n}\n@media screen and (max-width: 1200px) {\n  .xsm-none {\n    display: none !important;\n  }\n  .xsm-block {\n    display: block !important;\n  }\n  button.xsm-block {\n    display: flex !important;\n  }\n}\n@media screen and (max-width: 940px) {\n  .content.wcal-296 {\n    width: 100%;\n  }\n  .m-none {\n    display: none !important;\n  }\n  .m-block {\n    display: block !important;\n  }\n  .m-flex {\n    display: flex !important;\n  }\n  td.m-block,\n  th.m-block {\n    display: table-cell !important;\n  }\n}\n@media screen and (min-width: 941px) {\n  .m-block,\n  .m-flex {\n    display: none !important;\n  }\n}\n\n/* 설비별 목록 */\n.tbl-select tr.selected td {\n  border-top: 2px solid #0a78ff;\n  border-bottom: 2px solid #0a78ff;\n  height: 36px;\n}\n.tbl-select tr.selected td:first-child {\n  border-left: 2px solid #0a78ff;\n}\n.tbl-select tr.selected td:last-child {\n  border-right: 2px solid #0a78ff;\n}\n.tbl-select.line-1 tr.selected td {\n  border-width: 1px;\n}\n.tbl-select.line-1 tr.selected td:first-child {\n  border-width: 1px;\n}\n.tbl-select.line-1 tr.selected td:last-child {\n  border-width: 1px;\n}\n.tbl-select tr.selected td button.bg-no.btn-basic {\n  background: #0978ff !important;\n}\n.tbl-select tr.selected td button.bg-no.btn-basic span,\n.tbl-select tr.selected td button.bg-no.btn-basic span.txt-gray {\n  color: #fff !important;\n}\n.tbl-select tr td:hover button.bg-no.btn-basic:not(:disabled):hover {\n  background: #0978ff !important;\n}\n.tbl-select tr td:hover button.bg-no.btn-basic:not(:disabled):hover span,\n.tbl-select tr.selected td button.bg-no.btn-basic:not(:disabled):hover span.txt-gray {\n  color: #fff !important;\n}\n.tbl__top .right .btn-add.tooltip-link:before {\n  left: auto;\n  right: 0;\n  width: 70px;\n}\n\n@media screen and (max-width: 940px) {\n  .tbl-select tr.selected td {\n    height: 52px;\n  }\n  .tbl-select:not(.tbl-border) tr.selected td {\n    border: 0 !important;\n  }\n  .tbl-select tr.selected td button.bg-no.btn-basic.wmax-90 {\n    max-width: 101px !important;\n  }\n}\n\n/* 설비상세정보 박스 */\n.box.box-detailinfo {\n  margin-top: -16px;\n  margin-right: -16px;\n  margin-bottom: -8px;\n  border-radius: 0;\n  background: #f7f8fa;\n}\n.box.box-detailinfo .box__header {\n  position: absolute;\n  width: calc(100% - 64px);\n  padding: 58px 32px 16px;\n  background: #2c364e;\n  border-bottom: 2px solid #dde2e9;\n  z-index: 1;\n}\n.box.box-detailinfo .box__header .box__title {\n  color: #fff;\n  background: url(\"../img/icon_sulbi_w.png\") no-repeat 0 center;\n  background-size: 24px 24px;\n  padding-left: 32px;\n}\n.box.box-detailinfo .box__header .box__title.bg-no {\n  background: none;\n  padding-left: 0;\n}\n.box.box-detailinfo .box__header .btn-close {\n  display: none;\n  background: url(\"../img/icon_close_w@3x.png\") no-repeat center center;\n  background-size: 100%;\n}\n.box.box-detailinfo .box__body {\n  position: absolute;\n  top: 96px;\n  padding: 16px 30px;\n  width: calc(100% - 60px);\n  max-height: calc(100% - 129px);\n  overflow-y: auto;\n}\n.box.box-detailinfo .box__body section {\n  background: #f7f8fa;\n  padding: 16px;\n}\n.box.box-detailinfo .box__body section + section {\n  margin-top: 16px;\n}\n.box.box-detailinfo .box__body section .section-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 14px;\n}\n.box.box-detailinfo .box__body section .section-top .right {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n.box.box-detailinfo .box__body section .section-top .tit {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 1.2;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.box.box-detailinfo .box__body section .section-top .tit .txt-info {\n  font-weight: 400;\n  font-size: 14px;\n  color: #7a8596;\n  margin-left: 8px;\n  letter-spacing: -0.7px;\n}\n.box.box-detailinfo .box__body section .section-top .btn {\n  width: 32px;\n  height: 32px;\n}\n.box.box-detailinfo .box__body section .section-bottom {\n  padding: 16px;\n  border-top: 2px solid #dde2e9;\n  border-bottom: 2px solid #dde2e9;\n  background: #fff;\n}\n.box.box-detailinfo .box__body section .section-bottom .tbl-list {\n  margin: -16px;\n}\n.box.box-detailinfo .box__body section .section-bottom .tbl-list table {\n  border-bottom: 0;\n}\n.box.box-detailinfo .box__body section .section-bottom .tbl-list th,\n.box.box-detailinfo .box__body section .section-bottom .tbl-list td {\n  padding: 10px 16px;\n  height: 28px;\n}\n.box.box-detailinfo .box__body section .section-bottom textarea:read-only {\n  width: 100%;\n  height: auto;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.7;\n  letter-spacing: -0.4px;\n  color: #000;\n  border: 0;\n  padding: 0;\n  background: #fff;\n}\n/* @media screen and (min-width: 1876px) {\n  .box.box-detailinfo .box__header {\n    position: absolute;\n    width: calc(100% - 64px);\n    padding: 58px 32px 16px;\n    background: #2c364e;\n    border-bottom: 2px solid #dde2e9;\n    z-index: 1;\n  }\n  .box.box-detailinfo .box__body {\n    position: absolute;\n    top: 96px;\n    padding: 16px 30px;\n    width: calc(100% - 60px);\n    max-height: calc(100% - 129px);\n    overflow-y: auto;\n  }\n} */\n@media screen and (max-width: 1650px) {\n  .box.box-detailinfo .box__header {\n    margin-top: -18px;\n  }\n  .box.box-detailinfo .box__header .btn-close {\n    display: block;\n    width: 32px;\n    height: 32px;\n    background: url(\"../img/icon_close_w@3x.png\") no-repeat center center;\n    background-size: 100%;\n  }\n  .box.box-detailinfo.m-hidden {\n    display: none;\n  }\n  .box.box-detailinfo {\n    height: 100vh;\n    margin: 0;\n  }\n}\n@media screen and (min-width: 500px) and (max-width: 1650px) {\n  /* .box.box-detailinfo .box__header,\n  .box.box-detailinfo .box__body {\n    position: relative;\n    top: unset;\n  } */\n  .box.box-detailinfo {\n    box-shadow: 0px 10px 30px rgba(42, 44, 47, 0.5);\n  }\n}\n@media screen and (min-width: 640px) and (max-width: 1650px) {\n  .box.box-detailinfo {\n    width: 640px;\n  }\n}\n@media screen and (max-width: 639px) {\n  .box.box-detailinfo {\n    width: 100%;\n    margin: 0;\n  }\n}\n@media screen and (max-width: 499px) {\n  .box.box-detailinfo {\n    width: 100% !important;\n  }\n  .box.box-detailinfo .box__body {\n    padding: 16px 4px;\n    width: calc(100% - 8px);\n    overflow-x: hidden;\n  }\n}\n\n/* 설비상세정보 박스 - 설비정보*/\n.box.box-detailinfo .box__body section .section-bottom .btn-open {\n  height: 40px;\n  width: calc(100% + 32px);\n  margin-top: 16px;\n  margin-bottom: -16px;\n  margin-left: -16px;\n  background: #f7f8fa;\n}\n.box.box-detailinfo .box__body section .section-bottom .btn-open:before {\n  content: \"\";\n  width: 12px;\n  height: 12px;\n  margin-right: 8px;\n  background: url(\"../img/icon_arrow_bottom_b.png\") no-repeat center center;\n  background-size: 100%;\n}\n.box.box-detailinfo .box__body section .section-bottom .btn-open span {\n  font-weight: 400;\n  font-size: 14px;\n  color: #0a78ff;\n}\n.box.box-detailinfo .box__body section .section-bottom .btn-open.close:before {\n  transform: scaleY(-1);\n}\n.box.box-detailinfo .box__body section .section-bottom .tbl-list.fold-list {\n  height: 245px;\n  overflow-y: hidden;\n}\n.box.box-detailinfo .box__body section .section-bottom .tbl-list.fold-list.open {\n  height: auto;\n  overflow-y: auto;\n}\n\n/* 설비상세정보 박스 - reports*/\n.box.box-detailinfo .box__body section .section-top .btn.btn-more {\n  width: auto;\n  height: auto;\n}\n.box.box-detailinfo .box__body section .section-top .btn-more:after {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  margin-left: 4px;\n  background: url(\"../img/icon_arrow_left@3x.png\") no-repeat center center;\n  background-size: 100%;\n  transform: scaleX(-1);\n}\n.box.box-detailinfo .box__body section .section-top .btn-more span {\n  font-weight: 400;\n  font-size: 14px;\n  color: #0a78ff;\n}\n.box.box-detailinfo .box__body section .section-bottom .tbl-list .filelist {\n  margin: 0;\n}\n.box.box-detailinfo .box__body section .section-bottom .tbl-list .filelist li span {\n  color: #2a2c2f;\n  font-size: 14px;\n  padding-left: 20px;\n  line-height: 1.2;\n  background-size: 9px 17px;\n}\n.box.box-detailinfo .box__body section .section-bottom .tbl-list .filelist li.no-file span {\n  background: none;\n}\n\n/* 설비상세정보 박스 -  진단점검 평균점수 */\n.box.box-detailinfo .box__body section .section-top .date {\n  color: #7a8596;\n  font-weight: 400;\n  font-size: 14px;\n}\n\n/* 설비상세정보 박스 -  진단점검 Trend */\n.box.box-detailinfo .box__body section .section-top .select {\n  width: auto;\n  height: auto;\n  color: #0a78ff;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: -0.7px;\n  border: 0;\n  border-radius: 0;\n}\n.box.box-detailinfo .box__body section .section-top .select .selected .arrow {\n  width: 20px;\n  height: 20px;\n  margin-left: 4px;\n  background: url(\"../img/icon_arrow_left@3x.png\") no-repeat center center;\n  background-size: 100%;\n  transform: rotate(-90deg);\n}\n.box.box-detailinfo .box__body section .section-top .select.active .selected .arrow {\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_arrow_left@3x.png\") no-repeat center center;\n  background-size: 100%;\n  transform: rotate(90deg);\n}\n\n/* 설비상세정보 박스 - 진단점검 */\n.color-info {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n.color-info p {\n  display: flex;\n  align-items: center;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.color-info p:before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #0f5fa5;\n  margin-right: 8px;\n}\n.color-info .ehc::before {\n  background: #0f5fa5;\n}\n.color-info .jig::before {\n  background: #00dacd;\n}\n.color-info .etc::before {\n  background: #ff9900;\n}\n.color-info .memo::before {\n  background: #d3b59a;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow {\n  position: relative;\n  padding: 0;\n  border: 0;\n  box-shadow: 1px 1px 12px rgba(144, 159, 183, 0.5);\n  border-radius: 6px;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 4px;\n  height: 100%;\n  background: #0f5fa5;\n  border-radius: 4px 0 0 4px;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow.ehc::before {\n  content: \"\";\n  background: #0f5fa5;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow.jig::before {\n  content: \"\";\n  background: #00dacd;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow.etc::before {\n  content: \"\";\n  background: #ff9900;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow + .box-shadow {\n  margin-top: 8px;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow .title {\n  display: flex;\n  align-items: center;\n  width: calc(100% - 34px);\n  padding: 0 14px 0 20px;\n  height: 60px;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow .title a {\n  flex: 3;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 5px;\n  width: 100%;\n  height: 100%;\n  margin-right: 10px;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow .title a p {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 1.3;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow .title a p:first-child {\n  width: calc(100% - 109px);\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow .title a p.date {\n  font-weight: 400;\n  padding-left: 23px;\n  background: url(\"../img/icon_calendar_b.png\") no-repeat 0 center;\n  background-size: 16px 16px;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow .title .btn {\n  height: 32px;\n  padding: 0 20px;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow .title .btn span {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  letter-spacing: -0.4px;\n  color: #0a78ff;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow .title .btn:hover {\n  background: #0978ff;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow .title .btn:hover span {\n  color: #fff;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow .title .btn.btn-etc {\n  position: relative;\n  padding: 0;\n}\n.btn.btn-etc {\n  width: 32px;\n  height: 32px;\n  background: url(\"../img/icon_etc.png\") no-repeat center center transparent !important;\n  background-size: 100% !important;\n}\n\n/*데이터없는경우*/\n.box.box-detailinfo .nodata .nodata__txt {\n  height: 100%;\n  margin: 20px auto;\n}\n.float-page .nodata .nodata__txt {\n  height: 100%;\n  margin: 20px auto;\n}\n.nodata .nodata__txt {\n  margin: 20px auto;\n}\n.nodata .tbl-list {\n  border: 0;\n  display: block;\n}\n.nodata .tbl-list table {\n  display: none;\n}\n.nodata .tbl-list .nodata__txt {\n  margin: 0 auto;\n}\n.popup__body .nodata .tbl-list .nodata__txt {\n  height: 100%;\n}\n\n/*btn-etc 클릭시 수정삭제팝업*/\n.popup-etc {\n  display: none;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 88px;\n  height: auto;\n  position: absolute;\n  top: 45px;\n  right: -15px;\n  background: #fff;\n  border-radius: 4px;\n  filter: drop-shadow(0px 8px 12px rgba(122, 133, 150, 0.5));\n  z-index: 2;\n}\n.popup-etc.open {\n  display: flex;\n}\n.popup-etc li {\n  width: 100%;\n  flex: 1;\n}\n.popup-etc li button {\n  width: 100% !important;\n  height: 100% !important;\n  border: 0 !important;\n  background-size: 28%;\n  background-position: 12px center;\n  padding: 4px 0 3px 20px;\n}\n.popup-etc li button span {\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 1.8;\n  letter-spacing: -0.004em;\n  color: #19181a;\n}\n.popup-etc li button:focus {\n  background-color: #b4d2ff;\n  border-radius: 0;\n}\n.popup-etc li button.btn-edit-g:focus {\n  background: url(\"../img/icon_pen_blue.png\") no-repeat 12px center #b4d2ff;\n  background-size: 24px;\n}\n.popup-etc li button.btn-delete-gr:focus {\n  background: url(\"../img/icon_delete_blue.png\") no-repeat 12px center #b4d2ff;\n  background-size: 24px;\n}\n.popup-etc li button:focus span {\n  font-weight: 700;\n  color: #0a78ff;\n}\n.popup-etc li button:focus:hover {\n  background-color: #b4d2ff;\n}\n.popup-etc li button:hover {\n  background-color: #e6f0ff;\n  border-radius: 0;\n}\n.popup-etc li:first-child button:hover,\n.popup-etc li:first-child button:focus {\n  border-radius: 4px 4px 0 0;\n}\n.popup-etc li:last-child button:hover,\n.popup-etc li:last-child button:focus {\n  border-radius: 0 0 4px 4px;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow .cont {\n  display: none;\n  border-top: 2px solid #dde2e9;\n  padding: 32px 48px;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow .cont.open {\n  display: block;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow .cont li + li {\n  border-top: 1px solid #dde2e9;\n  padding-top: 24px;\n  margin-top: 24px;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow .cont li {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow .cont li p {\n  display: flex;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow .cont li p span {\n  font-size: 14px;\n  line-height: 1.5;\n  letter-spacing: -0.004em;\n  font-weight: 400;\n  color: #2a2c2f;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow .cont li p span:nth-child(1) {\n  flex: 1;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow .cont li p span:nth-child(2) {\n  font-weight: 500;\n  color: #000;\n  flex: 2;\n}\n\n@media screen and (max-width: 940px) {\n  .box.box-detailinfo .box__body section .section-bottom.box-shadow .title a p.date {\n    margin-left: 0;\n  }\n}\n\n/* 설비상세정보 박스 - 진단점검 : 데이터 없는 경우*/\n.box.box-detailinfo .box__body section .section-bottom.box-shadow.no-data {\n  box-shadow: none;\n  border-radius: 4px;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow.no-data::before {\n  content: none;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow.no-data::before {\n  content: none;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow.no-data .title {\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  padding: 14px 10px 14px 24px;\n  height: auto;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow.no-data .title a {\n  width: auto;\n  flex: unset;\n  margin: 0;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow.no-data .title a p {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.4;\n  color: #7a8596;\n  width: 100%;\n}\n.box.box-detailinfo .box__body section .section-bottom.box-shadow.no-data .title .flex-inline.right {\n  width: auto !important;\n}\n@media screen and (max-width: 940px) {\n  .box.box-detailinfo .box__body section .section-bottom.box-shadow.no-data .title {\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    gap: 14px;\n    height: auto;\n    padding: 23px 14px 17px 20px;\n  }\n  .box.box-detailinfo .box__body section .section-bottom.box-shadow.no-data .title a {\n    height: auto;\n    width: 100%;\n  }\n  .box.box-detailinfo .box__body section .section-bottom.box-shadow.no-data .title .flex-inline.right {\n    width: 100% !important;\n  }\n}\n\n/* 일정별 - 왼쪽 */\n.body-left {\n  background: #f7f8fa;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 340px;\n}\n@media screen and (min-width: 1651px) and (max-width: 1820px) {\n  .content.wcal-296 .box__body .flex-row.m-m24 {\n    flex-direction: column !important;\n  }\n  .body-left {\n    flex: 1;\n    width: calc(100% - 32px);\n    flex-direction: row;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .content.wcal-296 .box__body .flex-row.m-m24 {\n    flex-direction: column !important;\n  }\n}\n@media screen and (min-width: 941px) and (max-width: 1280px) {\n  .body-left {\n    flex: 1;\n    width: calc(100% - 32px);\n    flex-direction: row;\n    gap: 16px;\n  }\n}\n@media screen and (max-width: 940px) {\n  .body-left {\n    flex-direction: column;\n    width: 100%;\n    padding: 0 0 18px 0;\n    gap: 18px;\n  }\n}\n\n/* 일정별 - 캘린더 */\n.left-top {\n  height: 370px;\n  background: #fff;\n  padding: 24px 16px;\n  width: calc(100% - 32px);\n}\n.left-top .calendar-area {\n  display: flex;\n  justify-content: center;\n  /* height: calc(100% - 36px); */\n}\n.left-top .color-info {\n  justify-content: flex-end;\n  /* margin-top: 24px; */\n  margin-right: 9px;\n}\n.calendar-area .css-1cafy48-MuiPickersSlideTransition-root-MuiDayCalendar-slideTransition > * {\n  display: grid !important;\n  grid-gap: 9px 0 !important;\n}\n.css-12p2adl-MuiDayCalendar-monthContainer {\n  overflow: unset !important;\n}\n.MuiPickersLayout-actionBar {\n  width: fit-content !important;\n  height: fit-content !important;\n  left: 65% !important;\n  padding: 0 !important;\n  grid-column: none !important;\n  grid-row: none !important;\n  top: -5px !important;\n  color: #0978ff !important;\n}\n.left-top .MuiPickersLayout-actionBar {\n  left: 60% !important;\n  top: 0px !important;\n}\n.css-16ac5r2-MuiButtonBase-root-MuiListItemButton-root:hover,\n.css-1uwabd6:hover {\n  background-color: transparent !important;\n}\n.calendar-area .css-flbe84-MuiDayCalendar-weekContainer,\n.calendar-area .MuiDayCalendar-weekContainer {\n  align-items: center !important;\n}\n.calendar-area .MuiButtonBase-root-MuiPickersDay-root,\n.calendar-area .css-ga06f9-MuiButtonBase-root-MuiPickersDay-root {\n  width: 28px !important;\n  height: 28px !important;\n  color: #2a2c2f !important;\n  font-size: 0.875rem !important;\n}\n.calendar-area .MuiButtonBase-root.MuiPickersDay-root.Mui-selected {\n  width: 28px !important;\n  height: 28px !important;\n  font-size: 0.875rem !important;\n  letter-spacing: -0.3px !important;\n  background: #0a78ff !important;\n  color: #fff !important;\n  font-weight: 700 !important;\n}\n.calendar-area .css-10dddir-MuiPickersLayout-root .MuiPickersLayout-actionBar {\n  grid-column: none !important;\n  grid-row: none !important;\n}\n.calendar-area .MuiButtonBase-root-MuiPickersDay-root:not(.Mui-selected),\n.calendar-area .css-byu9xf-MuiButtonBase-root-MuiPickersDay-root:not(.Mui-selected) {\n  width: 28px !important;\n  height: 28px !important;\n  font-size: 0.875rem !important;\n  font-weight: 700 !important;\n  color: #0978ff !important;\n  border: 0 !important;\n  background: none !important;\n}\n.calendar-area .css-7oawqu-MuiButtonBase-root-MuiPickersDay-root:not(.Mui-selected) {\n  border: 0 !important;\n}\n.calendar-area .css-rhmlg1-MuiTypography-root-MuiDayCalendar-weekDayLabel {\n  height: 25px !important;\n  font-size: 0.875rem !important;\n  color: #909fb7 !important;\n}\n.calendar-area .css-vrdxij-MuiPickersLayout-root {\n  width: 100% !important;\n  min-width: 100% !important;\n}\n.left-top .calendar-area .css-cwhad8-MuiDateCalendar-root {\n  width: 100% !important;\n}\n.calendar-area .css-rhmlg1-MuiTypography-root-MuiDayCalendar-weekDayLabel {\n  width: calc(100% / 7) !important;\n}\n.calendar-area .css-jz75aw-MuiBadge-root {\n  width: calc(100% / 7) !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n.calendar-area .css-1qs309j-MuiButtonBase-root-MuiPickersDay-root {\n  width: 100% !important;\n}\n.calendar-area .css-yav00v-MuiPickersLayout-root {\n  min-width: 100% !important;\n}\n.calendar-area .css-dplwbx-MuiPickersCalendarHeader-label {\n  font-family: \"NotoSansKR\", sans-serif !important;\n  font-weight: 500 !important;\n  font-size: 16px !important;\n  line-height: 1.4 !important;\n  letter-spacing: -0.32px !important;\n  color: #2a2c2f !important;\n}\n.calendar-area .css-16snd-MuiPickersLayout-root .MuiPickersLayout-actionBar {\n  padding: 0 !important;\n}\n.calendar-area .css-16ac5r2-MuiButtonBase-root-MuiListItemButton-root,\n.calendar-area .css-1uwabd6 {\n  padding: 0 !important;\n  text-align: center !important;\n}\n.calendar-area .css-10hburv-MuiTypography-root,\n.calendar-area .css-yb0lig {\n  font-family: \"NotoSansKR\", sans-serif !important;\n  font-weight: 400 !important;\n  font-size: 14px !important;\n  line-height: 1.4 !important;\n  letter-spacing: -0.4px !important;\n  color: #0978ff !important;\n}\n.left-top .calendar-area .css-nk89i7-MuiPickersCalendarHeader-root {\n  margin-top: 5px !important;\n  margin-bottom: 20px !important;\n  padding-left: 16px !important;\n  padding-right: 8px !important;\n}\n.calendar-area .css-6kkttg-MuiPickersLayout-root .MuiPickersLayout-actionBar {\n  padding: 0 !important;\n  display: flex !important;\n}\n.calendar-area button:hover {\n  background: none !important;\n}\n.calendar-area button.css-1beqopj-MuiPickersYear-yearButton.Mui-selected:hover {\n  background: #0978ff !important;\n}\n.calendar-area .css-1beqopj-MuiPickersYear-yearButton.Mui-selected {\n  background: #0978ff !important;\n}\n.calendar-area .css-1cafy48-MuiPickersSlideTransition-root-MuiDayCalendar-slideTransition {\n  display: block !important;\n  position: relative !important;\n  overflow-x: hidden !important;\n  min-height: 280px !important;\n}\n\n@media screen and (min-width: 1651px) and (max-width: 1820px) {\n  .left-top {\n    flex: 1;\n  }\n  .left-bottom {\n    flex: 1;\n  }\n}\n@media screen and (min-width: 941px) and (max-width: 1280px) {\n  .left-top {\n    flex: 1;\n  }\n  .left-bottom {\n    flex: 1;\n  }\n}\n@media screen and (max-width: 940px) {\n  .left-top {\n    flex: auto;\n    padding: 24px 20px;\n  }\n  .left-bottom {\n    flex: auto;\n    height: auto;\n  }\n  .left-bottom.m-h200 {\n    height: 200px;\n  }\n}\n\n/* 일정별 - 탭영역 */\n.left-bottom {\n  height: 418px;\n  background: #fff;\n}\n.tab__box {\n  display: flex;\n}\n.tab__box li {\n  flex: 1;\n  height: 40px;\n  display: flex;\n  align-items: center;\n}\n.tab__box li a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1.2;\n  letter-spacing: -0.4px;\n  color: #646c74;\n  background: #f7f8fa;\n  border-bottom: 1px solid #dde2e9;\n}\n.tab__box li.on a {\n  font-weight: 700;\n  color: #0978ff;\n  background: #fff;\n  border-bottom: 1px solid #fff;\n  border-left: 1px solid #dde2e9;\n  border-right: 1px solid #dde2e9;\n}\n.tab__box li:first-child.on a {\n  border-left: 0;\n}\n.tab__box li:last-child.on a {\n  border-right: 0;\n}\n.tabbox-cont {\n  height: 378px;\n}\n@media screen and (max-width: 940px) {\n  #wrap:not(.no-responsive) .tab__box li a {\n    font-size: 16px;\n  }\n  #wrap:not(.no-responsive) .tabbox-cont {\n    height: 211px;\n  }\n}\n\n/* 일정별 - 탭영역 - 메모 */\n.tabbox-cont .cont-memo {\n  padding: 8px 16px 16px;\n  height: calc(100% - 24px);\n}\n.tabbox-cont .cont-memo .memo-top {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-bottom: 8px;\n}\n.tabbox-cont .cont-memo .memo-top .btn {\n  width: 32px;\n  height: 32px;\n}\n.tabbox-cont .cont-memo .memo-top .btn + .btn {\n  margin-left: 4px;\n}\n.tabbox-cont .cont-memo .memo-box {\n  display: flex;\n  justify-content: flex-end;\n  height: calc(100% - 40px);\n  overflow-y: auto;\n}\n.tabbox-cont .cont-memo .memo-box textarea:read-only {\n  width: 100%;\n  height: 100%;\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 2.1;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  border: 0;\n  padding: 0;\n  background: #fff;\n}\n.tabbox-cont .cont-memo .memo-box p {\n  width: 100%;\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 2.1;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.tabbox-cont .cont-memo.nodata .memo-box {\n  display: none;\n}\n.tabbox-cont .cont-memo.nodata .nodata__txt {\n  margin: 0 auto;\n  height: auto;\n}\n/* 일정별 - 탭영역 - 월별일정,미이행항목 */\n.tabbox-cont .cont-tbl {\n  height: 100%;\n  overflow-y: auto;\n}\n.tbl-list:not(.row) tr:hover td,\n.tbl-list:not(.row) tbody tr:nth-child(even):hover td {\n  background: #e6f0ff;\n}\n.tbl-list:not(.row) tr:active td,\n.tbl-list:not(.row) tbody tr:nth-child(even):active td {\n  background: #b4d2ff;\n}\n\n.tabbox-cont .cont-tbl .tbl-list td {\n  padding: 0 4px;\n  height: 54px;\n  text-align: center;\n  margin: 0 auto;\n  border-bottom: 1px solid #dde2e9;\n  cursor: pointer;\n}\n.tabbox-cont .cont-tbl .tbl-list table td .ellipsis {\n  width: 90px;\n  margin: 0 auto;\n}\n.tabbox-cont .cont-tbl .tbl-list tbody tr:nth-child(even) td {\n  background: #fff;\n}\n.tabbox-cont .cont-tbl .tbl-list td img {\n  width: 16px;\n  height: 16px;\n  margin-left: 4px;\n}\n\n/* 일정별 - 목록영역 */\n.body-right {\n  width: calc(100% - 340px);\n}\n.body-right .right-top {\n  padding: 24px;\n  height: 33px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #dde2e9;\n}\n.body-right .right-top .tit {\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 1.2;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.body-right .right-top .tab__toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f7f8fa;\n  border-radius: 16px;\n  padding: 4px;\n}\n.body-right .right-top .tab__toggle li a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 14px;\n  height: 26px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1;\n  text-align: center;\n  color: #2c364e;\n  border-radius: 45px;\n  background: #f7f8fa;\n}\n.body-right .right-top .tab__toggle li.on a {\n  font-weight: 500;\n  color: #fff;\n  background: #2c364e;\n}\n.body-right .right-bottom {\n  padding: 38px 24px 24px;\n}\n.body-right .right-bottom .tbl-list table tr:hover td {\n  background: #e6f0ff;\n}\n.body-right .right-bottom .tbl-list table tr:active td {\n  background: #e6f0ff;\n}\n/* 일정별 - 목록영역 - 테이블 유형컬러 */\n.body-right .right-bottom .tbl-list table td span.ehc,\n.body-right .right-bottom .tbl-list table td span.jig,\n.body-right .right-bottom .tbl-list table td span.etc {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n.body-right .right-bottom .tbl-list table td span.ehc:before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  left: -8px;\n  width: 4px;\n  height: 32px;\n  background: #0f5fa5;\n}\n.body-right .right-bottom .tbl-list table td span.jig:before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  left: -8px;\n  width: 4px;\n  height: 32px;\n  background: #00dacd;\n}\n.body-right .right-bottom .tbl-list table td span.etc:before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  left: -8px;\n  width: 4px;\n  height: 32px;\n  background: #ff9900;\n}\n/* 일정별 - 목록영역 - 유형선택레이어 */\n.tbl-list table th.select-cate {\n  position: relative;\n}\n.tbl-list table th.select-cate span {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n.tbl-list table th.select-cate span:after {\n  content: \"\";\n  width: 7px;\n  height: 6px;\n  margin-left: 10px;\n  background: url(\"../img/icon_sortable_asc.png\") no-repeat right center;\n  background-size: 100%;\n}\n.popup-cate {\n  display: none;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 128px;\n  height: auto;\n  position: absolute;\n  top: 28px;\n  left: 0;\n  background: #fff;\n  border-radius: 4px;\n  filter: drop-shadow(0px 8px 12px rgba(122, 133, 150, 0.5));\n  z-index: 2;\n}\n.popup-cate.open {\n  display: flex;\n}\n.popup-cate li {\n  display: flex;\n  align-items: center;\n  width: calc(100% - 28px);\n  flex: 1;\n  padding: 5px 14px;\n}\n.popup-cate input[type=\"checkbox\"] + label {\n  font-size: 15px;\n  letter-spacing: -0.004em;\n  color: #19181a;\n}\n.popup-cate li:first-child {\n  padding-top: 8px;\n}\n.popup-cate li:last-child {\n  padding-bottom: 9px;\n}\n.popup-cate li:hover {\n  background: #e6f0ff;\n  border-radius: 0;\n}\n.popup-cate li:first-child:hover,\n.popup-cate li:first-child {\n  border-radius: 4px 4px 0 0;\n}\n.popup-cate li:last-child:hover,\n.popup-cate li:last-child {\n  border-radius: 0 0 4px 4px;\n}\n.popup-cate li:active,\n.popup-cate li.checked {\n  background: #b4d2ff;\n  border-radius: 0;\n}\n.popup-cate li:active:hover,\n.popup-cate li.checked:hover {\n  background: #b4d2ff;\n}\n.popup-cate li.checked label span {\n  color: #0a78ff;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n.tbl-list table th.select-cate .popup-cate span:after {\n  content: none;\n}\n.tbl-list table th.select-cate .popup-cate input[type=\"checkbox\"]:checked + label:after,\n.tbl-list table th.select-cate .popup-cate input[type=\"checkbox\"] + label:before {\n  top: 4px;\n  left: 0;\n}\n\n@media screen and (min-width: 1651px) and (max-width: 1820px) {\n  .body-right {\n    flex: 1;\n    width: 100%;\n  }\n}\n@media screen and (min-width: 500px) and (max-width: 1280px) {\n  .body-right {\n    flex: 1;\n    width: 100%;\n  }\n}\n@media screen and (max-width: 940px) {\n  .body-right {\n    border-top: 1px solid #dde2e9;\n    padding-top: 16px;\n    width: 100%;\n  }\n  .body-right .right-top {\n    padding: 16px 20px;\n  }\n  .body-right .right-bottom {\n    padding: 16px 20px;\n  }\n  .tabbox-cont .cont-memo {\n    padding: 10px 20px 18px;\n    height: calc(100% - 28px);\n  }\n  .tabbox-cont .cont-memo .memo-top {\n    justify-content: flex-start;\n  }\n  .tabbox-cont .cont-memo .memo-top .m-block.title {\n    width: auto;\n    flex: 1;\n    font-size: 16px;\n    font-weight: 700;\n    color: #0978ff;\n    line-height: 1.2;\n    letter-spacing: -0.4px;\n  }\n  .tabbox-cont .cont-memo .memo-box {\n    height: calc(100% - 48px);\n  }\n  .tabbox-cont .cont-memo .memo-box p {\n    font-size: 16px;\n    line-height: 2;\n  }\n  #wrap:not(.no-responsive) .left-bottom .tabbox-cont {\n    height: 100%;\n  }\n}\n@media screen and (max-width: 499px) {\n  .body-right .right-top .tit {\n    font-size: 19px;\n    letter-spacing: -1px;\n  }\n  .body-right .right-top .tab__toggle li a {\n    padding: 0 10px;\n    letter-spacing: -1px;\n  }\n}\n\n/* 설비별 - 설비추가 팝업 */\n.locate {\n  background: #f4f6f8;\n  padding: 8px 16px;\n  display: flex;\n  align-items: center;\n  margin: -16px -16px 0;\n}\n.locate li {\n  display: flex;\n  align-items: center;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.2;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.locate li:before {\n  content: \"\";\n  width: 16px;\n  height: 16px;\n  background: url(\"../img/icon_arrow_right_s.png\") no-repeat center center;\n  background-size: 100%;\n}\n.locate li:first-child:before {\n  content: none;\n}\n\n/* 점검진행 */\n.float-page header {\n  background-color: #2c364e;\n}\n.float-page header .header__title {\n  width: auto;\n  height: auto;\n  background: url(\"../img/icon_sulbi_w.png\") no-repeat 0 center;\n  background-size: 24px 24px;\n  padding-left: 32px;\n  margin-left: 12px;\n}\n.float-page header .header__title.bg-no {\n  background: none;\n  padding-left: 0;\n  margin-left: 0;\n}\n.float-page header .header__title span {\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 1;\n  padding-left: 16px;\n}\n.float-page header .header__title strong {\n  font-weight: 700;\n}\n.float-page .header__etc {\n  margin-right: 16px;\n}\n.float-page .header__etc li {\n  width: auto !important;\n  height: auto;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 1;\n  letter-spacing: -0.6px;\n  color: #ffffff;\n}\n.float-page .header__etc li button {\n  width: 117px;\n  height: 34px;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 1;\n  letter-spacing: -0.4px;\n  color: #ffffff;\n  background: rgba(144, 159, 183, 0.2);\n  border-radius: 4px;\n  border: 0;\n  margin-left: 16px;\n}\n@media screen and (max-width: 940px) {\n  .float-page .header__etc li.date {\n    display: none;\n  }\n  .float-page .container .treebar__toggleBtn.active {\n    border-bottom: 0;\n  }\n  .float-page .container .treebar__toggleBtn p span:last-child {\n    margin-left: 5px;\n  }\n  .float-page .container .treebar__toggleBtn p span {\n    font-weight: 400;\n    margin-left: 11px;\n  }\n}\n@media screen and (max-width: 768px) {\n  .float-page header {\n    background-color: #2c364e;\n  }\n  .float-page.onepage header {\n    padding-top: 47px;\n    padding-bottom: 5px;\n  }\n  .float-page .header__etc {\n    margin-right: 0;\n  }\n  .float-page .header__etc li.date {\n    display: none;\n  }\n  .float-page .header__etc li button.btn-close {\n    width: 36px;\n    height: 36px;\n    font-size: 0;\n    background: url(\"../img/icon_close_w@3x.png\") no-repeat center center;\n    background-size: 100%;\n  }\n}\n@media screen and (max-width: 679px) {\n  .float-page .container {\n    margin: 102px 0 0 0;\n  }\n  .float-page .container .treebar__toggleBtn {\n    top: 102px;\n  }\n  .float-page header {\n    justify-content: space-between;\n    padding: 47px 10px 5px 20px;\n    width: calc(100% - 30px);\n  }\n  .float-page header .header__left {\n    width: calc(100% - 50px);\n  }\n  .float-page header .header__title {\n    background: none;\n    padding-left: 0;\n    margin-left: 0;\n    width: 100%;\n  }\n  .float-page header .header__title strong {\n    display: none;\n  }\n  .float-page header .header__title span {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    cursor: pointer;\n    width: 100%;\n    display: inline-block;\n    padding-left: 0;\n    text-align: left;\n  }\n  .float-page header .header__right {\n    margin-right: 0;\n  }\n}\n\n/* 점검진행 - 왼쪽 메뉴 */\n.float-page .treebar.box.menutype {\n  width: 304px;\n  overflow-y: hidden;\n}\n.float-page .treebar.box.menutype .box__header {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  height: 89px;\n  padding: 18px 12px 12px 20px;\n  border-bottom: 1px solid #dde2e9;\n}\n.float-page .treebar.box.menutype .box__header .title-info {\n  display: flex;\n  gap: 20px;\n  width: 100%;\n  margin-right: 8px;\n  font-weight: 400;\n  margin-top: 4px;\n  margin-bottom: 0;\n}\n.float-page .treebar.box.menutype .box__header .title-info span:first-child {\n  max-width: calc(100% - 83px);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n}\n.float-page .treebar.box.menutype .box__header .title-info span + span {\n  flex: 1;\n  max-width: 63px;\n}\n.float-page .treebar.box.menutype .box__header .list-info {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 16px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.2;\n  width: 100%;\n  margin-top: 30px;\n}\n.float-page .treebar.box.menutype .box__header .list-info span {\n  display: flex;\n  align-items: center;\n}\n.float-page .treebar.box.menutype .box__header .list-info span:before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  margin-right: 8px;\n  background: #0a78ff;\n  border-radius: 50%;\n}\n.float-page .treebar.box.menutype .box__header .list-info span.not::before {\n  background: #f55547;\n}\n.float-page .treebar.box.menutype .manuarea {\n  overflow-y: auto;\n  height: calc(100% - 120px);\n}\n.float-page .treebar.box.menutype .manuarea .manulist li {\n  height: 45px;\n  border-bottom: 1px solid #dde2e9;\n}\n.float-page .treebar.box.menutype .manuarea .manulist li a {\n  padding: 0 24px 0 20px;\n  margin-right: 11px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n.float-page .treebar.box.menutype .manuarea .manulist li a.ok::before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  background: #0a78ff;\n  border-radius: 50%;\n}\n.float-page .treebar.box.menutype .manuarea .manulist li a.not::before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  background: #f55547;\n  border-radius: 50%;\n}\n.float-page .treebar.box.menutype .manuarea .manulist li:hover {\n  background: #e8f1fe;\n}\n.float-page .treebar.box.menutype .manuarea .manulist li.on {\n  background: #b4d2ff;\n}\n.float-page .treebar.box.menutype .manuarea .manulist li.on a p {\n  color: #0a78ff;\n  font-weight: 700;\n}\n.float-page .treebar.box.menutype .manuarea .manulist li a.not p,\n.float-page .treebar.box.menutype .manuarea .manulist li a.ok p {\n  margin-left: 16px;\n}\n.float-page .treebar.box.menutype .manuarea .manulist li a p {\n  display: block;\n  width: calc(100% - 20px);\n  margin-left: 26px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.float-page .treebar.box.menutype .manuarea .manulist li.gas a {\n  background: url(\"../img/icon_gas.png\") no-repeat center right;\n  background-size: 24px;\n}\n.float-page .treebar.box.menutype .manuarea .manulist li.on.gas a {\n  background: url(\"../img/icon_gas_b.png\") no-repeat center right;\n  background-size: 24px;\n}\n\n/* 점검진행 - 점검하기 */\n.float-page .content {\n  width: calc(100% - 304px);\n}\n.float-page .box__header {\n  padding: 24px;\n}\n.float-page .box__header h2 {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: 20px;\n  line-height: 1.2;\n  letter-spacing: -1px;\n}\n.float-page .box__header h2 strong {\n  font-weight: 700;\n}\n.float-page .box__body {\n  height: calc(100% - 153px);\n}\n.float-page .box__body .flex-row.m-m24 {\n  height: calc(100% + 48px);\n}\n.float-page .body-left + .body-right {\n  border-left: 1px solid #dde2e9;\n}\n.float-page .body-left + .body-right.m-popup.m-hidden .box__header {\n  display: none;\n}\n.float-page .body-left {\n  position: relative;\n  width: auto;\n  flex: 1.65;\n  flex-direction: column;\n  gap: 16px;\n  padding: 16px 14px 24px;\n  width: calc(100% - 28px);\n  height: calc(100% - 40px);\n}\n.float-page .body-right {\n  width: auto;\n  flex: 1;\n  height: 100%;\n  overflow: hidden;\n}\n.float-page .txt-info {\n  font-size: 16px;\n  line-height: 1.25;\n  letter-spacing: -0.4px;\n  color: #7a8596;\n}\n.float-page .txt-info.icon {\n  padding-left: 24px;\n  background: url(\"../img/icon_info_black.png\") no-repeat 0 1px;\n  background-size: 16px;\n}\n.float-page .body-left .left-top {\n  width: calc(100% - 10px);\n  height: calc(100% - 150px);\n  padding: 5px;\n  background: none;\n  flex: none;\n}\n.scorebox-list {\n  width: calc(100% - 20px);\n  height: calc(100% - 10px);\n  padding: 5px 15px 5px 5px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.scorebox-list .scorebox {\n  display: flex;\n  align-items: center;\n  padding: 16px 24px;\n  width: calc(100% - 48px);\n  background: #ffffff;\n  border: 2px solid #ffffff;\n  border-radius: 10px;\n  filter: drop-shadow(0px 0px 2px #909fb7);\n}\n.scorebox-list .scorebox + .scorebox {\n  margin-top: 12px;\n}\n.scorebox-list .scorebox .score {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 1.3;\n  letter-spacing: -0.4px;\n  color: #909fb7;\n}\n.scorebox-list .scorebox .score::before {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  margin-right: 10px;\n  margin-left: 24px;\n  background: url(\"../img/icon_check_big_g.png\") no-repeat center center;\n  background-size: 100%;\n}\n.scorebox-list .scorebox:hover {\n  background: #e8f1fe;\n}\n.scorebox-list .scorebox:active {\n  background: #b4d2ff;\n}\n.scorebox-list .scorebox.selected {\n  border-color: #0a78ff;\n}\n.scorebox-list .scorebox:hover .score,\n.scorebox-list .scorebox:active .score,\n.scorebox-list .scorebox.selected .score {\n  color: #0a78ff;\n  font-weight: 500;\n}\n.scorebox-list .scorebox:hover .score::before,\n.scorebox-list .scorebox:active .score::before,\n.scorebox-list .scorebox.selected .score::before {\n  background: url(\"../img/icon_check_big_b.png\") no-repeat center center;\n  background-size: 100%;\n}\n.scorebox-list .scorebox .score-list {\n  flex: 4;\n}\n.scorebox-list .scorebox .score-list li {\n  font-weight: 350;\n  font-size: 16px;\n  line-height: 1.7;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  display: flex;\n}\n.scorebox-list .scorebox .score-list li:before {\n  content: \"\";\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: #2a2c2f;\n  margin: 12px 10px 0 0;\n}\n.scorebox-list .scorebox .score-list li span {\n  width: calc(100% - 14px);\n}\n.float-page .body-left .left-bottom {\n  position: absolute;\n  bottom: 24px;\n  left: 0;\n  height: auto;\n  width: 100%;\n  gap: 16px;\n  display: flex;\n  flex-direction: column;\n  background: none;\n}\n.float-page .progress-area {\n  position: relative;\n  height: 6px;\n  width: 100%;\n  border-bottom: 1px solid #dde2e9;\n}\n.float-page .progress-area progress {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n  -webkit-appearance: none;\n  appearance: none;\n  color: #0a78ff;\n  background-color: #f7f8fa;\n}\nprogress::-webkit-progress-bar {\n  background-color: #f7f8fa;\n}\nprogress::-webkit-progress-value {\n  background-color: #0a78ff;\n}\n.float-page .body-right .tab__line {\n  padding: 0 10px;\n  width: calc(100% - 20px);\n}\n.float-page .body-right .tab__line li {\n  padding: 12px 14px 11px;\n}\n.float-page .body-right .tab__line li a {\n  font-size: 16px;\n}\n.float-page .body-right .tab__line li.on a,\n.float-page .body-right .tab__line li.on {\n  font-weight: 700;\n}\n.float-page .body-right .right-bottom {\n  padding: 24px;\n  height: calc(100% - 91px);\n}\n.float-page .body-right .tab-content {\n  height: 100%;\n  overflow-y: auto;\n  margin-right: -10px;\n  padding-right: 10px;\n  overflow-x: hidden;\n}\n.float-page .body-right .tab-content .tit,\n.imgbox-area .tit {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 1.3;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  margin-bottom: 14px;\n}\n.float-page .body-right .imgbox-area {\n  height: calc(100vh - 272px);\n}\n.float-page .body-right .imgbox-area li + li,\n.imgbox-area li + li {\n  margin-top: 24px;\n}\n.float-page .body-right .imgbox-area .txt,\n.imgbox-area .txt {\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 1.6;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  margin-top: 8px;\n}\n.float-page .body-right .img-area,\n.img-area {\n  display: flex;\n  gap: 8px;\n  /* height: 368px; */\n  height: 300px;\n  overflow-x: auto;\n}\n.float-page .body-right .img-area video,\n.img-area video {\n  width: 100%;\n}\nul.img-area li {\n  height: 100%;\n  /* width: 367px; */\n  width: 372px;\n  background: #f7f8fa;\n  text-align: center;\n}\nul.img-area li + li {\n  margin-top: 0;\n}\nul.img-area li img {\n  object-fit: contain;\n  height: 100%;\n  width: 372px;\n  /* width: auto; */\n}\nul.img-area.video,\n.float-page .body-right ul.img-area.video {\n  width: 100%;\n  height: auto;\n  flex-direction: column;\n  gap: 20px;\n}\nul.img-area.video li {\n  width: 100%;\n  height: auto;\n}\nul.img-area.video li video {\n  width: 100%;\n  object-fit: cover;\n}\n.float-page .body-right .img-area img,\n.img-area img {\n  object-fit: cover;\n}\n.float-page .body-right .img-area.more-img img,\n.img-area.more-img img {\n  width: 272px;\n  object-fit: cover;\n}\n\n.float-page .body-right .tab-content textarea {\n  height: 50vh;\n  overflow-y: scroll;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 2;\n  letter-spacing: -0.4px;\n  border-color: #dde2e9;\n}\n.float-page .body-right .tab-content .btn-basic {\n  width: 120px;\n  height: 40px;\n}\n.float-page .body-right .tab-content .btn-basic span {\n  font-size: 16px;\n  font-weight: 700;\n}\n.float-page .body-right .tab-content .form__input li .tit {\n  flex: 1;\n  min-width: 100px;\n}\n.float-page .body-right .tab-content .form__input .input__area {\n  flex: 3;\n  max-width: 400px;\n}\n.float-page .body-right .tab-content .form__input .filebox .upload-name {\n  height: 38px;\n}\n.float-page .body-right .tab-content .form__input input[type=\"text\"],\n.float-page .body-right .tab-content .form__input input[type=\"password\"],\n.float-page .body-right .tab-content .form__input input[type=\"tel\"],\n.float-page .body-right .tab-content .form__input input[type=\"file\"],\n.float-page .body-right .tab-content .form__input .box__search input[type=\"text\"],\n.float-page .body-right .tab-content .form__input .select {\n  height: 38px;\n}\n.float-page .body-right .tab-content .form__input .select {\n  font-size: 16px;\n}\n.float-page .body-right .tab-content .form__input .input__area .txt-info,\n.form__input .input__area .txt-info {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.4;\n  letter-spacing: -0.48px;\n  color: #909fb7;\n  margin-top: 5px;\n  margin-left: 0;\n}\n.float-page .body-right .tab-content .form__input .filelist,\n.form__input .filelist {\n  display: inline-table;\n}\n.float-page .body-right .tab-content .form__input .filelist li,\n.form__input .filelist li {\n  display: inline-flex;\n  flex-direction: row !important;\n  align-items: center !important;\n  gap: 4px;\n  margin-bottom: 4px;\n}\n.float-page .body-right .tab-content .form__input .filelist li .btn-delete,\n.form__input .filelist li .btn-delete,\n.form__input .labellist li .btn-delete {\n  margin-left: 0;\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_delete_x_lg.png\") no-repeat center center;\n  background-size: 100%;\n}\n.float-page .body-right .tab-content .form__input .filelist li span,\n.form__input .filelist li span {\n  font-size: 14px;\n  line-height: 20px;\n}\n.form__input .filelist li span {\n  background-position: left 4px;\n}\n.float-page .body-right .tab-content .form__input .filelist li:not(:first-child) span,\n.form__input .filelist li:not(:first-child) span {\n  background: none;\n}\n.float-page .body-right .tab-content .imglist {\n  margin-top: 40px;\n  padding-top: 24px;\n  border-top: 1px solid #dde2e9;\n}\n.float-page .body-right .tab-content .imglist .tit {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n.float-page .body-right .tab-content .imglist .imgbox-area {\n  height: calc(100vh - 800px);\n}\n.float-page .body-right .tab-content .imglist .imgbox-area .tit {\n  margin-bottom: 8px;\n}\n.float-page .body-right .tab-content .imglist .imgbox-area .img-area {\n  height: 552px;\n  width: 100%;\n  overflow-x: hidden;\n}\n.float-page .body-right .tab-content .imglist .imgbox-area .img-area.js-open {\n  cursor: pointer;\n}\n.float-page .body-right .tab-content .imglist .imgbox-area .img-area img {\n  width: auto;\n  height: 100%;\n  object-fit: contain;\n}\n.float-page .body-right .tab-content .imglist .imgbox-area .tit .btn-area {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  width: 75px !important;\n}\n.float-page .body-right .tab-content .imglist .imgbox-area .tit .btn-area button {\n  width: 32px;\n  height: 32px;\n}\n.float-page .body-right .tab-content .imglist .imgbox-area .tit .btn-area button.btn-edit-g {\n  background: url(\"../img/icon_pen_g.png\") no-repeat center center;\n  background-size: 100%;\n}\n.float-page .body-right .tab-content .imglist .imgbox-area .tit .btn-area button.btn-delete-gr {\n  background: url(\"../img/icon_delete_gr.png\") no-repeat center center;\n  background-size: 100%;\n}\n@media screen and (min-width: 941px) and (max-width: 1650px) {\n  .float-page .body-right .box__header {\n    padding: 3px 20px 5px 10px;\n  }\n  .float-page .body-right .tab__line {\n    margin-top: 50px;\n  }\n  .float-page .body-left + .body-right.m-popup.popup-layer .right-bottom {\n    height: calc(100% - 158px);\n  }\n}\n@media screen and (max-width: 1650px) {\n  .float-page .treebar.box.menutype {\n    height: auto;\n  }\n  .float-page .content .box__header.flex-column {\n    flex-direction: row !important;\n  }\n  .float-page .body-left .left-top .clicktab-list {\n    display: flex;\n    flex-direction: column;\n    margin-top: 32px;\n  }\n  .float-page .body-left .left-top .clicktab-list li {\n    display: flex;\n    align-items: center;\n    padding: 0 20px;\n    height: 48px;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 1;\n    letter-spacing: -0.4px;\n    color: #2a2c2f;\n    border-top: 1px solid #dde2e9;\n    background: url(\"../img/icon_more_g_thin.png\") no-repeat 98% center #fff;\n    background-size: 32px;\n    cursor: pointer;\n  }\n  .scorebox-list .scorebox {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n    padding: 16px;\n    width: calc(100% - 32px);\n  }\n  .scorebox-list .scorebox .score::before {\n    margin-right: 8px;\n    margin-left: 0;\n  }\n  .float-page .body-right.m-hidden {\n    display: none;\n  }\n  .float-page .body-right .box__header {\n    position: absolute;\n    top: 0;\n    width: calc(100% - 30px);\n    background: #2c364e;\n    border-bottom: 2px solid #dde2e9;\n    z-index: 1;\n  }\n  .float-page .body-right .box__header .box__title {\n    color: #fff;\n    text-align: center;\n    font-weight: 500;\n    width: calc(100% - 40px);\n  }\n  .float-page .body-right .box__header .btn-prev {\n    display: block;\n    width: 40px;\n    height: 40px;\n    background: url(\"../img/icon_prev_w.png\") no-repeat center center;\n    background-size: 100%;\n  }\n  .float-page .body-left + .body-right.m-popup.popup-layer {\n    width: 100% !important;\n    border-radius: 0;\n  }\n  .float-page .body-right.m-popup.popup-layer .tab-content .form__input .input__area {\n    max-width: unset;\n  }\n  .float-page .body-right.m-popup.popup-layer .tab-content .form__input li .tit {\n    min-width: unset;\n  }\n}\n@media screen and (max-width: 940px) {\n  .float-page .body-right .box__header {\n    padding: 47px 20px 5px 10px;\n  }\n  .float-page .body-right .tab__line {\n    margin-top: 90px;\n  }\n  .float-page .body-left + .body-right.m-popup.popup-layer .right-bottom {\n    height: calc(100% - 198px);\n  }\n  .float-page .content {\n    width: 100%;\n    padding-left: 0;\n  }\n  .float-page .treebar.box.active {\n    top: 101px;\n    z-index: 10;\n  }\n  .float-page .treebar.box.menutype .box__header {\n    display: flex;\n    height: auto;\n    padding: 18px 20px 12px;\n  }\n  .float-page .treebar.box.menutype .box__header .box__title,\n  .float-page .treebar.box.menutype .box__header .title-info {\n    display: none;\n  }\n  .float-page .treebar.box.menutype .box__header .list-info {\n    margin-top: 0;\n  }\n  .float-page .treebar.box.menutype .manuarea {\n    height: calc(100vh - 202px);\n  }\n  .float-page .treebar.box.menutype .manuarea .manulist li {\n    height: 58px;\n  }\n  .float-page .treebar.box.menutype .manuarea .manulist li a p {\n    font-size: 16px;\n  }\n  .float-page .body-left .left-top {\n    margin-bottom: 150px;\n  }\n  .float-page .body-left .left-bottom {\n    position: fixed;\n    bottom: 0;\n    padding-bottom: 24px;\n    background: #fff;\n    z-index: 1;\n  }\n  .float-page .body-right .tab__line {\n    gap: 1px;\n  }\n  .float-page .body-right .tab__line li {\n    padding: 12px 0 11px;\n  }\n  .float-page .treebar.box.menutype + .content {\n    margin-top: 52px;\n  }\n}\n@media screen and (max-width: 679px) {\n  .float-page .treebar.box.active {\n    top: 153px;\n  }\n}\n\n/* 점검진행 - 측정값 */\n.float-page .body-left .tbl-list table th,\n.float-page .body-left .tbl-list table td {\n  font-size: 16px;\n  padding-left: 40px;\n  padding-right: 40px;\n}\n.float-page .body-left .tbl-list table tr.selected td {\n  border-top: 2px solid #0a78ff;\n  border-bottom: 2px solid #0a78ff;\n  height: 36px;\n}\n.float-page .body-left .tbl-list table tr.selected td:first-child {\n  border-left: 2px solid #0a78ff;\n}\n.float-page .body-left .tbl-list table tr.selected td:last-child {\n  border-right: 2px solid #0a78ff;\n  font-weight: 500;\n  color: #0a78ff;\n}\n.float-page .body-left .tbl__top {\n  justify-content: flex-start;\n  gap: 16px;\n}\n.float-page .body-left .tbl__top span {\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 1.2;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.float-page .body-left .tbl__top span.disabled {\n  color: #f0f2f4;\n  font-weight: 400;\n  background: none;\n  border: none;\n}\n.float-page .body-left .tbl__top span.input-value {\n  color: #0a78ff;\n}\n.float-page .body-left .value-box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: -5%;\n  height: 35%;\n}\n.float-page .body-left .value-box .form__input {\n  width: 100%;\n}\n.float-page .body-left .value-box .form__input button {\n  width: 170px;\n}\n.float-page .body-left .value-box .form__input button.btn-not {\n  background: #ffffff;\n  border: 2px solid #ffffff;\n  filter: drop-shadow(0px 0px 2px #909fb7);\n}\n.float-page .body-left .value-box .form__input button.btn-not span {\n  color: #909fb7;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 400;\n}\n.float-page .body-left .value-box .form__input button.btn-not span::before {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  margin-right: 16px;\n  background: url(\"../img/icon_not.png\") no-repeat center center;\n  background-size: 100%;\n}\n.float-page .body-left .value-box .form__input button.btn-not:hover {\n  background: #feeeed;\n}\n.float-page .body-left .value-box .form__input button.btn-not:hover span {\n  color: #e53f31;\n  font-weight: 500;\n}\n.float-page .body-left .value-box .form__input button.btn-not:hover span::before {\n  background: url(\"../img/icon_not_red.png\") no-repeat center center;\n  background-size: 100%;\n}\n.float-page .body-left .value-box .form__input button.btn-not.selected {\n  background: #f5c6c1;\n}\n.float-page .body-left .value-box .form__input button.btn-not.selected span {\n  color: #e53f31;\n  font-weight: 500;\n}\n.float-page .body-left .value-box .form__input button.btn-not.selected span::before {\n  background: url(\"../img/icon_not_red.png\") no-repeat center center;\n  background-size: 100%;\n}\n.float-page .body-left .value-box .form__input button,\n.float-page .body-left .value-box .form__input input[type=\"text\"] {\n  height: 56px;\n}\n.float-page .body-left .value-box .form__input input[type=\"text\"],\n.float-page .body-left .value-box .form__input input[type=\"text\"]::placeholder {\n  font-size: 20px !important;\n}\n.float-page .body-left .value-box .form__input li {\n  align-items: center;\n}\n.float-page .body-left .value-box .form__input li .tit {\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 1;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  flex: 1;\n  margin-left: 16px;\n  margin-top: 0;\n}\n.float-page .body-left .value-box .form__input .input__area {\n  flex: 2.5;\n  display: flex;\n  gap: 12px;\n}\n.float-page .body-left .value-box .form__input .input__area .input-errortxt {\n  top: 63px;\n  font-size: 1rem;\n}\n.float-page .body-left .value-box.more {\n  flex-direction: column;\n  gap: 20px;\n  height: auto;\n  margin: 5% 0 40px;\n}\n.float-page .body-left .value-box.more .form__input {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: 2%;\n}\n.float-page .body-left .value-box.more .form__input li {\n  margin-top: 0;\n  width: 49%;\n}\n.float-page .body-left .value-box.more .btn-area {\n  width: 100%;\n  justify-content: flex-end;\n}\n.float-page .body-left .value-box.more button {\n  width: 170px;\n  height: 56px;\n}\n.float-page .body-left .left-top textarea {\n  border-color: #dde2e9;\n  font-size: 16px;\n  line-height: 2;\n  height: 40vh;\n}\n.input-list {\n  margin: 16px 0;\n  padding: 20px 40px;\n  background: #fff;\n  border: 2px solid #0a78ff;\n}\n.input-list li {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  gap: 10%;\n}\n.input-list li:last-child {\n  margin-bottom: 0;\n}\n.input-list li p {\n  width: 45%;\n  display: flex;\n  align-items: center;\n}\n.input-list li p span {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1;\n  letter-spacing: -0.7px;\n  color: #2a2c2f;\n  flex: 1;\n}\n.input-list li p span strong {\n  font-weight: 500;\n  font-size: 20px;\n  color: #0a78ff;\n}\n\n@media screen and (max-width: 1650px) {\n  .float-page .body-left .value-box {\n    height: auto;\n    margin: 2% 0 7%;\n  }\n  .float-page .body-left .value-box .form__input li {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n  .float-page .body-left .value-box .form__input li .tit {\n    margin-left: 0;\n  }\n}\n@media screen and (max-width: 940px) {\n  .float-page .body-left .value-box .form__input .input__area {\n    flex-direction: column;\n    flex: 1;\n  }\n  .float-page .body-left .value-box .form__input .input__area .btn-area {\n    flex-direction: row-reverse;\n    margin: 0;\n    width: 100%;\n  }\n  .float-page .body-left .value-box .form__input .input__area .btn-area button {\n    width: auto;\n    flex: 1;\n  }\n  .float-page .body-left .value-box .form__input .input__area .btn-area button span {\n    font-size: 20px;\n  }\n  .float-page .body-left .value-box .form__input .input__area .input-errortxt + .btn-area {\n    margin-top: 20px;\n  }\n  .float-page .body-left .tbl__top {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .float-page .body-left .tbl__top span.tit {\n    font-size: 16px;\n    line-height: 1;\n  }\n  .float-page .body-left .tbl-list table th,\n  .float-page .body-left .tbl-list table td {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n  .float-page .body-left .tbl-list table td {\n    height: 40px !important;\n  }\n  .float-page .body-left .value-box.more .form__input {\n    gap: 16px;\n  }\n  .float-page .body-left .value-box.more .form__input li {\n    width: 100%;\n  }\n}\n\n/* 점검진행 - 점검유형선택 */\n#wrap.float-page.onepage {\n  background: #fff !important;\n}\n.float-page.onepage .content {\n  width: 100%;\n  padding-left: 0;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 40px;\n}\n.float-page.onepage .content .top {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.float-page.onepage .content .top:before {\n  content: \"\";\n  width: 350px;\n  height: 136px;\n  margin-bottom: 16px;\n  background: url(\"../img/bg_cate_step1.png\") no-repeat 0 center;\n  background-size: 100%;\n}\n.float-page.onepage .content .top p {\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 1.4;\n  text-align: center;\n  letter-spacing: -0.4px;\n  color: #646c74;\n}\n.float-page.onepage .content .top p.tit {\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 1.3;\n  text-align: center;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  margin-top: 4px;\n}\n.float-page.onepage .content .bottom {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 40px;\n}\n.float-page.onepage .content .bottom .form-area {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 350px;\n}\n.float-page.onepage .content .bottom a {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  color: #0a78ff;\n}\n.float-page.onepage .content .bottom a:hover {\n  text-decoration: underline;\n}\n.float-page.onepage .content .bottom button,\n.float-page .content .btn-area button {\n  width: 100%;\n  height: 48px;\n  background: #0a78ff;\n  border: 0;\n  position: relative;\n}\n.float-page.onepage .content .bottom button:hover,\n.float-page .content .btn-area button:hover {\n  border-color: #0050b8;\n  background-color: #0050b8;\n}\n.float-page.onepage .content .bottom button:active,\n.float-page .content .btn-area button:active {\n  border-color: #003876;\n  background-color: #003876;\n}\n.float-page.onepage .content .bottom button span,\n.float-page .content .btn-area button span {\n  font-size: 20px;\n  line-height: 1;\n  color: #fff;\n  font-weight: 700;\n}\n.float-page.onepage .content .bottom button.btn-back:before {\n  content: \"\";\n  position: absolute;\n  left: 10px;\n  width: 32px;\n  height: 32px;\n  background: url(\"../img/icon_arrow_left@3x.png\") no-repeat center center;\n  background-size: 100%;\n}\n.float-page.onepage .content .bottom button.btn {\n  width: 40px;\n  height: 40px;\n}\n.float-page.onepage .content .bottom button.btn.btn-add {\n  background: url(\"../img/icon_plus_w.png\") no-repeat center center #0a78ff;\n  background-size: 16px;\n}\n.float-page.onepage .content .bottom button.btn.btn-edit {\n  background: url(\"../img/icon_pen_w.png\") no-repeat center center #0a78ff;\n  background-size: 45%;\n}\n.float-page.onepage .content .bottom button.btn-back.bg-white:disabled span {\n  color: #e6f0ff !important;\n}\n.float-page.onepage .content .bottom button.btn-back.bg-white:disabled:before {\n  opacity: 0.1;\n}\n.float-page .content .btn-area {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n}\n.float-page .content .btn-area button,\n.float-page.onepage .content .bottom .btn-area button {\n  width: 169px;\n}\n.float-page.onepage .content .bottom .select {\n  height: 46px;\n  font-size: 18px;\n}\n.float-page.onepage .content .bottom .select .selected {\n  padding: 0 12px;\n}\n.float-page.onepage .content.step3 .bottom .form-area {\n  gap: 24px;\n}\n.float-page.onepage .content .bottom .form-area .info-add {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.float-page.onepage .content .bottom .form-area .info-add .name {\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 1;\n  letter-spacing: -0.8px;\n  color: #2a2c2f;\n}\n.float-page.onepage .content .bottom .form-area .info-add.edit .name {\n  flex: 1;\n}\n.float-page.onepage .content .bottom .form-area .info-add.edit .right {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 16px;\n  flex: 1;\n}\n.float-page.onepage .content .bottom .form-area .info-add.edit .number {\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 1;\n  text-align: right;\n  letter-spacing: -0.4px;\n  color: #0a78ff;\n}\n.float-page.onepage .content .bottom .form-area .info-add.edit .number strong {\n  font-weight: 500;\n  color: #2a2c2f;\n}\n.float-page.onepage .content .bottom .form-area .info-add-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  overflow-y: auto;\n  max-height: 212px;\n}\n.float-page.onepage .content .bottom .form-area .info-add-list li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #dde2e9;\n}\n.float-page.onepage .content .bottom .form-area .info-add-list li .name {\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 1.3;\n  color: #2a2c2f;\n}\n.float-page.onepage .content .bottom .form-area .info-add-list .btn-more {\n  width: 32px;\n  height: 32px;\n  background: url(\"../img/icon_more_g_thin.png\") no-repeat center center;\n  background-size: 100%;\n}\n.float-page.onepage.onepage .content.step2-1 .top:before {\n  content: none;\n}\n.float-page.onepage.onepage .content.step2-1 .bottom .tbl-list {\n  width: 100%;\n  max-width: 616px;\n  max-height: 53vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n  border-bottom: 1px solid #dde2e9;\n}\n.float-page.onepage.onepage .content.step2-1 .bottom .tbl-list table {\n  border-bottom: 0;\n}\n.float-page.onepage.onepage .content.step2-1 .bottom .tbl-list table th {\n  position: sticky;\n  position: -webkit-sticky;\n  top: 0;\n  z-index: 2;\n}\n.float-page.onepage .content.step2-1 .bottom .tbl-list table td span.ehc,\n.float-page.onepage .content.step2-1 .bottom .tbl-list table td span.jig,\n.float-page.onepage .content.step2-1 .bottom .tbl-list table td span.etc {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n.float-page.onepage .content.step2-1 .bottom .tbl-list table td span.ehc:before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  left: -8px;\n  width: 4px;\n  height: 32px;\n  background: #0f5fa5;\n}\n.float-page.onepage .content.step2-1 .bottom .tbl-list table td span.jig:before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  left: -8px;\n  width: 4px;\n  height: 32px;\n  background: #00dacd;\n}\n.float-page.onepage .content.step2-1 .bottom .tbl-list table td span.etc:before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  left: -8px;\n  width: 4px;\n  height: 32px;\n  background: #ff9900;\n}\n.float-page.onepage .content.step2-1 .bottom .tbl-list table td .btn-file {\n  width: 0.563rem !important;\n  height: 1.087rem !important;\n  background: url(\"../img/icon_file.png\") no-repeat center center !important;\n  background-size: 100% !important;\n  padding: 0;\n}\n.float-page.onepage .content.step2-1 .bottom .tbl-list table .tooltip-link::before {\n  left: -5%;\n}\n.float-page .content .btn-area.sm-column .left {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n}\n@media screen and (max-width: 940px) {\n  .float-page.onepage .content {\n    margin: 84px 0;\n  }\n  .float-page .content .btn-area.sm-column {\n    flex-direction: column;\n    gap: 8px;\n  }\n  .float-page .content .body-left .left-bottom .btn-area.sm-column .right {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    position: relative;\n  }\n}\n@media screen and (max-width: 499px) {\n  .float-page.onepage .container {\n    margin-top: 102px;\n    min-height: calc(100vh - 102px);\n  }\n  .float-page.onepage .content {\n    margin: 20px;\n    min-height: calc(100vh - 145px);\n    width: calc(100% - 40px);\n  }\n  .float-page.onepage .content .top p.tit {\n    font-size: 20px;\n  }\n  .float-page.onepage .content .top p {\n    font-size: 16px;\n  }\n  .float-page.onepage .content .bottom,\n  .float-page.onepage .content .top,\n  .float-page.onepage .content .bottom .form-area,\n  .float-page .content .btn-area {\n    width: 100%;\n  }\n  .float-page .content .btn-area button,\n  .float-page.onepage .content .bottom .btn-area button {\n    height: 40px;\n  }\n  .float-page:not(.onepage) .content .btn-area {\n    width: calc(100% - 60px);\n    margin: 0 30px;\n  }\n  .float-page.onepage .content .bottom button span,\n  .float-page .content .btn-area button span {\n    font-size: 16px;\n  }\n}\n\n/* 점검결과 - 설비선택결과보기 */\n.box.box-detailinfo .box-result {\n  background: #fff;\n  width: 100%;\n  height: 100%;\n}\n.box.box-detailinfo .box-result .box__header {\n  position: relative;\n  height: 33px;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 15px;\n  background: url(\"../img/bg_top_result.png\") no-repeat 0 0 #fff;\n  background-size: 183px 32px;\n  border-top: 1px solid #003875;\n  border-bottom: 0;\n}\n.box.box-detailinfo .box-result .box__header .box__title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  background: none;\n  padding-left: 20px;\n}\n.box.box-detailinfo .box-result .box__header .box__title span {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1.4;\n  letter-spacing: -1px;\n  color: #ffffff;\n}\n.box.box-detailinfo .box-result .box__header .box__title span.tit {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.box.box-detailinfo .box-result .box__header .box__title span.date {\n  font-weight: 400;\n  color: #2a2c2f;\n}\n.box.box-detailinfo .box__body .box-result section {\n  padding: 16px 16px 0;\n  background: #fff;\n}\n.box.box-detailinfo .box__body .box-result section::after {\n  content: \"\";\n  width: calc(100% + 92px);\n  height: 1px;\n  background: #dde2e9;\n  margin: 48px -46px 16px;\n  display: block;\n}\n.box.box-detailinfo .box__body .box-result section .section-top {\n  margin-bottom: 30px;\n  border-bottom: 2px solid #0f5fa5;\n  padding-bottom: 8px;\n}\n.box.box-detailinfo .box__body .box-result section .section-top .tit {\n  font-size: 20px;\n  font-weight: 500;\n}\n.box.box-detailinfo .box__body .box-result section .section-bottom {\n  border: 0;\n  border-radius: 0;\n  padding: 0;\n}\n.box.box-detailinfo .box__body .box-result section .section-bottom + .section-bottom {\n  border-top: 2px solid #dde2e9;\n  padding-top: 32px;\n  margin-top: 32px;\n}\n.box.box-detailinfo .box__body .box-result section .section-bottom .part:not(.line) + .part:not(.line) {\n  margin-top: 32px;\n}\n.box.box-detailinfo .box__body .box-result section .section-bottom .part.line {\n  border-bottom: 2px solid #dde2e9;\n  padding-bottom: 32px;\n  margin-bottom: 32px;\n}\n.box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list {\n  margin: 0;\n  border-bottom: 2px solid #dde2e9;\n}\n.box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list th {\n  height: 24px;\n  padding: 4px 16px;\n}\n.box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list.row {\n  border-top: 2px solid #dde2e9;\n}\n.box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list.row th {\n  height: auto;\n  padding: 12px 16px;\n}\n.box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list.td-40 td {\n  height: auto;\n  padding: 12px 16px;\n  vertical-align: top;\n}\n.box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list td .btn {\n  width: 24px;\n  height: 24px;\n  padding: 0;\n}\n.box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list.tbl-border {\n  border-top: 1px solid #909fb7;\n  border-bottom: 1px solid #909fb7;\n  border-right: 1px solid #909fb7;\n}\n.box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list.tbl-border th {\n  border-left: 1px solid #909fb7;\n  padding: 4px 8px;\n}\n.box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list.tbl-border td {\n  padding: 4px 8px;\n  height: 39px;\n  border-left: 1px solid #909fb7;\n  border-top: 1px solid #909fb7;\n  background: #fff !important;\n}\n.box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list.tbl-border td .ellipsis {\n  width: 100%;\n}\n.box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list.tbl-border td .flex-inline .ellipsis {\n  width: calc(100% - 26px);\n}\n.box.box-detailinfo .box__body .box-result section .section-bottom .tbl__top {\n  margin-bottom: 12px;\n}\n.box.box-detailinfo .box__body .box-result section .section-bottom .tbl__top p.tit {\n  font-weight: 500;\n  color: #2a2c2f;\n}\n.box.box-detailinfo .box__body .box-result section .section-bottom .tbl__top p {\n  font-weight: 350;\n  color: #7a8596;\n}\n.box.box-detailinfo .box__body .box-result section .section-bottom .tbl__top .btn-area {\n  margin-top: 0;\n}\n.score-info {\n  display: flex;\n  align-items: center;\n}\n.score-info:before {\n  content: \"\";\n  width: 8px;\n  height: 8px;\n  margin-right: 8px;\n  border-radius: 50%;\n}\n.score-info.green:before {\n  background: #1fc95c;\n}\n.score-info.orange:before {\n  background: #ff7836;\n}\n.score-info.yellow:before {\n  background: #ffbc0a;\n}\n.score-info.gray:before {\n  background: #909fb7;\n}\n.box.box-detailinfo .box__body .box-result .tit-bar {\n  margin-bottom: 16px;\n  padding: 8px 16px;\n  background: rgba(227, 231, 238, 0.5);\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 1.6;\n  letter-spacing: -0.7px;\n  color: #2a2c2f;\n}\n.box.box-detailinfo .box__body .box-result .detail-area {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  padding: 0 16px 0;\n}\n.box.box-detailinfo .box__body .box-result .detail-area li {\n  display: flex;\n}\n.box.box-detailinfo .box__body .box-result .detail-area li .tit {\n  flex: 1;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1.7;\n  letter-spacing: -0.7px;\n  color: #2a2c2f;\n}\n.box.box-detailinfo .box__body .box-result .detail-area li .txt-area {\n  flex: 3.5;\n}\n.box.box-detailinfo .box__body .box-result .detail-area li .txt-area p {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.7;\n  letter-spacing: -0.7px;\n  color: #2a2c2f;\n  word-wrap: break-word;\n  text-align: justify;\n}\n.box.box-detailinfo .box__body .box-result .detail-area li .txt-area p .txt-gray {\n  color: #7a8596 !important;\n}\n.box.box-detailinfo .box__body .box-result .detail-area li .img-area {\n  margin-top: 8px;\n  display: flex;\n  gap: 8px;\n  height: 300px;\n  overflow-x: auto;\n}\n.box.box-detailinfo .box__body .box-result .detail-area li .img-area img {\n  object-fit: cover;\n}\n.box.box-detailinfo .box__body .box-result .detail-area.line {\n  border-top: 2px solid #dde2e9;\n  border-bottom: 2px solid #dde2e9;\n  padding: 16px;\n}\n.box.box-detailinfo .box__body .box-result section .section-bottom .tbl__top .btn.btn-more {\n  position: relative;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  background: url(\"../img/icon_plus_g.png\") no-repeat center center;\n  background-size: 100%;\n}\n.box.box-detailinfo .box__body .box-result section .section-bottom .tbl__top .flex-right {\n  width: auto !important;\n  align-items: center;\n}\n.box.box-detailinfo .box__body .box-result section .section-bottom .tbl__top p strong {\n  color: #2a2c2f;\n  font-weight: 500;\n}\n.box.box-detailinfo .box__body .box-result .btn-area {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 16px;\n}\n.box.box-detailinfo .box__body .box-result .btn-area.m-block {\n  display: flex !important;\n}\n.box.box-detailinfo .box__body .box-result .btn-area button.btn-basic {\n  height: 40px;\n  min-width: 140px;\n}\n.box.box-detailinfo .box__body .box-result .btn-area button.btn-basic span {\n  font-size: 16px;\n}\n.box.box-detailinfo .box__body .box-result .total-score .score-top {\n  border-bottom: 1px solid #e5e6ee;\n  padding-bottom: 32px;\n  margin-bottom: 32px;\n  display: flex;\n  flex-direction: column;\n}\n.box.box-detailinfo .box__body .box-result .total-score .score-top .tit {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1.4;\n  letter-spacing: -0.4px;\n  color: #ff7836;\n}\n.box.box-detailinfo .box__body .box-result .total-score .score-top .score {\n  font-weight: 500;\n  font-size: 40px;\n  line-height: 1.2;\n  letter-spacing: -0.4px;\n  color: #2c364e;\n  margin: 2px 0 14px;\n}\n.box.box-detailinfo .box__body .box-result .total-score .score-top .score span {\n  color: #909fb7;\n  font-weight: 400;\n  font-size: 20px;\n  margin-left: 3px;\n}\n.box.box-detailinfo .box__body .box-result .total-score .score-top .info {\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 1.4;\n  letter-spacing: -1px;\n  color: #2a2c2f;\n  padding-left: 23px;\n  background: url(\"../img/icon_info_gr.png\") no-repeat -3px -1px;\n  background-size: 26px;\n}\n.box.box-detailinfo .box__body .box-result .total-score .score-top.caution .info {\n  background: url(\"../img/icon_info_o.png\") no-repeat 0 3px;\n  background-size: 18px;\n}\n.box.box-detailinfo .box__body .box-result .total-score .score-top .info .tit {\n  font-size: 18px;\n  line-height: 1.4;\n  letter-spacing: -1px;\n  color: #1fc95c;\n  margin-right: 4px;\n}\n.box.box-detailinfo .box__body .box-result .total-score .score-top.caution .info .tit {\n  color: #f55547;\n}\n.box.box-detailinfo .box__body .box-result .total-score .graph-area {\n  padding: 16px;\n}\n.box.box-detailinfo .box__body .box-result .total-score .graph-area + .graph-area {\n  margin-top: 30px;\n}\n.box.box-detailinfo .box__body .box-result .total-score .graph-area > div {\n  height: 100% !important;\n}\n\n@media screen and (max-width: 499px) {\n  .box.box-detailinfo .box-result .box__header {\n    margin-top: -16px;\n  }\n  .box.box-detailinfo .box__body section + section {\n    margin-top: 24px;\n  }\n  .box.box-detailinfo .box__body .box-result section .section-top .tit {\n    font-size: 24px;\n  }\n  .box.box-detailinfo .box__body .box-result .total-score .score-top .score span {\n    font-size: 44px;\n  }\n  .box.box-detailinfo .box__body .box-result .total-score .score-top .score span {\n    font-size: 24px;\n  }\n  .box.box-detailinfo .box__body .box-result .total-score .score-top .info {\n    font-size: 20px;\n  }\n  .box.box-detailinfo .box__body .box-result section .section-bottom .tbl__top {\n    flex-direction: row;\n    align-items: center;\n  }\n  .box.box-detailinfo .box__body .box-result section .section-bottom .tbl__top p {\n    font-size: 20px;\n  }\n  .box.box-detailinfo .box__body .box-result section .section-bottom .tbl__top .btn-area .btn {\n    width: 32px;\n    height: 32px;\n  }\n  .box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list th {\n    padding: 4px;\n  }\n  .box.box-detailinfo .box__body .box-result section .section-bottom .tbl-list.td-40 td {\n    padding: 12px 5px;\n  }\n  .box.box-detailinfo .box__body .box-result .tit-bar {\n    font-size: 18px;\n    padding: 10px 16px;\n    margin-bottom: 24px;\n  }\n  .box.box-detailinfo .box__body .box-result .detail-area {\n    gap: 40px;\n  }\n  .box.box-detailinfo .box__body .box-result .detail-area li .tit,\n  .box.box-detailinfo .box__body .box-result .detail-area li .txt-area p {\n    font-size: 16px;\n  }\n  .box.box-detailinfo .box__body .box-result .detail-area li {\n    flex-direction: column;\n    gap: 10px;\n  }\n  .box.box-detailinfo .box__body .box-result .detail-area li .img-area {\n    height: 240px;\n  }\n  .box.box-detailinfo .box__body .box-result .btn-area button.btn-basic {\n    min-width: auto;\n    padding: 0 10px;\n  }\n}\n\n/* 점검결과 - 설비선택결과보기 - 전체화면 */\n.float-page .content.w100p {\n  width: 100%;\n  padding-left: 0;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.float-page .content .box-result-top {\n  width: 100%;\n  margin-top: 4px;\n}\n.box-result-top .txt {\n  color: #757d88;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 1;\n  letter-spacing: -0.4px;\n  margin-left: 32px;\n  max-width: 50%;\n}\n.float-page .content .box-result-top .btn-area {\n  gap: unset;\n  justify-content: flex-end;\n}\n.float-page .content .box-result-top button {\n  height: 32px;\n  padding: 0 20px;\n  min-width: 94px;\n  width: auto;\n}\n.float-page .content .box-result-top button span {\n  font-size: 15px;\n  font-weight: 500;\n}\n.float-page .content .box-result-top button.bg-transparent {\n  background: transparent;\n}\n.float-page .content .box-result-top button.bg-transparent span {\n  color: #0a78ff;\n}\n.float-page .content .box-result {\n  width: 55%;\n  padding: 40px 20px 24px;\n  background: #fff;\n}\n.float-page .content .box-result .box__header {\n  position: relative;\n  height: 33px;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 30px;\n  /* background: url('../img/bg_top_result.png') no-repeat 0 0 #fff;\n  background-size: 312px 32px; */\n  border-top: 1px solid #003875;\n  border-bottom: 0;\n}\n.float-page .content .box-result .box__header .box__title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  background: none;\n  height: 34px;\n}\n.float-page .content .box-result .box__header .box__title span {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.4;\n  color: #ffffff;\n}\n.float-page .content .box-result .box__header .box__title span.tit {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: auto;\n  height: 100%;\n  padding-left: 20px;\n  padding-right: 45px;\n  cursor: pointer;\n  background: #003875;\n  position: relative;\n}\n.float-page .content .box-result .box__header .box__title span.tit:after {\n  content: \"\";\n  position: absolute;\n  right: -34px;\n  top: 0;\n  width: 0;\n  height: 0;\n  border-bottom: 17px solid transparent;\n  border-top: 17px solid #003875;\n  border-left: 17px solid #003875;\n  border-right: 17px solid transparent;\n}\n.float-page .content .box-result .box__header .box__title span.tit span {\n  max-width: calc(100% - 28px);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.float-page .content .box-result .box__header .box__title span.tit .btn-edit {\n  width: 24px;\n  height: 24px;\n  background: url(\"../img/icon_pen_g.png\") no-repeat center center;\n  background-size: 100%;\n  filter: brightness(0) invert(1);\n}\n.float-page .content .box-result .box__header .box__title span.date {\n  font-weight: 400;\n  color: #2a2c2f;\n}\n.float-page .content .box-result section {\n  padding: 30px 20px 0;\n  background: #fff;\n}\n.float-page .content .box-result section::after {\n  content: \"\";\n  width: calc(100% + 80px);\n  height: 1px;\n  background: #dde2e9;\n  margin: 48px -40px 16px;\n  display: block;\n}\n.float-page .content .box-result section .section-top {\n  margin-bottom: 36px;\n  border-bottom: 2px solid #0f5fa5;\n  padding-bottom: 10px;\n}\n.float-page .content .box-result section .section-top .tit {\n  font-size: 20px;\n  font-weight: 500;\n}\n.float-page .content .box-result section .section-bottom {\n  border: 0;\n  border-radius: 0;\n  padding: 0;\n}\n.float-page .content .box-result section .section-bottom + .section-bottom {\n  border-top: 2px solid #dde2e9;\n  padding-top: 32px;\n  margin-top: 32px;\n}\n.float-page .content .box-result section .section-bottom .part:not(.line) + .part:not(.line) {\n  margin-top: 32px;\n}\n.float-page .content .box-result section .section-bottom .part.line {\n  border-bottom: 2px solid #dde2e9;\n  padding-bottom: 40px;\n  margin-bottom: 40px;\n}\n.float-page .content .box-result section .section-bottom .tbl-list {\n  margin: 0;\n  border-bottom: 2px solid #dde2e9;\n}\n.float-page .content .box-result section .section-bottom .tbl-list th {\n  height: 24px;\n  padding: 4px 16px;\n}\n.float-page .content .box-result section .section-bottom .tbl-list.row {\n  border-top: 2px solid #dde2e9;\n}\n.float-page .content .box-result section .section-bottom .tbl-list.row th {\n  height: auto;\n  padding: 12px 16px;\n  vertical-align: top;\n}\n.float-page .content .box-result section .section-bottom .tbl-list.row td {\n  height: auto;\n  padding: 12px 16px;\n  vertical-align: top;\n}\n.float-page .content .box-result section .section-bottom .tbl-list.row td button.add__item {\n  margin: -4px -16px;\n  width: calc(100% + 32px);\n  height: 40px;\n  background: #e6f0ff;\n  border-radius: 4px;\n  border: 0;\n  justify-content: flex-start;\n}\n.float-page .content .box-result section .section-bottom .tbl-list.row td button.add__item span {\n  display: flex;\n  align-items: center;\n  color: #0a78ff;\n}\n.float-page .content .box-result section .section-bottom .tbl-list.row td button.add__item span:before {\n  content: \"\";\n  background: url(\"../img/icon_plus.png\") no-repeat center center;\n  width: 12px;\n  height: 12px;\n  margin-right: 12px;\n  background-size: 100%;\n}\n.float-page .content .box-result section .section-bottom .tbl-list.td-40 td {\n  height: auto;\n  padding: 12px 16px;\n  vertical-align: top;\n}\n.float-page .content .box-result section .section-bottom .tbl-list td {\n  height: auto;\n  padding: 16px;\n  vertical-align: top;\n}\n.float-page .content .box-result section .section-bottom .tbl-list td .btn {\n  width: 24px;\n  height: 24px;\n  padding: 0;\n}\n.float-page .content .box-result section .section-bottom .tbl-list.tbl-border {\n  border-top: 1px solid #909fb7;\n  border-bottom: 1px solid #909fb7;\n  border-right: 1px solid #909fb7;\n}\n.float-page .content .box-result section .section-bottom .tbl-list.tbl-border th {\n  border-left: 1px solid #909fb7;\n  padding: 4px 8px;\n}\n.float-page .content .box-result section .section-bottom .tbl-list.tbl-border td {\n  padding: 6px 8px 5px;\n  height: auto;\n  border-left: 1px solid #909fb7;\n  border-top: 1px solid #909fb7;\n  background: #fff !important;\n  line-height: 1.5;\n}\n.float-page .content .box-result section .section-bottom .tbl-list.tbl-border td .ellipsis {\n  width: 100%;\n}\n.float-page .content .box-result section .section-bottom .tbl-list.tbl-border td .flex-inline .ellipsis {\n  width: calc(100% - 26px);\n}\n.float-page .content .box-result section .section-bottom textarea {\n  height: 170px;\n}\n.tbl-list table td.score-line {\n  padding: 0 0 0 12px !important;\n}\n.tbl-list table td .score-line {\n  padding: 0 !important;\n}\n.tbl-list table td .score-line ul + ul {\n  margin-top: 16px;\n}\n.tbl-list table .score-line ul li {\n  display: flex;\n  min-height: 36px;\n  vertical-align: middle;\n}\n.tbl-list table .score-line ul li span {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 0 0 12px;\n}\n.tbl-list table .score-line ul li + li {\n  border-top: 2px solid #dde2e9;\n}\n.float-page .content .box-result section .section-bottom .tbl__top p.tit {\n  font-weight: 500;\n  color: #2a2c2f;\n}\n.float-page .content .box-result section .section-bottom .tbl__top p {\n  font-weight: 350;\n  color: #7a8596;\n}\n.float-page .content .box-result section .section-bottom .tbl__top .btn-area {\n  margin-top: 0;\n}\n.float-page .content .box-result section .section-bottom .tbl__top .btn-area .btn {\n  width: 32px;\n  height: 32px;\n}\n.float-page .content .box-result section .section-bottom .tbl__top .btn-area .btn.btn-edit-g {\n  background: url(\"../img/icon_pen_g.png\") no-repeat center center;\n  background-size: 100%;\n}\n.float-page .content .box-result .tit-bar {\n  margin-bottom: 20px;\n  padding: 8px 20px;\n  background: rgba(227, 231, 238, 0.5);\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 1.6;\n  letter-spacing: -0.7px;\n  color: #2a2c2f;\n}\n.float-page .content .box-result .detail-area {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  padding: 0 20px 0;\n}\n.float-page .content .box-result .detail-area li {\n  display: flex;\n}\n.float-page .content .box-result .detail-area li .tit {\n  flex: 1;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1.7;\n  letter-spacing: -0.7px;\n  color: #2a2c2f;\n}\n.float-page .content .box-result .detail-area li .txt-area {\n  flex: 6;\n  overflow: hidden;\n}\n.float-page .content .box-result .detail-area li .txt-area p {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.7;\n  letter-spacing: -0.7px;\n  color: #2a2c2f;\n  word-wrap: break-word;\n  text-align: justify;\n}\n.float-page .content .box-result .detail-area li .txt-area p .txt-gray {\n  color: #7a8596 !important;\n}\n.float-page .content .box-result .detail-area li .img-area {\n  margin-top: 8px;\n  display: flex;\n  gap: 8px;\n  height: 300px;\n  overflow-x: auto;\n}\n.float-page .content .box-result .detail-area li .img-area img {\n  object-fit: cover;\n  width: 300px;\n}\n.float-page .content .box-result .detail-area.line {\n  border-top: 2px solid #dde2e9;\n  border-bottom: 2px solid #dde2e9;\n  padding: 20px;\n}\n.float-page .content .box-result section .section-bottom .tbl__top .btn.btn-more {\n  position: relative;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  background: url(\"../img/icon_plus_g.png\") no-repeat center center;\n  background-size: 100%;\n}\n.float-page .content .box-result section .section-bottom .tbl__top .flex-right {\n  width: auto !important;\n  align-items: center;\n}\n.float-page .content .box-result section .section-bottom .tbl__top p strong {\n  color: #2a2c2f;\n  font-weight: 500;\n}\n.float-page .content .box-result .btn-area {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 16px 0 0;\n}\n.float-page .content .box-result .btn-area.m-block {\n  display: flex !important;\n}\n.float-page .content .box-result .btn-area button.btn-basic {\n  height: 48px;\n  min-width: 219px;\n  width: auto;\n}\n.float-page .content .box-result .btn-area button.btn-basic span {\n  font-size: 20px;\n}\n.float-page .content .box-result .total-score .score-top {\n  border-bottom: 1px solid #e5e6ee;\n  padding-bottom: 40px;\n  margin-bottom: 40px;\n  display: flex;\n  flex-direction: column;\n}\n/* .float-page .content .box-result .total-score .score-top .tit {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1.4;\n  letter-spacing: -0.4px;\n  color: #ff7836;\n} */\n.float-page .content .box-result .total-score .score-top .score {\n  font-weight: 500;\n  font-size: 44px;\n  line-height: 1.2;\n  letter-spacing: -0.4px;\n  color: #2c364e;\n  margin: 2px 0 14px;\n}\n.float-page .content .box-result .total-score .score-top .score span {\n  color: #909fb7;\n  font-weight: 400;\n  font-size: 24px;\n  margin-left: 3px;\n}\n.float-page .content .box-result .total-score .score-top .info {\n  display: inline-flex;\n  flex-wrap: wrap;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 1.4;\n  letter-spacing: -1px;\n  color: #2a2c2f;\n  padding-left: 28px;\n  background: url(\"../img/icon_info_gr.png\") no-repeat 0 -2px;\n  background-size: 28px;\n}\n.float-page .content .box-result .total-score .score-top.caution .info {\n  background: url(\"../img/icon_info_r.png\") no-repeat 0 -2px;\n  background-size: 28px;\n}\n.float-page .content .box-result .total-score .score-top .info .tit {\n  color: #1fc95c;\n  margin-right: 8px;\n}\n.float-page .content .box-result .total-score .score-top.caution .info .tit {\n  color: #f55547;\n}\n.float-page .content .box-result .total-score .score-top .info .txt {\n  flex: 1;\n}\n.float-page .content .box-result .total-score .score-top .info-line {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin-top: 5px;\n  gap: 20px;\n}\n.float-page .content .box-result .total-score .score-top .info-line p {\n  color: #7a8596;\n  font-size: 16px;\n  line-height: 1.3;\n}\n.float-page .content .box-result .total-score .graph-box {\n  /* height: 342px; */\n  height: auto;\n  display: flex;\n  gap: 15px;\n}\n.float-page .content .box-result .total-score .graph-area {\n  flex: 1.4;\n}\n.float-page .content .box-result .total-score .graph-area + .graph-area {\n  flex: 1;\n}\n\n.float-page .content .box-result .detail-area.form__input {\n  gap: 24px;\n  padding: 0;\n}\n.float-page .content .box-result .detail-area.form__input li {\n  margin: 0;\n}\n.float-page .content .box-result .form__input li .tit {\n  flex: 1;\n  min-width: 100px;\n}\n.float-page .content .box-result .form__input .input__area {\n  flex: 7;\n}\n.float-page .content .box-result .form__input .filebox .upload-name {\n  height: 30px;\n}\n.float-page .content .box-result .form__input input[type=\"text\"],\n.float-page .content .box-result .form__input input[type=\"password\"],\n.float-page .content .box-result .form__input input[type=\"tel\"],\n.float-page .content .box-result .form__input input[type=\"file\"],\n.float-page .content .box-result .form__input .box__search input[type=\"text\"],\n.float-page .content .box-result .form__input .select {\n  height: 30px;\n}\n.float-page .content .box-result .form__input .select {\n  font-size: 16px;\n}\n.float-page .content .box-result .form__input .input__area .txt-info {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 15px;\n  letter-spacing: -0.4px;\n  color: #909fb7;\n  margin-top: 5px;\n  margin-left: 0;\n}\n.float-page .content .box-result .form__input .filelist {\n  display: inline-table;\n}\n.float-page .content .box-result .form__input .filelist li {\n  display: inline-flex;\n  flex-direction: row !important;\n  align-items: center !important;\n  gap: 4px;\n  margin-bottom: 4px;\n}\n.float-page .content .box-result .form__input .filelist li .btn-delete {\n  margin-left: 0;\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_delete_x_lg.png\") no-repeat center center;\n  background-size: 100%;\n}\n.float-page .content .box-result .form__input .filelist li span {\n  font-size: 14px;\n  line-height: 1.7;\n}\n.float-page .content .box-result .form__input .filelist li:not(:first-child) span {\n  background: none;\n}\n.float-page .content .box-result .imglist {\n  margin-top: 40px;\n  padding-top: 24px;\n  border-top: 1px solid #dde2e9;\n}\n.float-page .content .box-result .imglist .tit {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n.float-page .content .box-result .imglist .imgbox-area {\n  display: flex;\n  gap: 14px;\n  overflow-x: auto;\n}\n.float-page .content .box-result .imglist .imgbox-area li + li {\n  margin: 0;\n}\n.float-page .content .box-result .imglist .imgbox-area .tit {\n  margin-bottom: 8px;\n}\n.float-page .content .box-result .imglist .imgbox-area .img-area {\n  height: 468px;\n  width: 100%;\n  overflow-x: hidden;\n}\n.float-page .content .box-result .imglist .imgbox-area .img-area.js-open {\n  cursor: pointer;\n}\n.float-page .content .box-result .imglist .imgbox-area .img-area img {\n  width: auto;\n  height: 100%;\n  object-fit: contain;\n}\n.float-page .content .box-result .imglist .imgbox-area .tit .btn-area {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  width: 75px !important;\n  margin: 0;\n}\n.float-page .content .box-result .imglist .imgbox-area .tit .btn-area button {\n  width: 32px;\n  height: 32px;\n}\n.float-page .content .box-result .imglist .imgbox-area .tit .btn-area button.btn-edit-g {\n  background: url(\"../img/icon_pen_g.png\") no-repeat center center;\n  background-size: 100%;\n}\n.float-page .content .box-result .imglist .imgbox-area .tit .btn-area button.btn-delete-gr {\n  background: url(\"../img/icon_delete_gr.png\") no-repeat center center;\n  background-size: 100%;\n}\n\n@media screen and (max-width: 1399px) {\n  .float-page .content .box-result {\n    width: 80%;\n  }\n}\n@media screen and (max-width: 990px) {\n  .float-page .content .box-result {\n    width: 100%;\n  }\n}\n@media screen and (max-width: 940px) {\n  .float-page .content.w100p {\n    margin-top: 0;\n  }\n  .float-page .content .box-result .m-none,\n  .float-page .content .box-result-top .m-none {\n    display: none !important;\n  }\n  .float-page .content .box-result .m-block:not(td),\n  .float-page .content .box-result-top .m-block:not(td) {\n    display: none !important;\n  }\n  #wrap:not(.no-responsive) .float-page .content .box-result section .section-bottom .tbl-list:not(.row) table td {\n    height: auto;\n    padding: 16px;\n    vertical-align: top;\n  }\n  .float-page .content .box-result section .section-bottom .tbl-list td,\n  .float-page .content .box-result section .section-bottom .tbl-list.row td,\n  .float-page .content .box-result section .section-bottom .tbl-list.row th,\n  .float-page .content .box-result section .section-bottom .tbl-list.td-40 td {\n    height: auto !important;\n    padding: 15px 16px 14px;\n    vertical-align: top;\n  }\n  .float-page .content .box-result section .section-bottom .tbl-list.td-40 th {\n    height: auto !important;\n    padding: 11px 16px 10px;\n    vertical-align: top;\n  }\n  .float-page .content .box-result section .section-bottom .tbl-list.tbl-border td {\n    height: auto !important;\n    padding: 12px 8px 11px;\n    vertical-align: top;\n  }\n}\n@media screen and (max-width: 840px) {\n  .float-page .content.w100p {\n    position: relative;\n    margin-top: 0;\n    background: #fff;\n    gap: 0;\n  }\n  .float-page .content .box-result {\n    width: calc(100% - 20px);\n    padding: 0 10px 24px;\n  }\n  .float-page .content .box-result .m-none {\n    display: none !important;\n  }\n\n  .float-page .content .box-result .m-block:not(td),\n  .float-page .content .box-result-top .m-block:not(td) {\n    display: block !important;\n  }\n  .float-page .content .box-result .m-block-w60p {\n    width: 60%;\n  }\n  .float-page .content .box-result .m-block-w10p {\n    width: 10%;\n  }\n  .float-page .content .box-result-top .txt {\n    display: none;\n  }\n  .float-page .content .box-result-top .btn-area {\n    display: none;\n  }\n  .float-page .content .box-result-top .btn-area.open {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    gap: 16px;\n    position: absolute;\n    background: #fff;\n    top: 56px;\n    left: 0;\n    width: 100%;\n    height: calc(100vh - 154px);\n    margin: 0;\n    z-index: 1;\n  }\n  .float-page .content .box-result-top .btn-area.open button {\n    width: calc(100% - 40px);\n    min-width: calc(100% - 40px);\n    height: 48px;\n  }\n  .float-page .content .box-result-top .btn-area.open button:first-child {\n    margin-top: 16px;\n  }\n  .float-page .content .box-result-top .btn-area.open button span {\n    font-size: 20px;\n  }\n  .float-page .content .box-result-top .btn-area.open button + button {\n    margin-left: 0;\n  }\n  .float-page .content .box-result-top .m-block button {\n    justify-content: space-between;\n    height: 52px;\n    min-width: 100%;\n    width: 100%;\n    border-radius: 0;\n    border: 0;\n    border-bottom: 1px solid #dde2e9;\n    background: #fff;\n  }\n  .float-page .content .box-result-top .m-block button:after {\n    content: \"\";\n    width: 24px;\n    height: 24px;\n    background: url(\"../img/icon_down_g.png\") no-repeat right center;\n    background-size: 100%;\n  }\n  .float-page .content .box-result-top .m-block button.action:after {\n    transform: scaleY(-1);\n  }\n  .float-page .content .box-result-top .m-block button span {\n    color: #909fb7;\n    font-weight: 400;\n    font-size: 16px;\n    letter-spacing: -1px;\n    text-align: left;\n    width: calc(100% - 30px);\n  }\n  .float-page .content .box-result .box__header {\n    margin-bottom: 10px;\n  }\n  .float-page .content section + section {\n    margin-top: 24px;\n  }\n  .float-page .content .box-result section {\n    padding: 30px 10px 0;\n  }\n  .float-page .content .box-result section .section-top .tit {\n    font-size: 24px;\n  }\n  .float-page .content .box-result .total-score .score-top .score span {\n    font-size: 44px;\n  }\n  .float-page .content .box-result .total-score .score-top .score span {\n    font-size: 24px;\n  }\n  .float-page .content .box-result .total-score .score-top .info {\n    font-size: 20px;\n  }\n  .float-page .content .box-result .total-score .score-top .info-line {\n    margin-top: 20px;\n    flex-direction: column;\n  }\n  .float-page .content .box-result .total-score .score-top .info-line button {\n    width: 100%;\n  }\n  .float-page .content .box-result section .section-bottom .tbl__top {\n    flex-direction: row;\n    align-items: center;\n  }\n  .float-page .content .box-result section .section-bottom .tbl__top p {\n    font-size: 20px;\n  }\n  .float-page .content .box-result section .section-bottom .tbl__top .btn-area {\n    width: auto;\n    margin: 0;\n  }\n  .float-page .content .box-result section .section-bottom .tbl__top .btn-area .btn {\n    width: 32px;\n    height: 32px;\n  }\n  .float-page .content .box-result section .section-bottom .tbl-list th {\n    padding: 4px;\n  }\n  .float-page .content .box-result .tit-bar {\n    font-size: 18px;\n    padding: 10px 16px;\n    margin-bottom: 24px;\n  }\n  .float-page .content .box-result .detail-area {\n    gap: 40px;\n  }\n  .float-page .content .box-result .detail-area li .tit,\n  .float-page .content .box-result .detail-area li .txt-area p {\n    font-size: 16px;\n  }\n  .float-page .content .box-result .detail-area li {\n    flex-direction: column;\n    gap: 10px;\n  }\n  .float-page .content .box-result .detail-area li .img-area {\n    height: 240px;\n  }\n  .float-page .content .box-result .total-score .graph-box {\n    flex-direction: column;\n    gap: 40px;\n  }\n  .float-page .content .box-result .total-score .graph-area {\n    flex: auto;\n  }\n  .float-page .content .box-result .part.flex-row {\n    flex-direction: column !important;\n  }\n  .float-page .content .box-result .part.flex-row.gap-20 {\n    gap: 32px !important;\n  }\n  .float-page .content .box-result .detail-area.form__input {\n    gap: 16px;\n  }\n}\n@media screen and (max-width: 610px) {\n  .float-page .content .box-result .m-block-w60p {\n    width: 52%;\n  }\n}\n@media screen and (max-width: 499px) {\n  .float-page .content .box-result .btn-area {\n    width: 100%;\n    margin: 0;\n  }\n  /* .float-page .content .box-result .box__header {\n    background: url('../img/bg_top_result_m.png') no-repeat 0 0 #fff;\n    background-size: 77% 32px;\n  } */\n  .float-page .content .box-result .box__header .box__title span.tit {\n    width: auto;\n    max-width: 60%;\n    padding-left: 11px;\n    padding-right: 15px;\n  }\n  .float-page .content .box-result section .section-bottom textarea {\n    height: 234px;\n  }\n  .float-page .content .box-result .form__input .filebox .upload-name,\n  .float-page .content .box-result .form__input input[type=\"text\"],\n  .float-page .content .box-result .form__input input[type=\"password\"],\n  .float-page .content .box-result .form__input input[type=\"tel\"],\n  .float-page .content .box-result .form__input input[type=\"file\"],\n  .float-page .content .box-result .form__input .box__search input[type=\"text\"],\n  .float-page .content .box-result .form__input .select {\n    height: 38px;\n  }\n  .float-page .content .box-result .detail-area.form__input .input__area .btn-basic {\n    width: 100%;\n  }\n  .float-page .content .box-result .imglist .imgbox-area {\n    flex-direction: column;\n    gap: 20px;\n  }\n  .float-page .content .box-result .imglist .imgbox-area .img-area {\n    height: auto;\n  }\n  .float-page .content .box-result .imglist .imgbox-area .img-area img {\n    width: 100%;\n  }\n  .float-page .content .box-result .imglist .tit span {\n    font-weight: 500;\n  }\n  .float-page .content .box-result .m-block-w60p {\n    width: 37%;\n  }\n}\n\n/* management - 체크시트 관리 - 상세유형  리스트  */\n.content.w100p {\n  width: 100%;\n  padding-left: 0;\n}\n.content.w100p .tab__line li {\n  padding: 15px 14px 14px;\n}\n.content.w100p .tab__line li a {\n  font-size: 16px;\n  font-weight: 500;\n  color: #646c74;\n}\n.content.w100p .box {\n  width: 100%;\n}\n.content.w100p .box .box-wrap,\n.content.w100p .box .content-wrap {\n  width: 100%;\n}\n.no-responsive .box-wrap {\n  display: flex;\n  height: calc(100% - 49px);\n}\n.no-responsive .treebar.box {\n  width: 304px;\n}\n.no-responsive .treebar.box + .content-wrap {\n  width: calc(100% - 304px);\n  position: relative;\n}\n.tbl-list table td button.btn {\n  width: 32px;\n  height: 32px;\n  background-size: 100%;\n}\n.tbl-list table td button.btn.btn-delete-gr {\n  filter: none;\n}\n.tbl-list table td button.btn.btn-edit-g {\n  background-size: contain;\n}\n.tbl-list table td button.btn.btn-comment {\n  background: url(\"../img/icon_pen_on.png\") no-repeat center center;\n  background-size: 100%;\n}\n.tbl-list table td button.btn.btn-comment:hover {\n  opacity: 1 !important;\n  filter: none !important;\n}\n.tbl-list table td button.btn.btn-comment.icon-gray {\n  opacity: 1 !important;\n  filter: none !important;\n  background-color: unset !important;\n  border-color: unset !important;\n  background: url(\"../img/icon_pen.png\") no-repeat center center;\n  background-size: 100%;\n}\n\n/* management - 체크시트 관리 - 왼쪽 메뉴 */\n#wrap.no-responsive {\n  min-width: 1580px;\n  overflow-x: auto;\n}\n.no-responsive .treebar.box.menutype {\n  display: block;\n  width: 301px;\n  overflow-y: hidden;\n  box-shadow: none;\n  border-right: 4px solid #dde2e9;\n  border-radius: 0;\n  height: calc(100vh - 115px);\n  min-height: 964px;\n}\n.no-responsive .treebar.box.menutype .box__header {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  height: auto;\n  padding: 12px 15px 11px;\n  border-bottom: 1px solid #dde2e9;\n}\n.no-responsive .treebar.box.menutype .box__header .title-info {\n  font-weight: 400;\n  margin-top: 4px;\n  margin-bottom: 30px;\n}\n.no-responsive .treebar.box.menutype .box__header .title-info span + span {\n  margin-left: 16px;\n}\n.no-responsive .treebar.box.menutype .box__header .list-info {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 16px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.2;\n  width: 100%;\n}\n.no-responsive .treebar.box.menutype .box__header .list-info span {\n  display: flex;\n  align-items: center;\n}\n.no-responsive .treebar.box.menutype .box__header .list-info span:before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  margin-right: 8px;\n  background: #0a78ff;\n  border-radius: 50%;\n}\n.no-responsive .treebar.box.menutype .box__header .list-info span.not::before {\n  background: #f55547;\n}\n.no-responsive .treebar.box.menutype .manuarea {\n  overflow-y: auto;\n  height: calc(100% - 41px);\n}\n.no-responsive .treebar.box.menutype .manuarea .manulist li {\n  height: 45px;\n  border-bottom: 1px solid #dde2e9;\n}\n.no-responsive .treebar.box.menutype .manuarea .manulist li a {\n  padding: 0 16px 0 20px;\n  margin-right: 0;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n.no-responsive .treebar.box.menutype .manuarea .manulist li a.ok::before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  background: #0a78ff;\n  border-radius: 50%;\n}\n.no-responsive .treebar.box.menutype .manuarea .manulist li a.not::before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  background: #f55547;\n  border-radius: 50%;\n}\n.no-responsive .treebar.box.menutype .manuarea .manulist li:hover {\n  background: #e8f1fe;\n}\n.no-responsive .treebar.box.menutype .manuarea .manulist li.on {\n  background: #b4d2ff;\n}\n.no-responsive .treebar.box.menutype .manuarea .manulist li.on a p {\n  color: #0a78ff;\n  font-weight: 700;\n}\n.no-responsive .treebar.box.menutype .manuarea .manulist li a.not p,\n.no-responsive .treebar.box.menutype .manuarea .manulist li a.ok p {\n  margin-left: 16px;\n}\n.no-responsive .treebar.box.menutype .manuarea .manulist li a p {\n  display: block;\n  flex: 4;\n  width: auto;\n  margin-left: 26px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.no-responsive .treebar.box.menutype .manuarea .manulist li a .txt {\n  flex: 1;\n  color: #0a78ff;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 1.2;\n  text-align: right;\n}\n.no-responsive .treebar.box.menutype .manuarea .manulist li.title-line:first-child {\n  margin-top: 0;\n}\n.no-responsive .treebar.box.menutype .manuarea .manulist li.title-line {\n  position: relative;\n  margin-top: 24px;\n  padding: 0 0 0 12px;\n  margin-right: 0;\n  display: flex;\n  align-items: center;\n  background: #f0f2f4;\n}\n.no-responsive .treebar.box.menutype .manuarea .manulist li.title-line p {\n  width: calc(100% - 32px);\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 1;\n  color: #2a2c2f;\n}\n.no-responsive .treebar.box.menutype .manuarea .manulist li.title-line .popup-etc {\n  right: 2px;\n  top: 37px;\n}\n.no-responsive .treebar.box.menutype .manuarea .manulist li.title-line .popup-etc li {\n  height: auto;\n  border-bottom: 0;\n}\n.no-responsive .treebar.box.menutype .manuarea .manulist li.title-line .popup-etc li button.btn-add-g {\n  padding-left: 13px !important;\n  background-position: 0 5px !important;\n}\n.no-responsive .treebar.box.menutype .manuarea .manulist li.title-line .popup-etc li button.btn-add-g:hover {\n  border-radius: 4px;\n}\n.no-responsive .treebar.box.menutype .manuarea .manulist li.title-line .popup-etc li button.btn-add-g:active {\n  border-radius: 4px;\n}\n\n/* management - 체크시트 관리 - 점검항목 리스트 */\n.go-back {\n  width: 32px;\n  height: 32px;\n  border: 0;\n  border-radius: 0;\n  margin-right: 8px;\n  background: url(\"../img/icon_goback.png\") no-repeat center center;\n  background-size: 100%;\n}\n.tbl-list table td .list-icon {\n  width: 24px;\n  height: 24px;\n  vertical-align: middle;\n}\n.btn-guide {\n  width: 32px;\n  height: 32px;\n  background: url(\"../img/icon_guide_blue.png\") no-repeat center center;\n  background-size: 100%;\n}\n.tbl-list table td button.btn.btn-guide:hover {\n  opacity: 1 !important;\n  filter: none !important;\n}\n.tbl-list table td button.btn.btn-guide.icon-gray {\n  opacity: 1 !important;\n  filter: none !important;\n  background-color: unset !important;\n  border-color: unset !important;\n  background: url(\"../img/icon_guide.png\") no-repeat center center;\n  background-size: 100%;\n}\n.tbl-list table td ul.input__area {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.tbl-list table td ul.input__area li {\n  display: flex;\n  align-items: center;\n}\n.tbl-list table td .btn-add-wide {\n  width: 100%;\n  height: 40px;\n  background: #e7f2ff;\n  border-radius: 4px;\n  border: 0;\n  justify-content: flex-start;\n}\n.tbl-list table td .btn-add-wide span {\n  color: #0978ff;\n  display: flex;\n  align-items: center;\n}\n.tbl-list table td .btn-add-wide span::before {\n  content: \"\";\n  width: 12px;\n  height: 12px;\n  margin-right: 12px;\n  background: url(\"../img/icon_plus.png\") no-repeat center center;\n  background-size: 100%;\n}\n.go-back.tooltip-link::before {\n  background: #fff;\n  top: 90%;\n  width: 140%;\n  font-weight: 700;\n  color: #646c74;\n}\n.float-page .body-left .left-bottom .btn-txt.next {\n  position: absolute;\n  right: 24px;\n}\n.float-page .body-left .left-bottom .btn-area.sm-column .right {\n  position: absolute;\n  right: 24px;\n}\n.float-page .body-left .left-bottom .btn-area.sm-column .right .btn-txt.next {\n  position: relative;\n}\n.btn-txt.next span,\n.float-page .content .btn-area button.btn-txt.next span {\n  font-weight: 400;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n}\n.btn-txt.next span:after {\n  content: \"\";\n  width: 16px;\n  height: 16px;\n  margin-left: 4px;\n  background: url(\"../img/icon_arrow_left.png\") no-repeat center center;\n  background-size: 100%;\n  transform: scaleX(-1);\n}\n\n/* Report - 점검결과 - 단일 유형별리스트*/\n/* Report - 점검결과 - 단일 유형별리스트 - 왼쪽 메뉴(반응형) */\n#wrap:not(.float-page, .no-responsive) .treebar.box {\n  width: 282px;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype {\n  display: block;\n  width: 301px;\n  overflow-y: hidden;\n  box-shadow: none;\n  border-right: 4px solid #dde2e9;\n  border-radius: 0;\n  height: calc(100vh - 115px);\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .box__header {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  height: auto;\n  padding: 12px 15px 11px;\n  border-bottom: 1px solid #dde2e9;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .box__header .title-info {\n  font-weight: 400;\n  margin-top: 4px;\n  margin-bottom: 30px;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .box__header .title-info span + span {\n  margin-left: 16px;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .box__header .list-info {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 16px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.2;\n  width: 100%;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .box__header .list-info span {\n  display: flex;\n  align-items: center;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .box__header .list-info span:before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  margin-right: 8px;\n  background: #0a78ff;\n  border-radius: 50%;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .box__header .list-info span.not::before {\n  background: #f55547;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea {\n  overflow-y: auto;\n  height: calc(100% - 41px);\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li {\n  height: 45px;\n  border-bottom: 1px solid #dde2e9;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li a {\n  padding: 0 16px 0 20px;\n  margin-right: 0;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li a.ok::before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  background: #0a78ff;\n  border-radius: 50%;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li a.not::before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  background: #f55547;\n  border-radius: 50%;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist > li a:hover,\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea li.arrow:hover {\n  background: #e8f1fe !important;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li.on,\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li.on a:hover,\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li.title-line.on,\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea li.arrow.on,\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li:active a {\n  background: #b4d2ff !important;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li.on a p,\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li.title-line.on p {\n  color: #0a78ff;\n  font-weight: 700;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li a.not p,\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li a.ok p {\n  margin-left: 16px;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li a p {\n  display: block;\n  flex: 4;\n  width: auto;\n  margin-left: 26px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: normal;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li a .txt {\n  flex: 1;\n  color: #0a78ff;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 1.2;\n  text-align: right;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li.title-line:first-child {\n  margin-top: 0;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li.title-line {\n  position: relative;\n  margin-top: 24px;\n  padding: 0 0 0 12px;\n  margin-right: 0;\n  display: flex;\n  align-items: center;\n  background: #f0f2f4;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li.title-line p {\n  width: calc(100% - 32px);\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 1;\n  color: #2a2c2f;\n  margin-left: 8px;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li.arrow p {\n  margin-left: 20px;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li.title-line .popup-etc {\n  right: 2px;\n  top: 37px;\n}\n#wrap:not(.float-page, .no-responsive) .selectbar.box.menutype {\n  display: none;\n}\n\n@media screen and (max-width: 1650px) {\n  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype {\n    height: auto;\n  }\n}\n@media screen and (max-width: 940px) {\n  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype {\n    display: none;\n  }\n  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype.active {\n    display: block;\n    top: 102px;\n    z-index: 22;\n  }\n  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype.active {\n    position: fixed;\n    display: block;\n    top: 154px;\n    left: 0;\n    width: 100%;\n    border: 0;\n    padding: 0;\n    margin: 0;\n    z-index: 21;\n  }\n  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype .box__header,\n  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype .box__header {\n    display: flex;\n    height: auto;\n    padding: 18px 20px 12px;\n  }\n  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype .box__header .box__title,\n  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype .box__header .title-info {\n    display: none;\n  }\n  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype .box__header .list-info {\n    margin-top: 0;\n  }\n  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea {\n    height: calc(100vh - 202px);\n  }\n  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li {\n    height: 58px;\n  }\n  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li a p,\n  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li.title-line p {\n    font-size: 16px;\n  }\n  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype .manuarea {\n    height: calc(100vh - 154px);\n  }\n  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype .manuarea .manulist li {\n    height: 58px;\n    border-bottom: 1px solid #dde2e9;\n  }\n  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype .manuarea .manulist li a {\n    padding: 0 16px 0 20px;\n    margin-right: 0;\n    height: 100%;\n    display: flex;\n    align-items: center;\n  }\n  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype .manuarea .manulist li:hover {\n    background: #e8f1fe;\n  }\n  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype .manuarea .manulist li.on {\n    background: #b4d2ff;\n  }\n  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype .manuarea .manulist li.on a p {\n    color: #0a78ff;\n    font-weight: 700;\n  }\n  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype .manuarea .manulist li a p {\n    display: block;\n    flex: 4;\n    width: auto;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: normal;\n    letter-spacing: -0.4px;\n    color: #2a2c2f;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n@media screen and (max-width: 679px) {\n  /* .float-page .treebar.box.active {\n    top: 153px;\n  } */\n}\n\n/* Report - 점검결과 - 단일 유형별리스트 - 레이아웃 영역*/\n#wrap:not(.no-responsive) .box-wrap {\n  display: flex;\n}\n#wrap:not(.no-responsive) .treebar.box + .content-wrap {\n  width: calc(100% - 304px);\n}\n#wrap:not(.no-responsive) .content-wrap .box__header {\n  padding-bottom: 21px;\n}\n@media screen and (max-width: 940px) {\n  #wrap:not(.no-responsive) .treebar.box + .content-wrap {\n    width: 100%;\n  }\n}\n\n/* Report - 점검결과 - 단일 유형별리스트 - 컨텐츠 영역*/\n.score-info {\n  display: flex;\n  align-items: center;\n}\n.score-info:before {\n  content: \"\";\n  width: 8px;\n  height: 8px;\n  margin-right: 8px;\n  border-radius: 50%;\n}\n.score-info.green:before {\n  background: #1fc95c;\n}\n.score-info.orange:before {\n  background: #ff7836;\n}\n.score-info.yellow:before {\n  background: #ffbc0a;\n}\n.score-info.gray:before {\n  background: #909fb7;\n}\n.score-level {\n  padding-left: 18px;\n}\n.score-level.danger {\n  background: url(\"../img/icon_danger.png\") no-repeat 0 2px;\n  background-size: 12px;\n}\n.score-level.safety {\n  background: url(\"../img/icon_safety.png\") no-repeat 0 2px;\n  background-size: 12px;\n}\n\n/* 페이지 검색 영역 */\n.tbl__top > .search {\n  width: 100%;\n}\n.tbl__top > .search ul.form__input {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px 3%;\n  width: 100%;\n}\n.tbl__top > .search ul.form__input:has(.wmin-64) {\n  justify-content: space-between;\n}\n.tbl__top > .search ul.form__input li {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin: 0;\n}\n.tbl__top > .search ul.form__input .input__area {\n  width: auto;\n}\n.tbl__top > .search ul.form__input .input__area:has(.btn-basic.bg-sky) {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n@media screen and (max-width: 940px) {\n  .tbl__top > .search ul.form__input .input__area:has(.btn-basic.bg-sky) {\n    align-items: normal;\n    flex-direction: column;\n  }\n}\n.tbl__top > .search ul.form__input li > span:not(.centerline) {\n  min-width: 72px;\n  margin-top: 8px;\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 1.1;\n  color: #2a2c2f;\n}\n.tbl__top > .search ul.form__input li button.btn-basic {\n  margin-left: 0;\n}\n.tbl__top > .search ul.form__input .input__area + button,\n.tbl__top > .search ul.form__input .input__area + button.btn-basic {\n  margin-left: -8px;\n}\nbutton.btn-basic.btn-more:after {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  margin-left: 4px;\n  background: url(\"../img/icon_arrow_right_g@3x.png\") no-repeat center center;\n  background-size: 100%;\n}\n\n.tbl__top .right .inline-flex {\n  width: 100%;\n  display: inline-flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 10px 12px;\n}\n\n@media screen and (max-width: 1599px) {\n  .tbl__top > .search ul.form__input {\n    gap: 10px 1%;\n  }\n}\n@media screen and (max-width: 940px) {\n  .tbl__top:not(.m-none) + .tbl__top {\n    margin-top: 40px;\n  }\n  .tbl__top > .search ul.form__input li {\n    width: 100%;\n  }\n  .tbl__top > .search ul.form__input .input__area {\n    width: 100%;\n  }\n  .tbl__top > .search ul.form__input .input__area .select,\n  .tbl__top > .search ul.form__input .input__area input[type=\"text\"] {\n    width: 100% !important;\n    height: 38px;\n  }\n  .tbl__top > .search ul.form__input .input__area .searchterm .term__month {\n    width: calc(100% - 2px) !important;\n    height: 38px;\n  }\n  .tbl__top > .search ul.form__input {\n    gap: 20px;\n  }\n  .tbl__top > .search ul.form__input li {\n    gap: 10px;\n  }\n  .tbl__top > .search ul.form__input li > span:not(.centerline) {\n    margin-top: 0;\n  }\n  .tbl__top > .search ul.form__input .input__area + button,\n  .tbl__top > .search ul.form__input .input__area + button.btn-basic {\n    margin-left: 0;\n  }\n  .tbl__top > .search ul.form__input li button.btn-basic {\n    width: 100%;\n  }\n  .searchterm .term__month .selected {\n    width: calc(100% - 0.6rem) !important;\n  }\n  .searchterm .term__month {\n    width: calc(100% - 2px);\n  }\n  .searchterm {\n    width: 100%;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .searchterm .term__month + .term__date {\n    width: 100%;\n    margin-top: 8px;\n    margin-left: 0;\n  }\n  .form__input .searchterm .term__date input[type=\"text\"] {\n    width: calc(100% - 51px);\n    font-size: 14px;\n    padding-left: 39px;\n    background-position: 10px center;\n  }\n}\n\n/* Report - 점검결과 - 단일 유형별리스트 - 오른쪽 팝업 영역 */\n.popup-type3 .popup__body .check-area .check-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 16px;\n  margin-bottom: 46px;\n  border-bottom: 2px solid #dde2e9;\n  border-radius: 0;\n}\n.popup-type3 .popup__body .check-area input[type=\"checkbox\"] + label {\n  padding-left: 26px;\n}\n.popup-type3 .popup__body .check-area input[type=\"checkbox\"] + label:before {\n  border-radius: 0;\n  width: 12px;\n  height: 12px;\n  top: 4px;\n}\n.popup-type3 .popup__body .check-area input[type=\"checkbox\"] + label:after {\n  top: 4px;\n}\ninput[type=\"checkbox\"]:checked + label:after {\n  width: 12px;\n  height: 12px;\n}\n.popup-type3 .popup__body .check-area .check-top input[type=\"checkbox\"] + label {\n  font-size: 16px;\n  font-weight: 500;\n}\n.popup-type3 .popup__body .check-area .check-list section > input[type=\"checkbox\"] + label {\n  font-size: 16px;\n  font-weight: 500;\n}\n.popup-type3 .popup__body .check-area .check-list {\n  display: flex;\n  flex-direction: column;\n  gap: 46px;\n}\n.popup-type3 .popup__body .check-area .check-list section ul {\n  margin: 12px 0 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.popup-type3 .popup__body .check-area .check-list section ul li {\n  background: #fff;\n  height: 60px;\n  padding: 0 14px 0 22px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.popup-type3 .popup__body .check-area .check-list section ul li input[type=\"checkbox\"] + label {\n  width: 85%;\n  font-size: 16px;\n}\n.popup-type3 .popup__body .check-area .check-list section ul li .tooltip-link p {\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n}\n.popup-type3 .popup__body .check-area .check-list section ul li .tooltip-link::before {\n  max-width: 100%;\n  width: auto;\n  left: 0;\n  top: 20px;\n}\n.popup-type3 .popup__body .check-area .check-list section ul li .btn {\n  width: 32px;\n  height: 32px;\n}\n\n/* Report - 점검결과 - 에너지레포트 리스트 */\n.tbl__top > .search ul.form__input .input__area > .type__cont {\n  margin-left: 0;\n}\n.tbl__top > .search ul.form__input li .type__cont li {\n  margin-right: 4px;\n}\n.tbl__top > .search ul.form__input li .type__cont li a {\n  height: 100%;\n}\n\n@media screen and (max-width: 940px) {\n  .tbl-list table th.sm-w45p {\n    width: 45% !important;\n  }\n  .tbl__top > .search ul.form__input li .type__cont li {\n    margin-right: 4px;\n    width: auto;\n  }\n}\n@media screen and (max-width: 499px) {\n  .tbl-list table th.sm-w45p {\n    width: auto !important;\n  }\n  .tbl-list table th.w3p,\n  .tbl-list table th.w4p {\n    width: 10% !important;\n  }\n}\n\n/* 모니터링 */\n.monitor .treebar.box {\n  /* min-height: 900px; */\n  min-height: unset;\n}\n.monitor .box {\n  width: 100%;\n}\n.time {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.time .btn-refresh {\n  margin: 0 auto;\n  width: 24px;\n  height: 24px;\n  background: url(\"../img/icon_refresh_gr.png\") no-repeat 0 0 transparent;\n  background-size: 100%;\n}\n.time p {\n  font-size: 15px;\n  color: #7a8596;\n  line-height: 1.3;\n}\n.monitor .box__body {\n  padding: 16px 12px 16px 15px;\n  min-height: calc(100% - 116px);\n  max-height: calc(100vh - 182px);\n  overflow-y: auto;\n  background: #f7f8fa;\n}\n.monitor .box__body .box-column {\n  display: flex;\n  gap: 14px;\n  flex-wrap: wrap;\n}\n.monitor .box__body .box-column > li {\n  display: flex;\n  gap: 14px;\n  flex-wrap: nowrap;\n  flex: 1;\n  min-width: 673px;\n}\n.monitor .box__body .box-column > li.w100p {\n  min-width: 100%;\n}\n.monitor .box__body .box-column > li > article {\n  background: #fff;\n  padding: 16px;\n  border-radius: 4px;\n  height: 368px;\n  box-shadow: 0px 3px 8px rgba(144, 159, 183, 0.5);\n  flex: 1;\n}\n.monitor .box__body .box-column > li:nth-child(2) > article,\n.monitor .box__body .box-column > li:nth-child(3) > article,\n.monitor .box__body .box-column > li:nth-child(4) > article {\n  width: 45%;\n}\n.monitor .box__body .box-column > li > article.h-auto {\n  height: 368px !important;\n}\n.monitor .box__body .box-column > li.w100p > article.h-auto {\n  height: auto !important;\n}\n.monitor .box__body .box-column > li > article .top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n.monitor .box__body .box-column > li > article h2 {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.3;\n  color: #2a2c2f;\n}\n.monitor .box__body .box-column > li > article .top > .right {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 16px;\n}\n.monitor .box__body .box-column > li > article:not(.boxtype-tab) > .top .txt-info {\n  font-size: 12px;\n  margin-top: 2px;\n  flex: 1;\n}\n.monitor .box__body .box-column > li > article.boxtype-tab > .top .txt-info {\n  letter-spacing: -1.2px;\n}\n.monitor .box__body .box-column > li > article .cont .txt-info {\n  line-height: 1.4;\n}\n/* 250207 추가 */\n.monitor .box__body .box-column > li > article .cont .txt-info.mt-16.mb-18 {\n  font-size: 12px;\n  line-height: 18px;\n}\n.monitor .box__body .box-column > li > article .cont {\n  width: 100%;\n}\n.monitor .box__body .box-column > li > article .cont .tbl-list table th,\n.monitor .box__body .box-column > li > article .cont .tbl-list table td {\n  padding: 16px 16px 15px;\n  height: auto;\n}\n.monitor .box__body .box-column > li > article .cont .tbl-list {\n  border-top: 2px solid #dde2e9;\n  border-bottom: 2px solid #dde2e9;\n}\n.monitor .box__body .box-column > li > article .cont .graph-box {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.monitor .box__body .box-column > li > article .cont .graph-box .graph-area {\n  width: 100%;\n  height: 300px;\n}\n.monitor .box__body .box-column > li > article .cont .graph-box .graph-area .echarts-for-react > div:first-child {\n  width: 100% !important;\n}\n.monitor\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  .graph-box\n  .graph-area\n  .echarts-for-react\n  > div:first-child\n  canvas {\n  width: 100% !important;\n}\n.graph-legend {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.graph-legend p {\n  font-size: 12px;\n  line-height: 1.7;\n  letter-spacing: -0.7px;\n  color: #2a2c2f !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n.graph-legend p:before {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_legend.png\") no-repeat 0 0 transparent;\n  background-size: 100%;\n}\n.graph-legend p.mint:before {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_legend_mint.png\") no-repeat 0 0 transparent;\n  background-size: 100%;\n}\n.graph-legend p.red:before {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_legend_red.png\") no-repeat 0 0 transparent;\n  background-size: 100%;\n}\n.graph-legend p.line-type:before {\n  content: \"\";\n  width: 16px;\n  height: 4px;\n  background-color: #5470c6;\n}\n.monitor .box__body .box-column > li > article.part-len {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n.monitor .box__body .box-column > li > article.part-len > div {\n  flex: 1;\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap {\n  display: flex;\n  gap: 8px;\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  flex: 1;\n  padding: 16px;\n  min-height: 102px;\n  background: #fff;\n  border: 1px solid #dde2e9;\n  border-radius: 4px;\n  box-shadow: 0px 2px 8px rgba(144, 159, 183, 0.4);\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.opacity-5 li {\n  border: 1px solid rgba(221, 226, 233, 0.5);\n  box-shadow: none;\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li .tit {\n  font-size: 16px;\n  line-height: 1.3;\n  color: #051c3f;\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li .score-info {\n  justify-content: space-between;\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li .score-info::before {\n  content: none;\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li .count-info {\n  text-align: right;\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li span {\n  font-size: 16px;\n  line-height: 1.3;\n  color: #646c74;\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li span.info {\n  font-size: 24px;\n  display: flex;\n  align-items: center;\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li span.info:before {\n  content: \"\";\n  width: 32px;\n  height: 32px;\n  margin-right: 4px;\n  background: url(\"../img/icon_info_gr.png\") no-repeat 0 0 transparent;\n  background-size: 100%;\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li span.info.caution:before {\n  background: url(\"../img/icon_info_r.png\") no-repeat 0 0 transparent;\n  background-size: 100%;\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li span strong {\n  font-size: 30px;\n  color: #003876;\n  font-weight: 700;\n  line-height: 1.1;\n  margin-right: 8px;\n  vertical-align: sub;\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li .count-info span strong {\n  color: #2a2c2f;\n  font-weight: 400;\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.link li:hover {\n  background: #e8f1fe;\n  border: 2px solid #fff;\n  padding: 15px;\n  cursor: pointer;\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.link li:hover .tit {\n  font-weight: 500;\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.link li:hover .count-info span strong {\n  color: #003876;\n  font-weight: 500;\n}\n/* 250207 box-list 관련 추가 [s] */\n.monitor .box__body .box-column > li > article.part-len:has(.cont ul.box-small-wrap.box-list) {\n  height: auto;\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li {\n  border: none;\n  background: #f7f8fa;\n  border-radius: 0;\n  box-shadow: none;\n  padding: 24px;\n  min-height: 120px;\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li:hover {\n  cursor: pointer;\n  background: #e6f0ff;\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li .tit {\n  font-size: 15px;\n  line-height: 24px;\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li .tit:before {\n  content: \"\";\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  margin: 6px 8px 0 0;\n  background: #0a78ff;\n  border-radius: 50%;\n  vertical-align: text-top;\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li span {\n  font-size: 12px;\n  line-height: 24px;\n  color: #909fb7;\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li span strong {\n  font-size: 40px;\n  line-height: 40px;\n  font-family: \"Pretendard\";\n  margin-right: 4px;\n}\n/* 주의 클래스 caution */\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li.caution:hover {\n  background: rgba(245, 85, 71, 0.1);\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li.caution .tit:before {\n  background: #f55547;\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li.caution span > strong {\n  color: #f55547;\n}\n.monitor .box__body .box-column > li > article.part-len:has(ul.box-small-wrap.box-list li.caution) .cont .banner-wrap {\n  height: 160px;\n  display: block;\n}\n.monitor\n  .box__body\n  .box-column\n  > li\n  > article.part-len:has(ul.box-small-wrap.box-list li.caution)\n  .cont\n  .banner-wrap\n  > a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n.monitor\n  .box__body\n  .box-column\n  > li\n  > article.part-len:has(ul.box-small-wrap.box-list li.caution)\n  .cont\n  .banner-wrap\n  > a\n  > .img {\n  height: 100%;\n  min-width: 350px;\n  width: 100%;\n}\n.monitor\n  .box__body\n  .box-column\n  > li\n  > article.part-len:has(ul.box-small-wrap.box-list li.caution)\n  .cont\n  .banner-wrap\n  > a\n  > .img\n  > img {\n  height: 100%;\n  object-fit: cover;\n}\n@media screen and (max-width: 1091px) {\n  .monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list {\n    flex-direction: column;\n  }\n  .monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li {\n    min-height: 0;\n    flex-direction: row;\n  }\n}\n@media screen and (max-width: 940px) {\n  .monitor .box__body .box-column > li > article .cont ul.box-small-wrap.box-list {\n    gap: 8px;\n  }\n}\n/* 250207 box-list 관련 추가 [e] */\n.monitor .box__body .box-column > li > article.boxtype-tab {\n  height: auto;\n  width: 100%;\n  min-height: 368px;\n  padding: 0;\n}\n.monitor .box__body .box-column > li > article.boxtype-tab > .top {\n  padding: 16px 16px 8px;\n  margin-bottom: 0;\n}\n.monitor .box__body .box-column > li > article.boxtype-tab > .top h2 img {\n  width: 132px;\n  height: 40px;\n}\n.monitor .box__body .box-column > li > article.boxtype-tab > .cont {\n  display: flex;\n  border-top: 1px solid #dde2e9;\n}\n.monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line__toggleBtn {\n  display: none;\n}\n.monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line {\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0;\n  background: #f7f8fa;\n  width: 239px;\n  border-right: 1px solid #dde2e9;\n}\n.monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li {\n  justify-content: flex-start;\n  font-size: 14px;\n  line-height: 1;\n  font-weight: 400;\n  color: #2a2c2f;\n  padding: 0 32px;\n  width: calc(100% - 64px);\n  height: 45px;\n  border-bottom: 1px solid #dde2e9;\n}\n.monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li.on {\n  font-weight: 700;\n  color: #0a78ff;\n  border-right: 1px solid #fff;\n  background: #fff;\n}\n.icon-down:before {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  margin-right: 8px;\n  margin-left: -8px;\n  background: url(\"../img/icon_filedown_w@3x.png\") no-repeat center center;\n  background-size: 100%;\n}\n.monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.show {\n  padding: 16px;\n  width: calc(100% - 272px);\n}\n.monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab-content .top h3 {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.3;\n  color: #2a2c2f;\n}\n.monitor .box__body .box-column > li > article .cont .tab-cont-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 42px;\n}\n.monitor .box__body .box-column > li > article .cont .tab-cont-wrap.part-len > div {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .top {\n  margin-bottom: 0;\n}\n.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont + .cont {\n  margin-top: 42px;\n}\n.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap {\n  gap: 32px;\n  height: auto;\n  flex-wrap: wrap;\n}\n.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap.border-0 li {\n  box-shadow: none;\n  border: 0;\n}\n.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap li {\n  min-height: 60px;\n  flex: none;\n}\n.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap li .tit {\n  font-size: 15px;\n  color: #646c74;\n  display: flex;\n  align-items: center;\n}\n.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap li .tit:before {\n  content: \"\";\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #0f5fa5;\n  margin-right: 8px;\n}\n.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap li span {\n  font-size: 12px;\n  color: #909fb7;\n}\n.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap li .count-info span strong {\n  font-size: 28px;\n  font-weight: 500;\n}\n.monitor .box__body .cont-border-box {\n  padding: 16px;\n  border: 1px solid rgba(221, 226, 233, 0.5);\n}\n.monitor .box__body .cont-border-box .scrollX {\n  margin-bottom: -20px;\n  padding-bottom: 17px;\n}\n/* .monitor .box__body .cont-border-box .scrollX .graph-box {\n  min-width: calc(100vw - 646px);\n} */\n.monitor .box__body .cont-border-box .scrollX .graph-box .graph-area {\n  width: 100%;\n  min-width: 1185px;\n  height: 300px;\n}\n.monitor .box__body .box-column > li > article .cont .cont-border-box .scrollX .tbl-list table {\n  table-layout: auto;\n}\n.monitor .box__body .box-column > li > article .cont .cont-border-box .tbl-list table th {\n  min-width: 80px;\n  word-break: keep-all;\n  text-align: center;\n  padding: 9px 5px 8px;\n}\n.monitor .box__body .box-column > li > article .cont .cont-border-box .tbl-list table td {\n  min-width: 80px;\n  word-break: keep-all;\n  background: #fff;\n  text-align: center;\n  padding: 12px 5px 11px;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list.w-min-auto table th,\n.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list.w-min-auto table td {\n  min-width: auto;\n}\n.monitor .box__body .box-column > li > article .cont > .count-info {\n  margin-top: 16px;\n}\n.monitor .box__body .box-column > li > article .cont > .count-info span {\n  font-size: 20px;\n  line-height: 1;\n  color: #909fb7;\n  margin-left: 16px;\n}\n.monitor .box__body .box-column > li > article .cont > .count-info span strong {\n  font-size: 24px;\n  line-height: 1.2;\n  color: #003876;\n  margin-right: 8px;\n}\n.monitor .box__body .box-column > li > article .cont > .tab__round {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px;\n  width: fit-content;\n  background: #f7f8fa;\n  border-radius: 25px;\n}\n.monitor .box__body .box-column > li > article .cont > .tab__round li a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 14px 5px;\n  min-width: 68px;\n  font-size: 14px;\n  line-height: 1.1;\n  color: #2c364e;\n}\n.monitor .box__body .box-column > li > article .cont > .tab__round li.on {\n  background: #2c364e;\n  border-radius: 25px;\n}\n.monitor .box__body .box-column > li > article .cont > .tab__round li.on a {\n  color: #fff;\n  font-weight: 500;\n}\n.monitor .box__body .txtnum {\n  font-size: 12px;\n}\n.popup__body .img-box {\n  margin: 24px 0;\n}\n\n@media screen and (max-width: 940px) {\n  .monitor .box__body .box-column > li > article {\n    height: auto;\n  }\n}\n\n/* 모니터링 - 배너영역 */\n.monitor .box__body .box-column > li > article .cont .banner-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  height: 348px;\n  overflow: hidden;\n}\n.monitor .box__body .box-column > li > article .cont .banner-wrap > li {\n  position: relative;\n  height: 112px;\n  min-height: 112px;\n  width: 100%;\n}\n.monitor .box__body .box-column > li > article .cont .banner-wrap > li > a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n.monitor .box__body .box-column > li > article .cont .banner-wrap > li > a > .img {\n  position: absolute;\n  left: auto;\n  right: auto;\n  height: 100%;\n  min-width: 612px;\n  width: 100%;\n}\n.monitor .box__body .box-column > li > article .cont .banner-wrap > li > a > .img > img {\n  height: 100%;\n  object-fit: cover;\n}\n.monitor .box__body .box-column > li > article .cont .banner-wrap + .slide-pagenation {\n  gap: 9px;\n}\n\n/* 모니터링 - 데이터 프리미엄 전 안내 */\n.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont.no-view {\n  position: relative;\n}\n.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont.no-view:before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.57);\n  z-index: 1;\n}\n.no-view-txt {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n}\n.no-view-txt span {\n  padding: 6px 48px;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #fff;\n  background: #2c364e;\n}\n\n/* 모니터링 - 캘린더 박스 */\n.monitor .box__body .box-column > li > article .cont .calendar-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  height: 100%;\n}\n.monitor .box__body .box-column > li > article .cont .calendar-wrap .calendar-area {\n  height: 324px;\n}\n.monitor .box__body .box-column > li > article .cont .calendar-wrap .color-info {\n  justify-content: center;\n}\n\n/* 모니터링 - 탭 박스 */\n.monitor .box__body .box-column > li > article .cont .tabbox-wrap {\n  margin: 0 -16px !important;\n}\n.monitor .box__body .box-column > li > article .cont .tabbox-wrap .tab__box li a {\n  border-top: 1px solid #dde2e9;\n  line-height: 16px;\n}\n.monitor .box__body .box-column > li > article .cont .tabbox-cont {\n  height: 280px;\n}\n.monitor .box__body .box-column > li > article .cont .tabbox-cont .cont-tbl .tbl-list {\n  border: 0;\n}\n.monitor .box__body .box-column > li > article .cont .tabbox-cont .cont-tbl .tbl-list table td {\n  height: 24px;\n}\n@media screen and (max-width: 940px) {\n  .monitor .box__body .box-column > li > article .cont .tabbox-wrap .tab__box li {\n    height: 46px;\n  }\n  #wrap:not(.no-responsive) .monitor .box__body .box-column > li > article .cont .tabbox-wrap .tab__box li a {\n    font-size: 14px;\n  }\n  .monitor .box__body .box-column > li > article .cont .tabbox-cont .cont-tbl .tbl-list table td {\n    height: 27px;\n    font-size: 14px !important;\n  }\n  .monitor .box__body .box-column > li > article .cont .tabbox-cont {\n    height: 285px !important;\n  }\n}\n\n/* 모니터링 - 알람박스리스트 */\n.list-box {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.monitor .box__body .box-column > li > article .cont .list-box {\n  height: 334px;\n  overflow-y: auto;\n  margin-right: -15px;\n  padding-right: 5px;\n  margin-left: -15px;\n  padding-left: 15px;\n  padding-top: 5px;\n  margin-top: -5px;\n  padding-bottom: 5px;\n}\n.list-box li {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  padding: 16px;\n  border-radius: 4px;\n  box-shadow: 0px 0px 4px 0px rgba(144, 159, 183, 0.5);\n}\n.list-box li p {\n  font-size: 14px;\n  color: #2a2c2f;\n}\n.list-box li .title {\n  display: flex;\n  justify-content: space-between;\n}\n.list-box li .title p {\n  font-weight: 500;\n  line-height: 14px;\n}\n.list-box li .title p.dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  /* background: #909FB7; */\n  background: #0978ff;\n  margin-right: 5px;\n}\n/* .list-box li .title p.dot.new{\n  background: #0978FF;\n} */\n.list-box li .detail {\n  display: flex;\n  justify-content: space-between;\n}\n.list-box li .detail p:not(.date) {\n  font-size: 13px;\n  width: calc(100% - 100px);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n}\n.list-box li .detail p.date {\n  font-size: 14px;\n  color: #6b7891;\n}\n@media screen and (max-width: 940px) {\n  .list-box li {\n    padding: 24px 16px;\n    gap: 10px;\n  }\n  .list-box li .title p {\n    font-size: 16px;\n  }\n  .monitor .box__body .box-column > li > article .cont .list-box {\n    height: 453px;\n    padding-bottom: 5px;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-top: 5px;\n  }\n}\n\n/* 모니터링 - 운영설비 */\n.monitor .box__body .box-column > li > article.seolbi {\n  height: auto;\n}\n.monitor .box__body .box-column > li > article.seolbi .tab__line {\n  margin: 0 -16px 0 -16px;\n  width: calc(100% + 32px);\n}\n.monitor .box__body .box-column > li > article.seolbi .tbl__top {\n  margin-top: 24px;\n}\n.monitor .box__body .box-column > li > article.seolbi .tbl__top .searcharea {\n  position: relative;\n}\n.monitor .box__body .box-column > li > article.seolbi .cont .tbl-list table th {\n  padding: 4px 8px;\n  height: 24px;\n}\n.monitor .box__body .box-column > li > article.seolbi .cont .tbl-list table td {\n  padding: 4px 8px;\n  height: 40px;\n}\n.monitor .box__body .box-column > li > article.seolbi .btn-ask.etc + .popup-etc {\n  top: 33px;\n  right: 0;\n}\n.filter-txt {\n  margin-bottom: 12px;\n  height: 28px;\n  padding: 0 12px;\n  background: #e7f2ff;\n  border-radius: 25px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n.filter-txt p {\n  font-size: 14px;\n  line-height: 20px;\n  color: #0a78ff;\n}\n.filter-txt p span {\n  font-size: 14px;\n  line-height: 20px;\n  color: #0a78ff;\n}\n.filter-txt .btn-delete {\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_delete_x_lg.png\") no-repeat center center;\n  background-size: 100%;\n}\n.filter-txt button.btn-renew {\n  width: 24px;\n  height: 24px;\n  border: 0;\n  background: url(\"../img/icon_renew.png\") no-repeat center center;\n  background-size: 100%;\n}\n\n@media screen and (max-width: 1625px) {\n  .filter-txt-wrap {\n    text-align: right;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  #wrap:not(.no-responsive) .monitor .box__body .box-column > li > article.seolbi .tab__line li {\n    padding: 14px 5px;\n    letter-spacing: -1px;\n  }\n}\n\n/* 모니터링 - 스마트에너지인사이트 */\n.monitor .box__body .box-column > li > article.smartEI {\n  width: calc(100% - 32px);\n  height: auto;\n}\n.monitor .box__body .box-column > li > article.smartEI h2 {\n  font-weight: 700;\n}\n.monitor .box__body .box-column > li > article.smartEI h2 img {\n  width: 150px;\n  height: 8px;\n  display: block;\n  margin-bottom: 11px;\n}\n.monitor .box__body .box-column > li > article.smartEI > .cont .tab__line {\n  align-items: flex-start;\n  gap: 0;\n  margin: 0 -16px 32px;\n  width: calc(100% + 32px);\n  height: 46px;\n  background: #f7f8fa;\n  border-top: 1px solid #dde2e9;\n}\n.monitor .box__body .box-column > li > article.smartEI > .cont .tab__line li {\n  justify-content: center;\n  font-size: 14px;\n  line-height: 1;\n  font-weight: 400;\n  color: #2a2c2f;\n  padding: 0 32px;\n  min-width: 115px;\n  height: 100%;\n  border-right: 1px solid #dde2e9;\n}\n.monitor .box__body .box-column > li > article.smartEI > .cont .tab__line li.on {\n  font-weight: 700;\n  color: #0a78ff;\n  border-bottom: 1px solid #fff;\n  background: #fff;\n}\n.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap {\n  gap: 0;\n}\n.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div {\n  border-top: 1px solid #dde2e9;\n  padding-top: 32px;\n}\n.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div:first-child {\n  border-top: 0;\n  padding-top: 0;\n  /* margin-bottom: 16px; */\n}\n.monitor .box__body .box-column > li > article.smartEI > .cont .tab-content .top h3 {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.3;\n  color: #2a2c2f;\n}\n.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row {\n  display: flex;\n}\n.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding-bottom: 16px;\n}\n.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.verage {\n  width: 352px;\n  margin-right: 16px;\n  border-right: 16px solid #f7f8fa;\n  padding-right: 16px;\n  gap: 0;\n}\n.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.verage .top {\n  margin-bottom: 24px;\n}\n.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.verage .cont {\n  flex-direction: column;\n  gap: 0;\n}\n.monitor\n  .box__body\n  .box-column\n  > li\n  > article.smartEI\n  .cont\n  .tab-cont-wrap\n  > div\n  > .row\n  > .part.verage\n  .cont\n  .score-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 16px;\n  margin-bottom: 8px;\n  height: 46px;\n  background: #fff;\n  border-radius: 4px;\n  border: 1px solid #dde2e9;\n}\n.monitor\n  .box__body\n  .box-column\n  > li\n  > article.smartEI\n  .cont\n  .tab-cont-wrap\n  > div\n  > .row\n  > .part.verage\n  .cont\n  .score-top\n  .tit {\n  font-size: 24px;\n  line-height: 32px;\n  letter-spacing: -0.6px;\n  display: flex;\n  align-items: center;\n}\n.monitor\n  .box__body\n  .box-column\n  > li\n  > article.smartEI\n  .cont\n  .tab-cont-wrap\n  > div\n  > .row\n  > .part.verage\n  .cont\n  .score-top\n  .tit:before {\n  content: \"\";\n  width: 42px;\n  height: 42px;\n  background: url(\"../img/icon_info_gr.png\") no-repeat 0 0 transparent;\n  background-size: 100%;\n}\n.monitor\n  .box__body\n  .box-column\n  > li\n  > article.smartEI\n  .cont\n  .tab-cont-wrap\n  > div\n  > .row\n  > .part.verage\n  .cont\n  .score-top\n  .score {\n  font-size: 30px;\n  line-height: 32px;\n  color: #003876;\n  font-weight: 700;\n}\n.monitor\n  .box__body\n  .box-column\n  > li\n  > article.smartEI\n  .cont\n  .tab-cont-wrap\n  > div\n  > .row\n  > .part.verage\n  .cont\n  .score-top\n  .score\n  span {\n  color: #646c74;\n  font-size: 16px;\n  line-height: 20px;\n  margin-left: 8px;\n  font-weight: 400;\n  vertical-align: middle;\n}\n.monitor\n  .box__body\n  .box-column\n  > li\n  > article.smartEI\n  .cont\n  .tab-cont-wrap\n  > div\n  > .row\n  > .part.verage\n  .cont\n  .score-top.caution {\n  background: #f55547;\n  border-color: #f55547;\n}\n.monitor\n  .box__body\n  .box-column\n  > li\n  > article.smartEI\n  .cont\n  .tab-cont-wrap\n  > div\n  > .row\n  > .part.verage\n  .cont\n  .score-top.caution\n  .tit:before {\n  background: url(\"../img/icon_info_r.png\") no-repeat 0 0 transparent;\n  background-size: 100%;\n}\n.monitor\n  .box__body\n  .box-column\n  > li\n  > article.smartEI\n  .cont\n  .tab-cont-wrap\n  > div\n  > .row\n  > .part.verage\n  .cont\n  .score-top.caution\n  p,\n.monitor\n  .box__body\n  .box-column\n  > li\n  > article.smartEI\n  .cont\n  .tab-cont-wrap\n  > div\n  > .row\n  > .part.verage\n  .cont\n  .score-top.caution\n  span {\n  color: #fff;\n}\n.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.trend {\n  width: 100%;\n}\n.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.verage + .part.trend {\n  width: calc(100% - 400px);\n}\n.monitor\n  .box__body\n  .box-column\n  > li\n  > article.smartEI\n  .cont\n  .tab-cont-wrap\n  > div\n  > .row\n  > .part.verage\n  + .part.trend\n  .cont {\n  gap: 32px;\n}\n.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part .cont {\n  flex-direction: row;\n}\n.monitor\n  .box__body\n  .box-column\n  > li\n  > article.smartEI\n  .cont\n  .tab-cont-wrap\n  > div\n  > .row\n  > .part\n  .cont\n  > div\n  .tbl__top\n  span {\n  font-size: 15px;\n}\n.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.trend .cont {\n  gap: 48px;\n  justify-content: space-between;\n}\n.monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.trend .cont > div {\n  width: 100%;\n}\n.monitor\n  .box__body\n  .box-column\n  > li\n  > article.smartEI\n  .cont\n  .tab-cont-wrap\n  > div\n  > .row\n  > .part.trend\n  .cont\n  > div\n  .cont-border-box {\n  width: calc(100% - 34px);\n}\n/* .monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.trend .cont > div .cont-border-box.w1118 {\n  width: 1118px;\n} */\n.monitor\n  .box__body\n  .box-column\n  > li\n  > article.smartEI\n  .cont\n  .tab-cont-wrap\n  > div\n  > .row\n  > .part.trend\n  .cont\n  > .result__num {\n  font-size: 13px;\n}\n.monitor .box__body .box-column > li > article.smartEI .cont .tbl-list table th {\n  padding: 8px 10px;\n}\n.monitor .box__body .box-column > li > article.smartEI .cont .tbl-list table td {\n  padding: 16px 10px 15px;\n  letter-spacing: -1px;\n}\n.monitor\n  .box__body\n  .box-column\n  > li\n  > article.smartEI\n  .cont\n  .tab-cont-wrap\n  > div\n  > .row\n  > .part.trend\n  .cont\n  > div:last-child {\n  width: fit-content;\n}\n.monitor\n  .box__body\n  .box-column\n  > li\n  > article.smartEI\n  .cont\n  .tab-cont-wrap\n  > div\n  > .row\n  > .part.trend\n  .cont\n  > div\n  .tbl-list {\n  max-width: 352px;\n  min-width: 352px;\n}\n.monitor\n  .box__body\n  .box-column\n  > li\n  > article.smartEI\n  .cont\n  .tab-cont-wrap\n  > div\n  > .row\n  > .part.trend\n  .cont\n  > div\n  .tbl-list.scrollH {\n  padding: 0;\n  margin: 0;\n}\n.monitor\n  .box__body\n  .box-column\n  > li\n  > article.smartEI\n  .cont\n  .tab-cont-wrap\n  > div\n  > .row\n  > .part.trend\n  .cont\n  > div\n  .cont-border-box\n  .scrollX {\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n.monitor\n  .box__body\n  .box-column\n  > li\n  > article.smartEI\n  .cont\n  .tab-cont-wrap\n  > div\n  > .row\n  > .part.trend\n  .cont\n  > div\n  .cont-border-box\n  .scrollX\n  .graph-box\n  .graph-area {\n  min-width: 1118px;\n}\n.btn-basic.btn-filter {\n  padding: 0 24px 0 16px;\n}\n.btn-filter::before {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  margin-right: 8px;\n  background: url(\"../img/icon_filter_white.png\") no-repeat 0 center;\n  background-size: 100%;\n}\n@media screen and (max-width: 1892px) {\n  .monitor .box__body .box-column > li > article.smartEI .lm-none {\n    display: none !important;\n  }\n  .monitor .box__body .box-column > li > article.smartEI .lm-block {\n    display: block !important;\n  }\n  .monitor\n    .box__body\n    .box-column\n    > li\n    > article.smartEI\n    .cont\n    .tab-cont-wrap\n    > div\n    > .row\n    > .part.trend\n    .cont\n    > div\n    .cont-border-box {\n    width: calc(100% - 32px);\n  }\n  /* .monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.trend .cont > div .cont-border-box.w1118 {\n    width: calc(100% - 32px);\n  } */\n  .monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.trend .cont,\n  .monitor\n    .box__body\n    .box-column\n    > li\n    > article.smartEI\n    .cont\n    .tab-cont-wrap\n    > div\n    > .row\n    > .part.verage\n    + .part.trend\n    .cont {\n    gap: 24px;\n  }\n  .monitor\n    .box__body\n    .box-column\n    > li\n    > article.smartEI\n    .cont\n    .tab-cont-wrap\n    > div\n    > .row\n    > .part.trend\n    .cont\n    > div:first-child {\n    max-width: calc(100% - 376px);\n  }\n  .monitor\n    .box__body\n    .box-column\n    > li\n    > article.smartEI\n    .cont\n    .tab-cont-wrap\n    > div\n    > .row\n    > .part.verage\n    + .part.trend\n    .cont\n    > div:first-child {\n    max-width: 100%;\n  }\n}\n@media screen and (max-width: 1625px) {\n  .monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part .cont {\n    flex-direction: column;\n  }\n  .monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.trend .cont > div {\n    max-width: 100% !important;\n    width: 100% !important;\n  }\n  .monitor\n    .box__body\n    .box-column\n    > li\n    > article.smartEI\n    .cont\n    .tab-cont-wrap\n    > div\n    > .row\n    > .part.trend\n    .cont\n    > div\n    .tbl-list {\n    max-width: 100% !important;\n    width: 100% !important;\n  }\n  .monitor\n    .box__body\n    .box-column\n    > li\n    > article.smartEI\n    .cont\n    .tab-cont-wrap\n    > div\n    > .row\n    > .part.trend\n    .cont\n    > div\n    .tbl-list.mt-52 {\n    margin-top: 0 !important;\n  }\n  .monitor\n    .box__body\n    .box-column\n    > li\n    > article.smartEI\n    .cont\n    .tab-cont-wrap\n    > div\n    > .row\n    > .part.trend\n    .cont\n    > div\n    .tbl-list.h288 {\n    height: 324px !important;\n  }\n  .monitor\n    .box__body\n    .box-column\n    > li\n    > article.smartEI\n    .cont\n    .tab-cont-wrap\n    > div\n    > .row\n    > .part.trend\n    .cont\n    > div\n    .cont-border-box.h258 {\n    height: 294px !important;\n  }\n  .monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row {\n    flex-direction: column;\n  }\n  .monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.verage {\n    width: 100%;\n    margin-right: 0;\n    border-right: 0;\n    padding-right: 0;\n  }\n  .monitor\n    .box__body\n    .box-column\n    > li\n    > article.smartEI\n    .cont\n    .tab-cont-wrap\n    > div\n    > .row\n    > .part.verage\n    .cont\n    .score-top {\n    margin-bottom: 0;\n  }\n  .monitor\n    .box__body\n    .box-column\n    > li\n    > article.smartEI\n    .cont\n    .tab-cont-wrap\n    > div\n    > .row\n    > .part.verage\n    + .part.trend {\n    width: 100%;\n  }\n  .monitor .box__body .box-column > li > article.smartEI .lm-none {\n    display: block !important;\n  }\n  .monitor .box__body .box-column > li > article.smartEI .lm-block {\n    display: none !important;\n  }\n}\n\n@media screen and (max-width: 940px) {\n  #wrap:not(.no-responsive) .monitor .box__body .box-column > li > article.smartEI > .cont .tab__line li {\n    padding: 0 5px;\n    flex: unset;\n  }\n  .monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part.verage .top {\n    margin-bottom: 16px;\n  }\n  .monitor .box__body .box-column > li > article.smartEI .cont .tbl-list table td {\n    height: auto !important;\n    padding: 16px 8px 15px;\n  }\n  .monitor .box__body .box-column > li > article.smartEI .cont .tab-cont-wrap > div > .row > .part {\n    gap: 20px;\n  }\n  .monitor .box__body .box-column > li > article.smartEI > .cont .tab-content .top h3 {\n    font-size: 20px;\n  }\n  .monitor .box__body .box-column > li > article.smartEI .select {\n    height: 40px;\n  }\n  .monitor .box__body .box-column > li > article.smartEI .react-datepicker__input-container {\n    height: 40px;\n    max-height: 40px;\n  }\n  .react-datepicker__input-container {\n    max-height: 38px;\n  }\n}\n@media screen and (max-width: 620px) {\n  .monitor\n    .box__body\n    .box-column\n    > li\n    > article.smartEI\n    .cont\n    .tab-cont-wrap\n    > div\n    > .row\n    > .part\n    .cont\n    > div\n    .tbl__top {\n    gap: 20px;\n  }\n  .monitor\n    .box__body\n    .box-column\n    > li\n    > article.smartEI\n    .cont\n    .tab-cont-wrap\n    > div\n    > .row\n    > .part\n    .cont\n    > div\n    .tbl__top\n    .left {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n  }\n  .monitor\n    .box__body\n    .box-column\n    > li\n    > article.smartEI\n    .cont\n    .tab-cont-wrap\n    > div\n    > .row\n    > .part\n    .cont\n    > div\n    .tbl__top\n    span.ml-48 {\n    margin-left: 0 !important;\n  }\n  .monitor\n    .box__body\n    .box-column\n    > li\n    > article.smartEI\n    .cont\n    .tab-cont-wrap\n    > div\n    > .row\n    > .part\n    .cont\n    > div\n    .tbl__top\n    span {\n    margin-bottom: 10px;\n  }\n  .monitor\n    .box__body\n    .box-column\n    > li\n    > article.smartEI\n    .cont\n    .tab-cont-wrap\n    > div\n    > .row\n    > .part\n    .cont\n    > div\n    .tbl__top\n    button\n    span {\n    margin-bottom: 0;\n  }\n  .monitor .box__body .box-column > li > article.smartEI .select,\n  .monitor .box__body .box-column > li > article.smartEI .term__date.w158 {\n    width: 100% !important;\n    margin-bottom: 20px;\n  }\n  .monitor .box__body .box-column > li > article.smartEI .select:last-child {\n    margin-bottom: 0;\n  }\n}\n@media screen and (max-width: 400px) {\n  #wrap:not(.no-responsive) .monitor .box__body .box-column > li > article.smartEI > .cont .tab__line li {\n    min-width: auto;\n    flex: 1;\n  }\n}\n\n/* 모니터링 - 기본 정보 */\n.monitor .box__body .box-column > li > article.boxtype-tab > .cont .row {\n  display: flex;\n}\n.monitor .box__body .box-column > li > article.boxtype-tab > .cont .part.verage {\n  flex: 1;\n  margin: 0 32px 32px 0;\n}\n.monitor .box__body .box-column > li > article.boxtype-tab > .cont .part.trend {\n  flex: 1;\n}\n.monitor .box__body .box-column > li > article.boxtype-tab > .cont .part + .part {\n  margin-right: 16px;\n  padding-left: 32px;\n  border-left: 16px solid #f7f8fa;\n}\n.monitor .box__body .box-column > li > article.boxtype-tab > .cont .small-tit {\n  color: #646c74;\n  font-size: 15px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  margin-top: 32px;\n}\n.monitor .box__body .box-column > li > article.boxtype-tab .part.verage .cont .score-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 16px;\n  height: 46px;\n  background: #fff;\n  border-radius: 4px;\n  border: 1px solid #dde2e9;\n}\n.monitor .box__body .box-column > li > article.boxtype-tab .part.verage .cont .score-top .tit {\n  font-size: 24px;\n  line-height: 32px;\n  letter-spacing: -0.6px;\n  display: flex;\n  align-items: center;\n}\n.monitor .box__body .box-column > li > article.boxtype-tab .part.verage .cont .score-top .tit:before {\n  content: \"\";\n  width: 42px;\n  height: 42px;\n  background: url(\"../img/icon_info_gr.png\") no-repeat 0 0 transparent;\n  background-size: 100%;\n}\n.monitor .box__body .box-column > li > article.boxtype-tab .part.verage .cont .score-top .score {\n  font-size: 30px;\n  line-height: 32px;\n  color: #003876;\n  font-weight: 700;\n}\n.monitor .box__body .box-column > li > article.boxtype-tab .part.verage .cont .score-top .score span {\n  color: #646c74;\n  font-size: 16px;\n  line-height: 20px;\n  margin-left: 8px;\n  font-weight: 400;\n  vertical-align: middle;\n}\n.monitor .box__body .box-column > li > article.boxtype-tab .part.verage .cont .score-top.caution {\n  background: #f55547;\n  border-color: #f55547;\n}\n.monitor .box__body .box-column > li > article.boxtype-tab .part.verage .cont .score-top.caution .tit:before {\n  background: url(\"../img/icon_info_r.png\") no-repeat 0 0 transparent;\n  background-size: 100%;\n}\n.monitor .box__body .box-column > li > article.boxtype-tab .part.verage .cont .score-top.caution p,\n.monitor .box__body .box-column > li > article.boxtype-tab .part.verage .cont .score-top.caution span {\n  color: #fff;\n}\n.monitor .box__body .box-column > li > article .cont ul.box-small-wrap li .etc-info {\n  color: #7a8596;\n  font-size: 14px;\n  margin-top: 8px;\n}\n.monitor .box__body .box-column > li > article.boxtype-tab > .cont .part.verage .graph-box .graph-area,\n.monitor .box__body .box-column > li > article.boxtype-tab > .cont .part.trend .graph-box .graph-area {\n  /* min-width: 576px; */\n  min-width: 525px;\n}\n\n@media screen and (max-width: 1770px) {\n  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .row {\n    flex-direction: column;\n  }\n  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .part.verage {\n    margin-right: 0;\n    margin-bottom: 48px;\n  }\n  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .part + .part {\n    margin-right: 0;\n    padding-left: 0;\n    border-left: 0;\n  }\n  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .part.trend {\n    margin-bottom: 16px;\n  }\n}\n\n@media screen and (min-width: 2390px) {\n  .monitor .box__body .box-column {\n    display: grid;\n    gap: 14px;\n    grid-template-columns: 1fr 1fr;\n  }\n  .monitor .box__body .box-column > li:nth-child(1) {\n    grid-column: 1 / 2;\n    grid-row: 1;\n  }\n  .monitor .box__body .box-column > li:nth-child(2) {\n    grid-column: 2 / 3;\n    grid-row: 1;\n  }\n  .monitor .box__body .box-column > li:nth-child(3) {\n    grid-column: 1 / 2;\n    grid-row: 2;\n  }\n  .monitor .box__body .box-column > li:nth-child(4) {\n    grid-column: 2 / 3;\n    grid-row: 2;\n  }\n  .monitor .box__body .box-column > li:nth-child(5) {\n    grid-column: 1 / 3;\n    grid-row: 3;\n  }\n  .monitor .box__body .box-column > li:nth-child(6) {\n    grid-column: 1 / 3;\n    grid-row: 4;\n  }\n  .monitor .box__body .box-column > li:nth-child(7) {\n    grid-column: 1 / 3;\n    grid-row: 5;\n  }\n}\n@media screen and (min-width: 2390px) {\n  .monitor.type2 .box__body .box-column > li:nth-child(1) {\n    grid-column: 1 / 3;\n    grid-row: 1;\n  }\n  .monitor.type2 .box__body .box-column > li:nth-child(2) {\n    grid-column: 1 / 3;\n    grid-row: 2;\n  }\n  .monitor.type2 .box__body .box-column > li:nth-child(3) {\n    grid-column: 1;\n    grid-row: 3;\n  }\n  .monitor.type2 .box__body .box-column > li:nth-child(4) {\n    grid-column: 2;\n    grid-row: 3;\n  }\n  .monitor.type2 .box__body .box-column > li:nth-child(5) {\n    grid-column: 1 / 3;\n    grid-row: 4;\n  }\n  .monitor.type2 .box__body .box-column > li:nth-child(6) {\n    grid-column: 1 / 3;\n    grid-row: 5;\n  }\n}\n@media screen and (max-width: 1200px) {\n  .monitor .box__body .box-column > li > article .top {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  .monitor .box__body .box-column > li > article .top > .right {\n    width: 100%;\n  }\n\n  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line {\n    width: 191px;\n  }\n  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.show {\n    width: calc(100% - 224px);\n  }\n}\n@media screen and (max-width: 1091px) {\n  .monitor .box__body .box-column > li {\n    flex-direction: column;\n    min-width: 100%;\n  }\n  .monitor .box__body .box-column > li:nth-child(2) > article,\n  .monitor .box__body .box-column > li:nth-child(3) > article,\n  .monitor .box__body .box-column > li:nth-child(4) > article {\n    width: auto;\n  }\n}\n@media screen and (max-width: 940px) {\n  .monitor .box__body {\n    padding: 7px 0 0;\n    min-height: auto;\n    max-height: none;\n    overflow-y: unset;\n  }\n  .monitor .box__body .box-column {\n    gap: 0;\n  }\n  .monitor .box__body .box-column > li {\n    gap: 0;\n  }\n  .monitor .box__body .box-column > li > article {\n    padding: 20px;\n    box-shadow: none;\n  }\n  .monitor .box__body .box-column > li > article.h-auto {\n    height: auto !important;\n  }\n  .monitor .box__body .box-column > li > article.part-len {\n    gap: 40px;\n  }\n  .monitor .box__body .box-column > li > article .txt-info {\n    font-size: 14px;\n    margin-left: 0;\n    line-height: 1.4;\n    text-align: right;\n  }\n  .monitor .box__body .box-column > li > article:not(.boxtype-tab) > .top .txt-info {\n    margin-top: 0;\n  }\n  .monitor .box__body .box-column > li > article h2 {\n    font-size: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n  .monitor .box__body .box-column > li > article h2.flex-row {\n    flex-direction: column !important;\n  }\n  .monitor .box__body .box-column > li > article .top {\n    margin-bottom: 16px;\n  }\n  .monitor .box__body .box-column > li > article .top > .right {\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 10px;\n  }\n  .monitor .box__body .box-column > li > article.boxtype-tab > .top {\n    gap: 18px;\n    padding: 20px 20px 12px;\n  }\n  .monitor .box__body .box-column > li > article.boxtype-tab > .cont {\n    flex-direction: column;\n    position: relative;\n  }\n  .monitor .box__body .box-column > li > article .cont ul.box-small-wrap {\n    gap: 10px;\n  }\n  .monitor .box__body .box-column > li > article .cont .graph-box {\n    gap: 20px;\n  }\n  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line__toggleBtn {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 20px;\n    width: calc(100% - 40px);\n    height: 47px;\n    background: #fff;\n    border-bottom: 1px solid #dde2e9;\n    cursor: pointer;\n  }\n  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line__toggleBtn::after {\n    content: \"\";\n    width: 24px;\n    height: 24px;\n    margin-left: 40px;\n    background: url(\"../img/icon_select_l.png\") no-repeat center center;\n    background-size: 100%;\n  }\n  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line__toggleBtn.active:after {\n    content: \"\";\n    transform: rotate(180deg);\n  }\n  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line__toggleBtn p {\n    color: #2a2c2f;\n    font-size: 16px;\n    font-weight: 700;\n  }\n  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line {\n    display: none;\n  }\n  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line.active {\n    display: block;\n    position: absolute;\n    top: 49px;\n    width: 100% !important;\n    border: 0;\n    padding: 0;\n    margin: 0;\n    z-index: 2;\n    box-shadow: none;\n  }\n  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li {\n    padding: 0px 20px !important;\n    width: calc(100% - 40px);\n    border-right: 0;\n  }\n  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.show {\n    width: calc(100% - 40px) !important;\n    padding: 20px;\n  }\n  .monitor .box__body .box-column > li > article .cont .cont-border-box .tbl-list table th,\n  .monitor .box__body .box-column > li > article .cont .cont-border-box .tbl-list table td {\n    font-size: 14px !important;\n    height: auto !important;\n  }\n  .monitor .box__body .box-column > li > article .cont .tab-cont-wrap {\n    gap: 40px;\n  }\n  .monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont {\n    gap: 20px;\n  }\n  .monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap {\n    gap: 16px 24px;\n  }\n  .monitor .box__body .box-column > li > article .cont .tbl-list table th,\n  .monitor .box__body .box-column > li > article .cont .tbl-list table td {\n    padding: 15px 16px 14px;\n  }\n  .monitor .box__body .box-column > li > article .cont ul.box-small-wrap li span.info {\n    font-size: 0;\n  }\n  .monitor .box__body .box-column > li > article .cont ul.box-small-wrap li span.info:before {\n    width: 28px;\n    height: 28px;\n  }\n  .monitor .box__body .box-column > li > article .cont ul.box-small-wrap li span strong {\n    margin-right: 4px;\n    font-size: 22px;\n    vertical-align: bottom;\n  }\n  .popup__body .img-box {\n    margin: 16px 0;\n  }\n}\n@media screen and (max-width: 620px) {\n  .popup-layer.w658,\n  .popup-layer.w524 {\n    width: calc(100% - 40px) !important;\n  }\n}\n@media screen and (max-width: 499px) {\n  .monitor .box__body .box-column > li > article .cont ul.box-small-wrap li {\n    padding: 16px 8px;\n  }\n  table.m-w400 {\n    width: 400px;\n  }\n  table.m-w578 {\n    width: 578px;\n  }\n  .popup__body .img-box {\n    margin: 24px 0;\n  }\n  .popup__body p.txt.word {\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: -0.22px;\n    text-align: justify;\n  }\n}\n\n/* 운영관리 - 왼쪽 메뉴(반응형) */\n.box.treebar.pushy-menutype {\n  min-height: auto;\n}\n.box.treebar.pushy-menutype .lnb {\n  width: 100%;\n  overflow-y: auto;\n  height: 100%;\n}\n.box.treebar.pushy-menutype .lnb a {\n  width: 100%;\n}\n.box.treebar.pushy-menutype .lnb .add__item {\n  height: auto;\n  width: 100%;\n  padding: 13px 12px;\n  background: #e6f0ff;\n  border-radius: 4px;\n  border: 0;\n  justify-content: flex-start;\n}\n.box.treebar.pushy-menutype .lnb .add__item:hover {\n  background: #dee9f6;\n}\n.box.treebar.pushy-menutype .lnb .add__item:active {\n  background: #b4d2ff;\n}\n.box.treebar.pushy-menutype .lnb .add__item span {\n  display: flex;\n  align-items: center;\n  color: #0978ff;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1;\n}\n.box.treebar.pushy-menutype .lnb .add__item span::before {\n  content: \"\";\n  background: url(\"../img/icon_plus.png\") no-repeat center center;\n  width: 12px;\n  height: 12px;\n  margin-right: 12px;\n  background-size: 100%;\n}\n/* .add__item.active {\n  background: #0978FF;\n}\n.add__item.active span {\n  color: #fff;\n}\n.add__item.active span::before {\n  background: url('../img/icon_plus_w.png') no-repeat center center;\n  background-size: 100%;\n} */\n\n.box.treebar.pushy-menutype .lnb > .add__item {\n  margin: 8px;\n  width: calc(100% - 16px);\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth1 > li {\n  border-top: 1px solid #fff;\n  border-bottom: 1px solid #dde2e9;\n  padding: 0;\n  width: 100%;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth1 > li:first-child {\n  border-top: 0;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth1 > li > p {\n  display: flex;\n  align-items: center;\n  padding: 16px;\n  width: calc(100% - 32px);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 16px;\n  color: #2a2c2f;\n  cursor: pointer;\n  background: #f0f2f4;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth1 > li > p a {\n  position: relative;\n  display: flex;\n  gap: 16px;\n  width: calc(100% - 16px);\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth1 > li > p a::after {\n  content: \"\";\n  position: absolute;\n  right: -16px;\n  width: 16px;\n  height: 16px;\n  background: url(\"../img/icon_depth_down.png\") 0 center no-repeat;\n  background-size: 100%;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth1 > li > p a span + span {\n  margin-right: 16px;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth1 > li > p a span {\n  max-width: 50%;\n}\n.box.treebar.pushy-menutype:not(.type2, .type3) .lnb .lnb-depth1 > li.active > p {\n  background: #0a78ff;\n}\n.box.treebar.pushy-menutype:not(.type2, .type3) .lnb .lnb-depth1 > li.active > p span {\n  color: #fff;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth1 > li.active p span {\n  font-weight: 700;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth1 > li.active > p a::after {\n  transform: scaleY(-1);\n  filter: brightness(0) invert(1);\n}\n.box.treebar.pushy-menutype:not(.type2, .type3) .lnb .lnb-depth1 > li.active.nobg p {\n  background: #f0f2f4;\n}\n.box.treebar.pushy-menutype:not(.type2, .type3) .lnb .lnb-depth1 > li.active.nobg p span {\n  color: #2a2c2f;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth1 > li.active.nobg > p a::after {\n  filter: none;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth1 > li.active > .lnb-depth2,\n.box.treebar.pushy-menutype .lnb .lnb-depth2 > li.active > .lnb-depth3,\n.box.treebar.pushy-menutype .lnb .lnb-depth3 > li.active > .lnb-depth4 {\n  display: block;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth2 {\n  display: none;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth2 > li > .add__item {\n  margin: 8px;\n  width: calc(100% - 16px);\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth2 > li > a {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 16px 35px 15px 44px;\n  width: calc(100% - 79px);\n  font-size: 14px;\n  font-weight: 400;\n  color: #2a2c2f;\n  border-top: 1px solid #dde2e9;\n  background: #fff;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth2 > li > a::after {\n  content: \"\";\n  position: absolute;\n  right: 15px;\n  width: 16px;\n  height: 16px;\n  background: url(\"../img/icon_depth_down.png\") 0 center no-repeat;\n  background-size: 100%;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth2 > li.active > a {\n  font-weight: 700;\n  background: #0a78ff;\n  color: #fff;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth2 > li.active > a::after {\n  transform: scaleY(-1);\n  filter: brightness(0) invert(1);\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth2 > li.active.nobg > a,\n.box.treebar.pushy-menutype.navy .lnb .lnb-depth2 > li.active.nobg > a {\n  font-weight: 400;\n  color: #2a2c2f;\n  background: #fff;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth2 > li.active.nobg > a::after {\n  filter: none;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth2 > li > .lnb-depth3 {\n  display: none;\n  background: #fff;\n  padding-bottom: 24px;\n  height: auto;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth2 > li.active > .lnb-depth3 {\n  height: auto !important;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth3 > li > .add__item {\n  margin: 8px 8px 8px 36px;\n  width: calc(100% - 44px);\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth3 > li a {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 16px 48px 16px 72px;\n  width: calc(100% - 120px);\n  font-size: 14px;\n  color: #2a2c2f;\n  font-weight: 700;\n  background: #fff;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth3 > li.active a {\n  background: #0a78ff;\n  color: #fff;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth4 {\n  display: none;\n  background: #fff;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth4 > li > .add__item {\n  margin: 8px 8px 8px 64px;\n  width: calc(100% - 74px);\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth4 > li:has(.btn-etc) {\n  position: relative;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth4 > li .popup-etc {\n  width: auto;\n  top: 29px;\n  right: 53px;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth4 > li .popup-etc li button {\n  background-size: 24px !important;\n  padding: 4px 18px 3px 39px !important;\n  background-position-x: 9px !important;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth4 > li:has(.popup-etc.open) .add__item {\n  background: #e6f0ff;\n}\n@media screen and (max-width: 940px) {\n  .box.treebar.pushy-menutype.active {\n    top: 102px;\n  }\n  .box.treebar.pushy-menutype .lnb .lnb-depth1 > li > p {\n    min-height: 28px;\n  }\n  .box.treebar.pushy-menutype .lnb .lnb-depth2 > li a {\n    min-height: 28px;\n  }\n  .box.treebar.pushy-menutype .lnb .lnb-depth3 > li a {\n    min-height: 28px;\n  }\n}\n/* 운영관리 - 왼쪽 메뉴(반응형) - 포인트컬러 네이비 */\n.box.treebar.pushy-menutype.navy .lnb .add__item {\n  background: #fff;\n}\n.box.treebar.pushy-menutype.navy .lnb .add__item:hover {\n  background: rgba(10, 120, 255, 0.1);\n}\n.box.treebar.pushy-menutype.navy .lnb .add__item:active {\n  background: #b4d2ff;\n}\n.box.treebar.pushy-menutype.navy .lnb .lnb-depth3 > li.active a,\n.box.treebar.pushy-menutype.navy .lnb .lnb-depth2 > li.active > a,\n.box.treebar.pushy-menutype.navy .lnb .lnb-depth1 > li.active > p {\n  background: #062b55;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth1 > li.requesting > p a::after {\n  right: -13px;\n  width: 8px;\n  height: 8px;\n  background: #0a78ff;\n  border-radius: 50%;\n  top: 5px;\n  filter: none;\n  transform: none;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth1 > li.requesting.delete > p a::after {\n  background: #f55547;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth1 > li.requesting.delete > .lnb-depth2,\n.box.treebar.pushy-menutype .lnb .lnb-depth2 > li.requesting.delete > .lnb-depth3,\n.box.treebar.pushy-menutype .lnb .lnb-depth3 > li.requesting.delete > .lnb-depth4 {\n  display: none !important;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth1 > li.disabled > p a span {\n  color: rgba(144, 159, 183, 0.5);\n  font-weight: 500;\n}\n\n@media screen and (max-width: 940px) {\n  .box.treebar.pushy-menutype .lnb {\n    height: calc(100vh - 102px);\n  }\n}\n/* lnb-depth3 type4 */\n.box.treebar.pushy-menutype.type4 .lnb .lnb-depth3 > li a {\n  padding: 15px 40px;\n  width: calc(100% - 80px);\n  font-weight: 400;\n  line-height: 14px;\n}\n.box.treebar.pushy-menutype.type4 .lnb .lnb-depth3 > li.active a {\n  background: #b4d2ff;\n  color: #0a78ff;\n  font-weight: 500;\n}\n\n/* 운영관리 - 컨텐츠 */\n.btn-add.etc + .popup-etc {\n  top: 56px;\n  right: 140px;\n  width: 112px;\n}\n.btn-add.etc + .popup-etc li button,\n.btn-add.etc + .popup-etc li button:focus {\n  background-position: 10px center;\n  background-size: 24px !important;\n}\n.btn-ask.etc + .popup-etc {\n  top: 56px;\n  right: 23px;\n  width: 106px;\n}\n.btn-ask.etc + .popup-etc li button {\n  background: #fff;\n  padding-left: 0;\n}\n.btn-ask.etc + .popup-etc li button:focus-within {\n  background: #b4d2ff;\n}\n.btn-ask.etc + .popup-etc li button:hover {\n  background: #e6f0ff;\n}\n.btn-ask {\n  width: 32px;\n  height: 32px;\n  background: url(\"../img/icon_ask.png\") no-repeat 7px 7px #0a78ff;\n  background-size: 21px;\n}\n.btn-ask:hover {\n  background: url(\"../img/icon_ask_hover.png\") no-repeat 7px 7px #0050b8;\n  background-size: 21px;\n}\n.btn-ask:active {\n  background: url(\"../img/icon_ask_active.png\") no-repeat 7px 7px #003876;\n  background-size: 21px;\n}\n.btn-add-g-s {\n  background: url(\"../img/icon_plus_g_s.png\") no-repeat center center;\n  background-size: 24px;\n}\n.btn-add-all {\n  background: url(\"../img/icon_add_all_g.png\") no-repeat center center;\n  background-size: 24px;\n}\n@media screen and (max-width: 1160px) {\n  .left.m-block-mt-8 {\n    margin-top: 8px;\n  }\n  .right.m-block-mt-34 {\n    margin-top: 34px;\n    width: 100% !important;\n  }\n  .btn-ask.etc + .popup-etc,\n  .btn-add.etc + .popup-etc {\n    top: 130px;\n  }\n}\n@media screen and (max-width: 940px) {\n  #wrap:not(.no-responsive) .tbl__top .searcharea button.btn.btn-filedown {\n    background-size: 100%;\n  }\n  #wrap:not(.no-responsive) .tbl__top .searcharea button.btn.btn-ask {\n    background-size: 25px;\n    background-position: 10px 9px;\n  }\n  .btn-add.etc + .popup-etc {\n    top: 140px;\n    right: 95px;\n  }\n  .btn-ask.etc + .popup-etc {\n    top: 140px;\n  }\n}\n@media screen and (max-width: 499px) {\n  .right.m-block-mt-34 {\n    margin-top: 0;\n  }\n  .btn-ask.etc + .popup-etc,\n  .btn-add.etc + .popup-etc {\n    top: 155px;\n  }\n}\n\n/* 운영관리 - 사용자 */\n.btn-small-round,\n.tbl-list table td button.btn-small-round {\n  border: 0;\n  padding: 0 12px;\n  gap: 4px;\n  justify-content: flex-end;\n}\n.btn-small-round span:first-child {\n  font-size: 12px;\n  font-weight: 500;\n  /* line-height: 3px; */\n  letter-spacing: -0.7px;\n  color: #909fb7;\n}\n.btn-small-round span:last-child {\n  background: #0a78ff;\n  border-radius: 25px;\n  padding: 4px 7px;\n  font-size: 10px;\n  font-weight: 500;\n  letter-spacing: -0.4px;\n  color: #fff;\n}\n.btn-small-round.red span:last-child {\n  background: #f55547;\n}\n\n/* 운영관리 - 사업장,전기실 관리 - 사용자관리 */\n.request-cond {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  margin-left: 2px;\n}\n.request-cond p {\n  font-size: 12px;\n  line-height: 16px;\n  color: #909fb7;\n  font-weight: 500;\n  letter-spacing: -0.7px;\n}\n.request-cond .tit {\n  font-size: 10px;\n  color: #fff;\n  font-weight: 500;\n  letter-spacing: -0.4px;\n  padding: 4px 8px 4px 7px;\n  background: #0a78ff;\n  border-radius: 25px;\n  line-height: 1;\n}\n.request-cond.ok .tit {\n  background: #f55547;\n}\n\n.content__info ul li p.txt .request-cond {\n  display: none;\n}\n\n@media screen and (max-width: 940px) {\n  .content__info ul li p.txt .request-cond {\n    display: inline-block;\n    margin-left: 15px;\n  }\n  .content__info ul li p.txt .request-cond span {\n    font-size: 12px;\n    line-height: 16px;\n    color: #909fb7;\n    font-weight: 500;\n    letter-spacing: -0.7px;\n  }\n  .content__info ul li p.txt .request-cond span.tit {\n    margin-left: 5px;\n    font-size: 10px;\n    color: #fff;\n    font-weight: 500;\n    letter-spacing: -0.4px;\n    padding: 2px 8px 2px 7px;\n    background: #0a78ff;\n    border-radius: 25px;\n    line-height: 1;\n  }\n  .content__info ul li p.txt .request-cond.ok span.tit {\n    background: #f55547;\n  }\n}\n\n@media screen and (max-width: 320px) {\n  .content__info ul li p.txt .request-cond {\n    display: block;\n    margin-left: 0;\n    margin-top: 4px;\n  }\n}\n\n.form__info .txt > .filelist span span {\n  padding-left: 24px;\n  background: url(\"../img/icon_add_file.png\") no-repeat 0 center;\n  background-size: 20px;\n  cursor: pointer;\n  color: #0a78ff;\n}\n.form__info .txt > .filelist span:active span {\n  padding-left: 24px;\n  background: url(\"../img/icon_add_file_active.png\") no-repeat 0 center;\n  background-size: 20px;\n}\n.form__info .txt > .filelist span:hover span {\n  padding-left: 24px;\n  background: url(\"../img/icon_add_file_hover.png\") no-repeat 0 center;\n  background-size: 20px;\n}\n#wrap:not(.no-responsive) .container:not(.service) .content__info + .content__info.line:before {\n  content: \"\";\n  position: relative;\n  display: block;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  background: #e9edef;\n  margin-bottom: 40px;\n}\n#wrap:not(.no-responsive) .container:not(.service) .content__info ul > li {\n  margin-bottom: 16px;\n}\n#wrap:not(.no-responsive) .container:not(.service) .content__info ul > li:last-child {\n  margin-bottom: 40px;\n}\n.content__info > .top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n.content__info > .top .tit {\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 20px;\n  color: #2a2c2f;\n}\n.content__info ul.box-small-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.content__info ul.box-small-wrap li {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  flex: 1;\n  padding: 16px;\n  margin: 0 !important;\n  max-width: calc(100% / 6 - 41px);\n  min-width: calc(100% / 6 - 41px);\n  min-height: 102px;\n  background: #fff;\n  border: 1px solid #dde2e9;\n  border-radius: 4px;\n}\n.content__info ul.box-small-wrap li .tit {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.3;\n  color: #051c3f;\n  width: 100%;\n}\n.content__info ul.box-small-wrap li .score-info {\n  justify-content: space-between;\n}\n.content__info ul.box-small-wrap li .score-info::before {\n  content: none;\n}\n.content__info ul.box-small-wrap li .count-info {\n  text-align: right;\n  width: 100%;\n}\n.content__info ul.box-small-wrap li span {\n  font-size: 16px;\n  line-height: 1.3;\n  color: #646c74;\n}\n.content__info ul.box-small-wrap li span.info {\n  font-size: 24px;\n  display: flex;\n  align-items: center;\n}\n.content__info ul.box-small-wrap li span.info:before {\n  content: \"\";\n  width: 32px;\n  height: 32px;\n  margin-right: 4px;\n  background: url(\"../img/icon_info_gr.png\") no-repeat 0 0 transparent;\n  background-size: 100%;\n}\n.content__info ul.box-small-wrap li span.info.caution:before {\n  background: url(\"../img/icon_info_r.png\") no-repeat 0 0 transparent;\n  background-size: 100%;\n}\n.content__info ul.box-small-wrap li span strong {\n  font-size: 30px;\n  color: #003876;\n  font-weight: 700;\n  line-height: 1.1;\n  margin-right: 8px;\n  vertical-align: sub;\n}\n.content__info ul.box-small-wrap li .count-info span strong {\n  color: #2a2c2f;\n  font-weight: 400;\n}\n.content__info ul.box-small-wrap li > button {\n  position: relative;\n  margin: -17px;\n  width: calc(100% + 34px);\n  height: calc(100% + 34px);\n  border: 0;\n  background: #e8f1fe;\n  padding: 16px 20px 16px 16px;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  text-align: left;\n}\n.content__info ul.box-small-wrap li > button::before {\n  content: \"\";\n  position: absolute;\n  right: 24px;\n  bottom: 20px;\n  display: block;\n  width: 12px;\n  height: 12px;\n  background: url(\"../img/icon_plus.png\") no-repeat center center;\n  background-size: 100%;\n}\n.content__info ul.box-small-wrap li > button .tit {\n  color: #0a78ff;\n}\n@media screen and (max-width: 1260px) {\n  .content__info ul.box-small-wrap li {\n    max-width: calc(100% / 3 - 41px);\n    min-width: calc(100% / 3 - 41px);\n  }\n}\n@media screen and (max-width: 940px) {\n  .tab__line.m-fix {\n    position: fixed;\n    top: 102px;\n    left: 0;\n    background: #fff;\n    z-index: 2;\n  }\n}\n@media screen and (max-width: 499px) {\n  .tab__line.m-fix {\n    top: 142px;\n  }\n  .content__info ul.box-small-wrap {\n    gap: 10px;\n  }\n  .content__info ul.box-small-wrap li {\n    padding: 16px 8px;\n    max-width: calc(100% / 3 - 25px);\n    min-width: calc(100% / 3 - 25px);\n  }\n  .content__info ul.box-small-wrap li .count-info span strong {\n    font-size: 22px;\n    margin-right: 2px;\n    vertical-align: text-bottom;\n  }\n  .content__info ul.box-small-wrap li > button {\n    padding: 16px 8px;\n    margin: -17px -9px;\n    width: calc(100% + 18px);\n    height: calc(100% + 34px);\n  }\n  .content__info ul.box-small-wrap li > button::before {\n    right: 16px;\n  }\n}\n\n/* 운영관리 - 설비추가 - 일괄 등록 */\n.tbl-list.scrollX-basic {\n  overflow-x: auto;\n  width: 100%;\n}\n.tbl-list.scrollX-basic table {\n  white-space: nowrap;\n  width: max-content;\n}\n.tbl-list.scrollX-basic table th,\n.tbl-list.scrollX-basic table td {\n  padding: 4px 20px;\n}\n.tbl-list.scrollX-basic td .ellipsis {\n  max-width: 152px;\n  width: auto;\n}\n.content__info > .top .upload-area {\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n}\n.content__info > .top .upload-area li {\n  align-items: center;\n  margin-bottom: 0;\n}\n.content__info > .top .upload-area li.flex-top {\n  align-items: flex-start;\n}\n.content__info > .top .upload-area .tit {\n  width: 104px;\n  margin-right: 16px;\n}\n.content__info > .top .upload-area button.btn-basic {\n  min-width: 96px;\n}\n.content__info > .top .upload-area button + button {\n  margin-left: 8px;\n}\n.content__info .upload-area li .filelist {\n  margin-right: 70px;\n}\n.content__info .upload-area li .filelist li {\n  margin-bottom: 0 !important;\n}\n.content__info .upload-area li .filelist li + li {\n  margin-top: 8px;\n}\n.content__info .upload-area li .filelist li span {\n  font-size: 14px;\n  line-height: 20px;\n  color: #2a2c2f;\n  padding-left: 21px;\n}\n.content__info .upload-area li .filelist li span.uploading {\n  background: none;\n  padding-left: 21px;\n  position: relative;\n}\n.content__info .upload-area li .filelist li span.uploading:before {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  left: -8px;\n  top: 0;\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_upload@3x.png\") no-repeat center center;\n  background-size: 100%;\n}\n.content__info .upload-area li .filelist li span.uploading.end:before {\n  content: \"\";\n  background: url(\"../img/icon_success@3x.png\") no-repeat center center;\n  background-size: 100%;\n}\n.content__info .upload-area li .filelist.h80.scrollH {\n  padding-right: 0;\n}\n.content__info .upload-area li .filelist.h80.scrollH::-webkit-scrollbar-thumb {\n  height: 64px;\n}\n.content__info .upload-area .progressbar .progress-value {\n  margin-top: 0;\n  width: auto;\n  height: auto;\n  flex-direction: row;\n  align-items: center;\n}\n.content__info .upload-area .progressbar {\n  width: auto;\n  display: flex;\n  justify-content: space-between;\n}\n.content__info .upload-area .progressbar .progress-value progress {\n  height: 4px;\n  width: 95px;\n}\n.content__info .upload-area .progressbar .progress-value .value {\n  margin-left: 15px;\n  width: auto;\n}\n.content__info .upload-area .progressbar .progress-value .value span {\n  position: initial;\n  top: unset;\n  width: auto;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #2a2c2f;\n}\n.content__info .upload-area li .filelist li .case-info {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-left: 70px;\n}\n.content__info .upload-area li .filelist li .case-info p {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-width: 88px;\n  font-size: 14px;\n  line-height: 20px;\n  color: #2a2c2f;\n}\n.content__info .upload-area li .filelist li .case-info span {\n  background: none;\n  padding-left: 0;\n}\n.content__info .upload-area li .filelist li .case-info .case-ok strong {\n  font-weight: 500;\n  color: #1fc95c;\n}\n.content__info .upload-area li .filelist li .case-info .case-no {\n  margin-left: 24px;\n}\n.content__info .upload-area li .filelist li .case-info .case-no strong {\n  font-weight: 500;\n  color: #f55547;\n}\n.content__info .upload-area li .filelist li .case-info .btn-go {\n  width: 20px;\n  height: 20px;\n  margin-left: 15px;\n  border: 0;\n  background: url(\"../img/icon_gopop.png\") no-repeat center center;\n  background-size: 100%;\n}\n.tbl-list table.mb-110 .select.active ul {\n  max-height: 110px;\n}\n.tbl-list table.mb-110 .select.active ul::-webkit-scrollbar-thumb {\n  height: 70px;\n}\n\n@media screen and (max-width: 1580px) {\n  .no-responsive .header__menu {\n    margin-left: 70px;\n  }\n  .no-responsive .header__menu li a {\n    padding: 0 12px;\n    width: auto;\n  }\n}\n\n/* 운영관리 - 데이터 관리 */\n.box__body.data-manage {\n  padding: 0 0 88px !important;\n  overflow-y: auto;\n  height: calc(100vh - 275px);\n}\n.box__body.data-manage .top-img {\n  position: relative;\n  padding: 48px 72px 24px;\n  margin-bottom: 54px;\n  height: 130px;\n  background: linear-gradient(96.19deg, #114886 -1.88%, #003876 35.48%);\n}\n.box__body.data-manage .top-img::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  right: 136px;\n  display: block;\n  width: 240px;\n  height: 162px;\n  background: url(\"../img/bg_data.png\") no-repeat 0 0;\n  background-size: 100%;\n}\n.box__body.data-manage .top-img .text-wrap {\n  position: relative;\n  width: 845px;\n  z-index: 1;\n}\n.box__body.data-manage .top-img p {\n  color: #fff;\n  line-height: 20px;\n  letter-spacing: -0.7px;\n}\n.box__body.data-manage .top-img p.tit {\n  margin-bottom: 16px;\n  font-size: 20px;\n  font-weight: 500;\n}\n.box__body.data-manage .top-img p.txt {\n  font-size: 13px;\n}\n.box__body.data-manage .top-img .btn-basic {\n  background: rgba(10, 120, 255, 0.5);\n  border-color: transparent;\n  margin-top: 16px;\n}\n.box__body.data-manage .info__input + .info__input {\n  margin-top: 80px;\n}\n.box__body.data-manage .info__input + .info__input + .info__input {\n  margin-top: 120px;\n}\n.box__body.data-manage .info__input {\n  width: 828px;\n  margin-left: 72px;\n}\n.box__body.data-manage .info__input li {\n  margin-bottom: 16px;\n  margin-top: 0;\n  gap: 0;\n}\n.box__body.data-manage .info__input li:last-child {\n  margin-bottom: 0;\n}\n.box__body.data-manage .info__input li .flex-column {\n  width: 100%;\n  margin-bottom: 16px;\n}\n.box__body.data-manage .info__input li .flex-column .tit {\n  margin-bottom: 16px;\n}\n.box__body.data-manage .info__input .page-top {\n  margin-bottom: 16px;\n}\n.box__body.data-manage .info__input .page-top h3 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding-bottom: 16px;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  border-bottom: 1px solid #dde2e9;\n}\n.box__body.data-manage .info__input .page-top h3 .txt-info {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.box__body.data-manage .info__input .input__area .txt-info {\n  display: inline-flex;\n  font-size: 14px;\n  line-height: 16px;\n  color: #7a8596;\n  margin-top: 4px;\n}\n.box__body.data-manage .info__input .input__area .txt-info + .txt-info {\n  margin-top: 0;\n}\n.box__body.data-manage .info__input .input__area .txt-info::before {\n  content: \"*\";\n  margin-right: 2px;\n}\n.box__body.data-manage .info__input .input__area .txt-info.txt-red {\n  color: #f55547 !important;\n}\n.box__body.data-manage .info__input .content__info .form__input {\n  margin-left: 220px;\n}\n.box__body.data-manage .info__input .content__info ul.form__input li p.tit {\n  width: 248px;\n  margin-top: 7px;\n  line-height: 20px;\n  font-size: 15px;\n}\n.box__body.data-manage .info__input .content__info ul.form__input .input__area,\n.box__body.data-manage .info__input .content__info ul li .txt {\n  width: 360px;\n  max-width: 360px;\n}\n.box__body.data-manage .info__input .content__info ul li .txt {\n  margin-top: 7px;\n  margin-bottom: 6px;\n}\n.box__body.data-manage .info__input .content__info ul.form__input .input__area .checkBox {\n  margin-bottom: 15px;\n}\n.box__body.data-manage .info__input .content__info ul.form__input .input__area p.txtnum {\n  position: absolute;\n  top: -15px;\n  right: 0;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 16px;\n  color: #909fb7;\n}\n.box__body.data-manage .info__input .content__info ul li .btn__wrap {\n  margin-top: 56px;\n}\n.box__body.data-manage .upload-area {\n  margin-top: 40px;\n}\n.box__body.data-manage .content__info .upload-area li p.tit {\n  width: 220px;\n  margin-top: 6px;\n  font-size: 15px;\n}\n.box__body.data-manage .content__info .upload-area li .filelist {\n  margin-top: 6px;\n  margin-right: 10px;\n}\n.box__body.data-manage .content__info .upload-area li .filelist li span:not(.uploading) {\n  background-position: 5px center;\n}\n.box__body.data-manage .content__info .upload-area li .filelist li span {\n  width: 300px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.box__body.data-manage .content__info .upload-area li .filelist li span.uploading {\n  width: 300px;\n  padding-left: 25px;\n}\n.box__body.data-manage .content__info .upload-area li .filelist li span.uploading.end {\n  width: 200px;\n}\n.box__body.data-manage .content__info .upload-area li .filelist li span.uploading:before {\n  left: 0;\n}\n.box__body.data-manage .content__info .upload-area li .filelist.end {\n  width: 608px;\n  margin-right: 0;\n}\n.box__body.data-manage .content__info .upload-area li .filelist.end li {\n  justify-content: space-between;\n}\n.box__body.data-manage .content__info .upload-area li .filelist.end li span {\n  width: auto;\n  max-width: 300px;\n}\n.box__body.data-manage .content__info .upload-area li .filelist.end li .case-info {\n  margin-left: 0;\n}\n.box__body.data-manage .content__info .upload-area li .btn-area {\n  justify-content: flex-end;\n  display: flex;\n  flex: 1;\n}\n.box__body.data-manage .content__info .upload-area li .btn-area button {\n  min-width: 96px;\n}\n.box__body.data-manage .content__info .upload-area li .btn-area button + button {\n  margin-left: 8px;\n}\n.box__body.data-manage .content__info .upload-area .progressbar {\n  margin-top: 6px;\n  justify-content: flex-end;\n  flex: 1;\n}\n.box__body.data-manage .content__info .upload-area .progressbar .progress-value {\n  width: 200px;\n}\n.box__body.data-manage .content__info .upload-area .progressbar .progress-value progress {\n  width: 160px;\n}\n.box__body.data-manage .content__info .upload-area .progressbar .progress-value .value {\n  width: 35px;\n  margin-left: 5px;\n  text-align: right;\n}\n.box__body.data-manage .content__info .upload-area .endtxt {\n  flex: 1;\n  margin-top: 6px;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #0a78ff;\n  text-align: right;\n}\n.box__body.data-manage .btn-basic span.icon-go:after {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  margin-left: 8px;\n  margin-right: -8px;\n  background: url(\"../img/icon_go_gr.png\") no-repeat center center;\n  background-size: 100%;\n}\n.box__body.data-manage .img-wrap {\n  border: 1px solid #dde2e9;\n}\n.box__body.data-manage .paging {\n  width: 100%;\n  display: block;\n}\n.box__body.data-manage .paging ul {\n  margin-left: 0;\n}\n.box__body.data-manage .info__input .content__info .paging ul > li {\n  margin-bottom: 0 !important;\n  border: 0;\n}\n.box__body.data-manage .info__input .content__info .paging ul > li > a {\n  color: #909fb7;\n}\n.box__body.data-manage .info__input .content__info .paging ul > li > a.active {\n  color: #fff;\n}\n\n/* 컨설팅 */\n#wrap.bg-white .box {\n  box-shadow: none;\n}\n.container.wide {\n  margin: 50px 0 0 0;\n  min-height: calc(100vh - 50px);\n}\n.container.wide .content {\n  width: 100%;\n  padding-left: 0;\n}\n.container.wide .box {\n  display: flex;\n  flex-direction: column;\n  /* gap: 20px; */\n  width: 100%;\n  border-radius: 0;\n}\n.container.wide .box .box__header {\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: #0f2b4b;\n  position: fixed;\n  width: 100%;\n  z-index: 3;\n}\n.container.wide .box .box__header .box-wrap {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 1200px;\n\n  margin: 0 auto;\n}\n.container.wide .box .box__header .select {\n  color: #fff;\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: -0.4px;\n  height: 32px;\n  background: #0f2b4b;\n}\n.container.wide .box .box__header .select ul {\n  margin-top: 0;\n}\n.container.wide .box .box__header .select .selected .arrow {\n  filter: brightness(0) invert(1);\n  background-size: 16px;\n  margin-left: 8px;\n}\n.container.wide .box .box__body {\n  padding: 0;\n}\n.container.wide .box .box__body .box-wrap {\n  display: flex;\n  flex-direction: column;\n  width: calc(100% - 150px);\n  max-width: 1050px;\n  margin: 0 auto;\n  padding: 0 75px 0;\n  /* gap: 20px; */\n}\n.container.wide .box .box__body .box-wrap .locate {\n  justify-content: flex-end;\n  gap: 4px;\n  background: none;\n  position: relative;\n  top: unset;\n  width: 100%;\n  max-width: 1050px;\n  margin: 0 auto;\n  padding: 0 0 20px;\n  /* z-index: 3; */\n}\n.container.wide .box .box__body .box-wrap .locate li {\n  gap: 4px;\n  line-height: 1;\n}\n.container.wide .box .box__body .box-wrap .locate li:before {\n  content: \"\";\n  width: 16px;\n  height: 16px;\n  background: url(\"../img/icon_arrow_right_s_g.png\") no-repeat center center;\n  background-size: 100%;\n}\n.container.wide .box .box__body .box-wrap .locate li:first-child:before {\n  content: none;\n}\n.container.wide .box .box__body .box-wrap .locate li a {\n  display: flex;\n  align-items: center;\n  font-weight: 400;\n  font-size: 13px;\n  letter-spacing: -0.4px;\n  color: #909fb7;\n}\n.container.wide .box .box__body .box-wrap .locate li.on a {\n  font-weight: 500;\n  color: #2a2c2f;\n}\n.container.wide .box .box__body .box-wrap > section {\n  display: flex;\n  flex-direction: column;\n  /* gap: 160px; */\n}\n.container.wide .box .box__body .box-wrap > section > article {\n  display: flex;\n  flex-direction: column;\n  padding-top: 160px;\n  /* gap: 120px; */\n}\n.container.wide .box .box__body .box-wrap > section > article:first-child {\n  padding-top: 112px;\n}\n.container.wide .box .box__body .box-wrap h2 {\n  font-size: 35px;\n  font-weight: 500;\n  line-height: 1.3;\n  color: #2a2c2f;\n  letter-spacing: -0.4px;\n  padding-bottom: 80px;\n}\n.container.wide .box .box__body .box-wrap h3 {\n  font-size: 26px;\n  font-weight: 700;\n  line-height: 1.6;\n  color: #2a2c2f;\n  letter-spacing: -1px;\n  margin-bottom: 40px;\n}\n.container.wide .box .box__body .box-wrap h3 .txt-info {\n  margin: 0;\n}\n.container.wide .box .box__body .box-wrap .txt-info {\n  color: #646c74;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  margin: 0 0 10px 0;\n}\n.helper-info {\n  display: flex;\n  gap: 16px;\n}\n.helper-info::before {\n  content: \"\";\n  width: 92px;\n  height: 92px;\n  flex: none;\n  background: url(\"../img/icon_bolt.png\") no-repeat center center;\n  background-size: 100%;\n}\n.helper-info p {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: calc(100% - 92px);\n}\n.helper-info p span {\n  font-size: 16px;\n  line-height: 1.5;\n  color: #2a2c2f;\n  padding: 20px;\n  background: #f7f8fa;\n  border-radius: 20px;\n}\n.consult-result-box {\n  margin-top: 80px;\n}\n.consult-result-box .title {\n  font-size: 22px;\n  font-weight: 500;\n  line-height: 1.8;\n  color: #2a2c2f;\n  padding-left: 46px;\n  background: url(\"../img/icon_home.png\") no-repeat 0 center;\n  background-size: 38px 40px;\n  margin-bottom: 20px;\n}\n.consult-result-box ul.result-box {\n  display: flex;\n  gap: 15px;\n}\n.consult-result-box ul.result-box li {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  flex: 1;\n  padding: 32px 24px 24px;\n  min-height: 166px;\n  background-image: linear-gradient(145deg, #eef1f4, #f7f8fa);\n  border: 1px solid #f7f8fa;\n  border-radius: 24px;\n  box-shadow: none;\n}\n.consult-result-box ul.result-box li .tit {\n  font-size: 22px;\n  font-weight: 500;\n  line-height: 1.3;\n  color: #051c3f;\n}\n.consult-result-box ul.result-box li .tit span {\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 1.3;\n  color: #051c3f;\n}\n.consult-result-box ul.result-box li .score-info {\n  justify-content: space-between;\n}\n.consult-result-box ul.result-box li .score-info::before {\n  content: \"\";\n  width: 72px;\n  height: 72px;\n  border-radius: 0;\n  background: url(\"../img/icon_result_2.png\") no-repeat 0 0;\n  background-size: 100%;\n}\n.consult-result-box ul.result-box li:first-child .score-info::before {\n  width: 72px;\n  height: 72px;\n  background: url(\"../img/icon_result_1.png\") no-repeat 0 0;\n  background-size: 100%;\n}\n.consult-result-box ul.result-box li:last-child .score-info::before {\n  width: 72px;\n  height: 72px;\n  background: url(\"../img/icon_result_3.png\") no-repeat 0 0;\n  background-size: 100%;\n}\n.consult-result-box ul.result-box li span {\n  margin-top: 10px;\n  font-size: 20px;\n  line-height: 1;\n  color: #646c74;\n}\n.consult-result-box ul.result-box li span strong {\n  font-size: 38px;\n  color: #051c3f;\n  font-weight: 500;\n  line-height: 1.1;\n  margin-right: 8px;\n  vertical-align: sub;\n}\n.consult-result-box ul.result-box + ul.result-box.small {\n  margin-top: 16px;\n}\n.consult-result-box ul.result-box.small {\n  gap: 11px;\n}\n.consult-result-box ul.result-box.small li {\n  padding: 24px;\n  min-height: 98px;\n  background: #fff;\n  border: 1px solid #dde2e9;\n  border-radius: 20px;\n}\n.consult-result-box ul.result-box.small li .tit {\n  font-size: 18px;\n}\n.consult-result-box ul.result-box.small li .score-info {\n  justify-content: space-between;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n}\n.consult-result-box ul.result-box.small li .score-info::after {\n  content: \"\";\n  width: 100%;\n  height: 2px;\n  background: #c7d6ea;\n}\n.consult-result-box ul.result-box.small li .score-info::before {\n  content: none;\n}\n.consult-result-box ul.result-box.small li .tit span {\n  font-size: 18px;\n}\n.consult-result-box ul.result-box.small li span {\n  font-size: 16px;\n  margin-top: 0;\n}\n.consult-result-box ul.result-box.small li span strong {\n  font-size: 30px;\n  margin-right: 4px;\n}\n.consult-result-txt {\n  margin-top: 80px;\n}\n.consult-result-txt .title {\n  font-size: 16px;\n  color: #2a2c2f;\n  line-height: 1.5;\n  margin-bottom: 20px;\n}\n.consult-result-txt .method {\n  font-size: 26px;\n  font-weight: 500;\n  line-height: 1.6;\n  letter-spacing: -1px;\n  margin-bottom: 40px;\n}\n.consult-result-txt .method strong {\n  font-weight: 700;\n}\n.consult-result-txt .point-wrap {\n  padding: 40px 40px 60px;\n  border-radius: 20px;\n  background: #f7f8fa;\n  margin-bottom: 40px;\n}\n.consult-result-txt .point-wrap .tit {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 40px;\n}\n.consult-result-txt .point-wrap .tit:before {\n  content: \"\";\n  width: 40px;\n  height: 40px;\n  background: url(\"../img/icon_point.png\") no-repeat 0 0;\n  background-size: 100%;\n}\n.consult-result-txt .point-wrap .tit span {\n  font-size: 22px;\n  line-height: 1.5;\n  color: #2a2c2f;\n}\n.consult-result-txt .point-wrap .tit strong {\n  font-weight: 700;\n}\n.consult-result-txt .point-wrap .point {\n  display: flex;\n  flex-direction: column;\n  gap: 35px;\n  margin-left: 20px;\n}\n.consult-result-txt .point-wrap .point li {\n  list-style: decimal;\n  font-size: 16px;\n  line-height: 1.5;\n  color: #2a2c2f;\n}\n.solution + .solution {\n  margin-top: 120px;\n}\n.solution .sol-txt li {\n  font-size: 20px;\n  line-height: 1.8;\n  color: #2a2c2f;\n}\n.solution .sol-txt li strong {\n  font-weight: 500;\n}\n.solution-area {\n  display: flex;\n  flex-direction: column;\n  margin-top: 60px;\n}\n.solution-area .top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.solution-area .top .btn-basic {\n  background: #fff !important;\n  border-color: #fff !important;\n}\n.solution-area .top .btn-basic span {\n  color: #909fb7;\n}\n.solution-area .top .btn-basic span.icon-go:after {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  margin-left: 8px;\n  margin-right: -8px;\n  background: url(\"../img/icon_go_gr.png\") no-repeat center center;\n  background-size: 100%;\n}\n.solution-area .tab__line {\n  display: flex;\n  align-items: center;\n  background: #f7f8fa;\n  border-radius: 25px;\n  border: 0;\n  gap: 0;\n  width: auto;\n  height: 32px;\n}\n.solution-area .tab__line li {\n  padding: 0 24px;\n}\n.solution-area .tab__line li a {\n  color: #2a2c2f;\n}\n.solution-area .tab__line li.on,\n.solution-area .tab__line li:hover {\n  background: #003875;\n  border-radius: 25px;\n  border: 0;\n}\n.solution-area .top .tab__line li.on a,\n.solution-area .top .tab__line li:hover a {\n  color: #fff !important;\n  font-weight: 500 !important;\n}\n.solution-area .tab__line li.on a,\n.solution-area .tab__line li:hover a {\n  color: #fff !important;\n  font-weight: 500 !important;\n}\n.item-list {\n  display: flex;\n  gap: 20px;\n  height: 528px;\n}\n.item-list > li {\n  flex: 1;\n  max-width: 515px;\n  height: 100%;\n  border-radius: 4px;\n  background: #fff;\n  border: 1px solid #dde2e9;\n}\n.item-list li .img-wrap {\n  position: relative;\n  height: 200px;\n  min-height: unset;\n  background-size: cover;\n  border-radius: 4px 4px 0 0;\n}\n.item-list li .img-wrap img {\n  object-fit: cover;\n  border-radius: 4px 4px 0 0;\n}\n.item-list li .img-wrap .tit {\n  position: absolute;\n  left: 40px;\n  top: 88px;\n  width: 80%;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.item-list li .img-wrap .tit strong {\n  color: #fff;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n.item-list li .img-wrap .tit span {\n  color: #fff;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 1.3;\n}\n.slide-pagenation {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n  margin-top: 13px;\n}\n.slide-pagenation li {\n  margin: 0 !important;\n}\n.slide-pagenation li a {\n  display: block;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #909fb7;\n}\n.slide-pagenation li.on a {\n  background: #0978ff;\n}\n.item-info {\n  height: calc(100% - 200px);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.item-info-top {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  overflow-y: auto;\n}\n.item-info-top .keyword {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0px 16px;\n}\n.item-info-top .keyword span {\n  font-size: 13px;\n  color: #0a78ff;\n  line-height: 1.5;\n}\n.item-info-top .keyword span:before {\n  content: \"#\";\n}\n.item-info-top .tit {\n  color: #2a2c2f;\n  font-size: 18px;\n  font-weight: 700;\n}\n.item-info-top .company {\n  color: #7783a1;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.3;\n}\n.item-info-top .cont {\n  color: #2a2c2f;\n  font-size: 13px;\n  line-height: 1.5;\n}\n.item-info-top .etc {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n.item-info-top .etc li {\n  color: #003875;\n  font-size: 13px;\n  line-height: 1.5;\n  font-weight: 500;\n}\n.item-info-btnarea {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: #41444a;\n  height: 48px;\n  border-radius: 0 0 4px 4px;\n}\n.item-info-btnarea button {\n  flex: 1;\n  border: 0;\n  height: 100%;\n  justify-content: flex-start;\n  padding: 0 16px 0 20px;\n}\n.item-info-btnarea button + button {\n  border-left: 1px solid #26282e;\n  height: 38px;\n  border-radius: 0;\n}\n.item-info-btnarea button span.icon-go {\n  background: url(\"../img/icon_page_go.png\") no-repeat center right;\n  background-size: 24px;\n}\n.item-info-btnarea button span.icon-more {\n  background: url(\"../img/icon_more_wh.png\") no-repeat center right;\n  background-size: 24px;\n}\n.item-info-btnarea button span {\n  width: 100%;\n  font-size: 14px;\n  color: #fff;\n  text-align: left;\n}\n.solution-area .paging {\n  margin-top: 20px;\n  width: 100%;\n  justify-content: center;\n}\n.solution-area .paging ul {\n  margin: 0;\n  gap: 40px;\n}\n.solution-area .paging .btn-prev {\n  width: 32px;\n  height: 32px;\n  margin: 0;\n  border: 0;\n  background: url(\"../img/icon_next_bgno.png\") no-repeat center center;\n  background-size: 100%;\n  transform: rotate(180deg);\n}\n.solution-area .paging .btn-next {\n  width: 32px;\n  height: 32px;\n  margin: 0;\n  border: 0;\n  background: url(\"../img/icon_next_bgno.png\") no-repeat center center;\n  background-size: 100%;\n}\n.solution-area .paging .btn-prev.disabled,\n.solution-area .paging .btn-next.disabled {\n  opacity: 0.2;\n}\n.solution-area .paging li.btn-prev + li {\n  border: 0;\n  height: auto;\n  min-width: unset;\n  letter-spacing: 3px;\n  font-size: 14px;\n  font-weight: 500;\n}\n.product {\n  margin-top: -30px;\n  margin-bottom: 30px;\n}\n.container.wide .box .box__body .box-wrap .product h3 {\n  margin-bottom: 10px;\n  margin-top: 30px;\n}\n.product .scrollX {\n  margin-bottom: -20px;\n  padding-bottom: 17px;\n}\n.product .scrollX::-webkit-scrollbar-thumb {\n  border: 2px solid transparent;\n}\n.product .scrollX .tab__line {\n  gap: 10px;\n  width: 100%;\n  min-width: 1050px;\n  border: 0;\n  background: none;\n}\n.product .scrollX .tab__line > li {\n  height: 132px;\n  padding: 0;\n  min-width: 120px;\n  max-width: 120px;\n  border-radius: 4px;\n  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);\n}\n.product .scrollX .tab__line > li a {\n  flex-direction: column;\n}\n.product .scrollX .tab__line > li a .img-wrap {\n  width: 100%;\n  height: 64px;\n  min-height: unset;\n  background: url(\"../img/bg_picture.png\") no-repeat center 35px;\n  background-size: 24px;\n}\n.product .scrollX .tab__line > li.on a .img-wrap {\n  background: url(\"../img/bg_picture_on.png\") no-repeat center 35px;\n  background-size: 24px;\n}\n.product .scrollX .tab__line > li a .img-wrap img {\n  object-fit: cover;\n  border-radius: 4px 4px 0 0;\n}\n.product .scrollX .tab__line > li a p {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #2a2c2f;\n  font-size: 13px;\n  line-height: 16px;\n  text-align: center;\n  letter-spacing: -1px;\n  font-weight: 500;\n  height: calc(100% - 64px);\n  padding: 0 8px;\n}\n.product .scrollX .tab__line li.on {\n  border: 0;\n  background: #0a78ff;\n}\n.product .scrollX .tab__line li.on a p {\n  color: #fff;\n  font-weight: 700;\n}\n.product .tab-content {\n  padding: 40px;\n  height: 448px;\n  overflow-y: scroll;\n  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);\n  border-radius: 0 0 4px 4px;\n}\n.product .tab-content .scrollH {\n  height: 448px;\n}\n.product .tab-content p {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  text-align: justify;\n}\n.product .tab-content p.tit {\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 36px;\n  letter-spacing: -0.4px;\n  color: #051c3f;\n  margin-bottom: 20px;\n}\n.btn-top {\n  position: fixed;\n  right: 80px;\n  bottom: 40px;\n  width: 50px;\n  height: 50px;\n  border-radius: 0;\n  border: 0;\n  background: url(\"../img/icon_top_w.png\") no-repeat center center #26282e;\n  background-size: 30px;\n  z-index: 10;\n}\n.bg-logo {\n  width: 100%;\n  height: 30px;\n  text-align: left;\n}\n.bg-logo img {\n  width: 152px;\n}\n\n@media screen and (max-width: 940px) {\n  .container.wide .box .box-wrap .select__toggleBtn {\n    top: 50px;\n  }\n  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype.active {\n    top: 102px;\n    height: calc(100vh - 102px);\n  }\n  .container.wide .box .box__body .box-wrap {\n    width: calc(100% - 80px);\n    padding: 0 40px 0;\n  }\n  .container.wide .box .box__body .box-wrap > section > article {\n    padding-top: 140px;\n  }\n  .container.wide .box .box__body .box-wrap > section > article:first-child {\n    padding-top: 20px;\n  }\n  #wrap:not(.no-responsive) .solution-area .tab__line li {\n    width: auto;\n    padding: 0 24px;\n    flex: unset;\n  }\n  #wrap:not(.no-responsive) .product > .tab__line li {\n    flex: unset;\n    padding: 12px 14px 13px;\n  }\n  #wrap:not(.no-responsive) .product .scrollX .tab__line li {\n    flex: unset;\n    padding: 0;\n  }\n}\n@media screen and (max-width: 779px) {\n  .container.wide .box .box__body .box-wrap .locate li a {\n    font-size: 14px;\n  }\n  .container.wide .box .box__body .box-wrap h2 {\n    font-size: 32px;\n    padding-bottom: 72px;\n  }\n  .helper-info {\n    gap: 8px;\n  }\n  .helper-info p {\n    width: calc(100% - 100px);\n  }\n  .consult-result-box {\n    margin-top: 72px;\n  }\n  .consult-result-box .title {\n    margin-bottom: 16px;\n  }\n  .consult-result-box ul.result-box {\n    flex-direction: column;\n    gap: 12px;\n  }\n  .consult-result-box ul.result-box li {\n    padding: 28px 20px 20px;\n    min-height: 102px;\n  }\n  .consult-result-box ul.result-box li .score-info::before,\n  .consult-result-box ul.result-box li:first-child .score-info::before,\n  .consult-result-box ul.result-box li:last-child .score-info::before {\n    width: 64px;\n    height: 64px;\n  }\n  .consult-result-box ul.result-box + ul.result-box.small {\n    flex-wrap: wrap;\n    flex-direction: row;\n    gap: 10px;\n  }\n  .consult-result-box ul.result-box.small li {\n    width: 33%;\n    padding: 24px 20px;\n    flex: auto;\n  }\n  .consult-result-box ul.result-box.small li .tit {\n    display: flex;\n    flex-direction: column;\n  }\n  .consult-result-txt {\n    margin-top: 68px;\n  }\n  .consult-result-txt .method {\n    font-size: 22px;\n    line-height: 1.8;\n  }\n  .consult-result-txt .point-wrap {\n    padding: 40px 20px 60px;\n  }\n  .consult-result-txt .point-wrap .tit {\n    gap: 8px;\n    margin-bottom: 20px;\n  }\n  .consult-result-txt .point-wrap .point {\n    gap: 30px;\n    margin-left: 25px;\n  }\n  .consult-result-txt .point-wrap .point li {\n    line-height: 1.8;\n  }\n  #wrap:not(.no-responsive) .solution-area .tab__line li {\n    padding: 0 20px;\n  }\n  #wrap:not(.no-responsive) .solution-area .tab__line li a {\n    font-size: 14px;\n    line-height: 1;\n  }\n  .solution-area .top {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 20px;\n  }\n  .solution-area .top .right {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n  }\n  #wrap:not(.no-responsive) .solution-area .top .btn-basic {\n    height: 32px;\n  }\n  #wrap:not(.no-responsive) .solution-area .top .btn-basic span {\n    font-size: 14px;\n  }\n  .item-list {\n    width: 100%;\n    overflow: hidden;\n  }\n  .item-list > li {\n    width: calc(100% - 2px);\n    flex: none;\n  }\n  .product > .tab__line {\n    gap: 0;\n  }\n  #wrap:not(.no-responsive) .product > .tab__line li {\n    min-width: 89px;\n  }\n  .product .tab-content {\n    padding: 20px 0;\n    width: calc(100% + 15px);\n    overflow: hidden;\n    box-shadow: none;\n    height: auto;\n  }\n  .product .tab-content .scrollH {\n    height: 540px;\n    padding-right: 25px;\n    margin-right: 0;\n  }\n  .bg-logo {\n    text-align: center;\n  }\n  .btn-top {\n    right: 20px;\n  }\n}\n@media screen and (max-width: 767px) {\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .solution-area .paging {\n    margin-top: 20px;\n    width: 100%;\n    justify-content: center;\n  }\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .solution-area .paging ul {\n    margin: 0;\n    gap: 40px;\n  }\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .solution-area .paging .btn-prev {\n    width: 32px;\n    height: 32px;\n    margin: 0;\n    border: 0;\n    background: url(\"../img/icon_next_bgno.png\") no-repeat center center;\n    background-size: 100%;\n    transform: rotate(180deg);\n  }\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .solution-area .paging .btn-next {\n    width: 32px;\n    height: 32px;\n    margin: 0;\n    border: 0;\n    background: url(\"../img/icon_next_bgno.png\") no-repeat center center;\n    background-size: 100%;\n  }\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .solution-area .paging .btn-prev.disabled,\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .solution-area .paging .btn-next.disabled {\n    opacity: 0.2;\n  }\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .solution-area .paging li.btn-prev + li {\n    border: 0;\n    height: auto;\n    min-width: unset;\n    width: auto;\n    letter-spacing: 3px;\n  }\n}\n@media screen and (max-width: 499px) {\n  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype.active {\n    top: 194px;\n    height: calc(100vh - 192px);\n  }\n  .container.wide .box .box__body .box-wrap {\n    width: calc(100% - 40px);\n    padding: 0 20px 0;\n  }\n  #wrap:not(.no-responsive) .solution-area .tab__line li {\n    padding: 0 12px;\n  }\n  .container.wide .box .box-wrap .select__toggleBtn {\n    top: 90px;\n  }\n  #wrap:not(.float-page, .no-responsive) .container.wide .selectbar.box.menutype.active {\n    top: 142px;\n  }\n}\n\n/* management - 승인관리 */\n.content-wrap > .l-divide {\n  display: flex;\n  height: 100%;\n}\n.content-wrap > .l-divide > article + article {\n  border-left: 4px solid #dde2e9;\n}\n.user-num {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  color: #2a2c2f;\n  text-align: right;\n}\n.user-num span {\n  font-weight: 700;\n  color: #0a78ff;\n  margin-right: 4px;\n}\ntd.icon-new {\n  position: relative;\n}\ntd.icon-new:after {\n  content: \"\";\n  display: block;\n  clear: both;\n}\ntd.icon-new span::before {\n  content: \"New\";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  left: -20px;\n  float: left;\n  margin-top: 2px;\n  width: 24px;\n  height: 12px;\n  margin-right: 8px;\n  font-weight: 500;\n  font-size: 8px;\n  line-height: 14px;\n  color: #fff;\n  background: #0a78ff;\n  border-radius: 16px;\n}\ntd.icon-delete {\n  position: relative;\n}\ntd.icon-delete:after {\n  content: \"\";\n  display: block;\n  clear: both;\n}\ntd.icon-delete span::before {\n  content: \"삭제\";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  left: -20px;\n  float: left;\n  margin-top: 2px;\n  width: 24px;\n  height: 12px;\n  margin-right: 8px;\n  font-weight: 500;\n  font-size: 8px;\n  line-height: 14px;\n  color: #fff;\n  background: #f55547;\n  border-radius: 16px;\n}\n.tbl-list table td button.btn.btn-delete-g {\n  background-size: 20px 20px;\n}\n.form__input .input__area .btn-new {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  background: #0978ff;\n  height: 12px;\n  min-width: 24px;\n  padding: 0 3px;\n  border-radius: 25px;\n  border-color: #0978ff;\n}\n.form__input .input__area .btn-new span {\n  color: #fff;\n  font-size: 8px;\n}\n.form__input .input__area .btn-new + input[type=\"text\"] {\n  padding-right: 38px;\n  width: calc(100% - 54px);\n}\n\n/* management - 설비유형 관리 */\n.no-responsive .box-wrap > .treebar.box {\n  border-right: 4px solid #dde2e9;\n  box-shadow: none;\n  border-radius: 0;\n  height: calc(100vh - 115px);\n  min-height: 964px;\n}\n.treebar.box.pushy-menutype.type2 .box__header {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  height: auto;\n  padding: 12px 15px 11px;\n}\n.treebar.box.pushy-menutype.type2 .box__header .add__item {\n  height: auto;\n  width: calc(100% + 16px);\n  padding: 12px;\n  margin: 0 -8px;\n  background: #e6f0ff;\n  border-radius: 4px;\n  border: 0;\n  justify-content: flex-start;\n}\n.treebar.box.pushy-menutype.type2 .box__header .add__item:hover {\n  background: #dee9f6;\n}\n.treebar.box.pushy-menutype.type2 .box__header .add__item:active {\n  background: #b4d2ff;\n}\n.treebar.box.pushy-menutype.type2 .box__header .add__item span {\n  display: flex;\n  align-items: center;\n  color: #0978ff;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1;\n}\n.treebar.box.pushy-menutype.type2 .box__header .add__item span::before {\n  content: \"\";\n  background: url(\"../img/icon_plus.png\") no-repeat center center;\n  width: 12px;\n  height: 12px;\n  margin-right: 12px;\n  background-size: 100%;\n}\n.box.treebar.pushy-menutype.type2 .lnb {\n  /* height: calc(100vh - 103px); */\n  height: calc(100% - 74px);\n}\n.box.treebar.pushy-menutype.type2 .lnb .lnb-depth2 > li > .add__item {\n  margin: 8px 8px 24px;\n  width: calc(100% - 16px);\n}\n.box.treebar.pushy-menutype.type2 .lnb .lnb-depth1 > li.active {\n  border-bottom: 0;\n}\n.box.treebar.pushy-menutype.type2 .lnb .lnb-depth1 > li.active > p {\n  background: #f0f2f4;\n  color: #2a2c2f;\n}\n.box.treebar.pushy-menutype.type2 .lnb .lnb-depth1 > li > p a {\n  font-weight: 700;\n}\n.box.treebar.pushy-menutype.type2 .lnb .lnb-depth1 > li > p a::after {\n  content: none;\n}\n.box.treebar.pushy-menutype.type2 .lnb .lnb-depth2 > li {\n  border-bottom: 1px solid #dde2e9;\n}\n.box.treebar.pushy-menutype.type2 .lnb .lnb-depth2 > li:first-child {\n  border-top: 1px solid #dde2e9;\n}\n.box.treebar.pushy-menutype.type2 .lnb .lnb-depth2 > li > a {\n  padding: 16px 24px 15px 20px;\n  width: calc(100% - 44px);\n  border: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.box.treebar.pushy-menutype.type2 .lnb .lnb-depth2 > li > a::after {\n  content: none;\n}\n.box.treebar.pushy-menutype.type2 .lnb .lnb-depth2 > li > a p {\n  display: flex;\n  align-items: center;\n  flex: 2.5;\n}\n.box.treebar.pushy-menutype.type2 .lnb .lnb-depth2 > li > a p:before {\n  content: \"\";\n  width: 8px;\n  height: 8px;\n  margin-right: 16px;\n  background: #0a78ff;\n  border-radius: 50%;\n}\n.box.treebar.pushy-menutype.type2 .lnb .lnb-depth2 > li > a.dis p:before {\n  background: #dde2e9;\n}\n.box.treebar.pushy-menutype.type2 .lnb .lnb-depth2.basic > li > a p:before {\n  content: none;\n}\n.box.treebar.pushy-menutype.type2 .lnb .lnb-depth2 > li > a span.txt {\n  flex: 1;\n  color: #0a78ff;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 1.2;\n  text-align: right;\n}\n.box.treebar.pushy-menutype.type2 .lnb .lnb-depth2 > li.active > a {\n  background: #b4d2ff;\n  font-weight: 700;\n  color: #0a78ff;\n}\n.box.treebar.pushy-menutype.type2 .box__search.type-line + .box__header + .lnb {\n  height: calc(100% - 107px);\n}\n.treebar.box.pushy-menutype .box__header .list-info {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 16px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.2;\n  width: 100%;\n}\n.treebar.box.pushy-menutype .box__header .list-info.tit {\n  color: #0a78ff;\n  justify-content: flex-start;\n  font-weight: 500;\n}\n.treebar.box.pushy-menutype .box__header .list-info span {\n  display: flex;\n  align-items: center;\n}\n.treebar.box.pushy-menutype .box__header .list-info span:before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  margin-right: 8px;\n  background: #0a78ff;\n  border-radius: 50%;\n}\n.treebar.box.pushy-menutype .box__header .list-info span.dis:before {\n  background: #dde2e9;\n}\n.top-button {\n  display: flex;\n}\n.top-button button {\n  width: 32px;\n  height: 32px;\n  border-radius: 4px;\n  background-color: #909fb7;\n}\n.top-button button:hover {\n  background-color: #7a8596;\n}\n.top-button button:active {\n  background-color: #646c74;\n}\n.top-button button.blue {\n  border-color: #0a78ff;\n  background-color: #0a78ff;\n}\n.top-button button.blue:hover {\n  border-color: #0050b8;\n  background-color: #0050b8;\n}\n.top-button button.blue:active {\n  border-color: #003876;\n  background-color: #003876;\n}\n.top-button button + button {\n  margin-left: 10px;\n}\n.content__info ul:not(.paging__button) li {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 40px;\n}\n.content__info ul li p {\n  font-size: 14px;\n  line-height: 14px;\n  color: #2a2c2f;\n}\n.content__info ul li p.txt-info {\n  font-size: 14px;\n  color: #7a8596;\n  line-height: 24px;\n  margin: 5px 0 0 0;\n}\n.content__info ul li p.tit {\n  width: 120px;\n  font-weight: 700;\n  line-height: 20px;\n  font-size: 15px;\n}\n/* .content__info ul li:first-child p.tit {\n  margin-top: 5px;\n} */\n.content__info ul li p.tit span {\n  font-size: 13px;\n  font-weight: 400;\n  margin-left: 3px;\n}\n.content__info ul li p.tit span.inline {\n  display: inline !important;\n}\n.content__info ul li .txt {\n  width: calc(100% - 120px);\n  line-height: 20px;\n  position: relative;\n}\n.content__info ul li .treeon {\n  width: 100px;\n  height: 32px;\n  background: url(\"../img/icon_treeon.png\") no-repeat 0 0;\n  background-size: 100%;\n}\n.content__info ul li .treeoff {\n  width: 100px;\n  height: 32px;\n  background: url(\"../img/icon_treeoff.png\") no-repeat 0 0;\n  background-size: 100%;\n}\n.content__info ul li p.txt a {\n  color: #0a78ff;\n}\n.content__info ul li .tbl-list table th {\n  background: rgba(227, 231, 238, 0.5);\n  padding: 4px 24px;\n}\n.content__info ul li .tbl-list table td {\n  padding: 4px 24px;\n}\n.content__info ul li .tbl-list.p-4 table th,\n.content__info ul li .tbl-list.p-4 table td {\n  padding: 4px;\n}\n.content__info ul li .tbl-list.p-4 table td .btn-delete-gr {\n  background-size: 32px;\n}\n.content__info ul li .txt.radioBox {\n  gap: 20px;\n  flex-wrap: wrap;\n  margin-top: 4px;\n}\n.content__info ul li .txt.radioBox input[type=\"checkbox\"] + label {\n  width: 63px;\n  margin-left: 0;\n}\n.content__info ul li .txt.radioBox input[type=\"checkbox\"] + label:before {\n  top: 0;\n  border-radius: 0;\n}\n.content__info ul li .txt.radioBox input[type=\"checkbox\"] + label:after {\n  width: 12px;\n  height: 12px;\n  top: 0;\n  border-radius: 0;\n  background-size: inherit;\n}\n.content__info ul li .btn__wrap {\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  margin-top: 6px;\n}\n.content__info ul li .btn__wrap .btn-basic {\n  height: 40px;\n  min-width: 140px;\n}\n.content__info ul li .btn__wrap .btn-basic span {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n@media screen and (max-width: 940px) {\n  .no-responsive .treebar.box {\n    display: block;\n  }\n  .no-responsive .box.treebar.pushy-menutype.active {\n    top: unset;\n  }\n  .no-responsive .box.treebar.pushy-menutype .lnb .lnb-depth1 > li > p {\n    min-height: unset;\n  }\n  .no-responsive .box.treebar.pushy-menutype .lnb .lnb-depth2 > li a {\n    min-height: unset;\n  }\n  .no-responsive .box.treebar.pushy-menutype .lnb .lnb-depth3 > li a {\n    min-height: unset;\n  }\n}\n\n/* management - 메세지 관리 */\n.box.treebar.pushy-menutype.type3 .lnb .lnb-depth1 > li.active {\n  position: relative;\n}\n.box.treebar.pushy-menutype.type3 .lnb .lnb-depth1 > li.active:before {\n  content: none;\n}\n.box.treebar.pushy-menutype .lnb .lnb-depth1 > li.active > p {\n  background: #b4d2ff;\n  color: #0a78ff;\n}\n.box.treebar.pushy-menutype.type3 .lnb .lnb-depth1 > li > p {\n  font-weight: 700;\n}\n.box.treebar.pushy-menutype.type3 .lnb .lnb-depth1 > li > p a::after {\n  content: none;\n}\n.box.treebar.pushy-menutype.type3 .lnb .lnb-depth1 > li > p a span {\n  max-width: 100%;\n}\n.popup__body .message .form__input {\n  width: 100%;\n  margin-bottom: 24px;\n}\n.popup__body .message .form__input + .form__input {\n  padding-top: 24px;\n  border-top: 1px solid #dde2e9;\n}\n.popup__body .message .form__input:last-child {\n  margin-bottom: 0;\n}\n.popup__body .message .form__input .tit {\n  font-weight: 700;\n  font-size: 15px;\n  color: #2a2c2f;\n  width: 222px;\n}\n.popup__body .message .form__input .sub-input {\n  margin-top: 1rem;\n  align-items: flex-start;\n}\n.popup__body .message .form__input .sub-input + .sub-input {\n  margin-top: 8px;\n}\n.popup__body .message .form__input .sub-input .tit {\n  font-weight: 500;\n  font-size: 13px;\n  color: #2a2c2f;\n  width: 222px;\n  vertical-align: top;\n  margin-top: 8px;\n}\n.popup__body .message .form__input input[type=\"text\"]:read-only,\n.popup__body .message .form__input input[type=\"text\"]:read-only:focus,\n.popup__body .message .form__input input[type=\"text\"]:disabled {\n  background: #f7f8fa !important;\n  border-color: #f7f8fa !important;\n  color: #2a2c2f !important;\n}\n\n/* management - 메뉴 관리 */\n.tbl-list.menulist input[type=\"checkbox\"] + label:before {\n  width: 12px;\n  height: 12px;\n  border-radius: 0;\n}\n.tbl-list.menulist input[type=\"checkbox\"]:checked + label:after {\n  width: 12px;\n  height: 12px;\n  border-radius: 0;\n  background-size: 10px;\n  background-position-y: 2px;\n}\n.tbl-list.menulist input[type=\"checkbox\"]:disabled + label:before {\n  background-color: #e9edef;\n  border-color: #e9edef;\n}\n.tbl-list.menulist input[type=\"checkbox\"]:disabled + label:after {\n  content: none;\n}\n.tbl-list.menulist input[type=\"checkbox\"].readonly:disabled + label:before {\n  border-color: #909fb7;\n  background: url(\"../img/icon_chk_s.png\") no-repeat center center #909fb7;\n  background-size: 10px;\n}\n.tbl-list.menulist input[type=\"checkbox\"].error + label:before {\n  border-color: #f55547;\n  background-color: #fff;\n}\n.tbl-list.menulist input[type=\"checkbox\"].error:checked + label:after {\n  border-color: #f55547;\n  background: url(\"../img/icon_chk_s.png\") no-repeat center center #f55547;\n  background-size: 10px;\n}\n.tbl-list.menulist input[type=\"checkbox\"] {\n  position: unset;\n  width: auto;\n}\n.tbl-list.menulist input[type=\"checkbox\"] + label {\n  display: inline;\n}\n\n/* management - 사용자 관리 */\n.box.treebar.pushy-menutype.type3 .box__header + .lnb {\n  height: calc(100% - 47px);\n}\n.tbl-list.userlist table td button.btn-basic {\n  padding: 0 8px;\n  height: 30px;\n}\n/* .tbl-list.userlist table td button.btn-basic.bg-no:hover, .tbl-list.userlist.tbl-select tr td:hover button.bg-no.btn-basic:not(:disabled):hover, .tbl-list.userlist.tbl-select tr.selected td button.bg-no.btn-basic{\n  background: transparent !important;\n} */\n.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap button.txtline {\n  width: auto;\n  height: auto;\n  border: 0;\n}\n.userjoin-ok.page-detail .popup__body .form__input li .btn__wrap button.txtline span {\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 0px;\n  color: #909fb7;\n  text-decoration: underline;\n}\n\n/* management - 사업장 관리 */\n.content__info + .content__info.line:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background: #e9edef;\n}\n.content__info + .content__info.line > .form__input {\n  padding-top: 35px;\n}\n.content__info + .content__info.scrollH {\n  max-height: calc(100vh - 560px);\n  min-height: 520px;\n  margin-right: -20px;\n}\n.content__info.hidden + .content__info.scrollH {\n  height: calc(100vh - 240px);\n}\n.content__info + .content__info > h3 {\n  margin-top: 30px;\n  font-weight: 700;\n  font-size: 17px;\n  line-height: 22px;\n  color: #2a2c2f;\n}\n.content__info + .content__info.scrollH ul.form__input li:last-child {\n  margin: 40px 0 0;\n}\n.result__score p.tit.caution {\n  display: flex;\n  align-items: center;\n  font-size: 15px;\n  color: #2a2c2f;\n  font-weight: 400;\n  margin-top: 0;\n  width: auto;\n}\n.result__score p.tit.caution::before {\n  content: \"\";\n  width: 16px;\n  height: 16px;\n  margin-right: 4px;\n  background: url(\"../img/icon_caution.png\") no-repeat top center;\n  background-size: 100%;\n}\n.result__score p.tit.caution::after {\n  content: \"\";\n  width: 14px;\n  height: 14px;\n  margin-left: 20px;\n  background: url(\"../img/icon_eq.png\") no-repeat center center;\n  background-size: 100%;\n}\n.txt .result__score .score::before {\n  content: \"\";\n  width: 12px;\n  height: 12px;\n  margin-right: 0;\n}\n.result__score {\n  display: flex;\n  align-items: center;\n}\n.result__score::after {\n  content: \"점\";\n  margin-left: 7px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #909fb7;\n}\n.result__score .select.active ul {\n  max-height: 162px;\n  overflow-y: auto;\n}\n.content-wrap .box__header .box__title > .btn-more {\n  width: 32px;\n  height: 32px;\n  border: 0;\n  margin-left: 16px;\n  background: url(\"../img/icon_downbtn_s.png\") no-repeat center center;\n  background-size: 100%;\n  transform: scaleY(-1);\n}\n.content-wrap .box__header .box__title > .btn-more.on {\n  transform: scaleY(1);\n}\n.content-wrap .content__info .listbox__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  margin-top: 30px;\n}\n.content-wrap .content__info .listbox__top h3 {\n  font-weight: 700;\n  font-size: 17px;\n  line-height: 22px;\n  color: #2a2c2f;\n}\n.content-wrap .content__info .listbox__top button.add__item {\n  width: 128px;\n  height: 32px;\n  background: #e7f2ff;\n  border: 0;\n}\n.content-wrap .content__info .listbox__top button.add__item span {\n  font-weight: 500;\n  font-size: 14px;\n  color: #0a78ff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.content-wrap .content__info .listbox__top button.add__item span::before {\n  content: \"\";\n  background: url(\"../img/icon_plus.png\") no-repeat center center;\n  width: 12px;\n  height: 12px;\n  margin-right: 7px;\n  background-size: 100%;\n}\n.content-wrap .content__info .listbox__top button.add__item:hover {\n  background: #dee9f6;\n}\n.content-wrap .content__info .listbox__top button.add__item:active {\n  background: #b4d2ff;\n}\n.content-wrap .content__info .listbox__area {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding-left: 4px;\n}\n.content-wrap .content__info .listbox {\n  width: calc(25% - 8px);\n  min-width: 320px;\n  height: 270px;\n  background: #ffffff;\n  box-shadow: 0px 3px 8px rgba(144, 159, 183, 0.5);\n  border-radius: 4px;\n}\n.content-wrap .content__info .listbox:last-child {\n  margin-right: 0;\n}\n.content-wrap .content__info .listbox .box__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 15px;\n  border-bottom: 1px solid #dde2e9;\n}\n.content-wrap .content__info .listbox .box__top p {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 16px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.content-wrap .content__info .listbox .box__top p.site {\n  padding-left: 20px;\n  background: url(\"../img/icon_treesub3_g.png\") 0 center no-repeat;\n  background-size: 10px 14px;\n}\n.content-wrap .content__info .listbox .box__top p.factory {\n  padding-left: 20px;\n  background: url(\"../img/icon_treesub3_g.png\") 0 center no-repeat;\n  background-size: 10px 14px;\n}\n.content-wrap .content__info .listbox .box__bottom {\n  padding: 15px;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n}\n.content-wrap .content__info .listbox .box__bottom p span {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 12px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.content-wrap .content__info .listbox .box__bottom ul {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.content-wrap .content__info .listbox .box__bottom ul li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 15px;\n  line-height: 16px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  margin-bottom: 0;\n}\n.content-wrap .content__info .listbox .box__bottom ul li.column {\n  flex-direction: column;\n}\n.content-wrap .content__info .listbox .box__bottom ul + ul {\n  border-top: 1px solid #dde2e9;\n  margin-top: 12px;\n  padding-top: 5px;\n}\n.content-wrap .content__info .listbox .box__bottom ul li strong {\n  font-weight: 500;\n  margin-right: 7px;\n}\n.content-wrap .content__info .listbox .box__bottom ul li .tit {\n  width: auto;\n}\n.content-wrap .content__info .listbox .box__bottom ul li .score__info {\n  margin-top: 8px;\n  margin-bottom: 0;\n  font-size: 12px;\n  line-height: 1.3;\n  text-align: justify;\n  letter-spacing: -0.4px;\n  color: #909fb7;\n}\n.content-wrap .content__info .listbox .box__bottom ul li .result__score {\n  justify-content: space-between;\n  width: 100%;\n  margin-top: 5px;\n}\n.content-wrap .content__info .listbox .box__bottom ul li .result__score::after {\n  content: none;\n}\n.content-wrap .content__info .listbox .box__bottom ul li .result__score div::after {\n  content: \"점\";\n  margin-left: 7px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #909fb7;\n}\n.content-wrap .content__info .listbox .box__bottom ul li .result__score p.tit.caution::after {\n  margin-right: 7px;\n  margin-left: 15px;\n}\n.content-wrap .content__info .listbox .box__bottom li div {\n  display: flex;\n  align-items: center;\n}\n.content-wrap .content__info .listbox .box__bottom p strong {\n  font-weight: 700;\n  margin-left: 10px;\n}\n.popup-type1.workplace-ok.page-detail .workplace__info .txt_workplace {\n  margin-left: 0;\n  width: 100%;\n}\n.popup-type1.workplace-ok.page-detail .workplace__info .txt_workplace ul {\n  width: 100%;\n}\n.popup-type1.workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column .result__score {\n  justify-content: flex-start;\n  width: 100%;\n  margin-bottom: 0;\n}\n.popup-type1.workplace-ok.page-detail .workplace__info .txt_workplace .result__score::after {\n  content: none;\n}\n.popup-type1.workplace-ok.page-detail .workplace__info .txt_workplace .result__score > div::after {\n  content: \"점\";\n  margin-left: 7px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #909fb7;\n}\n.popup-type1.workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column .result__score .tit.caution {\n  width: auto;\n  margin-right: 0;\n}\n.popup-type1.workplace-ok.page-detail .workplace__info .txt_workplace .result__score p.tit.caution::after {\n  margin-right: 7px;\n  margin-left: 15px;\n}\n.popup-type1.workplace-ok.page-detail\n  .workplace__info\n  .txt_workplace\n  ul\n  li\n  div.txt.column\n  .result__score\n  .score::before {\n  content: none;\n}\n.popup-type1.workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column .score__info {\n  margin-top: 20px;\n  margin-bottom: 0;\n  font-size: 13px;\n  line-height: 1.3;\n  text-align: justify;\n  letter-spacing: -0.4px;\n  color: #909fb7;\n}\n.popup-type1.workplace-ok.page-detail .workplace__info .txt_workplace ul li p.tit {\n  width: 160px;\n}\n\n/* management - 솔루션관리 */\n.keywordlist {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\ntd .keywordlist {\n  margin: 12px 0;\n}\n.labellist {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.labellist li {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  height: 28px;\n  padding: 0 12px;\n  margin: 0;\n  font-size: 14px;\n  font-weight: 400;\n  color: #0a78ff;\n  background: #e7f2ff;\n  border-radius: 45px;\n}\ntd .labellist {\n  margin: 12px 0;\n}\n\n/* 서비스요청 - 상담신청 */\n.service .box__header {\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 32px 72px 32px;\n  max-width: 828px;\n  height: auto;\n  border: 0;\n}\n.service .box__header h2 {\n  margin-bottom: 24px;\n  font-weight: 700;\n  font-size: 25px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.service .box__header .box__title {\n  margin-bottom: 32px;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 24px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.service .box__info {\n  padding-left: 225px;\n  background: url(\"../img/bg_servicenfo.png\") no-repeat left center;\n  background-size: auto 88px;\n}\n.service .box__info.nobg {\n  background: none;\n  padding: 0;\n}\n.service .box__info li {\n  position: relative;\n  display: flex;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 22px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  padding-left: 10px;\n}\n.service .box__info li::before {\n  content: \"\";\n  position: absolute;\n  top: 10px;\n  left: 0;\n  width: 3px;\n  height: 3px;\n  margin-right: 7px;\n  border-radius: 50%;\n  background: #2a2c2f;\n}\n.service hr {\n  border-top: 1px solid #dde2e9;\n}\n.service .box__body .d-sm-block {\n  display: none;\n}\n.service .box__body {\n  padding: 40px 72px 64px;\n  max-width: 828px;\n}\n.service .box__body .info__input + .info__input {\n  margin-top: 70px;\n}\n.service .box__body .info__input {\n  width: 828px;\n}\n.service .box__body .info__input li {\n  margin-bottom: 24px;\n  margin-top: 0;\n  gap: 0;\n}\n.service .box__body .info__input li:last-child {\n  margin-bottom: 0;\n}\n.service .box__body .info__input li .flex-column {\n  width: 100%;\n  margin-bottom: 16px;\n}\n.service .box__body .info__input li .flex-column .tit {\n  margin-bottom: 16px;\n}\n.service .box__body .page-top h3 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding-bottom: 16px;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  border-bottom: 1px solid #a4b0c4;\n}\n.service .box__body .page-top h3 .txt-info {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.service .box__body .info__input .content__info {\n  margin-left: 220px;\n}\n.service .box__body .content__info ul.form__input li p.tit {\n  width: 248px;\n  margin-top: 7px;\n  line-height: 20px;\n  font-size: 15px;\n}\n.service .box__body .content__info ul.form__input .input__area {\n  width: 360px;\n  max-width: 360px;\n}\n.service .box__body .content__info ul.form__input .input__area .checkBox {\n  margin-bottom: 15px;\n}\n.service .box__body .content__info ul.form__input .input__area p.txtnum {\n  position: absolute;\n  top: -15px;\n  right: 0;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 16px;\n  color: #909fb7;\n}\n.service .box__body .input__area .select + .select {\n  margin-top: 8px;\n}\n.service .box__body .input__area .txt-info {\n  display: inline-flex;\n  font-size: 12px;\n  line-height: 16px;\n  color: #646c74;\n  margin-bottom: 8px;\n  margin-top: 4px;\n}\n.service .box__body .input__area .txt-info + .txt-info {\n  margin-top: 0;\n}\n.service .box__body .input__area .txt-info::before {\n  content: \"*\";\n  margin-right: 2px;\n  font-size: 12px;\n}\n.service .box__body .input__area .txt-info.txt-red {\n  color: #f55547 !important;\n}\n.service ul.form__input li .filelist li {\n  gap: 4px;\n}\n.service .box__body .content__info ul.form__input li.flex-column p.tit,\n.service .box__body .content__info ul.form__input li.flex-column .input__area {\n  width: 100% !important;\n  max-width: 100% !important;\n}\n.service .box__body .content__info ul.form__input li.flex-column p.tit {\n  font-size: 14px;\n}\n.service .box__body .content__info ul.form__input li.flex-column .input__area {\n  margin-top: 16px;\n}\n.service .box__body .terms {\n  display: flex;\n  flex-direction: column;\n}\n.service .box__body .terms li {\n  display: flex;\n  flex-direction: column;\n  margin-top: 24px;\n}\n.service .box__body .terms li:first-child {\n  margin-top: 0;\n}\n.service .box__body .terms .box-scroll {\n  border: 1px solid #909fb7;\n  border-radius: 4px;\n  padding: 9px 19px 9px 9px;\n  font-size: 13px;\n  height: 140px;\n  overflow-y: scroll;\n  background: #fff;\n}\n.service .box__body .terms p {\n  width: 100%;\n  font-size: 13px;\n  line-height: 16px;\n  color: #2a2c2f;\n  word-wrap: break-word;\n  word-break: break-all;\n  text-align: justify;\n}\n/* .service .box__body .radioBox input[type='radio']:checked::before {\n  height: 100%;\n} */\n.service .box__body .form__input li .btn__wrap {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 0;\n}\n.service .box__body .form__input li .btn__wrap.center {\n  max-width: 100%;\n  justify-content: center;\n  margin-left: 10px;\n}\n.service .box__body .form__input li .btn__wrap button {\n  padding: 0 1.25rem;\n  width: 8.75rem;\n  height: 2.5rem;\n  background-color: #0a78ff;\n  border: 0;\n}\n.service .box__body .form__input li .btn__wrap button span {\n  color: #fff;\n  font-weight: 700;\n}\n.service .box__body .form__input li .btn__wrap button + button {\n  margin-left: 8px;\n}\n.service .form__input input[type=\"text\"].input-error,\n.service .form__input input[type=\"password\"].input-error,\n.service .form__input input[type=\"tel\"].input-error,\n.service .form__input input[type=\"file\"].input-error,\n.service .form__input textarea.input-error {\n  background: none;\n}\n.service .service-info {\n  margin-top: 96px;\n}\n.service .service-info .banner-box {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 22px 15px 19px 30px;\n  height: 55px;\n  width: calc(100% - 45px);\n  background: url(\"../img/bg_service.png\") no-repeat 0 0;\n  background-size: cover;\n}\n.service .service-info .banner-box::after {\n  content: \"\";\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  width: 40px;\n  height: 19.2px;\n  background: url(\"../img/icon_logo_ls_sky.svg\") no-repeat center center;\n  background-size: 100%;\n  opacity: 0.6;\n}\n.service .service-info .banner-box .left p {\n  color: #fff;\n  font-weight: 600;\n}\n.service .service-info .banner-box .right {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n.service .service-info .banner-box .right .btn-txt {\n  gap: 0 !important;\n}\n.service .service-info .banner-box .right .btn-txt span {\n  font-size: 14px;\n  letter-spacing: -0.07em;\n  color: #fff !important;\n}\n.service .service-info .banner-box button::after {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_arrow_white.svg\") no-repeat center center;\n  background-size: 100%;\n  transform: scaleX(-1);\n}\n\n@media screen and (max-width: 1124px) {\n  .service .box__body {\n    padding: 40px 24px 64px;\n    max-width: 720px;\n  }\n  .service .box__header {\n    padding: 32px 24px 32px;\n    max-width: 720px;\n  }\n  .service .box__header h2 {\n    font-size: 20px;\n    line-height: 1;\n    margin-bottom: 38px;\n  }\n  .service .box__header .box__title {\n    margin-bottom: 34px;\n  }\n  .service .box__info {\n    padding-left: 144px;\n    background-size: auto 72px;\n  }\n  .service .box__info li {\n    font-size: 12px;\n    line-height: 18px;\n  }\n  .service .box__body .page-top {\n    margin-bottom: 32px;\n  }\n  .service .box__body .page-top h3 {\n    font-size: 15px;\n  }\n  .service .box__body .info__input {\n    width: 100%;\n  }\n  .service .box__body .info__input .content__info {\n    margin-left: 132px;\n  }\n  .service .box__body .content__info ul.form__input li p.tit {\n    width: 228px;\n    font-size: 14px;\n  }\n  .service .box__body .content__info ul.form__input .input__area {\n    width: calc(100% - 228px);\n    max-width: calc(100% - 228px);\n  }\n  .service .box__body .terms li:last-child {\n    margin-top: 16px !important;\n  }\n}\n@media screen and (max-width: 940px) {\n  .service .service-info .m-block {\n    display: none !important;\n  }\n  .service .service-info .m-none {\n    display: block !important;\n  }\n  #wrap:not(.no-responsive, .float-page) .container.service {\n    margin: 3.625rem 0.5rem 0.5rem 0.5rem;\n  }\n  #wrap:not(.no-responsive, .float-page) .container.service .content {\n    margin-top: 0;\n  }\n  .container.service .form__input {\n    display: block;\n  }\n  .container.service .form__input li {\n    flex-direction: row;\n  }\n  .container.service .form__input li .tit {\n    margin-top: 7px !important;\n  }\n  .service .box__body .content__info ul.form__input li.flex-column p.tit {\n    margin-top: 0 !important;\n  }\n  .service .box__body .info__input li .flex-column .tit {\n    margin-bottom: 16px !important;\n  }\n  #wrap:not(.no-responsive) .service .tbl-list table th {\n    font-size: 14px;\n  }\n  #wrap:not(.no-responsive) .service .tbl-list:not(.row) table td {\n    height: 40px;\n    font-size: 14px;\n  }\n}\n@media screen and (max-width: 699px) {\n  .service .service-info .m-block {\n    display: block !important;\n  }\n  .service .service-info .m-none {\n    display: none !important;\n  }\n  .service .box__header {\n    padding: 24px 20px 0;\n  }\n  .service .box__header h2 {\n    margin-bottom: 16px;\n  }\n  .service hr {\n    display: none;\n  }\n  .service .box__body {\n    padding: 58px 20px 64px;\n  }\n  .service .box__body .page-top {\n    margin-bottom: 24px;\n  }\n  .service .box__body .page-top h3 {\n    font-size: 20px;\n  }\n  .service .box__body .page-top h3 .txt-info {\n    font-size: 12px;\n  }\n  .container.service .form__input {\n    display: flex;\n    flex-direction: column;\n    gap: 17px;\n  }\n  .container.service .form__input li {\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    margin: 0;\n    gap: 10px;\n  }\n  .service .box__body .content__info ul.form__input li p.tit {\n    font-size: 15px;\n    width: 100%;\n    margin-top: 0 !important;\n    margin-bottom: 8px;\n  }\n  .service .box__body .info__input li .flex-column .tit {\n    margin-bottom: 10px !important;\n  }\n  .service .box__header .box__title {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    margin-bottom: 0;\n  }\n  .service .box__header .box__info {\n    display: none;\n  }\n  .service .box__body .info__input .content__info {\n    margin-left: 4px;\n  }\n  .service .box__body .input__area .txt-info {\n    font-size: 14px;\n    line-height: 21px;\n    color: #909fb7;\n  }\n  .service .box__body .content__info ul.form__input .input__area {\n    width: 100%;\n    max-width: 100%;\n    min-width: 100%;\n  }\n  .service .box__body .content__info ul.form__input .input__area .checkBox {\n    margin-bottom: 8px;\n  }\n  .service .box__body .content__info ul.form__input .input__area p.txtnum {\n    top: -22px;\n  }\n  .service .box__body .terms li {\n    margin-top: 16px;\n  }\n  .service .box__body .content__info ul.form__input li.flex-column .terms li:last-child .input__area {\n    margin-top: 0;\n  }\n  .service .box__body .content__info ul.form__input li.flex-column p.tit {\n    margin-bottom: 0;\n    font-size: 16px;\n    line-height: 20px;\n  }\n  .service .box__body .content__info ul.form__input li.flex-column .input__area {\n    margin-top: 14px;\n  }\n  .service .box__body .content__info ul.form__input li.flex-column .input__area.mt-8 {\n    margin-top: 0 !important;\n  }\n  .service .box__body .select {\n    height: 40px;\n  }\n  .service .box__body .form__input input[type=\"text\"],\n  .service .box__body .form__input input[type=\"password\"],\n  .service .box__body .form__input input[type=\"tel\"],\n  .service .box__body .form__input input[type=\"file\"] {\n    height: 40px;\n  }\n  .service .box__body .filebox .upload-name {\n    height: 40px;\n    padding: 0 0.75rem 0 3.2rem;\n  }\n  .service .box__body .filebox label {\n    width: 40px;\n  }\n  .service .box__body .form__input li .btn__wrap {\n    max-width: 100%;\n    margin-left: 0;\n    justify-content: center;\n  }\n  .service .box__body .info__input li.mt-80 {\n    margin-top: 72px !important;\n  }\n  .container.service .box__body .form__input li.mt-70 {\n    margin-top: 35px !important;\n  }\n  #wrap:not(.no-responsive) .service .tbl-list table th {\n    font-size: 16px;\n  }\n  #wrap:not(.no-responsive) .service .tbl-list:not(.row) table td {\n    font-size: 16px;\n    height: 52px;\n  }\n  .service .content__info ul.form__input li textarea {\n    height: 234px !important;\n  }\n  .service .box__body .input__area .txt-info {\n    margin-bottom: 4px;\n  }\n  .service .box__body .info__input + .info__input {\n    margin-bottom: 30px;\n  }\n  .service .box__body .terms p {\n    font-size: 14px;\n    line-height: 19px;\n  }\n  .service .box__body .service-info {\n    margin-top: 80px;\n  }\n  .service .service-info .banner-box {\n    margin-bottom: 16px;\n    padding: 16px 12px 16px 24px;\n    width: calc(100% - 36px);\n    height: 104px;\n    background: url(\"../img/bg_service_mobile.png\") no-repeat 0 0;\n    background-size: cover;\n  }\n  .service .service-info .banner-box .left p {\n    line-height: 20px;\n    width: 295px;\n  }\n  .service .service-info .banner-box button::after {\n    width: 16px;\n    height: 16px;\n  }\n  .service .service-info .banner-box .right .btn-txt span {\n    font-size: 12px;\n    letter-spacing: -0.04em;\n  }\n  .service .service-info ul {\n    padding: 10px 8px 8px 16px;\n    background: #e9edef;\n  }\n  .service .service-info ul li {\n    display: flex;\n    gap: 8px;\n  }\n  .service .service-info ul li p {\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: -0.4px;\n    color: #2a2c2f;\n    width: calc(100% - 8px);\n  }\n  .service .service-info ul li::before {\n    content: \"\";\n    width: 3px;\n    height: 3px;\n    background: #2a2c2f;\n    margin-top: 9px;\n    border-radius: 50%;\n  }\n}\n@media screen and (max-width: 499px) {\n  #wrap:not(.no-responsive, .float-page) .container.service {\n    margin: 90px 0 0;\n  }\n  .service .service-info .banner-box .left p {\n    line-height: 20px;\n    width: 224px;\n    letter-spacing: 0;\n  }\n}\n\n/* management - 요청 관리 - 고객 문의 */\n.btn-add-file,\n.tbl-list table td button.btn.btn-add-file {\n  padding-left: 24px;\n  margin: 0;\n  background: url(\"../img/icon_add_file.png\") no-repeat 0 center;\n  background-size: 20px;\n  width: auto;\n  height: 20px;\n  filter: none;\n}\n.tbl-list table td button.btn.btn-add-file span {\n  font-weight: 400;\n}\n.btn-add-file:active {\n  background: url(\"../img/icon_add_file_active.png\") no-repeat 0 center !important;\n  background-size: 20px !important;\n}\n.btn-add-file:hover {\n  background: url(\"../img/icon_add_file_hover.png\") no-repeat 0 center !important;\n  background-size: 20px !important;\n}\n.btn-add-file:disabled {\n  background: url(\"../img/icon_add_file_dis.png\") no-repeat 0 center !important;\n  background-size: 20px !important;\n  border-color: transparent !important;\n  background-color: transparent !important;\n  opacity: 1 !important;\n}\n.btn-add-file:disabled span {\n  color: #2a2c2f !important;\n}\n.btn-add-file:disabled:active {\n  background: url(\"../img/icon_add_file_dis.png\") no-repeat 0 center !important;\n  background-size: 20px !important;\n}\n.sub-input .filelist li span {\n  padding-left: 24px;\n  background: url(\"../img/icon_add_file.png\") no-repeat 0 center;\n  background-size: 20px;\n}\n.sub-input .filelist li:active span {\n  padding-left: 24px;\n  background: url(\"../img/icon_add_file_active.png\") no-repeat 0 center;\n  background-size: 20px;\n}\n.sub-input .filelist li:hover span {\n  padding-left: 24px;\n  background: url(\"../img/icon_add_file_hover.png\") no-repeat 0 center;\n  background-size: 20px;\n}\n.sub-input .filelist li:not(:first-child) span {\n  background: none !important;\n}\n.popup-type2 .popup__body .form__input .sub-input {\n  margin-top: 16px;\n}\n.popup-type2 .popup__body .form__input .sub-input + .sub-input {\n  margin-top: 8px;\n}\n.popup-type2 .popup__body .form__input .sub-input .tit {\n  font-weight: 500;\n  font-size: 14px;\n  color: #2a2c2f;\n  line-height: 20px;\n  min-width: 72px;\n  margin-right: 16px;\n  margin-top: 0;\n}\n.btn-basic.dis-click {\n  background: #f0f2f4;\n  border-color: #f0f2f4;\n}\n.popup-layer.h90vh {\n  height: auto !important;\n}\n.popup-layer.popup-type2.h90vh .popup__body {\n  max-height: calc(90vh - 6.5rem) !important;\n}\n.popup-layer.h90vh .popup__body {\n  max-height: calc(90vh - 7.5rem) !important;\n}\n\n.popup-type2.h674 .popup__body .flex-row .pop-right {\n  height: calc(75vh - 73px);\n}\n\n/* management - 에너지솔루션 관리 */\n.content-wrap > .l-divide:has(.flex-7, .flex-3) .box__body h3 {\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 1;\n  color: #2a2c2f;\n}\n.content-wrap > .l-divide:has(.flex-7, .flex-3) .box__body .form__input .tit {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 1.3;\n  color: #2a2c2f;\n  letter-spacing: -0.06em;\n  min-width: 108px;\n  max-width: 108px;\n  word-break: keep-all;\n}\n.content-wrap > .l-divide:has(.flex-7, .flex-3) ul > li:has(+ h3) {\n  border-bottom: 1px solid #dde2e9;\n  padding-bottom: 40px;\n  margin-bottom: 40px;\n}\n*/\n\n/* sei - 마켓플레이스 */\n#wrap.page-market > header {\n  background-color: #fff;\n  height: 62px;\n  border-bottom: 1px solid #dde2e9;\n}\n#wrap.page-market > header .header__left {\n  flex: 2;\n  justify-content: space-between;\n}\n#wrap.page-market > header h1 {\n  width: 216px;\n  height: 20px;\n  padding-left: 32px;\n}\n#wrap.page-market > header h1 img {\n  /* width: 216px; */\n  width: auto;\n  height: 20px;\n  object-fit: contain;\n}\n#wrap.page-market > header h1:has(img.h26) {\n  width: 193px;\n  height: 26px;\n}\n#wrap.page-market .header__menu {\n  margin: 0 !important;\n  flex: none;\n  gap: 8px;\n}\n#wrap.page-market .header__menu li a {\n  font-size: 14px;\n  font-weight: 400;\n  color: #2c364e;\n  line-height: 1.5;\n  padding: 0 20px;\n  width: auto;\n  min-width: auto;\n}\n#wrap.page-market .header__menu li.active a {\n  color: #0a78ff;\n  font-weight: 500;\n}\n#wrap.page-market .header__menu li.disabled {\n  background: none;\n  border: none;\n}\n#wrap.page-market .header__menu li.disabled a {\n  color: #dde2e9;\n}\n#wrap.page-market > header .navbar__toggleBtn {\n  display: none;\n}\n#wrap.page-market > header .header__right {\n  margin-right: 1rem;\n  justify-content: flex-end;\n  flex: 1;\n}\n#wrap.page-market > header .header__etc {\n  margin: 0;\n  gap: 16px;\n  flex: none;\n}\n#wrap.page-market .header__etc li {\n  width: auto !important;\n}\n#wrap.page-market .header__etc li a {\n  color: #2a2c2f;\n  font-weight: 400;\n}\n#wrap.page-market .header__etc li a.btn-admin {\n  background: url(\"../img/icon_profile_navy.png\") no-repeat 0 center;\n  background-size: 40px 40px;\n}\n#wrap.page-market .header__etc li a.btn-admin span {\n  font-size: 14px;\n  font-weight: 400;\n  margin-left: 40px;\n}\n#wrap.page-market .header__etc li .btn-basic span {\n  font-weight: 400;\n}\n#wrap.page-market .header__etc li span.icon-go:after,\n.header__etc li span.icon-go:after {\n  content: \"\";\n  width: 24px;\n  height: 24px;\n  margin-left: 8px;\n  margin-right: -8px;\n  background: url(\"../img/icon_page_go.png\") no-repeat center center;\n  background-size: 100%;\n}\n#wrap.page-market > header .header__userinfo {\n  top: 62px;\n  border-radius: 0 0 4px 4px;\n  right: 85px;\n}\n#wrap.page-market > .container {\n  margin: 62px 0 0 0;\n  width: 100%;\n  min-height: calc(100vh - 62px);\n}\n#wrap.page-market > .container .content {\n  flex-direction: column;\n  align-items: center;\n  gap: 0;\n  width: 100%;\n  padding: 0;\n  background: url(\"../img/bg_market.jpg\") no-repeat 0 0;\n  background-size: 100% 528px;\n}\n#wrap.page-market > .container .content .area-search {\n  margin-top: 120px;\n  margin-bottom: 46px;\n}\n#wrap.page-market > .container .content .area-search .name {\n  display: none;\n}\n#wrap.page-market > .container .content .area-search h2 {\n  font-size: 40px;\n  font-weight: 500;\n  line-height: 1.25;\n  color: #fff;\n  text-align: center;\n}\n#wrap.page-market > .container .content .area-search .searcharea {\n  margin-top: 30px;\n  height: 60px;\n  width: 744px;\n  padding: 0 24px 0 32px;\n  justify-content: space-between;\n  background: #fff;\n  border-radius: 45px;\n}\n#wrap.page-market > .container .content .area-search .searcharea .searchinput {\n  height: 100%;\n  width: calc(100% - 80px);\n  gap: 32px;\n}\n#wrap.page-market > .container .content .area-search .searcharea .input__direct {\n  margin: 0 !important;\n  height: 100%;\n  width: calc(100% - 100px);\n}\n#wrap.page-market > .container .content .area-search .searcharea .input__direct input[type=\"text\"] {\n  height: 100%;\n  border: 0;\n  font-size: 16px;\n  padding: 0;\n}\n#wrap.page-market > .container .content .area-search .searcharea .input__direct input[type=\"text\"]::placeholder {\n  font-size: 16px !important;\n}\n#wrap.page-market > .container .content .area-search .searcharea .select {\n  height: 100%;\n  width: 117px;\n  border: 0;\n  font-size: 16px;\n  letter-spacing: -0.4px;\n  font-weight: 500;\n}\n/* #wrap.page-market > .container .content .area-search .searcharea .select.active ul {\n  margin: 4px 0 0 -32px;\n  width: calc(100% + 32px) !important;\n  padding: 8px 0;\n  border-radius: 4px;\n  border: 0;\n  box-shadow: 0px 8px 20px 0px rgba(122, 133, 150, 0.5);\n} */\n#wrap.page-market > .container .content .area-search .searcharea .select.active ul {\n  margin: 0;\n  padding: 2px 0;\n  position: absolute;\n  top: 64px;\n  left: -32px;\n  width: max-content !important;\n  border-radius: 4px;\n  border: 0;\n  box-shadow: 0px 8px 20px 0px rgba(122, 133, 150, 0.5);\n}\n#wrap.page-market > .container .content .area-search .searcharea .select ul li {\n  font-size: 15px;\n  line-height: 21px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  font-weight: 350;\n  padding: 7px 24px 8px;\n  width: calc(100% - 48px) !important;\n  min-width: 140px;\n}\n#wrap.page-market > .container .content .area-search .searcharea .select .selected {\n  padding: 0;\n}\n#wrap.page-market > .container .content .area-search .searcharea .select .selected .arrow {\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_arrow_down_20.png\") no-repeat center center;\n  background-size: 100%;\n}\n#wrap.page-market > .container .content .area-search .searcharea .select ul li {\n  font-size: 15px;\n  line-height: 16px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  font-weight: 350;\n  padding: 10px 24px;\n  width: calc(100% - 48px) !important;\n}\n#wrap.page-market > .container .content .area-search .searcharea button.btn-search {\n  height: 100%;\n  width: 40px;\n  background: url(\"../img/icon_search_large.png\") no-repeat center center;\n  background-size: 40px;\n  border: 0;\n}\n.area-select {\n  margin: 0 auto;\n  width: 1230px;\n  background: #fff;\n  box-shadow: 0px 2px 10px 0px rgba(67, 85, 131, 0.25);\n  border-radius: 8px;\n}\n.area-select .select-cont {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 40px 40px 24px;\n  min-height: 98px;\n}\n.area-select .select-cont > li {\n  display: flex;\n  justify-content: space-between;\n}\n.area-select .select-cont > li:first-child .right {\n  height: auto;\n  max-height: 66px;\n  overflow-y: auto;\n}\n.area-select.open .select-cont > li:first-child .right {\n  max-height: 242px;\n  overflow-y: auto;\n}\n.area-select .select-cont .left {\n  width: 120px;\n}\n.area-select .select-cont .right {\n  flex: 1;\n  max-width: 1030px;\n}\n.area-select .select-cont .tit {\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 500;\n  color: #2a2c2f;\n  letter-spacing: -0.4px;\n}\n.labellist li.on {\n  background: #0a78ff;\n  color: #fff;\n}\n.area-select .select-cont .labellist {\n  gap: 10px;\n}\n.area-select .select-cont .labellist li {\n  height: auto;\n  padding: 0;\n}\n.labellist li > a {\n  display: flex;\n  align-items: center;\n  height: 28px;\n  padding: 0 12px;\n}\n.filterlist {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n.filterlist li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 44px;\n  padding: 0 24px;\n  margin: 0;\n  font-size: 15px;\n  font-weight: 400;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  background: #fff;\n  border: 1px solid #dde2e9;\n  border-radius: 45px;\n}\n.filterlist li.on {\n  border: 1.5px solid #0a78ff;\n  color: #2a2c2f;\n  font-weight: 500;\n}\n.area-select .select-cont .filterlist li {\n  height: auto;\n  padding: 0;\n}\n.filterlist li > a {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 44px;\n  padding: 0 16px;\n}\n.filterlist li img {\n  width: 24px;\n  height: 24px;\n  object-fit: cover;\n  margin-right: -4px;\n}\n.area-select .select-btn {\n  display: flex;\n  justify-content: space-between;\n  border-top: 1px solid #dde2e9;\n  padding: 12px 16px;\n}\n.area-select .select-btn button {\n  height: 48px;\n}\n.area-select .select-btn button.btn-basic {\n  background-color: #fff;\n  border-color: #fff;\n  gap: 8px;\n}\n.area-select .select-btn button.btn-basic span {\n  font-size: 16px;\n  font-weight: 400;\n  color: #646c74;\n  gap: 8px;\n}\n.area-select .select-btn button.btn-open-select span:after {\n  content: \"\";\n  width: 24px;\n  height: 24px;\n  background: url(\"../img/icon_arrow_gray.png\") no-repeat center center;\n  background-size: 100%;\n}\n.area-select .select-btn button.btn-open-select.active span:after {\n  transform: scaleY(-1);\n}\n.area-select .select-btn button.btn-basic.btn-renew span {\n  color: #646c74;\n}\n.area-select .select-btn button.btn-renew span:before {\n  content: \"\";\n  width: 24px;\n  height: 24px;\n  background: url(\"../img/icon_renew.svg\") no-repeat center center;\n  background-size: 100%;\n}\n.area-result {\n  max-width: 1230px;\n  width: 100%;\n}\n.area-result .solution-area .top {\n  margin-bottom: 16px;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n  gap: 40px;\n}\n.area-result .solution-area .top .result-num {\n  font-size: 22px;\n  line-height: 1.8;\n  letter-spacing: -1px;\n  font-weight: 350;\n  color: #2a2c2f;\n}\n.area-result .solution-area .top .result-num strong {\n  font-weight: 500;\n  color: #0a78ff;\n}\n.area-result .solution-area .tab__line {\n  border-bottom: 1px solid #dde2e9;\n  width: 100%;\n  background: none;\n  border-radius: 0;\n  height: 64px;\n}\n.area-result .solution-area .tab__line li {\n  padding: 0 !important;\n}\n.area-result .solution-area .tab__line li a {\n  padding: 0 24px;\n  color: #646c74 !important;\n  font-size: 20px !important;\n  letter-spacing: -0.4px;\n}\n.area-result .solution-area .tab__line li a span {\n  margin-left: 25px;\n  font-weight: 350;\n  color: #909fb7 !important;\n}\n.area-result .solution-area .tab__line li.on a span,\n.area-result .solution-area .tab__line li:hover a span {\n  color: #0a78ff !important;\n}\n.area-result .solution-area .tab__line li.on,\n.area-result .solution-area .tab__line li:hover {\n  border-radius: 0;\n  background: none;\n  position: relative;\n}\n.area-result .solution-area .tab__line li.on:after,\n.area-result .solution-area .tab__line li:hover:after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 4px;\n  background: #0978ff;\n}\n.area-result .solution-area .tab__line li.on a,\n.area-result .solution-area .tab__line li:hover a {\n  color: #2a2c2f !important;\n}\n.area-result .solution-area .top .select {\n  height: auto;\n  width: auto;\n  border: 0;\n  letter-spacing: -0.4px;\n}\n.area-result .solution-area .top .select .selected {\n  padding: 0;\n  gap: 10px;\n}\n.area-result .solution-area .top .select .selected .selected-value {\n  width: auto;\n}\n.area-result .solution-area .top .select .selected .arrow {\n  width: 16px;\n  height: 16px;\n  background: url(\"../img/icon_select_line.png\") no-repeat center center;\n  background-size: 100%;\n}\n.area-result .solution-area .top .select.active ul {\n  margin-top: 4px;\n  border-radius: 4px;\n  width: 214px !important;\n  max-height: 192px;\n  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.2);\n}\n.area-result .solution-area .top .select ul li {\n  padding: 16px 24px;\n  width: calc(100% - 48px) !important;\n  font-size: 15px;\n  line-height: 16px;\n  letter-spacing: -0.4px;\n  font-weight: 400;\n}\n.area-result .solution-area .top .select ul li:active {\n  font-weight: 700;\n  color: #0a78ff;\n}\n\n.area-result .item-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(394px, auto));\n  gap: 24px;\n  height: auto;\n  overflow: hidden;\n}\n.area-result .item-list > li {\n  max-width: unset;\n  border-radius: 8px;\n  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);\n  height: 528px;\n}\n.area-result .item-info-top .tit {\n  position: relative;\n  padding-top: 3px;\n}\n.area-result .item-info-top .tit {\n  font-size: 16px;\n}\n.area-result .item-info-top.best .tit:after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  top: -1px;\n  width: 24px;\n  height: 24px;\n  background: url(\"../img/icon_best.png\") no-repeat center 0;\n  /* background: url('../img/icon_best.svg') no-repeat center 0; */\n  background-size: 100%;\n}\n.area-result .item-info-top .keyword {\n  width: calc(100% - 30px);\n}\n.area-result .item-info-top .btn-like {\n  width: 24px;\n  height: 24px;\n  background: url(\"../img/icon_like_gray.png\") no-repeat center -2px;\n  background-size: 100%;\n}\n.area-result .item-info-top .btn-like.on {\n  background: url(\"../img/icon_like.png\") no-repeat center -2px;\n  background-size: 100%;\n}\n.area-result .solution-area .paging {\n  margin: 40px 0 160px;\n}\n.area-result .item-info-btnarea {\n  background: #f0f2f4;\n}\n.area-result .item-info-btnarea button span {\n  color: #909fb7;\n}\n.area-result .item-info-btnarea button + button {\n  border-color: #dde2e9;\n}\n.area-result .item-info-btnarea button span.icon-more {\n  background: url(\"../img/icon_more_gr.png\") no-repeat center right;\n  background-size: 24px;\n}\n.area-result .item-info-btnarea button span.icon-go {\n  background: url(\"../img/icon_page_go_gr.png\") no-repeat center right;\n  background-size: 24px;\n}\n.area-result .item-list > li:hover .item-info-btnarea {\n  background: #41444a;\n}\n.area-result .item-list > li:hover .item-info-btnarea button span {\n  color: #fff;\n}\n.area-result .item-list > li:hover .item-info-btnarea button + button {\n  border-color: #26282e;\n}\n.area-result .item-list > li:hover .item-info-btnarea button span.icon-more {\n  background: url(\"../img/icon_more_wh.png\") no-repeat center right;\n  background-size: 24px;\n}\n.area-result .item-list > li:hover .item-info-btnarea button span.icon-go {\n  background: url(\"../img/icon_page_go.png\") no-repeat center right;\n  background-size: 24px;\n}\n.area-result .nodata .nodata__txt {\n  margin: 0 auto 10%;\n  height: 40vh;\n}\n#wrap.page-market .navbar {\n  display: none;\n}\n.area-select .select-top button.btn-basic:disabled {\n  background: none !important;\n  border: none !important;\n}\n.area-select .select-top button.btn-basic:disabled span {\n  color: #f0f2f4 !important;\n}\n.area-select .s0elect-top button.btn-open-select:disabled span:after {\n  opacity: 0.1;\n}\n/* 241125 추가 */\n@media screen and (max-width: 1480px) {\n  #wrap.page-market > header .header__right {\n    flex: unset;\n  }\n}\n@media screen and (max-width: 1300px) {\n  #wrap.page-market > .container .content {\n    width: calc(100% - 60px);\n    padding: 0 30px;\n  }\n  #wrap.page-market > .container .content .area-search {\n    width: 100%;\n  }\n  #wrap.page-market > .container .content .area-search .searcharea {\n    width: 70%;\n    margin: 30px auto;\n  }\n  #wrap.page-market > .container .content .area-search .searcharea .searchinput {\n    width: calc(100% - 50px);\n  }\n  .area-select {\n    max-width: 1230px;\n    width: 100%;\n  }\n}\n@media screen and (max-width: 1299px) {\n  .area-result .item-list {\n    grid-template-columns: repeat(auto-fill, minmax(48%, auto));\n  }\n}\n@media screen and (max-width: 1278px) {\n  #wrap:not(.no-responsive).page-market .header__etc li a.btn-admin span {\n    display: none;\n  }\n  #wrap.page-market > header {\n    height: 90px;\n    padding-bottom: 10px;\n    align-items: flex-end;\n    justify-content: space-between;\n    z-index: 19;\n  }\n  #wrap.page-market > header h1 {\n    padding-left: 0;\n  }\n  #wrap.page-market > header .header__menu,\n  #wrap.page-market .header__etc li > .bi-beyoundx {\n    /* 241125 선택자 추가 */\n    display: none;\n  }\n  .header-etc-pop,\n  #wrap.page-market > header .header-etc-pop {\n    left: 0; /* 241126 추가 */\n  }\n  #wrap.page-market > header .header__userinfo {\n    top: 100px;\n  }\n  #wrap.page-market .header__etc > li:last-child {\n    display: none;\n  }\n  #wrap.page-market .header__etc li a.btn-admin {\n    width: 36px;\n    height: 36px;\n    background-position: center center;\n  }\n  #wrap.page-market > header .navbar__toggleBtn {\n    display: block;\n    margin-left: 12px;\n    width: 36px;\n    height: 36px;\n    background: url(\"../img/icon_menu_navy.png\") no-repeat center center;\n    background-size: 100%;\n    cursor: pointer;\n  }\n  #wrap.page-market > header .navbar__toggleBtn.active {\n    background: url(\"../img/icon_menu_close.png\") no-repeat center center;\n    background-size: 100%;\n  }\n  #wrap.page-market > header .header__left {\n    flex: 1;\n    justify-content: center;\n    height: 36px;\n  }\n  #wrap.page-market > header .header__right {\n    flex: none;\n    margin-right: 0;\n    height: 36px;\n  }\n  #wrap.page-market .header-etc-pop.header__userinfo {\n    left: auto !important;\n    right: 0;\n  }\n  #wrap.page-market .navbar {\n    display: block;\n  }\n  #wrap.page-market .navbar .navbar__menu {\n    top: 100px;\n    width: 100%;\n    height: calc(100% - 100px);\n    box-shadow: unset;\n  }\n  #wrap.page-market .navbar__menu li {\n    padding: 0 21px;\n  }\n  #wrap.page-market .navbar__menu li > a {\n    padding: 22px 0;\n    color: #2a2c2f;\n    background: none;\n    border-bottom: 1px solid #dde2e9;\n    border-top: 0;\n  }\n  #wrap.page-market .navbar__menu li.disabled {\n    background: unset;\n    border-color: unset;\n  }\n  #wrap.page-market .navbar__menu li.disabled > a {\n    color: #dde2e9;\n  }\n  #wrap.page-market .navbar__menu li:first-child > a {\n    border-top: 1px solid #dde2e9;\n  }\n  #wrap.page-market .navbar__menu li button.btn-basic {\n    margin-top: 60px;\n    width: 100%;\n    height: 48px !important;\n  }\n  #wrap.page-market .navbar__menu li button.btn-basic span {\n    font-size: 14px !important;\n    letter-spacing: -0.4px;\n  }\n  #wrap.page-market .navbar__menu li button.btn-basic span.icon-go:after {\n    content: \"\";\n    width: 24px;\n    height: 24px;\n    margin-left: 15px;\n    margin-right: -8px;\n    background: url(\"../img/icon_page_go.png\") no-repeat center center;\n    background-size: 100%;\n  }\n  #wrap.page-market > .container {\n    margin: 101px 0 0 0;\n  }\n}\n@media screen and (max-width: 1130px) {\n  #wrap.page-market .header__etc li a.btn-admin {\n    width: 40px;\n    height: 40px;\n  }\n  #wrap.page-market > header .header__userinfo {\n    right: 5px;\n  }\n  #wrap.page-market .header__etc li .btn-basic {\n    padding: 0 12px;\n  }\n  #wrap.page-market > header .header__etc {\n    gap: 10px;\n  }\n  #wrap.page-market > header .header__menu {\n    gap: 0;\n  }\n}\n@media screen and (max-width: 940px) {\n  .area-select.m-block {\n    display: none !important;\n  }\n  .area-select.m-none {\n    display: block !important;\n  }\n  #wrap.page-market > .container {\n    margin: 100px 0 0 0 !important;\n    min-height: calc(100vh - 100px);\n  }\n  #wrap.page-market > .container .content {\n    margin-top: 0;\n  }\n  /* #wrap.page-market .navbar {\n    display: block;\n  } */\n}\n@media screen and (max-width: 733px) {\n  #wrap.page-market > .container .content {\n    padding: 0 20px;\n    margin: 0;\n    width: calc(100% - 40px);\n    background-size: 100% 244px;\n  }\n  #wrap.page-market > .container .content .area-search {\n    width: 100%;\n    margin-top: 20px;\n    margin-bottom: 0;\n  }\n  #wrap.page-market > .container .content .area-search .name {\n    display: block;\n    font-size: 14px;\n    color: #909fb7;\n    line-height: 20px;\n    letter-spacing: -0.4px;\n    text-align: right;\n    margin-bottom: 40px;\n  }\n  #wrap.page-market > .container .content .area-search h2 {\n    text-align: left;\n    width: 220px;\n    font-size: 32px;\n  }\n  #wrap.page-market > .container .content .area-search .searcharea {\n    margin-top: 46px;\n    margin-bottom: 10px;\n    width: calc(100% - 56px);\n    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);\n  }\n  #wrap.page-market > .container .content .area-search .searcharea .select {\n    display: none;\n  }\n  #wrap.page-market > .container .content .area-search .searcharea .searchinput {\n    width: calc(100% - 40px);\n  }\n  #wrap.page-market > .container .content .area-search .searcharea .input__direct {\n    width: 100%;\n  }\n  .area-result .solution-area {\n    margin-top: 56px;\n  }\n  .area-result .solution-area .tab__line {\n    margin: 0 -20px;\n    width: calc(100% + 40px);\n  }\n  .area-result .solution-area .tab__line li {\n    flex: 1 !important;\n  }\n  .area-result .solution-area .top .result-num {\n    font-size: 16px;\n    line-height: 24px;\n  }\n  .area-result .item-list {\n    gap: 20px;\n    grid-template-columns: repeat(auto-fit, minmax(100%, auto));\n  }\n  .area-result .solution-area .paging {\n    margin: 20px 0 64px;\n  }\n  .area-select {\n    box-shadow: unset;\n    width: 100%;\n    border-bottom: 1px solid #dde2e9;\n    margin: 0;\n    padding: 0 20px 0 20px;\n    border-radius: 0;\n  }\n  .area-select.m-block {\n    display: block !important;\n  }\n  .area-select.m-none {\n    display: none !important;\n  }\n  .area-select .select-top {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: calc(100% + 20px);\n    margin-right: -20px;\n  }\n  .area-select .select-top .left {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n  }\n  .area-select .select-top .tit {\n    font-size: 14px;\n    line-height: 24px;\n    font-weight: 500;\n    color: #2a2c2f;\n    letter-spacing: -0.4px;\n  }\n  .area-select .select-top button {\n    height: 48px !important;\n  }\n  .area-select .select-top button.btn-basic {\n    background-color: #fff;\n    border-color: #fff;\n    gap: 8px;\n  }\n  .area-select .select-top button.btn-basic span {\n    font-size: 14px !important;\n    font-weight: 400;\n    color: #646c74;\n    gap: 8px;\n  }\n  .area-select .select-top button.btn-open-select span:after {\n    content: \"\";\n    width: 24px;\n    height: 24px;\n    background: url(\"../img/icon_arrow_gray.png\") no-repeat center center;\n    background-size: 100%;\n  }\n  .area-select .select-top button.btn-open-select.active span:after {\n    transform: scaleY(-1);\n  }\n  .area-select .select-bottom {\n    display: none;\n  }\n  .area-select.open .select-bottom {\n    display: block;\n  }\n  .area-select .select-cont {\n    padding: 0;\n    min-height: unset;\n    gap: 20px;\n  }\n  .area-select .select-btn {\n    justify-content: flex-end;\n    padding: 0;\n    margin: 20px 0 10px;\n    border-top: 0;\n  }\n  .area-select .select-btn button {\n    height: 48px !important;\n  }\n  .area-select .select-btn button.btn-basic span {\n    font-size: 14px !important;\n  }\n  .area-select .select-btn button.btn-basic.btn-renew {\n    margin-right: -20px;\n  }\n}\n@media screen and (max-width: 499px) {\n  #wrap.page-market > header {\n    padding-top: 0;\n  }\n  .area-result .item-list {\n    grid-template-columns: repeat(auto-fit, minmax(300px, auto));\n  }\n  .area-result .solution-area .tab__line li a {\n    padding: 0;\n  }\n  .header__etc .btn-lang {\n    display: none;\n  }\n  #wrap.page-market > header .header__etc {\n    margin-right: 9px;\n  }\n  #wrap.page-market .header__etc li a.btn-admin {\n    width: 36px;\n    height: 36px;\n  }\n  .header-etc-pop,\n  #wrap.page-market > header .header-etc-pop {\n    top: 49px !important;\n  }\n  #wrap.page-market .header__etc li .header__userinfo li {\n    padding: 0;\n  }\n}\n\n/* sei - 마켓플레이스 - 상세페이지 */\n#wrap.page-market.detail header .btn-prev {\n  display: none;\n}\n#wrap.page-market.detail > .container .content {\n  border-top: 1px solid #dde2e9;\n  padding-top: 120px;\n  background: none;\n}\n#wrap.page-market.detail > .container .content > div:not(.cont-imgslide) {\n  max-width: 1230px;\n  width: 100%;\n}\n#wrap.page-market.detail > .container .content .cont-top {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  margin-bottom: 30px;\n}\n#wrap.page-market.detail > .container .content .cont-top .left {\n  display: flex;\n  align-items: flex-end;\n  flex: 1;\n}\n#wrap.page-market.detail > .container .content .cont-top .left .left-txt {\n  display: flex;\n  gap: 4px;\n}\n#wrap.page-market.detail > .container .content .cont-top .left h1 {\n  font-size: 40px;\n  line-height: 56px;\n  letter-spacing: -1px;\n  font-weight: 500;\n  color: #2a2c2f;\n}\n#wrap.page-market.detail > .container .content .cont-top .left h2 {\n  display: flex;\n  align-items: flex-end;\n  color: #2a2c2f;\n  font-size: 24px;\n  line-height: 40px;\n  letter-spacing: -0.4px;\n  font-weight: 350;\n}\n#wrap.page-market.detail > .container .content .cont-top .left img {\n  width: 44px;\n  height: 44px;\n  margin-bottom: 5px;\n  margin-left: 6px;\n}\n#wrap.page-market.detail > .container .content .cont-top .right {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n}\n#wrap.page-market.detail > .container .content .cont-top .btn-like {\n  height: 46px;\n  padding: 0 18px 0 29px;\n  border-radius: 25px;\n  border: 1px solid #dde2e9;\n}\n#wrap.page-market.detail > .container .content .cont-top button.btn-like span {\n  font-weight: 400;\n  font-size: 15px;\n  letter-spacing: -0.4px;\n  color: #646c74;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n#wrap.page-market.detail > .container .content .cont-top .btn-like span:after {\n  content: \"\";\n  width: 24px;\n  height: 24px;\n  background: url(\"../img/icon_like_gray.png\") no-repeat center center;\n  background-size: 100%;\n}\n#wrap.page-market.detail > .container .content .cont-top .btn-like.on span:after {\n  background: url(\"../img/icon_like.png\") no-repeat center center;\n  background-size: 100%;\n}\n#wrap.page-market.detail > .container .content .cont-imgslide .img-wrap {\n  height: 400px;\n  min-height: unset;\n  overflow: hidden;\n}\n#wrap.page-market.detail > .container .content .cont-bottom {\n  margin-top: 50px;\n}\n#wrap.page-market.detail > .container .content .cont-bottom .top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #dde2e9;\n  margin-bottom: 24px;\n}\n#wrap.page-market.detail > .container .content .cont-bottom .top p {\n  font-size: 15px;\n  line-height: 24px;\n  letter-spacing: -0.4px;\n  color: #646c74;\n  font-weight: 400;\n}\n#wrap.page-market.detail > .container .content .cont-bottom .top p span {\n  margin-left: 8px;\n}\n#wrap.page-market.detail > .container .content .cont-bottom .top p.tit {\n  color: #7783a1;\n  font-weight: 500;\n}\n#wrap.page-market.detail > .container .content .cont-bottom .key-area .tit {\n  display: inline;\n  margin-right: 15px;\n  padding: 6px 24px 7px 25px;\n  font-size: 14px;\n  letter-spacing: -0.4px;\n  color: #fff;\n  font-weight: 400;\n  border-radius: 25px;\n  background: #003875;\n  vertical-align: initial;\n}\n#wrap.page-market.detail > .container .content .cont-bottom .key-area .keyword {\n  display: inline;\n}\n#wrap.page-market.detail > .container .content .cont-bottom .key-area .keyword span {\n  font-size: 16px;\n  line-height: 32px;\n  font-weight: 500;\n  color: #003875;\n}\n#wrap.page-market.detail > .container .content .cont-bottom .cont-text {\n  margin: 80px 0 160px;\n  display: flex;\n  flex-direction: column;\n}\n#wrap.page-market.detail > .container .content .cont-bottom .cont-text article + article {\n  margin-top: 80px;\n}\n#wrap.page-market.detail > .container .content .cont-bottom .cont-text article .tit {\n  font-size: 26px;\n  line-height: 40px;\n  font-weight: 700;\n  letter-spacing: -1px;\n}\n#wrap.page-market.detail > .container .content .cont-bottom .cont-text article .tit-sub {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 700;\n}\n#wrap.page-market.detail > .container .content .cont-bottom .cont-text article p {\n  font-size: 14px;\n  line-height: 24px;\n  color: #2a2c2f;\n  font-weight: 400;\n  margin-bottom: 16px;\n}\n#wrap.page-market.detail > .container .content .cont-bottom .cont-text article p:last-child {\n  margin-bottom: 0;\n}\n#wrap.page-market.detail > .container .content .cont-bottom .btn-area {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n#wrap.page-market.detail > .container .content .cont-bottom .btn-area .btn-basic {\n  height: 48px;\n  min-width: 350px;\n}\n#wrap.page-market.detail > .container .content .cont-bottom .btn-area .btn-basic span {\n  font-size: 20px;\n  letter-spacing: -0.4px;\n}\n#wrap.page-market.detail > .container .content .cont-bottom .select-cont {\n  margin-top: 160px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n#wrap.page-market.detail > .container .content .cont-bottom .select-cont .tit {\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: -0.4px;\n  font-weight: 500;\n  color: #2a2c2f;\n}\n#wrap.page-market.detail > .container .content .cont-bottom .select-cont .labellist li {\n  height: auto;\n  padding: 0;\n}\n#wrap.page-market.detail > .container .content .cont-bottom .page-bottom {\n  margin-top: 40px;\n  margin-bottom: 160px;\n  padding-top: 40px;\n  border-top: 1px solid #dde2e9;\n}\n#wrap.page-market.detail > .container .content .cont-bottom .page-bottom .btn-basic {\n  height: 48px;\n  background: #2c364e;\n  border-color: #2c364e;\n}\n#wrap.page-market.detail > .container .content .cont-bottom .page-bottom .btn-basic span {\n  font-size: 16px;\n  letter-spacing: -0.4px;\n  font-weight: 400;\n}\n@media screen and (max-width: 940px) {\n  #wrap.page-market.detail > header .navbar__toggleBtn {\n    display: none !important;\n  }\n  #wrap.page-market.detail > header .header__left {\n    display: none !important;\n  }\n  #wrap.page-market.detail header .btn-prev {\n    display: flex;\n    align-items: center;\n    gap: 2px;\n    margin-left: 12px;\n  }\n  #wrap.page-market.detail header .btn-prev:before {\n    content: \"\";\n    width: 36px;\n    height: 36px;\n    background: url(\"../img/icon_menu_close.png\") no-repeat 0 center;\n    background-size: 100%;\n  }\n  #wrap.page-market.detail header .btn-prev span {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: -0.4px;\n    color: #2c364e;\n  }\n  #wrap.page-market.detail > .container .content {\n    border: 0;\n    padding: 20px 0 0;\n    width: 100%;\n  }\n  #wrap.page-market.detail > .container .content > div:not(.cont-imgslide) {\n    padding: 0 20px;\n    width: calc(100% - 40px);\n  }\n  #wrap.page-market.detail > .container .content .cont-top {\n    flex-direction: column;\n    align-items: unset;\n    gap: 10px;\n    margin-bottom: 20px;\n  }\n  #wrap.page-market.detail > .container .content .cont-top .left {\n    gap: 0;\n    align-items: flex-start;\n  }\n  #wrap.page-market.detail > .container .content .cont-top .left .left-txt {\n    flex-direction: column;\n    gap: 0;\n  }\n  #wrap.page-market.detail > .container .content .cont-top .left h1 {\n    font-size: 32px;\n    line-height: 40px;\n  }\n  #wrap.page-market.detail > .container .content .cont-top .left h2 {\n    font-size: 20px;\n    line-height: 40px;\n  }\n  #wrap.page-market.detail > .container .content .cont-top .left img {\n    width: 31px;\n    height: 31px;\n    margin-bottom: 0;\n    margin-top: 3px;\n    margin-left: 4px;\n  }\n  #wrap.page-market.detail > .container .content .cont-imgslide .img-wrap {\n    height: 200px;\n  }\n  #wrap.page-market.detail > .container .content .cont-bottom {\n    margin-top: 39px;\n  }\n  #wrap.page-market.detail > .container .content .cont-bottom .key-area .tit {\n    display: inline-block;\n    margin-bottom: 10px;\n    padding: 9px 24px 9px 25px;\n  }\n  #wrap.page-market.detail > .container .content .cont-bottom .key-area .keyword {\n    display: block;\n  }\n  #wrap.page-market.detail > .container .content .cont-bottom .cont-text {\n    margin: 40px 0 80px;\n  }\n  #wrap.page-market.detail > .container .content .cont-bottom .cont-text article + article {\n    margin-top: 40px;\n  }\n  #wrap.page-market.detail > .container .content .cont-bottom .select-cont {\n    margin-top: 80px;\n  }\n  #wrap.page-market.detail > .container .content .cont-bottom .page-bottom {\n    margin-bottom: 74px;\n  }\n  #wrap.page-market.detail > .container .content .cont-bottom .btn-area .btn-basic {\n    height: 46px;\n    min-width: unset;\n    flex: 1;\n    border-radius: 25px;\n  }\n  #wrap.page-market.detail > .container .content .cont-bottom .btn-area .btn-basic span {\n    font-size: 16px;\n  }\n  #wrap.page-market.detail > .container .content .cont-bottom .page-bottom .btn-basic {\n    height: 32px;\n  }\n  #wrap.page-market.detail > .container .content .cont-bottom .page-bottom .btn-basic span {\n    font-size: 14px;\n  }\n}\n\n/* sei - 마켓플레이스 - 상담신청 */\n#wrap.page-market.consulting > .container .content {\n  padding: 120px 0 160px;\n  background: linear-gradient(180deg, #f7f8fa 0%, rgba(247, 248, 250, 0) 100%);\n}\n#wrap.page-market.consulting .service h1 {\n  font-size: 40px;\n  font-weight: 500;\n  line-height: 40px;\n  letter-spacing: -1px;\n  color: #2a2c2f;\n  margin-bottom: 32px;\n}\n#wrap.page-market.consulting .service .box {\n  border-radius: 8px;\n  box-shadow: 0px 2px 10px 0px rgba(67, 85, 131, 0.25);\n}\n#wrap.page-market.consulting .service .box__header {\n  padding: 64px 72px 30px;\n}\n#wrap.page-market.consulting .service .box__body {\n  padding: 40px 72px 72px;\n}\n#wrap.page-market.consulting .service .box__body .page-top h3 {\n  border-bottom: 1px solid #dde2e9;\n}\n#wrap.page-market.consulting .service .box__body .input__area .txt-info {\n  width: 100%;\n}\n\n@media screen and (max-width: 1300px) {\n  #wrap.page-market.consulting > .container .content {\n    width: 100%;\n  }\n}\n@media screen and (max-width: 940px) {\n  #wrap.page-market.consulting > .container .content {\n    padding: 112px 0;\n  }\n  #wrap.page-market.consulting .service .box {\n    width: 98%;\n  }\n  #wrap.page-market.consulting .service .box__header {\n    max-width: calc(100% - 48px);\n    padding: 32px 24px;\n  }\n  #wrap.page-market.consulting .service .box__body {\n    max-width: calc(100% - 48px);\n    padding: 40px 24px 64px;\n  }\n  #wrap.page-market.consulting .service .box__body .page-top h3 .txt-info {\n    font-size: 13px;\n  }\n  #wrap.page-market.consulting .terms .box-scroll {\n    height: 140px;\n    line-height: 16px;\n    padding: 9px;\n  }\n}\n@media screen and (max-width: 699px) {\n  #wrap.page-market.consulting .service .box {\n    box-shadow: none;\n    width: 100%;\n  }\n  #wrap.page-market.consulting > .container .content {\n    padding: 0 0 64px;\n    background: #fff;\n  }\n  #wrap.page-market.consulting > .container .content .cont-top {\n    padding: 80px 20px 40px;\n    width: calc(100% - 40px);\n    background: linear-gradient(180deg, #f7f8fa 0%, rgba(247, 248, 250, 0) 100%);\n  }\n  #wrap.page-market.consulting .service h1 {\n    margin-bottom: 0;\n    font-size: 32px;\n  }\n  #wrap.page-market.consulting .service .box__header {\n    max-width: calc(100% - 40px);\n    padding: 0 20px;\n  }\n  #wrap.page-market.consulting .service .box__header .box__title {\n    margin-bottom: 0;\n    font-weight: 400;\n    font-size: 16px;\n  }\n  #wrap.page-market.consulting .service .box__info {\n    display: none;\n  }\n  #wrap.page-market.consulting .service hr {\n    display: none;\n  }\n  #wrap.page-market.consulting .service .box__body {\n    max-width: calc(100% - 40px);\n    padding: 64px 20px 0;\n  }\n  #wrap.page-market.consulting .service .box__body .page-top h3 {\n    border-color: #a4b0c4;\n    font-size: 20px;\n  }\n  #wrap.page-market.consulting .service .box__body .page-top h3 .txt-info {\n    font-size: 12px;\n  }\n  #wrap.page-market.consulting .service .box__body .info__input + .info__input {\n    margin-top: 40px;\n  }\n  #wrap.page-market.consulting .terms .box-scroll {\n    height: 164px;\n    line-height: 19px;\n    padding: 12px 12px 4px 12px;\n    font-size: 14px;\n  }\n  #wrap.page-market.consulting .service .box__body .form__input li .btn__wrap button {\n    height: 46px;\n    flex: 1;\n  }\n  #wrap.page-market.consulting .service .box__body .service-info {\n    margin-top: 76px;\n  }\n}\n\n/* sei - 마켓플레이스 - what we do */\n#wrap.page-market.whatwedo > .container .content {\n  background: url(\"../img/bg_market_what.jpg\") no-repeat 0 0;\n  background-size: 100% 528px;\n}\n#wrap.page-market.whatwedo > .container .content .cont-top {\n  margin-top: 120px;\n  margin-bottom: 46px;\n  width: 100%;\n  max-width: 1230px;\n}\n#wrap.page-market.whatwedo > .container .content .cont-top h1 {\n  font-size: 40px;\n  font-weight: 500;\n  line-height: 1.25;\n  color: #2a2c2f;\n  text-align: center;\n}\n#wrap.page-market.whatwedo > .container .content .cont-top .txt {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 20px;\n  color: #2a2c2f;\n  text-align: center;\n  margin-top: 30px;\n}\n#wrap.page-market.whatwedo > .container .content .cont-bottom {\n  max-width: 1230px;\n  width: 100%;\n}\n#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(49%, auto));\n  gap: 18px;\n  height: 640px;\n  overflow: hidden;\n  padding-bottom: 162px;\n}\n#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list > li {\n  width: 100%;\n  max-width: 100%;\n  height: 100%;\n  border-radius: 8px;\n  box-shadow: 0px 2px 10px 0px rgba(67, 85, 131, 0.25);\n  border: 0;\n}\n#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list > li > a {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n  height: 100%;\n  border-radius: 8px;\n}\n#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .img-wrap {\n  width: 100%;\n  height: 374px;\n  border-radius: 0 0 8px 8px;\n  overflow: hidden;\n}\n#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .img-wrap img {\n  object-fit: cover;\n  border-radius: 0 0 8px 8px;\n  transition-duration: 0.3s;\n}\n#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .item-info {\n  height: calc(100% - 450px);\n  padding: 40px 36px 36px 40px;\n  justify-content: flex-start;\n  position: relative;\n}\n#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .item-info:after {\n  content: \"\";\n  position: absolute;\n  right: 36px;\n  bottom: 36px;\n  width: 32px;\n  height: 32px;\n  background: url(\"../img/icon_arrow_round.png\") no-repeat center center;\n  background-size: 100%;\n}\n#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .item-info .tit {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 82%;\n}\n#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .item-info .tit strong {\n  font-size: 26px;\n  line-height: 40px;\n  font-weight: 500;\n  color: #2a2c2f;\n  letter-spacing: -1px;\n}\n#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .item-info .tit span {\n  font-size: 14px;\n  line-height: 24px;\n  font-weight: 400;\n  color: #2a2c2f;\n}\n#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list > li:hover .item-info:after {\n  background: url(\"../img/icon_arrow_round_blue.png\") no-repeat center center;\n  background-size: 100%;\n}\n#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li:hover .item-info .tit strong {\n  color: #0a78ff;\n  font-weight: 700;\n}\n#wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li:hover .img-wrap img {\n  transform: scale(1.2, 1.2);\n  transition-duration: 0.6s;\n}\n#wrap.page-market.whatwedo .m-block {\n  display: none !important;\n}\n@media screen and (max-width: 1299px) {\n  #wrap.page-market.whatwedo > .container .content .cont-bottom .item-list {\n    grid-template-columns: repeat(auto-fill, minmax(48%, auto));\n  }\n}\n@media screen and (max-width: 940px) {\n  #wrap.page-market.whatwedo > .container .content {\n    background-size: 100% 400px;\n  }\n  #wrap.page-market.whatwedo > .container .content .cont-top {\n    margin-bottom: 62px;\n  }\n  #wrap.page-market.whatwedo > .container .content .cont-bottom .item-list {\n    height: 458px;\n    padding-bottom: 230px;\n  }\n  #wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .img-wrap {\n    height: 244px;\n  }\n  #wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .item-info {\n    height: calc(100% - 312px);\n    padding: 40px 28px 28px 40px;\n  }\n  #wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .item-info:after {\n    right: 28px;\n    bottom: 28px;\n  }\n  #wrap.page-market.whatwedo .m-block {\n    display: none !important;\n  }\n  #wrap.page-market.whatwedo .m-none {\n    display: block !important;\n  }\n}\n@media screen and (max-width: 733px) {\n  #wrap.page-market.whatwedo > .container .content {\n    background-size: 100% 244px;\n  }\n  #wrap.page-market.whatwedo > .container .content .cont-top {\n    margin-bottom: 20px;\n    margin-top: 80px;\n  }\n  #wrap.page-market.whatwedo > .container .content .cont-top h1 {\n    font-size: 32px;\n    text-align: left;\n  }\n  #wrap.page-market.whatwedo > .container .content .cont-top .txt {\n    margin-top: 20px;\n    text-align: left;\n  }\n  #wrap.page-market.whatwedo > .container .content .cont-bottom .item-list {\n    grid-template-columns: repeat(auto-fit, minmax(100%, auto));\n    height: auto;\n    gap: 20px;\n  }\n  #wrap.page-market.whatwedo > .container .content .cont-bottom .item-list > li {\n    width: 98%;\n    max-width: 98%;\n    height: 412px;\n    margin: 0 auto;\n  }\n  #wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .item-info {\n    height: calc(100% - 264px);\n    padding: 20px 28px 28px 16px;\n  }\n  #wrap.page-market.whatwedo > .container .content .cont-bottom .item-list li .img-wrap {\n    height: 216px;\n  }\n  #wrap.page-market.whatwedo .m-block {\n    display: block !important;\n  }\n  #wrap.page-market.whatwedo .m-none {\n    display: none !important;\n  }\n}\n\n/* sei - 마켓플레이스 - what we do - 상세 */\n#wrap.page-market.whatwedo > .container .content.detail {\n  background-size: 100% 360px;\n}\n#wrap.page-market.whatwedo > .container .content.detail .cont-top {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 30px;\n}\n#wrap.page-market.whatwedo > .container .content.detail .cont-top h1 {\n  line-height: 1;\n  letter-spacing: -1px;\n}\n#wrap.page-market.whatwedo > .container .content.detail .cont-top .btn-prev {\n  width: 56px;\n  height: 56px;\n  background: url(\"../img/icon_arrow_right.png\") no-repeat center center;\n  background-size: 100%;\n}\n#wrap.page-market.whatwedo > .container .content.detail .cont-bottom .item-list {\n  grid-template-columns: repeat(auto-fill, minmax(394px, auto));\n  gap: 12px;\n  height: auto;\n  padding-bottom: 74px;\n}\n#wrap.page-market.whatwedo > .container .content.detail .cont-bottom .item-list > li {\n  height: 184px;\n}\n#wrap.page-market.whatwedo > .container .content.detail .cont-bottom .item-list li .item-info {\n  height: calc(100% - 44px);\n  padding: 16px 28px 28px 32px;\n}\n#wrap.page-market.whatwedo > .container .content.detail .cont-bottom .item-list li .item-info .tit {\n  height: 70%;\n  justify-content: center;\n}\n#wrap.page-market.whatwedo > .container .content.detail .cont-bottom .item-list li .item-info .tit strong {\n  font-size: 20px;\n  line-height: 28px;\n}\n#wrap.page-market.whatwedo > .container .content.detail .cont-bottom .item-list li:hover {\n  border: 1px solid #2a2c2f;\n  background: #2c364e;\n  background: radial-gradient(#2c364e, #2a2c2f);\n  box-shadow: 0px 8px 10px 0px rgba(67, 85, 131, 0.5);\n}\n#wrap.page-market.whatwedo > .container .content.detail .cont-bottom .item-list li:hover .item-info .tit strong {\n  color: #fff;\n}\n\n@media screen and (max-width: 1299px) {\n  #wrap.page-market.whatwedo > .container .content.detail .cont-bottom .item-list {\n    grid-template-columns: repeat(auto-fill, minmax(32%, auto));\n  }\n}\n@media screen and (max-width: 940px) {\n}\n@media screen and (max-width: 733px) {\n  #wrap.page-market.whatwedo > .container .content.detail .cont-top {\n    margin-bottom: 20px;\n  }\n  #wrap.page-market.whatwedo > .container .content.detail .cont-bottom .item-list {\n    grid-template-columns: repeat(auto-fit, minmax(100%, auto));\n    gap: 20px;\n    padding-bottom: 64px;\n  }\n  #wrap.page-market.whatwedo > .container .content.detail .cont-bottom .item-list > li {\n    height: 176px;\n  }\n  #wrap.page-market.whatwedo > .container .content.detail .cont-bottom .item-list li .item-info {\n    padding: 16px 28px 28px 24px;\n  }\n}\n\n/* sei - 마켓플레이스 - what we do - 팝업 */\n.popup-type1 .popup__body.scroll-no {\n  max-height: calc(85vh - 6.5rem);\n}\n.popup__body .product {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.popup__body .product .tab__line {\n  margin-bottom: 30px;\n  margin-top: -12px;\n}\n.popup__body .product .tab__line li.on {\n  font-weight: 700;\n}\n.popup__body .product .tab-content {\n  height: 466px;\n  overflow-y: hidden;\n}\n.popup__body .product .tab-content.itmelist {\n  height: 546px;\n}\n.popup__body .product .tab-content p {\n  font-size: 15px;\n  line-height: 32px;\n}\n.popup__body .product .tab-content p.tit {\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 36px;\n  text-align: left;\n  letter-spacing: -0.4px;\n  color: #051c3f;\n  margin-bottom: 20px;\n}\n.popup__body .product .tab-content .item-info-top .tit {\n  position: relative;\n  padding-top: 3px;\n  font-size: 16px;\n  line-height: 28px;\n  color: #2a2c2f;\n  margin: 0;\n}\n.popup__body .product .tab-content .item-info-top.best .tit:after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  top: -1px;\n  width: 24px;\n  height: 24px;\n  background: url(\"../img/icon_best.png\") no-repeat center 0;\n  /* background: url('../img/icon_best.svg') no-repeat center 0; */\n  background-size: 100%;\n}\n.popup__body .product .tab-content .item-info-top .keyword {\n  width: calc(100% - 30px);\n}\n.popup__body .product .tab-content .item-info-top .btn-like {\n  width: 24px;\n  height: 24px;\n  background: url(\"../img/icon_like_gray.png\") no-repeat center -2px;\n  background-size: 100%;\n}\n.popup__body .product .tab-content .item-info-top .btn-like.on {\n  background: url(\"../img/icon_like.png\") no-repeat center -2px;\n  background-size: 100%;\n}\n.popup__body .product .tab-content .item-info-top .company {\n  color: #7783a1;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.3;\n  margin-top: -4px;\n}\n.popup__body .product .tab-content .item-info-top .cont {\n  color: #2a2c2f;\n  font-size: 13px;\n  line-height: 1.5;\n}\n.popup__body .product .tab-content .item-info-top .etc {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n.popup__body .product .tab-content.itmelist {\n  padding: 0;\n  overflow-y: hidden;\n  overflow-x: auto;\n  box-shadow: none;\n}\n.popup__body .product .tab-content.itmelist::-webkit-scrollbar-thumb,\n.popup__body .product .tab-content .scrollH::-webkit-scrollbar-thumb {\n  border: 1px solid transparent;\n}\n.popup__body .product .tab-content.itmelist .item-list {\n  display: inline-flex;\n  gap: 12px;\n}\n.popup__body .product .tab-content.itmelist .item-list > li {\n  flex: none;\n  width: 392px;\n  max-width: 392px;\n  height: calc(100% - 2px);\n  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);\n}\n.popup__body .product .tab-content.itmelist .item-info-btnarea {\n  background: #f0f2f4;\n}\n.popup__body .product .tab-content.itmelist .item-info-btnarea button span {\n  color: #909fb7;\n}\n.popup__body .product .tab-content.itmelist .item-info-btnarea button + button {\n  border-color: #dde2e9;\n}\n.popup__body .product .tab-content.itmelist .item-info-btnarea button span.icon-more {\n  background: url(\"../img/icon_more_gr.png\") no-repeat center right;\n  background-size: 24px;\n}\n.popup__body .product .tab-content.itmelist .item-info-btnarea button span.icon-go {\n  background: url(\"../img/icon_page_go_gr.png\") no-repeat center right;\n  background-size: 24px;\n}\n.popup__body .product .tab-content.itmelist .item-list > li:hover .item-info-btnarea {\n  background: #41444a;\n}\n.popup__body .product .tab-content.itmelist .item-list > li:hover .item-info-btnarea button span {\n  color: #fff;\n}\n.popup__body .product .tab-content.itmelist .item-list > li:hover .item-info-btnarea button + button {\n  border-color: #26282e;\n}\n.popup__body .product .tab-content.itmelist .item-list > li:hover .item-info-btnarea button span.icon-more {\n  background: url(\"../img/icon_more_wh.png\") no-repeat center right;\n  background-size: 24px;\n}\n.popup__body .product .tab-content.itmelist .item-list > li:hover .item-info-btnarea button span.icon-go {\n  background: url(\"../img/icon_page_go.png\") no-repeat center right;\n  background-size: 24px;\n}\n@media screen and (max-width: 1180px) {\n  .popup-layer.w1130 {\n    width: calc(100% - 40px) !important;\n  }\n}\n@media screen and (max-width: 779px) {\n  .popup-type1 .popup__head h1.ellipsis {\n    width: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    line-height: normal;\n  }\n  .popup-type1 .popup__body.scroll-no {\n    overflow-y: hidden;\n  }\n  .popup__body .product .tab-content {\n    padding-bottom: 0;\n    height: 546px;\n  }\n  .popup__body .product .tab-content .scrollH {\n    height: calc(85vh - 160px);\n    padding-right: 15px;\n  }\n  .popup__body .product .tab__line {\n    margin: -4px -20px 0;\n    width: calc(100% + 40px);\n  }\n  #wrap:not(.no-responsive) .popup__body .product > .tab__line li {\n    flex: 1;\n  }\n  .popup__body .product .tab-content p.tit {\n    font-size: 16px;\n    line-height: 24px;\n    margin-bottom: 24px;\n  }\n  .popup__body .product .tab-content.itmelist {\n    padding-top: 20px;\n    padding-bottom: 10px;\n    height: calc(85vh - 160px);\n    overflow-y: auto;\n  }\n  .popup__body .product .tab-content.itmelist .item-list {\n    overflow: unset;\n    width: auto;\n  }\n  .popup__body .product .tab-content.itmelist .item-list > li {\n    width: 348px;\n    max-width: 348px;\n  }\n  .popup__body .product .tab-content.itmelist::-webkit-scrollbar-thumb,\n  .popup__body .product .tab-content .scrollH::-webkit-scrollbar-thumb {\n    border: 2px solid transparent;\n  }\n}\n\n/* sei - 마켓플레이스 - 서비스소개 */\n#wrap.page-market.serviceintro {\n  overflow-x: unset;\n}\n#wrap.page-market.serviceintro > .container .content {\n  background: url(\"../img/bg_market_service1.jpg\") no-repeat 0 0;\n  background-size: 100% 1018px;\n}\n#wrap.page-market.serviceintro > .container .content .cont-top {\n  width: 100%;\n  max-width: 1230px;\n  height: 1018px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  position: relative;\n}\n#wrap.page-market.serviceintro > .container .content .cont-top .subtit {\n  margin-top: -24px;\n  margin-bottom: 16px;\n  font-size: 14px;\n  line-height: 30px;\n  color: #fff;\n  opacity: 0.8;\n}\n#wrap.page-market.serviceintro > .container .content .cont-top .tit {\n  font-size: 56px;\n  font-weight: 500;\n  line-height: 70px;\n  letter-spacing: -0.04em;\n  color: #fff;\n}\n#wrap.page-market.serviceintro > .container .content .cont-top .txt {\n  margin-top: 180px;\n  font-size: 24px;\n  font-weight: 350;\n  line-height: 40px;\n  letter-spacing: -0.01em;\n  color: #fff;\n}\n#wrap.page-market.serviceintro > .container .content .btn-scroll {\n  position: absolute;\n  bottom: 80px;\n  left: 50%;\n  transform: translate(-50%, 0%);\n  width: 160px;\n  height: 80px;\n  border: 0;\n  background: url(\"../img/icon_scrolldown.png\") no-repeat center center;\n  background-size: 100%;\n  z-index: 2;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom {\n  width: 100%;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom .btn-scroll {\n  background: url(\"../img/icon_scrolldown_color.png\") no-repeat center center;\n  background-size: 100%;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article {\n  position: relative;\n  min-height: 1080px;\n  width: 100%;\n  height: 1080px;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article:last-child {\n  height: auto;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  max-width: 1230px;\n  margin: 0 auto;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article:first-child > section {\n  padding-top: 120px;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article:nth-child(2) > section {\n  padding-top: 200px;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section > p {\n  text-align: center;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section > p.cate {\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 40px;\n  letter-spacing: -0.4px;\n  color: #909fb7;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section > p.tit {\n  font-size: 40px;\n  font-weight: 350;\n  line-height: 56px;\n  letter-spacing: -1px;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section > p.txt {\n  font-size: 20px;\n  font-weight: 350;\n  line-height: 40px;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section > p strong {\n  font-weight: 700;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section > .img-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 40px;\n  padding: 40px 84px 40px 106px;\n  width: calc(100% - 190px);\n  box-shadow: 0px 2px 10px 0px rgba(67, 85, 131, 0.25);\n  background: #fff;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 18px;\n  margin-top: 80px;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li {\n  flex: 1;\n  min-width: calc(48% - 80px);\n  height: 256px;\n  padding: 40px;\n  background: #fff;\n  box-shadow: 0px 2px 10px 0px rgba(67, 85, 131, 0.25);\n  border-radius: 8px;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li > .tit {\n  font-size: 26px;\n  font-weight: 700;\n  line-height: 40px;\n  color: #002f68;\n  position: relative;\n  display: inline-block;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li > .tit span {\n  font-size: 26px;\n  font-weight: 700;\n  line-height: 40px;\n  color: #002f68;\n  position: relative;\n  z-index: 1;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li > .tit:after {\n  content: \"\";\n  position: absolute;\n  bottom: 2px;\n  left: 0;\n  width: 100%;\n  height: 12px;\n  background: #8bc3ff;\n  opacity: 0.4;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li > .txt {\n  margin-top: 40px;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li > .txt span {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.01em;\n  color: #2a2c2f;\n}\n#wrap.page-market.serviceintro\n  > .container\n  .content\n  .cont-bottom\n  > article\n  > section\n  .txt-box\n  > li\n  > .txt\n  span:last-child {\n  margin-bottom: 0;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li > .txt span:before {\n  content: \"\";\n  width: 24px;\n  height: 24px;\n  background: url(\"../img/icon_check_blue.png\") no-repeat center center;\n  background-size: 100%;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel {\n  position: unset;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel > section {\n  max-width: unset;\n  position: relative;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel > section > .top {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 232px;\n  width: 100%;\n  background-size: cover !important;\n  background-position: center center !important;\n  backrground-repeat: no-repeat !important;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel > section > .top p {\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 32px;\n  letter-spacing: -0.4px;\n  text-align: center;\n  color: #fff;\n  opacity: 0.8;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel > section > .bottom {\n  max-width: 1230px;\n  width: 100%;\n  margin: 80px auto 112px;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel > section > .bottom .cate {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 32px;\n  letter-spacing: -1px;\n  color: #7783a1;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel > section > .bottom > .tit {\n  font-size: 40px;\n  font-weight: 500;\n  line-height: 56px;\n  letter-spacing: -0.02em;\n  color: #2a2c2f;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel > section > .bottom .detail {\n  margin-top: 40px;\n}\n#wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel > section > .bottom .detail > li {\n  display: flex;\n  justify-content: space-between;\n  gap: 20px;\n  padding: 20px 0;\n  border-top: 1px solid #dde2e9;\n}\n#wrap.page-market.serviceintro\n  > .container\n  .content\n  .cont-bottom\n  > article.intro-sel\n  > section\n  > .bottom\n  .detail\n  > li\n  .img-wrap {\n  width: 349px;\n  height: 234px;\n  min-height: auto;\n}\n#wrap.page-market.serviceintro\n  > .container\n  .content\n  .cont-bottom\n  > article.intro-sel\n  > section\n  > .bottom\n  .detail\n  > li\n  .txt-wrap {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n#wrap.page-market.serviceintro\n  > .container\n  .content\n  .cont-bottom\n  > article.intro-sel\n  > section\n  > .bottom\n  .detail\n  > li\n  .txt-wrap\n  button {\n  margin-bottom: 20px;\n  width: 132px;\n  height: 46px;\n  background: #fff;\n  border-radius: 45px;\n  border: 1px solid #dde2e9;\n}\n#wrap.page-market.serviceintro\n  > .container\n  .content\n  .cont-bottom\n  > article.intro-sel\n  > section\n  > .bottom\n  .detail\n  > li\n  .txt-wrap\n  button\n  span {\n  color: #646c74;\n  font-size: 15px;\n  font-weight: 400;\n  letter-spacing: -0.4px;\n}\n#wrap.page-market.serviceintro\n  > .container\n  .content\n  .cont-bottom\n  > article.intro-sel\n  > section\n  > .bottom\n  .detail\n  > li\n  .txt-wrap\n  button:hover {\n  border: 2px solid #0a78ff;\n}\n#wrap.page-market.serviceintro\n  > .container\n  .content\n  .cont-bottom\n  > article.intro-sel\n  > section\n  > .bottom\n  .detail\n  > li\n  .txt-wrap\n  button:hover\n  span {\n  font-weight: 500;\n  color: #2a2c2f;\n}\n#wrap.page-market.serviceintro\n  > .container\n  .content\n  .cont-bottom\n  > article.intro-sel\n  > section\n  > .bottom\n  .detail\n  > li\n  .txt-wrap\n  button.not-ex:hover {\n  background: #f0f2f4;\n  width: 222px;\n  border: 0;\n}\n#wrap.page-market.serviceintro\n  > .container\n  .content\n  .cont-bottom\n  > article.intro-sel\n  > section\n  > .bottom\n  .detail\n  > li\n  .txt-wrap\n  button.not-ex:hover\n  span {\n  font-size: 0;\n}\n#wrap.page-market.serviceintro\n  > .container\n  .content\n  .cont-bottom\n  > article.intro-sel\n  > section\n  > .bottom\n  .detail\n  > li\n  .txt-wrap\n  button.not-ex:hover\n  span:before {\n  content: \"DEMO가 현재 준비중입니다.\";\n  font-size: 15px;\n  font-weight: 400;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n#wrap.page-market.serviceintro\n  > .container\n  .content\n  .cont-bottom\n  > article.intro-sel\n  > section\n  > .bottom\n  .detail\n  > li\n  .txt-wrap\n  .tit {\n  font-size: 26px;\n  font-weight: 500;\n  line-height: 40px;\n  letter-spacing: -0.01em;\n}\n#wrap.page-market.serviceintro\n  > .container\n  .content\n  .cont-bottom\n  > article.intro-sel\n  > section\n  > .bottom\n  .detail\n  > li\n  .txt-wrap\n  .txt {\n  display: flex;\n  flex-direction: column;\n  margin-top: 20px;\n}\n#wrap.page-market.serviceintro\n  > .container\n  .content\n  .cont-bottom\n  > article.intro-sel\n  > section\n  > .bottom\n  .detail\n  > li\n  .txt-wrap\n  .txt\n  span {\n  font-size: 16px;\n  font-weight: 350;\n  line-height: 28px;\n  letter-spacing: -0.01em;\n}\n\n@media screen and (max-width: 940px) {\n  #wrap.page-market.serviceintro > .container .content {\n    background-size: 100% 528px;\n    padding: 0;\n    width: 100%;\n  }\n  #wrap.page-market.serviceintro > .container .content .cont-top {\n    height: 528px;\n    padding: 0 20px;\n    width: calc(100% - 40px);\n  }\n  #wrap.page-market.serviceintro > .container .content .cont-top .subtit {\n    margin-bottom: 8px;\n  }\n  #wrap.page-market.serviceintro > .container .content .cont-top .tit {\n    font-size: 32px;\n    font-weight: 500;\n    line-height: 40px;\n    letter-spacing: -0.8px;\n  }\n  #wrap.page-market.serviceintro > .container .content .cont-top .txt {\n    margin-top: 90px;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 24px;\n    letter-spacing: -0.4px;\n  }\n  #wrap.page-market.serviceintro > .container .content .cont-bottom > article {\n    height: auto;\n    min-height: auto;\n    padding: 80px 20px 60px;\n    width: calc(100% - 40px);\n  }\n  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section {\n    padding-top: 0 !important;\n  }\n  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section > p.cate {\n    font-size: 16px;\n    line-height: 20px;\n    margin-bottom: 20px;\n  }\n  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section > p.tit {\n    font-size: 32px;\n    font-weight: 500;\n    line-height: 40px;\n    letter-spacing: -2.6px;\n  }\n  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section > p.txt {\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: -1px;\n  }\n  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section > .img-wrap {\n    margin-top: 60px;\n    padding: 0;\n    width: 100%;\n    box-shadow: none;\n  }\n  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box {\n    gap: 20px;\n    margin-top: 60px;\n  }\n  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li {\n    width: calc(100% - 40px);\n    min-height: 184px;\n    height: auto;\n    padding: 20px;\n    flex: none;\n  }\n  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li > .tit,\n  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li > .tit span {\n    font-size: 20px;\n  }\n  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li > .tit:after {\n    height: 10px;\n    bottom: 6px;\n  }\n  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li > .txt {\n    margin-top: 20px;\n  }\n  #wrap.page-market.serviceintro > .container .content .cont-bottom > article > section .txt-box > li > .txt span {\n    margin-bottom: 16px;\n    font-size: 16px;\n    line-height: 20px;\n  }\n  #wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel {\n    padding: 0;\n    width: 100%;\n  }\n  #wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel > section > .top {\n    height: 200px;\n  }\n  #wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel > section > .bottom {\n    margin: 48px auto 140px;\n    padding: 0 20px;\n    width: calc(100% - 40px);\n  }\n  #wrap.page-market.serviceintro > .container .content .cont-bottom > article.intro-sel > section > .bottom > .tit {\n    font-size: 32px;\n    line-height: 40px;\n    letter-spacing: -1.4px;\n  }\n  #wrap.page-market.serviceintro\n    > .container\n    .content\n    .cont-bottom\n    > article.intro-sel\n    > section\n    > .bottom\n    .detail\n    > li {\n    flex-direction: column;\n  }\n  #wrap.page-market.serviceintro\n    > .container\n    .content\n    .cont-bottom\n    > article.intro-sel\n    > section\n    > .bottom\n    .detail\n    > li\n    .txt-wrap\n    .tit {\n    font-size: 24px;\n    line-height: 32px;\n  }\n  #wrap.page-market.serviceintro\n    > .container\n    .content\n    .cont-bottom\n    > article.intro-sel\n    > section\n    > .bottom\n    .detail\n    > li\n    .txt-wrap\n    button {\n    display: none;\n  }\n  #wrap.page-market.serviceintro\n    > .container\n    .content\n    .cont-bottom\n    > article.intro-sel\n    > section\n    > .bottom\n    .detail\n    > li\n    .img-wrap {\n    width: 100%;\n  }\n  #wrap.page-market.serviceintro\n    > .container\n    .content\n    .cont-bottom\n    > article.intro-sel\n    > section\n    > .bottom\n    .detail\n    > li\n    .img-wrap\n    img {\n    object-fit: fill;\n  }\n  #wrap.page-market.serviceintro > .container .content .btn-scroll {\n    display: none;\n  }\n}\n/* sei - 마켓플레이스 - 로그인 */\n#wrap.page-market .login-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: calc(100vh - 63px);\n  border-top: 1px solid #dde2e9;\n}\n#wrap.page-market .login-wrap h2 p {\n  font-size: 1.375rem;\n  font-weight: 500;\n  color: #2a2c2f;\n}\n#wrap.page-market .login-wrap h2 p:first-child {\n  display: none;\n}\n#wrap.page-market .login__form .form__input {\n  margin: 2.25rem 0 1.938rem;\n}\n#wrap.page-market .login__form .form__input li {\n  margin-top: 1rem;\n}\n#wrap.page-market .login__form .form__input li:first-child {\n  margin-top: 0 !important;\n}\n#wrap.page-market .login__form .form__input .input__area {\n  margin-left: 0;\n}\n#wrap.page-market .login__form .form__input input[type=\"text\"],\n#wrap.page-market .login__form .form__input input[type=\"password\"] {\n  width: 19.125rem;\n  height: 2.75rem;\n  padding: 0 1rem;\n}\n#wrap.page-market .login__form .input-errortxt {\n  top: 3rem;\n  font-size: 0.875rem;\n  line-height: 1;\n}\n#wrap.page-market .login__form .form__etc {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n#wrap.page-market .login__form .form__etc li:last-child {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n#wrap.page-market .login__form .form__etc button:first-child:before {\n  content: none;\n}\n#wrap.page-market .login__form .form__etc button::before {\n  content: \"\";\n  width: 1px;\n  height: 0.658rem;\n  margin-left: 0.499rem;\n  padding-left: 0.499rem;\n  border-left: 1px solid #909fb7;\n}\n#wrap.page-market .login__form .form__etc button span {\n  font-size: 0.875rem;\n}\n#wrap.page-market .btn-login {\n  margin: 1.813rem 0 1rem;\n  background: #0a78ff;\n  border: 0;\n  width: 21.25rem;\n  height: 2.875rem;\n}\n#wrap.page-market .btn-login:hover,\n#wrap.page-market .btn-login:active {\n  background: #0050b8;\n}\n#wrap.page-market .btn-login:disabled {\n  background: #e9edef;\n}\n#wrap.page-market .btn-login span {\n  color: #fff;\n}\n#wrap.page-market .join {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n#wrap.page-market .join li {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n#wrap.page-market .join li p {\n  color: #909fb7;\n  margin-right: 0.5rem;\n}\n#wrap.page-market .terms {\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  /* height: calc(75vh - 6.5rem); */\n}\n/* #wrap.page-market.login .terms {\n  height: calc(75vh - 6.5rem);\n} */\n/* #wrap.page-market.community .terms {\n  height: calc(68vh - 10.3rem);\n} */\n#wrap.page-market .terms li {\n  display: flex;\n  flex-direction: column;\n  margin-top: 24px;\n  min-height: 30%;\n  flex: 1;\n}\n#wrap.page-market .terms li:first-child {\n  margin-top: 0;\n}\n#wrap.page-market .terms .terms__tit {\n  font-size: 15px;\n  font-weight: 700;\n  color: #2a2c2f;\n  margin-bottom: 12px;\n}\n#wrap.page-market .terms .box-scroll {\n  border: 1px solid #909fb7;\n  border-radius: 4px;\n  padding: 6px 8px;\n  font-size: 13px;\n  height: 100%;\n  overflow-y: scroll;\n  /* background: #fff; */\n}\n#wrap.page-market .terms p {\n  font-size: 13px;\n  line-height: 19.24px;\n  word-wrap: break-word;\n  word-break: break-all;\n  margin-bottom: 1rem;\n}\n#wrap.page-market .terms p strong {\n  font-weight: 700;\n}\n#wrap.page-market .terms p.tit {\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 20.72px;\n}\n#wrap.page-market .terms p.txt + p.tit {\n  padding-top: 2.25rem;\n}\n#wrap.page-market .terms .tit-middle {\n  font-weight: 700;\n  padding-top: 1rem;\n}\n#wrap.page-market .terms p.tit + p.tit-small {\n  padding-top: 0;\n}\n#wrap.page-market .terms p.tit-small {\n  font-weight: 400;\n  padding-top: 0.6rem;\n  margin-bottom: 0;\n}\n#wrap.page-market .terms .btn-txt span {\n  font-size: 14px;\n}\n#wrap.page-market .terms .renewday {\n  color: #7783a1;\n}\n#wrap.page-market .terms .dot {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin-bottom: 0;\n}\n#wrap.page-market .terms .dot::before {\n  content: \"\";\n  width: 4px;\n  height: 4px;\n  background-color: #222;\n  border-radius: 50%;\n  margin: 8px 8px 0 5px;\n}\n#wrap.page-market .joinok:before {\n  content: \"\";\n  width: 200px;\n  height: 108px;\n  display: block;\n  margin: 0 auto 16px;\n  background: url(\"../img/bg_joinok.png\") no-repeat center center;\n  /* background-size: 1.25rem; */\n}\n#wrap.page-market .popup__body.joinok-h {\n  padding: 2rem 2.5rem 8.7rem;\n}\n#wrap.page-market .popup__body.joinok-h .complete-txt {\n  height: calc(75vh - 8.9rem);\n}\n#wrap.page-market .popup__body.joinok-h .complete-txt button {\n  margin-top: 33px;\n  padding: 0 1.25rem;\n  width: 8.75rem;\n  height: 2.5rem;\n  background-color: #0a78ff;\n  border: 0;\n}\n#wrap.page-market .popup__body.joinok-h .complete-txt button span {\n  color: #fff;\n  font-weight: 700;\n}\n#wrap.page-market .popup__body.joinok-h .complete-txt button:hover {\n  background-color: #0050b8;\n}\n#wrap.page-market .popup__body.joinok-h .complete-txt button:active {\n  background-color: #003876;\n}\n\n@media screen and (max-width: 940px) {\n  #wrap.page-market.login > header {\n    display: none;\n  }\n  #wrap.page-market.login > .container {\n    margin: 0 !important;\n    min-height: 100vh;\n  }\n  #wrap.page-market:not(.community) .login-wrap {\n    width: calc(100% - 40px);\n    height: auto;\n    min-height: calc(100vh - 40%);\n    padding: 20% 20px;\n    background: url(\"../img/icon_logo_login_m.png\") no-repeat 20px 54px;\n    background-size: 72px 34px;\n  }\n  #wrap.page-market .login-wrap h2 {\n    width: 100%;\n  }\n  #wrap.page-market .login-wrap h2 p:first-child {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n  #wrap.page-market .login-wrap h2 p:first-child span {\n    font-size: 1.375rem;\n    font-weight: 300;\n    color: #2a2c2f;\n  }\n  #wrap.page-market .login-wrap h2 p:first-child span:last-child {\n    font-size: 2.188rem;\n    font-weight: 700;\n    color: #003876;\n    width: 100%;\n    height: 30px;\n    margin-top: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  #wrap.page-market:not(.community) .login-wrap h2 p:first-child span:last-child img {\n    height: 30px;\n    width: 100%;\n  }\n  #wrap.page-market:not(.community) .login-wrap h2 p:last-child {\n    display: none;\n  }\n  #wrap.page-market:not(.community) .login-wrap .join__sns button {\n    margin-left: 1.5rem;\n  }\n  #wrap.page-market:not(.community) .login-wrap .btn-login {\n    margin: 64px 0 20px;\n    width: 100%;\n  }\n  #wrap.page-market:not(.community) .login-wrap .login__form .form__input {\n    margin: 64px 0 24px;\n    gap: 8px;\n  }\n  #wrap.page-market:not(.community) .login-wrap .form__input li {\n    margin-top: 0;\n  }\n  #wrap.page-market:not(.community) .login__form {\n    width: 100%;\n  }\n  #wrap.page-market:not(.community) .login__form .form__input input[type=\"text\"],\n  #wrap.page-market:not(.community) .login__form .form__input input[type=\"password\"] {\n    height: 38px;\n    width: calc(100% - 24px);\n    padding: 0 12px;\n  }\n  #wrap.page-market:not(.community) .login__form .input-errortxt {\n    top: 2.7rem;\n  }\n  #wrap.page-market:not(.community) .popup-type1 .popup__body .form__input {\n    gap: 16px;\n  }\n  #wrap.page-market:not(.community) .popup-layer .popup__body .form__input li {\n    gap: 0;\n  }\n  #wrap.page-market:not(.community) .popup__body.joinok-h {\n    padding: 0;\n    width: 100%;\n    min-height: 75vh;\n  }\n  #wrap.page-market .popup__body .form__input .checkBox.column label {\n    width: auto !important;\n  }\n  #wrap.page-market .popup__body .form__input .checkBox.column li.ml-50 {\n    margin-left: 20px !important;\n    margin-top: 0;\n  }\n  #wrap.page-market .popup__body .form__input .checkBox.column li.ml-50 label {\n    width: 100% !important;\n  }\n  #wrap.page-market:not(.community) .popup__body .input-errortxt {\n    font-size: 13px;\n    top: 44px;\n  }\n  #wrap.page-market:not(.community) .popup__body .form__input input[type=\"text\"],\n  #wrap.page-market:not(.community) .popup__body .form__input input[type=\"password\"],\n  #wrap.page-market:not(.community) .popup__body .form__input input[type=\"tel\"],\n  #wrap.page-market:not(.community) .popup__body .select {\n    height: 40px;\n    font-size: 1rem;\n  }\n\n  #wrap.page-market .popup__body .form__input input[type=\"text\"].input-error,\n  #wrap.page-market .popup__body .form__input input[type=\"password\"].input-error,\n  #wrap.page-market .popup__body .form__input input[type=\"tel\"].input-error {\n    background: none;\n  }\n  #wrap.page-market .joinok {\n    margin: 0 !important;\n  }\n  #wrap.page-market .terms .terms__tit {\n    font-size: 1rem;\n  }\n  .popup-layer.w570 {\n    width: calc(100% - 40px) !important;\n  }\n}\n\n/************************************************** 컨텐츠팝업 ****************************************************/\n/* 컨텐츠팝업 - 팝업 height 고정일경우 : h값에 따라 popup__body 값이 정해짐 */\n.popup-layer.h740 .popup__body {\n  height: 602px;\n  max-height: 100vh;\n  min-height: 602px;\n  /* min-height: 521px; */\n}\n.popup-layer.h740 .popup__body .flex-row {\n  min-height: 585px;\n  max-height: 100vh;\n}\n.popup-layer.scrollH-no .popup__body {\n  overflow-y: hidden !important;\n}\n\n/* 컨텐츠팝업 - 기본형 - popup-type1 */\n.popup-type1 .popup__body {\n  position: relative;\n  padding: 32px 40px;\n  width: calc(100% - 80px);\n  height: auto;\n  max-height: calc(75vh - 6.5rem);\n  overflow-y: auto;\n}\n.popup-type1 .popup__body h2 {\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 1;\n  color: #2a2c2f;\n}\n.popup-type1 .popup__body .form__input {\n  margin-top: 0;\n}\n.popup-type1 .popup__body .form__input .tit {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 1.3;\n  color: #2a2c2f;\n  min-width: 120px;\n  max-width: 150px;\n}\n.popup-type1 .popup__body h2 + .form__input {\n  margin-top: 26px;\n}\n.popup-type1 .locate {\n  margin: -32px -40px 0;\n}\n.popup__body p {\n  font-size: 14px;\n  color: #2a2c2f;\n  line-height: 1.5;\n}\n.popup__body p.txt.word {\n  word-break: break-word;\n}\n.popup__body p.txt-info {\n  font-weight: 400;\n  font-size: 14px;\n  color: #7a8596;\n  margin-left: 8px;\n  letter-spacing: -0.7px;\n}\n.popup__body textarea {\n  width: calc(100% - 20px);\n  padding: 6px 10px;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: -0.6px;\n}\n.popup-layer.h97vh .popup__body,\n.popup-layer.h97vh.popup-type1 .popup__body,\n.popup-layer.h97vh.popup-type2 .popup__body {\n  max-height: calc(97vh - 6.5rem);\n}\n.popup-layer.h76vh .popup__body,\n.popup-layer.h76vh.popup-type1 .popup__body {\n  max-height: calc(76vh - 6.5rem);\n}\n.popup-layer.h82vh .popup__body,\n.popup-layer.h82vh.popup-type1 .popup__body,\n.popup-layer.h82vh.popup-type2 .popup__body {\n  max-height: calc(82vh - 6.5rem);\n}\n\n/**/\n.popup-layer.popup-type2.h674 .popup__body {\n  max-height: calc(75vh - 1.6rem);\n}\n.popup-layer.popup-type2.h674 .popup__body .flex-row .pop-left,\n.popup-layer.popup-type2.h674 .popup__body .flex-row .pop-right {\n  height: 100%;\n  min-height: 610px;\n}\n.popup-layer.popup-type2.h674 .popup__body .flex-row > div .form__input > li {\n  margin-top: 16px;\n}\n.popup-layer.popup-type2.h674 .popup__body .input__area textarea {\n  padding: 12px;\n}\n@media screen and (max-width: 940px) {\n  .popup-layer.popup-type2.h674 .popup__body .flex-row .pop-right {\n    min-height: 982px;\n  }\n}\n\n@media screen and (max-width: 940px) {\n  .popup-type1 .popup__body {\n    padding: 20px;\n    width: calc(100% - 40px);\n  }\n  .popup-type1 .popup__body .form__input {\n    margin-top: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n  .popup-type1 .locate {\n    margin: -20px -20px 0;\n    width: calc(100% - 3px);\n  }\n  .popup-type1 .popup__footer button {\n    width: 120px;\n  }\n  .popup-layer.w630 {\n    width: calc(100% - 40px) !important;\n  }\n}\n@media screen and (max-width: 1150px) {\n  .popup-type2.popup-layer {\n    width: calc(100% - 40px) !important;\n  }\n}\n@media screen and (max-width: 1500px) {\n  .popup-layer.w1496 {\n    width: calc(100% - 40px) !important;\n  }\n}\n\n/* 컨텐츠팝업 - 좌우형 - popup-type2 */\n.popup-type2 .popup__body {\n  position: relative;\n  padding: 1rem 1rem 0;\n  width: calc(100% - 2rem);\n  height: auto;\n  max-height: calc(75vh - 6.5rem);\n  overflow-y: auto;\n}\n.popup-type2 .popup__body .flex-row {\n  margin: 0 -16px;\n}\n.popup-type2 .popup__body .flex-row .pop-left {\n  padding: 32px 40px;\n  height: calc(75vh - 290px);\n  /* height: calc(100vh - 186px); */\n}\n.popup-type2 .popup__body .flex-row .pop-right {\n  border-left: 4px solid #e3e7ee;\n  padding: 32px 40px;\n  height: calc(75vh - 290px);\n  /* height: calc(100vh - 186px); */\n}\n.popup-type2 .popup__body:has(.locate) .flex-row .pop-left,\n.popup-type2 .popup__body:has(.locate) .flex-row .pop-right {\n  height: calc(75vh - 160px);\n}\n.popup-type2 .popup__body h2 {\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 1;\n  color: #2a2c2f;\n}\n.popup-type2 .popup__body .tbl-list table td {\n  height: 34px;\n}\n.popup-type2 .popup__body .form__input {\n  margin-top: 26px;\n}\n.popup-type2 .popup__body .form__input .tit {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 1.3;\n  color: #2a2c2f;\n  letter-spacing: -0.06em;\n  min-width: 120px;\n  max-width: 150px;\n}\n.popup-type2 .popup__body .form__input .tit.w185 {\n  max-width: 185px;\n}\n.popup-type2 .popup__body .form__input .tit.disabled {\n  background: none;\n  border: 0;\n  color: #dde2e9;\n}\n.popup-type2 .popup__body .form__input .input__area {\n  margin-left: 0;\n}\n.popup-type2 .popup__body .input__area textarea {\n  height: 58px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.4;\n}\n.popup-type2 .popup__body .form__input ul:not(.filelist, .labellist, .checkBox) li {\n  margin-bottom: 24px;\n}\n.popup-type2 .popup__body .form__input li:last-child {\n  margin-bottom: 0;\n}\n.popup-type2 .popup__body .form__input .radioBox {\n  width: 100%;\n  /* justify-content: space-between; */\n  display: inline-flex;\n  gap: 20px;\n}\n.popup-type2 .popup__body .form__input .radioBox label {\n  width: auto !important;\n  margin-left: 0;\n  /* font-weight: 500; */\n  color: #2a2c2f;\n}\n.popup-type2 .popup__body .form__input .radioBox.left {\n  justify-content: flex-start;\n  gap: 22px;\n}\n.popup-type2 .popup__body .tbl-list.scrollH {\n  height: 410px;\n}\n.popup-type2 .popup__body .tbl-select tr.selected td {\n  height: 30px;\n}\n\n@media screen and (max-width: 1150px) {\n  .popup-type2.popup-layer {\n    width: calc(100% - 40px) !important;\n  }\n}\n@media screen and (max-width: 940px) {\n  .popup-type2 .popup__body .tbl-list table td {\n    height: 52px;\n  }\n  .popup-type2 .popup__body h2 {\n    font-size: 1rem;\n  }\n  .popup-type2 .popup__body .flex-row .pop-left {\n    padding: 32px 20px;\n  }\n  .popup-type2 .popup__body .flex-row .pop-right {\n    padding: 32px 20px;\n  }\n}\n\n/* 컨텐츠팝업 - 화면 오른쪽 노출 - popup-type3 */\n.popup-type3 {\n  width: 640px;\n  right: 0;\n  top: 0;\n  left: auto !important;\n  height: 100vh;\n  margin: 0;\n  border-radius: 0;\n  box-shadow: 0px 10px 30px rgba(42, 44, 47, 0.5);\n  transform: unset;\n}\n.popup-type3 .popup__head {\n  width: calc(100% - 64px);\n  padding: 30px 32px 16px;\n  background: #2c364e;\n  border-bottom: 2px solid #dde2e9;\n  z-index: 1;\n}\n.popup-type3 .popup__head .btn-close {\n  display: block;\n  width: 32px;\n  height: 32px;\n  background: url(\"../img/icon_close_w@3x.png\") no-repeat center center;\n  background-size: 100%;\n}\n.popup-type3 .popup__head h1 {\n  color: #fff;\n  font-size: 20px;\n}\n.popup-type3 .popup__body {\n  position: relative;\n  padding: 30px 40px;\n  width: calc(100% - 80px);\n  height: calc(100vh - 254px);\n  max-height: calc(100vh - 254px);\n  overflow-y: auto;\n  background: #f7f8fa;\n}\n.popup-type3 .popup__body h2 {\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 1;\n  color: #2a2c2f;\n}\n.popup-type3 .popup__body .form__input {\n  margin-top: 0;\n}\n.popup-type3 .popup__body .form__input .tit {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 1.3;\n  color: #2a2c2f;\n  min-width: 120px;\n  max-width: 150px;\n}\n.popup-type3 .popup__body h2 + .form__input {\n  margin-top: 26px;\n}\n.popup-type3 .popup__footer {\n  position: absolute;\n  bottom: 0;\n  height: 73px;\n  width: calc(100% - 92px);\n  padding: 16px 46px 24px;\n}\n.popup-type3 .popup__footer .flex-column {\n  width: 100%;\n  gap: 16px;\n}\n.popup-type3 .popup__footer button {\n  margin: 0 auto;\n  width: auto;\n}\n.popup-type3 .popup__footer .result__num {\n  font-size: 16px;\n}\n\n@media screen and (max-width: 940px) {\n  .popup-type3 {\n    width: 100%;\n    position: fixed !important;\n    box-shadow: none;\n  }\n}\n@media screen and (max-width: 499px) {\n  .popup-type3 {\n    width: 100% !important;\n    top: 0 !important;\n    position: fixed !important;\n  }\n  .popup-type3 .popup__body {\n    padding: 30px 20px;\n    width: calc(100% - 40px);\n  }\n}\n\n/* 알럿 타입 팝업 - popup-basic */\n.popup-basic .popup__head {\n  border-bottom: 0;\n}\n.popup-basic .popup__body {\n  padding-top: 6px;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1.45;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n  min-height: 38px;\n}\n.popup-basic .popup__footer {\n  border-top: 0;\n}\n\n/* 컨텐츠팝업 - 기본형 - popup-type1 - 와이드형 -  wide */\n.popup-type1.wide {\n  height: 90vh;\n}\n.popup-type1.wide .popup__body {\n  height: calc(90vh - 186px);\n  max-height: calc(90vh - 186px);\n}\n/*와이드형-사진확대팝업*/\n.popup-type1.wide .popup__body .img-area {\n  width: 100%;\n  height: 100%;\n  margin: 0 auto;\n  text-align: center;\n}\n.popup-type1.wide .popup__body .img-area img {\n  width: auto;\n  height: 100%;\n}\n\n/* 컨텐츠팝업 - 사진파일업로드 */\n.popup__body .form__input .input__area.add-file .txt-info {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 15px;\n  letter-spacing: -0.4px;\n  color: #909fb7;\n  margin-top: 5px;\n  margin-left: 0;\n}\n.popup__body .form__input .input__area.add-file .filelist {\n  display: inline-table;\n}\n.popup__body .form__input .input__area.add-file .filelist li {\n  display: inline-flex;\n  flex-direction: row !important;\n  align-items: center !important;\n  gap: 4px;\n  margin-bottom: 4px;\n}\n.popup__body .form__input .input__area.add-file .filelist li span {\n  font-size: 14px;\n  line-height: 1.7;\n}\n.popup__body .form__input .input__area.add-file .filelist li:not(:first-child) span {\n  background: none;\n}\n.popup__body .form__input .input__area.add-file .filelist li .btn-delete {\n  margin-left: 0;\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_delete_x_lg.png\") no-repeat center center;\n  background-size: 100%;\n}\n.popup__body .form__input .input__area.add-file .btn-basic {\n  width: 120px;\n  height: 40px;\n}\n.popup__body .form__input .input__area.add-file .btn-basic span {\n  font-size: 16px;\n  font-weight: 700;\n}\n.popup__body .imglist {\n  margin-top: 40px;\n  padding-top: 24px;\n  border-top: 1px solid #dde2e9;\n}\n.popup__body .imglist .tit {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 1.3;\n  letter-spacing: -0.4px;\n  color: #2a2c2f;\n}\n.popup__body .imglist .tit span:last-child {\n  font-weight: 400;\n}\n.popup__body .imglist .imgbox-area .tit {\n  margin-bottom: 8px;\n}\n.popup__body .imglist .imgbox-area .tit .btn-area {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  width: 75px !important;\n}\n.popup__body .imglist .imgbox-area .tit .btn-area button {\n  width: 32px;\n  height: 32px;\n}\n.popup__body .imglist .imgbox-area li + li {\n  margin-top: 24px;\n}\n\n/* 지정 컬러 */\n.set-color {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px 32px;\n}\n.set-color > li {\n  margin-top: 0;\n  gap: 16px;\n}\n.set-color input[type=\"radio\"] {\n  width: 16px;\n  height: 16px;\n  margin-top: 8px;\n}\n.popup__body .form__input .set-color label {\n  width: auto;\n}\n.set-color .sample {\n  width: 78px;\n  height: 78px;\n  border: 1px solid #dde2e9;\n  background: #fafbfc;\n}\n.set-color .sample .title {\n  width: 100%;\n  height: 24px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 2;\n  color: #eff6ed;\n  text-align: center;\n  background: #909fb7;\n  border: 1px solid #dde2e9;\n  margin-left: -1px;\n  margin-top: -1px;\n}\n.set-color .set-blue {\n  background: #f2f5fb;\n}\n.set-color .set-yellow {\n  background: #fffff7;\n}\n.set-color .set-teal {\n  background: #ebf9f6;\n}\n.set-color .set-magenta {\n  background: #fff6f7;\n}\n.set-color .set-navy {\n  background: #f8f9fb;\n}\n.set-color .set-green {\n  background: #f8fff6;\n}\n.set-color .set-blue .title {\n  background: #577eff;\n  border-color: #577eff;\n}\n.set-color .set-yellow .title {\n  background: #d6a834;\n  border-color: #d6a834;\n}\n.set-color .set-teal .title {\n  background: #00a985;\n  border-color: #00a985;\n}\n.set-color .set-magenta .title {\n  background: #d00365;\n  border-color: #d00365;\n}\n.set-color .set-navy .title {\n  background: #2c364e;\n  border-color: #2c364e;\n}\n.set-color .set-green .title {\n  background: #005b09;\n  border-color: #005b09;\n}\n\n/* 텍스트와 필드간격 16px 지정  */\n.popup-type1 .popup__body .form__input.gap16 li {\n  gap: 16px;\n}\n.popup-type1 .popup__body .form__input.gap16 .tit {\n  min-width: 104px;\n  max-width: 104px;\n}\n\n/********************************************** language - ENGLISH **********************************************/\n#wrap.lang-eng > *,\n#wrap.lang-eng h1,\n#wrap.lang-eng h2,\n#wrap.lang-eng h3,\n#wrap.lang-eng h4,\n#wrap.lang-eng h5,\n#wrap.lang-eng button,\n#wrap.lang-eng button span,\n#wrap.lang-eng .tab__line li a {\n  word-break: keep-all;\n}\n#wrap.lang-eng .monitor .box__body .box-column > li > article .cont ul.box-small-wrap li span.info {\n  font-size: 20px;\n}\n#wrap.lang-eng .monitor .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li {\n  height: 68px;\n  line-height: 1.4;\n}\n#wrap.lang-eng .monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap {\n  gap: 0;\n}\n#wrap.lang-eng .graph-legend {\n  gap: 8px 16px;\n}\n#wrap.lang-eng .area-result .solution-area .top .result-num {\n  line-height: 1.6;\n}\n#wrap.lang-eng .container.wide .box .box__body .box-wrap h2 {\n  line-height: 1.4;\n}\n#wrap.lang-eng .helper-info p span {\n  line-height: 1.4;\n}\n#wrap.lang-eng.float-page .body-left .tbl-list table th,\n#wrap.lang-eng .float-page .body-left .tbl-list table td {\n  padding-left: 30px;\n  padding-right: 30px;\n}\n#wrap.lang-eng.float-page .body-left .value-box .form__input button.btn-not.selected span {\n  letter-spacing: -0.08em;\n}\n#wrap.lang-eng.float-page .body-left .value-box .form__input button.btn-not.selected span::before {\n  width: 18px;\n  height: 18px;\n  margin-right: 3px;\n}\n#wrap.lang-eng .content__info ul li p.tit.w120 {\n  width: 225px !important;\n}\n#wrap.lang-eng .btn-add.etc + .popup-etc {\n  width: 186px;\n}\n#wrap.lang-eng .monitor .box__body .box-column > li > article .cont .tbl-list table th,\n#wrap.lang-eng .monitor .box__body .box-column > li > article .cont .tbl-list table td {\n  word-break: keep-all;\n  padding: 13px 12px;\n}\n#wrap.lang-eng .monitor .box__body .box-column > li > article .cont .tbl-list.small-size table th,\n#wrap.lang-eng .monitor .box__body .box-column > li > article .cont .tbl-list.small-size table td {\n  padding: 9px 5px 8px;\n}\n#wrap.lang-eng .tab__box li a {\n  letter-spacing: -0.9px;\n}\n#wrap.lang-eng .color-info {\n  gap: 10px;\n}\n#wrap.lang-eng .color-info p {\n  letter-spacing: -0.8px;\n}\n#wrap.lang-eng .color-info p:before {\n  margin-right: 4px;\n}\n#wrap.lang-eng .tbl-list table th,\n#wrap.lang-eng .tbl-list table td {\n  word-break: keep-all;\n}\n#wrap.lang-eng .list-area > li > .list-top .btn-alarm:hover::before {\n  content: \"Mark as Read\";\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  right: 22px;\n  width: 85px;\n  height: 18px;\n  font-weight: 400;\n  font-size: 12px;\n  color: #2a2c2f;\n  background: #dde2e9;\n  border-radius: 10px;\n  z-index: 1000;\n}\n#wrap.lang-eng .list-area > li > .list-top .btn-alarm.readend:hover:before {\n  content: \"Mark as Unread\";\n  width: 108px;\n  right: 24px;\n}\n#wrap.lang-eng .header__alarm .alarm__list li a .list__name button:hover::before {\n  content: \"Mark as Read\";\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  right: 22px;\n  width: 85px;\n  height: 18px;\n  font-weight: 400;\n  font-size: 12px;\n  color: #2a2c2f;\n  background: #dde2e9;\n  border-radius: 10px;\n  z-index: 1000;\n}\n#wrap.lang-eng .header__alarm .alarm__list li a .list__name button.readend:hover:before {\n  content: \"Mark as Unread\" !important;\n  width: 108px;\n  right: 24px;\n}\n#wrap.lang-eng.page-market.serviceintro > .container .content .cont-bottom > article > section > p.tit {\n  font-size: 32px;\n}\n#wrap.lang-eng.page-market.serviceintro\n  > .container\n  .content\n  .cont-bottom\n  > article.intro-sel\n  > section\n  > .bottom\n  > .tit {\n  font-size: 32px;\n}\n#wrap.lang-eng.page-market.serviceintro > .container .content .cont-bottom > article > section > p.txt {\n  font-size: 18px;\n  line-height: 1.6;\n}\n#wrap.lang-eng.page-market > .container .content .area-search .searcharea .select {\n  flex: none;\n  min-width: 180px;\n  width: auto;\n}\n#wrap.lang-eng.page-market > .container .content .area-search .searcharea .select.active ul {\n  min-width: 214px;\n}\n.float-page.lang-eng .body-left .value-box .form__input input[type=\"text\"],\n.float-page.lang-eng .body-left .value-box .form__input input[type=\"text\"]::placeholder {\n  font-size: 17px !important;\n}\n.float-page.lang-eng .body-left .value-box .form__input button.btn-not span {\n  letter-spacing: -0.06em;\n}\n.float-page.lang-eng .body-left .value-box .form__input button.btn-not span::before {\n  margin-right: 4px;\n}\n.lang-eng .tbl-list table th.sort span {\n  flex-wrap: nowrap;\n}\n.lang-eng .tbl-list table th.sort span:after {\n  flex: none;\n}\n.lang-eng .workplace-ok.page-detail .workplace__info .txt_workplace ul li div.txt.column .result__score .score::after {\n  content: \"points\";\n}\n.lang-eng.main .content-top .top-wrap .right .btn-edit:hover::before {\n  content: \"Edit card position\";\n  width: 98px;\n}\n.lang-eng td.icon-delete span::before {\n  content: \"delete\";\n  left: -24px;\n  width: 28px;\n  letter-spacing: -0.02em;\n}\n.lang-eng td.icon-new span::before {\n  left: -24px;\n  width: 28px;\n  letter-spacing: -0.02em;\n}\n.lang-eng .result__score::after {\n  content: \"points\";\n}\n.lang-eng .content-wrap .content__info .listbox .box__bottom ul li .result__score div::after {\n  content: \"points\";\n}\n.lang-eng .popup-type1.workplace-ok.page-detail .workplace__info .txt_workplace .result__score > div::after {\n  content: \"points\";\n}\n#wrap.lang-eng.page-market.serviceintro\n  > .container\n  .content\n  .cont-bottom\n  > article.intro-sel\n  > section\n  > .bottom\n  .detail\n  > li\n  .txt-wrap\n  button.not-ex:hover\n  span:before {\n  content: \"DEMO is currently being prepared.\";\n}\n.lang-eng .loading-box::before {\n  content: \"Loading\";\n}\n.lang-eng .header__alarm .alarm__list li a .list__name button:hover::before {\n  content: \"Mark as read\";\n}\n.lang-eng .header__alarm .alarm__list li a .list__name button.readend:hover:before {\n  content: \"Mark as unread\";\n}\n.lang-eng .list-area > li > .list-top .btn-alarm:hover::before {\n  content: \"Mark as read\";\n}\n.lang-eng .list-area > li > .list-top .btn-alarm.readend:hover:before {\n  content: \"Mark as unread\";\n}\n.lang-eng .btn-basic.pw-12.bg-no {\n  flex: none;\n}\n.lang-eng .popup-type2 .popup__body .flex-row .pop-right .tbl-list table td ul.input__area > li:nth-of-type(2) > label {\n  letter-spacing: -0.09em;\n}\n.lang-eng\n  .popup-type2\n  .popup__body\n  .flex-row\n  .pop-right\n  .tbl-list\n  table\n  td\n  ul.input__area\n  > li\n  > input[type=\"text\"].w84.ml-16.mr-14 {\n  flex: 1;\n}\n.lang-eng textarea::placeholder {\n  word-break: keep-all;\n}\n.lang-eng .rank-info-list > li strong {\n  min-width: 84px;\n}\n.lang-eng .pop-login.popup-type1 .popup__body .tab__line li {\n  min-height: 32px;\n  letter-spacing: -0.04em;\n}\n\n/********************************************** SEI2.0 에너지레포트 고도화 **********************************************/\n.container.energy-solution .content .box .box__header .select ul,\n.container.report .content .box .box__header .select ul {\n  max-height: 436px;\n  border-radius: 4px;\n  box-shadow: 0px 8px 20px 0px #7a859680;\n}\n/* report 신규 발행 버튼 */\n.container .content .box .box__header .select.report ul {\n  margin-top: 0;\n  width: calc(147px - 24px) !important;\n  border: none;\n}\n.container .content .box .box__header .select.report:has(p.txt-round) ul {\n  width: calc(177px - 24px) !important;\n}\n.box__header .select.report ul {\n  padding: 12px;\n}\n.box__header .select.report ul li {\n  border-bottom: 0;\n  padding: 0;\n  font-size: 14px;\n  line-height: 24px;\n  width: 100% !important;\n}\n.select.report ul li:hover {\n  background: inherit;\n}\n.box__header .select.report ul li:active,\n.select.report ul li:active,\n.select.report ul li.active {\n  background: inherit;\n  color: inherit !important;\n  font-weight: 500;\n}\n.box__header .select.report ul li + li {\n  padding-top: 8px;\n}\n\n@media screen and (max-width: 940px) {\n  .select.report {\n    height: 100%;\n    border: none;\n  }\n  .select.report ul {\n    padding: 12px;\n    border-radius: 4px;\n    box-shadow: 0px 8px 20px 0px #7a859680;\n    width: calc(100% - 24px) !important;\n    border: none;\n  }\n  .select.report ul li {\n    border-bottom: 0;\n    padding: 0;\n    font-size: 14px;\n    line-height: 24px;\n    width: 100% !important;\n  }\n  .box__header .select.report ul li:active,\n  .select.report ul li:active,\n  .select.report ul li.active {\n    font-weight: 700;\n  }\n  .select.report ul li + li {\n    padding-top: 24px;\n  }\n}\n/********* 에너지 솔루션 - ESS설치분석 *********/\n.container.energy-solution .box__body:has(.area__left) {\n  padding: 0;\n  display: flex;\n  gap: 16px;\n}\n.container.energy-solution .box__body > .area__left {\n  width: 240px;\n}\n.container.energy-solution .box__body > .area__right {\n  display: flex;\n  width: calc(100% - 252px);\n  padding: 16px 0;\n}\n.container.energy-solution .box__body > .area__left .tab__line__toggleBtn {\n  display: none;\n}\n.container.energy-solution .box .box__header:has(.tab__line.medium) + .box__body {\n  min-height: calc(100% - 119px);\n}\n@media screen and (max-width: 940px) {\n  .container.energy-solution .box__body > .area__left .tab__line__toggleBtn {\n    display: block;\n  }\n  .container.energy-solution .box__body:has(.area__left) {\n    flex-direction: column;\n    gap: 0;\n  }\n  .container.energy-solution .box__body:has(.area__left) > .area__left {\n    width: 100%;\n    position: relative;\n  }\n  .container.energy-solution .box__body:has(.area__left) > .area__right {\n    width: calc(100% - 40px);\n    padding: 20px;\n  }\n}\n\n.container.energy-solution .box__body .box-search-card-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 296px;\n}\n.container.energy-solution .box__body .box-search-card {\n  padding-top: 16px;\n  border-radius: 4px;\n  background: #f2f5fb;\n  border: 1px solid #0a78ff;\n}\n.container.energy-solution .box__body .box-search-card > .top {\n  padding: 0 16px 16px;\n}\n.container.energy-solution .box__body .box-search-card > .top .tit {\n  font-size: 1rem;\n  font-weight: 500;\n  line-height: 2;\n  letter-spacing: -0.02em;\n  color: #051c3f;\n}\n.container.energy-solution .box__body .box-search-card > .top .txt {\n  margin-top: 4px;\n  font-size: 0.75rem;\n  font-weight: 400;\n  line-height: 1.6;\n  letter-spacing: -0.02em;\n  color: #7a8596;\n  word-break: break-word;\n}\n.container.energy-solution .box__body .box-search-card > .top .txt > button {\n  display: inline-block;\n}\n.container.energy-solution .box__body .box-search-card > .top:has(.icon-renew.btn-pop-hover) {\n  position: relative;\n}\n.container.energy-solution .box__body .box-search-card > .top .icon-renew.btn-pop-hover + .pop-layer-box.info {\n  top: 24px;\n  right: 16px;\n  left: auto;\n  width: auto;\n  border: 0;\n}\n.container.energy-solution\n  .box__body\n  .box-search-card\n  > .top\n  .icon-renew.btn-pop-hover\n  + .pop-layer-box.info\n  .pop-body {\n  padding: 9px 8px 8px;\n}\n.container.energy-solution\n  .box__body\n  .box-search-card\n  > .top\n  .icon-renew.btn-pop-hover\n  + .pop-layer-box.info\n  .pop-body\n  p {\n  font-size: 0.75rem;\n  line-height: 1.3;\n  letter-spacing: -0.02em;\n}\n.icon-renew {\n  width: 24px;\n  height: 24px;\n  background: url(\"../img/icon_reload.svg\") no-repeat center center;\n  background-size: 100%;\n}\n.icon-renew:hover,\n.btn-pop-hover.icon-renew.click {\n  background: url(\"../img/icon_reload_primary.svg\") no-repeat center center;\n}\n.btn-pop-hover.icon-renew {\n  width: 24px;\n  height: 24px;\n}\n.container.energy-solution .box__body .box-search-card > .bottom {\n  padding: 0 16px 24px;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul + ul {\n  margin-top: 24px;\n  padding-top: 24px;\n  border-top: 1px solid #dde2e9;\n  gap: 0;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > li > * {\n  flex: 1;\n}\n/* .container.energy-solution .box__body .box-search-card > .bottom > ul > li > *:not(.tit) {\n  text-align: right;\n} */\n.container.energy-solution .box__body .box-search-card > .bottom > ul > li .tit {\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.6;\n  letter-spacing: -0.05em;\n  color: #051c3f;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > li .tit:has(.btn-pop) {\n  display: flex;\n  position: relative;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > li .tit .btn-pop {\n  margin-top: 1px;\n  margin-left: 2px;\n}\n/* .container.energy-solution .box__body .box-search-card > .bottom > ul > li > .btn-pop-area {\n  position: relative;\n  display: flex;\n} */\n/* .container.energy-solution .box__body .box-search-card > .bottom > ul > li > .btn-pop-area .btn-pop {\n  margin-left: 2px;\n  margin-top: 1px;\n} */\n/* .container.energy-solution .box__body .box-search-card .btn-pop-area .pop-layer-box.info {\n  left: 0;\n  top: 22px;\n} */\n.container.energy-solution .box__body .box-search-card > .bottom > ul > li .txt {\n  font-size: 1.25rem;\n  font-weight: 500;\n  line-height: 1.6;\n  letter-spacing: -0.04em;\n  color: #051c3f;\n  text-align: right;\n  font-family: \"Pretendard\", sans-serif; /* 추가 */\n}\n.container.energy-solution .box__body .unit {\n  display: inline-block;\n  min-width: 24px;\n  margin-left: 4px;\n  font-size: 0.75rem;\n  font-weight: 400;\n  line-height: 1.66;\n  letter-spacing: -0.02em;\n  color: #909fb7;\n  text-align: left;\n  vertical-align: middle;\n  font-family: \"NotoSansKR\", sans-serif; /* 추가 */\n}\n.container.energy-solution .input__area {\n  max-width: 120px;\n}\n.container.energy-solution .box__body .btn-area:has(.btn-round) {\n  display: flex;\n  gap: 3px;\n}\n.container.energy-solution .box__body .btn-area:has(.btn-round) .btn-round {\n  flex: 1;\n  height: 40px;\n  background: #fff;\n  border-color: #dde2e9;\n  border-radius: 25px;\n}\n.container.energy-solution .box__body .btn-area:has(.btn-round) .btn-round:hover {\n  border-color: #e6f0ff;\n  background-color: #e6f0ff;\n}\n.container.energy-solution .box__body .btn-area:has(.btn-round) .btn-round span {\n  font-size: 1rem;\n  color: #2a2c2f;\n  font-weight: 400;\n  letter-spacing: -0.04em;\n}\n.container.energy-solution .box__body .btn-area:has(.btn-round) .btn-select.active {\n  background: #0a78ff;\n  border-color: #0a78ff;\n}\n.container.energy-solution .box__body .btn-area:has(.btn-round) .btn-select.active span {\n  color: #fff;\n  font-weight: 700;\n}\n.container.energy-solution .box__body .box-search-card .select,\n.container.energy-solution .box__body .box-search-card input[type=\"text\"] {\n  height: 38px;\n  font-size: 1rem;\n  letter-spacing: -0.04em;\n  background-color: #fff;\n}\n.container.energy-solution .box__body .box-search-card input[type=\"text\"] {\n  padding-right: 40px;\n  width: calc(100% - 52px);\n}\n.container.energy-solution .box__body .box-search-card .select .selected {\n  padding: 0 10px 0 12px;\n}\n.container.energy-solution .box__body .box-search-card .select.active ul {\n  top: 42px;\n  border-radius: 4px;\n  box-shadow: 0px 8px 20px 0px rgba(122, 133, 150, 0.5);\n}\n.container.energy-solution .box__body .box-search-card .select ul li {\n  width: calc(100% - 48px) !important;\n  padding: 16px 24px;\n  border-bottom: 1px solid #dde2e9;\n}\n.container.energy-solution .box__body .box-search-card .select.disabled {\n  border-color: #f0f2f4;\n  background-color: #f0f2f4;\n  color: #bdc6d3;\n}\n.container.energy-solution .box__body .box-search-card .select.disabled .selected .arrow {\n  opacity: 0.2;\n}\n.container.energy-solution .box__body .box-search-card .select.disabled + .txt-info {\n  color: #bdc6d3;\n}\ninput[type=\"text\"]:has(.num-inputin) {\n  padding-right: 40px;\n  width: calc(100% - 54px);\n}\n.num-inputin {\n  position: absolute;\n  right: 12px;\n  top: 8px;\n  font-size: 1rem;\n  letter-spacing: -0.04em;\n  line-height: 1.5;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > li.column {\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > li.column > * {\n  width: 100%;\n  max-width: 100%;\n  text-align: left;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > li.column .input__area {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > li.column .input__area .radioBox {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  position: relative;\n}\n.container.energy-solution .box__body .box-search-card .radioBox label {\n  margin-left: 8px;\n  font-size: 1rem;\n  letter-spacing: -0.04em;\n}\n.container.energy-solution .box__body .box-search-card .radioBox label:has(input[type=\"radio\"]:disabled) {\n  color: #f0f2f4;\n}\n.container.energy-solution .box__body .box-search-card .radioBox input[type=\"radio\"]:disabled {\n  background: #fff;\n}\n.container.energy-solution .box__body .box-search-card .radioBox label:has(input[type=\"radio\"]:disabled) + .icon-info {\n  background: url(\"../img/icon_info_disabled.svg\") no-repeat center center;\n}\n.container.energy-solution .box__body .box-search-card input[type=\"checkbox\"] + label {\n  font-size: 1rem;\n  padding-left: 24px;\n}\n.container.energy-solution .box__body .box-search-card input[type=\"checkbox\"] + label:before {\n  top: 1px;\n  width: 16px;\n  height: 16px;\n}\n.container.energy-solution .box__body .box-search-card input[type=\"checkbox\"]:checked + label:after {\n  top: 1px;\n  width: 16px;\n  height: 16px;\n  border-radius: 0;\n  background-position-x: 1px;\n}\n.container.energy-solution .box__body .pop-layer-box.info {\n  border-radius: 4px;\n}\n.container.energy-solution .box__body .pop-layer-box.info .pop-body {\n  padding: 10px 24px;\n  max-height: 300px;\n  overflow-y: auto;\n}\n.container.energy-solution .box__body .box-search-card .radioBox .pop-layer-box.info {\n  left: 56%;\n  top: 20px;\n}\n@media screen and (max-width: 699px) {\n  .container.energy-solution .box__body .box-search-card .radioBox .pop-layer-box.info {\n    left: -16px;\n  }\n}\n.container.energy-solution .box__body .box-search-card .txt-info {\n  margin: 0;\n  line-height: 1.5;\n  font-size: 0.75rem;\n  letter-spacing: -0.03em;\n}\n.container.energy-solution .box__body .box-search-card > .btn-area {\n  width: 100%;\n}\n.container.energy-solution .box__body .box-search-card > .btn-area .btn-basic {\n  width: 100%;\n  height: 42px;\n}\n.container.energy-solution .box__body .box-search-card > .btn-area .btn-basic span {\n  font-size: 1rem;\n}\n.container.energy-solution .box__body .box-search-card-bottom > button {\n  padding: 0 16px;\n  width: 100%;\n  height: 44px;\n  background: #f0f2f4;\n  border-radius: 4px;\n  border: 0;\n  justify-content: space-between;\n}\n.container.energy-solution .box__body .box-search-card-bottom > button:after {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_arrow_white.svg\") no-repeat center center;\n  background-size: 100%;\n  transform: scaleX(-1);\n}\n.container.energy-solution .box__body .box-search-card-bottom > button span {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 1rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #fff;\n}\n.container.energy-solution .box__body .box-search-card-bottom > button.btn-chk span:before {\n  content: \"\";\n  width: 24px;\n  height: 24px;\n  background: url(\"../img/icon_chk_white.svg\") no-repeat center center;\n  background-size: 100%;\n}\n.container.energy-solution .box__body .box-search-card-bottom > button.btn-set span:before {\n  content: \"\";\n  width: 24px;\n  height: 24px;\n  background: url(\"../img/icon_setting.svg\") no-repeat center center;\n  background-size: 100%;\n}\n.container.energy-solution .box__body .box-search-card-bottom > button.bg-primary:hover {\n  background-color: #0050b8 !important;\n}\n.container.energy-solution .box__body .box-search-card-bottom > button.bg-primary:active,\n.container.energy-solution .box__body .box-search-card-bottom > button.bg-primary:focus {\n  background: #003876 !important;\n}\n/* .container.energy-solution .box__body .box-search-card-bottom .btn-chk:focus:after {\n  background: url('../img/icon_arrow_white.svg') no-repeat center center;\n}\n.container.energy-solution .box__body .box-search-card-bottom .btn-chk:focus span {\n  color: #fff;\n}\n.container.energy-solution .box__body .box-search-card-bottom .btn-chk:focus span:before {\n  background: url('../img/icon_chk_white.svg') no-repeat center center;\n  background-size: 100%;\n} */\n.container.energy-solution .box__body .box-search-card-bottom .filelist {\n  margin: 8px 0 0;\n}\n.container.energy-solution .box__body .box-search-card-bottom .filelist li {\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 12px 6px 16px;\n  background: #e7f2ff;\n  border-radius: 25px;\n  margin-bottom: 8px;\n  width: auto;\n}\n.container.energy-solution .box__body .box-search-card-bottom .filelist li span {\n  display: inline;\n  padding: 0;\n  font-size: 0.75rem;\n  line-height: 1.43;\n  letter-spacing: -0.04em;\n  background: none;\n}\n.container.energy-solution .box__body .box-search-card-bottom .filelist li .btn-delete {\n  display: inline;\n  margin-left: 0;\n  width: 20px;\n  height: 20px;\n  vertical-align: middle;\n  background: url(\"../img/icon_delete_gray20.svg\") no-repeat 0 0;\n  background-size: 20px;\n}\n.container.energy-solution .box__body .box-column {\n  margin: 0 0 16px 16px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.container.energy-solution .box__body .scroll-area .box-column {\n  width: calc(100% - 21px);\n  padding: 5px 16px 5px 5px;\n  margin: 0;\n}\n.container.energy-solution .box__body .box-column > li {\n  padding: 16px;\n  background: #fff;\n  box-shadow: 0px 2px 8px 0px rgba(144, 159, 183, 0.5);\n  border-radius: 4px;\n  min-height: 160px;\n}\n.container.energy-solution .box__body .box-column > li.on,\n.container.energy-solution .box__body .box-column > li.on {\n  border: 1px solid #0a78ff;\n}\n.container.energy-solution .box__body > .area__right:has(.box-column > li.on) .box-search-card {\n  border-color: #f2f5fb;\n}\n.container.energy-solution .box__body > .area__right:has(.box-column > li.on) .box-search-card > .btn-area .btn-basic {\n  border-color: #909fb7;\n  background-color: #909fb7;\n}\n.container.energy-solution .box__body > .area__right:has(.scroll-area) {\n  height: calc(100vh - 217px);\n}\n.container.energy-solution .box__body > .area__right .scroll-area:has(.box-column) {\n  flex: 1;\n  margin: -4px 0 0 16px;\n  width: calc(100% - 328px);\n  height: 100%;\n  overflow-y: auto;\n}\n.container.energy-solution .box__body .box-column > li > article > section .top {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #dde2e9;\n}\n.container.energy-solution .box__body .box-column > li > article > section .top input[type=\"checkbox\"] + label {\n  padding-left: 24px;\n  font-size: 1rem;\n  letter-spacing: -0.02em;\n  font-weight: 500;\n  line-height: 1.5;\n}\n.container.energy-solution .box__body .box-column > li > article > section .top input[type=\"checkbox\"] + label:before {\n  width: 16px;\n  height: 16px;\n  top: 4px;\n}\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .top\n  input[type=\"checkbox\"]:checked\n  + label:after {\n  width: 16px;\n  height: 16px;\n  top: 4px;\n  background-position-x: 1px;\n}\n.container.energy-solution .box__body .box-column > li > article > section .top .btn-close {\n  margin-top: -5px;\n  width: 32px;\n  height: 32px;\n  background: url(\"../img/icon_close.svg\") no-repeat center center;\n  background-size: 100%;\n}\n.container.energy-solution .box__body .box-column > li > article > section .cont {\n  display: flex;\n  gap: 32px;\n}\n.container.energy-solution .box__body .box-column > li > article > section .cont > .left {\n  flex: 1;\n}\n.container.energy-solution .box__body .box-column > li > article > section .cont > .right {\n  flex: 1.53;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  width: 100%;\n  height: 100%;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li {\n  padding: 16px;\n  background: #f7f8fa;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  flex: 1;\n  /* min-width: 174px; */\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li > .box-list > li {\n  padding: 0;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list.column {\n  flex-direction: column;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list.column > li {\n  flex-direction: row;\n  justify-content: space-between;\n  min-height: 56px;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .name {\n  font-size: 0.938rem;\n  line-height: 1.6;\n  letter-spacing: -0.04em;\n  color: #2a2c2f;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .name:before {\n  content: \"\";\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  margin: 6px 8px 0 0;\n  background: #0a78ff;\n  border-radius: 50%;\n  vertical-align: text-top;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .data {\n  text-align: right;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .data .num {\n  font-size: 1.625rem;\n  font-weight: 500;\n  line-height: 1.39;\n  letter-spacing: -0.02em;\n  color: #2a2c2f;\n  font-family: \"Pretendard\", sans-serif; /* 추가 */\n  font-style: normal; /* 추가 */\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .data + .name {\n  margin-top: 16px;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info span {\n  font-size: 0.813rem;\n  font-weight: 400;\n  line-height: 1.54;\n  letter-spacing: -0.02em;\n  color: #646c74;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info span {\n  font-size: 0.813rem;\n  font-weight: 400;\n  line-height: 1.54;\n  letter-spacing: -0.02em;\n  color: #646c74;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info .percent {\n  display: inline-flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 2px;\n  font-size: 0.875rem;\n  line-height: 1.43;\n  color: #0a78ff;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info .percent .unit {\n  font-size: 0.75rem;\n  color: #0a78ff;\n  min-width: auto;\n  margin-left: 0;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info .percent.down {\n  color: #0a78ff;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info .percent.down .unit {\n  color: #0a78ff;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info .percent.up {\n  color: #f55547;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info .percent.up .unit {\n  color: #f55547;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info .percent.down:after {\n  content: \"\";\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_arrow_bg_primary.svg\") no-repeat center center;\n  background-size: 100%;\n  vertical-align: bottom;\n}\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .box-list\n  > li\n  .info\n  .percent.down.text:after {\n  content: \"감소\";\n  width: auto;\n  background: none;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info .percent.up:after {\n  content: \"\";\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_arrow_bg_red.svg\") no-repeat center center;\n  background-size: 100%;\n  vertical-align: bottom;\n  transform: scaleY(-1);\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info .percent.up.text:after {\n  content: \"증가\";\n  background: none;\n  transform: none;\n  width: auto;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info .text {\n  font-size: 0.75rem;\n  color: #0a78ff;\n  line-height: 1.66;\n  letter-spacing: -0.04em;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info a {\n  cursor: pointer;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info a:hover,\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .info a:active {\n  font-weight: 500;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list:not(.column) > li {\n  position: relative;\n  min-height: 248px;\n}\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .box-list:not(.column)\n  > li:has(.data + .btn-pop-area, .data + .name) {\n  min-height: 248px;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list:not(.column) > li:not(:has(.etc)) {\n  min-height: 104px;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .etc {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  position: absolute;\n  bottom: 22px;\n  width: calc(100% - 32px);\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .etc p {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.813rem;\n  font-weight: 400;\n  line-height: 1.54;\n  letter-spacing: -0.02em;\n  color: #646c74;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .etc p > span {\n  flex: 1;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .etc p > span.txt-right {\n  word-break: break-word;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li.warning {\n  border: 1px solid #f55547;\n  background: rgba(245, 85, 71, 0.1);\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li.warning .name,\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li.warning .data .num,\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li.warning .data .unit {\n  color: #f55547;\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li.warning .name:before {\n  background: #f55547;\n}\n.container.energy-solution .box__body .box-column > li > article > section .bottom {\n  margin-top: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.container.energy-solution .box__body .box-column > li > article > section .bottom .btn-area {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  flex: 1;\n}\n.container.energy-solution .box__body .box-column > li > article > section .bottom .btn-area .checkbox-wrap {\n  padding: 6px 16px 6px 8px;\n}\n@media screen and (max-width: 1006px) {\n  .container.energy-solution .box__body .box-column > li > article > section .bottom .btn-area:has(.checkbox-wrap) {\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 16px;\n  }\n}\n@media screen and (max-width: 940px) {\n  .container.energy-solution .box__body .box-column > li > article > section .bottom .btn-area:has(.checkbox-wrap) {\n    flex-direction: row;\n    gap: 8px;\n  }\n}\n@media screen and (max-width: 750px) {\n  .container.energy-solution .box__body .box-column > li > article > section .bottom .btn-area:has(.checkbox-wrap) {\n    flex-direction: column;\n    gap: 16px;\n  }\n}\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .bottom\n  .btn-area\n  .checkbox-wrap\n  input[type=\"checkbox\"]:disabled\n  + label:after {\n  top: 0.125rem;\n}\n@media screen and (max-width: 320px) {\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .bottom\n    .btn-area\n    .checkbox-wrap\n    input[type=\"checkbox\"]\n    + label:before {\n    width: 12px;\n    height: 12px;\n    top: 0.125rem;\n  }\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .bottom\n    .btn-area\n    .checkbox-wrap\n    input[type=\"checkbox\"]:checked\n    + label:after {\n    top: 0.125rem;\n  }\n}\n.container.energy-solution .box__body .box-column > li > article > section .bottom .btn-area .btn-basic {\n  min-width: 112px;\n  padding: 0 16px;\n}\n.container.energy-solution .box__body .box-column > li > article > section .bottom .btn-area .btn-basic + .btn-basic {\n  margin-left: 0;\n}\n.container.energy-solution .box__body .box-column > li > article > section .bottom .btn-area .btn-basic span {\n  letter-spacing: -0.047em;\n}\n.container.energy-solution .box__body .box-column > li > article > section .bottom .txt-info {\n  font-size: 0.75rem;\n  letter-spacing: -0.02em;\n  margin-left: 0;\n  line-height: 1.66;\n}\n\n/*데이터없는경우*/\n.container.energy-solution .box__body .scroll-area .box-column.nodata {\n  height: calc(100% - 10px);\n}\n.container.energy-solution .box__body .nodata .nodata__txt {\n  height: 100%;\n  font-size: 0.75rem;\n}\n\n@media screen and (max-width: 1740px) {\n  .container.energy-solution .box__body .box-column > li > article > section .cont {\n    flex-direction: column;\n    gap: 16px;\n  }\n  .container.energy-solution .box__body .box-column > li > article > section .box-list.column {\n    flex-direction: row;\n  }\n  .container.energy-solution .box__body .box-column > li > article > section .box-list.column > li {\n    flex-direction: column;\n    gap: 24px;\n  }\n}\n@media screen and (max-width: 1294px) {\n  .container.energy-solution .box__body .box-column > li > article > section .box-list {\n    flex-direction: column;\n  }\n  .container.energy-solution .box__body .box-column > li > article > section .box-list.column {\n    flex-direction: column;\n  }\n  /* .container.energy-solution .box__body .box-column > li > article > section .box-list > li .etc {\n    position: relative;\n    bottom: auto;\n    margin-top: 0;\n    width: 100%;\n  } */\n  .container.energy-solution .box__body .box-column > li > article > section .bottom {\n    align-items: flex-start;\n    justify-content: flex-start;\n    flex-direction: column;\n    gap: 16px;\n  }\n  .container.energy-solution .box__body .box-column > li > article > section .bottom > * {\n    width: 100%;\n  }\n}\n@media screen and (max-width: 940px) {\n  #wrap:not(.no-responsive) .container.energy-solution .box__header .tab__line li {\n    padding: 11px 14px 12px;\n  }\n  .container.energy-solution .box__body > .area__left > .tab__line {\n    display: none;\n  }\n  .container.energy-solution .box__body > .area__left > .tab__line__toggleBtn {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 20px;\n    width: calc(100% - 40px);\n    height: 47px;\n    background: #fff;\n    border-bottom: 1px solid #dde2e9;\n    cursor: pointer;\n  }\n  .container.energy-solution .box__body > .area__left > .tab__line__toggleBtn::after {\n    content: \"\";\n    width: 24px;\n    height: 24px;\n    margin-left: 40px;\n    background: url(\"../img/icon_select_l.png\") no-repeat center center;\n    background-size: 100%;\n  }\n  .container.energy-solution .box__body > .area__left > .tab__line__toggleBtn.active:after {\n    content: \"\";\n    transform: rotate(180deg);\n  }\n  .container.energy-solution .box__body > .area__left > .tab__line.active {\n    display: block;\n    position: absolute;\n    top: 49px;\n    width: 100% !important;\n    height: auto;\n    border: 0;\n    padding: 0;\n    margin: 0;\n    z-index: 2;\n    box-shadow: none;\n  }\n  #wrap:not(.no-responsive) .container.energy-solution .box__body > .area__left > .tab__line li {\n    padding: 14px 32px;\n    width: calc(100% - 64px);\n    height: auto;\n    min-height: 39px;\n    border-bottom: 1px solid #dde2e9;\n  }\n  #wrap:not(.no-responsive) .container.energy-solution .box__header.flex-column.brd-bottom-0.pb-0 {\n    padding: 32px 0 24px;\n  }\n  #wrap:not(.no-responsive, .float-page) .container.energy-solution {\n    margin: 50px 0 0 0;\n  }\n  #wrap:not(.no-responsive, .float-page) .container.energy-solution .content {\n    margin-top: 0;\n  }\n  .container.energy-solution .box__header > *:not(.tab__line) {\n    margin: 0 20px;\n    width: calc(100% - 40px) !important;\n  }\n  #wrap:not(.no-responsive) .container.energy-solution .box {\n    height: auto;\n    overflow-y: hidden;\n  }\n  .container.energy-solution .box__body > .area__right .scroll-area:has(.box-column) {\n    margin: -4px -14px 0 16px;\n  }\n  .container.energy-solution .box__body .scroll-area .box-column {\n    padding-right: 5px;\n    width: calc(100% - 10px);\n  }\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .top\n    input[type=\"checkbox\"].m-none\n    + label {\n    padding-left: 0;\n  }\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .top\n    input[type=\"checkbox\"].m-none\n    + label:before {\n    content: none;\n  }\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .top\n    input[type=\"checkbox\"].m-none:checked\n    + label:after {\n    content: none;\n  }\n  .container.energy-solution .box__body .box-column > li > article > section .bottom .btn-area .btn-basic,\n  #wrap:not(.no-responsive)\n    .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .bottom\n    .btn-area\n    .btn-basic {\n    height: 32px;\n  }\n  .container.energy-solution .box__body .box-column > li > article > section .bottom .btn-area .btn-basic span,\n  #wrap:not(.no-responsive)\n    .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .bottom\n    .btn-area\n    .btn-basic\n    span {\n    font-size: 14px;\n  }\n}\n@media screen and (max-width: 699px) {\n  .container.energy-solution .box__body:has(.area__left) > .area__right {\n    flex-direction: column;\n    gap: 20px;\n    height: auto;\n  }\n  .container.energy-solution .box__body .box-search-card-wrap {\n    width: 100%;\n    flex: 1;\n  }\n  .container.energy-solution .box__body .box-column {\n    width: 100%;\n    margin: 0;\n  }\n  .container.energy-solution .box__body > .area__right .scroll-area:has(.box-column) {\n    margin: 0;\n    width: 100%;\n  }\n}\n@media screen and (max-width: 499px) {\n  #wrap:not(.no-responsive) .container.energy-solution .box__header.flex-column.brd-bottom-0.pb-0 {\n    padding: 83px 0 24px;\n  }\n}\n\n/* 운영 효과 상세분석 */\n.detail-analysispop {\n  display: none;\n  margin-top: 32px;\n}\n.detail-analysispop.view {\n  display: block;\n}\n.container.energy-solution .box__body .box-column > li > article > section.detail-analysispop .top,\n.detail-analysispop .top {\n  border-radius: 4px 4px 0px 0px;\n  background: #003378;\n  color: #fff;\n  padding: 6px 16px;\n}\n.detail-analysispop .left > b {\n  font-size: 14px;\n  font-weight: 500;\n}\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section.detail-analysispop\n  > .top\n  .right\n  .btn-close.white,\n.detail-analysispop > .top .right .btn-close.white {\n  margin-top: 0;\n  width: 20px !important;\n  height: 20px !important;\n  background: url(\"../img/icon_close_white.svg\") no-repeat center center !important;\n}\n.detail-analysis-wrap {\n  margin: 32px 16px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.detail-analysis-wrap + .detail-analysis-wrap {\n  margin-top: 48px;\n}\n.detail-analysis-wrap > .title {\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: #2a2c2f;\n  line-height: 1.6;\n}\n.detail-analysis-wrap .title-small {\n  font-size: 1rem;\n  font-weight: 500;\n  color: #2a2c2f;\n  line-height: 1.5;\n}\n.detail-analysis-wrap .tbl__top .title-small {\n  margin-bottom: 0;\n}\n.detail-analysis-wrap .tbl-list.tbl-border-large .btn-txt span {\n  font-weight: 400;\n}\n.detail-analysis-wrap .tbl-list.tbl-border-large .btn-txt:hover span,\n.detail-analysis-wrap .tbl-list.tbl-border-large .btn-txt:active span {\n  font-weight: 500;\n}\n.container.energy-solution .box__body .detail-analysispop .unit {\n  min-width: auto;\n}\n.container.energy-solution .box__body .box-column > li > article > section .detail-analysis-wrap > .bottom {\n  margin-top: 0;\n}\n.analysis-box {\n  padding: 32px;\n  width: calc(100% - 64px);\n  border: 1px solid #dde2e9;\n}\n.analysis-box > ul {\n  display: flex;\n  gap: 16px 64px;\n  flex-wrap: wrap;\n}\n/* .analysis-box li {\n  padding: 32px;\n} */\n.analysis-box > ul > li > p {\n  font-size: 0.813rem;\n  font-weight: 400;\n  line-height: 1.53;\n  color: #2a2c2f;\n}\n.analysis-box li > p.tit {\n  margin-bottom: 4px;\n  color: #646c74;\n}\n@media screen and (max-width: 1469px) {\n  .analysis-box > ul {\n    gap: 16px 32px;\n  }\n  .analysis-box > ul > li {\n    width: calc(50% - 32px);\n  }\n}\n@media screen and (max-width: 1294px) {\n  .analysis-box > ul {\n    flex-direction: column;\n    gap: 32px;\n  }\n  .analysis-box > ul > li {\n    width: 100%;\n  }\n}\n@media screen and (max-width: 940px) {\n  .detail-analysis-wrap {\n    margin: 32px 0 0;\n  }\n  .container.energy-solution .box__body .box-column > li > article > section.detail-analysispop .top,\n  .detail-analysispop .top {\n    margin: 0 -8px 0;\n  }\n  .analysis-box {\n    padding: 16px;\n    width: calc(100% - 32px);\n  }\n}\n\n.line-box {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  padding: 32px;\n  width: calc(100% - 64px);\n  border: 1px solid #dde2e9;\n}\n.line-box .txt-info {\n  font-size: 0.75rem;\n  line-height: 1.5;\n  margin: 16px 0 0 0;\n}\n.line-box .txt-info-large {\n  margin-top: 16px;\n  font-size: 1.125rem;\n  line-height: 1.6;\n  color: #2a2c2f;\n  letter-spacing: -0.05em;\n}\n.line-box .txt-info-large + .txt-info-large {\n  margin-top: 8px;\n}\n.line-box.row {\n  flex-direction: row;\n  justify-content: space-between;\n}\n.line-box.row > * {\n  flex: 1;\n}\n.box-info-area {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.box-info-area:has(.left) {\n  flex-direction: row !important;\n  justify-content: space-between;\n}\n.box-info-area.hover:hover {\n  background: #e6f0ff !important;\n  border: 1px solid #0a78ff !important;\n}\n.box-info-area > .left {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.box-info-area .select-wrap {\n  display: flex;\n  gap: 38px;\n  flex-direction: row;\n}\n.box-info-area .select-wrap .date-area {\n  position: relative;\n}\n/* 선택 스케줄 일 react-datepicker */\n.box-info-area .select-wrap .date-area .react-datepicker {\n  position: absolute;\n  left: 0;\n  top: 72px;\n  font-family: \"NotoSansKR\", sans-serif !important;\n  border-color: #0d78ff;\n  box-shadow: 0px 8px 12px 0px rgba(122, 133, 150, 0.5);\n  z-index: 2;\n}\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__navigation {\n  top: 20px;\n  height: 20px;\n  width: 20px;\n}\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__navigation--previous {\n  left: 80px;\n}\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__navigation--next {\n  right: 80px;\n}\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__year-read-view--down-arrow,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__month-read-view--down-arrow,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__month-year-read-view--down-arrow,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__navigation-icon::before {\n  border-color: #0a78ff;\n  border-width: 2px 2px 0 0;\n  height: 10px;\n  width: 10px;\n}\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__header {\n  padding-top: 23px;\n  background-color: #fff;\n  border-bottom: 0;\n}\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__day-names {\n  margin-top: 16px;\n}\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__day-name {\n  margin: 3px;\n  width: 32px;\n  line-height: 32px;\n  font-size: 14px;\n  color: #909fb7;\n}\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__month {\n  margin: 0px 6px 13px;\n}\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__current-month {\n  font-size: 15px;\n  font-weight: 500;\n}\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__day {\n  margin: 2px 3px;\n  width: 32px;\n  line-height: 32px;\n  font-size: 14px;\n  color: #2a2c2f;\n}\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__day:hover,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__month-text:hover,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__quarter-text:hover,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__year-text:hover {\n  color: #fff;\n  font-weight: 700;\n  border-radius: 100%;\n  background-color: #0a78ff;\n}\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__day--selected,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__day--in-selecting-range,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__day--in-range,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__month-text--selected,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__month-text--in-selecting-range,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__month-text--in-range,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__quarter-text--selected,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__quarter-text--in-selecting-range,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__quarter-text--in-range,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__year-text--selected,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__year-text--in-selecting-range,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__year-text--in-range {\n  color: #fff;\n  font-weight: 700;\n  border-radius: 100%;\n  background-color: #0a78ff;\n}\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__day--selected:hover,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__day--in-selecting-range:hover,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__day--in-range:hover,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__month-text--selected:hover,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__month-text--in-selecting-range:hover,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__month-text--in-range:hover,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__quarter-text--selected:hover,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__quarter-text--in-selecting-range:hover,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__quarter-text--in-range:hover,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__year-text--selected:hover,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__year-text--in-selecting-range:hover,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__year-text--in-range:hover {\n  color: #fff;\n  font-weight: 700;\n  background-color: #0a78ff;\n}\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__day--keyboard-selected,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__month-text--keyboard-selected,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__quarter-text--keyboard-selected,\n.box-info-area .select-wrap .date-area .react-datepicker .react-datepicker__year-text--keyboard-selected {\n  color: #fff;\n  font-weight: 700;\n  border-radius: 100%;\n  background-color: #0a78ff;\n}\n.box-info-area .term__date {\n  display: flex;\n  gap: 12px;\n  border-radius: 0;\n  border: 0;\n  background-color: transparent;\n  height: auto;\n}\n.box-info-area .term__date:after {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_arrow_blue.svg\") no-repeat center center;\n  background-size: 100%;\n  flex: none;\n}\n.box-info-area .term__date.open:after {\n  transform: scaleY(-1);\n}\n.box-info-area .term__date span {\n  font-size: 26px;\n  line-height: 40px;\n  font-weight: 500;\n  letter-spacing: -0.02em;\n  text-align: left;\n  font-family: \"Pretendard\", sans-serif; /* 추가 */\n}\n.box-info-area .txt-info {\n  margin: 0;\n  font-size: 0.75rem;\n  line-height: 1.5;\n}\n.box-info-area .tit {\n  font-size: 0.938rem;\n  line-height: 1.6;\n  font-weight: 400;\n  color: #051c3f;\n}\n.box-info-area .select-wrap .tit {\n  margin-bottom: 8px;\n  white-space: nowrap;\n}\n.box-info-area .select-wrap .txt {\n  font-size: 26px;\n  line-height: 40px;\n  font-weight: 500;\n  letter-spacing: -0.02em;\n  font-family: \"Pretendard\", sans-serif;\n}\n.box-info-area .num {\n  font-size: 1.625rem;\n  font-weight: 500;\n  line-height: 1.08;\n  letter-spacing: -0.02em;\n  color: #2a2c2f;\n  font-family: \"Pretendard\", sans-serif; /* 추가 */\n}\n.box-info-area .unit,\n.container.energy-solution .box__body .box-info-area .unit {\n  margin-left: 8px;\n  line-height: 1.66;\n  min-width: auto;\n}\n.line-box .box-info-area.large .unit,\n.container.energy-solution .box__body .line-box .box-info-area.large .unit {\n  min-width: 24px;\n  font-size: 1rem;\n  line-height: 2;\n}\n.line-box .box-info-area {\n  gap: 16px;\n  margin: -32px -32px 0;\n  padding: 32px;\n  background: #f7f8fa;\n}\n.line-box .box-info-area .tit {\n  font-size: 1rem;\n  line-height: 1.5;\n}\n.line-box .box-info-area.large .tit {\n  font-size: 1.125rem;\n  line-height: 1.334;\n}\n.line-box .box-info-area .num {\n  line-height: 1.39;\n}\n.line-box .box-info-area.large .num {\n  font-family: \"Pretendard\", sans-serif;\n  font-style: normal;\n  font-size: 1.875rem;\n  line-height: 1.61;\n}\n.line-box .box-info-area .unit,\n.container.energy-solution .box__body .line-box .box-info-area .unit {\n  line-height: 2.67;\n}\n.box-info-area > .right:has(.btn-txt) {\n  display: flex;\n  align-items: flex-end;\n  flex: 1;\n  gap: 79px;\n  margin-left: 140px;\n}\n.box-info-area > .right:has(.btn-txt + .btn-txt) {\n  margin-left: 80px;\n}\n.box-info-area > .right .btn-txt {\n  margin-bottom: 10px;\n  gap: 33px;\n}\n.box-info-area > .right .btn-txt i {\n  width: 20px;\n  height: 20px;\n}\n.box-info-area > .right .btn-txt span {\n  color: var(--navy) !important;\n}\n.box-info-area > .right .btn-txt:has(.icon-setting-primary) {\n  gap: 22px;\n}\n.icon-folder-primary {\n  background: url(../img/icon-folder-primary.svg) no-repeat center center;\n  background-size: 100%;\n}\n@media screen and (max-width: 1540px) {\n  .box-info-area:has(.left) {\n    flex-direction: column;\n  }\n}\n@media screen and (max-width: 1140px) {\n  .box-info-area > div,\n  .box-info-area .select-wrap {\n    flex-direction: column;\n  }\n  .box-info-area .select-wrap {\n    gap: 16px;\n  }\n  .box-info-area .right:has(button) {\n    display: flex;\n    align-items: flex-end;\n  }\n  .line-box .box-info-area > .data,\n  .line-box .box-info-area > .data + .txt-info {\n    text-align: right;\n  }\n}\n@media screen and (max-width: 940px) {\n  .line-box {\n    padding: 16px;\n    width: calc(100% - 32px);\n  }\n  .line-box .box-info-area,\n  .box-info-area {\n    padding: 16px;\n    margin: -16px -16px 0;\n  }\n  .box-info-area .right:has(button.m-none) {\n    display: none;\n  }\n}\n\n.box-info-area .select-wrap .select,\n.box-info-area .select-wrap .select input[type=\"date\"] {\n  display: flex;\n  gap: 38px;\n  height: 40px;\n  color: #2a2c2f;\n  font-weight: 500;\n  font-size: 26px;\n  line-height: 40px;\n  letter-spacing: -0.7px;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n}\n.box-info-area .select-wrap .select .selected .selected-value {\n  font-family: \"Pretendard\", sans-serif; /* 추가 */\n}\n.box-info-area .select-wrap .select.wmin-120 .selected .selected-value {\n  min-width: 120px;\n}\n.box-info-area .select-wrap .select.wmin-120.active > ul {\n  min-width: 96%;\n  white-space: nowrap;\n}\n/* input=\"date\" 캘린더 아이콘 제거 */\n.selected-value input[type=\"date\"] {\n  width: 137px;\n}\n.selected-value input[type=\"date\"]::-webkit-calendar-picker-indicator,\n.selected-value input[type=\"time\"]::-webkit-calendar-picker-indicator,\n.selected-value input[type=\"month\"]::-webkit-calendar-picker-indicator,\n.selected-value input[type=\"week\"]::-webkit-calendar-picker-indicator,\n.selected-value input[type=\"datetime-local\"]::-webkit-calendar-picker-indicator {\n  display: none;\n}\n.box-info-area .select-wrap .select.active > ul {\n  border-radius: 4px;\n  top: 40px;\n  width: auto !important;\n  max-height: 398px;\n  box-shadow: 0px 8px 20px 0px rgba(122, 133, 150, 0.5);\n}\n.box-info-area .select-wrap .select ul li:hover {\n  color: #0a78ff;\n}\n.box-info-area .select-wrap .select > ul li {\n  font-size: 1rem;\n  padding: 12px 32px 11px 24px;\n  width: auto !important;\n  line-height: 1;\n  border-bottom: 1px solid #dde2e9;\n}\n.box-info-area .select-wrap .select .selected {\n  padding: 0;\n  gap: 12px;\n}\n.box-info-area .select-wrap .select .selected .arrow {\n  background: url(\"../img/icon_arrow_blue.svg\") no-repeat center center;\n}\n.box-info-area > div > .btn-basic {\n  height: 28px;\n  min-width: 80px;\n}\n.box-info-area > div > .btn-basic.viewall {\n  width: 100px;\n}\n@media screen and (max-width: 940px) {\n  .box-info-area > div > .btn-basic,\n  #wrap:not(.no-responsive) .box-info-area > div > button.btn-basic {\n    height: 28px;\n  }\n  .box-info-area > div > .btn-basic span,\n  #wrap:not(.no-responsive) .box-info-area > div > button.btn-basic span {\n    font-size: 14px;\n  }\n}\n.analysis-graph .analysis-graph-wrap .tit {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.3;\n  color: #2a2c2f;\n}\n.analysis-graph-wrap .graph-cont {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n.analysis-graph-wrap .graph-cont .graph-box {\n  overflow: auto;\n}\n.analysis-graph-wrap .graph-cont .graph-box .graph-area {\n  width: 100%;\n  min-width: 525px;\n}\n.graph-cont .graph-legend {\n  justify-content: center;\n  gap: 8px;\n}\n.graph-cont .graph-legend p {\n  font-size: 0.875rem;\n  font-weight: 500;\n  line-height: 1.43;\n}\n.graph-cont .graph-legend p:before {\n  content: \"\";\n  width: 16px;\n  height: 16px;\n  background: #ddd;\n  border-radius: 0;\n  min-width: 16px;\n}\n.graph-cont .graph-legend p sub {\n  padding-right: 3px;\n  transform: translatey(30%);\n}\n.graph-cont .graph-legend p.line-square:before {\n  border: 3px solid #ff6781;\n  background: #fff;\n}\n.graph-cont .graph-legend p.line-bg-square:before {\n  border: 1px solid #ff4f6e;\n  background-color: rgba(255, 79, 110, 0.1);\n}\n.graph-cont .graph-legend p.dote-type:before {\n  height: 4px;\n  background: url(\"../img/icon_doteline.svg\") no-repeat center center;\n  background-size: 100%;\n}\n.graph-cont .graph-legend p.dote-type.magenta:before {\n  background: url(\"../img/icon_doteline_mg.svg\") no-repeat center center !important;\n}\n.graph-cont .graph-legend p.dote-type.deep-blue:before {\n  background: url(\"../img/icon_doteline_db.svg\") no-repeat center center !important;\n}\n.graph-cont .graph-legend p.dote-type.midnight-blue:before {\n  background: url(\"../img/icon_doteline_mnb.svg\") no-repeat center center !important;\n}\n.graph-cont .graph-legend p.dote-type.mint:before {\n  background: url(\"../img/icon_doteline_mint.svg\") no-repeat center center !important;\n}\n.graph-cont .graph-legend p.dote-type.light-aqua:before {\n  background: url(\"../img/icon_doteline_la.svg\") no-repeat center center !important;\n}\n.graph-cont .graph-legend p.line-type:before {\n  height: 6px;\n}\n.graph-cont .graph-legend .navy::before {\n  background: #0f5fa5 !important;\n}\n.graph-cont .graph-legend .dark-navy::before {\n  background: #003876 !important;\n}\n.graph-cont .graph-legend .blue::before {\n  background: #4253ba !important;\n}\n.graph-cont .graph-legend .blue-navy::before {\n  background: #1b67aa !important;\n}\n.graph-cont .graph-legend .light-blue::before {\n  background: #5b71ef !important;\n}\n.graph-cont .graph-legend .cyan::before {\n  background: #00d5cc !important;\n}\n.graph-cont .graph-legend .red::before {\n  background: #ff6781 !important;\n}\n.graph-cont .graph-legend .purple::before {\n  background: #930aff !important;\n}\n.graph-cont .graph-legend .light-purple::before {\n  background: #e3e6ff !important;\n}\n.graph-cont .graph-legend .vivid-purple::before {\n  background: rgba(147, 10, 255, 0.89) !important;\n}\n.graph-cont .graph-legend .light-cyan::before {\n  background: #ccece5 !important;\n}\n.graph-cont .graph-legend .light-green::before {\n  background: #eefbdd !important;\n}\n.graph-cont .graph-legend .sky-blue::before {\n  background: #cddbff !important;\n}\n.graph-cont .graph-legend .dark-blue::before {\n  background: #162db9 !important;\n}\n.graph-cont .graph-legend .deep-blue::before {\n  background: #0028b6 !important;\n}\n.graph-cont .graph-legend .medium-blue::before {\n  background: #5c73f8 !important;\n}\n.graph-cont .graph-legend .light-gray::before {\n  background: #dde2e9 !important;\n}\n.graph-cont .graph-legend .white-gray::before {\n  background: #d5d8e5 !important;\n}\n.graph-cont .graph-legend .dark-gray::before {\n  background: #646c74 !important;\n}\n.graph-cont .graph-legend .hot-pink::before {\n  background: #ff4f6e !important;\n}\n.graph-cont .graph-legend .coral::before {\n  background: #f55547 !important;\n}\n.graph-cont .graph-legend .mint::before {\n  background: #00dacd !important;\n}\n.graph-cont .graph-legend .deep-cyan::before {\n  background: #13a79e !important;\n}\n.graph-cont .graph-legend .bright-blue::before {\n  background: #0a78ff !important;\n}\n.graph-cont .graph-legend .lavender::before {\n  background: #7d5cbe !important;\n}\n.graph-cont .graph-legend .orange::before {\n  background: #ff9900 !important;\n}\n.graph-cont .graph-legend .turquoise::before {\n  background: #00a07c !important;\n}\n.graph-cont .graph-legend .bright-cyan::before {\n  background: #1bc8e9 !important;\n}\n.graph-cont .graph-legend .lime::before {\n  background: #819b17 !important;\n}\n.graph-cont .graph-legend .beige::before {\n  background: #8d5b2d !important;\n}\n.graph-cont .graph-legend .light-pink::before {\n  background: #ffc0cd !important;\n}\n.graph-cont .graph-legend .grayish::before {\n  background: #b2c0db !important;\n}\n.graph-cont .graph-legend .dark-cerulean::before {\n  background: #084a84 !important;\n}\n.graph-cont .graph-legend .deep-pink::before {\n  background: #cc4b78 !important;\n}\n.graph-cont .graph-legend .dark-purple::before {\n  background: #663c90 !important;\n}\n.graph-cont .graph-legend .dark-orange::before {\n  background: #e76700 !important;\n}\n.graph-cont .graph-legend .bright-yellow::before {\n  background: #ffe501 !important;\n}\n.graph-cont .graph-legend .golden::before {\n  background: #eaa925 !important;\n}\n.graph-cont .graph-legend .terracotta::before {\n  background: #d67047 !important;\n}\n.graph-cont .graph-legend .raspberry::before {\n  background: #c43c68 !important;\n}\n.graph-cont .graph-legend .vivid-pink::before {\n  background: #b40b85 !important;\n}\n.graph-cont .graph-legend .cool-gray::before {\n  background: #909fb7 !important;\n}\n@media screen and (max-width: 1450px) {\n  .graph-cont .graph-legend {\n    flex-wrap: wrap;\n  }\n}\n@media screen and (max-width: 940px) {\n  .analysis-graph-wrap .graph-cont {\n    gap: 16px;\n  }\n}\n/* bar-type */\n.graph-legend p.bar-type {\n  gap: 0;\n  position: relative;\n  padding-bottom: 1.5em;\n}\n.graph-legend p.bar-type::before {\n  width: 300px;\n}\n.graph-legend p.bar-type > span {\n  position: absolute;\n  bottom: 0;\n}\n.graph-legend p.bar-type > span.left {\n  left: 0;\n}\n.graph-legend p.bar-type > span.right {\n  right: 0;\n  text-align: right;\n}\n.graph-cont .graph-legend .green-pink::before {\n  background: linear-gradient(to right, #0d5d82, #82a5bb, #f6edf4, #fbacb9, #ff6c7f);\n}\n\n.graph-info {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 32px;\n  margin-top: 64px;\n}\n.graph-info .name {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 16px;\n  font-size: 1.125rem;\n  line-height: 1.33;\n  font-weight: 400;\n  color: #051c3f;\n  letter-spacing: -0.07em;\n}\n.graph-info .name:before {\n  content: \"\";\n  width: 16px;\n  height: 16px;\n  flex: none;\n  background: #ddd;\n}\n.graph-info .name.line-type:before {\n  height: 6px;\n}\n.graph-info .name.navy::before {\n  background: #0f5fa5 !important;\n}\n.graph-info .name.blue::before {\n  background: #4253ba !important;\n}\n.graph-info .name.light-blue::before {\n  background: #5b71ef !important;\n}\n.graph-info .name.cyan::before {\n  background: #00d5cc !important;\n}\n.graph-info .name.red::before {\n  background: #ff6781 !important;\n}\n.graph-info .name.purple::before {\n  background: #930aff !important;\n}\n.graph-info .name.light-purple::before {\n  background: #e3e6ff !important;\n}\n.graph-info .name.light-cyan::before {\n  background: #ccece5 !important;\n}\n.graph-info .name.light-green::before {\n  background: #eefbdd !important;\n}\n.graph-info .name.bright-blue::before {\n  background: #0a78ff !important;\n}\n.graph-info .name.mint::before {\n  background: #00dacd !important;\n}\n.graph-info .name.dote-type:before {\n  height: 4px;\n  background: url(../img/icon_doteline.svg) no-repeat center center;\n  background-size: 100%;\n}\n.graph-info .data {\n  text-align: right;\n}\n.graph-info .num {\n  font-family: \"Pretendard\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.625rem;\n  font-weight: 400;\n  line-height: 1.33;\n  letter-spacing: -0.02em;\n  color: #2a2c2f;\n}\n.graph-info .num.primary {\n  font-weight: 600;\n}\n.container.energy-solution .box__body .graph-info .unit {\n  display: inline-block;\n  min-width: unset;\n  margin-left: 4px;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 2;\n  letter-spacing: -0.02em;\n  color: #909fb7;\n  text-align: right;\n  vertical-align: middle;\n}\n.graph-info .arrow {\n  width: 32px;\n  height: 32px;\n  /* background: url('../img/icon_change_arrow.svg') no-repeat center center; */\n  background: url(../img/icon_change_arrow_lg.svg) no-repeat center center;\n  background-size: 100%;\n}\n@media screen and (max-width: 1450px) {\n  .graph-info {\n    flex-direction: column;\n    align-items: flex-start;\n    margin-top: 32px;\n  }\n  .graph-info > * {\n    width: 100%;\n  }\n  .graph-info .arrow {\n    margin: 0 auto;\n    transform: rotate(90deg);\n  }\n}\n.graph-info.gap-64 {\n  margin-top: 0;\n}\n@media screen and (max-width: 1450px) {\n  .graph-info.gap-64 {\n    gap: 32px !important;\n  }\n}\n.table-wrap:has(.left) {\n  display: flex;\n  gap: 64px;\n}\n@media screen and (max-width: 1540px) {\n  .table-wrap:has(.left) {\n    flex-direction: column;\n    gap: 32px;\n  }\n}\n.detail-box .tit {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n}\n.detail-box .tit {\n  margin-bottom: 8px;\n}\n.container.energy-solution .box__body .box-column > li > article > section .detail-box .box-list {\n  height: auto;\n}\n.container.energy-solution .box__body .box-column > li > article > section .detail-box .box-list + .box-list {\n  margin-top: 8px;\n}\n.container.energy-solution .box__body .box-column > li > article > section .detail-box .box-list:not(.column) > li {\n  min-height: auto;\n}\n.container.energy-solution .box__body .box-column > li > article > section .detail-box .box-list > li.row {\n  flex-direction: row;\n  justify-content: space-between;\n  max-width: calc(50% - 36px);\n}\n/* .detail-box .box-list {\n  display: flex;\n  gap: 8px;\n}\n.detail-box .box-list.column > li {\n  flex-direction: column;\n}\n.detail-box .box-list > li {\n  padding: 16px;\n  background: #f7f8fa;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  flex: 1;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.detail-box .box-list > li .name {\n  font-size: 0.938rem;\n  line-height: 1.6;\n  letter-spacing: -0.04em;\n  color: #2a2c2f;\n}\n.detail-box .box-list > li .name:before {\n  content: '';\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  margin: 6px 8px 0 0;\n  background: #0a78ff;\n  border-radius: 50%;\n  vertical-align: text-top;\n} */\n.btn-pop-area {\n  position: relative;\n  display: inline-flex;\n  gap: 2px;\n}\n.btn-pop-area .btn-pop {\n  margin-top: 1px;\n  min-width: 20px;\n}\n.btn-pop-area .pop-layer-box.info {\n  left: 0;\n  top: 22px;\n}\n.detail-box .box-list > li .data {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n.detail-box .box-list > li .data .num {\n  font-size: 1.625rem;\n  font-weight: 500;\n  line-height: 1.39;\n  letter-spacing: -0.02em;\n  color: #2a2c2f;\n}\n.detail-box .box-list > li .info .percent {\n  font-size: 0.875rem;\n  line-height: 1.43;\n  color: #0a78ff;\n  font-weight: 400;\n  letter-spacing: -0.02em;\n}\n.detail-box .box-list > li .info .percent .unit {\n  font-size: 0.75rem;\n  color: #0a78ff;\n  margin-left: 2px;\n  min-width: auto;\n  font-weight: 400;\n  line-height: 1.54;\n  letter-spacing: -0.02em;\n}\n.detail-box .box-list > li .info .percent.down:after {\n  content: \"\";\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_arrow_bg_primary.svg\") no-repeat center center;\n  background-size: 100%;\n  vertical-align: bottom;\n}\n@media screen and (max-width: 1420px) {\n  /* .detail-box .box-list,\n  .detail-box .box-list > li {\n    flex-direction: column;\n  }\n  .detail-box,\n  .detail-box.margin {\n    padding: 16px;\n    margin-bottom: 0;\n  } */\n  .container.energy-solution .box__body .box-column > li > article > section .detail-box .box-list > li.row {\n    flex-direction: column;\n    max-width: 100%;\n    gap: 24px;\n  }\n}\n@media screen and (max-width: 1294px) {\n  .container.energy-solution .box__body .box-column > li > article > section .detail-box .box-list:not(.column) > li {\n    gap: 24px;\n  }\n}\n\n/********* 에너지 솔루션 - ESS설치분석 - 팝업 *********/\n.btn-basic .icon-go-large {\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_page_go_large.svg\") no-repeat center center;\n  background-size: 100%;\n}\n.dot-list > li:before {\n  content: \"\";\n  width: 4px;\n  height: 4px;\n  background: #2a2c2f;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 8px;\n}\n\n/********* 에너지 솔루션 - PV 설치 분석 *********/\n@media screen and (max-width: 1740px) {\n  .container.energy-solution .box__body .box-column > li > article > section .cont > .box-list > li {\n    min-width: 233px;\n  }\n}\n@media screen and (max-width: 1400px) {\n  .popup-layer.w1360 {\n    width: calc(100% - 40px) !important;\n  }\n}\n@media screen and (max-width: 940px) {\n  .popup-layer.w880 {\n    width: calc(100% - 40px) !important;\n  }\n}\n@media screen and (max-width: 600px) {\n  .popup-layer.w560 {\n    width: calc(100% - 40px) !important;\n  }\n}\n\n/********* 에너지 솔루션 - 고효율 설비 교체 분석 *********/\n.container.energy-solution .box__body .box-search-card.no-focus {\n  border-color: #f2f5fb;\n}\n.container.energy-solution .box__body .box-search-card > .bottom .menu-list {\n  gap: 24px;\n}\n.container.energy-solution .box__body .box-search-card > .bottom .menu-list > li > a {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 40px;\n  width: 100%;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: #051c3f;\n}\n.container.energy-solution .box__body .box-search-card > .bottom .menu-list > li > a > span {\n  min-width: 47px;\n}\n.container.energy-solution .box__body .box-search-card > .bottom .menu-list.only-view > li > a {\n  cursor: default;\n}\n.container.energy-solution .box__body .box-search-card > .bottom .menu-list:not(.only-view) > li.on > a {\n  color: var(--primary);\n  font-weight: 700;\n}\n.container.energy-solution .box__body .box-search-card > .bottom .menu-list:not(.only-view) > li.on:after,\n.container.energy-solution .box__body .box-search-card > .bottom .menu-list:not(.only-view) > li:hover:after {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_arrow_line2.svg\") no-repeat center center;\n  background-size: 100%;\n}\n.container.energy-solution .box__body .box-search-card > .bottom .menu-list:not(.only-view) > li:hover > a {\n  color: var(--primary);\n}\n.container.energy-solution .box__body .box-column:has(.box-guide) {\n  gap: 8px;\n}\n.container.energy-solution .box__body .box-column > li > article > section .top:has(.tit) {\n  padding-bottom: 10px;\n}\n.container.energy-solution .box__body .box-column > li > article > section .top.brd-0 {\n  padding-bottom: 0;\n}\n.container.energy-solution .box__body .box-column > li > article > section .top .tit {\n  font-size: 1rem;\n  letter-spacing: -0.02em;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #2a2c2f;\n}\n.container.energy-solution .box__body .box-column > li > article > section .top .tit .txt-info {\n  margin-left: 16px;\n  color: #646c74;\n}\n.container.energy-solution .box__body .box-column > li > article > section .cont .box-info-area {\n  padding: 24px;\n  width: calc(100% - 48px);\n  background: #f7f8fa;\n}\n.container.energy-solution .box__body .box-column > li > article > section .cont .box-info-area.hover:hover {\n  width: calc(100% - 50px);\n}\n\n.container.energy-solution .box__body .box-column > li > article > section .cont .box-info-area.active-color.show {\n  background: #e6f0ff;\n}\n.container.energy-solution .box__body .box-column > li > article > section .cont .box-info-area.active-color.show .tit {\n  font-weight: 500;\n}\n.container.energy-solution .box__body .box-column > li > article > section .cont .box-info-area .select-wrap {\n  gap: 64px;\n}\n.container.energy-solution .box__body .box-column > li > article > section .cont:has(.box-guide, .box-data-detail) {\n  flex-direction: column;\n  gap: 0;\n}\n.container.energy-solution .box__body .box-column > li > article > section .cont:has(> .right .box-info-area) {\n  flex-direction: row;\n  align-items: flex-end;\n  gap: 24px;\n  flex: 1;\n}\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .cont:has(.box-guide, .box-data-detail)\n  > .left,\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .cont:has(.box-guide, .box-data-detail)\n  > .right,\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .cont:has(.box-guide, .box-data-detail)\n  > .row\n  > .left,\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .cont:has(.box-guide, .box-data-detail)\n  > .row\n  > .right {\n  flex: 1;\n  width: 100%;\n}\n.container.energy-solution .box__body .box-column > li > article > section .cont:has(> .row .btn-area-line) {\n  flex-direction: column;\n  gap: 40px;\n}\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .cont:has(.box-guide, .box-data-detail)\n  > .row {\n  display: flex;\n  gap: 24px;\n  align-items: flex-end;\n}\n.container.energy-solution .box__body .box-column > li > article > section .cont .box-guide {\n  display: none;\n}\n.container.energy-solution .box__body .box-column > li.on > article > section .cont .box-guide {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 8px;\n  background: #0a78ff;\n  font-size: 0.875rem;\n  line-height: 1.4;\n  font-weight: 500;\n  color: #fff;\n  border-radius: 4px 4px 0 0;\n}\n.box-guide .tag {\n  padding: 0 5px 0 4px;\n  width: auto;\n  height: 16px;\n  color: #0a78ff;\n  font-size: 0.688rem;\n  font-weight: 600;\n  letter-spacing: -0.07em;\n  background: #fff;\n  border-radius: 25px;\n  flex: none;\n}\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .cont:has(.box-guide, .box-data-detail)\n  .box-info-area\n  .tit,\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .cont\n  .box-info-area\n  .select-wrap:has(.txt)\n  .tit {\n  font-size: 1rem;\n  line-height: 1.4;\n}\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .cont:has(.box-guide, .box-data-detail)\n  .box-info-area\n  .num {\n  line-height: 1.61;\n}\n\n.box-data-detail {\n  display: none;\n  gap: 24px;\n}\n.box-data-detail.show {\n  display: flex;\n  margin-top: 16px;\n}\n.box-data-detail > *,\n.box-data-detail > .row > * {\n  flex: 1;\n}\n.box-data-detail:has(> .row) {\n  flex-direction: column;\n  gap: 40px;\n}\n.box-data-detail > .row {\n  display: flex;\n  gap: 24px;\n}\n.box-data-detail .tbl-list.scrollH {\n  height: 320px;\n  margin: 0;\n  padding: 0;\n}\n.box-data-detail .keywordlist {\n  gap: 8px;\n}\n.box-data-detail .keywordlist.scrollH {\n  height: 310px;\n  margin: 0;\n  padding: 0 0 10px 0;\n  border-bottom: 1px solid #ddd;\n}\n.box-data-detail .keywordlist > li {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex: none;\n  padding: 5px 12px 4px;\n  width: fit-content;\n  min-height: 24px;\n  background: var(--sky);\n  border-radius: 25px;\n}\n.box-data-detail .keywordlist span {\n  font-size: 12px;\n  line-height: 1.63;\n  color: var(--primary);\n}\n.box-data-detail .keywordlist li .btn-delete {\n  display: inline;\n  width: 20px;\n  height: 20px;\n  flex: none;\n  background: url(\"../img/icon_delete_gray20.svg\") no-repeat center center;\n  background-size: 100%;\n}\n.box-data-detail .tbl__top .data .num {\n  font-size: 1.25rem;\n  line-height: 1.6;\n  font-weight: 500;\n  letter-spacing: -0.07em;\n  color: #051c3f;\n}\n.container.energy-solution .cont .btn-area-line {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 16px;\n  flex: 1;\n  padding-top: 16px;\n  border-top: 1px solid #dde2e9;\n}\n.container.energy-solution .cont .btn-area-line button.btn-basic {\n  height: 42px;\n  min-width: 376px;\n}\n.container.energy-solution .cont .btn-area-line button.btn-basic span {\n  font-size: 1rem;\n  font-weight: 700;\n}\n.container.energy-solution .cont .btn-area-line button.btn-basic:disabled {\n  border-color: #dde2e9 !important;\n  background-color: #dde2e9 !important;\n}\n@media screen and (max-width: 500px) {\n  .container.energy-solution .cont .btn-area-line button.btn-basic {\n    min-width: 100%;\n  }\n}\n@media screen and (max-width: 1130px) {\n  #wrap:not(.no-responsive) .tbl__top:has(.left, .right > .btn-basic.gray) {\n    gap: 16px;\n    flex-direction: column;\n    align-items: normal;\n  }\n}\nbutton.gray:disabled {\n  background: #f0f2f4 !important;\n}\n.popup-type2 .popup__body:has(.locate) .flex-row .pop-right > ul li.error-txt .txt-info-small {\n  color: #f55547;\n}\n/********* 에너지 솔루션 - 고효율 설비 교체 분석 상세 분석 *********/\n.box-data-detail.show .detail-analysispop {\n  display: block;\n  margin-top: 0;\n}\n.box-data-detail .detail-analysis-wrap + .detail-analysis-wrap {\n  margin-top: 40px;\n}\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .cont\n  .box-data-detail\n  .detail-analysispop\n  .box-info-area {\n  gap: 16px;\n  width: 100%;\n  margin: -32px -32px 0;\n  padding: 32px;\n  background: #f7f8fa;\n}\n.box-data-detail .detail-analysispop {\n  width: 100%;\n}\n.box-data-detail .detail-analysispop .line-box {\n  border-color: #fff;\n}\n.box-data-detail .detail-analysispop .box-info-area .tit {\n  font-size: 1.125rem;\n  line-height: 1.33;\n  color: #2a2c2f;\n}\n.box-data-detail .detail-analysispop .box-info-area .num {\n  font-family: \"Pretendard\", sans-serif;\n  font-style: normal;\n  font-size: 1.875rem;\n  line-height: 1.33;\n}\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .cont:has(.box-guide, .box-data-detail)\n  .box-info-area\n  .num\n  .unit {\n  min-width: 24px;\n  font-size: 1rem;\n  line-height: 2;\n}\n.container.energy-solution .cont .box-data-detail .detail-analysispop .btn-area-line {\n  margin: 0 16px;\n}\n.container.energy-solution .searcharea:has(.btn-add.etc + .popup-etc) {\n  position: relative;\n}\n.tbl__top .data > .num {\n  font-size: 1.625rem;\n  font-weight: 500;\n  line-height: 1.5;\n  letter-spacing: -0.02em;\n  color: #2a2c2f;\n}\n.tbl__top .data > .num .unit {\n  display: inline-block;\n  margin-left: 8px;\n  font-size: 0.75rem;\n  font-weight: 400;\n  line-height: 2.66;\n  letter-spacing: -0.02em;\n  color: #909fb7;\n  text-align: left;\n  vertical-align: middle;\n}\n.tbl__top .data.error > .num,\n.tbl__top .data.error + .txt-info-small {\n  color: #f55547;\n}\n.box-data-detail .tbl__top .data button.num {\n  display: block;\n  border: 0;\n  border-radius: 0;\n}\n.tbl__top button.num span {\n  font-size: 1.25rem;\n  line-height: 1.6;\n  font-weight: 500;\n  letter-spacing: -0.07em;\n  color: #051c3f;\n}\n.tbl__top button span.unit {\n  margin-left: 8px;\n}\n.box-data-detail .tbl__top:has(.data button.num.btn-pop) {\n  position: relative;\n}\n.box-data-detail .tbl__top .data button.num.btn-pop + .pop-layer-box.show {\n  top: 25px;\n  left: calc(100% - 330px);\n}\n.tbl-list.right table td button {\n  margin-right: 8px;\n}\n.m-block-1540 {\n  display: none !important;\n}\n.m-block-1250 {\n  display: none !important;\n}\n.m-block-1090 {\n  display: none !important;\n}\n@media screen and (max-width: 1670px) {\n  .box-data-detail .detail-analysis-wrap .line-box.row .graph-cont .graph-legend {\n    flex-wrap: wrap;\n  }\n}\n@media screen and (max-width: 1740px) {\n  .container.energy-solution .box__body .box-column > li > article > section .cont {\n    flex-direction: column;\n    gap: 16px;\n  }\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .box-data-detail\n    .detail-analysis-wrap\n    .detail-box\n    .box-list.column {\n    flex-direction: column;\n  }\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .box-data-detail\n    .detail-analysis-wrap\n    .detail-box\n    .box-list.column\n    > li {\n    flex-direction: row;\n  }\n}\n@media screen and (max-width: 1710px) {\n  .box-info-area:has(.right .btn-txt + .btn-txt) {\n    flex-direction: column;\n  }\n  .box-info-area > .right:has(.btn-txt + .btn-txt) {\n    margin: 16px 0 0 0;\n  }\n}\n@media screen and (max-width: 1710px) {\n  .box-info-area:has(.right .btn-txt + .btn-txt) {\n    flex-direction: column;\n  }\n  .box-info-area > .right:has(.btn-txt + .btn-txt) {\n    margin: 16px 0 0 0;\n  }\n  .box-data-detail\n    .detail-analysispop:has(.analysis-graph-wrap + .detail-box)\n    .analysis-graph-wrap\n    .graph-cont\n    .graph-box\n    .graph-area {\n    min-width: auto;\n  }\n}\n@media screen and (max-width: 1540px) {\n  .box-info-area > .right:has(.btn-txt) {\n    margin: 16px 0 0 0;\n  }\n  .box-info-area:has(.left + .right.flex-row.end) {\n    flex-direction: row;\n  }\n  /* .box-info-area:has(.left + .right.flex-row.end){\n    flex-direction: row-reverse;\n  } */\n  .box-data-detail > .row {\n    flex-direction: column;\n  }\n  .box-data-detail > .row:has(.keywordlist.scrollH) {\n    flex-direction: column-reverse;\n    gap: 0;\n  }\n  .box-data-detail .keywordlist.scrollH {\n    display: none;\n  }\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .cont:has(.box-guide, .box-data-detail)\n    > .row {\n    flex-direction: column;\n    gap: 32px;\n  }\n  .container.energy-solution .box__body .box-column > li > article > section .detail-box .box-list {\n    flex-direction: column;\n    flex-wrap: nowrap;\n  }\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .box-data-detail\n    .detail-box\n    .box-list.column\n    > li {\n    flex-direction: row;\n  }\n  .container.energy-solution .box__body .box-column > li > article > section .detail-box .box-list > li > .box-list {\n    flex-direction: row;\n  }\n  .box-data-detail .detail-analysis-wrap .line-box.row {\n    flex-direction: column;\n    gap: 24px;\n  }\n  .m-none-1540 {\n    display: none !important;\n  }\n  .m-block-1540 {\n    display: block !important;\n  }\n}\n@media screen and (max-width: 1500px) {\n  .m-none-1500 {\n    display: none !important;\n  }\n}\n@media screen and (max-width: 1250px) {\n  .line-box .txt-info-large + .txt-info-large {\n    margin-top: 16px;\n  }\n  .box-data-detail .detail-analysispop .line-box {\n    padding: 0;\n    width: 100%;\n  }\n  .detail-analysis-wrap.section .analysis-graph-wrap.scroll.m-mt-16 {\n    margin-top: 0 !important;\n  }\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .cont\n    .box-data-detail\n    .detail-analysispop\n    .box-info-area {\n    margin: 0;\n    width: calc(100% - 64px);\n  }\n  .m-none-1250 {\n    display: none !important;\n  }\n  .m-block-1250 {\n    display: block !important;\n  }\n}\n@media screen and (max-width: 1190px) {\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .box-data-detail\n    .detail-analysis-wrap\n    .detail-box\n    .box-list\n    > li\n    > .box-list {\n    flex-direction: column;\n    gap: 40px;\n  }\n}\n@media screen and (max-width: 1140px) {\n  .container.energy-solution .box__body .box-column > li > article > section .cont .box-info-area .select-wrap {\n    gap: 32px;\n  }\n  .box-info-area > .right:has(.btn-txt + .btn-txt) {\n    margin: 56px 0 0 0;\n  }\n  .box-info-area > .right:has(.btn-txt) {\n    /* 240626 flex-start삭제 */\n    gap: 16px;\n  }\n\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .box-data-detail .tbl__bottom {\n    justify-content: flex-start;\n    margin: 24px 0 0;\n    flex-wrap: wrap;\n  }\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .box-data-detail .paging {\n    width: 100%;\n    justify-content: center;\n    margin-top: 24px;\n  }\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .box-data-detail .paging__select {\n    display: none;\n  }\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .box-data-detail .paging ul {\n    margin-left: 0;\n  }\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .box-data-detail .paging .btn-first,\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .box-data-detail .paging .btn-last {\n    display: none;\n  }\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .box-data-detail .paging li > a {\n    font-size: 0.875rem;\n  }\n  #wrap:not(.no-responsive) .container:not(.no-responsive) .box-data-detail .paging li > a.active {\n    height: 100%;\n    border-top: 1px solid #909fb7;\n    border-bottom: 1px solid #909fb7;\n  }\n  .box-data-detail .paging .btn-prev {\n    margin-right: 16px;\n  }\n  .box-data-detail .paging .btn-next {\n    margin-left: 16px;\n  }\n}\n@media screen and (max-width: 1090px) {\n  .m-none-1090 {\n    display: none !important;\n  }\n  .m-block-1090 {\n    display: block !important;\n  }\n  .container.energy-solution .cont .btn-area-line button.btn-basic {\n    min-width: 100%;\n  }\n}\n@media screen and (max-width: 940px) {\n  .container.energy-solution .box__body .box-column > li > article > section .cont .box-info-area {\n    margin: 0;\n  }\n}\n@media screen and (max-width: 699px) {\n  .m-none-699 {\n    display: none !important;\n  }\n}\n@media screen and (max-width: 500px) {\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .box-data-detail\n    .detail-analysis-wrap\n    .detail-box\n    .box-list.column\n    > li {\n    flex-direction: column;\n  }\n  .box-info-area .right.flex-row.end {\n    justify-content: flex-end;\n  }\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .cont\n    .box-data-detail\n    .detail-analysispop\n    .box-info-area {\n    margin: 0;\n    padding: 16px;\n    width: calc(100% - 32px);\n  }\n  .box-data-detail .detail-analysis-wrap .line-box .detail-box {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n  .box-data-detail .detail-analysis-wrap .line-box .txt-info-large {\n    margin-top: 0;\n  }\n}\n\n/********* 에너지 솔루션 - 고효율 설비 교체 분석 USER 화면 *********/\n.box-column.only-view .box-data-detail {\n  display: flex;\n  margin-top: 16px;\n}\n.container.energy-solution .box__body .box-column.only-view > li > article > section .cont .box-info-area.active-color {\n  background: #e6f0ff;\n}\n.container.energy-solution\n  .box__body\n  .box-column.only-view\n  > li\n  > article\n  > section\n  .cont\n  .box-info-area.active-color\n  .tit {\n  font-weight: 500;\n}\n\n/********* 에너지 솔루션 - 전기차충전기설치분석 *********/\n.radioBox .checked-box.on {\n  display: block;\n}\n.radioBox .checked-box {\n  display: none;\n  margin-left: 8px;\n}\n.radioBox .checked-box .wrap {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.radioBox .checked-box .wrap > li .text {\n  color: #7a8596;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  word-break: break-word;\n  letter-spacing: -0.02em;\n}\n.radioBox .checked-box .wrap .input-box {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n.radioBox .checked-box .wrap .input-box .tit {\n  flex: 1;\n}\n.radioBox .checked-box .wrap .input-box .input__area {\n  max-width: 88px !important;\n}\n.box-data-detail .detail-analysis-wrap.pt96 + .detail-analysis-wrap.pt96 {\n  margin-top: 96px;\n}\n.box-data-detail .detail-analysispop .detail-analysis-wrap.pt96 .line-box.no .box-info-area .left .tit {\n  font-size: 1.125rem;\n  line-height: 1.334;\n}\n.line-box.no {\n  padding: 32px 32px 0 32px;\n}\n.line-box.no .box-info-area .num {\n  line-height: 1.33 !important;\n}\n.line-box.pt48 {\n  gap: 16px;\n  padding: 48px 32px 0;\n}\n@media screen and (max-width: 1250px) {\n  .box-data-detail .detail-analysispop .line-box.pt48 {\n    padding: 48px 0 0;\n  }\n}\n.line-box.pt48 .column-box {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.full-box {\n  background: #f7f8fa;\n}\n.full-box:hover,\n.ful-box:active {\n  background-color: #e6f0ff;\n}\n.full-box .wrap {\n  padding: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n@media screen and (max-width: 1100px) {\n  .full-box .wrap {\n    padding: 16px;\n  }\n}\n.full-box .wrap .text {\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.4;\n}\n.full-box .wrap .move::after {\n  content: \"\";\n  display: block;\n  width: 24px;\n  height: 24px;\n  background: url(../img/icon_page_go_gr_large.svg) no-repeat center;\n}\n.full-box:active .wrap .move::after,\n.full-box:hover .wrap .move::after {\n  background: url(../img/icon_move.svg) no-repeat center center;\n  background-size: 24px;\n}\n@media screen and (max-width: 1140px) {\n  .line-box.no .box-info-area > .data,\n  .line-box.no .box-info-area > .data + .txt-info {\n    text-align: left;\n  }\n}\n.detail-box.info .title-small {\n  font-weight: 400;\n  margin-bottom: 16px;\n}\n.detail-box.info .box-list > li {\n  gap: 8px !important;\n  padding: 32px !important;\n}\n@media screen and (max-width: 1540px) {\n  .detail-box.info .box-list > li {\n    padding: 16px !important;\n  }\n}\n.detail-box.info .box-list > li .tit {\n  font-weight: 400;\n  margin-bottom: 0;\n}\n.detail-box.info .box-list > li .data {\n  align-items: flex-start;\n}\n.detail-box.info .box-list > li .data .num {\n  line-height: 1.539 !important;\n}\n.detail-box.info .box-list > li .txt-info {\n  font-size: 0.75rem;\n  margin-left: 0;\n  line-height: 1.5;\n}\n.detail-box.info .box-list > li .data .num .unit {\n  margin-left: 8px;\n  font-size: 0.75rem;\n  line-height: 2.667;\n}\n.detail-box.info .box-list:not(.column) > li {\n  min-height: 98px !important;\n}\n.line-box.right-circular {\n  padding: 0;\n  gap: 8px;\n  width: auto;\n}\n.line-box.right-circular .analysis-graph-wrap .graph-cont .graph-box {\n  margin: 0 auto;\n}\n.line-box.right-circular .analysis-graph-wrap .graph-cont .graph-box .graph-area {\n  width: 220px;\n  min-width: 220px;\n}\n.line-box.right-circular .analysis-graph-wrap .graph-cont {\n  gap: 18px;\n}\n.detail-analysis-wrap .line-box.right-circular .title-small {\n  margin-bottom: 8px;\n}\n.line-box.right-circular .txt-info-large {\n  margin-top: 0;\n  margin-bottom: 16px;\n}\n@media screen and (max-width: 1540px) {\n  .box-data-detail .detail-analysis-wrap .line-box.right-circular {\n    gap: 32px;\n  }\n}\n@media screen and (max-width: 500px) {\n  .box-data-detail .detail-analysis-wrap .line-box.right-circular .detail-box {\n    gap: 0;\n  }\n}\n.txt-info.pt {\n  font-size: 0.75rem;\n  margin-left: 0;\n  margin-top: -8px;\n  line-height: 1.5;\n  letter-spacing: -0.2px;\n}\n.full-box-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n}\n@media screen and (max-width: 1250px) {\n  .full-box-wrap {\n    gap: 8px;\n  }\n}\n.full-box-wrap .box-info-area {\n  flex-direction: row;\n  align-items: center;\n  gap: 8px !important;\n}\n@media screen and (max-width: 1636px) {\n  .full-box-wrap.btn .box-info-area {\n    align-items: flex-start;\n  }\n}\n@media screen and (max-width: 1645px) {\n  .full-box-wrap.btn .box-info-area .wrap.txt {\n    gap: 8px;\n  }\n}\n@media screen and (max-width: 1585px) {\n  .full-box-wrap .box-info-area {\n    align-items: unset;\n    flex-direction: column;\n  }\n  .full-box-wrap.btn .box-info-area {\n    align-items: flex-start;\n    flex-direction: unset;\n  }\n}\n@media screen and (max-width: 1058px) {\n  .full-box-wrap .box-info-area {\n    margin: 0 !important;\n    padding: 16px !important;\n    width: calc(100% - 32px) !important;\n  }\n}\n.full-box-wrap .box-info-area:hover,\n.full-box-wrap .box-info-area:active {\n  background-color: #e6f0ff !important;\n}\n.full-box-wrap .box-info-area .wrap {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.full-box-wrap .box-info-area .wrap > img {\n  width: 100px;\n  height: 20px;\n}\n.full-box-wrap .box-info-area .wrap .text {\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.4;\n}\n@media screen and (max-width: 1585px) {\n  .full-box-wrap .box-info-area .wrap {\n    align-items: flex-start !important;\n    flex-direction: column;\n  }\n  .full-box-wrap .box-info-area .btn-area {\n    display: flex;\n    align-items: flex-end;\n    justify-content: flex-end;\n  }\n}\n.flex-right .txt-info {\n  text-align: right;\n  letter-spacing: -0.2px;\n}\n.guide-wrap .txt-info-large {\n  margin-top: 8px;\n}\n@media screen and (max-width: 500px) {\n  .box-data-detail .detail-analysis-wrap .line-box .guide-wrap .txt-info-large {\n    margin-top: 8px;\n  }\n}\n\n/********* 에너지 솔루션 - 전기요금변동 시뮬레이션 *********/\n.container.energy-solution .box__body .box-search-card > .bottom.right > ul > li .txt,\n.container.energy-solution .box__body .box-search-card > .bottom.right > ul > li .txt-info {\n  text-align: right;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > li .etc {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > li .etc li {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.813rem;\n  font-weight: 400;\n  line-height: 1.54;\n  letter-spacing: -0.02em;\n  color: #646c74;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > li .etc li span {\n  flex: 1;\n}\n.pop-layer-box .pop-bottom:has(a) {\n  padding: 10px 24px;\n}\n.pop-layer-box .pop-bottom > a {\n  font-size: 0.813rem;\n  line-height: 1.4;\n  letter-spacing: -0.02em;\n  text-decoration: underline;\n  color: #0a78ff;\n}\n\n.container.energy-solution .box__body .btn-area:has(.btn-round) .btn-round.h32 span {\n  font-size: 0.938rem;\n  line-height: 21.72px;\n}\n.container.energy-solution .box__body .btn-area:has(.btn-round) .btn-select.h32.active span {\n  font-weight: 500;\n}\n.container.energy-solution .box__body .box-column > li > article > section .cont .box-guide.check {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 8px;\n  background: #0a78ff;\n  font-size: 0.875rem;\n  line-height: 1.4;\n  font-weight: 500;\n  color: #fff;\n  border-radius: 4px 4px 0 0;\n}\n.full-box-wrap .box-info-area.bg:hover,\n.full-box-wrap .box-info-area.bg:active {\n  background-color: #f7f8fa !important;\n}\n.full-box-wrap .box-info-area .wrap.txt {\n  gap: 16px;\n  flex-wrap: wrap;\n  flex-direction: row;\n  align-items: flex-start;\n}\n.full-box-wrap .box-info-area .wrap.txt.gap-8 {\n  flex-direction: column;\n}\n.full-box-wrap .box-info-area .wrap.txt > p {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.full-box-wrap .box-info-area .wrap.txt > p > span .txt-red {\n  padding-left: 4px;\n}\n@media screen and (max-width: 1585px) {\n  .full-box-wrap .box-info-area .wrap.txt {\n    flex-direction: row;\n  }\n}\n@media screen and (max-width: 1512px) {\n  .full-box-wrap .box-info-area .wrap.txt {\n    gap: 8px;\n  }\n}\n@media screen and (max-width: 1098px) {\n  .full-box-wrap .box-info-area .wrap.txt,\n  .full-box-wrap .box-info-area .wrap.txt > p {\n    flex-direction: column;\n  }\n}\n.graph-info.no-graph {\n  margin-top: 0;\n}\n.graph-info.no-graph .name.line-type:before {\n  display: none;\n}\n.graph-info.no-graph .arrow {\n  background: url(../img/icon_change_arrow_lg.svg) no-repeat center center;\n}\n.graph-info .arrow.gr {\n  background: url(../img/icon_change_arrow_lg.svg) no-repeat center center;\n}\n@media screen and (max-width: 1450px) {\n  .graph-info.no-graph > * {\n    width: auto;\n  }\n  .graph-info.no-graph {\n    flex-direction: row;\n    gap: 32px;\n    align-items: center;\n  }\n  .graph-info.no-graph .arrow {\n    margin: 0;\n    width: 32px;\n    transform: rotate(0deg);\n  }\n}\n@media screen and (max-width: 1177px) {\n  .graph-info.no-graph {\n    flex-direction: column;\n    gap: 0px;\n  }\n  .graph-info.no-graph .arrow {\n    transform: rotate(90deg);\n  }\n}\n@media screen and (max-width: 699px) {\n  .graph-info.no-graph .name {\n    justify-content: center;\n  }\n  .graph-info.no-graph .num {\n    text-align: center;\n  }\n}\n@media screen and (max-width: 1710px) {\n  .box-data-detail\n    .detail-analysispop:has(.analysis-graph-wrap + .detail-box)\n    .analysis-graph-wrap.scroll\n    .graph-cont\n    .graph-box\n    .graph-area {\n    min-width: 525px;\n  }\n}\n.box-data-detail .detail-analysispop .line-box.no .line-box.row {\n  padding: 0;\n  width: 100%;\n}\n.box-data-detail .detail-analysispop .line-box.no .line-box.row .top {\n  background: none;\n  border-radius: 0;\n  padding: 0;\n}\n.box-data-detail .detail-analysispop .line-box.no .line-box.row .top .tit .txt-info {\n  margin-left: 4px;\n}\n.box-data-detail .detail-analysispop .line-box.no .line-box.row .box-list.column {\n  flex-direction: column !important;\n}\n.box-data-detail .detail-analysispop .line-box.no .line-box.row .left .box-list.column > li {\n  min-height: 36px;\n}\n.box-data-detail .detail-analysispop .line-box.no .line-box.row .left .box-list.column > li.change {\n  background: #e6f0ff;\n}\n.box-data-detail .detail-analysispop .line-box.no .line-box.row .left .box-list.column > li.change .data .num {\n  color: #0a78ff;\n}\n.box-data-detail .detail-analysispop .line-box.no .line-box.row:has(.box-list.column) {\n  gap: 8px;\n}\n@media screen and (max-width: 1719px) {\n  .box-data-detail .detail-analysispop .line-box.no .line-box.row:has(.box-list.column) {\n    flex-direction: column;\n    gap: 32px;\n  }\n}\n@media screen and (max-width: 1740px) {\n  .container.energy-solution .box__body .box-column > li > article > section .line-box.row .left .box-list.column > li {\n    flex-direction: row;\n    gap: 0;\n  }\n}\n@media screen and (max-width: 699px) {\n  .container.energy-solution .box__body .box-column > li > article > section .line-box.row .left .box-list.column > li {\n    flex-direction: column;\n    gap: 24px;\n  }\n}\n.container.energy-solution .box__body .box-column > li > article > section .box-list > li .data .num {\n  line-height: 1.3;\n}\n.box-data-detail .tbl-list.scrollH.h296 {\n  height: 296px !important;\n}\n@media screen and (max-width: 1160px) {\n  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(1) {\n    width: 43% !important;\n  }\n  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(2) {\n    width: 58% !important;\n  }\n  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(3),\n  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(4),\n  .line-box.row.list-gp .right .tbl-list.scrollH table th:nth-child(3),\n  .line-box.row.list-gp .right .tbl-list.scrollH table th:nth-child(4),\n  .line-box.row.list-gp .right .tbl-list.scrollH table td:nth-child(3),\n  .line-box.row.list-gp .right .tbl-list.scrollH table td:nth-child(4) {\n    display: none;\n  }\n}\n@media screen and (max-width: 940px) {\n  #wrap:not(.no-responsive) .line-box.row.list-gp .right .tbl-list.scrollH table td {\n    height: 40px;\n  }\n  #wrap:not(.no-responsive) .line-box.row.list-gp .right .tbl-list.scrollH table td,\n  #wrap:not(.no-responsive) .line-box.row.list-gp .right .tbl-list.scrollH table th {\n    font-size: 14px;\n  }\n  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(1) {\n    width: 20% !important;\n  }\n  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(2) {\n    width: 51% !important;\n  }\n  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(3),\n  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(4),\n  .line-box.row.list-gp .right .tbl-list.scrollH table th:nth-child(3),\n  .line-box.row.list-gp .right .tbl-list.scrollH table th:nth-child(4),\n  .line-box.row.list-gp .right .tbl-list.scrollH table td:nth-child(3),\n  .line-box.row.list-gp .right .tbl-list.scrollH table td:nth-child(4) {\n    display: table-cell;\n  }\n}\n@media screen and (max-width: 900px) {\n  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(1) {\n    width: 43% !important;\n  }\n  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(2) {\n    width: 57% !important;\n  }\n  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(3),\n  .line-box.row.list-gp .right .tbl-list.scrollH col:nth-child(4),\n  .line-box.row.list-gp .right .tbl-list.scrollH table th:nth-child(3),\n  .line-box.row.list-gp .right .tbl-list.scrollH table th:nth-child(4),\n  .line-box.row.list-gp .right .tbl-list.scrollH table td:nth-child(3),\n  .line-box.row.list-gp .right .tbl-list.scrollH table td:nth-child(4) {\n    display: none;\n  }\n}\n.box-info-area .select-wrap:has(.wmin-100) .tit {\n  white-space: normal;\n}\n.box-info-area .select-wrap .select.wmin-100 .selected .selected-value {\n  min-width: 100px;\n}\n.box-data-detail .detail-analysispop .detail-analysis-wrap.pt96 .line-box.no .box-info-area.hover .left {\n  flex-direction: row;\n  gap: 64px;\n}\n.box-data-detail .detail-analysispop .detail-analysis-wrap.pt96 .full-box-wrap.btn .box-info-area.brd-0,\n.box-data-detail\n  .detail-analysispop\n  .detail-analysis-wrap.pt96\n  .full-box-wrap.btn:has(.box-info-area.brd-0.active)\n  .box-info-area.bg {\n  display: none;\n}\n.box-data-detail .detail-analysispop .detail-analysis-wrap.pt96 .full-box-wrap.btn .box-info-area.brd-0.active,\n.box-data-detail .detail-analysispop .detail-analysis-wrap.pt96 .full-box-wrap.btn:not(.active) .box-info-area.bg {\n  display: flex;\n}\n@media screen and (max-width: 1645px) {\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .cont\n    .box-data-detail\n    .detail-analysispop\n    .detail-analysis-wrap.pt96\n    .full-box-wrap.btn\n    .box-info-area {\n    gap: 58px !important;\n    align-items: flex-start;\n  }\n  .box-data-detail .detail-analysispop .detail-analysis-wrap.pt96 .line-box.no .box-info-area.hover .left {\n    gap: 24px;\n  }\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .cont\n    .box-info-area\n    .select-wrap:has(.wmin-100) {\n    gap: 24px;\n  }\n}\n@media screen and (max-width: 1566px) {\n  .box-data-detail .detail-analysispop .detail-analysis-wrap.pt96 .line-box.no .box-info-area.hover .left {\n    flex-direction: column;\n  }\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .cont\n    .box-info-area\n    .select-wrap:has(.wmin-100) {\n    gap: 78px;\n  }\n}\n@media screen and (max-width: 1540px) {\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .cont\n    .box-data-detail\n    .detail-analysispop\n    .detail-analysis-wrap.pt96\n    .box-info-area:has(.left) {\n    flex-direction: unset;\n  }\n}\n@media screen and (max-width: 1327px) {\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .cont\n    .box-data-detail\n    .detail-analysispop\n    .detail-analysis-wrap.pt96\n    .full-box-wrap.btn\n    .box-info-area {\n    gap: 16px !important;\n    align-items: unset;\n  }\n  .full-box-wrap.btn .box-info-area,\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .cont\n    .box-data-detail\n    .detail-analysispop\n    .detail-analysis-wrap.pt96\n    .box-info-area:has(.left) {\n    flex-direction: column !important;\n    gap: 16px;\n    align-items: unset;\n  }\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .cont\n    .box-info-area\n    .select-wrap:has(.wmin-100) {\n    gap: 40px;\n  }\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .cont\n    .box-data-detail\n    .detail-analysispop\n    .detail-analysis-wrap.pt96\n    .box-info-area:has(.right)\n    .btn-area {\n    display: flex;\n    align-items: flex-end;\n    justify-content: flex-end;\n  }\n}\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .cont\n  .box-data-detail\n  .detail-analysispop\n  .detail-analysis-wrap.pt96\n  .box-info-area:has(.right)\n  .btn-area\n  .btn-basic {\n  height: 28px !important;\n  min-width: 80px;\n}\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .cont\n  .box-data-detail\n  .detail-analysispop\n  .detail-analysis-wrap.pt96\n  .box-info-area:has(.right)\n  .btn-area\n  .btn-basic\n  span {\n  font-size: 14px !important;\n}\n.box-data-detail .detail-analysispop .detail-analysis-wrap.pt96 .line-box.no .box-info-area.hover .left .tit {\n  font-size: 1rem;\n  line-height: 1.6;\n}\n@media screen and (max-width: 1140px) {\n  .box-data-detail .detail-analysispop .detail-analysis-wrap.pt96 .line-box.no .box-info-area.hover .left,\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .cont\n    .box-info-area\n    .select-wrap:has(.wmin-100) {\n    gap: 16px;\n  }\n}\n.box-info-area.hover.brd-0:hover {\n  border: 0 !important;\n}\n.white.tooltip-link::before {\n  top: 80%;\n  width: 75%;\n  background: #fff;\n  font-weight: 400;\n  color: #2a2c2f;\n}\n.white.tooltip-link.w140p::before {\n  width: 140%;\n  left: -20%;\n}\n.line-box.row.list-gp .right .tbl-list tr.order td {\n  background: #e6f0ff !important;\n}\n.line-box.row.list-gp .right .tbl-list tr.order td > p {\n  color: #0a78ff;\n}\n.line-box.row.list-gp .right .tbl-list:not(.row) tr:hover td,\n.line-box.row.list-gp .right .tbl-list:not(.row) tr:active td {\n  background: #fff;\n}\n.line-box.row.list-gp .right .tbl-list:not(.row) tbody tr:nth-child(even):hover td,\n.line-box.row.list-gp .right .tbl-list:not(.row) tbody tr:nth-child(even):active td {\n  background: #f7f8fa;\n}\n.analysis-graph-wrap .graph-cont .graph-box.load {\n  position: relative;\n}\n.analysis-graph-wrap .graph-cont .graph-box.load .loading {\n  position: absolute;\n  height: 100%;\n  z-index: 10;\n}\n/********* 에너지 솔루션 - 설비운전패턴 최적화 분석 *********/\n.detail-analysis-wrap.section {\n  scroll-margin-top: 16px;\n}\n@media screen and (max-width: 699px) {\n  .detail-analysis-wrap.section {\n    scroll-margin-top: 64px;\n  }\n}\n.container.energy-solution .box__body .box-column > li > article > section .top .btn-refresh {\n  width: 24px;\n  height: 24px;\n  background: url(../img/icon_refresh_gr.png) no-repeat 0 0 transparent;\n  background-size: 100%;\n}\n.box-data-detail .detail-analysispop .detail-analysis-wrap.pt96 .line-box.no .box-info-area.hover.column .left {\n  flex-direction: column;\n  gap: 8px;\n}\n.tbl-list.blod table td {\n  position: relative;\n}\n.tbl-select.blod tr.selected td {\n  font-weight: 500;\n}\n.analysis-graph-wrap .graph-cont .graph-box.line {\n  /* border: 1px solid #DDE2E9; */\n  padding: 40px 32px;\n}\n.line-box.gap-8 {\n  padding: 0;\n  width: auto;\n}\n.container.energy-solution .box__body .box-column > li > article > section .top.brd-0.bg {\n  background: 0;\n  padding: 0;\n}\n.container.energy-solution .box__body .box-column > li > article > section .cont.start > .row {\n  align-items: flex-start;\n}\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .cont.start\n  > .row\n  .left\n  .analysis-graph-wrap\n  .graph-cont {\n  gap: 16px;\n}\n.box-data-detail .tbl-list.scrollH.tb-h80 {\n  height: 400px;\n}\n.tbl-list.tb-h80 table td {\n  height: 72px;\n  padding: 4px 16px;\n}\n.tbl-list.tb-h68 table td {\n  height: 52px;\n  padding: 8px;\n}\n.tbl-list.tb-h68 table th {\n  height: 40px;\n}\n@media screen and (max-width: 940px) {\n  .container.energy-solution .box__body .box-column > li > article > section.detail-analysispop .top,\n  .detail-analysispop:has(.pt96) .top {\n    margin: 0;\n  }\n}\n.tbl-list table td .ellipsis.clamp2 {\n  width: 90%;\n  white-space: normal;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .cont\n  .box-data-detail\n  .detail-analysispop\n  .box-info-area.no-box {\n  gap: 8px;\n  background: #fff;\n  margin: 0;\n  padding: 0;\n}\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .cont:has(.box-guide, .box-data-detail)\n  .box-info-area.no-box\n  .tit {\n  font-size: 0.938rem;\n  line-height: 1.599;\n}\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .cont:has(.box-guide, .box-data-detail)\n  .box-info-area.no-box\n  .num {\n  font-size: 1.625rem;\n  line-height: 1.077;\n}\n.container.energy-solution .box__body .box-data-detail .detail-analysispop .box-info-area.no-box .unit {\n  font-size: 0.75rem;\n  line-height: 1.667;\n  letter-spacing: -0.4px;\n}\n/* .analysis-graph-wrap .graph-cont.small .graph-box {\n  padding: 16px 0;\n} */\n.analysis-graph-wrap .graph-cont.small .graph-box .graph-area.w288 {\n  min-width: auto;\n  max-width: 358.66px;\n  margin: 0 auto;\n}\n\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .cont\n  .box-data-detail\n  .detail-analysispop\n  .box-info-area:has(.btn-area.flex) {\n  align-items: flex-start;\n}\n.btn-area.flex {\n  display: flex;\n}\n@media screen and (max-width: 1585px) {\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .cont\n    .box-data-detail\n    .detail-analysispop\n    .box-info-area:has(.btn-area.flex) {\n    align-items: unset;\n  }\n}\n@media screen and (max-width: 1140px) {\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .cont\n    .box-data-detail\n    .detail-analysispop\n    .box-info-area:has(.btn-area.flex)\n    > div {\n    gap: 8px;\n  }\n}\n@media screen and (max-width: 1939px) {\n  .two-box .row {\n    flex-direction: column;\n  }\n}\n@media screen and (max-width: 1140px) {\n  .line-box .box-info-area.long > .data {\n    text-align: left;\n  }\n}\n@media screen and (max-width: 500px) {\n  .line-box .box-info-area.long > .data {\n    text-align: right;\n  }\n}\n@media screen and (max-width: 1452px) {\n  .container.energy-solution .box__body .box-column > li > article > section .detail-box.long .box-list > li.row {\n    flex-direction: column;\n    max-width: 100%;\n    gap: 24px;\n  }\n}\n.full-box-wrap .box-info-area.gap-16 {\n  gap: 16px !important;\n}\n@media screen and (max-width: 1089px) {\n  .full-box-wrap .box-info-area.gap-16 {\n    margin: 0 !important;\n    padding: 16px !important;\n    width: calc(100% - 32px) !important;\n  }\n}\n@media screen and (max-width: 1250px) {\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .cont\n    .box-data-detail\n    .detail-analysispop\n    .box-info-area.gap-16:has(.wrap.txt) {\n    margin-bottom: 32px !important;\n  }\n}\n@media screen and (max-width: 1352px) {\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .cont\n    .box-data-detail\n    .detail-analysispop\n    .detail-analysis-wrap.pt96\n    .box-info-area.column:has(.left) {\n    flex-direction: column;\n  }\n  .box-info-area.column .right:has(button) {\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n.analysis-graph-wrap .graph-cont .graph-box:has(.m-w-402) {\n  width: 100%;\n}\n.analysis-graph-wrap .graph-cont .graph-area.m-w-402 {\n  min-width: 402px;\n  max-width: 544px;\n  margin: 0 auto;\n}\n.analysis-graph-wrap .graph-cont .graph-area.m-w-402.h246 {\n  padding: 17px 0;\n}\n@media screen and (max-width: 1555px) {\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .cont:has(.box-guide, .box-data-detail)\n    > .row:has(.m-w-402) {\n    flex-direction: column;\n  }\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .cont:has(.box-guide, .box-data-detail)\n    > .row.gap-8 {\n    gap: 32px !important;\n  }\n  .analysis-graph-wrap .graph-cont .graph-area.m-w-402 {\n    min-width: 525px;\n    max-width: 544px;\n  }\n}\n@media screen and (max-width: 940px) {\n  #wrap:not(.no-responsive) .tbl-list.blod:not(.row) table td {\n    height: 40px;\n  }\n  #wrap:not(.no-responsive) .tbl-list.blod table td {\n    font-size: 14px;\n  }\n  #wrap:not(.no-responsive) .tbl-list.blod table th {\n    font-size: 14px;\n  }\n  .tbl-select.blod tr.selected td:first-child {\n    border-left: 2px solid #0a78ff !important;\n  }\n  .tbl-select.blod tr.selected td:last-child {\n    border-right: 2px solid #0a78ff !important;\n  }\n  .tbl-select.blod:not(.tbl-border) tr.selected td {\n    border-top: 2px solid #0a78ff !important;\n    border-bottom: 2px solid #0a78ff !important;\n  }\n  #wrap:not(.no-responsive) .tbl-list.tb-h80:not(.row) table td {\n    height: 70px;\n  }\n  #wrap:not(.no-responsive) .tbl-list.tb-h80 table td,\n  #wrap:not(.no-responsive) .tbl-list.tb-h68 table td,\n  #wrap:not(.no-responsive) .tbl-list.tb-h68 table th {\n    font-size: 14px;\n  }\n}\n.row.gap-8:has(.top.brd-0.bg) {\n  display: flex;\n  width: 100%;\n}\n.row.gap-8:has(.top.brd-0.bg) .flex-1 .analysis-graph-wrap .graph-cont .graph-box .graph-area {\n  min-width: auto;\n}\n.row.gap-8:has(.top.brd-0.bg) .flex-1 .analysis-graph-wrap .graph-cont .graph-box .graph-area.m-w-391 {\n  min-width: 391px;\n  max-width: 552px;\n  margin: 0 auto;\n}\n@media screen and (max-width: 1030px) {\n  .row.gap-8:has(.top.brd-0.bg) .flex-1 .analysis-graph-wrap .graph-cont .graph-box .graph-area.m-w-391 {\n    min-width: 252px;\n  }\n}\n@media screen and (max-width: 1529px) {\n  .row.gap-8:has(.top.brd-0.bg) {\n    flex-direction: column;\n    gap: 32px !important;\n  }\n  .row.gap-8:has(.left.flex-1.m-w-376) {\n    gap: 8px !important;\n  }\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .column-box.legend\n    .cont\n    .graph-cont\n    .graph-legend {\n    justify-content: center !important;\n  }\n}\n@media screen and (max-width: 1276px) {\n  .m-none-1276 {\n    display: none !important;\n  }\n}\n.popup-layer.d-sm-on {\n  display: none;\n}\n@media screen and (max-width: 940px) {\n  .popup-layer:not(.hidden).d-sm-on {\n    display: block;\n  }\n  #wrap:not(.no-responsive) .tbl-list.tbl80:not(.row) table th {\n    font-size: 16px !important;\n    background: #dde2e9;\n  }\n  #wrap:not(.no-responsive) .tbl-list.tbl80:not(.row) table td {\n    word-break: keep-all;\n    height: 71.5px !important;\n    font-size: 16px !important;\n    padding: 4px 8px;\n  }\n}\n.container.energy-solution .box__body .box-column > li > article > section .column-box.legend .cont {\n  flex-direction: column;\n}\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .column-box.legend:not(.line)\n  .cont\n  .graph-cont\n  .graph-legend {\n  gap: 15px;\n  row-gap: 6px;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.container.energy-solution .box__body .box-column > li > article > section .top:has(.tit.center) {\n  justify-content: center;\n}\n.container.energy-solution .box__body .box-column > li > article > section .column-box.line {\n  border: 1px solid #dde2e9;\n  padding: 16px 16px 32px;\n}\n.container.energy-solution .box__body .box-column > li > article > section .column-box.line .cont .row .flex-1.m-w-376 {\n  min-width: 376px;\n}\n@media screen and (max-width: 1529px) {\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .column-box.line\n    .cont\n    .row\n    .flex-1.m-w-376 {\n    min-width: auto;\n  }\n}\n.row.gap-8:has(.top.brd-0.bg) .flex-1 .analysis-graph-wrap .graph-cont .graph-box .graph-area.m-h-443 {\n  height: 100%;\n  max-height: 443px;\n  min-height: 128px;\n  padding: 12px 0;\n  min-width: 525px;\n}\n@media screen and (max-width: 940px) {\n  .container.energy-solution .box__body .box-column > li > article > section .cont.gap-32 {\n    gap: 16px !important;\n  }\n}\n.selected-process {\n  display: none;\n}\n.selected-process.active {\n  display: block;\n}\n@media screen and (max-width: 500px) {\n  .box-data-detail .detail-analysis-wrap .line-box .detail-box.long {\n    gap: 0px;\n  }\n}\n@media screen and (max-width: 940px) {\n  .btn-pop-area .pop-layer-box.info.lf-32 {\n    left: -32px;\n  }\n}\n\n/********* 에너지 솔루션 - 피크 최적화 분석 *********/\n.box-data-detail .detail-analysispop .box-info-area.long > ul {\n  display: flex;\n  gap: 64px;\n  flex-wrap: wrap;\n  row-gap: 40px;\n}\n.box-data-detail .detail-analysispop .box-info-area.long > ul > li {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.box-data-detail .detail-analysispop .box-info-area.long > ul > li .tit,\n.box-data-detail .detail-analysispop .box-info-area.long .tit {\n  font-size: 1.125rem !important;\n  color: #2a2c2f;\n  line-height: 1.334 !important;\n}\n.box-data-detail .detail-analysispop .box-info-area.long > ul > li .data .num {\n  line-height: 1.334 !important;\n}\n@media screen and (max-width: 940px) {\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .cont\n    .box-data-detail\n    .detail-analysispop\n    .box-info-area {\n    padding: 16px;\n    width: calc(100% - 32px);\n  }\n}\n.analysis-graph-wrap .graph-cont:has(.h360, .m-w-391) {\n  align-items: center;\n}\n.graph-info.no-graph.gap {\n  gap: 64px;\n}\n@media screen and (max-width: 1177px) {\n  .graph-info.no-graph.gap {\n    flex-direction: row;\n    gap: 32px;\n  }\n  .graph-info.no-graph.gap .arrow {\n    margin: 0;\n    width: 32px;\n    transform: rotate(0deg);\n  }\n}\n@media screen and (max-width: 1234px) {\n  .graph-info.no-graph.gap {\n    flex-direction: column;\n    gap: 16px;\n  }\n  .graph-info.no-graph.gap .arrow {\n    transform: rotate(90deg) !important;\n  }\n}\n.row.gap-8:has(.top.brd-0.bg) .flex-1 .analysis-graph-wrap .graph-cont .graph-box .graph-area.m-w-402 {\n  min-width: 402px;\n  max-width: 100%;\n  margin: auto;\n}\n.tbl-list.tb-h80 table:has(p.legend) th,\n.tbl-list.tb-h68 table:has(p.legend) th {\n  text-align: right;\n  padding: 4px 16px;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n.tbl-list.tb-h68 table:has(p.legend) th {\n  padding: 8px 8px;\n}\n.tbl-list.tb-h68 table:has(p.legend) th:first-child,\n.tbl-list.tb-h68 table td:first-child {\n  padding: 8px 8px 8px 16px;\n}\n.tbl-list.tb-h68 table:has(p.legend) th:last-child,\n.tbl-list.tb-h68 table td:last-child {\n  padding: 8px 16px 8px 8px;\n}\n.tbl-list.tb-h80.p-space-8 table:has(p.legend) th:first-child {\n  padding: 4px 8px 4px 16px;\n}\n.tbl-list.tb-h80.p-space-8 table:has(p.legend) th {\n  padding: 4px 8px;\n}\n.tbl-list.tb-h80 table:has(p.legend) th:first-child,\n.tbl-list.tb-h68 table:has(p.legend) th:first-child {\n  text-align: left;\n}\n.tbl-list.tb-h80 table:has(p.legend) th.left {\n  text-align: left;\n}\n.tbl-list.tb-h80 table:has(p.legend) td p,\n.tbl-list.tb-h68 table:has(p.legend) td p {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  color: #2a2c2f !important;\n}\n.tbl-list.tb-h80 table:has(p.legend) td.left p,\n.tbl-list.tb-h68 table:has(p.legend) td.left p {\n  justify-content: flex-start;\n}\n.tbl-list.tb-h80 table:has(p.legend) td:first-child p,\n.tbl-list.tb-h68 table:has(p.legend) td:first-child p {\n  justify-content: flex-start;\n  word-break: keep-all;\n  white-space: normal;\n}\n.tbl-list.tb-h80.p-space-8 table td {\n  padding: 4px 8px;\n}\n.tbl-list.tb-h80.p-space-8 table td:first-child {\n  padding: 4px 8px 4px 16px;\n}\n.tbl-list.tb-h80 table td p.legend:before,\n.tbl-list.tb-h68 table td p.legend:before {\n  display: block;\n  content: \"\";\n  min-width: 16px;\n  width: 16px;\n  height: 16px;\n  background: #ddd;\n  border-radius: 0;\n}\n.tbl-list.tb-h80 table td p.legend.red,\n.tbl-list.tb-h68 table td p.legend.red:before {\n  color: #2a2c2f !important;\n}\n.tbl-list.tb-h80 table td p.legend.navy::before,\n.tbl-list.tb-h68 table td p.legend.navy:before {\n  background: #0f5fa5 !important;\n}\n.tbl-list.tb-h80 table td p.legend.mint::before,\n.tbl-list.tb-h68 table td p.legend.mint:before {\n  background: #00dacd !important;\n}\n.tbl-list.tb-h80 table td p.legend.red::before,\n.tbl-list.tb-h68 table td p.legend.red:before {\n  background: #ff6781 !important;\n}\n.tbl-list.tb-h80 table td p.legend.lavender::before,\n.tbl-list.tb-h68 table td p.legendlavender:before {\n  background: #7d5cbe !important;\n}\n.tbl-list.tb-h80 table.wmin-1016:has(p.legend) colgroup col:first-child {\n  min-width: 176px;\n  max-width: 256px;\n}\n.tbl-list.tb-h80 table.wmin-1016:has(p.legend) colgroup col {\n  min-width: 140px;\n  max-width: 156px;\n}\n.table-wrap:has(.wmin-1016) {\n  display: block;\n}\n.table-wrap:has(.wmin-1016) .tbl__top .right .btn-basic {\n  height: 28px;\n  min-width: 80px;\n}\n@media screen and (max-width: 940px) {\n  .table-wrap:has(.wmin-1016) .tbl__top .right .btn-basic {\n    height: 28px !important;\n  }\n  .table-wrap:has(.wmin-1016) .tbl__top .right .btn-basic span {\n    font-size: 14px !important;\n  }\n}\n@media screen and (max-width: 1100px) {\n  .table-wrap:has(.wmin-1016) .tbl__top {\n    align-items: normal;\n    flex-wrap: nowrap;\n    flex-direction: column;\n    gap: 16px;\n  }\n}\n@media screen and (max-width: 1760px) {\n  .row.gap-8:has(.left, .right, .graph-legend) {\n    flex-direction: column;\n    gap: 64px !important;\n  }\n  .container.energy-solution .box__body .box-column > li > article > section .top.brd-0.bg:has(.filter-txt-wrap) {\n    flex-direction: row;\n  }\n}\n.container.energy-solution .box__body .box-column > li > article > section .top.brd-0.bg:has(.filter-txt-wrap) .left {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .top.brd-0.bg\n  .left\n  .box-search-card-bottom\n  .filter-txt-wrap\n  .filter-txt {\n  height: 32px;\n  margin: 0;\n}\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .top.brd-0.bg\n  .left\n  .box-search-card-bottom\n  .filter-txt-wrap\n  .filter-txt\n  > p {\n  font-size: 12px;\n}\n@media screen and (max-width: 1185px) {\n  .container.energy-solution .box__body .box-column > li > article > section .top.brd-0.bg:has(.filter-txt-wrap) {\n    flex-direction: column;\n    gap: 16px;\n  }\n  .container.energy-solution .box__body .box-column > li > article > section .top.brd-0.bg:has(.filter-txt-wrap) .left {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .top.brd-0.bg:has(.filter-txt-wrap)\n    .right {\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n@media screen and (max-width: 1032px) {\n  .container.energy-solution .box__body .box-column > li > article > section .top.brd-0.bg:has(.filter-txt-wrap) {\n    flex-direction: column;\n    gap: 16px;\n  }\n}\n@media screen and (max-width: 1625px) {\n  .container.energy-solution\n    .box__body\n    .box-column\n    > li\n    > article\n    > section\n    .top.brd-0.bg\n    .left\n    .box-search-card-bottom\n    .filter-txt-wrap {\n    text-align: left;\n  }\n}\n.table-wrap:has(.right > button) {\n  flex-direction: column;\n  gap: 0;\n}\n#wrap:not(.no-responsive) .tbl__top:has(.left, .right) .right > button.btn-basic {\n  height: 28px;\n}\n@media screen and (max-width: 940px) {\n  #wrap:not(.no-responsive) .top.brd-0.bg:has(.box-search-card-bottom) .right > button.btn-basic,\n  #wrap:not(.no-responsive) section:has(.target-content) .target-content .right button.btn-basic {\n    height: 32px;\n  }\n  #wrap:not(.no-responsive) .top.brd-0.bg:has(.box-search-card-bottom) .right > button.btn-basic span,\n  #wrap:not(.no-responsive) .tbl__top:has(.left, .right) .right > button.btn-basic span,\n  #wrap:not(.no-responsive) section:has(.target-content) .target-content .right button.btn-basic span {\n    font-size: 14px;\n  }\n}\n@media screen and (max-width: 1100px) {\n  #wrap:not(.no-responsive) .tbl__top:has(.left, .right > .btn-basic) {\n    gap: 16px;\n    flex-direction: column;\n    align-items: normal;\n  }\n}\n.tbl-list.tbl-border-large:has(.wmin-532) tr > .focus {\n  font-weight: 500;\n  font-size: 14px;\n}\n.tbl-list.tbl-border-large:has(.wmin-532) tbody th.focus {\n  background: #e6f0ff !important;\n  border-top: 2px solid #0a78ff !important;\n  border-left: 2px solid #0a78ff !important;\n  border-bottom: 2px solid #0a78ff !important;\n}\n.tbl-list.tbl-border-large:has(.wmin-532) tbody td.focus {\n  background: #f8fbff !important;\n  border-top: 2px solid #0a78ff !important;\n  border-right: 2px solid #0a78ff !important;\n  border-bottom: 2px solid #0a78ff !important;\n}\n.container.energy-solution .box__body .pop-layer-box.info .pop-body .list-item p:before {\n  display: none;\n}\n.tbl-list.tbl-border-large:has(.bg-light-blue) thead tr:first-child > th:first-child,\n.tbl-list.tbl-border-large:has(.bg-light-blue) tbody tr:first-child > th:first-child {\n  background: #dde2e9;\n}\n.tbl-list.tbl-border-large:has(.bg-light-blue) tr:nth-child(n + 3):nth-child(-n + 11) th {\n  background: #f7f8fa;\n}\n.tbl-list.tbl-border-large thead th.bg-light-blue {\n  background: #e6f0ff !important;\n  border-top: 2px solid #0a78ff !important;\n  border-right: 2px solid #0a78ff !important;\n  border-left: 2px solid #0a78ff !important;\n}\n.tbl-list.tbl-border-large thead th.bg-light-blue-left,\n.tbl-list.tbl-border-large thead th.bg-light-blue-right {\n  background: #e6f0ff !important;\n}\n.tbl-list.tbl-border-large thead th.bg-light-blue-left,\n.tbl-list.tbl-border-large td.bg-light-blue-left {\n  border-left: 2px solid #0a78ff !important;\n}\n.tbl-list.tbl-border-large thead th.bg-light-blue-right,\n.tbl-list.tbl-border-large td.bg-light-blue-right {\n  border-right: 2px solid #0a78ff !important;\n}\n.tbl-list.tbl-border-large tbody tr:last-child td[class^=\"bg-light-blue-\"] {\n  border-bottom: 2px solid #0a78ff !important;\n}\n.container.energy-solution .box__body .nodata .nodata__txt.noicon {\n  width: calc(100% - 24px);\n  background: #f7f8fa;\n  margin: 0;\n  height: 80px;\n  font-size: 0.85rem;\n  color: #2a2c2f;\n  padding: 10px 12px;\n}\n.nodata .nodata__txt.noicon::before {\n  display: none;\n}\n/* progress 관련 [s] */\n.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area {\n  flex-direction: column;\n  align-items: normal;\n  gap: 8px;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area .btn-pop-area {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.container.energy-solution\n  .box__body\n  .area__right:has(.box-column > li.on)\n  .box-search-card:hover\n  > .bottom\n  > ul\n  .progress-area\n  .btn-pop-area\n  .btn-txt {\n  display: block;\n}\n.container.energy-solution\n  .box__body\n  > .area__right:has(.box-column > li.on)\n  .box-search-card-wrap\n  .bottom\n  > ul\n  .progress-area\n  .btn-pop-area\n  .btn-txt {\n  display: none;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area .btn-pop-area .btn-txt.disabled {\n  background: inherit !important;\n}\n.container.energy-solution\n  .box__body\n  .box-search-card\n  > .bottom\n  > ul\n  > .progress-area\n  .btn-pop-area\n  .btn-txt.disabled\n  > span {\n  color: #dde2e9 !important;\n}\n.btn-txt.btn-pop.disabled:hover + .pop-layer-box.info.w296.error {\n  display: flex;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area .btn-pop-area .btn-txt > span {\n  font-size: 0.75rem;\n  line-height: 1.667;\n}\n.container.energy-solution\n  .box__body\n  .box-search-card\n  > .bottom\n  > ul\n  > .progress-area\n  .btn-pop-area\n  .btn-txt:hover\n  span {\n  font-weight: normal;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area > label {\n  display: flex;\n  gap: 16px;\n  flex-direction: column;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area > label .right {\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area .progressbar-wrap {\n  width: 100%;\n  position: relative;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area .num-wrap {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area .num-wrap > span {\n  color: #909fb7;\n  font-size: 10px;\n  line-height: 15px;\n}\n.container.energy-solution\n  .box__body\n  > .area__right:has(.box-column > li.on)\n  .box-search-card-wrap\n  .bottom\n  > ul\n  .progress-area\n  .num-wrap {\n  display: none;\n}\n.container.energy-solution\n  .box__body\n  > .area__right:has(.box-column > li.on)\n  .box-search-card-wrap:hover\n  .bottom\n  > ul\n  .progress-area\n  .num-wrap {\n  display: flex;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area .progressbar-wrap .progressbar {\n  width: 100%;\n  background: linear-gradient(90deg, #f55547 0%, #ffbc0a 50.38%, #1fc95c 100%);\n  box-shadow: 1px 1px 4px 0px rgba(122, 133, 150, 0.5) inset;\n  height: 8px;\n  border-radius: 2px;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  gap: 13px;\n}\n.container.energy-solution\n  .box__body\n  .box-search-card\n  > .bottom\n  > ul\n  > .progress-area\n  .progressbar-wrap\n  .progressbar\n  .tick-marks {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.container.energy-solution\n  .box__body\n  .box-search-card\n  > .bottom\n  > ul\n  > .progress-area\n  .progressbar-wrap\n  .progressbar\n  .tick-marks\n  .tick {\n  width: 1px;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.5);\n  position: absolute;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area .progressbar-wrap .range {\n  width: inherit;\n  position: absolute;\n  bottom: -4px;\n  left: 0px;\n  border: none;\n  background: none;\n  appearance: none;\n  z-index: 1;\n  transition: 0.2s all;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area:has(input:disabled) .num-wrap {\n  display: none;\n}\n.container.energy-solution\n  .box__body\n  .box-search-card\n  > .bottom\n  > ul\n  > .progress-area\n  .progressbar-wrap\n  .range::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  height: 16px;\n  width: 16px;\n  border-radius: 50%;\n  cursor: pointer;\n  margin-top: -4px;\n  z-index: 1;\n  position: relative;\n  background: rgba(255, 255, 255, 1);\n  border: 0.5px solid rgba(255, 255, 255, 1);\n  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.4);\n  transition: 0.2s all;\n}\n.container.energy-solution\n  .box__body\n  .box-search-card\n  > .bottom\n  > ul\n  > .progress-area\n  .progressbar-wrap\n  .range::-webkit-slider-thumb:hover {\n  background: #0050b8;\n}\n.container.energy-solution\n  .box__body\n  .box-search-card\n  > .bottom\n  > ul\n  > .progress-area\n  .progressbar-wrap\n  .range::-webkit-slider-thumb:active {\n  background: #003876;\n}\n.container.energy-solution\n  .box__body\n  .box-search-card\n  > .bottom\n  > ul\n  > .progress-area\n  .progressbar-wrap:has(:disabled)\n  .range::-webkit-slider-thumb {\n  background: #909fb7;\n}\n.container.energy-solution\n  .box__body\n  .box-search-card\n  > .bottom\n  > ul\n  > .progress-area\n  .progressbar-wrap:has(.gray)\n  .range::-webkit-slider-thumb {\n  background: #909fb7;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > .progress-area:has(.gray) .num-wrap {\n  display: none;\n}\n.container.energy-solution\n  .box__body\n  .box-search-card:hover\n  > .bottom\n  > ul\n  > .progress-area\n  .progressbar-wrap\n  .range::-webkit-slider-thumb {\n  background: #0a78ff !important;\n}\n.container.energy-solution\n  .box__body\n  > .area__right:has(.box-column > li.on)\n  .box-search-card\n  > .bottom\n  > ul\n  > .progress-area\n  .progressbar-wrap\n  .range::-webkit-slider-thumb {\n  background: #909fb7;\n}\n/* progress 관련 [e] */\n.btn-pop-area .pop-layer-box.info.input {\n  top: 74px;\n  border: 1px solid #0a78ff;\n}\n.btn-pop-area .pop-layer-box.input.error {\n  border: 1px solid #f55547;\n}\n.btn-pop-area .pop-layer-box.info.input input[type=\"text\"],\n.btn-pop-area .pop-layer-box.info.input input[type=\"text\"]:focus {\n  border: 0;\n}\n.btn-pop-area .pop-layer-box.info.input input[type=\"text\"] {\n  padding-right: 0;\n  width: calc(100% - 24px);\n}\n.container.energy-solution .box__body .pop-layer-box.info.input .pop-body {\n  padding: 16px 16px 24px;\n}\n.btn-pop-area .pop-layer-box.info.input .pop-body:has(.dot-list) li {\n  padding-left: 7.25px;\n  font-size: 0.625rem;\n  line-height: 1.6;\n  color: #2a2c2f;\n  position: relative;\n}\n.btn-pop-area .pop-layer-box.input.error .pop-body:has(.dot-list) li.error-txt {\n  color: #f55547;\n}\n.btn-pop-area .pop-layer-box.info.input .pop-body .dot-list li::before {\n  content: \"\";\n  position: absolute;\n  top: 7.25px;\n  left: 0;\n  display: block;\n  width: 2.5px;\n  height: 2.5px;\n  border-radius: 100%;\n  background: #2a2c2f;\n}\n.btn-pop-area .pop-layer-box.input.error .pop-body:has(.dot-list) li.error-txt::before {\n  background: #f55547;\n}\n.btn-pop-area .pop-layer-box.info.input .pop-bottom {\n  padding: 0 16px 16px;\n  border-top: 0;\n}\n.btn-pop-area .pop-layer-box.info.input .pop-bottom .btn-basic {\n  height: 28px;\n}\n.btn-pop-area .pop-layer-box.info.input .pop-bottom .btn-basic + .btn-basic {\n  margin-left: 0.5rem;\n}\n.btn-pop-area .pop-layer-box.info.input .pop-bottom .btn-wrap {\n  display: flex;\n  justify-content: flex-end;\n}\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section:has(.target-content)\n  .target-content\n  .top\n  .tit {\n  font-size: 1.125rem;\n  font-weight: 400;\n  line-height: 1.6;\n}\n.tbl-list table td button.btn.move {\n  width: 24px !important;\n  height: 24px !important;\n  background: url(../img/icon_page_go_gr_large.svg) no-repeat center;\n}\n.tbl-select tr.selected td button.btn.move,\n.tbl-list table tr td button.btn.move:hover {\n  background: url(../img/icon_move.svg) no-repeat center center !important;\n  background-size: 24px !important;\n  filter: none;\n}\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section:has(.target-content)\n  .target-content\n  > .right {\n  margin-top: 16px;\n  display: flex;\n  justify-content: flex-end;\n}\n.box-data-detail.show\n  .detail-analysispop:not(.detail-analysis-wrap.pt96.mt-16 > .box-guide.check.m-mb-16)\n  .detail-analysis-wrap.pt96:first-child {\n  margin-top: 16px !important;\n}\n@media screen and (max-width: 940px) {\n  .box-data-detail .tbl-list.scrollH.h230:has(.wmin-636) {\n    height: 282px !important;\n  }\n}\n\n/************************************************** RE100 컨설팅 ****************************************************/\n.btn-pop-area .pop-layer-box.info.w296 {\n  left: calc(100% - 0px);\n  top: calc(100% - 138px);\n}\n@media screen and (max-width: 699px) {\n  .btn-pop-area .pop-layer-box.info.w296 {\n    left: calc(100% - 327px);\n  }\n}\n.container.energy-solution .box__body .pop-layer-box.info.input.w296.error .pop-body {\n  padding: 8px;\n}\n.container.energy-solution .box__body .pop-layer-box.info.input.w296.error .txt {\n  letter-spacing: -0.01em;\n  color: #f55547;\n  font-size: 12px;\n  text-align: left;\n  font-weight: 400;\n  line-height: 1.334;\n}\n.btn-pop-area .pop-layer-box.info.w296.error {\n  top: calc(100% - 38px);\n}\n.container.energy-solution .box__body .pop-layer-box.info.input .pop-body .type__cont {\n  flex-wrap: nowrap;\n  align-items: center;\n}\n.container.energy-solution .box__body .pop-layer-box.info.input .pop-body .type__cont li {\n  height: 38px;\n  min-width: 64px;\n  border-radius: 30px;\n  margin-bottom: 0;\n}\n.container.energy-solution .box__body .pop-layer-box.info.input .pop-body > ul > li:has(.input__area.wmax-120) {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.container.energy-solution .box__body .pop-layer-box.info.input .pop-body > ul > li .input__area.wmax-120 > input {\n  border: 1px solid #909fb7;\n  border-radius: 4px;\n  padding-right: 40px;\n  width: calc(100% - 52px);\n}\n.container.energy-solution .box__body .pop-layer-box.info.input .pop-body .tit {\n  line-height: 1.5;\n}\n.type__cont li.active {\n  background: #0a78ff;\n  border-color: #0a78ff;\n  color: #fff;\n}\n.type__cont li.active a {\n  font-weight: 500;\n  color: #fff;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > ul > li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n.container.energy-solution\n  .box__body\n  .box-search-card\n  > .bottom\n  > .filelist:has(.filter-txt-wrap)\n  li\n  .filter-txt-wrap\n  .filter-no {\n  font-size: 12px;\n  color: #909fb7;\n  line-height: 32px;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > .filelist:has(.filter-txt-wrap) {\n  margin-left: 0;\n}\n.container.energy-solution .box__body .box-search-card > .bottom > .filelist:has(.filter-txt-wrap) .progress-area {\n  margin-bottom: 0;\n  display: block;\n}\n.container.energy-solution\n  .box__body\n  .box-search-card\n  > .bottom\n  > .filelist:has(.filter-txt-wrap)\n  li\n  .filter-txt-wrap\n  .filter-txt {\n  height: 32px;\n  background: #fff;\n  margin-bottom: 8px;\n}\n.container.energy-solution\n  .box__body\n  .box-search-card\n  > .bottom\n  > .filelist:has(.filter-txt-wrap)\n  li\n  .filter-txt-wrap\n  .filter-txt\n  > p {\n  font-size: 12px;\n}\n.container.energy-solution\n  .box__body\n  .box-search-card\n  > .bottom\n  > .filelist:has(.filter-txt-wrap)\n  li\n  .filter-txt-wrap\n  .filter-txt\n  .btn-delete {\n  width: 20px;\n  height: 20px;\n  background: url(../img/icon_delete_x_lg.png) no-repeat center center;\n  background-size: 100%;\n  margin-left: 0;\n}\n.container.energy-solution\n  .box__body\n  > .area__right:has(.box-column > li.on)\n  .box-search-card-wrap\n  .bottom\n  .filelist\n  .progress-area\n  .btn-pop-area\n  .btn-txt {\n  display: block;\n}\n@media screen and (max-width: 1625px) {\n  .container.energy-solution\n    .box__body\n    .box-search-card\n    > .bottom\n    > .filelist:has(.filter-txt-wrap)\n    li\n    .filter-txt-wrap {\n    text-align: left;\n  }\n}\n.left-fixed-area {\n  display: flex;\n  gap: 32px;\n}\n.left-fixed-area .body-left.line-box {\n  background: inherit;\n  padding: 0;\n  max-width: 400px;\n  min-width: 354px;\n  width: auto;\n  margin-top: 136px;\n}\n.left-fixed-area .body-left.line-box .analysis-graph-wrap .graph-cont {\n  align-items: center;\n  width: 290px;\n  margin: 0 auto;\n}\n.left-fixed-area .body-right {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  width: calc(100% - 432px);\n}\n.left-fixed-area .body-right .detail-box.info .box-list > li {\n  padding: 32px 32px 30px !important;\n  min-height: auto !important;\n}\n.left-fixed-area .body-right .detail-box.info .box-list > li:last-child .data {\n  align-items: end;\n}\n.left-fixed-area .body-right .right-top {\n  padding: 0;\n  border-bottom: 0;\n  height: 28px;\n  margin-bottom: 16px;\n}\n.left-fixed-area .body-right .line-box.no.w100p .table-wrap .flex-right .txt-info.mo {\n  display: none;\n}\n.left-fixed-area .body-right .right-top .tab__toggle {\n  gap: 4px;\n}\n.left-fixed-area .body-right .right-top .tab__toggle li a {\n  padding: 0 16px;\n}\n@media screen and (max-width: 1692px) {\n  .container.energy-solution .box__body .box-column > li > article > section .detail-box .box-list {\n    flex-direction: column;\n  }\n  .left-fixed-area .body-right .detail-box.info .box-list > li:last-child .data {\n    align-items: start;\n  }\n}\n@media screen and (max-width: 1384px) {\n  .left-fixed-area {\n    flex-direction: column;\n  }\n  .left-fixed-area .body-right {\n    width: 100%;\n  }\n  .left-fixed-area .line-box .body-left.line-box {\n    width: 100%;\n  }\n  .left-fixed-area .body-left.line-box .analysis-graph-wrap .graph-cont {\n    flex-direction: row;\n    gap: 42px;\n    width: 100%;\n    justify-content: center;\n  }\n  .box-data-detail .detail-analysispop:has(.left-fixed-area) .line-box {\n    padding: 48px 0 32px;\n    max-width: 100%;\n    min-width: auto;\n    margin-top: 0;\n  }\n}\n@media screen and (max-width: 1254px) {\n  .left-fixed-area .body-left.line-box .analysis-graph-wrap .graph-cont {\n    flex-direction: column;\n    gap: 32px;\n  }\n  .left-fixed-area .body-left.line-box .analysis-graph-wrap .graph-cont .graph-legend {\n    flex-direction: column;\n    align-items: start;\n  }\n}\n@media screen and (max-width: 940px) {\n  .left-fixed-area .body-right {\n    border-top: 0;\n    padding-top: 0;\n  }\n  .left-fixed-area .body-right .detail-box.info .box-list > li {\n    padding: 16px 32px !important;\n  }\n  .left-fixed-area .body-left.line-box .analysis-graph-wrap .graph-cont {\n    flex-direction: row;\n    gap: 42px;\n  }\n}\n@media screen and (max-width: 938px) {\n  .left-fixed-area .body-left.line-box .analysis-graph-wrap .graph-cont {\n    flex-direction: column;\n    gap: 32px;\n  }\n}\n@media screen and (max-width: 699px) {\n  .left-fixed-area .body-right .line-box.no.w100p .table-wrap .flex-right .txt-info.pc {\n    display: none;\n  }\n  .left-fixed-area .body-right .line-box.no.w100p .table-wrap .flex-right .txt-info.mo {\n    display: block;\n  }\n  .left-fixed-area .body-right:has(.box-info-area.no-box .tit.line-h28-8 + .tit.line-h28-8) .detail-box.info {\n    margin-top: 32px;\n  }\n}\n.container.energy-solution\n  .box__body\n  .box-column\n  > li\n  > article\n  > section\n  .cont:has(.box-guide, .box-data-detail)\n  .box-info-area.no-box\n  .tit.line-h28-8 {\n  font-size: 1.125rem;\n}\n.switch-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.form-toggle > input.coral-pink[type=\"checkbox\"]:checked + label:before {\n  background: #ff6781;\n}\n.form-toggle > input.coral-pink[type=\"checkbox\"]:checked + label:after {\n  background: #ffe7ea;\n}\n.form-toggle > input.purple[type=\"checkbox\"]:checked + label:before {\n  background: #7d5cbe;\n}\n.form-toggle > input.purple[type=\"checkbox\"]:checked + label:after {\n  background: #e9deff;\n}\n.graph-cont .graph-legend:has(.form-toggle) {\n  justify-content: flex-start;\n  gap: 40px;\n}\n.graph-cont .graph-legend:has(.form-toggle) p {\n  align-items: flex-start;\n}\n.graph-cont .graph-legend:has(.form-toggle) p:before {\n  margin-top: 4px;\n}\n.analysis-graph-wrap .graph-cont .graph-box:has(.w240.wmin-240.h240) {\n  overflow: unset;\n}\n.form__input.wmin-86 li {\n  align-items: center;\n  gap: 34px;\n}\n.popup-type1 .popup__body .form__input.wmin-86 .tit {\n  min-width: 86px;\n  max-width: 86px;\n  line-height: 1.141;\n  color: #2a2c2f;\n}\n.form__input.wmin-54 {\n  display: flex;\n  align-items: center;\n}\n.form__input.wmin-54 li {\n  align-items: center;\n  gap: 16px;\n  margin-top: 0;\n}\n.popup-type1 .popup__body .form__input.wmin-54 .tit {\n  min-width: 54px;\n  max-width: 82px;\n  line-height: 1.429;\n  color: #2a2c2f;\n  margin-top: 0;\n}\n.popup-type1 .popup__body .form__input.wmin-54 > li .input__area {\n  width: auto;\n}\n.popup__body:has(.wmin-54, .wmin-86) p.txt-info {\n  font-size: 12px;\n  margin-left: 0;\n  margin-top: 4px;\n  letter-spacing: -0.2px;\n}\n@media screen and (max-width: 940px) {\n  .popup-type1 .popup__body .form__input.wmin-54 {\n    flex-direction: row;\n  }\n}\n@media screen and (max-width: 500px) {\n  .form__input.wmin-54 li:not(.form__input .filelist li) {\n    margin-top: 0;\n  }\n}\n@media screen and (max-width: 940px) {\n  .form__input.wmin-54 li {\n    align-items: flex-start;\n    gap: 8px;\n  }\n}\n@media screen and (max-width: 940px) {\n  .form__input.wmin-86 li {\n    flex-direction: row;\n  }\n}\n@media screen and (max-width: 500px) {\n  .form__input.wmin-86 li:not(.form__input .filelist li) {\n    flex-direction: row;\n    align-items: center;\n  }\n}\n@media screen and (max-width: 940px) {\n  .tbl-select:not(.tbl-border) tr:has(.btn.move).selected td:first-child {\n    border-left: 2px solid #0a78ff !important;\n  }\n  .tbl-select:not(.tbl-border) tr:has(.btn.move).selected td {\n    border-top: 2px solid #0a78ff !important;\n    border-bottom: 2px solid #0a78ff !important;\n  }\n  .tbl-select:not(.tbl-border) tr:has(.btn.move).selected td:last-child {\n    border-right: 2px solid #0a78ff !important;\n  }\n}\n.graph-info > div .graph-cont .graph-help {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n.graph-info > div .graph-cont .graph-help .txt,\n.graph-info > div .graph-cont .graph-help > p {\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 20px;\n  color: #2a2c2f;\n}\n.graph-info > div .graph-cont .graph-help > p {\n  color: #909fb7;\n}\n.graph-info > div .graph-cont .graph-help .num .unit {\n  font-weight: 400 !important;\n  font-size: 12px !important;\n  line-height: 20px !important;\n}\n.graph-cont:not(.analysis-graph-wrap) .graph-box:has(.w200.h200) {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.graph-info:has(.graph-help) {\n  align-items: flex-start;\n  gap: 64px;\n}\n@media screen and (max-width: 1277px) {\n  .graph-info.no-graph.gap:has(.graph-help) {\n    flex-direction: column;\n    align-items: center;\n  }\n  .graph-info > div .graph-cont .graph-help {\n    gap: 4px;\n    flex-direction: column;\n  }\n  .graph-info.no-graph.gap:has(.graph-help) .arrow {\n    transform: rotate(90deg) !important;\n    margin-top: 0 !important;\n    width: 100%;\n  }\n}\n@media screen and (max-width: 940px) {\n  .graph-info.no-graph.gap:has(.graph-help) {\n    gap: 24px;\n  }\n}\n@media screen and (max-width: 699px) {\n  .graph-info.no-graph.gap:has(.graph-help) {\n    gap: 16px;\n  }\n}\n@media screen and (max-width: 1100px) {\n  .graph-info.no-graph.gap:has(.graph-help) > * {\n    width: auto;\n  }\n}\n@media screen and (max-width: 699px) {\n  .graph-info.no-graph.gap:has(.graph-help) .name {\n    justify-content: flex-start;\n  }\n}\n.detail-analysis-wrap.pt96.load {\n  position: relative;\n}\n.detail-analysis-wrap.pt96.load .loading {\n  height: 100%;\n  position: absolute;\n}\n.graph-info .name:has(.txt-midlightgray) {\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0;\n}\n/************************************************** 05.management_에너지솔루션 관리_전기차 충전기설치분석 ****************************************************/\n.tbl-list.menulist.tbl-select.scrollX.dark table.wmin-2922 tbody tr td input[type=\"checkbox\"] + label {\n  padding-left: 0;\n}\n.tbl-list.menulist.tbl-select.scrollX.dark table.wmin-2922 tbody tr td input[type=\"checkbox\"] + label:before,\n.tbl-list.menulist.tbl-select.scrollX.dark table.wmin-2922 tbody tr td input[type=\"checkbox\"]:checked + label:after {\n  right: 0;\n  left: auto;\n}\n.tbl-list.menulist.tbl-select.scrollX.dark table.wmin-2922 tbody tr.selected td {\n  font-weight: 500;\n}\n\n/************************************************** 02.점검결과_report_에너지레포트_리스트 ****************************************************/\n.tbl__top > .search ul.form__input li > span.wmin-64.d-sm-block {\n  display: none;\n}\n@media screen and (max-width: 1843px) {\n  .tbl__top > .search ul.form__input:has(.wmin-64) {\n    gap: 16px;\n  }\n  .tbl__top > .search ul.form__input li > span.wmin-64.d-sm-block {\n    display: block;\n  }\n}\n@media screen and (max-width: 1343px) {\n  .tbl__top:has(.wmin-64.d-sm-block) {\n    margin-bottom: 34px;\n  }\n}\n@media screen and (max-width: 940px) {\n  .tbl__top > .search ul.form__input:has(.wmin-64) {\n    gap: 32px;\n  }\n  .tbl__top:has(.wmin-64.d-sm-block) + .tbl__top {\n    margin-top: 0;\n  }\n  .tbl__top:has(.wmin-64.d-sm-block) {\n    margin-bottom: 0;\n  }\n  .searchterm .term__month .selected.w87 {\n    width: calc(100% - 0.6rem) !important;\n  }\n}\n@media screen and (max-width: 539px) {\n  .tbl__top > .search ul.form__input .input__area:has(.btn-basic.bg-sky) > a {\n    width: 100%;\n  }\n}\n@media screen and (max-width: 500px) {\n  .form__input:has(.btn-basic.bg-sky) li:not(.form__input .filelist li) {\n    margin-top: 0;\n  }\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist .title-line.bg-white.brd-bottom-0 {\n  border-top: 2px solid #dde2e9;\n  margin-top: 32px !important;\n}\n#wrap:not(.float-page, .no-responsive)\n  .treebar.box.menutype\n  .manuarea\n  .manulist\n  .title-line.bg-white.brd-bottom-0:first-child {\n  border-top: none;\n  margin-top: 0 !important;\n}\n#wrap:not(.float-page, .no-responsive)\n  .treebar.box.menutype\n  .manuarea\n  .manulist\n  .title-line.bg-white.brd-bottom-0.arrow {\n  padding: 0;\n}\n#wrap:not(.float-page, .no-responsive)\n  .treebar.box.menutype\n  .manuarea\n  .manulist:has(.title-line.bg-white.brd-bottom-0)\n  li.on\n  a\n  p {\n  font-weight: 500;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li:has(.premium) {\n  position: relative;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li:has(.premium) a::before {\n  content: \"\";\n  width: 34px;\n  height: 34px;\n  top: 0;\n  left: 0;\n  position: absolute;\n  background: url(\"../img/icon_premium_badge.svg\") no-repeat center;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li:has(.premium.disabled) {\n  pointer-events: none;\n}\n#wrap:not(.float-page, .no-responsive)\n  .treebar.box.menutype\n  .manuarea\n  .manulist\n  li.brd-bottom-0\n  > a\n  > p.premium.disabled {\n  background: inherit;\n  border-color: inherit;\n  color: #dde2e9;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n#wrap:not(.float-page, .no-responsive)\n  .treebar.box.menutype\n  .manuarea\n  .manulist\n  li.brd-bottom-0\n  > a\n  > p.premium.disabled\n  > span {\n  color: #dc7700;\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 1.5;\n}\n@media screen and (max-width: 940px) {\n  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea .manulist li:has(.premium) a::before {\n    background: none;\n  }\n  #wrap:not(.float-page, .no-responsive)\n    .treebar.box.menutype\n    .manuarea\n    .manulist\n    li.brd-bottom-0\n    > a\n    > p.premium::after {\n    background: url(\"../img/icon_premium.svg\") no-repeat center;\n    content: \"\";\n    width: 20px;\n    height: 20px;\n    display: inline-block;\n    vertical-align: top;\n    margin-left: 8px;\n  }\n}\n.popup-type3 .popup__body .check-area .check-list section > input[type=\"checkbox\"] + label > span.premium::after {\n  background: url(\"../img/icon_premium.svg\") no-repeat center;\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  vertical-align: top;\n  margin-left: 4px;\n}\n.badge {\n  width: max-content;\n  padding: 3px 12px;\n  border-radius: 5px;\n  background-color: #f4aa0c1a;\n  color: #f4aa0c;\n  font-size: 15px;\n  font-weight: 700;\n  letter-spacing: -0.12px;\n  white-space: nowrap;\n  line-height: 16px;\n  display: inline-block;\n  margin-right: 8px;\n}\n.badge.type2 {\n  width: 25px;\n  padding: 3px 5px;\n  border-radius: 100px;\n  background-color: #dde2e9;\n  color: #7a8596;\n  font-size: 10px;\n  font-weight: 500;\n  letter-spacing: -0.4px;\n  white-space: nowrap;\n  line-height: 12px;\n  margin-right: 16px;\n  text-align: center;\n}\n.badge.type2.gray {\n  background-color: #909fb7;\n  color: #fff;\n}\n@media screen and (max-width: 499px) {\n  .tbl-list table th.w3p,\n  .tbl-list table th.w4p.txt-center {\n    width: 4% !important;\n  }\n  .tbl-list table th.w6p {\n    width: 6% !important;\n  }\n  .tbl-list table th.d-sm-w60 {\n    width: 60px !important;\n  }\n  .tbl-list table th.d-sm-w76 {\n    width: 76px !important;\n  }\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea li:not(.title-line.bg-white.brd-bottom-0) a {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea li.arrow a {\n  flex: 1;\n  padding-left: 0;\n}\n#wrap:not(.float-page, .no-responsive)\n  .treebar.box.menutype\n  .manuarea\n  li:not(.title-line.bg-white.brd-bottom-0)\n  a::after,\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea li.arrow a::after {\n  content: \"\";\n  display: block;\n  width: 16px;\n  height: 16px;\n  background: url(\"../img/icon_arrow_right_g@3x.png\") no-repeat center center;\n  background-size: 100%;\n}\n#wrap:not(.float-page, .no-responsive)\n  .treebar.box.menutype\n  .manuarea\n  li:not(.title-line.bg-white.brd-bottom-0).on\n  a::after,\n#wrap:not(.float-page, .no-responsive)\n  .treebar.box.menutype\n  .manuarea\n  li:hover:not(.title-line.bg-white.brd-bottom-0)\n  a::after,\n#wrap:not(.float-page, .no-responsive)\n  .treebar.box.menutype\n  .manuarea\n  li:active:not(.title-line.bg-white.brd-bottom-0)\n  a::after,\n#wrap:not(.float-page, .no-responsive)\n  .treebar.box.menutype\n  .manuarea\n  li:not(.title-line.bg-white.brd-bottom-0).on\n  a::after,\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea li.arrow:hover a::after,\n#wrap:not(.float-page, .no-responsive) .treebar.box.menutype .manuarea li.arrow.on a::after {\n  background: url(\"../img/icon_arrow_right_blue.svg\") no-repeat center center;\n}\n/* 클래스 report 추가 */\n#wrap:has(.report) .box__header.brd-bottom-0.gap-16 {\n  justify-content: normal;\n}\n#wrap:has(.report) .tbl__top .left .search {\n  width: 100%;\n}\n#wrap:has(.report) .tbl__top .btn__wrap {\n  gap: 12px;\n}\n@media screen and (max-width: 1086px) {\n  #wrap:has(.report) .tbl__top .btn__wrap .searcharea.m-none.end {\n    justify-content: flex-end;\n    width: 100%;\n  }\n}\n@media screen and (max-width: 940px) {\n  #wrap:has(.report) .tbl__top.gap-20 {\n    gap: 32px !important;\n  }\n  #wrap:has(.report) .tbl__top.gap-20 .btn__wrap {\n    gap: 8px !important;\n  }\n}\n#wrap:has(.report) .centerline {\n  margin: 0 4px;\n}\n#wrap:has(.report) .box.treebar {\n  width: 304px;\n  overflow-x: hidden;\n  box-shadow: none;\n  border-right: 4px solid #dde2e9;\n  border-radius: 0;\n  min-height: calc(100vh - 66px);\n  height: auto;\n}\n#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1:has(li.active > .lnb-depth2) {\n  background: #f7f8fa;\n}\n#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1 > li {\n  position: relative;\n}\n#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1 > li.active {\n  margin: 4px;\n  width: calc(100% - 8px);\n  border-bottom: 0;\n  border-top: 0;\n}\n#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1 > li.active::after {\n  content: \"\";\n  width: calc(100% + 16px);\n  height: 1px;\n  background: #dde2e9;\n  position: absolute;\n  left: -8px;\n  bottom: -8px;\n}\n#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1 > li.active::before:first-child {\n  border-top: 0;\n}\n#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1 > li > p {\n  font-size: 15px;\n  line-height: 24px;\n  font-weight: 400;\n  background: #fff;\n  padding: 24px 24px 24px 32px;\n  width: calc(100% - 56px);\n}\n#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1 > li:not(.active):hover > p {\n  font-weight: 500;\n  color: #0978ff;\n  background: #e6f0ff;\n}\n#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1 > li:hover > p a::after {\n  background: url(\"../img/icon_arrow_blue.svg\") 0 center no-repeat;\n}\n#wrap:has(.report) .box.treebar.pushy-menutype.navy .lnb .lnb-depth1 > li.active > p {\n  background: #123069;\n  border-radius: 8px;\n  padding: 16px 16px 16px 24px;\n  width: calc(100% - 40px);\n}\n#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1 > li > p a::after {\n  width: 20px;\n  height: 20px;\n  top: 50%;\n  transform: translateY(-50%) rotate(-90deg);\n}\n#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1 > li:has(.lnb-depth2):hover > p a::after {\n  transform: translateY(-50%);\n}\n#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1 > li:has(.lnb-depth2).active > p {\n  font-size: 15px;\n  line-height: 24px;\n  font-weight: 400;\n  background: #f1f3f7;\n  padding: 24px 24px 24px 32px;\n  border-radius: 0;\n  margin: -8px -8px 0 -8px;\n  color: #2a2c2f;\n  border-bottom: 1px solid #dde2e9;\n}\n#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth2 > li > a {\n  border-top: 0;\n  padding: 16px 16px 16px 32px;\n  width: calc(100% - 48px);\n  background: #f7f8fa;\n  line-height: 24px;\n  font-size: 15px;\n}\n#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth2 > li.active > a {\n  background: #003875;\n  border-radius: 8px;\n}\n#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth2 > li:not(.active):hover a {\n  background: #e6f0ff;\n  color: #0978ff;\n}\n#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth2 > li > a::after {\n  display: none;\n}\n#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth2 > li.active > a::after,\n#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth2 > li:hover > a::after {\n  display: block;\n  transform: rotate(-90deg);\n  width: 20px;\n  height: 20px;\n}\n#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth2 > li:not(.active):hover > a::after {\n  background: url(\"../img/icon_arrow_blue.svg\") 0 center no-repeat;\n}\n#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth2 > li:last-child {\n  padding-bottom: 52px;\n}\n#wrap:has(.report)\n  .box.treebar.pushy-menutype.report.m-none\n  .lnb\n  .lnb-depth1\n  > li:has(.lnb-depth2).active\n  > p\n  a::after {\n  filter: grayscale(1) brightness(0.1);\n  transform: translateY(-50%);\n}\n#wrap:has(.report) .box.treebar.pushy-menutype.report.m-none .lnb .lnb-depth1 > li:has(.lnb-depth2).active p span {\n  color: #2a2c2f;\n  font-weight: 400;\n}\n#wrap:has(.report) .box.treebar.menutype.m-block {\n  display: none !important;\n}\n#wrap:has(.report) .box.treebar.menutype.m-block.active {\n  display: block !important;\n}\n@media screen and (min-width: 941px) {\n  #wrap:has(.report) .box.treebar.menutype.m-block.active {\n    display: none !important;\n  }\n}\n#wrap:has(.report) .box.treebar.menutype.m-block .manuarea .manulist li {\n  height: 60px;\n  border: 0;\n}\n#wrap:has(.report) .box.treebar.menutype.m-block .manuarea .manulist .title-line.bg-white.brd-bottom-0 {\n  margin-top: 0 !important;\n  border-top: 1px solid #dde2e9;\n}\n#wrap:has(.report) .box.treebar.menutype.m-block .manuarea li:not(.title-line.bg-white.brd-bottom-0) a::after,\n#wrap:has(.report) .box.treebar.menutype.m-block .manuarea li.arrow a::after {\n  width: 24px;\n  height: 24px;\n  background-size: 24px;\n}\n#wrap:has(.report.new) .tbl-select tr.selected td {\n  border-top: 0;\n  border-bottom: 0;\n  height: 40px;\n}\n#wrap:has(.report.new) .tbl-select tr.selected td:first-child {\n  border-left: 0;\n}\n#wrap:has(.report.new) .tbl-select tr.selected td:last-child {\n  border-right: 0;\n}\n#wrap:has(.report.new) .tbl-list table tr:has(input[type=\"checkbox\"]:checked) td {\n  background: #b4d2ff;\n}\n#wrap:has(.report) .searchterm .term__month > span {\n  margin-left: 8px;\n}\n@media screen and (max-width: 940px) {\n  #wrap:has(.report) .box__body:has(button.btn-basic.bg-sky.w100p) {\n    padding-top: 32px !important;\n  }\n  #wrap:has(.report) .centerline {\n    margin: 0 14px;\n  }\n  #wrap:not(.report) .tbl__top.gap-12 {\n    gap: 32px !important;\n  }\n  #wrap:has(.report) .form__input li {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    gap: 10px !important;\n  }\n  #wrap:has(.report) .searchterm .term__month {\n    height: 40px;\n  }\n  #wrap:has(.report) .searchterm .term__month + .term__date {\n    height: 40px;\n  }\n  #wrap:has(.report) .form__input .searchterm .term__date input[type=\"text\"] {\n    height: 100%;\n  }\n  #wrap:has(.report) .searchterm button.btn-basic.bg-gray.ml-8 {\n    margin-left: 0px !important;\n    margin-top: 8px;\n    width: 100%;\n  }\n  #wrap:has(.report) .tbl-list:not(.row) table td {\n    height: 52px;\n  }\n}\n/************************************************** beyondX enable 모니터링  ****************************************************/\n.monitor.type2 .content *,\n.popup-layer.type2 * {\n  font-family: \"Pretendard\";\n}\n.d-xsm-block {\n  display: none !important;\n}\n.icon-move.white::before {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_move_white.svg\") no-repeat center center;\n  background-size: 100%;\n}\n.icon-move::before {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_move.svg\") no-repeat center center;\n  background-size: 100%;\n}\n.btn-basic.bg-none {\n  background: transparent;\n  border: 0;\n}\n\n.container.monitor.type2 .content .box .box__header .select ul {\n  max-height: 436px;\n  border-radius: 4px;\n  box-shadow: 0px 8px 20px 0px #7a859680;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li:has(.btn-pop-area) {\n  color: #145973;\n  font-weight: 400;\n  justify-content: space-between;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li:has(.btn-pop-area):hover {\n  font-weight: 600;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab__line\n  li:has(.btn-pop-area):hover\n  .btn-pop-area\n  .icon-arrow {\n  display: flex;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li .btn-pop-area .icon-arrow {\n  background: url(\"../img/BeyondXEnable_linear_gradient_arrow.svg\") no-repeat center center;\n  width: 25px;\n  margin-top: 0;\n  display: none;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab__line\n  li:has(.btn-pop-area):hover\n  .btn-pop-area\n  .pop-layer-box {\n  display: flex;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li .btn-pop-area .pop-layer-box {\n  border-radius: 4px;\n  left: -167px;\n  width: 292px;\n  top: 25px;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab__line\n  li\n  .btn-pop-area\n  .pop-layer-box\n  .pop-body\n  p {\n  font-size: 12px;\n  font-weight: 400;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .tab-cont-wrap {\n  gap: 64px;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .tbl-list.row > table {\n  border-top: 1px solid #dde2e9;\n}\n.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li {\n  min-height: 112px;\n  padding: 16px;\n}\n.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li span strong {\n  font-size: 26px;\n  font-weight: 500;\n  line-height: 36px;\n}\n.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li span {\n  line-height: 32px;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .tbl-list.row table th {\n  padding: 12px 20px 12px 24px;\n  height: 23px;\n  font-size: 15px;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .tbl-list.row table th + td {\n  padding: 12px 24px 12px 0;\n  height: 23px;\n  font-weight: 500;\n  font-size: 15px !important;\n}\n\n/* sort 있는 table */\n.monitor.type2 .box__body .box-column > li > article .cont .tbl-list:has(th.sort) {\n  border-bottom: 1px solid #dde2e9;\n  border-top: 0;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .tbl-list table thead th.sort {\n  padding: 8px 16px;\n  height: 0;\n  font-size: 15px;\n  background: #f1f3f7;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .tbl-list table thead th.sort span:after {\n  margin-left: 12px;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .tbl-list table:has(th.sort) td {\n  padding: 12px 16px;\n  height: auto !important;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .tbl-list table td > p.ellipsis {\n  font-size: 15px;\n  line-height: 24px;\n  width: 100%;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .tbl-select tr.selected td {\n  border-top: 1px solid #0a78ff !important;\n  border-bottom: 1px solid #0a78ff !important;\n  font-weight: 400;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .tbl-select tr.selected td:first-child {\n  border-left: 1px solid #0a78ff !important;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .tbl-select tr.selected td:last-child {\n  border-right: 1px solid #0a78ff !important;\n}\n\n.monitor.type2 .box__body .box-column > li > article.h-auto {\n  height: auto !important;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top {\n  padding: 16px 16px 0 16px;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top .tab__line {\n  border-bottom: 0;\n  width: auto;\n  gap: 32px;\n  margin-top: auto;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top .tab__line li:has(img) {\n  gap: 8px;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top .tab__line > li {\n  padding: 0px 8px 15px 8px;\n  font-size: 18px;\n  font-weight: 400;\n  color: #646c74;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top .tab__line li.on {\n  font-weight: 600;\n  color: #0a1941;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top .tab__line h2 > img {\n  width: 147.86px;\n  height: 20px;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li {\n  font-size: 15px;\n  height: 68px;\n  padding: 0 32px;\n  width: calc(100% - 64px);\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li:last-child {\n  border-bottom: 0;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li.on {\n  font-weight: 600;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .bg-box:has(.btn-basic.bg-none) {\n  background: url(\"../img/BeyondXEnable_bg_box.svg\") no-repeat center center;\n  background-size: cover;\n  background-position: right;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .bg-box:has(.btn-basic.bg-none)\n  .txt-info {\n  color: #fff;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .bottom.top {\n  flex-wrap: wrap;\n  gap: 20px;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .bottom.top > .right {\n  margin-left: auto;\n}\n\n/* bg-box */\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .bg-box {\n  background: #f7f8fa;\n  padding: 24px 32px;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .top.justify-right {\n  margin-bottom: 0;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .top h3 {\n  font-size: 20px;\n  font-weight: 600;\n}\n.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap li .tit.d-sm-block {\n  display: none;\n}\n.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap li .tit.font-18 {\n  font-size: 18px;\n  color: #2a2c2f;\n}\n.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap li .tit.font-18::before {\n  display: none;\n}\n.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap .count-info.type2 {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap .count-info.type2 span {\n  font-size: 16px;\n}\n.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap .count-info.type2 span.icon {\n  display: flex;\n  align-items: center;\n}\n.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap .count-info.type2 span.icon::before {\n  content: \"\";\n  width: 32px;\n  height: 32px;\n  margin-right: 8px;\n  background: url(\"../img/icon_price_blue.svg\") no-repeat 0 0 transparent;\n  background-size: 100%;\n}\n.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap .count-info.type2 span:has(.btn-pop) {\n  display: flex;\n  align-items: center;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  ul.box-small-wrap\n  .count-info.type2\n  .btn-pop-area\n  .pop-layer-box.info {\n  border-radius: 4px;\n  border: 0;\n  text-align: left;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  ul.box-small-wrap\n  .count-info.type2\n  .btn-pop-area\n  .pop-layer-box.info\n  .pop-body {\n  padding: 10px 24px;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  .tab-cont-wrap\n  .cont\n  ul.box-small-wrap\n  li\n  .count-info\n  span\n  strong {\n  font-size: 30px;\n  margin-right: 8px;\n}\n.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap .score-info.type2 {\n  background: rgba(31, 201, 92, 0.1);\n  border-radius: 10px;\n  padding: 4px 16px 4px 6px;\n  width: fit-content;\n}\n.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap li .score-info.type2 span.info {\n  color: #1fc95c;\n  font-weight: 600;\n  font-size: 26px;\n}\n.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap li .score-info.type2 span.info:before {\n  width: 40px;\n  height: 40px;\n  margin-right: 8px;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap {\n  gap: 48px 32px;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap.center {\n  margin: 0 auto;\n  gap: 64px;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap.center li {\n  padding: 0;\n  justify-content: flex-start;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  .tab-cont-wrap\n  .cont\n  ul.box-small-wrap.center\n  li\n  .count-info\n  span\n  strong {\n  font-weight: 400;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  .tab-cont-wrap\n  .cont\n  ul.box-small-wrap.center\n  li\n  .count-info {\n  gap: 5px;\n}\n.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap li span.txt {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #f55547;\n}\n.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap li span.txt.down {\n  color: #0a78ff;\n}\n@media screen and (max-width: 1240px) {\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .bg-box {\n    padding: 24px;\n  }\n}\n@media screen and (max-width: 1490px) {\n  .monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap.center {\n    gap: 32px;\n  }\n}\n@media screen and (max-width: 699px) {\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap\n    .item\n    .graph-info\n    .info\n    .percent {\n    justify-content: center !important;\n  }\n}\n@media screen and (max-width: 500px) {\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article\n    .cont\n    .tab-cont-wrap\n    .cont\n    ul.box-small-wrap.center\n    li\n    .count-info {\n    gap: 0;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article\n    .cont\n    .tab-content.type2\n    .tab-cont-wrap\n    .cont:has(.graph-legend.mb-32.m-mb-0)\n    ul.box-small-wrap {\n    margin-top: 20px;\n  }\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .bg-box {\n    padding: 16px 24px;\n  }\n}\n\n/* 부적합 */\n.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap .score-info.type2:has(.info.caution) {\n  background: #ffe7e4;\n}\n.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap li .score-info.type2 span.info.caution {\n  color: #f55547;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  ul.box-small-wrap\n  li\n  .score-info.type2\n  span.info.caution:before {\n  background: url(\"../img/icon_info_check_r.svg\") no-repeat 0 0 transparent;\n  background-size: 100%;\n}\n.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap .count-info.type2 > .score-info.type2 {\n  background: #ffe7e4;\n  border-radius: 10px;\n  padding: 4px 8px;\n  width: auto;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  ul.box-small-wrap\n  .count-info.type2\n  > .score-info.type2\n  .info::before {\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_price_red.svg\") no-repeat 0 0 transparent;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  ul.box-small-wrap\n  .count-info.type2\n  > .score-info.type2\n  .info {\n  color: #f55547;\n  line-height: 20px;\n  font-weight: 600;\n  font-size: 14px;\n}\ni.icon-arrow-down {\n  width: 20px !important;\n  height: 20px !important;\n}\n.icon-arrow-down:before {\n  content: \"\";\n  display: block;\n  width: 20px;\n  height: 20px;\n}\n.icon-arrow-down.red:before {\n  background: url(\"../img/icon_arrow_down_red.svg\") no-repeat center center;\n}\n\n/* level */\n.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap:has(.img-area) li {\n  justify-content: flex-start;\n}\n.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap li .img-area {\n  height: auto;\n  gap: 40px;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  ul.box-small-wrap\n  li:has(.score-info.type2 > .info.level)\n  .img-area\n  > img {\n  height: 98px;\n  width: auto;\n  object-fit: contain;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  ul.box-small-wrap\n  li:has(.score-info.type2 > .info.level)\n  .txt {\n  text-align: right;\n  padding-right: 59px;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 24px;\n  margin-top: -8px;\n}\n.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap .score-info.type2:has(.info.level) {\n  background: #e6f0ff;\n  padding: 4px 14px 4px 6px;\n  height: fit-content;\n}\n.monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap li .score-info.type2 span.info.level {\n  color: #0a78ff;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  ul.box-small-wrap\n  li\n  .score-info.type2\n  span.info.level:before {\n  background: url(\"../img/icon_price_blue.svg\") no-repeat 0 0 transparent;\n  background-size: 100%;\n}\n.monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap li button.btn-basic.h40 {\n  width: fit-content;\n  padding: 0 16px;\n  gap: 23px;\n  margin-top: -4px;\n}\n.monitor\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  .tab-cont-wrap\n  .cont\n  ul.box-small-wrap\n  li\n  button.btn-basic.h40\n  > span {\n  color: #fff;\n}\n@media screen and (max-width: 500px) {\n  .monitor .box__body .box-column > li > article .cont .tab-cont-wrap .cont ul.box-small-wrap li button.btn-basic.h40 {\n    gap: 15px;\n    padding: 0 16px !important;\n    width: auto;\n    max-width: 286px;\n  }\n  .monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap li .img-area {\n    gap: 20px;\n  }\n}\n\n/* 감액 클래스 notice */\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  ul.box-small-wrap\n  .count-info.type2\n  > .score-info.notice.type2\n  .info::before {\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_price_gray_blue.svg\") no-repeat 0 0 transparent;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  ul.box-small-wrap\n  .count-info.type2\n  > .score-info.notice.type2 {\n  background: #ebedf4;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  ul.box-small-wrap\n  .count-info.type2\n  > .score-info.notice.type2\n  .info {\n  color: #2e4890;\n}\n.icon-arrow-down.gr-blue:before {\n  background: url(\"../img/icon_arrow_down_gr_blue.svg\") no-repeat center center;\n}\n\n/* info-area */\n.monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap .cont .box-info-area {\n  padding: 32px;\n  gap: 16px;\n  background: #f7f8fa;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap .cont .box-info-area:has(.left) {\n  flex-direction: row;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  .tab-cont-wrap\n  .cont\n  .box-info-area\n  + .box-small-wrap.pt-0.pb-0 {\n  padding: 16px;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap .cont .box-info-area .right:has(button) {\n  margin-left: auto;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap .cont .box-info-area .left .select-wrap .tit {\n  font-size: 16px;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap .cont .box-info-area .txt-info {\n  line-height: 18px;\n  text-align: left;\n}\n@media screen and (max-width: 940px) {\n  .monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap .cont .box-info-area {\n    margin: 0;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article\n    .cont\n    .tab-cont-wrap\n    .cont\n    .box-info-area\n    + .box-small-wrap.pt-0.pb-0 {\n    padding: 0;\n    gap: 64px;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .box-small-wrap.pt-0.pb-0\n    + .cont-border-box.m-mt-16\n    .scrollX\n    .graph-box {\n    padding: 20px 0 0;\n  }\n}\n@media screen and (max-width: 500px) {\n  .monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap .cont .box-info-area {\n    padding: 16px;\n  }\n}\n\n/* content */\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .tab-cont-wrap\n  .cont\n  + .cont {\n  margin-top: 48px;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .tbl-tit,\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .sm-tit {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 20px;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .item-wrap {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .item-wrap > div {\n  flex: 1;\n  width: 100%;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .cont-border-box\n  .scrollX\n  .graph-box {\n  padding: 32px;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .cont-border-box\n  .scrollX\n  .graph-box:has(.graph-legend) {\n  padding: 32px 32px 0 32px;\n  gap: 34px;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .cont-border-box\n  .scrollX\n  .graph-box\n  .graph-area {\n  min-width: 421px;\n}\n\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .item-wrap .box-wrap.long {\n  flex-direction: column;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .box-wrap.long\n  ul.box-small-wrap {\n  flex-direction: column;\n  gap: 8px;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .box-wrap.long\n  ul.box-small-wrap\n  li {\n  min-height: 56px;\n  min-width: 310px;\n  flex-direction: row;\n  align-items: flex-start;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .box-wrap.long\n  ul.box-small-wrap\n  li\n  .tit {\n  color: #2a2c2f;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .box-wrap.long\n  ul.box-small-wrap\n  li\n  .tit::before {\n  margin-top: 0;\n  background: #0a78ff;\n  vertical-align: text-top;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .box-wrap.long\n  ul.box-small-wrap\n  li\n  span\n  strong {\n  font-size: 26px;\n  margin-right: 4px;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .box-wrap.long\n  ul.box-small-wrap\n  li\n  .count-info:has(span.percent) {\n  display: flex;\n  flex-direction: column;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .box-wrap.long\n  ul.box-small-wrap\n  li\n  .count-info\n  span.percent {\n  line-height: 20px;\n  font-size: 14px;\n  font-weight: 400;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .box-wrap.long\n  ul.box-small-wrap\n  li\n  .count-info\n  span.percent.down,\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .box-wrap.long\n  ul.box-small-wrap\n  li\n  .count-info\n  span.percent\n  > span.unit {\n  color: #0a78ff;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .box-wrap.long\n  ul.box-small-wrap\n  li\n  .count-info\n  span.percent\n  > span.unit {\n  line-height: 20px;\n  margin-left: 2px;\n  font-weight: 400;\n  font-size: 12px;\n}\n\n/* item-wrap > item */\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .item-wrap:has(.item) {\n  align-items: flex-start;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .item-wrap .item {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .item-wrap .item .img-item {\n  position: relative;\n  padding: 32px 50px;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .item\n  .graph-info {\n  gap: 24px;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .item\n  .graph-info:has(.info > .percent)\n  > div {\n  margin-bottom: auto;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .item\n  .graph-info\n  .num {\n  line-height: 24px;\n  color: #051c3f;\n  font-size: 30px;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .item\n  .graph-info\n  .num\n  > .unit {\n  color: #909fb7;\n  margin-left: 4px;\n  font-size: 16px;\n  line-height: 32px;\n  font-weight: 400;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .item\n  .graph-info\n  .info\n  .percent {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 2px;\n  font-size: 14px;\n  font-weight: 400;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .item\n  .graph-info\n  .info\n  .percent.down {\n  color: #0a78ff;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .item\n  .graph-info\n  .info\n  .percent.down.icon:after {\n  content: \"\";\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_arrow_down_blue.svg\") no-repeat center center;\n  background-size: 100%;\n  vertical-align: bottom;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .item\n  .graph-info\n  .info\n  .percent\n  .unit {\n  font-size: 12px;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .item\n  ul.box-small-wrap {\n  gap: 64px;\n  justify-content: center;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .item\n  .img-item\n  .label {\n  position: absolute;\n  top: 14.54%;\n  right: 50px;\n  gap: 8px;\n  padding: 8px 16px;\n  background: #2a2c2f;\n  border-radius: 4px;\n  display: flex;\n  box-shadow: 0px 4px 12px rgba(122, 133, 150, 0.5);\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .item\n  .img-item\n  .label.peak {\n  top: 23.27%;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .item\n  .img-item\n  .label\n  > span {\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.43;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .item-wrap\n  .item\n  .img-item\n  .label\n  > span.num {\n  min-width: 52px;\n  text-align: right;\n}\n@media screen and (max-width: 1649px) {\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap.gap-40:has(.item) {\n    flex-direction: column;\n    gap: 32px !important;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap.gap-40\n    .cont-border-box\n    .scrollX\n    .graph-box.pt-0.pb-0 {\n    padding: 22px;\n  }\n}\n@media screen and (max-width: 1560px) {\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .item-wrap.d-w-1560 {\n    flex-direction: column;\n    gap: 64px;\n  }\n}\n@media screen and (max-width: 1177px) {\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap\n    .item\n    .graph-info {\n    gap: 8px;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap\n    .item\n    ul.box-small-wrap {\n    gap: 32px;\n    flex-wrap: nowrap;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap\n    .item\n    .img-item {\n    padding: 32px 24px;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap\n    .item\n    .img-item\n    .label {\n    right: 24px;\n  }\n}\n@media screen and (max-width: 1110px) {\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap\n    .item\n    .img-item\n    .label {\n    display: none;\n  }\n}\n@media screen and (max-width: 940px) {\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .item-wrap.d-w-1560 {\n    padding: 0 !important;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap.gap-40:has(.item) {\n    gap: 20px !important;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap.gap-40\n    .cont-border-box\n    .scrollX\n    .graph-box.pt-0.pb-0 {\n    padding: 0;\n  }\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .item-wrap .item {\n    gap: 20px;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap\n    .item\n    ul.box-small-wrap {\n    flex-wrap: wrap;\n  }\n}\n@media screen and (max-width: 699px) {\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap\n    .item\n    .graph-info.no-graph\n    .name {\n    justify-content: flex-start;\n  }\n}\n@media screen and (max-width: 499px) {\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .item-wrap.d-w-1560 {\n    gap: 40px;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap\n    .item\n    ul.box-small-wrap {\n    justify-content: flex-start;\n    gap: 40px;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap\n    .item\n    .img-item {\n    padding: 20px;\n  }\n}\n/* 스카다 없을때 반응형 */\n@media screen and (max-width: 1770px) {\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .row.gap-40:has(.img-area.h-auto) {\n    flex-direction: row;\n    gap: 40px !important;\n  }\n}\n@media screen and (max-width: 1649px) {\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap.gap-40:has(.img-area.h-auto) {\n    flex-direction: row;\n    gap: 40px !important;\n  }\n}\n@media screen and (max-width: 1241px) {\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .cont-border-box\n    .graph-cont.p-32.pb-0:has(.img-area) {\n    padding: 32px 0 0 32px !important;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .cont-border-box\n    .graph-cont.p-32.pb-0:has(.img-area)\n    .img-area {\n    height: 304px !important;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .cont-border-box\n    .graph-cont.p-32.pb-0:has(.img-area)\n    .img-area\n    > img {\n    min-width: fit-content;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap.gap-40:has(.img-area.h-auto) {\n    flex-direction: column;\n    gap: 32px !important;\n  }\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .row.gap-40:has(.img-area.h-auto) {\n    flex-direction: column;\n    gap: 48px !important;\n  }\n}\n@media screen and (max-width: 940px) {\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .cont-border-box\n    .graph-cont.p-32.pb-0:has(.img-area) {\n    padding: 20px 0 0 0 !important;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap.gap-40:has(.img-area.h-auto) {\n    gap: 20px !important;\n  }\n}\n\n/* column-box */\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .tab-cont-wrap\n  .selected-process {\n  display: none;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .tab-cont-wrap\n  .selected-process.active {\n  display: flex;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .column-box.line {\n  border: 1px solid #dde2e9;\n  padding: 16px 16px 0;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .column-box .top {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 20px;\n  margin-bottom: 16px;\n}\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .column-box .top.center {\n  justify-content: center;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .column-box\n  .graph-cont\n  .graph-legend {\n  justify-content: flex-start;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .graph-cont\n  .graph-legend\n  p {\n  font-weight: 400;\n}\n@media screen and (min-width: 1920px) {\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .column-box\n    .flex-1.m-w-600 {\n    min-width: 616px;\n  }\n}\n@media screen and (max-width: 1770px) {\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .row.gap-40 {\n    gap: 16px !important;\n  }\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .column-box .top.center {\n    justify-content: flex-start;\n  }\n}\n@media screen and (max-width: 1590px) {\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .column-box\n    .graph-cont\n    .graph-legend {\n    justify-content: center;\n  }\n}\n@media screen and (max-width: 1133px) {\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .column-box.line {\n    padding: 16px 0 16px 16px;\n  }\n}\n@media screen and (max-width: 940px) {\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .column-box.line {\n    padding: 0;\n    padding-top: 12px;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .column-box\n    .top.center\n    > div {\n    width: 100%;\n    text-align: center;\n  }\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab .column-box .cont.gap-32,\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab .column-box .cont .row.gap-40 {\n    gap: 20px !important;\n  }\n}\n@media screen and (max-width: 499px) {\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .graph-cont\n    .graph-legend.m-mt-0 {\n    margin-top: 0 !important;\n  }\n  .monitor .box__body .box-column > li > article.boxtype-tab > .cont .row.gap-16 {\n    gap: 8px !important;\n  }\n}\n\n.monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .cont-border-box {\n  border: none;\n  padding: 0;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .cont-border-box\n  .graph-cont {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .cont-border-box\n  .scrollX\n  .graph-box {\n  padding: 32px 32px 0 32px;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article.boxtype-tab\n  > .cont\n  .tab-content.type2\n  .cont-border-box\n  .graph-cont\n  .graph-legend\n  p {\n  font-weight: 400;\n}\n.tbl-list.type6.tbl-border table th {\n  background: #f1f3f7;\n  border: 1px solid #dde2e9 !important;\n}\n.tbl-list.type6.tbl-border table tbody th {\n  background: #f7f8fa;\n}\n.tbl-list.type6.tbl-border table:has(tbody > tr > th) tr:first-child th:first-child {\n  border-bottom: 0 !important;\n}\n.tbl-list.type6.tbl-border td {\n  border: 1px solid #dde2e9 !important;\n  border-top: 0 !important;\n  font-size: 15px;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list.type6 table th {\n  padding: 10px 12px;\n  line-height: 20px;\n  font-size: 15px;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box:not(.scrollX) .tbl-list.type6 table th {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list.type6 table td {\n  padding: 8px 16px;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list.type6.small table tbody th,\n.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list.type6.small table td {\n  padding: 10px 12px;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list.type6.w-min-149 table td {\n  min-width: 149px;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list.type6.w-min-600 table {\n  min-width: 600px;\n}\n\n/* item-box (ul) */\n.monitor.type2 .box__body .box-column > li > article .cont .tab-content.type2 ul.item-box {\n  display: flex;\n  gap: 16px;\n  width: 100%;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .tab-content.type2 ul.item-box > li {\n  background: #f7f8fa;\n  padding: 32px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: center;\n  text-align: center;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .tab-content.type2 ul.item-box > li > p {\n  font-size: 15px;\n  line-height: 20px;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .tab-content.type2 ul.item-box > li > .tit {\n  font-weight: 700;\n}\n\n/* banner-area */\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  .tab-content.type2\n  .tab-cont-wrap\n  > div\n  > .cont\n  .banner-area {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-end;\n  height: 142px;\n  overflow: hidden;\n  width: auto;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  .tab-content.type2\n  .tab-cont-wrap\n  > div\n  > .cont\n  .banner-area::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: url(\"../img/BeyondXEnable_monitoring_bg_banner.svg\") no-repeat center center;\n  background-size: cover;\n  background-position: 100% 0;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  .tab-content.type2\n  .tab-cont-wrap\n  > div\n  > .cont\n  .banner-area\n  > .item {\n  padding: 43px 32px;\n  z-index: 1;\n  width: calc(100% - 64px);\n  height: 100%;\n  display: flex;\n  gap: 16px;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  .tab-content.type2\n  .tab-cont-wrap\n  > div\n  > .cont\n  .banner-area\n  > .item\n  .txt-area {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  .tab-content.type2\n  .tab-cont-wrap\n  > div\n  > .cont\n  .banner-area\n  > .item\n  .txt-area\n  > p {\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 32px;\n  white-space: nowrap;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  .tab-content.type2\n  .tab-cont-wrap\n  > div\n  > .cont\n  .banner-area\n  > .item\n  .txt-area\n  .txt-sm {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 16px;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  .tab-content.type2\n  .tab-cont-wrap\n  > div\n  > .cont\n  .banner-area\n  > .item\n  .txt-area\n  > p\n  > span {\n  color: #5221cb;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  .tab-content.type2\n  .tab-cont-wrap\n  > div\n  > .cont\n  .banner-area\n  > .item\n  .btn-basic.black {\n  background: #2a2c2f;\n  border-color: #2a2c2f;\n  margin-top: auto;\n}\n@media screen and (max-width: 1320px) {\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article\n    .cont\n    .tab-content.type2\n    .tab-cont-wrap\n    > div\n    > .cont\n    .banner-area\n    > .item {\n    flex-direction: column;\n    padding: 24px;\n    width: calc(100% - 48px);\n    gap: 0;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article\n    .cont\n    .tab-content.type2\n    .tab-cont-wrap\n    > div\n    > .cont\n    .banner-area\n    > .item\n    .txt-area {\n    gap: 4px;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article\n    .cont\n    .tab-content.type2\n    .tab-cont-wrap\n    > div\n    > .cont\n    .banner-area\n    > .item\n    .txt-area\n    > p {\n    font-size: 16px;\n    line-height: 22px;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article\n    .cont\n    .tab-content.type2\n    .tab-cont-wrap\n    > div\n    > .cont\n    .banner-area\n    > .item\n    .btn-basic.black {\n    width: fit-content;\n  }\n}\n@media screen and (max-width: 965px) {\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article\n    .cont\n    .tab-content.type2\n    .tab-cont-wrap\n    > div\n    > .cont\n    .banner-area\n    > .item {\n    padding: 24px 16px;\n    width: calc(100% - 32px);\n  }\n}\n\n/* linear 버튼 */\n.btn-basic.linear {\n  border: 1.5px solid transparent;\n  border-radius: 4px;\n  background:\n    linear-gradient(#0a1e5a, #0a1e5a) padding-box,\n    linear-gradient(90deg, #61c9e1, #83c8c2, #92c8b4) border-box;\n}\n.btn-basic.linear:hover,\n.btn-basic.linear:active {\n  background:\n    linear-gradient(#3c899c, #3c899c) padding-box,\n    linear-gradient(90deg, #61c9e1, #83c8c2, #92c8b4) border-box;\n}\n\n/* banner-area */\n.monitor.type2 .box__body .box-column > li > article.h-auto:has(.banner-area) {\n  position: relative;\n  overflow: hidden;\n  padding: 40px 40px 34px 60px;\n  background: url(\"../img/BeyondXEnable_monitoring_bg_banner_top.svg\") no-repeat 0 0;\n  width: auto;\n  background-size: cover;\n}\n.monitor.type2 .box__body .box-column > li > article > .banner-area {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 60px;\n}\n.monitor.type2 .box__body .box-column > li > article > .banner-area > .item {\n  display: flex;\n  flex-direction: column;\n  gap: 38px;\n}\n.monitor.type2 .box__body .box-column > li > article > .banner-area > .item > button {\n  width: fit-content;\n}\n.monitor.type2 .box__body .box-column > li > article > .banner-area > .item > .txt-area {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px 80px;\n}\n.monitor.type2 .box__body .box-column > li > article > .banner-area > .item > .txt-area > div {\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 22px;\n}\n.monitor.type2 .box__body .box-column > li > article > .banner-area > .item > .txt-area > .left {\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 29px;\n}\n.monitor.type2 .box__body .box-column > li > article > .banner-area > .item > .txt-area > .left > p {\n  margin-top: 8px;\n}\n.monitor.type2 .box__body .box-column > li > article > .banner-area > .item > .txt-area > .left > p > img {\n  width: 219px;\n  height: 29px;\n  object-fit: cover;\n  margin-right: 6px;\n}\n@media screen and (max-width: 940px) {\n  .monitor.type2 .box__body .box-column > li > article.h-auto:has(.banner-area) {\n    padding: 40px;\n  }\n}\n@media screen and (max-width: 521px) {\n  .monitor.type2 .box__body .box-column > li > article.h-auto:has(.banner-area) {\n    padding: 20px 20px 32px 20px;\n  }\n  .monitor.type2 .box__body .box-column > li > article > .banner-area > .item > .txt-area {\n    gap: 10px;\n  }\n  .monitor.type2 .box__body .box-column > li > article > .banner-area > .item {\n    gap: 0;\n    justify-content: space-between;\n    height: 224px;\n  }\n  .monitor.type2 .box__body .box-column > li > article > .banner-area > .item > .txt-area > .left {\n    font-size: 16px;\n  }\n  .monitor.type2 .box__body .box-column > li > article > .banner-area > .item > .txt-area > .left > p > img {\n    width: 146px;\n    height: 20px;\n  }\n}\n\n/* 팝업 */\n.popup-layer.type2 .popup__body .tbl-list table {\n  border-top: 1px solid #dde2e9;\n  border-left: 1px solid #dde2e9;\n  border-right: 1px solid #dde2e9;\n}\n.popup-layer.type2 .popup__body .tbl-list table th {\n  padding: 10px 8px;\n}\n.popup-layer.type2 .popup__body .tbl-list table thead th {\n  background: #dfe3ea;\n  border-top: 1px solid #dde2e9;\n}\n.popup-layer.type2 .popup__body .tbl-list table thead th + th {\n  border-left: 1px solid #dde2e9;\n}\n.popup-layer.type2 .popup__body .tbl-list table td {\n  height: 27.5px;\n  border-top: 1px solid #dde2e9;\n}\n.popup-layer.type2 .popup__body .tbl-list table td + td {\n  border-left: 1px solid #dde2e9;\n}\n.popup-layer.type2 .popup__body .tbl-list table td > span {\n  line-height: 20px;\n}\n.popup-layer.type2 .popup__body .tbl-list table td .unit {\n  margin-left: 6px;\n  color: #95a1c6;\n}\n.popup-layer.type2 .popup__body .tbl-list tbody th {\n  border-right: 1px solid #dde2e9;\n  border-top: 1px solid #dde2e9;\n}\n.popup-layer.type2 .popup__body .tbl-list .d-xsm-block {\n  display: none !important;\n}\n\n/* 팝업 내 양옆 border 없는 테이블 */\n.popup-layer.type2 .popup__body .tbl-list.brd-none table {\n  border-left: 0;\n  border-right: 0;\n}\n.popup-layer.type2 .popup__body .tbl-list.brd-none table thead th {\n  background: #edf0f6;\n  border-top: 1px solid #d5d8e5;\n}\n.popup-layer.type2 .popup__body .tbl-list.brd-none table tbody th {\n  background: #f9faff;\n  border-right: 1px solid #d5d8e5;\n  border-top: 1px solid #d5d8e5;\n  border-bottom: 1px solid #d5d8e5 !important;\n}\n.popup-layer.type2 .popup__body .tbl-list.brd-none table thead th + th {\n  border-left: 1px solid #d5d8e5;\n}\n.popup-layer.type2 .popup__body .tbl-list.brd-none table td {\n  border-top: 1px solid #d5d8e5;\n  border-bottom: 1px solid #d5d8e5 !important;\n  padding: 10px 2px;\n  height: 19px;\n  word-break: break-all;\n}\n.popup-layer.type2 .popup__body .tbl-list.brd-none table td + td {\n  border-left: 1px solid #d5d8e5;\n}\n\n/* d-sm-none */\n.popup-layer.type2 .popup__body .tbl-list .d-sm-none {\n  display: table-cell !important;\n}\n.popup-layer.type2 .popup__body .tbl-list colgroup.d-sm-none {\n  display: table-column-group !important;\n}\n.popup-layer.type2 .popup__body .tbl-list .d-sm-block {\n  display: none !important;\n}\n@media screen and (max-width: 499px) {\n  .popup-layer.type2 .popup__body .tbl-list .d-sm-block {\n    display: table-cell !important;\n  }\n  .popup-layer.type2 .popup__body .tbl-list colgroup.d-sm-block {\n    display: table-column-group !important;\n  }\n  .popup-layer.type2 .popup__body .tbl-list .d-sm-none,\n  .popup-layer.type2 .popup__body .tbl-list colgroup.d-sm-none {\n    display: none !important;\n  }\n}\n\n/* d-w620-none */\n.d-w620-none {\n  display: flex !important;\n}\n.d-w620-flex {\n  display: none !important;\n}\n@media screen and (max-width: 620px) {\n  .d-w620-none {\n    display: none !important;\n  }\n  .d-w620-flex {\n    display: flex !important;\n  }\n}\n\n/* popup__sticky */\n.popup__sticky {\n  display: flex;\n  align-items: center;\n  width: auto;\n  padding: 16px 40px;\n  background: #fff;\n}\n@media screen and (max-width: 940px) {\n  .popup__sticky {\n    padding: 20px;\n  }\n}\n\n/* 팝업 내 highlight */\n.popup-layer.type2 .popup__body .tbl-list table th.highlight-blue,\n.popup-layer.type2 .popup__body .tbl-list table td.highlight-blue {\n  background: #e2ebfb !important;\n  color: #0028b6;\n  font-weight: 500;\n}\n.popup-layer.type2 .popup__body .tbl-list table th.highlight-blue-bottom,\n.popup-layer.type2 .popup__body .tbl-list table td.highlight-blue-bottom {\n  border-bottom: 1px solid #577eff !important;\n}\n.popup-layer.type2 .popup__body .tbl-list table tbody th.highlight-blue.highlight-blue-bottom {\n  border-left: 1px solid #577eff !important;\n}\n.popup-layer.type2\n  .popup__body\n  .tbl-list\n  table\n  tbody\n  th.highlight-blue.highlight-blue-bottom\n  + td.highlight-blue.highlight-blue-bottom {\n  border-right: 1px solid #577eff !important;\n}\n\n/* 팝업 내 수용률 계산식 */\n.popup-layer.type2 .popup__body:has(.formula-container) {\n  padding: 32px 40px 64px;\n  width: calc(100% - 80px);\n}\n.popup-layer.type2 .popup__body .formula-container {\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 14px;\n  color: #2a2c2f;\n  padding: 20px 0;\n}\n.popup-layer.type2 .popup__body .formula-container .side-text {\n  line-height: 17px;\n}\n.popup-layer.type2 .popup__body .formula-container .side-text.left {\n  margin-right: 8.38px;\n}\n.popup-layer.type2 .popup__body .formula-container .side-text.right {\n  margin-left: 12px;\n}\n.popup-layer.type2 .popup__body .formula-container .formula-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.popup-layer.type2 .popup__body .formula-container .formula-wrapper .formula div {\n  min-width: 152px;\n  line-height: 17px;\n}\n.popup-layer.type2 .popup__body .formula-container .formula-wrapper .formula .numerator {\n  border-bottom: 1px solid rgba(42, 44, 47, 0.8);\n  padding-bottom: 8px;\n}\n.popup-layer.type2 .popup__body .formula-container .formula-wrapper .formula .denominator {\n  padding-top: 8px;\n}\n@media screen and (max-width: 620px) {\n  .popup-layer.type2 .popup__body:has(.formula-container) {\n    padding: 32px 20px 178px;\n    width: calc(100% - 40px);\n  }\n  .popup-layer.type2 .popup__body .formula-container + .tbl-list {\n    margin-top: 20px;\n  }\n}\n\n/* 팝업 body 높이 444px */\n.popup-layer.type2 .popup__body.h380:has(.complete-txt) {\n  display: flex;\n  align-items: center;\n}\n.popup-layer.type2 .popup__body .form__input li {\n  align-items: center;\n}\n.popup-layer.type2 .popup__body.h380 .complete-txt .joinok.font-14::before {\n  margin: 0 auto 14px;\n}\n.popup-layer.type2 input[type=\"text\"] {\n  font-size: 14px !important;\n}\n.popup-layer.type2 input[type=\"text\"]:read-only {\n  background: #f0f2f4 !important;\n  border: 1px solid #f0f2f4 !important;\n}\n.input__area:has(.btn-eye) input[type=\"password\"] {\n  padding: 0 28px 0 12px;\n  width: calc(100% - 2.625rem);\n  position: relative;\n}\n.input__area .btn-eye {\n  border: 0;\n  position: absolute;\n  right: 8px;\n  top: 6px;\n}\ni.icon-eye,\ni.icon-eye-off {\n  width: 20px;\n  height: 20px;\n}\ni.icon-eye::before,\ni.icon-eye-off::before {\n  content: \"\";\n  display: block;\n  background-size: 20px;\n  width: 20px;\n  height: 20px;\n  background: url(\"../img/icon_eye_on.svg\");\n}\ni.icon-eye-off::before {\n  background: url(\"../img/icon_eye_off.svg\");\n}\n@media screen and (max-width: 940px) {\n  .popup-layer.type2 .popup__body.h380 {\n    height: 490px !important;\n    padding: 24px 20px;\n  }\n  .popup-layer.type2 .popup__body .form__input {\n    gap: 16px;\n  }\n  .popup-layer.type2 .popup__body .form__input input[type=\"checkbox\"] + label {\n    width: calc(100% - 29px) !important;\n    margin-bottom: 0;\n    margin-top: 14px;\n  }\n}\n@media screen and (max-width: 500px) {\n  .popup-layer.type2 .popup__body .form__input li:not(.form__input .filelist li) {\n    margin-top: 0;\n  }\n}\n\n/* 반응형 */\n@media screen and (max-width: 1655px) {\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap:has(.flex-inline.center) {\n    gap: 32px;\n  }\n}\n@media screen and (max-width: 1601px) {\n  .monitor.type2 .box__body .box-column > li > article .flex-row.center.gap-16 {\n    flex-direction: column !important;\n  }\n}\n@media screen and (max-width: 1260px) {\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top .right .txt-info {\n    display: none;\n  }\n}\n@media screen and (max-width: 1200px) {\n  .monitor.type2 .box__body .box-column > li > article .top:has(.tab__line.group) {\n    flex-direction: row;\n  }\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top:has(.tab__line.group) .right {\n    width: auto;\n  }\n  .monitor.type2 .box__body .box-column > li > article .cont .tab-content.type2 ul.item-box {\n    flex-direction: column;\n    width: 100%;\n  }\n  .monitor.type2 .box__body .box-column > li > article .cont .tab-content.type2 ul.item-box > li {\n    width: auto;\n  }\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab__line li {\n    padding: 0 16px;\n    width: calc(100% - 32px);\n  }\n}\n@media screen and (max-width: 1127px) {\n  .monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap.item-w1127 li:has(.score-info.type2) {\n    width: calc(100% - 32px);\n  }\n}\n@media screen and (max-width: 1091px) {\n  .monitor.type2 .box__body .box-column > li {\n    width: calc(100% - 32px);\n  }\n  .monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li {\n    min-height: auto;\n  }\n}\n@media screen and (max-width: 1000px) {\n  .monitor.type2 .box__body .box-column > li > article .top:has(.tab__line.group) {\n    flex-direction: column;\n    margin-bottom: 0;\n  }\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top .tab__line li.on {\n    border-bottom: 0;\n    padding: 0 !important;\n  }\n  .monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li {\n    min-height: auto;\n  }\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top .right .txt-info {\n    display: block;\n  }\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top:has(.tab__line.group) .right {\n    margin-left: auto;\n    align-items: center;\n    justify-content: flex-start;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 16px;\n  }\n}\n@media screen and (max-width: 940px) {\n  #wrap:not(.no-responsive)\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    button.btn-basic\n    span,\n  #wrap:not(.no-responsive)\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .tbl__top\n    button.btn-basic\n    span,\n  #wrap:not(.no-responsive) button.btn-basic.font-14 span {\n    font-size: 14px !important;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab__line\n    li:has(.btn-pop-area)\n    .btn-pop-area {\n    display: none;\n  }\n  .monitor.type2 .box__body .box-column > li > article h2 {\n    font-size: 16px;\n  }\n  .monitor.type2 .box__body .box-column > li > article .txt-info.ml-16 {\n    margin-left: 0 !important;\n    margin-top: 20px !important;\n  }\n  .monitor.type2 .box__body .box-column > li > article .top {\n    margin-bottom: 10px;\n  }\n  .monitor.type2 .box__body .box-column > li > article .cont .tbl-list.row table th {\n    padding: 14px 8px 14px 24px;\n    vertical-align: middle !important;\n  }\n  .monitor.type2 .box__body .box-column > li > article .cont .tbl-list.row table th + td {\n    padding: 14px 20px 14px 0px;\n    font-weight: 400;\n  }\n  .monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap > div.p-16 {\n    padding: 0 !important;\n    gap: 20px;\n  }\n  .monitor.type2 .box__body .box-column > li > article .cont .tab-cont-wrap > div > div.p-16.gap-16 {\n    gap: 20px !important;\n  }\n  .monitor.type2 .box__body .box-column > li > article .cont .tab-content.type2 .tab-cont-wrap .cont ul.box-small-wrap {\n    gap: 40px;\n  }\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .tbl-tit,\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article\n    .cont\n    .tab-cont-wrap\n    .cont\n    .tab-content.type2\n    ul.box-small-wrap.border-0\n    li,\n  .monitor.type2 .box__body .tab-content.type2 .cont-border-box {\n    padding: 0;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap:has(.flex-inline.center) {\n    padding: 0 !important;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap:has(.box-wrap.long) {\n    flex-direction: column;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap\n    .box-wrap.long\n    ul.box-small-wrap\n    li {\n    min-width: auto;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article\n    .cont\n    .tab-content.type2\n    .cont-border-box\n    .tbl-list.type6\n    table\n    th,\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article\n    .cont\n    .tab-content.type2\n    .cont-border-box\n    .tbl-list.type6\n    table\n    td {\n    font-size: 15px !important;\n  }\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .cont-border-box.mt-16 {\n    margin-top: 0 !important;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .cont-border-box\n    .graph-cont {\n    gap: 20px;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .cont-border-box\n    .scrollX\n    .graph-box {\n    padding: 20px 20px 0 20px;\n  }\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .bottom.top {\n    margin-top: 0 !important;\n  }\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .top.justify-right {\n    padding: 0;\n    padding-top: 20px;\n  }\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .tab-cont-wrap {\n    gap: 60px;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .tab-cont-wrap\n    .cont\n    + .cont {\n    margin-top: 44px;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article\n    .cont\n    .tab-content.type2\n    .tab-cont-wrap\n    .cont\n    ul.box-small-wrap:not(.box-list)\n    li {\n    padding: 0;\n  }\n}\n@media screen and (max-width: 508px) {\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .top:has(.tab__line.group) .right .btn-basic.h32 {\n    margin-left: auto;\n  }\n}\n@media screen and (max-width: 499px) {\n  .monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li {\n    min-height: 86px;\n  }\n  .monitor.type2 .box__body .box-column > li > article .cont ul.box-small-wrap.box-list li .count-info {\n    margin-top: auto;\n  }\n  .monitor.type2 .box__body .box-column > li > article .cont .tbl-list.row table th {\n    padding: 14px 8px 14px 16px;\n  }\n  .monitor.type2 .box__body .box-column > li > article .cont .tbl-list.row table th + td {\n    padding: 14px 8px 14px 0px;\n  }\n  .monitor.type2 .box__body .box-column > li > article .txt-info.ml-16,\n  .monitor.type2 .box__body .box-column > li > article.boxtype-tab > .cont .tab-content.type2 .bottom.top {\n    margin-top: 0px !important;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap\n    .cont-border-box\n    .scrollX\n    .graph-box {\n    padding: 32px 16px;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .cont-border-box\n    .graph-cont\n    .graph-legend.m-mb-0 {\n    margin-bottom: 0 !important;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap\n    .box-wrap.long\n    ul.box-small-wrap\n    li {\n    flex-direction: column;\n    min-height: 104px;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap:has(.box-wrap.long) {\n    gap: 60px !important;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap\n    .box-wrap.long {\n    gap: 8px !important;\n  }\n  .monitor.type2\n    .box__body\n    .box-column\n    > li\n    > article.boxtype-tab\n    > .cont\n    .tab-content.type2\n    .item-wrap\n    .box-wrap.long\n    ul.box-small-wrap\n    li\n    .count-info {\n    margin-left: auto;\n  }\n  .monitor.type2 .box__body .box-column > li > article .cont .tab-content.type2 .tab-cont-wrap .cont .txt-info.mt-16 {\n    margin-top: 0 !important;\n  }\n}\n@media screen and (max-width: 390px) {\n  .d-xsm-none {\n    display: none !important;\n  }\n  .d-xsm-block {\n    display: block !important;\n  }\n  .popup-layer.type2 .popup__body .tbl-list .d-xsm-none {\n    display: none !important;\n  }\n  .popup-layer.type2 .popup__body .tbl-list .d-xsm-block {\n    display: block !important;\n  }\n  .popup-layer.type2 .popup__body p.txt,\n  .popup-layer.type2 .popup__body p.txt-info,\n  .popup-layer.type2 .popup__body .tbl-list table th,\n  .popup-layer.type2 .popup__body .tbl-list table td {\n    font-size: 16px;\n    line-height: 22px;\n  }\n}\n@media screen and (max-width: 360px) {\n  .graph-legend p.bar-type::before {\n    width: 240px;\n  }\n}\n\n/* tab-group */\n.tab-group {\n  display: none !important;\n}\n.tab-group.show {\n  display: flex !important;\n}\n\n/* highlight-blue */\n.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list table th.highlight-blue,\n.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list table td.highlight-blue {\n  background: #e6f0ff !important;\n  color: #0a78ff;\n  font-weight: 500;\n  font-size: 16px;\n  border: 1px solid #0a78ff !important;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list table th.brd-right-0 {\n  border-right: 0 !important;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list table th.highlight-blue-bottom,\n.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list table td.highlight-blue-bottom {\n  border-bottom: 1px solid #0a78ff !important;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list table .highlight-blue.brd-left-0 {\n  border-left: 0 !important;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  .cont-border-box\n  .tbl-list\n  table\n  .highlight-blue.brd-right-0 {\n  border-right: 0 !important;\n}\n.monitor.type2 .box__body .box-column > li > article .cont .cont-border-box .tbl-list table .highlight-blue.brd-left-1 {\n  border-left: 1px solid #0a78ff !important;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  .cont-border-box\n  .tbl-list\n  table\n  th.highlight-blue.brd-right-gray,\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  .cont-border-box\n  .tbl-list\n  table\n  td.highlight-blue.brd-right-gray {\n  border-right: 1px solid #dde2e9 !important;\n}\n.monitor.type2\n  .box__body\n  .box-column\n  > li\n  > article\n  .cont\n  .cont-border-box\n  .tbl-list\n  table\n  td.highlight-blue\n  span.unit {\n  color: #003378;\n  font-weight: 500;\n  font-size: 16px;\n}\n/************************************************** beyondX enable 업그레이드 개발 - 제안서 추가  ****************************************************/\n#wrap:has(.report) .box.treebar:has(.tooltip-link) {\n  overflow-x: unset;\n}\n.box.treebar.pushy-menutype:has(.tooltip-link) .lnb {\n  overflow-y: unset;\n}\n.box.treebar.pushy-menutype:has(.btn-pop-area) .lnb .lnb-depth1 .btn-pop-area .pop-layer-box.info {\n  left: 20px;\n  top: 40px;\n}\n.tooltip-link.wmax-292::before {\n  max-width: 292px;\n  width: 100%;\n  letter-spacing: 0;\n  pointer-events: none;\n}\n.tooltip-link.wmax-282::before {\n  right: auto;\n  left: -192px;\n  text-align: left;\n  width: 282px;\n  max-width: 282px;\n  letter-spacing: 0;\n  pointer-events: none;\n  top: 36px;\n}\n\ni.icon-check-circle.blue {\n  background-image: url(\"../img/icon_check_circle_blue.svg\");\n}\n.float-page.type2 * {\n  font-family: \"Pretendard\", sans-serif;\n}\n.float-page.type2 header .header__title {\n  background: url(\"../img/beyondx_logo_white.png\") no-repeat 0 center;\n  background-size: contain;\n  height: 26px;\n  padding-left: 184px;\n  margin-left: 24px;\n}\n.float-page.type2 .content {\n  width: 100%;\n  padding: 0;\n}\n.float-page.type2 .box__header {\n  padding: 16px 25px 16px 32px;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.float-page.type2 header .header__title span {\n  font-weight: 700;\n  padding-left: 12px;\n  line-height: 30px;\n}\n.float-page.type2 .box__body {\n  padding: 0;\n  height: calc(100% - 65px);\n}\n.float-page.type2 .box__body .body-right {\n  flex: unset;\n  width: 493px;\n}\n.float-page.type2 .box__body .body-right .right-top {\n  padding: 16px 24px;\n  height: auto;\n}\n.float-page.type2 .box__body .body-right .right-top > p {\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 600;\n}\n.float-page.type2 .box__body .body-right .right-bottom {\n  padding: 16px 32px;\n  height: calc(100vh - 216px);\n  overflow: auto;\n}\n.float-page.type2 .txt-info {\n  font-size: 15px;\n  line-height: 1.4;\n  margin-left: 0;\n}\n.float-page.type2 .asterisk {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding-left: 14px;\n}\n.float-page.type2 .asterisk::before {\n  content: \"※\";\n  position: absolute;\n  left: 0;\n  color: #0028b6;\n}\n.float-page.type2 .box__body .box-search-card-wrap {\n  width: auto;\n}\n.float-page.type2 .box__body .box-search-card {\n  background: #fff;\n  border: 1px solid #dde2e9;\n  border-radius: 6px;\n}\n.float-page.type2 .box__body .box-search-card.on,\n.float-page.type2 .box__body .box-search-card:hover {\n  border-color: #0a78ff;\n}\n.float-page.type2 .box__body .box-search-card > .top .tit {\n  line-height: 1.5;\n  font-weight: 600;\n}\n.float-page.type2 .box__body .box-search-card > .bottom {\n  padding: 0 16px 16px;\n}\n.float-page.type2 .box__body .box-search-card .input__area.wmax-180 input[type=\"text\"] {\n  text-align: right;\n}\n.float-page.type2 .box__body .box-search-card .input__area.wmax-180:has(.num-inputin.font-13) input[type=\"text\"] {\n  padding-right: 88px;\n  width: calc(100% - 102px);\n}\n.float-page.type2 .box__body .box-search-card .input__area.wmax-180:has(.num-inputin.font-13) .num-inputin.font-13 {\n  top: 9px;\n  line-height: 24px;\n}\n.float-page.type2 .box__body .box-search-card > .bottom > ul:has(.input__area > textarea) {\n  gap: 16px;\n}\n.float-page.type2 .box__body .box-search-card > .bottom > ul:has(.input__area > textarea) > li {\n  gap: 8px;\n  flex-direction: column;\n  align-items: flex-start;\n}\n.float-page.type2 .box__body .box-search-card > .bottom > ul:has(.input__area > textarea) > li .input__area {\n  max-width: none;\n}\n.float-page.type2 .box__body .box-search-card > .bottom > ul:has(.input__area > textarea) > li .input__area > textarea {\n  width: calc(100% - 25px);\n  padding: 8px 12.5px;\n  height: 102px;\n}\n.float-page.type2 .body-left:has(.left, .right) {\n  flex-direction: row;\n  gap: 0;\n}\n.float-page.type2 .body-left {\n  padding: 0;\n  gap: 0;\n  flex-direction: row;\n  height: calc(100vh - 132px);\n}\n.float-page.type2 .body-left .tab__line {\n  width: 272px;\n  height: calc(100vh - 132px);\n  overflow: auto;\n  align-items: flex-start;\n  flex-direction: column;\n  background: inherit;\n  gap: 0;\n  border-bottom: 0;\n}\n.float-page.type2 .body-left .tab__line li {\n  width: 100%;\n  justify-content: flex-start;\n  padding: 16px 16px 16px 32px;\n  border-bottom: 1px solid #dde2e9;\n  max-width: 214px;\n}\n.float-page.type2 .body-left .tab__line li:last-child {\n  border-bottom: 0;\n}\n.float-page.type2 .body-left .tab__line li.on {\n  border-bottom: 1px solid #dde2e9;\n  background: inherit;\n  font-weight: 700;\n  color: #0a78ff;\n}\n.float-page.type2 .body-left .tab__line li.white.tooltip-link::before {\n  width: fit-content;\n  pointer-events: none;\n}\n.float-page.type2 .body-left .tab__line li > span {\n  font-size: 15px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 20px;\n}\n.float-page.type2 .body-left .tab-content-group {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: calc((100vh - 4.16665vw) - 132px);\n  width: calc((100% - 7.08333vw) - 272px);\n  gap: 52px;\n  margin: auto;\n}\n.float-page.type2 .body-left .tab-content,\n.float-page.type2 .body-left .tab-content .tab-cont-wrap,\n.float-page.type2 .body-left .tab-content .tab-cont-wrap .proposal-wrap {\n  width: 100%;\n  height: auto;\n}\n.float-page.type2 .body-left .tab-content .tab-cont-wrap .proposal-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 1.458331vw;\n}\n.float-page.type2 .body-left .tab-content .tab-cont-wrap .proposal-wrap .proposal {\n  width: min(100%, calc((100vh - 7.08333vw - 132px) * (4 / 3)));\n  height: auto;\n  aspect-ratio: 4 / 3.11;\n  /* max-width: 1000px;\n  max-height: 750px;*/\n  overflow: hidden;\n  border: 1px solid #909fb7;\n  background: #fff;\n  box-sizing: border-box;\n}\n.float-page.type2 .body-left .tab-content .tab-cont-wrap .proposal-wrap .proposal > img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.float-page.type2 .body-left .tab-content-group .paging {\n  width: 100%;\n  height: 28px;\n}\n.float-page.type2 .body-left .tab-content-group .paging ul {\n  margin-left: 0;\n}\n.float-page.type2 .body-left .tab-content-group .paging ul > li.count {\n  border: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.float-page.type2 .body-left .tab-content-group .paging ul > li.count > span {\n  font-size: 14px;\n  color: #2a2c2f;\n}\n.float-page.type2 .body-left .tab-content-group .paging ul li:not(.count) {\n  border-radius: 0 4px 4px 0;\n  width: 28px;\n  height: 28px;\n}\n@media screen and (max-width: 940px) {\n  .float-page.type2 .container.energy-solution .box__header > * {\n    margin: 0 !important;\n    width: auto !important;\n  }\n  .float-page.type2 header {\n    padding: unset;\n    width: 100%;\n  }\n  .float-page.type2 .container {\n    margin-top: 58px;\n    height: calc(100vh - 66px);\n  }\n  .float-page.type2 .box__body .body-right {\n    border: none;\n    padding-top: 0;\n  }\n  #wrap:not(.no-responsive) button.btn-basic {\n    height: 32px;\n  }\n  .float-page.type2 .body-left .tab__line li {\n    flex: unset;\n    padding: 16px 16px 16px 32px !important;\n  }\n}\n/* radio */\n.float-page.type2 .container.energy-solution .box__body .box-search-card > .bottom > ul > li:has(.radioBox) {\n  gap: 20px;\n}\n.float-page.type2 .container.energy-solution .box__body .box-search-card > .bottom > ul > li:has(.radioBox) .tit {\n  max-width: 128px;\n}\n.float-page.type2\n  .container.energy-solution\n  .box__body\n  .box-search-card\n  > .bottom\n  > ul\n  > li:has(.radioBox)\n  .input__area {\n  max-width: none;\n}\n.float-page.type2\n  .container.energy-solution\n  .box__body\n  .box-search-card\n  > .bottom\n  > ul\n  > li:has(.radioBox)\n  .input__area\n  .radioBox {\n  display: flex;\n  align-items: center;\n}\n.float-page.type2\n  .container.energy-solution\n  .box__body\n  .box-search-card\n  > .bottom\n  > ul\n  > li:has(.radioBox)\n  .input__area\n  .radioBox\n  label {\n  margin-left: 0;\n  align-items: center;\n  letter-spacing: -0.09em;\n}\n.float-page.type2\n  .container.energy-solution\n  .box__body\n  .box-search-card\n  > .bottom\n  > ul\n  > li:has(.radioBox)\n  .input__area\n  .radioBox\n  label\n  + label {\n  margin-left: 16px;\n}\n.float-page.type2\n  .container.energy-solution\n  .box__body\n  .box-search-card\n  > .bottom\n  > ul\n  > li:has(.radioBox)\n  .input__area\n  .radioBox\n  input[type=\"radio\"] {\n  margin: 8px;\n}\n/* state 표시 있을 시 */\n.float-page.type2 .body-left .tab-content .tab-cont-wrap .proposal-wrap:has(.state) {\n  flex-direction: column;\n  margin-top: 0;\n}\n.float-page.type2 .body-left .tab-content .tab-cont-wrap .proposal-wrap:has(.state) .state {\n  color: #7a8596;\n  font-size: 14px;\n  line-height: 20px;\n  margin-bottom: 0.625vw;\n  width: min(100%, calc((100vh - 7.08333vw - 132px) * (4 / 3)));\n  text-align: right;\n}\n.float-page.type2\n  .container.energy-solution\n  .box__body\n  .box-search-card\n  > .bottom\n  > ul\n  > li:has(.input-error)\n  .num-inputin {\n  display: none;\n}\n\n/********* 에너지 솔루션 - 인버터(고압 MVD) 경제성 분석 *********\n * 좌우 폭과 결과 패널(지표 카드 · 표) 규칙. 입력 폼 쪽은 아래 「피그마 화면 개편」 블록에 있다.\n * 이 화면에만 적용되도록 .inverter-input / .inverter-result 로 스코프를 좁힌다.\n ***************************************************************/\n/* 좌측 Step 레일 폭에 맞춘 값 — 고효율 설비 교체 분석과 같은 296px 레일이다 (2026-08-31) */\n.container.energy-solution .box__body > .area__right .scroll-area.inverter-result:has(.box-column) {\n  width: calc(100% - 328px);\n}\n@media screen and (max-width: 940px) {\n  .container.energy-solution .box__body .box-search-card-wrap.inverter-input,\n  .container.energy-solution .box__body > .area__right .scroll-area.inverter-result:has(.box-column) {\n    width: 100%;\n  }\n}\n/* 결과 패널 본문 — 기본 .cont 는 좌/우 2단(display:flex)이라 지표 그리드와 표가 가로로 붙는다.\n * 인버터 화면은 지표 → CASE 표 → 대수운전 표 순으로 세로로 쌓는다. */\n.container.energy-solution\n  .box__body\n  .inverter-result\n  .box-column\n  > li\n  > article\n  > section\n  .cont {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* 결과 지표 6종 — 화면 ver 1.3 의 .grid3 / .metric 을 그대로 옮긴다.\n * 프로젝트 기본 .box-list 는 값이 오른쪽 정렬이고 카드 높이를 균등하게 늘려서 쓰지 않는다. */\n.container.energy-solution .box__body .inverter-result .inv-grid3 {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 6px;\n  width: 100%;\n}\n.container.energy-solution .box__body .inverter-result .inv-grid3 + .inv-grid3 {\n  margin-top: 6px;\n}\n@media screen and (max-width: 1200px) {\n  .container.energy-solution .box__body .inverter-result .inv-grid3 {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@media screen and (max-width: 780px) {\n  .container.energy-solution .box__body .inverter-result .inv-grid3 {\n    grid-template-columns: 1fr;\n  }\n}\n/* 피그마 : 회색 패널 · 라벨 좌상단 · 값과 보조문구는 우측 정렬, 값 색은 모두 먹색 */\n/* 보조문구가 없는 카드(총 가동 시간)도 값이 같은 높이에 오도록 block 으로 쌓는다.\n * flex + space-between 이면 보조문구가 없는 카드만 값이 아래로 내려간다. */\n.container.energy-solution .box__body .inverter-result .inv-metric {\n  display: block;\n  min-height: 92px;\n  padding: 11px 20px 4px;\n  border: 0;\n  border-radius: 2px;\n  background: #f7f8fa;\n}\n.container.energy-solution .box__body .inverter-result .inv-metric .k {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 14px;\n  font-size: 0.8125rem;\n  line-height: 1.4;\n  color: #3d4753;\n}\n.container.energy-solution .box__body .inverter-result .inv-metric .k:before {\n  content: \"\";\n  flex: 0 0 auto;\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: #1763d6;\n}\n.container.energy-solution .box__body .inverter-result .inv-metric .v {\n  font-size: 1.25rem;\n  font-weight: 700;\n  letter-spacing: -0.3px;\n  line-height: 1.3;\n  color: #1a2330;\n  text-align: right;\n}\n.container.energy-solution .box__body .inverter-result .inv-metric .v small {\n  margin-left: 3px;\n  font-size: 0.6875rem;\n  font-weight: 400;\n  color: #97a3b4;\n}\n/* 값 왼쪽의 회색 보조표기 (「2 CASE 합계」) */\n.container.energy-solution .box__body .inverter-result .inv-metric .v > em {\n  margin-right: 10px;\n  font-style: normal;\n  font-size: 0.75rem;\n  font-weight: 400;\n  letter-spacing: 0;\n  color: #97a3b4;\n}\n.container.energy-solution .box__body .inverter-result .inv-metric .v.green,\n.container.energy-solution .box__body .inverter-result .inv-metric.savings .v,\n.container.energy-solution .box__body .inverter-result .inv-metric.benefit .v {\n  color: #1a2330;\n}\n.container.energy-solution .box__body .inverter-result .inv-metric .sub {\n  margin-top: 2px;\n  font-size: 0.75rem;\n  line-height: 1.4;\n  color: #1763d6;\n  text-align: right;\n}\n\n/* ---- 표 (HTML .breakdown) ----\n * 프로젝트 기본 tbl-list 는 파란 bg-sky 헤더 + 전체 격자선이라 HTML 과 인상이 다르다.\n * 마크업은 그대로 두고 인버터 결과 영역에서만 .breakdown 형태로 덮어쓴다.\n * 헤더 옅은 배경 · 가로선만 · 첫 칸 왼쪽 정렬 · 나머지 오른쪽 정렬. */\n/* 피그마 : 표를 감싸는 상자도, 회색 제목바도 없다. 제목은 흰 배경 위 글씨 한 줄 */\n.container.energy-solution .box__body .inverter-result .table-wrap {\n  margin-top: 20px;\n  border: 0;\n  border-radius: 0;\n  overflow: visible;\n}\n.container.energy-solution .box__body .inverter-result .table-wrap .tbl__top {\n  margin: 0 0 8px;\n  padding: 0;\n  background: none;\n  border: 0;\n}\n.container.energy-solution .box__body .inverter-result .table-wrap .tbl__top .title-small {\n  margin: 0;\n  font-size: 0.875rem;\n  font-weight: 500;\n  line-height: 1.4;\n  letter-spacing: normal;\n  color: #1a2330;\n}\n.container.energy-solution .box__body .inverter-result .tbl-list {\n  border: 0;\n}\n.container.energy-solution .box__body .inverter-result .tbl-list table {\n  width: 100%;\n  border-collapse: collapse;\n  /* 기본 tbl-list 는 table-layout:fixed 라 모든 열이 같은 폭이 된다.\n     HTML .breakdown 은 auto 라 라벨 열이 내용만큼만 차지한다. */\n  table-layout: auto;\n  border-bottom: 0;\n  font-size: 0.75rem;\n}\n/* 기본 tbl-list 는 th 배경 #dde2e9 · td 높이 40px · 자간 -0.9px 가 걸려 있다.\n * HTML .breakdown 과 맞추려면 이 넷을 모두 되돌려야 한다. */\n.container.energy-solution .box__body .inverter-result .tbl-list th,\n.container.energy-solution .box__body .inverter-result .tbl-list td {\n  height: 33px;\n  min-height: 0;\n  padding: 0 14px;\n  border: 0;\n  border-bottom: 1px solid #f1f3f6;\n  background: #fff;\n  text-align: center;\n  font-size: 0.8125rem;\n  font-weight: 400;\n  line-height: 1.4;\n  letter-spacing: normal;\n  color: #1a2330;\n}\n/* 헤더 — 옅은 배경에 회색 글씨 */\n.container.energy-solution .box__body .inverter-result .tbl-list thead th {\n  background: #fbfcfe;\n  color: #6b7686;\n  font-weight: 600;\n}\n/* 데이터 행 — HTML .caseRow td 는 600. 첫 칸도 같은 굵기이고 배경색을 따로 주지 않는다\n * (마크업에서 bg-sky 를 제거했으므로 여기서 덮어쓸 필요가 없다) */\n.container.energy-solution .box__body .inverter-result .tbl-list tbody th,\n.container.energy-solution .box__body .inverter-result .tbl-list tbody td {\n  background: #fff;\n  font-weight: 400;\n}\n.container.energy-solution .box__body .inverter-result .tbl-list th:first-child,\n.container.energy-solution .box__body .inverter-result .tbl-list td:first-child {\n  text-align: left;\n}\n/* 경제성 검토 표만 첫 칸 제외 가운데 정렬 — HTML .ecoTable */\n.container.energy-solution .box__body .inverter-result .tbl-list.eco-table th:not(:first-child),\n.container.energy-solution .box__body .inverter-result .tbl-list.eco-table td:not(:first-child) {\n  text-align: center;\n}\n.container.energy-solution .box__body .inverter-result .tbl-list tbody tr:last-child th,\n.container.energy-solution .box__body .inverter-result .tbl-list tbody tr:last-child td {\n  border-bottom: 0;\n}\n/* 합계행 — HTML .sumRow */\n.container.energy-solution .box__body .inverter-result .tbl-list tr.sum-row th,\n.container.energy-solution .box__body .inverter-result .tbl-list tr.sum-row td {\n  background: #eef5ff;\n  font-weight: 800;\n  color: #0f4aa8;\n}\n\n/* 추천 지정 별표 — 추천이 아닌 건에만 회색 ☆ 로 노출된다(추천 건은 배지로 표시).\n * 제목 바로 옆에 놓기 위해 .top .left 를 가로 정렬로 잡는다. */\n.container.energy-solution .box__body .inverter-result .box-column > li > article > section .top .left {\n  display: flex;\n  align-items: center;\n}\n.container.energy-solution .box__body .inverter-result .btn-report-star {\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  margin-left: 6px;\n  padding: 0;\n  border: 0;\n  background: none;\n  cursor: pointer;\n  line-height: 1;\n  vertical-align: middle;\n}\n.container.energy-solution .box__body .inverter-result .btn-report-star:before {\n  content: \"☆\";\n  font-size: 1.25rem;\n  color: #c2cad6;\n}\n.container.energy-solution .box__body .inverter-result .btn-report-star:hover:before {\n  color: #f0a92a;\n}\n\n/* 적용 회전수 자동 산정값 — 직접 입력이 아니라는 것을 배경으로 구분한다 */\n.container.energy-solution .box__body .inverter-input .box-search-card input[type=\"text\"].auto-filled {\n  background: #eef5ff;\n}\n\n/* ---- 결과 영역 스크롤 해제 ----\n * 기본은 고정 높이(100vh-217px) + overflow-y:auto 라 이력이 여러 건이거나 상세분석을 펼치면\n * 안쪽에 스크롤이 생긴다. 인버터 화면은 높이를 풀어 전체가 한 번에 보이게 하고 페이지 스크롤로 넘긴다. */\n.container.energy-solution .box__body > .area__right:has(.scroll-area.inverter-result) {\n  height: auto;\n}\n.container.energy-solution .box__body > .area__right .scroll-area.inverter-result:has(.box-column) {\n  height: auto;\n  overflow: visible;\n}\n/* 분석 이력이 없을 때는 안내문이 납작해지지 않도록 최소 높이를 준다 */\n.container.energy-solution .box__body .inverter-result .box-column.nodata {\n  height: auto;\n  min-height: 320px;\n}\n\n\n/* ⓘ 분석 설비 정보 — 3단 요약표 */\n.container.energy-solution .box__body .inverter-result .inv-info-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n@media screen and (max-width: 760px) {\n  .container.energy-solution .box__body .inverter-result .inv-info-grid {\n    grid-template-columns: 1fr;\n  }\n}\n.container.energy-solution .box__body .inverter-result .inv-info-col {\n  border: 1px solid #e3e8ef;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #fff;\n}\n.container.energy-solution .box__body .inverter-result .inv-info-h {\n  padding: 8px 12px;\n  background: #f7f9fc;\n  border-bottom: 1px solid #e3e8ef;\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #0f4aa8;\n}\n.container.energy-solution .box__body .inverter-result .inv-info-tbl {\n  width: 100%;\n  border-collapse: collapse;\n}\n.container.energy-solution .box__body .inverter-result .inv-info-tbl td {\n  padding: 6px 12px;\n  border-bottom: 1px solid #f0f3f7;\n  font-size: 0.75rem;\n  line-height: 1.4;\n  color: #6b7686;\n}\n.container.energy-solution .box__body .inverter-result .inv-info-tbl td:first-child {\n  width: 52%;\n}\n.container.energy-solution .box__body .inverter-result .inv-info-tbl tr:last-child td {\n  border-bottom: 0;\n}\n.container.energy-solution .box__body .inverter-result .inv-info-tbl td:last-child {\n  text-align: right;\n  font-weight: 700;\n  color: #1a2330;\n}\n.container.energy-solution .box__body .inverter-result .inv-rpm-card {\n  padding: 14px 15px;\n  border: 1px solid #e3e8ef;\n  border-radius: 10px;\n  background: linear-gradient(180deg, #fbfcfe, #fff);\n}\n.container.energy-solution .box__body .inverter-result .inv-rpm-card .rc-k {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 8px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #6b7686;\n}\n.container.energy-solution .box__body .inverter-result .inv-rpm-card .rc-k:before {\n  content: \"\";\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #1763d6;\n}\n.container.energy-solution .box__body .inverter-result .inv-rpm-card .rc-v {\n  font-size: 1.5rem;\n  font-weight: 800;\n  letter-spacing: -0.5px;\n  line-height: 1.25;\n  color: #0f4aa8;\n}\n.container.energy-solution .box__body .inverter-result .inv-rpm-card .rc-v small {\n  margin-left: 2px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #6b7686;\n}\n.container.energy-solution .box__body .inverter-result .inv-rpm-card .rc-eq {\n  margin-top: 7px;\n  font-family: Consolas, monospace;\n  font-size: 0.656rem;\n  line-height: 1.6;\n  color: #8a94a3;\n}\n/* 최종 적용 회전속도 — 한 줄 전체를 쓰고 값이 더 크다 */\n.container.energy-solution .box__body .inverter-result .inv-rpm-card.final {\n  grid-column: 1 / -1;\n  border-color: #bcd3f7;\n  background: linear-gradient(180deg, #eef5ff, #f7faff);\n}\n.container.energy-solution .box__body .inverter-result .inv-rpm-card.final .rc-k {\n  color: #0f4aa8;\n}\n.container.energy-solution .box__body .inverter-result .inv-rpm-card.final .rc-v {\n  font-size: 1.75rem;\n  color: #1763d6;\n}\n\n/* 2번 소비전력 산식 */\n.container.energy-solution .box__body .inverter-result .inv-formula {\n  padding: 12px 14px;\n  border: 1px solid #e3e8ef;\n  border-radius: 8px;\n  background: #f7f9fc;\n  text-align: center;\n}\n.container.energy-solution .box__body .inverter-result .inv-formula p {\n  font-family: Consolas, monospace;\n  font-size: 0.813rem;\n  line-height: 1.9;\n  color: #2a3340;\n}\n.container.energy-solution .box__body .inverter-result .inv-formula b {\n  color: #0f4aa8;\n}\n.container.energy-solution .box__body .inverter-result .inv-formula .sub {\n  display: block;\n  margin-top: 6px;\n  font-size: 0.813rem;\n  color: #8a94a3;\n}\n\n/* 4번 추천 MVD 기기 — HTML .mvd-hero / .spec2 / .dim-wrap */\n.container.energy-solution .box__body .inverter-result .mvd-hero {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 16px;\n  border: 1px solid #e8f0fc;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #eef5ff, #f7fbff);\n}\n.container.energy-solution .box__body .inverter-result .mvd-hero .badge {\n  padding: 4px 10px;\n  border-radius: 20px;\n  background: #1763d6;\n  color: #fff;\n  font-size: 0.656rem;\n  font-weight: 800;\n  white-space: nowrap;\n}\n.container.energy-solution .box__body .inverter-result .mvd-hero .mname {\n  font-size: 1.125rem;\n  font-weight: 800;\n  letter-spacing: 0.3px;\n  color: #0f4aa8;\n}\n.container.energy-solution .box__body .inverter-result .mvd-hero .msub {\n  margin-top: 2px;\n  font-size: 0.688rem;\n  color: #6b7686;\n}\n.container.energy-solution .box__body .inverter-result .mvd-warn {\n  padding: 11px 14px;\n  border: 1px solid #ffd9b0;\n  border-radius: 9px;\n  background: #fff5ec;\n  color: #a85a12;\n  font-size: 0.719rem;\n  font-weight: 600;\n  line-height: 1.55;\n}\n.container.energy-solution .box__body .inverter-result .mvd-warn.nomargin {\n  margin: 0;\n}\n.container.energy-solution .box__body .inverter-result .spec2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n@media screen and (max-width: 760px) {\n  .container.energy-solution .box__body .inverter-result .spec2 {\n    grid-template-columns: 1fr;\n  }\n}\n.container.energy-solution .box__body .inverter-result .spec-card {\n  border: 1px solid #e3e8ef;\n  border-radius: 10px;\n  background: #fff;\n  overflow: hidden;\n}\n.container.energy-solution .box__body .inverter-result .spec-card .sh {\n  padding: 9px 13px;\n  color: #fff;\n  font-size: 0.75rem;\n  font-weight: 800;\n}\n.container.energy-solution .box__body .inverter-result .spec-card.mot .sh {\n  background: #5b6472;\n}\n.container.energy-solution .box__body .inverter-result .spec-card.mvd .sh {\n  background: #1763d6;\n}\n.container.energy-solution .box__body .inverter-result .spec-card table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.75rem;\n}\n.container.energy-solution .box__body .inverter-result .spec-card td {\n  padding: 7px 13px;\n  border-bottom: 1px solid #f0f3f7;\n}\n.container.energy-solution .box__body .inverter-result .spec-card tr:last-child td {\n  border-bottom: none;\n}\n.container.energy-solution .box__body .inverter-result .spec-card td:first-child {\n  width: 56%;\n  color: #6b7686;\n}\n.container.energy-solution .box__body .inverter-result .spec-card td:last-child {\n  text-align: right;\n  font-weight: 700;\n  color: #1a2330;\n}\n.container.energy-solution .box__body .inverter-result .dim-wrap {\n  padding: 16px;\n  border: 1px solid #e3e8ef;\n  border-radius: 10px;\n  background: #fff;\n}\n.container.energy-solution .box__body .inverter-result .dim-wrap .dt {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin-bottom: 12px;\n  font-size: 0.75rem;\n  font-weight: 800;\n  color: #1a2330;\n}\n.container.energy-solution .box__body .inverter-result .dim-wrap .dt .pt {\n  padding: 2px 8px;\n  border-radius: 10px;\n  background: #6b7686;\n  color: #fff;\n  font-size: 0.625rem;\n  font-weight: 700;\n}\n.container.energy-solution .box__body .inverter-result .dim-tbl {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.75rem;\n}\n.container.energy-solution .box__body .inverter-result .dim-tbl td {\n  padding: 6px 10px;\n  border-bottom: 1px solid #f0f3f7;\n  color: #6b7686;\n}\n.container.energy-solution .box__body .inverter-result .dim-tbl tr:last-child td {\n  border-bottom: none;\n}\n.container.energy-solution .box__body .inverter-result .dim-tbl td:last-child {\n  text-align: right;\n  font-weight: 700;\n  color: #1a2330;\n}\n\n/* 3번 차트 제목 · 절감효과 강조행 */\n.container.energy-solution .box__body .inverter-result .inv-chart-tit {\n  text-align: center;\n  font-size: 0.875rem;\n  font-weight: 800;\n  color: #1f9d5b;\n}\n\n/* =========================================================================\n * 에너지 솔루션 - 인버터 경제성 분석 : 피그마 화면 개편 (2026-08-26, 08-31 개정)\n *\n * 좌측 Step 레일(고정 296px) + 우측 카드 스택 구조로 바꾼다.\n * 기본 카드(box-search-card, 296px·1열)와 폭·열수가 달라 공용 클래스에 손대지 않고\n * .inv-* 를 새로 두되, 다른 화면에 번지지 않도록 .inverter-input / .inverter-result\n * 안으로만 스코프를 좁힌다.\n * ========================================================================= */\n\n/* ---- 좌측 Step 레일 ----\n * 폭·글자 크기는 「고효율 설비 교체 분석」 레일(.box-search-card-wrap 296px,\n * .menu-list 1rem)과 같게 맞춘다. 두 화면이 같은 자리에 번갈아 뜨므로 어긋나면 눈에 띈다. */\n.container.energy-solution .box__body .box-search-card-wrap.inverter-input {\n  width: 296px;\n  min-width: 296px;\n  flex: 0 0 296px;\n}\n.container.energy-solution .box__body .inverter-input .box-search-card.inv-rail {\n  padding-bottom: 16px;\n}\n.container.energy-solution .box__body .inverter-input .inv-rail > .top .flex-inline.left-right {\n  align-items: baseline;\n}\n.container.energy-solution .box__body .inverter-input .inv-rail .inv-rail-link {\n  margin-left: auto;\n  border: 0;\n  background: none;\n  font-size: 0.6875rem;\n  color: #1763d6;\n  text-decoration: underline;\n  cursor: pointer;\n}\n.container.energy-solution .box__body .inverter-input .inv-rail > .bottom {\n  padding: 0 12px;\n}\n.container.energy-solution .box__body .inverter-input .inv-rail .inv-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 14px 0;\n  border-radius: 4px;\n  background: #f2f5f9;\n}\n/* 고효율 .menu-list > li > a 와 같은 글자 크기(1rem)·행 높이(40px)·색(#051c3f) */\n.container.energy-solution .box__body .inverter-input .inv-rail .inv-steps > li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 40px;\n  padding: 8px 14px;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: #051c3f;\n  cursor: pointer;\n}\n/* 「Step n」 칸을 고정폭으로 잡아야 아래 이름들의 시작선이 맞는다 (고효율 span min-width 47px) */\n.container.energy-solution .box__body .inverter-input .inv-rail .inv-steps > li .no {\n  flex: 0 0 auto;\n  min-width: 47px;\n}\n.container.energy-solution .box__body .inverter-input .inv-rail .inv-steps > li.on .no,\n.container.energy-solution .box__body .inverter-input .inv-rail .inv-steps > li.on .nm {\n  font-weight: 700;\n  color: #1763d6;\n}\n/* 활성 단계 오른쪽 화살표 (→) — 가로선 + 촉 */\n.container.energy-solution .box__body .inverter-input .inv-rail .inv-steps > li .arw {\n  display: none;\n}\n.container.energy-solution .box__body .inverter-input .inv-rail .inv-steps > li.on .arw {\n  position: relative;\n  display: block;\n  flex: 0 0 auto;\n  width: 18px;\n  height: 10px;\n  margin-left: auto;\n}\n.container.energy-solution .box__body .inverter-input .inv-rail .inv-steps > li.on .arw::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 4px;\n  width: 17px;\n  height: 1.5px;\n  background: #1763d6;\n}\n.container.energy-solution .box__body .inverter-input .inv-rail .inv-steps > li.on .arw::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  top: 1.5px;\n  width: 7px;\n  height: 7px;\n  border-top: 1.5px solid #1763d6;\n  border-right: 1.5px solid #1763d6;\n  transform: rotate(45deg);\n}\n.container.energy-solution .box__body .inverter-input .inv-rail .inv-rail-reset {\n  width: 100%;\n  height: 32px;\n  margin-top: 12px;\n  border: 1px solid #dfe3e9;\n  border-radius: 4px;\n  background: #fff;\n  font-size: 0.75rem;\n  color: #6b7684;\n  cursor: pointer;\n}\n\n/* ---- 우측 : 입력 카드 스택 ---- */\n/* 기존 폭 규칙은 :has(.box-column) 에만 걸려 있어 입력 단계(.inv-form)에서는 폭이 생기지 않는다 */\n.container.energy-solution .box__body > .area__right .scroll-area.inverter-result {\n  flex: 1;\n  margin: -4px 0 0 16px;\n  width: calc(100% - 328px);\n  height: 100%;\n  overflow-y: auto;\n}\n@media screen and (max-width: 940px) {\n  .container.energy-solution .box__body > .area__right .scroll-area.inverter-result {\n    width: 100%;\n    margin-left: 0;\n  }\n}\n.container.energy-solution .inverter-result .inv-form {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 0 0 24px;\n}\n.container.energy-solution .inverter-result .inv-card {\n  border: 1px solid #e4e8ee;\n  border-radius: 6px;\n  background: #fff;\n}\n.container.energy-solution .inverter-result .inv-card.on {\n  border-color: #1763d6;\n  box-shadow: 0 0 0 1px rgba(23, 99, 214, 0.25);\n}\n.container.energy-solution .inverter-result .inv-card .inv-card-hd {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 16px;\n}\n.container.energy-solution .inverter-result .inv-card .inv-card-hd .tit {\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: #1a2330;\n}\n.container.energy-solution .inverter-result .inv-card .inv-card-hd .inv-hd-btns {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-left: auto;\n}\n/* Guide 띠 */\n.container.energy-solution .inverter-result .inv-card .inv-guide {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 28px;\n  margin: 0 16px;\n  padding: 0 12px;\n  background: #1763d6;\n  font-size: 0.75rem;\n  color: #fff;\n}\n.container.energy-solution .inverter-result .inv-card .inv-guide > span {\n  padding: 2px 7px;\n  border-radius: 10px;\n  background: #fff;\n  font-size: 0.625rem;\n  font-weight: 700;\n  color: #1763d6;\n}\n.container.energy-solution .inverter-result .inv-card .inv-card-bd {\n  padding: 0 16px 16px;\n}\n.container.energy-solution .inverter-result .inv-card:not(.on) .inv-card-bd {\n  padding-top: 16px;\n}\n\n/* ---- 카드 안 그리드 : 라벨 위 · 값 아래 ---- */\n.container.energy-solution .inverter-result .inv-grid {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 24px 32px;\n  padding: 24px;\n  border-radius: 4px;\n  background: #f7f8fa;\n}\n.container.energy-solution .inverter-result .inv-grid + .inv-grid {\n  margin-top: 8px;\n}\n/* 피그마는 카드마다 열 수가 달라도 6열 그리드 위에 얹혀 있다.\n   3열 카드 = 2칸씩 · 2열 카드 = 3칸씩 차지하고, 4·5열 카드는 6열 중 앞에서부터 채운다.\n   그래야 설비(3) · 운용(4) · 모터(6) · 시나리오(5) 의 열 시작선이 서로 맞는다. */\n.container.energy-solution .inverter-result .inv-grid-2 > * {\n  grid-column: span 3;\n}\n.container.energy-solution .inverter-result .inv-grid-3 > * {\n  grid-column: span 2;\n}\n.container.energy-solution .inverter-result .inv-grid-4 > *,\n.container.energy-solution .inverter-result .inv-grid-5 > *,\n.container.energy-solution .inverter-result .inv-grid-6 > * {\n  grid-column: span 1;\n}\n@media all and (max-width: 1600px) {\n  .container.energy-solution .inverter-result .inv-grid-5 > *,\n  .container.energy-solution .inverter-result .inv-grid-6 > * {\n    grid-column: span 2;\n  }\n}\n@media all and (max-width: 1200px) {\n  .container.energy-solution .inverter-result .inv-grid-3 > *,\n  .container.energy-solution .inverter-result .inv-grid-4 > *,\n  .container.energy-solution .inverter-result .inv-grid-5 > *,\n  .container.energy-solution .inverter-result .inv-grid-6 > * {\n    grid-column: span 3;\n  }\n}\n.container.energy-solution .inverter-result .inv-f {\n  min-width: 0;\n}\n.container.energy-solution .inverter-result .inv-f-lb {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 0.75rem;\n  color: #46505f;\n  white-space: nowrap;\n}\n.container.energy-solution .inverter-result .inv-f-lb > i {\n  font-style: normal;\n  color: #ea3f3f;\n}\n.container.energy-solution .inverter-result .inv-f-lb > em {\n  font-style: normal;\n  font-size: 0.6875rem;\n  color: #a4adb9;\n}\n.container.energy-solution .inverter-result .inv-f-in {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n  margin-top: 4px;\n  min-width: 0;\n}\n.container.energy-solution .inverter-result .inv-f-in > input[type=\"text\"] {\n  width: 100%;\n  min-width: 0;\n  height: 28px;\n  padding: 0;\n  border: 0;\n  border-bottom: 1px solid transparent;\n  background: none;\n  font-size: 1.0625rem;\n  color: #1a2330;\n}\n.container.energy-solution .inverter-result .inv-f-in > input[type=\"text\"]:focus {\n  border-bottom-color: #1763d6;\n  outline: none;\n}\n.container.energy-solution .inverter-result .inv-f-in > input[type=\"text\"]::placeholder {\n  color: #b6bfcb;\n}\n.container.energy-solution .inverter-result .inv-f-in > input.auto-filled {\n  color: #1763d6;\n}\n.container.energy-solution .inverter-result .inv-f-in > .unit {\n  flex: 0 0 auto;\n  font-size: 0.6875rem;\n  color: #97a3b4;\n}\n/* 드롭다운 — 공용 .select 를 밑줄형으로 낮춰 쓴다 */\n.container.energy-solution .inverter-result .inv-f-in > .select.inv-sel {\n  width: 100%;\n  min-width: 0;\n  height: 28px;\n  border: 0;\n  background: none;\n}\n.container.energy-solution .inverter-result .inv-f-in > .select.inv-sel .selected {\n  height: 28px;\n  padding: 0;\n  border: 0;\n  background: none;\n}\n.container.energy-solution .inverter-result .inv-f-in > .select.inv-sel .selected-value {\n  font-size: 1.0625rem;\n  color: #1a2330;\n}\n.container.energy-solution .inverter-result .inv-f-in > .select.inv-sel > ul {\n  top: 30px;\n}\n.container.energy-solution .inverter-result .inv-f.inv-f-note {\n  grid-column: span 3;\n  align-self: end;\n}\n.container.energy-solution .inverter-result .inv-f.inv-f-note > p {\n  padding-bottom: 4px;\n  font-size: 0.6875rem;\n  color: #97a3b4;\n}\n.container.energy-solution .inverter-result .inv-sub-tit {\n  padding: 24px 24px 8px;\n  border-bottom: 1px solid #e1e6ed;\n  border-radius: 4px 4px 0 0;\n  background: #f7f8fa;\n  font-size: 0.75rem;\n  color: #46505f;\n}\n/* 소제목이 붙으면 아래 패널과 한 덩어리로 보이게 위쪽 라운드를 없앤다 */\n.container.energy-solution .inverter-result .inv-sub-tit + .inv-grid {\n  padding-top: 20px;\n  border-radius: 0 0 4px 4px;\n}\n.container.energy-solution .inverter-result .inv-sub-tit.inv {\n  color: #1763d6;\n}\n/* 운전 CASE 카드는 「기본 정보 → 유량 / 개도율 → 압력」이 한 판 위에 이어진다 (피그마 2026-08-31).\n   앞 격자는 아래 라운드를, 뒤따르는 소제목은 위 라운드를 버려야 경계가 보이지 않는다. */\n.container.energy-solution .inverter-result .inv-grid:has(+ .inv-sub-tit) {\n  border-radius: 4px 4px 0 0;\n}\n.container.energy-solution .inverter-result .inv-grid + .inv-sub-tit {\n  margin: 0;\n  border-radius: 0;\n}\n.container.energy-solution .inverter-result .inv-sub-tit + .inv-grid:has(+ .inv-sub-tit) {\n  border-radius: 0;\n}\n/* 6열 격자에서 안내문은 남는 두 칸만 쓴다 (span 3 이면 줄이 넘친다) */\n.container.energy-solution .inverter-result .inv-grid-6 > .inv-f.inv-f-note {\n  grid-column: span 2;\n}\n/* 대수 운전 시나리오 카드도 한 판이다 (피그마) — 위 격자와 DOL/INV 묶음이 떨어지면\n   회색 배경이 둘로 갈라져 보인다. 사이 여백과 맞닿는 모서리 둥글기를 없앤다. */\n.container.energy-solution .inverter-result .inv-grid:has(+ .inv-sc-pair) {\n  border-radius: 4px 4px 0 0;\n}\n.container.energy-solution .inverter-result .inv-grid + .inv-sc-pair {\n  margin-top: 0;\n  border-radius: 0 0 4px 4px;\n}\n.container.energy-solution .inverter-result .inv-sc-pair {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 0 32px;\n  margin-top: 8px;\n  padding: 0 24px;\n  border-radius: 4px;\n  background: #f7f8fa;\n}\n.container.energy-solution .inverter-result .inv-sc-pair > * {\n  grid-column: span 2;\n}\n.container.energy-solution .inverter-result .inv-sc-pair .inv-sub-tit {\n  padding: 24px 0 8px;\n  border-radius: 0;\n  background: none;\n}\n.container.energy-solution .inverter-result .inv-sc-pair .inv-grid {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  padding: 20px 0 24px;\n  border-radius: 0;\n  background: none;\n}\n.container.energy-solution .inverter-result .inv-sc-pair .inv-grid > * {\n  grid-column: span 1;\n}\n\n/* ---- 카드 하단 버튼 3종 ---- */\n.container.energy-solution .inverter-result .inv-card-ft {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  padding: 16px;\n}\n.container.energy-solution .inverter-result .btn-inv-dark,\n.popup-layer.inverter-all-pop .btn-inv-dark {\n  height: 40px;\n  padding: 0 14px;\n  border: 0;\n  border-radius: 4px;\n  background: #13315c;\n  font-size: 0.8125rem;\n  font-weight: 700;\n  color: #fff;\n  cursor: pointer;\n}\n.container.energy-solution .inverter-result .btn-inv-dark.sm,\n.popup-layer.inverter-all-pop .btn-inv-dark.sm {\n  height: 30px;\n  padding: 0 10px;\n  font-size: 0.75rem;\n}\n.container.energy-solution .inverter-result .btn-inv-dark:disabled,\n.popup-layer.inverter-all-pop .btn-inv-dark:disabled {\n  background: #e6eaf0;\n  color: #a4adb9;\n  cursor: default;\n}\n.container.energy-solution .inverter-result .btn-inv-dark,\n.container.energy-solution .inverter-result .btn-inv-go {\n  white-space: nowrap;\n}\n.container.energy-solution .inverter-result .btn-inv-go {\n  height: 40px;\n  /* 「한번에 입력하기」 팝업 하단 버튼과 같은 규격이다 (담당자 2026-09-02).\n     min-width 가 없으면 [수정] 처럼 글자가 짧은 버튼만 좁아져 두 화면의 크기가 어긋난다. */\n  min-width: 104px;\n  padding: 0 24px;\n  border: 0;\n  border-radius: 4px;\n  background: #1763d6;\n  font-size: 0.8125rem;\n  font-weight: 700;\n  color: #fff;\n  cursor: pointer;\n}\n.container.energy-solution .inverter-result .btn-inv-go:disabled {\n  background: #e6eaf0;\n  color: #a4adb9;\n  cursor: default;\n}\n/* 수정 모드의 「+ 신규 분석 추가」 — 같은 크기의 보조 동작이라 테두리형으로 구분한다 */\n.container.energy-solution .inverter-result .btn-inv-go.outline {\n  background: #fff;\n  border: 1px solid #1763d6;\n  color: #1763d6;\n}\n.container.energy-solution .inverter-result .btn-inv-go.outline:disabled {\n  background: #fff;\n  border-color: #e6eaf0;\n  color: #a4adb9;\n}\n.container.energy-solution .inverter-result .btn-inv-del,\n.popup-layer.inverter-all-pop .btn-inv-del {\n  position: relative;\n  width: 22px;\n  height: 22px;\n  border: 0;\n  background: none;\n  cursor: pointer;\n}\n.container.energy-solution .inverter-result .btn-inv-del::before,\n.container.energy-solution .inverter-result .btn-inv-del::after,\n.popup-layer.inverter-all-pop .btn-inv-del::before,\n.popup-layer.inverter-all-pop .btn-inv-del::after {\n  content: \"\";\n  position: absolute;\n  left: 4px;\n  top: 10px;\n  width: 14px;\n  height: 1px;\n  background: #8c96a3;\n}\n.container.energy-solution .inverter-result .btn-inv-del::before,\n.popup-layer.inverter-all-pop .btn-inv-del::before {\n  transform: rotate(45deg);\n}\n.container.energy-solution .inverter-result .btn-inv-del::after,\n.popup-layer.inverter-all-pop .btn-inv-del::after {\n  transform: rotate(-45deg);\n}\n\n/* ---- 소제목 옆 ⓘ 도움말 (피그마 2026-08-31) ----\n * 공용 .tooltip-link 을 그대로 쓰되, 기본 말풍선은 트리거 폭(14px)의 130% 라\n * 글이 한 글자씩 잘린다. 폭·위치·색만 흰 말풍선으로 덮어쓴다.\n * ------------------------------------------------------------------ */\n.container.energy-solution .inverter-result .inv-tip,\n.popup-layer.inverter-all-pop .inv-tip {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  margin-left: 6px;\n  border-radius: 50%;\n  background: #46505f;\n  font-style: normal;\n  vertical-align: -2px;\n  cursor: help;\n}\n.container.energy-solution .inverter-result .inv-tip::after,\n.popup-layer.inverter-all-pop .inv-tip::after {\n  content: \"i\";\n  display: block;\n  font-size: 0.5625rem;\n  font-weight: 700;\n  line-height: 14px;\n  text-align: center;\n  color: #fff;\n}\n.container.energy-solution .inverter-result .inv-tip::before,\n.popup-layer.inverter-all-pop .inv-tip::before {\n  top: 22px;\n  left: -4px;\n  width: 320px;\n  max-width: 320px;\n  padding: 12px 14px;\n  border-radius: 6px;\n  background: #fff;\n  box-shadow: 0 4px 12px rgba(122, 133, 150, 0.4);\n  font-size: 0.75rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #46505f;\n  white-space: normal;\n}\n\n/* ---- 결과 : 하단 안내문 + 버튼 줄 ---- */\n.container.energy-solution .inverter-result .bottom.inv-result-ft {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.container.energy-solution .inverter-result .bottom.inv-result-ft .btn-area {\n  /* 안내문(inv-result-note)이 빠져 flex 로 밀어 주던 것이 없어졌다. 버튼 줄을 직접 오른쪽으로 붙인다 */\n  flex: 0 0 auto;\n  margin-left: auto;\n}\n\n/* ---- 결과 표 : 피그마 실측 ----\n * 헤더는 모든 칸 가운데. 본문은 첫 칸 왼쪽 · 마지막(금액) 칸 오른쪽 · 나머지 가운데.\n * 단위는 헤더가 아니라 셀 안에 붙는다(마크업 참조). 줄무늬는 없다.\n * ------------------------------------------------------------------ */\n.container.energy-solution .box__body .inverter-result .tbl-list thead th,\n.container.energy-solution .box__body .inverter-result .tbl-list thead th:first-child,\n.container.energy-solution .box__body .inverter-result .tbl-list thead th:last-child {\n  height: 32px;\n  padding: 0 14px;\n  background: #f7f8fa;\n  vertical-align: middle;\n  border-bottom: 0;\n  font-weight: 400;\n  color: #46505f;\n  text-align: center;\n}\n.container.energy-solution .box__body .inverter-result .tbl-list tbody th,\n.container.energy-solution .box__body .inverter-result .tbl-list tbody td {\n  height: 33px;\n  text-align: center;\n}\n.container.energy-solution .box__body .inverter-result .tbl-list tbody th:first-child,\n.container.energy-solution .box__body .inverter-result .tbl-list tbody td:first-child {\n  text-align: left;\n}\n.container.energy-solution .box__body .inverter-result .tbl-list tbody th:last-child,\n.container.energy-solution .box__body .inverter-result .tbl-list tbody td:last-child {\n  text-align: right;\n}\n.container.energy-solution .box__body .inverter-result .tbl-list tr.sum-row th,\n.container.energy-solution .box__body .inverter-result .tbl-list tr.sum-row td {\n  background: #e6f0ff;\n  border-bottom: 0;\n  font-weight: 400;\n  color: #1763d6;\n}\n/* 경제성 검토 표는 값 칸이 둘이라 둘 다 오른쪽 정렬이다 (피그마 상세분석) */\n.container.energy-solution .box__body .inverter-result .tbl-list.eco-table tbody td {\n  text-align: right;\n}\n\n/* ---- 결과 카드 제목줄 (피그마 : 글씨 한 줄 + 얇은 구분선) ---- */\n.container.energy-solution .box__body .inverter-result .top.inv-item-hd {\n  align-items: center;\n  margin-bottom: 12px;\n  padding-bottom: 14px;\n  border-bottom-color: #e1e6ec;\n}\n.container.energy-solution .box__body .inverter-result .inv-item-tit {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #1a2330;\n}\n\n/* =========================================================================\n * 상세분석 — 피그마(2026-08-26) f06_2~4 구조\n * 섹션 제목은 번호 배지가 아니라 「1. 회전속도 산정」 글씨 한 줄,\n * 본문 블록은 전부 테두리 없는 회색 패널(#f7f8fa)이다.\n * ========================================================================= */\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-sec-tit {\n  margin: 26px 0 10px;\n  font-size: 0.9375rem;\n  font-weight: 500;\n  color: #1a2330;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-sec-tit > em {\n  margin-right: 4px;\n  font-style: normal;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-panel {\n  padding: 18px 20px;\n  border: 0;\n  border-radius: 4px;\n  background: #f7f8fa;\n}\n\n/* ---- 설비 / 모터 / 운용 입력값 요약 : 흰 카드 한 장 안 3열 ---- */\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-info-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0 30px;\n  padding: 18px 20px;\n  border: 1px solid #e7eaef;\n  border-radius: 4px;\n  background: #fff;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-info-col {\n  border: 0;\n  border-radius: 0;\n  overflow: visible;\n  background: none;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-info-h {\n  padding: 0 0 8px;\n  border-bottom: 1px solid #e7eaef;\n  background: none;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: #1a2330;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-info-tbl td {\n  padding: 6px 0;\n  border-bottom: 0;\n  font-size: 0.75rem;\n  color: #6b7686;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-info-tbl td:last-child {\n  font-weight: 400;\n  color: #1a2330;\n}\n\n/* ---- 1. 회전속도 산정 : 패널 한 장 안 3열 ---- */\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-panel.inv-rpm {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0 24px;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card {\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: none;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card .rc-k {\n  margin-bottom: 10px;\n  font-size: 0.8125rem;\n  font-weight: 400;\n  color: #46505f;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card .rc-k:before {\n  display: none;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card .rc-v {\n  font-size: 1.625rem;\n  font-weight: 700;\n  line-height: 1.2;\n  color: #1a2330;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card .rc-v small {\n  margin-left: 4px;\n  font-size: 0.75rem;\n  font-weight: 400;\n  color: #97a3b4;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card.final .rc-v {\n  color: #1763d6;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card .rc-eq {\n  margin-top: 8px;\n  font-size: 0.75rem;\n  line-height: 1.5;\n  color: #97a3b4;\n}\n\n/* ---- 2. 예상 소비전력 ---- */\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-panel.inv-formula {\n  border: 0;\n  background: #f7f8fa;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-formula .ff-hd {\n  display: flex;\n  align-items: center;\n  margin-bottom: 12px;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-formula .ff-k {\n  font-size: 0.8125rem;\n  color: #46505f;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-formula .ff-law {\n  margin-left: auto;\n  font-size: 0.75rem;\n  color: #97a3b4;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-formula p {\n  font-size: 1.375rem;\n  font-weight: 500;\n  line-height: 1.4;\n  color: #1a2330;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-formula b {\n  font-weight: 700;\n  color: #1763d6;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-formula .sub {\n  display: block;\n  margin-top: 10px;\n  font-size: 0.75rem;\n  color: #97a3b4;\n}\n\n/* ---- 3. 경제성 검토 : 좌 차트 / 우 절감효과 3종 + 비교표 ---- */\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-eco {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: 0 24px;\n  align-items: start;\n}\n@media screen and (max-width: 1100px) {\n  .container.energy-solution .box__body .inverter-result .inv-detail .inv-eco {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 20px;\n  }\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-eco-l .inv-chart-tit {\n  margin-bottom: 8px;\n  font-size: 0.9375rem;\n  font-weight: 700;\n  color: #1763d6;\n  text-align: center;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-chart-box {\n  height: 300px;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-eco-r {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-eco-r .inv-metric {\n  min-height: 0;\n  padding: 12px 16px;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-eco-r .inv-metric .k {\n  margin-bottom: 6px;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-eco-r .tbl-list {\n  margin-top: 10px;\n}\n\n/* ---- 4. 추천 MVD 기기 ---- */\n.container.energy-solution .box__body .inverter-result .inv-detail .mvd-hero {\n  display: block;\n  padding: 18px 20px;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .mvd-hero .badge {\n  display: block;\n  margin: 0 0 6px;\n  padding: 0;\n  border-radius: 0;\n  background: none;\n  font-size: 0.8125rem;\n  font-weight: 400;\n  color: #46505f;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .mvd-hero .mname {\n  font-size: 1.625rem;\n  font-weight: 700;\n  line-height: 1.2;\n  color: #1763d6;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .mvd-hero .msub {\n  margin-top: 8px;\n  font-size: 0.75rem;\n  color: #97a3b4;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .dim-wrap .dm {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 10px 0 12px;\n  font-size: 1.0625rem;\n  font-weight: 700;\n  color: #1a2330;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .dim-wrap .dm .badge {\n  padding: 3px 9px;\n  border-radius: 10px;\n  background: #1763d6;\n  font-size: 0.6875rem;\n  font-weight: 500;\n  color: #fff;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .dim-wrap .dm .pt {\n  font-size: 0.75rem;\n  font-weight: 400;\n  color: #97a3b4;\n}\n\n/* ---- 상세분석 보정 (2026-08-26) ---- */\n/* 옛 규칙은 회전속도가 2열이라 최종 카드가 한 줄을 다 썼다. 피그마는 3열이라 되돌린다 */\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card.final {\n  grid-column: auto;\n  border-color: transparent;\n  background: none;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card.final .rc-k {\n  color: #46505f;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card.final .rc-v {\n  font-size: 1.625rem;\n}\n/* 산식은 왼쪽 정렬 · 본문 글꼴 (옛 규칙이 가운데 정렬 + 고정폭 글꼴이었다) */\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-panel.inv-formula {\n  text-align: left;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-formula p {\n  font-family: inherit;\n}\n\n/* CASE 2·3 이 있으면 한 칸에 「49.2 Hz / 86.1 Hz」가 들어가 값이 길어진다 (2026-09-03) */\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card .rc-v.multi {\n  font-size: 1.125rem;\n  line-height: 1.35;\n  word-break: keep-all;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-rpm-card.final .rc-v.multi {\n  font-size: 1.25rem;\n}\n/* CASE 별 산식은 한 줄에 하나씩 (2026-09-03) */\n.container.energy-solution .box__body .inverter-result .inv-rpm-card .rc-eq .eq-line {\n  display: block;\n}\n.container.energy-solution .box__body .inverter-result .inv-rpm-card .rc-eq .eq-line + .eq-line {\n  margin-top: 4px;\n}\n/* 예상 소비전력 — 패널 한 장 안에서 CASE 를 구분선으로만 나눈다 (2026-09-03) */\n.container.energy-solution .box__body .inverter-result .inv-detail .inv-formula .ff-row + .ff-row {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid #e5e8ee;\n}\n\n/* ---- 4. 추천 MVD : 스펙 표 ---- */\n.container.energy-solution .box__body .inverter-result .inv-detail .spec2 {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0 40px;\n  align-items: start;\n  margin-top: 22px;\n}\n@media screen and (max-width: 1100px) {\n  .container.energy-solution .box__body .inverter-result .inv-detail .spec2 {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 24px;\n  }\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .spec-card {\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: none;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .spec-card .sh {\n  margin-bottom: 8px;\n  padding: 0;\n  border: 0;\n  background: none;\n  font-size: 0.8125rem;\n  font-weight: 700;\n  color: #1a2330;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .spec-card table,\n.container.energy-solution .box__body .inverter-result .inv-detail .dim-tbl {\n  width: 100%;\n  border-collapse: collapse;\n  border-bottom: 1px solid #eceff3;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .spec-card table td,\n.container.energy-solution .box__body .inverter-result .inv-detail .dim-tbl td {\n  height: 32px;\n  padding: 0 16px;\n  border: 0;\n  font-size: 0.8125rem;\n  font-weight: 400;\n  color: #1a2330;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .spec-card table tr:nth-child(odd) td,\n.container.energy-solution .box__body .inverter-result .inv-detail .dim-tbl tr:nth-child(odd) td {\n  background: #f7f8fa;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .spec-card table td:last-child,\n.container.energy-solution .box__body .inverter-result .inv-detail .dim-tbl td:last-child {\n  text-align: right;\n  white-space: nowrap;\n}\n/* 값 오른쪽 끝을 맞추기 위해 단위는 고정폭으로 뽑아 둔다 */\n.container.energy-solution .box__body .inverter-result .inv-detail .spec-card table td > i,\n.container.energy-solution .box__body .inverter-result .inv-detail .dim-tbl td > i {\n  display: inline-block;\n  width: 34px;\n  margin-left: 6px;\n  font-style: normal;\n  font-size: 0.75rem;\n  color: #1a2330;\n  text-align: left;\n}\n/* MVD 선정 스펙에는 「Level 상당」·「Pulse 상당」이 있어 34px 로는 단위 시작점이 어긋난다.\n   가장 긴 단위에 맞춰 칸을 넓히면 V·A·kVA·kW·Hz 까지 한 줄에서 시작한다.\n   전동기 입력 스펙도 같은 규칙을 타므로 좌우 두 표의 단위 위치가 맞는다. */\n.container.energy-solution .box__body .inverter-result .inv-detail .spec-card table td > i {\n  width: 62px;\n}\n\n/* ---- 4. 추천 MVD : 외형 치수 ---- */\n.container.energy-solution .box__body .inverter-result .inv-detail .dim-wrap {\n  margin-top: 26px;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .dim-wrap .dt {\n  font-size: 0.8125rem;\n  font-weight: 700;\n  color: #1a2330;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .dim-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0 40px;\n  align-items: start;\n}\n@media screen and (max-width: 1100px) {\n  .container.energy-solution .box__body .inverter-result .inv-detail .dim-grid {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 20px;\n  }\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .dim-fig {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  border: 1px dashed #dfe3e9;\n  border-radius: 4px;\n  background: #fbfcfd;\n  font-size: 0.75rem;\n  color: #a4adb9;\n}\n/* 도면이 들어오면 자리표시자용 점선을 실선으로 바꾸고 여백을 준다 */\n.container.energy-solution .box__body .inverter-result .inv-detail .dim-fig.has-fig {\n  border-style: solid;\n  background: #fff;\n  padding: 12px;\n}\n.container.energy-solution .box__body .inverter-result .inv-detail .dim-fig img {\n  max-width: 100%;\n  max-height: 260px;\n  height: auto;\n  object-fit: contain;\n}\n\n/* =========================================================================\n * 「한번에 입력하기」 팝업\n * ========================================================================= */\n.popup-layer.inverter-all-pop {\n  width: 1240px;\n  max-width: 96%;\n}\n.popup-layer.inverter-all-pop .popup__body {\n  max-height: calc(100vh - 220px);\n  overflow-y: auto;\n  /* 스크롤이 생기는 순간 내용이 왼쪽으로 밀리지 않도록 스크롤바 자리를 미리 잡는다 */\n  scrollbar-gutter: stable;\n  padding: 8px 24px 20px;\n}\n.popup-layer.inverter-all-pop .inv-pop-row {\n  display: grid;\n  grid-template-columns: 120px minmax(0, 1fr);\n  gap: 0 16px;\n  padding: 16px 0;\n  border-bottom: 1px solid #eef1f5;\n}\n.popup-layer.inverter-all-pop .inv-pop-row:last-child {\n  border-bottom: 0;\n}\n.popup-layer.inverter-all-pop .inv-pop-lb {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  padding-top: 6px;\n  font-size: 0.8125rem;\n  font-weight: 700;\n  color: #1a2330;\n}\n.popup-layer.inverter-all-pop .inv-grid {\n  display: grid;\n  gap: 10px 16px;\n}\n.popup-layer.inverter-all-pop .inv-grid-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n.popup-layer.inverter-all-pop .inv-grid-3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n.popup-layer.inverter-all-pop .inv-grid-4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n/* 팝업은 「라벨 왼쪽 · 입력 오른쪽」의 테두리형이다 */\n/* 라벨은 남는 폭, 입력칸은 고정폭. 피그마 f03 은 140px 이었으나\n   단위가 붙는 칸(「0.4747 tCO₂/MWh」 등)이 빠듯해 200px 로 넓혔다 (2026-08-31 요청) */\n.popup-layer.inverter-all-pop .inv-f {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 200px;\n  align-items: center;\n  gap: 0 10px;\n  min-width: 0;\n}\n.popup-layer.inverter-all-pop .inv-f-lb {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 0.8125rem;\n  color: #1a2330;\n  white-space: nowrap;\n}\n.popup-layer.inverter-all-pop .inv-f-lb > i {\n  font-style: normal;\n  color: #ea3f3f;\n}\n.popup-layer.inverter-all-pop .inv-f-lb > em {\n  font-style: normal;\n  font-size: 0.6875rem;\n  color: #a4adb9;\n}\n.popup-layer.inverter-all-pop .inv-f-in {\n  position: relative;\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  height: 34px;\n  padding: 0 10px;\n  border: 1px solid #cfd8e3;\n  border-radius: 4px;\n  background: #fff;\n}\n.popup-layer.inverter-all-pop .inv-f-in:focus-within {\n  border-color: #1763d6;\n}\n.popup-layer.inverter-all-pop .inv-f-in > input[type=\"text\"] {\n  width: 100%;\n  min-width: 0;\n  height: 32px;\n  border: 0;\n  background: none;\n  font-size: 0.8125rem;\n  color: #1a2330;\n  text-align: right;\n}\n.popup-layer.inverter-all-pop .inv-f-in > input[type=\"text\"]::placeholder {\n  color: #b6bfcb;\n}\n/* 피그마 : 값은 오른쪽 정렬, 안내문구(placeholder)는 왼쪽. 단위는 칸 오른쪽 끝 */\n.popup-layer.inverter-all-pop .inv-f-in > input[type=\"text\"]:placeholder-shown {\n  text-align: left;\n}\n.popup-layer.inverter-all-pop .inv-f-in > .unit {\n  flex: 0 0 auto;\n  margin-left: 4px;\n  font-size: 0.6875rem;\n  color: #97a3b4;\n}\n.popup-layer.inverter-all-pop .inv-f-in > .select.inv-sel {\n  width: 100%;\n  min-width: 0;\n  height: 32px;\n  border: 0;\n  background: none;\n}\n.popup-layer.inverter-all-pop .inv-f-in > .select.inv-sel .selected {\n  height: 32px;\n  padding: 0;\n  border: 0;\n  background: none;\n}\n.popup-layer.inverter-all-pop .inv-f-in > .select.inv-sel .selected-value {\n  font-size: 0.8125rem;\n  color: #1a2330;\n}\n.popup-layer.inverter-all-pop .inv-f.inv-f-note {\n  grid-column: span 2;\n}\n.popup-layer.inverter-all-pop .inv-f.inv-f-note > p {\n  font-size: 0.6875rem;\n  color: #97a3b4;\n}\n.popup-layer.inverter-all-pop .inv-sub-tit {\n  margin: 16px 0 10px;\n  font-size: 0.8125rem;\n  font-weight: 700;\n  color: #1a2330;\n}\n.popup-layer.inverter-all-pop .inv-sub-tit.dol,\n.popup-layer.inverter-all-pop .inv-sub-tit.inv {\n  margin-top: 22px;\n  color: #1a2330;\n}\n/* 「일일 대수운전 패턴 비교」는 체크박스와 같은 높이에서 시작한다 */\n.popup-layer.inverter-all-pop .inv-pop-fields > .inv-sub-tit:first-child {\n  margin-top: 2px;\n}\n.popup-layer.inverter-all-pop .inv-sc-pair {\n  gap: 0 24px;\n}\n.popup-layer.inverter-all-pop .inv-chk {\n  display: inline-flex;\n  align-items: center;\n}\n\n/* ---- 팝업 보정 (2026-08-26) ---- */\n/* 버튼 문구가 두 줄로 접히지 않게 */\n.popup-layer.inverter-all-pop .btn-inv-dark,\n.popup-layer.inverter-all-pop .popup__footer button {\n  white-space: nowrap;\n}\n.popup-layer.inverter-all-pop .popup__footer button {\n  min-width: 104px;\n  padding: 0 20px;\n}\n.popup-layer.inverter-all-pop .inv-chk label {\n  white-space: nowrap;\n}\n.popup-layer.inverter-all-pop .inv-pop-lb {\n  white-space: nowrap;\n}\n\n/* 앞 필드 개수가 달라져도 항상 새 줄 첫 칸에서 시작한다 */\n.container.energy-solution .box__body .inverter-result .inv-grid > .inv-f.inv-f-newrow,\n.popup-layer.inverter-all-pop .inv-grid > .inv-f.inv-f-newrow {\n  grid-column-start: 1;\n}\n/* 시나리오처럼 블록이 여러 개인 줄은 이 상자로 감싼다 (격자 칸 하나를 차지) */\n.popup-layer.inverter-all-pop .inv-pop-fields {\n  min-width: 0;\n}\n/* 1열 격자 (대수운전 DOL/INV 묶음) */\n.popup-layer.inverter-all-pop .inv-grid-1 {\n  grid-template-columns: minmax(0, 1fr);\n}\n/* DOL / INV 는 좌우 두 묶음 — 3중 격자로 쌓으면 라벨이 겹친다 */\n.popup-layer.inverter-all-pop .inv-sc-pair {\n  display: grid;\n  gap: 0 16px;\n}\n/* 피그마 f05 : 시나리오도 위 3열 줄과 같은 트랙 폭(왼쪽 두 칸)에 놓인다.\n * 2열이라고 폭을 반씩 나누면 라벨과 입력칸 사이가 벌어져 다른 줄과 어긋난다. */\n.popup-layer.inverter-all-pop .inv-pop-fields .inv-grid-2,\n.popup-layer.inverter-all-pop .inv-pop-fields .inv-sc-pair {\n  grid-template-columns: repeat(2, calc((100% - 32px) / 3));\n}\n.popup-layer.inverter-all-pop .inv-pop-fields .inv-grid-1 {\n  grid-template-columns: minmax(0, 1fr);\n}\n/* 하단 버튼 — 프로젝트 기본 폭이 고정이라 문구가 잘린다 */\n/* ---- 「한번에 입력하기」 팝업 하단 버튼 ----\n * 단계별 입력 화면(.btn-inv-go)과 색을 맞춘다. 공통 팝업 기본색(#0a78ff)을 그대로 두면\n * 같은 [수정]·[+ 신규 분석 추가]가 화면과 팝업에서 다른 파랑으로 보인다.\n * 취소(.bg-gray)는 공통 규칙을 그대로 쓴다.\n * ------------------------------------------------------------------ */\n.popup-layer.inverter-all-pop .popup__footer button:not(.bg-gray) {\n  background-color: #1763d6;\n}\n/* [+ 신규 분석 추가] — 화면과 같은 테두리형. span 색까지 눌러야 흰 글자가 안 남는다 */\n.popup-layer.inverter-all-pop .popup__footer button.outline {\n  background-color: #fff;\n  border: 1px solid #1763d6;\n}\n.popup-layer.inverter-all-pop .popup__footer button.outline span {\n  color: #1763d6;\n}\n/* 공통 팝업은 1rem 인데 단계별 화면 버튼은 0.8125rem 이다.\n   글자 크기가 다르면 [+ 신규 분석 추가] 처럼 라벨이 긴 버튼의 폭이 두 화면에서 어긋난다. */\n.popup-layer.inverter-all-pop .popup__footer button span {\n  font-size: 0.8125rem;\n}\n.popup-layer.inverter-all-pop .popup__footer button {\n  width: auto;\n  min-width: 104px;\n  padding: 0 24px;\n  white-space: nowrap;\n}\n\n/* =========================================================================\n * 태양광 역률 영향 분석 — 프로토타입 「별도_태양광 내 역률 영향 분석 ver.0.1」 재현\n * 5대분류 세로형 표는 기존 .tbl-list 로는 못 만든다(열 균등분할·첫 열 강제 배경·!important).\n * 이 화면에만 적용되도록 .pvpf-wrap 으로 스코프를 좁혀 표를 따로 만든다.\n * ========================================================================= */\n.detail-analysis-wrap.pvpf-wrap .pvpf-legend .pvpf-unit {\n  margin-left: 10px;\n  font-size: 0.75rem;\n  font-weight: 400;\n  color: #8b94a1;\n}\n\n/* 범례 — 어느 셀을 고칠 수 있는지 */\n.detail-analysis-wrap.pvpf-wrap .pvpf-legend {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin: 10px 0 12px;\n  font-size: 0.75rem;\n  color: #5b6472;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-legend .sw {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  margin-right: 5px;\n  border-radius: 3px;\n  vertical-align: -1px;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-legend .sw.edit {\n  border: 1px solid #b5d4f4;\n  background: #e6f1fb;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-legend .sw.auto {\n  border: 1px solid #c9d2dd;\n  background: #fff;\n}\n\n/* 전력 단가 · 연간 발전량 · 할인율 + 기준 전환 */\n.detail-analysis-wrap.pvpf-wrap .pvpf-assump {\n  display: flex;\n  gap: 18px;\n  flex-wrap: wrap;\n  align-items: center;\n  margin: 4px 0 14px;\n  font-size: 0.8125rem;\n  color: #5b6472;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-assump > label {\n  display: inline-flex;\n  gap: 6px;\n  align-items: center;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-assump input[type=\"text\"] {\n  width: 90px;\n  height: 30px;\n  padding: 0 8px;\n  border: 1px solid #b5d4f4;\n  border-radius: 6px;\n  background: #e6f1fb;\n  color: #0c447c;\n  font-size: 0.8125rem;\n  text-align: right;\n}\n/* 전력단가·연간발전량·역률개선 할인율 — 고쳐 쓰는 값이 아니라 기 입력·분석 결과라 읽기 전용이다.\n   입력칸과 헷갈리지 않도록 테두리를 없애고 값만 굵게 보여 준다 */\n.detail-analysis-wrap.pvpf-wrap .pvpf-assump .pvpf-fixed {\n  display: inline-flex;\n  gap: 6px;\n  align-items: baseline;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-assump .pvpf-fixed .vl {\n  min-width: 60px;\n  padding: 0 2px;\n  color: #0c447c;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  text-align: right;\n}\n\n/* 표 — 가로 스크롤, 첫 두 열 고정 */\n/* 역률 영향 분석을 펼친 동안에는 스크롤을 페이지 하나로 모은다.\n   .area__right 는 평소 calc(100vh - 217px) 로 잘려 있고 .scroll-area 가 안쪽에서 스크롤하는데,\n   이 패널은 카드·차트·표가 이어져 길어서 안쪽 스크롤이 페이지 스크롤과 겹쳐 보인다. */\n.container.energy-solution .box__body > .area__right:has(.pvpf-wrap) {\n  height: auto;\n}\n.container.energy-solution .box__body > .area__right:has(.pvpf-wrap) .scroll-area:has(.box-column) {\n  height: auto;\n  overflow-y: visible;\n}\n\n/* 표 위 — 범례(어느 셀을 고칠 수 있는지)와 역률 안내 버튼 */\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl-top {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 24px 0 8px;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl-top .pvpf-legend {\n  align-items: flex-end;\n  margin: 0;\n}\n/* 단위 안내 — 역률 조정 요금 범례 옆 */\n.detail-analysis-wrap.pvpf-wrap .pvpf-legend .pvpf-unit {\n  color: #8b94a1;\n}\n/* ------------------------------------------------------------------ *\n *  월별 표 — Enable 표(.tbl-list) 규격에 5대분류 세로형 구성을 얹었다.\n *  기본 .tbl-list 는 th 배경 #dde2e9 · 높이 40px · 자간 -0.9px · 열 균등분할(table-layout:fixed)이\n *  걸려 있어 여기서 되돌린다. 열 폭은 colgroup 으로 못박아 편집 셀과 계산 셀 크기를 맞춘다.\n * ------------------------------------------------------------------ */\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl-wrap {\n  overflow-x: auto;\n  overflow-y: hidden;\n  border: 0;\n  background: #fff;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl {\n  width: 100%;\n  min-width: 0;\n  border-collapse: collapse;\n  border-bottom: 0;\n  table-layout: fixed;\n  white-space: nowrap;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl .col-grp {\n  width: 112px;\n}\n/* 가장 긴 라벨 「태양광 설치/발전 시 (a−c)」가 딱 들어가는 폭.\n   글자가 약 158px 이라 이보다 좁히면 잘린다 — 더 줄이려면 라벨을 줄여야 한다. */\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl .col-lbl {\n  width: 154px;\n}\n/* 월 열은 폭을 주지 않는다 — 남은 폭을 균등하게 나눠 가져 가로 스크롤이 생기지 않는다 */\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl .col-yr {\n  width: 96px;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl caption {\n  overflow: hidden;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  clip: rect(0, 0, 0, 0);\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl th,\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td {\n  box-sizing: border-box;\n  height: 36px;\n  min-height: 0;\n  padding: 0 8px;\n  border: 0;\n  border-bottom: 1px solid #f1f3f6;\n  background: #fff;\n  overflow: hidden;\n  text-align: center;\n  text-overflow: ellipsis;\n  font-size: 0.8125rem;\n  font-weight: 400;\n  line-height: 1.4;\n  letter-spacing: normal;\n  color: #1a2330;\n  vertical-align: middle;\n}\n/* 머리글 — 옅은 회색 바탕에 회색 글씨 (인버터 결과 표와 같은 규격) */\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  height: 40px;\n  border-bottom: 1px solid #e9edf2;\n  background: #f7f8fa;\n  color: #46505f;\n  font-weight: 400;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl th.lft,\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td.lft {\n  text-align: left;\n}\n/* 대분류·구분 두 열은 왼쪽 고정. 월 열만 좌우로 스크롤한다 */\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td.grp {\n  position: sticky;\n  left: 0;\n  z-index: 1;\n  padding: 0 12px;\n  white-space: normal;\n  border-right: 1px solid #eaedf2;\n  background: #f7f8fa;\n  color: #46505f;\n  text-align: left;\n  line-height: 1.45;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td.grp span {\n  display: block;\n}\n/* 구분 — 이름이 길면 줄을 바꿔 다 보여 준다. 행 높이는 그만큼 늘어난다 (담당자 요청 2026-09-04) */\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td.lbl {\n  position: sticky;\n  left: 112px;\n  padding: 6px 5px;\n  z-index: 1;\n  border-right: 1px solid #eaedf2;\n  background: #f1f3f7;\n  color: #46505f;\n  text-align: left;\n  white-space: normal;\n  overflow: visible;\n  text-overflow: clip;\n  line-height: 1.35;\n  word-break: keep-all;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl thead th.grp-h {\n  left: 0;\n  z-index: 3;\n  border-right: 1px solid #e9edf2;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl thead th.lbl-h {\n  left: 112px;\n  z-index: 3;\n  border-right: 1px solid #e9edf2;\n}\n/* 셀 안 단위 — 값보다 옅게 */\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl .u {\n  color: #8b94a1;\n}\n/* 대분류가 바뀌는 자리만 진한 선 */\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl tr.grp-end td {\n  border-bottom: 1px solid #e3e8ef;\n}\n/* 표 아래도 행 사이와 같은 선으로 닫는다 (담당자 2026-09-03) */\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl tbody tr:last-child td {\n  border-bottom: 1px solid #f1f3f6;\n}\n/* 파란 바탕은 입력 행(무효 전력)과 연간 열에만 둔다 (담당자 2026-09-03).\n   무효 전력이 이 표에서 유일하게 고칠 수 있는 값이라 한눈에 보여야 한다. */\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl tr.hl td:not(.grp) {\n  background: #e6f0ff;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl tr.hl td.lbl {\n  background: #e6f0ff;\n  color: #0c447c;\n}\n/* 최종 절감 행 — 바탕색 없이 글자만 파랗게 */\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl tr.hi td:not(.grp) {\n  color: #1763d6;\n  font-weight: 600;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl tr.hi td.lbl {\n  color: #1763d6;\n}\n/* 편집 가능 셀 — 구분 칸까지 같은 색으로 묶는다 */\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td.edit {\n  padding: 0;\n  background: #e6f0ff;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td.lbl.edit {\n  padding: 0 5px;\n  background: #e6f0ff;\n  color: #0c447c;\n  font-weight: 400;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl .pvpf-cell-input {\n  box-sizing: border-box;\n  display: block;\n  width: 100%;\n  min-width: 0;\n  height: 35px;\n  margin: 0;\n  padding: 0 8px;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  color: #0c447c;\n  font-family: inherit;\n  font-size: 0.8125rem;\n  line-height: 35px;\n  letter-spacing: normal;\n  text-align: center;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl .pvpf-cell-input:focus {\n  outline: 2px solid #378add;\n  outline-offset: -2px;\n}\n/* 연간 열 — 맨 오른쪽. 강조 행 위에 와야 하므로 뒤에 둔다 */\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td.yr,\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl tr.hl td.yr,\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl tr.hi td.yr {\n  background: #e6f0ff;\n  color: #0f4aa8;\n  font-weight: 600;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td.yr .u {\n  color: #5b87c4;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td.yr .avg {\n  margin-left: 3px;\n  font-size: 0.625rem;\n}\n\n\n/* 절감 금액 3단계 비교 */\n/* 절감 금액 3종 — 피그마 : 회색 패널 한 장 안에 3칸.\n   글자 크기는 피그마 실측을 배율 2.5 로 환산해 프로젝트 표준 스케일에 맞췄다\n   (기준 = 이미 구현된 PV 결과 카드의 라벨 15px · 값 26px 잉크 높이). */\n.detail-analysis-wrap.pvpf-wrap .pvpf-panel {\n  padding: 24px;\n  border-radius: 10px;\n  background: #f7f8fa;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-sum-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0 32px;\n  margin: 0 0 16px;\n}\n@media screen and (max-width: 1100px) {\n  .detail-analysis-wrap.pvpf-wrap .pvpf-sum-grid {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 20px;\n  }\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-sum .ps-k {\n  margin-bottom: 10px;\n  font-size: 1rem;\n  line-height: 1.6;\n  letter-spacing: -0.04em;\n  color: #2a2c2f;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-sum .ps-v {\n  font-family: \"Pretendard\", sans-serif;\n  font-size: 1.75rem;\n  font-weight: 500;\n  font-style: normal;\n  line-height: 1.39;\n  letter-spacing: -0.02em;\n  color: #2a2c2f;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-sum .ps-v small {\n  margin-left: 6px;\n  font-size: 0.8125rem;\n  font-weight: 400;\n  letter-spacing: -0.02em;\n  color: #97a3b4;\n}\n/* 최종 절감액만 파랗다 — 피그마 세 번째 칸 */\n.detail-analysis-wrap.pvpf-wrap .pvpf-sum.acc .ps-v {\n  color: #1763d6;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-sum .ps-s {\n  margin-top: 10px;\n  font-size: 0.75rem;\n  line-height: 1.5;\n  letter-spacing: -0.02em;\n  color: #97a3b4;\n}\n/* 차트 캡션 — 무엇의 합계인지와 단위 */\n.detail-analysis-wrap.pvpf-wrap .pvpf-chart-tit {\n  margin: 24px 0 0;\n  font-size: 0.75rem;\n  color: #6b7686;\n}\n/* 차트 — 높이는 피그마 실측 350px(공용 .h446 은 !important 라 전용 클래스로 뺐다).\n   공용 .graph-box 의 overflow:auto 는 이 화면에서 스크롤을 하나 더 만들므로 되돌린다. */\n.detail-analysis-wrap.pvpf-wrap .analysis-graph-wrap .graph-cont .graph-box {\n  overflow: visible;\n}\n.detail-analysis-wrap.pvpf-wrap .analysis-graph-wrap .graph-area.pvpf-chart {\n  height: 350px;\n}\n\n/* CSV 다운로드 · 입력값 초기화 */\n.detail-analysis-wrap.pvpf-wrap .pvpf-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 14px;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-footer .btn-basic {\n  width: auto;\n  min-width: 130px;\n}\n\n/* ==========================================================================\n   management - MVD 모델 관리 / 전압 등급 관리\n   레이아웃은 「고효율 설비 List」와 같다(.l-divide > article.flex-7 + article.flex-3).\n   그 화면이 쓰는 규칙을 그대로 타므로 여기서는 고효율에 없는 것만 더한다.\n     - 고효율 우측 패널은 읽기 전용이라 버튼줄이 없다 → 저장·삭제 버튼줄을 여기서 정의\n     - 참조 중인 전압 등급 안내문\n   라벨 폭(.form__input .tit 108px)과 h3 는 위쪽 「management - 에너지솔루션 관리」 블록이\n   :has(.flex-7, .flex-3) 로 이 화면에도 걸어 준다. 다시 정의하지 말 것.\n   ========================================================================== */\n.content-wrap > .l-divide .box__body .btn-area.mvd-btns {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 32px;\n}\n.content-wrap > .l-divide .box__body .txt-info.mvd-note {\n  margin-top: 20px;\n  padding: 10px 12px;\n  border-radius: 4px;\n  background: #f7f8fa;\n  font-size: 13px;\n  line-height: 1.5;\n  color: #6b7684;\n  word-break: keep-all;\n}\n\n/* ==========================================================================\n   역률 안내 버튼 (.pvpf-guide-btn) — 태양광 역률 영향 분석 패널\n   안내 내용은 공통 팝업(EnablePowerFactorGuidePop)을 띄운다. 여기엔 버튼 모양만 둔다.\n   ========================================================================== */\n.detail-analysis-wrap.pvpf-wrap .title {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl-top .pvpf-guide-btn {\n  margin-left: auto;\n  padding: 5px 12px;\n  border: 1px solid #d6e4f7;\n  border-radius: 6px;\n  background: #eff6ff;\n  font-size: 12.5px;\n  line-height: 16px;\n  color: #2a78d6;\n  white-space: nowrap;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl-top .pvpf-guide-btn::before {\n  content: \"ⓘ \";\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl-top .pvpf-guide-btn:hover {\n  background: #d6e4f7;\n}\n\n/* 역률 조정 요금 셀 — 할증(+) 붉게 · 감액(−) 푸르게. 템플릿 ver.1.0 의 adjCell 과 같은 규칙 */\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td.pos {\n  color: #e5484d;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-tbl td.neg {\n  color: #2a78d6;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-legend .pvpf-pos {\n  color: #e5484d;\n}\n.detail-analysis-wrap.pvpf-wrap .pvpf-legend .pvpf-neg {\n  color: #2a78d6;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
